var fn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function I1(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Mb(e) {
  var r = e.default;
  if (typeof r == "function") {
    var i = function() {
      return r.apply(this, arguments);
    };
    i.prototype = r.prototype;
  } else
    i = {};
  return Object.defineProperty(i, "__esModule", { value: !0 }), Object.keys(e).forEach(function(t) {
    var n = Object.getOwnPropertyDescriptor(e, t);
    Object.defineProperty(i, t, n.get ? n : {
      enumerable: !0,
      get: function() {
        return e[t];
      }
    });
  }), i;
}
/**
 * @license AngularJS v1.4.14
 * (c) 2010-2015 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(e, r, i) {
  function t(A, k) {
    return k = k || Error, function() {
      var L = 2, I = arguments, B = I[0], U = "[" + (A ? A + ":" : "") + B + "] ", j = I[1], H, W;
      for (U += j.replace(/\{\d+\}/g, function(X) {
        var Z = +X.slice(1, -1), fe = Z + L;
        return fe < I.length ? Tn(I[fe]) : X;
      }), U += `
http://errors.angularjs.org/1.4.14/` + (A ? A + "/" : "") + B, W = L, H = "?"; W < I.length; W++, H = "&")
        U += H + "p" + (W - L) + "=" + encodeURIComponent(Tn(I[W]));
      return new k(U);
    };
  }
  var n = /^\/(.+)\/([a-z]*)$/, a = "validity", s = function(A) {
    return Ne(A) ? A.toLowerCase() : A;
  }, o = Object.prototype.hasOwnProperty, l = function(A) {
    return Ne(A) ? A.toUpperCase() : A;
  }, u = function(A) {
    return Ne(A) ? A.replace(/[A-Z]/g, function(k) {
      return String.fromCharCode(k.charCodeAt(0) | 32);
    }) : A;
  }, h = function(A) {
    return Ne(A) ? A.replace(/[a-z]/g, function(k) {
      return String.fromCharCode(k.charCodeAt(0) & -33);
    }) : A;
  };
  "I".toLowerCase() !== "i" && (s = u, l = h);
  var c, d, f, m = [].slice, p = [].splice, b = [].push, y = Object.prototype.toString, v = Object.getPrototypeOf, g = t("ng"), E = e.angular || (e.angular = {}), x, w = 0;
  c = r.documentMode;
  function S(A) {
    if (A == null || qt(A))
      return !1;
    if ($e(A) || Ne(A) || d && A instanceof d)
      return !0;
    var k = "length" in Object(A) && A.length;
    return ot(k) && (k >= 0 && (k - 1 in A || A instanceof Array) || typeof A.item == "function");
  }
  function T(A, k, L) {
    var I, B;
    if (A)
      if (Ze(A))
        for (I in A)
          I != "prototype" && I != "length" && I != "name" && (!A.hasOwnProperty || A.hasOwnProperty(I)) && k.call(L, A[I], I, A);
      else if ($e(A) || S(A)) {
        var U = typeof A != "object";
        for (I = 0, B = A.length; I < B; I++)
          (U || I in A) && k.call(L, A[I], I, A);
      } else if (A.forEach && A.forEach !== T)
        A.forEach(k, L, A);
      else if (Ce(A))
        for (I in A)
          k.call(L, A[I], I, A);
      else if (typeof A.hasOwnProperty == "function")
        for (I in A)
          A.hasOwnProperty(I) && k.call(L, A[I], I, A);
      else
        for (I in A)
          o.call(A, I) && k.call(L, A[I], I, A);
    return A;
  }
  function C(A, k, L) {
    for (var I = Object.keys(A).sort(), B = 0; B < I.length; B++)
      k.call(L, A[I[B]], I[B]);
    return I;
  }
  function D(A) {
    return function(k, L) {
      A(L, k);
    };
  }
  function R() {
    return ++w;
  }
  function P(A, k) {
    k ? A.$$hashKey = k : delete A.$$hashKey;
  }
  function N(A, k, L) {
    for (var I = A.$$hashKey, B = 0, U = k.length; B < U; ++B) {
      var j = k[B];
      if (!(!me(j) && !Ze(j)))
        for (var H = Object.keys(j), W = 0, X = H.length; W < X; W++) {
          var Z = H[W], fe = j[Z];
          L && me(fe) ? ze(fe) ? A[Z] = new Date(fe.valueOf()) : Ut(fe) ? A[Z] = new RegExp(fe) : fe.nodeName ? A[Z] = fe.cloneNode(!0) : lt(fe) ? A[Z] = fe.clone() : (me(A[Z]) || (A[Z] = $e(fe) ? [] : {}), N(A[Z], [fe], !0)) : A[Z] = fe;
        }
    }
    return P(A, I), A;
  }
  function $(A) {
    return N(A, m.call(arguments, 1), !1);
  }
  function O(A) {
    return N(A, m.call(arguments, 1), !0);
  }
  function M(A) {
    return parseInt(A, 10);
  }
  function F(A, k) {
    return $(Object.create(A), k);
  }
  function G() {
  }
  G.$inject = [];
  function K(A) {
    return A;
  }
  K.$inject = [];
  function J(A) {
    return function() {
      return A;
    };
  }
  function ue(A) {
    return Ze(A.toString) && A.toString !== y;
  }
  function ce(A) {
    return typeof A > "u";
  }
  function ee(A) {
    return typeof A < "u";
  }
  function me(A) {
    return A !== null && typeof A == "object";
  }
  function Ce(A) {
    return A !== null && typeof A == "object" && !v(A);
  }
  function Ne(A) {
    return typeof A == "string";
  }
  function ot(A) {
    return typeof A == "number";
  }
  function ze(A) {
    return y.call(A) === "[object Date]";
  }
  var $e = Array.isArray;
  function Ze(A) {
    return typeof A == "function";
  }
  function Ut(A) {
    return y.call(A) === "[object RegExp]";
  }
  function qt(A) {
    return A && A.window === A;
  }
  function ir(A) {
    return A && A.$evalAsync && A.$watch;
  }
  function We(A) {
    return y.call(A) === "[object File]";
  }
  function vt(A) {
    return y.call(A) === "[object FormData]";
  }
  function Tt(A) {
    return y.call(A) === "[object Blob]";
  }
  function xt(A) {
    return typeof A == "boolean";
  }
  function Pt(A) {
    return A && Ze(A.then);
  }
  var at = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array\]$/;
  function Ot(A) {
    return A && ot(A.length) && at.test(y.call(A));
  }
  var It = function(A) {
    return Ne(A) ? A.trim() : A;
  }, sr = function(A) {
    return A.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
  };
  function lt(A) {
    return !!(A && (A.nodeName || A.prop && A.attr && A.find));
  }
  function ri(A) {
    var k = {}, L = A.split(","), I;
    for (I = 0; I < L.length; I++)
      k[L[I]] = !0;
    return k;
  }
  function Qr(A) {
    return s(A.nodeName || A[0] && A[0].nodeName);
  }
  function xr(A, k) {
    var L = A.indexOf(k);
    return L >= 0 && A.splice(L, 1), L;
  }
  function _i(A, k) {
    var L = [], I = [];
    if (k) {
      if (Ot(k))
        throw g("cpta", "Can't copy! TypedArray destination cannot be mutated.");
      if (A === k)
        throw g("cpi", "Can't copy! Source and destination are identical.");
      return $e(k) ? k.length = 0 : T(k, function(j, H) {
        H !== "$$hashKey" && delete k[H];
      }), L.push(A), I.push(k), B(A, k);
    }
    return U(A);
    function B(j, H) {
      var W = H.$$hashKey, X;
      if ($e(j))
        for (var Z = 0, fe = j.length; Z < fe; Z++)
          H.push(U(j[Z]));
      else if (Ce(j))
        for (X in j)
          H[X] = U(j[X]);
      else if (j && typeof j.hasOwnProperty == "function")
        for (X in j)
          j.hasOwnProperty(X) && (H[X] = U(j[X]));
      else
        for (X in j)
          o.call(j, X) && (H[X] = U(j[X]));
      return P(H, W), H;
    }
    function U(j) {
      if (!me(j))
        return j;
      var H = L.indexOf(j);
      if (H !== -1)
        return I[H];
      if (qt(j) || ir(j))
        throw g(
          "cpws",
          "Can't copy! Making copies of Window or Scope instances is not supported."
        );
      var W = !1, X;
      return $e(j) ? (X = [], W = !0) : Ot(j) ? X = new j.constructor(j) : ze(j) ? X = new Date(j.getTime()) : Ut(j) ? (X = new RegExp(j.source, j.toString().match(/[^\/]*$/)[0]), X.lastIndex = j.lastIndex) : Tt(j) ? X = new j.constructor([j], { type: j.type }) : Ze(j.cloneNode) ? X = j.cloneNode(!0) : (X = Object.create(v(j)), W = !0), L.push(j), I.push(X), W ? B(j, X) : X;
    }
  }
  function Gr(A, k) {
    if ($e(A)) {
      k = k || [];
      for (var L = 0, I = A.length; L < I; L++)
        k[L] = A[L];
    } else if (me(A)) {
      k = k || {};
      for (var B in A)
        B.charAt(0) === "$" && B.charAt(1) === "$" || (k[B] = A[B]);
    }
    return k || A;
  }
  function li(A, k) {
    if (A === k)
      return !0;
    if (A === null || k === null)
      return !1;
    if (A !== A && k !== k)
      return !0;
    var L = typeof A, I = typeof k, B, U, j;
    if (L == I && L == "object")
      if ($e(A)) {
        if (!$e(k))
          return !1;
        if ((B = A.length) == k.length) {
          for (U = 0; U < B; U++)
            if (!li(A[U], k[U]))
              return !1;
          return !0;
        }
      } else {
        if (ze(A))
          return ze(k) ? li(A.getTime(), k.getTime()) : !1;
        if (Ut(A))
          return Ut(k) ? A.toString() == k.toString() : !1;
        if (ir(A) || ir(k) || qt(A) || qt(k) || $e(k) || ze(k) || Ut(k))
          return !1;
        j = xi();
        for (U in A)
          if (!(U.charAt(0) === "$" || Ze(A[U]))) {
            if (!li(A[U], k[U]))
              return !1;
            j[U] = !0;
          }
        for (U in k)
          if (!(U in j) && U.charAt(0) !== "$" && ee(k[U]) && !Ze(k[U]))
            return !1;
        return !0;
      }
    return !1;
  }
  var ci = function() {
    if (!ee(ci.rules)) {
      var A = r.querySelector("[ng-csp]") || r.querySelector("[data-ng-csp]");
      if (A) {
        var k = A.getAttribute("ng-csp") || A.getAttribute("data-ng-csp");
        ci.rules = {
          noUnsafeEval: !k || k.indexOf("no-unsafe-eval") !== -1,
          noInlineStyle: !k || k.indexOf("no-inline-style") !== -1
        };
      } else
        ci.rules = {
          noUnsafeEval: L(),
          noInlineStyle: !1
        };
    }
    return ci.rules;
    function L() {
      try {
        return new Function(""), !1;
      } catch {
        return !0;
      }
    }
  }, oi = function() {
    if (ee(oi.name_))
      return oi.name_;
    var A, k, L = Ca.length, I, B;
    for (k = 0; k < L; ++k)
      if (I = Ca[k], A = r.querySelector("[" + I.replace(":", "\\:") + "jq]")) {
        B = A.getAttribute(I + "jq");
        break;
      }
    return oi.name_ = B;
  };
  function Kr(A, k, L) {
    return A.concat(m.call(k, L));
  }
  function mn(A, k) {
    return m.call(A, k || 0);
  }
  function wa(A, k) {
    var L = arguments.length > 2 ? mn(arguments, 2) : [];
    return Ze(k) && !(k instanceof RegExp) ? L.length ? function() {
      return arguments.length ? k.apply(A, Kr(L, arguments, 0)) : k.apply(A, L);
    } : function() {
      return arguments.length ? k.apply(A, arguments) : k.call(A);
    } : k;
  }
  function Ys(A, k) {
    var L = k;
    return typeof A == "string" && A.charAt(0) === "$" && A.charAt(1) === "$" ? L = i : qt(k) ? L = "$WINDOW" : k && r === k ? L = "$DOCUMENT" : ir(k) && (L = "$SCOPE"), L;
  }
  function za(A, k) {
    return ce(A) ? i : (ot(k) || (k = k ? 2 : null), JSON.stringify(A, Ys, k));
  }
  function jn(A) {
    return Ne(A) ? JSON.parse(A) : A;
  }
  var Xa = /:/g;
  function Ks(A, k) {
    A = A.replace(Xa, "");
    var L = Date.parse("Jan 01, 1970 00:00:00 " + A) / 6e4;
    return isNaN(L) ? k : L;
  }
  function yn(A, k) {
    return A = new Date(A.getTime()), A.setMinutes(A.getMinutes() + k), A;
  }
  function ha(A, k, L) {
    L = L ? -1 : 1;
    var I = A.getTimezoneOffset(), B = Ks(k, I);
    return yn(A, L * (B - I));
  }
  function Ei(A) {
    A = d(A).clone();
    try {
      A.empty();
    } catch {
    }
    var k = d("<div>").append(A).html();
    try {
      return A[0].nodeType === Ra ? s(k) : k.match(/^(<[^>]+>)/)[1].replace(/^<([\w\-]+)/, function(L, I) {
        return "<" + s(I);
      });
    } catch {
      return s(k);
    }
  }
  function ys(A) {
    try {
      return decodeURIComponent(A);
    } catch {
    }
  }
  function Ro(A) {
    var k = {};
    return T((A || "").split("&"), function(L) {
      var I, B, U;
      L && (B = L = L.replace(/\+/g, "%20"), I = L.indexOf("="), I !== -1 && (B = L.substring(0, I), U = L.substring(I + 1)), B = ys(B), ee(B) && (U = ee(U) ? ys(U) : !0, o.call(k, B) ? $e(k[B]) ? k[B].push(U) : k[B] = [k[B], U] : k[B] = U));
    }), k;
  }
  function zs(A) {
    var k = [];
    return T(A, function(L, I) {
      $e(L) ? T(L, function(B) {
        k.push(_n(I, !0) + (B === !0 ? "" : "=" + _n(B, !0)));
      }) : k.push(_n(I, !0) + (L === !0 ? "" : "=" + _n(L, !0)));
    }), k.length ? k.join("&") : "";
  }
  function Ja(A) {
    return _n(A, !0).replace(/%26/gi, "&").replace(/%3D/gi, "=").replace(/%2B/gi, "+");
  }
  function _n(A, k) {
    return encodeURIComponent(A).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%3B/gi, ";").replace(/%20/g, k ? "%20" : "+");
  }
  var Ca = ["ng-", "data-ng-", "ng:", "x-ng-"];
  function Da(A, k) {
    var L, I, B = Ca.length;
    for (I = 0; I < B; ++I)
      if (L = Ca[I] + k, Ne(L = A.getAttribute(L)))
        return L;
    return null;
  }
  function on(A, k) {
    var L, I, B = {};
    T(Ca, function(U) {
      var j = U + "app";
      !L && A.hasAttribute && A.hasAttribute(j) && (L = A, I = A.getAttribute(j));
    }), T(Ca, function(U) {
      var j = U + "app", H;
      !L && (H = A.querySelector("[" + j.replace(":", "\\:") + "]")) && (L = H, I = H.getAttribute(j));
    }), L && (B.strictDi = Da(L, "strict-di") !== null, k(L, I ? [I] : [], B));
  }
  function Po(A, k, L) {
    me(L) || (L = {});
    var I = {
      strictDi: !1
    };
    L = $(I, L);
    var B = function() {
      if (A = d(A), A.injector()) {
        var H = A[0] === r ? "document" : Ei(A);
        throw g(
          "btstrpd",
          "App already bootstrapped with this element '{0}'",
          H.replace(/</, "&lt;").replace(/>/, "&gt;")
        );
      }
      k = k || [], k.unshift(["$provide", function(X) {
        X.value("$rootElement", A);
      }]), L.debugInfoEnabled && k.push(["$compileProvider", function(X) {
        X.debugInfoEnabled(!0);
      }]), k.unshift("ng");
      var W = Zt(k, L.strictDi);
      return W.invoke(
        [
          "$rootScope",
          "$rootElement",
          "$compile",
          "$injector",
          function(Z, fe, he, ye) {
            Z.$apply(function() {
              fe.data("$injector", ye), he(fe)(Z);
            });
          }
        ]
      ), W;
    }, U = /^NG_ENABLE_DEBUG_INFO!/, j = /^NG_DEFER_BOOTSTRAP!/;
    if (e && U.test(e.name) && (L.debugInfoEnabled = !0, e.name = e.name.replace(U, "")), e && !j.test(e.name))
      return B();
    e.name = e.name.replace(j, ""), E.resumeBootstrap = function(H) {
      return T(H, function(W) {
        k.push(W);
      }), B();
    }, Ze(E.resumeDeferredBootstrap) && E.resumeDeferredBootstrap();
  }
  function _s() {
    e.name = "NG_ENABLE_DEBUG_INFO!" + e.name, e.location.reload();
  }
  function bs(A) {
    var k = E.element(A).injector();
    if (!k)
      throw g(
        "test",
        "no injector found for element argument to getTestability"
      );
    return k.get("$$testability");
  }
  var Oo = /[A-Z]/g;
  function $n(A, k) {
    return k = k || "_", A.replace(Oo, function(L, I) {
      return (I ? k : "") + L.toLowerCase();
    });
  }
  var ui = !1, Ts;
  function Qi() {
    var A;
    if (!ui) {
      var k = oi();
      f = ce(k) ? e.jQuery : k ? e[k] : i, f && f.fn.on ? (d = f, $(f.fn, {
        scope: na.scope,
        isolateScope: na.isolateScope,
        controller: na.controller,
        injector: na.injector,
        inheritedData: na.inheritedData
      }), A = f.cleanData, f.cleanData = function(L) {
        var I;
        if (Ts)
          Ts = !1;
        else
          for (var B = 0, U; (U = L[B]) != null; B++)
            I = f._data(U, "events"), I && I.$destroy && f(U).triggerHandler("$destroy");
        A(L);
      }) : d = mr, E.element = d, ui = !0;
    }
  }
  function Ss(A, k, L) {
    if (!A)
      throw g("areq", "Argument '{0}' is {1}", k || "?", L || "required");
    return A;
  }
  function ka(A, k, L) {
    return L && $e(A) && (A = A[A.length - 1]), Ss(Ze(A), k, "not a function, got " + (A && typeof A == "object" ? A.constructor.name || "Object" : typeof A)), A;
  }
  function pa(A, k) {
    if (A === "hasOwnProperty")
      throw g("badname", "hasOwnProperty is not a valid {0} name", k);
  }
  function Qa(A, k, L) {
    if (!k)
      return A;
    for (var I = k.split("."), B, U = A, j = I.length, H = 0; H < j; H++)
      B = I[H], A && (A = (U = A)[B]);
    return !L && Ze(A) ? wa(U, A) : A;
  }
  function Za(A) {
    for (var k = A[0], L = A[A.length - 1], I, B = 1; k !== L && (k = k.nextSibling); B++)
      (I || A[B] !== k) && (I || (I = d(m.call(A, 0, B))), I.push(k));
    return I || A;
  }
  function xi() {
    return /* @__PURE__ */ Object.create(null);
  }
  var bn = 1, Es = 2, Ra = 3, Dn = 8, xs = 9, ta = 11;
  function Pa(A) {
    var k = t("$injector"), L = t("ng");
    function I(U, j, H) {
      return U[j] || (U[j] = H());
    }
    var B = I(A, "angular", Object);
    return B.$$minErr = B.$$minErr || t, I(B, "module", function() {
      var U = {};
      return function(H, W, X) {
        var Z = function(fe, he) {
          if (fe === "hasOwnProperty")
            throw L("badname", "hasOwnProperty is not a valid {0} name", he);
        };
        return Z(H, "module"), W && U.hasOwnProperty(H) && (U[H] = null), I(U, H, function() {
          if (!W)
            throw k("nomod", "Module '{0}' is not available! You either misspelled the module name or forgot to load it. If registering a module ensure that you specify the dependencies as the second argument.", H);
          var fe = [], he = [], ye = [], Se = be("$injector", "invoke", "push", he), Pe = {
            _invokeQueue: fe,
            _configBlocks: he,
            _runBlocks: ye,
            requires: W,
            name: H,
            provider: Te("$provide", "provider"),
            factory: Te("$provide", "factory"),
            service: Te("$provide", "service"),
            value: be("$provide", "value"),
            constant: be("$provide", "constant", "unshift"),
            decorator: Te("$provide", "decorator"),
            animation: Te("$animateProvider", "register"),
            filter: Te("$filterProvider", "register"),
            controller: Te("$controllerProvider", "register"),
            directive: Te("$compileProvider", "directive"),
            config: Se,
            run: function(_e) {
              return ye.push(_e), this;
            }
          };
          return X && Se(X), Pe;
          function be(_e, Ie, De, Re) {
            return Re || (Re = fe), function() {
              return Re[De || "push"]([_e, Ie, arguments]), Pe;
            };
          }
          function Te(_e, Ie) {
            return function(De, Re) {
              return Re && Ze(Re) && (Re.$$moduleName = H), fe.push([_e, Ie, arguments]), Pe;
            };
          }
        });
      };
    });
  }
  function Xs(A) {
    var k = [];
    return JSON.stringify(A, function(L, I) {
      if (I = Ys(L, I), me(I)) {
        if (k.indexOf(I) >= 0)
          return "...";
        k.push(I);
      }
      return I;
    });
  }
  function Tn(A) {
    return typeof A == "function" ? A.toString().replace(/ \{[\s\S]*$/, "") : ce(A) ? "undefined" : typeof A != "string" ? Xs(A) : A;
  }
  var es = {
    full: "1.4.14",
    major: 1,
    minor: 4,
    dot: 14,
    codeName: "material-distinction"
  };
  function ga(A) {
    $(A, {
      bootstrap: Po,
      copy: _i,
      extend: $,
      merge: O,
      equals: li,
      element: d,
      forEach: T,
      injector: Zt,
      noop: G,
      bind: wa,
      toJson: za,
      fromJson: jn,
      identity: K,
      isUndefined: ce,
      isDefined: ee,
      isString: Ne,
      isFunction: Ze,
      isObject: me,
      isNumber: ot,
      isElement: lt,
      isArray: $e,
      version: es,
      isDate: ze,
      lowercase: s,
      uppercase: l,
      callbacks: { counter: 0 },
      getTestability: bs,
      $$minErr: t,
      $$csp: ci,
      reloadWithDebugInfo: _s
    }), x = Pa(e), x("ng", ["ngLocale"], [
      "$provide",
      function(L) {
        L.provider({
          $$sanitizeUri: iw
        }), L.provider("$compile", xc).directive({
          a: Dw,
          input: gy,
          textarea: gy,
          form: Rw,
          script: x1,
          select: D1,
          style: R1,
          option: k1,
          ngBind: Ww,
          ngBindHtml: Kw,
          ngBindTemplate: Yw,
          ngClass: Xw,
          ngClassEven: Qw,
          ngClassOdd: Jw,
          ngCloak: Zw,
          ngController: e1,
          ngForm: Pw,
          ngHide: y1,
          ngIf: r1,
          ngInclude: i1,
          ngInit: a1,
          ngNonBindable: d1,
          ngPluralize: g1,
          ngRepeat: v1,
          ngShow: m1,
          ngStyle: _1,
          ngSwitch: b1,
          ngSwitchWhen: T1,
          ngSwitchDefault: S1,
          ngOptions: p1,
          ngTransclude: E1,
          ngModel: u1,
          ngList: s1,
          ngChange: zw,
          pattern: Ay,
          ngPattern: Ay,
          required: xy,
          ngRequired: xy,
          minlength: Cy,
          ngMinlength: Cy,
          maxlength: wy,
          ngMaxlength: wy,
          ngValue: qw,
          ngModelOptions: c1
        }).directive({
          ngInclude: n1
        }).directive(Kd).directive(vy), L.provider({
          $anchorScroll: nr,
          $animate: ts,
          $animateCss: Zi,
          $$animateJs: No,
          $$animateQueue: gu,
          $$AnimateRunner: Fo,
          $$animateAsyncRun: vu,
          $browser: mu,
          $cacheFactory: rs,
          $controller: we,
          $document: Fe,
          $exceptionHandler: He,
          $filter: K0,
          $$forceReflow: ct,
          $interpolate: ks,
          $interval: yu,
          $http: vr,
          $httpParamSerializer: Dr,
          $httpParamSerializerJQLike: hr,
          $httpBackend: zr,
          $xhrFactory: Zr,
          $location: VA,
          $log: qA,
          $parse: QA,
          $rootScope: rw,
          $q: ZA,
          $$q: ew,
          $sce: sw,
          $sceDelegate: aw,
          $sniffer: ow,
          $templateCache: sp,
          $templateRequest: uw,
          $$testability: lw,
          $timeout: cw,
          $window: dw,
          $$rAF: tw,
          $$jqLite: q,
          $$HashMap: ne,
          $$cookieReader: fw
        });
      }
    ]);
  }
  mr.expando = "ng339";
  var un = mr.cache = {}, As = 1, Oa = function(A, k, L) {
    A.addEventListener(k, L, !1);
  }, Gn = function(A, k, L) {
    A.removeEventListener(k, L, !1);
  };
  mr._data = function(A) {
    return this.cache[A[this.expando]] || {};
  };
  function Hn() {
    return ++As;
  }
  var Lo = /([\:\-\_]+(.))/g, de = /^moz([A-Z])/, Ee = { mouseleave: "mouseout", mouseenter: "mouseover" }, ge = t("jqLite");
  function Me(A) {
    return A.replace(Lo, function(k, L, I, B) {
      return B ? I.toUpperCase() : I;
    }).replace(de, "Moz$1");
  }
  var Ge = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/, Le = /<|&#?\w+;/, et = /<([\w:-]+)/, yt = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi, gt = {
    option: [1, '<select multiple="multiple">', "</select>"],
    thead: [1, "<table>", "</table>"],
    col: [2, "<table><colgroup>", "</colgroup></table>"],
    tr: [2, "<table><tbody>", "</tbody></table>"],
    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    _default: [0, "", ""]
  };
  gt.optgroup = gt.option, gt.tbody = gt.tfoot = gt.colgroup = gt.caption = gt.thead, gt.th = gt.td;
  function St(A) {
    return !Le.test(A);
  }
  function kt(A) {
    var k = A.nodeType;
    return k === bn || !k || k === xs;
  }
  function Qt(A) {
    for (var k in un[A.ng339])
      return !0;
    return !1;
  }
  function _r(A, k) {
    var L, I, B, U = k.createDocumentFragment(), j = [], H;
    if (St(A))
      j.push(k.createTextNode(A));
    else {
      for (L = L || U.appendChild(k.createElement("div")), I = (et.exec(A) || ["", ""])[1].toLowerCase(), B = gt[I] || gt._default, L.innerHTML = B[1] + A.replace(yt, "<$1></$2>") + B[2], H = B[0]; H--; )
        L = L.lastChild;
      j = Kr(j, L.childNodes), L = U.firstChild, L.textContent = "";
    }
    return U.textContent = "", U.innerHTML = "", T(j, function(W) {
      U.appendChild(W);
    }), U;
  }
  function Br(A, k) {
    k = k || r;
    var L;
    return (L = Ge.exec(A)) ? [k.createElement(L[1])] : (L = _r(A, k)) ? L.childNodes : [];
  }
  function jr(A, k) {
    var L = A.parentNode;
    L && L.replaceChild(k, A), k.appendChild(A);
  }
  var Ai = Node.prototype.contains || function(A) {
    return !!(this.compareDocumentPosition(A) & 16);
  };
  function mr(A) {
    if (A instanceof mr)
      return A;
    var k;
    if (Ne(A) && (A = It(A), k = !0), !(this instanceof mr)) {
      if (k && A.charAt(0) != "<")
        throw ge("nosel", "Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element");
      return new mr(A);
    }
    k ? Js(this, Br(A)) : Js(this, A);
  }
  function Ki(A) {
    return A.cloneNode(!0);
  }
  function ra(A, k) {
    if (k || Sn(A), A.querySelectorAll)
      for (var L = A.querySelectorAll("*"), I = 0, B = L.length; I < B; I++)
        Sn(L[I]);
  }
  function La(A, k, L, I) {
    if (ee(I))
      throw ge("offargs", "jqLite#off() does not support the `selector` argument");
    var B = Ia(A), U = B && B.events, j = B && B.handle;
    if (!!j)
      if (k) {
        var H = function(W) {
          var X = U[W];
          ee(L) && xr(X || [], L), ee(L) && X && X.length > 0 || (Gn(A, W, j), delete U[W]);
        };
        T(k.split(" "), function(W) {
          H(W), Ee[W] && H(Ee[W]);
        });
      } else
        for (k in U)
          k !== "$destroy" && Gn(A, k, j), delete U[k];
  }
  function Sn(A, k) {
    var L = A.ng339, I = L && un[L];
    if (I) {
      if (k) {
        delete I.data[k];
        return;
      }
      I.handle && (I.events.$destroy && I.handle({}, "$destroy"), La(A)), delete un[L], A.ng339 = i;
    }
  }
  function Ia(A, k) {
    var L = A.ng339, I = L && un[L];
    return k && !I && (A.ng339 = L = Hn(), I = un[L] = { events: {}, data: {}, handle: i }), I;
  }
  function Io(A, k, L) {
    if (kt(A)) {
      var I = ee(L), B = !I && k && !me(k), U = !k, j = Ia(A, !B), H = j && j.data;
      if (I)
        H[k] = L;
      else {
        if (U)
          return H;
        if (B)
          return H && H[k];
        $(H, k);
      }
    }
  }
  function Vn(A, k) {
    return A.getAttribute ? (" " + (A.getAttribute("class") || "") + " ").replace(/[\n\t]/g, " ").indexOf(" " + k + " ") > -1 : !1;
  }
  function ia(A, k) {
    k && A.setAttribute && T(k.split(" "), function(L) {
      A.setAttribute(
        "class",
        It(
          (" " + (A.getAttribute("class") || "") + " ").replace(/[\n\t]/g, " ").replace(" " + It(L) + " ", " ")
        )
      );
    });
  }
  function va(A, k) {
    if (k && A.setAttribute) {
      var L = (" " + (A.getAttribute("class") || "") + " ").replace(/[\n\t]/g, " ");
      T(k.split(" "), function(I) {
        I = It(I), L.indexOf(" " + I + " ") === -1 && (L += I + " ");
      }), A.setAttribute("class", It(L));
    }
  }
  function Js(A, k) {
    if (k)
      if (k.nodeType)
        A[A.length++] = k;
      else {
        var L = k.length;
        if (typeof L == "number" && k.window !== k) {
          if (L)
            for (var I = 0; I < L; I++)
              A[A.length++] = k[I];
        } else
          A[A.length++] = k;
      }
  }
  function ws(A, k) {
    return ma(A, "$" + (k || "ngController") + "Controller");
  }
  function ma(A, k, L) {
    A.nodeType == xs && (A = A.documentElement);
    for (var I = $e(k) ? k : [k]; A; ) {
      for (var B = 0, U = I.length; B < U; B++)
        if (ee(L = d.data(A, I[B])))
          return L;
      A = A.parentNode || A.nodeType === ta && A.host;
    }
  }
  function Qs(A) {
    for (ra(A, !0); A.firstChild; )
      A.removeChild(A.firstChild);
  }
  function ya(A, k) {
    k || ra(A);
    var L = A.parentNode;
    L && L.removeChild(A);
  }
  function fl(A, k) {
    k = k || e, k.document.readyState === "complete" ? k.setTimeout(A) : d(k).on("load", A);
  }
  var na = mr.prototype = {
    ready: function(A) {
      var k = !1;
      function L() {
        k || (k = !0, A());
      }
      r.readyState === "complete" ? setTimeout(L) : (this.on("DOMContentLoaded", L), mr(e).on("load", L));
    },
    toString: function() {
      var A = [];
      return T(this, function(k) {
        A.push("" + k);
      }), "[" + A.join(", ") + "]";
    },
    eq: function(A) {
      return A >= 0 ? d(this[A]) : d(this[this.length + A]);
    },
    length: 0,
    push: b,
    sort: [].sort,
    splice: [].splice
  }, Cs = {};
  T("multiple,selected,checked,disabled,readOnly,required,open".split(","), function(A) {
    Cs[s(A)] = A;
  });
  var pu = {};
  T("input,select,option,textarea,button,form,details".split(","), function(A) {
    pu[A] = !0;
  });
  var Mo = {
    ngMinlength: "minlength",
    ngMaxlength: "maxlength",
    ngMin: "min",
    ngMax: "max",
    ngPattern: "pattern"
  };
  function hl(A, k) {
    var L = Cs[k.toLowerCase()];
    return L && pu[Qr(A)] && L;
  }
  function pl(A) {
    return Mo[A];
  }
  T({
    data: Io,
    removeData: Sn,
    hasData: Qt
  }, function(A, k) {
    mr[k] = A;
  }), T({
    data: Io,
    inheritedData: ma,
    scope: function(A) {
      return d.data(A, "$scope") || ma(A.parentNode || A, ["$isolateScope", "$scope"]);
    },
    isolateScope: function(A) {
      return d.data(A, "$isolateScope") || d.data(A, "$isolateScopeNoTemplate");
    },
    controller: ws,
    injector: function(A) {
      return ma(A, "$injector");
    },
    removeAttr: function(A, k) {
      A.removeAttribute(k);
    },
    hasClass: Vn,
    css: function(A, k, L) {
      if (k = Me(k), ee(L))
        A.style[k] = L;
      else
        return A.style[k];
    },
    attr: function(A, k, L) {
      var I = A.nodeType;
      if (!(I === Ra || I === Es || I === Dn)) {
        var B = s(k);
        if (Cs[B])
          if (ee(L))
            L ? (A[k] = !0, A.setAttribute(k, B)) : (A[k] = !1, A.removeAttribute(B));
          else
            return A[k] || (A.attributes.getNamedItem(k) || G).specified ? B : i;
        else if (ee(L))
          A.setAttribute(k, L);
        else if (A.getAttribute) {
          var U = A.getAttribute(k, 2);
          return U === null ? i : U;
        }
      }
    },
    prop: function(A, k, L) {
      if (ee(L))
        A[k] = L;
      else
        return A[k];
    },
    text: function() {
      return A.$dv = "", A;
      function A(k, L) {
        if (ce(L)) {
          var I = k.nodeType;
          return I === bn || I === Ra ? k.textContent : "";
        }
        k.textContent = L;
      }
    }(),
    val: function(A, k) {
      if (ce(k)) {
        if (A.multiple && Qr(A) === "select") {
          var L = [];
          return T(A.options, function(I) {
            I.selected && L.push(I.value || I.text);
          }), L.length === 0 ? null : L;
        }
        return A.value;
      }
      A.value = k;
    },
    html: function(A, k) {
      if (ce(k))
        return A.innerHTML;
      ra(A, !0), A.innerHTML = k;
    },
    empty: Qs
  }, function(A, k) {
    mr.prototype[k] = function(L, I) {
      var B, U, j = this.length;
      if (A !== Qs && ce(A.length == 2 && A !== Vn && A !== ws ? L : I))
        if (me(L)) {
          for (B = 0; B < j; B++)
            if (A === Io)
              A(this[B], L);
            else
              for (U in L)
                A(this[B], U, L[U]);
          return this;
        } else {
          for (var H = A.$dv, W = ce(H) ? Math.min(j, 1) : j, X = 0; X < W; X++) {
            var Z = A(this[X], L, I);
            H = H ? H + Z : Z;
          }
          return H;
        }
      else {
        for (B = 0; B < j; B++)
          A(this[B], L, I);
        return this;
      }
    };
  });
  function Sc(A, k) {
    var L = function(I, B) {
      I.isDefaultPrevented = function() {
        return I.defaultPrevented;
      };
      var U = k[B || I.type], j = U ? U.length : 0;
      if (!!j) {
        if (ce(I.immediatePropagationStopped)) {
          var H = I.stopImmediatePropagation;
          I.stopImmediatePropagation = function() {
            I.immediatePropagationStopped = !0, I.stopPropagation && I.stopPropagation(), H && H.call(I);
          };
        }
        I.isImmediatePropagationStopped = function() {
          return I.immediatePropagationStopped === !0;
        };
        var W = U.specialHandlerWrapper || Ec;
        j > 1 && (U = Gr(U));
        for (var X = 0; X < j; X++)
          I.isImmediatePropagationStopped() || W(A, I, U[X]);
      }
    };
    return L.elem = A, L;
  }
  function Ec(A, k, L) {
    L.call(A, k);
  }
  function xe(A, k, L) {
    var I = k.relatedTarget;
    (!I || I !== A && !Ai.call(A, I)) && L.call(A, k);
  }
  T({
    removeData: Sn,
    on: function(k, L, I, B) {
      if (ee(B))
        throw ge("onargs", "jqLite#on() does not support the `selector` or `eventData` parameters");
      if (!!kt(k)) {
        var U = Ia(k, !0), j = U.events, H = U.handle;
        H || (H = U.handle = Sc(k, j));
        for (var W = L.indexOf(" ") >= 0 ? L.split(" ") : [L], X = W.length, Z = function(fe, he, ye) {
          var Se = j[fe];
          Se || (Se = j[fe] = [], Se.specialHandlerWrapper = he, fe !== "$destroy" && !ye && Oa(k, fe, H)), Se.push(I);
        }; X--; )
          L = W[X], Ee[L] ? (Z(Ee[L], xe), Z(L, i, !0)) : Z(L);
      }
    },
    off: La,
    one: function(A, k, L) {
      A = d(A), A.on(k, function I() {
        A.off(k, L), A.off(k, I);
      }), A.on(k, L);
    },
    replaceWith: function(A, k) {
      var L, I = A.parentNode;
      ra(A), T(new mr(k), function(B) {
        L ? I.insertBefore(B, L.nextSibling) : I.replaceChild(B, A), L = B;
      });
    },
    children: function(A) {
      var k = [];
      return T(A.childNodes, function(L) {
        L.nodeType === bn && k.push(L);
      }), k;
    },
    contents: function(A) {
      return A.contentDocument || A.childNodes || [];
    },
    append: function(A, k) {
      var L = A.nodeType;
      if (!(L !== bn && L !== ta)) {
        k = new mr(k);
        for (var I = 0, B = k.length; I < B; I++) {
          var U = k[I];
          A.appendChild(U);
        }
      }
    },
    prepend: function(A, k) {
      if (A.nodeType === bn) {
        var L = A.firstChild;
        T(new mr(k), function(I) {
          A.insertBefore(I, L);
        });
      }
    },
    wrap: function(A, k) {
      jr(A, d(k).eq(0).clone()[0]);
    },
    remove: ya,
    detach: function(A) {
      ya(A, !0);
    },
    after: function(A, k) {
      var L = A, I = A.parentNode;
      k = new mr(k);
      for (var B = 0, U = k.length; B < U; B++) {
        var j = k[B];
        I.insertBefore(j, L.nextSibling), L = j;
      }
    },
    addClass: va,
    removeClass: ia,
    toggleClass: function(A, k, L) {
      k && T(k.split(" "), function(I) {
        var B = L;
        ce(B) && (B = !Vn(A, I)), (B ? va : ia)(A, I);
      });
    },
    parent: function(A) {
      var k = A.parentNode;
      return k && k.nodeType !== ta ? k : null;
    },
    next: function(A) {
      return A.nextElementSibling;
    },
    find: function(A, k) {
      return A.getElementsByTagName ? A.getElementsByTagName(k) : [];
    },
    clone: Ki,
    triggerHandler: function(A, k, L) {
      var I, B, U, j = k.type || k, H = Ia(A), W = H && H.events, X = W && W[j];
      X && (I = {
        preventDefault: function() {
          this.defaultPrevented = !0;
        },
        isDefaultPrevented: function() {
          return this.defaultPrevented === !0;
        },
        stopImmediatePropagation: function() {
          this.immediatePropagationStopped = !0;
        },
        isImmediatePropagationStopped: function() {
          return this.immediatePropagationStopped === !0;
        },
        stopPropagation: G,
        type: j,
        target: A
      }, k.type && (I = $(I, k)), B = Gr(X), U = L ? [I].concat(L) : [I], T(B, function(Z) {
        I.isImmediatePropagationStopped() || Z.apply(A, U);
      }));
    }
  }, function(A, k) {
    mr.prototype[k] = function(L, I, B) {
      for (var U, j = 0, H = this.length; j < H; j++)
        ce(U) ? (U = A(this[j], L, I, B), ee(U) && (U = d(U))) : Js(U, A(this[j], L, I, B));
      return ee(U) ? U : this;
    }, mr.prototype.bind = mr.prototype.on, mr.prototype.unbind = mr.prototype.off;
  });
  function q() {
    this.$get = function() {
      return $(mr, {
        hasClass: function(k, L) {
          return k.attr && (k = k[0]), Vn(k, L);
        },
        addClass: function(k, L) {
          return k.attr && (k = k[0]), va(k, L);
        },
        removeClass: function(k, L) {
          return k.attr && (k = k[0]), ia(k, L);
        }
      });
    };
  }
  function z(A, k) {
    var L = A && A.$$hashKey;
    if (L)
      return typeof L == "function" && (L = A.$$hashKey()), L;
    var I = typeof A;
    return I == "function" || I == "object" && A !== null ? L = A.$$hashKey = I + ":" + (k || R)() : L = I + ":" + A, L;
  }
  function ie(A, k) {
    if (k) {
      var L = 0;
      this.nextUid = function() {
        return ++L;
      };
    }
    T(A, this.put, this);
  }
  ie.prototype = {
    put: function(A, k) {
      this[z(A, this.nextUid)] = k;
    },
    get: function(A) {
      return this[z(A, this.nextUid)];
    },
    remove: function(A) {
      var k = this[A = z(A, this.nextUid)];
      return delete this[A], k;
    }
  };
  var ne = [function() {
    this.$get = [function() {
      return ie;
    }];
  }], pe = /^[^\(]*\(\s*([^\)]*)\)/m, ve = /,/, Ae = /^\s*(_?)(\S+?)\1\s*$/, ke = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg, Ve = t("$injector");
  function st(A) {
    var k = A.toString().replace(ke, ""), L = k.match(pe);
    return L ? "function(" + (L[1] || "").replace(/[\s\r\n]+/, " ") + ")" : "fn";
  }
  function Ft(A, k, L) {
    var I, B, U, j;
    if (typeof A == "function") {
      if (!(I = A.$inject)) {
        if (I = [], A.length) {
          if (k)
            throw (!Ne(L) || !L) && (L = A.name || st(A)), Ve(
              "strictdi",
              "{0} is not using explicit annotation and cannot be invoked in strict mode",
              L
            );
          B = A.toString().replace(ke, ""), U = B.match(pe), T(U[1].split(ve), function(H) {
            H.replace(Ae, function(W, X, Z) {
              I.push(Z);
            });
          });
        }
        A.$inject = I;
      }
    } else
      $e(A) ? (j = A.length - 1, ka(A[j], "fn"), I = A.slice(0, j)) : ka(A, "fn", !0);
    return I;
  }
  function Zt(A, k) {
    k = k === !0;
    var L = {}, I = "Provider", B = [], U = new ie([], !0), j = {
      $provide: {
        provider: Z(fe),
        factory: Z(ye),
        service: Z(Se),
        value: Z(Pe),
        constant: Z(be),
        decorator: Te
      }
    }, H = j.$injector = Ie(j, function(De, Re) {
      throw E.isString(Re) && B.push(Re), Ve("unpr", "Unknown provider: {0}", B.join(" <- "));
    }), W = {}, X = W.$injector = Ie(W, function(De, Re) {
      var qe = H.get(De + I, Re);
      return X.invoke(qe.$get, qe, i, De);
    });
    return T(_e(A), function(De) {
      De && X.invoke(De);
    }), X;
    function Z(De) {
      return function(Re, qe) {
        if (me(Re))
          T(Re, D(De));
        else
          return De(Re, qe);
      };
    }
    function fe(De, Re) {
      if (pa(De, "service"), (Ze(Re) || $e(Re)) && (Re = H.instantiate(Re)), !Re.$get)
        throw Ve("pget", "Provider '{0}' must define $get factory method.", De);
      return j[De + I] = Re;
    }
    function he(De, Re) {
      return function() {
        var Oe = X.invoke(Re, this);
        if (ce(Oe))
          throw Ve("undef", "Provider '{0}' must return a value from $get factory method.", De);
        return Oe;
      };
    }
    function ye(De, Re, qe) {
      return fe(De, {
        $get: qe !== !1 ? he(De, Re) : Re
      });
    }
    function Se(De, Re) {
      return ye(De, ["$injector", function(qe) {
        return qe.instantiate(Re);
      }]);
    }
    function Pe(De, Re) {
      return ye(De, J(Re), !1);
    }
    function be(De, Re) {
      pa(De, "constant"), j[De] = Re, W[De] = Re;
    }
    function Te(De, Re) {
      var qe = H.get(De + I), Oe = qe.$get;
      qe.$get = function() {
        var rt = X.invoke(Oe, qe);
        return X.invoke(Re, null, { $delegate: rt });
      };
    }
    function _e(De) {
      Ss(ce(De) || $e(De), "modulesToLoad", "not an array");
      var Re = [], qe;
      return T(De, function(Oe) {
        if (U.get(Oe))
          return;
        U.put(Oe, !0);
        function rt(Xe) {
          var Je, Qe;
          for (Je = 0, Qe = Xe.length; Je < Qe; Je++) {
            var tt = Xe[Je], dt = H.get(tt[0]);
            dt[tt[1]].apply(dt, tt[2]);
          }
        }
        try {
          Ne(Oe) ? (qe = x(Oe), Re = Re.concat(_e(qe.requires)).concat(qe._runBlocks), rt(qe._invokeQueue), rt(qe._configBlocks)) : Ze(Oe) || $e(Oe) ? Re.push(H.invoke(Oe)) : ka(Oe, "module");
        } catch (Xe) {
          throw $e(Oe) && (Oe = Oe[Oe.length - 1]), Xe.message && Xe.stack && Xe.stack.indexOf(Xe.message) == -1 && (Xe = Xe.message + `
` + Xe.stack), Ve(
            "modulerr",
            `Failed to instantiate module {0} due to:
{1}`,
            Oe,
            Xe.stack || Xe.message || Xe
          );
        }
      }), Re;
    }
    function Ie(De, Re) {
      function qe(Xe, Je) {
        if (De.hasOwnProperty(Xe)) {
          if (De[Xe] === L)
            throw Ve(
              "cdep",
              "Circular dependency found: {0}",
              Xe + " <- " + B.join(" <- ")
            );
          return De[Xe];
        } else
          try {
            return B.unshift(Xe), De[Xe] = L, De[Xe] = Re(Xe, Je);
          } catch (Qe) {
            throw De[Xe] === L && delete De[Xe], Qe;
          } finally {
            B.shift();
          }
      }
      function Oe(Xe, Je, Qe, tt) {
        typeof Qe == "string" && (tt = Qe, Qe = null);
        var dt = [], Ye = Zt.$$annotate(Xe, k, tt), it, wt, Ct;
        for (wt = 0, it = Ye.length; wt < it; wt++) {
          if (Ct = Ye[wt], typeof Ct != "string")
            throw Ve(
              "itkn",
              "Incorrect injection token! Expected service name as string, got {0}",
              Ct
            );
          dt.push(
            Qe && Qe.hasOwnProperty(Ct) ? Qe[Ct] : qe(Ct, tt)
          );
        }
        return $e(Xe) && (Xe = Xe[it]), Xe.apply(Je, dt);
      }
      function rt(Xe, Je, Qe) {
        var tt = Object.create(($e(Xe) ? Xe[Xe.length - 1] : Xe).prototype || null), dt = Oe(Xe, tt, Je, Qe);
        return me(dt) || Ze(dt) ? dt : tt;
      }
      return {
        invoke: Oe,
        instantiate: rt,
        get: qe,
        annotate: Zt.$$annotate,
        has: function(Xe) {
          return j.hasOwnProperty(Xe + I) || De.hasOwnProperty(Xe);
        }
      };
    }
  }
  Zt.$$annotate = Ft;
  function nr() {
    var A = !0;
    this.disableAutoScrolling = function() {
      A = !1;
    }, this.$get = ["$window", "$location", "$rootScope", function(k, L, I) {
      var B = k.document;
      function U(X) {
        var Z = null;
        return Array.prototype.some.call(X, function(fe) {
          if (Qr(fe) === "a")
            return Z = fe, !0;
        }), Z;
      }
      function j() {
        var X = W.yOffset;
        if (Ze(X))
          X = X();
        else if (lt(X)) {
          var Z = X[0], fe = k.getComputedStyle(Z);
          fe.position !== "fixed" ? X = 0 : X = Z.getBoundingClientRect().bottom;
        } else
          ot(X) || (X = 0);
        return X;
      }
      function H(X) {
        if (X) {
          X.scrollIntoView();
          var Z = j();
          if (Z) {
            var fe = X.getBoundingClientRect().top;
            k.scrollBy(0, fe - Z);
          }
        } else
          k.scrollTo(0, 0);
      }
      function W(X) {
        X = Ne(X) ? X : L.hash();
        var Z;
        X ? (Z = B.getElementById(X)) || (Z = U(B.getElementsByName(X))) ? H(Z) : X === "top" && H(null) : H(null);
      }
      return A && I.$watch(
        function() {
          return L.hash();
        },
        function(Z, fe) {
          Z === fe && Z === "" || fl(function() {
            I.$evalAsync(W);
          });
        }
      ), W;
    }];
  }
  var br = t("$animate"), Cr = 1, Rt = "ng-animate";
  function Oi(A, k) {
    return !A && !k ? "" : A ? k ? ($e(A) && (A = A.join(" ")), $e(k) && (k = k.join(" ")), A + " " + k) : A : k;
  }
  function qn(A) {
    for (var k = 0; k < A.length; k++) {
      var L = A[k];
      if (L.nodeType === Cr)
        return L;
    }
  }
  function Ds(A) {
    Ne(A) && (A = A.split(" "));
    var k = xi();
    return T(A, function(L) {
      L.length && (k[L] = !0);
    }), k;
  }
  function _a(A) {
    return me(A) ? A : {};
  }
  var No = function() {
    this.$get = function() {
    };
  }, gu = function() {
    var A = new ie(), k = [];
    this.$get = [
      "$$AnimateRunner",
      "$rootScope",
      function(L, I) {
        return {
          enabled: G,
          on: G,
          off: G,
          pin: G,
          push: function(H, W, X, Z) {
            Z && Z(), X = X || {}, X.from && H.css(X.from), X.to && H.css(X.to), (X.addClass || X.removeClass) && j(H, X.addClass, X.removeClass);
            var fe = new L();
            return fe.complete(), fe;
          }
        };
        function B(H, W, X) {
          var Z = !1;
          return W && (W = Ne(W) ? W.split(" ") : $e(W) ? W : [], T(W, function(fe) {
            fe && (Z = !0, H[fe] = X);
          })), Z;
        }
        function U() {
          T(k, function(H) {
            var W = A.get(H);
            if (W) {
              var X = Ds(H.attr("class")), Z = "", fe = "";
              T(W, function(he, ye) {
                var Se = !!X[ye];
                he !== Se && (he ? Z += (Z.length ? " " : "") + ye : fe += (fe.length ? " " : "") + ye);
              }), T(H, function(he) {
                Z && va(he, Z), fe && ia(he, fe);
              }), A.remove(H);
            }
          }), k.length = 0;
        }
        function j(H, W, X) {
          var Z = A.get(H) || {}, fe = B(Z, W, !0), he = B(Z, X, !1);
          (fe || he) && (A.put(H, Z), k.push(H), k.length === 1 && I.$$postDigest(U));
        }
      }
    ];
  }, ts = ["$provide", function(A) {
    var k = this;
    this.$$registeredAnimations = /* @__PURE__ */ Object.create(null), this.register = function(L, I) {
      if (L && L.charAt(0) !== ".")
        throw br("notcsel", "Expecting class selector starting with '.' got '{0}'.", L);
      var B = L + "-animation";
      k.$$registeredAnimations[L.substr(1)] = B, A.factory(B, I);
    }, this.classNameFilter = function(L) {
      if (arguments.length === 1 && (this.$$classNameFilter = L instanceof RegExp ? L : null, this.$$classNameFilter)) {
        var I = new RegExp("(\\s+|\\/)" + Rt + "(\\s+|\\/)");
        if (I.test(this.$$classNameFilter.toString()))
          throw br("nongcls", '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', Rt);
      }
      return this.$$classNameFilter;
    }, this.$get = ["$$animateQueue", function(L) {
      function I(B, U, j) {
        if (j) {
          var H = qn(j);
          H && !H.parentNode && !H.previousElementSibling && (j = null);
        }
        j ? j.after(B) : U.prepend(B);
      }
      return {
        on: L.on,
        off: L.off,
        pin: L.pin,
        enabled: L.enabled,
        cancel: function(B) {
          B.end && B.end();
        },
        enter: function(B, U, j, H) {
          return U = U && d(U), j = j && d(j), U = U || j.parent(), I(B, U, j), L.push(B, "enter", _a(H));
        },
        move: function(B, U, j, H) {
          return U = U && d(U), j = j && d(j), U = U || j.parent(), I(B, U, j), L.push(B, "move", _a(H));
        },
        leave: function(B, U) {
          return L.push(B, "leave", _a(U), function() {
            B.remove();
          });
        },
        addClass: function(B, U, j) {
          return j = _a(j), j.addClass = Oi(j.addclass, U), L.push(B, "addClass", j);
        },
        removeClass: function(B, U, j) {
          return j = _a(j), j.removeClass = Oi(j.removeClass, U), L.push(B, "removeClass", j);
        },
        setClass: function(B, U, j, H) {
          return H = _a(H), H.addClass = Oi(H.addClass, U), H.removeClass = Oi(H.removeClass, j), L.push(B, "setClass", H);
        },
        animate: function(B, U, j, H, W) {
          return W = _a(W), W.from = W.from ? $(W.from, U) : U, W.to = W.to ? $(W.to, j) : j, H = H || "ng-inline-animate", W.tempClasses = Oi(W.tempClasses, H), L.push(B, "animate", W);
        }
      };
    }];
  }], vu = function() {
    this.$get = ["$$rAF", function(A) {
      var k = [];
      function L(I) {
        k.push(I), !(k.length > 1) && A(function() {
          for (var B = 0; B < k.length; B++)
            k[B]();
          k = [];
        });
      }
      return function() {
        var I = !1;
        return L(function() {
          I = !0;
        }), function(B) {
          I ? B() : L(B);
        };
      };
    }];
  }, Fo = function() {
    this.$get = [
      "$q",
      "$sniffer",
      "$$animateAsyncRun",
      "$document",
      "$timeout",
      function(A, k, L, I, B) {
        var U = 0, j = 1, H = 2;
        W.chain = function(X, Z) {
          var fe = 0;
          he();
          function he() {
            if (fe === X.length) {
              Z(!0);
              return;
            }
            X[fe](function(ye) {
              if (ye === !1) {
                Z(!1);
                return;
              }
              fe++, he();
            });
          }
        }, W.all = function(X, Z) {
          var fe = 0, he = !0;
          T(X, function(Se) {
            Se.done(ye);
          });
          function ye(Se) {
            he = he && Se, ++fe === X.length && Z(he);
          }
        };
        function W(X) {
          this.setHost(X);
          var Z = L(), fe = function(he) {
            B(he, 0, !1);
          };
          this._doneCallbacks = [], this._tick = function(he) {
            var ye = I[0];
            ye && ye.hidden ? fe(he) : Z(he);
          }, this._state = 0;
        }
        return W.prototype = {
          setHost: function(X) {
            this.host = X || {};
          },
          done: function(X) {
            this._state === H ? X() : this._doneCallbacks.push(X);
          },
          progress: G,
          getPromise: function() {
            if (!this.promise) {
              var X = this;
              this.promise = A(function(Z, fe) {
                X.done(function(he) {
                  he === !1 ? fe() : Z();
                });
              });
            }
            return this.promise;
          },
          then: function(X, Z) {
            return this.getPromise().then(X, Z);
          },
          catch: function(X) {
            return this.getPromise().catch(X);
          },
          finally: function(X) {
            return this.getPromise().finally(X);
          },
          pause: function() {
            this.host.pause && this.host.pause();
          },
          resume: function() {
            this.host.resume && this.host.resume();
          },
          end: function() {
            this.host.end && this.host.end(), this._resolve(!0);
          },
          cancel: function() {
            this.host.cancel && this.host.cancel(), this._resolve(!1);
          },
          complete: function(X) {
            var Z = this;
            Z._state === U && (Z._state = j, Z._tick(function() {
              Z._resolve(X);
            }));
          },
          _resolve: function(X) {
            this._state !== H && (T(this._doneCallbacks, function(Z) {
              Z(X);
            }), this._doneCallbacks.length = 0, this._state = H);
          }
        }, W;
      }
    ];
  }, Zi = function() {
    this.$get = ["$$rAF", "$q", "$$AnimateRunner", function(A, k, L) {
      return function(I, B) {
        var U = B || {};
        U.$$prepared || (U = _i(U)), U.cleanupStyles && (U.from = U.to = null), U.from && (I.css(U.from), U.from = null);
        var j, H = new L();
        return {
          start: W,
          end: W
        };
        function W() {
          return A(function() {
            X(), j || H.complete(), j = !0;
          }), H;
        }
        function X() {
          U.addClass && (I.addClass(U.addClass), U.addClass = null), U.removeClass && (I.removeClass(U.removeClass), U.removeClass = null), U.to && (I.css(U.to), U.to = null);
        }
      };
    }];
  };
  function wi(A, k, L, I) {
    var B = this;
    k[0];
    var U = A.location, j = A.history, H = A.setTimeout, W = A.clearTimeout, X = {};
    B.isMock = !1;
    var Z = 0, fe = [];
    B.$$completeOutstandingRequest = he, B.$$incOutstandingRequestCount = function() {
      Z++;
    };
    function he(Je) {
      try {
        Je.apply(null, mn(arguments, 1));
      } finally {
        if (Z--, Z === 0)
          for (; fe.length; )
            try {
              fe.pop()();
            } catch (Qe) {
              L.error(Qe);
            }
      }
    }
    function ye(Je) {
      var Qe = Je.indexOf("#");
      return Qe === -1 ? "" : Je.substr(Qe);
    }
    B.notifyWhenNoOutstandingRequests = function(Je) {
      Z === 0 ? Je() : fe.push(Je);
    };
    var Se, Pe, be = U.href, Te = k.find("base"), _e = null;
    rt(), Pe = Se, B.url = function(Je, Qe, tt) {
      if (ce(tt) && (tt = null), U !== A.location && (U = A.location), j !== A.history && (j = A.history), Je) {
        var dt = Pe === tt;
        if (be === Je && (!I.history || dt))
          return B;
        var Ye = be && Zs(be) === Zs(Je);
        return be = Je, Pe = tt, I.history && (!Ye || !dt) ? (j[Qe ? "replaceState" : "pushState"](tt, "", Je), rt(), Pe = Se) : ((!Ye || _e) && (_e = Je), Qe ? U.replace(Je) : Ye ? U.hash = ye(Je) : U.href = Je, U.href !== Je && (_e = Je)), B;
      } else
        return _e || U.href.replace(/%27/g, "'");
    }, B.state = function() {
      return Se;
    };
    var Ie = [], De = !1;
    function Re() {
      _e = null, rt(), Xe();
    }
    function qe() {
      try {
        return j.state;
      } catch {
      }
    }
    var Oe = null;
    function rt() {
      Se = qe(), Se = ce(Se) ? null : Se, li(Se, Oe) && (Se = Oe), Oe = Se;
    }
    function Xe() {
      be === B.url() && Pe === Se || (be = B.url(), Pe = Se, T(Ie, function(Je) {
        Je(B.url(), Se);
      }));
    }
    B.onUrlChange = function(Je) {
      return De || (I.history && d(A).on("popstate", Re), d(A).on("hashchange", Re), De = !0), Ie.push(Je), Je;
    }, B.$$applicationDestroyed = function() {
      d(A).off("hashchange popstate", Re);
    }, B.$$checkUrlChange = Xe, B.baseHref = function() {
      var Je = Te.attr("href");
      return Je ? Je.replace(/^(https?\:)?\/\/[^\/]*/, "") : "";
    }, B.defer = function(Je, Qe) {
      var tt;
      return Z++, tt = H(function() {
        delete X[tt], he(Je);
      }, Qe || 0), X[tt] = !0, tt;
    }, B.defer.cancel = function(Je) {
      return X[Je] ? (delete X[Je], W(Je), he(G), !0) : !1;
    };
  }
  function mu() {
    this.$get = [
      "$window",
      "$log",
      "$sniffer",
      "$document",
      function(A, k, L, I) {
        return new wi(A, I, k, L);
      }
    ];
  }
  function rs() {
    this.$get = function() {
      var A = {};
      function k(L, I) {
        if (L in A)
          throw t("$cacheFactory")("iid", "CacheId '{0}' is already taken!", L);
        var B = 0, U = $({}, I, { id: L }), j = xi(), H = I && I.capacity || Number.MAX_VALUE, W = xi(), X = null, Z = null;
        return A[L] = {
          put: function(ye, Se) {
            if (!ce(Se)) {
              if (H < Number.MAX_VALUE) {
                var Pe = W[ye] || (W[ye] = { key: ye });
                fe(Pe);
              }
              return ye in j || B++, j[ye] = Se, B > H && this.remove(Z.key), Se;
            }
          },
          get: function(ye) {
            if (H < Number.MAX_VALUE) {
              var Se = W[ye];
              if (!Se)
                return;
              fe(Se);
            }
            return j[ye];
          },
          remove: function(ye) {
            if (H < Number.MAX_VALUE) {
              var Se = W[ye];
              if (!Se)
                return;
              Se == X && (X = Se.p), Se == Z && (Z = Se.n), he(Se.n, Se.p), delete W[ye];
            }
            ye in j && (delete j[ye], B--);
          },
          removeAll: function() {
            j = xi(), B = 0, W = xi(), X = Z = null;
          },
          destroy: function() {
            j = null, U = null, W = null, delete A[L];
          },
          info: function() {
            return $({}, U, { size: B });
          }
        };
        function fe(ye) {
          ye != X && (Z ? Z == ye && (Z = ye.n) : Z = ye, he(ye.n, ye.p), he(ye, X), X = ye, X.n = null);
        }
        function he(ye, Se) {
          ye != Se && (ye && (ye.p = Se), Se && (Se.n = ye));
        }
      }
      return k.info = function() {
        var L = {};
        return T(A, function(I, B) {
          L[B] = I.info();
        }), L;
      }, k.get = function(L) {
        return A[L];
      }, k;
    };
  }
  function sp() {
    this.$get = ["$cacheFactory", function(A) {
      return A("templates");
    }];
  }
  var Yn = t("$compile");
  xc.$inject = ["$provide", "$$sanitizeUriProvider"];
  function xc(A, k) {
    var L = {}, I = "Directive", B = /^\s*directive\:\s*([\w\-]+)\s+(.*)$/, U = /(([\w\-]+)(?:\:([^;]+))?;?)/, j = ri("ngSrc,ngSrcset,src,srcset"), H = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/, W = /^(on[a-z]+|formaction)$/, X = xi();
    function Z(Se, Pe, be) {
      var Te = /^\s*([@&]|=(\*?))(\??)\s*(\w*)\s*$/, _e = xi();
      return T(Se, function(Ie, De) {
        if (Ie in X) {
          _e[De] = X[Ie];
          return;
        }
        var Re = Ie.match(Te);
        if (!Re)
          throw Yn(
            "iscp",
            "Invalid {3} for directive '{0}'. Definition: {... {1}: '{2}' ...}",
            Pe,
            De,
            Ie,
            be ? "controller bindings definition" : "isolate scope definition"
          );
        _e[De] = {
          mode: Re[1][0],
          collection: Re[2] === "*",
          optional: Re[3] === "?",
          attrName: Re[4] || De
        }, Re[4] && (X[Ie] = _e[De]);
      }), _e;
    }
    function fe(Se, Pe) {
      var be = {
        isolateScope: null,
        bindToController: null
      };
      if (me(Se.scope) && (Se.bindToController === !0 ? (be.bindToController = Z(
        Se.scope,
        Pe,
        !0
      ), be.isolateScope = {}) : be.isolateScope = Z(
        Se.scope,
        Pe,
        !1
      )), me(Se.bindToController) && (be.bindToController = Z(Se.bindToController, Pe, !0)), me(be.bindToController)) {
        var Te = Se.controller, _e = Se.controllerAs;
        if (Te) {
          if (!te(Te, _e))
            throw Yn(
              "noident",
              "Cannot bind to controller without identifier for directive '{0}'.",
              Pe
            );
        } else
          throw Yn(
            "noctrl",
            "Cannot bind to controller without directive '{0}'s controller.",
            Pe
          );
      }
      return be;
    }
    function he(Se) {
      var Pe = Se.charAt(0);
      if (!Pe || Pe !== s(Pe))
        throw Yn("baddir", "Directive name '{0}' is invalid. The first character must be a lowercase letter", Se);
      if (Se !== Se.trim())
        throw Yn(
          "baddir",
          "Directive name '{0}' is invalid. The name should not contain leading or trailing whitespaces",
          Se
        );
    }
    this.directive = function Se(Pe, be) {
      return pa(Pe, "directive"), Ne(Pe) ? (he(Pe), Ss(be, "directiveFactory"), L.hasOwnProperty(Pe) || (L[Pe] = [], A.factory(Pe + I, [
        "$injector",
        "$exceptionHandler",
        function(Te, _e) {
          var Ie = [];
          return T(L[Pe], function(De, Re) {
            try {
              var qe = Te.invoke(De);
              Ze(qe) ? qe = { compile: J(qe) } : !qe.compile && qe.link && (qe.compile = J(qe.link)), qe.priority = qe.priority || 0, qe.index = Re, qe.name = qe.name || Pe, qe.require = qe.require || qe.controller && qe.name, qe.restrict = qe.restrict || "EA", qe.$$moduleName = De.$$moduleName, Ie.push(qe);
            } catch (Oe) {
              _e(Oe);
            }
          }), Ie;
        }
      ])), L[Pe].push(be)) : T(Pe, D(Se)), this;
    }, this.aHrefSanitizationWhitelist = function(Se) {
      return ee(Se) ? (k.aHrefSanitizationWhitelist(Se), this) : k.aHrefSanitizationWhitelist();
    }, this.imgSrcSanitizationWhitelist = function(Se) {
      return ee(Se) ? (k.imgSrcSanitizationWhitelist(Se), this) : k.imgSrcSanitizationWhitelist();
    };
    var ye = !0;
    this.debugInfoEnabled = function(Se) {
      return ee(Se) ? (ye = Se, this) : ye;
    }, this.$get = [
      "$injector",
      "$interpolate",
      "$exceptionHandler",
      "$templateRequest",
      "$parse",
      "$controller",
      "$rootScope",
      "$sce",
      "$animate",
      "$$sanitizeUri",
      function(Se, Pe, be, Te, _e, Ie, De, Re, qe, Oe) {
        var rt = function(je, Ke) {
          if (Ke) {
            var mt = Object.keys(Ke), Et, Xt, ur;
            for (Et = 0, Xt = mt.length; Et < Xt; Et++)
              ur = mt[Et], this[ur] = Ke[ur];
          } else
            this.$attr = {};
          this.$$element = je;
        };
        rt.prototype = {
          $normalize: V,
          $addClass: function(je) {
            je && je.length > 0 && qe.addClass(this.$$element, je);
          },
          $removeClass: function(je) {
            je && je.length > 0 && qe.removeClass(this.$$element, je);
          },
          $updateClass: function(je, Ke) {
            var mt = Y(je, Ke);
            mt && mt.length && qe.addClass(this.$$element, mt);
            var Et = Y(Ke, je);
            Et && Et.length && qe.removeClass(this.$$element, Et);
          },
          $set: function(je, Ke, mt, Et) {
            var Xt = this.$$element[0], ur = hl(Xt, je), Wt = pl(je), cr = je, Bt;
            if (ur ? (this.$$element.prop(je, Ke), Et = ur) : Wt && (this[Wt] = Ke, cr = Wt), this[je] = Ke, Et ? this.$attr[je] = Et : (Et = this.$attr[je], Et || (this.$attr[je] = Et = $n(je, "-"))), Bt = Qr(this.$$element), Bt === "a" && je === "href" || Bt === "img" && je === "src")
              this[je] = Ke = Oe(Ke, je === "src");
            else if (Bt === "img" && je === "srcset" && ee(Ke)) {
              for (var rr = "", pr = It(Ke), gr = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/, Nt = /\s/.test(pr) ? gr : /(,)/, Vr = pr.split(Nt), Pr = Math.floor(Vr.length / 2), fi = 0; fi < Pr; fi++) {
                var ni = fi * 2;
                rr += Oe(It(Vr[ni]), !0), rr += " " + It(Vr[ni + 1]);
              }
              var Ir = It(Vr[fi * 2]).split(/\s/);
              rr += Oe(It(Ir[0]), !0), Ir.length === 2 && (rr += " " + It(Ir[1])), this[je] = Ke = rr;
            }
            mt !== !1 && (Ke === null || ce(Ke) ? this.$$element.removeAttr(Et) : this.$$element.attr(Et, Ke));
            var dr = this.$$observers;
            dr && T(dr[cr], function(Kt) {
              try {
                Kt(Ke);
              } catch (hi) {
                be(hi);
              }
            });
          },
          $observe: function(je, Ke) {
            var mt = this, Et = mt.$$observers || (mt.$$observers = xi()), Xt = Et[je] || (Et[je] = []);
            return Xt.push(Ke), De.$evalAsync(function() {
              !Xt.$$inter && mt.hasOwnProperty(je) && !ce(mt[je]) && Ke(mt[je]);
            }), function() {
              xr(Xt, Ke);
            };
          }
        };
        function Xe(je, Ke) {
          try {
            je.addClass(Ke);
          } catch {
          }
        }
        var Je = Pe.startSymbol(), Qe = Pe.endSymbol(), tt = Je == "{{" && Qe == "}}" ? K : function(Ke) {
          return Ke.replace(/\{\{/g, Je).replace(/}}/g, Qe);
        }, dt = /^ngAttr[A-Z]/, Ye = /^(.+)Start$/;
        return it.$$addBindingInfo = ye ? function(Ke, mt) {
          var Et = Ke.data("$binding") || [];
          $e(mt) ? Et = Et.concat(mt) : Et.push(mt), Ke.data("$binding", Et);
        } : G, it.$$addBindingClass = ye ? function(Ke) {
          Xe(Ke, "ng-binding");
        } : G, it.$$addScopeInfo = ye ? function(Ke, mt, Et, Xt) {
          var ur = Et ? Xt ? "$isolateScopeNoTemplate" : "$isolateScope" : "$scope";
          Ke.data(ur, mt);
        } : G, it.$$addScopeClass = ye ? function(Ke, mt) {
          Xe(Ke, mt ? "ng-isolate-scope" : "ng-scope");
        } : G, it;
        function it(je, Ke, mt, Et, Xt) {
          je instanceof d || (je = d(je));
          for (var ur = /\S+/, Wt = 0, cr = je.length; Wt < cr; Wt++) {
            var Bt = je[Wt];
            Bt.nodeType === Ra && Bt.nodeValue.match(ur) && jr(Bt, je[Wt] = r.createElement("span"));
          }
          var rr = Ct(
            je,
            Ke,
            je,
            mt,
            Et,
            Xt
          );
          it.$$addScopeClass(je);
          var pr = null;
          return function(Nt, Vr, Pr) {
            Ss(Nt, "scope"), Xt && Xt.needsNewScope && (Nt = Nt.$parent.$new()), Pr = Pr || {};
            var fi = Pr.parentBoundTranscludeFn, ni = Pr.transcludeControllers, Ir = Pr.futureParentElement;
            fi && fi.$$boundTransclude && (fi = fi.$$boundTransclude), pr || (pr = wt(Ir));
            var dr;
            if (pr !== "html" ? dr = d(
              Au(pr, d("<div>").append(je).html())
            ) : Vr ? dr = na.clone.call(je) : dr = je, ni)
              for (var Kt in ni)
                dr.data("$" + Kt + "Controller", ni[Kt].instance);
            return it.$$addScopeInfo(dr, Nt), Vr && Vr(dr, Nt), rr && rr(Nt, dr, dr, fi), dr;
          };
        }
        function wt(je) {
          var Ke = je && je[0];
          return Ke && Qr(Ke) !== "foreignobject" && Ke.toString().match(/SVG/) ? "svg" : "html";
        }
        function Ct(je, Ke, mt, Et, Xt, ur) {
          for (var Wt = [], cr, Bt, rr, pr, gr, Nt, Vr, Pr = 0; Pr < je.length; Pr++)
            cr = new rt(), Bt = Lr(
              je[Pr],
              [],
              cr,
              Pr === 0 ? Et : i,
              Xt
            ), rr = Bt.length ? Jr(
              Bt,
              je[Pr],
              cr,
              Ke,
              mt,
              null,
              [],
              [],
              ur
            ) : null, rr && rr.scope && it.$$addScopeClass(cr.$$element), gr = rr && rr.terminal || !(pr = je[Pr].childNodes) || !pr.length ? null : Ct(
              pr,
              rr ? (rr.transcludeOnThisElement || !rr.templateOnThisElement) && rr.transclude : Ke
            ), (rr || gr) && (Wt.push(Pr, rr, gr), Nt = !0, Vr = Vr || rr), ur = null;
          return Nt ? fi : null;
          function fi(ni, Ir, dr, Kt) {
            var hi, Mi, en, Pn, dn, En, Ni, ba, ns;
            if (Vr) {
              var Cu = Ir.length;
              for (ns = new Array(Cu), dn = 0; dn < Wt.length; dn += 3)
                Ni = Wt[dn], ns[Ni] = Ir[Ni];
            } else
              ns = Ir;
            for (dn = 0, En = Wt.length; dn < En; )
              en = ns[Wt[dn++]], hi = Wt[dn++], Mi = Wt[dn++], hi ? (hi.scope ? (Pn = ni.$new(), it.$$addScopeInfo(d(en), Pn)) : Pn = ni, hi.transcludeOnThisElement ? ba = yr(
                ni,
                hi.transclude,
                Kt
              ) : !hi.templateOnThisElement && Kt ? ba = Kt : !Kt && Ke ? ba = yr(ni, Ke) : ba = null, hi(Mi, Pn, en, dr, ba)) : Mi && Mi(ni, en.childNodes, i, Kt);
          }
        }
        function yr(je, Ke, mt) {
          var Et = function(Xt, ur, Wt, cr, Bt) {
            return Xt || (Xt = je.$new(!1, Bt), Xt.$$transcluded = !0), Ke(Xt, ur, {
              parentBoundTranscludeFn: mt,
              transcludeControllers: Wt,
              futureParentElement: cr
            });
          };
          return Et;
        }
        function Lr(je, Ke, mt, Et, Xt) {
          var ur = je.nodeType, Wt = mt.$attr, cr, Bt, rr;
          switch (ur) {
            case bn:
              Bt = Qr(je), Li(
                Ke,
                V(Bt),
                "E",
                Et,
                Xt
              );
              for (var pr, gr, Nt, Vr, Pr, fi, ni = je.attributes, Ir = 0, dr = ni && ni.length; Ir < dr; Ir++) {
                var Kt = !1, hi = !1;
                pr = ni[Ir], gr = pr.name, Pr = It(pr.value), Vr = V(gr), (fi = dt.test(Vr)) && (gr = gr.replace(Q, "").substr(8).replace(/_(.)/g, function(en, Pn) {
                  return Pn.toUpperCase();
                }));
                var Mi = Vr.match(Ye);
                Mi && cn(Mi[1]) && (Kt = gr, hi = gr.substr(0, gr.length - 5) + "end", gr = gr.substr(0, gr.length - 6)), Nt = V(gr.toLowerCase()), Wt[Nt] = gr, (fi || !mt.hasOwnProperty(Nt)) && (mt[Nt] = Pr, hl(je, Nt) && (mt[Nt] = !0)), wu(je, Ke, Pr, Nt, fi), Li(
                  Ke,
                  Nt,
                  "A",
                  Et,
                  Xt,
                  Kt,
                  hi
                );
              }
              if (Bt === "input" && je.getAttribute("type") === "hidden" && je.setAttribute("autocomplete", "off"), rr = je.className, me(rr) && (rr = rr.animVal), Ne(rr) && rr !== "")
                for (; cr = U.exec(rr); )
                  Nt = V(cr[2]), Li(Ke, Nt, "C", Et, Xt) && (mt[Nt] = It(cr[3])), rr = rr.substr(cr.index + cr[0].length);
              break;
            case Ra:
              if (c === 11)
                for (; je.parentNode && je.nextSibling && je.nextSibling.nodeType === Ra; )
                  je.nodeValue = je.nodeValue + je.nextSibling.nodeValue, je.parentNode.removeChild(je.nextSibling);
              xu(Ke, je.nodeValue);
              break;
            case Dn:
              try {
                cr = B.exec(je.nodeValue), cr && (Nt = V(cr[1]), Li(Ke, Nt, "M", Et, Xt) && (mt[Nt] = It(cr[2])));
              } catch {
              }
              break;
          }
          return Ke.sort(Di), Ke;
        }
        function Hr(je, Ke, mt) {
          var Et = [], Xt = 0;
          if (Ke && je.hasAttribute && je.hasAttribute(Ke))
            do {
              if (!je)
                throw Yn(
                  "uterdir",
                  "Unterminated attribute, found '{0}' but no matching '{1}' found.",
                  Ke,
                  mt
                );
              je.nodeType == bn && (je.hasAttribute(Ke) && Xt++, je.hasAttribute(mt) && Xt--), Et.push(je), je = je.nextSibling;
            } while (Xt > 0);
          else
            Et.push(je);
          return d(Et);
        }
        function di(je, Ke, mt) {
          return function(Et, Xt, ur, Wt, cr) {
            return Xt = Hr(Xt[0], Ke, mt), je(Et, Xt, ur, Wt, cr);
          };
        }
        function Jr(je, Ke, mt, Et, Xt, ur, Wt, cr, Bt) {
          Bt = Bt || {};
          for (var rr = -Number.MAX_VALUE, pr = Bt.newScopeDirective, gr = Bt.controllerDirectives, Nt = Bt.newIsolateScopeDirective, Vr = Bt.templateDirective, Pr = Bt.nonTlbTranscludeDirective, fi = !1, ni = !1, Ir = Bt.hasElementTranscludeDirective, dr = mt.$$element = d(Ke), Kt, hi, Mi, en = ur, Pn = Et, dn, En, Ni = 0, ba = je.length; Ni < ba; Ni++) {
            Kt = je[Ni];
            var ns = Kt.$$start, Cu = Kt.$$end;
            if (ns && (dr = Hr(Ke, ns, Cu)), Mi = i, rr > Kt.priority)
              break;
            if ((En = Kt.scope) && (Kt.templateUrl || (me(En) ? (Na(
              "new/isolated scope",
              Nt || pr,
              Kt,
              dr
            ), Nt = Kt) : Na(
              "new/isolated scope",
              Nt,
              Kt,
              dr
            )), pr = pr || Kt), hi = Kt.name, !Kt.templateUrl && Kt.controller && (En = Kt.controller, gr = gr || xi(), Na(
              "'" + hi + "' controller",
              gr[hi],
              Kt,
              dr
            ), gr[hi] = Kt), (En = Kt.transclude) && (fi = !0, Kt.$$tlb || (Na("transclusion", Pr, Kt, dr), Pr = Kt), En == "element" ? (Ir = !0, rr = Kt.priority, Mi = dr, dr = mt.$$element = d(r.createComment(" " + hi + ": " + mt[hi] + " ")), Ke = dr[0], eo(Xt, mn(Mi), Ke), Pn = it(
              Mi,
              Et,
              rr,
              en && en.name,
              {
                nonTlbTranscludeDirective: Pr
              }
            )) : (Mi = d(Ki(Ke)).contents(), dr.empty(), Pn = it(
              Mi,
              Et,
              i,
              i,
              { needsNewScope: Kt.$$isolateScope || Kt.$$newScope }
            ))), Kt.template)
              if (ni = !0, Na("template", Vr, Kt, dr), Vr = Kt, En = Ze(Kt.template) ? Kt.template(dr, mt) : Kt.template, En = tt(En), Kt.replace) {
                if (en = Kt, St(En) ? Mi = [] : Mi = se(Au(Kt.templateNamespace, It(En))), Ke = Mi[0], Mi.length != 1 || Ke.nodeType !== bn)
                  throw Yn(
                    "tplrt",
                    "Template for directive '{0}' must have exactly one root element. {1}",
                    hi,
                    ""
                  );
                eo(Xt, dr, Ke);
                var Dy = { $attr: {} }, ky = Lr(Ke, [], Dy), P1 = je.splice(Ni + 1, je.length - (Ni + 1));
                (Nt || pr) && ii(ky, Nt, pr), je = je.concat(ky).concat(P1), Gi(mt, Dy), ba = je.length;
              } else
                dr.html(En);
            if (Kt.templateUrl)
              ni = !0, Na("template", Vr, Kt, dr), Vr = Kt, Kt.replace && (en = Kt), Du = Ii(
                je.splice(Ni, je.length - Ni),
                dr,
                mt,
                Xt,
                fi && Pn,
                Wt,
                cr,
                {
                  controllerDirectives: gr,
                  newScopeDirective: pr !== Kt && pr,
                  newIsolateScopeDirective: Nt,
                  templateDirective: Vr,
                  nonTlbTranscludeDirective: Pr
                }
              ), ba = je.length;
            else if (Kt.compile)
              try {
                dn = Kt.compile(dr, mt, Pn), Ze(dn) ? Ry(null, dn, ns, Cu) : dn && Ry(dn.pre, dn.post, ns, Cu);
              } catch (tn) {
                be(tn, Ei(dr));
              }
            Kt.terminal && (Du.terminal = !0, rr = Math.max(rr, Kt.priority));
          }
          return Du.scope = pr && pr.scope === !0, Du.transcludeOnThisElement = fi, Du.templateOnThisElement = ni, Du.transclude = Pn, Bt.hasElementTranscludeDirective = Ir, Du;
          function Ry(tn, bi, On, Rs) {
            tn && (On && (tn = di(tn, On, Rs)), tn.require = Kt.require, tn.directiveName = hi, (Nt === Kt || Kt.$$isolateScope) && (tn = Qd(tn, { isolateScope: !0 })), Wt.push(tn)), bi && (On && (bi = di(bi, On, Rs)), bi.require = Kt.require, bi.directiveName = hi, (Nt === Kt || Kt.$$isolateScope) && (bi = Qd(bi, { isolateScope: !0 })), cr.push(bi));
          }
          function Ep(tn, bi, On, Rs) {
            var xn;
            if (Ne(bi)) {
              var rn = bi.match(H), An = bi.substring(rn[0].length), to = rn[1] || rn[3], Ln = rn[2] === "?";
              if (to === "^^" ? On = On.parent() : (xn = Rs && Rs[An], xn = xn && xn.instance), !xn) {
                var Ps = "$" + An + "Controller";
                xn = to ? On.inheritedData(Ps) : On.data(Ps);
              }
              if (!xn && !Ln)
                throw Yn(
                  "ctreq",
                  "Controller '{0}', required by directive '{1}', can't be found!",
                  An,
                  tn
                );
            } else if ($e(bi)) {
              xn = [];
              for (var ji = 0, Ta = bi.length; ji < Ta; ji++)
                xn[ji] = Ep(tn, bi[ji], On, Rs);
            }
            return xn || null;
          }
          function O1(tn, bi, On, Rs, xn, rn) {
            var An = xi();
            for (var to in Rs) {
              var Ln = Rs[to], Ps = {
                $scope: Ln === Nt || Ln.$$isolateScope ? xn : rn,
                $element: tn,
                $attrs: bi,
                $transclude: On
              }, ji = Ln.controller;
              ji == "@" && (ji = bi[Ln.name]);
              var Ta = Ie(ji, Ps, !0, Ln.controllerAs);
              An[Ln.name] = Ta, tn.data("$" + Ln.name + "Controller", Ta.instance);
            }
            return An;
          }
          function Du(tn, bi, On, Rs, xn) {
            var rn, An, to, Ln, Ps, ji, Ta, xp, Zd;
            Ke === On ? (Ta = mt, ji = mt.$$element) : (ji = d(On), Ta = new rt(ji, mt)), to = bi, Nt ? An = bi.$new(!0) : pr && (to = bi.$parent), xn && (Ps = L1, Ps.$$boundTransclude = xn), gr && (Ln = O1(ji, Ta, Ps, gr, An, bi)), Nt && (it.$$addScopeInfo(ji, An, !0, !(Vr && (Vr === Nt || Vr === Nt.$$originalDirective))), it.$$addScopeClass(ji, !0), An.$$isolateBindings = Nt.$$isolateBindings, xp = Sp(
              bi,
              Ta,
              An,
              An.$$isolateBindings,
              Nt
            ), xp && An.$on("$destroy", xp));
            for (var Py in Ln) {
              var ef = gr[Py], yl = Ln[Py], Ap = ef.$$bindings.bindToController;
              yl.identifier && Ap && (Zd = Sp(to, Ta, yl.instance, Ap, ef));
              var wp = yl();
              wp !== yl.instance && (yl.instance = wp, ji.data("$" + ef.name + "Controller", wp), Zd && Zd(), Zd = Sp(to, Ta, yl.instance, Ap, ef));
            }
            for (Ni = 0, ba = Wt.length; Ni < ba; Ni++)
              rn = Wt[Ni], kc(
                rn,
                rn.isolateScope ? An : bi,
                ji,
                Ta,
                rn.require && Ep(rn.directiveName, rn.require, ji, Ln),
                Ps
              );
            var Cp = bi;
            for (Nt && (Nt.template || Nt.templateUrl === null) && (Cp = An), tn && tn(Cp, On.childNodes, i, xn), Ni = cr.length - 1; Ni >= 0; Ni--)
              rn = cr[Ni], kc(
                rn,
                rn.isolateScope ? An : bi,
                ji,
                Ta,
                rn.require && Ep(rn.directiveName, rn.require, ji, Ln),
                Ps
              );
            function L1(tf, Dp, rf) {
              var Oy;
              return ir(tf) || (rf = Dp, Dp = tf, tf = i), Ir && (Oy = Ln), rf || (rf = Ir ? ji.parent() : ji), xn(tf, Dp, Oy, rf, Cp);
            }
          }
        }
        function ii(je, Ke, mt) {
          for (var Et = 0, Xt = je.length; Et < Xt; Et++)
            je[Et] = F(je[Et], { $$isolateScope: Ke, $$newScope: mt });
        }
        function Li(je, Ke, mt, Et, Xt, ur, Wt) {
          if (Ke === Xt)
            return null;
          var cr = null;
          if (L.hasOwnProperty(Ke))
            for (var Bt, rr = Se.get(Ke + I), pr = 0, gr = rr.length; pr < gr; pr++)
              try {
                if (Bt = rr[pr], (ce(Et) || Et > Bt.priority) && Bt.restrict.indexOf(mt) != -1) {
                  if (ur && (Bt = F(Bt, { $$start: ur, $$end: Wt })), !Bt.$$bindings) {
                    var Nt = Bt.$$bindings = fe(Bt, Bt.name);
                    me(Nt.isolateScope) && (Bt.$$isolateBindings = Nt.isolateScope);
                  }
                  je.push(Bt), cr = Bt;
                }
              } catch (Vr) {
                be(Vr);
              }
          return cr;
        }
        function cn(je) {
          if (L.hasOwnProperty(je)) {
            for (var Ke, mt = Se.get(je + I), Et = 0, Xt = mt.length; Et < Xt; Et++)
              if (Ke = mt[Et], Ke.multiElement)
                return !0;
          }
          return !1;
        }
        function Gi(je, Ke) {
          var mt = Ke.$attr, Et = je.$attr, Xt = je.$$element;
          T(je, function(ur, Wt) {
            Wt.charAt(0) != "$" && (Ke[Wt] && Ke[Wt] !== ur && (ur += (Wt === "style" ? ";" : " ") + Ke[Wt]), je.$set(Wt, ur, !0, mt[Wt]));
          }), T(Ke, function(ur, Wt) {
            Wt == "class" ? (Xe(Xt, ur), je.class = (je.class ? je.class + " " : "") + ur) : Wt == "style" ? (Xt.attr("style", Xt.attr("style") + ";" + ur), je.style = (je.style ? je.style + ";" : "") + ur) : Wt.charAt(0) != "$" && !je.hasOwnProperty(Wt) && (je[Wt] = ur, Et[Wt] = mt[Wt]);
          });
        }
        function Ii(je, Ke, mt, Et, Xt, ur, Wt, cr) {
          var Bt = [], rr, pr, gr = Ke[0], Nt = je.shift(), Vr = F(Nt, {
            templateUrl: null,
            transclude: null,
            replace: null,
            $$originalDirective: Nt
          }), Pr = Ze(Nt.templateUrl) ? Nt.templateUrl(Ke, mt) : Nt.templateUrl, fi = Nt.templateNamespace;
          return Ke.empty(), Te(Pr).then(function(ni) {
            var Ir, dr, Kt, hi;
            if (ni = tt(ni), Nt.replace) {
              if (St(ni) ? Kt = [] : Kt = se(Au(fi, It(ni))), Ir = Kt[0], Kt.length != 1 || Ir.nodeType !== bn)
                throw Yn(
                  "tplrt",
                  "Template for directive '{0}' must have exactly one root element. {1}",
                  Nt.name,
                  Pr
                );
              dr = { $attr: {} }, eo(Et, Ke, Ir);
              var Mi = Lr(Ir, [], dr);
              me(Nt.scope) && ii(Mi, !0), je = Mi.concat(je), Gi(mt, dr);
            } else
              Ir = gr, Ke.html(ni);
            for (je.unshift(Vr), rr = Jr(
              je,
              Ir,
              mt,
              Xt,
              Ke,
              Nt,
              ur,
              Wt,
              cr
            ), T(Et, function(ns, Cu) {
              ns == Ir && (Et[Cu] = Ke[0]);
            }), pr = Ct(Ke[0].childNodes, Xt); Bt.length; ) {
              var en = Bt.shift(), Pn = Bt.shift(), dn = Bt.shift(), En = Bt.shift(), Ni = Ke[0];
              if (!en.$$destroyed) {
                if (Pn !== gr) {
                  var ba = Pn.className;
                  cr.hasElementTranscludeDirective && Nt.replace || (Ni = Ki(Ir)), eo(dn, d(Pn), Ni), Xe(d(Ni), ba);
                }
                rr.transcludeOnThisElement ? hi = yr(en, rr.transclude, En) : hi = En, rr(
                  pr,
                  en,
                  Ni,
                  Et,
                  hi
                );
              }
            }
            Bt = null;
          }), function(Ir, dr, Kt, hi, Mi) {
            var en = Mi;
            dr.$$destroyed || (Bt ? Bt.push(
              dr,
              Kt,
              hi,
              en
            ) : (rr.transcludeOnThisElement && (en = yr(dr, rr.transclude, Mi)), rr(pr, dr, Kt, hi, en)));
          };
        }
        function Di(je, Ke) {
          var mt = Ke.priority - je.priority;
          return mt !== 0 ? mt : je.name !== Ke.name ? je.name < Ke.name ? -1 : 1 : je.index - Ke.index;
        }
        function Na(je, Ke, mt, Et) {
          function Xt(ur) {
            return ur ? " (module: " + ur + ")" : "";
          }
          if (Ke)
            throw Yn(
              "multidir",
              "Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}",
              Ke.name,
              Xt(Ke.$$moduleName),
              mt.name,
              Xt(mt.$$moduleName),
              je,
              Ei(Et)
            );
        }
        function xu(je, Ke) {
          var mt = Pe(Ke, !0);
          mt && je.push({
            priority: 0,
            compile: function(Xt) {
              var ur = Xt.parent(), Wt = !!ur.length;
              return Wt && it.$$addBindingClass(ur), function(Bt, rr) {
                var pr = rr.parent();
                Wt || it.$$addBindingClass(pr), it.$$addBindingInfo(pr, mt.expressions), Bt.$watch(mt, function(Nt) {
                  rr[0].nodeValue = Nt;
                });
              };
            }
          });
        }
        function Au(je, Ke) {
          switch (je = s(je || "html"), je) {
            case "svg":
            case "math":
              var mt = r.createElement("div");
              return mt.innerHTML = "<" + je + ">" + Ke + "</" + je + ">", mt.childNodes[0].childNodes;
            default:
              return Ke;
          }
        }
        function Tp(je, Ke) {
          if (Ke == "srcdoc")
            return Re.HTML;
          var mt = Qr(je);
          if (Ke == "xlinkHref" || mt == "form" && Ke == "action" || mt != "img" && (Ke == "src" || Ke == "ngSrc"))
            return Re.RESOURCE_URL;
        }
        function wu(je, Ke, mt, Et, Xt) {
          var ur = Tp(je, Et);
          Xt = j[Et] || Xt;
          var Wt = Pe(mt, !0, ur, Xt);
          if (!!Wt) {
            if (Et === "multiple" && Qr(je) === "select")
              throw Yn(
                "selmulti",
                "Binding to the 'multiple' attribute is not supported. Element: {0}",
                Ei(je)
              );
            Ke.push({
              priority: 100,
              compile: function() {
                return {
                  pre: function(Bt, rr, pr) {
                    var gr = pr.$$observers || (pr.$$observers = xi());
                    if (W.test(Et))
                      throw Yn(
                        "nodomevents",
                        "Interpolations for HTML DOM event attributes are disallowed.  Please use the ng- versions (such as ng-click instead of onclick) instead."
                      );
                    var Nt = pr[Et];
                    Nt !== mt && (Wt = Nt && Pe(Nt, !0, ur, Xt), mt = Nt), Wt && (pr[Et] = Wt(Bt), (gr[Et] || (gr[Et] = [])).$$inter = !0, (pr.$$observers && pr.$$observers[Et].$$scope || Bt).$watch(Wt, function(Pr, fi) {
                      Et === "class" && Pr != fi ? pr.$updateClass(Pr, fi) : pr.$set(Et, Pr);
                    }));
                  }
                };
              }
            });
          }
        }
        function eo(je, Ke, mt) {
          var Et = Ke[0], Xt = Ke.length, ur = Et.parentNode, Wt, cr;
          if (je) {
            for (Wt = 0, cr = je.length; Wt < cr; Wt++)
              if (je[Wt] == Et) {
                je[Wt++] = mt;
                for (var Bt = Wt, rr = Bt + Xt - 1, pr = je.length; Bt < pr; Bt++, rr++)
                  rr < pr ? je[Bt] = je[rr] : delete je[Bt];
                je.length -= Xt - 1, je.context === Et && (je.context = mt);
                break;
              }
          }
          ur && ur.replaceChild(mt, Et);
          var gr = r.createDocumentFragment();
          gr.appendChild(Et), d.hasData(Et) && (d.data(mt, d.data(Et)), f ? (Ts = !0, f.cleanData([Et])) : delete d.cache[Et[d.expando]]);
          for (var Nt = 1, Vr = Ke.length; Nt < Vr; Nt++) {
            var Pr = Ke[Nt];
            d(Pr).remove(), gr.appendChild(Pr), delete Ke[Nt];
          }
          Ke[0] = mt, Ke.length = 1;
        }
        function Qd(je, Ke) {
          return $(function() {
            return je.apply(null, arguments);
          }, je, Ke);
        }
        function kc(je, Ke, mt, Et, Xt, ur) {
          try {
            je(Ke, mt, Et, Xt, ur);
          } catch (Wt) {
            be(Wt, Ei(mt));
          }
        }
        function Sp(je, Ke, mt, Et, Xt) {
          var ur = [];
          return T(Et, function(Wt, cr) {
            var Bt = Wt.attrName, rr = Wt.optional, pr = Wt.mode, gr, Nt, Vr, Pr;
            switch (pr) {
              case "@":
                !rr && !o.call(Ke, Bt) && (mt[cr] = Ke[Bt] = void 0), Ke.$observe(Bt, function(Ir) {
                  Ne(Ir) && (mt[cr] = Ir);
                }), Ke.$$observers[Bt].$$scope = je, gr = Ke[Bt], Ne(gr) ? mt[cr] = Pe(gr)(je) : xt(gr) && (mt[cr] = gr);
                break;
              case "=":
                if (!o.call(Ke, Bt)) {
                  if (rr)
                    break;
                  Ke[Bt] = void 0;
                }
                if (rr && !Ke[Bt])
                  break;
                Nt = _e(Ke[Bt]), Nt.literal ? Pr = li : Pr = function(Ir, dr) {
                  return Ir === dr || Ir !== Ir && dr !== dr;
                }, Vr = Nt.assign || function() {
                  throw gr = mt[cr] = Nt(je), Yn(
                    "nonassign",
                    "Expression '{0}' in attribute '{1}' used with directive '{2}' is non-assignable!",
                    Ke[Bt],
                    Bt,
                    Xt.name
                  );
                }, gr = mt[cr] = Nt(je);
                var fi = function(dr) {
                  return Pr(dr, mt[cr]) || (Pr(dr, gr) ? Vr(je, dr = mt[cr]) : mt[cr] = dr), gr = dr;
                };
                fi.$stateful = !0;
                var ni;
                Wt.collection ? ni = je.$watchCollection(Ke[Bt], fi) : ni = je.$watch(_e(Ke[Bt], fi), null, Nt.literal), ur.push(ni);
                break;
              case "&":
                if (Nt = Ke.hasOwnProperty(Bt) ? _e(Ke[Bt]) : G, Nt === G && rr)
                  break;
                mt[cr] = function(Ir) {
                  return Nt(je, Ir);
                };
                break;
            }
          }), ur.length && function() {
            for (var cr = 0, Bt = ur.length; cr < Bt; ++cr)
              ur[cr]();
          };
        }
      }
    ];
  }
  var Q = /^((?:x|data)[\:\-_])/i;
  function V(A) {
    return Me(A.replace(Q, ""));
  }
  function Y(A, k) {
    var L = "", I = A.split(/\s+/), B = k.split(/\s+/);
    e:
      for (var U = 0; U < I.length; U++) {
        for (var j = I[U], H = 0; H < B.length; H++)
          if (j == B[H])
            continue e;
        L += (L.length > 0 ? " " : "") + j;
      }
    return L;
  }
  function se(A) {
    A = d(A);
    var k = A.length;
    if (k <= 1)
      return A;
    for (; k--; ) {
      var L = A[k];
      L.nodeType === Dn && p.call(A, k, 1);
    }
    return A;
  }
  var le = t("$controller"), oe = /^(\S+)(\s+as\s+([\w$]+))?$/;
  function te(A, k) {
    if (k && Ne(k))
      return k;
    if (Ne(A)) {
      var L = oe.exec(A);
      if (L)
        return L[3];
    }
  }
  function we() {
    var A = {}, k = !1;
    this.register = function(L, I) {
      pa(L, "controller"), me(L) ? $(A, L) : A[L] = I;
    }, this.allowGlobals = function() {
      k = !0;
    }, this.$get = ["$injector", "$window", function(L, I) {
      return function(U, j, H, W) {
        var X, Z, fe, he;
        if (H = H === !0, W && Ne(W) && (he = W), Ne(U)) {
          if (Z = U.match(oe), !Z)
            throw le(
              "ctrlfmt",
              "Badly formed controller string '{0}'. Must match `__name__ as __id__` or `__name__`.",
              U
            );
          fe = Z[1], he = he || Z[3], U = A.hasOwnProperty(fe) ? A[fe] : Qa(j.$scope, fe, !0) || (k ? Qa(I, fe, !0) : i), ka(U, fe, !0);
        }
        if (H) {
          var ye = ($e(U) ? U[U.length - 1] : U).prototype;
          return X = Object.create(ye || null), he && B(j, he, X, fe || U.name), $(function() {
            var Se = L.invoke(U, X, j, fe);
            return Se !== X && (me(Se) || Ze(Se)) && (X = Se, he && B(j, he, X, fe || U.name)), X;
          }, {
            instance: X,
            identifier: he
          });
        }
        return X = L.instantiate(U, j, fe), he && B(j, he, X, fe || U.name), X;
      };
      function B(U, j, H, W) {
        if (!(U && me(U.$scope)))
          throw t("$controller")(
            "noscp",
            "Cannot export controller '{0}' as '{1}'! No $scope object provided via `locals`.",
            W,
            j
          );
        U.$scope[j] = H;
      }
    }];
  }
  function Fe() {
    this.$get = ["$window", function(A) {
      return d(A.document);
    }];
  }
  function He() {
    this.$get = ["$log", function(A) {
      return function(k, L) {
        A.error.apply(A, arguments);
      };
    }];
  }
  var ct = function() {
    this.$get = ["$document", function(A) {
      return function(k) {
        return k ? !k.nodeType && k instanceof d && (k = k[0]) : k = A[0].body, k.offsetWidth + 1;
      };
    }];
  }, ut = "application/json", ft = { "Content-Type": ut + ";charset=utf-8" }, Ue = /^\[|^\{(?!\{)/, _t = {
    "[": /]$/,
    "{": /}$/
  }, Lt = /^\)\]\}',?\n/, ar = t("$http"), or = function(A) {
    return function() {
      throw ar("legacy", "The method `{0}` on the promise returned from `$http` has been disabled.", A);
    };
  };
  function tr(A) {
    return me(A) ? ze(A) ? A.toISOString() : za(A) : A;
  }
  function Dr() {
    this.$get = function() {
      return function(k) {
        if (!k)
          return "";
        var L = [];
        return C(k, function(I, B) {
          I === null || ce(I) || ($e(I) ? T(I, function(U, j) {
            L.push(_n(B) + "=" + _n(tr(U)));
          }) : L.push(_n(B) + "=" + _n(tr(I))));
        }), L.join("&");
      };
    };
  }
  function hr() {
    this.$get = function() {
      return function(k) {
        if (!k)
          return "";
        var L = [];
        return I(k, "", !0), L.join("&");
        function I(B, U, j) {
          B === null || ce(B) || ($e(B) ? T(B, function(H, W) {
            I(H, U + "[" + (me(H) ? W : "") + "]");
          }) : me(B) && !ze(B) ? C(B, function(H, W) {
            I(H, U + (j ? "" : "[") + W + (j ? "" : "]"));
          }) : L.push(_n(U) + "=" + _n(tr(B))));
        }
      };
    };
  }
  function $t(A, k) {
    if (Ne(A)) {
      var L = A.replace(Lt, "").trim();
      if (L) {
        var I = k("Content-Type");
        (I && I.indexOf(ut) === 0 || ht(L)) && (A = jn(L));
      }
    }
    return A;
  }
  function ht(A) {
    var k = A.match(Ue);
    return k && _t[k[0]].test(A);
  }
  function pt(A) {
    var k = xi(), L;
    function I(B, U) {
      B && (k[B] = k[B] ? k[B] + ", " + U : U);
    }
    return Ne(A) ? T(A.split(`
`), function(B) {
      L = B.indexOf(":"), I(s(It(B.substr(0, L))), It(B.substr(L + 1)));
    }) : me(A) && T(A, function(B, U) {
      I(s(U), It(B));
    }), k;
  }
  function Gt(A) {
    var k;
    return function(L) {
      if (k || (k = pt(A)), L) {
        var I = k[s(L)];
        return I === void 0 && (I = null), I;
      }
      return k;
    };
  }
  function Yt(A, k, L, I) {
    return Ze(I) ? I(A, k, L) : (T(I, function(B) {
      A = B(A, k, L);
    }), A);
  }
  function Ht(A) {
    return 200 <= A && A < 300;
  }
  function vr() {
    var A = this.defaults = {
      transformResponse: [$t],
      transformRequest: [function(B) {
        return me(B) && !We(B) && !Tt(B) && !vt(B) ? za(B) : B;
      }],
      headers: {
        common: {
          Accept: "application/json, text/plain, */*"
        },
        post: Gr(ft),
        put: Gr(ft),
        patch: Gr(ft)
      },
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      paramSerializer: "$httpParamSerializer"
    }, k = !1;
    this.useApplyAsync = function(B) {
      return ee(B) ? (k = !!B, this) : k;
    };
    var L = !0;
    this.useLegacyPromiseExtensions = function(B) {
      return ee(B) ? (L = !!B, this) : L;
    };
    var I = this.interceptors = [];
    this.$get = [
      "$httpBackend",
      "$$cookieReader",
      "$cacheFactory",
      "$rootScope",
      "$q",
      "$injector",
      function(B, U, j, H, W, X) {
        var Z = j("$http");
        A.paramSerializer = Ne(A.paramSerializer) ? X.get(A.paramSerializer) : A.paramSerializer;
        var fe = [];
        T(I, function(Te) {
          fe.unshift(Ne(Te) ? X.get(Te) : X.invoke(Te));
        });
        function he(Te) {
          if (!E.isObject(Te))
            throw t("$http")("badreq", "Http request configuration must be an object.  Received: {0}", Te);
          if (!Ne(Te.url))
            throw t("$http")("badreq", "Http request configuration url must be a string.  Received: {0}", Te.url);
          var _e = $({
            method: "get",
            transformRequest: A.transformRequest,
            transformResponse: A.transformResponse,
            paramSerializer: A.paramSerializer
          }, Te);
          _e.headers = Je(Te), _e.method = l(_e.method), _e.paramSerializer = Ne(_e.paramSerializer) ? X.get(_e.paramSerializer) : _e.paramSerializer;
          var Ie = function(Qe) {
            var tt = Qe.headers, dt = Yt(Qe.data, Gt(tt), i, Qe.transformRequest);
            return ce(dt) && T(tt, function(Ye, it) {
              s(it) === "content-type" && delete tt[it];
            }), ce(Qe.withCredentials) && !ce(A.withCredentials) && (Qe.withCredentials = A.withCredentials), Pe(Qe, dt).then(rt, rt);
          }, De = [Ie, i], Re = W.when(_e);
          for (T(fe, function(Qe) {
            (Qe.request || Qe.requestError) && De.unshift(Qe.request, Qe.requestError), (Qe.response || Qe.responseError) && De.push(Qe.response, Qe.responseError);
          }); De.length; ) {
            var qe = De.shift(), Oe = De.shift();
            Re = Re.then(qe, Oe);
          }
          return L ? (Re.success = function(Qe) {
            return ka(Qe, "fn"), Re.then(function(tt) {
              Qe(tt.data, tt.status, tt.headers, _e);
            }), Re;
          }, Re.error = function(Qe) {
            return ka(Qe, "fn"), Re.then(null, function(tt) {
              Qe(tt.data, tt.status, tt.headers, _e);
            }), Re;
          }) : (Re.success = or("success"), Re.error = or("error")), Re;
          function rt(Qe) {
            var tt = $({}, Qe);
            return tt.data = Yt(
              Qe.data,
              Qe.headers,
              Qe.status,
              _e.transformResponse
            ), Ht(Qe.status) ? tt : W.reject(tt);
          }
          function Xe(Qe, tt) {
            var dt, Ye = {};
            return T(Qe, function(it, wt) {
              Ze(it) ? (dt = it(tt), dt != null && (Ye[wt] = dt)) : Ye[wt] = it;
            }), Ye;
          }
          function Je(Qe) {
            var tt = A.headers, dt = $({}, Qe.headers), Ye, it, wt;
            tt = $({}, tt.common, tt[s(Qe.method)]);
            e:
              for (Ye in tt) {
                it = s(Ye);
                for (wt in dt)
                  if (s(wt) === it)
                    continue e;
                dt[Ye] = tt[Ye];
              }
            return Xe(dt, Gr(Qe));
          }
        }
        return he.pendingRequests = [], ye("get", "delete", "head", "jsonp"), Se("post", "put", "patch"), he.defaults = A, he;
        function ye(Te) {
          T(arguments, function(_e) {
            he[_e] = function(Ie, De) {
              return he($({}, De || {}, {
                method: _e,
                url: Ie
              }));
            };
          });
        }
        function Se(Te) {
          T(arguments, function(_e) {
            he[_e] = function(Ie, De, Re) {
              return he($({}, Re || {}, {
                method: _e,
                url: Ie,
                data: De
              }));
            };
          });
        }
        function Pe(Te, _e) {
          var Ie = W.defer(), De = Ie.promise, Re, qe, Oe = Te.headers, rt = be(Te.url, Te.paramSerializer(Te.params));
          if (he.pendingRequests.push(Te), De.then(dt, dt), (Te.cache || A.cache) && Te.cache !== !1 && (Te.method === "GET" || Te.method === "JSONP") && (Re = me(Te.cache) ? Te.cache : me(A.cache) ? A.cache : Z), Re && (qe = Re.get(rt), ee(qe) ? Pt(qe) ? qe.then(tt, tt) : $e(qe) ? Qe(qe[1], qe[0], Gr(qe[2]), qe[3]) : Qe(qe, 200, {}, "OK") : Re.put(rt, De)), ce(qe)) {
            var Xe = W0(Te.url) ? U()[Te.xsrfCookieName || A.xsrfCookieName] : i;
            Xe && (Oe[Te.xsrfHeaderName || A.xsrfHeaderName] = Xe), B(
              Te.method,
              rt,
              _e,
              Je,
              Oe,
              Te.timeout,
              Te.withCredentials,
              Te.responseType
            );
          }
          return De;
          function Je(Ye, it, wt, Ct) {
            Re && (Ht(Ye) ? Re.put(rt, [Ye, it, pt(wt), Ct]) : Re.remove(rt));
            function yr() {
              Qe(it, Ye, wt, Ct);
            }
            k ? H.$applyAsync(yr) : (yr(), H.$$phase || H.$apply());
          }
          function Qe(Ye, it, wt, Ct) {
            it = it >= -1 ? it : 0, (Ht(it) ? Ie.resolve : Ie.reject)({
              data: Ye,
              status: it,
              headers: Gt(wt),
              config: Te,
              statusText: Ct
            });
          }
          function tt(Ye) {
            Qe(Ye.data, Ye.status, Gr(Ye.headers()), Ye.statusText);
          }
          function dt() {
            var Ye = he.pendingRequests.indexOf(Te);
            Ye !== -1 && he.pendingRequests.splice(Ye, 1);
          }
        }
        function be(Te, _e) {
          return _e.length > 0 && (Te += (Te.indexOf("?") == -1 ? "?" : "&") + _e), Te;
        }
      }
    ];
  }
  function Zr() {
    this.$get = function() {
      return function() {
        return new e.XMLHttpRequest();
      };
    };
  }
  function zr() {
    this.$get = ["$browser", "$window", "$document", "$xhrFactory", function(A, k, L, I) {
      return kr(A, I, A.defer, k.angular.callbacks, L[0]);
    }];
  }
  function kr(A, k, L, I, B) {
    return function(j, H, W, X, Z, fe, he, ye) {
      if (A.$$incOutstandingRequestCount(), H = H || A.url(), s(j) == "jsonp") {
        var Se = "_" + (I.counter++).toString(36);
        I[Se] = function(Re) {
          I[Se].data = Re, I[Se].called = !0;
        };
        var Pe = U(
          H.replace("JSON_CALLBACK", "angular.callbacks." + Se),
          Se,
          function(Re, qe) {
            De(X, Re, I[Se].data, "", qe), I[Se] = G;
          }
        );
      } else {
        var be = k(j, H);
        be.open(j, H, !0), T(Z, function(Re, qe) {
          ee(Re) && be.setRequestHeader(qe, Re);
        }), be.onload = function() {
          var qe = be.statusText || "", Oe = "response" in be ? be.response : be.responseText, rt = be.status === 1223 ? 204 : be.status;
          rt === 0 && (rt = Oe ? 200 : $o(H).protocol == "file" ? 404 : 0), De(
            X,
            rt,
            Oe,
            be.getAllResponseHeaders(),
            qe
          );
        };
        var Te = function() {
          De(X, -1, null, null, "");
        };
        if (be.onerror = Te, be.onabort = Te, he && (be.withCredentials = !0), ye)
          try {
            be.responseType = ye;
          } catch (Re) {
            if (ye !== "json")
              throw Re;
          }
        be.send(ce(W) ? null : W);
      }
      if (fe > 0)
        var _e = L(Ie, fe);
      else
        Pt(fe) && fe.then(Ie);
      function Ie() {
        Pe && Pe(), be && be.abort();
      }
      function De(Re, qe, Oe, rt, Xe) {
        ee(_e) && L.cancel(_e), Pe = be = null, Re(qe, Oe, rt, Xe), A.$$completeOutstandingRequest(G);
      }
    };
    function U(j, H, W) {
      var X = B.createElement("script"), Z = null;
      return X.type = "text/javascript", X.src = j, X.async = !0, Z = function(fe) {
        Gn(X, "load", Z), Gn(X, "error", Z), B.body.removeChild(X), X = null;
        var he = -1, ye = "unknown";
        fe && (fe.type === "load" && !I[H].called && (fe = { type: "error" }), ye = fe.type, he = fe.type === "error" ? 404 : 200), W && W(he, ye);
      }, Oa(X, "load", Z), Oa(X, "error", Z), B.body.appendChild(X), Z;
    }
  }
  var Xr = E.$interpolateMinErr = t("$interpolate");
  Xr.throwNoconcat = function(A) {
    throw Xr(
      "noconcat",
      `Error while interpolating: {0}
Strict Contextual Escaping disallows interpolations that concatenate multiple expressions when a trusted value is required.  See http://docs.angularjs.org/api/ng.$sce`,
      A
    );
  }, Xr.interr = function(A, k) {
    return Xr("interr", `Can't interpolate: {0}
{1}`, A, k.toString());
  };
  function ks() {
    var A = "{{", k = "}}";
    this.startSymbol = function(L) {
      return L ? (A = L, this) : A;
    }, this.endSymbol = function(L) {
      return L ? (k = L, this) : k;
    }, this.$get = ["$parse", "$exceptionHandler", "$sce", function(L, I, B) {
      var U = A.length, j = k.length, H = new RegExp(A.replace(/./g, X), "g"), W = new RegExp(k.replace(/./g, X), "g");
      function X(ye) {
        return "\\\\\\" + ye;
      }
      function Z(ye) {
        return ye.replace(H, A).replace(W, k);
      }
      function fe(ye) {
        if (ye == null)
          return "";
        switch (typeof ye) {
          case "string":
            break;
          case "number":
            ye = "" + ye;
            break;
          default:
            ye = za(ye);
        }
        return ye;
      }
      function he(ye, Se, Pe, be) {
        be = !!be;
        for (var Te, _e, Ie = 0, De = [], Re = [], qe = ye.length, Oe, rt = [], Xe = []; Ie < qe; )
          if ((Te = ye.indexOf(A, Ie)) != -1 && (_e = ye.indexOf(k, Te + U)) != -1)
            Ie !== Te && rt.push(Z(ye.substring(Ie, Te))), Oe = ye.substring(Te + U, _e), De.push(Oe), Re.push(L(Oe, tt)), Ie = _e + j, Xe.push(rt.length), rt.push("");
          else {
            Ie !== qe && rt.push(Z(ye.substring(Ie)));
            break;
          }
        if (Pe && rt.length > 1 && Xr.throwNoconcat(ye), !Se || De.length) {
          var Je = function(dt) {
            for (var Ye = 0, it = De.length; Ye < it; Ye++) {
              if (be && ce(dt[Ye]))
                return;
              rt[Xe[Ye]] = dt[Ye];
            }
            return rt.join("");
          }, Qe = function(dt) {
            return Pe ? B.getTrusted(Pe, dt) : B.valueOf(dt);
          };
          return $(function(Ye) {
            var it = 0, wt = De.length, Ct = new Array(wt);
            try {
              for (; it < wt; it++)
                Ct[it] = Re[it](Ye);
              return Je(Ct);
            } catch (yr) {
              I(Xr.interr(ye, yr));
            }
          }, {
            exp: ye,
            expressions: De,
            $$watchDelegate: function(dt, Ye) {
              var it;
              return dt.$watchGroup(Re, function(Ct, yr) {
                var Lr = Je(Ct);
                Ze(Ye) && Ye.call(this, Lr, Ct !== yr ? it : Lr, dt), it = Lr;
              });
            }
          });
        }
        function tt(dt) {
          try {
            return dt = Qe(dt), be && !ee(dt) ? dt : fe(dt);
          } catch (Ye) {
            I(Xr.interr(ye, Ye));
          }
        }
      }
      return he.startSymbol = function() {
        return A;
      }, he.endSymbol = function() {
        return k;
      }, he;
    }];
  }
  function yu() {
    this.$get = [
      "$rootScope",
      "$window",
      "$q",
      "$$q",
      function(A, k, L, I) {
        var B = {};
        function U(j, H, W, X) {
          var Z = arguments.length > 4, fe = Z ? mn(arguments, 4) : [], he = k.setInterval, ye = k.clearInterval, Se = 0, Pe = ee(X) && !X, be = (Pe ? I : L).defer(), Te = be.promise;
          return W = ee(W) ? W : 0, Te.then(null, null, Z ? function() {
            j.apply(null, fe);
          } : j), Te.$$intervalId = he(function() {
            be.notify(Se++), W > 0 && Se >= W && (be.resolve(Se), ye(Te.$$intervalId), delete B[Te.$$intervalId]), Pe || A.$apply();
          }, H), B[Te.$$intervalId] = be, Te;
        }
        return U.cancel = function(j) {
          return j && j.$$intervalId in B ? (B[j.$$intervalId].reject("canceled"), k.clearInterval(j.$$intervalId), delete B[j.$$intervalId], !0) : !1;
        }, U;
      }
    ];
  }
  var _u = /^([^\?#]*)(\?([^#]*))?(#(.*))?$/, aa = { http: 80, https: 443, ftp: 21 }, Ma = t("$location");
  function bu(A) {
    for (var k = A.split("/"), L = k.length; L--; )
      k[L] = Ja(k[L]);
    return k.join("/");
  }
  function gl(A, k) {
    var L = $o(A);
    k.$$protocol = L.protocol, k.$$host = L.hostname, k.$$port = M(L.port) || aa[L.protocol] || null;
  }
  function Uo(A, k) {
    var L = A.charAt(0) !== "/";
    L && (A = "/" + A);
    var I = $o(A);
    k.$$path = decodeURIComponent(L && I.pathname.charAt(0) === "/" ? I.pathname.substring(1) : I.pathname), k.$$search = Ro(I.search), k.$$hash = decodeURIComponent(I.hash), k.$$path && k.$$path.charAt(0) != "/" && (k.$$path = "/" + k.$$path);
  }
  function $i(A, k) {
    if (k.indexOf(A) === 0)
      return k.substr(A.length);
  }
  function Zs(A) {
    var k = A.indexOf("#");
    return k == -1 ? A : A.substr(0, k);
  }
  function Tu(A) {
    return A.replace(/(#.+)|#$/, "$1");
  }
  function op(A) {
    return A.substr(0, Zs(A).lastIndexOf("/") + 1);
  }
  function up(A) {
    return A.substring(0, A.indexOf("/", A.indexOf("//") + 2));
  }
  function lp(A, k, L) {
    this.$$html5 = !0, L = L || "", gl(A, this), this.$$parse = function(I) {
      var B = $i(k, I);
      if (!Ne(B))
        throw Ma(
          "ipthprfx",
          'Invalid url "{0}", missing path prefix "{1}".',
          I,
          k
        );
      Uo(B, this), this.$$path || (this.$$path = "/"), this.$$compose();
    }, this.$$compose = function() {
      var I = zs(this.$$search), B = this.$$hash ? "#" + Ja(this.$$hash) : "";
      this.$$url = bu(this.$$path) + (I ? "?" + I : "") + B, this.$$absUrl = k + this.$$url.substr(1);
    }, this.$$parseLinkUrl = function(I, B) {
      if (B && B[0] === "#")
        return this.hash(B.slice(1)), !0;
      var U, j, H;
      return ee(U = $i(A, I)) ? (j = U, ee(U = $i(L, U)) ? H = k + ($i("/", U) || U) : H = A + j) : ee(U = $i(k, I)) ? H = k + U : k == I + "/" && (H = k), H && this.$$parse(H), !!H;
    };
  }
  function cp(A, k, L) {
    gl(A, this), this.$$parse = function(I) {
      var B = $i(A, I) || $i(k, I), U;
      !ce(B) && B.charAt(0) === "#" ? (U = $i(L, B), ce(U) && (U = B)) : this.$$html5 ? U = B : (U = "", ce(B) && (A = I, this.replace())), Uo(U, this), this.$$path = j(this.$$path, U, A), this.$$compose();
      function j(H, W, X) {
        var Z = /^\/[A-Z]:(\/.*)/, fe;
        return W.indexOf(X) === 0 && (W = W.replace(X, "")), Z.exec(W) ? H : (fe = Z.exec(H), fe ? fe[1] : H);
      }
    }, this.$$compose = function() {
      var I = zs(this.$$search), B = this.$$hash ? "#" + Ja(this.$$hash) : "";
      this.$$url = bu(this.$$path) + (I ? "?" + I : "") + B, this.$$absUrl = A + (this.$$url ? L + this.$$url : "");
    }, this.$$parseLinkUrl = function(I, B) {
      return Zs(A) == Zs(I) ? (this.$$parse(I), !0) : !1;
    };
  }
  function R0(A, k, L) {
    this.$$html5 = !0, cp.apply(this, arguments), this.$$parseLinkUrl = function(I, B) {
      if (B && B[0] === "#")
        return this.hash(B.slice(1)), !0;
      var U, j;
      return A == Zs(I) ? U = I : (j = $i(k, I)) ? U = A + L + j : k === I + "/" && (U = k), U && this.$$parse(U), !!U;
    }, this.$$compose = function() {
      var I = zs(this.$$search), B = this.$$hash ? "#" + Ja(this.$$hash) : "";
      this.$$url = bu(this.$$path) + (I ? "?" + I : "") + B, this.$$absUrl = A + L + this.$$url;
    };
  }
  var HA = {
    $$html5: !1,
    $$replace: !1,
    absUrl: Gd("$$absUrl"),
    url: function(A) {
      if (ce(A))
        return this.$$url;
      var k = _u.exec(A);
      return (k[1] || A === "") && this.path(decodeURIComponent(k[1])), (k[2] || k[1] || A === "") && this.search(k[3] || ""), this.hash(k[5] || ""), this;
    },
    protocol: Gd("$$protocol"),
    host: Gd("$$host"),
    port: Gd("$$port"),
    path: P0("$$path", function(A) {
      return A = A !== null ? A.toString() : "", A.charAt(0) == "/" ? A : "/" + A;
    }),
    search: function(A, k) {
      switch (arguments.length) {
        case 0:
          return this.$$search;
        case 1:
          if (Ne(A) || ot(A))
            A = A.toString(), this.$$search = Ro(A);
          else if (me(A))
            A = _i(A, {}), T(A, function(L, I) {
              L == null && delete A[I];
            }), this.$$search = A;
          else
            throw Ma(
              "isrcharg",
              "The first argument of the `$location#search()` call must be a string or an object."
            );
          break;
        default:
          ce(k) || k === null ? delete this.$$search[A] : this.$$search[A] = k;
      }
      return this.$$compose(), this;
    },
    hash: P0("$$hash", function(A) {
      return A !== null ? A.toString() : "";
    }),
    replace: function() {
      return this.$$replace = !0, this;
    }
  };
  T([R0, cp, lp], function(A) {
    A.prototype = Object.create(HA), A.prototype.state = function(k) {
      if (!arguments.length)
        return this.$$state;
      if (A !== lp || !this.$$html5)
        throw Ma("nostate", "History API state support is available only in HTML5 mode and only in browsers supporting HTML5 History API");
      return this.$$state = ce(k) ? null : k, this;
    };
  });
  function Gd(A) {
    return function() {
      return this[A];
    };
  }
  function P0(A, k) {
    return function(L) {
      return ce(L) ? this[A] : (this[A] = k(L), this.$$compose(), this);
    };
  }
  function VA() {
    var A = "", k = {
      enabled: !1,
      requireBase: !0,
      rewriteLinks: !0
    };
    this.hashPrefix = function(L) {
      return ee(L) ? (A = L, this) : A;
    }, this.html5Mode = function(L) {
      return xt(L) ? (k.enabled = L, this) : me(L) ? (xt(L.enabled) && (k.enabled = L.enabled), xt(L.requireBase) && (k.requireBase = L.requireBase), xt(L.rewriteLinks) && (k.rewriteLinks = L.rewriteLinks), this) : k;
    }, this.$get = [
      "$rootScope",
      "$browser",
      "$sniffer",
      "$rootElement",
      "$window",
      function(L, I, B, U, j) {
        var H, W, X = I.baseHref(), Z = I.url(), fe;
        if (k.enabled) {
          if (!X && k.requireBase)
            throw Ma(
              "nobase",
              "$location in HTML5 mode requires a <base> tag to be present!"
            );
          fe = up(Z) + (X || "/"), W = B.history ? lp : R0;
        } else
          fe = Zs(Z), W = cp;
        var he = op(fe);
        H = new W(fe, he, "#" + A), H.$$parseLinkUrl(Z, Z), H.$$state = I.state();
        var ye = /^\s*(javascript|mailto):/i;
        function Se(Te, _e, Ie) {
          var De = H.url(), Re = H.$$state;
          try {
            I.url(Te, _e, Ie), H.$$state = I.state();
          } catch (qe) {
            throw H.url(De), H.$$state = Re, qe;
          }
        }
        U.on("click", function(Te) {
          if (!(!k.rewriteLinks || Te.ctrlKey || Te.metaKey || Te.shiftKey || Te.which == 2 || Te.button == 2)) {
            for (var _e = d(Te.target); Qr(_e[0]) !== "a"; )
              if (_e[0] === U[0] || !(_e = _e.parent())[0])
                return;
            var Ie = _e.prop("href"), De = _e.attr("href") || _e.attr("xlink:href");
            me(Ie) && Ie.toString() === "[object SVGAnimatedString]" && (Ie = $o(Ie.animVal).href), !ye.test(Ie) && Ie && !_e.attr("target") && !Te.isDefaultPrevented() && H.$$parseLinkUrl(Ie, De) && (Te.preventDefault(), H.absUrl() != I.url() && (L.$apply(), j.angular["ff-684208-preventDefault"] = !0));
          }
        }), Tu(H.absUrl()) != Tu(Z) && I.url(H.absUrl(), !0);
        var Pe = !0;
        return I.onUrlChange(function(Te, _e) {
          if (ce($i(he, Te))) {
            j.location.href = Te;
            return;
          }
          L.$evalAsync(function() {
            var Ie = H.absUrl(), De = H.$$state, Re;
            Te = Tu(Te), H.$$parse(Te), H.$$state = _e, Re = L.$broadcast(
              "$locationChangeStart",
              Te,
              Ie,
              _e,
              De
            ).defaultPrevented, H.absUrl() === Te && (Re ? (H.$$parse(Ie), H.$$state = De, Se(Ie, !1, De)) : (Pe = !1, be(Ie, De)));
          }), L.$$phase || L.$digest();
        }), L.$watch(function() {
          var _e = Tu(I.url()), Ie = Tu(H.absUrl()), De = I.state(), Re = H.$$replace, qe = _e !== Ie || H.$$html5 && B.history && De !== H.$$state;
          (Pe || qe) && (Pe = !1, L.$evalAsync(function() {
            var Oe = H.absUrl(), rt = L.$broadcast(
              "$locationChangeStart",
              Oe,
              _e,
              H.$$state,
              De
            ).defaultPrevented;
            H.absUrl() === Oe && (rt ? (H.$$parse(_e), H.$$state = De) : (qe && Se(
              Oe,
              Re,
              De === H.$$state ? null : H.$$state
            ), be(_e, De)));
          })), H.$$replace = !1;
        }), H;
        function be(Te, _e) {
          L.$broadcast(
            "$locationChangeSuccess",
            H.absUrl(),
            Te,
            H.$$state,
            _e
          );
        }
      }
    ];
  }
  function qA() {
    var A = !0, k = this;
    this.debugEnabled = function(L) {
      return ee(L) ? (A = L, this) : A;
    }, this.$get = ["$window", function(L) {
      return {
        log: B("log"),
        info: B("info"),
        warn: B("warn"),
        error: B("error"),
        debug: function() {
          var U = B("debug");
          return function() {
            A && U.apply(k, arguments);
          };
        }()
      };
      function I(U) {
        return U instanceof Error && (U.stack ? U = U.message && U.stack.indexOf(U.message) === -1 ? "Error: " + U.message + `
` + U.stack : U.stack : U.sourceURL && (U = U.message + `
` + U.sourceURL + ":" + U.line)), U;
      }
      function B(U) {
        var j = L.console || {}, H = j[U] || j.log || G, W = !1;
        try {
          W = !!H.apply;
        } catch {
        }
        return W ? function() {
          var X = [];
          return T(arguments, function(Z) {
            X.push(I(Z));
          }), H.apply(j, X);
        } : function(X, Z) {
          H(X, Z == null ? "" : Z);
        };
      }
    }];
  }
  var Wn = t("$parse");
  function vl(A, k) {
    if (A === "__defineGetter__" || A === "__defineSetter__" || A === "__lookupGetter__" || A === "__lookupSetter__" || A === "__proto__")
      throw Wn(
        "isecfld",
        "Attempting to access a disallowed field in Angular expressions! Expression: {0}",
        k
      );
    return A;
  }
  function O0(A, k) {
    if (A = A + "", !Ne(A))
      throw Wn(
        "iseccst",
        "Cannot convert object to primitive value! Expression: {0}",
        k
      );
    return A;
  }
  function Bo(A, k) {
    if (A) {
      if (A.constructor === A)
        throw Wn(
          "isecfn",
          "Referencing Function in Angular expressions is disallowed! Expression: {0}",
          k
        );
      if (A.window === A)
        throw Wn(
          "isecwindow",
          "Referencing the Window in Angular expressions is disallowed! Expression: {0}",
          k
        );
      if (A.children && (A.nodeName || A.prop && A.attr && A.find))
        throw Wn(
          "isecdom",
          "Referencing DOM nodes in Angular expressions is disallowed! Expression: {0}",
          k
        );
      if (A === Object)
        throw Wn(
          "isecobj",
          "Referencing Object in Angular expressions is disallowed! Expression: {0}",
          k
        );
    }
    return A;
  }
  var WA = Function.prototype.call, YA = Function.prototype.apply, KA = Function.prototype.bind;
  function L0(A, k) {
    if (A) {
      if (A.constructor === A)
        throw Wn(
          "isecfn",
          "Referencing Function in Angular expressions is disallowed! Expression: {0}",
          k
        );
      if (A === WA || A === YA || A === KA)
        throw Wn(
          "isecff",
          "Referencing call, apply or bind in Angular expressions is disallowed! Expression: {0}",
          k
        );
    }
  }
  function Hd(A, k) {
    if (A && (A === 0 .constructor || A === (!1).constructor || A === "".constructor || A === {}.constructor || A === [].constructor || A === Function.constructor))
      throw Wn(
        "isecaf",
        "Assigning to a constructor is disallowed! Expression: {0}",
        k
      );
  }
  var Vd = xi();
  T("+ - * / % === !== == != < > <= >= && || ! = |".split(" "), function(A) {
    Vd[A] = !0;
  });
  var zA = { n: `
`, f: "\f", r: "\r", t: "	", v: "\v", "'": "'", '"': '"' }, dp = function(A) {
    this.options = A;
  };
  dp.prototype = {
    constructor: dp,
    lex: function(A) {
      for (this.text = A, this.index = 0, this.tokens = []; this.index < this.text.length; ) {
        var k = this.text.charAt(this.index);
        if (k === '"' || k === "'")
          this.readString(k);
        else if (this.isNumber(k) || k === "." && this.isNumber(this.peek()))
          this.readNumber();
        else if (this.isIdent(k))
          this.readIdent();
        else if (this.is(k, "(){}[].,;:?"))
          this.tokens.push({ index: this.index, text: k }), this.index++;
        else if (this.isWhitespace(k))
          this.index++;
        else {
          var L = k + this.peek(), I = L + this.peek(2), B = Vd[k], U = Vd[L], j = Vd[I];
          if (B || U || j) {
            var H = j ? I : U ? L : k;
            this.tokens.push({ index: this.index, text: H, operator: !0 }), this.index += H.length;
          } else
            this.throwError("Unexpected next character ", this.index, this.index + 1);
        }
      }
      return this.tokens;
    },
    is: function(A, k) {
      return k.indexOf(A) !== -1;
    },
    peek: function(A) {
      var k = A || 1;
      return this.index + k < this.text.length ? this.text.charAt(this.index + k) : !1;
    },
    isNumber: function(A) {
      return "0" <= A && A <= "9" && typeof A == "string";
    },
    isWhitespace: function(A) {
      return A === " " || A === "\r" || A === "	" || A === `
` || A === "\v" || A === "\xA0";
    },
    isIdent: function(A) {
      return "a" <= A && A <= "z" || "A" <= A && A <= "Z" || A === "_" || A === "$";
    },
    isExpOperator: function(A) {
      return A === "-" || A === "+" || this.isNumber(A);
    },
    throwError: function(A, k, L) {
      L = L || this.index;
      var I = ee(k) ? "s " + k + "-" + this.index + " [" + this.text.substring(k, L) + "]" : " " + L;
      throw Wn(
        "lexerr",
        "Lexer Error: {0} at column{1} in expression [{2}].",
        A,
        I,
        this.text
      );
    },
    readNumber: function() {
      for (var A = "", k = this.index; this.index < this.text.length; ) {
        var L = s(this.text.charAt(this.index));
        if (L == "." || this.isNumber(L))
          A += L;
        else {
          var I = this.peek();
          if (L == "e" && this.isExpOperator(I))
            A += L;
          else if (this.isExpOperator(L) && I && this.isNumber(I) && A.charAt(A.length - 1) == "e")
            A += L;
          else if (this.isExpOperator(L) && (!I || !this.isNumber(I)) && A.charAt(A.length - 1) == "e")
            this.throwError("Invalid exponent");
          else
            break;
        }
        this.index++;
      }
      this.tokens.push({
        index: k,
        text: A,
        constant: !0,
        value: Number(A)
      });
    },
    readIdent: function() {
      for (var A = this.index; this.index < this.text.length; ) {
        var k = this.text.charAt(this.index);
        if (!(this.isIdent(k) || this.isNumber(k)))
          break;
        this.index++;
      }
      this.tokens.push({
        index: A,
        text: this.text.slice(A, this.index),
        identifier: !0
      });
    },
    readString: function(A) {
      var k = this.index;
      this.index++;
      for (var L = "", I = A, B = !1; this.index < this.text.length; ) {
        var U = this.text.charAt(this.index);
        if (I += U, B) {
          if (U === "u") {
            var j = this.text.substring(this.index + 1, this.index + 5);
            j.match(/[\da-f]{4}/i) || this.throwError("Invalid unicode escape [\\u" + j + "]"), this.index += 4, L += String.fromCharCode(parseInt(j, 16));
          } else {
            var H = zA[U];
            L = L + (H || U);
          }
          B = !1;
        } else if (U === "\\")
          B = !0;
        else if (U === A) {
          this.index++, this.tokens.push({
            index: k,
            text: I,
            constant: !0,
            value: L
          });
          return;
        } else
          L += U;
        this.index++;
      }
      this.throwError("Unterminated quote", k);
    }
  };
  var At = function(A, k) {
    this.lexer = A, this.options = k;
  };
  At.Program = "Program", At.ExpressionStatement = "ExpressionStatement", At.AssignmentExpression = "AssignmentExpression", At.ConditionalExpression = "ConditionalExpression", At.LogicalExpression = "LogicalExpression", At.BinaryExpression = "BinaryExpression", At.UnaryExpression = "UnaryExpression", At.CallExpression = "CallExpression", At.MemberExpression = "MemberExpression", At.Identifier = "Identifier", At.Literal = "Literal", At.ArrayExpression = "ArrayExpression", At.Property = "Property", At.ObjectExpression = "ObjectExpression", At.ThisExpression = "ThisExpression", At.NGValueParameter = "NGValueParameter", At.prototype = {
    ast: function(A) {
      this.text = A, this.tokens = this.lexer.lex(A);
      var k = this.program();
      return this.tokens.length !== 0 && this.throwError("is an unexpected token", this.tokens[0]), k;
    },
    program: function() {
      for (var A = []; ; )
        if (this.tokens.length > 0 && !this.peek("}", ")", ";", "]") && A.push(this.expressionStatement()), !this.expect(";"))
          return { type: At.Program, body: A };
    },
    expressionStatement: function() {
      return { type: At.ExpressionStatement, expression: this.filterChain() };
    },
    filterChain: function() {
      for (var A = this.expression(); this.expect("|"); )
        A = this.filter(A);
      return A;
    },
    expression: function() {
      return this.assignment();
    },
    assignment: function() {
      var A = this.ternary();
      return this.expect("=") && (A = { type: At.AssignmentExpression, left: A, right: this.assignment(), operator: "=" }), A;
    },
    ternary: function() {
      var A = this.logicalOR(), k, L;
      return this.expect("?") && (k = this.expression(), this.consume(":")) ? (L = this.expression(), { type: At.ConditionalExpression, test: A, alternate: k, consequent: L }) : A;
    },
    logicalOR: function() {
      for (var A = this.logicalAND(); this.expect("||"); )
        A = { type: At.LogicalExpression, operator: "||", left: A, right: this.logicalAND() };
      return A;
    },
    logicalAND: function() {
      for (var A = this.equality(); this.expect("&&"); )
        A = { type: At.LogicalExpression, operator: "&&", left: A, right: this.equality() };
      return A;
    },
    equality: function() {
      for (var A = this.relational(), k; k = this.expect("==", "!=", "===", "!=="); )
        A = { type: At.BinaryExpression, operator: k.text, left: A, right: this.relational() };
      return A;
    },
    relational: function() {
      for (var A = this.additive(), k; k = this.expect("<", ">", "<=", ">="); )
        A = { type: At.BinaryExpression, operator: k.text, left: A, right: this.additive() };
      return A;
    },
    additive: function() {
      for (var A = this.multiplicative(), k; k = this.expect("+", "-"); )
        A = { type: At.BinaryExpression, operator: k.text, left: A, right: this.multiplicative() };
      return A;
    },
    multiplicative: function() {
      for (var A = this.unary(), k; k = this.expect("*", "/", "%"); )
        A = { type: At.BinaryExpression, operator: k.text, left: A, right: this.unary() };
      return A;
    },
    unary: function() {
      var A;
      return (A = this.expect("+", "-", "!")) ? { type: At.UnaryExpression, operator: A.text, prefix: !0, argument: this.unary() } : this.primary();
    },
    primary: function() {
      var A;
      this.expect("(") ? (A = this.filterChain(), this.consume(")")) : this.expect("[") ? A = this.arrayDeclaration() : this.expect("{") ? A = this.object() : this.constants.hasOwnProperty(this.peek().text) ? A = _i(this.constants[this.consume().text]) : this.peek().identifier ? A = this.identifier() : this.peek().constant ? A = this.constant() : this.throwError("not a primary expression", this.peek());
      for (var k; k = this.expect("(", "[", "."); )
        k.text === "(" ? (A = { type: At.CallExpression, callee: A, arguments: this.parseArguments() }, this.consume(")")) : k.text === "[" ? (A = { type: At.MemberExpression, object: A, property: this.expression(), computed: !0 }, this.consume("]")) : k.text === "." ? A = { type: At.MemberExpression, object: A, property: this.identifier(), computed: !1 } : this.throwError("IMPOSSIBLE");
      return A;
    },
    filter: function(A) {
      for (var k = [A], L = { type: At.CallExpression, callee: this.identifier(), arguments: k, filter: !0 }; this.expect(":"); )
        k.push(this.expression());
      return L;
    },
    parseArguments: function() {
      var A = [];
      if (this.peekToken().text !== ")")
        do
          A.push(this.expression());
        while (this.expect(","));
      return A;
    },
    identifier: function() {
      var A = this.consume();
      return A.identifier || this.throwError("is not a valid identifier", A), { type: At.Identifier, name: A.text };
    },
    constant: function() {
      return { type: At.Literal, value: this.consume().value };
    },
    arrayDeclaration: function() {
      var A = [];
      if (this.peekToken().text !== "]")
        do {
          if (this.peek("]"))
            break;
          A.push(this.expression());
        } while (this.expect(","));
      return this.consume("]"), { type: At.ArrayExpression, elements: A };
    },
    object: function() {
      var A = [], k;
      if (this.peekToken().text !== "}")
        do {
          if (this.peek("}"))
            break;
          k = { type: At.Property, kind: "init" }, this.peek().constant ? k.key = this.constant() : this.peek().identifier ? k.key = this.identifier() : this.throwError("invalid key", this.peek()), this.consume(":"), k.value = this.expression(), A.push(k);
        } while (this.expect(","));
      return this.consume("}"), { type: At.ObjectExpression, properties: A };
    },
    throwError: function(A, k) {
      throw Wn(
        "syntax",
        "Syntax Error: Token '{0}' {1} at column {2} of the expression [{3}] starting at [{4}].",
        k.text,
        A,
        k.index + 1,
        this.text,
        this.text.substring(k.index)
      );
    },
    consume: function(A) {
      if (this.tokens.length === 0)
        throw Wn("ueoe", "Unexpected end of expression: {0}", this.text);
      var k = this.expect(A);
      return k || this.throwError("is unexpected, expecting [" + A + "]", this.peek()), k;
    },
    peekToken: function() {
      if (this.tokens.length === 0)
        throw Wn("ueoe", "Unexpected end of expression: {0}", this.text);
      return this.tokens[0];
    },
    peek: function(A, k, L, I) {
      return this.peekAhead(0, A, k, L, I);
    },
    peekAhead: function(A, k, L, I, B) {
      if (this.tokens.length > A) {
        var U = this.tokens[A], j = U.text;
        if (j === k || j === L || j === I || j === B || !k && !L && !I && !B)
          return U;
      }
      return !1;
    },
    expect: function(A, k, L, I) {
      var B = this.peek(A, k, L, I);
      return B ? (this.tokens.shift(), B) : !1;
    },
    constants: {
      true: { type: At.Literal, value: !0 },
      false: { type: At.Literal, value: !1 },
      null: { type: At.Literal, value: null },
      undefined: { type: At.Literal, value: i },
      this: { type: At.ThisExpression }
    }
  };
  function XA(A, k) {
    return typeof A < "u" ? A : k;
  }
  function I0(A, k) {
    return typeof A > "u" ? k : typeof k > "u" ? A : A + k;
  }
  function M0(A, k) {
    var L = A(k);
    return !L.$stateful;
  }
  function ln(A, k) {
    var L, I;
    switch (A.type) {
      case At.Program:
        L = !0, T(A.body, function(B) {
          ln(B.expression, k), L = L && B.expression.constant;
        }), A.constant = L;
        break;
      case At.Literal:
        A.constant = !0, A.toWatch = [];
        break;
      case At.UnaryExpression:
        ln(A.argument, k), A.constant = A.argument.constant, A.toWatch = A.argument.toWatch;
        break;
      case At.BinaryExpression:
        ln(A.left, k), ln(A.right, k), A.constant = A.left.constant && A.right.constant, A.toWatch = A.left.toWatch.concat(A.right.toWatch);
        break;
      case At.LogicalExpression:
        ln(A.left, k), ln(A.right, k), A.constant = A.left.constant && A.right.constant, A.toWatch = A.constant ? [] : [A];
        break;
      case At.ConditionalExpression:
        ln(A.test, k), ln(A.alternate, k), ln(A.consequent, k), A.constant = A.test.constant && A.alternate.constant && A.consequent.constant, A.toWatch = A.constant ? [] : [A];
        break;
      case At.Identifier:
        A.constant = !1, A.toWatch = [A];
        break;
      case At.MemberExpression:
        ln(A.object, k), A.computed && ln(A.property, k), A.constant = A.object.constant && (!A.computed || A.property.constant), A.toWatch = [A];
        break;
      case At.CallExpression:
        L = A.filter ? M0(k, A.callee.name) : !1, I = [], T(A.arguments, function(B) {
          ln(B, k), L = L && B.constant, B.constant || I.push.apply(I, B.toWatch);
        }), A.constant = L, A.toWatch = A.filter && M0(k, A.callee.name) ? I : [A];
        break;
      case At.AssignmentExpression:
        ln(A.left, k), ln(A.right, k), A.constant = A.left.constant && A.right.constant, A.toWatch = [A];
        break;
      case At.ArrayExpression:
        L = !0, I = [], T(A.elements, function(B) {
          ln(B, k), L = L && B.constant, B.constant || I.push.apply(I, B.toWatch);
        }), A.constant = L, A.toWatch = I;
        break;
      case At.ObjectExpression:
        L = !0, I = [], T(A.properties, function(B) {
          ln(B.value, k), L = L && B.value.constant, B.value.constant || I.push.apply(I, B.value.toWatch);
        }), A.constant = L, A.toWatch = I;
        break;
      case At.ThisExpression:
        A.constant = !1, A.toWatch = [];
        break;
    }
  }
  function N0(A) {
    if (A.length == 1) {
      var k = A[0].expression, L = k.toWatch;
      return L.length !== 1 || L[0] !== k ? L : i;
    }
  }
  function F0(A) {
    return A.type === At.Identifier || A.type === At.MemberExpression;
  }
  function U0(A) {
    if (A.body.length === 1 && F0(A.body[0].expression))
      return { type: At.AssignmentExpression, left: A.body[0].expression, right: { type: At.NGValueParameter }, operator: "=" };
  }
  function B0(A) {
    return A.body.length === 0 || A.body.length === 1 && (A.body[0].expression.type === At.Literal || A.body[0].expression.type === At.ArrayExpression || A.body[0].expression.type === At.ObjectExpression);
  }
  function j0(A) {
    return A.constant;
  }
  function $0(A, k) {
    this.astBuilder = A, this.$filter = k;
  }
  $0.prototype = {
    compile: function(A, k) {
      var L = this, I = this.astBuilder.ast(A);
      this.state = {
        nextId: 0,
        filters: {},
        expensiveChecks: k,
        fn: { vars: [], body: [], own: {} },
        assign: { vars: [], body: [], own: {} },
        inputs: []
      }, ln(I, L.$filter);
      var B = "", U;
      if (this.stage = "assign", U = U0(I)) {
        this.state.computing = "assign";
        var j = this.nextId();
        this.recurse(U, j), this.return_(j), B = "fn.assign=" + this.generateFunction("assign", "s,v,l");
      }
      var H = N0(I.body);
      L.stage = "inputs", T(H, function(Z, fe) {
        var he = "fn" + fe;
        L.state[he] = { vars: [], body: [], own: {} }, L.state.computing = he;
        var ye = L.nextId();
        L.recurse(Z, ye), L.return_(ye), L.state.inputs.push(he), Z.watchId = fe;
      }), this.state.computing = "fn", this.stage = "main", this.recurse(I);
      var W = '"' + this.USE + " " + this.STRICT + `";
` + this.filterPrefix() + "var fn=" + this.generateFunction("fn", "s,l,a,i") + B + this.watchFns() + "return fn;", X = new Function(
        "$filter",
        "ensureSafeMemberName",
        "ensureSafeObject",
        "ensureSafeFunction",
        "getStringValue",
        "ensureSafeAssignContext",
        "ifDefined",
        "plus",
        "text",
        W
      )(
        this.$filter,
        vl,
        Bo,
        L0,
        O0,
        Hd,
        XA,
        I0,
        A
      );
      return this.state = this.stage = i, X.literal = B0(I), X.constant = j0(I), X;
    },
    USE: "use",
    STRICT: "strict",
    watchFns: function() {
      var A = [], k = this.state.inputs, L = this;
      return T(k, function(I) {
        A.push("var " + I + "=" + L.generateFunction(I, "s"));
      }), k.length && A.push("fn.inputs=[" + k.join(",") + "];"), A.join("");
    },
    generateFunction: function(A, k) {
      return "function(" + k + "){" + this.varsPrefix(A) + this.body(A) + "};";
    },
    filterPrefix: function() {
      var A = [], k = this;
      return T(this.state.filters, function(L, I) {
        A.push(L + "=$filter(" + k.escape(I) + ")");
      }), A.length ? "var " + A.join(",") + ";" : "";
    },
    varsPrefix: function(A) {
      return this.state[A].vars.length ? "var " + this.state[A].vars.join(",") + ";" : "";
    },
    body: function(A) {
      return this.state[A].body.join("");
    },
    recurse: function(A, k, L, I, B, U) {
      var j, H, W = this, X, Z;
      if (I = I || G, !U && ee(A.watchId)) {
        k = k || this.nextId(), this.if_(
          "i",
          this.lazyAssign(k, this.computedMember("i", A.watchId)),
          this.lazyRecurse(A, k, L, I, B, !0)
        );
        return;
      }
      switch (A.type) {
        case At.Program:
          T(A.body, function(fe, he) {
            W.recurse(fe.expression, i, i, function(ye) {
              H = ye;
            }), he !== A.body.length - 1 ? W.current().body.push(H, ";") : W.return_(H);
          });
          break;
        case At.Literal:
          Z = this.escape(A.value), this.assign(k, Z), I(Z);
          break;
        case At.UnaryExpression:
          this.recurse(A.argument, i, i, function(fe) {
            H = fe;
          }), Z = A.operator + "(" + this.ifDefined(H, 0) + ")", this.assign(k, Z), I(Z);
          break;
        case At.BinaryExpression:
          this.recurse(A.left, i, i, function(fe) {
            j = fe;
          }), this.recurse(A.right, i, i, function(fe) {
            H = fe;
          }), A.operator === "+" ? Z = this.plus(j, H) : A.operator === "-" ? Z = this.ifDefined(j, 0) + A.operator + this.ifDefined(H, 0) : Z = "(" + j + ")" + A.operator + "(" + H + ")", this.assign(k, Z), I(Z);
          break;
        case At.LogicalExpression:
          k = k || this.nextId(), W.recurse(A.left, k), W.if_(A.operator === "&&" ? k : W.not(k), W.lazyRecurse(A.right, k)), I(k);
          break;
        case At.ConditionalExpression:
          k = k || this.nextId(), W.recurse(A.test, k), W.if_(k, W.lazyRecurse(A.alternate, k), W.lazyRecurse(A.consequent, k)), I(k);
          break;
        case At.Identifier:
          k = k || this.nextId(), L && (L.context = W.stage === "inputs" ? "s" : this.assign(this.nextId(), this.getHasOwnProperty("l", A.name) + "?l:s"), L.computed = !1, L.name = A.name), vl(A.name), W.if_(
            W.stage === "inputs" || W.not(W.getHasOwnProperty("l", A.name)),
            function() {
              W.if_(W.stage === "inputs" || "s", function() {
                B && B !== 1 && W.if_(
                  W.not(W.nonComputedMember("s", A.name)),
                  W.lazyAssign(W.nonComputedMember("s", A.name), "{}")
                ), W.assign(k, W.nonComputedMember("s", A.name));
              });
            },
            k && W.lazyAssign(k, W.nonComputedMember("l", A.name))
          ), (W.state.expensiveChecks || qd(A.name)) && W.addEnsureSafeObject(k), I(k);
          break;
        case At.MemberExpression:
          j = L && (L.context = this.nextId()) || this.nextId(), k = k || this.nextId(), W.recurse(A.object, j, i, function() {
            W.if_(W.notNull(j), function() {
              B && B !== 1 && W.addEnsureSafeAssignContext(j), A.computed ? (H = W.nextId(), W.recurse(A.property, H), W.getStringValue(H), W.addEnsureSafeMemberName(H), B && B !== 1 && W.if_(W.not(W.computedMember(j, H)), W.lazyAssign(W.computedMember(j, H), "{}")), Z = W.ensureSafeObject(W.computedMember(j, H)), W.assign(k, Z), L && (L.computed = !0, L.name = H)) : (vl(A.property.name), B && B !== 1 && W.if_(W.not(W.nonComputedMember(j, A.property.name)), W.lazyAssign(W.nonComputedMember(j, A.property.name), "{}")), Z = W.nonComputedMember(j, A.property.name), (W.state.expensiveChecks || qd(A.property.name)) && (Z = W.ensureSafeObject(Z)), W.assign(k, Z), L && (L.computed = !1, L.name = A.property.name));
            }, function() {
              W.assign(k, "undefined");
            }), I(k);
          }, !!B);
          break;
        case At.CallExpression:
          k = k || this.nextId(), A.filter ? (H = W.filter(A.callee.name), X = [], T(A.arguments, function(fe) {
            var he = W.nextId();
            W.recurse(fe, he), X.push(he);
          }), Z = H + "(" + X.join(",") + ")", W.assign(k, Z), I(k)) : (H = W.nextId(), j = {}, X = [], W.recurse(A.callee, H, j, function() {
            W.if_(W.notNull(H), function() {
              W.addEnsureSafeFunction(H), T(A.arguments, function(fe) {
                W.recurse(fe, W.nextId(), i, function(he) {
                  X.push(W.ensureSafeObject(he));
                });
              }), j.name ? (W.state.expensiveChecks || W.addEnsureSafeObject(j.context), Z = W.member(j.context, j.name, j.computed) + "(" + X.join(",") + ")") : Z = H + "(" + X.join(",") + ")", Z = W.ensureSafeObject(Z), W.assign(k, Z);
            }, function() {
              W.assign(k, "undefined");
            }), I(k);
          }));
          break;
        case At.AssignmentExpression:
          if (H = this.nextId(), j = {}, !F0(A.left))
            throw Wn("lval", "Trying to assign a value to a non l-value");
          this.recurse(A.left, i, j, function() {
            W.if_(W.notNull(j.context), function() {
              W.recurse(A.right, H), W.addEnsureSafeObject(W.member(j.context, j.name, j.computed)), W.addEnsureSafeAssignContext(j.context), Z = W.member(j.context, j.name, j.computed) + A.operator + H, W.assign(k, Z), I(k || Z);
            });
          }, 1);
          break;
        case At.ArrayExpression:
          X = [], T(A.elements, function(fe) {
            W.recurse(fe, W.nextId(), i, function(he) {
              X.push(he);
            });
          }), Z = "[" + X.join(",") + "]", this.assign(k, Z), I(Z);
          break;
        case At.ObjectExpression:
          X = [], T(A.properties, function(fe) {
            W.recurse(fe.value, W.nextId(), i, function(he) {
              X.push(W.escape(
                fe.key.type === At.Identifier ? fe.key.name : "" + fe.key.value
              ) + ":" + he);
            });
          }), Z = "{" + X.join(",") + "}", this.assign(k, Z), I(Z);
          break;
        case At.ThisExpression:
          this.assign(k, "s"), I("s");
          break;
        case At.NGValueParameter:
          this.assign(k, "v"), I("v");
          break;
      }
    },
    getHasOwnProperty: function(A, k) {
      var L = A + "." + k, I = this.current().own;
      return I.hasOwnProperty(L) || (I[L] = this.nextId(!1, A + "&&(" + this.escape(k) + " in " + A + ")")), I[L];
    },
    assign: function(A, k) {
      if (!!A)
        return this.current().body.push(A, "=", k, ";"), A;
    },
    filter: function(A) {
      return this.state.filters.hasOwnProperty(A) || (this.state.filters[A] = this.nextId(!0)), this.state.filters[A];
    },
    ifDefined: function(A, k) {
      return "ifDefined(" + A + "," + this.escape(k) + ")";
    },
    plus: function(A, k) {
      return "plus(" + A + "," + k + ")";
    },
    return_: function(A) {
      this.current().body.push("return ", A, ";");
    },
    if_: function(A, k, L) {
      if (A === !0)
        k();
      else {
        var I = this.current().body;
        I.push("if(", A, "){"), k(), I.push("}"), L && (I.push("else{"), L(), I.push("}"));
      }
    },
    not: function(A) {
      return "!(" + A + ")";
    },
    notNull: function(A) {
      return A + "!=null";
    },
    nonComputedMember: function(A, k) {
      return A + "." + k;
    },
    computedMember: function(A, k) {
      return A + "[" + k + "]";
    },
    member: function(A, k, L) {
      return L ? this.computedMember(A, k) : this.nonComputedMember(A, k);
    },
    addEnsureSafeObject: function(A) {
      this.current().body.push(this.ensureSafeObject(A), ";");
    },
    addEnsureSafeMemberName: function(A) {
      this.current().body.push(this.ensureSafeMemberName(A), ";");
    },
    addEnsureSafeFunction: function(A) {
      this.current().body.push(this.ensureSafeFunction(A), ";");
    },
    addEnsureSafeAssignContext: function(A) {
      this.current().body.push(this.ensureSafeAssignContext(A), ";");
    },
    ensureSafeObject: function(A) {
      return "ensureSafeObject(" + A + ",text)";
    },
    ensureSafeMemberName: function(A) {
      return "ensureSafeMemberName(" + A + ",text)";
    },
    ensureSafeFunction: function(A) {
      return "ensureSafeFunction(" + A + ",text)";
    },
    getStringValue: function(A) {
      this.assign(A, "getStringValue(" + A + ",text)");
    },
    ensureSafeAssignContext: function(A) {
      return "ensureSafeAssignContext(" + A + ",text)";
    },
    lazyRecurse: function(A, k, L, I, B, U) {
      var j = this;
      return function() {
        j.recurse(A, k, L, I, B, U);
      };
    },
    lazyAssign: function(A, k) {
      var L = this;
      return function() {
        L.assign(A, k);
      };
    },
    stringEscapeRegex: /[^ a-zA-Z0-9]/g,
    stringEscapeFn: function(A) {
      return "\\u" + ("0000" + A.charCodeAt(0).toString(16)).slice(-4);
    },
    escape: function(A) {
      if (Ne(A))
        return "'" + A.replace(this.stringEscapeRegex, this.stringEscapeFn) + "'";
      if (ot(A))
        return A.toString();
      if (A === !0)
        return "true";
      if (A === !1)
        return "false";
      if (A === null)
        return "null";
      if (typeof A > "u")
        return "undefined";
      throw Wn("esc", "IMPOSSIBLE");
    },
    nextId: function(A, k) {
      var L = "v" + this.state.nextId++;
      return A || this.current().vars.push(L + (k ? "=" + k : "")), L;
    },
    current: function() {
      return this.state[this.state.computing];
    }
  };
  function G0(A, k) {
    this.astBuilder = A, this.$filter = k;
  }
  G0.prototype = {
    compile: function(A, k) {
      var L = this, I = this.astBuilder.ast(A);
      this.expression = A, this.expensiveChecks = k, ln(I, L.$filter);
      var B, U;
      (B = U0(I)) && (U = this.recurse(B));
      var j = N0(I.body), H;
      j && (H = [], T(j, function(Z, fe) {
        var he = L.recurse(Z);
        Z.input = he, H.push(he), Z.watchId = fe;
      }));
      var W = [];
      T(I.body, function(Z) {
        W.push(L.recurse(Z.expression));
      });
      var X = I.body.length === 0 ? function() {
      } : I.body.length === 1 ? W[0] : function(Z, fe) {
        var he;
        return T(W, function(ye) {
          he = ye(Z, fe);
        }), he;
      };
      return U && (X.assign = function(Z, fe, he) {
        return U(Z, he, fe);
      }), H && (X.inputs = H), X.literal = B0(I), X.constant = j0(I), X;
    },
    recurse: function(A, k, L) {
      var I, B, U = this, j;
      if (A.input)
        return this.inputs(A.input, A.watchId);
      switch (A.type) {
        case At.Literal:
          return this.value(A.value, k);
        case At.UnaryExpression:
          return B = this.recurse(A.argument), this["unary" + A.operator](B, k);
        case At.BinaryExpression:
          return I = this.recurse(A.left), B = this.recurse(A.right), this["binary" + A.operator](I, B, k);
        case At.LogicalExpression:
          return I = this.recurse(A.left), B = this.recurse(A.right), this["binary" + A.operator](I, B, k);
        case At.ConditionalExpression:
          return this["ternary?:"](
            this.recurse(A.test),
            this.recurse(A.alternate),
            this.recurse(A.consequent),
            k
          );
        case At.Identifier:
          return vl(A.name, U.expression), U.identifier(
            A.name,
            U.expensiveChecks || qd(A.name),
            k,
            L,
            U.expression
          );
        case At.MemberExpression:
          return I = this.recurse(A.object, !1, !!L), A.computed || (vl(A.property.name, U.expression), B = A.property.name), A.computed && (B = this.recurse(A.property)), A.computed ? this.computedMember(I, B, k, L, U.expression) : this.nonComputedMember(I, B, U.expensiveChecks, k, L, U.expression);
        case At.CallExpression:
          return j = [], T(A.arguments, function(H) {
            j.push(U.recurse(H));
          }), A.filter && (B = this.$filter(A.callee.name)), A.filter || (B = this.recurse(A.callee, !0)), A.filter ? function(H, W, X, Z) {
            for (var fe = [], he = 0; he < j.length; ++he)
              fe.push(j[he](H, W, X, Z));
            var ye = B.apply(i, fe, Z);
            return k ? { context: i, name: i, value: ye } : ye;
          } : function(H, W, X, Z) {
            var fe = B(H, W, X, Z), he;
            if (fe.value != null) {
              Bo(fe.context, U.expression), L0(fe.value, U.expression);
              for (var ye = [], Se = 0; Se < j.length; ++Se)
                ye.push(Bo(j[Se](H, W, X, Z), U.expression));
              he = Bo(fe.value.apply(fe.context, ye), U.expression);
            }
            return k ? { value: he } : he;
          };
        case At.AssignmentExpression:
          return I = this.recurse(A.left, !0, 1), B = this.recurse(A.right), function(H, W, X, Z) {
            var fe = I(H, W, X, Z), he = B(H, W, X, Z);
            return Bo(fe.value, U.expression), Hd(fe.context), fe.context[fe.name] = he, k ? { value: he } : he;
          };
        case At.ArrayExpression:
          return j = [], T(A.elements, function(H) {
            j.push(U.recurse(H));
          }), function(H, W, X, Z) {
            for (var fe = [], he = 0; he < j.length; ++he)
              fe.push(j[he](H, W, X, Z));
            return k ? { value: fe } : fe;
          };
        case At.ObjectExpression:
          return j = [], T(A.properties, function(H) {
            j.push({
              key: H.key.type === At.Identifier ? H.key.name : "" + H.key.value,
              value: U.recurse(H.value)
            });
          }), function(H, W, X, Z) {
            for (var fe = {}, he = 0; he < j.length; ++he)
              fe[j[he].key] = j[he].value(H, W, X, Z);
            return k ? { value: fe } : fe;
          };
        case At.ThisExpression:
          return function(H) {
            return k ? { value: H } : H;
          };
        case At.NGValueParameter:
          return function(H, W, X, Z) {
            return k ? { value: X } : X;
          };
      }
    },
    "unary+": function(A, k) {
      return function(L, I, B, U) {
        var j = A(L, I, B, U);
        return ee(j) ? j = +j : j = 0, k ? { value: j } : j;
      };
    },
    "unary-": function(A, k) {
      return function(L, I, B, U) {
        var j = A(L, I, B, U);
        return ee(j) ? j = -j : j = 0, k ? { value: j } : j;
      };
    },
    "unary!": function(A, k) {
      return function(L, I, B, U) {
        var j = !A(L, I, B, U);
        return k ? { value: j } : j;
      };
    },
    "binary+": function(A, k, L) {
      return function(I, B, U, j) {
        var H = A(I, B, U, j), W = k(I, B, U, j), X = I0(H, W);
        return L ? { value: X } : X;
      };
    },
    "binary-": function(A, k, L) {
      return function(I, B, U, j) {
        var H = A(I, B, U, j), W = k(I, B, U, j), X = (ee(H) ? H : 0) - (ee(W) ? W : 0);
        return L ? { value: X } : X;
      };
    },
    "binary*": function(A, k, L) {
      return function(I, B, U, j) {
        var H = A(I, B, U, j) * k(I, B, U, j);
        return L ? { value: H } : H;
      };
    },
    "binary/": function(A, k, L) {
      return function(I, B, U, j) {
        var H = A(I, B, U, j) / k(I, B, U, j);
        return L ? { value: H } : H;
      };
    },
    "binary%": function(A, k, L) {
      return function(I, B, U, j) {
        var H = A(I, B, U, j) % k(I, B, U, j);
        return L ? { value: H } : H;
      };
    },
    "binary===": function(A, k, L) {
      return function(I, B, U, j) {
        var H = A(I, B, U, j) === k(I, B, U, j);
        return L ? { value: H } : H;
      };
    },
    "binary!==": function(A, k, L) {
      return function(I, B, U, j) {
        var H = A(I, B, U, j) !== k(I, B, U, j);
        return L ? { value: H } : H;
      };
    },
    "binary==": function(A, k, L) {
      return function(I, B, U, j) {
        var H = A(I, B, U, j) == k(I, B, U, j);
        return L ? { value: H } : H;
      };
    },
    "binary!=": function(A, k, L) {
      return function(I, B, U, j) {
        var H = A(I, B, U, j) != k(I, B, U, j);
        return L ? { value: H } : H;
      };
    },
    "binary<": function(A, k, L) {
      return function(I, B, U, j) {
        var H = A(I, B, U, j) < k(I, B, U, j);
        return L ? { value: H } : H;
      };
    },
    "binary>": function(A, k, L) {
      return function(I, B, U, j) {
        var H = A(I, B, U, j) > k(I, B, U, j);
        return L ? { value: H } : H;
      };
    },
    "binary<=": function(A, k, L) {
      return function(I, B, U, j) {
        var H = A(I, B, U, j) <= k(I, B, U, j);
        return L ? { value: H } : H;
      };
    },
    "binary>=": function(A, k, L) {
      return function(I, B, U, j) {
        var H = A(I, B, U, j) >= k(I, B, U, j);
        return L ? { value: H } : H;
      };
    },
    "binary&&": function(A, k, L) {
      return function(I, B, U, j) {
        var H = A(I, B, U, j) && k(I, B, U, j);
        return L ? { value: H } : H;
      };
    },
    "binary||": function(A, k, L) {
      return function(I, B, U, j) {
        var H = A(I, B, U, j) || k(I, B, U, j);
        return L ? { value: H } : H;
      };
    },
    "ternary?:": function(A, k, L, I) {
      return function(B, U, j, H) {
        var W = A(B, U, j, H) ? k(B, U, j, H) : L(B, U, j, H);
        return I ? { value: W } : W;
      };
    },
    value: function(A, k) {
      return function() {
        return k ? { context: i, name: i, value: A } : A;
      };
    },
    identifier: function(A, k, L, I, B) {
      return function(U, j, H, W) {
        var X = j && A in j ? j : U;
        I && I !== 1 && X && !X[A] && (X[A] = {});
        var Z = X ? X[A] : i;
        return k && Bo(Z, B), L ? { context: X, name: A, value: Z } : Z;
      };
    },
    computedMember: function(A, k, L, I, B) {
      return function(U, j, H, W) {
        var X = A(U, j, H, W), Z, fe;
        return X != null && (Z = k(U, j, H, W), Z = O0(Z), vl(Z, B), I && I !== 1 && (Hd(X), X && !X[Z] && (X[Z] = {})), fe = X[Z], Bo(fe, B)), L ? { context: X, name: Z, value: fe } : fe;
      };
    },
    nonComputedMember: function(A, k, L, I, B, U) {
      return function(j, H, W, X) {
        var Z = A(j, H, W, X);
        B && B !== 1 && (Hd(Z), Z && !Z[k] && (Z[k] = {}));
        var fe = Z != null ? Z[k] : i;
        return (L || qd(k)) && Bo(fe, U), I ? { context: Z, name: k, value: fe } : fe;
      };
    },
    inputs: function(A, k) {
      return function(L, I, B, U) {
        return U ? U[k] : A(L, I, B);
      };
    }
  };
  var fp = function(A, k, L) {
    this.lexer = A, this.$filter = k, this.options = L, this.ast = new At(this.lexer), this.astCompiler = L.csp ? new G0(this.ast, k) : new $0(this.ast, k);
  };
  fp.prototype = {
    constructor: fp,
    parse: function(A) {
      return this.astCompiler.compile(A, this.options.expensiveChecks);
    }
  };
  function qd(A) {
    return A == "constructor";
  }
  var JA = Object.prototype.valueOf;
  function hp(A) {
    return Ze(A.valueOf) ? A.valueOf() : JA.call(A);
  }
  function QA() {
    var A = xi(), k = xi();
    this.$get = ["$filter", function(L) {
      var I = ci().noUnsafeEval, B = {
        csp: I,
        expensiveChecks: !1
      }, U = {
        csp: I,
        expensiveChecks: !0
      }, j = !1;
      return H.$$runningExpensiveChecks = function() {
        return j;
      }, H;
      function H(Pe, be, Te) {
        var _e, Ie, De;
        switch (Te = Te || j, typeof Pe) {
          case "string":
            Pe = Pe.trim(), De = Pe;
            var Re = Te ? k : A;
            if (_e = Re[De], !_e) {
              Pe.charAt(0) === ":" && Pe.charAt(1) === ":" && (Ie = !0, Pe = Pe.substring(2));
              var qe = Te ? U : B, Oe = new dp(qe), rt = new fp(Oe, L, qe);
              _e = rt.parse(Pe), _e.constant ? _e.$$watchDelegate = ye : Ie ? _e.$$watchDelegate = _e.literal ? he : fe : _e.inputs && (_e.$$watchDelegate = Z), Te && (_e = W(_e)), Re[De] = _e;
            }
            return Se(_e, be);
          case "function":
            return Se(Pe, be);
          default:
            return Se(G, be);
        }
      }
      function W(Pe) {
        if (!Pe)
          return Pe;
        Te.$$watchDelegate = Pe.$$watchDelegate, Te.assign = W(Pe.assign), Te.constant = Pe.constant, Te.literal = Pe.literal;
        for (var be = 0; Pe.inputs && be < Pe.inputs.length; ++be)
          Pe.inputs[be] = W(Pe.inputs[be]);
        return Te.inputs = Pe.inputs, Te;
        function Te(_e, Ie, De, Re) {
          var qe = j;
          j = !0;
          try {
            return Pe(_e, Ie, De, Re);
          } finally {
            j = qe;
          }
        }
      }
      function X(Pe, be) {
        return Pe == null || be == null ? Pe === be : typeof Pe == "object" && (Pe = hp(Pe), typeof Pe == "object") ? !1 : Pe === be || Pe !== Pe && be !== be;
      }
      function Z(Pe, be, Te, _e, Ie) {
        var De = _e.inputs, Re;
        if (De.length === 1) {
          var qe = X;
          return De = De[0], Pe.$watch(function(tt) {
            var dt = De(tt);
            return X(dt, qe) || (Re = _e(tt, i, i, [dt]), qe = dt && hp(dt)), Re;
          }, be, Te, Ie);
        }
        for (var Oe = [], rt = [], Xe = 0, Je = De.length; Xe < Je; Xe++)
          Oe[Xe] = X, rt[Xe] = null;
        return Pe.$watch(function(tt) {
          for (var dt = !1, Ye = 0, it = De.length; Ye < it; Ye++) {
            var wt = De[Ye](tt);
            (dt || (dt = !X(wt, Oe[Ye]))) && (rt[Ye] = wt, Oe[Ye] = wt && hp(wt));
          }
          return dt && (Re = _e(tt, i, i, rt)), Re;
        }, be, Te, Ie);
      }
      function fe(Pe, be, Te, _e) {
        var Ie, De;
        return Ie = Pe.$watch(function(qe) {
          return _e(qe);
        }, function(qe, Oe, rt) {
          De = qe, Ze(be) && be.apply(this, arguments), ee(qe) && rt.$$postDigest(function() {
            ee(De) && Ie();
          });
        }, Te);
      }
      function he(Pe, be, Te, _e) {
        var Ie, De;
        return Ie = Pe.$watch(function(Oe) {
          return _e(Oe);
        }, function(Oe, rt, Xe) {
          De = Oe, Ze(be) && be.call(this, Oe, rt, Xe), Re(Oe) && Xe.$$postDigest(function() {
            Re(De) && Ie();
          });
        }, Te);
        function Re(qe) {
          var Oe = !0;
          return T(qe, function(rt) {
            ee(rt) || (Oe = !1);
          }), Oe;
        }
      }
      function ye(Pe, be, Te, _e) {
        var Ie;
        return Ie = Pe.$watch(function(Re) {
          return _e(Re);
        }, function(Re, qe, Oe) {
          Ze(be) && be.apply(this, arguments), Ie();
        }, Te);
      }
      function Se(Pe, be) {
        if (!be)
          return Pe;
        var Te = Pe.$$watchDelegate, _e = !1, Ie = Te !== he && Te !== fe, De = Ie ? function(qe, Oe, rt, Xe) {
          var Je = _e && Xe ? Xe[0] : Pe(qe, Oe, rt, Xe);
          return be(Je, qe, Oe);
        } : function(qe, Oe, rt, Xe) {
          var Je = Pe(qe, Oe, rt, Xe), Qe = be(Je, qe, Oe);
          return ee(Je) ? Qe : Je;
        };
        return Pe.$$watchDelegate && Pe.$$watchDelegate !== Z ? De.$$watchDelegate = Pe.$$watchDelegate : be.$stateful || (De.$$watchDelegate = Z, _e = !Pe.inputs, De.inputs = Pe.inputs ? Pe.inputs : [Pe]), De;
      }
    }];
  }
  function ZA() {
    this.$get = ["$rootScope", "$exceptionHandler", function(A, k) {
      return H0(function(L) {
        A.$evalAsync(L);
      }, k);
    }];
  }
  function ew() {
    this.$get = ["$browser", "$exceptionHandler", function(A, k) {
      return H0(function(L) {
        A.defer(L);
      }, k);
    }];
  }
  function H0(A, k) {
    var L = t("$q", TypeError);
    function I(Te, _e, Ie) {
      var De = !1;
      function Re(qe) {
        return function(Oe) {
          De || (De = !0, qe.call(Te, Oe));
        };
      }
      return [Re(_e), Re(Ie)];
    }
    var B = function() {
      return new X();
    };
    function U() {
      this.$$state = { status: 0 };
    }
    $(U.prototype, {
      then: function(Te, _e, Ie) {
        if (ce(Te) && ce(_e) && ce(Ie))
          return this;
        var De = new X();
        return this.$$state.pending = this.$$state.pending || [], this.$$state.pending.push([De, Te, _e, Ie]), this.$$state.status > 0 && W(this.$$state), De.promise;
      },
      catch: function(Te) {
        return this.then(null, Te);
      },
      finally: function(Te, _e) {
        return this.then(function(Ie) {
          return he(Ie, !0, Te);
        }, function(Ie) {
          return he(Ie, !1, Te);
        }, _e);
      }
    });
    function j(Te, _e) {
      return function(Ie) {
        _e.call(Te, Ie);
      };
    }
    function H(Te) {
      var _e, Ie, De;
      De = Te.pending, Te.processScheduled = !1, Te.pending = i;
      for (var Re = 0, qe = De.length; Re < qe; ++Re) {
        Ie = De[Re][0], _e = De[Re][Te.status];
        try {
          Ze(_e) ? Ie.resolve(_e(Te.value)) : Te.status === 1 ? Ie.resolve(Te.value) : Ie.reject(Te.value);
        } catch (Oe) {
          Ie.reject(Oe), k(Oe);
        }
      }
    }
    function W(Te) {
      Te.processScheduled || !Te.pending || (Te.processScheduled = !0, A(function() {
        H(Te);
      }));
    }
    function X() {
      this.promise = new U(), this.resolve = j(this, this.resolve), this.reject = j(this, this.reject), this.notify = j(this, this.notify);
    }
    $(X.prototype, {
      resolve: function(Te) {
        this.promise.$$state.status || (Te === this.promise ? this.$$reject(L(
          "qcycle",
          "Expected promise to be resolved with value other than itself '{0}'",
          Te
        )) : this.$$resolve(Te));
      },
      $$resolve: function(Te) {
        var _e, Ie;
        Ie = I(this, this.$$resolve, this.$$reject);
        try {
          (me(Te) || Ze(Te)) && (_e = Te && Te.then), Ze(_e) ? (this.promise.$$state.status = -1, _e.call(Te, Ie[0], Ie[1], this.notify)) : (this.promise.$$state.value = Te, this.promise.$$state.status = 1, W(this.promise.$$state));
        } catch (De) {
          Ie[1](De), k(De);
        }
      },
      reject: function(Te) {
        this.promise.$$state.status || this.$$reject(Te);
      },
      $$reject: function(Te) {
        this.promise.$$state.value = Te, this.promise.$$state.status = 2, W(this.promise.$$state);
      },
      notify: function(Te) {
        var _e = this.promise.$$state.pending;
        this.promise.$$state.status <= 0 && _e && _e.length && A(function() {
          for (var Ie, De, Re = 0, qe = _e.length; Re < qe; Re++) {
            De = _e[Re][0], Ie = _e[Re][3];
            try {
              De.notify(Ze(Ie) ? Ie(Te) : Te);
            } catch (Oe) {
              k(Oe);
            }
          }
        });
      }
    });
    var Z = function(Te) {
      var _e = new X();
      return _e.reject(Te), _e.promise;
    }, fe = function(_e, Ie) {
      var De = new X();
      return Ie ? De.resolve(_e) : De.reject(_e), De.promise;
    }, he = function(_e, Ie, De) {
      var Re = null;
      try {
        Ze(De) && (Re = De());
      } catch (qe) {
        return fe(qe, !1);
      }
      return Pt(Re) ? Re.then(function() {
        return fe(_e, Ie);
      }, function(qe) {
        return fe(qe, !1);
      }) : fe(_e, Ie);
    }, ye = function(Te, _e, Ie, De) {
      var Re = new X();
      return Re.resolve(Te), Re.promise.then(_e, Ie, De);
    }, Se = ye;
    function Pe(Te) {
      var _e = new X(), Ie = 0, De = $e(Te) ? [] : {};
      return T(Te, function(Re, qe) {
        Ie++, ye(Re).then(function(Oe) {
          De.hasOwnProperty(qe) || (De[qe] = Oe, --Ie || _e.resolve(De));
        }, function(Oe) {
          De.hasOwnProperty(qe) || _e.reject(Oe);
        });
      }), Ie === 0 && _e.resolve(De), _e.promise;
    }
    var be = function Te(_e) {
      if (!Ze(_e))
        throw L("norslvr", "Expected resolverFn, got '{0}'", _e);
      if (!(this instanceof Te))
        return new Te(_e);
      var Ie = new X();
      function De(qe) {
        Ie.resolve(qe);
      }
      function Re(qe) {
        Ie.reject(qe);
      }
      return _e(De, Re), Ie.promise;
    };
    return be.defer = B, be.reject = Z, be.when = ye, be.resolve = Se, be.all = Pe, be;
  }
  function tw() {
    this.$get = ["$window", "$timeout", function(A, k) {
      var L = A.requestAnimationFrame || A.webkitRequestAnimationFrame, I = A.cancelAnimationFrame || A.webkitCancelAnimationFrame || A.webkitCancelRequestAnimationFrame, B = !!L, U = B ? function(j) {
        var H = L(j);
        return function() {
          I(H);
        };
      } : function(j) {
        var H = k(j, 16.66, !1);
        return function() {
          k.cancel(H);
        };
      };
      return U.supported = B, U;
    }];
  }
  function rw() {
    var A = 10, k = t("$rootScope"), L = null, I = null;
    this.digestTtl = function(U) {
      return arguments.length && (A = U), A;
    };
    function B(U) {
      function j() {
        this.$$watchers = this.$$nextSibling = this.$$childHead = this.$$childTail = null, this.$$listeners = {}, this.$$listenerCount = {}, this.$$watchersCount = 0, this.$id = R(), this.$$ChildScope = null;
      }
      return j.prototype = U, j;
    }
    this.$get = [
      "$injector",
      "$exceptionHandler",
      "$parse",
      "$browser",
      function(U, j, H, W) {
        function X(Oe) {
          Oe.currentScope.$$destroyed = !0;
        }
        function Z(Oe) {
          c === 9 && (Oe.$$childHead && Z(Oe.$$childHead), Oe.$$nextSibling && Z(Oe.$$nextSibling)), Oe.$parent = Oe.$$nextSibling = Oe.$$prevSibling = Oe.$$childHead = Oe.$$childTail = Oe.$root = Oe.$$watchers = null;
        }
        function fe() {
          this.$id = R(), this.$$phase = this.$parent = this.$$watchers = this.$$nextSibling = this.$$prevSibling = this.$$childHead = this.$$childTail = null, this.$root = this, this.$$destroyed = !1, this.$$listeners = {}, this.$$listenerCount = {}, this.$$watchersCount = 0, this.$$isolateBindings = null;
        }
        fe.prototype = {
          constructor: fe,
          $new: function(Oe, rt) {
            var Xe;
            return rt = rt || this, Oe ? (Xe = new fe(), Xe.$root = this.$root) : (this.$$ChildScope || (this.$$ChildScope = B(this)), Xe = new this.$$ChildScope()), Xe.$parent = rt, Xe.$$prevSibling = rt.$$childTail, rt.$$childHead ? (rt.$$childTail.$$nextSibling = Xe, rt.$$childTail = Xe) : rt.$$childHead = rt.$$childTail = Xe, (Oe || rt != this) && Xe.$on("$destroy", X), Xe;
          },
          $watch: function(Oe, rt, Xe, Je) {
            var Qe = H(Oe);
            if (Qe.$$watchDelegate)
              return Qe.$$watchDelegate(this, rt, Xe, Qe, Oe);
            var tt = this, dt = tt.$$watchers, Ye = {
              fn: rt,
              last: De,
              get: Qe,
              exp: Je || Oe,
              eq: !!Xe
            };
            return L = null, Ze(rt) || (Ye.fn = G), dt || (dt = tt.$$watchers = []), dt.unshift(Ye), _e(this, 1), function() {
              xr(dt, Ye) >= 0 && _e(tt, -1), L = null;
            };
          },
          $watchGroup: function(Oe, rt) {
            var Xe = new Array(Oe.length), Je = new Array(Oe.length), Qe = [], tt = this, dt = !1, Ye = !0;
            if (!Oe.length) {
              var it = !0;
              return tt.$evalAsync(function() {
                it && rt(Je, Je, tt);
              }), function() {
                it = !1;
              };
            }
            if (Oe.length === 1)
              return this.$watch(Oe[0], function(yr, Lr, Hr) {
                Je[0] = yr, Xe[0] = Lr, rt(Je, yr === Lr ? Je : Xe, Hr);
              });
            T(Oe, function(Ct, yr) {
              var Lr = tt.$watch(Ct, function(di, Jr) {
                Je[yr] = di, Xe[yr] = Jr, dt || (dt = !0, tt.$evalAsync(wt));
              });
              Qe.push(Lr);
            });
            function wt() {
              dt = !1, Ye ? (Ye = !1, rt(Je, Je, tt)) : rt(Je, Xe, tt);
            }
            return function() {
              for (; Qe.length; )
                Qe.shift()();
            };
          },
          $watchCollection: function(Oe, rt) {
            Hr.$stateful = !0;
            var Xe = this, Je, Qe, tt, dt = rt.length > 1, Ye = 0, it = H(Oe, Hr), wt = [], Ct = {}, yr = !0, Lr = 0;
            function Hr(Jr) {
              Je = Jr;
              var ii, Li, cn, Gi, Ii;
              if (!ce(Je)) {
                if (!me(Je))
                  Qe !== Je && (Qe = Je, Ye++);
                else if (S(Je)) {
                  Qe !== wt && (Qe = wt, Lr = Qe.length = 0, Ye++), ii = Je.length, Lr !== ii && (Ye++, Qe.length = Lr = ii);
                  for (var Di = 0; Di < ii; Di++)
                    Ii = Qe[Di], Gi = Je[Di], cn = Ii !== Ii && Gi !== Gi, !cn && Ii !== Gi && (Ye++, Qe[Di] = Gi);
                } else {
                  Qe !== Ct && (Qe = Ct = {}, Lr = 0, Ye++), ii = 0;
                  for (Li in Je)
                    o.call(Je, Li) && (ii++, Gi = Je[Li], Ii = Qe[Li], Li in Qe ? (cn = Ii !== Ii && Gi !== Gi, !cn && Ii !== Gi && (Ye++, Qe[Li] = Gi)) : (Lr++, Qe[Li] = Gi, Ye++));
                  if (Lr > ii) {
                    Ye++;
                    for (Li in Qe)
                      o.call(Je, Li) || (Lr--, delete Qe[Li]);
                  }
                }
                return Ye;
              }
            }
            function di() {
              if (yr ? (yr = !1, rt(Je, Je, Xe)) : rt(Je, tt, Xe), dt)
                if (!me(Je))
                  tt = Je;
                else if (S(Je)) {
                  tt = new Array(Je.length);
                  for (var Jr = 0; Jr < Je.length; Jr++)
                    tt[Jr] = Je[Jr];
                } else {
                  tt = {};
                  for (var ii in Je)
                    o.call(Je, ii) && (tt[ii] = Je[ii]);
                }
            }
            return this.$watch(it, di);
          },
          $digest: function() {
            var Oe, rt, Xe, Je, Qe, tt, dt, Ye, it = A, wt, Ct, yr = this, Lr = [], Hr, di;
            be("$digest"), W.$$checkUrlChange(), this === he && I !== null && (W.defer.cancel(I), Re()), L = null;
            do {
              for (Ye = !1, Ct = yr; ye.length; ) {
                try {
                  di = ye.shift(), di.scope.$eval(di.expression, di.locals);
                } catch (Jr) {
                  j(Jr);
                }
                L = null;
              }
              e:
                do {
                  if (tt = Ct.$$watchers)
                    for (dt = tt.length; dt--; )
                      try {
                        if (Oe = tt[dt], Oe) {
                          if (Qe = Oe.get, (rt = Qe(Ct)) !== (Xe = Oe.last) && !(Oe.eq ? li(rt, Xe) : typeof rt == "number" && typeof Xe == "number" && isNaN(rt) && isNaN(Xe)))
                            Ye = !0, L = Oe, Oe.last = Oe.eq ? _i(rt, null) : rt, Je = Oe.fn, Je(rt, Xe === De ? rt : Xe, Ct), it < 5 && (Hr = 4 - it, Lr[Hr] || (Lr[Hr] = []), Lr[Hr].push({
                              msg: Ze(Oe.exp) ? "fn: " + (Oe.exp.name || Oe.exp.toString()) : Oe.exp,
                              newVal: rt,
                              oldVal: Xe
                            }));
                          else if (Oe === L) {
                            Ye = !1;
                            break e;
                          }
                        }
                      } catch (Jr) {
                        j(Jr);
                      }
                  if (!(wt = Ct.$$watchersCount && Ct.$$childHead || Ct !== yr && Ct.$$nextSibling))
                    for (; Ct !== yr && !(wt = Ct.$$nextSibling); )
                      Ct = Ct.$parent;
                } while (Ct = wt);
              if ((Ye || ye.length) && !it--)
                throw Te(), k(
                  "infdig",
                  `{0} $digest() iterations reached. Aborting!
Watchers fired in the last 5 iterations: {1}`,
                  A,
                  Lr
                );
            } while (Ye || ye.length);
            for (Te(); Se.length; )
              try {
                Se.shift()();
              } catch (Jr) {
                j(Jr);
              }
          },
          $destroy: function() {
            if (!this.$$destroyed) {
              var Oe = this.$parent;
              this.$broadcast("$destroy"), this.$$destroyed = !0, this === he && W.$$applicationDestroyed(), _e(this, -this.$$watchersCount);
              for (var rt in this.$$listenerCount)
                Ie(this, this.$$listenerCount[rt], rt);
              Oe && Oe.$$childHead == this && (Oe.$$childHead = this.$$nextSibling), Oe && Oe.$$childTail == this && (Oe.$$childTail = this.$$prevSibling), this.$$prevSibling && (this.$$prevSibling.$$nextSibling = this.$$nextSibling), this.$$nextSibling && (this.$$nextSibling.$$prevSibling = this.$$prevSibling), this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = G, this.$on = this.$watch = this.$watchGroup = function() {
                return G;
              }, this.$$listeners = {}, this.$$nextSibling = null, Z(this);
            }
          },
          $eval: function(Oe, rt) {
            return H(Oe)(this, rt);
          },
          $evalAsync: function(Oe, rt) {
            !he.$$phase && !ye.length && W.defer(function() {
              ye.length && he.$digest();
            }), ye.push({ scope: this, expression: H(Oe), locals: rt });
          },
          $$postDigest: function(Oe) {
            Se.push(Oe);
          },
          $apply: function(Oe) {
            try {
              be("$apply");
              try {
                return this.$eval(Oe);
              } finally {
                Te();
              }
            } catch (rt) {
              j(rt);
            } finally {
              try {
                he.$digest();
              } catch (rt) {
                throw j(rt), rt;
              }
            }
          },
          $applyAsync: function(Oe) {
            var rt = this;
            Oe && Pe.push(Xe), Oe = H(Oe), qe();
            function Xe() {
              rt.$eval(Oe);
            }
          },
          $on: function(Oe, rt) {
            var Xe = this.$$listeners[Oe];
            Xe || (this.$$listeners[Oe] = Xe = []), Xe.push(rt);
            var Je = this;
            do
              Je.$$listenerCount[Oe] || (Je.$$listenerCount[Oe] = 0), Je.$$listenerCount[Oe]++;
            while (Je = Je.$parent);
            var Qe = this;
            return function() {
              var tt = Xe.indexOf(rt);
              tt !== -1 && (Xe[tt] = null, Ie(Qe, 1, Oe));
            };
          },
          $emit: function(Oe, rt) {
            var Xe = [], Je, Qe = this, tt = !1, dt = {
              name: Oe,
              targetScope: Qe,
              stopPropagation: function() {
                tt = !0;
              },
              preventDefault: function() {
                dt.defaultPrevented = !0;
              },
              defaultPrevented: !1
            }, Ye = Kr([dt], arguments, 1), it, wt;
            do {
              for (Je = Qe.$$listeners[Oe] || Xe, dt.currentScope = Qe, it = 0, wt = Je.length; it < wt; it++) {
                if (!Je[it]) {
                  Je.splice(it, 1), it--, wt--;
                  continue;
                }
                try {
                  Je[it].apply(null, Ye);
                } catch (Ct) {
                  j(Ct);
                }
              }
              if (tt)
                return dt.currentScope = null, dt;
              Qe = Qe.$parent;
            } while (Qe);
            return dt.currentScope = null, dt;
          },
          $broadcast: function(Oe, rt) {
            var Xe = this, Je = Xe, Qe = Xe, tt = {
              name: Oe,
              targetScope: Xe,
              preventDefault: function() {
                tt.defaultPrevented = !0;
              },
              defaultPrevented: !1
            };
            if (!Xe.$$listenerCount[Oe])
              return tt;
            for (var dt = Kr([tt], arguments, 1), Ye, it, wt; Je = Qe; ) {
              for (tt.currentScope = Je, Ye = Je.$$listeners[Oe] || [], it = 0, wt = Ye.length; it < wt; it++) {
                if (!Ye[it]) {
                  Ye.splice(it, 1), it--, wt--;
                  continue;
                }
                try {
                  Ye[it].apply(null, dt);
                } catch (Ct) {
                  j(Ct);
                }
              }
              if (!(Qe = Je.$$listenerCount[Oe] && Je.$$childHead || Je !== Xe && Je.$$nextSibling))
                for (; Je !== Xe && !(Qe = Je.$$nextSibling); )
                  Je = Je.$parent;
            }
            return tt.currentScope = null, tt;
          }
        };
        var he = new fe(), ye = he.$$asyncQueue = [], Se = he.$$postDigestQueue = [], Pe = he.$$applyAsyncQueue = [];
        return he;
        function be(Oe) {
          if (he.$$phase)
            throw k("inprog", "{0} already in progress", he.$$phase);
          he.$$phase = Oe;
        }
        function Te() {
          he.$$phase = null;
        }
        function _e(Oe, rt) {
          do
            Oe.$$watchersCount += rt;
          while (Oe = Oe.$parent);
        }
        function Ie(Oe, rt, Xe) {
          do
            Oe.$$listenerCount[Xe] -= rt, Oe.$$listenerCount[Xe] === 0 && delete Oe.$$listenerCount[Xe];
          while (Oe = Oe.$parent);
        }
        function De() {
        }
        function Re() {
          for (; Pe.length; )
            try {
              Pe.shift()();
            } catch (Oe) {
              j(Oe);
            }
          I = null;
        }
        function qe() {
          I === null && (I = W.defer(function() {
            he.$apply(Re);
          }));
        }
      }
    ];
  }
  function iw() {
    var A = /^\s*(https?|ftp|mailto|tel|file):/, k = /^\s*((https?|ftp|file|blob):|data:image\/)/;
    this.aHrefSanitizationWhitelist = function(L) {
      return ee(L) ? (A = L, this) : A;
    }, this.imgSrcSanitizationWhitelist = function(L) {
      return ee(L) ? (k = L, this) : k;
    }, this.$get = function() {
      return function(I, B) {
        var U = B ? k : A, j;
        return j = $o(I).href, j !== "" && !j.match(U) ? "unsafe:" + j : I;
      };
    };
  }
  var jo = t("$sce"), is = {
    HTML: "html",
    CSS: "css",
    URL: "url",
    RESOURCE_URL: "resourceUrl",
    JS: "js"
  };
  function nw(A) {
    if (A === "self")
      return A;
    if (Ne(A)) {
      if (A.indexOf("***") > -1)
        throw jo(
          "iwcard",
          "Illegal sequence *** in string matcher.  String: {0}",
          A
        );
      return A = sr(A).replace("\\*\\*", ".*").replace("\\*", "[^:/.?&;]*"), new RegExp("^" + A + "$");
    } else {
      if (Ut(A))
        return new RegExp("^" + A.source + "$");
      throw jo(
        "imatcher",
        'Matchers may only be "self", string patterns or RegExp objects'
      );
    }
  }
  function V0(A) {
    var k = [];
    return ee(A) && T(A, function(L) {
      k.push(nw(L));
    }), k;
  }
  function aw() {
    this.SCE_CONTEXTS = is;
    var A = ["self"], k = [];
    this.resourceUrlWhitelist = function(L) {
      return arguments.length && (A = V0(L)), A;
    }, this.resourceUrlBlacklist = function(L) {
      return arguments.length && (k = V0(L)), k;
    }, this.$get = ["$injector", function(L) {
      var I = function(ye) {
        throw jo("unsafe", "Attempting to use an unsafe value in a safe context.");
      };
      L.has("$sanitize") && (I = L.get("$sanitize"));
      function B(he, ye) {
        return he === "self" ? W0(ye) : !!he.exec(ye.href);
      }
      function U(he) {
        var ye = $o(he.toString()), Se, Pe, be = !1;
        for (Se = 0, Pe = A.length; Se < Pe; Se++)
          if (B(A[Se], ye)) {
            be = !0;
            break;
          }
        if (be) {
          for (Se = 0, Pe = k.length; Se < Pe; Se++)
            if (B(k[Se], ye)) {
              be = !1;
              break;
            }
        }
        return be;
      }
      function j(he) {
        var ye = function(Pe) {
          this.$$unwrapTrustedValue = function() {
            return Pe;
          };
        };
        return he && (ye.prototype = new he()), ye.prototype.valueOf = function() {
          return this.$$unwrapTrustedValue();
        }, ye.prototype.toString = function() {
          return this.$$unwrapTrustedValue().toString();
        }, ye;
      }
      var H = j(), W = {};
      W[is.HTML] = j(H), W[is.CSS] = j(H), W[is.URL] = j(H), W[is.JS] = j(H), W[is.RESOURCE_URL] = j(W[is.URL]);
      function X(he, ye) {
        var Se = W.hasOwnProperty(he) ? W[he] : null;
        if (!Se)
          throw jo(
            "icontext",
            "Attempted to trust a value in invalid context. Context: {0}; Value: {1}",
            he,
            ye
          );
        if (ye === null || ce(ye) || ye === "")
          return ye;
        if (typeof ye != "string")
          throw jo(
            "itype",
            "Attempted to trust a non-string value in a content requiring a string: Context: {0}",
            he
          );
        return new Se(ye);
      }
      function Z(he) {
        return he instanceof H ? he.$$unwrapTrustedValue() : he;
      }
      function fe(he, ye) {
        if (ye === null || ce(ye) || ye === "")
          return ye;
        var Se = W.hasOwnProperty(he) ? W[he] : null;
        if (Se && ye instanceof Se)
          return ye.$$unwrapTrustedValue();
        if (he === is.RESOURCE_URL) {
          if (U(ye))
            return ye;
          throw jo(
            "insecurl",
            "Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}",
            ye.toString()
          );
        } else if (he === is.HTML)
          return I(ye);
        throw jo("unsafe", "Attempting to use an unsafe value in a safe context.");
      }
      return {
        trustAs: X,
        getTrusted: fe,
        valueOf: Z
      };
    }];
  }
  function sw() {
    var A = !0;
    this.enabled = function(k) {
      return arguments.length && (A = !!k), A;
    }, this.$get = ["$parse", "$sceDelegate", function(k, L) {
      if (A && c < 8)
        throw jo(
          "iequirks",
          "Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks mode.  You can fix this by adding the text <!doctype html> to the top of your HTML document.  See http://docs.angularjs.org/api/ng.$sce for more information."
        );
      var I = Gr(is);
      I.isEnabled = function() {
        return A;
      }, I.trustAs = L.trustAs, I.getTrusted = L.getTrusted, I.valueOf = L.valueOf, A || (I.trustAs = I.getTrusted = function(H, W) {
        return W;
      }, I.valueOf = K), I.parseAs = function(W, X) {
        var Z = k(X);
        return Z.literal && Z.constant ? Z : k(X, function(fe) {
          return I.getTrusted(W, fe);
        });
      };
      var B = I.parseAs, U = I.getTrusted, j = I.trustAs;
      return T(is, function(H, W) {
        var X = s(W);
        I[Me("parse_as_" + X)] = function(Z) {
          return B(H, Z);
        }, I[Me("get_trusted_" + X)] = function(Z) {
          return U(H, Z);
        }, I[Me("trust_as_" + X)] = function(Z) {
          return j(H, Z);
        };
      }), I;
    }];
  }
  function ow() {
    this.$get = ["$window", "$document", function(A, k) {
      var L = {}, I = M((/android (\d+)/.exec(s((A.navigator || {}).userAgent)) || [])[1]), B = /Boxee/i.test((A.navigator || {}).userAgent), U = k[0] || {}, j, H = /^(Moz|webkit|ms)(?=[A-Z])/, W = U.body && U.body.style, X = !1, Z = !1, fe;
      if (W) {
        for (var he in W)
          if (fe = H.exec(he)) {
            j = fe[0], j = j.substr(0, 1).toUpperCase() + j.substr(1);
            break;
          }
        j || (j = "WebkitOpacity" in W && "webkit"), X = "transition" in W || j + "Transition" in W, Z = "animation" in W || j + "Animation" in W, I && (!X || !Z) && (X = Ne(W.webkitTransition), Z = Ne(W.webkitAnimation));
      }
      return {
        history: !!(A.history && A.history.pushState && !(I < 4) && !B),
        hasEvent: function(ye) {
          if (ye === "input" && c <= 11)
            return !1;
          if (ce(L[ye])) {
            var Se = U.createElement("div");
            L[ye] = "on" + ye in Se;
          }
          return L[ye];
        },
        csp: ci(),
        vendorPrefix: j,
        transitions: X,
        animations: Z,
        android: I
      };
    }];
  }
  var Yn = t("$compile");
  function uw() {
    this.$get = ["$templateCache", "$http", "$q", "$sce", function(A, k, L, I) {
      function B(U, j) {
        B.totalPendingRequests++, (!Ne(U) || ce(A.get(U))) && (U = I.getTrustedResourceUrl(U));
        var H = k.defaults && k.defaults.transformResponse;
        $e(H) ? H = H.filter(function(Z) {
          return Z !== $t;
        }) : H === $t && (H = null);
        var W = {
          cache: A,
          transformResponse: H
        };
        return k.get(U, W).finally(function() {
          B.totalPendingRequests--;
        }).then(function(Z) {
          return A.put(U, Z.data), Z.data;
        }, X);
        function X(Z) {
          if (!j)
            throw Yn(
              "tpload",
              "Failed to load template: {0} (HTTP status: {1} {2})",
              U,
              Z.status,
              Z.statusText
            );
          return L.reject(Z);
        }
      }
      return B.totalPendingRequests = 0, B;
    }];
  }
  function lw() {
    this.$get = [
      "$rootScope",
      "$browser",
      "$location",
      function(A, k, L) {
        var I = {};
        return I.findBindings = function(B, U, j) {
          var H = B.getElementsByClassName("ng-binding"), W = [];
          return T(H, function(X) {
            var Z = E.element(X).data("$binding");
            Z && T(Z, function(fe) {
              if (j) {
                var he = new RegExp("(^|\\s)" + sr(U) + "(\\s|\\||$)");
                he.test(fe) && W.push(X);
              } else
                fe.indexOf(U) != -1 && W.push(X);
            });
          }), W;
        }, I.findModels = function(B, U, j) {
          for (var H = ["ng-", "data-ng-", "ng\\:"], W = 0; W < H.length; ++W) {
            var X = j ? "=" : "*=", Z = "[" + H[W] + "model" + X + '"' + U + '"]', fe = B.querySelectorAll(Z);
            if (fe.length)
              return fe;
          }
        }, I.getLocation = function() {
          return L.url();
        }, I.setLocation = function(B) {
          B !== L.url() && (L.url(B), A.$digest());
        }, I.whenStable = function(B) {
          k.notifyWhenNoOutstandingRequests(B);
        }, I;
      }
    ];
  }
  function cw() {
    this.$get = [
      "$rootScope",
      "$browser",
      "$q",
      "$$q",
      "$exceptionHandler",
      function(A, k, L, I, B) {
        var U = {};
        function j(H, W, X) {
          Ze(H) || (X = W, W = H, H = G);
          var Z = mn(arguments, 3), fe = ee(X) && !X, he = (fe ? I : L).defer(), ye = he.promise, Se;
          return Se = k.defer(function() {
            try {
              he.resolve(H.apply(null, Z));
            } catch (Pe) {
              he.reject(Pe), B(Pe);
            } finally {
              delete U[ye.$$timeoutId];
            }
            fe || A.$apply();
          }, W), ye.$$timeoutId = Se, U[Se] = he, ye;
        }
        return j.cancel = function(H) {
          return H && H.$$timeoutId in U ? (U[H.$$timeoutId].reject("canceled"), delete U[H.$$timeoutId], k.defer.cancel(H.$$timeoutId)) : !1;
        }, j;
      }
    ];
  }
  var kn = r.createElement("a"), q0 = $o(e.location.href);
  function $o(A) {
    var k = A;
    return c && (kn.setAttribute("href", k), k = kn.href), kn.setAttribute("href", k), {
      href: kn.href,
      protocol: kn.protocol ? kn.protocol.replace(/:$/, "") : "",
      host: kn.host,
      search: kn.search ? kn.search.replace(/^\?/, "") : "",
      hash: kn.hash ? kn.hash.replace(/^#/, "") : "",
      hostname: kn.hostname,
      port: kn.port,
      pathname: kn.pathname.charAt(0) === "/" ? kn.pathname : "/" + kn.pathname
    };
  }
  function W0(A) {
    var k = Ne(A) ? $o(A) : A;
    return k.protocol === q0.protocol && k.host === q0.host;
  }
  function dw() {
    this.$get = J(e);
  }
  function Y0(A) {
    var k = A[0] || {}, L = {}, I = "";
    function B(U) {
      try {
        return decodeURIComponent(U);
      } catch {
        return U;
      }
    }
    return function() {
      var U, j, H, W, X, Z = k.cookie || "";
      if (Z !== I)
        for (I = Z, U = I.split("; "), L = {}, H = 0; H < U.length; H++)
          j = U[H], W = j.indexOf("="), W > 0 && (X = B(j.substring(0, W)), ce(L[X]) && (L[X] = B(j.substring(W + 1))));
      return L;
    };
  }
  Y0.$inject = ["$document"];
  function fw() {
    this.$get = Y0;
  }
  K0.$inject = ["$provide"];
  function K0(A) {
    var k = "Filter";
    function L(I, B) {
      if (me(I)) {
        var U = {};
        return T(I, function(j, H) {
          U[H] = L(H, j);
        }), U;
      } else
        return A.factory(I + k, B);
    }
    this.register = L, this.$get = ["$injector", function(I) {
      return function(B) {
        return I.get(B + k);
      };
    }], L("currency", J0), L("date", ry), L("filter", hw), L("json", xw), L("limitTo", Cw), L("lowercase", Aw), L("number", Q0), L("orderBy", iy), L("uppercase", ww);
  }
  function hw() {
    return function(A, k, L) {
      if (!S(A)) {
        if (A == null)
          return A;
        throw t("filter")("notarray", "Expected array but received: {0}", A);
      }
      var I = pp(k), B, U;
      switch (I) {
        case "function":
          B = k;
          break;
        case "boolean":
        case "null":
        case "number":
        case "string":
          U = !0;
        case "object":
          B = pw(k, L, U);
          break;
        default:
          return A;
      }
      return Array.prototype.filter.call(A, B);
    };
  }
  function pw(A, k, L) {
    var I = me(A) && "$" in A, B;
    return k === !0 ? k = li : Ze(k) || (k = function(U, j) {
      return ce(U) ? !1 : U === null || j === null ? U === j : me(j) || me(U) && !ue(U) ? !1 : (U = s("" + U), j = s("" + j), U.indexOf(j) !== -1);
    }), B = function(U) {
      return I && !me(U) ? Su(U, A.$, k, !1) : Su(U, A, k, L);
    }, B;
  }
  function Su(A, k, L, I, B) {
    var U = pp(A), j = pp(k);
    if (j === "string" && k.charAt(0) === "!")
      return !Su(A, k.substring(1), L, I);
    if ($e(A))
      return A.some(function(fe) {
        return Su(fe, k, L, I);
      });
    switch (U) {
      case "object":
        var H;
        if (I) {
          for (H in A)
            if (H.charAt(0) !== "$" && Su(A[H], k, L, !0))
              return !0;
          return B ? !1 : Su(A, k, L, !1);
        } else if (j === "object") {
          for (H in k) {
            var W = k[H];
            if (!(Ze(W) || ce(W))) {
              var X = H === "$", Z = X ? A : A[H];
              if (!Su(Z, W, L, X, X))
                return !1;
            }
          }
          return !0;
        } else
          return L(A, k);
      case "function":
        return !1;
      default:
        return L(A, k);
    }
  }
  function pp(A) {
    return A === null ? "null" : typeof A;
  }
  var z0 = 22, X0 = ".", gp = "0";
  J0.$inject = ["$locale"];
  function J0(A) {
    var k = A.NUMBER_FORMATS;
    return function(L, I, B) {
      return ce(I) && (I = k.CURRENCY_SYM), ce(B) && (B = k.PATTERNS[1].maxFrac), L == null ? L : Z0(L, k.PATTERNS[1], k.GROUP_SEP, k.DECIMAL_SEP, B).replace(/\u00A4/g, I);
    };
  }
  Q0.$inject = ["$locale"];
  function Q0(A) {
    var k = A.NUMBER_FORMATS;
    return function(L, I) {
      return L == null ? L : Z0(
        L,
        k.PATTERNS[0],
        k.GROUP_SEP,
        k.DECIMAL_SEP,
        I
      );
    };
  }
  function gw(A) {
    var k = 0, L, I, B, U, j;
    for ((I = A.indexOf(X0)) > -1 && (A = A.replace(X0, "")), (B = A.search(/e/i)) > 0 ? (I < 0 && (I = B), I += +A.slice(B + 1), A = A.substring(0, B)) : I < 0 && (I = A.length), B = 0; A.charAt(B) == gp; B++)
      ;
    if (B == (j = A.length))
      L = [0], I = 1;
    else {
      for (j--; A.charAt(j) == gp; )
        j--;
      for (I -= B, L = [], U = 0; B <= j; B++, U++)
        L[U] = +A.charAt(B);
    }
    return I > z0 && (L = L.splice(0, z0 - 1), k = I - 1, I = 1), { d: L, e: k, i: I };
  }
  function vw(A, k, L, I) {
    var B = A.d, U = B.length - A.i;
    k = ce(k) ? Math.min(Math.max(L, U), I) : +k;
    var j = k + A.i, H = B[j];
    if (j > 0)
      B.splice(j);
    else {
      A.i = 1, B.length = j = k + 1;
      for (var W = 0; W < j; W++)
        B[W] = 0;
    }
    for (H >= 5 && B[j - 1]++; U < k; U++)
      B.push(0);
    var X = B.reduceRight(function(Z, fe, he, ye) {
      return fe = fe + Z, ye[he] = fe % 10, Math.floor(fe / 10);
    }, 0);
    X && (B.unshift(X), A.i++);
  }
  function Z0(A, k, L, I, B) {
    if (!(Ne(A) || ot(A)) || isNaN(A))
      return "";
    var U = !isFinite(A), j = !1, H = Math.abs(A) + "", W = "", X;
    if (U)
      W = "\u221E";
    else {
      X = gw(H), vw(X, B, k.minFrac, k.maxFrac);
      var Z = X.d, fe = X.i, he = X.e, ye = [];
      for (j = Z.reduce(function(Pe, be) {
        return Pe && !be;
      }, !0); fe < 0; )
        Z.unshift(0), fe++;
      fe > 0 ? ye = Z.splice(fe, Z.length) : (ye = Z, Z = [0]);
      var Se = [];
      for (Z.length >= k.lgSize && Se.unshift(Z.splice(-k.lgSize, Z.length).join("")); Z.length > k.gSize; )
        Se.unshift(Z.splice(-k.gSize, Z.length).join(""));
      Z.length && Se.unshift(Z.join("")), W = Se.join(L), ye.length && (W += I + ye.join("")), he && (W += "e+" + he);
    }
    return A < 0 && !j ? k.negPre + W + k.negSuf : k.posPre + W + k.posSuf;
  }
  function Wd(A, k, L) {
    var I = "";
    for (A < 0 && (I = "-", A = -A), A = "" + A; A.length < k; )
      A = gp + A;
    return L && (A = A.substr(A.length - k)), I + A;
  }
  function Rn(A, k, L, I) {
    return L = L || 0, function(B) {
      var U = B["get" + A]();
      return (L > 0 || U > -L) && (U += L), U === 0 && L == -12 && (U = 12), Wd(U, k, I);
    };
  }
  function Yd(A, k) {
    return function(L, I) {
      var B = L["get" + A](), U = l(k ? "SHORT" + A : A);
      return I[U][B];
    };
  }
  function mw(A, k, L) {
    var I = -1 * L, B = I >= 0 ? "+" : "";
    return B += Wd(Math[I > 0 ? "floor" : "ceil"](I / 60), 2) + Wd(Math.abs(I % 60), 2), B;
  }
  function ey(A) {
    var k = new Date(A, 0, 1).getDay();
    return new Date(A, 0, (k <= 4 ? 5 : 12) - k);
  }
  function yw(A) {
    return new Date(
      A.getFullYear(),
      A.getMonth(),
      A.getDate() + (4 - A.getDay())
    );
  }
  function ty(A) {
    return function(k) {
      var L = ey(k.getFullYear()), I = yw(k), B = +I - +L, U = 1 + Math.round(B / 6048e5);
      return Wd(U, A);
    };
  }
  function _w(A, k) {
    return A.getHours() < 12 ? k.AMPMS[0] : k.AMPMS[1];
  }
  function vp(A, k) {
    return A.getFullYear() <= 0 ? k.ERAS[0] : k.ERAS[1];
  }
  function bw(A, k) {
    return A.getFullYear() <= 0 ? k.ERANAMES[0] : k.ERANAMES[1];
  }
  var Tw = {
    yyyy: Rn("FullYear", 4),
    yy: Rn("FullYear", 2, 0, !0),
    y: Rn("FullYear", 1),
    MMMM: Yd("Month"),
    MMM: Yd("Month", !0),
    MM: Rn("Month", 2, 1),
    M: Rn("Month", 1, 1),
    dd: Rn("Date", 2),
    d: Rn("Date", 1),
    HH: Rn("Hours", 2),
    H: Rn("Hours", 1),
    hh: Rn("Hours", 2, -12),
    h: Rn("Hours", 1, -12),
    mm: Rn("Minutes", 2),
    m: Rn("Minutes", 1),
    ss: Rn("Seconds", 2),
    s: Rn("Seconds", 1),
    sss: Rn("Milliseconds", 3),
    EEEE: Yd("Day"),
    EEE: Yd("Day", !0),
    a: _w,
    Z: mw,
    ww: ty(2),
    w: ty(1),
    G: vp,
    GG: vp,
    GGG: vp,
    GGGG: bw
  }, Sw = /((?:[^yMdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/, Ew = /^\-?\d+$/;
  ry.$inject = ["$locale"];
  function ry(A) {
    var k = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
    function L(I) {
      var B;
      if (B = I.match(k)) {
        var U = new Date(0), j = 0, H = 0, W = B[8] ? U.setUTCFullYear : U.setFullYear, X = B[8] ? U.setUTCHours : U.setHours;
        B[9] && (j = M(B[9] + B[10]), H = M(B[9] + B[11])), W.call(U, M(B[1]), M(B[2]) - 1, M(B[3]));
        var Z = M(B[4] || 0) - j, fe = M(B[5] || 0) - H, he = M(B[6] || 0), ye = Math.round(parseFloat("0." + (B[7] || 0)) * 1e3);
        return X.call(U, Z, fe, he, ye), U;
      }
      return I;
    }
    return function(I, B, U) {
      var j = "", H = [], W, X;
      if (B = B || "mediumDate", B = A.DATETIME_FORMATS[B] || B, Ne(I) && (I = Ew.test(I) ? M(I) : L(I)), ot(I) && (I = new Date(I)), !ze(I) || !isFinite(I.getTime()))
        return I;
      for (; B; )
        X = Sw.exec(B), X ? (H = Kr(H, X, 1), B = H.pop()) : (H.push(B), B = null);
      var Z = I.getTimezoneOffset();
      return U && (Z = Ks(U, Z), I = ha(I, U, !0)), T(H, function(fe) {
        W = Tw[fe], j += W ? W(I, A.DATETIME_FORMATS, Z) : fe === "''" ? "'" : fe.replace(/(^'|'$)/g, "").replace(/''/g, "'");
      }), j;
    };
  }
  function xw() {
    return function(A, k) {
      return ce(k) && (k = 2), za(A, k);
    };
  }
  var Aw = J(s), ww = J(l);
  function Cw() {
    return function(A, k, L) {
      return Math.abs(Number(k)) === 1 / 0 ? k = Number(k) : k = M(k), isNaN(k) || (ot(A) && (A = A.toString()), !$e(A) && !Ne(A)) ? A : (L = !L || isNaN(L) ? 0 : M(L), L = L < 0 ? Math.max(0, A.length + L) : L, k >= 0 ? A.slice(L, L + k) : L === 0 ? A.slice(k, A.length) : A.slice(Math.max(0, L + k), L));
    };
  }
  iy.$inject = ["$parse"];
  function iy(A) {
    return function(j, H, W) {
      if (!S(j))
        return j;
      $e(H) || (H = [H]), H.length === 0 && (H = ["+"]);
      var X = k(H, W);
      X.push({ get: function() {
        return {};
      }, descending: W ? -1 : 1 });
      var Z = Array.prototype.map.call(j, fe);
      return Z.sort(he), j = Z.map(function(ye) {
        return ye.value;
      }), j;
      function fe(ye, Se) {
        return {
          value: ye,
          predicateValues: X.map(function(Pe) {
            return B(Pe.get(ye), Se);
          })
        };
      }
      function he(ye, Se) {
        for (var Pe = 0, be = 0, Te = X.length; be < Te && (Pe = U(ye.predicateValues[be], Se.predicateValues[be]) * X[be].descending, !Pe); ++be)
          ;
        return Pe;
      }
    };
    function k(j, H) {
      return H = H ? -1 : 1, j.map(function(W) {
        var X = 1, Z = K;
        if (Ze(W))
          Z = W;
        else if (Ne(W) && ((W.charAt(0) == "+" || W.charAt(0) == "-") && (X = W.charAt(0) == "-" ? -1 : 1, W = W.substring(1)), W !== "" && (Z = A(W), Z.constant))) {
          var fe = Z();
          Z = function(he) {
            return he[fe];
          };
        }
        return { get: Z, descending: X * H };
      });
    }
    function L(j) {
      switch (typeof j) {
        case "number":
        case "boolean":
        case "string":
          return !0;
        default:
          return !1;
      }
    }
    function I(j, H) {
      return typeof j.valueOf == "function" && (j = j.valueOf(), L(j)) || ue(j) && (j = j.toString(), L(j)) ? j : H;
    }
    function B(j, H) {
      var W = typeof j;
      return j === null ? (W = "string", j = "null") : W === "string" ? j = j.toLowerCase() : W === "object" && (j = I(j, H)), { value: j, type: W };
    }
    function U(j, H) {
      var W = 0;
      return j.type === H.type ? j.value !== H.value && (W = j.value < H.value ? -1 : 1) : W = j.type < H.type ? -1 : 1, W;
    }
  }
  function Eu(A) {
    return Ze(A) && (A = {
      link: A
    }), A.restrict = A.restrict || "AC", J(A);
  }
  var Dw = J({
    restrict: "E",
    compile: function(A, k) {
      if (!k.href && !k.xlinkHref)
        return function(L, I) {
          if (I[0].nodeName.toLowerCase() === "a") {
            var B = y.call(I.prop("href")) === "[object SVGAnimatedString]" ? "xlink:href" : "href";
            I.on("click", function(U) {
              I.attr(B) || U.preventDefault();
            });
          }
        };
    }
  }), Kd = {};
  T(Cs, function(A, k) {
    if (A == "multiple")
      return;
    function L(U, j, H) {
      U.$watch(H[I], function(X) {
        H.$set(k, !!X);
      });
    }
    var I = V("ng-" + k), B = L;
    A === "checked" && (B = function(U, j, H) {
      H.ngModel !== H[I] && L(U, j, H);
    }), Kd[I] = function() {
      return {
        restrict: "A",
        priority: 100,
        link: B
      };
    };
  }), T(Mo, function(A, k) {
    Kd[k] = function() {
      return {
        priority: 100,
        link: function(L, I, B) {
          if (k === "ngPattern" && B.ngPattern.charAt(0) == "/") {
            var U = B.ngPattern.match(n);
            if (U) {
              B.$set("ngPattern", new RegExp(U[1], U[2]));
              return;
            }
          }
          L.$watch(B[k], function(H) {
            B.$set(k, H);
          });
        }
      };
    };
  }), T(["src", "srcset", "href"], function(A) {
    var k = V("ng-" + A);
    Kd[k] = function() {
      return {
        priority: 99,
        link: function(L, I, B) {
          var U = A, j = A;
          A === "href" && y.call(I.prop("href")) === "[object SVGAnimatedString]" && (j = "xlinkHref", B.$attr[j] = "xlink:href", U = null), B.$observe(k, function(H) {
            if (!H) {
              A === "href" && B.$set(j, null);
              return;
            }
            B.$set(j, H), c && U && I.prop(U, B[j]);
          });
        }
      };
    };
  });
  var zd = {
    $addControl: G,
    $$renameControl: kw,
    $removeControl: G,
    $setValidity: G,
    $setDirty: G,
    $setPristine: G,
    $setSubmitted: G
  }, ny = "ng-submitted";
  function kw(A, k) {
    A.$name = k;
  }
  ay.$inject = ["$element", "$attrs", "$scope", "$animate", "$interpolate"];
  function ay(A, k, L, I, B) {
    var U = this, j = [];
    U.$error = {}, U.$$success = {}, U.$pending = i, U.$name = B(k.name || k.ngForm || "")(L), U.$dirty = !1, U.$pristine = !0, U.$valid = !0, U.$invalid = !1, U.$submitted = !1, U.$$parentForm = zd, U.$rollbackViewValue = function() {
      T(j, function(H) {
        H.$rollbackViewValue();
      });
    }, U.$commitViewValue = function() {
      T(j, function(H) {
        H.$commitViewValue();
      });
    }, U.$addControl = function(H) {
      pa(H.$name, "input"), j.push(H), H.$name && (U[H.$name] = H), H.$$parentForm = U;
    }, U.$$renameControl = function(H, W) {
      var X = H.$name;
      U[X] === H && delete U[X], U[W] = H, H.$name = W;
    }, U.$removeControl = function(H) {
      H.$name && U[H.$name] === H && delete U[H.$name], T(U.$pending, function(W, X) {
        U.$setValidity(X, null, H);
      }), T(U.$error, function(W, X) {
        U.$setValidity(X, null, H);
      }), T(U.$$success, function(W, X) {
        U.$setValidity(X, null, H);
      }), xr(j, H), H.$$parentForm = zd;
    }, by({
      ctrl: this,
      $element: A,
      set: function(H, W, X) {
        var Z = H[W];
        if (!Z)
          H[W] = [X];
        else {
          var fe = Z.indexOf(X);
          fe === -1 && Z.push(X);
        }
      },
      unset: function(H, W, X) {
        var Z = H[W];
        !Z || (xr(Z, X), Z.length === 0 && delete H[W]);
      },
      $animate: I
    }), U.$setDirty = function() {
      I.removeClass(A, ml), I.addClass(A, Jd), U.$dirty = !0, U.$pristine = !1, U.$$parentForm.$setDirty();
    }, U.$setPristine = function() {
      I.setClass(A, ml, Jd + " " + ny), U.$dirty = !1, U.$pristine = !0, U.$submitted = !1, T(j, function(H) {
        H.$setPristine();
      });
    }, U.$setUntouched = function() {
      T(j, function(H) {
        H.$setUntouched();
      });
    }, U.$setSubmitted = function() {
      I.addClass(A, ny), U.$submitted = !0, U.$$parentForm.$setSubmitted();
    };
  }
  var sy = function(A) {
    return ["$timeout", "$parse", function(k, L) {
      var I = {
        name: "form",
        restrict: A ? "EAC" : "E",
        require: ["form", "^^?form"],
        controller: ay,
        compile: function(j, H) {
          j.addClass(ml).addClass(Cc);
          var W = H.name ? "name" : A && H.ngForm ? "ngForm" : !1;
          return {
            pre: function(Z, fe, he, ye) {
              var Se = ye[0];
              if (!("action" in he)) {
                var Pe = function(_e) {
                  Z.$apply(function() {
                    Se.$commitViewValue(), Se.$setSubmitted();
                  }), _e.preventDefault();
                };
                Oa(fe[0], "submit", Pe), fe.on("$destroy", function() {
                  k(function() {
                    Gn(fe[0], "submit", Pe);
                  }, 0, !1);
                });
              }
              var be = ye[1] || Se.$$parentForm;
              be.$addControl(Se);
              var Te = W ? B(Se.$name) : G;
              W && (Te(Z, Se), he.$observe(W, function(_e) {
                Se.$name !== _e && (Te(Z, i), Se.$$parentForm.$$renameControl(Se, _e), Te = B(Se.$name), Te(Z, Se));
              })), fe.on("$destroy", function() {
                Se.$$parentForm.$removeControl(Se), Te(Z, i), $(Se, zd);
              });
            }
          };
        }
      };
      return I;
      function B(U) {
        return U === "" ? L('this[""]').assign : L(U).assign || G;
      }
    }];
  }, Rw = sy(), Pw = sy(!0), Ow = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/, Lw = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+\])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i, Iw = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i, Mw = /^\s*(\-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/, oy = /^(\d{4})-(\d{2})-(\d{2})$/, uy = /^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/, mp = /^(\d{4})-W(\d\d)$/, ly = /^(\d{4})-(\d\d)$/, cy = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/, Nw = "keydown wheel mousedown", dy = xi();
  T("date,datetime-local,month,time,week".split(","), function(A) {
    dy[A] = !0;
  });
  var fy = {
    text: Fw,
    date: wc(
      "date",
      oy,
      Xd(oy, ["yyyy", "MM", "dd"]),
      "yyyy-MM-dd"
    ),
    "datetime-local": wc(
      "datetimelocal",
      uy,
      Xd(uy, ["yyyy", "MM", "dd", "HH", "mm", "ss", "sss"]),
      "yyyy-MM-ddTHH:mm:ss.sss"
    ),
    time: wc(
      "time",
      cy,
      Xd(cy, ["HH", "mm", "ss", "sss"]),
      "HH:mm:ss.sss"
    ),
    week: wc("week", mp, Uw, "yyyy-Www"),
    month: wc(
      "month",
      ly,
      Xd(ly, ["yyyy", "MM"]),
      "yyyy-MM"
    ),
    number: Bw,
    url: jw,
    email: $w,
    radio: Gw,
    checkbox: Hw,
    hidden: G,
    button: G,
    submit: G,
    reset: G,
    file: G
  };
  function yp(A) {
    A.$formatters.push(function(k) {
      return A.$isEmpty(k) ? k : k.toString();
    });
  }
  function Fw(A, k, L, I, B, U) {
    Ac(A, k, L, I, B, U), yp(I);
  }
  function Ac(A, k, L, I, B, U) {
    var j = s(k[0].type);
    if (!B.android) {
      var H = !1;
      k.on("compositionstart", function(fe) {
        H = !0;
      }), k.on("compositionend", function() {
        H = !1, X();
      });
    }
    var W, X = function(fe) {
      if (W && (U.defer.cancel(W), W = null), !H) {
        var he = k.val(), ye = fe && fe.type;
        j !== "password" && (!L.ngTrim || L.ngTrim !== "false") && (he = It(he)), (I.$viewValue !== he || he === "" && I.$$hasNativeValidators) && I.$setViewValue(he, ye);
      }
    };
    if (B.hasEvent("input"))
      k.on("input", X);
    else {
      var Z = function(fe, he, ye) {
        W || (W = U.defer(function() {
          W = null, (!he || he.value !== ye) && X(fe);
        }));
      };
      k.on("keydown", function(fe) {
        var he = fe.keyCode;
        he === 91 || 15 < he && he < 19 || 37 <= he && he <= 40 || Z(fe, this, this.value);
      }), B.hasEvent("paste") && k.on("paste cut", Z);
    }
    k.on("change", X), dy[j] && I.$$hasNativeValidators && j === L.type && k.on(Nw, function(fe) {
      if (!W) {
        var he = this[a], ye = he.badInput, Se = he.typeMismatch;
        W = U.defer(function() {
          W = null, (he.badInput !== ye || he.typeMismatch !== Se) && X(fe);
        });
      }
    }), I.$render = function() {
      var fe = I.$isEmpty(I.$viewValue) ? "" : I.$viewValue;
      k.val() !== fe && k.val(fe);
    };
  }
  function Uw(A, k) {
    if (ze(A))
      return A;
    if (Ne(A)) {
      mp.lastIndex = 0;
      var L = mp.exec(A);
      if (L) {
        var I = +L[1], B = +L[2], U = 0, j = 0, H = 0, W = 0, X = ey(I), Z = (B - 1) * 7;
        return k && (U = k.getHours(), j = k.getMinutes(), H = k.getSeconds(), W = k.getMilliseconds()), new Date(I, 0, X.getDate() + Z, U, j, H, W);
      }
    }
    return NaN;
  }
  function Xd(A, k) {
    return function(L, I) {
      var B, U;
      if (ze(L))
        return L;
      if (Ne(L)) {
        if (L.charAt(0) == '"' && L.charAt(L.length - 1) == '"' && (L = L.substring(1, L.length - 1)), Ow.test(L))
          return new Date(L);
        if (A.lastIndex = 0, B = A.exec(L), B)
          return B.shift(), I ? U = {
            yyyy: I.getFullYear(),
            MM: I.getMonth() + 1,
            dd: I.getDate(),
            HH: I.getHours(),
            mm: I.getMinutes(),
            ss: I.getSeconds(),
            sss: I.getMilliseconds() / 1e3
          } : U = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 }, T(B, function(j, H) {
            H < k.length && (U[k[H]] = +j);
          }), new Date(U.yyyy, U.MM - 1, U.dd, U.HH, U.mm, U.ss || 0, U.sss * 1e3 || 0);
      }
      return NaN;
    };
  }
  function wc(A, k, L, I) {
    return function(U, j, H, W, X, Z, fe) {
      hy(U, j, H, W), Ac(U, j, H, W, X, Z);
      var he = W && W.$options && W.$options.timezone, ye;
      if (W.$$parserName = A, W.$parsers.push(function(_e) {
        if (W.$isEmpty(_e))
          return null;
        if (k.test(_e)) {
          var Ie = L(_e, ye);
          return he && (Ie = ha(Ie, he)), Ie;
        }
        return i;
      }), W.$formatters.push(function(_e) {
        if (_e && !ze(_e))
          throw Dc("datefmt", "Expected `{0}` to be a date", _e);
        return be(_e) ? (ye = _e, ye && he && (ye = ha(ye, he, !0)), fe("date")(_e, I, he)) : (ye = null, "");
      }), ee(H.min) || H.ngMin) {
        var Se;
        W.$validators.min = function(_e) {
          return !be(_e) || ce(Se) || L(_e) >= Se;
        }, H.$observe("min", function(_e) {
          Se = Te(_e), W.$validate();
        });
      }
      if (ee(H.max) || H.ngMax) {
        var Pe;
        W.$validators.max = function(_e) {
          return !be(_e) || ce(Pe) || L(_e) <= Pe;
        }, H.$observe("max", function(_e) {
          Pe = Te(_e), W.$validate();
        });
      }
      function be(_e) {
        return _e && !(_e.getTime && _e.getTime() !== _e.getTime());
      }
      function Te(_e) {
        return ee(_e) && !ze(_e) ? L(_e) || i : _e;
      }
    };
  }
  function hy(A, k, L, I) {
    var B = k[0], U = I.$$hasNativeValidators = me(B.validity);
    U && I.$parsers.push(function(j) {
      var H = k.prop(a) || {};
      return H.badInput && !H.typeMismatch ? i : j;
    });
  }
  function Bw(A, k, L, I, B, U) {
    if (hy(A, k, L, I), Ac(A, k, L, I, B, U), I.$$parserName = "number", I.$parsers.push(function(W) {
      return I.$isEmpty(W) ? null : Mw.test(W) ? parseFloat(W) : i;
    }), I.$formatters.push(function(W) {
      if (!I.$isEmpty(W)) {
        if (!ot(W))
          throw Dc("numfmt", "Expected `{0}` to be a number", W);
        W = W.toString();
      }
      return W;
    }), ee(L.min) || L.ngMin) {
      var j;
      I.$validators.min = function(W) {
        return I.$isEmpty(W) || ce(j) || W >= j;
      }, L.$observe("min", function(W) {
        ee(W) && !ot(W) && (W = parseFloat(W, 10)), j = ot(W) && !isNaN(W) ? W : i, I.$validate();
      });
    }
    if (ee(L.max) || L.ngMax) {
      var H;
      I.$validators.max = function(W) {
        return I.$isEmpty(W) || ce(H) || W <= H;
      }, L.$observe("max", function(W) {
        ee(W) && !ot(W) && (W = parseFloat(W, 10)), H = ot(W) && !isNaN(W) ? W : i, I.$validate();
      });
    }
  }
  function jw(A, k, L, I, B, U) {
    Ac(A, k, L, I, B, U), yp(I), I.$$parserName = "url", I.$validators.url = function(j, H) {
      var W = j || H;
      return I.$isEmpty(W) || Lw.test(W);
    };
  }
  function $w(A, k, L, I, B, U) {
    Ac(A, k, L, I, B, U), yp(I), I.$$parserName = "email", I.$validators.email = function(j, H) {
      var W = j || H;
      return I.$isEmpty(W) || Iw.test(W);
    };
  }
  function Gw(A, k, L, I) {
    ce(L.name) && k.attr("name", R());
    var B = function(U) {
      k[0].checked && I.$setViewValue(L.value, U && U.type);
    };
    k.on("click", B), I.$render = function() {
      var U = L.value;
      k[0].checked = U == I.$viewValue;
    }, L.$observe("value", I.$render);
  }
  function py(A, k, L, I, B) {
    var U;
    if (ee(I)) {
      if (U = A(I), !U.constant)
        throw Dc("constexpr", "Expected constant expression for `{0}`, but saw `{1}`.", L, I);
      return U(k);
    }
    return B;
  }
  function Hw(A, k, L, I, B, U, j, H) {
    var W = py(H, A, "ngTrueValue", L.ngTrueValue, !0), X = py(H, A, "ngFalseValue", L.ngFalseValue, !1), Z = function(fe) {
      I.$setViewValue(k[0].checked, fe && fe.type);
    };
    k.on("click", Z), I.$render = function() {
      k[0].checked = I.$viewValue;
    }, I.$isEmpty = function(fe) {
      return fe === !1;
    }, I.$formatters.push(function(fe) {
      return li(fe, W);
    }), I.$parsers.push(function(fe) {
      return fe ? W : X;
    });
  }
  var gy = [
    "$browser",
    "$sniffer",
    "$filter",
    "$parse",
    function(A, k, L, I) {
      return {
        restrict: "E",
        require: ["?ngModel"],
        link: {
          pre: function(B, U, j, H) {
            H[0] && (fy[s(j.type)] || fy.text)(
              B,
              U,
              j,
              H[0],
              k,
              A,
              L,
              I
            );
          }
        }
      };
    }
  ], Vw = /^(true|false|\d+)$/, qw = function() {
    return {
      restrict: "A",
      priority: 100,
      compile: function(A, k) {
        return Vw.test(k.ngValue) ? function(I, B, U) {
          U.$set("value", I.$eval(U.ngValue));
        } : function(I, B, U) {
          I.$watch(U.ngValue, function(H) {
            U.$set("value", H);
          });
        };
      }
    };
  }, Ww = ["$compile", function(A) {
    return {
      restrict: "AC",
      compile: function(L) {
        return A.$$addBindingClass(L), function(B, U, j) {
          A.$$addBindingInfo(U, j.ngBind), U = U[0], B.$watch(j.ngBind, function(W) {
            U.textContent = ce(W) ? "" : W;
          });
        };
      }
    };
  }], Yw = ["$interpolate", "$compile", function(A, k) {
    return {
      compile: function(I) {
        return k.$$addBindingClass(I), function(U, j, H) {
          var W = A(j.attr(H.$attr.ngBindTemplate));
          k.$$addBindingInfo(j, W.expressions), j = j[0], H.$observe("ngBindTemplate", function(X) {
            j.textContent = ce(X) ? "" : X;
          });
        };
      }
    };
  }], Kw = ["$sce", "$parse", "$compile", function(A, k, L) {
    return {
      restrict: "A",
      compile: function(B, U) {
        var j = k(U.ngBindHtml), H = k(U.ngBindHtml, function(X) {
          return A.valueOf(X);
        });
        return L.$$addBindingClass(B), function(X, Z, fe) {
          L.$$addBindingInfo(Z, fe.ngBindHtml), X.$watch(H, function() {
            var ye = j(X);
            Z.html(A.getTrustedHtml(ye) || "");
          });
        };
      }
    };
  }], zw = J({
    restrict: "A",
    require: "ngModel",
    link: function(A, k, L, I) {
      I.$viewChangeListeners.push(function() {
        A.$eval(L.ngChange);
      });
    }
  });
  function _p(A, k) {
    return A = "ngClass" + A, ["$animate", function(L) {
      return {
        restrict: "AC",
        link: function(U, j, H) {
          var W;
          U.$watch(H[A], ye, !0), H.$observe("class", function(Se) {
            ye(U.$eval(H[A]));
          }), A !== "ngClass" && U.$watch("$index", function(Se, Pe) {
            var be = Se & 1;
            if (be !== (Pe & 1)) {
              var Te = B(U.$eval(H[A]));
              be === k ? X(Te) : Z(Te);
            }
          });
          function X(Se) {
            var Pe = fe(Se, 1);
            H.$addClass(Pe);
          }
          function Z(Se) {
            var Pe = fe(Se, -1);
            H.$removeClass(Pe);
          }
          function fe(Se, Pe) {
            var be = j.data("$classCounts") || xi(), Te = [];
            return T(Se, function(_e) {
              (Pe > 0 || be[_e]) && (be[_e] = (be[_e] || 0) + Pe, be[_e] === +(Pe > 0) && Te.push(_e));
            }), j.data("$classCounts", be), Te.join(" ");
          }
          function he(Se, Pe) {
            var be = I(Pe, Se), Te = I(Se, Pe);
            be = fe(be, 1), Te = fe(Te, -1), be && be.length && L.addClass(j, be), Te && Te.length && L.removeClass(j, Te);
          }
          function ye(Se) {
            if (k === !0 || U.$index % 2 === k) {
              var Pe = B(Se || []);
              if (!W)
                X(Pe);
              else if (!li(Se, W)) {
                var be = B(W);
                he(be, Pe);
              }
            }
            $e(Se) ? W = Se.map(function(Te) {
              return Gr(Te);
            }) : W = Gr(Se);
          }
        }
      };
      function I(U, j) {
        var H = [];
        e:
          for (var W = 0; W < U.length; W++) {
            for (var X = U[W], Z = 0; Z < j.length; Z++)
              if (X == j[Z])
                continue e;
            H.push(X);
          }
        return H;
      }
      function B(U) {
        var j = [];
        return $e(U) ? (T(U, function(H) {
          j = j.concat(B(H));
        }), j) : Ne(U) ? U.split(" ") : me(U) ? (T(U, function(H, W) {
          H && (j = j.concat(W.split(" ")));
        }), j) : U;
      }
    }];
  }
  var Xw = _p("", !0), Jw = _p("Odd", 0), Qw = _p("Even", 1), Zw = Eu({
    compile: function(A, k) {
      k.$set("ngCloak", i), A.removeClass("ng-cloak");
    }
  }), e1 = [function() {
    return {
      restrict: "A",
      scope: !0,
      controller: "@",
      priority: 500
    };
  }], vy = {}, t1 = {
    blur: !0,
    focus: !0
  };
  T(
    "click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste".split(" "),
    function(A) {
      var k = V("ng-" + A);
      vy[k] = ["$parse", "$rootScope", function(L, I) {
        return {
          restrict: "A",
          compile: function(B, U) {
            var j = L(U[k], null, !0);
            return function(W, X) {
              X.on(A, function(Z) {
                var fe = function() {
                  j(W, { $event: Z });
                };
                t1[A] && I.$$phase ? W.$evalAsync(fe) : W.$apply(fe);
              });
            };
          }
        };
      }];
    }
  );
  var r1 = ["$animate", function(A) {
    return {
      multiElement: !0,
      transclude: "element",
      priority: 600,
      terminal: !0,
      restrict: "A",
      $$tlb: !0,
      link: function(k, L, I, B, U) {
        var j, H, W;
        k.$watch(I.ngIf, function(Z) {
          Z ? H || U(function(fe, he) {
            H = he, fe[fe.length++] = r.createComment(" end ngIf: " + I.ngIf + " "), j = {
              clone: fe
            }, A.enter(fe, L.parent(), L);
          }) : (W && (W.remove(), W = null), H && (H.$destroy(), H = null), j && (W = Za(j.clone), A.leave(W).then(function() {
            W = null;
          }), j = null));
        });
      }
    };
  }], i1 = [
    "$templateRequest",
    "$anchorScroll",
    "$animate",
    function(A, k, L) {
      return {
        restrict: "ECA",
        priority: 400,
        terminal: !0,
        transclude: "element",
        controller: E.noop,
        compile: function(I, B) {
          var U = B.ngInclude || B.src, j = B.onload || "", H = B.autoscroll;
          return function(W, X, Z, fe, he) {
            var ye = 0, Se, Pe, be, Te = function() {
              Pe && (Pe.remove(), Pe = null), Se && (Se.$destroy(), Se = null), be && (L.leave(be).then(function() {
                Pe = null;
              }), Pe = be, be = null);
            };
            W.$watch(U, function(Ie) {
              var De = function() {
                ee(H) && (!H || W.$eval(H)) && k();
              }, Re = ++ye;
              Ie ? (A(Ie, !0).then(function(qe) {
                if (!W.$$destroyed && Re === ye) {
                  var Oe = W.$new();
                  fe.template = qe;
                  var rt = he(Oe, function(Xe) {
                    Te(), L.enter(Xe, null, X).then(De);
                  });
                  Se = Oe, be = rt, Se.$emit("$includeContentLoaded", Ie), W.$eval(j);
                }
              }, function() {
                W.$$destroyed || Re === ye && (Te(), W.$emit("$includeContentError", Ie));
              }), W.$emit("$includeContentRequested", Ie)) : (Te(), fe.template = null);
            });
          };
        }
      };
    }
  ], n1 = [
    "$compile",
    function(A) {
      return {
        restrict: "ECA",
        priority: -400,
        require: "ngInclude",
        link: function(k, L, I, B) {
          if (/SVG/.test(L[0].toString())) {
            L.empty(), A(_r(B.template, r).childNodes)(
              k,
              function(j) {
                L.append(j);
              },
              { futureParentElement: L }
            );
            return;
          }
          L.html(B.template), A(L.contents())(k);
        }
      };
    }
  ], a1 = Eu({
    priority: 450,
    compile: function() {
      return {
        pre: function(A, k, L) {
          A.$eval(L.ngInit);
        }
      };
    }
  }), s1 = function() {
    return {
      restrict: "A",
      priority: 100,
      require: "ngModel",
      link: function(A, k, L, I) {
        var B = k.attr(L.$attr.ngList) || ", ", U = L.ngTrim !== "false", j = U ? It(B) : B, H = function(W) {
          if (!ce(W)) {
            var X = [];
            return W && T(W.split(j), function(Z) {
              Z && X.push(U ? It(Z) : Z);
            }), X;
          }
        };
        I.$parsers.push(H), I.$formatters.push(function(W) {
          return $e(W) ? W.join(B) : i;
        }), I.$isEmpty = function(W) {
          return !W || !W.length;
        };
      }
    };
  }, Cc = "ng-valid", my = "ng-invalid", ml = "ng-pristine", Jd = "ng-dirty", bp = "ng-untouched", yy = "ng-touched", _y = "ng-pending", Dc = t("ngModel"), o1 = [
    "$scope",
    "$exceptionHandler",
    "$attrs",
    "$element",
    "$parse",
    "$animate",
    "$timeout",
    "$rootScope",
    "$q",
    "$interpolate",
    function(A, k, L, I, B, U, j, H, W, X) {
      this.$viewValue = Number.NaN, this.$modelValue = Number.NaN, this.$$rawModelValue = i, this.$validators = {}, this.$asyncValidators = {}, this.$parsers = [], this.$formatters = [], this.$viewChangeListeners = [], this.$untouched = !0, this.$touched = !1, this.$pristine = !0, this.$dirty = !1, this.$valid = !0, this.$invalid = !1, this.$error = {}, this.$$success = {}, this.$pending = i, this.$name = X(L.name || "", !1)(A), this.$$parentForm = zd;
      var Z = B(L.ngModel), fe = Z.assign, he = Z, ye = fe, Se = null, Pe, be = this;
      this.$$setOptions = function(_e) {
        if (be.$options = _e, _e && _e.getterSetter) {
          var Ie = B(L.ngModel + "()"), De = B(L.ngModel + "($$$p)");
          he = function(Re) {
            var qe = Z(Re);
            return Ze(qe) && (qe = Ie(Re)), qe;
          }, ye = function(Re, qe) {
            Ze(Z(Re)) ? De(Re, { $$$p: be.$modelValue }) : fe(Re, be.$modelValue);
          };
        } else if (!Z.assign)
          throw Dc(
            "nonassign",
            "Expression '{0}' is non-assignable. Element: {1}",
            L.ngModel,
            Ei(I)
          );
      }, this.$render = G, this.$isEmpty = function(_e) {
        return ce(_e) || _e === "" || _e === null || _e !== _e;
      };
      var Te = 0;
      by({
        ctrl: this,
        $element: I,
        set: function(_e, Ie) {
          _e[Ie] = !0;
        },
        unset: function(_e, Ie) {
          delete _e[Ie];
        },
        $animate: U
      }), this.$setPristine = function() {
        be.$dirty = !1, be.$pristine = !0, U.removeClass(I, Jd), U.addClass(I, ml);
      }, this.$setDirty = function() {
        be.$dirty = !0, be.$pristine = !1, U.removeClass(I, ml), U.addClass(I, Jd), be.$$parentForm.$setDirty();
      }, this.$setUntouched = function() {
        be.$touched = !1, be.$untouched = !0, U.setClass(I, bp, yy);
      }, this.$setTouched = function() {
        be.$touched = !0, be.$untouched = !1, U.setClass(I, yy, bp);
      }, this.$rollbackViewValue = function() {
        j.cancel(Se), be.$viewValue = be.$$lastCommittedViewValue, be.$render();
      }, this.$validate = function() {
        if (!(ot(be.$modelValue) && isNaN(be.$modelValue))) {
          var _e = be.$$lastCommittedViewValue, Ie = be.$$rawModelValue, De = be.$valid, Re = be.$modelValue, qe = be.$options && be.$options.allowInvalid;
          be.$$runValidators(Ie, _e, function(Oe) {
            !qe && De !== Oe && (be.$modelValue = Oe ? Ie : i, be.$modelValue !== Re && be.$$writeModelToScope());
          });
        }
      }, this.$$runValidators = function(_e, Ie, De) {
        Te++;
        var Re = Te;
        if (!qe()) {
          Je(!1);
          return;
        }
        if (!Oe()) {
          Je(!1);
          return;
        }
        rt();
        function qe() {
          var Qe = be.$$parserName || "parse";
          if (ce(Pe))
            Xe(Qe, null);
          else
            return Pe || (T(be.$validators, function(tt, dt) {
              Xe(dt, null);
            }), T(be.$asyncValidators, function(tt, dt) {
              Xe(dt, null);
            })), Xe(Qe, Pe), Pe;
          return !0;
        }
        function Oe() {
          var Qe = !0;
          return T(be.$validators, function(tt, dt) {
            var Ye = tt(_e, Ie);
            Qe = Qe && Ye, Xe(dt, Ye);
          }), Qe ? !0 : (T(be.$asyncValidators, function(tt, dt) {
            Xe(dt, null);
          }), !1);
        }
        function rt() {
          var Qe = [], tt = !0;
          T(be.$asyncValidators, function(dt, Ye) {
            var it = dt(_e, Ie);
            if (!Pt(it))
              throw Dc(
                "nopromise",
                "Expected asynchronous validator to return a promise but got '{0}' instead.",
                it
              );
            Xe(Ye, i), Qe.push(it.then(function() {
              Xe(Ye, !0);
            }, function(wt) {
              tt = !1, Xe(Ye, !1);
            }));
          }), Qe.length ? W.all(Qe).then(function() {
            Je(tt);
          }, G) : Je(!0);
        }
        function Xe(Qe, tt) {
          Re === Te && be.$setValidity(Qe, tt);
        }
        function Je(Qe) {
          Re === Te && De(Qe);
        }
      }, this.$commitViewValue = function() {
        var _e = be.$viewValue;
        j.cancel(Se), !(be.$$lastCommittedViewValue === _e && (_e !== "" || !be.$$hasNativeValidators)) && (be.$$lastCommittedViewValue = _e, be.$pristine && this.$setDirty(), this.$$parseAndValidate());
      }, this.$$parseAndValidate = function() {
        var _e = be.$$lastCommittedViewValue, Ie = _e;
        if (Pe = ce(Ie) ? i : !0, Pe) {
          for (var De = 0; De < be.$parsers.length; De++)
            if (Ie = be.$parsers[De](Ie), ce(Ie)) {
              Pe = !1;
              break;
            }
        }
        ot(be.$modelValue) && isNaN(be.$modelValue) && (be.$modelValue = he(A));
        var Re = be.$modelValue, qe = be.$options && be.$options.allowInvalid;
        be.$$rawModelValue = Ie, qe && (be.$modelValue = Ie, Oe()), be.$$runValidators(Ie, be.$$lastCommittedViewValue, function(rt) {
          qe || (be.$modelValue = rt ? Ie : i, Oe());
        });
        function Oe() {
          be.$modelValue !== Re && be.$$writeModelToScope();
        }
      }, this.$$writeModelToScope = function() {
        ye(A, be.$modelValue), T(be.$viewChangeListeners, function(_e) {
          try {
            _e();
          } catch (Ie) {
            k(Ie);
          }
        });
      }, this.$setViewValue = function(_e, Ie) {
        be.$viewValue = _e, (!be.$options || be.$options.updateOnDefault) && be.$$debounceViewValueCommit(Ie);
      }, this.$$debounceViewValueCommit = function(_e) {
        var Ie = 0, De = be.$options, Re;
        De && ee(De.debounce) && (Re = De.debounce, ot(Re) ? Ie = Re : ot(Re[_e]) ? Ie = Re[_e] : ot(Re.default) && (Ie = Re.default)), j.cancel(Se), Ie ? Se = j(function() {
          be.$commitViewValue();
        }, Ie) : H.$$phase ? be.$commitViewValue() : A.$apply(function() {
          be.$commitViewValue();
        });
      }, A.$watch(function() {
        var Ie = he(A);
        if (Ie !== be.$modelValue && (be.$modelValue === be.$modelValue || Ie === Ie)) {
          be.$modelValue = be.$$rawModelValue = Ie, Pe = i;
          for (var De = be.$formatters, Re = De.length, qe = Ie; Re--; )
            qe = De[Re](qe);
          be.$viewValue !== qe && (be.$viewValue = be.$$lastCommittedViewValue = qe, be.$render(), be.$$runValidators(Ie, qe, G));
        }
        return Ie;
      });
    }
  ], u1 = ["$rootScope", function(A) {
    return {
      restrict: "A",
      require: ["ngModel", "^?form", "^?ngModelOptions"],
      controller: o1,
      priority: 1,
      compile: function(L) {
        return L.addClass(ml).addClass(bp).addClass(Cc), {
          pre: function(B, U, j, H) {
            var W = H[0], X = H[1] || W.$$parentForm;
            W.$$setOptions(H[2] && H[2].$options), X.$addControl(W), j.$observe("name", function(Z) {
              W.$name !== Z && W.$$parentForm.$$renameControl(W, Z);
            }), B.$on("$destroy", function() {
              W.$$parentForm.$removeControl(W);
            });
          },
          post: function(B, U, j, H) {
            var W = H[0];
            W.$options && W.$options.updateOn && U.on(W.$options.updateOn, function(X) {
              W.$$debounceViewValueCommit(X && X.type);
            }), U.on("blur", function(X) {
              W.$touched || (A.$$phase ? B.$evalAsync(W.$setTouched) : B.$apply(W.$setTouched));
            });
          }
        };
      }
    };
  }], l1 = /(\s+|^)default(\s+|$)/, c1 = function() {
    return {
      restrict: "A",
      controller: ["$scope", "$attrs", function(A, k) {
        var L = this;
        this.$options = _i(A.$eval(k.ngModelOptions)), ee(this.$options.updateOn) ? (this.$options.updateOnDefault = !1, this.$options.updateOn = It(this.$options.updateOn.replace(l1, function() {
          return L.$options.updateOnDefault = !0, " ";
        }))) : this.$options.updateOnDefault = !0;
      }]
    };
  };
  function by(A) {
    var k = A.ctrl, L = A.$element, I = {}, B = A.set, U = A.unset, j = A.$animate;
    I[my] = !(I[Cc] = L.hasClass(Cc)), k.$setValidity = H;
    function H(he, ye, Se) {
      ce(ye) ? W("$pending", he, Se) : X("$pending", he, Se), xt(ye) ? ye ? (U(k.$error, he, Se), B(k.$$success, he, Se)) : (B(k.$error, he, Se), U(k.$$success, he, Se)) : (U(k.$error, he, Se), U(k.$$success, he, Se)), k.$pending ? (Z(_y, !0), k.$valid = k.$invalid = i, fe("", null)) : (Z(_y, !1), k.$valid = Ty(k.$error), k.$invalid = !k.$valid, fe("", k.$valid));
      var Pe;
      k.$pending && k.$pending[he] ? Pe = i : k.$error[he] ? Pe = !1 : k.$$success[he] ? Pe = !0 : Pe = null, fe(he, Pe), k.$$parentForm.$setValidity(he, Pe, k);
    }
    function W(he, ye, Se) {
      k[he] || (k[he] = {}), B(k[he], ye, Se);
    }
    function X(he, ye, Se) {
      k[he] && U(k[he], ye, Se), Ty(k[he]) && (k[he] = i);
    }
    function Z(he, ye) {
      ye && !I[he] ? (j.addClass(L, he), I[he] = !0) : !ye && I[he] && (j.removeClass(L, he), I[he] = !1);
    }
    function fe(he, ye) {
      he = he ? "-" + $n(he, "-") : "", Z(Cc + he, ye === !0), Z(my + he, ye === !1);
    }
  }
  function Ty(A) {
    if (A) {
      for (var k in A)
        if (A.hasOwnProperty(k))
          return !1;
    }
    return !0;
  }
  var d1 = Eu({ terminal: !0, priority: 1e3 }), f1 = t("ngOptions"), h1 = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/, p1 = ["$compile", "$parse", function(A, k) {
    function L(j, H, W) {
      var X = j.match(h1);
      if (!X)
        throw f1(
          "iexp",
          "Expected expression in form of '_select_ (as _label_)? for (_key_,)?_value_ in _collection_' but got '{0}'. Element: {1}",
          j,
          Ei(H)
        );
      var Z = X[5] || X[7], fe = X[6], he = / as /.test(X[0]) && X[1], ye = X[9], Se = k(X[2] ? X[1] : Z), Pe = he && k(he), be = Pe || Se, Te = ye && k(ye), _e = ye ? function(tt, dt) {
        return Te(W, dt);
      } : function(dt) {
        return z(dt);
      }, Ie = function(tt, dt) {
        return _e(tt, Xe(tt, dt));
      }, De = k(X[2] || X[1]), Re = k(X[3] || ""), qe = k(X[4] || ""), Oe = k(X[8]), rt = {}, Xe = fe ? function(tt, dt) {
        return rt[fe] = dt, rt[Z] = tt, rt;
      } : function(tt) {
        return rt[Z] = tt, rt;
      };
      function Je(tt, dt, Ye, it, wt) {
        this.selectValue = tt, this.viewValue = dt, this.label = Ye, this.group = it, this.disabled = wt;
      }
      function Qe(tt) {
        var dt;
        if (!fe && S(tt))
          dt = tt;
        else {
          dt = [];
          for (var Ye in tt)
            tt.hasOwnProperty(Ye) && Ye.charAt(0) !== "$" && dt.push(Ye);
        }
        return dt;
      }
      return {
        trackBy: ye,
        getTrackByValue: Ie,
        getWatchables: k(Oe, function(tt) {
          var dt = [];
          tt = tt || [];
          for (var Ye = Qe(tt), it = Ye.length, wt = 0; wt < it; wt++) {
            var Ct = tt === Ye ? wt : Ye[wt];
            tt[Ct];
            var yr = Xe(tt[Ct], Ct), Lr = _e(tt[Ct], yr);
            if (dt.push(Lr), X[2] || X[1]) {
              var Hr = De(W, yr);
              dt.push(Hr);
            }
            if (X[4]) {
              var di = qe(W, yr);
              dt.push(di);
            }
          }
          return dt;
        }),
        getOptions: function() {
          for (var tt = [], dt = {}, Ye = Oe(W) || [], it = Qe(Ye), wt = it.length, Ct = 0; Ct < wt; Ct++) {
            var yr = Ye === it ? Ct : it[Ct], Lr = Ye[yr], Hr = Xe(Lr, yr), di = be(W, Hr), Jr = _e(di, Hr), ii = De(W, Hr), Li = Re(W, Hr), cn = qe(W, Hr), Gi = new Je(Jr, di, ii, Li, cn);
            tt.push(Gi), dt[Jr] = Gi;
          }
          return {
            items: tt,
            selectValueMap: dt,
            getOptionFromViewValue: function(Ii) {
              return dt[Ie(Ii)];
            },
            getViewValueFromOption: function(Ii) {
              return ye ? E.copy(Ii.viewValue) : Ii.viewValue;
            }
          };
        }
      };
    }
    var I = r.createElement("option"), B = r.createElement("optgroup");
    function U(j, H, W, X) {
      var Z = X[1];
      if (!Z)
        return;
      for (var fe = X[0], he = W.multiple, ye, Se = 0, Pe = H.children(), be = Pe.length; Se < be; Se++)
        if (Pe[Se].value === "") {
          ye = Pe.eq(Se);
          break;
        }
      var Te = !!ye, _e = d(I.cloneNode(!1));
      _e.val("?");
      var Ie, De = L(W.ngOptions, H, j), Re = function() {
        Te || H.prepend(ye), H.val(""), ye.prop("selected", !0), ye.attr("selected", !0);
      }, qe = function() {
        Te || ye.remove();
      }, Oe = function() {
        H.prepend(_e), H.val("?"), _e.prop("selected", !0), _e.attr("selected", !0);
      }, rt = function() {
        _e.remove();
      };
      he ? (Z.$isEmpty = function(Ye) {
        return !Ye || Ye.length === 0;
      }, fe.writeValue = function(it) {
        Ie.items.forEach(function(wt) {
          wt.element.selected = !1;
        }), it && it.forEach(function(wt) {
          var Ct = Ie.getOptionFromViewValue(wt);
          Ct && !Ct.disabled && (Ct.element.selected = !0);
        });
      }, fe.readValue = function() {
        var it = H.val() || [], wt = [];
        return T(it, function(Ct) {
          var yr = Ie.selectValueMap[Ct];
          yr && !yr.disabled && wt.push(Ie.getViewValueFromOption(yr));
        }), wt;
      }, De.trackBy && j.$watchCollection(function() {
        if ($e(Z.$viewValue))
          return Z.$viewValue.map(function(Ye) {
            return De.getTrackByValue(Ye);
          });
      }, function() {
        Z.$render();
      })) : (fe.writeValue = function(it) {
        var wt = Ie.getOptionFromViewValue(it);
        wt && !wt.disabled ? (H[0].value !== wt.selectValue && (rt(), qe(), H[0].value = wt.selectValue, wt.element.selected = !0), wt.element.setAttribute("selected", "selected")) : it === null || Te ? (rt(), Re()) : (qe(), Oe());
      }, fe.readValue = function() {
        var it = Ie.selectValueMap[H.val()];
        return it && !it.disabled ? (qe(), rt(), Ie.getViewValueFromOption(it)) : null;
      }, De.trackBy && j.$watch(
        function() {
          return De.getTrackByValue(Z.$viewValue);
        },
        function() {
          Z.$render();
        }
      )), Te ? (ye.remove(), A(ye)(j), ye.removeClass("ng-scope")) : ye = d(I.cloneNode(!1)), dt(), j.$watchCollection(De.getWatchables, dt);
      function Xe(Ye, it) {
        Ye.element = it, it.disabled = Ye.disabled, Ye.label !== it.label && (it.label = Ye.label, it.textContent = Ye.label), Ye.value !== it.value && (it.value = Ye.selectValue);
      }
      function Je(Ye, it, wt, Ct) {
        var yr;
        return it && s(it.nodeName) === wt ? yr = it : (yr = Ct.cloneNode(!1), it ? Ye.insertBefore(yr, it) : Ye.appendChild(yr)), yr;
      }
      function Qe(Ye) {
        for (var it; Ye; )
          it = Ye.nextSibling, ya(Ye), Ye = it;
      }
      function tt(Ye) {
        var it = ye && ye[0], wt = _e && _e[0];
        if (it || wt)
          for (; Ye && (Ye === it || Ye === wt || Ye.nodeType === Dn || Qr(Ye) === "option" && Ye.value === ""); )
            Ye = Ye.nextSibling;
        return Ye;
      }
      function dt() {
        var Ye = Ie && fe.readValue();
        Ie = De.getOptions();
        var it = {}, wt = H[0].firstChild;
        if (Te && H.prepend(ye), wt = tt(wt), Ie.items.forEach(function(Hr) {
          var di, Jr, ii;
          Hr.group ? (di = it[Hr.group], di || (Jr = Je(
            H[0],
            wt,
            "optgroup",
            B
          ), wt = Jr.nextSibling, Jr.label = Hr.group, di = it[Hr.group] = {
            groupElement: Jr,
            currentOptionElement: Jr.firstChild
          }), ii = Je(
            di.groupElement,
            di.currentOptionElement,
            "option",
            I
          ), Xe(Hr, ii), di.currentOptionElement = ii.nextSibling) : (ii = Je(
            H[0],
            wt,
            "option",
            I
          ), Xe(Hr, ii), wt = ii.nextSibling);
        }), Object.keys(it).forEach(function(Lr) {
          Qe(it[Lr].currentOptionElement);
        }), Qe(wt), Z.$render(), !Z.$isEmpty(Ye)) {
          var Ct = fe.readValue(), yr = De.trackBy || he;
          (yr ? !li(Ye, Ct) : Ye !== Ct) && (Z.$setViewValue(Ct), Z.$render());
        }
      }
    }
    return {
      restrict: "A",
      terminal: !0,
      require: ["select", "?ngModel"],
      link: {
        pre: function(H, W, X, Z) {
          Z[0].registerOption = G;
        },
        post: U
      }
    };
  }], g1 = ["$locale", "$interpolate", "$log", function(A, k, L) {
    var I = /{}/g, B = /^when(Minus)?(.+)$/;
    return {
      link: function(U, j, H) {
        var W = H.count, X = H.$attr.when && j.attr(H.$attr.when), Z = H.offset || 0, fe = U.$eval(X) || {}, he = {}, ye = k.startSymbol(), Se = k.endSymbol(), Pe = ye + W + "-" + Z + Se, be = E.noop, Te;
        T(H, function(Ie, De) {
          var Re = B.exec(De);
          if (Re) {
            var qe = (Re[1] ? "-" : "") + s(Re[2]);
            fe[qe] = j.attr(H.$attr[De]);
          }
        }), T(fe, function(Ie, De) {
          he[De] = k(Ie.replace(I, Pe));
        }), U.$watch(W, function(De) {
          var Re = parseFloat(De), qe = isNaN(Re);
          if (!qe && !(Re in fe) && (Re = A.pluralCat(Re - Z)), Re !== Te && !(qe && ot(Te) && isNaN(Te))) {
            be();
            var Oe = he[Re];
            ce(Oe) ? (De != null && L.debug("ngPluralize: no rule defined for '" + Re + "' in " + X), be = G, _e()) : be = U.$watch(Oe, _e), Te = Re;
          }
        });
        function _e(Ie) {
          j.text(Ie || "");
        }
      }
    };
  }], v1 = ["$parse", "$animate", function(A, k) {
    var L = "$$NG_REMOVED", I = t("ngRepeat"), B = function(H, W, X, Z, fe, he, ye) {
      H[X] = Z, fe && (H[fe] = he), H.$index = W, H.$first = W === 0, H.$last = W === ye - 1, H.$middle = !(H.$first || H.$last), H.$odd = !(H.$even = (W & 1) === 0);
    }, U = function(H) {
      return H.clone[0];
    }, j = function(H) {
      return H.clone[H.clone.length - 1];
    };
    return {
      restrict: "A",
      multiElement: !0,
      transclude: "element",
      priority: 1e3,
      terminal: !0,
      $$tlb: !0,
      compile: function(W, X) {
        var Z = X.ngRepeat, fe = r.createComment(" end ngRepeat: " + Z + " "), he = Z.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
        if (!he)
          throw I(
            "iexp",
            "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
            Z
          );
        var ye = he[1], Se = he[2], Pe = he[3], be = he[4];
        if (he = ye.match(/^(?:(\s*[\$\w]+)|\(\s*([\$\w]+)\s*,\s*([\$\w]+)\s*\))$/), !he)
          throw I(
            "iidexp",
            "'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.",
            ye
          );
        var Te = he[3] || he[1], _e = he[2];
        if (Pe && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(Pe) || /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(Pe)))
          throw I(
            "badident",
            "alias '{0}' is invalid --- must be a valid JS identifier which is not a reserved name.",
            Pe
          );
        var Ie, De, Re, qe, Oe = { $id: z };
        return be ? Ie = A(be) : (Re = function(rt, Xe) {
          return z(Xe);
        }, qe = function(rt) {
          return rt;
        }), function(Xe, Je, Qe, tt, dt) {
          Ie && (De = function(it, wt, Ct) {
            return _e && (Oe[_e] = it), Oe[Te] = wt, Oe.$index = Ct, Ie(Xe, Oe);
          });
          var Ye = xi();
          Xe.$watchCollection(Se, function(wt) {
            var Ct, yr, Lr = Je[0], Hr, di = xi(), Jr, ii, Li, cn, Gi, Ii, Di, Na, xu;
            if (Pe && (Xe[Pe] = wt), S(wt))
              Ii = wt, Gi = De || Re;
            else {
              Gi = De || qe, Ii = [];
              for (var Au in wt)
                o.call(wt, Au) && Au.charAt(0) !== "$" && Ii.push(Au);
            }
            for (Jr = Ii.length, Na = new Array(Jr), Ct = 0; Ct < Jr; Ct++)
              if (ii = wt === Ii ? Ct : Ii[Ct], Li = wt[ii], cn = Gi(ii, Li, Ct), Ye[cn])
                Di = Ye[cn], delete Ye[cn], di[cn] = Di, Na[Ct] = Di;
              else {
                if (di[cn])
                  throw T(Na, function(wu) {
                    wu && wu.scope && (Ye[wu.id] = wu);
                  }), I(
                    "dupes",
                    "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}",
                    Z,
                    cn,
                    Li
                  );
                Na[Ct] = { id: cn, scope: i, clone: i }, di[cn] = !0;
              }
            for (var Tp in Ye) {
              if (Di = Ye[Tp], xu = Za(Di.clone), k.leave(xu), xu[0].parentNode)
                for (Ct = 0, yr = xu.length; Ct < yr; Ct++)
                  xu[Ct][L] = !0;
              Di.scope.$destroy();
            }
            for (Ct = 0; Ct < Jr; Ct++)
              if (ii = wt === Ii ? Ct : Ii[Ct], Li = wt[ii], Di = Na[Ct], Di.scope) {
                Hr = Lr;
                do
                  Hr = Hr.nextSibling;
                while (Hr && Hr[L]);
                U(Di) != Hr && k.move(Za(Di.clone), null, Lr), Lr = j(Di), B(Di.scope, Ct, Te, Li, _e, ii, Jr);
              } else
                dt(function(eo, Qd) {
                  Di.scope = Qd;
                  var kc = fe.cloneNode(!1);
                  eo[eo.length++] = kc, k.enter(eo, null, Lr), Lr = kc, Di.clone = eo, di[Di.id] = Di, B(Di.scope, Ct, Te, Li, _e, ii, Jr);
                });
            Ye = di;
          });
        };
      }
    };
  }], Sy = "ng-hide", Ey = "ng-hide-animate", m1 = ["$animate", function(A) {
    return {
      restrict: "A",
      multiElement: !0,
      link: function(k, L, I) {
        k.$watch(I.ngShow, function(U) {
          A[U ? "removeClass" : "addClass"](L, Sy, {
            tempClasses: Ey
          });
        });
      }
    };
  }], y1 = ["$animate", function(A) {
    return {
      restrict: "A",
      multiElement: !0,
      link: function(k, L, I) {
        k.$watch(I.ngHide, function(U) {
          A[U ? "addClass" : "removeClass"](L, Sy, {
            tempClasses: Ey
          });
        });
      }
    };
  }], _1 = Eu(function(A, k, L) {
    A.$watch(L.ngStyle, function(B, U) {
      U && B !== U && T(U, function(j, H) {
        k.css(H, "");
      }), B && k.css(B);
    }, !0);
  }), b1 = ["$animate", function(A) {
    return {
      require: "ngSwitch",
      controller: ["$scope", function() {
        this.cases = {};
      }],
      link: function(k, L, I, B) {
        var U = I.ngSwitch || I.on, j = [], H = [], W = [], X = [], Z = function(fe, he) {
          return function() {
            fe.splice(he, 1);
          };
        };
        k.$watch(U, function(he) {
          var ye, Se;
          for (ye = 0, Se = W.length; ye < Se; ++ye)
            A.cancel(W[ye]);
          for (W.length = 0, ye = 0, Se = X.length; ye < Se; ++ye) {
            var Pe = Za(H[ye].clone);
            X[ye].$destroy();
            var be = W[ye] = A.leave(Pe);
            be.then(Z(W, ye));
          }
          H.length = 0, X.length = 0, (j = B.cases["!" + he] || B.cases["?"]) && T(j, function(Te) {
            Te.transclude(function(_e, Ie) {
              X.push(Ie);
              var De = Te.element;
              _e[_e.length++] = r.createComment(" end ngSwitchWhen: ");
              var Re = { clone: _e };
              H.push(Re), A.enter(_e, De.parent(), De);
            });
          });
        });
      }
    };
  }], T1 = Eu({
    transclude: "element",
    priority: 1200,
    require: "^ngSwitch",
    multiElement: !0,
    link: function(A, k, L, I, B) {
      I.cases["!" + L.ngSwitchWhen] = I.cases["!" + L.ngSwitchWhen] || [], I.cases["!" + L.ngSwitchWhen].push({ transclude: B, element: k });
    }
  }), S1 = Eu({
    transclude: "element",
    priority: 1200,
    require: "^ngSwitch",
    multiElement: !0,
    link: function(A, k, L, I, B) {
      I.cases["?"] = I.cases["?"] || [], I.cases["?"].push({ transclude: B, element: k });
    }
  }), E1 = Eu({
    restrict: "EAC",
    link: function(A, k, L, I, B) {
      if (!B)
        throw t("ngTransclude")(
          "orphan",
          "Illegal use of ngTransclude directive in the template! No parent directive that requires a transclusion found. Element: {0}",
          Ei(k)
        );
      B(function(U) {
        k.empty(), k.append(U);
      });
    }
  }), x1 = ["$templateCache", function(A) {
    return {
      restrict: "E",
      terminal: !0,
      compile: function(k, L) {
        if (L.type == "text/ng-template") {
          var I = L.id, B = k[0].text;
          A.put(I, B);
        }
      }
    };
  }], A1 = { $setViewValue: G, $render: G };
  function w1(A) {
    A[0].hasAttribute("selected") && (A[0].selected = !0);
  }
  var C1 = ["$element", "$scope", "$attrs", function(A, k, L) {
    var I = this, B = new ie();
    I.ngModelCtrl = A1, I.unknownOption = d(r.createElement("option")), I.renderUnknownOption = function(U) {
      var j = "? " + z(U) + " ?";
      I.unknownOption.val(j), A.prepend(I.unknownOption), A.val(j);
    }, k.$on("$destroy", function() {
      I.renderUnknownOption = G;
    }), I.removeUnknownOption = function() {
      I.unknownOption.parent() && I.unknownOption.remove();
    }, I.readValue = function() {
      return I.removeUnknownOption(), A.val();
    }, I.writeValue = function(j) {
      I.hasOption(j) ? (I.removeUnknownOption(), A.val(j), j === "" && I.emptyOption.prop("selected", !0)) : j == null && I.emptyOption ? (I.removeUnknownOption(), A.val("")) : I.renderUnknownOption(j);
    }, I.addOption = function(U, j) {
      if (j[0].nodeType !== Dn) {
        pa(U, '"option value"'), U === "" && (I.emptyOption = j);
        var H = B.get(U) || 0;
        B.put(U, H + 1), I.ngModelCtrl.$render(), w1(j);
      }
    }, I.removeOption = function(U) {
      var j = B.get(U);
      j && (j === 1 ? (B.remove(U), U === "" && (I.emptyOption = i)) : B.put(U, j - 1));
    }, I.hasOption = function(U) {
      return !!B.get(U);
    }, I.registerOption = function(U, j, H, W, X) {
      if (W) {
        var Z;
        H.$observe("value", function(he) {
          ee(Z) && I.removeOption(Z), Z = he, I.addOption(he, j);
        });
      } else
        X ? U.$watch(X, function(he, ye) {
          H.$set("value", he), ye !== he && I.removeOption(ye), I.addOption(he, j);
        }) : I.addOption(H.value, j);
      j.on("$destroy", function() {
        I.removeOption(H.value), I.ngModelCtrl.$render();
      });
    };
  }], D1 = function() {
    return {
      restrict: "E",
      require: ["select", "?ngModel"],
      controller: C1,
      priority: 1,
      link: {
        pre: A,
        post: k
      }
    };
    function A(L, I, B, U) {
      var j = U[1];
      if (!!j) {
        var H = U[0];
        if (H.ngModelCtrl = j, I.on("change", function() {
          L.$apply(function() {
            j.$setViewValue(H.readValue());
          });
        }), B.multiple) {
          H.readValue = function() {
            var fe = [];
            return T(I.find("option"), function(he) {
              he.selected && fe.push(he.value);
            }), fe;
          }, H.writeValue = function(fe) {
            var he = new ie(fe);
            T(I.find("option"), function(ye) {
              ye.selected = ee(he.get(ye.value));
            });
          };
          var W, X = NaN;
          L.$watch(function() {
            X === j.$viewValue && !li(W, j.$viewValue) && (W = Gr(j.$viewValue), j.$render()), X = j.$viewValue;
          }), j.$isEmpty = function(Z) {
            return !Z || Z.length === 0;
          };
        }
      }
    }
    function k(L, I, B, U) {
      var j = U[1];
      if (!!j) {
        var H = U[0];
        j.$render = function() {
          H.writeValue(j.$viewValue);
        };
      }
    }
  }, k1 = ["$interpolate", function(A) {
    return {
      restrict: "E",
      priority: 100,
      compile: function(k, L) {
        if (ee(L.value))
          var I = A(L.value, !0);
        else {
          var B = A(k.text(), !0);
          B || L.$set("value", k.text());
        }
        return function(U, j, H) {
          var W = "$selectController", X = j.parent(), Z = X.data(W) || X.parent().data(W);
          Z && Z.registerOption(U, j, H, I, B);
        };
      }
    };
  }], R1 = J({
    restrict: "E",
    terminal: !1
  }), xy = function() {
    return {
      restrict: "A",
      require: "?ngModel",
      link: function(A, k, L, I) {
        !I || (L.required = !0, I.$validators.required = function(B, U) {
          return !L.required || !I.$isEmpty(U);
        }, L.$observe("required", function() {
          I.$validate();
        }));
      }
    };
  }, Ay = function() {
    return {
      restrict: "A",
      require: "?ngModel",
      link: function(A, k, L, I) {
        if (!!I) {
          var B, U = L.ngPattern || L.pattern;
          L.$observe("pattern", function(j) {
            if (Ne(j) && j.length > 0 && (j = new RegExp("^" + j + "$")), j && !j.test)
              throw t("ngPattern")(
                "noregexp",
                "Expected {0} to be a RegExp but was {1}. Element: {2}",
                U,
                j,
                Ei(k)
              );
            B = j || i, I.$validate();
          }), I.$validators.pattern = function(j, H) {
            return I.$isEmpty(H) || ce(B) || B.test(H);
          };
        }
      }
    };
  }, wy = function() {
    return {
      restrict: "A",
      require: "?ngModel",
      link: function(A, k, L, I) {
        if (!!I) {
          var B = -1;
          L.$observe("maxlength", function(U) {
            var j = M(U);
            B = isNaN(j) ? -1 : j, I.$validate();
          }), I.$validators.maxlength = function(U, j) {
            return B < 0 || I.$isEmpty(j) || j.length <= B;
          };
        }
      }
    };
  }, Cy = function() {
    return {
      restrict: "A",
      require: "?ngModel",
      link: function(A, k, L, I) {
        if (!!I) {
          var B = 0;
          L.$observe("minlength", function(U) {
            B = M(U) || 0, I.$validate();
          }), I.$validators.minlength = function(U, j) {
            return I.$isEmpty(j) || j.length >= B;
          };
        }
      }
    };
  };
  if (e.angular.bootstrap) {
    e.console && console.log("WARNING: Tried to load angular more than once.");
    return;
  }
  Qi(), ga(E), E.module("ngLocale", [], ["$provide", function(A) {
    var k = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
    function L(B) {
      B = B + "";
      var U = B.indexOf(".");
      return U == -1 ? 0 : B.length - U - 1;
    }
    function I(B, U) {
      var j = U;
      i === j && (j = Math.min(L(B), 3));
      var H = Math.pow(10, j), W = (B * H | 0) % H;
      return { v: j, f: W };
    }
    A.value("$locale", {
      DATETIME_FORMATS: {
        AMPMS: [
          "AM",
          "PM"
        ],
        DAY: [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday"
        ],
        ERANAMES: [
          "Before Christ",
          "Anno Domini"
        ],
        ERAS: [
          "BC",
          "AD"
        ],
        FIRSTDAYOFWEEK: 6,
        MONTH: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ],
        SHORTDAY: [
          "Sun",
          "Mon",
          "Tue",
          "Wed",
          "Thu",
          "Fri",
          "Sat"
        ],
        SHORTMONTH: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ],
        STANDALONEMONTH: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ],
        WEEKENDRANGE: [
          5,
          6
        ],
        fullDate: "EEEE, MMMM d, y",
        longDate: "MMMM d, y",
        medium: "MMM d, y h:mm:ss a",
        mediumDate: "MMM d, y",
        mediumTime: "h:mm:ss a",
        short: "M/d/yy h:mm a",
        shortDate: "M/d/yy",
        shortTime: "h:mm a"
      },
      NUMBER_FORMATS: {
        CURRENCY_SYM: "$",
        DECIMAL_SEP: ".",
        GROUP_SEP: ",",
        PATTERNS: [
          {
            gSize: 3,
            lgSize: 3,
            maxFrac: 3,
            minFrac: 0,
            minInt: 1,
            negPre: "-",
            negSuf: "",
            posPre: "",
            posSuf: ""
          },
          {
            gSize: 3,
            lgSize: 3,
            maxFrac: 2,
            minFrac: 2,
            minInt: 1,
            negPre: "-\xA4",
            negSuf: "",
            posPre: "\xA4",
            posSuf: ""
          }
        ]
      },
      id: "en-us",
      localeID: "en_US",
      pluralCat: function(B, U) {
        var j = B | 0, H = I(B, U);
        return j == 1 && H.v == 0 ? k.ONE : k.OTHER;
      }
    });
  }]), d(r).ready(function() {
    on(r, Po);
  });
})(window, document);
!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');
var Nb = angular, Fb = { exports: {} };
(function(e, r) {
  typeof window < "u" && function(t, n) {
    e.exports = n();
  }(fn, function() {
    return function(i) {
      var t = {};
      function n(a) {
        if (t[a])
          return t[a].exports;
        var s = t[a] = {
          i: a,
          l: !1,
          exports: {}
        };
        return i[a].call(s.exports, s, s.exports, n), s.l = !0, s.exports;
      }
      return n.m = i, n.c = t, n.d = function(a, s, o) {
        n.o(a, s) || Object.defineProperty(a, s, { enumerable: !0, get: o });
      }, n.r = function(a) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(a, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(a, "__esModule", { value: !0 });
      }, n.t = function(a, s) {
        if (s & 1 && (a = n(a)), s & 8 || s & 4 && typeof a == "object" && a && a.__esModule)
          return a;
        var o = /* @__PURE__ */ Object.create(null);
        if (n.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: a }), s & 2 && typeof a != "string")
          for (var l in a)
            n.d(o, l, function(u) {
              return a[u];
            }.bind(null, l));
        return o;
      }, n.n = function(a) {
        var s = a && a.__esModule ? function() {
          return a.default;
        } : function() {
          return a;
        };
        return n.d(s, "a", s), s;
      }, n.o = function(a, s) {
        return Object.prototype.hasOwnProperty.call(a, s);
      }, n.p = "/dist/", n(n.s = "./src/hls.js");
    }({
      "./node_modules/eventemitter3/index.js": function(i, t, n) {
        var a = Object.prototype.hasOwnProperty, s = "~";
        function o() {
        }
        Object.create && (o.prototype = /* @__PURE__ */ Object.create(null), new o().__proto__ || (s = !1));
        function l(d, f, m) {
          this.fn = d, this.context = f, this.once = m || !1;
        }
        function u(d, f, m, p, b) {
          if (typeof m != "function")
            throw new TypeError("The listener must be a function");
          var y = new l(m, p || d, b), v = s ? s + f : f;
          return d._events[v] ? d._events[v].fn ? d._events[v] = [d._events[v], y] : d._events[v].push(y) : (d._events[v] = y, d._eventsCount++), d;
        }
        function h(d, f) {
          --d._eventsCount === 0 ? d._events = new o() : delete d._events[f];
        }
        function c() {
          this._events = new o(), this._eventsCount = 0;
        }
        c.prototype.eventNames = function() {
          var f = [], m, p;
          if (this._eventsCount === 0)
            return f;
          for (p in m = this._events)
            a.call(m, p) && f.push(s ? p.slice(1) : p);
          return Object.getOwnPropertySymbols ? f.concat(Object.getOwnPropertySymbols(m)) : f;
        }, c.prototype.listeners = function(f) {
          var m = s ? s + f : f, p = this._events[m];
          if (!p)
            return [];
          if (p.fn)
            return [p.fn];
          for (var b = 0, y = p.length, v = new Array(y); b < y; b++)
            v[b] = p[b].fn;
          return v;
        }, c.prototype.listenerCount = function(f) {
          var m = s ? s + f : f, p = this._events[m];
          return p ? p.fn ? 1 : p.length : 0;
        }, c.prototype.emit = function(f, m, p, b, y, v) {
          var g = s ? s + f : f;
          if (!this._events[g])
            return !1;
          var E = this._events[g], x = arguments.length, w, S;
          if (E.fn) {
            switch (E.once && this.removeListener(f, E.fn, void 0, !0), x) {
              case 1:
                return E.fn.call(E.context), !0;
              case 2:
                return E.fn.call(E.context, m), !0;
              case 3:
                return E.fn.call(E.context, m, p), !0;
              case 4:
                return E.fn.call(E.context, m, p, b), !0;
              case 5:
                return E.fn.call(E.context, m, p, b, y), !0;
              case 6:
                return E.fn.call(E.context, m, p, b, y, v), !0;
            }
            for (S = 1, w = new Array(x - 1); S < x; S++)
              w[S - 1] = arguments[S];
            E.fn.apply(E.context, w);
          } else {
            var T = E.length, C;
            for (S = 0; S < T; S++)
              switch (E[S].once && this.removeListener(f, E[S].fn, void 0, !0), x) {
                case 1:
                  E[S].fn.call(E[S].context);
                  break;
                case 2:
                  E[S].fn.call(E[S].context, m);
                  break;
                case 3:
                  E[S].fn.call(E[S].context, m, p);
                  break;
                case 4:
                  E[S].fn.call(E[S].context, m, p, b);
                  break;
                default:
                  if (!w)
                    for (C = 1, w = new Array(x - 1); C < x; C++)
                      w[C - 1] = arguments[C];
                  E[S].fn.apply(E[S].context, w);
              }
          }
          return !0;
        }, c.prototype.on = function(f, m, p) {
          return u(this, f, m, p, !1);
        }, c.prototype.once = function(f, m, p) {
          return u(this, f, m, p, !0);
        }, c.prototype.removeListener = function(f, m, p, b) {
          var y = s ? s + f : f;
          if (!this._events[y])
            return this;
          if (!m)
            return h(this, y), this;
          var v = this._events[y];
          if (v.fn)
            v.fn === m && (!b || v.once) && (!p || v.context === p) && h(this, y);
          else {
            for (var g = 0, E = [], x = v.length; g < x; g++)
              (v[g].fn !== m || b && !v[g].once || p && v[g].context !== p) && E.push(v[g]);
            E.length ? this._events[y] = E.length === 1 ? E[0] : E : h(this, y);
          }
          return this;
        }, c.prototype.removeAllListeners = function(f) {
          var m;
          return f ? (m = s ? s + f : f, this._events[m] && h(this, m)) : (this._events = new o(), this._eventsCount = 0), this;
        }, c.prototype.off = c.prototype.removeListener, c.prototype.addListener = c.prototype.on, c.prefixed = s, c.EventEmitter = c, i.exports = c;
      },
      "./node_modules/node-libs-browser/node_modules/events/events.js": function(i, t) {
        function n() {
          this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
        }
        i.exports = n, n.EventEmitter = n, n.prototype._events = void 0, n.prototype._maxListeners = void 0, n.defaultMaxListeners = 10, n.prototype.setMaxListeners = function(u) {
          if (!s(u) || u < 0 || isNaN(u))
            throw TypeError("n must be a positive number");
          return this._maxListeners = u, this;
        }, n.prototype.emit = function(u) {
          var h, c, d, f, m, p;
          if (this._events || (this._events = {}), u === "error" && (!this._events.error || o(this._events.error) && !this._events.error.length)) {
            if (h = arguments[1], h instanceof Error)
              throw h;
            var b = new Error('Uncaught, unspecified "error" event. (' + h + ")");
            throw b.context = h, b;
          }
          if (c = this._events[u], l(c))
            return !1;
          if (a(c))
            switch (arguments.length) {
              case 1:
                c.call(this);
                break;
              case 2:
                c.call(this, arguments[1]);
                break;
              case 3:
                c.call(this, arguments[1], arguments[2]);
                break;
              default:
                f = Array.prototype.slice.call(arguments, 1), c.apply(this, f);
            }
          else if (o(c))
            for (f = Array.prototype.slice.call(arguments, 1), p = c.slice(), d = p.length, m = 0; m < d; m++)
              p[m].apply(this, f);
          return !0;
        }, n.prototype.addListener = function(u, h) {
          var c;
          if (!a(h))
            throw TypeError("listener must be a function");
          return this._events || (this._events = {}), this._events.newListener && this.emit(
            "newListener",
            u,
            a(h.listener) ? h.listener : h
          ), this._events[u] ? o(this._events[u]) ? this._events[u].push(h) : this._events[u] = [this._events[u], h] : this._events[u] = h, o(this._events[u]) && !this._events[u].warned && (l(this._maxListeners) ? c = n.defaultMaxListeners : c = this._maxListeners, c && c > 0 && this._events[u].length > c && (this._events[u].warned = !0, console.error(
            "(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",
            this._events[u].length
          ), typeof console.trace == "function" && console.trace())), this;
        }, n.prototype.on = n.prototype.addListener, n.prototype.once = function(u, h) {
          if (!a(h))
            throw TypeError("listener must be a function");
          var c = !1;
          function d() {
            this.removeListener(u, d), c || (c = !0, h.apply(this, arguments));
          }
          return d.listener = h, this.on(u, d), this;
        }, n.prototype.removeListener = function(u, h) {
          var c, d, f, m;
          if (!a(h))
            throw TypeError("listener must be a function");
          if (!this._events || !this._events[u])
            return this;
          if (c = this._events[u], f = c.length, d = -1, c === h || a(c.listener) && c.listener === h)
            delete this._events[u], this._events.removeListener && this.emit("removeListener", u, h);
          else if (o(c)) {
            for (m = f; m-- > 0; )
              if (c[m] === h || c[m].listener && c[m].listener === h) {
                d = m;
                break;
              }
            if (d < 0)
              return this;
            c.length === 1 ? (c.length = 0, delete this._events[u]) : c.splice(d, 1), this._events.removeListener && this.emit("removeListener", u, h);
          }
          return this;
        }, n.prototype.removeAllListeners = function(u) {
          var h, c;
          if (!this._events)
            return this;
          if (!this._events.removeListener)
            return arguments.length === 0 ? this._events = {} : this._events[u] && delete this._events[u], this;
          if (arguments.length === 0) {
            for (h in this._events)
              h !== "removeListener" && this.removeAllListeners(h);
            return this.removeAllListeners("removeListener"), this._events = {}, this;
          }
          if (c = this._events[u], a(c))
            this.removeListener(u, c);
          else if (c)
            for (; c.length; )
              this.removeListener(u, c[c.length - 1]);
          return delete this._events[u], this;
        }, n.prototype.listeners = function(u) {
          var h;
          return !this._events || !this._events[u] ? h = [] : a(this._events[u]) ? h = [this._events[u]] : h = this._events[u].slice(), h;
        }, n.prototype.listenerCount = function(u) {
          if (this._events) {
            var h = this._events[u];
            if (a(h))
              return 1;
            if (h)
              return h.length;
          }
          return 0;
        }, n.listenerCount = function(u, h) {
          return u.listenerCount(h);
        };
        function a(u) {
          return typeof u == "function";
        }
        function s(u) {
          return typeof u == "number";
        }
        function o(u) {
          return typeof u == "object" && u !== null;
        }
        function l(u) {
          return u === void 0;
        }
      },
      "./node_modules/url-toolkit/src/url-toolkit.js": function(i, t, n) {
        (function(a) {
          var s = /^((?:[a-zA-Z0-9+\-.]+:)?)(\/\/[^\/?#]*)?((?:[^\/\?#]*\/)*.*?)??(;.*?)?(\?.*?)?(#.*?)?$/, o = /^([^\/?#]*)(.*)$/, l = /(?:\/|^)\.(?=\/)/g, u = /(?:\/|^)\.\.\/(?!\.\.\/).*?(?=\/)/g, h = {
            buildAbsoluteURL: function(c, d, f) {
              if (f = f || {}, c = c.trim(), d = d.trim(), !d) {
                if (!f.alwaysNormalize)
                  return c;
                var m = h.parseURL(c);
                if (!m)
                  throw new Error("Error trying to parse base URL.");
                return m.path = h.normalizePath(m.path), h.buildURLFromParts(m);
              }
              var p = h.parseURL(d);
              if (!p)
                throw new Error("Error trying to parse relative URL.");
              if (p.scheme)
                return f.alwaysNormalize ? (p.path = h.normalizePath(p.path), h.buildURLFromParts(p)) : d;
              var b = h.parseURL(c);
              if (!b)
                throw new Error("Error trying to parse base URL.");
              if (!b.netLoc && b.path && b.path[0] !== "/") {
                var y = o.exec(b.path);
                b.netLoc = y[1], b.path = y[2];
              }
              b.netLoc && !b.path && (b.path = "/");
              var v = {
                scheme: b.scheme,
                netLoc: p.netLoc,
                path: null,
                params: p.params,
                query: p.query,
                fragment: p.fragment
              };
              if (!p.netLoc && (v.netLoc = b.netLoc, p.path[0] !== "/"))
                if (!p.path)
                  v.path = b.path, p.params || (v.params = b.params, p.query || (v.query = b.query));
                else {
                  var g = b.path, E = g.substring(0, g.lastIndexOf("/") + 1) + p.path;
                  v.path = h.normalizePath(E);
                }
              return v.path === null && (v.path = f.alwaysNormalize ? h.normalizePath(p.path) : p.path), h.buildURLFromParts(v);
            },
            parseURL: function(c) {
              var d = s.exec(c);
              return d ? {
                scheme: d[1] || "",
                netLoc: d[2] || "",
                path: d[3] || "",
                params: d[4] || "",
                query: d[5] || "",
                fragment: d[6] || ""
              } : null;
            },
            normalizePath: function(c) {
              for (c = c.split("").reverse().join("").replace(l, ""); c.length !== (c = c.replace(u, "")).length; )
                ;
              return c.split("").reverse().join("");
            },
            buildURLFromParts: function(c) {
              return c.scheme + c.netLoc + c.path + c.params + c.query + c.fragment;
            }
          };
          i.exports = h;
        })();
      },
      "./node_modules/webworkify-webpack/index.js": function(i, t, n) {
        function a(f) {
          var m = {};
          function p(y) {
            if (m[y])
              return m[y].exports;
            var v = m[y] = {
              i: y,
              l: !1,
              exports: {}
            };
            return f[y].call(v.exports, v, v.exports, p), v.l = !0, v.exports;
          }
          p.m = f, p.c = m, p.i = function(y) {
            return y;
          }, p.d = function(y, v, g) {
            p.o(y, v) || Object.defineProperty(y, v, {
              configurable: !1,
              enumerable: !0,
              get: g
            });
          }, p.r = function(y) {
            Object.defineProperty(y, "__esModule", { value: !0 });
          }, p.n = function(y) {
            var v = y && y.__esModule ? function() {
              return y.default;
            } : function() {
              return y;
            };
            return p.d(v, "a", v), v;
          }, p.o = function(y, v) {
            return Object.prototype.hasOwnProperty.call(y, v);
          }, p.p = "/", p.oe = function(y) {
            throw console.error(y), y;
          };
          var b = p(p.s = ENTRY_MODULE);
          return b.default || b;
        }
        var s = "[\\.|\\-|\\+|\\w|/|@]+", o = "\\((/\\*.*?\\*/)?s?.*?(" + s + ").*?\\)";
        function l(f) {
          return (f + "").replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
        }
        function u(f) {
          return !isNaN(1 * f);
        }
        function h(f, m, p) {
          var b = {};
          b[p] = [];
          var y = m.toString(), v = y.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);
          if (!v)
            return b;
          for (var g = v[1], E = new RegExp("(\\\\n|\\W)" + l(g) + o, "g"), x; x = E.exec(y); )
            x[3] !== "dll-reference" && b[p].push(x[3]);
          for (E = new RegExp("\\(" + l(g) + '\\("(dll-reference\\s(' + s + '))"\\)\\)' + o, "g"); x = E.exec(y); )
            f[x[2]] || (b[p].push(x[1]), f[x[2]] = n(x[1]).m), b[x[2]] = b[x[2]] || [], b[x[2]].push(x[4]);
          for (var w = Object.keys(b), S = 0; S < w.length; S++)
            for (var T = 0; T < b[w[S]].length; T++)
              u(b[w[S]][T]) && (b[w[S]][T] = 1 * b[w[S]][T]);
          return b;
        }
        function c(f) {
          var m = Object.keys(f);
          return m.reduce(function(p, b) {
            return p || f[b].length > 0;
          }, !1);
        }
        function d(f, m) {
          for (var p = {
            main: [m]
          }, b = {
            main: []
          }, y = {
            main: {}
          }; c(p); )
            for (var v = Object.keys(p), g = 0; g < v.length; g++) {
              var E = v[g], x = p[E], w = x.pop();
              if (y[E] = y[E] || {}, !(y[E][w] || !f[E][w])) {
                y[E][w] = !0, b[E] = b[E] || [], b[E].push(w);
                for (var S = h(f, f[E][w], E), T = Object.keys(S), C = 0; C < T.length; C++)
                  p[T[C]] = p[T[C]] || [], p[T[C]] = p[T[C]].concat(S[T[C]]);
              }
            }
          return b;
        }
        i.exports = function(f, m) {
          m = m || {};
          var p = {
            main: n.m
          }, b = m.all ? { main: Object.keys(p.main) } : d(p, f), y = "";
          Object.keys(b).filter(function(w) {
            return w !== "main";
          }).forEach(function(w) {
            for (var S = 0; b[w][S]; )
              S++;
            b[w].push(S), p[w][S] = "(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })", y = y + "var " + w + " = (" + a.toString().replace("ENTRY_MODULE", JSON.stringify(S)) + ")({" + b[w].map(function(T) {
              return "" + JSON.stringify(T) + ": " + p[w][T].toString();
            }).join(",") + `});
`;
          }), y = y + "new ((" + a.toString().replace("ENTRY_MODULE", JSON.stringify(f)) + ")({" + b.main.map(function(w) {
            return "" + JSON.stringify(w) + ": " + p.main[w].toString();
          }).join(",") + "}))(self);";
          var v = new window.Blob([y], { type: "text/javascript" });
          if (m.bare)
            return v;
          var g = window.URL || window.webkitURL || window.mozURL || window.msURL, E = g.createObjectURL(v), x = new window.Worker(E);
          return x.objectURL = E, x;
        };
      },
      "./src/config.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/controller/abr-controller.js"), s = n("./src/controller/buffer-controller.js"), o = n("./src/controller/cap-level-controller.js"), l = n("./src/controller/fps-controller.js"), u = n("./src/utils/xhr-loader.js"), h = n("./src/controller/audio-track-controller.js"), c = n("./src/controller/audio-stream-controller.js"), d = n("./src/utils/cues.js"), f = n("./src/controller/timeline-controller.js"), m = n("./src/controller/subtitle-track-controller.js"), p = n("./src/controller/subtitle-stream-controller.js"), b = n("./src/controller/eme-controller.js"), y = n("./src/utils/mediakeys-helper.js");
        t.hlsDefaultConfig = {
          autoStartLoad: !0,
          startPosition: -1,
          defaultAudioCodec: void 0,
          debug: !1,
          capLevelOnFPSDrop: !1,
          capLevelToPlayerSize: !1,
          initialLiveManifestSize: 1,
          maxBufferLength: 30,
          maxBufferSize: 60 * 1e3 * 1e3,
          maxBufferHole: 0.5,
          lowBufferWatchdogPeriod: 0.5,
          highBufferWatchdogPeriod: 3,
          nudgeOffset: 0.1,
          nudgeMaxRetry: 3,
          maxFragLookUpTolerance: 0.25,
          liveSyncDurationCount: 3,
          liveMaxLatencyDurationCount: 1 / 0,
          liveSyncDuration: void 0,
          liveMaxLatencyDuration: void 0,
          liveDurationInfinity: !1,
          liveBackBufferLength: 1 / 0,
          maxMaxBufferLength: 600,
          enableWorker: !0,
          enableSoftwareAES: !0,
          manifestLoadingTimeOut: 1e4,
          manifestLoadingMaxRetry: 1,
          manifestLoadingRetryDelay: 1e3,
          manifestLoadingMaxRetryTimeout: 64e3,
          startLevel: void 0,
          levelLoadingTimeOut: 1e4,
          levelLoadingMaxRetry: 4,
          levelLoadingRetryDelay: 1e3,
          levelLoadingMaxRetryTimeout: 64e3,
          fragLoadingTimeOut: 2e4,
          fragLoadingMaxRetry: 6,
          fragLoadingRetryDelay: 1e3,
          fragLoadingMaxRetryTimeout: 64e3,
          startFragPrefetch: !1,
          fpsDroppedMonitoringPeriod: 5e3,
          fpsDroppedMonitoringThreshold: 0.2,
          appendErrorMaxRetry: 3,
          loader: u.default,
          fLoader: void 0,
          pLoader: void 0,
          xhrSetup: void 0,
          licenseXhrSetup: void 0,
          abrController: a.default,
          bufferController: s.default,
          capLevelController: o.default,
          fpsController: l.default,
          stretchShortVideoTrack: !1,
          maxAudioFramesDrift: 1,
          forceKeyFrameOnDiscontinuity: !0,
          abrEwmaFastLive: 3,
          abrEwmaSlowLive: 9,
          abrEwmaFastVoD: 3,
          abrEwmaSlowVoD: 9,
          abrEwmaDefaultEstimate: 5e5,
          abrBandWidthFactor: 0.95,
          abrBandWidthUpFactor: 0.7,
          abrMaxWithRealBitrate: !1,
          maxStarvationDelay: 4,
          maxLoadingDelay: 4,
          minAutoBitrate: 0,
          emeEnabled: !1,
          widevineLicenseUrl: void 0,
          requestMediaKeySystemAccessFunc: y.requestMediaKeySystemAccess
        }, t.hlsDefaultConfig.subtitleStreamController = p.SubtitleStreamController, t.hlsDefaultConfig.subtitleTrackController = m.default, t.hlsDefaultConfig.timelineController = f.default, t.hlsDefaultConfig.cueHandler = d, t.hlsDefaultConfig.enableCEA708Captions = !0, t.hlsDefaultConfig.enableWebVTT = !0, t.hlsDefaultConfig.captionsTextTrack1Label = "English", t.hlsDefaultConfig.captionsTextTrack1LanguageCode = "en", t.hlsDefaultConfig.captionsTextTrack2Label = "Spanish", t.hlsDefaultConfig.captionsTextTrack2LanguageCode = "es", t.hlsDefaultConfig.audioStreamController = c.default, t.hlsDefaultConfig.audioTrackController = h.default, t.hlsDefaultConfig.emeController = b.default;
      },
      "./src/controller/abr-controller.js": function(i, t, n) {
        (function(a) {
          var s = this && this.__extends || function() {
            var p = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(b, y) {
              b.__proto__ = y;
            } || function(b, y) {
              for (var v in y)
                y.hasOwnProperty(v) && (b[v] = y[v]);
            };
            return function(b, y) {
              p(b, y);
              function v() {
                this.constructor = b;
              }
              b.prototype = y === null ? Object.create(y) : (v.prototype = y.prototype, new v());
            };
          }();
          Object.defineProperty(t, "__esModule", { value: !0 });
          var o = n("./src/events.js"), l = n("./src/event-handler.js"), u = n("./src/utils/buffer-helper.js"), h = n("./src/errors.js"), c = n("./src/utils/logger.js"), d = n("./src/utils/ewma-bandwidth-estimator.js"), f = window.performance, m = function(p) {
            s(b, p);
            function b(y) {
              var v = p.call(this, y, o.default.FRAG_LOADING, o.default.FRAG_LOADED, o.default.FRAG_BUFFERED, o.default.ERROR) || this;
              return v.lastLoadedFragLevel = 0, v._nextAutoLevel = -1, v.hls = y, v.timer = null, v._bwEstimator = null, v.onCheck = v._abandonRulesCheck.bind(v), v;
            }
            return b.prototype.destroy = function() {
              this.clearTimer(), l.default.prototype.destroy.call(this);
            }, b.prototype.onFragLoading = function(y) {
              var v = y.frag;
              if (v.type === "main" && (this.timer || (this.fragCurrent = v, this.timer = setInterval(this.onCheck, 100)), !this._bwEstimator)) {
                var g = this.hls, E = g.config, x = v.level, w = g.levels[x].details.live, S = void 0, T = void 0;
                w ? (S = E.abrEwmaFastLive, T = E.abrEwmaSlowLive) : (S = E.abrEwmaFastVoD, T = E.abrEwmaSlowVoD), this._bwEstimator = new d.default(g, T, S, E.abrEwmaDefaultEstimate);
              }
            }, b.prototype._abandonRulesCheck = function() {
              var y = this.hls, v = y.media, g = this.fragCurrent;
              if (!!g) {
                var E = g.loader, x = y.minAutoLevel;
                if (!E || E.stats && E.stats.aborted) {
                  c.logger.warn("frag loader destroy or aborted, disarm abandonRules"), this.clearTimer(), this._nextAutoLevel = -1;
                  return;
                }
                var w = E.stats;
                if (v && w && (!v.paused && v.playbackRate !== 0 || !v.readyState) && g.autoLevel && g.level) {
                  var S = f.now() - w.trequest, T = Math.abs(v.playbackRate);
                  if (S > 500 * g.duration / T) {
                    var C = y.levels, D = Math.max(1, w.bw ? w.bw / 8 : w.loaded * 1e3 / S), R = C[g.level], P = R.realBitrate ? Math.max(R.realBitrate, R.bitrate) : R.bitrate, N = w.total ? w.total : Math.max(w.loaded, Math.round(g.duration * P / 8)), $ = v.currentTime, O = (N - w.loaded) / D, M = (u.BufferHelper.bufferInfo(v, $, y.config.maxBufferHole).end - $) / T;
                    if (M < 2 * g.duration / T && O > M) {
                      var F = void 0, G = void 0;
                      for (G = g.level - 1; G > x; G--) {
                        var K = C[G].realBitrate ? Math.max(C[G].realBitrate, C[G].bitrate) : C[G].bitrate;
                        if (F = g.duration * K / (8 * 0.8 * D), F < M)
                          break;
                      }
                      F < O && (c.logger.warn("loading too slow, abort fragment loading and switch to level " + G + ":fragLoadedDelay[" + G + "]<fragLoadedDelay[" + (g.level - 1) + "];bufferStarvationDelay:" + F.toFixed(1) + "<" + O.toFixed(1) + ":" + M.toFixed(1)), y.nextLoadLevel = G, this._bwEstimator.sample(S, w.loaded), E.abort(), this.clearTimer(), y.trigger(o.default.FRAG_LOAD_EMERGENCY_ABORTED, { frag: g, stats: w }));
                    }
                  }
                }
              }
            }, b.prototype.onFragLoaded = function(y) {
              var v = y.frag;
              if (v.type === "main" && a.isFinite(v.sn)) {
                if (this.clearTimer(), this.lastLoadedFragLevel = v.level, this._nextAutoLevel = -1, this.hls.config.abrMaxWithRealBitrate) {
                  var g = this.hls.levels[v.level], E = (g.loaded ? g.loaded.bytes : 0) + y.stats.loaded, x = (g.loaded ? g.loaded.duration : 0) + y.frag.duration;
                  g.loaded = { bytes: E, duration: x }, g.realBitrate = Math.round(8 * E / x);
                }
                if (y.frag.bitrateTest) {
                  var w = y.stats;
                  w.tparsed = w.tbuffered = w.tload, this.onFragBuffered(y);
                }
              }
            }, b.prototype.onFragBuffered = function(y) {
              var v = y.stats, g = y.frag;
              if (v.aborted !== !0 && g.type === "main" && a.isFinite(g.sn) && (!g.bitrateTest || v.tload === v.tbuffered)) {
                var E = v.tparsed - v.trequest;
                c.logger.log("latency/loading/parsing/append/kbps:" + Math.round(v.tfirst - v.trequest) + "/" + Math.round(v.tload - v.tfirst) + "/" + Math.round(v.tparsed - v.tload) + "/" + Math.round(v.tbuffered - v.tparsed) + "/" + Math.round(8 * v.loaded / (v.tbuffered - v.trequest))), this._bwEstimator.sample(E, v.loaded), v.bwEstimate = this._bwEstimator.getEstimate(), g.bitrateTest ? this.bitrateTestDelay = E / 1e3 : this.bitrateTestDelay = 0;
              }
            }, b.prototype.onError = function(y) {
              switch (y.details) {
                case h.ErrorDetails.FRAG_LOAD_ERROR:
                case h.ErrorDetails.FRAG_LOAD_TIMEOUT:
                  this.clearTimer();
                  break;
              }
            }, b.prototype.clearTimer = function() {
              clearInterval(this.timer), this.timer = null;
            }, Object.defineProperty(b.prototype, "nextAutoLevel", {
              get: function() {
                var y = this._nextAutoLevel, v = this._bwEstimator;
                if (y !== -1 && (!v || !v.canEstimate()))
                  return y;
                var g = this._nextABRAutoLevel;
                return y !== -1 && (g = Math.min(y, g)), g;
              },
              set: function(y) {
                this._nextAutoLevel = y;
              },
              enumerable: !0,
              configurable: !0
            }), Object.defineProperty(b.prototype, "_nextABRAutoLevel", {
              get: function() {
                var y = this.hls, v = y.maxAutoLevel, g = y.levels, E = y.config, x = y.minAutoLevel, w = y.media, S = this.lastLoadedFragLevel, T = this.fragCurrent ? this.fragCurrent.duration : 0, C = w ? w.currentTime : 0, D = w && w.playbackRate !== 0 ? Math.abs(w.playbackRate) : 1, R = this._bwEstimator ? this._bwEstimator.getEstimate() : E.abrEwmaDefaultEstimate, P = (u.BufferHelper.bufferInfo(w, C, E.maxBufferHole).end - C) / D, N = this._findBestLevel(S, T, R, x, v, P, E.abrBandWidthFactor, E.abrBandWidthUpFactor, g);
                if (N >= 0)
                  return N;
                c.logger.trace("rebuffering expected to happen, lets try to find a quality level minimizing the rebuffering");
                var $ = T ? Math.min(T, E.maxStarvationDelay) : E.maxStarvationDelay, O = E.abrBandWidthFactor, M = E.abrBandWidthUpFactor;
                if (P === 0) {
                  var F = this.bitrateTestDelay;
                  if (F) {
                    var G = T ? Math.min(T, E.maxLoadingDelay) : E.maxLoadingDelay;
                    $ = G - F, c.logger.trace("bitrate test took " + Math.round(1e3 * F) + "ms, set first fragment max fetchDuration to " + Math.round(1e3 * $) + " ms"), O = M = 1;
                  }
                }
                return N = this._findBestLevel(S, T, R, x, v, P + $, O, M, g), Math.max(N, 0);
              },
              enumerable: !0,
              configurable: !0
            }), b.prototype._findBestLevel = function(y, v, g, E, x, w, S, T, C) {
              for (var D = x; D >= E; D--) {
                var R = C[D];
                if (!!R) {
                  var P = R.details, N = P ? P.totalduration / P.fragments.length : v, $ = P ? P.live : !1, O = void 0;
                  D <= y ? O = S * g : O = T * g;
                  var M = C[D].realBitrate ? Math.max(C[D].realBitrate, C[D].bitrate) : C[D].bitrate, F = M * N / O;
                  if (c.logger.trace("level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: " + D + "/" + Math.round(O) + "/" + M + "/" + N + "/" + w + "/" + F), O > M && (!F || $ && !this.bitrateTestDelay || F < w))
                    return D;
                }
              }
              return -1;
            }, b;
          }(l.default);
          t.default = m;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/controller/audio-stream-controller.js": function(i, t, n) {
        (function(a) {
          var s = this && this.__extends || function() {
            var w = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(S, T) {
              S.__proto__ = T;
            } || function(S, T) {
              for (var C in T)
                T.hasOwnProperty(C) && (S[C] = T[C]);
            };
            return function(S, T) {
              w(S, T);
              function C() {
                this.constructor = S;
              }
              S.prototype = T === null ? Object.create(T) : (C.prototype = T.prototype, new C());
            };
          }();
          Object.defineProperty(t, "__esModule", { value: !0 });
          var o = n("./src/utils/binary-search.js"), l = n("./src/utils/buffer-helper.js"), u = n("./src/demux/demuxer.js"), h = n("./src/events.js"), c = n("./src/controller/level-helper.js"), d = n("./src/utils/time-ranges.js"), f = n("./src/errors.js"), m = n("./src/utils/logger.js"), p = n("./src/utils/discontinuities.js"), b = n("./src/controller/fragment-tracker.js"), y = n("./src/loader/fragment.js"), v = n("./src/controller/base-stream-controller.js"), g = window.performance, E = 100, x = function(w) {
            s(S, w);
            function S(T, C) {
              var D = w.call(this, T, h.default.MEDIA_ATTACHED, h.default.MEDIA_DETACHING, h.default.AUDIO_TRACKS_UPDATED, h.default.AUDIO_TRACK_SWITCHING, h.default.AUDIO_TRACK_LOADED, h.default.KEY_LOADED, h.default.FRAG_LOADED, h.default.FRAG_PARSING_INIT_SEGMENT, h.default.FRAG_PARSING_DATA, h.default.FRAG_PARSED, h.default.ERROR, h.default.BUFFER_RESET, h.default.BUFFER_CREATED, h.default.BUFFER_APPENDED, h.default.BUFFER_FLUSHED, h.default.INIT_PTS_FOUND) || this;
              return D.fragmentTracker = C, D.config = T.config, D.audioCodecSwap = !1, D._state = v.State.STOPPED, D.initPTS = [], D.waitingFragment = null, D.videoTrackCC = null, D;
            }
            return S.prototype.onInitPtsFound = function(T) {
              var C = T.id, D = T.frag.cc, R = T.initPTS;
              C === "main" && (this.initPTS[D] = R, this.videoTrackCC = D, m.logger.log("InitPTS for cc: " + D + " found from video track: " + R), this.state === v.State.WAITING_INIT_PTS && this.tick());
            }, S.prototype.startLoad = function(T) {
              if (this.tracks) {
                var C = this.lastCurrentTime;
                this.stopLoad(), this.setInterval(E), this.fragLoadError = 0, C > 0 && T === -1 ? (m.logger.log("audio:override startPosition with lastCurrentTime @" + C.toFixed(3)), this.state = v.State.IDLE) : (this.lastCurrentTime = this.startPosition ? this.startPosition : T, this.state = v.State.STARTING), this.nextLoadPosition = this.startPosition = this.lastCurrentTime, this.tick();
              } else
                this.startPosition = T, this.state = v.State.STOPPED;
            }, Object.defineProperty(S.prototype, "state", {
              get: function() {
                return this._state;
              },
              set: function(T) {
                if (this.state !== T) {
                  var C = this.state;
                  this._state = T, m.logger.log("audio stream:" + C + "->" + T);
                }
              },
              enumerable: !0,
              configurable: !0
            }), S.prototype.doTick = function() {
              var T, C, D, R = this.hls, P = R.config;
              switch (this.state) {
                case v.State.ERROR:
                case v.State.PAUSED:
                case v.State.BUFFER_FLUSHING:
                  break;
                case v.State.STARTING:
                  this.state = v.State.WAITING_TRACK, this.loadedmetadata = !1;
                  break;
                case v.State.IDLE:
                  var N = this.tracks;
                  if (!N || !this.media && (this.startFragRequested || !P.startFragPrefetch))
                    break;
                  if (this.loadedmetadata)
                    T = this.media.currentTime;
                  else if (T = this.nextLoadPosition, T === void 0)
                    break;
                  var $ = this.mediaBuffer ? this.mediaBuffer : this.media, O = this.videoBuffer ? this.videoBuffer : this.media, M = l.BufferHelper.bufferInfo($, T, P.maxBufferHole), F = l.BufferHelper.bufferInfo(O, T, P.maxBufferHole), G = M.len, K = M.end, J = this.fragPrevious, ue = Math.min(P.maxBufferLength, P.maxMaxBufferLength), ce = Math.max(ue, F.len), ee = this.audioSwitch, me = this.trackId;
                  if ((G < ce || ee) && me < N.length) {
                    if (D = N[me].details, typeof D > "u") {
                      this.state = v.State.WAITING_TRACK;
                      break;
                    }
                    if (!ee && this._streamEnded(M, D)) {
                      this.hls.trigger(h.default.BUFFER_EOS, { type: "audio" }), this.state = v.State.ENDED;
                      return;
                    }
                    var Ce = D.fragments, Ne = Ce.length, ot = Ce[0].start, ze = Ce[Ne - 1].start + Ce[Ne - 1].duration, $e = void 0;
                    if (ee) {
                      if (D.live && !D.PTSKnown)
                        m.logger.log("switching audiotrack, live stream, unknown PTS,load first fragment"), K = 0;
                      else if (K = T, D.PTSKnown && T < ot)
                        if (M.end > ot || M.nextStart)
                          m.logger.log("alt audio track ahead of main track, seek to start of alt audio track"), this.media.currentTime = ot + 0.05;
                        else
                          return;
                    }
                    if (D.initSegment && !D.initSegment.data)
                      $e = D.initSegment;
                    else if (K <= ot) {
                      if ($e = Ce[0], this.videoTrackCC !== null && $e.cc !== this.videoTrackCC && ($e = p.findFragWithCC(Ce, this.videoTrackCC)), D.live && $e.loadIdx && $e.loadIdx === this.fragLoadIdx) {
                        var Ze = M.nextStart ? M.nextStart : ot;
                        m.logger.log("no alt audio available @currentTime:" + this.media.currentTime + ", seeking @" + (Ze + 0.05)), this.media.currentTime = Ze + 0.05;
                        return;
                      }
                    } else {
                      var Ut = void 0, qt = P.maxFragLookUpTolerance, ir = J ? Ce[J.sn - Ce[0].sn + 1] : void 0, We = function(It) {
                        var sr = Math.min(qt, It.duration);
                        return It.start + It.duration - sr <= K ? 1 : It.start - sr > K && It.start ? -1 : 0;
                      };
                      K < ze ? (K > ze - qt && (qt = 0), ir && !We(ir) ? Ut = ir : Ut = o.default.search(Ce, We)) : Ut = Ce[Ne - 1], Ut && ($e = Ut, ot = Ut.start, J && $e.level === J.level && $e.sn === J.sn && ($e.sn < D.endSN ? ($e = Ce[$e.sn + 1 - D.startSN], m.logger.log("SN just loaded, load next one: " + $e.sn)) : $e = null));
                    }
                    $e && ($e.encrypted ? (m.logger.log("Loading key for " + $e.sn + " of [" + D.startSN + " ," + D.endSN + "],track " + me), this.state = v.State.KEY_LOADING, R.trigger(h.default.KEY_LOADING, { frag: $e })) : (m.logger.log("Loading " + $e.sn + ", cc: " + $e.cc + " of [" + D.startSN + " ," + D.endSN + "],track " + me + ", currentTime:" + T + ",bufferEnd:" + K.toFixed(3)), this.fragCurrent = $e, (ee || this.fragmentTracker.getState($e) === b.FragmentState.NOT_LOADED) && (this.startFragRequested = !0, a.isFinite($e.sn) && (this.nextLoadPosition = $e.start + $e.duration), R.trigger(h.default.FRAG_LOADING, { frag: $e }), this.state = v.State.FRAG_LOADING)));
                  }
                  break;
                case v.State.WAITING_TRACK:
                  C = this.tracks[this.trackId], C && C.details && (this.state = v.State.IDLE);
                  break;
                case v.State.FRAG_LOADING_WAITING_RETRY:
                  var vt = g.now(), Tt = this.retryDate;
                  $ = this.media;
                  var xt = $ && $.seeking;
                  (!Tt || vt >= Tt || xt) && (m.logger.log("audioStreamController: retryDate reached, switch back to IDLE state"), this.state = v.State.IDLE);
                  break;
                case v.State.WAITING_INIT_PTS:
                  var Pt = this.videoTrackCC;
                  if (this.initPTS[Pt] === void 0)
                    break;
                  var at = this.waitingFragment;
                  if (at) {
                    var Ot = at.frag.cc;
                    Pt !== Ot ? (C = this.tracks[this.trackId], C.details && C.details.live && (m.logger.warn("Waiting fragment CC (" + Ot + ") does not match video track CC (" + Pt + ")"), this.waitingFragment = null, this.state = v.State.IDLE)) : (this.state = v.State.FRAG_LOADING, this.onFragLoaded(this.waitingFragment), this.waitingFragment = null);
                  } else
                    this.state = v.State.IDLE;
                  break;
                case v.State.STOPPED:
                case v.State.FRAG_LOADING:
                case v.State.PARSING:
                case v.State.PARSED:
                case v.State.ENDED:
                  break;
              }
            }, S.prototype.onMediaAttached = function(T) {
              var C = this.media = this.mediaBuffer = T.media;
              this.onvseeking = this.onMediaSeeking.bind(this), this.onvended = this.onMediaEnded.bind(this), C.addEventListener("seeking", this.onvseeking), C.addEventListener("ended", this.onvended);
              var D = this.config;
              this.tracks && D.autoStartLoad && this.startLoad(D.startPosition);
            }, S.prototype.onMediaDetaching = function() {
              var T = this.media;
              T && T.ended && (m.logger.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0), T && (T.removeEventListener("seeking", this.onvseeking), T.removeEventListener("ended", this.onvended), this.onvseeking = this.onvseeked = this.onvended = null), this.media = this.mediaBuffer = this.videoBuffer = null, this.loadedmetadata = !1, this.stopLoad();
            }, S.prototype.onAudioTracksUpdated = function(T) {
              m.logger.log("audio tracks updated"), this.tracks = T.audioTracks;
            }, S.prototype.onAudioTrackSwitching = function(T) {
              var C = !!T.url;
              this.trackId = T.id, this.fragCurrent = null, this.state = v.State.PAUSED, this.waitingFragment = null, C ? this.setInterval(E) : this.demuxer && (this.demuxer.destroy(), this.demuxer = null), C && (this.audioSwitch = !0, this.state = v.State.IDLE), this.tick();
            }, S.prototype.onAudioTrackLoaded = function(T) {
              var C = T.details, D = T.id, R = this.tracks[D], P = C.totalduration, N = 0;
              if (m.logger.log("track " + D + " loaded [" + C.startSN + "," + C.endSN + "],duration:" + P), C.live) {
                var $ = R.details;
                $ && C.fragments.length > 0 ? (c.mergeDetails($, C), N = C.fragments[0].start, C.PTSKnown ? m.logger.log("live audio playlist sliding:" + N.toFixed(3)) : m.logger.log("live audio playlist - outdated PTS, unknown sliding")) : (C.PTSKnown = !1, m.logger.log("live audio playlist - first load, unknown sliding"));
              } else
                C.PTSKnown = !1;
              if (R.details = C, !this.startFragRequested) {
                if (this.startPosition === -1) {
                  var O = C.startTimeOffset;
                  a.isFinite(O) ? (m.logger.log("start time offset found in playlist, adjust startPosition to " + O), this.startPosition = O) : this.startPosition = 0;
                }
                this.nextLoadPosition = this.startPosition;
              }
              this.state === v.State.WAITING_TRACK && (this.state = v.State.IDLE), this.tick();
            }, S.prototype.onKeyLoaded = function() {
              this.state === v.State.KEY_LOADING && (this.state = v.State.IDLE, this.tick());
            }, S.prototype.onFragLoaded = function(T) {
              var C = this.fragCurrent, D = T.frag;
              if (this.state === v.State.FRAG_LOADING && C && D.type === "audio" && D.level === C.level && D.sn === C.sn) {
                var R = this.tracks[this.trackId], P = R.details, N = P.totalduration, $ = C.level, O = C.sn, M = C.cc, F = this.config.defaultAudioCodec || R.audioCodec || "mp4a.40.2", G = this.stats = T.stats;
                if (O === "initSegment")
                  this.state = v.State.IDLE, G.tparsed = G.tbuffered = g.now(), P.initSegment.data = T.payload, this.hls.trigger(h.default.FRAG_BUFFERED, { stats: G, frag: C, id: "audio" }), this.tick();
                else {
                  this.state = v.State.PARSING, this.appended = !1, this.demuxer || (this.demuxer = new u.default(this.hls, "audio"));
                  var K = this.initPTS[M], J = P.initSegment ? P.initSegment.data : [];
                  if (P.initSegment || K !== void 0) {
                    this.pendingBuffering = !0, m.logger.log("Demuxing " + O + " of [" + P.startSN + " ," + P.endSN + "],track " + $);
                    var ue = !1;
                    this.demuxer.push(T.payload, J, F, null, C, N, ue, K);
                  } else
                    m.logger.log("unknown video PTS for continuity counter " + M + ", waiting for video PTS before demuxing audio frag " + O + " of [" + P.startSN + " ," + P.endSN + "],track " + $), this.waitingFragment = T, this.state = v.State.WAITING_INIT_PTS;
                }
              }
              this.fragLoadError = 0;
            }, S.prototype.onFragParsingInitSegment = function(T) {
              var C = this.fragCurrent, D = T.frag;
              if (C && T.id === "audio" && D.sn === C.sn && D.level === C.level && this.state === v.State.PARSING) {
                var R = T.tracks, P = void 0;
                if (R.video && delete R.video, P = R.audio, P) {
                  P.levelCodec = P.codec, P.id = T.id, this.hls.trigger(h.default.BUFFER_CODECS, R), m.logger.log("audio track:audio,container:" + P.container + ",codecs[level/parsed]=[" + P.levelCodec + "/" + P.codec + "]");
                  var N = P.initSegment;
                  if (N) {
                    var $ = { type: "audio", data: N, parent: "audio", content: "initSegment" };
                    this.audioSwitch ? this.pendingData = [$] : (this.appended = !0, this.pendingBuffering = !0, this.hls.trigger(h.default.BUFFER_APPENDING, $));
                  }
                  this.tick();
                }
              }
            }, S.prototype.onFragParsingData = function(T) {
              var C = this, D = this.fragCurrent, R = T.frag;
              if (D && T.id === "audio" && T.type === "audio" && R.sn === D.sn && R.level === D.level && this.state === v.State.PARSING) {
                var P = this.trackId, N = this.tracks[P], $ = this.hls;
                a.isFinite(T.endPTS) || (T.endPTS = T.startPTS + D.duration, T.endDTS = T.startDTS + D.duration), D.addElementaryStream(y.default.ElementaryStreamTypes.AUDIO), m.logger.log("parsed " + T.type + ",PTS:[" + T.startPTS.toFixed(3) + "," + T.endPTS.toFixed(3) + "],DTS:[" + T.startDTS.toFixed(3) + "/" + T.endDTS.toFixed(3) + "],nb:" + T.nb), c.updateFragPTSDTS(N.details, D, T.startPTS, T.endPTS);
                var O = this.audioSwitch, M = this.media, F = !1;
                if (O && M)
                  if (M.readyState) {
                    var G = M.currentTime;
                    m.logger.log("switching audio track : currentTime:" + G), G >= T.startPTS && (m.logger.log("switching audio track : flushing all audio"), this.state = v.State.BUFFER_FLUSHING, $.trigger(h.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: a.POSITIVE_INFINITY, type: "audio" }), F = !0, this.audioSwitch = !1, $.trigger(h.default.AUDIO_TRACK_SWITCHED, { id: P }));
                  } else
                    this.audioSwitch = !1, $.trigger(h.default.AUDIO_TRACK_SWITCHED, { id: P });
                var K = this.pendingData;
                if (!K) {
                  m.logger.warn("Apparently attempt to enqueue media payload without codec initialization data upfront"), $.trigger(h.default.ERROR, { type: f.ErrorTypes.MEDIA_ERROR, details: null, fatal: !0 });
                  return;
                }
                this.audioSwitch || ([T.data1, T.data2].forEach(function(J) {
                  J && J.length && K.push({ type: T.type, data: J, parent: "audio", content: "data" });
                }), !F && K.length && (K.forEach(function(J) {
                  C.state === v.State.PARSING && (C.pendingBuffering = !0, C.hls.trigger(h.default.BUFFER_APPENDING, J));
                }), this.pendingData = [], this.appended = !0)), this.tick();
              }
            }, S.prototype.onFragParsed = function(T) {
              var C = this.fragCurrent, D = T.frag;
              C && T.id === "audio" && D.sn === C.sn && D.level === C.level && this.state === v.State.PARSING && (this.stats.tparsed = g.now(), this.state = v.State.PARSED, this._checkAppendedParsed());
            }, S.prototype.onBufferReset = function() {
              this.mediaBuffer = this.videoBuffer = null, this.loadedmetadata = !1;
            }, S.prototype.onBufferCreated = function(T) {
              var C = T.tracks.audio;
              C && (this.mediaBuffer = C.buffer, this.loadedmetadata = !0), T.tracks.video && (this.videoBuffer = T.tracks.video.buffer);
            }, S.prototype.onBufferAppended = function(T) {
              if (T.parent === "audio") {
                var C = this.state;
                (C === v.State.PARSING || C === v.State.PARSED) && (this.pendingBuffering = T.pending > 0, this._checkAppendedParsed());
              }
            }, S.prototype._checkAppendedParsed = function() {
              if (this.state === v.State.PARSED && (!this.appended || !this.pendingBuffering)) {
                var T = this.fragCurrent, C = this.stats, D = this.hls;
                if (T) {
                  this.fragPrevious = T, C.tbuffered = g.now(), D.trigger(h.default.FRAG_BUFFERED, { stats: C, frag: T, id: "audio" });
                  var R = this.mediaBuffer ? this.mediaBuffer : this.media;
                  m.logger.log("audio buffered : " + d.default.toString(R.buffered)), this.audioSwitch && this.appended && (this.audioSwitch = !1, D.trigger(h.default.AUDIO_TRACK_SWITCHED, { id: this.trackId })), this.state = v.State.IDLE;
                }
                this.tick();
              }
            }, S.prototype.onError = function(T) {
              var C = T.frag;
              if (!(C && C.type !== "audio"))
                switch (T.details) {
                  case f.ErrorDetails.FRAG_LOAD_ERROR:
                  case f.ErrorDetails.FRAG_LOAD_TIMEOUT:
                    var D = T.frag;
                    if (D && D.type !== "audio")
                      break;
                    if (!T.fatal) {
                      var R = this.fragLoadError;
                      R ? R++ : R = 1;
                      var P = this.config;
                      if (R <= P.fragLoadingMaxRetry) {
                        this.fragLoadError = R;
                        var N = Math.min(Math.pow(2, R - 1) * P.fragLoadingRetryDelay, P.fragLoadingMaxRetryTimeout);
                        m.logger.warn("AudioStreamController: frag loading failed, retry in " + N + " ms"), this.retryDate = g.now() + N, this.state = v.State.FRAG_LOADING_WAITING_RETRY;
                      } else
                        m.logger.error("AudioStreamController: " + T.details + " reaches max retry, redispatch as fatal ..."), T.fatal = !0, this.state = v.State.ERROR;
                    }
                    break;
                  case f.ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
                  case f.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
                  case f.ErrorDetails.KEY_LOAD_ERROR:
                  case f.ErrorDetails.KEY_LOAD_TIMEOUT:
                    this.state !== v.State.ERROR && (this.state = T.fatal ? v.State.ERROR : v.State.IDLE, m.logger.warn("AudioStreamController: " + T.details + " while loading frag, now switching to " + this.state + " state ..."));
                    break;
                  case f.ErrorDetails.BUFFER_FULL_ERROR:
                    if (T.parent === "audio" && (this.state === v.State.PARSING || this.state === v.State.PARSED)) {
                      var $ = this.mediaBuffer, O = this.media.currentTime, M = $ && l.BufferHelper.isBuffered($, O) && l.BufferHelper.isBuffered($, O + 0.5);
                      if (M) {
                        var P = this.config;
                        P.maxMaxBufferLength >= P.maxBufferLength && (P.maxMaxBufferLength /= 2, m.logger.warn("AudioStreamController: reduce max buffer length to " + P.maxMaxBufferLength + "s")), this.state = v.State.IDLE;
                      } else
                        m.logger.warn("AudioStreamController: buffer full error also media.currentTime is not buffered, flush audio buffer"), this.fragCurrent = null, this.state = v.State.BUFFER_FLUSHING, this.hls.trigger(h.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: a.POSITIVE_INFINITY, type: "audio" });
                    }
                    break;
                }
            }, S.prototype.onBufferFlushed = function() {
              var T = this, C = this.pendingData;
              C && C.length ? (m.logger.log("AudioStreamController: appending pending audio data after buffer flushed"), C.forEach(function(D) {
                T.hls.trigger(h.default.BUFFER_APPENDING, D);
              }), this.appended = !0, this.pendingData = [], this.state = v.State.PARSED) : (this.state = v.State.IDLE, this.fragPrevious = null, this.tick());
            }, S;
          }(v.default);
          t.default = x;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/controller/audio-track-controller.js": function(i, t, n) {
        var a = this && this.__extends || function() {
          var c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, f) {
            d.__proto__ = f;
          } || function(d, f) {
            for (var m in f)
              f.hasOwnProperty(m) && (d[m] = f[m]);
          };
          return function(d, f) {
            c(d, f);
            function m() {
              this.constructor = d;
            }
            d.prototype = f === null ? Object.create(f) : (m.prototype = f.prototype, new m());
          };
        }();
        Object.defineProperty(t, "__esModule", { value: !0 });
        var s = n("./src/events.js"), o = n("./src/task-loop.js"), l = n("./src/utils/logger.js"), u = n("./src/errors.js"), h = function(c) {
          a(d, c);
          function d(f) {
            var m = c.call(this, f, s.default.MANIFEST_LOADING, s.default.MANIFEST_PARSED, s.default.AUDIO_TRACK_LOADED, s.default.AUDIO_TRACK_SWITCHED, s.default.LEVEL_LOADED, s.default.ERROR) || this;
            return m._trackId = -1, m._selectDefaultTrack = !0, m.tracks = [], m.trackIdBlacklist = /* @__PURE__ */ Object.create(null), m.audioGroupId = null, m;
          }
          return d.prototype.onManifestLoading = function() {
            this.tracks = [], this._trackId = -1, this._selectDefaultTrack = !0;
          }, d.prototype.onManifestParsed = function(f) {
            var m = this.tracks = f.audioTracks || [];
            this.hls.trigger(s.default.AUDIO_TRACKS_UPDATED, { audioTracks: m });
          }, d.prototype.onAudioTrackLoaded = function(f) {
            if (f.id >= this.tracks.length) {
              l.logger.warn("Invalid audio track id:", f.id);
              return;
            }
            if (l.logger.log("audioTrack " + f.id + " loaded"), this.tracks[f.id].details = f.details, f.details.live && !this.hasInterval()) {
              var m = f.details.targetduration * 1e3;
              this.setInterval(m);
            }
            !f.details.live && this.hasInterval() && this.clearInterval();
          }, d.prototype.onAudioTrackSwitched = function(f) {
            var m = this.tracks[f.id].groupId;
            m && this.audioGroupId !== m && (this.audioGroupId = m);
          }, d.prototype.onLevelLoaded = function(f) {
            var m = this.hls.levels[f.level];
            if (!!m.audioGroupIds) {
              var p = m.audioGroupIds[m.urlId];
              this.audioGroupId !== p && (this.audioGroupId = p, this._selectInitialAudioTrack());
            }
          }, d.prototype.onError = function(f) {
            f.type === u.ErrorTypes.NETWORK_ERROR && (f.fatal && this.clearInterval(), f.details === u.ErrorDetails.AUDIO_TRACK_LOAD_ERROR && (l.logger.warn("Network failure on audio-track id:", f.context.id), this._handleLoadError()));
          }, Object.defineProperty(d.prototype, "audioTracks", {
            get: function() {
              return this.tracks;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(d.prototype, "audioTrack", {
            get: function() {
              return this._trackId;
            },
            set: function(f) {
              this._setAudioTrack(f), this._selectDefaultTrack = !1;
            },
            enumerable: !0,
            configurable: !0
          }), d.prototype._setAudioTrack = function(f) {
            if (this._trackId === f && this.tracks[this._trackId].details) {
              l.logger.debug("Same id as current audio-track passed, and track details available -> no-op");
              return;
            }
            if (f < 0 || f >= this.tracks.length) {
              l.logger.warn("Invalid id passed to audio-track controller");
              return;
            }
            var m = this.tracks[f];
            l.logger.log("Now switching to audio-track index " + f), this.clearInterval(), this._trackId = f;
            var p = m.url, b = m.type, y = m.id;
            this.hls.trigger(s.default.AUDIO_TRACK_SWITCHING, { id: y, type: b, url: p }), this._loadTrackDetailsIfNeeded(m);
          }, d.prototype.doTick = function() {
            this._updateTrack(this._trackId);
          }, d.prototype._selectInitialAudioTrack = function() {
            var f = this, m = this.tracks;
            if (!!m.length) {
              var p = this.tracks[this._trackId], b = null;
              if (p && (b = p.name), this._selectDefaultTrack) {
                var y = m.filter(function(E) {
                  return E.default;
                });
                y.length ? m = y : l.logger.warn("No default audio tracks defined");
              }
              var v = !1, g = function() {
                m.forEach(function(E) {
                  v || (!f.audioGroupId || E.groupId === f.audioGroupId) && (!b || b === E.name) && (f._setAudioTrack(E.id), v = !0);
                });
              };
              g(), v || (b = null, g()), v || (l.logger.error("No track found for running audio group-ID: " + this.audioGroupId), this.hls.trigger(s.default.ERROR, {
                type: u.ErrorTypes.MEDIA_ERROR,
                details: u.ErrorDetails.AUDIO_TRACK_LOAD_ERROR,
                fatal: !0
              }));
            }
          }, d.prototype._needsTrackLoading = function(f) {
            var m = f.details, p = f.url;
            return !m || m.live ? !!p : !1;
          }, d.prototype._loadTrackDetailsIfNeeded = function(f) {
            if (this._needsTrackLoading(f)) {
              var m = f.url, p = f.id;
              l.logger.log("loading audio-track playlist for id: " + p), this.hls.trigger(s.default.AUDIO_TRACK_LOADING, { url: m, id: p });
            }
          }, d.prototype._updateTrack = function(f) {
            if (!(f < 0 || f >= this.tracks.length)) {
              this.clearInterval(), this._trackId = f, l.logger.log("trying to update audio-track " + f);
              var m = this.tracks[f];
              this._loadTrackDetailsIfNeeded(m);
            }
          }, d.prototype._handleLoadError = function() {
            this.trackIdBlacklist[this._trackId] = !0;
            var f = this._trackId, m = this.tracks[f], p = m.name, b = m.language, y = m.groupId;
            l.logger.warn("Loading failed on audio track id: " + f + ", group-id: " + y + ', name/language: "' + p + '" / "' + b + '"');
            for (var v = f, g = 0; g < this.tracks.length; g++)
              if (!this.trackIdBlacklist[g]) {
                var E = this.tracks[g];
                if (E.name === p) {
                  v = g;
                  break;
                }
              }
            if (v === f) {
              l.logger.warn('No fallback audio-track found for name/language: "' + p + '" / "' + b + '"');
              return;
            }
            l.logger.log("Attempting audio-track fallback id:", v, "group-id:", this.tracks[v].groupId), this._setAudioTrack(v);
          }, d;
        }(o.default);
        t.default = h;
      },
      "./src/controller/base-stream-controller.js": function(i, t, n) {
        (function(a) {
          var s = this && this.__extends || function() {
            var d = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, m) {
              f.__proto__ = m;
            } || function(f, m) {
              for (var p in m)
                m.hasOwnProperty(p) && (f[p] = m[p]);
            };
            return function(f, m) {
              d(f, m);
              function p() {
                this.constructor = f;
              }
              f.prototype = m === null ? Object.create(m) : (p.prototype = m.prototype, new p());
            };
          }();
          Object.defineProperty(t, "__esModule", { value: !0 });
          var o = n("./src/task-loop.js"), l = n("./src/controller/fragment-tracker.js"), u = n("./src/utils/buffer-helper.js"), h = n("./src/utils/logger.js");
          t.State = {
            STOPPED: "STOPPED",
            STARTING: "STARTING",
            IDLE: "IDLE",
            PAUSED: "PAUSED",
            KEY_LOADING: "KEY_LOADING",
            FRAG_LOADING: "FRAG_LOADING",
            FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
            WAITING_TRACK: "WAITING_TRACK",
            PARSING: "PARSING",
            PARSED: "PARSED",
            BUFFER_FLUSHING: "BUFFER_FLUSHING",
            ENDED: "ENDED",
            ERROR: "ERROR",
            WAITING_INIT_PTS: "WAITING_INIT_PTS",
            WAITING_LEVEL: "WAITING_LEVEL"
          };
          var c = function(d) {
            s(f, d);
            function f() {
              return d !== null && d.apply(this, arguments) || this;
            }
            return f.prototype.doTick = function() {
            }, f.prototype.startLoad = function() {
            }, f.prototype.stopLoad = function() {
              var m = this.fragCurrent;
              m && (m.loader && m.loader.abort(), this.fragmentTracker.removeFragment(m)), this.demuxer && (this.demuxer.destroy(), this.demuxer = null), this.fragCurrent = null, this.fragPrevious = null, this.clearInterval(), this.clearNextTick(), this.state = t.State.STOPPED;
            }, f.prototype._streamEnded = function(m, p) {
              var b = this, y = b.fragCurrent, v = b.fragmentTracker;
              if (!p.live && y && !y.backtracked && y.sn === p.endSN && !m.nextStart) {
                var g = v.getState(y);
                return g === l.FragmentState.PARTIAL || g === l.FragmentState.OK;
              }
              return !1;
            }, f.prototype.onMediaSeeking = function() {
              var m = this, p = m.config, b = m.media, y = m.mediaBuffer, v = m.state, g = b ? b.currentTime : null, E = u.BufferHelper.bufferInfo(y || b, g, this.config.maxBufferHole);
              if (a.isFinite(g) && h.logger.log("media seeking to " + g.toFixed(3)), v === t.State.FRAG_LOADING) {
                var x = this.fragCurrent;
                if (E.len === 0 && x) {
                  var w = p.maxFragLookUpTolerance, S = x.start - w, T = x.start + x.duration + w;
                  g < S || g > T ? (x.loader && (h.logger.log("seeking outside of buffer while fragment load in progress, cancel fragment load"), x.loader.abort()), this.fragCurrent = null, this.fragPrevious = null, this.state = t.State.IDLE) : h.logger.log("seeking outside of buffer but within currently loaded fragment range");
                }
              } else
                v === t.State.ENDED && (E.len === 0 && (this.fragPrevious = null, this.fragCurrent = null), this.state = t.State.IDLE);
              b && (this.lastCurrentTime = g), this.loadedmetadata || (this.nextLoadPosition = this.startPosition = g), this.tick();
            }, f.prototype.onMediaEnded = function() {
              this.startPosition = this.lastCurrentTime = 0;
            }, f.prototype.onHandlerDestroying = function() {
              this.stopLoad(), d.prototype.onHandlerDestroying.call(this);
            }, f.prototype.onHandlerDestroyed = function() {
              this.state = t.State.STOPPED, this.fragmentTracker = null;
            }, f;
          }(o.default);
          t.default = c;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/controller/buffer-controller.js": function(i, t, n) {
        (function(a) {
          var s = this && this.__extends || function() {
            var m = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, b) {
              p.__proto__ = b;
            } || function(p, b) {
              for (var y in b)
                b.hasOwnProperty(y) && (p[y] = b[y]);
            };
            return function(p, b) {
              m(p, b);
              function y() {
                this.constructor = p;
              }
              p.prototype = b === null ? Object.create(b) : (y.prototype = b.prototype, new y());
            };
          }();
          Object.defineProperty(t, "__esModule", { value: !0 });
          var o = n("./src/events.js"), l = n("./src/event-handler.js"), u = n("./src/utils/logger.js"), h = n("./src/errors.js"), c = n("./src/utils/mediasource-helper.js"), d = c.getMediaSource(), f = function(m) {
            s(p, m);
            function p(b) {
              var y = m.call(this, b, o.default.MEDIA_ATTACHING, o.default.MEDIA_DETACHING, o.default.MANIFEST_PARSED, o.default.BUFFER_RESET, o.default.BUFFER_APPENDING, o.default.BUFFER_CODECS, o.default.BUFFER_EOS, o.default.BUFFER_FLUSHING, o.default.LEVEL_PTS_UPDATED, o.default.LEVEL_UPDATED) || this;
              return y._msDuration = null, y._levelDuration = null, y._levelTargetDuration = 10, y._live = null, y._objectUrl = null, y.bufferCodecEventsExpected = 0, y.onsbue = y.onSBUpdateEnd.bind(y), y.onsbe = y.onSBUpdateError.bind(y), y.pendingTracks = {}, y.tracks = {}, y;
            }
            return p.prototype.destroy = function() {
              l.default.prototype.destroy.call(this);
            }, p.prototype.onLevelPtsUpdated = function(b) {
              var y = b.type, v = this.tracks.audio;
              if (y === "audio" && v && v.container === "audio/mpeg") {
                var g = this.sourceBuffer.audio, E = Math.abs(g.timestampOffset - b.start);
                if (E > 0.1) {
                  var x = g.updating;
                  try {
                    g.abort();
                  } catch (w) {
                    u.logger.warn("can not abort audio buffer: " + w);
                  }
                  x ? this.audioTimestampOffset = b.start : (u.logger.warn("change mpeg audio timestamp offset from " + g.timestampOffset + " to " + b.start), g.timestampOffset = b.start);
                }
              }
            }, p.prototype.onManifestParsed = function(b) {
              this.bufferCodecEventsExpected = b.altAudio ? 2 : 1, u.logger.log(this.bufferCodecEventsExpected + " bufferCodec event(s) expected");
            }, p.prototype.onMediaAttaching = function(b) {
              var y = this.media = b.media;
              if (y) {
                var v = this.mediaSource = new d();
                this.onmso = this.onMediaSourceOpen.bind(this), this.onmse = this.onMediaSourceEnded.bind(this), this.onmsc = this.onMediaSourceClose.bind(this), v.addEventListener("sourceopen", this.onmso), v.addEventListener("sourceended", this.onmse), v.addEventListener("sourceclose", this.onmsc), y.src = window.URL.createObjectURL(v), this._objectUrl = y.src;
              }
            }, p.prototype.onMediaDetaching = function() {
              u.logger.log("media source detaching");
              var b = this.mediaSource;
              if (b) {
                if (b.readyState === "open")
                  try {
                    b.endOfStream();
                  } catch (y) {
                    u.logger.warn("onMediaDetaching:" + y.message + " while calling endOfStream");
                  }
                b.removeEventListener("sourceopen", this.onmso), b.removeEventListener("sourceended", this.onmse), b.removeEventListener("sourceclose", this.onmsc), this.media && (window.URL.revokeObjectURL(this._objectUrl), this.media.src === this._objectUrl ? (this.media.removeAttribute("src"), this.media.load()) : u.logger.warn("media.src was changed by a third party - skip cleanup")), this.mediaSource = null, this.media = null, this._objectUrl = null, this.pendingTracks = {}, this.tracks = {}, this.sourceBuffer = {}, this.flushRange = [], this.segments = [], this.appended = 0;
              }
              this.onmso = this.onmse = this.onmsc = null, this.hls.trigger(o.default.MEDIA_DETACHED);
            }, p.prototype.onMediaSourceOpen = function() {
              u.logger.log("media source opened"), this.hls.trigger(o.default.MEDIA_ATTACHED, { media: this.media });
              var b = this.mediaSource;
              b && b.removeEventListener("sourceopen", this.onmso), this.checkPendingTracks();
            }, p.prototype.checkPendingTracks = function() {
              var b = this, y = b.bufferCodecEventsExpected, v = b.pendingTracks, g = Object.keys(v).length;
              (g && !y || g === 2) && (this.createSourceBuffers(v), this.pendingTracks = {}, this.doAppending());
            }, p.prototype.onMediaSourceClose = function() {
              u.logger.log("media source closed");
            }, p.prototype.onMediaSourceEnded = function() {
              u.logger.log("media source ended");
            }, p.prototype.onSBUpdateEnd = function() {
              if (this.audioTimestampOffset) {
                var b = this.sourceBuffer.audio;
                u.logger.warn("change mpeg audio timestamp offset from " + b.timestampOffset + " to " + this.audioTimestampOffset), b.timestampOffset = this.audioTimestampOffset, delete this.audioTimestampOffset;
              }
              this._needsFlush && this.doFlush(), this._needsEos && this.checkEos(), this.appending = !1;
              var y = this.parent, v = this.segments.reduce(function(w, S) {
                return S.parent === y ? w + 1 : w;
              }, 0), g = {}, E = this.sourceBuffer;
              for (var x in E)
                g[x] = E[x].buffered;
              this.hls.trigger(o.default.BUFFER_APPENDED, { parent: y, pending: v, timeRanges: g }), this._needsFlush || this.doAppending(), this.updateMediaElementDuration(), v === 0 && this.flushLiveBackBuffer();
            }, p.prototype.onSBUpdateError = function(b) {
              u.logger.error("sourceBuffer error:", b), this.hls.trigger(o.default.ERROR, { type: h.ErrorTypes.MEDIA_ERROR, details: h.ErrorDetails.BUFFER_APPENDING_ERROR, fatal: !1 });
            }, p.prototype.onBufferReset = function() {
              var b = this.sourceBuffer;
              for (var y in b) {
                var v = b[y];
                try {
                  this.mediaSource.removeSourceBuffer(v), v.removeEventListener("updateend", this.onsbue), v.removeEventListener("error", this.onsbe);
                } catch {
                }
              }
              this.sourceBuffer = {}, this.flushRange = [], this.segments = [], this.appended = 0;
            }, p.prototype.onBufferCodecs = function(b) {
              var y = this;
              if (!Object.keys(this.sourceBuffer).length) {
                Object.keys(b).forEach(function(g) {
                  y.pendingTracks[g] = b[g];
                });
                var v = this.mediaSource;
                this.bufferCodecEventsExpected = Math.max(this.bufferCodecEventsExpected - 1, 0), v && v.readyState === "open" && this.checkPendingTracks();
              }
            }, p.prototype.createSourceBuffers = function(b) {
              var y = this.sourceBuffer, v = this.mediaSource;
              for (var g in b)
                if (!y[g]) {
                  var E = b[g], x = E.levelCodec || E.codec, w = E.container + ";codecs=" + x;
                  u.logger.log("creating sourceBuffer(" + w + ")");
                  try {
                    var S = y[g] = v.addSourceBuffer(w);
                    S.addEventListener("updateend", this.onsbue), S.addEventListener("error", this.onsbe), this.tracks[g] = { codec: x, container: E.container }, E.buffer = S;
                  } catch (T) {
                    u.logger.error("error while trying to add sourceBuffer:" + T.message), this.hls.trigger(o.default.ERROR, { type: h.ErrorTypes.MEDIA_ERROR, details: h.ErrorDetails.BUFFER_ADD_CODEC_ERROR, fatal: !1, err: T, mimeType: w });
                  }
                }
              this.hls.trigger(o.default.BUFFER_CREATED, { tracks: b });
            }, p.prototype.onBufferAppending = function(b) {
              this._needsFlush || (this.segments ? this.segments.push(b) : this.segments = [b], this.doAppending());
            }, p.prototype.onBufferAppendFail = function(b) {
              u.logger.error("sourceBuffer error:", b.event), this.hls.trigger(o.default.ERROR, { type: h.ErrorTypes.MEDIA_ERROR, details: h.ErrorDetails.BUFFER_APPENDING_ERROR, fatal: !1 });
            }, p.prototype.onBufferEos = function(b) {
              var y = this.sourceBuffer, v = b.type;
              for (var g in y)
                (!v || g === v) && (y[g].ended || (y[g].ended = !0, u.logger.log(g + " sourceBuffer now EOS")));
              this.checkEos();
            }, p.prototype.checkEos = function() {
              var b = this.sourceBuffer, y = this.mediaSource;
              if (!y || y.readyState !== "open") {
                this._needsEos = !1;
                return;
              }
              for (var v in b) {
                var g = b[v];
                if (!g.ended)
                  return;
                if (g.updating) {
                  this._needsEos = !0;
                  return;
                }
              }
              u.logger.log("all media data are available, signal endOfStream() to MediaSource and stop loading fragment");
              try {
                y.endOfStream();
              } catch {
                u.logger.warn("exception while calling mediaSource.endOfStream()");
              }
              this._needsEos = !1;
            }, p.prototype.onBufferFlushing = function(b) {
              this.flushRange.push({ start: b.startOffset, end: b.endOffset, type: b.type }), this.flushBufferCounter = 0, this.doFlush();
            }, p.prototype.flushLiveBackBuffer = function() {
              if (!!this._live) {
                var b = this.hls.config.liveBackBufferLength;
                if (!(!isFinite(b) || b < 0))
                  for (var y = this.media.currentTime, v = this.sourceBuffer, g = Object.keys(v), E = y - Math.max(b, this._levelTargetDuration), x = g.length - 1; x >= 0; x--) {
                    var w = g[x], S = v[w].buffered;
                    S.length > 0 && E > S.start(0) && this.removeBufferRange(w, v[w], 0, E);
                  }
              }
            }, p.prototype.onLevelUpdated = function(b) {
              var y = b.details;
              y.fragments.length > 0 && (this._levelDuration = y.totalduration + y.fragments[0].start, this._levelTargetDuration = y.averagetargetduration || y.targetduration || 10, this._live = y.live, this.updateMediaElementDuration());
            }, p.prototype.updateMediaElementDuration = function() {
              var b = this.hls.config, y;
              if (!(this._levelDuration === null || !this.media || !this.mediaSource || !this.sourceBuffer || this.media.readyState === 0 || this.mediaSource.readyState !== "open")) {
                for (var v in this.sourceBuffer)
                  if (this.sourceBuffer[v].updating === !0)
                    return;
                y = this.media.duration, this._msDuration === null && (this._msDuration = this.mediaSource.duration), this._live === !0 && b.liveDurationInfinity === !0 ? (u.logger.log("Media Source duration is set to Infinity"), this._msDuration = this.mediaSource.duration = 1 / 0) : (this._levelDuration > this._msDuration && this._levelDuration > y || !a.isFinite(y)) && (u.logger.log("Updating Media Source duration to " + this._levelDuration.toFixed(3)), this._msDuration = this.mediaSource.duration = this._levelDuration);
              }
            }, p.prototype.doFlush = function() {
              for (; this.flushRange.length; ) {
                var b = this.flushRange[0];
                if (this.flushBuffer(b.start, b.end, b.type))
                  this.flushRange.shift(), this.flushBufferCounter = 0;
                else {
                  this._needsFlush = !0;
                  return;
                }
              }
              if (this.flushRange.length === 0) {
                this._needsFlush = !1;
                var y = 0, v = this.sourceBuffer;
                try {
                  for (var g in v)
                    y += v[g].buffered.length;
                } catch {
                  u.logger.error("error while accessing sourceBuffer.buffered");
                }
                this.appended = y, this.hls.trigger(o.default.BUFFER_FLUSHED);
              }
            }, p.prototype.doAppending = function() {
              var b = this, y = b.hls, v = b.segments, g = b.sourceBuffer;
              if (Object.keys(g).length) {
                if (this.media.error) {
                  this.segments = [], u.logger.error("trying to append although a media error occured, flush segment and abort");
                  return;
                }
                if (this.appending)
                  return;
                if (v && v.length) {
                  var E = v.shift();
                  try {
                    var x = E.type, w = g[x];
                    w ? w.updating ? v.unshift(E) : (w.ended = !1, this.parent = E.parent, w.appendBuffer(E.data), this.appendError = 0, this.appended++, this.appending = !0) : this.onSBUpdateEnd();
                  } catch (T) {
                    u.logger.error("error while trying to append buffer:" + T.message), v.unshift(E);
                    var S = { type: h.ErrorTypes.MEDIA_ERROR, parent: E.parent };
                    T.code !== 22 ? (this.appendError ? this.appendError++ : this.appendError = 1, S.details = h.ErrorDetails.BUFFER_APPEND_ERROR, this.appendError > y.config.appendErrorMaxRetry ? (u.logger.log("fail " + y.config.appendErrorMaxRetry + " times to append segment in sourceBuffer"), this.segments = [], S.fatal = !0, y.trigger(o.default.ERROR, S)) : (S.fatal = !1, y.trigger(o.default.ERROR, S))) : (this.segments = [], S.details = h.ErrorDetails.BUFFER_FULL_ERROR, S.fatal = !1, y.trigger(o.default.ERROR, S));
                  }
                }
              }
            }, p.prototype.flushBuffer = function(b, y, v) {
              var g, E = this.sourceBuffer;
              if (Object.keys(E).length) {
                if (u.logger.log("flushBuffer,pos/start/end: " + this.media.currentTime.toFixed(3) + "/" + b + "/" + y), this.flushBufferCounter < this.appended) {
                  for (var x in E)
                    if (!(v && x !== v)) {
                      if (g = E[x], g.ended = !1, g.updating)
                        return u.logger.warn("cannot flush, sb updating in progress"), !1;
                      if (this.removeBufferRange(x, g, b, y))
                        return this.flushBufferCounter++, !1;
                    }
                } else
                  u.logger.warn("abort flushing too many retries");
                u.logger.log("buffer flushed");
              }
              return !0;
            }, p.prototype.removeBufferRange = function(b, y, v, g) {
              try {
                for (var E = 0; E < y.buffered.length; E++) {
                  var x = y.buffered.start(E), w = y.buffered.end(E), S = Math.max(x, v), T = Math.min(w, g);
                  if (Math.min(T, w) - S > 0.5)
                    return u.logger.log("sb remove " + b + " [" + S + "," + T + "], of [" + x + "," + w + "], pos:" + this.media.currentTime), y.remove(S, T), !0;
                }
              } catch (C) {
                u.logger.warn("removeBufferRange failed", C);
              }
              return !1;
            }, p;
          }(l.default);
          t.default = f;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/controller/cap-level-controller.js": function(i, t, n) {
        (function(a) {
          var s = this && this.__extends || function() {
            var h = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(c, d) {
              c.__proto__ = d;
            } || function(c, d) {
              for (var f in d)
                d.hasOwnProperty(f) && (c[f] = d[f]);
            };
            return function(c, d) {
              h(c, d);
              function f() {
                this.constructor = c;
              }
              c.prototype = d === null ? Object.create(d) : (f.prototype = d.prototype, new f());
            };
          }();
          Object.defineProperty(t, "__esModule", { value: !0 });
          var o = n("./src/events.js"), l = n("./src/event-handler.js"), u = function(h) {
            s(c, h);
            function c(d) {
              var f = h.call(this, d, o.default.FPS_DROP_LEVEL_CAPPING, o.default.MEDIA_ATTACHING, o.default.MANIFEST_PARSED, o.default.BUFFER_CODECS, o.default.MEDIA_DETACHING) || this;
              return f.autoLevelCapping = a.POSITIVE_INFINITY, f.firstLevel = null, f.levels = [], f.media = null, f.restrictedLevels = [], f.timer = null, f;
            }
            return c.prototype.destroy = function() {
              this.hls.config.capLevelToPlayerSize && (this.media = null, this._stopCapping());
            }, c.prototype.onFpsDropLevelCapping = function(d) {
              c.isLevelAllowed(d.droppedLevel, this.restrictedLevels) && this.restrictedLevels.push(d.droppedLevel);
            }, c.prototype.onMediaAttaching = function(d) {
              this.media = d.media instanceof window.HTMLVideoElement ? d.media : null;
            }, c.prototype.onManifestParsed = function(d) {
              var f = this.hls;
              this.restrictedLevels = [], this.levels = d.levels, this.firstLevel = d.firstLevel, f.config.capLevelToPlayerSize && d.video && this._startCapping();
            }, c.prototype.onBufferCodecs = function(d) {
              var f = this.hls;
              f.config.capLevelToPlayerSize && d.video && this._startCapping();
            }, c.prototype.onLevelsUpdated = function(d) {
              this.levels = d.levels;
            }, c.prototype.onMediaDetaching = function() {
              this._stopCapping();
            }, c.prototype.detectPlayerSize = function() {
              if (this.media) {
                var d = this.levels ? this.levels.length : 0;
                if (d) {
                  var f = this.hls;
                  f.autoLevelCapping = this.getMaxLevel(d - 1), f.autoLevelCapping > this.autoLevelCapping && f.streamController.nextLevelSwitch(), this.autoLevelCapping = f.autoLevelCapping;
                }
              }
            }, c.prototype.getMaxLevel = function(d) {
              var f = this;
              if (!this.levels)
                return -1;
              var m = this.levels.filter(function(p, b) {
                return c.isLevelAllowed(b, f.restrictedLevels) && b <= d;
              });
              return c.getMaxLevelByMediaSize(m, this.mediaWidth, this.mediaHeight);
            }, c.prototype._startCapping = function() {
              this.timer || (this.autoLevelCapping = a.POSITIVE_INFINITY, this.hls.firstLevel = this.getMaxLevel(this.firstLevel), clearInterval(this.timer), this.timer = setInterval(this.detectPlayerSize.bind(this), 1e3), this.detectPlayerSize());
            }, c.prototype._stopCapping = function() {
              this.restrictedLevels = [], this.firstLevel = null, this.autoLevelCapping = a.POSITIVE_INFINITY, this.timer && (this.timer = clearInterval(this.timer), this.timer = null);
            }, Object.defineProperty(c.prototype, "mediaWidth", {
              get: function() {
                var d, f = this.media;
                return f && (d = f.width || f.clientWidth || f.offsetWidth, d *= c.contentScaleFactor), d;
              },
              enumerable: !0,
              configurable: !0
            }), Object.defineProperty(c.prototype, "mediaHeight", {
              get: function() {
                var d, f = this.media;
                return f && (d = f.height || f.clientHeight || f.offsetHeight, d *= c.contentScaleFactor), d;
              },
              enumerable: !0,
              configurable: !0
            }), Object.defineProperty(c, "contentScaleFactor", {
              get: function() {
                var d = 1;
                try {
                  d = window.devicePixelRatio;
                } catch {
                }
                return d;
              },
              enumerable: !0,
              configurable: !0
            }), c.isLevelAllowed = function(d, f) {
              return f === void 0 && (f = []), f.indexOf(d) === -1;
            }, c.getMaxLevelByMediaSize = function(d, f, m) {
              if (!d || d && !d.length)
                return -1;
              for (var p = function(g, E) {
                return E ? g.width !== E.width || g.height !== E.height : !0;
              }, b = d.length - 1, y = 0; y < d.length; y += 1) {
                var v = d[y];
                if ((v.width >= f || v.height >= m) && p(v, d[y + 1])) {
                  b = y;
                  break;
                }
              }
              return b;
            }, c;
          }(l.default);
          t.default = u;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/controller/eme-controller.js": function(i, t, n) {
        var a = this && this.__extends || function() {
          var b = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(y, v) {
            y.__proto__ = v;
          } || function(y, v) {
            for (var g in v)
              v.hasOwnProperty(g) && (y[g] = v[g]);
          };
          return function(y, v) {
            b(y, v);
            function g() {
              this.constructor = y;
            }
            y.prototype = v === null ? Object.create(v) : (g.prototype = v.prototype, new g());
          };
        }();
        Object.defineProperty(t, "__esModule", { value: !0 });
        var s = n("./src/event-handler.js"), o = n("./src/events.js"), l = n("./src/errors.js"), u = n("./src/utils/logger.js"), h = window.XMLHttpRequest, c = 3, d = {
          WIDEVINE: "com.widevine.alpha",
          PLAYREADY: "com.microsoft.playready"
        }, f = function(b, y, v) {
          var g = {
            videoCapabilities: []
          };
          return y.forEach(function(E) {
            g.videoCapabilities.push({
              contentType: 'video/mp4; codecs="' + E + '"'
            });
          }), [
            g
          ];
        }, m = function(b, y, v) {
          switch (b) {
            case d.WIDEVINE:
              return f(y, v);
            default:
              throw Error("Unknown key-system: " + b);
          }
        }, p = function(b) {
          a(y, b);
          function y(v) {
            var g = b.call(this, v, o.default.MEDIA_ATTACHED, o.default.MANIFEST_PARSED) || this;
            return g._widevineLicenseUrl = v.config.widevineLicenseUrl, g._licenseXhrSetup = v.config.licenseXhrSetup, g._emeEnabled = v.config.emeEnabled, g._requestMediaKeySystemAccess = v.config.requestMediaKeySystemAccessFunc, g._mediaKeysList = [], g._media = null, g._hasSetMediaKeys = !1, g._isMediaEncrypted = !1, g._requestLicenseFailureCount = 0, g;
          }
          return y.prototype.getLicenseServerUrl = function(v) {
            var g;
            switch (v) {
              case d.WIDEVINE:
                g = this._widevineLicenseUrl;
                break;
              default:
                g = null;
                break;
            }
            return g || (u.logger.error('No license server URL configured for key-system "' + v + '"'), this.hls.trigger(o.default.ERROR, {
              type: l.ErrorTypes.KEY_SYSTEM_ERROR,
              details: l.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
              fatal: !0
            })), g;
          }, y.prototype._attemptKeySystemAccess = function(v, g, E) {
            var x = this, w = m(v, g, E);
            if (!w) {
              u.logger.warn("Can not create config for key-system (maybe because platform is not supported):", v);
              return;
            }
            u.logger.log("Requesting encrypted media key-system access"), this.requestMediaKeySystemAccess(v, w).then(function(S) {
              x._onMediaKeySystemAccessObtained(v, S);
            }).catch(function(S) {
              u.logger.error('Failed to obtain key-system "' + v + '" access:', S);
            });
          }, Object.defineProperty(y.prototype, "requestMediaKeySystemAccess", {
            get: function() {
              if (!this._requestMediaKeySystemAccess)
                throw new Error("No requestMediaKeySystemAccess function configured");
              return this._requestMediaKeySystemAccess;
            },
            enumerable: !0,
            configurable: !0
          }), y.prototype._onMediaKeySystemAccessObtained = function(v, g) {
            var E = this;
            u.logger.log('Access for key-system "' + v + '" obtained');
            var x = {
              mediaKeys: null,
              mediaKeysSession: null,
              mediaKeysSessionInitialized: !1,
              mediaKeySystemAccess: g,
              mediaKeySystemDomain: v
            };
            this._mediaKeysList.push(x), g.createMediaKeys().then(function(w) {
              x.mediaKeys = w, u.logger.log('Media-keys created for key-system "' + v + '"'), E._onMediaKeysCreated();
            }).catch(function(w) {
              u.logger.error("Failed to create media-keys:", w);
            });
          }, y.prototype._onMediaKeysCreated = function() {
            var v = this;
            this._mediaKeysList.forEach(function(g) {
              g.mediaKeysSession || (g.mediaKeysSession = g.mediaKeys.createSession(), v._onNewMediaKeySession(g.mediaKeysSession));
            });
          }, y.prototype._onNewMediaKeySession = function(v) {
            var g = this;
            u.logger.log("New key-system session " + v.sessionId), v.addEventListener("message", function(E) {
              g._onKeySessionMessage(v, E.message);
            }, !1);
          }, y.prototype._onKeySessionMessage = function(v, g) {
            u.logger.log("Got EME message event, creating license request"), this._requestLicense(g, function(E) {
              u.logger.log("Received license data, updating key-session"), v.update(E);
            });
          }, y.prototype._onMediaEncrypted = function(v, g) {
            u.logger.log('Media is encrypted using "' + v + '" init data type'), this._isMediaEncrypted = !0, this._mediaEncryptionInitDataType = v, this._mediaEncryptionInitData = g, this._attemptSetMediaKeys(), this._generateRequestWithPreferredKeySession();
          }, y.prototype._attemptSetMediaKeys = function() {
            if (!this._hasSetMediaKeys) {
              var v = this._mediaKeysList[0];
              if (!v || !v.mediaKeys) {
                u.logger.error("Fatal: Media is encrypted but no CDM access or no keys have been obtained yet"), this.hls.trigger(o.default.ERROR, {
                  type: l.ErrorTypes.KEY_SYSTEM_ERROR,
                  details: l.ErrorDetails.KEY_SYSTEM_NO_KEYS,
                  fatal: !0
                });
                return;
              }
              u.logger.log("Setting keys for encrypted media"), this._media.setMediaKeys(v.mediaKeys), this._hasSetMediaKeys = !0;
            }
          }, y.prototype._generateRequestWithPreferredKeySession = function() {
            var v = this, g = this._mediaKeysList[0];
            if (!g) {
              u.logger.error("Fatal: Media is encrypted but not any key-system access has been obtained yet"), this.hls.trigger(o.default.ERROR, {
                type: l.ErrorTypes.KEY_SYSTEM_ERROR,
                details: l.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                fatal: !0
              });
              return;
            }
            if (g.mediaKeysSessionInitialized) {
              u.logger.warn("Key-Session already initialized but requested again");
              return;
            }
            var E = g.mediaKeysSession;
            E || (u.logger.error("Fatal: Media is encrypted but no key-session existing"), this.hls.trigger(o.default.ERROR, {
              type: l.ErrorTypes.KEY_SYSTEM_ERROR,
              details: l.ErrorDetails.KEY_SYSTEM_NO_SESSION,
              fatal: !0
            }));
            var x = this._mediaEncryptionInitDataType, w = this._mediaEncryptionInitData;
            u.logger.log('Generating key-session request for "' + x + '" init data type'), g.mediaKeysSessionInitialized = !0, E.generateRequest(x, w).then(function() {
              u.logger.debug("Key-session generation succeeded");
            }).catch(function(S) {
              u.logger.error("Error generating key-session request:", S), v.hls.trigger(o.default.ERROR, {
                type: l.ErrorTypes.KEY_SYSTEM_ERROR,
                details: l.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                fatal: !1
              });
            });
          }, y.prototype._createLicenseXhr = function(v, g, E) {
            var x = new h(), w = this._licenseXhrSetup;
            try {
              if (w)
                try {
                  w(x, v);
                } catch {
                  x.open("POST", v, !0), w(x, v);
                }
              x.readyState || x.open("POST", v, !0);
            } catch (S) {
              u.logger.error("Error setting up key-system license XHR", S), this.hls.trigger(o.default.ERROR, {
                type: l.ErrorTypes.KEY_SYSTEM_ERROR,
                details: l.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                fatal: !0
              });
              return;
            }
            return x.responseType = "arraybuffer", x.onreadystatechange = this._onLicenseRequestReadyStageChange.bind(this, x, v, g, E), x;
          }, y.prototype._onLicenseRequestReadyStageChange = function(v, g, E, x) {
            switch (v.readyState) {
              case 4:
                if (v.status === 200)
                  this._requestLicenseFailureCount = 0, u.logger.log("License request succeeded"), x(v.response);
                else {
                  if (u.logger.error("License Request XHR failed (" + g + "). Status: " + v.status + " (" + v.statusText + ")"), this._requestLicenseFailureCount++, this._requestLicenseFailureCount <= c) {
                    var w = c - this._requestLicenseFailureCount + 1;
                    u.logger.warn("Retrying license request, " + w + " attempts left"), this._requestLicense(E, x);
                    return;
                  }
                  this.hls.trigger(o.default.ERROR, {
                    type: l.ErrorTypes.KEY_SYSTEM_ERROR,
                    details: l.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                    fatal: !0
                  });
                }
                break;
            }
          }, y.prototype._generateLicenseRequestChallenge = function(v, g) {
            var E;
            return v.mediaKeySystemDomain === d.PLAYREADY ? u.logger.error("PlayReady is not supported (yet)") : v.mediaKeySystemDomain === d.WIDEVINE ? E = g : u.logger.error("Unsupported key-system:", v.mediaKeySystemDomain), E;
          }, y.prototype._requestLicense = function(v, g) {
            u.logger.log("Requesting content license for key-system");
            var E = this._mediaKeysList[0];
            if (!E) {
              u.logger.error("Fatal error: Media is encrypted but no key-system access has been obtained yet"), this.hls.trigger(o.default.ERROR, {
                type: l.ErrorTypes.KEY_SYSTEM_ERROR,
                details: l.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                fatal: !0
              });
              return;
            }
            var x = this.getLicenseServerUrl(E.mediaKeySystemDomain), w = this._createLicenseXhr(x, v, g);
            u.logger.log("Sending license request to URL: " + x), w.send(this._generateLicenseRequestChallenge(E, v));
          }, y.prototype.onMediaAttached = function(v) {
            var g = this;
            if (!!this._emeEnabled) {
              var E = v.media;
              this._media = E, E.addEventListener("encrypted", function(x) {
                g._onMediaEncrypted(x.initDataType, x.initData);
              });
            }
          }, y.prototype.onManifestParsed = function(v) {
            if (!!this._emeEnabled) {
              var g = v.levels.map(function(x) {
                return x.audioCodec;
              }), E = v.levels.map(function(x) {
                return x.videoCodec;
              });
              this._attemptKeySystemAccess(d.WIDEVINE, g, E);
            }
          }, y;
        }(s.default);
        t.default = p;
      },
      "./src/controller/fps-controller.js": function(i, t, n) {
        var a = this && this.__extends || function() {
          var c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, f) {
            d.__proto__ = f;
          } || function(d, f) {
            for (var m in f)
              f.hasOwnProperty(m) && (d[m] = f[m]);
          };
          return function(d, f) {
            c(d, f);
            function m() {
              this.constructor = d;
            }
            d.prototype = f === null ? Object.create(f) : (m.prototype = f.prototype, new m());
          };
        }();
        Object.defineProperty(t, "__esModule", { value: !0 });
        var s = n("./src/events.js"), o = n("./src/event-handler.js"), l = n("./src/utils/logger.js"), u = window.performance, h = function(c) {
          a(d, c);
          function d(f) {
            return c.call(this, f, s.default.MEDIA_ATTACHING) || this;
          }
          return d.prototype.destroy = function() {
            this.timer && clearInterval(this.timer), this.isVideoPlaybackQualityAvailable = !1;
          }, d.prototype.onMediaAttaching = function(f) {
            var m = this.hls.config;
            if (m.capLevelOnFPSDrop) {
              var p = this.video = f.media instanceof window.HTMLVideoElement ? f.media : null;
              typeof p.getVideoPlaybackQuality == "function" && (this.isVideoPlaybackQualityAvailable = !0), clearInterval(this.timer), this.timer = setInterval(this.checkFPSInterval.bind(this), m.fpsDroppedMonitoringPeriod);
            }
          }, d.prototype.checkFPS = function(f, m, p) {
            var b = u.now();
            if (m) {
              if (this.lastTime) {
                var y = b - this.lastTime, v = p - this.lastDroppedFrames, g = m - this.lastDecodedFrames, E = 1e3 * v / y, x = this.hls;
                if (x.trigger(s.default.FPS_DROP, { currentDropped: v, currentDecoded: g, totalDroppedFrames: p }), E > 0 && v > x.config.fpsDroppedMonitoringThreshold * g) {
                  var w = x.currentLevel;
                  l.logger.warn("drop FPS ratio greater than max allowed value for currentLevel: " + w), w > 0 && (x.autoLevelCapping === -1 || x.autoLevelCapping >= w) && (w = w - 1, x.trigger(s.default.FPS_DROP_LEVEL_CAPPING, { level: w, droppedLevel: x.currentLevel }), x.autoLevelCapping = w, x.streamController.nextLevelSwitch());
                }
              }
              this.lastTime = b, this.lastDroppedFrames = p, this.lastDecodedFrames = m;
            }
          }, d.prototype.checkFPSInterval = function() {
            var f = this.video;
            if (f)
              if (this.isVideoPlaybackQualityAvailable) {
                var m = f.getVideoPlaybackQuality();
                this.checkFPS(f, m.totalVideoFrames, m.droppedVideoFrames);
              } else
                this.checkFPS(f, f.webkitDecodedFrameCount, f.webkitDroppedFrameCount);
          }, d;
        }(o.default);
        t.default = h;
      },
      "./src/controller/fragment-finders.js": function(i, t, n) {
        (function(a) {
          Object.defineProperty(t, "__esModule", { value: !0 });
          var s = n("./src/utils/binary-search.js");
          function o(c, d, f) {
            if (!Array.isArray(c) || !c.length || !a.isFinite(d) || d < c[0].programDateTime || d >= c[c.length - 1].endProgramDateTime)
              return null;
            f = f || 0;
            for (var m = 0; m < c.length; ++m) {
              var p = c[m];
              if (h(d, f, p))
                return p;
            }
            return null;
          }
          t.findFragmentByPDT = o;
          function l(c, d, f, m) {
            f === void 0 && (f = 0), m === void 0 && (m = 0);
            var p = c ? d[c.sn - d[0].sn + 1] : null;
            return p && !u(f, m, p) ? p : s.default.search(d, u.bind(null, f, m));
          }
          t.findFragmentByPTS = l;
          function u(c, d, f) {
            c === void 0 && (c = 0), d === void 0 && (d = 0);
            var m = Math.min(d, f.duration + (f.deltaPTS ? f.deltaPTS : 0));
            return f.start + f.duration - m <= c ? 1 : f.start - m > c && f.start ? -1 : 0;
          }
          t.fragmentWithinToleranceTest = u;
          function h(c, d, f) {
            var m = Math.min(d, f.duration + (f.deltaPTS ? f.deltaPTS : 0)) * 1e3;
            return f.endProgramDateTime - m > c;
          }
          t.pdtWithinToleranceTest = h;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/controller/fragment-tracker.js": function(i, t, n) {
        (function(a) {
          var s = this && this.__extends || function() {
            var h = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(c, d) {
              c.__proto__ = d;
            } || function(c, d) {
              for (var f in d)
                d.hasOwnProperty(f) && (c[f] = d[f]);
            };
            return function(c, d) {
              h(c, d);
              function f() {
                this.constructor = c;
              }
              c.prototype = d === null ? Object.create(d) : (f.prototype = d.prototype, new f());
            };
          }();
          Object.defineProperty(t, "__esModule", { value: !0 });
          var o = n("./src/event-handler.js"), l = n("./src/events.js");
          t.FragmentState = {
            NOT_LOADED: "NOT_LOADED",
            APPENDING: "APPENDING",
            PARTIAL: "PARTIAL",
            OK: "OK"
          };
          var u = function(h) {
            s(c, h);
            function c(d) {
              var f = h.call(this, d, l.default.BUFFER_APPENDED, l.default.FRAG_BUFFERED, l.default.FRAG_LOADED) || this;
              return f.bufferPadding = 0.2, f.fragments = /* @__PURE__ */ Object.create(null), f.timeRanges = /* @__PURE__ */ Object.create(null), f.config = d.config, f;
            }
            return c.prototype.destroy = function() {
              this.fragments = /* @__PURE__ */ Object.create(null), this.timeRanges = /* @__PURE__ */ Object.create(null), this.config = null, o.default.prototype.destroy.call(this), h.prototype.destroy.call(this);
            }, c.prototype.getBufferedFrag = function(d, f) {
              var m = this.fragments, p = Object.keys(m).filter(function(y) {
                var v = m[y];
                if (v.body.type !== f || !v.buffered)
                  return !1;
                var g = v.body;
                return g.startPTS <= d && d <= g.endPTS;
              });
              if (p.length === 0)
                return null;
              var b = p.pop();
              return m[b].body;
            }, c.prototype.detectEvictedFragments = function(d, f) {
              var m = this, p, b;
              Object.keys(this.fragments).forEach(function(y) {
                var v = m.fragments[y];
                if (v.buffered === !0) {
                  var g = v.range[d];
                  if (g) {
                    p = g.time;
                    for (var E = 0; E < p.length; E++)
                      if (b = p[E], m.isTimeBuffered(b.startPTS, b.endPTS, f) === !1) {
                        m.removeFragment(v.body);
                        break;
                      }
                  }
                }
              });
            }, c.prototype.detectPartialFragments = function(d) {
              var f = this, m = this.getFragmentKey(d), p = this.fragments[m];
              p && (p.buffered = !0, Object.keys(this.timeRanges).forEach(function(b) {
                if (d.hasElementaryStream(b)) {
                  var y = f.timeRanges[b];
                  p.range[b] = f.getBufferedTimes(d.startPTS, d.endPTS, y);
                }
              }));
            }, c.prototype.getBufferedTimes = function(d, f, m) {
              for (var p = [], b, y, v = !1, g = 0; g < m.length; g++)
                if (b = m.start(g) - this.bufferPadding, y = m.end(g) + this.bufferPadding, d >= b && f <= y) {
                  p.push({
                    startPTS: Math.max(d, m.start(g)),
                    endPTS: Math.min(f, m.end(g))
                  });
                  break;
                } else if (d < y && f > b)
                  p.push({
                    startPTS: Math.max(d, m.start(g)),
                    endPTS: Math.min(f, m.end(g))
                  }), v = !0;
                else if (f <= b)
                  break;
              return {
                time: p,
                partial: v
              };
            }, c.prototype.getFragmentKey = function(d) {
              return d.type + "_" + d.level + "_" + d.urlId + "_" + d.sn;
            }, c.prototype.getPartialFragment = function(d) {
              var f = this, m, p, b, y = null, v = 0;
              return Object.keys(this.fragments).forEach(function(g) {
                var E = f.fragments[g];
                f.isPartial(E) && (p = E.body.startPTS - f.bufferPadding, b = E.body.endPTS + f.bufferPadding, d >= p && d <= b && (m = Math.min(d - p, b - d), v <= m && (y = E.body, v = m)));
              }), y;
            }, c.prototype.getState = function(d) {
              var f = this.getFragmentKey(d), m = this.fragments[f], p = t.FragmentState.NOT_LOADED;
              return m !== void 0 && (m.buffered ? this.isPartial(m) === !0 ? p = t.FragmentState.PARTIAL : p = t.FragmentState.OK : p = t.FragmentState.APPENDING), p;
            }, c.prototype.isPartial = function(d) {
              return d.buffered === !0 && (d.range.video !== void 0 && d.range.video.partial === !0 || d.range.audio !== void 0 && d.range.audio.partial === !0);
            }, c.prototype.isTimeBuffered = function(d, f, m) {
              for (var p, b, y = 0; y < m.length; y++) {
                if (p = m.start(y) - this.bufferPadding, b = m.end(y) + this.bufferPadding, d >= p && f <= b)
                  return !0;
                if (f <= p)
                  return !1;
              }
              return !1;
            }, c.prototype.onFragLoaded = function(d) {
              var f = d.frag;
              !a.isFinite(f.sn) || f.bitrateTest || (this.fragments[this.getFragmentKey(f)] = {
                body: f,
                range: /* @__PURE__ */ Object.create(null),
                buffered: !1
              });
            }, c.prototype.onBufferAppended = function(d) {
              var f = this;
              this.timeRanges = d.timeRanges, Object.keys(this.timeRanges).forEach(function(m) {
                var p = f.timeRanges[m];
                f.detectEvictedFragments(m, p);
              });
            }, c.prototype.onFragBuffered = function(d) {
              this.detectPartialFragments(d.frag);
            }, c.prototype.hasFragment = function(d) {
              var f = this.getFragmentKey(d);
              return this.fragments[f] !== void 0;
            }, c.prototype.removeFragment = function(d) {
              var f = this.getFragmentKey(d);
              delete this.fragments[f];
            }, c.prototype.removeAllFragments = function() {
              this.fragments = /* @__PURE__ */ Object.create(null);
            }, c;
          }(o.default);
          t.FragmentTracker = u;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/controller/gap-controller.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/utils/buffer-helper.js"), s = n("./src/errors.js"), o = n("./src/events.js"), l = n("./src/utils/logger.js"), u = 1e3, h = 0.5, c = function() {
          function d(f, m, p, b) {
            this.config = f, this.media = m, this.fragmentTracker = p, this.hls = b, this.stallReported = !1;
          }
          return d.prototype.poll = function(f, m) {
            var p = this, b = p.config, y = p.media, v = y.currentTime, g = window.performance.now();
            if (v !== f) {
              this.stallReported && (l.logger.warn("playback not stuck anymore @" + v + ", after " + Math.round(g - this.stalled) + "ms"), this.stallReported = !1), this.stalled = null, this.nudgeRetry = 0;
              return;
            }
            if (!(y.ended || !y.buffered.length || y.readyState > 2) && !(y.seeking && a.BufferHelper.isBuffered(y, v))) {
              var E = g - this.stalled, x = a.BufferHelper.bufferInfo(y, v, b.maxBufferHole);
              if (this.stalled)
                E >= u && this._reportStall(x.len);
              else {
                this.stalled = g;
                return;
              }
              this._tryFixBufferStall(x, E);
            }
          }, d.prototype._tryFixBufferStall = function(f, m) {
            var p = this, b = p.config, y = p.fragmentTracker, v = p.media, g = v.currentTime, E = y.getPartialFragment(g);
            E && this._trySkipBufferHole(E), f.len > h && m > b.highBufferWatchdogPeriod * 1e3 && (this.stalled = null, this._tryNudgeBuffer());
          }, d.prototype._reportStall = function(f) {
            var m = this, p = m.hls, b = m.media, y = m.stallReported;
            y || (this.stallReported = !0, l.logger.warn("Playback stalling at @" + b.currentTime + " due to low buffer"), p.trigger(o.default.ERROR, {
              type: s.ErrorTypes.MEDIA_ERROR,
              details: s.ErrorDetails.BUFFER_STALLED_ERROR,
              fatal: !1,
              buffer: f
            }));
          }, d.prototype._trySkipBufferHole = function(f) {
            for (var m = this, p = m.hls, b = m.media, y = b.currentTime, v = 0, g = 0; g < b.buffered.length; g++) {
              var E = b.buffered.start(g);
              if (y >= v && y < E) {
                b.currentTime = Math.max(E, b.currentTime + 0.1), l.logger.warn("skipping hole, adjusting currentTime from " + y + " to " + b.currentTime), this.stalled = null, p.trigger(o.default.ERROR, {
                  type: s.ErrorTypes.MEDIA_ERROR,
                  details: s.ErrorDetails.BUFFER_SEEK_OVER_HOLE,
                  fatal: !1,
                  reason: "fragment loaded with buffer holes, seeking from " + y + " to " + b.currentTime,
                  frag: f
                });
                return;
              }
              v = b.buffered.end(g);
            }
          }, d.prototype._tryNudgeBuffer = function() {
            var f = this, m = f.config, p = f.hls, b = f.media, y = b.currentTime, v = (this.nudgeRetry || 0) + 1;
            if (this.nudgeRetry = v, v < m.nudgeMaxRetry) {
              var g = y + v * m.nudgeOffset;
              l.logger.log("adjust currentTime from " + y + " to " + g), b.currentTime = g, p.trigger(o.default.ERROR, {
                type: s.ErrorTypes.MEDIA_ERROR,
                details: s.ErrorDetails.BUFFER_NUDGE_ON_STALL,
                fatal: !1
              });
            } else
              l.logger.error("still stuck in high buffer @" + y + " after " + m.nudgeMaxRetry + ", raise fatal error"), p.trigger(o.default.ERROR, {
                type: s.ErrorTypes.MEDIA_ERROR,
                details: s.ErrorDetails.BUFFER_STALLED_ERROR,
                fatal: !0
              });
          }, d;
        }();
        t.default = c;
      },
      "./src/controller/id3-track-controller.js": function(i, t, n) {
        var a = this && this.__extends || function() {
          var c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, f) {
            d.__proto__ = f;
          } || function(d, f) {
            for (var m in f)
              f.hasOwnProperty(m) && (d[m] = f[m]);
          };
          return function(d, f) {
            c(d, f);
            function m() {
              this.constructor = d;
            }
            d.prototype = f === null ? Object.create(f) : (m.prototype = f.prototype, new m());
          };
        }();
        Object.defineProperty(t, "__esModule", { value: !0 });
        var s = n("./src/events.js"), o = n("./src/event-handler.js"), l = n("./src/demux/id3.js"), u = n("./src/utils/texttrack-utils.js"), h = function(c) {
          a(d, c);
          function d(f) {
            var m = c.call(this, f, s.default.MEDIA_ATTACHED, s.default.MEDIA_DETACHING, s.default.FRAG_PARSING_METADATA) || this;
            return m.id3Track = void 0, m.media = void 0, m;
          }
          return d.prototype.destroy = function() {
            o.default.prototype.destroy.call(this);
          }, d.prototype.onMediaAttached = function(f) {
            this.media = f.media, this.media;
          }, d.prototype.onMediaDetaching = function() {
            u.clearCurrentCues(this.id3Track), this.id3Track = void 0, this.media = void 0;
          }, d.prototype.getID3Track = function(f) {
            for (var m = 0; m < f.length; m++) {
              var p = f[m];
              if (p.kind === "metadata" && p.label === "id3")
                return u.sendAddTrackEvent(p, this.media), p;
            }
            return this.media.addTextTrack("metadata", "id3");
          }, d.prototype.onFragParsingMetadata = function(f) {
            var m = f.frag, p = f.samples;
            this.id3Track || (this.id3Track = this.getID3Track(this.media.textTracks), this.id3Track.mode = "hidden");
            for (var b = window.WebKitDataCue || window.VTTCue || window.TextTrackCue, y = 0; y < p.length; y++) {
              var v = l.default.getID3Frames(p[y].data);
              if (v) {
                var g = p[y].pts, E = y < p.length - 1 ? p[y + 1].pts : m.endPTS;
                g === E && (E += 1e-4);
                for (var x = 0; x < v.length; x++) {
                  var w = v[x];
                  if (!l.default.isTimeStampFrame(w)) {
                    var S = new b(g, E, "");
                    S.value = w, this.id3Track.addCue(S);
                  }
                }
              }
            }
          }, d;
        }(o.default);
        t.default = h;
      },
      "./src/controller/level-controller.js": function(i, t, n) {
        var a = this && this.__extends || function() {
          var m = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, b) {
            p.__proto__ = b;
          } || function(p, b) {
            for (var y in b)
              b.hasOwnProperty(y) && (p[y] = b[y]);
          };
          return function(p, b) {
            m(p, b);
            function y() {
              this.constructor = p;
            }
            p.prototype = b === null ? Object.create(b) : (y.prototype = b.prototype, new y());
          };
        }();
        Object.defineProperty(t, "__esModule", { value: !0 });
        var s = n("./src/events.js"), o = n("./src/event-handler.js"), l = n("./src/utils/logger.js"), u = n("./src/errors.js"), h = n("./src/utils/codecs.js"), c = n("./src/controller/level-helper.js"), d, f = function(m) {
          a(p, m);
          function p(b) {
            var y = m.call(this, b, s.default.MANIFEST_LOADED, s.default.LEVEL_LOADED, s.default.AUDIO_TRACK_SWITCHED, s.default.FRAG_LOADED, s.default.ERROR) || this;
            return y.canload = !1, y.currentLevelIndex = null, y.manualLevelIndex = -1, y.timer = null, d = /chrome|firefox/.test(navigator.userAgent.toLowerCase()), y;
          }
          return p.prototype.onHandlerDestroying = function() {
            this.clearTimer(), this.manualLevelIndex = -1;
          }, p.prototype.clearTimer = function() {
            this.timer !== null && (clearTimeout(this.timer), this.timer = null);
          }, p.prototype.startLoad = function() {
            var b = this._levels;
            this.canload = !0, this.levelRetryCount = 0, b && b.forEach(function(y) {
              y.loadError = 0;
              var v = y.details;
              v && v.live && (y.details = void 0);
            }), this.timer !== null && this.loadLevel();
          }, p.prototype.stopLoad = function() {
            this.canload = !1;
          }, p.prototype.onManifestLoaded = function(b) {
            var y = [], v = [], g, E = {}, x = null, w = !1, S = !1;
            if (b.levels.forEach(function(C) {
              var D = C.attrs;
              C.loadError = 0, C.fragmentError = !1, w = w || !!C.videoCodec, S = S || !!C.audioCodec, d && C.audioCodec && C.audioCodec.indexOf("mp4a.40.34") !== -1 && (C.audioCodec = void 0), x = E[C.bitrate], x ? x.url.push(C.url) : (C.url = [C.url], C.urlId = 0, E[C.bitrate] = C, y.push(C)), D && (D.AUDIO && (S = !0, c.addGroupId(x || C, "audio", D.AUDIO)), D.SUBTITLES && c.addGroupId(x || C, "text", D.SUBTITLES));
            }), w && S && (y = y.filter(function(C) {
              var D = C.videoCodec;
              return !!D;
            })), y = y.filter(function(C) {
              var D = C.audioCodec, R = C.videoCodec;
              return (!D || h.isCodecSupportedInMp4(D, "audio")) && (!R || h.isCodecSupportedInMp4(R, "video"));
            }), b.audioTracks && (v = b.audioTracks.filter(function(C) {
              return !C.audioCodec || h.isCodecSupportedInMp4(C.audioCodec, "audio");
            }), v.forEach(function(C, D) {
              C.id = D;
            })), y.length > 0) {
              g = y[0].bitrate, y.sort(function(C, D) {
                return C.bitrate - D.bitrate;
              }), this._levels = y;
              for (var T = 0; T < y.length; T++)
                if (y[T].bitrate === g) {
                  this._firstLevel = T, l.logger.log("manifest loaded," + y.length + " level(s) found, first bitrate:" + g);
                  break;
                }
              this.hls.trigger(s.default.MANIFEST_PARSED, {
                levels: y,
                audioTracks: v,
                firstLevel: this._firstLevel,
                stats: b.stats,
                audio: S,
                video: w,
                altAudio: v.some(function(C) {
                  return !!C.url;
                })
              });
            } else
              this.hls.trigger(s.default.ERROR, {
                type: u.ErrorTypes.MEDIA_ERROR,
                details: u.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
                fatal: !0,
                url: this.hls.url,
                reason: "no level with compatible codecs found in manifest"
              });
          }, Object.defineProperty(p.prototype, "levels", {
            get: function() {
              return this._levels;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(p.prototype, "level", {
            get: function() {
              return this.currentLevelIndex;
            },
            set: function(b) {
              var y = this._levels;
              y && (b = Math.min(b, y.length - 1), (this.currentLevelIndex !== b || !y[b].details) && this.setLevelInternal(b));
            },
            enumerable: !0,
            configurable: !0
          }), p.prototype.setLevelInternal = function(b) {
            var y = this._levels, v = this.hls;
            if (b >= 0 && b < y.length) {
              if (this.clearTimer(), this.currentLevelIndex !== b) {
                l.logger.log("switching to level " + b), this.currentLevelIndex = b;
                var g = y[b];
                g.level = b, v.trigger(s.default.LEVEL_SWITCHING, g);
              }
              var E = y[b], x = E.details;
              if (!x || x.live) {
                var w = E.urlId;
                v.trigger(s.default.LEVEL_LOADING, { url: E.url[w], level: b, id: w });
              }
            } else
              v.trigger(s.default.ERROR, {
                type: u.ErrorTypes.OTHER_ERROR,
                details: u.ErrorDetails.LEVEL_SWITCH_ERROR,
                level: b,
                fatal: !1,
                reason: "invalid level idx"
              });
          }, Object.defineProperty(p.prototype, "manualLevel", {
            get: function() {
              return this.manualLevelIndex;
            },
            set: function(b) {
              this.manualLevelIndex = b, this._startLevel === void 0 && (this._startLevel = b), b !== -1 && (this.level = b);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(p.prototype, "firstLevel", {
            get: function() {
              return this._firstLevel;
            },
            set: function(b) {
              this._firstLevel = b;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(p.prototype, "startLevel", {
            get: function() {
              if (this._startLevel === void 0) {
                var b = this.hls.config.startLevel;
                return b !== void 0 ? b : this._firstLevel;
              } else
                return this._startLevel;
            },
            set: function(b) {
              this._startLevel = b;
            },
            enumerable: !0,
            configurable: !0
          }), p.prototype.onError = function(b) {
            if (b.fatal) {
              b.type === u.ErrorTypes.NETWORK_ERROR && this.clearTimer();
              return;
            }
            var y = !1, v = !1, g;
            switch (b.details) {
              case u.ErrorDetails.FRAG_LOAD_ERROR:
              case u.ErrorDetails.FRAG_LOAD_TIMEOUT:
              case u.ErrorDetails.KEY_LOAD_ERROR:
              case u.ErrorDetails.KEY_LOAD_TIMEOUT:
                g = b.frag.level, v = !0;
                break;
              case u.ErrorDetails.LEVEL_LOAD_ERROR:
              case u.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                g = b.context.level, y = !0;
                break;
              case u.ErrorDetails.REMUX_ALLOC_ERROR:
                g = b.level, y = !0;
                break;
            }
            g !== void 0 && this.recoverLevel(b, g, y, v);
          }, p.prototype.recoverLevel = function(b, y, v, g) {
            var E = this, x = this.hls.config, w = b.details, S = this._levels[y], T, C, D;
            if (S.loadError++, S.fragmentError = g, v)
              if (this.levelRetryCount + 1 <= x.levelLoadingMaxRetry)
                C = Math.min(Math.pow(2, this.levelRetryCount) * x.levelLoadingRetryDelay, x.levelLoadingMaxRetryTimeout), this.timer = setTimeout(function() {
                  return E.loadLevel();
                }, C), b.levelRetry = !0, this.levelRetryCount++, l.logger.warn("level controller, " + w + ", retry in " + C + " ms, current retry count is " + this.levelRetryCount);
              else {
                l.logger.error("level controller, cannot recover from " + w + " error"), this.currentLevelIndex = null, this.clearTimer(), b.fatal = !0;
                return;
              }
            (v || g) && (T = S.url.length, T > 1 && S.loadError < T ? (S.urlId = (S.urlId + 1) % T, S.details = void 0, l.logger.warn("level controller, " + w + " for level " + y + ": switching to redundant URL-id " + S.urlId)) : this.manualLevelIndex === -1 ? (D = y === 0 ? this._levels.length - 1 : y - 1, l.logger.warn("level controller, " + w + ": switch to " + D), this.hls.nextAutoLevel = this.currentLevelIndex = D) : g && (l.logger.warn("level controller, " + w + ": reload a fragment"), this.currentLevelIndex = null));
          }, p.prototype.onFragLoaded = function(b) {
            var y = b.frag;
            if (y !== void 0 && y.type === "main") {
              var v = this._levels[y.level];
              v !== void 0 && (v.fragmentError = !1, v.loadError = 0, this.levelRetryCount = 0);
            }
          }, p.prototype.onLevelLoaded = function(b) {
            var y = this, v = b.level, g = b.details;
            if (v === this.currentLevelIndex) {
              var E = this._levels[v];
              if (E.fragmentError || (E.loadError = 0, this.levelRetryCount = 0), g.live) {
                var x = c.computeReloadInterval(E.details, g, b.stats.trequest);
                l.logger.log("live playlist, reload in " + Math.round(x) + " ms"), this.timer = setTimeout(function() {
                  return y.loadLevel();
                }, x);
              } else
                this.clearTimer();
            }
          }, p.prototype.onAudioTrackSwitched = function(b) {
            var y = this.hls.audioTracks[b.id].groupId, v = this.hls.levels[this.currentLevelIndex];
            if (!!v && v.audioGroupIds) {
              for (var g = -1, E = 0; E < v.audioGroupIds.length; E++)
                if (v.audioGroupIds[E] === y) {
                  g = E;
                  break;
                }
              g !== v.urlId && (v.urlId = g, this.startLoad());
            }
          }, p.prototype.loadLevel = function() {
            if (l.logger.debug("call to loadLevel"), this.currentLevelIndex !== null && this.canload) {
              var b = this._levels[this.currentLevelIndex];
              if (typeof b == "object" && b.url.length > 0) {
                var y = this.currentLevelIndex, v = b.urlId, g = b.url[v];
                l.logger.log("Attempt loading level index " + y + " with URL-id " + v), this.hls.trigger(s.default.LEVEL_LOADING, { url: g, level: y, id: v });
              }
            }
          }, Object.defineProperty(p.prototype, "nextLoadLevel", {
            get: function() {
              return this.manualLevelIndex !== -1 ? this.manualLevelIndex : this.hls.nextAutoLevel;
            },
            set: function(b) {
              this.level = b, this.manualLevelIndex === -1 && (this.hls.nextAutoLevel = b);
            },
            enumerable: !0,
            configurable: !0
          }), p;
        }(o.default);
        t.default = f;
      },
      "./src/controller/level-helper.js": function(i, t, n) {
        (function(a) {
          Object.defineProperty(t, "__esModule", { value: !0 });
          var s = n("./src/utils/logger.js");
          function o(p, b, y) {
            switch (b) {
              case "audio":
                p.audioGroupIds || (p.audioGroupIds = []), p.audioGroupIds.push(y);
                break;
              case "text":
                p.textGroupIds || (p.textGroupIds = []), p.textGroupIds.push(y);
                break;
            }
          }
          t.addGroupId = o;
          function l(p, b, y) {
            var v = p[b], g = p[y], E = g.startPTS;
            a.isFinite(E) ? y > b ? (v.duration = E - v.start, v.duration < 0 && s.logger.warn("negative duration computed for frag " + v.sn + ",level " + v.level + ", there should be some duration drift between playlist and fragment!")) : (g.duration = v.start - E, g.duration < 0 && s.logger.warn("negative duration computed for frag " + g.sn + ",level " + g.level + ", there should be some duration drift between playlist and fragment!")) : y > b ? g.start = v.start + v.duration : g.start = Math.max(v.start - g.duration, 0);
          }
          t.updatePTS = l;
          function u(p, b, y, v, g, E) {
            var x = y;
            if (a.isFinite(b.startPTS)) {
              var w = Math.abs(b.startPTS - y);
              a.isFinite(b.deltaPTS) ? b.deltaPTS = Math.max(w, b.deltaPTS) : b.deltaPTS = w, x = Math.max(y, b.startPTS), y = Math.min(y, b.startPTS), v = Math.max(v, b.endPTS), g = Math.min(g, b.startDTS), E = Math.max(E, b.endDTS);
            }
            var S = y - b.start;
            b.start = b.startPTS = y, b.maxStartPTS = x, b.endPTS = v, b.startDTS = g, b.endDTS = E, b.duration = v - y;
            var T = b.sn;
            if (!p || T < p.startSN || T > p.endSN)
              return 0;
            var C, D, R;
            for (C = T - p.startSN, D = p.fragments, D[C] = b, R = C; R > 0; R--)
              l(D, R, R - 1);
            for (R = C; R < D.length - 1; R++)
              l(D, R, R + 1);
            return p.PTSKnown = !0, S;
          }
          t.updateFragPTSDTS = u;
          function h(p, b) {
            b.initSegment && p.initSegment && (b.initSegment = p.initSegment);
            var y = 0, v;
            if (d(p, b, function(x, w) {
              y = x.cc - w.cc, a.isFinite(x.startPTS) && (w.start = w.startPTS = x.startPTS, w.endPTS = x.endPTS, w.duration = x.duration, w.backtracked = x.backtracked, w.dropped = x.dropped, v = w), b.PTSKnown = !0;
            }), !!b.PTSKnown) {
              if (y) {
                s.logger.log("discontinuity sliding from playlist, take drift into account");
                for (var g = b.fragments, E = 0; E < g.length; E++)
                  g[E].cc += y;
              }
              v ? u(b, v, v.startPTS, v.endPTS, v.startDTS, v.endDTS) : f(p, b), b.PTSKnown = p.PTSKnown;
            }
          }
          t.mergeDetails = h;
          function c(p, b, y) {
            y === void 0 && (y = 0);
            var v = -1;
            d(p, b, function(x, w, S) {
              w.start = x.start, v = S;
            });
            var g = b.fragments;
            if (v < 0) {
              g.forEach(function(x) {
                x.start += y;
              });
              return;
            }
            for (var E = v + 1; E < g.length; E++)
              g[E].start = g[E - 1].start + g[E - 1].duration;
          }
          t.mergeSubtitlePlaylists = c;
          function d(p, b, y) {
            if (!(!p || !b))
              for (var v = Math.max(p.startSN, b.startSN) - b.startSN, g = Math.min(p.endSN, b.endSN) - b.startSN, E = b.startSN - p.startSN, x = v; x <= g; x++) {
                var w = p.fragments[E + x], S = b.fragments[x];
                if (!w || !S)
                  break;
                y(w, S, x);
              }
          }
          t.mapFragmentIntersection = d;
          function f(p, b) {
            var y = b.startSN - p.startSN, v = p.fragments, g = b.fragments;
            if (!(y < 0 || y > v.length))
              for (var E = 0; E < g.length; E++)
                g[E].start += v[y].start;
          }
          t.adjustSliding = f;
          function m(p, b, y) {
            var v = 1e3 * (b.averagetargetduration ? b.averagetargetduration : b.targetduration), g = v / 2;
            return p && b.endSN === p.endSN && (v = g), y && (v = Math.max(g, v - (window.performance.now() - y))), Math.round(v);
          }
          t.computeReloadInterval = m;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/controller/stream-controller.js": function(i, t, n) {
        (function(a) {
          var s = this && this.__extends || function() {
            var T = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(C, D) {
              C.__proto__ = D;
            } || function(C, D) {
              for (var R in D)
                D.hasOwnProperty(R) && (C[R] = D[R]);
            };
            return function(C, D) {
              T(C, D);
              function R() {
                this.constructor = C;
              }
              C.prototype = D === null ? Object.create(D) : (R.prototype = D.prototype, new R());
            };
          }();
          Object.defineProperty(t, "__esModule", { value: !0 });
          var o = n("./src/utils/binary-search.js"), l = n("./src/utils/buffer-helper.js"), u = n("./src/demux/demuxer.js"), h = n("./src/events.js"), c = n("./src/controller/fragment-tracker.js"), d = n("./src/loader/fragment.js"), f = n("./src/loader/playlist-loader.js"), m = n("./src/controller/level-helper.js"), p = n("./src/utils/time-ranges.js"), b = n("./src/errors.js"), y = n("./src/utils/logger.js"), v = n("./src/utils/discontinuities.js"), g = n("./src/controller/fragment-finders.js"), E = n("./src/controller/gap-controller.js"), x = n("./src/controller/base-stream-controller.js"), w = 100, S = function(T) {
            s(C, T);
            function C(D, R) {
              var P = T.call(this, D, h.default.MEDIA_ATTACHED, h.default.MEDIA_DETACHING, h.default.MANIFEST_LOADING, h.default.MANIFEST_PARSED, h.default.LEVEL_LOADED, h.default.KEY_LOADED, h.default.FRAG_LOADED, h.default.FRAG_LOAD_EMERGENCY_ABORTED, h.default.FRAG_PARSING_INIT_SEGMENT, h.default.FRAG_PARSING_DATA, h.default.FRAG_PARSED, h.default.ERROR, h.default.AUDIO_TRACK_SWITCHING, h.default.AUDIO_TRACK_SWITCHED, h.default.BUFFER_CREATED, h.default.BUFFER_APPENDED, h.default.BUFFER_FLUSHED) || this;
              return P.fragmentTracker = R, P.config = D.config, P.audioCodecSwap = !1, P._state = x.State.STOPPED, P.stallReported = !1, P.gapController = null, P;
            }
            return C.prototype.startLoad = function(D) {
              if (this.levels) {
                var R = this.lastCurrentTime, P = this.hls;
                if (this.stopLoad(), this.setInterval(w), this.level = -1, this.fragLoadError = 0, !this.startFragRequested) {
                  var N = P.startLevel;
                  N === -1 && (N = 0, this.bitrateTest = !0), this.level = P.nextLoadLevel = N, this.loadedmetadata = !1;
                }
                R > 0 && D === -1 && (y.logger.log("override startPosition with lastCurrentTime @" + R.toFixed(3)), D = R), this.state = x.State.IDLE, this.nextLoadPosition = this.startPosition = this.lastCurrentTime = D, this.tick();
              } else
                this.forceStartLoad = !0, this.state = x.State.STOPPED;
            }, C.prototype.stopLoad = function() {
              this.forceStartLoad = !1, T.prototype.stopLoad.call(this);
            }, C.prototype.doTick = function() {
              switch (this.state) {
                case x.State.BUFFER_FLUSHING:
                  this.fragLoadError = 0;
                  break;
                case x.State.IDLE:
                  this._doTickIdle();
                  break;
                case x.State.WAITING_LEVEL:
                  var D = this.levels[this.level];
                  D && D.details && (this.state = x.State.IDLE);
                  break;
                case x.State.FRAG_LOADING_WAITING_RETRY:
                  var R = window.performance.now(), P = this.retryDate;
                  (!P || R >= P || this.media && this.media.seeking) && (y.logger.log("mediaController: retryDate reached, switch back to IDLE state"), this.state = x.State.IDLE);
                  break;
                case x.State.ERROR:
                case x.State.STOPPED:
                case x.State.FRAG_LOADING:
                case x.State.PARSING:
                case x.State.PARSED:
                case x.State.ENDED:
                  break;
              }
              this._checkBuffer(), this._checkFragmentChanged();
            }, C.prototype._doTickIdle = function() {
              var D = this.hls, R = D.config, P = this.media;
              if (!(this.levelLastLoaded === void 0 || !P && (this.startFragRequested || !R.startFragPrefetch))) {
                var N;
                this.loadedmetadata ? N = P.currentTime : N = this.nextLoadPosition;
                var $ = D.nextLoadLevel, O = this.levels[$];
                if (!!O) {
                  var M = O.bitrate, F;
                  M ? F = Math.max(8 * R.maxBufferSize / M, R.maxBufferLength) : F = R.maxBufferLength, F = Math.min(F, R.maxMaxBufferLength);
                  var G = l.BufferHelper.bufferInfo(this.mediaBuffer ? this.mediaBuffer : P, N, R.maxBufferHole), K = G.len;
                  if (!(K >= F)) {
                    y.logger.trace("buffer length of " + K.toFixed(3) + " is below max of " + F.toFixed(3) + ". checking for more payload ..."), this.level = D.nextLoadLevel = $;
                    var J = O.details;
                    if (!J || J.live && this.levelLastLoaded !== $) {
                      this.state = x.State.WAITING_LEVEL;
                      return;
                    }
                    if (this._streamEnded(G, J)) {
                      var ue = {};
                      this.altAudio && (ue.type = "video"), this.hls.trigger(h.default.BUFFER_EOS, ue), this.state = x.State.ENDED;
                      return;
                    }
                    this._fetchPayloadOrEos(N, G, J);
                  }
                }
              }
            }, C.prototype._fetchPayloadOrEos = function(D, R, P) {
              var N = this.fragPrevious, $ = this.level, O = P.fragments, M = O.length;
              if (M !== 0) {
                var F = O[0].start, G = O[M - 1].start + O[M - 1].duration, K = R.end, J;
                if (P.initSegment && !P.initSegment.data)
                  J = P.initSegment;
                else if (P.live) {
                  var ue = this.config.initialLiveManifestSize;
                  if (M < ue) {
                    y.logger.warn("Can not start playback of a level, reason: not enough fragments " + M + " < " + ue);
                    return;
                  }
                  if (J = this._ensureFragmentAtLivePoint(P, K, F, G, N, O, M), J === null)
                    return;
                } else
                  K < F && (J = O[0]);
                J || (J = this._findFragment(F, N, M, O, K, G, P)), J && (J.encrypted ? (y.logger.log("Loading key for " + J.sn + " of [" + P.startSN + " ," + P.endSN + "],level " + $), this._loadKey(J)) : (y.logger.log("Loading " + J.sn + " of [" + P.startSN + " ," + P.endSN + "],level " + $ + ", currentTime:" + D.toFixed(3) + ",bufferEnd:" + K.toFixed(3)), this._loadFragment(J)));
              }
            }, C.prototype._ensureFragmentAtLivePoint = function(D, R, P, N, $, O, M) {
              var F = this.hls.config, G = this.media, K, J = F.liveMaxLatencyDuration !== void 0 ? F.liveMaxLatencyDuration : F.liveMaxLatencyDurationCount * D.targetduration;
              if (R < Math.max(P - F.maxFragLookUpTolerance, N - J)) {
                var ue = this.liveSyncPosition = this.computeLivePosition(P, D);
                y.logger.log("buffer end: " + R.toFixed(3) + " is located too far from the end of live sliding playlist, reset currentTime to : " + ue.toFixed(3)), R = ue, G && G.readyState && G.duration > ue && (G.currentTime = ue), this.nextLoadPosition = ue;
              }
              if (D.PTSKnown && R > N && G && G.readyState)
                return null;
              if (this.startFragRequested && !D.PTSKnown) {
                if ($)
                  if (D.hasProgramDateTime)
                    y.logger.log("live playlist, switching playlist, load frag with same PDT: " + $.programDateTime), K = g.findFragmentByPDT(O, $.endProgramDateTime, F.maxFragLookUpTolerance);
                  else {
                    var ce = $.sn + 1;
                    if (ce >= D.startSN && ce <= D.endSN) {
                      var ee = O[ce - D.startSN];
                      $.cc === ee.cc && (K = ee, y.logger.log("live playlist, switching playlist, load frag with next SN: " + K.sn));
                    }
                    K || (K = o.default.search(O, function(me) {
                      return $.cc - me.cc;
                    }), K && y.logger.log("live playlist, switching playlist, load frag with same CC: " + K.sn));
                  }
                K || (K = O[Math.min(M - 1, Math.round(M / 2))], y.logger.log("live playlist, switching playlist, unknown, load middle frag : " + K.sn));
              }
              return K;
            }, C.prototype._findFragment = function(D, R, P, N, $, O, M) {
              var F = this.hls.config, G;
              if ($ < O) {
                var K = $ > O - F.maxFragLookUpTolerance ? 0 : F.maxFragLookUpTolerance;
                G = g.findFragmentByPTS(R, N, $, K);
              } else
                G = N[P - 1];
              if (G) {
                var J = G.sn - M.startSN, ue = R && G.level === R.level, ce = N[J - 1], ee = N[J + 1];
                if (R && G.sn === R.sn)
                  if (ue && !G.backtracked)
                    if (G.sn < M.endSN) {
                      var me = R.deltaPTS;
                      me && me > F.maxBufferHole && R.dropped && J ? (G = ce, y.logger.warn("SN just loaded, with large PTS gap between audio and video, maybe frag is not starting with a keyframe ? load previous one to try to overcome this")) : (G = ee, y.logger.log("SN just loaded, load next one: " + G.sn, G));
                    } else
                      G = null;
                  else
                    G.backtracked && (ee && ee.backtracked ? (y.logger.warn("Already backtracked from fragment " + ee.sn + ", will not backtrack to fragment " + G.sn + ". Loading fragment " + ee.sn), G = ee) : (y.logger.warn("Loaded fragment with dropped frames, backtracking 1 segment to find a keyframe"), G.dropped = 0, ce ? (G = ce, G.backtracked = !0) : J && (G = null)));
              }
              return G;
            }, C.prototype._loadKey = function(D) {
              this.state = x.State.KEY_LOADING, this.hls.trigger(h.default.KEY_LOADING, { frag: D });
            }, C.prototype._loadFragment = function(D) {
              var R = this.fragmentTracker.getState(D);
              this.fragCurrent = D, this.startFragRequested = !0, a.isFinite(D.sn) && !D.bitrateTest && (this.nextLoadPosition = D.start + D.duration), D.backtracked || R === c.FragmentState.NOT_LOADED || R === c.FragmentState.PARTIAL ? (D.autoLevel = this.hls.autoLevelEnabled, D.bitrateTest = this.bitrateTest, this.hls.trigger(h.default.FRAG_LOADING, { frag: D }), this.demuxer || (this.demuxer = new u.default(this.hls, "main")), this.state = x.State.FRAG_LOADING) : R === c.FragmentState.APPENDING && this._reduceMaxBufferLength(D.duration) && this.fragmentTracker.removeFragment(D);
            }, Object.defineProperty(C.prototype, "state", {
              get: function() {
                return this._state;
              },
              set: function(D) {
                if (this.state !== D) {
                  var R = this.state;
                  this._state = D, y.logger.log("main stream:" + R + "->" + D), this.hls.trigger(h.default.STREAM_STATE_TRANSITION, { previousState: R, nextState: D });
                }
              },
              enumerable: !0,
              configurable: !0
            }), C.prototype.getBufferedFrag = function(D) {
              return this.fragmentTracker.getBufferedFrag(D, f.default.LevelType.MAIN);
            }, Object.defineProperty(C.prototype, "currentLevel", {
              get: function() {
                var D = this.media;
                if (D) {
                  var R = this.getBufferedFrag(D.currentTime);
                  if (R)
                    return R.level;
                }
                return -1;
              },
              enumerable: !0,
              configurable: !0
            }), Object.defineProperty(C.prototype, "nextBufferedFrag", {
              get: function() {
                var D = this.media;
                return D ? this.followingBufferedFrag(this.getBufferedFrag(D.currentTime)) : null;
              },
              enumerable: !0,
              configurable: !0
            }), C.prototype.followingBufferedFrag = function(D) {
              return D ? this.getBufferedFrag(D.endPTS + 0.5) : null;
            }, Object.defineProperty(C.prototype, "nextLevel", {
              get: function() {
                var D = this.nextBufferedFrag;
                return D ? D.level : -1;
              },
              enumerable: !0,
              configurable: !0
            }), C.prototype._checkFragmentChanged = function() {
              var D, R, P = this.media;
              if (P && P.readyState && P.seeking === !1 && (R = P.currentTime, R > this.lastCurrentTime && (this.lastCurrentTime = R), l.BufferHelper.isBuffered(P, R) ? D = this.getBufferedFrag(R) : l.BufferHelper.isBuffered(P, R + 0.1) && (D = this.getBufferedFrag(R + 0.1)), D)) {
                var N = D;
                if (N !== this.fragPlaying) {
                  this.hls.trigger(h.default.FRAG_CHANGED, { frag: N });
                  var $ = N.level;
                  (!this.fragPlaying || this.fragPlaying.level !== $) && this.hls.trigger(h.default.LEVEL_SWITCHED, { level: $ }), this.fragPlaying = N;
                }
              }
            }, C.prototype.immediateLevelSwitch = function() {
              if (y.logger.log("immediateLevelSwitch"), !this.immediateSwitch) {
                this.immediateSwitch = !0;
                var D = this.media, R = void 0;
                D ? (R = D.paused, D.pause()) : R = !0, this.previouslyPaused = R;
              }
              var P = this.fragCurrent;
              P && P.loader && P.loader.abort(), this.fragCurrent = null, this.flushMainBuffer(0, a.POSITIVE_INFINITY);
            }, C.prototype.immediateLevelSwitchEnd = function() {
              var D = this.media;
              D && D.buffered.length && (this.immediateSwitch = !1, l.BufferHelper.isBuffered(D, D.currentTime) && (D.currentTime -= 1e-4), this.previouslyPaused || D.play());
            }, C.prototype.nextLevelSwitch = function() {
              var D = this.media;
              if (D && D.readyState) {
                var R = void 0, P = void 0, N = void 0;
                if (P = this.getBufferedFrag(D.currentTime), P && P.startPTS > 1 && this.flushMainBuffer(0, P.startPTS - 1), D.paused)
                  R = 0;
                else {
                  var $ = this.hls.nextLoadLevel, O = this.levels[$], M = this.fragLastKbps;
                  M && this.fragCurrent ? R = this.fragCurrent.duration * O.bitrate / (1e3 * M) + 1 : R = 0;
                }
                if (N = this.getBufferedFrag(D.currentTime + R), N && (N = this.followingBufferedFrag(N), N)) {
                  var F = this.fragCurrent;
                  F && F.loader && F.loader.abort(), this.fragCurrent = null, this.flushMainBuffer(N.maxStartPTS, a.POSITIVE_INFINITY);
                }
              }
            }, C.prototype.flushMainBuffer = function(D, R) {
              this.state = x.State.BUFFER_FLUSHING;
              var P = { startOffset: D, endOffset: R };
              this.altAudio && (P.type = "video"), this.hls.trigger(h.default.BUFFER_FLUSHING, P);
            }, C.prototype.onMediaAttached = function(D) {
              var R = this.media = this.mediaBuffer = D.media;
              this.onvseeking = this.onMediaSeeking.bind(this), this.onvseeked = this.onMediaSeeked.bind(this), this.onvended = this.onMediaEnded.bind(this), R.addEventListener("seeking", this.onvseeking), R.addEventListener("seeked", this.onvseeked), R.addEventListener("ended", this.onvended);
              var P = this.config;
              this.levels && P.autoStartLoad && this.hls.startLoad(P.startPosition), this.gapController = new E.default(P, R, this.fragmentTracker, this.hls);
            }, C.prototype.onMediaDetaching = function() {
              var D = this.media;
              D && D.ended && (y.logger.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0);
              var R = this.levels;
              R && R.forEach(function(P) {
                P.details && P.details.fragments.forEach(function(N) {
                  N.backtracked = void 0;
                });
              }), D && (D.removeEventListener("seeking", this.onvseeking), D.removeEventListener("seeked", this.onvseeked), D.removeEventListener("ended", this.onvended), this.onvseeking = this.onvseeked = this.onvended = null), this.media = this.mediaBuffer = null, this.loadedmetadata = !1, this.stopLoad();
            }, C.prototype.onMediaSeeked = function() {
              var D = this.media, R = D ? D.currentTime : void 0;
              a.isFinite(R) && y.logger.log("media seeked to " + R.toFixed(3)), this.tick();
            }, C.prototype.onManifestLoading = function() {
              y.logger.log("trigger BUFFER_RESET"), this.hls.trigger(h.default.BUFFER_RESET), this.fragmentTracker.removeAllFragments(), this.stalled = !1, this.startPosition = this.lastCurrentTime = 0;
            }, C.prototype.onManifestParsed = function(D) {
              var R = !1, P = !1, N;
              D.levels.forEach(function(O) {
                N = O.audioCodec, N && (N.indexOf("mp4a.40.2") !== -1 && (R = !0), N.indexOf("mp4a.40.5") !== -1 && (P = !0));
              }), this.audioCodecSwitch = R && P, this.audioCodecSwitch && y.logger.log("both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"), this.levels = D.levels, this.startFragRequested = !1;
              var $ = this.config;
              ($.autoStartLoad || this.forceStartLoad) && this.hls.startLoad($.startPosition);
            }, C.prototype.onLevelLoaded = function(D) {
              var R = D.details, P = D.level, N = this.levels[this.levelLastLoaded], $ = this.levels[P], O = R.totalduration, M = 0;
              if (y.logger.log("level " + P + " loaded [" + R.startSN + "," + R.endSN + "],duration:" + O), R.live) {
                var F = $.details;
                F && R.fragments.length > 0 ? (m.mergeDetails(F, R), M = R.fragments[0].start, this.liveSyncPosition = this.computeLivePosition(M, F), R.PTSKnown && a.isFinite(M) ? y.logger.log("live playlist sliding:" + M.toFixed(3)) : (y.logger.log("live playlist - outdated PTS, unknown sliding"), v.alignStream(this.fragPrevious, N, R))) : (y.logger.log("live playlist - first load, unknown sliding"), R.PTSKnown = !1, v.alignStream(this.fragPrevious, N, R));
              } else
                R.PTSKnown = !1;
              if ($.details = R, this.levelLastLoaded = P, this.hls.trigger(h.default.LEVEL_UPDATED, { details: R, level: P }), this.startFragRequested === !1) {
                if (this.startPosition === -1 || this.lastCurrentTime === -1) {
                  var G = R.startTimeOffset;
                  a.isFinite(G) ? (G < 0 && (y.logger.log("negative start time offset " + G + ", count from end of last fragment"), G = M + O + G), y.logger.log("start time offset found in playlist, adjust startPosition to " + G), this.startPosition = G) : R.live ? (this.startPosition = this.computeLivePosition(M, R), y.logger.log("configure startPosition to " + this.startPosition)) : this.startPosition = 0, this.lastCurrentTime = this.startPosition;
                }
                this.nextLoadPosition = this.startPosition;
              }
              this.state === x.State.WAITING_LEVEL && (this.state = x.State.IDLE), this.tick();
            }, C.prototype.onKeyLoaded = function() {
              this.state === x.State.KEY_LOADING && (this.state = x.State.IDLE, this.tick());
            }, C.prototype.onFragLoaded = function(D) {
              var R = this, P = R.fragCurrent, N = R.hls, $ = R.levels, O = R.media, M = D.frag;
              if (this.state === x.State.FRAG_LOADING && P && M.type === "main" && M.level === P.level && M.sn === P.sn) {
                var F = D.stats, G = $[P.level], K = G.details;
                if (this.bitrateTest = !1, this.stats = F, y.logger.log("Loaded " + P.sn + " of [" + K.startSN + " ," + K.endSN + "],level " + P.level), M.bitrateTest && N.nextLoadLevel)
                  this.state = x.State.IDLE, this.startFragRequested = !1, F.tparsed = F.tbuffered = window.performance.now(), N.trigger(h.default.FRAG_BUFFERED, { stats: F, frag: P, id: "main" }), this.tick();
                else if (M.sn === "initSegment")
                  this.state = x.State.IDLE, F.tparsed = F.tbuffered = window.performance.now(), K.initSegment.data = D.payload, N.trigger(h.default.FRAG_BUFFERED, { stats: F, frag: P, id: "main" }), this.tick();
                else {
                  y.logger.log("Parsing " + P.sn + " of [" + K.startSN + " ," + K.endSN + "],level " + P.level + ", cc " + P.cc), this.state = x.State.PARSING, this.pendingBuffering = !0, this.appended = !1, M.bitrateTest && (M.bitrateTest = !1, this.fragmentTracker.onFragLoaded({
                    frag: M
                  }));
                  var J = !(O && O.seeking) && (K.PTSKnown || !K.live), ue = K.initSegment ? K.initSegment.data : [], ce = this._getAudioCodec(G), ee = this.demuxer = this.demuxer || new u.default(this.hls, "main");
                  ee.push(D.payload, ue, ce, G.videoCodec, P, K.totalduration, J);
                }
              }
              this.fragLoadError = 0;
            }, C.prototype.onFragParsingInitSegment = function(D) {
              var R = this.fragCurrent, P = D.frag;
              if (R && D.id === "main" && P.sn === R.sn && P.level === R.level && this.state === x.State.PARSING) {
                var N = D.tracks, $ = void 0, O = void 0;
                if (N.audio && this.altAudio && delete N.audio, O = N.audio, O) {
                  var M = this.levels[this.level].audioCodec, F = navigator.userAgent.toLowerCase();
                  M && this.audioCodecSwap && (y.logger.log("swapping playlist audio codec"), M.indexOf("mp4a.40.5") !== -1 ? M = "mp4a.40.2" : M = "mp4a.40.5"), this.audioCodecSwitch && O.metadata.channelCount !== 1 && F.indexOf("firefox") === -1 && (M = "mp4a.40.5"), F.indexOf("android") !== -1 && O.container !== "audio/mpeg" && (M = "mp4a.40.2", y.logger.log("Android: force audio codec to " + M)), O.levelCodec = M, O.id = D.id;
                }
                O = N.video, O && (O.levelCodec = this.levels[this.level].videoCodec, O.id = D.id), this.hls.trigger(h.default.BUFFER_CODECS, N);
                for ($ in N) {
                  O = N[$], y.logger.log("main track:" + $ + ",container:" + O.container + ",codecs[level/parsed]=[" + O.levelCodec + "/" + O.codec + "]");
                  var G = O.initSegment;
                  G && (this.appended = !0, this.pendingBuffering = !0, this.hls.trigger(h.default.BUFFER_APPENDING, { type: $, data: G, parent: "main", content: "initSegment" }));
                }
                this.tick();
              }
            }, C.prototype.onFragParsingData = function(D) {
              var R = this, P = this.fragCurrent, N = D.frag;
              if (P && D.id === "main" && N.sn === P.sn && N.level === P.level && !(D.type === "audio" && this.altAudio) && this.state === x.State.PARSING) {
                var $ = this.levels[this.level], O = P;
                if (a.isFinite(D.endPTS) || (D.endPTS = D.startPTS + P.duration, D.endDTS = D.startDTS + P.duration), D.hasAudio === !0 && O.addElementaryStream(d.default.ElementaryStreamTypes.AUDIO), D.hasVideo === !0 && O.addElementaryStream(d.default.ElementaryStreamTypes.VIDEO), y.logger.log("Parsed " + D.type + ",PTS:[" + D.startPTS.toFixed(3) + "," + D.endPTS.toFixed(3) + "],DTS:[" + D.startDTS.toFixed(3) + "/" + D.endDTS.toFixed(3) + "],nb:" + D.nb + ",dropped:" + (D.dropped || 0)), D.type === "video")
                  if (O.dropped = D.dropped, O.dropped)
                    if (O.backtracked)
                      y.logger.warn("Already backtracked on this fragment, appending with the gap", O.sn);
                    else {
                      var M = $.details;
                      if (M && O.sn === M.startSN)
                        y.logger.warn("missing video frame(s) on first frag, appending with gap", O.sn);
                      else {
                        y.logger.warn("missing video frame(s), backtracking fragment", O.sn), this.fragmentTracker.removeFragment(O), O.backtracked = !0, this.nextLoadPosition = D.startPTS, this.state = x.State.IDLE, this.fragPrevious = O, this.tick();
                        return;
                      }
                    }
                  else
                    O.backtracked = !1;
                var F = m.updateFragPTSDTS($.details, O, D.startPTS, D.endPTS, D.startDTS, D.endDTS), G = this.hls;
                G.trigger(h.default.LEVEL_PTS_UPDATED, { details: $.details, level: this.level, drift: F, type: D.type, start: D.startPTS, end: D.endPTS }), [D.data1, D.data2].forEach(function(K) {
                  K && K.length && R.state === x.State.PARSING && (R.appended = !0, R.pendingBuffering = !0, G.trigger(h.default.BUFFER_APPENDING, { type: D.type, data: K, parent: "main", content: "data" }));
                }), this.tick();
              }
            }, C.prototype.onFragParsed = function(D) {
              var R = this.fragCurrent, P = D.frag;
              R && D.id === "main" && P.sn === R.sn && P.level === R.level && this.state === x.State.PARSING && (this.stats.tparsed = window.performance.now(), this.state = x.State.PARSED, this._checkAppendedParsed());
            }, C.prototype.onAudioTrackSwitching = function(D) {
              var R = !!D.url, P = D.id;
              if (!R) {
                if (this.mediaBuffer !== this.media) {
                  y.logger.log("switching on main audio, use media.buffered to schedule main fragment loading"), this.mediaBuffer = this.media;
                  var N = this.fragCurrent;
                  N.loader && (y.logger.log("switching to main audio track, cancel main fragment load"), N.loader.abort()), this.fragCurrent = null, this.fragPrevious = null, this.demuxer && (this.demuxer.destroy(), this.demuxer = null), this.state = x.State.IDLE;
                }
                var $ = this.hls;
                $.trigger(h.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: a.POSITIVE_INFINITY, type: "audio" }), $.trigger(h.default.AUDIO_TRACK_SWITCHED, { id: P }), this.altAudio = !1;
              }
            }, C.prototype.onAudioTrackSwitched = function(D) {
              var R = D.id, P = !!this.hls.audioTracks[R].url;
              if (P) {
                var N = this.videoBuffer;
                N && this.mediaBuffer !== N && (y.logger.log("switching on alternate audio, use video.buffered to schedule main fragment loading"), this.mediaBuffer = N);
              }
              this.altAudio = P, this.tick();
            }, C.prototype.onBufferCreated = function(D) {
              var R = D.tracks, P, N, $ = !1;
              for (var O in R) {
                var M = R[O];
                M.id === "main" ? (N = O, P = M, O === "video" && (this.videoBuffer = R[O].buffer)) : $ = !0;
              }
              $ && P ? (y.logger.log("alternate track found, use " + N + ".buffered to schedule main fragment loading"), this.mediaBuffer = P.buffer) : this.mediaBuffer = this.media;
            }, C.prototype.onBufferAppended = function(D) {
              if (D.parent === "main") {
                var R = this.state;
                (R === x.State.PARSING || R === x.State.PARSED) && (this.pendingBuffering = D.pending > 0, this._checkAppendedParsed());
              }
            }, C.prototype._checkAppendedParsed = function() {
              if (this.state === x.State.PARSED && (!this.appended || !this.pendingBuffering)) {
                var D = this.fragCurrent;
                if (D) {
                  var R = this.mediaBuffer ? this.mediaBuffer : this.media;
                  y.logger.log("main buffered : " + p.default.toString(R.buffered)), this.fragPrevious = D;
                  var P = this.stats;
                  P.tbuffered = window.performance.now(), this.fragLastKbps = Math.round(8 * P.total / (P.tbuffered - P.tfirst)), this.hls.trigger(h.default.FRAG_BUFFERED, { stats: P, frag: D, id: "main" }), this.state = x.State.IDLE;
                }
                this.tick();
              }
            }, C.prototype.onError = function(D) {
              var R = D.frag || this.fragCurrent;
              if (!(R && R.type !== "main")) {
                var P = !!this.media && l.BufferHelper.isBuffered(this.media, this.media.currentTime) && l.BufferHelper.isBuffered(this.media, this.media.currentTime + 0.5);
                switch (D.details) {
                  case b.ErrorDetails.FRAG_LOAD_ERROR:
                  case b.ErrorDetails.FRAG_LOAD_TIMEOUT:
                  case b.ErrorDetails.KEY_LOAD_ERROR:
                  case b.ErrorDetails.KEY_LOAD_TIMEOUT:
                    if (!D.fatal)
                      if (this.fragLoadError + 1 <= this.config.fragLoadingMaxRetry) {
                        var N = Math.min(Math.pow(2, this.fragLoadError) * this.config.fragLoadingRetryDelay, this.config.fragLoadingMaxRetryTimeout);
                        y.logger.warn("mediaController: frag loading failed, retry in " + N + " ms"), this.retryDate = window.performance.now() + N, this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition), this.fragLoadError++, this.state = x.State.FRAG_LOADING_WAITING_RETRY;
                      } else
                        y.logger.error("mediaController: " + D.details + " reaches max retry, redispatch as fatal ..."), D.fatal = !0, this.state = x.State.ERROR;
                    break;
                  case b.ErrorDetails.LEVEL_LOAD_ERROR:
                  case b.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                    this.state !== x.State.ERROR && (D.fatal ? (this.state = x.State.ERROR, y.logger.warn("streamController: " + D.details + ",switch to " + this.state + " state ...")) : !D.levelRetry && this.state === x.State.WAITING_LEVEL && (this.state = x.State.IDLE));
                    break;
                  case b.ErrorDetails.BUFFER_FULL_ERROR:
                    D.parent === "main" && (this.state === x.State.PARSING || this.state === x.State.PARSED) && (P ? (this._reduceMaxBufferLength(this.config.maxBufferLength), this.state = x.State.IDLE) : (y.logger.warn("buffer full error also media.currentTime is not buffered, flush everything"), this.fragCurrent = null, this.flushMainBuffer(0, a.POSITIVE_INFINITY)));
                    break;
                }
              }
            }, C.prototype._reduceMaxBufferLength = function(D) {
              var R = this.config;
              return R.maxMaxBufferLength >= D ? (R.maxMaxBufferLength /= 2, y.logger.warn("main:reduce max buffer length to " + R.maxMaxBufferLength + "s"), !0) : !1;
            }, C.prototype._checkBuffer = function() {
              var D = this.media;
              if (!(!D || D.readyState === 0)) {
                var R = this.mediaBuffer ? this.mediaBuffer : D, P = R.buffered;
                !this.loadedmetadata && P.length ? (this.loadedmetadata = !0, this._seekToStartPos()) : this.immediateSwitch ? this.immediateLevelSwitchEnd() : this.gapController.poll(this.lastCurrentTime, P);
              }
            }, C.prototype.onFragLoadEmergencyAborted = function() {
              this.state = x.State.IDLE, this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition), this.tick();
            }, C.prototype.onBufferFlushed = function() {
              var D = this.mediaBuffer ? this.mediaBuffer : this.media;
              D && this.fragmentTracker.detectEvictedFragments(d.default.ElementaryStreamTypes.VIDEO, D.buffered), this.state = x.State.IDLE, this.fragPrevious = null;
            }, C.prototype.swapAudioCodec = function() {
              this.audioCodecSwap = !this.audioCodecSwap;
            }, C.prototype.computeLivePosition = function(D, R) {
              var P = this.config.liveSyncDuration !== void 0 ? this.config.liveSyncDuration : this.config.liveSyncDurationCount * R.targetduration;
              return D + Math.max(0, R.totalduration - P);
            }, C.prototype._seekToStartPos = function() {
              var D = this.media, R = D.currentTime, P = D.seeking ? R : this.startPosition;
              R !== P && (y.logger.log("target start position not buffered, seek to buffered.start(0) " + P + " from current time " + R + " "), D.currentTime = P);
            }, C.prototype._getAudioCodec = function(D) {
              var R = this.config.defaultAudioCodec || D.audioCodec;
              return this.audioCodecSwap && (y.logger.log("swapping playlist audio codec"), R && (R.indexOf("mp4a.40.5") !== -1 ? R = "mp4a.40.2" : R = "mp4a.40.5")), R;
            }, Object.defineProperty(C.prototype, "liveSyncPosition", {
              get: function() {
                return this._liveSyncPosition;
              },
              set: function(D) {
                this._liveSyncPosition = D;
              },
              enumerable: !0,
              configurable: !0
            }), C;
          }(x.default);
          t.default = S;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/controller/subtitle-stream-controller.js": function(i, t, n) {
        var a = this && this.__extends || function() {
          var y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, g) {
            v.__proto__ = g;
          } || function(v, g) {
            for (var E in g)
              g.hasOwnProperty(E) && (v[E] = g[E]);
          };
          return function(v, g) {
            y(v, g);
            function E() {
              this.constructor = v;
            }
            v.prototype = g === null ? Object.create(g) : (E.prototype = g.prototype, new E());
          };
        }();
        Object.defineProperty(t, "__esModule", { value: !0 });
        var s = n("./src/events.js"), o = n("./src/utils/logger.js"), l = n("./src/crypt/decrypter.js"), u = n("./src/utils/buffer-helper.js"), h = n("./src/controller/fragment-finders.js"), c = n("./src/controller/fragment-tracker.js"), d = n("./src/controller/base-stream-controller.js"), f = n("./src/controller/level-helper.js"), m = window.performance, p = 500, b = function(y) {
          a(v, y);
          function v(g, E) {
            var x = y.call(this, g, s.default.MEDIA_ATTACHED, s.default.MEDIA_DETACHING, s.default.ERROR, s.default.KEY_LOADED, s.default.FRAG_LOADED, s.default.SUBTITLE_TRACKS_UPDATED, s.default.SUBTITLE_TRACK_SWITCH, s.default.SUBTITLE_TRACK_LOADED, s.default.SUBTITLE_FRAG_PROCESSED, s.default.LEVEL_UPDATED) || this;
            return x.fragmentTracker = E, x.config = g.config, x.state = d.State.STOPPED, x.tracks = [], x.tracksBuffered = [], x.currentTrackId = -1, x.decrypter = new l.default(g, g.config), x.lastAVStart = 0, x._onMediaSeeking = x.onMediaSeeking.bind(x), x;
          }
          return v.prototype.onSubtitleFragProcessed = function(g) {
            var E = g.frag, x = g.success;
            if (this.fragPrevious = E, this.state = d.State.IDLE, !!x) {
              var w = this.tracksBuffered[this.currentTrackId];
              if (!!w) {
                for (var S, T = E.start, C = 0; C < w.length; C++)
                  if (T >= w[C].start && T <= w[C].end) {
                    S = w[C];
                    break;
                  }
                var D = E.start + E.duration;
                S ? S.end = D : (S = {
                  start: T,
                  end: D
                }, w.push(S));
              }
            }
          }, v.prototype.onMediaAttached = function(g) {
            var E = g.media;
            this.media = E, E.addEventListener("seeking", this._onMediaSeeking), this.state = d.State.IDLE;
          }, v.prototype.onMediaDetaching = function() {
            this.media.removeEventListener("seeking", this._onMediaSeeking), this.media = null, this.state = d.State.STOPPED;
          }, v.prototype.onError = function(g) {
            var E = g.frag;
            !E || E.type !== "subtitle" || (this.state = d.State.IDLE);
          }, v.prototype.onSubtitleTracksUpdated = function(g) {
            var E = this;
            o.logger.log("subtitle tracks updated"), this.tracksBuffered = [], this.tracks = g.subtitleTracks, this.tracks.forEach(function(x) {
              E.tracksBuffered[x.id] = [];
            });
          }, v.prototype.onSubtitleTrackSwitch = function(g) {
            if (this.currentTrackId = g.id, !this.tracks || this.currentTrackId === -1) {
              this.clearInterval();
              return;
            }
            var E = this.tracks[this.currentTrackId];
            E && E.details && this.setInterval(p);
          }, v.prototype.onSubtitleTrackLoaded = function(g) {
            var E = g.id, x = g.details, w = this, S = w.currentTrackId, T = w.tracks, C = T[S];
            E >= T.length || E !== S || !C || (x.live && f.mergeSubtitlePlaylists(C.details, x, this.lastAVStart), C.details = x, this.setInterval(p));
          }, v.prototype.onKeyLoaded = function() {
            this.state === d.State.KEY_LOADING && (this.state = d.State.IDLE);
          }, v.prototype.onFragLoaded = function(g) {
            var E = this.fragCurrent, x = g.frag.decryptdata, w = g.frag, S = this.hls;
            if (this.state === d.State.FRAG_LOADING && E && g.frag.type === "subtitle" && E.sn === g.frag.sn && g.payload.byteLength > 0 && x && x.key && x.method === "AES-128") {
              var T = m.now();
              this.decrypter.decrypt(g.payload, x.key.buffer, x.iv.buffer, function(C) {
                var D = m.now();
                S.trigger(s.default.FRAG_DECRYPTED, { frag: w, payload: C, stats: { tstart: T, tdecrypt: D } });
              });
            }
          }, v.prototype.onLevelUpdated = function(g) {
            var E = g.details, x = E.fragments;
            this.lastAVStart = x.length ? x[0].start : 0;
          }, v.prototype.doTick = function() {
            if (!this.media) {
              this.state = d.State.IDLE;
              return;
            }
            switch (this.state) {
              case d.State.IDLE: {
                var g = this, E = g.config, x = g.currentTrackId, w = g.fragmentTracker, S = g.media, T = g.tracks;
                if (!T || !T[x] || !T[x].details)
                  break;
                var C = E.maxBufferHole, D = E.maxFragLookUpTolerance, R = Math.min(E.maxBufferLength, E.maxMaxBufferLength), P = u.BufferHelper.bufferedInfo(this._getBuffered(), S.currentTime, C), N = P.end, $ = P.len, O = T[x].details, M = O.fragments, F = M.length, G = M[F - 1].start + M[F - 1].duration;
                if ($ > R)
                  return;
                var K = void 0, J = this.fragPrevious;
                N < G ? (J && O.hasProgramDateTime && (K = h.findFragmentByPDT(M, J.endProgramDateTime, D)), K || (K = h.findFragmentByPTS(J, M, N, D))) : K = M[F - 1], K && K.encrypted ? (o.logger.log("Loading key for " + K.sn), this.state = d.State.KEY_LOADING, this.hls.trigger(s.default.KEY_LOADING, { frag: K })) : K && w.getState(K) === c.FragmentState.NOT_LOADED && (this.fragCurrent = K, this.state = d.State.FRAG_LOADING, this.hls.trigger(s.default.FRAG_LOADING, { frag: K }));
              }
            }
          }, v.prototype.stopLoad = function() {
            this.lastAVStart = 0, y.prototype.stopLoad.call(this);
          }, v.prototype._getBuffered = function() {
            return this.tracksBuffered[this.currentTrackId] || [];
          }, v.prototype.onMediaSeeking = function() {
            this.fragPrevious = null;
          }, v;
        }(d.default);
        t.SubtitleStreamController = b;
      },
      "./src/controller/subtitle-track-controller.js": function(i, t, n) {
        (function(a) {
          var s = this && this.__extends || function() {
            var f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(m, p) {
              m.__proto__ = p;
            } || function(m, p) {
              for (var b in p)
                p.hasOwnProperty(b) && (m[b] = p[b]);
            };
            return function(m, p) {
              f(m, p);
              function b() {
                this.constructor = m;
              }
              m.prototype = p === null ? Object.create(p) : (b.prototype = p.prototype, new b());
            };
          }();
          Object.defineProperty(t, "__esModule", { value: !0 });
          var o = n("./src/events.js"), l = n("./src/event-handler.js"), u = n("./src/utils/logger.js"), h = n("./src/controller/level-helper.js"), c = function(f) {
            s(m, f);
            function m(p) {
              var b = f.call(this, p, o.default.MEDIA_ATTACHED, o.default.MEDIA_DETACHING, o.default.MANIFEST_LOADED, o.default.SUBTITLE_TRACK_LOADED) || this;
              return b.tracks = [], b.trackId = -1, b.media = null, b.stopped = !0, b.subtitleDisplay = !0, b;
            }
            return m.prototype.destroy = function() {
              l.default.prototype.destroy.call(this);
            }, m.prototype.onMediaAttached = function(p) {
              var b = this;
              this.media = p.media, this.media && (this.queuedDefaultTrack && (this.subtitleTrack = this.queuedDefaultTrack, delete this.queuedDefaultTrack), this.trackChangeListener = this._onTextTracksChanged.bind(this), this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks), this.useTextTrackPolling ? this.subtitlePollingInterval = setInterval(function() {
                b.trackChangeListener();
              }, 500) : this.media.textTracks.addEventListener("change", this.trackChangeListener));
            }, m.prototype.onMediaDetaching = function() {
              !this.media || (this.useTextTrackPolling ? clearInterval(this.subtitlePollingInterval) : this.media.textTracks.removeEventListener("change", this.trackChangeListener), this.media = null);
            }, m.prototype.onManifestLoaded = function(p) {
              var b = this, y = p.subtitles || [];
              this.tracks = y, this.hls.trigger(o.default.SUBTITLE_TRACKS_UPDATED, { subtitleTracks: y }), y.forEach(function(v) {
                v.default && (b.media ? b.subtitleTrack = v.id : b.queuedDefaultTrack = v.id);
              });
            }, m.prototype.onSubtitleTrackLoaded = function(p) {
              var b = this, y = p.id, v = p.details, g = this, E = g.trackId, x = g.tracks, w = x[E];
              if (y >= x.length || y !== E || !w || this.stopped) {
                this._clearReloadTimer();
                return;
              }
              if (u.logger.log("subtitle track " + y + " loaded"), v.live) {
                var S = h.computeReloadInterval(w.details, v, p.stats.trequest);
                u.logger.log("Reloading live subtitle playlist in " + S + "ms"), this.timer = setTimeout(function() {
                  b._loadCurrentTrack();
                }, S);
              } else
                this._clearReloadTimer();
            }, m.prototype.startLoad = function() {
              this.stopped = !1, this._loadCurrentTrack();
            }, m.prototype.stopLoad = function() {
              this.stopped = !0, this._clearReloadTimer();
            }, Object.defineProperty(m.prototype, "subtitleTracks", {
              get: function() {
                return this.tracks;
              },
              enumerable: !0,
              configurable: !0
            }), Object.defineProperty(m.prototype, "subtitleTrack", {
              get: function() {
                return this.trackId;
              },
              set: function(p) {
                this.trackId !== p && (this._toggleTrackModes(p), this._setSubtitleTrackInternal(p));
              },
              enumerable: !0,
              configurable: !0
            }), m.prototype._clearReloadTimer = function() {
              this.timer && (clearTimeout(this.timer), this.timer = null);
            }, m.prototype._loadCurrentTrack = function() {
              var p = this, b = p.trackId, y = p.tracks, v = p.hls, g = y[b];
              b < 0 || !g || g.details && !g.details.live || (u.logger.log("Loading subtitle track " + b), v.trigger(o.default.SUBTITLE_TRACK_LOADING, { url: g.url, id: b }));
            }, m.prototype._toggleTrackModes = function(p) {
              var b = this, y = b.media, v = b.subtitleDisplay, g = b.trackId;
              if (!!y) {
                var E = d(y.textTracks);
                if (p === -1)
                  [].slice.call(E).forEach(function(S) {
                    S.mode = "disabled";
                  });
                else {
                  var x = E[g];
                  x && (x.mode = "disabled");
                }
                var w = E[p];
                w && (w.mode = v ? "showing" : "hidden");
              }
            }, m.prototype._setSubtitleTrackInternal = function(p) {
              var b = this, y = b.hls, v = b.tracks;
              !a.isFinite(p) || p < -1 || p >= v.length || (this.trackId = p, u.logger.log("Switching to subtitle track " + p), y.trigger(o.default.SUBTITLE_TRACK_SWITCH, { id: p }), this._loadCurrentTrack());
            }, m.prototype._onTextTracksChanged = function() {
              if (!!this.media) {
                for (var p = -1, b = d(this.media.textTracks), y = 0; y < b.length; y++)
                  if (b[y].mode === "hidden")
                    p = y;
                  else if (b[y].mode === "showing") {
                    p = y;
                    break;
                  }
                this.subtitleTrack = p;
              }
            }, m;
          }(l.default);
          function d(f) {
            for (var m = [], p = 0; p < f.length; p++) {
              var b = f[p];
              b.kind === "subtitles" && b.label && m.push(f[p]);
            }
            return m;
          }
          t.default = c;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/controller/timeline-controller.js": function(i, t, n) {
        (function(a) {
          var s = this && this.__extends || function() {
            var y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, g) {
              v.__proto__ = g;
            } || function(v, g) {
              for (var E in g)
                g.hasOwnProperty(E) && (v[E] = g[E]);
            };
            return function(v, g) {
              y(v, g);
              function E() {
                this.constructor = v;
              }
              v.prototype = g === null ? Object.create(g) : (E.prototype = g.prototype, new E());
            };
          }();
          Object.defineProperty(t, "__esModule", { value: !0 });
          var o = n("./src/events.js"), l = n("./src/event-handler.js"), u = n("./src/utils/cea-608-parser.js"), h = n("./src/utils/output-filter.js"), c = n("./src/utils/webvtt-parser.js"), d = n("./src/utils/logger.js"), f = n("./src/utils/texttrack-utils.js");
          function m(y, v) {
            return y && y.label === v.name && !(y.textTrack1 || y.textTrack2);
          }
          function p(y, v, g, E) {
            return Math.min(v, E) - Math.max(y, g);
          }
          var b = function(y) {
            s(v, y);
            function v(g) {
              var E = y.call(this, g, o.default.MEDIA_ATTACHING, o.default.MEDIA_DETACHING, o.default.FRAG_PARSING_USERDATA, o.default.FRAG_DECRYPTED, o.default.MANIFEST_LOADING, o.default.MANIFEST_LOADED, o.default.FRAG_LOADED, o.default.LEVEL_SWITCHING, o.default.INIT_PTS_FOUND) || this;
              if (E.hls = g, E.config = g.config, E.enabled = !0, E.Cues = g.config.cueHandler, E.textTracks = [], E.tracks = [], E.unparsedVttFrags = [], E.initPTS = [], E.cueRanges = [], E.captionsTracks = {}, E.captionsProperties = {
                textTrack1: {
                  label: E.config.captionsTextTrack1Label,
                  languageCode: E.config.captionsTextTrack1LanguageCode
                },
                textTrack2: {
                  label: E.config.captionsTextTrack2Label,
                  languageCode: E.config.captionsTextTrack2LanguageCode
                }
              }, E.config.enableCEA708Captions) {
                var x = new h.default(E, "textTrack1"), w = new h.default(E, "textTrack2");
                E.cea608Parser = new u.default(0, x, w);
              }
              return E;
            }
            return v.prototype.addCues = function(g, E, x, w) {
              for (var S = this.cueRanges, T = !1, C = S.length; C--; ) {
                var D = S[C], R = p(D[0], D[1], E, x);
                if (R >= 0 && (D[0] = Math.min(D[0], E), D[1] = Math.max(D[1], x), T = !0, R / (x - E) > 0.5))
                  return;
              }
              T || S.push([E, x]), this.Cues.newCue(this.captionsTracks[g], E, x, w);
            }, v.prototype.onInitPtsFound = function(g) {
              var E = this;
              if (g.id === "main" && (this.initPTS[g.frag.cc] = g.initPTS), this.unparsedVttFrags.length) {
                var x = this.unparsedVttFrags;
                this.unparsedVttFrags = [], x.forEach(function(w) {
                  E.onFragLoaded(w);
                });
              }
            }, v.prototype.getExistingTrack = function(g) {
              var E = this.media;
              if (E)
                for (var x = 0; x < E.textTracks.length; x++) {
                  var w = E.textTracks[x];
                  if (w[g])
                    return w;
                }
              return null;
            }, v.prototype.createCaptionsTrack = function(g) {
              var E = this.captionsProperties[g], x = E.label, w = E.languageCode, S = this.captionsTracks;
              if (!S[g]) {
                var T = this.getExistingTrack(g);
                if (T)
                  S[g] = T, f.clearCurrentCues(S[g]), f.sendAddTrackEvent(S[g], this.media);
                else {
                  var C = this.createTextTrack("captions", x, w);
                  C && (C[g] = !0, S[g] = C);
                }
              }
            }, v.prototype.createTextTrack = function(g, E, x) {
              var w = this.media;
              if (w)
                return w.addTextTrack(g, E, x);
            }, v.prototype.destroy = function() {
              l.default.prototype.destroy.call(this);
            }, v.prototype.onMediaAttaching = function(g) {
              this.media = g.media, this._cleanTracks();
            }, v.prototype.onMediaDetaching = function() {
              var g = this.captionsTracks;
              Object.keys(g).forEach(function(E) {
                f.clearCurrentCues(g[E]), delete g[E];
              });
            }, v.prototype.onManifestLoading = function() {
              this.lastSn = -1, this.prevCC = -1, this.vttCCs = {
                ccOffset: 0,
                presentationOffset: 0,
                0: {
                  start: 0,
                  prevCC: -1,
                  new: !1
                }
              }, this._cleanTracks();
            }, v.prototype._cleanTracks = function() {
              var g = this.media;
              if (g) {
                var E = g.textTracks;
                if (E)
                  for (var x = 0; x < E.length; x++)
                    f.clearCurrentCues(E[x]);
              }
            }, v.prototype.onManifestLoaded = function(g) {
              var E = this;
              if (this.textTracks = [], this.unparsedVttFrags = this.unparsedVttFrags || [], this.initPTS = [], this.cueRanges = [], this.config.enableWebVTT) {
                this.tracks = g.subtitles || [];
                var x = this.media ? this.media.textTracks : [];
                this.tracks.forEach(function(w, S) {
                  var T;
                  if (S < x.length) {
                    for (var C = null, D = 0; D < x.length; D++)
                      if (m(x[D], w)) {
                        C = x[D];
                        break;
                      }
                    C && (T = C);
                  }
                  T || (T = E.createTextTrack("subtitles", w.name, w.lang)), w.default ? T.mode = E.hls.subtitleDisplay ? "showing" : "hidden" : T.mode = "disabled", E.textTracks.push(T);
                });
              }
            }, v.prototype.onLevelSwitching = function() {
              this.enabled = this.hls.currentLevel.closedCaptions !== "NONE";
            }, v.prototype.onFragLoaded = function(g) {
              var E = g.frag, x = g.payload;
              if (E.type === "main") {
                var w = E.sn;
                if (w !== this.lastSn + 1) {
                  var S = this.cea608Parser;
                  S && S.reset();
                }
                this.lastSn = w;
              } else if (E.type === "subtitle")
                if (x.byteLength) {
                  if (!a.isFinite(this.initPTS[E.cc])) {
                    this.unparsedVttFrags.push(g), this.initPTS.length && this.hls.trigger(o.default.SUBTITLE_FRAG_PROCESSED, { success: !1, frag: E });
                    return;
                  }
                  var T = E.decryptdata;
                  (T == null || T.key == null || T.method !== "AES-128") && this._parseVTTs(E, x);
                } else
                  this.hls.trigger(o.default.SUBTITLE_FRAG_PROCESSED, { success: !1, frag: E });
            }, v.prototype._parseVTTs = function(g, E) {
              var x = this.vttCCs;
              x[g.cc] || (x[g.cc] = { start: g.start, prevCC: this.prevCC, new: !0 }, this.prevCC = g.cc);
              var w = this.textTracks, S = this.hls;
              c.default.parse(E, this.initPTS[g.cc], x, g.cc, function(T) {
                var C = w[g.level];
                if (C.mode === "disabled") {
                  S.trigger(o.default.SUBTITLE_FRAG_PROCESSED, { success: !1, frag: g });
                  return;
                }
                T.forEach(function(D) {
                  if (!C.cues.getCueById(D.id))
                    try {
                      C.addCue(D);
                    } catch {
                      var R = new window.TextTrackCue(D.startTime, D.endTime, D.text);
                      R.id = D.id, C.addCue(R);
                    }
                }), S.trigger(o.default.SUBTITLE_FRAG_PROCESSED, { success: !0, frag: g });
              }, function(T) {
                d.logger.log("Failed to parse VTT cue: " + T), S.trigger(o.default.SUBTITLE_FRAG_PROCESSED, { success: !1, frag: g });
              });
            }, v.prototype.onFragDecrypted = function(g) {
              var E = g.payload, x = g.frag;
              if (x.type === "subtitle") {
                if (!a.isFinite(this.initPTS[x.cc])) {
                  this.unparsedVttFrags.push(g);
                  return;
                }
                this._parseVTTs(x, E);
              }
            }, v.prototype.onFragParsingUserdata = function(g) {
              if (this.enabled && this.config.enableCEA708Captions)
                for (var E = 0; E < g.samples.length; E++) {
                  var x = this.extractCea608Data(g.samples[E].bytes);
                  this.cea608Parser.addData(g.samples[E].pts, x);
                }
            }, v.prototype.extractCea608Data = function(g) {
              for (var E = g[0] & 31, x = 2, w, S, T, C, D, R = [], P = 0; P < E; P++)
                w = g[x++], S = 127 & g[x++], T = 127 & g[x++], C = (4 & w) !== 0, D = 3 & w, !(S === 0 && T === 0) && C && D === 0 && (R.push(S), R.push(T));
              return R;
            }, v;
          }(l.default);
          t.default = b;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/crypt/aes-crypto.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = function() {
          function s(o, l) {
            this.subtle = o, this.aesIV = l;
          }
          return s.prototype.decrypt = function(o, l) {
            return this.subtle.decrypt({ name: "AES-CBC", iv: this.aesIV }, l, o);
          }, s;
        }();
        t.default = a;
      },
      "./src/crypt/aes-decryptor.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        function a(o) {
          var l = o.byteLength, u = l && new DataView(o).getUint8(l - 1);
          return u ? o.slice(0, l - u) : o;
        }
        t.removePadding = a;
        var s = function() {
          function o() {
            this.rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.sBox = new Uint32Array(256), this.invSBox = new Uint32Array(256), this.key = new Uint32Array(0), this.initTable();
          }
          return o.prototype.uint8ArrayToUint32Array_ = function(l) {
            for (var u = new DataView(l), h = new Uint32Array(4), c = 0; c < 4; c++)
              h[c] = u.getUint32(c * 4);
            return h;
          }, o.prototype.initTable = function() {
            var l = this.sBox, u = this.invSBox, h = this.subMix, c = h[0], d = h[1], f = h[2], m = h[3], p = this.invSubMix, b = p[0], y = p[1], v = p[2], g = p[3], E = new Uint32Array(256), x = 0, w = 0, S = 0;
            for (S = 0; S < 256; S++)
              S < 128 ? E[S] = S << 1 : E[S] = S << 1 ^ 283;
            for (S = 0; S < 256; S++) {
              var T = w ^ w << 1 ^ w << 2 ^ w << 3 ^ w << 4;
              T = T >>> 8 ^ T & 255 ^ 99, l[x] = T, u[T] = x;
              var C = E[x], D = E[C], R = E[D], P = E[T] * 257 ^ T * 16843008;
              c[x] = P << 24 | P >>> 8, d[x] = P << 16 | P >>> 16, f[x] = P << 8 | P >>> 24, m[x] = P, P = R * 16843009 ^ D * 65537 ^ C * 257 ^ x * 16843008, b[T] = P << 24 | P >>> 8, y[T] = P << 16 | P >>> 16, v[T] = P << 8 | P >>> 24, g[T] = P, x ? (x = C ^ E[E[E[R ^ C]]], w ^= E[E[w]]) : x = w = 1;
            }
          }, o.prototype.expandKey = function(l) {
            for (var u = this.uint8ArrayToUint32Array_(l), h = !0, c = 0; c < u.length && h; )
              h = u[c] === this.key[c], c++;
            if (!h) {
              this.key = u;
              var d = this.keySize = u.length;
              if (d !== 4 && d !== 6 && d !== 8)
                throw new Error("Invalid aes key size=" + d);
              var f = this.ksRows = (d + 6 + 1) * 4, m, p, b = this.keySchedule = new Uint32Array(f), y = this.invKeySchedule = new Uint32Array(f), v = this.sBox, g = this.rcon, E = this.invSubMix, x = E[0], w = E[1], S = E[2], T = E[3], C, D;
              for (m = 0; m < f; m++) {
                if (m < d) {
                  C = b[m] = u[m];
                  continue;
                }
                D = C, m % d === 0 ? (D = D << 8 | D >>> 24, D = v[D >>> 24] << 24 | v[D >>> 16 & 255] << 16 | v[D >>> 8 & 255] << 8 | v[D & 255], D ^= g[m / d | 0] << 24) : d > 6 && m % d === 4 && (D = v[D >>> 24] << 24 | v[D >>> 16 & 255] << 16 | v[D >>> 8 & 255] << 8 | v[D & 255]), b[m] = C = (b[m - d] ^ D) >>> 0;
              }
              for (p = 0; p < f; p++)
                m = f - p, p & 3 ? D = b[m] : D = b[m - 4], p < 4 || m <= 4 ? y[p] = D : y[p] = x[v[D >>> 24]] ^ w[v[D >>> 16 & 255]] ^ S[v[D >>> 8 & 255]] ^ T[v[D & 255]], y[p] = y[p] >>> 0;
            }
          }, o.prototype.networkToHostOrderSwap = function(l) {
            return l << 24 | (l & 65280) << 8 | (l & 16711680) >> 8 | l >>> 24;
          }, o.prototype.decrypt = function(l, u, h, c) {
            for (var d = this.keySize + 6, f = this.invKeySchedule, m = this.invSBox, p = this.invSubMix, b = p[0], y = p[1], v = p[2], g = p[3], E = this.uint8ArrayToUint32Array_(h), x = E[0], w = E[1], S = E[2], T = E[3], C = new Int32Array(l), D = new Int32Array(C.length), R, P, N, $, O, M, F, G, K, J, ue, ce, ee, me, Ce = this.networkToHostOrderSwap; u < C.length; ) {
              for (K = Ce(C[u]), J = Ce(C[u + 1]), ue = Ce(C[u + 2]), ce = Ce(C[u + 3]), O = K ^ f[0], M = ce ^ f[1], F = ue ^ f[2], G = J ^ f[3], ee = 4, me = 1; me < d; me++)
                R = b[O >>> 24] ^ y[M >> 16 & 255] ^ v[F >> 8 & 255] ^ g[G & 255] ^ f[ee], P = b[M >>> 24] ^ y[F >> 16 & 255] ^ v[G >> 8 & 255] ^ g[O & 255] ^ f[ee + 1], N = b[F >>> 24] ^ y[G >> 16 & 255] ^ v[O >> 8 & 255] ^ g[M & 255] ^ f[ee + 2], $ = b[G >>> 24] ^ y[O >> 16 & 255] ^ v[M >> 8 & 255] ^ g[F & 255] ^ f[ee + 3], O = R, M = P, F = N, G = $, ee = ee + 4;
              R = m[O >>> 24] << 24 ^ m[M >> 16 & 255] << 16 ^ m[F >> 8 & 255] << 8 ^ m[G & 255] ^ f[ee], P = m[M >>> 24] << 24 ^ m[F >> 16 & 255] << 16 ^ m[G >> 8 & 255] << 8 ^ m[O & 255] ^ f[ee + 1], N = m[F >>> 24] << 24 ^ m[G >> 16 & 255] << 16 ^ m[O >> 8 & 255] << 8 ^ m[M & 255] ^ f[ee + 2], $ = m[G >>> 24] << 24 ^ m[O >> 16 & 255] << 16 ^ m[M >> 8 & 255] << 8 ^ m[F & 255] ^ f[ee + 3], ee = ee + 3, D[u] = Ce(R ^ x), D[u + 1] = Ce($ ^ w), D[u + 2] = Ce(N ^ S), D[u + 3] = Ce(P ^ T), x = K, w = J, S = ue, T = ce, u = u + 4;
            }
            return c ? a(D.buffer) : D.buffer;
          }, o.prototype.destroy = function() {
            this.key = void 0, this.keySize = void 0, this.ksRows = void 0, this.sBox = void 0, this.invSBox = void 0, this.subMix = void 0, this.invSubMix = void 0, this.keySchedule = void 0, this.invKeySchedule = void 0, this.rcon = void 0;
          }, o;
        }();
        t.default = s;
      },
      "./src/crypt/decrypter.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/crypt/aes-crypto.js"), s = n("./src/crypt/fast-aes-key.js"), o = n("./src/crypt/aes-decryptor.js"), l = n("./src/errors.js"), u = n("./src/utils/logger.js"), h = n("./src/events.js"), c = n("./src/utils/get-self-scope.js"), d = c.getSelfScope(), f = function() {
          function m(p, b, y) {
            var v = (y === void 0 ? {} : y).removePKCS7Padding, g = v === void 0 ? !0 : v;
            if (this.logEnabled = !0, this.observer = p, this.config = b, this.removePKCS7Padding = g, g)
              try {
                var E = d.crypto;
                E && (this.subtle = E.subtle || E.webkitSubtle);
              } catch {
              }
            this.disableWebCrypto = !this.subtle;
          }
          return m.prototype.isSync = function() {
            return this.disableWebCrypto && this.config.enableSoftwareAES;
          }, m.prototype.decrypt = function(p, b, y, v) {
            var g = this;
            if (this.disableWebCrypto && this.config.enableSoftwareAES) {
              this.logEnabled && (u.logger.log("JS AES decrypt"), this.logEnabled = !1);
              var E = this.decryptor;
              E || (this.decryptor = E = new o.default()), E.expandKey(b), v(E.decrypt(p, 0, y, this.removePKCS7Padding));
            } else {
              this.logEnabled && (u.logger.log("WebCrypto AES decrypt"), this.logEnabled = !1);
              var x = this.subtle;
              this.key !== b && (this.key = b, this.fastAesKey = new s.default(x, b)), this.fastAesKey.expandKey().then(function(w) {
                var S = new a.default(x, y);
                S.decrypt(p, w).catch(function(T) {
                  g.onWebCryptoError(T, p, b, y, v);
                }).then(function(T) {
                  v(T);
                });
              }).catch(function(w) {
                g.onWebCryptoError(w, p, b, y, v);
              });
            }
          }, m.prototype.onWebCryptoError = function(p, b, y, v, g) {
            this.config.enableSoftwareAES ? (u.logger.log("WebCrypto Error, disable WebCrypto API"), this.disableWebCrypto = !0, this.logEnabled = !0, this.decrypt(b, y, v, g)) : (u.logger.error("decrypting error : " + p.message), this.observer.trigger(h.default.ERROR, { type: l.ErrorTypes.MEDIA_ERROR, details: l.ErrorDetails.FRAG_DECRYPT_ERROR, fatal: !0, reason: p.message }));
          }, m.prototype.destroy = function() {
            var p = this.decryptor;
            p && (p.destroy(), this.decryptor = void 0);
          }, m;
        }();
        t.default = f;
      },
      "./src/crypt/fast-aes-key.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = function() {
          function s(o, l) {
            this.subtle = o, this.key = l;
          }
          return s.prototype.expandKey = function() {
            return this.subtle.importKey("raw", this.key, { name: "AES-CBC" }, !1, ["encrypt", "decrypt"]);
          }, s;
        }();
        t.default = a;
      },
      "./src/demux/aacdemuxer.js": function(i, t, n) {
        (function(a) {
          Object.defineProperty(t, "__esModule", { value: !0 });
          var s = n("./src/demux/adts.js"), o = n("./src/utils/logger.js"), l = n("./src/demux/id3.js"), u = function() {
            function h(c, d, f) {
              this.observer = c, this.config = f, this.remuxer = d;
            }
            return h.prototype.resetInitSegment = function(c, d, f, m) {
              this._audioTrack = { container: "audio/adts", type: "audio", id: 0, sequenceNumber: 0, isAAC: !0, samples: [], len: 0, manifestCodec: d, duration: m, inputTimeScale: 9e4 };
            }, h.prototype.resetTimeStamp = function() {
            }, h.probe = function(c) {
              if (!c)
                return !1;
              for (var d = l.default.getID3Data(c, 0) || [], f = d.length, m = c.length; f < m; f++)
                if (s.probe(c, f))
                  return o.logger.log("ADTS sync word found !"), !0;
              return !1;
            }, h.prototype.append = function(c, d, f, m) {
              for (var p = this._audioTrack, b = l.default.getID3Data(c, 0) || [], y = l.default.getTimeStamp(b), v = a.isFinite(y) ? y * 90 : d * 9e4, g = 0, E = v, x = c.length, w = b.length, S = [{ pts: E, dts: E, data: b }]; w < x - 1; )
                if (s.isHeader(c, w) && w + 5 < x) {
                  s.initTrackConfig(p, this.observer, c, w, p.manifestCodec);
                  var T = s.appendFrame(p, c, w, v, g);
                  if (T)
                    w += T.length, E = T.sample.pts, g++;
                  else {
                    o.logger.log("Unable to parse AAC frame");
                    break;
                  }
                } else
                  l.default.isHeader(c, w) ? (b = l.default.getID3Data(c, w), S.push({ pts: E, dts: E, data: b }), w += b.length) : w++;
              this.remuxer.remux(p, { samples: [] }, { samples: S, inputTimeScale: 9e4 }, { samples: [] }, d, f, m);
            }, h.prototype.destroy = function() {
            }, h;
          }();
          t.default = u;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/demux/adts.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/utils/logger.js"), s = n("./src/errors.js"), o = n("./src/events.js");
        function l(v, g, E, x) {
          var w, S, T, C, D, R = navigator.userAgent.toLowerCase(), P = x, N = [
            96e3,
            88200,
            64e3,
            48e3,
            44100,
            32e3,
            24e3,
            22050,
            16e3,
            12e3,
            11025,
            8e3,
            7350
          ];
          if (w = ((g[E + 2] & 192) >>> 6) + 1, S = (g[E + 2] & 60) >>> 2, S > N.length - 1) {
            v.trigger(o.default.ERROR, { type: s.ErrorTypes.MEDIA_ERROR, details: s.ErrorDetails.FRAG_PARSING_ERROR, fatal: !0, reason: "invalid ADTS sampling index:" + S });
            return;
          }
          return C = (g[E + 2] & 1) << 2, C |= (g[E + 3] & 192) >>> 6, a.logger.log("manifest codec:" + x + ",ADTS data:type:" + w + ",sampleingIndex:" + S + "[" + N[S] + "Hz],channelConfig:" + C), /firefox/i.test(R) ? S >= 6 ? (w = 5, D = new Array(4), T = S - 3) : (w = 2, D = new Array(2), T = S) : R.indexOf("android") !== -1 ? (w = 2, D = new Array(2), T = S) : (w = 5, D = new Array(4), x && (x.indexOf("mp4a.40.29") !== -1 || x.indexOf("mp4a.40.5") !== -1) || !x && S >= 6 ? T = S - 3 : ((x && x.indexOf("mp4a.40.2") !== -1 && (S >= 6 && C === 1 || /vivaldi/i.test(R)) || !x && C === 1) && (w = 2, D = new Array(2)), T = S)), D[0] = w << 3, D[0] |= (S & 14) >> 1, D[1] |= (S & 1) << 7, D[1] |= C << 3, w === 5 && (D[1] |= (T & 14) >> 1, D[2] = (T & 1) << 7, D[2] |= 2 << 2, D[3] = 0), { config: D, samplerate: N[S], channelCount: C, codec: "mp4a.40." + w, manifestCodec: P };
        }
        t.getAudioConfig = l;
        function u(v, g) {
          return v[g] === 255 && (v[g + 1] & 246) === 240;
        }
        t.isHeaderPattern = u;
        function h(v, g) {
          return v[g + 1] & 1 ? 7 : 9;
        }
        t.getHeaderLength = h;
        function c(v, g) {
          return (v[g + 3] & 3) << 11 | v[g + 4] << 3 | (v[g + 5] & 224) >>> 5;
        }
        t.getFullFrameLength = c;
        function d(v, g) {
          return !!(g + 1 < v.length && u(v, g));
        }
        t.isHeader = d;
        function f(v, g) {
          if (g + 1 < v.length && u(v, g)) {
            var E = h(v, g), x = E;
            g + 5 < v.length && (x = c(v, g));
            var w = g + x;
            if (w === v.length || w + 1 < v.length && u(v, w))
              return !0;
          }
          return !1;
        }
        t.probe = f;
        function m(v, g, E, x, w) {
          if (!v.samplerate) {
            var S = l(g, E, x, w);
            v.config = S.config, v.samplerate = S.samplerate, v.channelCount = S.channelCount, v.codec = S.codec, v.manifestCodec = S.manifestCodec, a.logger.log("parsed codec:" + v.codec + ",rate:" + S.samplerate + ",nb channel:" + S.channelCount);
          }
        }
        t.initTrackConfig = m;
        function p(v) {
          return 1024 * 9e4 / v;
        }
        t.getFrameDuration = p;
        function b(v, g, E, x, w) {
          var S, T, C, D = v.length;
          if (S = h(v, g), T = c(v, g), T -= S, T > 0 && g + S + T <= D)
            return C = E + x * w, { headerLength: S, frameLength: T, stamp: C };
        }
        t.parseFrameHeader = b;
        function y(v, g, E, x, w) {
          var S = p(v.samplerate), T = b(g, E, x, w, S);
          if (T) {
            var C = T.stamp, D = T.headerLength, R = T.frameLength, P = {
              unit: g.subarray(E + D, E + D + R),
              pts: C,
              dts: C
            };
            return v.samples.push(P), v.len += R, { sample: P, length: R + D };
          }
        }
        t.appendFrame = y;
      },
      "./src/demux/demuxer-inline.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/events.js"), s = n("./src/errors.js"), o = n("./src/crypt/decrypter.js"), l = n("./src/demux/aacdemuxer.js"), u = n("./src/demux/mp4demuxer.js"), h = n("./src/demux/tsdemuxer.js"), c = n("./src/demux/mp3demuxer.js"), d = n("./src/remux/mp4-remuxer.js"), f = n("./src/remux/passthrough-remuxer.js"), m = n("./src/utils/get-self-scope.js"), p = n("./src/utils/logger.js"), b = m.getSelfScope(), y;
        try {
          y = b.performance.now.bind(b.performance);
        } catch {
          p.logger.debug("Unable to use Performance API on this environment"), y = b.Date.now;
        }
        var v = function() {
          function g(E, x, w, S) {
            this.observer = E, this.typeSupported = x, this.config = w, this.vendor = S;
          }
          return g.prototype.destroy = function() {
            var E = this.demuxer;
            E && E.destroy();
          }, g.prototype.push = function(E, x, w, S, T, C, D, R, P, N, $, O) {
            var M = this;
            if (E.byteLength > 0 && x != null && x.key != null && x.method === "AES-128") {
              var F = this.decrypter;
              F == null && (F = this.decrypter = new o.default(this.observer, this.config));
              var G = y();
              F.decrypt(E, x.key.buffer, x.iv.buffer, function(K) {
                var J = y();
                M.observer.trigger(a.default.FRAG_DECRYPTED, { stats: { tstart: G, tdecrypt: J } }), M.pushDecrypted(new Uint8Array(K), x, new Uint8Array(w), S, T, C, D, R, P, N, $, O);
              });
            } else
              this.pushDecrypted(new Uint8Array(E), x, new Uint8Array(w), S, T, C, D, R, P, N, $, O);
          }, g.prototype.pushDecrypted = function(E, x, w, S, T, C, D, R, P, N, $, O) {
            var M = this.demuxer;
            if (!M || (D || R) && !this.probe(E)) {
              for (var F = this.observer, G = this.typeSupported, K = this.config, J = [
                { demux: h.default, remux: d.default },
                { demux: u.default, remux: f.default },
                { demux: l.default, remux: d.default },
                { demux: c.default, remux: d.default }
              ], ue = 0, ce = J.length; ue < ce; ue++) {
                var ee = J[ue], me = ee.demux.probe;
                if (me(E)) {
                  var Ce = this.remuxer = new ee.remux(F, K, G, this.vendor);
                  M = new ee.demux(F, Ce, K, G), this.probe = me;
                  break;
                }
              }
              if (!M) {
                F.trigger(a.default.ERROR, { type: s.ErrorTypes.MEDIA_ERROR, details: s.ErrorDetails.FRAG_PARSING_ERROR, fatal: !0, reason: "no demux matching with content found" });
                return;
              }
              this.demuxer = M;
            }
            var Ne = this.remuxer;
            (D || R) && (M.resetInitSegment(w, S, T, N), Ne.resetInitSegment()), D && (M.resetTimeStamp(O), Ne.resetTimeStamp(O)), typeof M.setDecryptData == "function" && M.setDecryptData(x), M.append(E, C, P, $);
          }, g;
        }();
        t.default = v;
      },
      "./src/demux/demuxer-worker.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/demux/demuxer-inline.js"), s = n("./src/events.js"), o = n("./src/utils/logger.js"), l = n("./node_modules/node-libs-browser/node_modules/events/events.js"), u = function(h) {
          var c = new l.EventEmitter();
          c.trigger = function(m) {
            for (var p = [], b = 1; b < arguments.length; b++)
              p[b - 1] = arguments[b];
            c.emit.apply(c, [m, m].concat(p));
          }, c.off = function(m) {
            for (var p = [], b = 1; b < arguments.length; b++)
              p[b - 1] = arguments[b];
            c.removeListener.apply(c, [m].concat(p));
          };
          var d = function(f, m) {
            h.postMessage({ event: f, data: m });
          };
          h.addEventListener("message", function(f) {
            var m = f.data;
            switch (m.cmd) {
              case "init":
                var p = JSON.parse(m.config);
                h.demuxer = new a.default(c, m.typeSupported, p, m.vendor), o.enableLogs(p.debug), d("init", null);
                break;
              case "demux":
                h.demuxer.push(m.data, m.decryptdata, m.initSegment, m.audioCodec, m.videoCodec, m.timeOffset, m.discontinuity, m.trackSwitch, m.contiguous, m.duration, m.accurateTimeOffset, m.defaultInitPTS);
                break;
            }
          }), c.on(s.default.FRAG_DECRYPTED, d), c.on(s.default.FRAG_PARSING_INIT_SEGMENT, d), c.on(s.default.FRAG_PARSED, d), c.on(s.default.ERROR, d), c.on(s.default.FRAG_PARSING_METADATA, d), c.on(s.default.FRAG_PARSING_USERDATA, d), c.on(s.default.INIT_PTS_FOUND, d), c.on(s.default.FRAG_PARSING_DATA, function(f, m) {
            var p = [], b = { event: f, data: m };
            m.data1 && (b.data1 = m.data1.buffer, p.push(m.data1.buffer), delete m.data1), m.data2 && (b.data2 = m.data2.buffer, p.push(m.data2.buffer), delete m.data2), h.postMessage(b, p);
          });
        };
        t.default = u;
      },
      "./src/demux/demuxer.js": function(i, t, n) {
        (function(a) {
          Object.defineProperty(t, "__esModule", { value: !0 });
          var s = n("./node_modules/webworkify-webpack/index.js"), o = n("./src/events.js"), l = n("./src/demux/demuxer-inline.js"), u = n("./src/utils/logger.js"), h = n("./src/errors.js"), c = n("./src/utils/mediasource-helper.js"), d = n("./src/utils/get-self-scope.js"), f = n("./src/observer.js"), m = d.getSelfScope(), p = c.getMediaSource(), b = function() {
            function y(v, g) {
              var E = this;
              this.hls = v, this.id = g;
              var x = this.observer = new f.Observer(), w = v.config, S = function(R, P) {
                P = P || {}, P.frag = E.frag, P.id = E.id, v.trigger(R, P);
              };
              x.on(o.default.FRAG_DECRYPTED, S), x.on(o.default.FRAG_PARSING_INIT_SEGMENT, S), x.on(o.default.FRAG_PARSING_DATA, S), x.on(o.default.FRAG_PARSED, S), x.on(o.default.ERROR, S), x.on(o.default.FRAG_PARSING_METADATA, S), x.on(o.default.FRAG_PARSING_USERDATA, S), x.on(o.default.INIT_PTS_FOUND, S);
              var T = {
                mp4: p.isTypeSupported("video/mp4"),
                mpeg: p.isTypeSupported("audio/mpeg"),
                mp3: p.isTypeSupported('audio/mp4; codecs="mp3"')
              }, C = navigator.vendor;
              if (w.enableWorker && typeof Worker < "u") {
                u.logger.log("demuxing in webworker");
                var D = void 0;
                try {
                  D = this.w = s("./src/demux/demuxer-worker.js"), this.onwmsg = this.onWorkerMessage.bind(this), D.addEventListener("message", this.onwmsg), D.onerror = function(R) {
                    v.trigger(o.default.ERROR, { type: h.ErrorTypes.OTHER_ERROR, details: h.ErrorDetails.INTERNAL_EXCEPTION, fatal: !0, event: "demuxerWorker", err: { message: R.message + " (" + R.filename + ":" + R.lineno + ")" } });
                  }, D.postMessage({ cmd: "init", typeSupported: T, vendor: C, id: g, config: JSON.stringify(w) });
                } catch (R) {
                  u.logger.warn("Error in worker:", R), u.logger.error("Error while initializing DemuxerWorker, fallback on DemuxerInline"), D && m.URL.revokeObjectURL(D.objectURL), this.demuxer = new l.default(x, T, w, C), this.w = void 0;
                }
              } else
                this.demuxer = new l.default(x, T, w, C);
            }
            return y.prototype.destroy = function() {
              var v = this.w;
              if (v)
                v.removeEventListener("message", this.onwmsg), v.terminate(), this.w = null;
              else {
                var g = this.demuxer;
                g && (g.destroy(), this.demuxer = null);
              }
              var E = this.observer;
              E && (E.removeAllListeners(), this.observer = null);
            }, y.prototype.push = function(v, g, E, x, w, S, T, C) {
              var D = this.w, R = a.isFinite(w.startPTS) ? w.startPTS : w.start, P = w.decryptdata, N = this.frag, $ = !(N && w.cc === N.cc), O = !(N && w.level === N.level), M = N && w.sn === N.sn + 1, F = !O && M;
              if ($ && u.logger.log(this.id + ":discontinuity detected"), O && u.logger.log(this.id + ":switch detected"), this.frag = w, D)
                D.postMessage({ cmd: "demux", data: v, decryptdata: P, initSegment: g, audioCodec: E, videoCodec: x, timeOffset: R, discontinuity: $, trackSwitch: O, contiguous: F, duration: S, accurateTimeOffset: T, defaultInitPTS: C }, v instanceof ArrayBuffer ? [v] : []);
              else {
                var G = this.demuxer;
                G && G.push(v, P, g, E, x, R, $, O, F, S, T, C);
              }
            }, y.prototype.onWorkerMessage = function(v) {
              var g = v.data, E = this.hls;
              switch (g.event) {
                case "init":
                  m.URL.revokeObjectURL(this.w.objectURL);
                  break;
                case o.default.FRAG_PARSING_DATA:
                  g.data.data1 = new Uint8Array(g.data1), g.data2 && (g.data.data2 = new Uint8Array(g.data2));
                default:
                  g.data = g.data || {}, g.data.frag = this.frag, g.data.id = this.id, E.trigger(g.event, g.data);
                  break;
              }
            }, y;
          }();
          t.default = b;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/demux/exp-golomb.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/utils/logger.js"), s = function() {
          function o(l) {
            this.data = l, this.bytesAvailable = l.byteLength, this.word = 0, this.bitsAvailable = 0;
          }
          return o.prototype.loadWord = function() {
            var l = this.data, u = this.bytesAvailable, h = l.byteLength - u, c = new Uint8Array(4), d = Math.min(4, u);
            if (d === 0)
              throw new Error("no bytes available");
            c.set(l.subarray(h, h + d)), this.word = new DataView(c.buffer).getUint32(0), this.bitsAvailable = d * 8, this.bytesAvailable -= d;
          }, o.prototype.skipBits = function(l) {
            var u;
            this.bitsAvailable > l ? (this.word <<= l, this.bitsAvailable -= l) : (l -= this.bitsAvailable, u = l >> 3, l -= u >> 3, this.bytesAvailable -= u, this.loadWord(), this.word <<= l, this.bitsAvailable -= l);
          }, o.prototype.readBits = function(l) {
            var u = Math.min(this.bitsAvailable, l), h = this.word >>> 32 - u;
            return l > 32 && a.logger.error("Cannot read more than 32 bits at a time"), this.bitsAvailable -= u, this.bitsAvailable > 0 ? this.word <<= u : this.bytesAvailable > 0 && this.loadWord(), u = l - u, u > 0 && this.bitsAvailable ? h << u | this.readBits(u) : h;
          }, o.prototype.skipLZ = function() {
            var l;
            for (l = 0; l < this.bitsAvailable; ++l)
              if ((this.word & 2147483648 >>> l) !== 0)
                return this.word <<= l, this.bitsAvailable -= l, l;
            return this.loadWord(), l + this.skipLZ();
          }, o.prototype.skipUEG = function() {
            this.skipBits(1 + this.skipLZ());
          }, o.prototype.skipEG = function() {
            this.skipBits(1 + this.skipLZ());
          }, o.prototype.readUEG = function() {
            var l = this.skipLZ();
            return this.readBits(l + 1) - 1;
          }, o.prototype.readEG = function() {
            var l = this.readUEG();
            return 1 & l ? 1 + l >>> 1 : -1 * (l >>> 1);
          }, o.prototype.readBoolean = function() {
            return this.readBits(1) === 1;
          }, o.prototype.readUByte = function() {
            return this.readBits(8);
          }, o.prototype.readUShort = function() {
            return this.readBits(16);
          }, o.prototype.readUInt = function() {
            return this.readBits(32);
          }, o.prototype.skipScalingList = function(l) {
            var u = 8, h = 8, c, d;
            for (c = 0; c < l; c++)
              h !== 0 && (d = this.readEG(), h = (u + d + 256) % 256), u = h === 0 ? u : h;
          }, o.prototype.readSPS = function() {
            var l = 0, u = 0, h = 0, c = 0, d, f, m, p, b, y, v, g = this.readUByte.bind(this), E = this.readBits.bind(this), x = this.readUEG.bind(this), w = this.readBoolean.bind(this), S = this.skipBits.bind(this), T = this.skipEG.bind(this), C = this.skipUEG.bind(this), D = this.skipScalingList.bind(this);
            if (g(), d = g(), E(5), S(3), g(), C(), d === 100 || d === 110 || d === 122 || d === 244 || d === 44 || d === 83 || d === 86 || d === 118 || d === 128) {
              var R = x();
              if (R === 3 && S(1), C(), C(), S(1), w())
                for (y = R !== 3 ? 8 : 12, v = 0; v < y; v++)
                  w() && (v < 6 ? D(16) : D(64));
            }
            C();
            var P = x();
            if (P === 0)
              x();
            else if (P === 1)
              for (S(1), T(), T(), f = x(), v = 0; v < f; v++)
                T();
            C(), S(1), m = x(), p = x(), b = E(1), b === 0 && S(1), S(1), w() && (l = x(), u = x(), h = x(), c = x());
            var N = [1, 1];
            if (w() && w()) {
              var $ = g();
              switch ($) {
                case 1:
                  N = [1, 1];
                  break;
                case 2:
                  N = [12, 11];
                  break;
                case 3:
                  N = [10, 11];
                  break;
                case 4:
                  N = [16, 11];
                  break;
                case 5:
                  N = [40, 33];
                  break;
                case 6:
                  N = [24, 11];
                  break;
                case 7:
                  N = [20, 11];
                  break;
                case 8:
                  N = [32, 11];
                  break;
                case 9:
                  N = [80, 33];
                  break;
                case 10:
                  N = [18, 11];
                  break;
                case 11:
                  N = [15, 11];
                  break;
                case 12:
                  N = [64, 33];
                  break;
                case 13:
                  N = [160, 99];
                  break;
                case 14:
                  N = [4, 3];
                  break;
                case 15:
                  N = [3, 2];
                  break;
                case 16:
                  N = [2, 1];
                  break;
                case 255: {
                  N = [g() << 8 | g(), g() << 8 | g()];
                  break;
                }
              }
            }
            return {
              width: Math.ceil((m + 1) * 16 - l * 2 - u * 2),
              height: (2 - b) * (p + 1) * 16 - (b ? 2 : 4) * (h + c),
              pixelRatio: N
            };
          }, o.prototype.readSliceType = function() {
            return this.readUByte(), this.readUEG(), this.readUEG();
          }, o;
        }();
        t.default = s;
      },
      "./src/demux/id3.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = function() {
          function o() {
          }
          return o.isHeader = function(l, u) {
            return u + 10 <= l.length && l[u] === 73 && l[u + 1] === 68 && l[u + 2] === 51 && l[u + 3] < 255 && l[u + 4] < 255 && l[u + 6] < 128 && l[u + 7] < 128 && l[u + 8] < 128 && l[u + 9] < 128;
          }, o.isFooter = function(l, u) {
            return u + 10 <= l.length && l[u] === 51 && l[u + 1] === 68 && l[u + 2] === 73 && l[u + 3] < 255 && l[u + 4] < 255 && l[u + 6] < 128 && l[u + 7] < 128 && l[u + 8] < 128 && l[u + 9] < 128;
          }, o.getID3Data = function(l, u) {
            for (var h = u, c = 0; o.isHeader(l, u); ) {
              c += 10;
              var d = o._readSize(l, u + 6);
              c += d, o.isFooter(l, u + 10) && (c += 10), u += c;
            }
            if (c > 0)
              return l.subarray(h, h + c);
          }, o._readSize = function(l, u) {
            var h = 0;
            return h = (l[u] & 127) << 21, h |= (l[u + 1] & 127) << 14, h |= (l[u + 2] & 127) << 7, h |= l[u + 3] & 127, h;
          }, o.getTimeStamp = function(l) {
            for (var u = o.getID3Frames(l), h = 0; h < u.length; h++) {
              var c = u[h];
              if (o.isTimeStampFrame(c))
                return o._readTimeStamp(c);
            }
          }, o.isTimeStampFrame = function(l) {
            return l && l.key === "PRIV" && l.info === "com.apple.streaming.transportStreamTimestamp";
          }, o._getFrameData = function(l) {
            var u = String.fromCharCode(l[0], l[1], l[2], l[3]), h = o._readSize(l, 4), c = 10;
            return { type: u, size: h, data: l.subarray(c, c + h) };
          }, o.getID3Frames = function(l) {
            for (var u = 0, h = []; o.isHeader(l, u); ) {
              var c = o._readSize(l, u + 6);
              u += 10;
              for (var d = u + c; u + 8 < d; ) {
                var f = o._getFrameData(l.subarray(u)), m = o._decodeFrame(f);
                m && h.push(m), u += f.size + 10;
              }
              o.isFooter(l, u) && (u += 10);
            }
            return h;
          }, o._decodeFrame = function(l) {
            if (l.type === "PRIV")
              return o._decodePrivFrame(l);
            if (l.type[0] === "T")
              return o._decodeTextFrame(l);
            if (l.type[0] === "W")
              return o._decodeURLFrame(l);
          }, o._readTimeStamp = function(l) {
            if (l.data.byteLength === 8) {
              var u = new Uint8Array(l.data), h = u[3] & 1, c = (u[4] << 23) + (u[5] << 15) + (u[6] << 7) + u[7];
              return c /= 45, h && (c += 4772185884e-2), Math.round(c);
            }
          }, o._decodePrivFrame = function(l) {
            if (!(l.size < 2)) {
              var u = o._utf8ArrayToStr(l.data, !0), h = new Uint8Array(l.data.subarray(u.length + 1));
              return { key: l.type, info: u, data: h.buffer };
            }
          }, o._decodeTextFrame = function(l) {
            if (!(l.size < 2))
              if (l.type === "TXXX") {
                var u = 1, h = o._utf8ArrayToStr(l.data.subarray(u));
                u += h.length + 1;
                var c = o._utf8ArrayToStr(l.data.subarray(u));
                return { key: l.type, info: h, data: c };
              } else {
                var d = o._utf8ArrayToStr(l.data.subarray(1));
                return { key: l.type, data: d };
              }
          }, o._decodeURLFrame = function(l) {
            if (l.type === "WXXX") {
              if (l.size < 2)
                return;
              var u = 1, h = o._utf8ArrayToStr(l.data.subarray(u));
              u += h.length + 1;
              var c = o._utf8ArrayToStr(l.data.subarray(u));
              return { key: l.type, info: h, data: c };
            } else {
              var d = o._utf8ArrayToStr(l.data);
              return { key: l.type, data: d };
            }
          }, o._utf8ArrayToStr = function(l, u) {
            u === void 0 && (u = !1);
            for (var h = l.length, c, d, f, m = "", p = 0; p < h; ) {
              if (c = l[p++], c === 0 && u)
                return m;
              if (c === 0 || c === 3)
                continue;
              switch (c >> 4) {
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                  m += String.fromCharCode(c);
                  break;
                case 12:
                case 13:
                  d = l[p++], m += String.fromCharCode((c & 31) << 6 | d & 63);
                  break;
                case 14:
                  d = l[p++], f = l[p++], m += String.fromCharCode((c & 15) << 12 | (d & 63) << 6 | (f & 63) << 0);
                  break;
              }
            }
            return m;
          }, o;
        }(), s = a._utf8ArrayToStr;
        t.utf8ArrayToStr = s, t.default = a;
      },
      "./src/demux/mp3demuxer.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/demux/id3.js"), s = n("./src/utils/logger.js"), o = n("./src/demux/mpegaudio.js"), l = function() {
          function u(h, c, d) {
            this.observer = h, this.config = d, this.remuxer = c;
          }
          return u.prototype.resetInitSegment = function(h, c, d, f) {
            this._audioTrack = { container: "audio/mpeg", type: "audio", id: -1, sequenceNumber: 0, isAAC: !1, samples: [], len: 0, manifestCodec: c, duration: f, inputTimeScale: 9e4 };
          }, u.prototype.resetTimeStamp = function() {
          }, u.probe = function(h) {
            var c, d, f = a.default.getID3Data(h, 0);
            if (f && a.default.getTimeStamp(f) !== void 0) {
              for (c = f.length, d = Math.min(h.length - 1, c + 100); c < d; c++)
                if (o.default.probe(h, c))
                  return s.logger.log("MPEG Audio sync word found !"), !0;
            }
            return !1;
          }, u.prototype.append = function(h, c, d, f) {
            for (var m = a.default.getID3Data(h, 0), p = a.default.getTimeStamp(m), b = p ? 90 * p : c * 9e4, y = m.length, v = h.length, g = 0, E = 0, x = this._audioTrack, w = [{ pts: b, dts: b, data: m }]; y < v; )
              if (o.default.isHeader(h, y)) {
                var S = o.default.appendFrame(x, h, y, b, g);
                if (S)
                  y += S.length, E = S.sample.pts, g++;
                else
                  break;
              } else
                a.default.isHeader(h, y) ? (m = a.default.getID3Data(h, y), w.push({ pts: E, dts: E, data: m }), y += m.length) : y++;
            this.remuxer.remux(x, { samples: [] }, { samples: w, inputTimeScale: 9e4 }, { samples: [] }, c, d, f);
          }, u.prototype.destroy = function() {
          }, u;
        }();
        t.default = l;
      },
      "./src/demux/mp4demuxer.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/utils/logger.js"), s = n("./src/events.js"), o = Math.pow(2, 32) - 1, l = function() {
          function u(h, c) {
            this.observer = h, this.remuxer = c;
          }
          return u.prototype.resetTimeStamp = function(h) {
            this.initPTS = h;
          }, u.prototype.resetInitSegment = function(h, c, d, f) {
            if (h && h.byteLength) {
              var m = this.initData = u.parseInitSegment(h);
              c == null && (c = "mp4a.40.5"), d == null && (d = "avc1.42e01e");
              var p = {};
              m.audio && m.video ? p.audiovideo = { container: "video/mp4", codec: c + "," + d, initSegment: f ? h : null } : (m.audio && (p.audio = { container: "audio/mp4", codec: c, initSegment: f ? h : null }), m.video && (p.video = { container: "video/mp4", codec: d, initSegment: f ? h : null })), this.observer.trigger(s.default.FRAG_PARSING_INIT_SEGMENT, { tracks: p });
            } else
              c && (this.audioCodec = c), d && (this.videoCodec = d);
          }, u.probe = function(h) {
            return u.findBox({ data: h, start: 0, end: Math.min(h.length, 16384) }, ["moof"]).length > 0;
          }, u.bin2str = function(h) {
            return String.fromCharCode.apply(null, h);
          }, u.readUint16 = function(h, c) {
            h.data && (c += h.start, h = h.data);
            var d = h[c] << 8 | h[c + 1];
            return d < 0 ? 65536 + d : d;
          }, u.readUint32 = function(h, c) {
            h.data && (c += h.start, h = h.data);
            var d = h[c] << 24 | h[c + 1] << 16 | h[c + 2] << 8 | h[c + 3];
            return d < 0 ? 4294967296 + d : d;
          }, u.writeUint32 = function(h, c, d) {
            h.data && (c += h.start, h = h.data), h[c] = d >> 24, h[c + 1] = d >> 16 & 255, h[c + 2] = d >> 8 & 255, h[c + 3] = d & 255;
          }, u.findBox = function(h, c) {
            var d = [], f, m, p, b, y, v, g;
            if (h.data ? (v = h.start, b = h.end, h = h.data) : (v = 0, b = h.byteLength), !c.length)
              return null;
            for (f = v; f < b; )
              m = u.readUint32(h, f), p = u.bin2str(h.subarray(f + 4, f + 8)), g = m > 1 ? f + m : b, p === c[0] && (c.length === 1 ? d.push({ data: h, start: f + 8, end: g }) : (y = u.findBox({ data: h, start: f + 8, end: g }, c.slice(1)), y.length && (d = d.concat(y)))), f = g;
            return d;
          }, u.parseSegmentIndex = function(h) {
            var c = u.findBox(h, ["moov"])[0], d = c ? c.end : null, f = 0, m = u.findBox(h, ["sidx"]), p;
            if (!m || !m[0])
              return null;
            p = [], m = m[0];
            var b = m.data[0];
            f = b === 0 ? 8 : 16;
            var y = u.readUint32(m, f);
            f += 4;
            var v = 0, g = 0;
            b === 0 ? f += 8 : f += 16, f += 2;
            var E = m.end + g, x = u.readUint16(m, f);
            f += 2;
            for (var w = 0; w < x; w++) {
              var S = f, T = u.readUint32(m, S);
              S += 4;
              var C = T & 2147483647, D = (T & 2147483648) >>> 31;
              if (D === 1) {
                console.warn("SIDX has hierarchical references (not supported)");
                return;
              }
              var R = u.readUint32(m, S);
              S += 4, p.push({
                referenceSize: C,
                subsegmentDuration: R,
                info: {
                  duration: R / y,
                  start: E,
                  end: E + C - 1
                }
              }), E += C, S += 4, f = S;
            }
            return {
              earliestPresentationTime: v,
              timescale: y,
              version: b,
              referencesCount: x,
              references: p,
              moovEndOffset: d
            };
          }, u.parseInitSegment = function(h) {
            var c = [], d = u.findBox(h, ["moov", "trak"]);
            return d.forEach(function(f) {
              var m = u.findBox(f, ["tkhd"])[0];
              if (m) {
                var p = m.data[m.start], b = p === 0 ? 12 : 20, y = u.readUint32(m, b), v = u.findBox(f, ["mdia", "mdhd"])[0];
                if (v) {
                  p = v.data[v.start], b = p === 0 ? 12 : 20;
                  var g = u.readUint32(v, b), E = u.findBox(f, ["mdia", "hdlr"])[0];
                  if (E) {
                    var x = u.bin2str(E.data.subarray(E.start + 8, E.start + 12)), w = { soun: "audio", vide: "video" }[x];
                    if (w) {
                      var S = u.findBox(f, ["mdia", "minf", "stbl", "stsd"]);
                      if (S.length) {
                        S = S[0];
                        var T = u.bin2str(S.data.subarray(S.start + 12, S.start + 16));
                        a.logger.log("MP4Demuxer:" + w + ":" + T + " found");
                      }
                      c[y] = { timescale: g, type: w }, c[w] = { timescale: g, id: y };
                    }
                  }
                }
              }
            }), c;
          }, u.getStartDTS = function(h, c) {
            var d, f, m;
            return d = u.findBox(c, ["moof", "traf"]), f = [].concat.apply([], d.map(function(p) {
              return u.findBox(p, ["tfhd"]).map(function(b) {
                var y, v, g;
                return y = u.readUint32(b, 4), v = h[y].timescale || 9e4, g = u.findBox(p, ["tfdt"]).map(function(E) {
                  var x, w;
                  return x = E.data[E.start], w = u.readUint32(E, 4), x === 1 && (w *= Math.pow(2, 32), w += u.readUint32(E, 8)), w;
                })[0], g / v;
              });
            })), m = Math.min.apply(null, f), isFinite(m) ? m : 0;
          }, u.offsetStartDTS = function(h, c, d) {
            u.findBox(c, ["moof", "traf"]).map(function(f) {
              return u.findBox(f, ["tfhd"]).map(function(m) {
                var p = u.readUint32(m, 4), b = h[p].timescale || 9e4;
                u.findBox(f, ["tfdt"]).map(function(y) {
                  var v = y.data[y.start], g = u.readUint32(y, 4);
                  if (v === 0)
                    u.writeUint32(y, 4, g - d * b);
                  else {
                    g *= Math.pow(2, 32), g += u.readUint32(y, 8), g -= d * b, g = Math.max(g, 0);
                    var E = Math.floor(g / (o + 1)), x = Math.floor(g % (o + 1));
                    u.writeUint32(y, 4, E), u.writeUint32(y, 8, x);
                  }
                });
              });
            });
          }, u.prototype.append = function(h, c, d, f) {
            var m = this.initData;
            m || (this.resetInitSegment(h, this.audioCodec, this.videoCodec, !1), m = this.initData);
            var p, b = this.initPTS;
            if (b === void 0) {
              var y = u.getStartDTS(m, h);
              this.initPTS = b = y - c, this.observer.trigger(s.default.INIT_PTS_FOUND, { initPTS: b });
            }
            u.offsetStartDTS(m, h, b), p = u.getStartDTS(m, h), this.remuxer.remux(m.audio, m.video, null, null, p, d, f, h);
          }, u.prototype.destroy = function() {
          }, u;
        }();
        t.default = l;
      },
      "./src/demux/mpegaudio.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = {
          BitratesMap: [
            32,
            64,
            96,
            128,
            160,
            192,
            224,
            256,
            288,
            320,
            352,
            384,
            416,
            448,
            32,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            160,
            192,
            224,
            256,
            320,
            384,
            32,
            40,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            160,
            192,
            224,
            256,
            320,
            32,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            144,
            160,
            176,
            192,
            224,
            256,
            8,
            16,
            24,
            32,
            40,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            144,
            160
          ],
          SamplingRateMap: [44100, 48e3, 32e3, 22050, 24e3, 16e3, 11025, 12e3, 8e3],
          SamplesCoefficients: [
            [
              0,
              72,
              144,
              12
            ],
            [
              0,
              0,
              0,
              0
            ],
            [
              0,
              72,
              144,
              12
            ],
            [
              0,
              144,
              144,
              12
            ]
          ],
          BytesInSlot: [
            0,
            1,
            1,
            4
          ],
          appendFrame: function(s, o, l, u, h) {
            if (!(l + 24 > o.length)) {
              var c = this.parseHeader(o, l);
              if (c && l + c.frameLength <= o.length) {
                var d = c.samplesPerFrame * 9e4 / c.sampleRate, f = u + h * d, m = { unit: o.subarray(l, l + c.frameLength), pts: f, dts: f };
                return s.config = [], s.channelCount = c.channelCount, s.samplerate = c.sampleRate, s.samples.push(m), s.len += c.frameLength, { sample: m, length: c.frameLength };
              }
            }
          },
          parseHeader: function(s, o) {
            var l = s[o + 1] >> 3 & 3, u = s[o + 1] >> 1 & 3, h = s[o + 2] >> 4 & 15, c = s[o + 2] >> 2 & 3, d = s[o + 2] >> 1 & 1;
            if (l !== 1 && h !== 0 && h !== 15 && c !== 3) {
              var f = l === 3 ? 3 - u : u === 3 ? 3 : 4, m = a.BitratesMap[f * 14 + h - 1] * 1e3, p = l === 3 ? 0 : l === 2 ? 1 : 2, b = a.SamplingRateMap[p * 3 + c], y = s[o + 3] >> 6 === 3 ? 1 : 2, v = a.SamplesCoefficients[l][u], g = a.BytesInSlot[u], E = v * 8 * g, x = parseInt(v * m / b + d, 10) * g;
              return { sampleRate: b, channelCount: y, frameLength: x, samplesPerFrame: E };
            }
          },
          isHeaderPattern: function(s, o) {
            return s[o] === 255 && (s[o + 1] & 224) === 224 && (s[o + 1] & 6) !== 0;
          },
          isHeader: function(s, o) {
            return !!(o + 1 < s.length && this.isHeaderPattern(s, o));
          },
          probe: function(s, o) {
            if (o + 1 < s.length && this.isHeaderPattern(s, o)) {
              var l = 4, u = this.parseHeader(s, o), h = l;
              u && u.frameLength && (h = u.frameLength);
              var c = o + h;
              if (c === s.length || c + 1 < s.length && this.isHeaderPattern(s, c))
                return !0;
            }
            return !1;
          }
        };
        t.default = a;
      },
      "./src/demux/sample-aes.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/crypt/decrypter.js"), s = function() {
          function o(l, u, h, c) {
            this.decryptdata = h, this.discardEPB = c, this.decrypter = new a.default(l, u, { removePKCS7Padding: !1 });
          }
          return o.prototype.decryptBuffer = function(l, u) {
            this.decrypter.decrypt(l, this.decryptdata.key.buffer, this.decryptdata.iv.buffer, u);
          }, o.prototype.decryptAacSample = function(l, u, h, c) {
            var d = l[u].unit, f = d.subarray(16, d.length - d.length % 16), m = f.buffer.slice(f.byteOffset, f.byteOffset + f.length), p = this;
            this.decryptBuffer(m, function(b) {
              b = new Uint8Array(b), d.set(b, 16), c || p.decryptAacSamples(l, u + 1, h);
            });
          }, o.prototype.decryptAacSamples = function(l, u, h) {
            for (; ; u++) {
              if (u >= l.length) {
                h();
                return;
              }
              if (!(l[u].unit.length < 32)) {
                var c = this.decrypter.isSync();
                if (this.decryptAacSample(l, u, h, c), !c)
                  return;
              }
            }
          }, o.prototype.getAvcEncryptedData = function(l) {
            for (var u = Math.floor((l.length - 48) / 160) * 16 + 16, h = new Int8Array(u), c = 0, d = 32; d <= l.length - 16; d += 160, c += 16)
              h.set(l.subarray(d, d + 16), c);
            return h;
          }, o.prototype.getAvcDecryptedUnit = function(l, u) {
            u = new Uint8Array(u);
            for (var h = 0, c = 32; c <= l.length - 16; c += 160, h += 16)
              l.set(u.subarray(h, h + 16), c);
            return l;
          }, o.prototype.decryptAvcSample = function(l, u, h, c, d, f) {
            var m = this.discardEPB(d.data), p = this.getAvcEncryptedData(m), b = this;
            this.decryptBuffer(p.buffer, function(y) {
              d.data = b.getAvcDecryptedUnit(m, y), f || b.decryptAvcSamples(l, u, h + 1, c);
            });
          }, o.prototype.decryptAvcSamples = function(l, u, h, c) {
            for (; ; u++, h = 0) {
              if (u >= l.length) {
                c();
                return;
              }
              for (var d = l[u].units; !(h >= d.length); h++) {
                var f = d[h];
                if (!(f.length <= 48 || f.type !== 1 && f.type !== 5)) {
                  var m = this.decrypter.isSync();
                  if (this.decryptAvcSample(l, u, h, c, f, m), !m)
                    return;
                }
              }
            }
          }, o;
        }();
        t.default = s;
      },
      "./src/demux/tsdemuxer.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/demux/adts.js"), s = n("./src/demux/mpegaudio.js"), o = n("./src/events.js"), l = n("./src/demux/exp-golomb.js"), u = n("./src/demux/sample-aes.js"), h = n("./src/utils/logger.js"), c = n("./src/errors.js"), d = {
          video: 1,
          audio: 2,
          id3: 3,
          text: 4
        }, f = function() {
          function m(p, b, y, v) {
            this.observer = p, this.config = y, this.typeSupported = v, this.remuxer = b, this.sampleAes = null;
          }
          return m.prototype.setDecryptData = function(p) {
            p != null && p.key != null && p.method === "SAMPLE-AES" ? this.sampleAes = new u.default(this.observer, this.config, p, this.discardEPB) : this.sampleAes = null;
          }, m.probe = function(p) {
            var b = m._syncOffset(p);
            return b < 0 ? !1 : (b && h.logger.warn("MPEG2-TS detected but first sync word found @ offset " + b + ", junk ahead ?"), !0);
          }, m._syncOffset = function(p) {
            for (var b = Math.min(1e3, p.length - 564), y = 0; y < b; ) {
              if (p[y] === 71 && p[y + 188] === 71 && p[y + 2 * 188] === 71)
                return y;
              y++;
            }
            return -1;
          }, m.createTrack = function(p, b) {
            return {
              container: p === "video" || p === "audio" ? "video/mp2t" : void 0,
              type: p,
              id: d[p],
              pid: -1,
              inputTimeScale: 9e4,
              sequenceNumber: 0,
              samples: [],
              len: 0,
              dropped: p === "video" ? 0 : void 0,
              isAAC: p === "audio" ? !0 : void 0,
              duration: p === "audio" ? b : void 0
            };
          }, m.prototype.resetInitSegment = function(p, b, y, v) {
            this.pmtParsed = !1, this._pmtId = -1, this._avcTrack = m.createTrack("video", v), this._audioTrack = m.createTrack("audio", v), this._id3Track = m.createTrack("id3", v), this._txtTrack = m.createTrack("text", v), this.aacOverFlow = null, this.aacLastPTS = null, this.avcSample = null, this.audioCodec = b, this.videoCodec = y, this._duration = v;
          }, m.prototype.resetTimeStamp = function() {
          }, m.prototype.append = function(p, b, y, v) {
            var g, E = p.length, x, w, S, T, C, D = !1;
            this.contiguous = y;
            var R = this.pmtParsed, P = this._avcTrack, N = this._audioTrack, $ = this._id3Track, O = P.pid, M = N.pid, F = $.pid, G = this._pmtId, K = P.pesData, J = N.pesData, ue = $.pesData, ce = this._parsePAT, ee = this._parsePMT, me = this._parsePES, Ce = this._parseAVCPES.bind(this), Ne = this._parseAACPES.bind(this), ot = this._parseMPEGPES.bind(this), ze = this._parseID3PES.bind(this), $e = m._syncOffset(p);
            for (E -= (E + $e) % 188, g = $e; g < E; g += 188)
              if (p[g] === 71) {
                if (x = !!(p[g + 1] & 64), w = ((p[g + 1] & 31) << 8) + p[g + 2], S = (p[g + 3] & 48) >> 4, S > 1) {
                  if (T = g + 5 + p[g + 4], T === g + 188)
                    continue;
                } else
                  T = g + 4;
                switch (w) {
                  case O:
                    x && (K && (C = me(K)) && C.pts !== void 0 && Ce(C, !1), K = { data: [], size: 0 }), K && (K.data.push(p.subarray(T, g + 188)), K.size += g + 188 - T);
                    break;
                  case M:
                    x && (J && (C = me(J)) && C.pts !== void 0 && (N.isAAC ? Ne(C) : ot(C)), J = { data: [], size: 0 }), J && (J.data.push(p.subarray(T, g + 188)), J.size += g + 188 - T);
                    break;
                  case F:
                    x && (ue && (C = me(ue)) && C.pts !== void 0 && ze(C), ue = { data: [], size: 0 }), ue && (ue.data.push(p.subarray(T, g + 188)), ue.size += g + 188 - T);
                    break;
                  case 0:
                    x && (T += p[T] + 1), G = this._pmtId = ce(p, T);
                    break;
                  case G:
                    x && (T += p[T] + 1);
                    var Ze = ee(p, T, this.typeSupported.mpeg === !0 || this.typeSupported.mp3 === !0, this.sampleAes != null);
                    O = Ze.avc, O > 0 && (P.pid = O), M = Ze.audio, M > 0 && (N.pid = M, N.isAAC = Ze.isAAC), F = Ze.id3, F > 0 && ($.pid = F), D && !R && (h.logger.log("reparse from beginning"), D = !1, g = $e - 188), R = this.pmtParsed = !0;
                    break;
                  case 17:
                  case 8191:
                    break;
                  default:
                    D = !0;
                    break;
                }
              } else
                this.observer.trigger(o.default.ERROR, { type: c.ErrorTypes.MEDIA_ERROR, details: c.ErrorDetails.FRAG_PARSING_ERROR, fatal: !1, reason: "TS packet did not start with 0x47" });
            K && (C = me(K)) && C.pts !== void 0 ? (Ce(C, !0), P.pesData = null) : P.pesData = K, J && (C = me(J)) && C.pts !== void 0 ? (N.isAAC ? Ne(C) : ot(C), N.pesData = null) : (J && J.size && h.logger.log("last AAC PES packet truncated,might overlap between fragments"), N.pesData = J), ue && (C = me(ue)) && C.pts !== void 0 ? (ze(C), $.pesData = null) : $.pesData = ue, this.sampleAes == null ? this.remuxer.remux(N, P, $, this._txtTrack, b, y, v) : this.decryptAndRemux(N, P, $, this._txtTrack, b, y, v);
          }, m.prototype.decryptAndRemux = function(p, b, y, v, g, E, x) {
            if (p.samples && p.isAAC) {
              var w = this;
              this.sampleAes.decryptAacSamples(p.samples, 0, function() {
                w.decryptAndRemuxAvc(p, b, y, v, g, E, x);
              });
            } else
              this.decryptAndRemuxAvc(p, b, y, v, g, E, x);
          }, m.prototype.decryptAndRemuxAvc = function(p, b, y, v, g, E, x) {
            if (b.samples) {
              var w = this;
              this.sampleAes.decryptAvcSamples(b.samples, 0, 0, function() {
                w.remuxer.remux(p, b, y, v, g, E, x);
              });
            } else
              this.remuxer.remux(p, b, y, v, g, E, x);
          }, m.prototype.destroy = function() {
            this._initPTS = this._initDTS = void 0, this._duration = 0;
          }, m.prototype._parsePAT = function(p, b) {
            return (p[b + 10] & 31) << 8 | p[b + 11];
          }, m.prototype._parsePMT = function(p, b, y, v) {
            var g, E, x, w, S = { audio: -1, avc: -1, id3: -1, isAAC: !0 };
            for (g = (p[b + 1] & 15) << 8 | p[b + 2], E = b + 3 + g - 4, x = (p[b + 10] & 15) << 8 | p[b + 11], b += 12 + x; b < E; ) {
              switch (w = (p[b + 1] & 31) << 8 | p[b + 2], p[b]) {
                case 207:
                  if (!v) {
                    h.logger.log("unkown stream type:" + p[b]);
                    break;
                  }
                case 15:
                  S.audio === -1 && (S.audio = w);
                  break;
                case 21:
                  S.id3 === -1 && (S.id3 = w);
                  break;
                case 219:
                  if (!v) {
                    h.logger.log("unkown stream type:" + p[b]);
                    break;
                  }
                case 27:
                  S.avc === -1 && (S.avc = w);
                  break;
                case 3:
                case 4:
                  y ? S.audio === -1 && (S.audio = w, S.isAAC = !1) : h.logger.log("MPEG audio found, not supported in this browser for now");
                  break;
                case 36:
                  h.logger.warn("HEVC stream type found, not supported for now");
                  break;
                default:
                  h.logger.log("unkown stream type:" + p[b]);
                  break;
              }
              b += ((p[b + 3] & 15) << 8 | p[b + 4]) + 5;
            }
            return S;
          }, m.prototype._parsePES = function(p) {
            var b = 0, y, v, g, E, x, w, S, T, C, D = p.data;
            if (!p || p.size === 0)
              return null;
            for (; D[0].length < 19 && D.length > 1; ) {
              var R = new Uint8Array(D[0].length + D[1].length);
              R.set(D[0]), R.set(D[1], D[0].length), D[0] = R, D.splice(1, 1);
            }
            if (y = D[0], g = (y[0] << 16) + (y[1] << 8) + y[2], g === 1) {
              if (E = (y[4] << 8) + y[5], E && E > p.size - 6)
                return null;
              v = y[7], v & 192 && (S = (y[9] & 14) * 536870912 + (y[10] & 255) * 4194304 + (y[11] & 254) * 16384 + (y[12] & 255) * 128 + (y[13] & 254) / 2, S > 4294967295 && (S -= 8589934592), v & 64 ? (T = (y[14] & 14) * 536870912 + (y[15] & 255) * 4194304 + (y[16] & 254) * 16384 + (y[17] & 255) * 128 + (y[18] & 254) / 2, T > 4294967295 && (T -= 8589934592), S - T > 60 * 9e4 && (h.logger.warn(Math.round((S - T) / 9e4) + "s delta between PTS and DTS, align them"), S = T)) : T = S), x = y[8], C = x + 9, p.size -= C, w = new Uint8Array(p.size);
              for (var P = 0, N = D.length; P < N; P++) {
                y = D[P];
                var $ = y.byteLength;
                if (C)
                  if (C > $) {
                    C -= $;
                    continue;
                  } else
                    y = y.subarray(C), $ -= C, C = 0;
                w.set(y, b), b += $;
              }
              return E && (E -= x + 3), { data: w, pts: S, dts: T, len: E };
            } else
              return null;
          }, m.prototype.pushAccesUnit = function(p, b) {
            if (p.units.length && p.frame) {
              var y = b.samples, v = y.length;
              !this.config.forceKeyFrameOnDiscontinuity || p.key === !0 || b.sps && (v || this.contiguous) ? (p.id = v, y.push(p)) : b.dropped++;
            }
            p.debug.length && h.logger.log(p.pts + "/" + p.dts + ":" + p.debug);
          }, m.prototype._parseAVCPES = function(p, b) {
            var y = this, v = this._avcTrack, g = this._parseAVCNALu(p.data), E, x = this.avcSample, w, S = !1, T, C = this.pushAccesUnit.bind(this), D = function(R, P, N, $) {
              return { key: R, pts: P, dts: N, units: [], debug: $ };
            };
            p.data = null, x && g.length && !v.audFound && (C(x, v), x = this.avcSample = D(!1, p.pts, p.dts, "")), g.forEach(function(R) {
              switch (R.type) {
                case 1:
                  w = !0, x || (x = y.avcSample = D(!0, p.pts, p.dts, "")), x.frame = !0;
                  var P = R.data;
                  if (S && P.length > 4) {
                    var N = new l.default(P).readSliceType();
                    (N === 2 || N === 4 || N === 7 || N === 9) && (x.key = !0);
                  }
                  break;
                case 5:
                  w = !0, x || (x = y.avcSample = D(!0, p.pts, p.dts, "")), x.key = !0, x.frame = !0;
                  break;
                case 6:
                  w = !0, E = new l.default(y.discardEPB(R.data)), E.readUByte();
                  for (var $ = 0, O = 0, M = !1, F = 0; !M && E.bytesAvailable > 1; ) {
                    $ = 0;
                    do
                      F = E.readUByte(), $ += F;
                    while (F === 255);
                    O = 0;
                    do
                      F = E.readUByte(), O += F;
                    while (F === 255);
                    if ($ === 4 && E.bytesAvailable !== 0) {
                      M = !0;
                      var G = E.readUByte();
                      if (G === 181) {
                        var K = E.readUShort();
                        if (K === 49) {
                          var J = E.readUInt();
                          if (J === 1195456820) {
                            var ue = E.readUByte();
                            if (ue === 3) {
                              var ce = E.readUByte(), ee = E.readUByte(), me = 31 & ce, Ce = [ce, ee];
                              for (T = 0; T < me; T++)
                                Ce.push(E.readUByte()), Ce.push(E.readUByte()), Ce.push(E.readUByte());
                              y._insertSampleInOrder(y._txtTrack.samples, { type: 3, pts: p.pts, bytes: Ce });
                            }
                          }
                        }
                      }
                    } else if (O < E.bytesAvailable)
                      for (T = 0; T < O; T++)
                        E.readUByte();
                  }
                  break;
                case 7:
                  if (w = !0, S = !0, !v.sps) {
                    E = new l.default(R.data);
                    var Ne = E.readSPS();
                    v.width = Ne.width, v.height = Ne.height, v.pixelRatio = Ne.pixelRatio, v.sps = [R.data], v.duration = y._duration;
                    var ot = R.data.subarray(1, 4), ze = "avc1.";
                    for (T = 0; T < 3; T++) {
                      var $e = ot[T].toString(16);
                      $e.length < 2 && ($e = "0" + $e), ze += $e;
                    }
                    v.codec = ze;
                  }
                  break;
                case 8:
                  w = !0, v.pps || (v.pps = [R.data]);
                  break;
                case 9:
                  w = !1, v.audFound = !0, x && C(x, v), x = y.avcSample = D(!1, p.pts, p.dts, "");
                  break;
                case 12:
                  w = !1;
                  break;
                default:
                  w = !1, x && (x.debug += "unknown NAL " + R.type + " ");
                  break;
              }
              if (x && w) {
                var Ze = x.units;
                Ze.push(R);
              }
            }), b && x && (C(x, v), this.avcSample = null);
          }, m.prototype._insertSampleInOrder = function(p, b) {
            var y = p.length;
            if (y > 0) {
              if (b.pts >= p[y - 1].pts)
                p.push(b);
              else
                for (var v = y - 1; v >= 0; v--)
                  if (b.pts < p[v].pts) {
                    p.splice(v, 0, b);
                    break;
                  }
            } else
              p.push(b);
          }, m.prototype._getLastNalUnit = function() {
            var p = this.avcSample, b;
            if (!p || p.units.length === 0) {
              var y = this._avcTrack, v = y.samples;
              p = v[v.length - 1];
            }
            if (p) {
              var g = p.units;
              b = g[g.length - 1];
            }
            return b;
          }, m.prototype._parseAVCNALu = function(p) {
            var b = 0, y = p.byteLength, v, g, E = this._avcTrack, x = E.naluState || 0, w = x, S = [], T, C, D = -1, R;
            for (x === -1 && (D = 0, R = p[0] & 31, x = 0, b = 1); b < y; ) {
              if (v = p[b++], !x) {
                x = v ? 0 : 1;
                continue;
              }
              if (x === 1) {
                x = v ? 0 : 2;
                continue;
              }
              if (!v)
                x = 3;
              else if (v === 1) {
                if (D >= 0)
                  T = { data: p.subarray(D, b - x - 1), type: R }, S.push(T);
                else {
                  var P = this._getLastNalUnit();
                  if (P && (w && b <= 4 - w && P.state && (P.data = P.data.subarray(0, P.data.byteLength - w)), g = b - x - 1, g > 0)) {
                    var N = new Uint8Array(P.data.byteLength + g);
                    N.set(P.data, 0), N.set(p.subarray(0, g), P.data.byteLength), P.data = N;
                  }
                }
                b < y ? (C = p[b] & 31, D = b, R = C, x = 0) : x = -1;
              } else
                x = 0;
            }
            if (D >= 0 && x >= 0 && (T = { data: p.subarray(D, y), type: R, state: x }, S.push(T)), S.length === 0) {
              var P = this._getLastNalUnit();
              if (P) {
                var N = new Uint8Array(P.data.byteLength + p.byteLength);
                N.set(P.data, 0), N.set(p, P.data.byteLength), P.data = N;
              }
            }
            return E.naluState = x, S;
          }, m.prototype.discardEPB = function(p) {
            for (var b = p.byteLength, y = [], v = 1, g, E; v < b - 2; )
              p[v] === 0 && p[v + 1] === 0 && p[v + 2] === 3 ? (y.push(v + 2), v += 2) : v++;
            if (y.length === 0)
              return p;
            g = b - y.length, E = new Uint8Array(g);
            var x = 0;
            for (v = 0; v < g; x++, v++)
              x === y[0] && (x++, y.shift()), E[v] = p[x];
            return E;
          }, m.prototype._parseAACPES = function(p) {
            var b = this._audioTrack, y = p.data, v = p.pts, g = 0, E = this.aacOverFlow, x = this.aacLastPTS, w, S, T, C, D;
            if (E) {
              var R = new Uint8Array(E.byteLength + y.byteLength);
              R.set(E, 0), R.set(y, E.byteLength), y = R;
            }
            for (T = g, D = y.length; T < D - 1 && !a.isHeader(y, T); T++)
              ;
            if (T) {
              var P = void 0, N = void 0;
              if (T < D - 1 ? (P = "AAC PES did not start with ADTS header,offset:" + T, N = !1) : (P = "no ADTS header found in AAC PES", N = !0), h.logger.warn("parsing error:" + P), this.observer.trigger(o.default.ERROR, { type: c.ErrorTypes.MEDIA_ERROR, details: c.ErrorDetails.FRAG_PARSING_ERROR, fatal: N, reason: P }), N)
                return;
            }
            if (a.initTrackConfig(b, this.observer, y, T, this.audioCodec), S = 0, w = a.getFrameDuration(b.samplerate), E && x) {
              var $ = x + w;
              Math.abs($ - v) > 1 && (h.logger.log("AAC: align PTS for overlapping frames by " + Math.round(($ - v) / 90)), v = $);
            }
            for (; T < D; )
              if (a.isHeader(y, T) && T + 5 < D) {
                var O = a.appendFrame(b, y, T, v, S);
                if (O)
                  T += O.length, C = O.sample.pts, S++;
                else
                  break;
              } else
                T++;
            T < D ? E = y.subarray(T, D) : E = null, this.aacOverFlow = E, this.aacLastPTS = C;
          }, m.prototype._parseMPEGPES = function(p) {
            for (var b = p.data, y = b.length, v = 0, g = 0, E = p.pts; g < y; )
              if (s.default.isHeader(b, g)) {
                var x = s.default.appendFrame(this._audioTrack, b, g, E, v);
                if (x)
                  g += x.length, v++;
                else
                  break;
              } else
                g++;
          }, m.prototype._parseID3PES = function(p) {
            this._id3Track.samples.push(p);
          }, m;
        }();
        t.default = f;
      },
      "./src/errors.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.ErrorTypes = {
          NETWORK_ERROR: "networkError",
          MEDIA_ERROR: "mediaError",
          KEY_SYSTEM_ERROR: "keySystemError",
          MUX_ERROR: "muxError",
          OTHER_ERROR: "otherError"
        }, t.ErrorDetails = {
          KEY_SYSTEM_NO_KEYS: "keySystemNoKeys",
          KEY_SYSTEM_NO_ACCESS: "keySystemNoAccess",
          KEY_SYSTEM_NO_SESSION: "keySystemNoSession",
          KEY_SYSTEM_LICENSE_REQUEST_FAILED: "keySystemLicenseRequestFailed",
          MANIFEST_LOAD_ERROR: "manifestLoadError",
          MANIFEST_LOAD_TIMEOUT: "manifestLoadTimeOut",
          MANIFEST_PARSING_ERROR: "manifestParsingError",
          MANIFEST_INCOMPATIBLE_CODECS_ERROR: "manifestIncompatibleCodecsError",
          LEVEL_LOAD_ERROR: "levelLoadError",
          LEVEL_LOAD_TIMEOUT: "levelLoadTimeOut",
          LEVEL_SWITCH_ERROR: "levelSwitchError",
          AUDIO_TRACK_LOAD_ERROR: "audioTrackLoadError",
          AUDIO_TRACK_LOAD_TIMEOUT: "audioTrackLoadTimeOut",
          FRAG_LOAD_ERROR: "fragLoadError",
          FRAG_LOAD_TIMEOUT: "fragLoadTimeOut",
          FRAG_DECRYPT_ERROR: "fragDecryptError",
          FRAG_PARSING_ERROR: "fragParsingError",
          REMUX_ALLOC_ERROR: "remuxAllocError",
          KEY_LOAD_ERROR: "keyLoadError",
          KEY_LOAD_TIMEOUT: "keyLoadTimeOut",
          BUFFER_ADD_CODEC_ERROR: "bufferAddCodecError",
          BUFFER_APPEND_ERROR: "bufferAppendError",
          BUFFER_APPENDING_ERROR: "bufferAppendingError",
          BUFFER_STALLED_ERROR: "bufferStalledError",
          BUFFER_FULL_ERROR: "bufferFullError",
          BUFFER_SEEK_OVER_HOLE: "bufferSeekOverHole",
          BUFFER_NUDGE_ON_STALL: "bufferNudgeOnStall",
          INTERNAL_EXCEPTION: "internalException"
        };
      },
      "./src/event-handler.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/utils/logger.js"), s = n("./src/errors.js"), o = n("./src/events.js"), l = {
          hlsEventGeneric: !0,
          hlsHandlerDestroying: !0,
          hlsHandlerDestroyed: !0
        }, u = function() {
          function h(c) {
            for (var d = [], f = 1; f < arguments.length; f++)
              d[f - 1] = arguments[f];
            this.hls = c, this.onEvent = this.onEvent.bind(this), this.handledEvents = d, this.useGenericHandler = !0, this.registerListeners();
          }
          return h.prototype.destroy = function() {
            this.onHandlerDestroying(), this.unregisterListeners(), this.onHandlerDestroyed();
          }, h.prototype.onHandlerDestroying = function() {
          }, h.prototype.onHandlerDestroyed = function() {
          }, h.prototype.isEventHandler = function() {
            return typeof this.handledEvents == "object" && this.handledEvents.length && typeof this.onEvent == "function";
          }, h.prototype.registerListeners = function() {
            this.isEventHandler() && this.handledEvents.forEach(function(c) {
              if (l[c])
                throw new Error("Forbidden event-name: " + c);
              this.hls.on(c, this.onEvent);
            }, this);
          }, h.prototype.unregisterListeners = function() {
            this.isEventHandler() && this.handledEvents.forEach(function(c) {
              this.hls.off(c, this.onEvent);
            }, this);
          }, h.prototype.onEvent = function(c, d) {
            this.onEventGeneric(c, d);
          }, h.prototype.onEventGeneric = function(c, d) {
            var f = function(m, p) {
              var b = "on" + m.replace("hls", "");
              if (typeof this[b] != "function")
                throw new Error("Event " + m + " has no generic handler in this " + this.constructor.name + " class (tried " + b + ")");
              return this[b].bind(this, p);
            };
            try {
              f.call(this, c, d).call();
            } catch (m) {
              a.logger.error("An internal error happened while handling event " + c + '. Error message: "' + m.message + '". Here is a stacktrace:', m), this.hls.trigger(o.default.ERROR, { type: s.ErrorTypes.OTHER_ERROR, details: s.ErrorDetails.INTERNAL_EXCEPTION, fatal: !1, event: c, err: m });
            }
          }, h;
        }();
        t.default = u;
      },
      "./src/events.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = {
          MEDIA_ATTACHING: "hlsMediaAttaching",
          MEDIA_ATTACHED: "hlsMediaAttached",
          MEDIA_DETACHING: "hlsMediaDetaching",
          MEDIA_DETACHED: "hlsMediaDetached",
          BUFFER_RESET: "hlsBufferReset",
          BUFFER_CODECS: "hlsBufferCodecs",
          BUFFER_CREATED: "hlsBufferCreated",
          BUFFER_APPENDING: "hlsBufferAppending",
          BUFFER_APPENDED: "hlsBufferAppended",
          BUFFER_EOS: "hlsBufferEos",
          BUFFER_FLUSHING: "hlsBufferFlushing",
          BUFFER_FLUSHED: "hlsBufferFlushed",
          MANIFEST_LOADING: "hlsManifestLoading",
          MANIFEST_LOADED: "hlsManifestLoaded",
          MANIFEST_PARSED: "hlsManifestParsed",
          LEVEL_SWITCHING: "hlsLevelSwitching",
          LEVEL_SWITCHED: "hlsLevelSwitched",
          LEVEL_LOADING: "hlsLevelLoading",
          LEVEL_LOADED: "hlsLevelLoaded",
          LEVEL_UPDATED: "hlsLevelUpdated",
          LEVEL_PTS_UPDATED: "hlsLevelPtsUpdated",
          AUDIO_TRACKS_UPDATED: "hlsAudioTracksUpdated",
          AUDIO_TRACK_SWITCHING: "hlsAudioTrackSwitching",
          AUDIO_TRACK_SWITCHED: "hlsAudioTrackSwitched",
          AUDIO_TRACK_LOADING: "hlsAudioTrackLoading",
          AUDIO_TRACK_LOADED: "hlsAudioTrackLoaded",
          SUBTITLE_TRACKS_UPDATED: "hlsSubtitleTracksUpdated",
          SUBTITLE_TRACK_SWITCH: "hlsSubtitleTrackSwitch",
          SUBTITLE_TRACK_LOADING: "hlsSubtitleTrackLoading",
          SUBTITLE_TRACK_LOADED: "hlsSubtitleTrackLoaded",
          SUBTITLE_FRAG_PROCESSED: "hlsSubtitleFragProcessed",
          INIT_PTS_FOUND: "hlsInitPtsFound",
          FRAG_LOADING: "hlsFragLoading",
          FRAG_LOAD_PROGRESS: "hlsFragLoadProgress",
          FRAG_LOAD_EMERGENCY_ABORTED: "hlsFragLoadEmergencyAborted",
          FRAG_LOADED: "hlsFragLoaded",
          FRAG_DECRYPTED: "hlsFragDecrypted",
          FRAG_PARSING_INIT_SEGMENT: "hlsFragParsingInitSegment",
          FRAG_PARSING_USERDATA: "hlsFragParsingUserdata",
          FRAG_PARSING_METADATA: "hlsFragParsingMetadata",
          FRAG_PARSING_DATA: "hlsFragParsingData",
          FRAG_PARSED: "hlsFragParsed",
          FRAG_BUFFERED: "hlsFragBuffered",
          FRAG_CHANGED: "hlsFragChanged",
          FPS_DROP: "hlsFpsDrop",
          FPS_DROP_LEVEL_CAPPING: "hlsFpsDropLevelCapping",
          ERROR: "hlsError",
          DESTROYING: "hlsDestroying",
          KEY_LOADING: "hlsKeyLoading",
          KEY_LOADED: "hlsKeyLoaded",
          STREAM_STATE_TRANSITION: "hlsStreamStateTransition"
        };
        t.default = a;
      },
      "./src/hls.js": function(i, t, n) {
        var a = this && this.__extends || function() {
          var x = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(w, S) {
            w.__proto__ = S;
          } || function(w, S) {
            for (var T in S)
              S.hasOwnProperty(T) && (w[T] = S[T]);
          };
          return function(w, S) {
            x(w, S);
            function T() {
              this.constructor = w;
            }
            w.prototype = S === null ? Object.create(S) : (T.prototype = S.prototype, new T());
          };
        }();
        Object.defineProperty(t, "__esModule", { value: !0 });
        var s = n("./node_modules/url-toolkit/src/url-toolkit.js"), o = n("./src/errors.js"), l = n("./src/loader/playlist-loader.js"), u = n("./src/loader/fragment-loader.js"), h = n("./src/loader/key-loader.js"), c = n("./src/controller/fragment-tracker.js"), d = n("./src/controller/stream-controller.js"), f = n("./src/controller/level-controller.js"), m = n("./src/controller/id3-track-controller.js"), p = n("./src/is-supported.js"), b = n("./src/utils/logger.js"), y = n("./src/config.js"), v = n("./src/events.js"), g = n("./src/observer.js"), E = function(x) {
          a(w, x);
          function w(S) {
            S === void 0 && (S = {});
            var T = x.call(this) || this, C = w.DefaultConfig;
            if ((S.liveSyncDurationCount || S.liveMaxLatencyDurationCount) && (S.liveSyncDuration || S.liveMaxLatencyDuration))
              throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
            for (var D in C)
              D in S || (S[D] = C[D]);
            if (S.liveMaxLatencyDurationCount !== void 0 && S.liveMaxLatencyDurationCount <= S.liveSyncDurationCount)
              throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be gt "liveSyncDurationCount"');
            if (S.liveMaxLatencyDuration !== void 0 && (S.liveMaxLatencyDuration <= S.liveSyncDuration || S.liveSyncDuration === void 0))
              throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be gt "liveSyncDuration"');
            b.enableLogs(S.debug), T.config = S, T._autoLevelCapping = -1;
            var R = T.abrController = new S.abrController(T), P = new S.bufferController(T), N = new S.capLevelController(T), $ = new S.fpsController(T), O = new l.default(T), M = new u.default(T), F = new h.default(T), G = new m.default(T), K = T.levelController = new f.default(T), J = new c.FragmentTracker(T), ue = T.streamController = new d.default(T, J), ce = [K, ue], ee = S.audioStreamController;
            ee && ce.push(new ee(T, J)), T.networkControllers = ce;
            var me = [
              O,
              M,
              F,
              R,
              P,
              N,
              $,
              G,
              J
            ];
            if (ee = S.audioTrackController, ee) {
              var Ce = new ee(T);
              T.audioTrackController = Ce, me.push(Ce);
            }
            if (ee = S.subtitleTrackController, ee) {
              var Ne = new ee(T);
              T.subtitleTrackController = Ne, ce.push(Ne);
            }
            if (ee = S.emeController, ee) {
              var ot = new ee(T);
              T.emeController = ot, me.push(ot);
            }
            return ee = S.subtitleStreamController, ee && ce.push(new ee(T, J)), ee = S.timelineController, ee && me.push(new ee(T)), T.coreComponents = me, T;
          }
          return Object.defineProperty(w, "version", {
            get: function() {
              return "0.12.4";
            },
            enumerable: !0,
            configurable: !0
          }), w.isSupported = function() {
            return p.isSupported();
          }, Object.defineProperty(w, "Events", {
            get: function() {
              return v.default;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w, "ErrorTypes", {
            get: function() {
              return o.ErrorTypes;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w, "ErrorDetails", {
            get: function() {
              return o.ErrorDetails;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w, "DefaultConfig", {
            get: function() {
              return w.defaultConfig ? w.defaultConfig : y.hlsDefaultConfig;
            },
            set: function(S) {
              w.defaultConfig = S;
            },
            enumerable: !0,
            configurable: !0
          }), w.prototype.destroy = function() {
            b.logger.log("destroy"), this.trigger(v.default.DESTROYING), this.detachMedia(), this.coreComponents.concat(this.networkControllers).forEach(function(S) {
              S.destroy();
            }), this.url = null, this.removeAllListeners(), this._autoLevelCapping = -1;
          }, w.prototype.attachMedia = function(S) {
            b.logger.log("attachMedia"), this.media = S, this.trigger(v.default.MEDIA_ATTACHING, { media: S });
          }, w.prototype.detachMedia = function() {
            b.logger.log("detachMedia"), this.trigger(v.default.MEDIA_DETACHING), this.media = null;
          }, w.prototype.loadSource = function(S) {
            S = s.buildAbsoluteURL(window.location.href, S, { alwaysNormalize: !0 }), b.logger.log("loadSource:" + S), this.url = S, this.trigger(v.default.MANIFEST_LOADING, { url: S });
          }, w.prototype.startLoad = function(S) {
            S === void 0 && (S = -1), b.logger.log("startLoad(" + S + ")"), this.networkControllers.forEach(function(T) {
              T.startLoad(S);
            });
          }, w.prototype.stopLoad = function() {
            b.logger.log("stopLoad"), this.networkControllers.forEach(function(S) {
              S.stopLoad();
            });
          }, w.prototype.swapAudioCodec = function() {
            b.logger.log("swapAudioCodec"), this.streamController.swapAudioCodec();
          }, w.prototype.recoverMediaError = function() {
            b.logger.log("recoverMediaError");
            var S = this.media;
            this.detachMedia(), this.attachMedia(S);
          }, Object.defineProperty(w.prototype, "levels", {
            get: function() {
              return this.levelController.levels;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w.prototype, "currentLevel", {
            get: function() {
              return this.streamController.currentLevel;
            },
            set: function(S) {
              b.logger.log("set currentLevel:" + S), this.loadLevel = S, this.streamController.immediateLevelSwitch();
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w.prototype, "nextLevel", {
            get: function() {
              return this.streamController.nextLevel;
            },
            set: function(S) {
              b.logger.log("set nextLevel:" + S), this.levelController.manualLevel = S, this.streamController.nextLevelSwitch();
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w.prototype, "loadLevel", {
            get: function() {
              return this.levelController.level;
            },
            set: function(S) {
              b.logger.log("set loadLevel:" + S), this.levelController.manualLevel = S;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w.prototype, "nextLoadLevel", {
            get: function() {
              return this.levelController.nextLoadLevel;
            },
            set: function(S) {
              this.levelController.nextLoadLevel = S;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w.prototype, "firstLevel", {
            get: function() {
              return Math.max(this.levelController.firstLevel, this.minAutoLevel);
            },
            set: function(S) {
              b.logger.log("set firstLevel:" + S), this.levelController.firstLevel = S;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w.prototype, "startLevel", {
            get: function() {
              return this.levelController.startLevel;
            },
            set: function(S) {
              b.logger.log("set startLevel:" + S);
              var T = this;
              S !== -1 && (S = Math.max(S, T.minAutoLevel)), T.levelController.startLevel = S;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w.prototype, "autoLevelCapping", {
            get: function() {
              return this._autoLevelCapping;
            },
            set: function(S) {
              b.logger.log("set autoLevelCapping:" + S), this._autoLevelCapping = S;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w.prototype, "autoLevelEnabled", {
            get: function() {
              return this.levelController.manualLevel === -1;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w.prototype, "manualLevel", {
            get: function() {
              return this.levelController.manualLevel;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w.prototype, "minAutoLevel", {
            get: function() {
              for (var S = this, T = S.levels, C = S.config.minAutoBitrate, D = T ? T.length : 0, R = 0; R < D; R++) {
                var P = T[R].realBitrate ? Math.max(T[R].realBitrate, T[R].bitrate) : T[R].bitrate;
                if (P > C)
                  return R;
              }
              return 0;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w.prototype, "maxAutoLevel", {
            get: function() {
              var S = this, T = S.levels, C = S.autoLevelCapping, D;
              return C === -1 && T && T.length ? D = T.length - 1 : D = C, D;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w.prototype, "nextAutoLevel", {
            get: function() {
              var S = this;
              return Math.min(Math.max(S.abrController.nextAutoLevel, S.minAutoLevel), S.maxAutoLevel);
            },
            set: function(S) {
              var T = this;
              T.abrController.nextAutoLevel = Math.max(T.minAutoLevel, S);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w.prototype, "audioTracks", {
            get: function() {
              var S = this.audioTrackController;
              return S ? S.audioTracks : [];
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w.prototype, "audioTrack", {
            get: function() {
              var S = this.audioTrackController;
              return S ? S.audioTrack : -1;
            },
            set: function(S) {
              var T = this.audioTrackController;
              T && (T.audioTrack = S);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w.prototype, "liveSyncPosition", {
            get: function() {
              return this.streamController.liveSyncPosition;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w.prototype, "subtitleTracks", {
            get: function() {
              var S = this.subtitleTrackController;
              return S ? S.subtitleTracks : [];
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w.prototype, "subtitleTrack", {
            get: function() {
              var S = this.subtitleTrackController;
              return S ? S.subtitleTrack : -1;
            },
            set: function(S) {
              var T = this.subtitleTrackController;
              T && (T.subtitleTrack = S);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(w.prototype, "subtitleDisplay", {
            get: function() {
              var S = this.subtitleTrackController;
              return S ? S.subtitleDisplay : !1;
            },
            set: function(S) {
              var T = this.subtitleTrackController;
              T && (T.subtitleDisplay = S);
            },
            enumerable: !0,
            configurable: !0
          }), w;
        }(g.Observer);
        t.default = E;
      },
      "./src/is-supported.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/utils/mediasource-helper.js");
        function s() {
          var o = a.getMediaSource(), l = window.SourceBuffer || window.WebKitSourceBuffer, u = o && typeof o.isTypeSupported == "function" && o.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), h = !l || l.prototype && typeof l.prototype.appendBuffer == "function" && typeof l.prototype.remove == "function";
          return !!u && !!h;
        }
        t.isSupported = s;
      },
      "./src/loader/fragment-loader.js": function(i, t, n) {
        (function(a) {
          var s = this && this.__extends || function() {
            var d = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, m) {
              f.__proto__ = m;
            } || function(f, m) {
              for (var p in m)
                m.hasOwnProperty(p) && (f[p] = m[p]);
            };
            return function(f, m) {
              d(f, m);
              function p() {
                this.constructor = f;
              }
              f.prototype = m === null ? Object.create(m) : (p.prototype = m.prototype, new p());
            };
          }();
          Object.defineProperty(t, "__esModule", { value: !0 });
          var o = n("./src/events.js"), l = n("./src/event-handler.js"), u = n("./src/errors.js"), h = n("./src/utils/logger.js"), c = function(d) {
            s(f, d);
            function f(m) {
              var p = d.call(this, m, o.default.FRAG_LOADING) || this;
              return p.loaders = {}, p;
            }
            return f.prototype.destroy = function() {
              var m = this.loaders;
              for (var p in m) {
                var b = m[p];
                b && b.destroy();
              }
              this.loaders = {}, d.prototype.destroy.call(this);
            }, f.prototype.onFragLoading = function(m) {
              var p = m.frag, b = p.type, y = this.loaders, v = this.hls.config, g = v.fLoader, E = v.loader;
              p.loaded = 0;
              var x = y[b];
              x && (h.logger.warn("abort previous fragment loader for type: " + b), x.abort()), x = y[b] = p.loader = v.fLoader ? new g(v) : new E(v);
              var w, S, T;
              w = { url: p.url, frag: p, responseType: "arraybuffer", progressData: !1 };
              var C = p.byteRangeStartOffset, D = p.byteRangeEndOffset;
              a.isFinite(C) && a.isFinite(D) && (w.rangeStart = C, w.rangeEnd = D), S = {
                timeout: v.fragLoadingTimeOut,
                maxRetry: 0,
                retryDelay: 0,
                maxRetryDelay: v.fragLoadingMaxRetryTimeout
              }, T = {
                onSuccess: this.loadsuccess.bind(this),
                onError: this.loaderror.bind(this),
                onTimeout: this.loadtimeout.bind(this),
                onProgress: this.loadprogress.bind(this)
              }, x.load(w, S, T);
            }, f.prototype.loadsuccess = function(m, p, b, y) {
              y === void 0 && (y = null);
              var v = m.data, g = b.frag;
              g.loader = void 0, this.loaders[g.type] = void 0, this.hls.trigger(o.default.FRAG_LOADED, { payload: v, frag: g, stats: p, networkDetails: y });
            }, f.prototype.loaderror = function(m, p, b) {
              b === void 0 && (b = null);
              var y = p.frag, v = y.loader;
              v && v.abort(), this.loaders[y.type] = void 0, this.hls.trigger(o.default.ERROR, { type: u.ErrorTypes.NETWORK_ERROR, details: u.ErrorDetails.FRAG_LOAD_ERROR, fatal: !1, frag: p.frag, response: m, networkDetails: b });
            }, f.prototype.loadtimeout = function(m, p, b) {
              b === void 0 && (b = null);
              var y = p.frag, v = y.loader;
              v && v.abort(), this.loaders[y.type] = void 0, this.hls.trigger(o.default.ERROR, { type: u.ErrorTypes.NETWORK_ERROR, details: u.ErrorDetails.FRAG_LOAD_TIMEOUT, fatal: !1, frag: p.frag, networkDetails: b });
            }, f.prototype.loadprogress = function(m, p, b, y) {
              y === void 0 && (y = null);
              var v = p.frag;
              v.loaded = m.loaded, this.hls.trigger(o.default.FRAG_LOAD_PROGRESS, { frag: v, stats: m, networkDetails: y });
            }, f;
          }(l.default);
          t.default = c;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/loader/fragment.js": function(i, t, n) {
        (function(a) {
          Object.defineProperty(t, "__esModule", { value: !0 });
          var s = n("./node_modules/url-toolkit/src/url-toolkit.js"), o = n("./src/loader/level-key.js"), l = function() {
            function u() {
              var h;
              this._url = null, this._byteRange = null, this._decryptdata = null, this.tagList = [], this.programDateTime = null, this.rawProgramDateTime = null, this._elementaryStreams = (h = {}, h[u.ElementaryStreamTypes.AUDIO] = !1, h[u.ElementaryStreamTypes.VIDEO] = !1, h);
            }
            return Object.defineProperty(u, "ElementaryStreamTypes", {
              get: function() {
                return {
                  AUDIO: "audio",
                  VIDEO: "video"
                };
              },
              enumerable: !0,
              configurable: !0
            }), Object.defineProperty(u.prototype, "url", {
              get: function() {
                return !this._url && this.relurl && (this._url = s.buildAbsoluteURL(this.baseurl, this.relurl, { alwaysNormalize: !0 })), this._url;
              },
              set: function(h) {
                this._url = h;
              },
              enumerable: !0,
              configurable: !0
            }), Object.defineProperty(u.prototype, "byteRange", {
              get: function() {
                if (!this._byteRange && !this.rawByteRange)
                  return [];
                if (this._byteRange)
                  return this._byteRange;
                var h = [];
                if (this.rawByteRange) {
                  var c = this.rawByteRange.split("@", 2);
                  if (c.length === 1) {
                    var d = this.lastByteRangeEndOffset;
                    h[0] = d || 0;
                  } else
                    h[0] = parseInt(c[1]);
                  h[1] = parseInt(c[0]) + h[0], this._byteRange = h;
                }
                return h;
              },
              enumerable: !0,
              configurable: !0
            }), Object.defineProperty(u.prototype, "byteRangeStartOffset", {
              get: function() {
                return this.byteRange[0];
              },
              enumerable: !0,
              configurable: !0
            }), Object.defineProperty(u.prototype, "byteRangeEndOffset", {
              get: function() {
                return this.byteRange[1];
              },
              enumerable: !0,
              configurable: !0
            }), Object.defineProperty(u.prototype, "decryptdata", {
              get: function() {
                return this._decryptdata || (this._decryptdata = this.fragmentDecryptdataFromLevelkey(this.levelkey, this.sn)), this._decryptdata;
              },
              enumerable: !0,
              configurable: !0
            }), Object.defineProperty(u.prototype, "endProgramDateTime", {
              get: function() {
                if (!a.isFinite(this.programDateTime))
                  return null;
                var h = a.isFinite(this.duration) ? this.duration : 0;
                return this.programDateTime + h * 1e3;
              },
              enumerable: !0,
              configurable: !0
            }), Object.defineProperty(u.prototype, "encrypted", {
              get: function() {
                return !!(this.decryptdata && this.decryptdata.uri !== null && this.decryptdata.key === null);
              },
              enumerable: !0,
              configurable: !0
            }), u.prototype.addElementaryStream = function(h) {
              this._elementaryStreams[h] = !0;
            }, u.prototype.hasElementaryStream = function(h) {
              return this._elementaryStreams[h] === !0;
            }, u.prototype.createInitializationVector = function(h) {
              for (var c = new Uint8Array(16), d = 12; d < 16; d++)
                c[d] = h >> 8 * (15 - d) & 255;
              return c;
            }, u.prototype.fragmentDecryptdataFromLevelkey = function(h, c) {
              var d = h;
              return h && h.method && h.uri && !h.iv && (d = new o.default(), d.method = h.method, d.baseuri = h.baseuri, d.reluri = h.reluri, d.iv = this.createInitializationVector(c)), d;
            }, u;
          }();
          t.default = l;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/loader/key-loader.js": function(i, t, n) {
        var a = this && this.__extends || function() {
          var c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, f) {
            d.__proto__ = f;
          } || function(d, f) {
            for (var m in f)
              f.hasOwnProperty(m) && (d[m] = f[m]);
          };
          return function(d, f) {
            c(d, f);
            function m() {
              this.constructor = d;
            }
            d.prototype = f === null ? Object.create(f) : (m.prototype = f.prototype, new m());
          };
        }();
        Object.defineProperty(t, "__esModule", { value: !0 });
        var s = n("./src/events.js"), o = n("./src/event-handler.js"), l = n("./src/errors.js"), u = n("./src/utils/logger.js"), h = function(c) {
          a(d, c);
          function d(f) {
            var m = c.call(this, f, s.default.KEY_LOADING) || this;
            return m.loaders = {}, m.decryptkey = null, m.decrypturl = null, m;
          }
          return d.prototype.destroy = function() {
            for (var f in this.loaders) {
              var m = this.loaders[f];
              m && m.destroy();
            }
            this.loaders = {}, o.default.prototype.destroy.call(this);
          }, d.prototype.onKeyLoading = function(f) {
            var m = f.frag, p = m.type, b = this.loaders[p], y = m.decryptdata, v = y.uri;
            if (v !== this.decrypturl || this.decryptkey === null) {
              var g = this.hls.config;
              b && (u.logger.warn("abort previous key loader for type:" + p), b.abort()), m.loader = this.loaders[p] = new g.loader(g), this.decrypturl = v, this.decryptkey = null;
              var E = void 0, x = void 0, w = void 0;
              E = { url: v, frag: m, responseType: "arraybuffer" }, x = { timeout: g.fragLoadingTimeOut, maxRetry: 0, retryDelay: g.fragLoadingRetryDelay, maxRetryDelay: g.fragLoadingMaxRetryTimeout }, w = { onSuccess: this.loadsuccess.bind(this), onError: this.loaderror.bind(this), onTimeout: this.loadtimeout.bind(this) }, m.loader.load(E, x, w);
            } else
              this.decryptkey && (y.key = this.decryptkey, this.hls.trigger(s.default.KEY_LOADED, { frag: m }));
          }, d.prototype.loadsuccess = function(f, m, p) {
            var b = p.frag;
            this.decryptkey = b.decryptdata.key = new Uint8Array(f.data), b.loader = void 0, this.loaders[b.type] = void 0, this.hls.trigger(s.default.KEY_LOADED, { frag: b });
          }, d.prototype.loaderror = function(f, m) {
            var p = m.frag, b = p.loader;
            b && b.abort(), this.loaders[m.type] = void 0, this.hls.trigger(s.default.ERROR, { type: l.ErrorTypes.NETWORK_ERROR, details: l.ErrorDetails.KEY_LOAD_ERROR, fatal: !1, frag: p, response: f });
          }, d.prototype.loadtimeout = function(f, m) {
            var p = m.frag, b = p.loader;
            b && b.abort(), this.loaders[m.type] = void 0, this.hls.trigger(s.default.ERROR, { type: l.ErrorTypes.NETWORK_ERROR, details: l.ErrorDetails.KEY_LOAD_TIMEOUT, fatal: !1, frag: p });
          }, d;
        }(o.default);
        t.default = h;
      },
      "./src/loader/level-key.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./node_modules/url-toolkit/src/url-toolkit.js"), s = function() {
          function o() {
            this.method = null, this.key = null, this.iv = null, this._uri = null;
          }
          return Object.defineProperty(o.prototype, "uri", {
            get: function() {
              return !this._uri && this.reluri && (this._uri = a.buildAbsoluteURL(this.baseuri, this.reluri, { alwaysNormalize: !0 })), this._uri;
            },
            enumerable: !0,
            configurable: !0
          }), o;
        }();
        t.default = s;
      },
      "./src/loader/level.js": function(i, t, n) {
        (function(a) {
          Object.defineProperty(t, "__esModule", { value: !0 });
          var s = function() {
            function o(l) {
              this.endCC = 0, this.endSN = 0, this.fragments = [], this.initSegment = null, this.live = !0, this.needSidxRanges = !1, this.startCC = 0, this.startSN = 0, this.startTimeOffset = null, this.targetduration = 0, this.totalduration = 0, this.type = null, this.url = l, this.version = null;
            }
            return Object.defineProperty(o.prototype, "hasProgramDateTime", {
              get: function() {
                return !!(this.fragments[0] && a.isFinite(this.fragments[0].programDateTime));
              },
              enumerable: !0,
              configurable: !0
            }), o;
          }();
          t.default = s;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/loader/m3u8-parser.js": function(i, t, n) {
        (function(a) {
          Object.defineProperty(t, "__esModule", { value: !0 });
          var s = n("./node_modules/url-toolkit/src/url-toolkit.js"), o = n("./src/loader/fragment.js"), l = n("./src/loader/level.js"), u = n("./src/loader/level-key.js"), h = n("./src/utils/attr-list.js"), c = n("./src/utils/logger.js"), d = n("./src/utils/codecs.js"), f = /#EXT-X-STREAM-INF:([^\n\r]*)[\r\n]+([^\r\n]+)/g, m = /#EXT-X-MEDIA:(.*)/g, p = new RegExp([
            /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
            /|(?!#)([\S+ ?]+)/.source,
            /|#EXT-X-BYTERANGE:*(.+)/.source,
            /|#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
            /|#.*/.source
          ].join(""), "g"), b = /(?:(?:#(EXTM3U))|(?:#EXT-X-(PLAYLIST-TYPE):(.+))|(?:#EXT-X-(MEDIA-SEQUENCE): *(\d+))|(?:#EXT-X-(TARGETDURATION): *(\d+))|(?:#EXT-X-(KEY):(.+))|(?:#EXT-X-(START):(.+))|(?:#EXT-X-(ENDLIST))|(?:#EXT-X-(DISCONTINUITY-SEQ)UENCE:(\d+))|(?:#EXT-X-(DIS)CONTINUITY))|(?:#EXT-X-(VERSION):(\d+))|(?:#EXT-X-(MAP):(.+))|(?:(#)([^:]*):(.*))|(?:(#)(.*))(?:.*)\r?\n?/, y = /\.(mp4|m4s|m4v|m4a)$/i, v = function() {
            function x() {
            }
            return x.findGroup = function(w, S) {
              if (!w)
                return null;
              for (var T = null, C = 0; C < w.length; C++) {
                var D = w[C];
                D.id === S && (T = D);
              }
              return T;
            }, x.convertAVC1ToAVCOTI = function(w) {
              var S, T = w.split(".");
              return T.length > 2 ? (S = T.shift() + ".", S += parseInt(T.shift()).toString(16), S += ("000" + parseInt(T.shift()).toString(16)).substr(-4)) : S = w, S;
            }, x.resolve = function(w, S) {
              return s.buildAbsoluteURL(S, w, { alwaysNormalize: !0 });
            }, x.parseMasterPlaylist = function(w, S) {
              var T = [], C;
              f.lastIndex = 0;
              function D($, O) {
                ["video", "audio"].forEach(function(M) {
                  var F = $.filter(function(K) {
                    return d.isCodecType(K, M);
                  });
                  if (F.length) {
                    var G = F.filter(function(K) {
                      return K.lastIndexOf("avc1", 0) === 0 || K.lastIndexOf("mp4a", 0) === 0;
                    });
                    O[M + "Codec"] = G.length > 0 ? G[0] : F[0], $ = $.filter(function(K) {
                      return F.indexOf(K) === -1;
                    });
                  }
                }), O.unknownCodecs = $;
              }
              for (; (C = f.exec(w)) != null; ) {
                var R = {}, P = R.attrs = new h.default(C[1]);
                R.url = x.resolve(C[2], S);
                var N = P.decimalResolution("RESOLUTION");
                N && (R.width = N.width, R.height = N.height), R.bitrate = P.decimalInteger("AVERAGE-BANDWIDTH") || P.decimalInteger("BANDWIDTH"), R.name = P.NAME, D([].concat((P.CODECS || "").split(/[ ,]+/)), R), R.videoCodec && R.videoCodec.indexOf("avc1") !== -1 && (R.videoCodec = x.convertAVC1ToAVCOTI(R.videoCodec)), T.push(R);
              }
              return T;
            }, x.parseMasterPlaylistMedia = function(w, S, T, C) {
              C === void 0 && (C = []);
              var D, R = [], P = 0;
              for (m.lastIndex = 0; (D = m.exec(w)) !== null; ) {
                var N = {}, $ = new h.default(D[1]);
                if ($.TYPE === T) {
                  if (N.groupId = $["GROUP-ID"], N.name = $.NAME, N.type = T, N.default = $.DEFAULT === "YES", N.autoselect = $.AUTOSELECT === "YES", N.forced = $.FORCED === "YES", $.URI && (N.url = x.resolve($.URI, S)), N.lang = $.LANGUAGE, N.name || (N.name = N.lang), C.length) {
                    var O = x.findGroup(C, N.groupId);
                    N.audioCodec = O ? O.codec : C[0].codec;
                  }
                  N.id = P++, R.push(N);
                }
              }
              return R;
            }, x.parseLevelPlaylist = function(w, S, T, C, D) {
              var R = 0, P = 0, N = new l.default(S), $ = new u.default(), O = 0, M = null, F = new o.default(), G, K, J = null;
              for (p.lastIndex = 0; (G = p.exec(w)) !== null; ) {
                var ue = G[1];
                if (ue) {
                  F.duration = parseFloat(ue);
                  var ce = (" " + G[2]).slice(1);
                  F.title = ce || null, F.tagList.push(ce ? ["INF", ue, ce] : ["INF", ue]);
                } else if (G[3]) {
                  if (a.isFinite(F.duration)) {
                    var ee = R++;
                    F.type = C, F.start = P, F.levelkey = $, F.sn = ee, F.level = T, F.cc = O, F.urlId = D, F.baseurl = S, F.relurl = (" " + G[3]).slice(1), E(F, M), N.fragments.push(F), M = F, P += F.duration, F = new o.default();
                  }
                } else if (G[4]) {
                  if (F.rawByteRange = (" " + G[4]).slice(1), M) {
                    var me = M.byteRangeEndOffset;
                    me && (F.lastByteRangeEndOffset = me);
                  }
                } else if (G[5])
                  F.rawProgramDateTime = (" " + G[5]).slice(1), F.tagList.push(["PROGRAM-DATE-TIME", F.rawProgramDateTime]), J === null && (J = N.fragments.length);
                else {
                  for (G = G[0].match(b), K = 1; K < G.length && G[K] === void 0; K++)
                    ;
                  var Ce = (" " + G[K + 1]).slice(1), Ne = (" " + G[K + 2]).slice(1);
                  switch (G[K]) {
                    case "#":
                      F.tagList.push(Ne ? [Ce, Ne] : [Ce]);
                      break;
                    case "PLAYLIST-TYPE":
                      N.type = Ce.toUpperCase();
                      break;
                    case "MEDIA-SEQUENCE":
                      R = N.startSN = parseInt(Ce);
                      break;
                    case "TARGETDURATION":
                      N.targetduration = parseFloat(Ce);
                      break;
                    case "VERSION":
                      N.version = parseInt(Ce);
                      break;
                    case "EXTM3U":
                      break;
                    case "ENDLIST":
                      N.live = !1;
                      break;
                    case "DIS":
                      O++, F.tagList.push(["DIS"]);
                      break;
                    case "DISCONTINUITY-SEQ":
                      O = parseInt(Ce);
                      break;
                    case "KEY":
                      var ot = Ce, ze = new h.default(ot), $e = ze.enumeratedString("METHOD"), Ze = ze.URI, Ut = ze.hexadecimalInteger("IV");
                      $e && ($ = new u.default(), Ze && ["AES-128", "SAMPLE-AES", "SAMPLE-AES-CENC"].indexOf($e) >= 0 && ($.method = $e, $.baseuri = S, $.reluri = Ze, $.key = null, $.iv = Ut));
                      break;
                    case "START":
                      var qt = Ce, ir = new h.default(qt), We = ir.decimalFloatingPoint("TIME-OFFSET");
                      a.isFinite(We) && (N.startTimeOffset = We);
                      break;
                    case "MAP":
                      var vt = new h.default(Ce);
                      F.relurl = vt.URI, F.rawByteRange = vt.BYTERANGE, F.baseurl = S, F.level = T, F.type = C, F.sn = "initSegment", N.initSegment = F, F = new o.default(), F.rawProgramDateTime = N.initSegment.rawProgramDateTime;
                      break;
                    default:
                      c.logger.warn("line parsed but not handled: " + G);
                      break;
                  }
                }
              }
              return F = M, F && !F.relurl && (N.fragments.pop(), P -= F.duration), N.totalduration = P, N.averagetargetduration = P / N.fragments.length, N.endSN = R - 1, N.startCC = N.fragments[0] ? N.fragments[0].cc : 0, N.endCC = O, !N.initSegment && N.fragments.length && N.fragments.every(function(Tt) {
                return y.test(Tt.relurl);
              }) && (c.logger.warn("MP4 fragments found but no init segment (probably no MAP, incomplete M3U8), trying to fetch SIDX"), F = new o.default(), F.relurl = N.fragments[0].relurl, F.baseurl = S, F.level = T, F.type = C, F.sn = "initSegment", N.initSegment = F, N.needSidxRanges = !0), J && g(N.fragments, J), N;
            }, x;
          }();
          t.default = v;
          function g(x, w) {
            for (var S = x[w], T = w - 1; T >= 0; T--) {
              var C = x[T];
              C.programDateTime = S.programDateTime - C.duration * 1e3, S = C;
            }
          }
          function E(x, w) {
            x.rawProgramDateTime ? x.programDateTime = Date.parse(x.rawProgramDateTime) : w && w.programDateTime && (x.programDateTime = w.endProgramDateTime), a.isFinite(x.programDateTime) || (x.programDateTime = null, x.rawProgramDateTime = null);
          }
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/loader/playlist-loader.js": function(i, t, n) {
        (function(a) {
          var s = this && this.__extends || function() {
            var y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, g) {
              v.__proto__ = g;
            } || function(v, g) {
              for (var E in g)
                g.hasOwnProperty(E) && (v[E] = g[E]);
            };
            return function(v, g) {
              y(v, g);
              function E() {
                this.constructor = v;
              }
              v.prototype = g === null ? Object.create(g) : (E.prototype = g.prototype, new E());
            };
          }();
          Object.defineProperty(t, "__esModule", { value: !0 });
          var o = n("./src/events.js"), l = n("./src/event-handler.js"), u = n("./src/errors.js"), h = n("./src/utils/logger.js"), c = n("./src/demux/mp4demuxer.js"), d = n("./src/loader/m3u8-parser.js"), f = window.performance, m = {
            MANIFEST: "manifest",
            LEVEL: "level",
            AUDIO_TRACK: "audioTrack",
            SUBTITLE_TRACK: "subtitleTrack"
          }, p = {
            MAIN: "main",
            AUDIO: "audio",
            SUBTITLE: "subtitle"
          }, b = function(y) {
            s(v, y);
            function v(g) {
              var E = y.call(this, g, o.default.MANIFEST_LOADING, o.default.LEVEL_LOADING, o.default.AUDIO_TRACK_LOADING, o.default.SUBTITLE_TRACK_LOADING) || this;
              return E.loaders = {}, E;
            }
            return Object.defineProperty(v, "ContextType", {
              get: function() {
                return m;
              },
              enumerable: !0,
              configurable: !0
            }), Object.defineProperty(v, "LevelType", {
              get: function() {
                return p;
              },
              enumerable: !0,
              configurable: !0
            }), v.canHaveQualityLevels = function(g) {
              return g !== m.AUDIO_TRACK && g !== m.SUBTITLE_TRACK;
            }, v.mapContextToLevelType = function(g) {
              var E = g.type;
              switch (E) {
                case m.AUDIO_TRACK:
                  return p.AUDIO;
                case m.SUBTITLE_TRACK:
                  return p.SUBTITLE;
                default:
                  return p.MAIN;
              }
            }, v.getResponseUrl = function(g, E) {
              var x = g.url;
              return (x === void 0 || x.indexOf("data:") === 0) && (x = E.url), x;
            }, v.prototype.createInternalLoader = function(g) {
              var E = this.hls.config, x = E.pLoader, w = E.loader, S = x || w, T = new S(E);
              return g.loader = T, this.loaders[g.type] = T, T;
            }, v.prototype.getInternalLoader = function(g) {
              return this.loaders[g.type];
            }, v.prototype.resetInternalLoader = function(g) {
              this.loaders[g] && delete this.loaders[g];
            }, v.prototype.destroyInternalLoaders = function() {
              for (var g in this.loaders) {
                var E = this.loaders[g];
                E && E.destroy(), this.resetInternalLoader(g);
              }
            }, v.prototype.destroy = function() {
              this.destroyInternalLoaders(), y.prototype.destroy.call(this);
            }, v.prototype.onManifestLoading = function(g) {
              this.load(g.url, { type: m.MANIFEST, level: 0, id: null });
            }, v.prototype.onLevelLoading = function(g) {
              this.load(g.url, { type: m.LEVEL, level: g.level, id: g.id });
            }, v.prototype.onAudioTrackLoading = function(g) {
              this.load(g.url, { type: m.AUDIO_TRACK, level: null, id: g.id });
            }, v.prototype.onSubtitleTrackLoading = function(g) {
              this.load(g.url, { type: m.SUBTITLE_TRACK, level: null, id: g.id });
            }, v.prototype.load = function(g, E) {
              var x = this.hls.config;
              h.logger.debug("Loading playlist of type " + E.type + ", level: " + E.level + ", id: " + E.id);
              var w = this.getInternalLoader(E);
              if (w) {
                var S = w.context;
                if (S && S.url === g)
                  return h.logger.trace("playlist request ongoing"), !1;
                h.logger.warn("aborting previous loader for type: " + E.type), w.abort();
              }
              var T, C, D, R;
              switch (E.type) {
                case m.MANIFEST:
                  T = x.manifestLoadingMaxRetry, C = x.manifestLoadingTimeOut, D = x.manifestLoadingRetryDelay, R = x.manifestLoadingMaxRetryTimeout;
                  break;
                case m.LEVEL:
                  T = 0, C = x.levelLoadingTimeOut;
                  break;
                default:
                  T = x.levelLoadingMaxRetry, C = x.levelLoadingTimeOut, D = x.levelLoadingRetryDelay, R = x.levelLoadingMaxRetryTimeout;
                  break;
              }
              w = this.createInternalLoader(E), E.url = g, E.responseType = E.responseType || "";
              var P = {
                timeout: C,
                maxRetry: T,
                retryDelay: D,
                maxRetryDelay: R
              }, N = {
                onSuccess: this.loadsuccess.bind(this),
                onError: this.loaderror.bind(this),
                onTimeout: this.loadtimeout.bind(this)
              };
              return h.logger.debug("Calling internal loader delegate for URL: " + g), w.load(E, P, N), !0;
            }, v.prototype.loadsuccess = function(g, E, x, w) {
              if (w === void 0 && (w = null), x.isSidxRequest) {
                this._handleSidxRequest(g, x), this._handlePlaylistLoaded(g, E, x, w);
                return;
              }
              this.resetInternalLoader(x.type);
              var S = g.data;
              if (E.tload = f.now(), S.indexOf("#EXTM3U") !== 0) {
                this._handleManifestParsingError(g, x, "no EXTM3U delimiter", w);
                return;
              }
              S.indexOf("#EXTINF:") > 0 || S.indexOf("#EXT-X-TARGETDURATION:") > 0 ? this._handleTrackOrLevelPlaylist(g, E, x, w) : this._handleMasterPlaylist(g, E, x, w);
            }, v.prototype.loaderror = function(g, E, x) {
              x === void 0 && (x = null), this._handleNetworkError(E, x, !1, g);
            }, v.prototype.loadtimeout = function(g, E, x) {
              x === void 0 && (x = null), this._handleNetworkError(E, x, !0);
            }, v.prototype._handleMasterPlaylist = function(g, E, x, w) {
              var S = this.hls, T = g.data, C = v.getResponseUrl(g, x), D = d.default.parseMasterPlaylist(T, C);
              if (!D.length) {
                this._handleManifestParsingError(g, x, "no level found in manifest", w);
                return;
              }
              var R = D.map(function(O) {
                return {
                  id: O.attrs.AUDIO,
                  codec: O.audioCodec
                };
              }), P = d.default.parseMasterPlaylistMedia(T, C, "AUDIO", R), N = d.default.parseMasterPlaylistMedia(T, C, "SUBTITLES");
              if (P.length) {
                var $ = !1;
                P.forEach(function(O) {
                  O.url || ($ = !0);
                }), $ === !1 && D[0].audioCodec && !D[0].attrs.AUDIO && (h.logger.log("audio codec signaled in quality level, but no embedded audio track signaled, create one"), P.unshift({
                  type: "main",
                  name: "main"
                }));
              }
              S.trigger(o.default.MANIFEST_LOADED, {
                levels: D,
                audioTracks: P,
                subtitles: N,
                url: C,
                stats: E,
                networkDetails: w
              });
            }, v.prototype._handleTrackOrLevelPlaylist = function(g, E, x, w) {
              var S = this.hls, T = x.id, C = x.level, D = x.type, R = v.getResponseUrl(g, x), P = a.isFinite(T) ? T : 0, N = a.isFinite(C) ? C : P, $ = v.mapContextToLevelType(x), O = d.default.parseLevelPlaylist(g.data, R, N, $, P);
              if (O.tload = E.tload, D === m.MANIFEST) {
                var M = {
                  url: R,
                  details: O
                };
                S.trigger(o.default.MANIFEST_LOADED, {
                  levels: [M],
                  audioTracks: [],
                  url: R,
                  stats: E,
                  networkDetails: w
                });
              }
              if (E.tparsed = f.now(), O.needSidxRanges) {
                var F = O.initSegment.url;
                this.load(F, {
                  isSidxRequest: !0,
                  type: D,
                  level: C,
                  levelDetails: O,
                  id: T,
                  rangeStart: 0,
                  rangeEnd: 2048,
                  responseType: "arraybuffer"
                });
                return;
              }
              x.levelDetails = O, this._handlePlaylistLoaded(g, E, x, w);
            }, v.prototype._handleSidxRequest = function(g, E) {
              var x = c.default.parseSegmentIndex(new Uint8Array(g.data));
              if (!!x) {
                var w = x.references, S = E.levelDetails;
                w.forEach(function(T, C) {
                  var D = T.info, R = S.fragments[C];
                  R.byteRange.length === 0 && (R.rawByteRange = String(1 + D.end - D.start) + "@" + String(D.start));
                }), S.initSegment.rawByteRange = String(x.moovEndOffset) + "@0";
              }
            }, v.prototype._handleManifestParsingError = function(g, E, x, w) {
              this.hls.trigger(o.default.ERROR, {
                type: u.ErrorTypes.NETWORK_ERROR,
                details: u.ErrorDetails.MANIFEST_PARSING_ERROR,
                fatal: !0,
                url: g.url,
                reason: x,
                networkDetails: w
              });
            }, v.prototype._handleNetworkError = function(g, E, x, w) {
              x === void 0 && (x = !1), w === void 0 && (w = null), h.logger.info("A network error occured while loading a " + g.type + "-type playlist");
              var S, T, C = this.getInternalLoader(g);
              switch (g.type) {
                case m.MANIFEST:
                  S = x ? u.ErrorDetails.MANIFEST_LOAD_TIMEOUT : u.ErrorDetails.MANIFEST_LOAD_ERROR, T = !0;
                  break;
                case m.LEVEL:
                  S = x ? u.ErrorDetails.LEVEL_LOAD_TIMEOUT : u.ErrorDetails.LEVEL_LOAD_ERROR, T = !1;
                  break;
                case m.AUDIO_TRACK:
                  S = x ? u.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT : u.ErrorDetails.AUDIO_TRACK_LOAD_ERROR, T = !1;
                  break;
                default:
                  T = !1;
              }
              C && (C.abort(), this.resetInternalLoader(g.type));
              var D = {
                type: u.ErrorTypes.NETWORK_ERROR,
                details: S,
                fatal: T,
                url: C.url,
                loader: C,
                context: g,
                networkDetails: E
              };
              w && (D.response = w), this.hls.trigger(o.default.ERROR, D);
            }, v.prototype._handlePlaylistLoaded = function(g, E, x, w) {
              var S = x.type, T = x.level, C = x.id, D = x.levelDetails;
              if (!D.targetduration) {
                this._handleManifestParsingError(g, x, "invalid target duration", w);
                return;
              }
              var R = v.canHaveQualityLevels(x.type);
              if (R)
                this.hls.trigger(o.default.LEVEL_LOADED, {
                  details: D,
                  level: T || 0,
                  id: C || 0,
                  stats: E,
                  networkDetails: w
                });
              else
                switch (S) {
                  case m.AUDIO_TRACK:
                    this.hls.trigger(o.default.AUDIO_TRACK_LOADED, {
                      details: D,
                      id: C,
                      stats: E,
                      networkDetails: w
                    });
                    break;
                  case m.SUBTITLE_TRACK:
                    this.hls.trigger(o.default.SUBTITLE_TRACK_LOADED, {
                      details: D,
                      id: C,
                      stats: E,
                      networkDetails: w
                    });
                    break;
                }
            }, v;
          }(l.default);
          t.default = b;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/observer.js": function(i, t, n) {
        var a = this && this.__extends || function() {
          var l = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, h) {
            u.__proto__ = h;
          } || function(u, h) {
            for (var c in h)
              h.hasOwnProperty(c) && (u[c] = h[c]);
          };
          return function(u, h) {
            l(u, h);
            function c() {
              this.constructor = u;
            }
            u.prototype = h === null ? Object.create(h) : (c.prototype = h.prototype, new c());
          };
        }();
        Object.defineProperty(t, "__esModule", { value: !0 });
        var s = n("./node_modules/eventemitter3/index.js"), o = function(l) {
          a(u, l);
          function u() {
            return l !== null && l.apply(this, arguments) || this;
          }
          return u.prototype.trigger = function(h) {
            for (var c = [], d = 1; d < arguments.length; d++)
              c[d - 1] = arguments[d];
            this.emit.apply(this, [h, h].concat(c));
          }, u;
        }(s.EventEmitter);
        t.Observer = o;
      },
      "./src/polyfills/number.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/utils/get-self-scope.js"), s = a.getSelfScope(), o = s.Number;
        t.Number = o, o.isFinite = o.isFinite || function(l) {
          return typeof l == "number" && isFinite(l);
        };
      },
      "./src/remux/aac-helper.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = function() {
          function s() {
          }
          return s.getSilentFrame = function(o, l) {
            switch (o) {
              case "mp4a.40.2":
                if (l === 1)
                  return new Uint8Array([0, 200, 0, 128, 35, 128]);
                if (l === 2)
                  return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
                if (l === 3)
                  return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
                if (l === 4)
                  return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
                if (l === 5)
                  return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56]);
                if (l === 6)
                  return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0, 32, 8, 224]);
                break;
              default:
                if (l === 1)
                  return new Uint8Array([1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                if (l === 2)
                  return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                if (l === 3)
                  return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                break;
            }
            return null;
          }, s;
        }();
        t.default = a;
      },
      "./src/remux/mp4-generator.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = Math.pow(2, 32) - 1, s = function() {
          function o() {
          }
          return o.init = function() {
            o.types = {
              avc1: [],
              avcC: [],
              btrt: [],
              dinf: [],
              dref: [],
              esds: [],
              ftyp: [],
              hdlr: [],
              mdat: [],
              mdhd: [],
              mdia: [],
              mfhd: [],
              minf: [],
              moof: [],
              moov: [],
              mp4a: [],
              ".mp3": [],
              mvex: [],
              mvhd: [],
              pasp: [],
              sdtp: [],
              stbl: [],
              stco: [],
              stsc: [],
              stsd: [],
              stsz: [],
              stts: [],
              tfdt: [],
              tfhd: [],
              traf: [],
              trak: [],
              trun: [],
              trex: [],
              tkhd: [],
              vmhd: [],
              smhd: []
            };
            var l;
            for (l in o.types)
              o.types.hasOwnProperty(l) && (o.types[l] = [
                l.charCodeAt(0),
                l.charCodeAt(1),
                l.charCodeAt(2),
                l.charCodeAt(3)
              ]);
            var u = new Uint8Array([
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              118,
              105,
              100,
              101,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              86,
              105,
              100,
              101,
              111,
              72,
              97,
              110,
              100,
              108,
              101,
              114,
              0
            ]), h = new Uint8Array([
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              115,
              111,
              117,
              110,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              83,
              111,
              117,
              110,
              100,
              72,
              97,
              110,
              100,
              108,
              101,
              114,
              0
            ]);
            o.HDLR_TYPES = {
              video: u,
              audio: h
            };
            var c = new Uint8Array([
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              1,
              0,
              0,
              0,
              12,
              117,
              114,
              108,
              32,
              0,
              0,
              0,
              1
            ]), d = new Uint8Array([
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0
            ]);
            o.STTS = o.STSC = o.STCO = d, o.STSZ = new Uint8Array([
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0
            ]), o.VMHD = new Uint8Array([
              0,
              0,
              0,
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0
            ]), o.SMHD = new Uint8Array([
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0
            ]), o.STSD = new Uint8Array([
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              1
            ]);
            var f = new Uint8Array([105, 115, 111, 109]), m = new Uint8Array([97, 118, 99, 49]), p = new Uint8Array([0, 0, 0, 1]);
            o.FTYP = o.box(o.types.ftyp, f, p, f, m), o.DINF = o.box(o.types.dinf, o.box(o.types.dref, c));
          }, o.box = function(l) {
            for (var u = Array.prototype.slice.call(arguments, 1), h = 8, c = u.length, d = c, f; c--; )
              h += u[c].byteLength;
            for (f = new Uint8Array(h), f[0] = h >> 24 & 255, f[1] = h >> 16 & 255, f[2] = h >> 8 & 255, f[3] = h & 255, f.set(l, 4), c = 0, h = 8; c < d; c++)
              f.set(u[c], h), h += u[c].byteLength;
            return f;
          }, o.hdlr = function(l) {
            return o.box(o.types.hdlr, o.HDLR_TYPES[l]);
          }, o.mdat = function(l) {
            return o.box(o.types.mdat, l);
          }, o.mdhd = function(l, u) {
            u *= l;
            var h = Math.floor(u / (a + 1)), c = Math.floor(u % (a + 1));
            return o.box(o.types.mdhd, new Uint8Array([
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              2,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              3,
              l >> 24 & 255,
              l >> 16 & 255,
              l >> 8 & 255,
              l & 255,
              h >> 24,
              h >> 16 & 255,
              h >> 8 & 255,
              h & 255,
              c >> 24,
              c >> 16 & 255,
              c >> 8 & 255,
              c & 255,
              85,
              196,
              0,
              0
            ]));
          }, o.mdia = function(l) {
            return o.box(o.types.mdia, o.mdhd(l.timescale, l.duration), o.hdlr(l.type), o.minf(l));
          }, o.mfhd = function(l) {
            return o.box(o.types.mfhd, new Uint8Array([
              0,
              0,
              0,
              0,
              l >> 24,
              l >> 16 & 255,
              l >> 8 & 255,
              l & 255
            ]));
          }, o.minf = function(l) {
            return l.type === "audio" ? o.box(o.types.minf, o.box(o.types.smhd, o.SMHD), o.DINF, o.stbl(l)) : o.box(o.types.minf, o.box(o.types.vmhd, o.VMHD), o.DINF, o.stbl(l));
          }, o.moof = function(l, u, h) {
            return o.box(o.types.moof, o.mfhd(l), o.traf(h, u));
          }, o.moov = function(l) {
            for (var u = l.length, h = []; u--; )
              h[u] = o.trak(l[u]);
            return o.box.apply(null, [o.types.moov, o.mvhd(l[0].timescale, l[0].duration)].concat(h).concat(o.mvex(l)));
          }, o.mvex = function(l) {
            for (var u = l.length, h = []; u--; )
              h[u] = o.trex(l[u]);
            return o.box.apply(null, [o.types.mvex].concat(h));
          }, o.mvhd = function(l, u) {
            u *= l;
            var h = Math.floor(u / (a + 1)), c = Math.floor(u % (a + 1)), d = new Uint8Array([
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              2,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              3,
              l >> 24 & 255,
              l >> 16 & 255,
              l >> 8 & 255,
              l & 255,
              h >> 24,
              h >> 16 & 255,
              h >> 8 & 255,
              h & 255,
              c >> 24,
              c >> 16 & 255,
              c >> 8 & 255,
              c & 255,
              0,
              1,
              0,
              0,
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              64,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              255,
              255,
              255,
              255
            ]);
            return o.box(o.types.mvhd, d);
          }, o.sdtp = function(l) {
            var u = l.samples || [], h = new Uint8Array(4 + u.length), c, d;
            for (d = 0; d < u.length; d++)
              c = u[d].flags, h[d + 4] = c.dependsOn << 4 | c.isDependedOn << 2 | c.hasRedundancy;
            return o.box(o.types.sdtp, h);
          }, o.stbl = function(l) {
            return o.box(o.types.stbl, o.stsd(l), o.box(o.types.stts, o.STTS), o.box(o.types.stsc, o.STSC), o.box(o.types.stsz, o.STSZ), o.box(o.types.stco, o.STCO));
          }, o.avc1 = function(l) {
            var u = [], h = [], c, d, f;
            for (c = 0; c < l.sps.length; c++)
              d = l.sps[c], f = d.byteLength, u.push(f >>> 8 & 255), u.push(f & 255), u = u.concat(Array.prototype.slice.call(d));
            for (c = 0; c < l.pps.length; c++)
              d = l.pps[c], f = d.byteLength, h.push(f >>> 8 & 255), h.push(f & 255), h = h.concat(Array.prototype.slice.call(d));
            var m = o.box(o.types.avcC, new Uint8Array([
              1,
              u[3],
              u[4],
              u[5],
              255,
              224 | l.sps.length
            ].concat(u).concat([
              l.pps.length
            ]).concat(h))), p = l.width, b = l.height, y = l.pixelRatio[0], v = l.pixelRatio[1];
            return o.box(
              o.types.avc1,
              new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                p >> 8 & 255,
                p & 255,
                b >> 8 & 255,
                b & 255,
                0,
                72,
                0,
                0,
                0,
                72,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                18,
                100,
                97,
                105,
                108,
                121,
                109,
                111,
                116,
                105,
                111,
                110,
                47,
                104,
                108,
                115,
                46,
                106,
                115,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                24,
                17,
                17
              ]),
              m,
              o.box(o.types.btrt, new Uint8Array([
                0,
                28,
                156,
                128,
                0,
                45,
                198,
                192,
                0,
                45,
                198,
                192
              ])),
              o.box(o.types.pasp, new Uint8Array([
                y >> 24,
                y >> 16 & 255,
                y >> 8 & 255,
                y & 255,
                v >> 24,
                v >> 16 & 255,
                v >> 8 & 255,
                v & 255
              ]))
            );
          }, o.esds = function(l) {
            var u = l.config.length;
            return new Uint8Array([
              0,
              0,
              0,
              0,
              3,
              23 + u,
              0,
              1,
              0,
              4,
              15 + u,
              64,
              21,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              5
            ].concat([u]).concat(l.config).concat([6, 1, 2]));
          }, o.mp4a = function(l) {
            var u = l.samplerate;
            return o.box(o.types.mp4a, new Uint8Array([
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              l.channelCount,
              0,
              16,
              0,
              0,
              0,
              0,
              u >> 8 & 255,
              u & 255,
              0,
              0
            ]), o.box(o.types.esds, o.esds(l)));
          }, o.mp3 = function(l) {
            var u = l.samplerate;
            return o.box(o.types[".mp3"], new Uint8Array([
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              l.channelCount,
              0,
              16,
              0,
              0,
              0,
              0,
              u >> 8 & 255,
              u & 255,
              0,
              0
            ]));
          }, o.stsd = function(l) {
            return l.type === "audio" ? !l.isAAC && l.codec === "mp3" ? o.box(o.types.stsd, o.STSD, o.mp3(l)) : o.box(o.types.stsd, o.STSD, o.mp4a(l)) : o.box(o.types.stsd, o.STSD, o.avc1(l));
          }, o.tkhd = function(l) {
            var u = l.id, h = l.duration * l.timescale, c = l.width, d = l.height, f = Math.floor(h / (a + 1)), m = Math.floor(h % (a + 1));
            return o.box(o.types.tkhd, new Uint8Array([
              1,
              0,
              0,
              7,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              2,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              3,
              u >> 24 & 255,
              u >> 16 & 255,
              u >> 8 & 255,
              u & 255,
              0,
              0,
              0,
              0,
              f >> 24,
              f >> 16 & 255,
              f >> 8 & 255,
              f & 255,
              m >> 24,
              m >> 16 & 255,
              m >> 8 & 255,
              m & 255,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              64,
              0,
              0,
              0,
              c >> 8 & 255,
              c & 255,
              0,
              0,
              d >> 8 & 255,
              d & 255,
              0,
              0
            ]));
          }, o.traf = function(l, u) {
            var h = o.sdtp(l), c = l.id, d = Math.floor(u / (a + 1)), f = Math.floor(u % (a + 1));
            return o.box(
              o.types.traf,
              o.box(o.types.tfhd, new Uint8Array([
                0,
                0,
                0,
                0,
                c >> 24,
                c >> 16 & 255,
                c >> 8 & 255,
                c & 255
              ])),
              o.box(o.types.tfdt, new Uint8Array([
                1,
                0,
                0,
                0,
                d >> 24,
                d >> 16 & 255,
                d >> 8 & 255,
                d & 255,
                f >> 24,
                f >> 16 & 255,
                f >> 8 & 255,
                f & 255
              ])),
              o.trun(l, h.length + 16 + 20 + 8 + 16 + 8 + 8),
              h
            );
          }, o.trak = function(l) {
            return l.duration = l.duration || 4294967295, o.box(o.types.trak, o.tkhd(l), o.mdia(l));
          }, o.trex = function(l) {
            var u = l.id;
            return o.box(o.types.trex, new Uint8Array([
              0,
              0,
              0,
              0,
              u >> 24,
              u >> 16 & 255,
              u >> 8 & 255,
              u & 255,
              0,
              0,
              0,
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              1,
              0,
              1
            ]));
          }, o.trun = function(l, u) {
            var h = l.samples || [], c = h.length, d = 12 + 16 * c, f = new Uint8Array(d), m, p, b, y, v, g;
            for (u += 8 + d, f.set([
              0,
              0,
              15,
              1,
              c >>> 24 & 255,
              c >>> 16 & 255,
              c >>> 8 & 255,
              c & 255,
              u >>> 24 & 255,
              u >>> 16 & 255,
              u >>> 8 & 255,
              u & 255
            ], 0), m = 0; m < c; m++)
              p = h[m], b = p.duration, y = p.size, v = p.flags, g = p.cts, f.set([
                b >>> 24 & 255,
                b >>> 16 & 255,
                b >>> 8 & 255,
                b & 255,
                y >>> 24 & 255,
                y >>> 16 & 255,
                y >>> 8 & 255,
                y & 255,
                v.isLeading << 2 | v.dependsOn,
                v.isDependedOn << 6 | v.hasRedundancy << 4 | v.paddingValue << 1 | v.isNonSync,
                v.degradPrio & 240 << 8,
                v.degradPrio & 15,
                g >>> 24 & 255,
                g >>> 16 & 255,
                g >>> 8 & 255,
                g & 255
              ], 12 + 16 * m);
            return o.box(o.types.trun, f);
          }, o.initSegment = function(l) {
            o.types || o.init();
            var u = o.moov(l), h;
            return h = new Uint8Array(o.FTYP.byteLength + u.byteLength), h.set(o.FTYP), h.set(u, o.FTYP.byteLength), h;
          }, o;
        }();
        t.default = s;
      },
      "./src/remux/mp4-remuxer.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/remux/aac-helper.js"), s = n("./src/remux/mp4-generator.js"), o = n("./src/events.js"), l = n("./src/errors.js"), u = n("./src/utils/logger.js"), h = 10 * 1e3, c = function() {
          function d(f, m, p, b) {
            this.observer = f, this.config = m, this.typeSupported = p;
            var y = navigator.userAgent;
            this.isSafari = b && b.indexOf("Apple") > -1 && y && !y.match("CriOS"), this.ISGenerated = !1;
          }
          return d.prototype.destroy = function() {
          }, d.prototype.resetTimeStamp = function(f) {
            this._initPTS = this._initDTS = f;
          }, d.prototype.resetInitSegment = function() {
            this.ISGenerated = !1;
          }, d.prototype.remux = function(f, m, p, b, y, v, g) {
            if (this.ISGenerated || this.generateIS(f, m, y), this.ISGenerated) {
              var E = f.samples.length, x = m.samples.length, w = y, S = y;
              if (E && x) {
                var T = (f.samples[0].pts - m.samples[0].pts) / m.inputTimeScale;
                w += Math.max(0, T), S += Math.max(0, -T);
              }
              if (E) {
                f.timescale || (u.logger.warn("regenerate InitSegment as audio detected"), this.generateIS(f, m, y));
                var C = this.remuxAudio(f, w, v, g);
                if (x) {
                  var D = void 0;
                  C && (D = C.endPTS - C.startPTS), m.timescale || (u.logger.warn("regenerate InitSegment as video detected"), this.generateIS(f, m, y)), this.remuxVideo(m, S, v, D, g);
                }
              } else if (x) {
                var R = this.remuxVideo(m, S, v, 0, g);
                R && f.codec && this.remuxEmptyAudio(f, w, v, R);
              }
            }
            p.samples.length && this.remuxID3(p, y), b.samples.length && this.remuxText(b, y), this.observer.trigger(o.default.FRAG_PARSED);
          }, d.prototype.generateIS = function(f, m, p) {
            var b = this.observer, y = f.samples, v = m.samples, g = this.typeSupported, E = "audio/mp4", x = {}, w = { tracks: x }, S = this._initPTS === void 0, T, C;
            if (S && (T = C = 1 / 0), f.config && y.length && (f.timescale = f.samplerate, u.logger.log("audio sampling rate : " + f.samplerate), f.isAAC || (g.mpeg ? (E = "audio/mpeg", f.codec = "") : g.mp3 && (f.codec = "mp3")), x.audio = {
              container: E,
              codec: f.codec,
              initSegment: !f.isAAC && g.mpeg ? new Uint8Array() : s.default.initSegment([f]),
              metadata: {
                channelCount: f.channelCount
              }
            }, S && (T = C = y[0].pts - f.inputTimeScale * p)), m.sps && m.pps && v.length) {
              var D = m.inputTimeScale;
              m.timescale = D, x.video = {
                container: "video/mp4",
                codec: m.codec,
                initSegment: s.default.initSegment([m]),
                metadata: {
                  width: m.width,
                  height: m.height
                }
              }, S && (T = Math.min(T, v[0].pts - D * p), C = Math.min(C, v[0].dts - D * p), this.observer.trigger(o.default.INIT_PTS_FOUND, { initPTS: T }));
            }
            Object.keys(x).length ? (b.trigger(o.default.FRAG_PARSING_INIT_SEGMENT, w), this.ISGenerated = !0, S && (this._initPTS = T, this._initDTS = C)) : b.trigger(o.default.ERROR, { type: l.ErrorTypes.MEDIA_ERROR, details: l.ErrorDetails.FRAG_PARSING_ERROR, fatal: !1, reason: "no audio/video samples found" });
          }, d.prototype.remuxVideo = function(f, m, p, b, y) {
            var v = 8, g, E, x, w, S, T, C, D = f.timescale, R = f.samples, P = [], N = R.length, $ = this._PTSNormalize, O = this._initPTS, M = this.nextAvcDts, F = this.isSafari;
            if (N !== 0) {
              F && (p |= R.length && M && (y && Math.abs(m - M / D) < 0.1 || Math.abs(R[0].pts - M - O) < D / 5)), p || (M = m * D), R.forEach(function(xr) {
                xr.pts = $(xr.pts - O, M), xr.dts = $(xr.dts - O, M);
              }), R.sort(function(xr, _i) {
                var Gr = xr.dts - _i.dts, li = xr.pts - _i.pts;
                return Gr || li || xr.id - _i.id;
              });
              var G = R.reduce(function(xr, _i) {
                return Math.max(Math.min(xr, _i.pts - _i.dts), -18e3);
              }, 0);
              if (G < 0) {
                u.logger.warn("PTS < DTS detected in video samples, shifting DTS by " + Math.round(G / 90) + " ms to overcome this issue");
                for (var K = 0; K < R.length; K++)
                  R[K].dts += G;
              }
              var J = R[0];
              S = Math.max(J.dts, 0), w = Math.max(J.pts, 0);
              var ue = Math.round((S - M) / 90);
              p && ue && (ue > 1 ? u.logger.log("AVC:" + ue + " ms hole between fragments detected,filling it") : ue < -1 && u.logger.log("AVC:" + -ue + " ms overlapping between fragments detected"), S = M, R[0].dts = S, w = Math.max(w - ue, M), R[0].pts = w, u.logger.log("Video/PTS/DTS adjusted: " + Math.round(w / 90) + "/" + Math.round(S / 90) + ",delta:" + ue + " ms")), J = R[R.length - 1], C = Math.max(J.dts, 0), T = Math.max(J.pts, 0, C), F && (g = Math.round((C - S) / (R.length - 1)));
              for (var ce = 0, ee = 0, K = 0; K < N; K++) {
                for (var me = R[K], Ce = me.units, Ne = Ce.length, ot = 0, ze = 0; ze < Ne; ze++)
                  ot += Ce[ze].data.length;
                ee += ot, ce += Ne, me.length = ot, F ? me.dts = S + K * g : me.dts = Math.max(me.dts, S), me.pts = Math.max(me.pts, me.dts);
              }
              var $e = ee + 4 * ce + 8;
              try {
                E = new Uint8Array($e);
              } catch {
                this.observer.trigger(o.default.ERROR, { type: l.ErrorTypes.MUX_ERROR, details: l.ErrorDetails.REMUX_ALLOC_ERROR, fatal: !1, bytes: $e, reason: "fail allocating video mdat " + $e });
                return;
              }
              var Ze = new DataView(E.buffer);
              Ze.setUint32(0, $e), E.set(s.default.types.mdat, 4);
              for (var K = 0; K < N; K++) {
                for (var Ut = R[K], qt = Ut.units, ir = 0, We = void 0, ze = 0, Ne = qt.length; ze < Ne; ze++) {
                  var vt = qt[ze], Tt = vt.data, xt = vt.data.byteLength;
                  Ze.setUint32(v, xt), v += 4, E.set(Tt, v), v += xt, ir += 4 + xt;
                }
                if (F)
                  We = Math.max(0, g * Math.round((Ut.pts - Ut.dts) / g));
                else {
                  if (K < N - 1)
                    g = R[K + 1].dts - Ut.dts;
                  else {
                    var Pt = this.config, at = Ut.dts - R[K > 0 ? K - 1 : K].dts;
                    if (Pt.stretchShortVideoTrack) {
                      var Ot = Pt.maxBufferHole, It = Math.floor(Ot * D), sr = (b ? w + b * D : this.nextAudioPts) - Ut.pts;
                      sr > It ? (g = sr - at, g < 0 && (g = at), u.logger.log("It is approximately " + sr / 90 + " ms to the next segment; using duration " + g / 90 + " ms for the last video frame.")) : g = at;
                    } else
                      g = at;
                  }
                  We = Math.round(Ut.pts - Ut.dts);
                }
                P.push({
                  size: ir,
                  duration: g,
                  cts: We,
                  flags: {
                    isLeading: 0,
                    isDependedOn: 0,
                    hasRedundancy: 0,
                    degradPrio: 0,
                    dependsOn: Ut.key ? 2 : 1,
                    isNonSync: Ut.key ? 0 : 1
                  }
                });
              }
              this.nextAvcDts = C + g;
              var lt = f.dropped;
              if (f.len = 0, f.nbNalu = 0, f.dropped = 0, P.length && navigator.userAgent.toLowerCase().indexOf("chrome") > -1) {
                var ri = P[0].flags;
                ri.dependsOn = 2, ri.isNonSync = 0;
              }
              f.samples = P, x = s.default.moof(f.sequenceNumber++, S, f), f.samples = [];
              var Qr = {
                data1: x,
                data2: E,
                startPTS: w / D,
                endPTS: (T + g) / D,
                startDTS: S / D,
                endDTS: this.nextAvcDts / D,
                type: "video",
                hasAudio: !1,
                hasVideo: !0,
                nb: P.length,
                dropped: lt
              };
              return this.observer.trigger(o.default.FRAG_PARSING_DATA, Qr), Qr;
            }
          }, d.prototype.remuxAudio = function(f, m, p, b) {
            var y = f.inputTimeScale, v = f.timescale, g = y / v, E = f.isAAC ? 1024 : 1152, x = E * g, w = this._PTSNormalize, S = this._initPTS, T = !f.isAAC && this.typeSupported.mpeg, C, D, R, P, N, $, O, M = f.samples, F = [], G = this.nextAudioPts;
            if (p |= M.length && G && (b && Math.abs(m - G / y) < 0.1 || Math.abs(M[0].pts - G - S) < 20 * x), M.forEach(function(sr) {
              sr.pts = sr.dts = w(sr.pts - S, m * y);
            }), M = M.filter(function(sr) {
              return sr.pts >= 0;
            }), M.length !== 0) {
              if (p || (b ? G = m * y : G = M[0].pts), f.isAAC)
                for (var K = this.config.maxAudioFramesDrift, J = 0, ue = G; J < M.length; ) {
                  var ce = M[J], ee, me = ce.pts;
                  ee = me - ue;
                  var Ce = Math.abs(1e3 * ee / y);
                  if (ee <= -K * x)
                    u.logger.warn("Dropping 1 audio frame @ " + (ue / y).toFixed(3) + "s due to " + Math.round(Ce) + " ms overlap."), M.splice(J, 1), f.len -= ce.unit.length;
                  else if (ee >= K * x && Ce < h && ue) {
                    var Ne = Math.round(ee / x);
                    u.logger.warn("Injecting " + Ne + " audio frame @ " + (ue / y).toFixed(3) + "s due to " + Math.round(1e3 * ee / y) + " ms gap.");
                    for (var ot = 0; ot < Ne; ot++) {
                      var ze = Math.max(ue, 0);
                      R = a.default.getSilentFrame(f.manifestCodec || f.codec, f.channelCount), R || (u.logger.log("Unable to get silent frame for given audio codec; duplicating last frame instead."), R = ce.unit.subarray()), M.splice(J, 0, { unit: R, pts: ze, dts: ze }), f.len += R.length, ue += x, J++;
                    }
                    ce.pts = ce.dts = ue, ue += x, J++;
                  } else
                    ce.pts = ce.dts = ue, ue += x, J++;
                }
              for (var ot = 0, $e = M.length; ot < $e; ot++) {
                var Ze = M[ot], Ut = Ze.unit, me = Ze.pts;
                if (O !== void 0)
                  D.duration = Math.round((me - O) / g);
                else {
                  var qt = Math.round(1e3 * (me - G) / y), ir = 0;
                  if (p && f.isAAC && qt) {
                    if (qt > 0 && qt < h)
                      ir = Math.round((me - G) / x), u.logger.log(qt + " ms hole between AAC samples detected,filling it"), ir > 0 && (R = a.default.getSilentFrame(f.manifestCodec || f.codec, f.channelCount), R || (R = Ut.subarray()), f.len += ir * R.length);
                    else if (qt < -12) {
                      u.logger.log("drop overlapping AAC sample, expected/parsed/delta:" + (G / y).toFixed(3) + "s/" + (me / y).toFixed(3) + "s/" + -qt + "ms"), f.len -= Ut.byteLength;
                      continue;
                    }
                    me = G;
                  }
                  if ($ = me, f.len > 0) {
                    var We = T ? f.len : f.len + 8;
                    C = T ? 0 : 8;
                    try {
                      P = new Uint8Array(We);
                    } catch {
                      this.observer.trigger(o.default.ERROR, { type: l.ErrorTypes.MUX_ERROR, details: l.ErrorDetails.REMUX_ALLOC_ERROR, fatal: !1, bytes: We, reason: "fail allocating audio mdat " + We });
                      return;
                    }
                    if (!T) {
                      var vt = new DataView(P.buffer);
                      vt.setUint32(0, We), P.set(s.default.types.mdat, 4);
                    }
                  } else
                    return;
                  for (var J = 0; J < ir; J++)
                    R = a.default.getSilentFrame(f.manifestCodec || f.codec, f.channelCount), R || (u.logger.log("Unable to get silent frame for given audio codec; duplicating this frame instead."), R = Ut.subarray()), P.set(R, C), C += R.byteLength, D = {
                      size: R.byteLength,
                      cts: 0,
                      duration: 1024,
                      flags: {
                        isLeading: 0,
                        isDependedOn: 0,
                        hasRedundancy: 0,
                        degradPrio: 0,
                        dependsOn: 1
                      }
                    }, F.push(D);
                }
                P.set(Ut, C);
                var Tt = Ut.byteLength;
                C += Tt, D = {
                  size: Tt,
                  cts: 0,
                  duration: 0,
                  flags: {
                    isLeading: 0,
                    isDependedOn: 0,
                    hasRedundancy: 0,
                    degradPrio: 0,
                    dependsOn: 1
                  }
                }, F.push(D), O = me;
              }
              var xt = 0, Pt = F.length;
              if (Pt >= 2 && (xt = F[Pt - 2].duration, D.duration = xt), Pt) {
                this.nextAudioPts = G = O + g * xt, f.len = 0, f.samples = F, T ? N = new Uint8Array() : N = s.default.moof(f.sequenceNumber++, $ / g, f), f.samples = [];
                var at = $ / y, Ot = G / y, It = {
                  data1: N,
                  data2: P,
                  startPTS: at,
                  endPTS: Ot,
                  startDTS: at,
                  endDTS: Ot,
                  type: "audio",
                  hasAudio: !0,
                  hasVideo: !1,
                  nb: Pt
                };
                return this.observer.trigger(o.default.FRAG_PARSING_DATA, It), It;
              }
              return null;
            }
          }, d.prototype.remuxEmptyAudio = function(f, m, p, b) {
            var y = f.inputTimeScale, v = f.samplerate ? f.samplerate : y, g = y / v, E = this.nextAudioPts, x = (E !== void 0 ? E : b.startDTS * y) + this._initDTS, w = b.endDTS * y + this._initDTS, S = 1024, T = g * S, C = Math.ceil((w - x) / T), D = a.default.getSilentFrame(f.manifestCodec || f.codec, f.channelCount);
            if (u.logger.warn("remux empty Audio"), !D) {
              u.logger.trace("Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec!");
              return;
            }
            for (var R = [], P = 0; P < C; P++) {
              var N = x + P * T;
              R.push({ unit: D, pts: N, dts: N }), f.len += D.length;
            }
            f.samples = R, this.remuxAudio(f, m, p);
          }, d.prototype.remuxID3 = function(f) {
            var m = f.samples.length, p, b = f.inputTimeScale, y = this._initPTS, v = this._initDTS;
            if (m) {
              for (var g = 0; g < m; g++)
                p = f.samples[g], p.pts = (p.pts - y) / b, p.dts = (p.dts - v) / b;
              this.observer.trigger(o.default.FRAG_PARSING_METADATA, {
                samples: f.samples
              });
            }
            f.samples = [];
          }, d.prototype.remuxText = function(f) {
            f.samples.sort(function(g, E) {
              return g.pts - E.pts;
            });
            var m = f.samples.length, p, b = f.inputTimeScale, y = this._initPTS;
            if (m) {
              for (var v = 0; v < m; v++)
                p = f.samples[v], p.pts = (p.pts - y) / b;
              this.observer.trigger(o.default.FRAG_PARSING_USERDATA, {
                samples: f.samples
              });
            }
            f.samples = [];
          }, d.prototype._PTSNormalize = function(f, m) {
            var p;
            if (m === void 0)
              return f;
            for (m < f ? p = -8589934592 : p = 8589934592; Math.abs(f - m) > 4294967296; )
              f += p;
            return f;
          }, d;
        }();
        t.default = c;
      },
      "./src/remux/passthrough-remuxer.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/events.js"), s = function() {
          function o(l) {
            this.observer = l;
          }
          return o.prototype.destroy = function() {
          }, o.prototype.resetTimeStamp = function() {
          }, o.prototype.resetInitSegment = function() {
          }, o.prototype.remux = function(l, u, h, c, d, f, m, p) {
            var b = this.observer, y = "";
            l && (y += "audio"), u && (y += "video"), b.trigger(a.default.FRAG_PARSING_DATA, {
              data1: p,
              startPTS: d,
              startDTS: d,
              type: y,
              hasAudio: !!l,
              hasVideo: !!u,
              nb: 1,
              dropped: 0
            }), b.trigger(a.default.FRAG_PARSED);
          }, o;
        }();
        t.default = s;
      },
      "./src/task-loop.js": function(i, t, n) {
        var a = this && this.__extends || function() {
          var l = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, h) {
            u.__proto__ = h;
          } || function(u, h) {
            for (var c in h)
              h.hasOwnProperty(c) && (u[c] = h[c]);
          };
          return function(u, h) {
            l(u, h);
            function c() {
              this.constructor = u;
            }
            u.prototype = h === null ? Object.create(h) : (c.prototype = h.prototype, new c());
          };
        }();
        Object.defineProperty(t, "__esModule", { value: !0 });
        var s = n("./src/event-handler.js"), o = function(l) {
          a(u, l);
          function u(h) {
            for (var c = [], d = 1; d < arguments.length; d++)
              c[d - 1] = arguments[d];
            var f = l.apply(this, [h].concat(c)) || this;
            return f._tickInterval = null, f._tickTimer = null, f._tickCallCount = 0, f._boundTick = f.tick.bind(f), f;
          }
          return u.prototype.onHandlerDestroying = function() {
            this.clearNextTick(), this.clearInterval();
          }, u.prototype.hasInterval = function() {
            return !!this._tickInterval;
          }, u.prototype.hasNextTick = function() {
            return !!this._tickTimer;
          }, u.prototype.setInterval = function(h) {
            return this._tickInterval ? !1 : (this._tickInterval = setInterval(this._boundTick, h), !0);
          }, u.prototype.clearInterval = function() {
            return this._tickInterval ? (clearInterval(this._tickInterval), this._tickInterval = null, !0) : !1;
          }, u.prototype.clearNextTick = function() {
            return this._tickTimer ? (clearTimeout(this._tickTimer), this._tickTimer = null, !0) : !1;
          }, u.prototype.tick = function() {
            this._tickCallCount++, this._tickCallCount === 1 && (this.doTick(), this._tickCallCount > 1 && (this.clearNextTick(), this._tickTimer = setTimeout(this._boundTick, 0)), this._tickCallCount = 0);
          }, u.prototype.doTick = function() {
          }, u;
        }(s.default);
        t.default = o;
      },
      "./src/utils/attr-list.js": function(i, t, n) {
        (function(a) {
          Object.defineProperty(t, "__esModule", { value: !0 });
          var s = /^(\d+)x(\d+)$/, o = /\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g, l = function() {
            function u(h) {
              typeof h == "string" && (h = u.parseAttrList(h));
              for (var c in h)
                h.hasOwnProperty(c) && (this[c] = h[c]);
            }
            return u.prototype.decimalInteger = function(h) {
              var c = parseInt(this[h], 10);
              return c > a.MAX_SAFE_INTEGER ? 1 / 0 : c;
            }, u.prototype.hexadecimalInteger = function(h) {
              if (this[h]) {
                var c = (this[h] || "0x").slice(2);
                c = (c.length & 1 ? "0" : "") + c;
                for (var d = new Uint8Array(c.length / 2), f = 0; f < c.length / 2; f++)
                  d[f] = parseInt(c.slice(f * 2, f * 2 + 2), 16);
                return d;
              } else
                return null;
            }, u.prototype.hexadecimalIntegerAsNumber = function(h) {
              var c = parseInt(this[h], 16);
              return c > a.MAX_SAFE_INTEGER ? 1 / 0 : c;
            }, u.prototype.decimalFloatingPoint = function(h) {
              return parseFloat(this[h]);
            }, u.prototype.enumeratedString = function(h) {
              return this[h];
            }, u.prototype.decimalResolution = function(h) {
              var c = s.exec(this[h]);
              if (c !== null)
                return {
                  width: parseInt(c[1], 10),
                  height: parseInt(c[2], 10)
                };
            }, u.parseAttrList = function(h) {
              var c, d = {};
              for (o.lastIndex = 0; (c = o.exec(h)) !== null; ) {
                var f = c[2], m = '"';
                f.indexOf(m) === 0 && f.lastIndexOf(m) === f.length - 1 && (f = f.slice(1, -1)), d[c[1]] = f;
              }
              return d;
            }, u;
          }();
          t.default = l;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/utils/binary-search.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = {
          search: function(s, o) {
            for (var l = 0, u = s.length - 1, h = null, c = null; l <= u; ) {
              h = (l + u) / 2 | 0, c = s[h];
              var d = o(c);
              if (d > 0)
                l = h + 1;
              else if (d < 0)
                u = h - 1;
              else
                return c;
            }
            return null;
          }
        };
        t.default = a;
      },
      "./src/utils/buffer-helper.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = function() {
          function s() {
          }
          return s.isBuffered = function(o, l) {
            try {
              if (o) {
                for (var u = o.buffered, h = 0; h < u.length; h++)
                  if (l >= u.start(h) && l <= u.end(h))
                    return !0;
              }
            } catch {
            }
            return !1;
          }, s.bufferInfo = function(o, l, u) {
            try {
              if (o) {
                var h = o.buffered, c = [], d = void 0;
                for (d = 0; d < h.length; d++)
                  c.push({ start: h.start(d), end: h.end(d) });
                return this.bufferedInfo(c, l, u);
              }
            } catch {
            }
            return { len: 0, start: l, end: l, nextStart: void 0 };
          }, s.bufferedInfo = function(o, l, u) {
            var h = [], c, d, f, m, p;
            for (o.sort(function(E, x) {
              var w = E.start - x.start;
              return w || x.end - E.end;
            }), p = 0; p < o.length; p++) {
              var b = h.length;
              if (b) {
                var y = h[b - 1].end;
                o[p].start - y < u ? o[p].end > y && (h[b - 1].end = o[p].end) : h.push(o[p]);
              } else
                h.push(o[p]);
            }
            for (p = 0, c = 0, d = f = l; p < h.length; p++) {
              var v = h[p].start, g = h[p].end;
              if (l + u >= v && l < g)
                d = v, f = g, c = f - l;
              else if (l + u < v) {
                m = v;
                break;
              }
            }
            return { len: c, start: d, end: f, nextStart: m };
          }, s;
        }();
        t.BufferHelper = a;
      },
      "./src/utils/cea-608-parser.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = {
          42: 225,
          92: 233,
          94: 237,
          95: 243,
          96: 250,
          123: 231,
          124: 247,
          125: 209,
          126: 241,
          127: 9608,
          128: 174,
          129: 176,
          130: 189,
          131: 191,
          132: 8482,
          133: 162,
          134: 163,
          135: 9834,
          136: 224,
          137: 32,
          138: 232,
          139: 226,
          140: 234,
          141: 238,
          142: 244,
          143: 251,
          144: 193,
          145: 201,
          146: 211,
          147: 218,
          148: 220,
          149: 252,
          150: 8216,
          151: 161,
          152: 42,
          153: 8217,
          154: 9473,
          155: 169,
          156: 8480,
          157: 8226,
          158: 8220,
          159: 8221,
          160: 192,
          161: 194,
          162: 199,
          163: 200,
          164: 202,
          165: 203,
          166: 235,
          167: 206,
          168: 207,
          169: 239,
          170: 212,
          171: 217,
          172: 249,
          173: 219,
          174: 171,
          175: 187,
          176: 195,
          177: 227,
          178: 205,
          179: 204,
          180: 236,
          181: 210,
          182: 242,
          183: 213,
          184: 245,
          185: 123,
          186: 125,
          187: 92,
          188: 94,
          189: 95,
          190: 124,
          191: 8764,
          192: 196,
          193: 228,
          194: 214,
          195: 246,
          196: 223,
          197: 165,
          198: 164,
          199: 9475,
          200: 197,
          201: 229,
          202: 216,
          203: 248,
          204: 9487,
          205: 9491,
          206: 9495,
          207: 9499
        }, s = function(w) {
          var S = w;
          return a.hasOwnProperty(w) && (S = a[w]), String.fromCharCode(S);
        }, o = 15, l = 100, u = { 17: 1, 18: 3, 21: 5, 22: 7, 23: 9, 16: 11, 19: 12, 20: 14 }, h = { 17: 2, 18: 4, 21: 6, 22: 8, 23: 10, 19: 13, 20: 15 }, c = { 25: 1, 26: 3, 29: 5, 30: 7, 31: 9, 24: 11, 27: 12, 28: 14 }, d = { 25: 2, 26: 4, 29: 6, 30: 8, 31: 10, 27: 13, 28: 15 }, f = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"], m = {
          verboseFilter: { DATA: 3, DEBUG: 3, INFO: 2, WARNING: 2, TEXT: 1, ERROR: 0 },
          time: null,
          verboseLevel: 0,
          setTime: function(w) {
            this.time = w;
          },
          log: function(w, S) {
            var T = this.verboseFilter[w];
            this.verboseLevel >= T;
          }
        }, p = function(w) {
          for (var S = [], T = 0; T < w.length; T++)
            S.push(w[T].toString(16));
          return S;
        }, b = function() {
          function w(S, T, C, D, R) {
            this.foreground = S || "white", this.underline = T || !1, this.italics = C || !1, this.background = D || "black", this.flash = R || !1;
          }
          return w.prototype.reset = function() {
            this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
          }, w.prototype.setStyles = function(S) {
            for (var T = ["foreground", "underline", "italics", "background", "flash"], C = 0; C < T.length; C++) {
              var D = T[C];
              S.hasOwnProperty(D) && (this[D] = S[D]);
            }
          }, w.prototype.isDefault = function() {
            return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
          }, w.prototype.equals = function(S) {
            return this.foreground === S.foreground && this.underline === S.underline && this.italics === S.italics && this.background === S.background && this.flash === S.flash;
          }, w.prototype.copy = function(S) {
            this.foreground = S.foreground, this.underline = S.underline, this.italics = S.italics, this.background = S.background, this.flash = S.flash;
          }, w.prototype.toString = function() {
            return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
          }, w;
        }(), y = function() {
          function w(S, T, C, D, R, P) {
            this.uchar = S || " ", this.penState = new b(T, C, D, R, P);
          }
          return w.prototype.reset = function() {
            this.uchar = " ", this.penState.reset();
          }, w.prototype.setChar = function(S, T) {
            this.uchar = S, this.penState.copy(T);
          }, w.prototype.setPenState = function(S) {
            this.penState.copy(S);
          }, w.prototype.equals = function(S) {
            return this.uchar === S.uchar && this.penState.equals(S.penState);
          }, w.prototype.copy = function(S) {
            this.uchar = S.uchar, this.penState.copy(S.penState);
          }, w.prototype.isEmpty = function() {
            return this.uchar === " " && this.penState.isDefault();
          }, w;
        }(), v = function() {
          function w() {
            this.chars = [];
            for (var S = 0; S < l; S++)
              this.chars.push(new y());
            this.pos = 0, this.currPenState = new b();
          }
          return w.prototype.equals = function(S) {
            for (var T = !0, C = 0; C < l; C++)
              if (!this.chars[C].equals(S.chars[C])) {
                T = !1;
                break;
              }
            return T;
          }, w.prototype.copy = function(S) {
            for (var T = 0; T < l; T++)
              this.chars[T].copy(S.chars[T]);
          }, w.prototype.isEmpty = function() {
            for (var S = !0, T = 0; T < l; T++)
              if (!this.chars[T].isEmpty()) {
                S = !1;
                break;
              }
            return S;
          }, w.prototype.setCursor = function(S) {
            this.pos !== S && (this.pos = S), this.pos < 0 ? (m.log("ERROR", "Negative cursor position " + this.pos), this.pos = 0) : this.pos > l && (m.log("ERROR", "Too large cursor position " + this.pos), this.pos = l);
          }, w.prototype.moveCursor = function(S) {
            var T = this.pos + S;
            if (S > 1)
              for (var C = this.pos + 1; C < T + 1; C++)
                this.chars[C].setPenState(this.currPenState);
            this.setCursor(T);
          }, w.prototype.backSpace = function() {
            this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
          }, w.prototype.insertChar = function(S) {
            S >= 144 && this.backSpace();
            var T = s(S);
            if (this.pos >= l) {
              m.log("ERROR", "Cannot insert " + S.toString(16) + " (" + T + ") at position " + this.pos + ". Skipping it!");
              return;
            }
            this.chars[this.pos].setChar(T, this.currPenState), this.moveCursor(1);
          }, w.prototype.clearFromPos = function(S) {
            var T;
            for (T = S; T < l; T++)
              this.chars[T].reset();
          }, w.prototype.clear = function() {
            this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
          }, w.prototype.clearToEndOfRow = function() {
            this.clearFromPos(this.pos);
          }, w.prototype.getTextString = function() {
            for (var S = [], T = !0, C = 0; C < l; C++) {
              var D = this.chars[C].uchar;
              D !== " " && (T = !1), S.push(D);
            }
            return T ? "" : S.join("");
          }, w.prototype.setPenStyles = function(S) {
            this.currPenState.setStyles(S);
            var T = this.chars[this.pos];
            T.setPenState(this.currPenState);
          }, w;
        }(), g = function() {
          function w() {
            this.rows = [];
            for (var S = 0; S < o; S++)
              this.rows.push(new v());
            this.currRow = o - 1, this.nrRollUpRows = null, this.reset();
          }
          return w.prototype.reset = function() {
            for (var S = 0; S < o; S++)
              this.rows[S].clear();
            this.currRow = o - 1;
          }, w.prototype.equals = function(S) {
            for (var T = !0, C = 0; C < o; C++)
              if (!this.rows[C].equals(S.rows[C])) {
                T = !1;
                break;
              }
            return T;
          }, w.prototype.copy = function(S) {
            for (var T = 0; T < o; T++)
              this.rows[T].copy(S.rows[T]);
          }, w.prototype.isEmpty = function() {
            for (var S = !0, T = 0; T < o; T++)
              if (!this.rows[T].isEmpty()) {
                S = !1;
                break;
              }
            return S;
          }, w.prototype.backSpace = function() {
            var S = this.rows[this.currRow];
            S.backSpace();
          }, w.prototype.clearToEndOfRow = function() {
            var S = this.rows[this.currRow];
            S.clearToEndOfRow();
          }, w.prototype.insertChar = function(S) {
            var T = this.rows[this.currRow];
            T.insertChar(S);
          }, w.prototype.setPen = function(S) {
            var T = this.rows[this.currRow];
            T.setPenStyles(S);
          }, w.prototype.moveCursor = function(S) {
            var T = this.rows[this.currRow];
            T.moveCursor(S);
          }, w.prototype.setCursor = function(S) {
            m.log("INFO", "setCursor: " + S);
            var T = this.rows[this.currRow];
            T.setCursor(S);
          }, w.prototype.setPAC = function(S) {
            m.log("INFO", "pacData = " + JSON.stringify(S));
            var T = S.row - 1;
            if (this.nrRollUpRows && T < this.nrRollUpRows - 1 && (T = this.nrRollUpRows - 1), this.nrRollUpRows && this.currRow !== T) {
              for (var C = 0; C < o; C++)
                this.rows[C].clear();
              var D = this.currRow + 1 - this.nrRollUpRows, R = this.lastOutputScreen;
              if (R) {
                var P = R.rows[D].cueStartTime;
                if (P && P < m.time)
                  for (var C = 0; C < this.nrRollUpRows; C++)
                    this.rows[T - this.nrRollUpRows + C + 1].copy(R.rows[D + C]);
              }
            }
            this.currRow = T;
            var N = this.rows[this.currRow];
            if (S.indent !== null) {
              var $ = S.indent, O = Math.max($ - 1, 0);
              N.setCursor(S.indent), S.color = N.chars[O].penState.foreground;
            }
            var M = { foreground: S.color, underline: S.underline, italics: S.italics, background: "black", flash: !1 };
            this.setPen(M);
          }, w.prototype.setBkgData = function(S) {
            m.log("INFO", "bkgData = " + JSON.stringify(S)), this.backSpace(), this.setPen(S), this.insertChar(32);
          }, w.prototype.setRollUpRows = function(S) {
            this.nrRollUpRows = S;
          }, w.prototype.rollUp = function() {
            if (this.nrRollUpRows === null) {
              m.log("DEBUG", "roll_up but nrRollUpRows not set yet");
              return;
            }
            m.log("TEXT", this.getDisplayText());
            var S = this.currRow + 1 - this.nrRollUpRows, T = this.rows.splice(S, 1)[0];
            T.clear(), this.rows.splice(this.currRow, 0, T), m.log("INFO", "Rolling up");
          }, w.prototype.getDisplayText = function(S) {
            S = S || !1;
            for (var T = [], C = "", D = -1, R = 0; R < o; R++) {
              var P = this.rows[R].getTextString();
              P && (D = R + 1, S ? T.push("Row " + D + ": '" + P + "'") : T.push(P.trim()));
            }
            return T.length > 0 && (S ? C = "[" + T.join(" | ") + "]" : C = T.join(`
`)), C;
          }, w.prototype.getTextAndFormat = function() {
            return this.rows;
          }, w;
        }(), E = function() {
          function w(S, T) {
            this.chNr = S, this.outputFilter = T, this.mode = null, this.verbose = 0, this.displayedMemory = new g(), this.nonDisplayedMemory = new g(), this.lastOutputScreen = new g(), this.currRollUpRow = this.displayedMemory.rows[o - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
          }
          return w.prototype.reset = function() {
            this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.currRollUpRow = this.displayedMemory.rows[o - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.lastCueEndTime = null;
          }, w.prototype.getHandler = function() {
            return this.outputFilter;
          }, w.prototype.setHandler = function(S) {
            this.outputFilter = S;
          }, w.prototype.setPAC = function(S) {
            this.writeScreen.setPAC(S);
          }, w.prototype.setBkgData = function(S) {
            this.writeScreen.setBkgData(S);
          }, w.prototype.setMode = function(S) {
            S !== this.mode && (this.mode = S, m.log("INFO", "MODE=" + S), this.mode === "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = S);
          }, w.prototype.insertChars = function(S) {
            for (var T = 0; T < S.length; T++)
              this.writeScreen.insertChar(S[T]);
            var C = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
            m.log("INFO", C + ": " + this.writeScreen.getDisplayText(!0)), (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") && (m.log("TEXT", "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
          }, w.prototype.ccRCL = function() {
            m.log("INFO", "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
          }, w.prototype.ccBS = function() {
            m.log("INFO", "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
          }, w.prototype.ccAOF = function() {
          }, w.prototype.ccAON = function() {
          }, w.prototype.ccDER = function() {
            m.log("INFO", "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
          }, w.prototype.ccRU = function(S) {
            m.log("INFO", "RU(" + S + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(S);
          }, w.prototype.ccFON = function() {
            m.log("INFO", "FON - Flash On"), this.writeScreen.setPen({ flash: !0 });
          }, w.prototype.ccRDC = function() {
            m.log("INFO", "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
          }, w.prototype.ccTR = function() {
            m.log("INFO", "TR"), this.setMode("MODE_TEXT");
          }, w.prototype.ccRTD = function() {
            m.log("INFO", "RTD"), this.setMode("MODE_TEXT");
          }, w.prototype.ccEDM = function() {
            m.log("INFO", "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate(!0);
          }, w.prototype.ccCR = function() {
            m.log("CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate(!0);
          }, w.prototype.ccENM = function() {
            m.log("INFO", "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
          }, w.prototype.ccEOC = function() {
            if (m.log("INFO", "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
              var S = this.displayedMemory;
              this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = S, this.writeScreen = this.nonDisplayedMemory, m.log("TEXT", "DISP: " + this.displayedMemory.getDisplayText());
            }
            this.outputDataUpdate(!0);
          }, w.prototype.ccTO = function(S) {
            m.log("INFO", "TO(" + S + ") - Tab Offset"), this.writeScreen.moveCursor(S);
          }, w.prototype.ccMIDROW = function(S) {
            var T = { flash: !1 };
            if (T.underline = S % 2 === 1, T.italics = S >= 46, T.italics)
              T.foreground = "white";
            else {
              var C = Math.floor(S / 2) - 16, D = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"];
              T.foreground = D[C];
            }
            m.log("INFO", "MIDROW: " + JSON.stringify(T)), this.writeScreen.setPen(T);
          }, w.prototype.outputDataUpdate = function(S) {
            S === void 0 && (S = !1);
            var T = m.time;
            T !== null && this.outputFilter && (this.cueStartTime === null && !this.displayedMemory.isEmpty() ? this.cueStartTime = T : this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue && (this.outputFilter.newCue(this.cueStartTime, T, this.lastOutputScreen), S === !0 && this.outputFilter.dispatchCue && this.outputFilter.dispatchCue()), this.cueStartTime = this.displayedMemory.isEmpty() ? null : T), this.lastOutputScreen.copy(this.displayedMemory));
          }, w.prototype.cueSplitAtTime = function(S) {
            this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, S, this.displayedMemory), this.cueStartTime = S));
          }, w;
        }(), x = function() {
          function w(S, T, C) {
            this.field = S || 1, this.outputs = [T, C], this.channels = [new E(1, T), new E(2, C)], this.currChNr = -1, this.lastCmdA = null, this.lastCmdB = null, this.bufferedData = [], this.startTime = null, this.lastTime = null, this.dataCounters = { padding: 0, char: 0, cmd: 0, other: 0 };
          }
          return w.prototype.getHandler = function(S) {
            return this.channels[S].getHandler();
          }, w.prototype.setHandler = function(S, T) {
            this.channels[S].setHandler(T);
          }, w.prototype.addData = function(S, T) {
            var C, D, R, P = !1;
            this.lastTime = S, m.setTime(S);
            for (var N = 0; N < T.length; N += 2) {
              if (D = T[N] & 127, R = T[N + 1] & 127, D === 0 && R === 0) {
                this.dataCounters.padding += 2;
                continue;
              } else
                m.log("DATA", "[" + p([T[N], T[N + 1]]) + "] -> (" + p([D, R]) + ")");
              if (C = this.parseCmd(D, R), C || (C = this.parseMidrow(D, R)), C || (C = this.parsePAC(D, R)), C || (C = this.parseBackgroundAttributes(D, R)), !C && (P = this.parseChars(D, R), P))
                if (this.currChNr && this.currChNr >= 0) {
                  var $ = this.channels[this.currChNr - 1];
                  $.insertChars(P);
                } else
                  m.log("WARNING", "No channel found yet. TEXT-MODE?");
              C ? this.dataCounters.cmd += 2 : P ? this.dataCounters.char += 2 : (this.dataCounters.other += 2, m.log("WARNING", "Couldn't parse cleaned data " + p([D, R]) + " orig: " + p([T[N], T[N + 1]])));
            }
          }, w.prototype.parseCmd = function(S, T) {
            var C = null, D = (S === 20 || S === 28) && T >= 32 && T <= 47, R = (S === 23 || S === 31) && T >= 33 && T <= 35;
            if (!(D || R))
              return !1;
            if (S === this.lastCmdA && T === this.lastCmdB)
              return this.lastCmdA = null, this.lastCmdB = null, m.log("DEBUG", "Repeated command (" + p([S, T]) + ") is dropped"), !0;
            S === 20 || S === 23 ? C = 1 : C = 2;
            var P = this.channels[C - 1];
            return S === 20 || S === 28 ? T === 32 ? P.ccRCL() : T === 33 ? P.ccBS() : T === 34 ? P.ccAOF() : T === 35 ? P.ccAON() : T === 36 ? P.ccDER() : T === 37 ? P.ccRU(2) : T === 38 ? P.ccRU(3) : T === 39 ? P.ccRU(4) : T === 40 ? P.ccFON() : T === 41 ? P.ccRDC() : T === 42 ? P.ccTR() : T === 43 ? P.ccRTD() : T === 44 ? P.ccEDM() : T === 45 ? P.ccCR() : T === 46 ? P.ccENM() : T === 47 && P.ccEOC() : P.ccTO(T - 32), this.lastCmdA = S, this.lastCmdB = T, this.currChNr = C, !0;
          }, w.prototype.parseMidrow = function(S, T) {
            var C = null;
            if ((S === 17 || S === 25) && T >= 32 && T <= 47) {
              if (S === 17 ? C = 1 : C = 2, C !== this.currChNr)
                return m.log("ERROR", "Mismatch channel in midrow parsing"), !1;
              var D = this.channels[C - 1];
              return D.ccMIDROW(T), m.log("DEBUG", "MIDROW (" + p([S, T]) + ")"), !0;
            }
            return !1;
          }, w.prototype.parsePAC = function(S, T) {
            var C = null, D = null, R = (S >= 17 && S <= 23 || S >= 25 && S <= 31) && T >= 64 && T <= 127, P = (S === 16 || S === 24) && T >= 64 && T <= 95;
            if (!(R || P))
              return !1;
            if (S === this.lastCmdA && T === this.lastCmdB)
              return this.lastCmdA = null, this.lastCmdB = null, !0;
            C = S <= 23 ? 1 : 2, T >= 64 && T <= 95 ? D = C === 1 ? u[S] : c[S] : D = C === 1 ? h[S] : d[S];
            var N = this.interpretPAC(D, T), $ = this.channels[C - 1];
            return $.setPAC(N), this.lastCmdA = S, this.lastCmdB = T, this.currChNr = C, !0;
          }, w.prototype.interpretPAC = function(S, T) {
            var C = T, D = { color: null, italics: !1, indent: null, underline: !1, row: S };
            return T > 95 ? C = T - 96 : C = T - 64, D.underline = (C & 1) === 1, C <= 13 ? D.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(C / 2)] : C <= 15 ? (D.italics = !0, D.color = "white") : D.indent = Math.floor((C - 16) / 2) * 4, D;
          }, w.prototype.parseChars = function(S, T) {
            var C = null, D = null, R = null;
            if (S >= 25 ? (C = 2, R = S - 8) : (C = 1, R = S), R >= 17 && R <= 19) {
              var P = T;
              R === 17 ? P = T + 80 : R === 18 ? P = T + 112 : P = T + 144, m.log("INFO", "Special char '" + s(P) + "' in channel " + C), D = [P];
            } else
              S >= 32 && S <= 127 && (D = T === 0 ? [S] : [S, T]);
            if (D) {
              var N = p(D);
              m.log("DEBUG", "Char codes =  " + N.join(",")), this.lastCmdA = null, this.lastCmdB = null;
            }
            return D;
          }, w.prototype.parseBackgroundAttributes = function(S, T) {
            var C, D, R, P, N = (S === 16 || S === 24) && T >= 32 && T <= 47, $ = (S === 23 || S === 31) && T >= 45 && T <= 47;
            return N || $ ? (C = {}, S === 16 || S === 24 ? (D = Math.floor((T - 32) / 2), C.background = f[D], T % 2 === 1 && (C.background = C.background + "_semi")) : T === 45 ? C.background = "transparent" : (C.foreground = "black", T === 47 && (C.underline = !0)), R = S < 24 ? 1 : 2, P = this.channels[R - 1], P.setBkgData(C), this.lastCmdA = null, this.lastCmdB = null, !0) : !1;
          }, w.prototype.reset = function() {
            for (var S = 0; S < this.channels.length; S++)
              this.channels[S] && this.channels[S].reset();
            this.lastCmdA = null, this.lastCmdB = null;
          }, w.prototype.cueSplitAtTime = function(S) {
            for (var T = 0; T < this.channels.length; T++)
              this.channels[T] && this.channels[T].cueSplitAtTime(S);
          }, w;
        }();
        t.default = x;
      },
      "./src/utils/codecs.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = {
          audio: {
            a3ds: !0,
            "ac-3": !0,
            "ac-4": !0,
            alac: !0,
            alaw: !0,
            dra1: !0,
            "dts+": !0,
            "dts-": !0,
            dtsc: !0,
            dtse: !0,
            dtsh: !0,
            "ec-3": !0,
            enca: !0,
            g719: !0,
            g726: !0,
            m4ae: !0,
            mha1: !0,
            mha2: !0,
            mhm1: !0,
            mhm2: !0,
            mlpa: !0,
            mp4a: !0,
            "raw ": !0,
            Opus: !0,
            samr: !0,
            sawb: !0,
            sawp: !0,
            sevc: !0,
            sqcp: !0,
            ssmv: !0,
            twos: !0,
            ulaw: !0
          },
          video: {
            avc1: !0,
            avc2: !0,
            avc3: !0,
            avc4: !0,
            avcp: !0,
            drac: !0,
            dvav: !0,
            dvhe: !0,
            encv: !0,
            hev1: !0,
            hvc1: !0,
            mjp2: !0,
            mp4v: !0,
            mvc1: !0,
            mvc2: !0,
            mvc3: !0,
            mvc4: !0,
            resv: !0,
            rv60: !0,
            s263: !0,
            svc1: !0,
            svc2: !0,
            "vc-1": !0,
            vp08: !0,
            vp09: !0
          }
        };
        function s(l, u) {
          var h = a[u];
          return !!h && h[l.slice(0, 4)] === !0;
        }
        t.isCodecType = s;
        function o(l, u) {
          return window.MediaSource.isTypeSupported((u || "video") + '/mp4;codecs="' + l + '"');
        }
        t.isCodecSupportedInMp4 = o;
      },
      "./src/utils/cues.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/utils/vttparser.js");
        function s(o, l, u, h) {
          for (var c, d, f, m, p, b = window.VTTCue || window.TextTrackCue, y = 0; y < h.rows.length; y++)
            if (c = h.rows[y], f = !0, m = 0, p = "", !c.isEmpty()) {
              for (var v = 0; v < c.chars.length; v++)
                c.chars[v].uchar.match(/\s/) && f ? m++ : (p += c.chars[v].uchar, f = !1);
              c.cueStartTime = l, l === u && (u += 1e-4), d = new b(l, u, a.fixLineBreaks(p.trim())), m >= 16 ? m-- : m++, navigator.userAgent.match(/Firefox\//) ? d.line = y + 1 : d.line = y > 7 ? y - 2 : y + 1, d.align = "left", d.position = Math.max(0, Math.min(100, 100 * (m / 32) + (navigator.userAgent.match(/Firefox\//) ? 50 : 0))), o.addCue(d);
            }
        }
        t.newCue = s;
      },
      "./src/utils/discontinuities.js": function(i, t, n) {
        (function(a) {
          Object.defineProperty(t, "__esModule", { value: !0 });
          var s = n("./src/utils/binary-search.js"), o = n("./src/utils/logger.js");
          function l(b, y) {
            for (var v = null, g = 0; g < b.length; g += 1) {
              var E = b[g];
              if (E && E.cc === y) {
                v = E;
                break;
              }
            }
            return v;
          }
          t.findFirstFragWithCC = l;
          function u(b, y) {
            return s.default.search(b, function(v) {
              return v.cc < y ? 1 : v.cc > y ? -1 : 0;
            });
          }
          t.findFragWithCC = u;
          function h(b, y, v) {
            var g = !1;
            return y && y.details && v && (v.endCC > v.startCC || b && b.cc < v.startCC) && (g = !0), g;
          }
          t.shouldAlignOnDiscontinuities = h;
          function c(b, y) {
            var v = b.fragments, g = y.fragments;
            if (!g.length || !v.length) {
              o.logger.log("No fragments to align");
              return;
            }
            var E = l(v, g[0].cc);
            if (!E || E && !E.startPTS) {
              o.logger.log("No frag in previous level to align on");
              return;
            }
            return E;
          }
          t.findDiscontinuousReferenceFrag = c;
          function d(b, y) {
            y.fragments.forEach(function(v) {
              if (v) {
                var g = v.start + b;
                v.start = v.startPTS = g, v.endPTS = g + v.duration;
              }
            }), y.PTSKnown = !0;
          }
          t.adjustPts = d;
          function f(b, y, v) {
            m(b, v, y), !v.PTSKnown && y && p(v, y.details);
          }
          t.alignStream = f;
          function m(b, y, v) {
            if (h(b, v, y)) {
              var g = c(v.details, y);
              g && (o.logger.log("Adjusting PTS using last level due to CC increase within current level"), d(g.start, y));
            }
          }
          t.alignDiscontinuities = m;
          function p(b, y) {
            if (y && y.fragments.length) {
              if (!b.hasProgramDateTime || !y.hasProgramDateTime)
                return;
              var v = y.fragments[0].programDateTime, g = b.fragments[0].programDateTime, E = (g - v) / 1e3 + y.fragments[0].start;
              a.isFinite(E) && (o.logger.log("adjusting PTS using programDateTime delta, sliding:" + E.toFixed(3)), d(E, b));
            }
          }
          t.alignPDT = p;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/utils/ewma-bandwidth-estimator.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/utils/ewma.js"), s = function() {
          function o(l, u, h, c) {
            this.hls = l, this.defaultEstimate_ = c, this.minWeight_ = 1e-3, this.minDelayMs_ = 50, this.slow_ = new a.default(u), this.fast_ = new a.default(h);
          }
          return o.prototype.sample = function(l, u) {
            l = Math.max(l, this.minDelayMs_);
            var h = 8e3 * u / l, c = l / 1e3;
            this.fast_.sample(c, h), this.slow_.sample(c, h);
          }, o.prototype.canEstimate = function() {
            var l = this.fast_;
            return l && l.getTotalWeight() >= this.minWeight_;
          }, o.prototype.getEstimate = function() {
            return this.canEstimate() ? Math.min(this.fast_.getEstimate(), this.slow_.getEstimate()) : this.defaultEstimate_;
          }, o.prototype.destroy = function() {
          }, o;
        }();
        t.default = s;
      },
      "./src/utils/ewma.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = function() {
          function s(o) {
            this.alpha_ = o ? Math.exp(Math.log(0.5) / o) : 0, this.estimate_ = 0, this.totalWeight_ = 0;
          }
          return s.prototype.sample = function(o, l) {
            var u = Math.pow(this.alpha_, o);
            this.estimate_ = l * (1 - u) + u * this.estimate_, this.totalWeight_ += o;
          }, s.prototype.getTotalWeight = function() {
            return this.totalWeight_;
          }, s.prototype.getEstimate = function() {
            if (this.alpha_) {
              var o = 1 - Math.pow(this.alpha_, this.totalWeight_);
              return this.estimate_ / o;
            } else
              return this.estimate_;
          }, s;
        }();
        t.default = a;
      },
      "./src/utils/get-self-scope.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        function a() {
          return typeof window > "u" ? self : window;
        }
        t.getSelfScope = a;
      },
      "./src/utils/logger.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/utils/get-self-scope.js");
        function s() {
        }
        var o = {
          trace: s,
          debug: s,
          log: s,
          warn: s,
          info: s,
          error: s
        }, l = o;
        function u(f, m) {
          return m = "[" + f + "] > " + m, m;
        }
        var h = a.getSelfScope();
        function c(f) {
          var m = h.console[f];
          return m ? function() {
            for (var p = [], b = 0; b < arguments.length; b++)
              p[b] = arguments[b];
            p[0] && (p[0] = u(f, p[0])), m.apply(h.console, p);
          } : s;
        }
        function d(f) {
          for (var m = [], p = 1; p < arguments.length; p++)
            m[p - 1] = arguments[p];
          m.forEach(function(b) {
            l[b] = f[b] ? f[b].bind(f) : c(b);
          });
        }
        t.enableLogs = function(f) {
          if (f === !0 || typeof f == "object") {
            d(
              f,
              "debug",
              "log",
              "info",
              "warn",
              "error"
            );
            try {
              l.log();
            } catch {
              l = o;
            }
          } else
            l = o;
        }, t.logger = l;
      },
      "./src/utils/mediakeys-helper.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = function() {
          return typeof window < "u" && window.navigator && window.navigator.requestMediaKeySystemAccess ? window.navigator.requestMediaKeySystemAccess.bind(window.navigator) : null;
        }();
        t.requestMediaKeySystemAccess = a;
      },
      "./src/utils/mediasource-helper.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        function a() {
          if (typeof window < "u")
            return window.MediaSource || window.WebKitMediaSource;
        }
        t.getMediaSource = a;
      },
      "./src/utils/output-filter.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = function() {
          function s(o, l) {
            this.timelineController = o, this.trackName = l, this.startTime = null, this.endTime = null, this.screen = null;
          }
          return s.prototype.dispatchCue = function() {
            this.startTime !== null && (this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen), this.startTime = null);
          }, s.prototype.newCue = function(o, l, u) {
            (this.startTime === null || this.startTime > o) && (this.startTime = o), this.endTime = l, this.screen = u, this.timelineController.createCaptionsTrack(this.trackName);
          }, s;
        }();
        t.default = a;
      },
      "./src/utils/texttrack-utils.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        function a(o, l) {
          var u = null;
          try {
            u = new window.Event("addtrack");
          } catch {
            u = document.createEvent("Event"), u.initEvent("addtrack", !1, !1);
          }
          u.track = o, l.dispatchEvent(u);
        }
        t.sendAddTrackEvent = a;
        function s(o) {
          if (o && o.cues)
            for (; o.cues.length > 0; )
              o.removeCue(o.cues[0]);
        }
        t.clearCurrentCues = s;
      },
      "./src/utils/time-ranges.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = {
          toString: function(s) {
            for (var o = "", l = s.length, u = 0; u < l; u++)
              o += "[" + s.start(u).toFixed(3) + "," + s.end(u).toFixed(3) + "]";
            return o;
          }
        };
        t.default = a;
      },
      "./src/utils/vttcue.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 }), t.default = function() {
          if (typeof window < "u" && window.VTTCue)
            return window.VTTCue;
          var a = "auto", s = {
            "": !0,
            lr: !0,
            rl: !0
          }, o = {
            start: !0,
            middle: !0,
            end: !0,
            left: !0,
            right: !0
          };
          function l(d) {
            if (typeof d != "string")
              return !1;
            var f = s[d.toLowerCase()];
            return f ? d.toLowerCase() : !1;
          }
          function u(d) {
            if (typeof d != "string")
              return !1;
            var f = o[d.toLowerCase()];
            return f ? d.toLowerCase() : !1;
          }
          function h(d) {
            for (var f = 1; f < arguments.length; f++) {
              var m = arguments[f];
              for (var p in m)
                d[p] = m[p];
            }
            return d;
          }
          function c(d, f, m) {
            var p = this, b = function() {
              if (!(typeof navigator > "u"))
                return /MSIE\s8\.0/.test(navigator.userAgent);
            }(), y = {};
            b ? p = document.createElement("custom") : y.enumerable = !0, p.hasBeenReset = !1;
            var v = "", g = !1, E = d, x = f, w = m, S = null, T = "", C = !0, D = "auto", R = "start", P = 50, N = "middle", $ = 50, O = "middle";
            if (Object.defineProperty(p, "id", h({}, y, {
              get: function() {
                return v;
              },
              set: function(M) {
                v = "" + M;
              }
            })), Object.defineProperty(p, "pauseOnExit", h({}, y, {
              get: function() {
                return g;
              },
              set: function(M) {
                g = !!M;
              }
            })), Object.defineProperty(p, "startTime", h({}, y, {
              get: function() {
                return E;
              },
              set: function(M) {
                if (typeof M != "number")
                  throw new TypeError("Start time must be set to a number.");
                E = M, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(p, "endTime", h({}, y, {
              get: function() {
                return x;
              },
              set: function(M) {
                if (typeof M != "number")
                  throw new TypeError("End time must be set to a number.");
                x = M, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(p, "text", h({}, y, {
              get: function() {
                return w;
              },
              set: function(M) {
                w = "" + M, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(p, "region", h({}, y, {
              get: function() {
                return S;
              },
              set: function(M) {
                S = M, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(p, "vertical", h({}, y, {
              get: function() {
                return T;
              },
              set: function(M) {
                var F = l(M);
                if (F === !1)
                  throw new SyntaxError("An invalid or illegal string was specified.");
                T = F, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(p, "snapToLines", h({}, y, {
              get: function() {
                return C;
              },
              set: function(M) {
                C = !!M, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(p, "line", h({}, y, {
              get: function() {
                return D;
              },
              set: function(M) {
                if (typeof M != "number" && M !== a)
                  throw new SyntaxError("An invalid number or illegal string was specified.");
                D = M, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(p, "lineAlign", h({}, y, {
              get: function() {
                return R;
              },
              set: function(M) {
                var F = u(M);
                if (!F)
                  throw new SyntaxError("An invalid or illegal string was specified.");
                R = F, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(p, "position", h({}, y, {
              get: function() {
                return P;
              },
              set: function(M) {
                if (M < 0 || M > 100)
                  throw new Error("Position must be between 0 and 100.");
                P = M, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(p, "positionAlign", h({}, y, {
              get: function() {
                return N;
              },
              set: function(M) {
                var F = u(M);
                if (!F)
                  throw new SyntaxError("An invalid or illegal string was specified.");
                N = F, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(p, "size", h({}, y, {
              get: function() {
                return $;
              },
              set: function(M) {
                if (M < 0 || M > 100)
                  throw new Error("Size must be between 0 and 100.");
                $ = M, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(p, "align", h({}, y, {
              get: function() {
                return O;
              },
              set: function(M) {
                var F = u(M);
                if (!F)
                  throw new SyntaxError("An invalid or illegal string was specified.");
                O = F, this.hasBeenReset = !0;
              }
            })), p.displayState = void 0, b)
              return p;
          }
          return c.prototype.getCueAsHTML = function() {
            var d = window.WebVTT;
            return d.convertCueToDOMTree(window, this.text);
          }, c;
        }();
      },
      "./src/utils/vttparser.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/utils/vttcue.js"), s = function() {
          return {
            decode: function(b) {
              if (!b)
                return "";
              if (typeof b != "string")
                throw new Error("Error - expected string data.");
              return decodeURIComponent(encodeURIComponent(b));
            }
          };
        };
        function o() {
          this.window = window, this.state = "INITIAL", this.buffer = "", this.decoder = new s(), this.regionList = [];
        }
        function l(p) {
          function b(v, g, E, x) {
            return (v | 0) * 3600 + (g | 0) * 60 + (E | 0) + (x | 0) / 1e3;
          }
          var y = p.match(/^(\d+):(\d{2})(:\d{2})?\.(\d{3})/);
          return y ? y[3] ? b(y[1], y[2], y[3].replace(":", ""), y[4]) : y[1] > 59 ? b(y[1], y[2], 0, y[4]) : b(0, y[1], y[2], y[4]) : null;
        }
        function u() {
          this.values = /* @__PURE__ */ Object.create(null);
        }
        u.prototype = {
          set: function(p, b) {
            !this.get(p) && b !== "" && (this.values[p] = b);
          },
          get: function(p, b, y) {
            return y ? this.has(p) ? this.values[p] : b[y] : this.has(p) ? this.values[p] : b;
          },
          has: function(p) {
            return p in this.values;
          },
          alt: function(p, b, y) {
            for (var v = 0; v < y.length; ++v)
              if (b === y[v]) {
                this.set(p, b);
                break;
              }
          },
          integer: function(p, b) {
            /^-?\d+$/.test(b) && this.set(p, parseInt(b, 10));
          },
          percent: function(p, b) {
            return b.match(/^([\d]{1,3})(\.[\d]*)?%$/) && (b = parseFloat(b), b >= 0 && b <= 100) ? (this.set(p, b), !0) : !1;
          }
        };
        function h(p, b, y, v) {
          var g = v ? p.split(v) : [p];
          for (var E in g)
            if (typeof g[E] == "string") {
              var x = g[E].split(y);
              if (x.length === 2) {
                var w = x[0], S = x[1];
                b(w, S);
              }
            }
        }
        var c = new a.default(0, 0, 0), d = c.align === "middle" ? "middle" : "center";
        function f(p, b, y) {
          var v = p;
          function g() {
            var w = l(p);
            if (w === null)
              throw new Error("Malformed timestamp: " + v);
            return p = p.replace(/^[^\sa-zA-Z-]+/, ""), w;
          }
          function E(w, S) {
            var T = new u();
            h(w, function(R, P) {
              switch (R) {
                case "region":
                  for (var N = y.length - 1; N >= 0; N--)
                    if (y[N].id === P) {
                      T.set(R, y[N].region);
                      break;
                    }
                  break;
                case "vertical":
                  T.alt(R, P, ["rl", "lr"]);
                  break;
                case "line":
                  var $ = P.split(","), O = $[0];
                  T.integer(R, O), T.percent(R, O) && T.set("snapToLines", !1), T.alt(R, O, ["auto"]), $.length === 2 && T.alt("lineAlign", $[1], ["start", d, "end"]);
                  break;
                case "position":
                  $ = P.split(","), T.percent(R, $[0]), $.length === 2 && T.alt("positionAlign", $[1], ["start", d, "end", "line-left", "line-right", "auto"]);
                  break;
                case "size":
                  T.percent(R, P);
                  break;
                case "align":
                  T.alt(R, P, ["start", d, "end", "left", "right"]);
                  break;
              }
            }, /:/, /\s/), S.region = T.get("region", null), S.vertical = T.get("vertical", "");
            var C = T.get("line", "auto");
            C === "auto" && c.line === -1 && (C = -1), S.line = C, S.lineAlign = T.get("lineAlign", "start"), S.snapToLines = T.get("snapToLines", !0), S.size = T.get("size", 100), S.align = T.get("align", d);
            var D = T.get("position", "auto");
            D === "auto" && c.position === 50 && (D = S.align === "start" || S.align === "left" ? 0 : S.align === "end" || S.align === "right" ? 100 : 50), S.position = D;
          }
          function x() {
            p = p.replace(/^\s+/, "");
          }
          if (x(), b.startTime = g(), x(), p.substr(0, 3) !== "-->")
            throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + v);
          p = p.substr(3), x(), b.endTime = g(), x(), E(p, b);
        }
        function m(p) {
          return p.replace(/<br(?: \/)?>/gi, `
`);
        }
        t.fixLineBreaks = m, o.prototype = {
          parse: function(p) {
            var b = this;
            p && (b.buffer += b.decoder.decode(p, { stream: !0 }));
            function y() {
              var S = b.buffer, T = 0;
              for (S = m(S); T < S.length && S[T] !== "\r" && S[T] !== `
`; )
                ++T;
              var C = S.substr(0, T);
              return S[T] === "\r" && ++T, S[T] === `
` && ++T, b.buffer = S.substr(T), C;
            }
            function v(S) {
              h(S, function(T, C) {
              }, /:/);
            }
            try {
              var g = void 0;
              if (b.state === "INITIAL") {
                if (!/\r\n|\n/.test(b.buffer))
                  return this;
                g = y();
                var E = g.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
                if (!E || !E[0])
                  throw new Error("Malformed WebVTT signature.");
                b.state = "HEADER";
              }
              for (var x = !1; b.buffer; ) {
                if (!/\r\n|\n/.test(b.buffer))
                  return this;
                switch (x ? x = !1 : g = y(), b.state) {
                  case "HEADER":
                    /:/.test(g) ? v(g) : g || (b.state = "ID");
                    continue;
                  case "NOTE":
                    g || (b.state = "ID");
                    continue;
                  case "ID":
                    if (/^NOTE($|[ \t])/.test(g)) {
                      b.state = "NOTE";
                      break;
                    }
                    if (!g)
                      continue;
                    if (b.cue = new a.default(0, 0, ""), b.state = "CUE", g.indexOf("-->") === -1) {
                      b.cue.id = g;
                      continue;
                    }
                  case "CUE":
                    try {
                      f(g, b.cue, b.regionList);
                    } catch {
                      b.cue = null, b.state = "BADCUE";
                      continue;
                    }
                    b.state = "CUETEXT";
                    continue;
                  case "CUETEXT":
                    var w = g.indexOf("-->") !== -1;
                    if (!g || w && (x = !0)) {
                      b.oncue && b.oncue(b.cue), b.cue = null, b.state = "ID";
                      continue;
                    }
                    b.cue.text && (b.cue.text += `
`), b.cue.text += g;
                    continue;
                  case "BADCUE":
                    g || (b.state = "ID");
                    continue;
                }
              }
            } catch {
              b.state === "CUETEXT" && b.cue && b.oncue && b.oncue(b.cue), b.cue = null, b.state = b.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
            }
            return this;
          },
          flush: function() {
            var p = this;
            try {
              if (p.buffer += p.decoder.decode(), (p.cue || p.state === "HEADER") && (p.buffer += `

`, p.parse()), p.state === "INITIAL")
                throw new Error("Malformed WebVTT signature.");
            } catch (b) {
              throw b;
            }
            return p.onflush && p.onflush(), this;
          }
        }, t.default = o;
      },
      "./src/utils/webvtt-parser.js": function(i, t, n) {
        (function(a) {
          Object.defineProperty(t, "__esModule", { value: !0 });
          var s = n("./src/utils/vttparser.js"), o = n("./src/demux/id3.js"), l = function(f, m, p) {
            return f.substr(p || 0, m.length) === m;
          }, u = function(f) {
            var m = parseInt(f.substr(-3)), p = parseInt(f.substr(-6, 2)), b = parseInt(f.substr(-9, 2)), y = f.length > 9 ? parseInt(f.substr(0, f.indexOf(":"))) : 0;
            return !a.isFinite(m) || !a.isFinite(p) || !a.isFinite(b) || !a.isFinite(y) ? -1 : (m += 1e3 * p, m += 60 * 1e3 * b, m += 60 * 60 * 1e3 * y, m);
          }, h = function(f) {
            for (var m = 5381, p = f.length; p; )
              m = m * 33 ^ f.charCodeAt(--p);
            return (m >>> 0).toString();
          }, c = function(f, m, p) {
            var b = f[m], y = f[b.prevCC];
            if (!y || !y.new && b.new) {
              f.ccOffset = f.presentationOffset = b.start, b.new = !1;
              return;
            }
            for (; y && y.new; )
              f.ccOffset += b.start - y.start, b.new = !1, b = y, y = f[b.prevCC];
            f.presentationOffset = p;
          }, d = {
            parse: function(f, m, p, b, y, v) {
              var g = /\r\n|\n\r|\n|\r/g, E = o.utf8ArrayToStr(new Uint8Array(f)).trim().replace(g, `
`).split(`
`), x = "00:00.000", w = 0, S = 0, T = 0, C = [], D, R = !0, P = new s.default();
              P.oncue = function(N) {
                var $ = p[b], O = p.ccOffset;
                $ && $.new && (S !== void 0 ? O = p.ccOffset = $.start : c(p, b, T)), T && (O = T - p.presentationOffset), N.startTime += O - S, N.endTime += O - S, N.id = h(N.startTime.toString()) + h(N.endTime.toString()) + h(N.text), N.text = decodeURIComponent(encodeURIComponent(N.text)), N.endTime > 0 && C.push(N);
              }, P.onparsingerror = function(N) {
                D = N;
              }, P.onflush = function() {
                if (D && v) {
                  v(D);
                  return;
                }
                y(C);
              }, E.forEach(function(N) {
                if (R)
                  if (l(N, "X-TIMESTAMP-MAP=")) {
                    R = !1, N.substr(16).split(",").forEach(function($) {
                      l($, "LOCAL:") ? x = $.substr(6) : l($, "MPEGTS:") && (w = parseInt($.substr(7)));
                    });
                    try {
                      m + (p[b].start * 9e4 || 0) < 0 && (m += 8589934592), w -= m, S = u(x) / 1e3, T = w / 9e4, S === -1 && (D = new Error("Malformed X-TIMESTAMP-MAP: " + N));
                    } catch {
                      D = new Error("Malformed X-TIMESTAMP-MAP: " + N);
                    }
                    return;
                  } else
                    N === "" && (R = !1);
                P.parse(N + `
`);
              }), P.flush();
            }
          };
          t.default = d;
        }).call(this, n("./src/polyfills/number.js").Number);
      },
      "./src/utils/xhr-loader.js": function(i, t, n) {
        Object.defineProperty(t, "__esModule", { value: !0 });
        var a = n("./src/utils/logger.js"), s = window.performance, o = window.XMLHttpRequest, l = function() {
          function u(h) {
            h && h.xhrSetup && (this.xhrSetup = h.xhrSetup);
          }
          return u.prototype.destroy = function() {
            this.abort(), this.loader = null;
          }, u.prototype.abort = function() {
            var h = this.loader;
            h && h.readyState !== 4 && (this.stats.aborted = !0, h.abort()), window.clearTimeout(this.requestTimeout), this.requestTimeout = null, window.clearTimeout(this.retryTimeout), this.retryTimeout = null;
          }, u.prototype.load = function(h, c, d) {
            this.context = h, this.config = c, this.callbacks = d, this.stats = { trequest: s.now(), retry: 0 }, this.retryDelay = c.retryDelay, this.loadInternal();
          }, u.prototype.loadInternal = function() {
            var h, c = this.context;
            h = this.loader = new o();
            var d = this.stats;
            d.tfirst = 0, d.loaded = 0;
            var f = this.xhrSetup;
            try {
              if (f)
                try {
                  f(h, c.url);
                } catch {
                  h.open("GET", c.url, !0), f(h, c.url);
                }
              h.readyState || h.open("GET", c.url, !0);
            } catch (m) {
              this.callbacks.onError({ code: h.status, text: m.message }, c, h);
              return;
            }
            c.rangeEnd && h.setRequestHeader("Range", "bytes=" + c.rangeStart + "-" + (c.rangeEnd - 1)), h.onreadystatechange = this.readystatechange.bind(this), h.onprogress = this.loadprogress.bind(this), h.responseType = c.responseType, this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), this.config.timeout), h.send();
          }, u.prototype.readystatechange = function(h) {
            var c = h.currentTarget, d = c.readyState, f = this.stats, m = this.context, p = this.config;
            if (!f.aborted && d >= 2)
              if (window.clearTimeout(this.requestTimeout), f.tfirst === 0 && (f.tfirst = Math.max(s.now(), f.trequest)), d === 4) {
                var b = c.status;
                if (b >= 200 && b < 300) {
                  f.tload = Math.max(f.tfirst, s.now());
                  var y = void 0, v = void 0;
                  m.responseType === "arraybuffer" ? (y = c.response, v = y.byteLength) : (y = c.responseText, v = y.length), f.loaded = f.total = v;
                  var g = { url: c.responseURL, data: y };
                  this.callbacks.onSuccess(g, f, m, c);
                } else
                  f.retry >= p.maxRetry || b >= 400 && b < 499 ? (a.logger.error(b + " while loading " + m.url), this.callbacks.onError({ code: b, text: c.statusText }, m, c)) : (a.logger.warn(b + " while loading " + m.url + ", retrying in " + this.retryDelay + "..."), this.destroy(), this.retryTimeout = window.setTimeout(this.loadInternal.bind(this), this.retryDelay), this.retryDelay = Math.min(2 * this.retryDelay, p.maxRetryDelay), f.retry++);
              } else
                this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), p.timeout);
          }, u.prototype.loadtimeout = function() {
            a.logger.warn("timeout while loading " + this.context.url), this.callbacks.onTimeout(this.stats, this.context, null);
          }, u.prototype.loadprogress = function(h) {
            var c = h.currentTarget, d = this.stats;
            d.loaded = h.loaded, h.lengthComputable && (d.total = h.total);
            var f = this.callbacks.onProgress;
            f && f(d, this.context, null, c);
          }, u;
        }();
        t.default = l;
      }
    }).default;
  });
})(Fb);
const $a = /* @__PURE__ */ I1(Fb.exports);
var Gc;
typeof window < "u" ? Gc = window : typeof fn < "u" ? Gc = fn : typeof self < "u" ? Gc = self : Gc = {};
var Be = Gc;
const M1 = new Proxy({}, {
  get(e, r) {
    throw new Error(`Module "" has been externalized for browser compatibility. Cannot access ".${r}" in client code.`);
  }
}), N1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: M1
}, Symbol.toStringTag, { value: "Module" })), Ub = /* @__PURE__ */ Mb(N1);
var Ly = typeof fn < "u" ? fn : typeof window < "u" ? window : {}, F1 = Ub, Hc;
typeof document < "u" ? Hc = document : (Hc = Ly["__GLOBAL_DOCUMENT_CACHE@4"], Hc || (Hc = Ly["__GLOBAL_DOCUMENT_CACHE@4"] = F1));
var Mt = Hc, U1 = B1;
function B1(e, r) {
  var i, t = null;
  try {
    i = JSON.parse(e, r);
  } catch (n) {
    t = n;
  }
  return [t, i];
}
var Sg = { exports: {} };
(function(e, r) {
  function i(l) {
    if (l && typeof l == "object") {
      var u = l.which || l.keyCode || l.charCode;
      u && (l = u);
    }
    if (typeof l == "number")
      return s[l];
    var h = String(l), c = t[h.toLowerCase()];
    if (c)
      return c;
    var c = n[h.toLowerCase()];
    if (c)
      return c;
    if (h.length === 1)
      return h.charCodeAt(0);
  }
  i.isEventKey = function(u, h) {
    if (u && typeof u == "object") {
      var c = u.which || u.keyCode || u.charCode;
      if (c == null)
        return !1;
      if (typeof h == "string") {
        var d = t[h.toLowerCase()];
        if (d)
          return d === c;
        var d = n[h.toLowerCase()];
        if (d)
          return d === c;
      } else if (typeof h == "number")
        return h === c;
      return !1;
    }
  }, r = e.exports = i;
  var t = r.code = r.codes = {
    backspace: 8,
    tab: 9,
    enter: 13,
    shift: 16,
    ctrl: 17,
    alt: 18,
    "pause/break": 19,
    "caps lock": 20,
    esc: 27,
    space: 32,
    "page up": 33,
    "page down": 34,
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    insert: 45,
    delete: 46,
    command: 91,
    "left command": 91,
    "right command": 93,
    "numpad *": 106,
    "numpad +": 107,
    "numpad -": 109,
    "numpad .": 110,
    "numpad /": 111,
    "num lock": 144,
    "scroll lock": 145,
    "my computer": 182,
    "my calculator": 183,
    ";": 186,
    "=": 187,
    ",": 188,
    "-": 189,
    ".": 190,
    "/": 191,
    "`": 192,
    "[": 219,
    "\\": 220,
    "]": 221,
    "'": 222
  }, n = r.aliases = {
    windows: 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    ctl: 17,
    control: 17,
    option: 18,
    pause: 19,
    break: 19,
    caps: 20,
    return: 13,
    escape: 27,
    spc: 32,
    spacebar: 32,
    pgup: 33,
    pgdn: 34,
    ins: 45,
    del: 46,
    cmd: 91
  };
  /*!
   * Programatically add the following
   */
  for (a = 97; a < 123; a++)
    t[String.fromCharCode(a)] = a - 32;
  for (var a = 48; a < 58; a++)
    t[a - 48] = a;
  for (a = 1; a < 13; a++)
    t["f" + a] = a + 111;
  for (a = 0; a < 10; a++)
    t["numpad " + a] = a + 96;
  var s = r.names = r.title = {};
  for (a in t)
    s[t[a]] = a;
  for (var o in n)
    t[o] = n[o];
})(Sg, Sg.exports);
const Tr = Sg.exports;
var j1 = G1, $1 = Object.prototype.toString;
function G1(e) {
  if (!e)
    return !1;
  var r = $1.call(e);
  return r === "[object Function]" || typeof e == "function" && r !== "[object RegExp]" || typeof window < "u" && (e === window.setTimeout || e === window.alert || e === window.confirm || e === window.prompt);
}
var kp = function(e) {
  return e.replace(/^\s+|\s+$/g, "");
}, H1 = function(e) {
  return Object.prototype.toString.call(e) === "[object Array]";
}, V1 = function(e) {
  if (!e)
    return {};
  for (var r = {}, i = kp(e).split(`
`), t = 0; t < i.length; t++) {
    var n = i[t], a = n.indexOf(":"), s = kp(n.slice(0, a)).toLowerCase(), o = kp(n.slice(a + 1));
    typeof r[s] > "u" ? r[s] = o : H1(r[s]) ? r[s].push(o) : r[s] = [r[s], o];
  }
  return r;
}, q1 = Y1, W1 = Object.prototype.hasOwnProperty;
function Y1() {
  for (var e = {}, r = 0; r < arguments.length; r++) {
    var i = arguments[r];
    for (var t in i)
      W1.call(i, t) && (e[t] = i[t]);
  }
  return e;
}
var Bb = Be, K1 = j1, z1 = V1, X1 = q1, jb = Jo;
Jo.XMLHttpRequest = Bb.XMLHttpRequest || eC;
Jo.XDomainRequest = "withCredentials" in new Jo.XMLHttpRequest() ? Jo.XMLHttpRequest : Bb.XDomainRequest;
J1(["get", "put", "post", "patch", "head", "delete"], function(e) {
  Jo[e === "delete" ? "del" : e] = function(r, i, t) {
    return i = $b(r, i, t), i.method = e.toUpperCase(), Gb(i);
  };
});
function J1(e, r) {
  for (var i = 0; i < e.length; i++)
    r(e[i]);
}
function Q1(e) {
  for (var r in e)
    if (e.hasOwnProperty(r))
      return !1;
  return !0;
}
function $b(e, r, i) {
  var t = e;
  return K1(r) ? (i = r, typeof e == "string" && (t = { uri: e })) : t = X1(r, { uri: e }), t.callback = i, t;
}
function Jo(e, r, i) {
  return r = $b(e, r, i), Gb(r);
}
function Gb(e) {
  if (typeof e.callback > "u")
    throw new Error("callback argument missing");
  var r = !1, i = function(g, E, x) {
    r || (r = !0, e.callback(g, E, x));
  };
  function t() {
    o.readyState === 4 && setTimeout(s, 0);
  }
  function n() {
    var v = void 0;
    if (o.response ? v = o.response : v = o.responseText || Z1(o), p)
      try {
        v = JSON.parse(v);
      } catch {
      }
    return v;
  }
  function a(v) {
    return clearTimeout(b), v instanceof Error || (v = new Error("" + (v || "Unknown XMLHttpRequest Error"))), v.statusCode = 0, i(v, y);
  }
  function s() {
    if (!u) {
      var v;
      clearTimeout(b), e.useXDR && o.status === void 0 ? v = 200 : v = o.status === 1223 ? 204 : o.status;
      var g = y, E = null;
      return v !== 0 ? (g = {
        body: n(),
        statusCode: v,
        method: c,
        headers: {},
        url: h,
        rawRequest: o
      }, o.getAllResponseHeaders && (g.headers = z1(o.getAllResponseHeaders()))) : E = new Error("Internal XMLHttpRequest Error"), i(E, g, g.body);
    }
  }
  var o = e.xhr || null;
  o || (e.cors || e.useXDR ? o = new Jo.XDomainRequest() : o = new Jo.XMLHttpRequest());
  var l, u, h = o.url = e.uri || e.url, c = o.method = e.method || "GET", d = e.body || e.data, f = o.headers = e.headers || {}, m = !!e.sync, p = !1, b, y = {
    body: void 0,
    headers: {},
    statusCode: 0,
    method: c,
    url: h,
    rawRequest: o
  };
  if ("json" in e && e.json !== !1 && (p = !0, f.accept || f.Accept || (f.Accept = "application/json"), c !== "GET" && c !== "HEAD" && (f["content-type"] || f["Content-Type"] || (f["Content-Type"] = "application/json"), d = JSON.stringify(e.json === !0 ? d : e.json))), o.onreadystatechange = t, o.onload = s, o.onerror = a, o.onprogress = function() {
  }, o.onabort = function() {
    u = !0;
  }, o.ontimeout = a, o.open(c, h, !m, e.username, e.password), m || (o.withCredentials = !!e.withCredentials), !m && e.timeout > 0 && (b = setTimeout(function() {
    if (!u) {
      u = !0, o.abort("timeout");
      var v = new Error("XMLHttpRequest timeout");
      v.code = "ETIMEDOUT", a(v);
    }
  }, e.timeout)), o.setRequestHeader)
    for (l in f)
      f.hasOwnProperty(l) && o.setRequestHeader(l, f[l]);
  else if (e.headers && !Q1(e.headers))
    throw new Error("Headers cannot be set on an XDomainRequest object");
  return "responseType" in e && (o.responseType = e.responseType), "beforeSend" in e && typeof e.beforeSend == "function" && e.beforeSend(o), o.send(d || null), o;
}
function Z1(e) {
  if (e.responseType === "document")
    return e.responseXML;
  var r = e.responseXML && e.responseXML.documentElement.nodeName === "parsererror";
  return e.responseType === "" && !r ? e.responseXML : null;
}
function eC() {
}
var Eg = { exports: {} }, pv = Object.create || function() {
  function e() {
  }
  return function(r) {
    if (arguments.length !== 1)
      throw new Error("Object.create shim only accepts one parameter.");
    return e.prototype = r, new e();
  };
}();
function Ea(e, r) {
  this.name = "ParsingError", this.code = e.code, this.message = r || e.message;
}
Ea.prototype = pv(Error.prototype);
Ea.prototype.constructor = Ea;
Ea.Errors = {
  BadSignature: {
    code: 0,
    message: "Malformed WebVTT signature."
  },
  BadTimeStamp: {
    code: 1,
    message: "Malformed time stamp."
  }
};
function gv(e) {
  function r(t, n, a, s) {
    return (t | 0) * 3600 + (n | 0) * 60 + (a | 0) + (s | 0) / 1e3;
  }
  var i = e.match(/^(\d+):(\d{2})(:\d{2})?\.(\d{3})/);
  return i ? i[3] ? r(i[1], i[2], i[3].replace(":", ""), i[4]) : i[1] > 59 ? r(i[1], i[2], 0, i[4]) : r(0, i[1], i[2], i[4]) : null;
}
function Kc() {
  this.values = pv(null);
}
Kc.prototype = {
  set: function(e, r) {
    !this.get(e) && r !== "" && (this.values[e] = r);
  },
  get: function(e, r, i) {
    return i ? this.has(e) ? this.values[e] : r[i] : this.has(e) ? this.values[e] : r;
  },
  has: function(e) {
    return e in this.values;
  },
  alt: function(e, r, i) {
    for (var t = 0; t < i.length; ++t)
      if (r === i[t]) {
        this.set(e, r);
        break;
      }
  },
  integer: function(e, r) {
    /^-?\d+$/.test(r) && this.set(e, parseInt(r, 10));
  },
  percent: function(e, r) {
    return r.match(/^([\d]{1,3})(\.[\d]*)?%$/) && (r = parseFloat(r), r >= 0 && r <= 100) ? (this.set(e, r), !0) : !1;
  }
};
function Vc(e, r, i, t) {
  var n = t ? e.split(t) : [e];
  for (var a in n)
    if (typeof n[a] == "string") {
      var s = n[a].split(i);
      if (s.length === 2) {
        var o = s[0], l = s[1];
        r(o, l);
      }
    }
}
function tC(e, r, i) {
  var t = e;
  function n() {
    var o = gv(e);
    if (o === null)
      throw new Ea(
        Ea.Errors.BadTimeStamp,
        "Malformed timestamp: " + t
      );
    return e = e.replace(/^[^\sa-zA-Z-]+/, ""), o;
  }
  function a(o, l) {
    var u = new Kc();
    Vc(o, function(h, c) {
      switch (h) {
        case "region":
          for (var d = i.length - 1; d >= 0; d--)
            if (i[d].id === c) {
              u.set(h, i[d].region);
              break;
            }
          break;
        case "vertical":
          u.alt(h, c, ["rl", "lr"]);
          break;
        case "line":
          var f = c.split(","), m = f[0];
          u.integer(h, m), u.percent(h, m) && u.set("snapToLines", !1), u.alt(h, m, ["auto"]), f.length === 2 && u.alt("lineAlign", f[1], ["start", "middle", "end"]);
          break;
        case "position":
          f = c.split(","), u.percent(h, f[0]), f.length === 2 && u.alt("positionAlign", f[1], ["start", "middle", "end"]);
          break;
        case "size":
          u.percent(h, c);
          break;
        case "align":
          u.alt(h, c, ["start", "middle", "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/), l.region = u.get("region", null), l.vertical = u.get("vertical", ""), l.line = u.get("line", "auto"), l.lineAlign = u.get("lineAlign", "start"), l.snapToLines = u.get("snapToLines", !0), l.size = u.get("size", 100), l.align = u.get("align", "middle"), l.position = u.get("position", {
      start: 0,
      left: 0,
      middle: 50,
      end: 100,
      right: 100
    }, l.align), l.positionAlign = u.get("positionAlign", {
      start: "start",
      left: "start",
      middle: "middle",
      end: "end",
      right: "end"
    }, l.align);
  }
  function s() {
    e = e.replace(/^\s+/, "");
  }
  if (s(), r.startTime = n(), s(), e.substr(0, 3) !== "-->")
    throw new Ea(
      Ea.Errors.BadTimeStamp,
      "Malformed time stamp (time stamps must be separated by '-->'): " + t
    );
  e = e.substr(3), s(), r.endTime = n(), s(), a(e, r);
}
var rC = {
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&lrm;": "\u200E",
  "&rlm;": "\u200F",
  "&nbsp;": "\xA0"
}, iC = {
  c: "span",
  i: "i",
  b: "b",
  u: "u",
  ruby: "ruby",
  rt: "rt",
  v: "span",
  lang: "span"
}, nC = {
  v: "title",
  lang: "lang"
}, Iy = {
  rt: "ruby"
};
function Hb(e, r) {
  function i() {
    if (!r)
      return null;
    function m(b) {
      return r = r.substr(b.length), b;
    }
    var p = r.match(/^([^<]*)(<[^>]*>?)?/);
    return m(p[1] ? p[1] : p[2]);
  }
  function t(m) {
    return rC[m];
  }
  function n(m) {
    for (; f = m.match(/&(amp|lt|gt|lrm|rlm|nbsp);/); )
      m = m.replace(f[0], t);
    return m;
  }
  function a(m, p) {
    return !Iy[p.localName] || Iy[p.localName] === m.localName;
  }
  function s(m, p) {
    var b = iC[m];
    if (!b)
      return null;
    var y = e.document.createElement(b);
    y.localName = b;
    var v = nC[m];
    return v && p && (y[v] = p.trim()), y;
  }
  for (var o = e.document.createElement("div"), l = o, u, h = []; (u = i()) !== null; ) {
    if (u[0] === "<") {
      if (u[1] === "/") {
        h.length && h[h.length - 1] === u.substr(2).replace(">", "") && (h.pop(), l = l.parentNode);
        continue;
      }
      var c = gv(u.substr(1, u.length - 2)), d;
      if (c) {
        d = e.document.createProcessingInstruction("timestamp", c), l.appendChild(d);
        continue;
      }
      var f = u.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
      if (!f || (d = s(f[1], f[3]), !d) || !a(l, d))
        continue;
      f[2] && (d.className = f[2].substr(1).replace(".", " ")), h.push(f[1]), l.appendChild(d), l = d;
      continue;
    }
    l.appendChild(e.document.createTextNode(n(u)));
  }
  return o;
}
var My = [
  [1470, 1470],
  [1472, 1472],
  [1475, 1475],
  [1478, 1478],
  [1488, 1514],
  [1520, 1524],
  [1544, 1544],
  [1547, 1547],
  [1549, 1549],
  [1563, 1563],
  [1566, 1610],
  [1645, 1647],
  [1649, 1749],
  [1765, 1766],
  [1774, 1775],
  [1786, 1805],
  [1807, 1808],
  [1810, 1839],
  [1869, 1957],
  [1969, 1969],
  [1984, 2026],
  [2036, 2037],
  [2042, 2042],
  [2048, 2069],
  [2074, 2074],
  [2084, 2084],
  [2088, 2088],
  [2096, 2110],
  [2112, 2136],
  [2142, 2142],
  [2208, 2208],
  [2210, 2220],
  [8207, 8207],
  [64285, 64285],
  [64287, 64296],
  [64298, 64310],
  [64312, 64316],
  [64318, 64318],
  [64320, 64321],
  [64323, 64324],
  [64326, 64449],
  [64467, 64829],
  [64848, 64911],
  [64914, 64967],
  [65008, 65020],
  [65136, 65140],
  [65142, 65276],
  [67584, 67589],
  [67592, 67592],
  [67594, 67637],
  [67639, 67640],
  [67644, 67644],
  [67647, 67669],
  [67671, 67679],
  [67840, 67867],
  [67872, 67897],
  [67903, 67903],
  [67968, 68023],
  [68030, 68031],
  [68096, 68096],
  [68112, 68115],
  [68117, 68119],
  [68121, 68147],
  [68160, 68167],
  [68176, 68184],
  [68192, 68223],
  [68352, 68405],
  [68416, 68437],
  [68440, 68466],
  [68472, 68479],
  [68608, 68680],
  [126464, 126467],
  [126469, 126495],
  [126497, 126498],
  [126500, 126500],
  [126503, 126503],
  [126505, 126514],
  [126516, 126519],
  [126521, 126521],
  [126523, 126523],
  [126530, 126530],
  [126535, 126535],
  [126537, 126537],
  [126539, 126539],
  [126541, 126543],
  [126545, 126546],
  [126548, 126548],
  [126551, 126551],
  [126553, 126553],
  [126555, 126555],
  [126557, 126557],
  [126559, 126559],
  [126561, 126562],
  [126564, 126564],
  [126567, 126570],
  [126572, 126578],
  [126580, 126583],
  [126585, 126588],
  [126590, 126590],
  [126592, 126601],
  [126603, 126619],
  [126625, 126627],
  [126629, 126633],
  [126635, 126651],
  [1114109, 1114109]
];
function aC(e) {
  for (var r = 0; r < My.length; r++) {
    var i = My[r];
    if (e >= i[0] && e <= i[1])
      return !0;
  }
  return !1;
}
function sC(e) {
  var r = [], i = "", t;
  if (!e || !e.childNodes)
    return "ltr";
  function n(o, l) {
    for (var u = l.childNodes.length - 1; u >= 0; u--)
      o.push(l.childNodes[u]);
  }
  function a(o) {
    if (!o || !o.length)
      return null;
    var l = o.pop(), u = l.textContent || l.innerText;
    if (u) {
      var h = u.match(/^.*(\n|\r)/);
      return h ? (o.length = 0, h[0]) : u;
    }
    if (l.tagName === "ruby")
      return a(o);
    if (l.childNodes)
      return n(o, l), a(o);
  }
  for (n(r, e); i = a(r); )
    for (var s = 0; s < i.length; s++)
      if (t = i.charCodeAt(s), aC(t))
        return "rtl";
  return "ltr";
}
function oC(e) {
  if (typeof e.line == "number" && (e.snapToLines || e.line >= 0 && e.line <= 100))
    return e.line;
  if (!e.track || !e.track.textTrackList || !e.track.textTrackList.mediaElement)
    return -1;
  for (var r = e.track, i = r.textTrackList, t = 0, n = 0; n < i.length && i[n] !== r; n++)
    i[n].mode === "showing" && t++;
  return ++t * -1;
}
function Eh() {
}
Eh.prototype.applyStyles = function(e, r) {
  r = r || this.div;
  for (var i in e)
    e.hasOwnProperty(i) && (r.style[i] = e[i]);
};
Eh.prototype.formatStyle = function(e, r) {
  return e === 0 ? 0 : e + r;
};
function Ff(e, r, i) {
  Eh.call(this), this.cue = r, this.cueDiv = Hb(e, r.text);
  var t = {
    color: "rgba(255, 255, 255, 1)",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    position: "relative",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "inline",
    writingMode: r.vertical === "" ? "horizontal-tb" : r.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext"
  };
  this.applyStyles(t, this.cueDiv), this.div = e.document.createElement("div"), t = {
    direction: sC(this.cueDiv),
    writingMode: r.vertical === "" ? "horizontal-tb" : r.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext",
    textAlign: r.align === "middle" ? "center" : r.align,
    font: i.font,
    whiteSpace: "pre-line",
    position: "absolute"
  }, this.applyStyles(t), this.div.appendChild(this.cueDiv);
  var n = 0;
  switch (r.positionAlign) {
    case "start":
      n = r.position;
      break;
    case "middle":
      n = r.position - r.size / 2;
      break;
    case "end":
      n = r.position - r.size;
      break;
  }
  r.vertical === "" ? this.applyStyles({
    left: this.formatStyle(n, "%"),
    width: this.formatStyle(r.size, "%")
  }) : this.applyStyles({
    top: this.formatStyle(n, "%"),
    height: this.formatStyle(r.size, "%")
  }), this.move = function(a) {
    this.applyStyles({
      top: this.formatStyle(a.top, "px"),
      bottom: this.formatStyle(a.bottom, "px"),
      left: this.formatStyle(a.left, "px"),
      right: this.formatStyle(a.right, "px"),
      height: this.formatStyle(a.height, "px"),
      width: this.formatStyle(a.width, "px")
    });
  };
}
Ff.prototype = pv(Eh.prototype);
Ff.prototype.constructor = Ff;
function Jn(e) {
  var r, i, t, n;
  if (e.div) {
    i = e.div.offsetHeight, t = e.div.offsetWidth, n = e.div.offsetTop;
    var a = (a = e.div.childNodes) && (a = a[0]) && a.getClientRects && a.getClientRects();
    e = e.div.getBoundingClientRect(), r = a ? Math.max(a[0] && a[0].height || 0, e.height / a.length) : 0;
  }
  this.left = e.left, this.right = e.right, this.top = e.top || n, this.height = e.height || i, this.bottom = e.bottom || n + (e.height || i), this.width = e.width || t, this.lineHeight = r !== void 0 ? r : e.lineHeight;
}
Jn.prototype.move = function(e, r) {
  switch (r = r !== void 0 ? r : this.lineHeight, e) {
    case "+x":
      this.left += r, this.right += r;
      break;
    case "-x":
      this.left -= r, this.right -= r;
      break;
    case "+y":
      this.top += r, this.bottom += r;
      break;
    case "-y":
      this.top -= r, this.bottom -= r;
      break;
  }
};
Jn.prototype.overlaps = function(e) {
  return this.left < e.right && this.right > e.left && this.top < e.bottom && this.bottom > e.top;
};
Jn.prototype.overlapsAny = function(e) {
  for (var r = 0; r < e.length; r++)
    if (this.overlaps(e[r]))
      return !0;
  return !1;
};
Jn.prototype.within = function(e) {
  return this.top >= e.top && this.bottom <= e.bottom && this.left >= e.left && this.right <= e.right;
};
Jn.prototype.overlapsOppositeAxis = function(e, r) {
  switch (r) {
    case "+x":
      return this.left < e.left;
    case "-x":
      return this.right > e.right;
    case "+y":
      return this.top < e.top;
    case "-y":
      return this.bottom > e.bottom;
  }
};
Jn.prototype.intersectPercentage = function(e) {
  var r = Math.max(0, Math.min(this.right, e.right) - Math.max(this.left, e.left)), i = Math.max(0, Math.min(this.bottom, e.bottom) - Math.max(this.top, e.top)), t = r * i;
  return t / (this.height * this.width);
};
Jn.prototype.toCSSCompatValues = function(e) {
  return {
    top: this.top - e.top,
    bottom: e.bottom - this.bottom,
    left: this.left - e.left,
    right: e.right - this.right,
    height: this.height,
    width: this.width
  };
};
Jn.getSimpleBoxPosition = function(e) {
  var r = e.div ? e.div.offsetHeight : e.tagName ? e.offsetHeight : 0, i = e.div ? e.div.offsetWidth : e.tagName ? e.offsetWidth : 0, t = e.div ? e.div.offsetTop : e.tagName ? e.offsetTop : 0;
  e = e.div ? e.div.getBoundingClientRect() : e.tagName ? e.getBoundingClientRect() : e;
  var n = {
    left: e.left,
    right: e.right,
    top: e.top || t,
    height: e.height || r,
    bottom: e.bottom || t + (e.height || r),
    width: e.width || i
  };
  return n;
};
function uC(e, r, i, t) {
  function n(b, y) {
    for (var v, g = new Jn(b), E = 1, x = 0; x < y.length; x++) {
      for (; b.overlapsOppositeAxis(i, y[x]) || b.within(i) && b.overlapsAny(t); )
        b.move(y[x]);
      if (b.within(i))
        return b;
      var w = b.intersectPercentage(i);
      E > w && (v = new Jn(b), E = w), b = new Jn(g);
    }
    return v || g;
  }
  var a = new Jn(r), s = r.cue, o = oC(s), l = [];
  if (s.snapToLines) {
    var u;
    switch (s.vertical) {
      case "":
        l = ["+y", "-y"], u = "height";
        break;
      case "rl":
        l = ["+x", "-x"], u = "width";
        break;
      case "lr":
        l = ["-x", "+x"], u = "width";
        break;
    }
    var h = a.lineHeight, c = h * Math.round(o), d = i[u] + h, f = l[0];
    Math.abs(c) > d && (c = c < 0 ? -1 : 1, c *= Math.ceil(d / h) * h), o < 0 && (c += s.vertical === "" ? i.height : i.width, l = l.reverse()), a.move(f, c);
  } else {
    var m = a.lineHeight / i.height * 100;
    switch (s.lineAlign) {
      case "middle":
        o -= m / 2;
        break;
      case "end":
        o -= m;
        break;
    }
    switch (s.vertical) {
      case "":
        r.applyStyles({
          top: r.formatStyle(o, "%")
        });
        break;
      case "rl":
        r.applyStyles({
          left: r.formatStyle(o, "%")
        });
        break;
      case "lr":
        r.applyStyles({
          right: r.formatStyle(o, "%")
        });
        break;
    }
    l = ["+y", "-x", "+x", "-y"], a = new Jn(r);
  }
  var p = n(a, l);
  r.move(p.toCSSCompatValues(i));
}
function ac() {
}
ac.StringDecoder = function() {
  return {
    decode: function(e) {
      if (!e)
        return "";
      if (typeof e != "string")
        throw new Error("Error - expected string data.");
      return decodeURIComponent(encodeURIComponent(e));
    }
  };
};
ac.convertCueToDOMTree = function(e, r) {
  return !e || !r ? null : Hb(e, r);
};
var lC = 0.05, cC = "sans-serif", dC = "1.5%";
ac.processCues = function(e, r, i) {
  if (!e || !r || !i)
    return null;
  for (; i.firstChild; )
    i.removeChild(i.firstChild);
  var t = e.document.createElement("div");
  t.style.position = "absolute", t.style.left = "0", t.style.right = "0", t.style.top = "0", t.style.bottom = "0", t.style.margin = dC, i.appendChild(t);
  function n(h) {
    for (var c = 0; c < h.length; c++)
      if (h[c].hasBeenReset || !h[c].displayState)
        return !0;
    return !1;
  }
  if (!n(r)) {
    for (var a = 0; a < r.length; a++)
      t.appendChild(r[a].displayState);
    return;
  }
  var s = [], o = Jn.getSimpleBoxPosition(t), l = Math.round(o.height * lC * 100) / 100, u = {
    font: l + "px " + cC
  };
  (function() {
    for (var h, c, d = 0; d < r.length; d++)
      c = r[d], h = new Ff(e, c, u), t.appendChild(h.div), uC(e, h, o, s), c.displayState = h.div, s.push(Jn.getSimpleBoxPosition(h));
  })();
};
ac.Parser = function(e, r, i) {
  i || (i = r, r = {}), r || (r = {}), this.window = e, this.vttjs = r, this.state = "INITIAL", this.buffer = "", this.decoder = i || new TextDecoder("utf8"), this.regionList = [];
};
ac.Parser.prototype = {
  reportOrThrowError: function(e) {
    if (e instanceof Ea)
      this.onparsingerror && this.onparsingerror(e);
    else
      throw e;
  },
  parse: function(e) {
    var r = this;
    e && (r.buffer += r.decoder.decode(e, { stream: !0 }));
    function i() {
      for (var h = r.buffer, c = 0; c < h.length && h[c] !== "\r" && h[c] !== `
`; )
        ++c;
      var d = h.substr(0, c);
      return h[c] === "\r" && ++c, h[c] === `
` && ++c, r.buffer = h.substr(c), d;
    }
    function t(h) {
      var c = new Kc();
      if (Vc(h, function(f, m) {
        switch (f) {
          case "id":
            c.set(f, m);
            break;
          case "width":
            c.percent(f, m);
            break;
          case "lines":
            c.integer(f, m);
            break;
          case "regionanchor":
          case "viewportanchor":
            var p = m.split(",");
            if (p.length !== 2)
              break;
            var b = new Kc();
            if (b.percent("x", p[0]), b.percent("y", p[1]), !b.has("x") || !b.has("y"))
              break;
            c.set(f + "X", b.get("x")), c.set(f + "Y", b.get("y"));
            break;
          case "scroll":
            c.alt(f, m, ["up"]);
            break;
        }
      }, /=/, /\s/), c.has("id")) {
        var d = new (r.vttjs.VTTRegion || r.window.VTTRegion)();
        d.width = c.get("width", 100), d.lines = c.get("lines", 3), d.regionAnchorX = c.get("regionanchorX", 0), d.regionAnchorY = c.get("regionanchorY", 100), d.viewportAnchorX = c.get("viewportanchorX", 0), d.viewportAnchorY = c.get("viewportanchorY", 100), d.scroll = c.get("scroll", ""), r.onregion && r.onregion(d), r.regionList.push({
          id: c.get("id"),
          region: d
        });
      }
    }
    function n(h) {
      var c = new Kc();
      Vc(h, function(d, f) {
        switch (d) {
          case "MPEGT":
            c.integer(d + "S", f);
            break;
          case "LOCA":
            c.set(d + "L", gv(f));
            break;
        }
      }, /[^\d]:/, /,/), r.ontimestampmap && r.ontimestampmap({
        MPEGTS: c.get("MPEGTS"),
        LOCAL: c.get("LOCAL")
      });
    }
    function a(h) {
      h.match(/X-TIMESTAMP-MAP/) ? Vc(h, function(c, d) {
        switch (c) {
          case "X-TIMESTAMP-MAP":
            n(d);
            break;
        }
      }, /=/) : Vc(h, function(c, d) {
        switch (c) {
          case "Region":
            t(d);
            break;
        }
      }, /:/);
    }
    try {
      var s;
      if (r.state === "INITIAL") {
        if (!/\r\n|\n/.test(r.buffer))
          return this;
        s = i();
        var o = s.match(/^WEBVTT([ \t].*)?$/);
        if (!o || !o[0])
          throw new Ea(Ea.Errors.BadSignature);
        r.state = "HEADER";
      }
      for (var l = !1; r.buffer; ) {
        if (!/\r\n|\n/.test(r.buffer))
          return this;
        switch (l ? l = !1 : s = i(), r.state) {
          case "HEADER":
            /:/.test(s) ? a(s) : s || (r.state = "ID");
            continue;
          case "NOTE":
            s || (r.state = "ID");
            continue;
          case "ID":
            if (/^NOTE($|[ \t])/.test(s)) {
              r.state = "NOTE";
              break;
            }
            if (!s)
              continue;
            if (r.cue = new (r.vttjs.VTTCue || r.window.VTTCue)(0, 0, ""), r.state = "CUE", s.indexOf("-->") === -1) {
              r.cue.id = s;
              continue;
            }
          case "CUE":
            try {
              tC(s, r.cue, r.regionList);
            } catch (h) {
              r.reportOrThrowError(h), r.cue = null, r.state = "BADCUE";
              continue;
            }
            r.state = "CUETEXT";
            continue;
          case "CUETEXT":
            var u = s.indexOf("-->") !== -1;
            if (!s || u && (l = !0)) {
              r.oncue && r.oncue(r.cue), r.cue = null, r.state = "ID";
              continue;
            }
            r.cue.text && (r.cue.text += `
`), r.cue.text += s;
            continue;
          case "BADCUE":
            s || (r.state = "ID");
            continue;
        }
      }
    } catch (h) {
      r.reportOrThrowError(h), r.state === "CUETEXT" && r.cue && r.oncue && r.oncue(r.cue), r.cue = null, r.state = r.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  },
  flush: function() {
    var e = this;
    try {
      if (e.buffer += e.decoder.decode(), (e.cue || e.state === "HEADER") && (e.buffer += `

`, e.parse()), e.state === "INITIAL")
        throw new Ea(Ea.Errors.BadSignature);
    } catch (r) {
      e.reportOrThrowError(r);
    }
    return e.onflush && e.onflush(), this;
  }
};
var fC = ac, hC = "auto", pC = {
  "": 1,
  lr: 1,
  rl: 1
}, gC = {
  start: 1,
  middle: 1,
  end: 1,
  left: 1,
  right: 1
};
function vC(e) {
  if (typeof e != "string")
    return !1;
  var r = pC[e.toLowerCase()];
  return r ? e.toLowerCase() : !1;
}
function Rp(e) {
  if (typeof e != "string")
    return !1;
  var r = gC[e.toLowerCase()];
  return r ? e.toLowerCase() : !1;
}
function Vb(e, r, i) {
  this.hasBeenReset = !1;
  var t = "", n = !1, a = e, s = r, o = i, l = null, u = "", h = !0, c = "auto", d = "start", f = 50, m = "middle", p = 50, b = "middle";
  Object.defineProperties(this, {
    id: {
      enumerable: !0,
      get: function() {
        return t;
      },
      set: function(y) {
        t = "" + y;
      }
    },
    pauseOnExit: {
      enumerable: !0,
      get: function() {
        return n;
      },
      set: function(y) {
        n = !!y;
      }
    },
    startTime: {
      enumerable: !0,
      get: function() {
        return a;
      },
      set: function(y) {
        if (typeof y != "number")
          throw new TypeError("Start time must be set to a number.");
        a = y, this.hasBeenReset = !0;
      }
    },
    endTime: {
      enumerable: !0,
      get: function() {
        return s;
      },
      set: function(y) {
        if (typeof y != "number")
          throw new TypeError("End time must be set to a number.");
        s = y, this.hasBeenReset = !0;
      }
    },
    text: {
      enumerable: !0,
      get: function() {
        return o;
      },
      set: function(y) {
        o = "" + y, this.hasBeenReset = !0;
      }
    },
    region: {
      enumerable: !0,
      get: function() {
        return l;
      },
      set: function(y) {
        l = y, this.hasBeenReset = !0;
      }
    },
    vertical: {
      enumerable: !0,
      get: function() {
        return u;
      },
      set: function(y) {
        var v = vC(y);
        if (v === !1)
          throw new SyntaxError("An invalid or illegal string was specified.");
        u = v, this.hasBeenReset = !0;
      }
    },
    snapToLines: {
      enumerable: !0,
      get: function() {
        return h;
      },
      set: function(y) {
        h = !!y, this.hasBeenReset = !0;
      }
    },
    line: {
      enumerable: !0,
      get: function() {
        return c;
      },
      set: function(y) {
        if (typeof y != "number" && y !== hC)
          throw new SyntaxError("An invalid number or illegal string was specified.");
        c = y, this.hasBeenReset = !0;
      }
    },
    lineAlign: {
      enumerable: !0,
      get: function() {
        return d;
      },
      set: function(y) {
        var v = Rp(y);
        if (!v)
          throw new SyntaxError("An invalid or illegal string was specified.");
        d = v, this.hasBeenReset = !0;
      }
    },
    position: {
      enumerable: !0,
      get: function() {
        return f;
      },
      set: function(y) {
        if (y < 0 || y > 100)
          throw new Error("Position must be between 0 and 100.");
        f = y, this.hasBeenReset = !0;
      }
    },
    positionAlign: {
      enumerable: !0,
      get: function() {
        return m;
      },
      set: function(y) {
        var v = Rp(y);
        if (!v)
          throw new SyntaxError("An invalid or illegal string was specified.");
        m = v, this.hasBeenReset = !0;
      }
    },
    size: {
      enumerable: !0,
      get: function() {
        return p;
      },
      set: function(y) {
        if (y < 0 || y > 100)
          throw new Error("Size must be between 0 and 100.");
        p = y, this.hasBeenReset = !0;
      }
    },
    align: {
      enumerable: !0,
      get: function() {
        return b;
      },
      set: function(y) {
        var v = Rp(y);
        if (!v)
          throw new SyntaxError("An invalid or illegal string was specified.");
        b = v, this.hasBeenReset = !0;
      }
    }
  }), this.displayState = void 0;
}
Vb.prototype.getCueAsHTML = function() {
  return WebVTT.convertCueToDOMTree(window, this.text);
};
var mC = Vb, yC = {
  "": !0,
  up: !0
};
function _C(e) {
  if (typeof e != "string")
    return !1;
  var r = yC[e.toLowerCase()];
  return r ? e.toLowerCase() : !1;
}
function Rc(e) {
  return typeof e == "number" && e >= 0 && e <= 100;
}
function bC() {
  var e = 100, r = 3, i = 0, t = 100, n = 0, a = 100, s = "";
  Object.defineProperties(this, {
    width: {
      enumerable: !0,
      get: function() {
        return e;
      },
      set: function(o) {
        if (!Rc(o))
          throw new Error("Width must be between 0 and 100.");
        e = o;
      }
    },
    lines: {
      enumerable: !0,
      get: function() {
        return r;
      },
      set: function(o) {
        if (typeof o != "number")
          throw new TypeError("Lines must be set to a number.");
        r = o;
      }
    },
    regionAnchorY: {
      enumerable: !0,
      get: function() {
        return t;
      },
      set: function(o) {
        if (!Rc(o))
          throw new Error("RegionAnchorX must be between 0 and 100.");
        t = o;
      }
    },
    regionAnchorX: {
      enumerable: !0,
      get: function() {
        return i;
      },
      set: function(o) {
        if (!Rc(o))
          throw new Error("RegionAnchorY must be between 0 and 100.");
        i = o;
      }
    },
    viewportAnchorY: {
      enumerable: !0,
      get: function() {
        return a;
      },
      set: function(o) {
        if (!Rc(o))
          throw new Error("ViewportAnchorY must be between 0 and 100.");
        a = o;
      }
    },
    viewportAnchorX: {
      enumerable: !0,
      get: function() {
        return n;
      },
      set: function(o) {
        if (!Rc(o))
          throw new Error("ViewportAnchorX must be between 0 and 100.");
        n = o;
      }
    },
    scroll: {
      enumerable: !0,
      get: function() {
        return s;
      },
      set: function(o) {
        var l = _C(o);
        if (l === !1)
          throw new SyntaxError("An invalid or illegal string was specified.");
        s = l;
      }
    }
  });
}
var TC = bC, go = Be, rl = Eg.exports = {
  WebVTT: fC,
  VTTCue: mC,
  VTTRegion: TC
};
go.vttjs = rl;
go.WebVTT = rl.WebVTT;
var SC = rl.VTTCue, EC = rl.VTTRegion, xC = go.VTTCue, AC = go.VTTRegion;
rl.shim = function() {
  go.VTTCue = SC, go.VTTRegion = EC;
};
rl.restore = function() {
  go.VTTCue = xC, go.VTTRegion = AC;
};
go.VTTCue || rl.shim();
var qb = { exports: {} };
(function(e, r) {
  (function(i) {
    var t = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/, n = /^(?=([^\/?#]*))\1([^]*)$/, a = /(?:\/|^)\.(?=\/)/g, s = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, o = {
      buildAbsoluteURL: function(l, u, h) {
        if (h = h || {}, l = l.trim(), u = u.trim(), !u) {
          if (!h.alwaysNormalize)
            return l;
          var c = o.parseURL(l);
          if (!c)
            throw new Error("Error trying to parse base URL.");
          return c.path = o.normalizePath(
            c.path
          ), o.buildURLFromParts(c);
        }
        var d = o.parseURL(u);
        if (!d)
          throw new Error("Error trying to parse relative URL.");
        if (d.scheme)
          return h.alwaysNormalize ? (d.path = o.normalizePath(d.path), o.buildURLFromParts(d)) : u;
        var f = o.parseURL(l);
        if (!f)
          throw new Error("Error trying to parse base URL.");
        if (!f.netLoc && f.path && f.path[0] !== "/") {
          var m = n.exec(f.path);
          f.netLoc = m[1], f.path = m[2];
        }
        f.netLoc && !f.path && (f.path = "/");
        var p = {
          scheme: f.scheme,
          netLoc: d.netLoc,
          path: null,
          params: d.params,
          query: d.query,
          fragment: d.fragment
        };
        if (!d.netLoc && (p.netLoc = f.netLoc, d.path[0] !== "/"))
          if (!d.path)
            p.path = f.path, d.params || (p.params = f.params, d.query || (p.query = f.query));
          else {
            var b = f.path, y = b.substring(0, b.lastIndexOf("/") + 1) + d.path;
            p.path = o.normalizePath(y);
          }
        return p.path === null && (p.path = h.alwaysNormalize ? o.normalizePath(d.path) : d.path), o.buildURLFromParts(p);
      },
      parseURL: function(l) {
        var u = t.exec(l);
        return u ? {
          scheme: u[1] || "",
          netLoc: u[2] || "",
          path: u[3] || "",
          params: u[4] || "",
          query: u[5] || "",
          fragment: u[6] || ""
        } : null;
      },
      normalizePath: function(l) {
        for (l = l.split("").reverse().join("").replace(a, ""); l.length !== (l = l.replace(s, "")).length; )
          ;
        return l.split("").reverse().join("");
      },
      buildURLFromParts: function(l) {
        return l.scheme + l.netLoc + l.path + l.params + l.query + l.fragment;
      }
    };
    e.exports = o;
  })();
})(qb);
const Uf = qb.exports;
var vv = /* @__PURE__ */ function() {
  function e() {
    this.listeners = {};
  }
  var r = e.prototype;
  return r.on = function(t, n) {
    this.listeners[t] || (this.listeners[t] = []), this.listeners[t].push(n);
  }, r.off = function(t, n) {
    if (!this.listeners[t])
      return !1;
    var a = this.listeners[t].indexOf(n);
    return this.listeners[t] = this.listeners[t].slice(0), this.listeners[t].splice(a, 1), a > -1;
  }, r.trigger = function(t) {
    var n = this.listeners[t];
    if (!!n)
      if (arguments.length === 2)
        for (var a = n.length, s = 0; s < a; ++s)
          n[s].call(this, arguments[1]);
      else
        for (var o = Array.prototype.slice.call(arguments, 1), l = n.length, u = 0; u < l; ++u)
          n[u].apply(this, o);
  }, r.dispose = function() {
    this.listeners = {};
  }, r.pipe = function(t) {
    this.on("data", function(n) {
      t.push(n);
    });
  }, e;
}();
function Nl() {
  return Nl = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var i = arguments[r];
      for (var t in i)
        ({}).hasOwnProperty.call(i, t) && (e[t] = i[t]);
    }
    return e;
  }, Nl.apply(null, arguments);
}
var qc;
typeof window < "u" ? qc = window : typeof fn < "u" ? qc = fn : typeof self < "u" ? qc = self : qc = {};
var ai = qc, wC = function(r) {
  return ai.atob ? ai.atob(r) : Buffer.from(r, "base64").toString("binary");
};
function CC(e) {
  for (var r = wC(e), i = new Uint8Array(r.length), t = 0; t < r.length; t++)
    i[t] = r.charCodeAt(t);
  return i;
}
/*! @name m3u8-parser @version 7.2.0 @license Apache-2.0 */
class DC extends vv {
  constructor() {
    super(), this.buffer = "";
  }
  push(r) {
    let i;
    for (this.buffer += r, i = this.buffer.indexOf(`
`); i > -1; i = this.buffer.indexOf(`
`))
      this.trigger("data", this.buffer.substring(0, i)), this.buffer = this.buffer.substring(i + 1);
  }
}
const kC = String.fromCharCode(9), Pp = function(e) {
  const r = /([0-9.]*)?@?([0-9.]*)?/.exec(e || ""), i = {};
  return r[1] && (i.length = parseInt(r[1], 10)), r[2] && (i.offset = parseInt(r[2], 10)), i;
}, RC = function() {
  const e = "[^=]*", r = '"[^"]*"|[^,]*', i = "(?:" + e + ")=(?:" + r + ")";
  return new RegExp("(?:^|,)(" + i + ")");
}, Kn = function(e) {
  const r = {};
  if (!e)
    return r;
  const i = e.split(RC());
  let t = i.length, n;
  for (; t--; )
    i[t] !== "" && (n = /([^=]*)=(.*)/.exec(i[t]).slice(1), n[0] = n[0].replace(/^\s+|\s+$/g, ""), n[1] = n[1].replace(/^\s+|\s+$/g, ""), n[1] = n[1].replace(/^['"](.*)['"]$/g, "$1"), r[n[0]] = n[1]);
  return r;
}, Ny = (e) => {
  const r = e.split("x"), i = {};
  return r[0] && (i.width = parseInt(r[0], 10)), r[1] && (i.height = parseInt(r[1], 10)), i;
};
class PC extends vv {
  constructor() {
    super(), this.customParsers = [], this.tagMappers = [];
  }
  push(r) {
    let i, t;
    if (r = r.trim(), r.length === 0)
      return;
    if (r[0] !== "#") {
      this.trigger("data", {
        type: "uri",
        uri: r
      });
      return;
    }
    this.tagMappers.reduce((a, s) => {
      const o = s(r);
      return o === r ? a : a.concat([o]);
    }, [r]).forEach((a) => {
      for (let s = 0; s < this.customParsers.length; s++)
        if (this.customParsers[s].call(this, a))
          return;
      if (a.indexOf("#EXT") !== 0) {
        this.trigger("data", {
          type: "comment",
          text: a.slice(1)
        });
        return;
      }
      if (a = a.replace("\r", ""), i = /^#EXTM3U/.exec(a), i) {
        this.trigger("data", {
          type: "tag",
          tagType: "m3u"
        });
        return;
      }
      if (i = /^#EXTINF:([0-9\.]*)?,?(.*)?$/.exec(a), i) {
        t = {
          type: "tag",
          tagType: "inf"
        }, i[1] && (t.duration = parseFloat(i[1])), i[2] && (t.title = i[2]), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-TARGETDURATION:([0-9.]*)?/.exec(a), i) {
        t = {
          type: "tag",
          tagType: "targetduration"
        }, i[1] && (t.duration = parseInt(i[1], 10)), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-VERSION:([0-9.]*)?/.exec(a), i) {
        t = {
          type: "tag",
          tagType: "version"
        }, i[1] && (t.version = parseInt(i[1], 10)), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-MEDIA-SEQUENCE:(\-?[0-9.]*)?/.exec(a), i) {
        t = {
          type: "tag",
          tagType: "media-sequence"
        }, i[1] && (t.number = parseInt(i[1], 10)), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-DISCONTINUITY-SEQUENCE:(\-?[0-9.]*)?/.exec(a), i) {
        t = {
          type: "tag",
          tagType: "discontinuity-sequence"
        }, i[1] && (t.number = parseInt(i[1], 10)), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-PLAYLIST-TYPE:(.*)?$/.exec(a), i) {
        t = {
          type: "tag",
          tagType: "playlist-type"
        }, i[1] && (t.playlistType = i[1]), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-BYTERANGE:(.*)?$/.exec(a), i) {
        t = Nl(Pp(i[1]), {
          type: "tag",
          tagType: "byterange"
        }), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-ALLOW-CACHE:(YES|NO)?/.exec(a), i) {
        t = {
          type: "tag",
          tagType: "allow-cache"
        }, i[1] && (t.allowed = !/NO/.test(i[1])), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-MAP:(.*)$/.exec(a), i) {
        if (t = {
          type: "tag",
          tagType: "map"
        }, i[1]) {
          const s = Kn(i[1]);
          s.URI && (t.uri = s.URI), s.BYTERANGE && (t.byterange = Pp(s.BYTERANGE));
        }
        this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-STREAM-INF:(.*)$/.exec(a), i) {
        t = {
          type: "tag",
          tagType: "stream-inf"
        }, i[1] && (t.attributes = Kn(i[1]), t.attributes.RESOLUTION && (t.attributes.RESOLUTION = Ny(t.attributes.RESOLUTION)), t.attributes.BANDWIDTH && (t.attributes.BANDWIDTH = parseInt(t.attributes.BANDWIDTH, 10)), t.attributes["FRAME-RATE"] && (t.attributes["FRAME-RATE"] = parseFloat(t.attributes["FRAME-RATE"])), t.attributes["PROGRAM-ID"] && (t.attributes["PROGRAM-ID"] = parseInt(t.attributes["PROGRAM-ID"], 10))), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-MEDIA:(.*)$/.exec(a), i) {
        t = {
          type: "tag",
          tagType: "media"
        }, i[1] && (t.attributes = Kn(i[1])), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-ENDLIST/.exec(a), i) {
        this.trigger("data", {
          type: "tag",
          tagType: "endlist"
        });
        return;
      }
      if (i = /^#EXT-X-DISCONTINUITY/.exec(a), i) {
        this.trigger("data", {
          type: "tag",
          tagType: "discontinuity"
        });
        return;
      }
      if (i = /^#EXT-X-PROGRAM-DATE-TIME:(.*)$/.exec(a), i) {
        t = {
          type: "tag",
          tagType: "program-date-time"
        }, i[1] && (t.dateTimeString = i[1], t.dateTimeObject = new Date(i[1])), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-KEY:(.*)$/.exec(a), i) {
        t = {
          type: "tag",
          tagType: "key"
        }, i[1] && (t.attributes = Kn(i[1]), t.attributes.IV && (t.attributes.IV.substring(0, 2).toLowerCase() === "0x" && (t.attributes.IV = t.attributes.IV.substring(2)), t.attributes.IV = t.attributes.IV.match(/.{8}/g), t.attributes.IV[0] = parseInt(t.attributes.IV[0], 16), t.attributes.IV[1] = parseInt(t.attributes.IV[1], 16), t.attributes.IV[2] = parseInt(t.attributes.IV[2], 16), t.attributes.IV[3] = parseInt(t.attributes.IV[3], 16), t.attributes.IV = new Uint32Array(t.attributes.IV))), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-START:(.*)$/.exec(a), i) {
        t = {
          type: "tag",
          tagType: "start"
        }, i[1] && (t.attributes = Kn(i[1]), t.attributes["TIME-OFFSET"] = parseFloat(t.attributes["TIME-OFFSET"]), t.attributes.PRECISE = /YES/.test(t.attributes.PRECISE)), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-CUE-OUT-CONT:(.*)?$/.exec(a), i) {
        t = {
          type: "tag",
          tagType: "cue-out-cont"
        }, i[1] ? t.data = i[1] : t.data = "", this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-CUE-OUT:(.*)?$/.exec(a), i) {
        t = {
          type: "tag",
          tagType: "cue-out"
        }, i[1] ? t.data = i[1] : t.data = "", this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-CUE-IN:?(.*)?$/.exec(a), i) {
        t = {
          type: "tag",
          tagType: "cue-in"
        }, i[1] ? t.data = i[1] : t.data = "", this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-SKIP:(.*)$/.exec(a), i && i[1]) {
        t = {
          type: "tag",
          tagType: "skip"
        }, t.attributes = Kn(i[1]), t.attributes.hasOwnProperty("SKIPPED-SEGMENTS") && (t.attributes["SKIPPED-SEGMENTS"] = parseInt(t.attributes["SKIPPED-SEGMENTS"], 10)), t.attributes.hasOwnProperty("RECENTLY-REMOVED-DATERANGES") && (t.attributes["RECENTLY-REMOVED-DATERANGES"] = t.attributes["RECENTLY-REMOVED-DATERANGES"].split(kC)), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-PART:(.*)$/.exec(a), i && i[1]) {
        t = {
          type: "tag",
          tagType: "part"
        }, t.attributes = Kn(i[1]), ["DURATION"].forEach(function(s) {
          t.attributes.hasOwnProperty(s) && (t.attributes[s] = parseFloat(t.attributes[s]));
        }), ["INDEPENDENT", "GAP"].forEach(function(s) {
          t.attributes.hasOwnProperty(s) && (t.attributes[s] = /YES/.test(t.attributes[s]));
        }), t.attributes.hasOwnProperty("BYTERANGE") && (t.attributes.byterange = Pp(t.attributes.BYTERANGE)), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(a), i && i[1]) {
        t = {
          type: "tag",
          tagType: "server-control"
        }, t.attributes = Kn(i[1]), ["CAN-SKIP-UNTIL", "PART-HOLD-BACK", "HOLD-BACK"].forEach(function(s) {
          t.attributes.hasOwnProperty(s) && (t.attributes[s] = parseFloat(t.attributes[s]));
        }), ["CAN-SKIP-DATERANGES", "CAN-BLOCK-RELOAD"].forEach(function(s) {
          t.attributes.hasOwnProperty(s) && (t.attributes[s] = /YES/.test(t.attributes[s]));
        }), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-PART-INF:(.*)$/.exec(a), i && i[1]) {
        t = {
          type: "tag",
          tagType: "part-inf"
        }, t.attributes = Kn(i[1]), ["PART-TARGET"].forEach(function(s) {
          t.attributes.hasOwnProperty(s) && (t.attributes[s] = parseFloat(t.attributes[s]));
        }), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(a), i && i[1]) {
        t = {
          type: "tag",
          tagType: "preload-hint"
        }, t.attributes = Kn(i[1]), ["BYTERANGE-START", "BYTERANGE-LENGTH"].forEach(function(s) {
          if (t.attributes.hasOwnProperty(s)) {
            t.attributes[s] = parseInt(t.attributes[s], 10);
            const o = s === "BYTERANGE-LENGTH" ? "length" : "offset";
            t.attributes.byterange = t.attributes.byterange || {}, t.attributes.byterange[o] = t.attributes[s], delete t.attributes[s];
          }
        }), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(a), i && i[1]) {
        t = {
          type: "tag",
          tagType: "rendition-report"
        }, t.attributes = Kn(i[1]), ["LAST-MSN", "LAST-PART"].forEach(function(s) {
          t.attributes.hasOwnProperty(s) && (t.attributes[s] = parseInt(t.attributes[s], 10));
        }), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-DATERANGE:(.*)$/.exec(a), i && i[1]) {
        t = {
          type: "tag",
          tagType: "daterange"
        }, t.attributes = Kn(i[1]), ["ID", "CLASS"].forEach(function(o) {
          t.attributes.hasOwnProperty(o) && (t.attributes[o] = String(t.attributes[o]));
        }), ["START-DATE", "END-DATE"].forEach(function(o) {
          t.attributes.hasOwnProperty(o) && (t.attributes[o] = new Date(t.attributes[o]));
        }), ["DURATION", "PLANNED-DURATION"].forEach(function(o) {
          t.attributes.hasOwnProperty(o) && (t.attributes[o] = parseFloat(t.attributes[o]));
        }), ["END-ON-NEXT"].forEach(function(o) {
          t.attributes.hasOwnProperty(o) && (t.attributes[o] = /YES/i.test(t.attributes[o]));
        }), ["SCTE35-CMD", " SCTE35-OUT", "SCTE35-IN"].forEach(function(o) {
          t.attributes.hasOwnProperty(o) && (t.attributes[o] = t.attributes[o].toString(16));
        });
        const s = /^X-([A-Z]+-)+[A-Z]+$/;
        for (const o in t.attributes) {
          if (!s.test(o))
            continue;
          const l = /[0-9A-Fa-f]{6}/g.test(t.attributes[o]), u = /^\d+(\.\d+)?$/.test(t.attributes[o]);
          t.attributes[o] = l ? t.attributes[o].toString(16) : u ? parseFloat(t.attributes[o]) : String(t.attributes[o]);
        }
        this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-INDEPENDENT-SEGMENTS/.exec(a), i) {
        this.trigger("data", {
          type: "tag",
          tagType: "independent-segments"
        });
        return;
      }
      if (i = /^#EXT-X-I-FRAMES-ONLY/.exec(a), i) {
        this.trigger("data", {
          type: "tag",
          tagType: "i-frames-only"
        });
        return;
      }
      if (i = /^#EXT-X-CONTENT-STEERING:(.*)$/.exec(a), i) {
        t = {
          type: "tag",
          tagType: "content-steering"
        }, t.attributes = Kn(i[1]), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-I-FRAME-STREAM-INF:(.*)$/.exec(a), i) {
        t = {
          type: "tag",
          tagType: "i-frame-playlist"
        }, t.attributes = Kn(i[1]), t.attributes.URI && (t.uri = t.attributes.URI), t.attributes.BANDWIDTH && (t.attributes.BANDWIDTH = parseInt(t.attributes.BANDWIDTH, 10)), t.attributes.RESOLUTION && (t.attributes.RESOLUTION = Ny(t.attributes.RESOLUTION)), t.attributes["AVERAGE-BANDWIDTH"] && (t.attributes["AVERAGE-BANDWIDTH"] = parseInt(t.attributes["AVERAGE-BANDWIDTH"], 10)), t.attributes["FRAME-RATE"] && (t.attributes["FRAME-RATE"] = parseFloat(t.attributes["FRAME-RATE"])), this.trigger("data", t);
        return;
      }
      if (i = /^#EXT-X-DEFINE:(.*)$/.exec(a), i) {
        t = {
          type: "tag",
          tagType: "define"
        }, t.attributes = Kn(i[1]), this.trigger("data", t);
        return;
      }
      this.trigger("data", {
        type: "tag",
        data: a.slice(4)
      });
    });
  }
  addParser({
    expression: r,
    customType: i,
    dataParser: t,
    segment: n
  }) {
    typeof t != "function" && (t = (a) => a), this.customParsers.push((a) => {
      if (r.exec(a))
        return this.trigger("data", {
          type: "custom",
          data: t(a),
          customType: i,
          segment: n
        }), !0;
    });
  }
  addTagMapper({
    expression: r,
    map: i
  }) {
    const t = (n) => r.test(n) ? i(n) : n;
    this.tagMappers.push(t);
  }
}
const OC = (e) => e.toLowerCase().replace(/-(\w)/g, (r) => r[1].toUpperCase()), Go = function(e) {
  const r = {};
  return Object.keys(e).forEach(function(i) {
    r[OC(i)] = e[i];
  }), r;
}, Op = function(e) {
  const {
    serverControl: r,
    targetDuration: i,
    partTargetDuration: t
  } = e;
  if (!r)
    return;
  const n = "#EXT-X-SERVER-CONTROL", a = "holdBack", s = "partHoldBack", o = i && i * 3, l = t && t * 2;
  i && !r.hasOwnProperty(a) && (r[a] = o, this.trigger("info", {
    message: `${n} defaulting HOLD-BACK to targetDuration * 3 (${o}).`
  })), o && r[a] < o && (this.trigger("warn", {
    message: `${n} clamping HOLD-BACK (${r[a]}) to targetDuration * 3 (${o})`
  }), r[a] = o), t && !r.hasOwnProperty(s) && (r[s] = t * 3, this.trigger("info", {
    message: `${n} defaulting PART-HOLD-BACK to partTargetDuration * 3 (${r[s]}).`
  })), t && r[s] < l && (this.trigger("warn", {
    message: `${n} clamping PART-HOLD-BACK (${r[s]}) to partTargetDuration * 2 (${l}).`
  }), r[s] = l);
};
class xg extends vv {
  constructor(r = {}) {
    super(), this.lineStream = new DC(), this.parseStream = new PC(), this.lineStream.pipe(this.parseStream), this.mainDefinitions = r.mainDefinitions || {}, this.params = new URL(r.uri, "https://a.com").searchParams, this.lastProgramDateTime = null;
    const i = this, t = [];
    let n = {}, a, s, o = !1;
    const l = function() {
    }, u = {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    }, h = "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed";
    let c = 0;
    this.manifest = {
      allowCache: !0,
      discontinuityStarts: [],
      dateRanges: [],
      iFramePlaylists: [],
      segments: []
    };
    let d = 0, f = 0;
    const m = {};
    this.on("end", () => {
      n.uri || !n.parts && !n.preloadHints || (!n.map && a && (n.map = a), !n.key && s && (n.key = s), !n.timeline && typeof c == "number" && (n.timeline = c), this.manifest.preloadSegment = n);
    }), this.parseStream.on("data", function(p) {
      let b, y;
      if (i.manifest.definitions) {
        for (const v in i.manifest.definitions)
          if (p.uri && (p.uri = p.uri.replace(`{$${v}}`, i.manifest.definitions[v])), p.attributes)
            for (const g in p.attributes)
              typeof p.attributes[g] == "string" && (p.attributes[g] = p.attributes[g].replace(`{$${v}}`, i.manifest.definitions[v]));
      }
      ({
        tag() {
          ({
            version() {
              p.version && (this.manifest.version = p.version);
            },
            "allow-cache"() {
              this.manifest.allowCache = p.allowed, "allowed" in p || (this.trigger("info", {
                message: "defaulting allowCache to YES"
              }), this.manifest.allowCache = !0);
            },
            byterange() {
              const v = {};
              "length" in p && (n.byterange = v, v.length = p.length, "offset" in p || (p.offset = d)), "offset" in p && (n.byterange = v, v.offset = p.offset), d = v.offset + v.length;
            },
            endlist() {
              this.manifest.endList = !0;
            },
            inf() {
              "mediaSequence" in this.manifest || (this.manifest.mediaSequence = 0, this.trigger("info", {
                message: "defaulting media sequence to zero"
              })), "discontinuitySequence" in this.manifest || (this.manifest.discontinuitySequence = 0, this.trigger("info", {
                message: "defaulting discontinuity sequence to zero"
              })), p.title && (n.title = p.title), p.duration > 0 && (n.duration = p.duration), p.duration === 0 && (n.duration = 0.01, this.trigger("info", {
                message: "updating zero segment duration to a small value"
              })), this.manifest.segments = t;
            },
            key() {
              if (!p.attributes) {
                this.trigger("warn", {
                  message: "ignoring key declaration without attribute list"
                });
                return;
              }
              if (p.attributes.METHOD === "NONE") {
                s = null;
                return;
              }
              if (!p.attributes.URI) {
                this.trigger("warn", {
                  message: "ignoring key declaration without URI"
                });
                return;
              }
              if (p.attributes.KEYFORMAT === "com.apple.streamingkeydelivery") {
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.apple.fps.1_0"] = {
                  attributes: p.attributes
                };
                return;
              }
              if (p.attributes.KEYFORMAT === "com.microsoft.playready") {
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.microsoft.playready"] = {
                  uri: p.attributes.URI
                };
                return;
              }
              if (p.attributes.KEYFORMAT === h) {
                if (["SAMPLE-AES", "SAMPLE-AES-CTR", "SAMPLE-AES-CENC"].indexOf(p.attributes.METHOD) === -1) {
                  this.trigger("warn", {
                    message: "invalid key method provided for Widevine"
                  });
                  return;
                }
                if (p.attributes.METHOD === "SAMPLE-AES-CENC" && this.trigger("warn", {
                  message: "SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead"
                }), p.attributes.URI.substring(0, 23) !== "data:text/plain;base64,") {
                  this.trigger("warn", {
                    message: "invalid key URI provided for Widevine"
                  });
                  return;
                }
                if (!(p.attributes.KEYID && p.attributes.KEYID.substring(0, 2) === "0x")) {
                  this.trigger("warn", {
                    message: "invalid key ID provided for Widevine"
                  });
                  return;
                }
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.widevine.alpha"] = {
                  attributes: {
                    schemeIdUri: p.attributes.KEYFORMAT,
                    keyId: p.attributes.KEYID.substring(2)
                  },
                  pssh: CC(p.attributes.URI.split(",")[1])
                };
                return;
              }
              p.attributes.METHOD || this.trigger("warn", {
                message: "defaulting key method to AES-128"
              }), s = {
                method: p.attributes.METHOD || "AES-128",
                uri: p.attributes.URI
              }, typeof p.attributes.IV < "u" && (s.iv = p.attributes.IV);
            },
            "media-sequence"() {
              if (!isFinite(p.number)) {
                this.trigger("warn", {
                  message: "ignoring invalid media sequence: " + p.number
                });
                return;
              }
              this.manifest.mediaSequence = p.number;
            },
            "discontinuity-sequence"() {
              if (!isFinite(p.number)) {
                this.trigger("warn", {
                  message: "ignoring invalid discontinuity sequence: " + p.number
                });
                return;
              }
              this.manifest.discontinuitySequence = p.number, c = p.number;
            },
            "playlist-type"() {
              if (!/VOD|EVENT/.test(p.playlistType)) {
                this.trigger("warn", {
                  message: "ignoring unknown playlist type: " + p.playlist
                });
                return;
              }
              this.manifest.playlistType = p.playlistType;
            },
            map() {
              a = {}, p.uri && (a.uri = p.uri), p.byterange && (a.byterange = p.byterange), s && (a.key = s);
            },
            "stream-inf"() {
              if (this.manifest.playlists = t, this.manifest.mediaGroups = this.manifest.mediaGroups || u, !p.attributes) {
                this.trigger("warn", {
                  message: "ignoring empty stream-inf attributes"
                });
                return;
              }
              n.attributes || (n.attributes = {}), Nl(n.attributes, p.attributes);
            },
            media() {
              if (this.manifest.mediaGroups = this.manifest.mediaGroups || u, !(p.attributes && p.attributes.TYPE && p.attributes["GROUP-ID"] && p.attributes.NAME)) {
                this.trigger("warn", {
                  message: "ignoring incomplete or missing media group"
                });
                return;
              }
              const v = this.manifest.mediaGroups[p.attributes.TYPE];
              v[p.attributes["GROUP-ID"]] = v[p.attributes["GROUP-ID"]] || {}, b = v[p.attributes["GROUP-ID"]], y = {
                default: /yes/i.test(p.attributes.DEFAULT)
              }, y.default ? y.autoselect = !0 : y.autoselect = /yes/i.test(p.attributes.AUTOSELECT), p.attributes.LANGUAGE && (y.language = p.attributes.LANGUAGE), p.attributes.URI && (y.uri = p.attributes.URI), p.attributes["INSTREAM-ID"] && (y.instreamId = p.attributes["INSTREAM-ID"]), p.attributes.CHARACTERISTICS && (y.characteristics = p.attributes.CHARACTERISTICS), p.attributes.FORCED && (y.forced = /yes/i.test(p.attributes.FORCED)), b[p.attributes.NAME] = y;
            },
            discontinuity() {
              c += 1, n.discontinuity = !0, this.manifest.discontinuityStarts.push(t.length);
            },
            "program-date-time"() {
              typeof this.manifest.dateTimeString > "u" && (this.manifest.dateTimeString = p.dateTimeString, this.manifest.dateTimeObject = p.dateTimeObject), n.dateTimeString = p.dateTimeString, n.dateTimeObject = p.dateTimeObject;
              const {
                lastProgramDateTime: v
              } = this;
              this.lastProgramDateTime = new Date(p.dateTimeString).getTime(), v === null && this.manifest.segments.reduceRight((g, E) => (E.programDateTime = g - E.duration * 1e3, E.programDateTime), this.lastProgramDateTime);
            },
            targetduration() {
              if (!isFinite(p.duration) || p.duration < 0) {
                this.trigger("warn", {
                  message: "ignoring invalid target duration: " + p.duration
                });
                return;
              }
              this.manifest.targetDuration = p.duration, Op.call(this, this.manifest);
            },
            start() {
              if (!p.attributes || isNaN(p.attributes["TIME-OFFSET"])) {
                this.trigger("warn", {
                  message: "ignoring start declaration without appropriate attribute list"
                });
                return;
              }
              this.manifest.start = {
                timeOffset: p.attributes["TIME-OFFSET"],
                precise: p.attributes.PRECISE
              };
            },
            "cue-out"() {
              n.cueOut = p.data;
            },
            "cue-out-cont"() {
              n.cueOutCont = p.data;
            },
            "cue-in"() {
              n.cueIn = p.data;
            },
            skip() {
              this.manifest.skip = Go(p.attributes), this.warnOnMissingAttributes_("#EXT-X-SKIP", p.attributes, ["SKIPPED-SEGMENTS"]);
            },
            part() {
              o = !0;
              const v = this.manifest.segments.length, g = Go(p.attributes);
              n.parts = n.parts || [], n.parts.push(g), g.byterange && (g.byterange.hasOwnProperty("offset") || (g.byterange.offset = f), f = g.byterange.offset + g.byterange.length);
              const E = n.parts.length - 1;
              this.warnOnMissingAttributes_(`#EXT-X-PART #${E} for segment #${v}`, p.attributes, ["URI", "DURATION"]), this.manifest.renditionReports && this.manifest.renditionReports.forEach((x, w) => {
                x.hasOwnProperty("lastPart") || this.trigger("warn", {
                  message: `#EXT-X-RENDITION-REPORT #${w} lacks required attribute(s): LAST-PART`
                });
              });
            },
            "server-control"() {
              const v = this.manifest.serverControl = Go(p.attributes);
              v.hasOwnProperty("canBlockReload") || (v.canBlockReload = !1, this.trigger("info", {
                message: "#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false"
              })), Op.call(this, this.manifest), v.canSkipDateranges && !v.hasOwnProperty("canSkipUntil") && this.trigger("warn", {
                message: "#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set"
              });
            },
            "preload-hint"() {
              const v = this.manifest.segments.length, g = Go(p.attributes), E = g.type && g.type === "PART";
              n.preloadHints = n.preloadHints || [], n.preloadHints.push(g), g.byterange && (g.byterange.hasOwnProperty("offset") || (g.byterange.offset = E ? f : 0, E && (f = g.byterange.offset + g.byterange.length)));
              const x = n.preloadHints.length - 1;
              if (this.warnOnMissingAttributes_(`#EXT-X-PRELOAD-HINT #${x} for segment #${v}`, p.attributes, ["TYPE", "URI"]), !!g.type)
                for (let w = 0; w < n.preloadHints.length - 1; w++) {
                  const S = n.preloadHints[w];
                  !S.type || S.type === g.type && this.trigger("warn", {
                    message: `#EXT-X-PRELOAD-HINT #${x} for segment #${v} has the same TYPE ${g.type} as preload hint #${w}`
                  });
                }
            },
            "rendition-report"() {
              const v = Go(p.attributes);
              this.manifest.renditionReports = this.manifest.renditionReports || [], this.manifest.renditionReports.push(v);
              const g = this.manifest.renditionReports.length - 1, E = ["LAST-MSN", "URI"];
              o && E.push("LAST-PART"), this.warnOnMissingAttributes_(`#EXT-X-RENDITION-REPORT #${g}`, p.attributes, E);
            },
            "part-inf"() {
              this.manifest.partInf = Go(p.attributes), this.warnOnMissingAttributes_("#EXT-X-PART-INF", p.attributes, ["PART-TARGET"]), this.manifest.partInf.partTarget && (this.manifest.partTargetDuration = this.manifest.partInf.partTarget), Op.call(this, this.manifest);
            },
            daterange() {
              this.manifest.dateRanges.push(Go(p.attributes));
              const v = this.manifest.dateRanges.length - 1;
              this.warnOnMissingAttributes_(`#EXT-X-DATERANGE #${v}`, p.attributes, ["ID", "START-DATE"]);
              const g = this.manifest.dateRanges[v];
              g.endDate && g.startDate && new Date(g.endDate) < new Date(g.startDate) && this.trigger("warn", {
                message: "EXT-X-DATERANGE END-DATE must be equal to or later than the value of the START-DATE"
              }), g.duration && g.duration < 0 && this.trigger("warn", {
                message: "EXT-X-DATERANGE DURATION must not be negative"
              }), g.plannedDuration && g.plannedDuration < 0 && this.trigger("warn", {
                message: "EXT-X-DATERANGE PLANNED-DURATION must not be negative"
              });
              const E = !!g.endOnNext;
              if (E && !g.class && this.trigger("warn", {
                message: "EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must have a CLASS attribute"
              }), E && (g.duration || g.endDate) && this.trigger("warn", {
                message: "EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must not contain DURATION or END-DATE attributes"
              }), g.duration && g.endDate) {
                const w = g.startDate.getTime() + g.duration * 1e3;
                this.manifest.dateRanges[v].endDate = new Date(w);
              }
              if (!m[g.id])
                m[g.id] = g;
              else {
                for (const w in m[g.id])
                  if (!!g[w] && JSON.stringify(m[g.id][w]) !== JSON.stringify(g[w])) {
                    this.trigger("warn", {
                      message: "EXT-X-DATERANGE tags with the same ID in a playlist must have the same attributes values"
                    });
                    break;
                  }
                const x = this.manifest.dateRanges.findIndex((w) => w.id === g.id);
                this.manifest.dateRanges[x] = Nl(this.manifest.dateRanges[x], g), m[g.id] = Nl(m[g.id], g), this.manifest.dateRanges.pop();
              }
            },
            "independent-segments"() {
              this.manifest.independentSegments = !0;
            },
            "i-frames-only"() {
              this.manifest.iFramesOnly = !0, this.requiredCompatibilityversion(this.manifest.version, 4);
            },
            "content-steering"() {
              this.manifest.contentSteering = Go(p.attributes), this.warnOnMissingAttributes_("#EXT-X-CONTENT-STEERING", p.attributes, ["SERVER-URI"]);
            },
            define() {
              this.manifest.definitions = this.manifest.definitions || {};
              const v = (g, E) => {
                if (g in this.manifest.definitions) {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: Duplicate name ${g}`
                  });
                  return;
                }
                this.manifest.definitions[g] = E;
              };
              if ("QUERYPARAM" in p.attributes) {
                if ("NAME" in p.attributes || "IMPORT" in p.attributes) {
                  this.trigger("error", {
                    message: "EXT-X-DEFINE: Invalid attributes"
                  });
                  return;
                }
                const g = this.params.get(p.attributes.QUERYPARAM);
                if (!g) {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: No query param ${p.attributes.QUERYPARAM}`
                  });
                  return;
                }
                v(p.attributes.QUERYPARAM, decodeURIComponent(g));
                return;
              }
              if ("NAME" in p.attributes) {
                if ("IMPORT" in p.attributes) {
                  this.trigger("error", {
                    message: "EXT-X-DEFINE: Invalid attributes"
                  });
                  return;
                }
                if (!("VALUE" in p.attributes) || typeof p.attributes.VALUE != "string") {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: No value for ${p.attributes.NAME}`
                  });
                  return;
                }
                v(p.attributes.NAME, p.attributes.VALUE);
                return;
              }
              if ("IMPORT" in p.attributes) {
                if (!this.mainDefinitions[p.attributes.IMPORT]) {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: No value ${p.attributes.IMPORT} to import, or IMPORT used on main playlist`
                  });
                  return;
                }
                v(p.attributes.IMPORT, this.mainDefinitions[p.attributes.IMPORT]);
                return;
              }
              this.trigger("error", {
                message: "EXT-X-DEFINE: No attribute"
              });
            },
            "i-frame-playlist"() {
              this.manifest.iFramePlaylists.push({
                attributes: p.attributes,
                uri: p.uri,
                timeline: c
              }), this.warnOnMissingAttributes_("#EXT-X-I-FRAME-STREAM-INF", p.attributes, ["BANDWIDTH", "URI"]);
            }
          }[p.tagType] || l).call(i);
        },
        uri() {
          n.uri = p.uri, t.push(n), this.manifest.targetDuration && !("duration" in n) && (this.trigger("warn", {
            message: "defaulting segment duration to the target duration"
          }), n.duration = this.manifest.targetDuration), s && (n.key = s), n.timeline = c, a && (n.map = a), f = 0, this.lastProgramDateTime !== null && (n.programDateTime = this.lastProgramDateTime, this.lastProgramDateTime += n.duration * 1e3), n = {};
        },
        comment() {
        },
        custom() {
          p.segment ? (n.custom = n.custom || {}, n.custom[p.customType] = p.data) : (this.manifest.custom = this.manifest.custom || {}, this.manifest.custom[p.customType] = p.data);
        }
      })[p.type].call(i);
    });
  }
  requiredCompatibilityversion(r, i) {
    (r < i || !r) && this.trigger("warn", {
      message: `manifest must be at least version ${i}`
    });
  }
  warnOnMissingAttributes_(r, i, t) {
    const n = [];
    t.forEach(function(a) {
      i.hasOwnProperty(a) || n.push(a);
    }), n.length && this.trigger("warn", {
      message: `${r} lacks required attribute(s): ${n.join(", ")}`
    });
  }
  push(r) {
    this.lineStream.push(r);
  }
  end() {
    this.lineStream.push(`
`), this.manifest.dateRanges.length && this.lastProgramDateTime === null && this.trigger("warn", {
      message: "A playlist with EXT-X-DATERANGE tag must contain atleast one EXT-X-PROGRAM-DATE-TIME tag"
    }), this.lastProgramDateTime = null, this.trigger("end");
  }
  addParser(r) {
    this.parseStream.addParser(r);
  }
  addTagMapper(r) {
    this.parseStream.addTagMapper(r);
  }
}
var Fy = "http://example.com", mv = function(r, i) {
  if (/^[a-z]+:/i.test(i))
    return i;
  /^data:/.test(r) && (r = ai.location && ai.location.href || "");
  var t = typeof ai.URL == "function", n = /^\/\//.test(r), a = !ai.location && !/\/\//i.test(r);
  if (t ? r = new ai.URL(r, ai.location || Fy) : /\/\//i.test(r) || (r = Uf.buildAbsoluteURL(ai.location && ai.location.href || "", r)), t) {
    var s = new URL(i, r);
    return a ? s.href.slice(Fy.length) : n ? s.href.slice(s.protocol.length) : s.href;
  }
  return Uf.buildAbsoluteURL(r, i);
}, LC = function(r, i, t) {
  i.forEach(function(n) {
    for (var a in r.mediaGroups[n])
      for (var s in r.mediaGroups[n][a]) {
        var o = r.mediaGroups[n][a][s];
        t(o, n, a, s);
      }
  });
}, IC = function(r) {
  return ai.atob ? ai.atob(r) : Buffer.from(r, "base64").toString("binary");
};
function MC(e) {
  for (var r = IC(e), i = new Uint8Array(r.length), t = 0; t < r.length; t++)
    i[t] = r.charCodeAt(t);
  return i;
}
var ou = {}, To = {};
function NC(e, r, i) {
  if (i === void 0 && (i = Array.prototype), e && typeof i.find == "function")
    return i.find.call(e, r);
  for (var t = 0; t < e.length; t++)
    if (Object.prototype.hasOwnProperty.call(e, t)) {
      var n = e[t];
      if (r.call(void 0, n, t, e))
        return n;
    }
}
function yv(e, r) {
  return r === void 0 && (r = Object), r && typeof r.freeze == "function" ? r.freeze(e) : e;
}
function FC(e, r) {
  if (e === null || typeof e != "object")
    throw new TypeError("target is not an object");
  for (var i in r)
    Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
  return e;
}
var Wb = yv({
  HTML: "text/html",
  isHTML: function(e) {
    return e === Wb.HTML;
  },
  XML_APPLICATION: "application/xml",
  XML_TEXT: "text/xml",
  XML_XHTML_APPLICATION: "application/xhtml+xml",
  XML_SVG_IMAGE: "image/svg+xml"
}), Yb = yv({
  HTML: "http://www.w3.org/1999/xhtml",
  isHTML: function(e) {
    return e === Yb.HTML;
  },
  SVG: "http://www.w3.org/2000/svg",
  XML: "http://www.w3.org/XML/1998/namespace",
  XMLNS: "http://www.w3.org/2000/xmlns/"
});
To.assign = FC;
To.find = NC;
To.freeze = yv;
To.MIME_TYPE = Wb;
To.NAMESPACE = Yb;
var Kb = To, Ns = Kb.find, td = Kb.NAMESPACE;
function UC(e) {
  return e !== "";
}
function BC(e) {
  return e ? e.split(/[\t\n\f\r ]+/).filter(UC) : [];
}
function jC(e, r) {
  return e.hasOwnProperty(r) || (e[r] = !0), e;
}
function Uy(e) {
  if (!e)
    return [];
  var r = BC(e);
  return Object.keys(r.reduce(jC, {}));
}
function $C(e) {
  return function(r) {
    return e && e.indexOf(r) !== -1;
  };
}
function Sd(e, r) {
  for (var i in e)
    Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
}
function ca(e, r) {
  var i = e.prototype;
  if (!(i instanceof r)) {
    let t = function() {
    };
    t.prototype = r.prototype, t = new t(), Sd(i, t), e.prototype = i = t;
  }
  i.constructor != e && (typeof e != "function" && console.error("unknown Class:" + e), i.constructor = e);
}
var da = {}, ls = da.ELEMENT_NODE = 1, ql = da.ATTRIBUTE_NODE = 2, Bf = da.TEXT_NODE = 3, zb = da.CDATA_SECTION_NODE = 4, Xb = da.ENTITY_REFERENCE_NODE = 5, GC = da.ENTITY_NODE = 6, Jb = da.PROCESSING_INSTRUCTION_NODE = 7, Qb = da.COMMENT_NODE = 8, Zb = da.DOCUMENT_NODE = 9, eT = da.DOCUMENT_TYPE_NODE = 10, vo = da.DOCUMENT_FRAGMENT_NODE = 11, HC = da.NOTATION_NODE = 12, Bn = {}, gn = {};
Bn.INDEX_SIZE_ERR = (gn[1] = "Index size error", 1);
Bn.DOMSTRING_SIZE_ERR = (gn[2] = "DOMString size error", 2);
var oa = Bn.HIERARCHY_REQUEST_ERR = (gn[3] = "Hierarchy request error", 3);
Bn.WRONG_DOCUMENT_ERR = (gn[4] = "Wrong document", 4);
Bn.INVALID_CHARACTER_ERR = (gn[5] = "Invalid character", 5);
Bn.NO_DATA_ALLOWED_ERR = (gn[6] = "No data allowed", 6);
Bn.NO_MODIFICATION_ALLOWED_ERR = (gn[7] = "No modification allowed", 7);
var tT = Bn.NOT_FOUND_ERR = (gn[8] = "Not found", 8);
Bn.NOT_SUPPORTED_ERR = (gn[9] = "Not supported", 9);
var By = Bn.INUSE_ATTRIBUTE_ERR = (gn[10] = "Attribute in use", 10);
Bn.INVALID_STATE_ERR = (gn[11] = "Invalid state", 11);
Bn.SYNTAX_ERR = (gn[12] = "Syntax error", 12);
Bn.INVALID_MODIFICATION_ERR = (gn[13] = "Invalid modification", 13);
Bn.NAMESPACE_ERR = (gn[14] = "Invalid namespace", 14);
Bn.INVALID_ACCESS_ERR = (gn[15] = "Invalid access", 15);
function Yi(e, r) {
  if (r instanceof Error)
    var i = r;
  else
    i = this, Error.call(this, gn[e]), this.message = gn[e], Error.captureStackTrace && Error.captureStackTrace(this, Yi);
  return i.code = e, r && (this.message = this.message + ": " + r), i;
}
Yi.prototype = Error.prototype;
Sd(Bn, Yi);
function uo() {
}
uo.prototype = {
  length: 0,
  item: function(e) {
    return e >= 0 && e < this.length ? this[e] : null;
  },
  toString: function(e, r) {
    for (var i = [], t = 0; t < this.length; t++)
      kl(this[t], i, e, r);
    return i.join("");
  },
  filter: function(e) {
    return Array.prototype.filter.call(this, e);
  },
  indexOf: function(e) {
    return Array.prototype.indexOf.call(this, e);
  }
};
function Wl(e, r) {
  this._node = e, this._refresh = r, _v(this);
}
function _v(e) {
  var r = e._node._inc || e._node.ownerDocument._inc;
  if (e._inc !== r) {
    var i = e._refresh(e._node);
    if (hT(e, "length", i.length), !e.$$length || i.length < e.$$length)
      for (var t = i.length; t in e; t++)
        Object.prototype.hasOwnProperty.call(e, t) && delete e[t];
    Sd(i, e), e._inc = r;
  }
}
Wl.prototype.item = function(e) {
  return _v(this), this[e] || null;
};
ca(Wl, uo);
function jf() {
}
function rT(e, r) {
  for (var i = e.length; i--; )
    if (e[i] === r)
      return i;
}
function jy(e, r, i, t) {
  if (t ? r[rT(r, t)] = i : r[r.length++] = i, e) {
    i.ownerElement = e;
    var n = e.ownerDocument;
    n && (t && aT(n, e, t), VC(n, e, i));
  }
}
function $y(e, r, i) {
  var t = rT(r, i);
  if (t >= 0) {
    for (var n = r.length - 1; t < n; )
      r[t] = r[++t];
    if (r.length = n, e) {
      var a = e.ownerDocument;
      a && (aT(a, e, i), i.ownerElement = null);
    }
  } else
    throw new Yi(tT, new Error(e.tagName + "@" + i));
}
jf.prototype = {
  length: 0,
  item: uo.prototype.item,
  getNamedItem: function(e) {
    for (var r = this.length; r--; ) {
      var i = this[r];
      if (i.nodeName == e)
        return i;
    }
  },
  setNamedItem: function(e) {
    var r = e.ownerElement;
    if (r && r != this._ownerElement)
      throw new Yi(By);
    var i = this.getNamedItem(e.nodeName);
    return jy(this._ownerElement, this, e, i), i;
  },
  setNamedItemNS: function(e) {
    var r = e.ownerElement, i;
    if (r && r != this._ownerElement)
      throw new Yi(By);
    return i = this.getNamedItemNS(e.namespaceURI, e.localName), jy(this._ownerElement, this, e, i), i;
  },
  removeNamedItem: function(e) {
    var r = this.getNamedItem(e);
    return $y(this._ownerElement, this, r), r;
  },
  removeNamedItemNS: function(e, r) {
    var i = this.getNamedItemNS(e, r);
    return $y(this._ownerElement, this, i), i;
  },
  getNamedItemNS: function(e, r) {
    for (var i = this.length; i--; ) {
      var t = this[i];
      if (t.localName == r && t.namespaceURI == e)
        return t;
    }
    return null;
  }
};
function iT() {
}
iT.prototype = {
  hasFeature: function(e, r) {
    return !0;
  },
  createDocument: function(e, r, i) {
    var t = new Ed();
    if (t.implementation = this, t.childNodes = new uo(), t.doctype = i || null, i && t.appendChild(i), r) {
      var n = t.createElementNS(e, r);
      t.appendChild(n);
    }
    return t;
  },
  createDocumentType: function(e, r, i) {
    var t = new xh();
    return t.name = e, t.nodeName = e, t.publicId = r || "", t.systemId = i || "", t;
  }
};
function mi() {
}
mi.prototype = {
  firstChild: null,
  lastChild: null,
  previousSibling: null,
  nextSibling: null,
  attributes: null,
  parentNode: null,
  childNodes: null,
  ownerDocument: null,
  nodeValue: null,
  namespaceURI: null,
  prefix: null,
  localName: null,
  insertBefore: function(e, r) {
    return $f(this, e, r);
  },
  replaceChild: function(e, r) {
    $f(this, e, r, oT), r && this.removeChild(r);
  },
  removeChild: function(e) {
    return sT(this, e);
  },
  appendChild: function(e) {
    return this.insertBefore(e, null);
  },
  hasChildNodes: function() {
    return this.firstChild != null;
  },
  cloneNode: function(e) {
    return Ag(this.ownerDocument || this, this, e);
  },
  normalize: function() {
    for (var e = this.firstChild; e; ) {
      var r = e.nextSibling;
      r && r.nodeType == Bf && e.nodeType == Bf ? (this.removeChild(r), e.appendData(r.data)) : (e.normalize(), e = r);
    }
  },
  isSupported: function(e, r) {
    return this.ownerDocument.implementation.hasFeature(e, r);
  },
  hasAttributes: function() {
    return this.attributes.length > 0;
  },
  lookupPrefix: function(e) {
    for (var r = this; r; ) {
      var i = r._nsMap;
      if (i) {
        for (var t in i)
          if (Object.prototype.hasOwnProperty.call(i, t) && i[t] === e)
            return t;
      }
      r = r.nodeType == ql ? r.ownerDocument : r.parentNode;
    }
    return null;
  },
  lookupNamespaceURI: function(e) {
    for (var r = this; r; ) {
      var i = r._nsMap;
      if (i && Object.prototype.hasOwnProperty.call(i, e))
        return i[e];
      r = r.nodeType == ql ? r.ownerDocument : r.parentNode;
    }
    return null;
  },
  isDefaultNamespace: function(e) {
    var r = this.lookupPrefix(e);
    return r == null;
  }
};
function nT(e) {
  return e == "<" && "&lt;" || e == ">" && "&gt;" || e == "&" && "&amp;" || e == '"' && "&quot;" || "&#" + e.charCodeAt() + ";";
}
Sd(da, mi);
Sd(da, mi.prototype);
function rd(e, r) {
  if (r(e))
    return !0;
  if (e = e.firstChild)
    do
      if (rd(e, r))
        return !0;
    while (e = e.nextSibling);
}
function Ed() {
  this.ownerDocument = this;
}
function VC(e, r, i) {
  e && e._inc++;
  var t = i.namespaceURI;
  t === td.XMLNS && (r._nsMap[i.prefix ? i.localName : ""] = i.value);
}
function aT(e, r, i, t) {
  e && e._inc++;
  var n = i.namespaceURI;
  n === td.XMLNS && delete r._nsMap[i.prefix ? i.localName : ""];
}
function bv(e, r, i) {
  if (e && e._inc) {
    e._inc++;
    var t = r.childNodes;
    if (i)
      t[t.length++] = i;
    else {
      for (var n = r.firstChild, a = 0; n; )
        t[a++] = n, n = n.nextSibling;
      t.length = a, delete t[t.length];
    }
  }
}
function sT(e, r) {
  var i = r.previousSibling, t = r.nextSibling;
  return i ? i.nextSibling = t : e.firstChild = t, t ? t.previousSibling = i : e.lastChild = i, r.parentNode = null, r.previousSibling = null, r.nextSibling = null, bv(e.ownerDocument, e), r;
}
function qC(e) {
  return e && (e.nodeType === mi.DOCUMENT_NODE || e.nodeType === mi.DOCUMENT_FRAGMENT_NODE || e.nodeType === mi.ELEMENT_NODE);
}
function WC(e) {
  return e && (Fs(e) || Tv(e) || mo(e) || e.nodeType === mi.DOCUMENT_FRAGMENT_NODE || e.nodeType === mi.COMMENT_NODE || e.nodeType === mi.PROCESSING_INSTRUCTION_NODE);
}
function mo(e) {
  return e && e.nodeType === mi.DOCUMENT_TYPE_NODE;
}
function Fs(e) {
  return e && e.nodeType === mi.ELEMENT_NODE;
}
function Tv(e) {
  return e && e.nodeType === mi.TEXT_NODE;
}
function Gy(e, r) {
  var i = e.childNodes || [];
  if (Ns(i, Fs) || mo(r))
    return !1;
  var t = Ns(i, mo);
  return !(r && t && i.indexOf(t) > i.indexOf(r));
}
function Hy(e, r) {
  var i = e.childNodes || [];
  function t(a) {
    return Fs(a) && a !== r;
  }
  if (Ns(i, t))
    return !1;
  var n = Ns(i, mo);
  return !(r && n && i.indexOf(n) > i.indexOf(r));
}
function YC(e, r, i) {
  if (!qC(e))
    throw new Yi(oa, "Unexpected parent node type " + e.nodeType);
  if (i && i.parentNode !== e)
    throw new Yi(tT, "child not in parent");
  if (!WC(r) || mo(r) && e.nodeType !== mi.DOCUMENT_NODE)
    throw new Yi(
      oa,
      "Unexpected node type " + r.nodeType + " for parent node type " + e.nodeType
    );
}
function KC(e, r, i) {
  var t = e.childNodes || [], n = r.childNodes || [];
  if (r.nodeType === mi.DOCUMENT_FRAGMENT_NODE) {
    var a = n.filter(Fs);
    if (a.length > 1 || Ns(n, Tv))
      throw new Yi(oa, "More than one element or text in fragment");
    if (a.length === 1 && !Gy(e, i))
      throw new Yi(oa, "Element in fragment can not be inserted before doctype");
  }
  if (Fs(r) && !Gy(e, i))
    throw new Yi(oa, "Only one element can be added and only after doctype");
  if (mo(r)) {
    if (Ns(t, mo))
      throw new Yi(oa, "Only one doctype is allowed");
    var s = Ns(t, Fs);
    if (i && t.indexOf(s) < t.indexOf(i))
      throw new Yi(oa, "Doctype can only be inserted before an element");
    if (!i && s)
      throw new Yi(oa, "Doctype can not be appended since element is present");
  }
}
function oT(e, r, i) {
  var t = e.childNodes || [], n = r.childNodes || [];
  if (r.nodeType === mi.DOCUMENT_FRAGMENT_NODE) {
    var a = n.filter(Fs);
    if (a.length > 1 || Ns(n, Tv))
      throw new Yi(oa, "More than one element or text in fragment");
    if (a.length === 1 && !Hy(e, i))
      throw new Yi(oa, "Element in fragment can not be inserted before doctype");
  }
  if (Fs(r) && !Hy(e, i))
    throw new Yi(oa, "Only one element can be added and only after doctype");
  if (mo(r)) {
    if (Ns(t, function(l) {
      return mo(l) && l !== i;
    }))
      throw new Yi(oa, "Only one doctype is allowed");
    var s = Ns(t, Fs);
    if (i && t.indexOf(s) < t.indexOf(i))
      throw new Yi(oa, "Doctype can only be inserted before an element");
  }
}
function $f(e, r, i, t) {
  YC(e, r, i), e.nodeType === mi.DOCUMENT_NODE && (t || KC)(e, r, i);
  var n = r.parentNode;
  if (n && n.removeChild(r), r.nodeType === vo) {
    var a = r.firstChild;
    if (a == null)
      return r;
    var s = r.lastChild;
  } else
    a = s = r;
  var o = i ? i.previousSibling : e.lastChild;
  a.previousSibling = o, s.nextSibling = i, o ? o.nextSibling = a : e.firstChild = a, i == null ? e.lastChild = s : i.previousSibling = s;
  do
    a.parentNode = e;
  while (a !== s && (a = a.nextSibling));
  return bv(e.ownerDocument || e, e), r.nodeType == vo && (r.firstChild = r.lastChild = null), r;
}
function zC(e, r) {
  return r.parentNode && r.parentNode.removeChild(r), r.parentNode = e, r.previousSibling = e.lastChild, r.nextSibling = null, r.previousSibling ? r.previousSibling.nextSibling = r : e.firstChild = r, e.lastChild = r, bv(e.ownerDocument, e, r), r;
}
Ed.prototype = {
  nodeName: "#document",
  nodeType: Zb,
  doctype: null,
  documentElement: null,
  _inc: 1,
  insertBefore: function(e, r) {
    if (e.nodeType == vo) {
      for (var i = e.firstChild; i; ) {
        var t = i.nextSibling;
        this.insertBefore(i, r), i = t;
      }
      return e;
    }
    return $f(this, e, r), e.ownerDocument = this, this.documentElement === null && e.nodeType === ls && (this.documentElement = e), e;
  },
  removeChild: function(e) {
    return this.documentElement == e && (this.documentElement = null), sT(this, e);
  },
  replaceChild: function(e, r) {
    $f(this, e, r, oT), e.ownerDocument = this, r && this.removeChild(r), Fs(e) && (this.documentElement = e);
  },
  importNode: function(e, r) {
    return fT(this, e, r);
  },
  getElementById: function(e) {
    var r = null;
    return rd(this.documentElement, function(i) {
      if (i.nodeType == ls && i.getAttribute("id") == e)
        return r = i, !0;
    }), r;
  },
  getElementsByClassName: function(e) {
    var r = Uy(e);
    return new Wl(this, function(i) {
      var t = [];
      return r.length > 0 && rd(i.documentElement, function(n) {
        if (n !== i && n.nodeType === ls) {
          var a = n.getAttribute("class");
          if (a) {
            var s = e === a;
            if (!s) {
              var o = Uy(a);
              s = r.every($C(o));
            }
            s && t.push(n);
          }
        }
      }), t;
    });
  },
  createElement: function(e) {
    var r = new Ju();
    r.ownerDocument = this, r.nodeName = e, r.tagName = e, r.localName = e, r.childNodes = new uo();
    var i = r.attributes = new jf();
    return i._ownerElement = r, r;
  },
  createDocumentFragment: function() {
    var e = new Ah();
    return e.ownerDocument = this, e.childNodes = new uo(), e;
  },
  createTextNode: function(e) {
    var r = new Sv();
    return r.ownerDocument = this, r.appendData(e), r;
  },
  createComment: function(e) {
    var r = new Ev();
    return r.ownerDocument = this, r.appendData(e), r;
  },
  createCDATASection: function(e) {
    var r = new xv();
    return r.ownerDocument = this, r.appendData(e), r;
  },
  createProcessingInstruction: function(e, r) {
    var i = new wv();
    return i.ownerDocument = this, i.tagName = i.nodeName = i.target = e, i.nodeValue = i.data = r, i;
  },
  createAttribute: function(e) {
    var r = new Gf();
    return r.ownerDocument = this, r.name = e, r.nodeName = e, r.localName = e, r.specified = !0, r;
  },
  createEntityReference: function(e) {
    var r = new Av();
    return r.ownerDocument = this, r.nodeName = e, r;
  },
  createElementNS: function(e, r) {
    var i = new Ju(), t = r.split(":"), n = i.attributes = new jf();
    return i.childNodes = new uo(), i.ownerDocument = this, i.nodeName = r, i.tagName = r, i.namespaceURI = e, t.length == 2 ? (i.prefix = t[0], i.localName = t[1]) : i.localName = r, n._ownerElement = i, i;
  },
  createAttributeNS: function(e, r) {
    var i = new Gf(), t = r.split(":");
    return i.ownerDocument = this, i.nodeName = r, i.name = r, i.namespaceURI = e, i.specified = !0, t.length == 2 ? (i.prefix = t[0], i.localName = t[1]) : i.localName = r, i;
  }
};
ca(Ed, mi);
function Ju() {
  this._nsMap = {};
}
Ju.prototype = {
  nodeType: ls,
  hasAttribute: function(e) {
    return this.getAttributeNode(e) != null;
  },
  getAttribute: function(e) {
    var r = this.getAttributeNode(e);
    return r && r.value || "";
  },
  getAttributeNode: function(e) {
    return this.attributes.getNamedItem(e);
  },
  setAttribute: function(e, r) {
    var i = this.ownerDocument.createAttribute(e);
    i.value = i.nodeValue = "" + r, this.setAttributeNode(i);
  },
  removeAttribute: function(e) {
    var r = this.getAttributeNode(e);
    r && this.removeAttributeNode(r);
  },
  appendChild: function(e) {
    return e.nodeType === vo ? this.insertBefore(e, null) : zC(this, e);
  },
  setAttributeNode: function(e) {
    return this.attributes.setNamedItem(e);
  },
  setAttributeNodeNS: function(e) {
    return this.attributes.setNamedItemNS(e);
  },
  removeAttributeNode: function(e) {
    return this.attributes.removeNamedItem(e.nodeName);
  },
  removeAttributeNS: function(e, r) {
    var i = this.getAttributeNodeNS(e, r);
    i && this.removeAttributeNode(i);
  },
  hasAttributeNS: function(e, r) {
    return this.getAttributeNodeNS(e, r) != null;
  },
  getAttributeNS: function(e, r) {
    var i = this.getAttributeNodeNS(e, r);
    return i && i.value || "";
  },
  setAttributeNS: function(e, r, i) {
    var t = this.ownerDocument.createAttributeNS(e, r);
    t.value = t.nodeValue = "" + i, this.setAttributeNode(t);
  },
  getAttributeNodeNS: function(e, r) {
    return this.attributes.getNamedItemNS(e, r);
  },
  getElementsByTagName: function(e) {
    return new Wl(this, function(r) {
      var i = [];
      return rd(r, function(t) {
        t !== r && t.nodeType == ls && (e === "*" || t.tagName == e) && i.push(t);
      }), i;
    });
  },
  getElementsByTagNameNS: function(e, r) {
    return new Wl(this, function(i) {
      var t = [];
      return rd(i, function(n) {
        n !== i && n.nodeType === ls && (e === "*" || n.namespaceURI === e) && (r === "*" || n.localName == r) && t.push(n);
      }), t;
    });
  }
};
Ed.prototype.getElementsByTagName = Ju.prototype.getElementsByTagName;
Ed.prototype.getElementsByTagNameNS = Ju.prototype.getElementsByTagNameNS;
ca(Ju, mi);
function Gf() {
}
Gf.prototype.nodeType = ql;
ca(Gf, mi);
function xd() {
}
xd.prototype = {
  data: "",
  substringData: function(e, r) {
    return this.data.substring(e, e + r);
  },
  appendData: function(e) {
    e = this.data + e, this.nodeValue = this.data = e, this.length = e.length;
  },
  insertData: function(e, r) {
    this.replaceData(e, 0, r);
  },
  appendChild: function(e) {
    throw new Error(gn[oa]);
  },
  deleteData: function(e, r) {
    this.replaceData(e, r, "");
  },
  replaceData: function(e, r, i) {
    var t = this.data.substring(0, e), n = this.data.substring(e + r);
    i = t + i + n, this.nodeValue = this.data = i, this.length = i.length;
  }
};
ca(xd, mi);
function Sv() {
}
Sv.prototype = {
  nodeName: "#text",
  nodeType: Bf,
  splitText: function(e) {
    var r = this.data, i = r.substring(e);
    r = r.substring(0, e), this.data = this.nodeValue = r, this.length = r.length;
    var t = this.ownerDocument.createTextNode(i);
    return this.parentNode && this.parentNode.insertBefore(t, this.nextSibling), t;
  }
};
ca(Sv, xd);
function Ev() {
}
Ev.prototype = {
  nodeName: "#comment",
  nodeType: Qb
};
ca(Ev, xd);
function xv() {
}
xv.prototype = {
  nodeName: "#cdata-section",
  nodeType: zb
};
ca(xv, xd);
function xh() {
}
xh.prototype.nodeType = eT;
ca(xh, mi);
function uT() {
}
uT.prototype.nodeType = HC;
ca(uT, mi);
function lT() {
}
lT.prototype.nodeType = GC;
ca(lT, mi);
function Av() {
}
Av.prototype.nodeType = Xb;
ca(Av, mi);
function Ah() {
}
Ah.prototype.nodeName = "#document-fragment";
Ah.prototype.nodeType = vo;
ca(Ah, mi);
function wv() {
}
wv.prototype.nodeType = Jb;
ca(wv, mi);
function cT() {
}
cT.prototype.serializeToString = function(e, r, i) {
  return dT.call(e, r, i);
};
mi.prototype.toString = dT;
function dT(e, r) {
  var i = [], t = this.nodeType == 9 && this.documentElement || this, n = t.prefix, a = t.namespaceURI;
  if (a && n == null) {
    var n = t.lookupPrefix(a);
    if (n == null)
      var s = [
        { namespace: a, prefix: null }
      ];
  }
  return kl(this, i, e, r, s), i.join("");
}
function Vy(e, r, i) {
  var t = e.prefix || "", n = e.namespaceURI;
  if (!n || t === "xml" && n === td.XML || n === td.XMLNS)
    return !1;
  for (var a = i.length; a--; ) {
    var s = i[a];
    if (s.prefix === t)
      return s.namespace !== n;
  }
  return !0;
}
function Lp(e, r, i) {
  e.push(" ", r, '="', i.replace(/[<>&"\t\n\r]/g, nT), '"');
}
function kl(e, r, i, t, n) {
  if (n || (n = []), t)
    if (e = t(e), e) {
      if (typeof e == "string") {
        r.push(e);
        return;
      }
    } else
      return;
  switch (e.nodeType) {
    case ls:
      var a = e.attributes, s = a.length, y = e.firstChild, o = e.tagName;
      i = td.isHTML(e.namespaceURI) || i;
      var l = o;
      if (!i && !e.prefix && e.namespaceURI) {
        for (var u, h = 0; h < a.length; h++)
          if (a.item(h).name === "xmlns") {
            u = a.item(h).value;
            break;
          }
        if (!u)
          for (var c = n.length - 1; c >= 0; c--) {
            var d = n[c];
            if (d.prefix === "" && d.namespace === e.namespaceURI) {
              u = d.namespace;
              break;
            }
          }
        if (u !== e.namespaceURI)
          for (var c = n.length - 1; c >= 0; c--) {
            var d = n[c];
            if (d.namespace === e.namespaceURI) {
              d.prefix && (l = d.prefix + ":" + o);
              break;
            }
          }
      }
      r.push("<", l);
      for (var f = 0; f < s; f++) {
        var m = a.item(f);
        m.prefix == "xmlns" ? n.push({ prefix: m.localName, namespace: m.value }) : m.nodeName == "xmlns" && n.push({ prefix: "", namespace: m.value });
      }
      for (var f = 0; f < s; f++) {
        var m = a.item(f);
        if (Vy(m, i, n)) {
          var p = m.prefix || "", b = m.namespaceURI;
          Lp(r, p ? "xmlns:" + p : "xmlns", b), n.push({ prefix: p, namespace: b });
        }
        kl(m, r, i, t, n);
      }
      if (o === l && Vy(e, i, n)) {
        var p = e.prefix || "", b = e.namespaceURI;
        Lp(r, p ? "xmlns:" + p : "xmlns", b), n.push({ prefix: p, namespace: b });
      }
      if (y || i && !/^(?:meta|link|img|br|hr|input)$/i.test(o)) {
        if (r.push(">"), i && /^script$/i.test(o))
          for (; y; )
            y.data ? r.push(y.data) : kl(y, r, i, t, n.slice()), y = y.nextSibling;
        else
          for (; y; )
            kl(y, r, i, t, n.slice()), y = y.nextSibling;
        r.push("</", l, ">");
      } else
        r.push("/>");
      return;
    case Zb:
    case vo:
      for (var y = e.firstChild; y; )
        kl(y, r, i, t, n.slice()), y = y.nextSibling;
      return;
    case ql:
      return Lp(r, e.name, e.value);
    case Bf:
      return r.push(
        e.data.replace(/[<&>]/g, nT)
      );
    case zb:
      return r.push("<![CDATA[", e.data, "]]>");
    case Qb:
      return r.push("<!--", e.data, "-->");
    case eT:
      var v = e.publicId, g = e.systemId;
      if (r.push("<!DOCTYPE ", e.name), v)
        r.push(" PUBLIC ", v), g && g != "." && r.push(" ", g), r.push(">");
      else if (g && g != ".")
        r.push(" SYSTEM ", g, ">");
      else {
        var E = e.internalSubset;
        E && r.push(" [", E, "]"), r.push(">");
      }
      return;
    case Jb:
      return r.push("<?", e.target, " ", e.data, "?>");
    case Xb:
      return r.push("&", e.nodeName, ";");
    default:
      r.push("??", e.nodeName);
  }
}
function fT(e, r, i) {
  var t;
  switch (r.nodeType) {
    case ls:
      t = r.cloneNode(!1), t.ownerDocument = e;
    case vo:
      break;
    case ql:
      i = !0;
      break;
  }
  if (t || (t = r.cloneNode(!1)), t.ownerDocument = e, t.parentNode = null, i)
    for (var n = r.firstChild; n; )
      t.appendChild(fT(e, n, i)), n = n.nextSibling;
  return t;
}
function Ag(e, r, i) {
  var t = new r.constructor();
  for (var n in r)
    if (Object.prototype.hasOwnProperty.call(r, n)) {
      var a = r[n];
      typeof a != "object" && a != t[n] && (t[n] = a);
    }
  switch (r.childNodes && (t.childNodes = new uo()), t.ownerDocument = e, t.nodeType) {
    case ls:
      var s = r.attributes, o = t.attributes = new jf(), l = s.length;
      o._ownerElement = t;
      for (var u = 0; u < l; u++)
        t.setAttributeNode(Ag(e, s.item(u), !0));
      break;
    case ql:
      i = !0;
  }
  if (i)
    for (var h = r.firstChild; h; )
      t.appendChild(Ag(e, h, i)), h = h.nextSibling;
  return t;
}
function hT(e, r, i) {
  e[r] = i;
}
try {
  if (Object.defineProperty) {
    let e = function(r) {
      switch (r.nodeType) {
        case ls:
        case vo:
          var i = [];
          for (r = r.firstChild; r; )
            r.nodeType !== 7 && r.nodeType !== 8 && i.push(e(r)), r = r.nextSibling;
          return i.join("");
        default:
          return r.nodeValue;
      }
    };
    Object.defineProperty(Wl.prototype, "length", {
      get: function() {
        return _v(this), this.$$length;
      }
    }), Object.defineProperty(mi.prototype, "textContent", {
      get: function() {
        return e(this);
      },
      set: function(r) {
        switch (this.nodeType) {
          case ls:
          case vo:
            for (; this.firstChild; )
              this.removeChild(this.firstChild);
            (r || String(r)) && this.appendChild(this.ownerDocument.createTextNode(r));
            break;
          default:
            this.data = r, this.value = r, this.nodeValue = r;
        }
      }
    }), hT = function(r, i, t) {
      r["$$" + i] = t;
    };
  }
} catch {
}
ou.DocumentType = xh;
ou.DOMException = Yi;
ou.DOMImplementation = iT;
ou.Element = Ju;
ou.Node = mi;
ou.NodeList = uo;
ou.XMLSerializer = cT;
var wh = {}, pT = {};
(function(e) {
  var r = To.freeze;
  e.XML_ENTITIES = r({
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    quot: '"'
  }), e.HTML_ENTITIES = r({
    Aacute: "\xC1",
    aacute: "\xE1",
    Abreve: "\u0102",
    abreve: "\u0103",
    ac: "\u223E",
    acd: "\u223F",
    acE: "\u223E\u0333",
    Acirc: "\xC2",
    acirc: "\xE2",
    acute: "\xB4",
    Acy: "\u0410",
    acy: "\u0430",
    AElig: "\xC6",
    aelig: "\xE6",
    af: "\u2061",
    Afr: "\u{1D504}",
    afr: "\u{1D51E}",
    Agrave: "\xC0",
    agrave: "\xE0",
    alefsym: "\u2135",
    aleph: "\u2135",
    Alpha: "\u0391",
    alpha: "\u03B1",
    Amacr: "\u0100",
    amacr: "\u0101",
    amalg: "\u2A3F",
    AMP: "&",
    amp: "&",
    And: "\u2A53",
    and: "\u2227",
    andand: "\u2A55",
    andd: "\u2A5C",
    andslope: "\u2A58",
    andv: "\u2A5A",
    ang: "\u2220",
    ange: "\u29A4",
    angle: "\u2220",
    angmsd: "\u2221",
    angmsdaa: "\u29A8",
    angmsdab: "\u29A9",
    angmsdac: "\u29AA",
    angmsdad: "\u29AB",
    angmsdae: "\u29AC",
    angmsdaf: "\u29AD",
    angmsdag: "\u29AE",
    angmsdah: "\u29AF",
    angrt: "\u221F",
    angrtvb: "\u22BE",
    angrtvbd: "\u299D",
    angsph: "\u2222",
    angst: "\xC5",
    angzarr: "\u237C",
    Aogon: "\u0104",
    aogon: "\u0105",
    Aopf: "\u{1D538}",
    aopf: "\u{1D552}",
    ap: "\u2248",
    apacir: "\u2A6F",
    apE: "\u2A70",
    ape: "\u224A",
    apid: "\u224B",
    apos: "'",
    ApplyFunction: "\u2061",
    approx: "\u2248",
    approxeq: "\u224A",
    Aring: "\xC5",
    aring: "\xE5",
    Ascr: "\u{1D49C}",
    ascr: "\u{1D4B6}",
    Assign: "\u2254",
    ast: "*",
    asymp: "\u2248",
    asympeq: "\u224D",
    Atilde: "\xC3",
    atilde: "\xE3",
    Auml: "\xC4",
    auml: "\xE4",
    awconint: "\u2233",
    awint: "\u2A11",
    backcong: "\u224C",
    backepsilon: "\u03F6",
    backprime: "\u2035",
    backsim: "\u223D",
    backsimeq: "\u22CD",
    Backslash: "\u2216",
    Barv: "\u2AE7",
    barvee: "\u22BD",
    Barwed: "\u2306",
    barwed: "\u2305",
    barwedge: "\u2305",
    bbrk: "\u23B5",
    bbrktbrk: "\u23B6",
    bcong: "\u224C",
    Bcy: "\u0411",
    bcy: "\u0431",
    bdquo: "\u201E",
    becaus: "\u2235",
    Because: "\u2235",
    because: "\u2235",
    bemptyv: "\u29B0",
    bepsi: "\u03F6",
    bernou: "\u212C",
    Bernoullis: "\u212C",
    Beta: "\u0392",
    beta: "\u03B2",
    beth: "\u2136",
    between: "\u226C",
    Bfr: "\u{1D505}",
    bfr: "\u{1D51F}",
    bigcap: "\u22C2",
    bigcirc: "\u25EF",
    bigcup: "\u22C3",
    bigodot: "\u2A00",
    bigoplus: "\u2A01",
    bigotimes: "\u2A02",
    bigsqcup: "\u2A06",
    bigstar: "\u2605",
    bigtriangledown: "\u25BD",
    bigtriangleup: "\u25B3",
    biguplus: "\u2A04",
    bigvee: "\u22C1",
    bigwedge: "\u22C0",
    bkarow: "\u290D",
    blacklozenge: "\u29EB",
    blacksquare: "\u25AA",
    blacktriangle: "\u25B4",
    blacktriangledown: "\u25BE",
    blacktriangleleft: "\u25C2",
    blacktriangleright: "\u25B8",
    blank: "\u2423",
    blk12: "\u2592",
    blk14: "\u2591",
    blk34: "\u2593",
    block: "\u2588",
    bne: "=\u20E5",
    bnequiv: "\u2261\u20E5",
    bNot: "\u2AED",
    bnot: "\u2310",
    Bopf: "\u{1D539}",
    bopf: "\u{1D553}",
    bot: "\u22A5",
    bottom: "\u22A5",
    bowtie: "\u22C8",
    boxbox: "\u29C9",
    boxDL: "\u2557",
    boxDl: "\u2556",
    boxdL: "\u2555",
    boxdl: "\u2510",
    boxDR: "\u2554",
    boxDr: "\u2553",
    boxdR: "\u2552",
    boxdr: "\u250C",
    boxH: "\u2550",
    boxh: "\u2500",
    boxHD: "\u2566",
    boxHd: "\u2564",
    boxhD: "\u2565",
    boxhd: "\u252C",
    boxHU: "\u2569",
    boxHu: "\u2567",
    boxhU: "\u2568",
    boxhu: "\u2534",
    boxminus: "\u229F",
    boxplus: "\u229E",
    boxtimes: "\u22A0",
    boxUL: "\u255D",
    boxUl: "\u255C",
    boxuL: "\u255B",
    boxul: "\u2518",
    boxUR: "\u255A",
    boxUr: "\u2559",
    boxuR: "\u2558",
    boxur: "\u2514",
    boxV: "\u2551",
    boxv: "\u2502",
    boxVH: "\u256C",
    boxVh: "\u256B",
    boxvH: "\u256A",
    boxvh: "\u253C",
    boxVL: "\u2563",
    boxVl: "\u2562",
    boxvL: "\u2561",
    boxvl: "\u2524",
    boxVR: "\u2560",
    boxVr: "\u255F",
    boxvR: "\u255E",
    boxvr: "\u251C",
    bprime: "\u2035",
    Breve: "\u02D8",
    breve: "\u02D8",
    brvbar: "\xA6",
    Bscr: "\u212C",
    bscr: "\u{1D4B7}",
    bsemi: "\u204F",
    bsim: "\u223D",
    bsime: "\u22CD",
    bsol: "\\",
    bsolb: "\u29C5",
    bsolhsub: "\u27C8",
    bull: "\u2022",
    bullet: "\u2022",
    bump: "\u224E",
    bumpE: "\u2AAE",
    bumpe: "\u224F",
    Bumpeq: "\u224E",
    bumpeq: "\u224F",
    Cacute: "\u0106",
    cacute: "\u0107",
    Cap: "\u22D2",
    cap: "\u2229",
    capand: "\u2A44",
    capbrcup: "\u2A49",
    capcap: "\u2A4B",
    capcup: "\u2A47",
    capdot: "\u2A40",
    CapitalDifferentialD: "\u2145",
    caps: "\u2229\uFE00",
    caret: "\u2041",
    caron: "\u02C7",
    Cayleys: "\u212D",
    ccaps: "\u2A4D",
    Ccaron: "\u010C",
    ccaron: "\u010D",
    Ccedil: "\xC7",
    ccedil: "\xE7",
    Ccirc: "\u0108",
    ccirc: "\u0109",
    Cconint: "\u2230",
    ccups: "\u2A4C",
    ccupssm: "\u2A50",
    Cdot: "\u010A",
    cdot: "\u010B",
    cedil: "\xB8",
    Cedilla: "\xB8",
    cemptyv: "\u29B2",
    cent: "\xA2",
    CenterDot: "\xB7",
    centerdot: "\xB7",
    Cfr: "\u212D",
    cfr: "\u{1D520}",
    CHcy: "\u0427",
    chcy: "\u0447",
    check: "\u2713",
    checkmark: "\u2713",
    Chi: "\u03A7",
    chi: "\u03C7",
    cir: "\u25CB",
    circ: "\u02C6",
    circeq: "\u2257",
    circlearrowleft: "\u21BA",
    circlearrowright: "\u21BB",
    circledast: "\u229B",
    circledcirc: "\u229A",
    circleddash: "\u229D",
    CircleDot: "\u2299",
    circledR: "\xAE",
    circledS: "\u24C8",
    CircleMinus: "\u2296",
    CirclePlus: "\u2295",
    CircleTimes: "\u2297",
    cirE: "\u29C3",
    cire: "\u2257",
    cirfnint: "\u2A10",
    cirmid: "\u2AEF",
    cirscir: "\u29C2",
    ClockwiseContourIntegral: "\u2232",
    CloseCurlyDoubleQuote: "\u201D",
    CloseCurlyQuote: "\u2019",
    clubs: "\u2663",
    clubsuit: "\u2663",
    Colon: "\u2237",
    colon: ":",
    Colone: "\u2A74",
    colone: "\u2254",
    coloneq: "\u2254",
    comma: ",",
    commat: "@",
    comp: "\u2201",
    compfn: "\u2218",
    complement: "\u2201",
    complexes: "\u2102",
    cong: "\u2245",
    congdot: "\u2A6D",
    Congruent: "\u2261",
    Conint: "\u222F",
    conint: "\u222E",
    ContourIntegral: "\u222E",
    Copf: "\u2102",
    copf: "\u{1D554}",
    coprod: "\u2210",
    Coproduct: "\u2210",
    COPY: "\xA9",
    copy: "\xA9",
    copysr: "\u2117",
    CounterClockwiseContourIntegral: "\u2233",
    crarr: "\u21B5",
    Cross: "\u2A2F",
    cross: "\u2717",
    Cscr: "\u{1D49E}",
    cscr: "\u{1D4B8}",
    csub: "\u2ACF",
    csube: "\u2AD1",
    csup: "\u2AD0",
    csupe: "\u2AD2",
    ctdot: "\u22EF",
    cudarrl: "\u2938",
    cudarrr: "\u2935",
    cuepr: "\u22DE",
    cuesc: "\u22DF",
    cularr: "\u21B6",
    cularrp: "\u293D",
    Cup: "\u22D3",
    cup: "\u222A",
    cupbrcap: "\u2A48",
    CupCap: "\u224D",
    cupcap: "\u2A46",
    cupcup: "\u2A4A",
    cupdot: "\u228D",
    cupor: "\u2A45",
    cups: "\u222A\uFE00",
    curarr: "\u21B7",
    curarrm: "\u293C",
    curlyeqprec: "\u22DE",
    curlyeqsucc: "\u22DF",
    curlyvee: "\u22CE",
    curlywedge: "\u22CF",
    curren: "\xA4",
    curvearrowleft: "\u21B6",
    curvearrowright: "\u21B7",
    cuvee: "\u22CE",
    cuwed: "\u22CF",
    cwconint: "\u2232",
    cwint: "\u2231",
    cylcty: "\u232D",
    Dagger: "\u2021",
    dagger: "\u2020",
    daleth: "\u2138",
    Darr: "\u21A1",
    dArr: "\u21D3",
    darr: "\u2193",
    dash: "\u2010",
    Dashv: "\u2AE4",
    dashv: "\u22A3",
    dbkarow: "\u290F",
    dblac: "\u02DD",
    Dcaron: "\u010E",
    dcaron: "\u010F",
    Dcy: "\u0414",
    dcy: "\u0434",
    DD: "\u2145",
    dd: "\u2146",
    ddagger: "\u2021",
    ddarr: "\u21CA",
    DDotrahd: "\u2911",
    ddotseq: "\u2A77",
    deg: "\xB0",
    Del: "\u2207",
    Delta: "\u0394",
    delta: "\u03B4",
    demptyv: "\u29B1",
    dfisht: "\u297F",
    Dfr: "\u{1D507}",
    dfr: "\u{1D521}",
    dHar: "\u2965",
    dharl: "\u21C3",
    dharr: "\u21C2",
    DiacriticalAcute: "\xB4",
    DiacriticalDot: "\u02D9",
    DiacriticalDoubleAcute: "\u02DD",
    DiacriticalGrave: "`",
    DiacriticalTilde: "\u02DC",
    diam: "\u22C4",
    Diamond: "\u22C4",
    diamond: "\u22C4",
    diamondsuit: "\u2666",
    diams: "\u2666",
    die: "\xA8",
    DifferentialD: "\u2146",
    digamma: "\u03DD",
    disin: "\u22F2",
    div: "\xF7",
    divide: "\xF7",
    divideontimes: "\u22C7",
    divonx: "\u22C7",
    DJcy: "\u0402",
    djcy: "\u0452",
    dlcorn: "\u231E",
    dlcrop: "\u230D",
    dollar: "$",
    Dopf: "\u{1D53B}",
    dopf: "\u{1D555}",
    Dot: "\xA8",
    dot: "\u02D9",
    DotDot: "\u20DC",
    doteq: "\u2250",
    doteqdot: "\u2251",
    DotEqual: "\u2250",
    dotminus: "\u2238",
    dotplus: "\u2214",
    dotsquare: "\u22A1",
    doublebarwedge: "\u2306",
    DoubleContourIntegral: "\u222F",
    DoubleDot: "\xA8",
    DoubleDownArrow: "\u21D3",
    DoubleLeftArrow: "\u21D0",
    DoubleLeftRightArrow: "\u21D4",
    DoubleLeftTee: "\u2AE4",
    DoubleLongLeftArrow: "\u27F8",
    DoubleLongLeftRightArrow: "\u27FA",
    DoubleLongRightArrow: "\u27F9",
    DoubleRightArrow: "\u21D2",
    DoubleRightTee: "\u22A8",
    DoubleUpArrow: "\u21D1",
    DoubleUpDownArrow: "\u21D5",
    DoubleVerticalBar: "\u2225",
    DownArrow: "\u2193",
    Downarrow: "\u21D3",
    downarrow: "\u2193",
    DownArrowBar: "\u2913",
    DownArrowUpArrow: "\u21F5",
    DownBreve: "\u0311",
    downdownarrows: "\u21CA",
    downharpoonleft: "\u21C3",
    downharpoonright: "\u21C2",
    DownLeftRightVector: "\u2950",
    DownLeftTeeVector: "\u295E",
    DownLeftVector: "\u21BD",
    DownLeftVectorBar: "\u2956",
    DownRightTeeVector: "\u295F",
    DownRightVector: "\u21C1",
    DownRightVectorBar: "\u2957",
    DownTee: "\u22A4",
    DownTeeArrow: "\u21A7",
    drbkarow: "\u2910",
    drcorn: "\u231F",
    drcrop: "\u230C",
    Dscr: "\u{1D49F}",
    dscr: "\u{1D4B9}",
    DScy: "\u0405",
    dscy: "\u0455",
    dsol: "\u29F6",
    Dstrok: "\u0110",
    dstrok: "\u0111",
    dtdot: "\u22F1",
    dtri: "\u25BF",
    dtrif: "\u25BE",
    duarr: "\u21F5",
    duhar: "\u296F",
    dwangle: "\u29A6",
    DZcy: "\u040F",
    dzcy: "\u045F",
    dzigrarr: "\u27FF",
    Eacute: "\xC9",
    eacute: "\xE9",
    easter: "\u2A6E",
    Ecaron: "\u011A",
    ecaron: "\u011B",
    ecir: "\u2256",
    Ecirc: "\xCA",
    ecirc: "\xEA",
    ecolon: "\u2255",
    Ecy: "\u042D",
    ecy: "\u044D",
    eDDot: "\u2A77",
    Edot: "\u0116",
    eDot: "\u2251",
    edot: "\u0117",
    ee: "\u2147",
    efDot: "\u2252",
    Efr: "\u{1D508}",
    efr: "\u{1D522}",
    eg: "\u2A9A",
    Egrave: "\xC8",
    egrave: "\xE8",
    egs: "\u2A96",
    egsdot: "\u2A98",
    el: "\u2A99",
    Element: "\u2208",
    elinters: "\u23E7",
    ell: "\u2113",
    els: "\u2A95",
    elsdot: "\u2A97",
    Emacr: "\u0112",
    emacr: "\u0113",
    empty: "\u2205",
    emptyset: "\u2205",
    EmptySmallSquare: "\u25FB",
    emptyv: "\u2205",
    EmptyVerySmallSquare: "\u25AB",
    emsp: "\u2003",
    emsp13: "\u2004",
    emsp14: "\u2005",
    ENG: "\u014A",
    eng: "\u014B",
    ensp: "\u2002",
    Eogon: "\u0118",
    eogon: "\u0119",
    Eopf: "\u{1D53C}",
    eopf: "\u{1D556}",
    epar: "\u22D5",
    eparsl: "\u29E3",
    eplus: "\u2A71",
    epsi: "\u03B5",
    Epsilon: "\u0395",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    eqcirc: "\u2256",
    eqcolon: "\u2255",
    eqsim: "\u2242",
    eqslantgtr: "\u2A96",
    eqslantless: "\u2A95",
    Equal: "\u2A75",
    equals: "=",
    EqualTilde: "\u2242",
    equest: "\u225F",
    Equilibrium: "\u21CC",
    equiv: "\u2261",
    equivDD: "\u2A78",
    eqvparsl: "\u29E5",
    erarr: "\u2971",
    erDot: "\u2253",
    Escr: "\u2130",
    escr: "\u212F",
    esdot: "\u2250",
    Esim: "\u2A73",
    esim: "\u2242",
    Eta: "\u0397",
    eta: "\u03B7",
    ETH: "\xD0",
    eth: "\xF0",
    Euml: "\xCB",
    euml: "\xEB",
    euro: "\u20AC",
    excl: "!",
    exist: "\u2203",
    Exists: "\u2203",
    expectation: "\u2130",
    ExponentialE: "\u2147",
    exponentiale: "\u2147",
    fallingdotseq: "\u2252",
    Fcy: "\u0424",
    fcy: "\u0444",
    female: "\u2640",
    ffilig: "\uFB03",
    fflig: "\uFB00",
    ffllig: "\uFB04",
    Ffr: "\u{1D509}",
    ffr: "\u{1D523}",
    filig: "\uFB01",
    FilledSmallSquare: "\u25FC",
    FilledVerySmallSquare: "\u25AA",
    fjlig: "fj",
    flat: "\u266D",
    fllig: "\uFB02",
    fltns: "\u25B1",
    fnof: "\u0192",
    Fopf: "\u{1D53D}",
    fopf: "\u{1D557}",
    ForAll: "\u2200",
    forall: "\u2200",
    fork: "\u22D4",
    forkv: "\u2AD9",
    Fouriertrf: "\u2131",
    fpartint: "\u2A0D",
    frac12: "\xBD",
    frac13: "\u2153",
    frac14: "\xBC",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    frac23: "\u2154",
    frac25: "\u2156",
    frac34: "\xBE",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    frasl: "\u2044",
    frown: "\u2322",
    Fscr: "\u2131",
    fscr: "\u{1D4BB}",
    gacute: "\u01F5",
    Gamma: "\u0393",
    gamma: "\u03B3",
    Gammad: "\u03DC",
    gammad: "\u03DD",
    gap: "\u2A86",
    Gbreve: "\u011E",
    gbreve: "\u011F",
    Gcedil: "\u0122",
    Gcirc: "\u011C",
    gcirc: "\u011D",
    Gcy: "\u0413",
    gcy: "\u0433",
    Gdot: "\u0120",
    gdot: "\u0121",
    gE: "\u2267",
    ge: "\u2265",
    gEl: "\u2A8C",
    gel: "\u22DB",
    geq: "\u2265",
    geqq: "\u2267",
    geqslant: "\u2A7E",
    ges: "\u2A7E",
    gescc: "\u2AA9",
    gesdot: "\u2A80",
    gesdoto: "\u2A82",
    gesdotol: "\u2A84",
    gesl: "\u22DB\uFE00",
    gesles: "\u2A94",
    Gfr: "\u{1D50A}",
    gfr: "\u{1D524}",
    Gg: "\u22D9",
    gg: "\u226B",
    ggg: "\u22D9",
    gimel: "\u2137",
    GJcy: "\u0403",
    gjcy: "\u0453",
    gl: "\u2277",
    gla: "\u2AA5",
    glE: "\u2A92",
    glj: "\u2AA4",
    gnap: "\u2A8A",
    gnapprox: "\u2A8A",
    gnE: "\u2269",
    gne: "\u2A88",
    gneq: "\u2A88",
    gneqq: "\u2269",
    gnsim: "\u22E7",
    Gopf: "\u{1D53E}",
    gopf: "\u{1D558}",
    grave: "`",
    GreaterEqual: "\u2265",
    GreaterEqualLess: "\u22DB",
    GreaterFullEqual: "\u2267",
    GreaterGreater: "\u2AA2",
    GreaterLess: "\u2277",
    GreaterSlantEqual: "\u2A7E",
    GreaterTilde: "\u2273",
    Gscr: "\u{1D4A2}",
    gscr: "\u210A",
    gsim: "\u2273",
    gsime: "\u2A8E",
    gsiml: "\u2A90",
    Gt: "\u226B",
    GT: ">",
    gt: ">",
    gtcc: "\u2AA7",
    gtcir: "\u2A7A",
    gtdot: "\u22D7",
    gtlPar: "\u2995",
    gtquest: "\u2A7C",
    gtrapprox: "\u2A86",
    gtrarr: "\u2978",
    gtrdot: "\u22D7",
    gtreqless: "\u22DB",
    gtreqqless: "\u2A8C",
    gtrless: "\u2277",
    gtrsim: "\u2273",
    gvertneqq: "\u2269\uFE00",
    gvnE: "\u2269\uFE00",
    Hacek: "\u02C7",
    hairsp: "\u200A",
    half: "\xBD",
    hamilt: "\u210B",
    HARDcy: "\u042A",
    hardcy: "\u044A",
    hArr: "\u21D4",
    harr: "\u2194",
    harrcir: "\u2948",
    harrw: "\u21AD",
    Hat: "^",
    hbar: "\u210F",
    Hcirc: "\u0124",
    hcirc: "\u0125",
    hearts: "\u2665",
    heartsuit: "\u2665",
    hellip: "\u2026",
    hercon: "\u22B9",
    Hfr: "\u210C",
    hfr: "\u{1D525}",
    HilbertSpace: "\u210B",
    hksearow: "\u2925",
    hkswarow: "\u2926",
    hoarr: "\u21FF",
    homtht: "\u223B",
    hookleftarrow: "\u21A9",
    hookrightarrow: "\u21AA",
    Hopf: "\u210D",
    hopf: "\u{1D559}",
    horbar: "\u2015",
    HorizontalLine: "\u2500",
    Hscr: "\u210B",
    hscr: "\u{1D4BD}",
    hslash: "\u210F",
    Hstrok: "\u0126",
    hstrok: "\u0127",
    HumpDownHump: "\u224E",
    HumpEqual: "\u224F",
    hybull: "\u2043",
    hyphen: "\u2010",
    Iacute: "\xCD",
    iacute: "\xED",
    ic: "\u2063",
    Icirc: "\xCE",
    icirc: "\xEE",
    Icy: "\u0418",
    icy: "\u0438",
    Idot: "\u0130",
    IEcy: "\u0415",
    iecy: "\u0435",
    iexcl: "\xA1",
    iff: "\u21D4",
    Ifr: "\u2111",
    ifr: "\u{1D526}",
    Igrave: "\xCC",
    igrave: "\xEC",
    ii: "\u2148",
    iiiint: "\u2A0C",
    iiint: "\u222D",
    iinfin: "\u29DC",
    iiota: "\u2129",
    IJlig: "\u0132",
    ijlig: "\u0133",
    Im: "\u2111",
    Imacr: "\u012A",
    imacr: "\u012B",
    image: "\u2111",
    ImaginaryI: "\u2148",
    imagline: "\u2110",
    imagpart: "\u2111",
    imath: "\u0131",
    imof: "\u22B7",
    imped: "\u01B5",
    Implies: "\u21D2",
    in: "\u2208",
    incare: "\u2105",
    infin: "\u221E",
    infintie: "\u29DD",
    inodot: "\u0131",
    Int: "\u222C",
    int: "\u222B",
    intcal: "\u22BA",
    integers: "\u2124",
    Integral: "\u222B",
    intercal: "\u22BA",
    Intersection: "\u22C2",
    intlarhk: "\u2A17",
    intprod: "\u2A3C",
    InvisibleComma: "\u2063",
    InvisibleTimes: "\u2062",
    IOcy: "\u0401",
    iocy: "\u0451",
    Iogon: "\u012E",
    iogon: "\u012F",
    Iopf: "\u{1D540}",
    iopf: "\u{1D55A}",
    Iota: "\u0399",
    iota: "\u03B9",
    iprod: "\u2A3C",
    iquest: "\xBF",
    Iscr: "\u2110",
    iscr: "\u{1D4BE}",
    isin: "\u2208",
    isindot: "\u22F5",
    isinE: "\u22F9",
    isins: "\u22F4",
    isinsv: "\u22F3",
    isinv: "\u2208",
    it: "\u2062",
    Itilde: "\u0128",
    itilde: "\u0129",
    Iukcy: "\u0406",
    iukcy: "\u0456",
    Iuml: "\xCF",
    iuml: "\xEF",
    Jcirc: "\u0134",
    jcirc: "\u0135",
    Jcy: "\u0419",
    jcy: "\u0439",
    Jfr: "\u{1D50D}",
    jfr: "\u{1D527}",
    jmath: "\u0237",
    Jopf: "\u{1D541}",
    jopf: "\u{1D55B}",
    Jscr: "\u{1D4A5}",
    jscr: "\u{1D4BF}",
    Jsercy: "\u0408",
    jsercy: "\u0458",
    Jukcy: "\u0404",
    jukcy: "\u0454",
    Kappa: "\u039A",
    kappa: "\u03BA",
    kappav: "\u03F0",
    Kcedil: "\u0136",
    kcedil: "\u0137",
    Kcy: "\u041A",
    kcy: "\u043A",
    Kfr: "\u{1D50E}",
    kfr: "\u{1D528}",
    kgreen: "\u0138",
    KHcy: "\u0425",
    khcy: "\u0445",
    KJcy: "\u040C",
    kjcy: "\u045C",
    Kopf: "\u{1D542}",
    kopf: "\u{1D55C}",
    Kscr: "\u{1D4A6}",
    kscr: "\u{1D4C0}",
    lAarr: "\u21DA",
    Lacute: "\u0139",
    lacute: "\u013A",
    laemptyv: "\u29B4",
    lagran: "\u2112",
    Lambda: "\u039B",
    lambda: "\u03BB",
    Lang: "\u27EA",
    lang: "\u27E8",
    langd: "\u2991",
    langle: "\u27E8",
    lap: "\u2A85",
    Laplacetrf: "\u2112",
    laquo: "\xAB",
    Larr: "\u219E",
    lArr: "\u21D0",
    larr: "\u2190",
    larrb: "\u21E4",
    larrbfs: "\u291F",
    larrfs: "\u291D",
    larrhk: "\u21A9",
    larrlp: "\u21AB",
    larrpl: "\u2939",
    larrsim: "\u2973",
    larrtl: "\u21A2",
    lat: "\u2AAB",
    lAtail: "\u291B",
    latail: "\u2919",
    late: "\u2AAD",
    lates: "\u2AAD\uFE00",
    lBarr: "\u290E",
    lbarr: "\u290C",
    lbbrk: "\u2772",
    lbrace: "{",
    lbrack: "[",
    lbrke: "\u298B",
    lbrksld: "\u298F",
    lbrkslu: "\u298D",
    Lcaron: "\u013D",
    lcaron: "\u013E",
    Lcedil: "\u013B",
    lcedil: "\u013C",
    lceil: "\u2308",
    lcub: "{",
    Lcy: "\u041B",
    lcy: "\u043B",
    ldca: "\u2936",
    ldquo: "\u201C",
    ldquor: "\u201E",
    ldrdhar: "\u2967",
    ldrushar: "\u294B",
    ldsh: "\u21B2",
    lE: "\u2266",
    le: "\u2264",
    LeftAngleBracket: "\u27E8",
    LeftArrow: "\u2190",
    Leftarrow: "\u21D0",
    leftarrow: "\u2190",
    LeftArrowBar: "\u21E4",
    LeftArrowRightArrow: "\u21C6",
    leftarrowtail: "\u21A2",
    LeftCeiling: "\u2308",
    LeftDoubleBracket: "\u27E6",
    LeftDownTeeVector: "\u2961",
    LeftDownVector: "\u21C3",
    LeftDownVectorBar: "\u2959",
    LeftFloor: "\u230A",
    leftharpoondown: "\u21BD",
    leftharpoonup: "\u21BC",
    leftleftarrows: "\u21C7",
    LeftRightArrow: "\u2194",
    Leftrightarrow: "\u21D4",
    leftrightarrow: "\u2194",
    leftrightarrows: "\u21C6",
    leftrightharpoons: "\u21CB",
    leftrightsquigarrow: "\u21AD",
    LeftRightVector: "\u294E",
    LeftTee: "\u22A3",
    LeftTeeArrow: "\u21A4",
    LeftTeeVector: "\u295A",
    leftthreetimes: "\u22CB",
    LeftTriangle: "\u22B2",
    LeftTriangleBar: "\u29CF",
    LeftTriangleEqual: "\u22B4",
    LeftUpDownVector: "\u2951",
    LeftUpTeeVector: "\u2960",
    LeftUpVector: "\u21BF",
    LeftUpVectorBar: "\u2958",
    LeftVector: "\u21BC",
    LeftVectorBar: "\u2952",
    lEg: "\u2A8B",
    leg: "\u22DA",
    leq: "\u2264",
    leqq: "\u2266",
    leqslant: "\u2A7D",
    les: "\u2A7D",
    lescc: "\u2AA8",
    lesdot: "\u2A7F",
    lesdoto: "\u2A81",
    lesdotor: "\u2A83",
    lesg: "\u22DA\uFE00",
    lesges: "\u2A93",
    lessapprox: "\u2A85",
    lessdot: "\u22D6",
    lesseqgtr: "\u22DA",
    lesseqqgtr: "\u2A8B",
    LessEqualGreater: "\u22DA",
    LessFullEqual: "\u2266",
    LessGreater: "\u2276",
    lessgtr: "\u2276",
    LessLess: "\u2AA1",
    lesssim: "\u2272",
    LessSlantEqual: "\u2A7D",
    LessTilde: "\u2272",
    lfisht: "\u297C",
    lfloor: "\u230A",
    Lfr: "\u{1D50F}",
    lfr: "\u{1D529}",
    lg: "\u2276",
    lgE: "\u2A91",
    lHar: "\u2962",
    lhard: "\u21BD",
    lharu: "\u21BC",
    lharul: "\u296A",
    lhblk: "\u2584",
    LJcy: "\u0409",
    ljcy: "\u0459",
    Ll: "\u22D8",
    ll: "\u226A",
    llarr: "\u21C7",
    llcorner: "\u231E",
    Lleftarrow: "\u21DA",
    llhard: "\u296B",
    lltri: "\u25FA",
    Lmidot: "\u013F",
    lmidot: "\u0140",
    lmoust: "\u23B0",
    lmoustache: "\u23B0",
    lnap: "\u2A89",
    lnapprox: "\u2A89",
    lnE: "\u2268",
    lne: "\u2A87",
    lneq: "\u2A87",
    lneqq: "\u2268",
    lnsim: "\u22E6",
    loang: "\u27EC",
    loarr: "\u21FD",
    lobrk: "\u27E6",
    LongLeftArrow: "\u27F5",
    Longleftarrow: "\u27F8",
    longleftarrow: "\u27F5",
    LongLeftRightArrow: "\u27F7",
    Longleftrightarrow: "\u27FA",
    longleftrightarrow: "\u27F7",
    longmapsto: "\u27FC",
    LongRightArrow: "\u27F6",
    Longrightarrow: "\u27F9",
    longrightarrow: "\u27F6",
    looparrowleft: "\u21AB",
    looparrowright: "\u21AC",
    lopar: "\u2985",
    Lopf: "\u{1D543}",
    lopf: "\u{1D55D}",
    loplus: "\u2A2D",
    lotimes: "\u2A34",
    lowast: "\u2217",
    lowbar: "_",
    LowerLeftArrow: "\u2199",
    LowerRightArrow: "\u2198",
    loz: "\u25CA",
    lozenge: "\u25CA",
    lozf: "\u29EB",
    lpar: "(",
    lparlt: "\u2993",
    lrarr: "\u21C6",
    lrcorner: "\u231F",
    lrhar: "\u21CB",
    lrhard: "\u296D",
    lrm: "\u200E",
    lrtri: "\u22BF",
    lsaquo: "\u2039",
    Lscr: "\u2112",
    lscr: "\u{1D4C1}",
    Lsh: "\u21B0",
    lsh: "\u21B0",
    lsim: "\u2272",
    lsime: "\u2A8D",
    lsimg: "\u2A8F",
    lsqb: "[",
    lsquo: "\u2018",
    lsquor: "\u201A",
    Lstrok: "\u0141",
    lstrok: "\u0142",
    Lt: "\u226A",
    LT: "<",
    lt: "<",
    ltcc: "\u2AA6",
    ltcir: "\u2A79",
    ltdot: "\u22D6",
    lthree: "\u22CB",
    ltimes: "\u22C9",
    ltlarr: "\u2976",
    ltquest: "\u2A7B",
    ltri: "\u25C3",
    ltrie: "\u22B4",
    ltrif: "\u25C2",
    ltrPar: "\u2996",
    lurdshar: "\u294A",
    luruhar: "\u2966",
    lvertneqq: "\u2268\uFE00",
    lvnE: "\u2268\uFE00",
    macr: "\xAF",
    male: "\u2642",
    malt: "\u2720",
    maltese: "\u2720",
    Map: "\u2905",
    map: "\u21A6",
    mapsto: "\u21A6",
    mapstodown: "\u21A7",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    marker: "\u25AE",
    mcomma: "\u2A29",
    Mcy: "\u041C",
    mcy: "\u043C",
    mdash: "\u2014",
    mDDot: "\u223A",
    measuredangle: "\u2221",
    MediumSpace: "\u205F",
    Mellintrf: "\u2133",
    Mfr: "\u{1D510}",
    mfr: "\u{1D52A}",
    mho: "\u2127",
    micro: "\xB5",
    mid: "\u2223",
    midast: "*",
    midcir: "\u2AF0",
    middot: "\xB7",
    minus: "\u2212",
    minusb: "\u229F",
    minusd: "\u2238",
    minusdu: "\u2A2A",
    MinusPlus: "\u2213",
    mlcp: "\u2ADB",
    mldr: "\u2026",
    mnplus: "\u2213",
    models: "\u22A7",
    Mopf: "\u{1D544}",
    mopf: "\u{1D55E}",
    mp: "\u2213",
    Mscr: "\u2133",
    mscr: "\u{1D4C2}",
    mstpos: "\u223E",
    Mu: "\u039C",
    mu: "\u03BC",
    multimap: "\u22B8",
    mumap: "\u22B8",
    nabla: "\u2207",
    Nacute: "\u0143",
    nacute: "\u0144",
    nang: "\u2220\u20D2",
    nap: "\u2249",
    napE: "\u2A70\u0338",
    napid: "\u224B\u0338",
    napos: "\u0149",
    napprox: "\u2249",
    natur: "\u266E",
    natural: "\u266E",
    naturals: "\u2115",
    nbsp: "\xA0",
    nbump: "\u224E\u0338",
    nbumpe: "\u224F\u0338",
    ncap: "\u2A43",
    Ncaron: "\u0147",
    ncaron: "\u0148",
    Ncedil: "\u0145",
    ncedil: "\u0146",
    ncong: "\u2247",
    ncongdot: "\u2A6D\u0338",
    ncup: "\u2A42",
    Ncy: "\u041D",
    ncy: "\u043D",
    ndash: "\u2013",
    ne: "\u2260",
    nearhk: "\u2924",
    neArr: "\u21D7",
    nearr: "\u2197",
    nearrow: "\u2197",
    nedot: "\u2250\u0338",
    NegativeMediumSpace: "\u200B",
    NegativeThickSpace: "\u200B",
    NegativeThinSpace: "\u200B",
    NegativeVeryThinSpace: "\u200B",
    nequiv: "\u2262",
    nesear: "\u2928",
    nesim: "\u2242\u0338",
    NestedGreaterGreater: "\u226B",
    NestedLessLess: "\u226A",
    NewLine: `
`,
    nexist: "\u2204",
    nexists: "\u2204",
    Nfr: "\u{1D511}",
    nfr: "\u{1D52B}",
    ngE: "\u2267\u0338",
    nge: "\u2271",
    ngeq: "\u2271",
    ngeqq: "\u2267\u0338",
    ngeqslant: "\u2A7E\u0338",
    nges: "\u2A7E\u0338",
    nGg: "\u22D9\u0338",
    ngsim: "\u2275",
    nGt: "\u226B\u20D2",
    ngt: "\u226F",
    ngtr: "\u226F",
    nGtv: "\u226B\u0338",
    nhArr: "\u21CE",
    nharr: "\u21AE",
    nhpar: "\u2AF2",
    ni: "\u220B",
    nis: "\u22FC",
    nisd: "\u22FA",
    niv: "\u220B",
    NJcy: "\u040A",
    njcy: "\u045A",
    nlArr: "\u21CD",
    nlarr: "\u219A",
    nldr: "\u2025",
    nlE: "\u2266\u0338",
    nle: "\u2270",
    nLeftarrow: "\u21CD",
    nleftarrow: "\u219A",
    nLeftrightarrow: "\u21CE",
    nleftrightarrow: "\u21AE",
    nleq: "\u2270",
    nleqq: "\u2266\u0338",
    nleqslant: "\u2A7D\u0338",
    nles: "\u2A7D\u0338",
    nless: "\u226E",
    nLl: "\u22D8\u0338",
    nlsim: "\u2274",
    nLt: "\u226A\u20D2",
    nlt: "\u226E",
    nltri: "\u22EA",
    nltrie: "\u22EC",
    nLtv: "\u226A\u0338",
    nmid: "\u2224",
    NoBreak: "\u2060",
    NonBreakingSpace: "\xA0",
    Nopf: "\u2115",
    nopf: "\u{1D55F}",
    Not: "\u2AEC",
    not: "\xAC",
    NotCongruent: "\u2262",
    NotCupCap: "\u226D",
    NotDoubleVerticalBar: "\u2226",
    NotElement: "\u2209",
    NotEqual: "\u2260",
    NotEqualTilde: "\u2242\u0338",
    NotExists: "\u2204",
    NotGreater: "\u226F",
    NotGreaterEqual: "\u2271",
    NotGreaterFullEqual: "\u2267\u0338",
    NotGreaterGreater: "\u226B\u0338",
    NotGreaterLess: "\u2279",
    NotGreaterSlantEqual: "\u2A7E\u0338",
    NotGreaterTilde: "\u2275",
    NotHumpDownHump: "\u224E\u0338",
    NotHumpEqual: "\u224F\u0338",
    notin: "\u2209",
    notindot: "\u22F5\u0338",
    notinE: "\u22F9\u0338",
    notinva: "\u2209",
    notinvb: "\u22F7",
    notinvc: "\u22F6",
    NotLeftTriangle: "\u22EA",
    NotLeftTriangleBar: "\u29CF\u0338",
    NotLeftTriangleEqual: "\u22EC",
    NotLess: "\u226E",
    NotLessEqual: "\u2270",
    NotLessGreater: "\u2278",
    NotLessLess: "\u226A\u0338",
    NotLessSlantEqual: "\u2A7D\u0338",
    NotLessTilde: "\u2274",
    NotNestedGreaterGreater: "\u2AA2\u0338",
    NotNestedLessLess: "\u2AA1\u0338",
    notni: "\u220C",
    notniva: "\u220C",
    notnivb: "\u22FE",
    notnivc: "\u22FD",
    NotPrecedes: "\u2280",
    NotPrecedesEqual: "\u2AAF\u0338",
    NotPrecedesSlantEqual: "\u22E0",
    NotReverseElement: "\u220C",
    NotRightTriangle: "\u22EB",
    NotRightTriangleBar: "\u29D0\u0338",
    NotRightTriangleEqual: "\u22ED",
    NotSquareSubset: "\u228F\u0338",
    NotSquareSubsetEqual: "\u22E2",
    NotSquareSuperset: "\u2290\u0338",
    NotSquareSupersetEqual: "\u22E3",
    NotSubset: "\u2282\u20D2",
    NotSubsetEqual: "\u2288",
    NotSucceeds: "\u2281",
    NotSucceedsEqual: "\u2AB0\u0338",
    NotSucceedsSlantEqual: "\u22E1",
    NotSucceedsTilde: "\u227F\u0338",
    NotSuperset: "\u2283\u20D2",
    NotSupersetEqual: "\u2289",
    NotTilde: "\u2241",
    NotTildeEqual: "\u2244",
    NotTildeFullEqual: "\u2247",
    NotTildeTilde: "\u2249",
    NotVerticalBar: "\u2224",
    npar: "\u2226",
    nparallel: "\u2226",
    nparsl: "\u2AFD\u20E5",
    npart: "\u2202\u0338",
    npolint: "\u2A14",
    npr: "\u2280",
    nprcue: "\u22E0",
    npre: "\u2AAF\u0338",
    nprec: "\u2280",
    npreceq: "\u2AAF\u0338",
    nrArr: "\u21CF",
    nrarr: "\u219B",
    nrarrc: "\u2933\u0338",
    nrarrw: "\u219D\u0338",
    nRightarrow: "\u21CF",
    nrightarrow: "\u219B",
    nrtri: "\u22EB",
    nrtrie: "\u22ED",
    nsc: "\u2281",
    nsccue: "\u22E1",
    nsce: "\u2AB0\u0338",
    Nscr: "\u{1D4A9}",
    nscr: "\u{1D4C3}",
    nshortmid: "\u2224",
    nshortparallel: "\u2226",
    nsim: "\u2241",
    nsime: "\u2244",
    nsimeq: "\u2244",
    nsmid: "\u2224",
    nspar: "\u2226",
    nsqsube: "\u22E2",
    nsqsupe: "\u22E3",
    nsub: "\u2284",
    nsubE: "\u2AC5\u0338",
    nsube: "\u2288",
    nsubset: "\u2282\u20D2",
    nsubseteq: "\u2288",
    nsubseteqq: "\u2AC5\u0338",
    nsucc: "\u2281",
    nsucceq: "\u2AB0\u0338",
    nsup: "\u2285",
    nsupE: "\u2AC6\u0338",
    nsupe: "\u2289",
    nsupset: "\u2283\u20D2",
    nsupseteq: "\u2289",
    nsupseteqq: "\u2AC6\u0338",
    ntgl: "\u2279",
    Ntilde: "\xD1",
    ntilde: "\xF1",
    ntlg: "\u2278",
    ntriangleleft: "\u22EA",
    ntrianglelefteq: "\u22EC",
    ntriangleright: "\u22EB",
    ntrianglerighteq: "\u22ED",
    Nu: "\u039D",
    nu: "\u03BD",
    num: "#",
    numero: "\u2116",
    numsp: "\u2007",
    nvap: "\u224D\u20D2",
    nVDash: "\u22AF",
    nVdash: "\u22AE",
    nvDash: "\u22AD",
    nvdash: "\u22AC",
    nvge: "\u2265\u20D2",
    nvgt: ">\u20D2",
    nvHarr: "\u2904",
    nvinfin: "\u29DE",
    nvlArr: "\u2902",
    nvle: "\u2264\u20D2",
    nvlt: "<\u20D2",
    nvltrie: "\u22B4\u20D2",
    nvrArr: "\u2903",
    nvrtrie: "\u22B5\u20D2",
    nvsim: "\u223C\u20D2",
    nwarhk: "\u2923",
    nwArr: "\u21D6",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    nwnear: "\u2927",
    Oacute: "\xD3",
    oacute: "\xF3",
    oast: "\u229B",
    ocir: "\u229A",
    Ocirc: "\xD4",
    ocirc: "\xF4",
    Ocy: "\u041E",
    ocy: "\u043E",
    odash: "\u229D",
    Odblac: "\u0150",
    odblac: "\u0151",
    odiv: "\u2A38",
    odot: "\u2299",
    odsold: "\u29BC",
    OElig: "\u0152",
    oelig: "\u0153",
    ofcir: "\u29BF",
    Ofr: "\u{1D512}",
    ofr: "\u{1D52C}",
    ogon: "\u02DB",
    Ograve: "\xD2",
    ograve: "\xF2",
    ogt: "\u29C1",
    ohbar: "\u29B5",
    ohm: "\u03A9",
    oint: "\u222E",
    olarr: "\u21BA",
    olcir: "\u29BE",
    olcross: "\u29BB",
    oline: "\u203E",
    olt: "\u29C0",
    Omacr: "\u014C",
    omacr: "\u014D",
    Omega: "\u03A9",
    omega: "\u03C9",
    Omicron: "\u039F",
    omicron: "\u03BF",
    omid: "\u29B6",
    ominus: "\u2296",
    Oopf: "\u{1D546}",
    oopf: "\u{1D560}",
    opar: "\u29B7",
    OpenCurlyDoubleQuote: "\u201C",
    OpenCurlyQuote: "\u2018",
    operp: "\u29B9",
    oplus: "\u2295",
    Or: "\u2A54",
    or: "\u2228",
    orarr: "\u21BB",
    ord: "\u2A5D",
    order: "\u2134",
    orderof: "\u2134",
    ordf: "\xAA",
    ordm: "\xBA",
    origof: "\u22B6",
    oror: "\u2A56",
    orslope: "\u2A57",
    orv: "\u2A5B",
    oS: "\u24C8",
    Oscr: "\u{1D4AA}",
    oscr: "\u2134",
    Oslash: "\xD8",
    oslash: "\xF8",
    osol: "\u2298",
    Otilde: "\xD5",
    otilde: "\xF5",
    Otimes: "\u2A37",
    otimes: "\u2297",
    otimesas: "\u2A36",
    Ouml: "\xD6",
    ouml: "\xF6",
    ovbar: "\u233D",
    OverBar: "\u203E",
    OverBrace: "\u23DE",
    OverBracket: "\u23B4",
    OverParenthesis: "\u23DC",
    par: "\u2225",
    para: "\xB6",
    parallel: "\u2225",
    parsim: "\u2AF3",
    parsl: "\u2AFD",
    part: "\u2202",
    PartialD: "\u2202",
    Pcy: "\u041F",
    pcy: "\u043F",
    percnt: "%",
    period: ".",
    permil: "\u2030",
    perp: "\u22A5",
    pertenk: "\u2031",
    Pfr: "\u{1D513}",
    pfr: "\u{1D52D}",
    Phi: "\u03A6",
    phi: "\u03C6",
    phiv: "\u03D5",
    phmmat: "\u2133",
    phone: "\u260E",
    Pi: "\u03A0",
    pi: "\u03C0",
    pitchfork: "\u22D4",
    piv: "\u03D6",
    planck: "\u210F",
    planckh: "\u210E",
    plankv: "\u210F",
    plus: "+",
    plusacir: "\u2A23",
    plusb: "\u229E",
    pluscir: "\u2A22",
    plusdo: "\u2214",
    plusdu: "\u2A25",
    pluse: "\u2A72",
    PlusMinus: "\xB1",
    plusmn: "\xB1",
    plussim: "\u2A26",
    plustwo: "\u2A27",
    pm: "\xB1",
    Poincareplane: "\u210C",
    pointint: "\u2A15",
    Popf: "\u2119",
    popf: "\u{1D561}",
    pound: "\xA3",
    Pr: "\u2ABB",
    pr: "\u227A",
    prap: "\u2AB7",
    prcue: "\u227C",
    prE: "\u2AB3",
    pre: "\u2AAF",
    prec: "\u227A",
    precapprox: "\u2AB7",
    preccurlyeq: "\u227C",
    Precedes: "\u227A",
    PrecedesEqual: "\u2AAF",
    PrecedesSlantEqual: "\u227C",
    PrecedesTilde: "\u227E",
    preceq: "\u2AAF",
    precnapprox: "\u2AB9",
    precneqq: "\u2AB5",
    precnsim: "\u22E8",
    precsim: "\u227E",
    Prime: "\u2033",
    prime: "\u2032",
    primes: "\u2119",
    prnap: "\u2AB9",
    prnE: "\u2AB5",
    prnsim: "\u22E8",
    prod: "\u220F",
    Product: "\u220F",
    profalar: "\u232E",
    profline: "\u2312",
    profsurf: "\u2313",
    prop: "\u221D",
    Proportion: "\u2237",
    Proportional: "\u221D",
    propto: "\u221D",
    prsim: "\u227E",
    prurel: "\u22B0",
    Pscr: "\u{1D4AB}",
    pscr: "\u{1D4C5}",
    Psi: "\u03A8",
    psi: "\u03C8",
    puncsp: "\u2008",
    Qfr: "\u{1D514}",
    qfr: "\u{1D52E}",
    qint: "\u2A0C",
    Qopf: "\u211A",
    qopf: "\u{1D562}",
    qprime: "\u2057",
    Qscr: "\u{1D4AC}",
    qscr: "\u{1D4C6}",
    quaternions: "\u210D",
    quatint: "\u2A16",
    quest: "?",
    questeq: "\u225F",
    QUOT: '"',
    quot: '"',
    rAarr: "\u21DB",
    race: "\u223D\u0331",
    Racute: "\u0154",
    racute: "\u0155",
    radic: "\u221A",
    raemptyv: "\u29B3",
    Rang: "\u27EB",
    rang: "\u27E9",
    rangd: "\u2992",
    range: "\u29A5",
    rangle: "\u27E9",
    raquo: "\xBB",
    Rarr: "\u21A0",
    rArr: "\u21D2",
    rarr: "\u2192",
    rarrap: "\u2975",
    rarrb: "\u21E5",
    rarrbfs: "\u2920",
    rarrc: "\u2933",
    rarrfs: "\u291E",
    rarrhk: "\u21AA",
    rarrlp: "\u21AC",
    rarrpl: "\u2945",
    rarrsim: "\u2974",
    Rarrtl: "\u2916",
    rarrtl: "\u21A3",
    rarrw: "\u219D",
    rAtail: "\u291C",
    ratail: "\u291A",
    ratio: "\u2236",
    rationals: "\u211A",
    RBarr: "\u2910",
    rBarr: "\u290F",
    rbarr: "\u290D",
    rbbrk: "\u2773",
    rbrace: "}",
    rbrack: "]",
    rbrke: "\u298C",
    rbrksld: "\u298E",
    rbrkslu: "\u2990",
    Rcaron: "\u0158",
    rcaron: "\u0159",
    Rcedil: "\u0156",
    rcedil: "\u0157",
    rceil: "\u2309",
    rcub: "}",
    Rcy: "\u0420",
    rcy: "\u0440",
    rdca: "\u2937",
    rdldhar: "\u2969",
    rdquo: "\u201D",
    rdquor: "\u201D",
    rdsh: "\u21B3",
    Re: "\u211C",
    real: "\u211C",
    realine: "\u211B",
    realpart: "\u211C",
    reals: "\u211D",
    rect: "\u25AD",
    REG: "\xAE",
    reg: "\xAE",
    ReverseElement: "\u220B",
    ReverseEquilibrium: "\u21CB",
    ReverseUpEquilibrium: "\u296F",
    rfisht: "\u297D",
    rfloor: "\u230B",
    Rfr: "\u211C",
    rfr: "\u{1D52F}",
    rHar: "\u2964",
    rhard: "\u21C1",
    rharu: "\u21C0",
    rharul: "\u296C",
    Rho: "\u03A1",
    rho: "\u03C1",
    rhov: "\u03F1",
    RightAngleBracket: "\u27E9",
    RightArrow: "\u2192",
    Rightarrow: "\u21D2",
    rightarrow: "\u2192",
    RightArrowBar: "\u21E5",
    RightArrowLeftArrow: "\u21C4",
    rightarrowtail: "\u21A3",
    RightCeiling: "\u2309",
    RightDoubleBracket: "\u27E7",
    RightDownTeeVector: "\u295D",
    RightDownVector: "\u21C2",
    RightDownVectorBar: "\u2955",
    RightFloor: "\u230B",
    rightharpoondown: "\u21C1",
    rightharpoonup: "\u21C0",
    rightleftarrows: "\u21C4",
    rightleftharpoons: "\u21CC",
    rightrightarrows: "\u21C9",
    rightsquigarrow: "\u219D",
    RightTee: "\u22A2",
    RightTeeArrow: "\u21A6",
    RightTeeVector: "\u295B",
    rightthreetimes: "\u22CC",
    RightTriangle: "\u22B3",
    RightTriangleBar: "\u29D0",
    RightTriangleEqual: "\u22B5",
    RightUpDownVector: "\u294F",
    RightUpTeeVector: "\u295C",
    RightUpVector: "\u21BE",
    RightUpVectorBar: "\u2954",
    RightVector: "\u21C0",
    RightVectorBar: "\u2953",
    ring: "\u02DA",
    risingdotseq: "\u2253",
    rlarr: "\u21C4",
    rlhar: "\u21CC",
    rlm: "\u200F",
    rmoust: "\u23B1",
    rmoustache: "\u23B1",
    rnmid: "\u2AEE",
    roang: "\u27ED",
    roarr: "\u21FE",
    robrk: "\u27E7",
    ropar: "\u2986",
    Ropf: "\u211D",
    ropf: "\u{1D563}",
    roplus: "\u2A2E",
    rotimes: "\u2A35",
    RoundImplies: "\u2970",
    rpar: ")",
    rpargt: "\u2994",
    rppolint: "\u2A12",
    rrarr: "\u21C9",
    Rrightarrow: "\u21DB",
    rsaquo: "\u203A",
    Rscr: "\u211B",
    rscr: "\u{1D4C7}",
    Rsh: "\u21B1",
    rsh: "\u21B1",
    rsqb: "]",
    rsquo: "\u2019",
    rsquor: "\u2019",
    rthree: "\u22CC",
    rtimes: "\u22CA",
    rtri: "\u25B9",
    rtrie: "\u22B5",
    rtrif: "\u25B8",
    rtriltri: "\u29CE",
    RuleDelayed: "\u29F4",
    ruluhar: "\u2968",
    rx: "\u211E",
    Sacute: "\u015A",
    sacute: "\u015B",
    sbquo: "\u201A",
    Sc: "\u2ABC",
    sc: "\u227B",
    scap: "\u2AB8",
    Scaron: "\u0160",
    scaron: "\u0161",
    sccue: "\u227D",
    scE: "\u2AB4",
    sce: "\u2AB0",
    Scedil: "\u015E",
    scedil: "\u015F",
    Scirc: "\u015C",
    scirc: "\u015D",
    scnap: "\u2ABA",
    scnE: "\u2AB6",
    scnsim: "\u22E9",
    scpolint: "\u2A13",
    scsim: "\u227F",
    Scy: "\u0421",
    scy: "\u0441",
    sdot: "\u22C5",
    sdotb: "\u22A1",
    sdote: "\u2A66",
    searhk: "\u2925",
    seArr: "\u21D8",
    searr: "\u2198",
    searrow: "\u2198",
    sect: "\xA7",
    semi: ";",
    seswar: "\u2929",
    setminus: "\u2216",
    setmn: "\u2216",
    sext: "\u2736",
    Sfr: "\u{1D516}",
    sfr: "\u{1D530}",
    sfrown: "\u2322",
    sharp: "\u266F",
    SHCHcy: "\u0429",
    shchcy: "\u0449",
    SHcy: "\u0428",
    shcy: "\u0448",
    ShortDownArrow: "\u2193",
    ShortLeftArrow: "\u2190",
    shortmid: "\u2223",
    shortparallel: "\u2225",
    ShortRightArrow: "\u2192",
    ShortUpArrow: "\u2191",
    shy: "\xAD",
    Sigma: "\u03A3",
    sigma: "\u03C3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    sim: "\u223C",
    simdot: "\u2A6A",
    sime: "\u2243",
    simeq: "\u2243",
    simg: "\u2A9E",
    simgE: "\u2AA0",
    siml: "\u2A9D",
    simlE: "\u2A9F",
    simne: "\u2246",
    simplus: "\u2A24",
    simrarr: "\u2972",
    slarr: "\u2190",
    SmallCircle: "\u2218",
    smallsetminus: "\u2216",
    smashp: "\u2A33",
    smeparsl: "\u29E4",
    smid: "\u2223",
    smile: "\u2323",
    smt: "\u2AAA",
    smte: "\u2AAC",
    smtes: "\u2AAC\uFE00",
    SOFTcy: "\u042C",
    softcy: "\u044C",
    sol: "/",
    solb: "\u29C4",
    solbar: "\u233F",
    Sopf: "\u{1D54A}",
    sopf: "\u{1D564}",
    spades: "\u2660",
    spadesuit: "\u2660",
    spar: "\u2225",
    sqcap: "\u2293",
    sqcaps: "\u2293\uFE00",
    sqcup: "\u2294",
    sqcups: "\u2294\uFE00",
    Sqrt: "\u221A",
    sqsub: "\u228F",
    sqsube: "\u2291",
    sqsubset: "\u228F",
    sqsubseteq: "\u2291",
    sqsup: "\u2290",
    sqsupe: "\u2292",
    sqsupset: "\u2290",
    sqsupseteq: "\u2292",
    squ: "\u25A1",
    Square: "\u25A1",
    square: "\u25A1",
    SquareIntersection: "\u2293",
    SquareSubset: "\u228F",
    SquareSubsetEqual: "\u2291",
    SquareSuperset: "\u2290",
    SquareSupersetEqual: "\u2292",
    SquareUnion: "\u2294",
    squarf: "\u25AA",
    squf: "\u25AA",
    srarr: "\u2192",
    Sscr: "\u{1D4AE}",
    sscr: "\u{1D4C8}",
    ssetmn: "\u2216",
    ssmile: "\u2323",
    sstarf: "\u22C6",
    Star: "\u22C6",
    star: "\u2606",
    starf: "\u2605",
    straightepsilon: "\u03F5",
    straightphi: "\u03D5",
    strns: "\xAF",
    Sub: "\u22D0",
    sub: "\u2282",
    subdot: "\u2ABD",
    subE: "\u2AC5",
    sube: "\u2286",
    subedot: "\u2AC3",
    submult: "\u2AC1",
    subnE: "\u2ACB",
    subne: "\u228A",
    subplus: "\u2ABF",
    subrarr: "\u2979",
    Subset: "\u22D0",
    subset: "\u2282",
    subseteq: "\u2286",
    subseteqq: "\u2AC5",
    SubsetEqual: "\u2286",
    subsetneq: "\u228A",
    subsetneqq: "\u2ACB",
    subsim: "\u2AC7",
    subsub: "\u2AD5",
    subsup: "\u2AD3",
    succ: "\u227B",
    succapprox: "\u2AB8",
    succcurlyeq: "\u227D",
    Succeeds: "\u227B",
    SucceedsEqual: "\u2AB0",
    SucceedsSlantEqual: "\u227D",
    SucceedsTilde: "\u227F",
    succeq: "\u2AB0",
    succnapprox: "\u2ABA",
    succneqq: "\u2AB6",
    succnsim: "\u22E9",
    succsim: "\u227F",
    SuchThat: "\u220B",
    Sum: "\u2211",
    sum: "\u2211",
    sung: "\u266A",
    Sup: "\u22D1",
    sup: "\u2283",
    sup1: "\xB9",
    sup2: "\xB2",
    sup3: "\xB3",
    supdot: "\u2ABE",
    supdsub: "\u2AD8",
    supE: "\u2AC6",
    supe: "\u2287",
    supedot: "\u2AC4",
    Superset: "\u2283",
    SupersetEqual: "\u2287",
    suphsol: "\u27C9",
    suphsub: "\u2AD7",
    suplarr: "\u297B",
    supmult: "\u2AC2",
    supnE: "\u2ACC",
    supne: "\u228B",
    supplus: "\u2AC0",
    Supset: "\u22D1",
    supset: "\u2283",
    supseteq: "\u2287",
    supseteqq: "\u2AC6",
    supsetneq: "\u228B",
    supsetneqq: "\u2ACC",
    supsim: "\u2AC8",
    supsub: "\u2AD4",
    supsup: "\u2AD6",
    swarhk: "\u2926",
    swArr: "\u21D9",
    swarr: "\u2199",
    swarrow: "\u2199",
    swnwar: "\u292A",
    szlig: "\xDF",
    Tab: "	",
    target: "\u2316",
    Tau: "\u03A4",
    tau: "\u03C4",
    tbrk: "\u23B4",
    Tcaron: "\u0164",
    tcaron: "\u0165",
    Tcedil: "\u0162",
    tcedil: "\u0163",
    Tcy: "\u0422",
    tcy: "\u0442",
    tdot: "\u20DB",
    telrec: "\u2315",
    Tfr: "\u{1D517}",
    tfr: "\u{1D531}",
    there4: "\u2234",
    Therefore: "\u2234",
    therefore: "\u2234",
    Theta: "\u0398",
    theta: "\u03B8",
    thetasym: "\u03D1",
    thetav: "\u03D1",
    thickapprox: "\u2248",
    thicksim: "\u223C",
    ThickSpace: "\u205F\u200A",
    thinsp: "\u2009",
    ThinSpace: "\u2009",
    thkap: "\u2248",
    thksim: "\u223C",
    THORN: "\xDE",
    thorn: "\xFE",
    Tilde: "\u223C",
    tilde: "\u02DC",
    TildeEqual: "\u2243",
    TildeFullEqual: "\u2245",
    TildeTilde: "\u2248",
    times: "\xD7",
    timesb: "\u22A0",
    timesbar: "\u2A31",
    timesd: "\u2A30",
    tint: "\u222D",
    toea: "\u2928",
    top: "\u22A4",
    topbot: "\u2336",
    topcir: "\u2AF1",
    Topf: "\u{1D54B}",
    topf: "\u{1D565}",
    topfork: "\u2ADA",
    tosa: "\u2929",
    tprime: "\u2034",
    TRADE: "\u2122",
    trade: "\u2122",
    triangle: "\u25B5",
    triangledown: "\u25BF",
    triangleleft: "\u25C3",
    trianglelefteq: "\u22B4",
    triangleq: "\u225C",
    triangleright: "\u25B9",
    trianglerighteq: "\u22B5",
    tridot: "\u25EC",
    trie: "\u225C",
    triminus: "\u2A3A",
    TripleDot: "\u20DB",
    triplus: "\u2A39",
    trisb: "\u29CD",
    tritime: "\u2A3B",
    trpezium: "\u23E2",
    Tscr: "\u{1D4AF}",
    tscr: "\u{1D4C9}",
    TScy: "\u0426",
    tscy: "\u0446",
    TSHcy: "\u040B",
    tshcy: "\u045B",
    Tstrok: "\u0166",
    tstrok: "\u0167",
    twixt: "\u226C",
    twoheadleftarrow: "\u219E",
    twoheadrightarrow: "\u21A0",
    Uacute: "\xDA",
    uacute: "\xFA",
    Uarr: "\u219F",
    uArr: "\u21D1",
    uarr: "\u2191",
    Uarrocir: "\u2949",
    Ubrcy: "\u040E",
    ubrcy: "\u045E",
    Ubreve: "\u016C",
    ubreve: "\u016D",
    Ucirc: "\xDB",
    ucirc: "\xFB",
    Ucy: "\u0423",
    ucy: "\u0443",
    udarr: "\u21C5",
    Udblac: "\u0170",
    udblac: "\u0171",
    udhar: "\u296E",
    ufisht: "\u297E",
    Ufr: "\u{1D518}",
    ufr: "\u{1D532}",
    Ugrave: "\xD9",
    ugrave: "\xF9",
    uHar: "\u2963",
    uharl: "\u21BF",
    uharr: "\u21BE",
    uhblk: "\u2580",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    ulcrop: "\u230F",
    ultri: "\u25F8",
    Umacr: "\u016A",
    umacr: "\u016B",
    uml: "\xA8",
    UnderBar: "_",
    UnderBrace: "\u23DF",
    UnderBracket: "\u23B5",
    UnderParenthesis: "\u23DD",
    Union: "\u22C3",
    UnionPlus: "\u228E",
    Uogon: "\u0172",
    uogon: "\u0173",
    Uopf: "\u{1D54C}",
    uopf: "\u{1D566}",
    UpArrow: "\u2191",
    Uparrow: "\u21D1",
    uparrow: "\u2191",
    UpArrowBar: "\u2912",
    UpArrowDownArrow: "\u21C5",
    UpDownArrow: "\u2195",
    Updownarrow: "\u21D5",
    updownarrow: "\u2195",
    UpEquilibrium: "\u296E",
    upharpoonleft: "\u21BF",
    upharpoonright: "\u21BE",
    uplus: "\u228E",
    UpperLeftArrow: "\u2196",
    UpperRightArrow: "\u2197",
    Upsi: "\u03D2",
    upsi: "\u03C5",
    upsih: "\u03D2",
    Upsilon: "\u03A5",
    upsilon: "\u03C5",
    UpTee: "\u22A5",
    UpTeeArrow: "\u21A5",
    upuparrows: "\u21C8",
    urcorn: "\u231D",
    urcorner: "\u231D",
    urcrop: "\u230E",
    Uring: "\u016E",
    uring: "\u016F",
    urtri: "\u25F9",
    Uscr: "\u{1D4B0}",
    uscr: "\u{1D4CA}",
    utdot: "\u22F0",
    Utilde: "\u0168",
    utilde: "\u0169",
    utri: "\u25B5",
    utrif: "\u25B4",
    uuarr: "\u21C8",
    Uuml: "\xDC",
    uuml: "\xFC",
    uwangle: "\u29A7",
    vangrt: "\u299C",
    varepsilon: "\u03F5",
    varkappa: "\u03F0",
    varnothing: "\u2205",
    varphi: "\u03D5",
    varpi: "\u03D6",
    varpropto: "\u221D",
    vArr: "\u21D5",
    varr: "\u2195",
    varrho: "\u03F1",
    varsigma: "\u03C2",
    varsubsetneq: "\u228A\uFE00",
    varsubsetneqq: "\u2ACB\uFE00",
    varsupsetneq: "\u228B\uFE00",
    varsupsetneqq: "\u2ACC\uFE00",
    vartheta: "\u03D1",
    vartriangleleft: "\u22B2",
    vartriangleright: "\u22B3",
    Vbar: "\u2AEB",
    vBar: "\u2AE8",
    vBarv: "\u2AE9",
    Vcy: "\u0412",
    vcy: "\u0432",
    VDash: "\u22AB",
    Vdash: "\u22A9",
    vDash: "\u22A8",
    vdash: "\u22A2",
    Vdashl: "\u2AE6",
    Vee: "\u22C1",
    vee: "\u2228",
    veebar: "\u22BB",
    veeeq: "\u225A",
    vellip: "\u22EE",
    Verbar: "\u2016",
    verbar: "|",
    Vert: "\u2016",
    vert: "|",
    VerticalBar: "\u2223",
    VerticalLine: "|",
    VerticalSeparator: "\u2758",
    VerticalTilde: "\u2240",
    VeryThinSpace: "\u200A",
    Vfr: "\u{1D519}",
    vfr: "\u{1D533}",
    vltri: "\u22B2",
    vnsub: "\u2282\u20D2",
    vnsup: "\u2283\u20D2",
    Vopf: "\u{1D54D}",
    vopf: "\u{1D567}",
    vprop: "\u221D",
    vrtri: "\u22B3",
    Vscr: "\u{1D4B1}",
    vscr: "\u{1D4CB}",
    vsubnE: "\u2ACB\uFE00",
    vsubne: "\u228A\uFE00",
    vsupnE: "\u2ACC\uFE00",
    vsupne: "\u228B\uFE00",
    Vvdash: "\u22AA",
    vzigzag: "\u299A",
    Wcirc: "\u0174",
    wcirc: "\u0175",
    wedbar: "\u2A5F",
    Wedge: "\u22C0",
    wedge: "\u2227",
    wedgeq: "\u2259",
    weierp: "\u2118",
    Wfr: "\u{1D51A}",
    wfr: "\u{1D534}",
    Wopf: "\u{1D54E}",
    wopf: "\u{1D568}",
    wp: "\u2118",
    wr: "\u2240",
    wreath: "\u2240",
    Wscr: "\u{1D4B2}",
    wscr: "\u{1D4CC}",
    xcap: "\u22C2",
    xcirc: "\u25EF",
    xcup: "\u22C3",
    xdtri: "\u25BD",
    Xfr: "\u{1D51B}",
    xfr: "\u{1D535}",
    xhArr: "\u27FA",
    xharr: "\u27F7",
    Xi: "\u039E",
    xi: "\u03BE",
    xlArr: "\u27F8",
    xlarr: "\u27F5",
    xmap: "\u27FC",
    xnis: "\u22FB",
    xodot: "\u2A00",
    Xopf: "\u{1D54F}",
    xopf: "\u{1D569}",
    xoplus: "\u2A01",
    xotime: "\u2A02",
    xrArr: "\u27F9",
    xrarr: "\u27F6",
    Xscr: "\u{1D4B3}",
    xscr: "\u{1D4CD}",
    xsqcup: "\u2A06",
    xuplus: "\u2A04",
    xutri: "\u25B3",
    xvee: "\u22C1",
    xwedge: "\u22C0",
    Yacute: "\xDD",
    yacute: "\xFD",
    YAcy: "\u042F",
    yacy: "\u044F",
    Ycirc: "\u0176",
    ycirc: "\u0177",
    Ycy: "\u042B",
    ycy: "\u044B",
    yen: "\xA5",
    Yfr: "\u{1D51C}",
    yfr: "\u{1D536}",
    YIcy: "\u0407",
    yicy: "\u0457",
    Yopf: "\u{1D550}",
    yopf: "\u{1D56A}",
    Yscr: "\u{1D4B4}",
    yscr: "\u{1D4CE}",
    YUcy: "\u042E",
    yucy: "\u044E",
    Yuml: "\u0178",
    yuml: "\xFF",
    Zacute: "\u0179",
    zacute: "\u017A",
    Zcaron: "\u017D",
    zcaron: "\u017E",
    Zcy: "\u0417",
    zcy: "\u0437",
    Zdot: "\u017B",
    zdot: "\u017C",
    zeetrf: "\u2128",
    ZeroWidthSpace: "\u200B",
    Zeta: "\u0396",
    zeta: "\u03B6",
    Zfr: "\u2128",
    zfr: "\u{1D537}",
    ZHcy: "\u0416",
    zhcy: "\u0436",
    zigrarr: "\u21DD",
    Zopf: "\u2124",
    zopf: "\u{1D56B}",
    Zscr: "\u{1D4B5}",
    zscr: "\u{1D4CF}",
    zwj: "\u200D",
    zwnj: "\u200C"
  }), e.entityMap = e.HTML_ENTITIES;
})(pT);
var Cv = {}, id = To.NAMESPACE, wg = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, qy = new RegExp("[\\-\\.0-9" + wg.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]"), Wy = new RegExp("^" + wg.source + qy.source + "*(?::" + wg.source + qy.source + "*)?$"), Pc = 0, Ho = 1, _l = 2, Oc = 3, bl = 4, Tl = 5, Lc = 6, nf = 7;
function Yl(e, r) {
  this.message = e, this.locator = r, Error.captureStackTrace && Error.captureStackTrace(this, Yl);
}
Yl.prototype = new Error();
Yl.prototype.name = Yl.name;
function gT() {
}
gT.prototype = {
  parse: function(e, r, i) {
    var t = this.domBuilder;
    t.startDocument(), vT(r, r = {}), XC(
      e,
      r,
      i,
      t,
      this.errorHandler
    ), t.endDocument();
  }
};
function XC(e, r, i, t, n) {
  function a(M) {
    if (M > 65535) {
      M -= 65536;
      var F = 55296 + (M >> 10), G = 56320 + (M & 1023);
      return String.fromCharCode(F, G);
    } else
      return String.fromCharCode(M);
  }
  function s(M) {
    var F = M.slice(1, -1);
    return Object.hasOwnProperty.call(i, F) ? i[F] : F.charAt(0) === "#" ? a(parseInt(F.substr(1).replace("x", "0x"))) : (n.error("entity not found:" + M), M);
  }
  function o(M) {
    if (M > p) {
      var F = e.substring(p, M).replace(/&#?\w+;/g, s);
      d && l(p), t.characters(F, 0, M - p), p = M;
    }
  }
  function l(M, F) {
    for (; M >= h && (F = c.exec(e)); )
      u = F.index, h = u + F[0].length, d.lineNumber++;
    d.columnNumber = M - u + 1;
  }
  for (var u = 0, h = 0, c = /.*(?:\r\n?|\n)|.*$/g, d = t.locator, f = [{ currentNSMap: r }], m = {}, p = 0; ; ) {
    try {
      var b = e.indexOf("<", p);
      if (b < 0) {
        if (!e.substr(p).match(/^\s*$/)) {
          var y = t.doc, v = y.createTextNode(e.substr(p));
          y.appendChild(v), t.currentElement = v;
        }
        return;
      }
      switch (b > p && o(b), e.charAt(b + 1)) {
        case "/":
          var R = e.indexOf(">", b + 3), g = e.substring(b + 2, R).replace(/[ \t\n\r]+$/g, ""), E = f.pop();
          R < 0 ? (g = e.substring(b + 2).replace(/[\s<].*/, ""), n.error("end tag name: " + g + " is not complete:" + E.tagName), R = b + 1 + g.length) : g.match(/\s</) && (g = g.replace(/[\s<].*/, ""), n.error("end tag name: " + g + " maybe not complete"), R = b + 1 + g.length);
          var x = E.localNSMap, w = E.tagName == g, S = w || E.tagName && E.tagName.toLowerCase() == g.toLowerCase();
          if (S) {
            if (t.endElement(E.uri, E.localName, g), x)
              for (var T in x)
                Object.prototype.hasOwnProperty.call(x, T) && t.endPrefixMapping(T);
            w || n.fatalError("end tag name: " + g + " is not match the current start tagName:" + E.tagName);
          } else
            f.push(E);
          R++;
          break;
        case "?":
          d && l(b), R = tD(e, b, t);
          break;
        case "!":
          d && l(b), R = eD(e, b, t, n);
          break;
        default:
          d && l(b);
          var C = new mT(), D = f[f.length - 1].currentNSMap, R = JC(e, b, C, D, s, n), P = C.length;
          if (!C.closed && ZC(e, R, C.tagName, m) && (C.closed = !0, i.nbsp || n.warning("unclosed xml attribute")), d && P) {
            for (var N = Yy(d, {}), $ = 0; $ < P; $++) {
              var O = C[$];
              l(O.offset), O.locator = Yy(d, {});
            }
            t.locator = N, Ky(C, t, D) && f.push(C), t.locator = d;
          } else
            Ky(C, t, D) && f.push(C);
          id.isHTML(C.uri) && !C.closed ? R = QC(e, R, C.tagName, s, t) : R++;
      }
    } catch (M) {
      if (M instanceof Yl)
        throw M;
      n.error("element parse error: " + M), R = -1;
    }
    R > p ? p = R : o(Math.max(b, p) + 1);
  }
}
function Yy(e, r) {
  return r.lineNumber = e.lineNumber, r.columnNumber = e.columnNumber, r;
}
function JC(e, r, i, t, n, a) {
  function s(d, f, m) {
    i.attributeNames.hasOwnProperty(d) && a.fatalError("Attribute " + d + " redefined"), i.addValue(
      d,
      f.replace(/[\t\n\r]/g, " ").replace(/&#?\w+;/g, n),
      m
    );
  }
  for (var o, l, u = ++r, h = Pc; ; ) {
    var c = e.charAt(u);
    switch (c) {
      case "=":
        if (h === Ho)
          o = e.slice(r, u), h = Oc;
        else if (h === _l)
          h = Oc;
        else
          throw new Error("attribute equal must after attrName");
        break;
      case "'":
      case '"':
        if (h === Oc || h === Ho)
          if (h === Ho && (a.warning('attribute value must after "="'), o = e.slice(r, u)), r = u + 1, u = e.indexOf(c, r), u > 0)
            l = e.slice(r, u), s(o, l, r - 1), h = Tl;
          else
            throw new Error("attribute value no end '" + c + "' match");
        else if (h == bl)
          l = e.slice(r, u), s(o, l, r), a.warning('attribute "' + o + '" missed start quot(' + c + ")!!"), r = u + 1, h = Tl;
        else
          throw new Error('attribute value must after "="');
        break;
      case "/":
        switch (h) {
          case Pc:
            i.setTagName(e.slice(r, u));
          case Tl:
          case Lc:
          case nf:
            h = nf, i.closed = !0;
          case bl:
          case Ho:
            break;
          case _l:
            i.closed = !0;
            break;
          default:
            throw new Error("attribute invalid close char('/')");
        }
        break;
      case "":
        return a.error("unexpected end of input"), h == Pc && i.setTagName(e.slice(r, u)), u;
      case ">":
        switch (h) {
          case Pc:
            i.setTagName(e.slice(r, u));
          case Tl:
          case Lc:
          case nf:
            break;
          case bl:
          case Ho:
            l = e.slice(r, u), l.slice(-1) === "/" && (i.closed = !0, l = l.slice(0, -1));
          case _l:
            h === _l && (l = o), h == bl ? (a.warning('attribute "' + l + '" missed quot(")!'), s(o, l, r)) : ((!id.isHTML(t[""]) || !l.match(/^(?:disabled|checked|selected)$/i)) && a.warning('attribute "' + l + '" missed value!! "' + l + '" instead!!'), s(l, l, r));
            break;
          case Oc:
            throw new Error("attribute value missed!!");
        }
        return u;
      case "\x80":
        c = " ";
      default:
        if (c <= " ")
          switch (h) {
            case Pc:
              i.setTagName(e.slice(r, u)), h = Lc;
              break;
            case Ho:
              o = e.slice(r, u), h = _l;
              break;
            case bl:
              var l = e.slice(r, u);
              a.warning('attribute "' + l + '" missed quot(")!!'), s(o, l, r);
            case Tl:
              h = Lc;
              break;
          }
        else
          switch (h) {
            case _l:
              i.tagName, (!id.isHTML(t[""]) || !o.match(/^(?:disabled|checked|selected)$/i)) && a.warning('attribute "' + o + '" missed value!! "' + o + '" instead2!!'), s(o, o, r), r = u, h = Ho;
              break;
            case Tl:
              a.warning('attribute space is required"' + o + '"!!');
            case Lc:
              h = Ho, r = u;
              break;
            case Oc:
              h = bl, r = u;
              break;
            case nf:
              throw new Error("elements closed character '/' and '>' must be connected to");
          }
    }
    u++;
  }
}
function Ky(e, r, i) {
  for (var t = e.tagName, n = null, c = e.length; c--; ) {
    var a = e[c], s = a.qName, o = a.value, d = s.indexOf(":");
    if (d > 0)
      var l = a.prefix = s.slice(0, d), u = s.slice(d + 1), h = l === "xmlns" && u;
    else
      u = s, l = null, h = s === "xmlns" && "";
    a.localName = u, h !== !1 && (n == null && (n = {}, vT(i, i = {})), i[h] = n[h] = o, a.uri = id.XMLNS, r.startPrefixMapping(h, o));
  }
  for (var c = e.length; c--; ) {
    a = e[c];
    var l = a.prefix;
    l && (l === "xml" && (a.uri = id.XML), l !== "xmlns" && (a.uri = i[l || ""]));
  }
  var d = t.indexOf(":");
  d > 0 ? (l = e.prefix = t.slice(0, d), u = e.localName = t.slice(d + 1)) : (l = null, u = e.localName = t);
  var f = e.uri = i[l || ""];
  if (r.startElement(f, u, t, e), e.closed) {
    if (r.endElement(f, u, t), n)
      for (l in n)
        Object.prototype.hasOwnProperty.call(n, l) && r.endPrefixMapping(l);
  } else
    return e.currentNSMap = i, e.localNSMap = n, !0;
}
function QC(e, r, i, t, n) {
  if (/^(?:script|textarea)$/i.test(i)) {
    var a = e.indexOf("</" + i + ">", r), s = e.substring(r + 1, a);
    if (/[&<]/.test(s))
      return /^script$/i.test(i) ? (n.characters(s, 0, s.length), a) : (s = s.replace(/&#?\w+;/g, t), n.characters(s, 0, s.length), a);
  }
  return r + 1;
}
function ZC(e, r, i, t) {
  var n = t[i];
  return n == null && (n = e.lastIndexOf("</" + i + ">"), n < r && (n = e.lastIndexOf("</" + i)), t[i] = n), n < r;
}
function vT(e, r) {
  for (var i in e)
    Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
}
function eD(e, r, i, t) {
  var n = e.charAt(r + 2);
  switch (n) {
    case "-":
      if (e.charAt(r + 3) === "-") {
        var a = e.indexOf("-->", r + 4);
        return a > r ? (i.comment(e, r + 4, a - r - 4), a + 3) : (t.error("Unclosed comment"), -1);
      } else
        return -1;
    default:
      if (e.substr(r + 3, 6) == "CDATA[") {
        var a = e.indexOf("]]>", r + 9);
        return i.startCDATA(), i.characters(e, r + 9, a - r - 9), i.endCDATA(), a + 3;
      }
      var s = rD(e, r), o = s.length;
      if (o > 1 && /!doctype/i.test(s[0][0])) {
        var l = s[1][0], u = !1, h = !1;
        o > 3 && (/^public$/i.test(s[2][0]) ? (u = s[3][0], h = o > 4 && s[4][0]) : /^system$/i.test(s[2][0]) && (h = s[3][0]));
        var c = s[o - 1];
        return i.startDTD(l, u, h), i.endDTD(), c.index + c[0].length;
      }
  }
  return -1;
}
function tD(e, r, i) {
  var t = e.indexOf("?>", r);
  if (t) {
    var n = e.substring(r, t).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
    return n ? (n[0].length, i.processingInstruction(n[1], n[2]), t + 2) : -1;
  }
  return -1;
}
function mT() {
  this.attributeNames = {};
}
mT.prototype = {
  setTagName: function(e) {
    if (!Wy.test(e))
      throw new Error("invalid tagName:" + e);
    this.tagName = e;
  },
  addValue: function(e, r, i) {
    if (!Wy.test(e))
      throw new Error("invalid attribute:" + e);
    this.attributeNames[e] = this.length, this[this.length++] = { qName: e, value: r, offset: i };
  },
  length: 0,
  getLocalName: function(e) {
    return this[e].localName;
  },
  getLocator: function(e) {
    return this[e].locator;
  },
  getQName: function(e) {
    return this[e].qName;
  },
  getURI: function(e) {
    return this[e].uri;
  },
  getValue: function(e) {
    return this[e].value;
  }
};
function rD(e, r) {
  var i, t = [], n = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
  for (n.lastIndex = r, n.exec(e); i = n.exec(e); )
    if (t.push(i), i[1])
      return t;
}
Cv.XMLReader = gT;
Cv.ParseError = Yl;
var iD = To, nD = ou, zy = pT, yT = Cv, aD = nD.DOMImplementation, Xy = iD.NAMESPACE, sD = yT.ParseError, oD = yT.XMLReader;
function _T(e) {
  return e.replace(/\r[\n\u0085]/g, `
`).replace(/[\r\u0085\u2028]/g, `
`);
}
function bT(e) {
  this.options = e || { locator: {} };
}
bT.prototype.parseFromString = function(e, r) {
  var i = this.options, t = new oD(), n = i.domBuilder || new Ad(), a = i.errorHandler, s = i.locator, o = i.xmlns || {}, l = /\/x?html?$/.test(r), u = l ? zy.HTML_ENTITIES : zy.XML_ENTITIES;
  s && n.setDocumentLocator(s), t.errorHandler = uD(a, n, s), t.domBuilder = i.domBuilder || n, l && (o[""] = Xy.HTML), o.xml = o.xml || Xy.XML;
  var h = i.normalizeLineEndings || _T;
  return e && typeof e == "string" ? t.parse(
    h(e),
    o,
    u
  ) : t.errorHandler.error("invalid doc source"), n.doc;
};
function uD(e, r, i) {
  if (!e) {
    if (r instanceof Ad)
      return r;
    e = r;
  }
  var t = {}, n = e instanceof Function;
  i = i || {};
  function a(s) {
    var o = e[s];
    !o && n && (o = e.length == 2 ? function(l) {
      e(s, l);
    } : e), t[s] = o && function(l) {
      o("[xmldom " + s + "]	" + l + Cg(i));
    } || function() {
    };
  }
  return a("warning"), a("error"), a("fatalError"), t;
}
function Ad() {
  this.cdata = !1;
}
function Sl(e, r) {
  r.lineNumber = e.lineNumber, r.columnNumber = e.columnNumber;
}
Ad.prototype = {
  startDocument: function() {
    this.doc = new aD().createDocument(null, null, null), this.locator && (this.doc.documentURI = this.locator.systemId);
  },
  startElement: function(e, r, i, t) {
    var n = this.doc, a = n.createElementNS(e, i || r), s = t.length;
    af(this, a), this.currentElement = a, this.locator && Sl(this.locator, a);
    for (var o = 0; o < s; o++) {
      var e = t.getURI(o), l = t.getValue(o), i = t.getQName(o), u = n.createAttributeNS(e, i);
      this.locator && Sl(t.getLocator(o), u), u.value = u.nodeValue = l, a.setAttributeNode(u);
    }
  },
  endElement: function(e, r, i) {
    var t = this.currentElement;
    t.tagName, this.currentElement = t.parentNode;
  },
  startPrefixMapping: function(e, r) {
  },
  endPrefixMapping: function(e) {
  },
  processingInstruction: function(e, r) {
    var i = this.doc.createProcessingInstruction(e, r);
    this.locator && Sl(this.locator, i), af(this, i);
  },
  ignorableWhitespace: function(e, r, i) {
  },
  characters: function(e, r, i) {
    if (e = Jy.apply(this, arguments), e) {
      if (this.cdata)
        var t = this.doc.createCDATASection(e);
      else
        var t = this.doc.createTextNode(e);
      this.currentElement ? this.currentElement.appendChild(t) : /^\s*$/.test(e) && this.doc.appendChild(t), this.locator && Sl(this.locator, t);
    }
  },
  skippedEntity: function(e) {
  },
  endDocument: function() {
    this.doc.normalize();
  },
  setDocumentLocator: function(e) {
    (this.locator = e) && (e.lineNumber = 0);
  },
  comment: function(e, r, i) {
    e = Jy.apply(this, arguments);
    var t = this.doc.createComment(e);
    this.locator && Sl(this.locator, t), af(this, t);
  },
  startCDATA: function() {
    this.cdata = !0;
  },
  endCDATA: function() {
    this.cdata = !1;
  },
  startDTD: function(e, r, i) {
    var t = this.doc.implementation;
    if (t && t.createDocumentType) {
      var n = t.createDocumentType(e, r, i);
      this.locator && Sl(this.locator, n), af(this, n), this.doc.doctype = n;
    }
  },
  warning: function(e) {
    console.warn("[xmldom warning]	" + e, Cg(this.locator));
  },
  error: function(e) {
    console.error("[xmldom error]	" + e, Cg(this.locator));
  },
  fatalError: function(e) {
    throw new sD(e, this.locator);
  }
};
function Cg(e) {
  if (e)
    return `
@` + (e.systemId || "") + "#[line:" + e.lineNumber + ",col:" + e.columnNumber + "]";
}
function Jy(e, r, i) {
  return typeof e == "string" ? e.substr(r, i) : e.length >= r + i || r ? new java.lang.String(e, r, i) + "" : e;
}
"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(e) {
  Ad.prototype[e] = function() {
    return null;
  };
});
function af(e, r) {
  e.currentElement ? e.currentElement.appendChild(r) : e.doc.appendChild(r);
}
wh.__DOMHandler = Ad;
wh.normalizeLineEndings = _T;
wh.DOMParser = bT;
var lD = wh.DOMParser;
/*! @name mpd-parser @version 0.22.1 @license Apache-2.0 */
var Qy = function(r) {
  return !!r && typeof r == "object";
}, Qn = function e() {
  for (var r = arguments.length, i = new Array(r), t = 0; t < r; t++)
    i[t] = arguments[t];
  return i.reduce(function(n, a) {
    return typeof a != "object" || Object.keys(a).forEach(function(s) {
      Array.isArray(n[s]) && Array.isArray(a[s]) ? n[s] = n[s].concat(a[s]) : Qy(n[s]) && Qy(a[s]) ? n[s] = e(n[s], a[s]) : n[s] = a[s];
    }), n;
  }, {});
}, TT = function(r) {
  return Object.keys(r).map(function(i) {
    return r[i];
  });
}, cD = function(r, i) {
  for (var t = [], n = r; n < i; n++)
    t.push(n);
  return t;
}, Ch = function(r) {
  return r.reduce(function(i, t) {
    return i.concat(t);
  }, []);
}, ST = function(r) {
  if (!r.length)
    return [];
  for (var i = [], t = 0; t < r.length; t++)
    i.push(r[t]);
  return i;
}, dD = function(r, i) {
  return r.reduce(function(t, n, a) {
    return n[i] && t.push(a), t;
  }, []);
}, Dg = function(r, i) {
  for (var t = 0; t < r.length; t++)
    if (i(r[t]))
      return t;
  return -1;
}, fD = function(r, i) {
  return TT(r.reduce(function(t, n) {
    return n.forEach(function(a) {
      t[i(a)] = a;
    }), t;
  }, {}));
}, Kl = {
  INVALID_NUMBER_OF_PERIOD: "INVALID_NUMBER_OF_PERIOD",
  DASH_EMPTY_MANIFEST: "DASH_EMPTY_MANIFEST",
  DASH_INVALID_XML: "DASH_INVALID_XML",
  NO_BASE_URL: "NO_BASE_URL",
  MISSING_SEGMENT_INFORMATION: "MISSING_SEGMENT_INFORMATION",
  SEGMENT_TIME_UNSPECIFIED: "SEGMENT_TIME_UNSPECIFIED",
  UNSUPPORTED_UTC_TIMING_SCHEME: "UNSUPPORTED_UTC_TIMING_SCHEME"
}, nd = function(r) {
  var i = r.baseUrl, t = i === void 0 ? "" : i, n = r.source, a = n === void 0 ? "" : n, s = r.range, o = s === void 0 ? "" : s, l = r.indexRange, u = l === void 0 ? "" : l, h = {
    uri: a,
    resolvedUri: mv(t || "", a)
  };
  if (o || u) {
    var c = o || u, d = c.split("-"), f = ai.BigInt ? ai.BigInt(d[0]) : parseInt(d[0], 10), m = ai.BigInt ? ai.BigInt(d[1]) : parseInt(d[1], 10);
    f < Number.MAX_SAFE_INTEGER && typeof f == "bigint" && (f = Number(f)), m < Number.MAX_SAFE_INTEGER && typeof m == "bigint" && (m = Number(m));
    var p;
    typeof m == "bigint" || typeof f == "bigint" ? p = ai.BigInt(m) - ai.BigInt(f) + ai.BigInt(1) : p = m - f + 1, typeof p == "bigint" && p < Number.MAX_SAFE_INTEGER && (p = Number(p)), h.byterange = {
      length: p,
      offset: f
    };
  }
  return h;
}, hD = function(r) {
  var i;
  return typeof r.offset == "bigint" || typeof r.length == "bigint" ? i = ai.BigInt(r.offset) + ai.BigInt(r.length) - ai.BigInt(1) : i = r.offset + r.length - 1, r.offset + "-" + i;
}, Zy = function(r) {
  return r && typeof r != "number" && (r = parseInt(r, 10)), isNaN(r) ? null : r;
}, pD = {
  static: function(r) {
    var i = r.duration, t = r.timescale, n = t === void 0 ? 1 : t, a = r.sourceDuration, s = r.periodDuration, o = Zy(r.endNumber), l = i / n;
    return typeof o == "number" ? {
      start: 0,
      end: o
    } : typeof s == "number" ? {
      start: 0,
      end: s / l
    } : {
      start: 0,
      end: a / l
    };
  },
  dynamic: function(r) {
    var i = r.NOW, t = r.clientOffset, n = r.availabilityStartTime, a = r.timescale, s = a === void 0 ? 1 : a, o = r.duration, l = r.periodStart, u = l === void 0 ? 0 : l, h = r.minimumUpdatePeriod, c = h === void 0 ? 0 : h, d = r.timeShiftBufferDepth, f = d === void 0 ? 1 / 0 : d, m = Zy(r.endNumber), p = (i + t) / 1e3, b = n + u, y = p + c, v = y - b, g = Math.ceil(v * s / o), E = Math.floor((p - b - f) * s / o), x = Math.floor((p - b) * s / o);
    return {
      start: Math.max(0, E),
      end: typeof m == "number" ? m : Math.min(g, x)
    };
  }
}, gD = function(r) {
  return function(i) {
    var t = r.duration, n = r.timescale, a = n === void 0 ? 1 : n, s = r.periodStart, o = r.startNumber, l = o === void 0 ? 1 : o;
    return {
      number: l + i,
      duration: t / a,
      timeline: s,
      time: i * t
    };
  };
}, Dv = function(r) {
  var i = r.type, t = r.duration, n = r.timescale, a = n === void 0 ? 1 : n, s = r.periodDuration, o = r.sourceDuration, l = pD[i](r), u = l.start, h = l.end, c = cD(u, h).map(gD(r));
  if (i === "static") {
    var d = c.length - 1, f = typeof s == "number" ? s : o;
    c[d].duration = f - t / a * d;
  }
  return c;
}, ET = function(r) {
  var i = r.baseUrl, t = r.initialization, n = t === void 0 ? {} : t, a = r.sourceDuration, s = r.indexRange, o = s === void 0 ? "" : s, l = r.periodStart, u = r.presentationTime, h = r.number, c = h === void 0 ? 0 : h, d = r.duration;
  if (!i)
    throw new Error(Kl.NO_BASE_URL);
  var f = nd({
    baseUrl: i,
    source: n.sourceURL,
    range: n.range
  }), m = nd({
    baseUrl: i,
    source: i,
    indexRange: o
  });
  if (m.map = f, d) {
    var p = Dv(r);
    p.length && (m.duration = p[0].duration, m.timeline = p[0].timeline);
  } else
    a && (m.duration = a, m.timeline = l);
  return m.presentationTime = u || l, m.number = c, [m];
}, vD = function(r, i, t) {
  var n = r.sidx.map ? r.sidx.map : null, a = r.sidx.duration, s = r.timeline || 0, o = r.sidx.byterange, l = o.offset + o.length, u = i.timescale, h = i.references.filter(function(C) {
    return C.referenceType !== 1;
  }), c = [], d = r.endList ? "static" : "dynamic", f = r.sidx.timeline, m = f, p = r.mediaSequence || 0, b;
  typeof i.firstOffset == "bigint" ? b = ai.BigInt(l) + i.firstOffset : b = l + i.firstOffset;
  for (var y = 0; y < h.length; y++) {
    var v = i.references[y], g = v.referencedSize, E = v.subsegmentDuration, x = void 0;
    typeof b == "bigint" ? x = b + ai.BigInt(g) - ai.BigInt(1) : x = b + g - 1;
    var w = b + "-" + x, S = {
      baseUrl: t,
      timescale: u,
      timeline: s,
      periodStart: f,
      presentationTime: m,
      number: p,
      duration: E,
      sourceDuration: a,
      indexRange: w,
      type: d
    }, T = ET(S)[0];
    n && (T.map = n), c.push(T), typeof b == "bigint" ? b += ai.BigInt(g) : b += g, m += E / u, p++;
  }
  return r.segments = c, r;
}, mD = ["AUDIO", "SUBTITLES"], yD = 1 / 60, xT = function(r) {
  return fD(r, function(i) {
    var t = i.timeline;
    return t;
  }).sort(function(i, t) {
    return i.timeline > t.timeline ? 1 : -1;
  });
}, _D = function(r, i) {
  for (var t = 0; t < r.length; t++)
    if (r[t].attributes.NAME === i)
      return r[t];
  return null;
}, e_ = function(r) {
  var i = [];
  return LC(r, mD, function(t, n, a, s) {
    i = i.concat(t.playlists || []);
  }), i;
}, t_ = function(r) {
  var i = r.playlist, t = r.mediaSequence;
  i.mediaSequence = t, i.segments.forEach(function(n, a) {
    n.number = i.mediaSequence + a;
  });
}, bD = function(r) {
  var i = r.oldPlaylists, t = r.newPlaylists, n = r.timelineStarts;
  t.forEach(function(a) {
    a.discontinuitySequence = Dg(n, function(h) {
      var c = h.timeline;
      return c === a.timeline;
    });
    var s = _D(i, a.attributes.NAME);
    if (!!s && !a.sidx) {
      var o = a.segments[0], l = Dg(s.segments, function(h) {
        return Math.abs(h.presentationTime - o.presentationTime) < yD;
      });
      if (l === -1) {
        t_({
          playlist: a,
          mediaSequence: s.mediaSequence + s.segments.length
        }), a.segments[0].discontinuity = !0, a.discontinuityStarts.unshift(0), (!s.segments.length && a.timeline > s.timeline || s.segments.length && a.timeline > s.segments[s.segments.length - 1].timeline) && a.discontinuitySequence--;
        return;
      }
      var u = s.segments[l];
      u.discontinuity && !o.discontinuity && (o.discontinuity = !0, a.discontinuityStarts.unshift(0), a.discontinuitySequence--), t_({
        playlist: a,
        mediaSequence: s.segments[l].number
      });
    }
  });
}, TD = function(r) {
  var i = r.oldManifest, t = r.newManifest, n = i.playlists.concat(e_(i)), a = t.playlists.concat(e_(t));
  return t.timelineStarts = xT([i.timelineStarts, t.timelineStarts]), bD({
    oldPlaylists: n,
    newPlaylists: a,
    timelineStarts: t.timelineStarts
  }), t;
}, SD = function(r) {
  return r && r.uri + "-" + hD(r.byterange);
}, Ip = function(r) {
  var i = TT(r.reduce(function(t, n) {
    var a = n.attributes.id + (n.attributes.lang || "");
    if (!t[a])
      t[a] = n, t[a].attributes.timelineStarts = [];
    else {
      if (n.segments) {
        var s;
        n.segments[0] && (n.segments[0].discontinuity = !0), (s = t[a].segments).push.apply(s, n.segments);
      }
      n.attributes.contentProtection && (t[a].attributes.contentProtection = n.attributes.contentProtection);
    }
    return t[a].attributes.timelineStarts.push({
      start: n.attributes.periodStart,
      timeline: n.attributes.periodStart
    }), t;
  }, {}));
  return i.map(function(t) {
    return t.discontinuityStarts = dD(t.segments || [], "discontinuity"), t;
  });
}, kv = function(r, i) {
  var t = SD(r.sidx), n = t && i[t] && i[t].sidx;
  return n && vD(r, n, r.sidx.resolvedUri), r;
}, ED = function(r, i) {
  if (i === void 0 && (i = {}), !Object.keys(i).length)
    return r;
  for (var t in r)
    r[t] = kv(r[t], i);
  return r;
}, xD = function(r, i) {
  var t, n = r.attributes, a = r.segments, s = r.sidx, o = r.mediaSequence, l = r.discontinuitySequence, u = r.discontinuityStarts, h = {
    attributes: (t = {
      NAME: n.id,
      BANDWIDTH: n.bandwidth,
      CODECS: n.codecs
    }, t["PROGRAM-ID"] = 1, t),
    uri: "",
    endList: n.type === "static",
    timeline: n.periodStart,
    resolvedUri: "",
    targetDuration: n.duration,
    discontinuitySequence: l,
    discontinuityStarts: u,
    timelineStarts: n.timelineStarts,
    mediaSequence: o,
    segments: a
  };
  return n.contentProtection && (h.contentProtection = n.contentProtection), s && (h.sidx = s), i && (h.attributes.AUDIO = "audio", h.attributes.SUBTITLES = "subs"), h;
}, AD = function(r) {
  var i, t = r.attributes, n = r.segments, a = r.mediaSequence, s = r.discontinuityStarts, o = r.discontinuitySequence;
  typeof n > "u" && (n = [{
    uri: t.baseUrl,
    timeline: t.periodStart,
    resolvedUri: t.baseUrl || "",
    duration: t.sourceDuration,
    number: 0
  }], t.duration = t.sourceDuration);
  var l = (i = {
    NAME: t.id,
    BANDWIDTH: t.bandwidth
  }, i["PROGRAM-ID"] = 1, i);
  return t.codecs && (l.CODECS = t.codecs), {
    attributes: l,
    uri: "",
    endList: t.type === "static",
    timeline: t.periodStart,
    resolvedUri: t.baseUrl || "",
    targetDuration: t.duration,
    timelineStarts: t.timelineStarts,
    discontinuityStarts: s,
    discontinuitySequence: o,
    mediaSequence: a,
    segments: n
  };
}, wD = function(r, i, t) {
  i === void 0 && (i = {}), t === void 0 && (t = !1);
  var n, a = r.reduce(function(o, l) {
    var u = l.attributes.role && l.attributes.role.value || "", h = l.attributes.lang || "", c = l.attributes.label || "main";
    if (h && !l.attributes.label) {
      var d = u ? " (" + u + ")" : "";
      c = "" + l.attributes.lang + d;
    }
    o[c] || (o[c] = {
      language: h,
      autoselect: !0,
      default: u === "main",
      playlists: [],
      uri: ""
    });
    var f = kv(xD(l, t), i);
    return o[c].playlists.push(f), typeof n > "u" && u === "main" && (n = l, n.default = !0), o;
  }, {});
  if (!n) {
    var s = Object.keys(a)[0];
    a[s].default = !0;
  }
  return a;
}, CD = function(r, i) {
  return i === void 0 && (i = {}), r.reduce(function(t, n) {
    var a = n.attributes.lang || "text";
    return t[a] || (t[a] = {
      language: a,
      default: !1,
      autoselect: !1,
      playlists: [],
      uri: ""
    }), t[a].playlists.push(kv(AD(n), i)), t;
  }, {});
}, DD = function(r) {
  return r.reduce(function(i, t) {
    return t && t.forEach(function(n) {
      var a = n.channel, s = n.language;
      i[s] = {
        autoselect: !1,
        default: !1,
        instreamId: a,
        language: s
      }, n.hasOwnProperty("aspectRatio") && (i[s].aspectRatio = n.aspectRatio), n.hasOwnProperty("easyReader") && (i[s].easyReader = n.easyReader), n.hasOwnProperty("3D") && (i[s]["3D"] = n["3D"]);
    }), i;
  }, {});
}, kD = function(r) {
  var i, t = r.attributes, n = r.segments, a = r.sidx, s = r.discontinuityStarts, o = {
    attributes: (i = {
      NAME: t.id,
      AUDIO: "audio",
      SUBTITLES: "subs",
      RESOLUTION: {
        width: t.width,
        height: t.height
      },
      CODECS: t.codecs,
      BANDWIDTH: t.bandwidth
    }, i["PROGRAM-ID"] = 1, i),
    uri: "",
    endList: t.type === "static",
    timeline: t.periodStart,
    resolvedUri: "",
    targetDuration: t.duration,
    discontinuityStarts: s,
    timelineStarts: t.timelineStarts,
    segments: n
  };
  return t.frameRate && (o.attributes["FRAME-RATE"] = t.frameRate), t.contentProtection && (o.contentProtection = t.contentProtection), a && (o.sidx = a), o;
}, RD = function(r) {
  var i = r.attributes;
  return i.mimeType === "video/mp4" || i.mimeType === "video/webm" || i.contentType === "video";
}, PD = function(r) {
  var i = r.attributes;
  return i.mimeType === "audio/mp4" || i.mimeType === "audio/webm" || i.contentType === "audio";
}, OD = function(r) {
  var i = r.attributes;
  return i.mimeType === "text/vtt" || i.contentType === "text";
}, LD = function(r, i) {
  r.forEach(function(t) {
    t.mediaSequence = 0, t.discontinuitySequence = Dg(i, function(n) {
      var a = n.timeline;
      return a === t.timeline;
    }), t.segments && t.segments.forEach(function(n, a) {
      n.number = a;
    });
  });
}, r_ = function(r) {
  return r ? Object.keys(r).reduce(function(i, t) {
    var n = r[t];
    return i.concat(n.playlists);
  }, []) : [];
}, ID = function(r) {
  var i, t = r.dashPlaylists, n = r.locations, a = r.sidxMapping, s = a === void 0 ? {} : a, o = r.previousManifest;
  if (!t.length)
    return {};
  var l = t[0].attributes, u = l.sourceDuration, h = l.type, c = l.suggestedPresentationDelay, d = l.minimumUpdatePeriod, f = Ip(t.filter(RD)).map(kD), m = Ip(t.filter(PD)), p = Ip(t.filter(OD)), b = t.map(function(S) {
    return S.attributes.captionServices;
  }).filter(Boolean), y = {
    allowCache: !0,
    discontinuityStarts: [],
    segments: [],
    endList: !0,
    mediaGroups: (i = {
      AUDIO: {},
      VIDEO: {}
    }, i["CLOSED-CAPTIONS"] = {}, i.SUBTITLES = {}, i),
    uri: "",
    duration: u,
    playlists: ED(f, s)
  };
  d >= 0 && (y.minimumUpdatePeriod = d * 1e3), n && (y.locations = n), h === "dynamic" && (y.suggestedPresentationDelay = c);
  var v = y.playlists.length === 0, g = m.length ? wD(m, s, v) : null, E = p.length ? CD(p, s) : null, x = f.concat(r_(g), r_(E)), w = x.map(function(S) {
    var T = S.timelineStarts;
    return T;
  });
  return y.timelineStarts = xT(w), LD(x, y.timelineStarts), g && (y.mediaGroups.AUDIO.audio = g), E && (y.mediaGroups.SUBTITLES.subs = E), b.length && (y.mediaGroups["CLOSED-CAPTIONS"].cc = DD(b)), o ? TD({
    oldManifest: o,
    newManifest: y
  }) : y;
}, MD = function(r, i, t) {
  var n = r.NOW, a = r.clientOffset, s = r.availabilityStartTime, o = r.timescale, l = o === void 0 ? 1 : o, u = r.periodStart, h = u === void 0 ? 0 : u, c = r.minimumUpdatePeriod, d = c === void 0 ? 0 : c, f = (n + a) / 1e3, m = s + h, p = f + d, b = p - m;
  return Math.ceil((b * l - i) / t);
}, AT = function(r, i) {
  for (var t = r.type, n = r.minimumUpdatePeriod, a = n === void 0 ? 0 : n, s = r.media, o = s === void 0 ? "" : s, l = r.sourceDuration, u = r.timescale, h = u === void 0 ? 1 : u, c = r.startNumber, d = c === void 0 ? 1 : c, f = r.periodStart, m = [], p = -1, b = 0; b < i.length; b++) {
    var y = i[b], v = y.d, g = y.r || 0, E = y.t || 0;
    p < 0 && (p = E), E && E > p && (p = E);
    var x = void 0;
    if (g < 0) {
      var w = b + 1;
      w === i.length ? t === "dynamic" && a > 0 && o.indexOf("$Number$") > 0 ? x = MD(r, p, v) : x = (l * h - p) / v : x = (i[w].t - p) / v;
    } else
      x = g + 1;
    for (var S = d + m.length + x, T = d + m.length; T < S; )
      m.push({
        number: T,
        duration: v / h,
        time: p,
        timeline: f
      }), p += v, T++;
  }
  return m;
}, ND = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g, FD = function(r) {
  return function(i, t, n, a) {
    if (i === "$$")
      return "$";
    if (typeof r[t] > "u")
      return i;
    var s = "" + r[t];
    return t === "RepresentationID" || (n ? a = parseInt(a, 10) : a = 1, s.length >= a) ? s : "" + new Array(a - s.length + 1).join("0") + s;
  };
}, i_ = function(r, i) {
  return r.replace(ND, FD(i));
}, UD = function(r, i) {
  return !r.duration && !i ? [{
    number: r.startNumber || 1,
    duration: r.sourceDuration,
    time: 0,
    timeline: r.periodStart
  }] : r.duration ? Dv(r) : AT(r, i);
}, BD = function(r, i) {
  var t = {
    RepresentationID: r.id,
    Bandwidth: r.bandwidth || 0
  }, n = r.initialization, a = n === void 0 ? {
    sourceURL: "",
    range: ""
  } : n, s = nd({
    baseUrl: r.baseUrl,
    source: i_(a.sourceURL, t),
    range: a.range
  }), o = UD(r, i);
  return o.map(function(l) {
    t.Number = l.number, t.Time = l.time;
    var u = i_(r.media || "", t), h = r.timescale || 1, c = r.presentationTimeOffset || 0, d = r.periodStart + (l.time - c) / h, f = {
      uri: u,
      timeline: l.timeline,
      duration: l.duration,
      resolvedUri: mv(r.baseUrl || "", u),
      map: s,
      number: l.number,
      presentationTime: d
    };
    return f;
  });
}, jD = function(r, i) {
  var t = r.baseUrl, n = r.initialization, a = n === void 0 ? {} : n, s = nd({
    baseUrl: t,
    source: a.sourceURL,
    range: a.range
  }), o = nd({
    baseUrl: t,
    source: i.media,
    range: i.mediaRange
  });
  return o.map = s, o;
}, $D = function(r, i) {
  var t = r.duration, n = r.segmentUrls, a = n === void 0 ? [] : n, s = r.periodStart;
  if (!t && !i || t && i)
    throw new Error(Kl.SEGMENT_TIME_UNSPECIFIED);
  var o = a.map(function(h) {
    return jD(r, h);
  }), l;
  t && (l = Dv(r)), i && (l = AT(r, i));
  var u = l.map(function(h, c) {
    if (o[c]) {
      var d = o[c], f = r.timescale || 1, m = r.presentationTimeOffset || 0;
      return d.timeline = h.timeline, d.duration = h.duration, d.number = h.number, d.presentationTime = s + (h.time - m) / f, d;
    }
  }).filter(function(h) {
    return h;
  });
  return u;
}, GD = function(r) {
  var i = r.attributes, t = r.segmentInfo, n, a;
  t.template ? (a = BD, n = Qn(i, t.template)) : t.base ? (a = ET, n = Qn(i, t.base)) : t.list && (a = $D, n = Qn(i, t.list));
  var s = {
    attributes: i
  };
  if (!a)
    return s;
  var o = a(n, t.segmentTimeline);
  if (n.duration) {
    var l = n, u = l.duration, h = l.timescale, c = h === void 0 ? 1 : h;
    n.duration = u / c;
  } else
    o.length ? n.duration = o.reduce(function(d, f) {
      return Math.max(d, Math.ceil(f.duration));
    }, 0) : n.duration = 0;
  return s.attributes = n, s.segments = o, t.base && n.indexRange && (s.sidx = o[0], s.segments = []), s;
}, HD = function(r) {
  return r.map(GD);
}, qi = function(r, i) {
  return ST(r.childNodes).filter(function(t) {
    var n = t.tagName;
    return n === i;
  });
}, Rv = function(r) {
  return r.textContent.trim();
}, VD = function(r) {
  return parseFloat(r.split("/").reduce(function(i, t) {
    return i / t;
  }));
}, El = function(r) {
  var i = 31536e3, t = 30 * 24 * 60 * 60, n = 24 * 60 * 60, a = 60 * 60, s = 60, o = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/, l = o.exec(r);
  if (!l)
    return 0;
  var u = l.slice(1), h = u[0], c = u[1], d = u[2], f = u[3], m = u[4], p = u[5];
  return parseFloat(h || 0) * i + parseFloat(c || 0) * t + parseFloat(d || 0) * n + parseFloat(f || 0) * a + parseFloat(m || 0) * s + parseFloat(p || 0);
}, qD = function(r) {
  var i = /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/;
  return i.test(r) && (r += "Z"), Date.parse(r);
}, n_ = {
  mediaPresentationDuration: function(r) {
    return El(r);
  },
  availabilityStartTime: function(r) {
    return qD(r) / 1e3;
  },
  minimumUpdatePeriod: function(r) {
    return El(r);
  },
  suggestedPresentationDelay: function(r) {
    return El(r);
  },
  type: function(r) {
    return r;
  },
  timeShiftBufferDepth: function(r) {
    return El(r);
  },
  start: function(r) {
    return El(r);
  },
  width: function(r) {
    return parseInt(r, 10);
  },
  height: function(r) {
    return parseInt(r, 10);
  },
  bandwidth: function(r) {
    return parseInt(r, 10);
  },
  frameRate: function(r) {
    return VD(r);
  },
  startNumber: function(r) {
    return parseInt(r, 10);
  },
  timescale: function(r) {
    return parseInt(r, 10);
  },
  presentationTimeOffset: function(r) {
    return parseInt(r, 10);
  },
  duration: function(r) {
    var i = parseInt(r, 10);
    return isNaN(i) ? El(r) : i;
  },
  d: function(r) {
    return parseInt(r, 10);
  },
  t: function(r) {
    return parseInt(r, 10);
  },
  r: function(r) {
    return parseInt(r, 10);
  },
  DEFAULT: function(r) {
    return r;
  }
}, Mn = function(r) {
  return r && r.attributes ? ST(r.attributes).reduce(function(i, t) {
    var n = n_[t.name] || n_.DEFAULT;
    return i[t.name] = n(t.value), i;
  }, {}) : {};
}, WD = {
  "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
  "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
  "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
  "urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb": "com.adobe.primetime"
}, Dh = function(r, i) {
  return i.length ? Ch(r.map(function(t) {
    return i.map(function(n) {
      return mv(t, Rv(n));
    });
  })) : r;
}, Pv = function(r) {
  var i = qi(r, "SegmentTemplate")[0], t = qi(r, "SegmentList")[0], n = t && qi(t, "SegmentURL").map(function(d) {
    return Qn({
      tag: "SegmentURL"
    }, Mn(d));
  }), a = qi(r, "SegmentBase")[0], s = t || i, o = s && qi(s, "SegmentTimeline")[0], l = t || a || i, u = l && qi(l, "Initialization")[0], h = i && Mn(i);
  h && u ? h.initialization = u && Mn(u) : h && h.initialization && (h.initialization = {
    sourceURL: h.initialization
  });
  var c = {
    template: h,
    segmentTimeline: o && qi(o, "S").map(function(d) {
      return Mn(d);
    }),
    list: t && Qn(Mn(t), {
      segmentUrls: n,
      initialization: Mn(u)
    }),
    base: a && Qn(Mn(a), {
      initialization: Mn(u)
    })
  };
  return Object.keys(c).forEach(function(d) {
    c[d] || delete c[d];
  }), c;
}, YD = function(r, i, t) {
  return function(n) {
    var a = qi(n, "BaseURL"), s = Dh(i, a), o = Qn(r, Mn(n)), l = Pv(n);
    return s.map(function(u) {
      return {
        segmentInfo: Qn(t, l),
        attributes: Qn(o, {
          baseUrl: u
        })
      };
    });
  };
}, KD = function(r) {
  return r.reduce(function(i, t) {
    var n = Mn(t);
    n.schemeIdUri && (n.schemeIdUri = n.schemeIdUri.toLowerCase());
    var a = WD[n.schemeIdUri];
    if (a) {
      i[a] = {
        attributes: n
      };
      var s = qi(t, "cenc:pssh")[0];
      if (s) {
        var o = Rv(s);
        i[a].pssh = o && MC(o);
      }
    }
    return i;
  }, {});
}, zD = function(r) {
  if (r.schemeIdUri === "urn:scte:dash:cc:cea-608:2015") {
    var i = typeof r.value != "string" ? [] : r.value.split(";");
    return i.map(function(n) {
      var a, s;
      if (s = n, /^CC\d=/.test(n)) {
        var o = n.split("=");
        a = o[0], s = o[1];
      } else
        /^CC\d$/.test(n) && (a = n);
      return {
        channel: a,
        language: s
      };
    });
  } else if (r.schemeIdUri === "urn:scte:dash:cc:cea-708:2015") {
    var t = typeof r.value != "string" ? [] : r.value.split(";");
    return t.map(function(n) {
      var a = {
        channel: void 0,
        language: void 0,
        aspectRatio: 1,
        easyReader: 0,
        "3D": 0
      };
      if (/=/.test(n)) {
        var s = n.split("="), o = s[0], l = s[1], u = l === void 0 ? "" : l;
        a.channel = o, a.language = n, u.split(",").forEach(function(h) {
          var c = h.split(":"), d = c[0], f = c[1];
          d === "lang" ? a.language = f : d === "er" ? a.easyReader = Number(f) : d === "war" ? a.aspectRatio = Number(f) : d === "3D" && (a["3D"] = Number(f));
        });
      } else
        a.language = n;
      return a.channel && (a.channel = "SERVICE" + a.channel), a;
    });
  }
}, XD = function(r, i, t) {
  return function(n) {
    var a = Mn(n), s = Dh(i, qi(n, "BaseURL")), o = qi(n, "Role")[0], l = {
      role: Mn(o)
    }, u = Qn(r, a, l), h = qi(n, "Accessibility")[0], c = zD(Mn(h));
    c && (u = Qn(u, {
      captionServices: c
    }));
    var d = qi(n, "Label")[0];
    if (d && d.childNodes.length) {
      var f = d.childNodes[0].nodeValue.trim();
      u = Qn(u, {
        label: f
      });
    }
    var m = KD(qi(n, "ContentProtection"));
    Object.keys(m).length && (u = Qn(u, {
      contentProtection: m
    }));
    var p = Pv(n), b = qi(n, "Representation"), y = Qn(t, p);
    return Ch(b.map(YD(u, s, y)));
  };
}, JD = function(r, i) {
  return function(t, n) {
    var a = Dh(i, qi(t.node, "BaseURL")), s = Qn(r, {
      periodStart: t.attributes.start
    });
    typeof t.attributes.duration == "number" && (s.periodDuration = t.attributes.duration);
    var o = qi(t.node, "AdaptationSet"), l = Pv(t.node);
    return Ch(o.map(XD(s, a, l)));
  };
}, QD = function(r) {
  var i = r.attributes, t = r.priorPeriodAttributes, n = r.mpdType;
  return typeof i.start == "number" ? i.start : t && typeof t.start == "number" && typeof t.duration == "number" ? t.start + t.duration : !t && n === "static" ? 0 : null;
}, ZD = function(r, i) {
  i === void 0 && (i = {});
  var t = i, n = t.manifestUri, a = n === void 0 ? "" : n, s = t.NOW, o = s === void 0 ? Date.now() : s, l = t.clientOffset, u = l === void 0 ? 0 : l, h = qi(r, "Period");
  if (!h.length)
    throw new Error(Kl.INVALID_NUMBER_OF_PERIOD);
  var c = qi(r, "Location"), d = Mn(r), f = Dh([a], qi(r, "BaseURL"));
  d.type = d.type || "static", d.sourceDuration = d.mediaPresentationDuration || 0, d.NOW = o, d.clientOffset = u, c.length && (d.locations = c.map(Rv));
  var m = [];
  return h.forEach(function(p, b) {
    var y = Mn(p), v = m[b - 1];
    y.start = QD({
      attributes: y,
      priorPeriodAttributes: v ? v.attributes : null,
      mpdType: d.type
    }), m.push({
      node: p,
      attributes: y
    });
  }), {
    locations: d.locations,
    representationInfo: Ch(m.map(JD(d, f)))
  };
}, wT = function(r) {
  if (r === "")
    throw new Error(Kl.DASH_EMPTY_MANIFEST);
  var i = new lD(), t, n;
  try {
    t = i.parseFromString(r, "application/xml"), n = t && t.documentElement.tagName === "MPD" ? t.documentElement : null;
  } catch {
  }
  if (!n || n && n.getElementsByTagName("parsererror").length > 0)
    throw new Error(Kl.DASH_INVALID_XML);
  return n;
}, ek = function(r) {
  var i = qi(r, "UTCTiming")[0];
  if (!i)
    return null;
  var t = Mn(i);
  switch (t.schemeIdUri) {
    case "urn:mpeg:dash:utc:http-head:2014":
    case "urn:mpeg:dash:utc:http-head:2012":
      t.method = "HEAD";
      break;
    case "urn:mpeg:dash:utc:http-xsdate:2014":
    case "urn:mpeg:dash:utc:http-iso:2014":
    case "urn:mpeg:dash:utc:http-xsdate:2012":
    case "urn:mpeg:dash:utc:http-iso:2012":
      t.method = "GET";
      break;
    case "urn:mpeg:dash:utc:direct:2014":
    case "urn:mpeg:dash:utc:direct:2012":
      t.method = "DIRECT", t.value = Date.parse(t.value);
      break;
    case "urn:mpeg:dash:utc:http-ntp:2014":
    case "urn:mpeg:dash:utc:ntp:2014":
    case "urn:mpeg:dash:utc:sntp:2014":
    default:
      throw new Error(Kl.UNSUPPORTED_UTC_TIMING_SCHEME);
  }
  return t;
}, CT = function(r, i) {
  i === void 0 && (i = {});
  var t = ZD(wT(r), i), n = HD(t.representationInfo);
  return ID({
    dashPlaylists: n,
    locations: t.locations,
    sidxMapping: i.sidxMapping,
    previousManifest: i.previousManifest
  });
}, tk = function(r) {
  return ek(wT(r));
}, DT = Math.pow(2, 32), rk = function(e) {
  var r = new DataView(e.buffer, e.byteOffset, e.byteLength), i;
  return r.getBigUint64 ? (i = r.getBigUint64(0), i < Number.MAX_SAFE_INTEGER ? Number(i) : i) : r.getUint32(0) * DT + r.getUint32(4);
}, kh = {
  getUint64: rk,
  MAX_UINT32: DT
}, ik = function(e) {
  var r = "";
  return r += String.fromCharCode(e[0]), r += String.fromCharCode(e[1]), r += String.fromCharCode(e[2]), r += String.fromCharCode(e[3]), r;
}, Ov = ik, nk = function(e) {
  return e >>> 0;
}, ak = function(e) {
  return ("00" + e.toString(16)).slice(-2);
}, Rh = {
  toUnsigned: nk,
  toHexString: ak
}, sk = Rh.toUnsigned, ok = Ov, kT = function(e, r) {
  var i = [], t, n, a, s, o;
  if (!r.length)
    return null;
  for (t = 0; t < e.byteLength; )
    n = sk(e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3]), a = ok(e.subarray(t + 4, t + 8)), s = n > 1 ? t + n : e.byteLength, a === r[0] && (r.length === 1 ? i.push(e.subarray(t + 8, s)) : (o = kT(e.subarray(t + 8, s), r.slice(1)), o.length && (i = i.concat(o)))), t = s;
  return i;
}, Lv = kT, Mp, a_;
function uk() {
  if (a_)
    return Mp;
  a_ = 1;
  var e = kh.getUint64, r = function(i) {
    var t = new DataView(i.buffer, i.byteOffset, i.byteLength), n = {
      version: i[0],
      flags: new Uint8Array(i.subarray(1, 4)),
      references: [],
      referenceId: t.getUint32(4),
      timescale: t.getUint32(8)
    }, a = 12;
    n.version === 0 ? (n.earliestPresentationTime = t.getUint32(a), n.firstOffset = t.getUint32(a + 4), a += 8) : (n.earliestPresentationTime = e(i.subarray(a)), n.firstOffset = e(i.subarray(a + 8)), a += 16), a += 2;
    var s = t.getUint16(a);
    for (a += 2; s > 0; a += 12, s--)
      n.references.push({
        referenceType: (i[a] & 128) >>> 7,
        referencedSize: t.getUint32(a) & 2147483647,
        subsegmentDuration: t.getUint32(a + 4),
        startsWithSap: !!(i[a + 8] & 128),
        sapType: (i[a + 8] & 112) >>> 4,
        sapDeltaTime: t.getUint32(a + 8) & 268435455
      });
    return n;
  };
  return Mp = r, Mp;
}
var lk = Rh.toUnsigned, ck = kh.getUint64, dk = function(e) {
  var r = {
    version: e[0],
    flags: new Uint8Array(e.subarray(1, 4))
  };
  return r.version === 1 ? r.baseMediaDecodeTime = ck(e.subarray(4)) : r.baseMediaDecodeTime = lk(e[4] << 24 | e[5] << 16 | e[6] << 8 | e[7]), r;
}, Iv = dk, fk = function(e) {
  var r = new DataView(e.buffer, e.byteOffset, e.byteLength), i = {
    version: e[0],
    flags: new Uint8Array(e.subarray(1, 4)),
    trackId: r.getUint32(4)
  }, t = i.flags[2] & 1, n = i.flags[2] & 2, a = i.flags[2] & 8, s = i.flags[2] & 16, o = i.flags[2] & 32, l = i.flags[0] & 65536, u = i.flags[0] & 131072, h;
  return h = 8, t && (h += 4, i.baseDataOffset = r.getUint32(12), h += 4), n && (i.sampleDescriptionIndex = r.getUint32(h), h += 4), a && (i.defaultSampleDuration = r.getUint32(h), h += 4), s && (i.defaultSampleSize = r.getUint32(h), h += 4), o && (i.defaultSampleFlags = r.getUint32(h)), l && (i.durationIsEmpty = !0), !t && u && (i.baseDataOffsetIsMoof = !0), i;
}, Mv = fk, hk = function(e) {
  return {
    isLeading: (e[0] & 12) >>> 2,
    dependsOn: e[0] & 3,
    isDependedOn: (e[1] & 192) >>> 6,
    hasRedundancy: (e[1] & 48) >>> 4,
    paddingValue: (e[1] & 14) >>> 1,
    isNonSyncSample: e[1] & 1,
    degradationPriority: e[2] << 8 | e[3]
  };
}, pk = hk, s_ = pk, gk = function(e) {
  var r = {
    version: e[0],
    flags: new Uint8Array(e.subarray(1, 4)),
    samples: []
  }, i = new DataView(e.buffer, e.byteOffset, e.byteLength), t = r.flags[2] & 1, n = r.flags[2] & 4, a = r.flags[1] & 1, s = r.flags[1] & 2, o = r.flags[1] & 4, l = r.flags[1] & 8, u = i.getUint32(4), h = 8, c;
  for (t && (r.dataOffset = i.getInt32(h), h += 4), n && u && (c = {
    flags: s_(e.subarray(h, h + 4))
  }, h += 4, a && (c.duration = i.getUint32(h), h += 4), s && (c.size = i.getUint32(h), h += 4), l && (r.version === 1 ? c.compositionTimeOffset = i.getInt32(h) : c.compositionTimeOffset = i.getUint32(h), h += 4), r.samples.push(c), u--); u--; )
    c = {}, a && (c.duration = i.getUint32(h), h += 4), s && (c.size = i.getUint32(h), h += 4), o && (c.flags = s_(e.subarray(h, h + 4)), h += 4), l && (r.version === 1 ? c.compositionTimeOffset = i.getInt32(h) : c.compositionTimeOffset = i.getUint32(h), h += 4), r.samples.push(c);
  return r;
}, Nv = gk, vk = kh, o_ = vk.getUint64, In, kg, Fa = function(e) {
  return new Date(e * 1e3 - 20828448e5);
}, zc = Ov, mk = Lv, yk = function(e) {
  var r = new DataView(e.buffer, e.byteOffset, e.byteLength), i = [], t, n;
  for (t = 0; t + 4 < e.length; t += n) {
    if (n = r.getUint32(t), t += 4, n <= 0) {
      i.push("<span style='color:red;'>MALFORMED DATA</span>");
      continue;
    }
    switch (e[t] & 31) {
      case 1:
        i.push("slice_layer_without_partitioning_rbsp");
        break;
      case 5:
        i.push("slice_layer_without_partitioning_rbsp_idr");
        break;
      case 6:
        i.push("sei_rbsp");
        break;
      case 7:
        i.push("seq_parameter_set_rbsp");
        break;
      case 8:
        i.push("pic_parameter_set_rbsp");
        break;
      case 9:
        i.push("access_unit_delimiter_rbsp");
        break;
      default:
        i.push("UNKNOWN NAL - " + e[t] & 31);
        break;
    }
  }
  return i;
}, qo = {
  avc1: function(e) {
    var r = new DataView(e.buffer, e.byteOffset, e.byteLength);
    return {
      dataReferenceIndex: r.getUint16(6),
      width: r.getUint16(24),
      height: r.getUint16(26),
      horizresolution: r.getUint16(28) + r.getUint16(30) / 16,
      vertresolution: r.getUint16(32) + r.getUint16(34) / 16,
      frameCount: r.getUint16(40),
      depth: r.getUint16(74),
      config: In(e.subarray(78, e.byteLength))
    };
  },
  avcC: function(e) {
    var r = new DataView(e.buffer, e.byteOffset, e.byteLength), i = {
      configurationVersion: e[0],
      avcProfileIndication: e[1],
      profileCompatibility: e[2],
      avcLevelIndication: e[3],
      lengthSizeMinusOne: e[4] & 3,
      sps: [],
      pps: []
    }, t = e[5] & 31, n, a, s, o;
    for (s = 6, o = 0; o < t; o++)
      a = r.getUint16(s), s += 2, i.sps.push(new Uint8Array(e.subarray(s, s + a))), s += a;
    for (n = e[s], s++, o = 0; o < n; o++)
      a = r.getUint16(s), s += 2, i.pps.push(new Uint8Array(e.subarray(s, s + a))), s += a;
    return i;
  },
  btrt: function(e) {
    var r = new DataView(e.buffer, e.byteOffset, e.byteLength);
    return {
      bufferSizeDB: r.getUint32(0),
      maxBitrate: r.getUint32(4),
      avgBitrate: r.getUint32(8)
    };
  },
  edts: function(r) {
    return {
      boxes: In(r)
    };
  },
  elst: function(r) {
    var i = new DataView(r.buffer, r.byteOffset, r.byteLength), t = {
      version: i.getUint8(0),
      flags: new Uint8Array(r.subarray(1, 4)),
      edits: []
    }, n = i.getUint32(4), a;
    for (a = 8; n; n--)
      t.version === 0 ? (t.edits.push({
        segmentDuration: i.getUint32(a),
        mediaTime: i.getInt32(a + 4),
        mediaRate: i.getUint16(a + 8) + i.getUint16(a + 10) / (256 * 256)
      }), a += 12) : (t.edits.push({
        segmentDuration: o_(r.subarray(a)),
        mediaTime: o_(r.subarray(a + 8)),
        mediaRate: i.getUint16(a + 16) + i.getUint16(a + 18) / (256 * 256)
      }), a += 20);
    return t;
  },
  esds: function(e) {
    return {
      version: e[0],
      flags: new Uint8Array(e.subarray(1, 4)),
      esId: e[6] << 8 | e[7],
      streamPriority: e[8] & 31,
      decoderConfig: {
        objectProfileIndication: e[11],
        streamType: e[12] >>> 2 & 63,
        bufferSize: e[13] << 16 | e[14] << 8 | e[15],
        maxBitrate: e[16] << 24 | e[17] << 16 | e[18] << 8 | e[19],
        avgBitrate: e[20] << 24 | e[21] << 16 | e[22] << 8 | e[23],
        decoderConfigDescriptor: {
          tag: e[24],
          length: e[25],
          audioObjectType: e[26] >>> 3 & 31,
          samplingFrequencyIndex: (e[26] & 7) << 1 | e[27] >>> 7 & 1,
          channelConfiguration: e[27] >>> 3 & 15
        }
      }
    };
  },
  ftyp: function(e) {
    for (var r = new DataView(e.buffer, e.byteOffset, e.byteLength), i = {
      majorBrand: zc(e.subarray(0, 4)),
      minorVersion: r.getUint32(4),
      compatibleBrands: []
    }, t = 8; t < e.byteLength; )
      i.compatibleBrands.push(zc(e.subarray(t, t + 4))), t += 4;
    return i;
  },
  dinf: function(e) {
    return {
      boxes: In(e)
    };
  },
  dref: function(e) {
    return {
      version: e[0],
      flags: new Uint8Array(e.subarray(1, 4)),
      dataReferences: In(e.subarray(8))
    };
  },
  hdlr: function(e) {
    var r = new DataView(e.buffer, e.byteOffset, e.byteLength), i = {
      version: r.getUint8(0),
      flags: new Uint8Array(e.subarray(1, 4)),
      handlerType: zc(e.subarray(8, 12)),
      name: ""
    }, t = 8;
    for (t = 24; t < e.byteLength; t++) {
      if (e[t] === 0) {
        t++;
        break;
      }
      i.name += String.fromCharCode(e[t]);
    }
    return i.name = decodeURIComponent(escape(i.name)), i;
  },
  mdat: function(e) {
    return {
      byteLength: e.byteLength,
      nals: yk(e)
    };
  },
  mdhd: function(e) {
    var r = new DataView(e.buffer, e.byteOffset, e.byteLength), i = 4, t, n = {
      version: r.getUint8(0),
      flags: new Uint8Array(e.subarray(1, 4)),
      language: ""
    };
    return n.version === 1 ? (i += 4, n.creationTime = Fa(r.getUint32(i)), i += 8, n.modificationTime = Fa(r.getUint32(i)), i += 4, n.timescale = r.getUint32(i), i += 8, n.duration = r.getUint32(i)) : (n.creationTime = Fa(r.getUint32(i)), i += 4, n.modificationTime = Fa(r.getUint32(i)), i += 4, n.timescale = r.getUint32(i), i += 4, n.duration = r.getUint32(i)), i += 4, t = r.getUint16(i), n.language += String.fromCharCode((t >> 10) + 96), n.language += String.fromCharCode(((t & 992) >> 5) + 96), n.language += String.fromCharCode((t & 31) + 96), n;
  },
  mdia: function(e) {
    return {
      boxes: In(e)
    };
  },
  mfhd: function(e) {
    return {
      version: e[0],
      flags: new Uint8Array(e.subarray(1, 4)),
      sequenceNumber: e[4] << 24 | e[5] << 16 | e[6] << 8 | e[7]
    };
  },
  minf: function(e) {
    return {
      boxes: In(e)
    };
  },
  mp4a: function(e) {
    var r = new DataView(e.buffer, e.byteOffset, e.byteLength), i = {
      dataReferenceIndex: r.getUint16(6),
      channelcount: r.getUint16(16),
      samplesize: r.getUint16(18),
      samplerate: r.getUint16(24) + r.getUint16(26) / 65536
    };
    return e.byteLength > 28 && (i.streamDescriptor = In(e.subarray(28))[0]), i;
  },
  moof: function(e) {
    return {
      boxes: In(e)
    };
  },
  moov: function(e) {
    return {
      boxes: In(e)
    };
  },
  mvex: function(e) {
    return {
      boxes: In(e)
    };
  },
  mvhd: function(e) {
    var r = new DataView(e.buffer, e.byteOffset, e.byteLength), i = 4, t = {
      version: r.getUint8(0),
      flags: new Uint8Array(e.subarray(1, 4))
    };
    return t.version === 1 ? (i += 4, t.creationTime = Fa(r.getUint32(i)), i += 8, t.modificationTime = Fa(r.getUint32(i)), i += 4, t.timescale = r.getUint32(i), i += 8, t.duration = r.getUint32(i)) : (t.creationTime = Fa(r.getUint32(i)), i += 4, t.modificationTime = Fa(r.getUint32(i)), i += 4, t.timescale = r.getUint32(i), i += 4, t.duration = r.getUint32(i)), i += 4, t.rate = r.getUint16(i) + r.getUint16(i + 2) / 16, i += 4, t.volume = r.getUint8(i) + r.getUint8(i + 1) / 8, i += 2, i += 2, i += 2 * 4, t.matrix = new Uint32Array(e.subarray(i, i + 9 * 4)), i += 9 * 4, i += 6 * 4, t.nextTrackId = r.getUint32(i), t;
  },
  pdin: function(e) {
    var r = new DataView(e.buffer, e.byteOffset, e.byteLength);
    return {
      version: r.getUint8(0),
      flags: new Uint8Array(e.subarray(1, 4)),
      rate: r.getUint32(4),
      initialDelay: r.getUint32(8)
    };
  },
  sdtp: function(e) {
    var r = {
      version: e[0],
      flags: new Uint8Array(e.subarray(1, 4)),
      samples: []
    }, i;
    for (i = 4; i < e.byteLength; i++)
      r.samples.push({
        dependsOn: (e[i] & 48) >> 4,
        isDependedOn: (e[i] & 12) >> 2,
        hasRedundancy: e[i] & 3
      });
    return r;
  },
  sidx: uk(),
  smhd: function(e) {
    return {
      version: e[0],
      flags: new Uint8Array(e.subarray(1, 4)),
      balance: e[4] + e[5] / 256
    };
  },
  stbl: function(e) {
    return {
      boxes: In(e)
    };
  },
  ctts: function(e) {
    var r = new DataView(e.buffer, e.byteOffset, e.byteLength), i = {
      version: r.getUint8(0),
      flags: new Uint8Array(e.subarray(1, 4)),
      compositionOffsets: []
    }, t = r.getUint32(4), n;
    for (n = 8; t; n += 8, t--)
      i.compositionOffsets.push({
        sampleCount: r.getUint32(n),
        sampleOffset: r[i.version === 0 ? "getUint32" : "getInt32"](n + 4)
      });
    return i;
  },
  stss: function(e) {
    var r = new DataView(e.buffer, e.byteOffset, e.byteLength), i = {
      version: r.getUint8(0),
      flags: new Uint8Array(e.subarray(1, 4)),
      syncSamples: []
    }, t = r.getUint32(4), n;
    for (n = 8; t; n += 4, t--)
      i.syncSamples.push(r.getUint32(n));
    return i;
  },
  stco: function(e) {
    var r = new DataView(e.buffer, e.byteOffset, e.byteLength), i = {
      version: e[0],
      flags: new Uint8Array(e.subarray(1, 4)),
      chunkOffsets: []
    }, t = r.getUint32(4), n;
    for (n = 8; t; n += 4, t--)
      i.chunkOffsets.push(r.getUint32(n));
    return i;
  },
  stsc: function(e) {
    var r = new DataView(e.buffer, e.byteOffset, e.byteLength), i = r.getUint32(4), t = {
      version: e[0],
      flags: new Uint8Array(e.subarray(1, 4)),
      sampleToChunks: []
    }, n;
    for (n = 8; i; n += 12, i--)
      t.sampleToChunks.push({
        firstChunk: r.getUint32(n),
        samplesPerChunk: r.getUint32(n + 4),
        sampleDescriptionIndex: r.getUint32(n + 8)
      });
    return t;
  },
  stsd: function(e) {
    return {
      version: e[0],
      flags: new Uint8Array(e.subarray(1, 4)),
      sampleDescriptions: In(e.subarray(8))
    };
  },
  stsz: function(e) {
    var r = new DataView(e.buffer, e.byteOffset, e.byteLength), i = {
      version: e[0],
      flags: new Uint8Array(e.subarray(1, 4)),
      sampleSize: r.getUint32(4),
      entries: []
    }, t;
    for (t = 12; t < e.byteLength; t += 4)
      i.entries.push(r.getUint32(t));
    return i;
  },
  stts: function(e) {
    var r = new DataView(e.buffer, e.byteOffset, e.byteLength), i = {
      version: e[0],
      flags: new Uint8Array(e.subarray(1, 4)),
      timeToSamples: []
    }, t = r.getUint32(4), n;
    for (n = 8; t; n += 8, t--)
      i.timeToSamples.push({
        sampleCount: r.getUint32(n),
        sampleDelta: r.getUint32(n + 4)
      });
    return i;
  },
  styp: function(e) {
    return qo.ftyp(e);
  },
  tfdt: Iv,
  tfhd: Mv,
  tkhd: function(e) {
    var r = new DataView(e.buffer, e.byteOffset, e.byteLength), i = 4, t = {
      version: r.getUint8(0),
      flags: new Uint8Array(e.subarray(1, 4))
    };
    return t.version === 1 ? (i += 4, t.creationTime = Fa(r.getUint32(i)), i += 8, t.modificationTime = Fa(r.getUint32(i)), i += 4, t.trackId = r.getUint32(i), i += 4, i += 8, t.duration = r.getUint32(i)) : (t.creationTime = Fa(r.getUint32(i)), i += 4, t.modificationTime = Fa(r.getUint32(i)), i += 4, t.trackId = r.getUint32(i), i += 4, i += 4, t.duration = r.getUint32(i)), i += 4, i += 2 * 4, t.layer = r.getUint16(i), i += 2, t.alternateGroup = r.getUint16(i), i += 2, t.volume = r.getUint8(i) + r.getUint8(i + 1) / 8, i += 2, i += 2, t.matrix = new Uint32Array(e.subarray(i, i + 9 * 4)), i += 9 * 4, t.width = r.getUint16(i) + r.getUint16(i + 2) / 65536, i += 4, t.height = r.getUint16(i) + r.getUint16(i + 2) / 65536, t;
  },
  traf: function(e) {
    return {
      boxes: In(e)
    };
  },
  trak: function(e) {
    return {
      boxes: In(e)
    };
  },
  trex: function(e) {
    var r = new DataView(e.buffer, e.byteOffset, e.byteLength);
    return {
      version: e[0],
      flags: new Uint8Array(e.subarray(1, 4)),
      trackId: r.getUint32(4),
      defaultSampleDescriptionIndex: r.getUint32(8),
      defaultSampleDuration: r.getUint32(12),
      defaultSampleSize: r.getUint32(16),
      sampleDependsOn: e[20] & 3,
      sampleIsDependedOn: (e[21] & 192) >> 6,
      sampleHasRedundancy: (e[21] & 48) >> 4,
      samplePaddingValue: (e[21] & 14) >> 1,
      sampleIsDifferenceSample: !!(e[21] & 1),
      sampleDegradationPriority: r.getUint16(22)
    };
  },
  trun: Nv,
  "url ": function(e) {
    return {
      version: e[0],
      flags: new Uint8Array(e.subarray(1, 4))
    };
  },
  vmhd: function(e) {
    var r = new DataView(e.buffer, e.byteOffset, e.byteLength);
    return {
      version: e[0],
      flags: new Uint8Array(e.subarray(1, 4)),
      graphicsmode: r.getUint16(4),
      opcolor: new Uint16Array([
        r.getUint16(6),
        r.getUint16(8),
        r.getUint16(10)
      ])
    };
  }
};
In = function(e) {
  for (var r = 0, i = [], t, n, a, s, o, l = new ArrayBuffer(e.length), u = new Uint8Array(l), h = 0; h < e.length; ++h)
    u[h] = e[h];
  for (t = new DataView(l); r < e.byteLength; )
    n = t.getUint32(r), a = zc(e.subarray(r + 4, r + 8)), s = n > 1 ? r + n : e.byteLength, o = (qo[a] || function(c) {
      return {
        data: c
      };
    })(e.subarray(r + 8, s)), o.size = n, o.type = a, i.push(o), r = s;
  return i;
};
kg = function(e, r) {
  var i;
  return r = r || 0, i = new Array(r * 2 + 1).join(" "), e.map(function(t, n) {
    return i + t.type + `
` + Object.keys(t).filter(function(a) {
      return a !== "type" && a !== "boxes";
    }).map(function(a) {
      var s = i + "  " + a + ": ", o = t[a];
      if (o instanceof Uint8Array || o instanceof Uint32Array) {
        var l = Array.prototype.slice.call(new Uint8Array(o.buffer, o.byteOffset, o.byteLength)).map(function(u) {
          return " " + ("00" + u.toString(16)).slice(-2);
        }).join("").match(/.{1,24}/g);
        return l ? l.length === 1 ? s + "<" + l.join("").slice(1) + ">" : s + `<
` + l.map(function(u) {
          return i + "  " + u;
        }).join(`
`) + `
` + i + "  >" : s + "<>";
      }
      return s + JSON.stringify(o, null, 2).split(`
`).map(function(u, h) {
        return h === 0 ? u : i + "  " + u;
      }).join(`
`);
    }).join(`
`) + (t.boxes ? `
` + kg(t.boxes, r + 1) : "");
  }).join(`
`);
};
var _k = {
  inspect: In,
  textify: kg,
  parseType: zc,
  findBox: mk,
  parseTraf: qo.traf,
  parseTfdt: qo.tfdt,
  parseHdlr: qo.hdlr,
  parseTfhd: qo.tfhd,
  parseTrun: qo.trun,
  parseSidx: qo.sidx
}, Hf = Rh.toUnsigned, Ic = Rh.toHexString, Xi = Lv, Rl = Ov, bk = Mv, Tk = Nv, Sk = Iv, Ek = kh.getUint64, RT, PT, OT, LT, IT, Fv, Rg = ai;
RT = function(e) {
  var r = {}, i = Xi(e, ["moov", "trak"]);
  return i.reduce(function(t, n) {
    var a, s, o, l, u;
    return a = Xi(n, ["tkhd"])[0], !a || (s = a[0], o = s === 0 ? 12 : 20, l = Hf(a[o] << 24 | a[o + 1] << 16 | a[o + 2] << 8 | a[o + 3]), u = Xi(n, ["mdia", "mdhd"])[0], !u) ? null : (s = u[0], o = s === 0 ? 12 : 20, t[l] = Hf(u[o] << 24 | u[o + 1] << 16 | u[o + 2] << 8 | u[o + 3]), t);
  }, r);
};
PT = function(e, r) {
  var i;
  i = Xi(r, ["moof", "traf"]);
  var t = i.reduce(function(n, a) {
    var s = Xi(a, ["tfhd"])[0], o = Hf(s[4] << 24 | s[5] << 16 | s[6] << 8 | s[7]), l = e[o] || 9e4, u = Xi(a, ["tfdt"])[0], h = new DataView(u.buffer, u.byteOffset, u.byteLength), c;
    u[0] === 1 ? c = Ek(u.subarray(4, 12)) : c = h.getUint32(4);
    let d;
    return typeof c == "bigint" ? d = c / Rg.BigInt(l) : typeof c == "number" && !isNaN(c) && (d = c / l), d < Number.MAX_SAFE_INTEGER && (d = Number(d)), d < n && (n = d), n;
  }, 1 / 0);
  return typeof t == "bigint" || isFinite(t) ? t : 0;
};
OT = function(e, r) {
  var i = Xi(r, ["moof", "traf"]), t = 0, n = 0, a;
  if (i && i.length) {
    var s = Xi(i[0], ["tfhd"])[0], o = Xi(i[0], ["trun"])[0], l = Xi(i[0], ["tfdt"])[0];
    if (s) {
      var u = bk(s);
      a = u.trackId;
    }
    if (l) {
      var h = Sk(l);
      t = h.baseMediaDecodeTime;
    }
    if (o) {
      var c = Tk(o);
      c.samples && c.samples.length && (n = c.samples[0].compositionTimeOffset || 0);
    }
  }
  var d = e[a] || 9e4;
  typeof t == "bigint" && (n = Rg.BigInt(n), d = Rg.BigInt(d));
  var f = (t + n) / d;
  return typeof f == "bigint" && f < Number.MAX_SAFE_INTEGER && (f = Number(f)), f;
};
LT = function(e) {
  var r = Xi(e, ["moov", "trak"]), i = [];
  return r.forEach(function(t) {
    var n = Xi(t, ["mdia", "hdlr"]), a = Xi(t, ["tkhd"]);
    n.forEach(function(s, o) {
      var l = Rl(s.subarray(8, 12)), u = a[o], h, c, d;
      l === "vide" && (h = new DataView(u.buffer, u.byteOffset, u.byteLength), c = h.getUint8(0), d = c === 0 ? h.getUint32(12) : h.getUint32(20), i.push(d));
    });
  }), i;
};
Fv = function(e) {
  var r = e[0], i = r === 0 ? 12 : 20;
  return Hf(
    e[i] << 24 | e[i + 1] << 16 | e[i + 2] << 8 | e[i + 3]
  );
};
IT = function(e) {
  var r = Xi(e, ["moov", "trak"]), i = [];
  return r.forEach(function(t) {
    var n = {}, a = Xi(t, ["tkhd"])[0], s, o;
    a && (s = new DataView(a.buffer, a.byteOffset, a.byteLength), o = s.getUint8(0), n.id = o === 0 ? s.getUint32(12) : s.getUint32(20));
    var l = Xi(t, ["mdia", "hdlr"])[0];
    if (l) {
      var u = Rl(l.subarray(8, 12));
      u === "vide" ? n.type = "video" : u === "soun" ? n.type = "audio" : n.type = u;
    }
    var h = Xi(t, ["mdia", "minf", "stbl", "stsd"])[0];
    if (h) {
      var c = h.subarray(8);
      n.codec = Rl(c.subarray(4, 8));
      var d = Xi(c, [n.codec])[0], f, m;
      d && (/^[asm]vc[1-9]$/i.test(n.codec) ? (f = d.subarray(78), m = Rl(f.subarray(4, 8)), m === "avcC" && f.length > 11 ? (n.codec += ".", n.codec += Ic(f[9]), n.codec += Ic(f[10]), n.codec += Ic(f[11])) : n.codec = "avc1.4d400d") : /^mp4[a,v]$/i.test(n.codec) ? (f = d.subarray(28), m = Rl(f.subarray(4, 8)), m === "esds" && f.length > 20 && f[19] !== 0 ? (n.codec += "." + Ic(f[19]), n.codec += "." + Ic(f[20] >>> 2 & 63).replace(/^0/, "")) : n.codec = "mp4a.40.2") : n.codec = n.codec.toLowerCase());
    }
    var p = Xi(t, ["mdia", "mdhd"])[0];
    p && (n.timescale = Fv(p)), i.push(n);
  }), i;
};
var Vf = {
  findBox: Xi,
  parseType: Rl,
  timescale: RT,
  startTime: PT,
  compositionStartTime: OT,
  videoTrackIds: LT,
  tracks: IT,
  getTimescaleFromMediaHeader: Fv
}, MT = 4, xk = 128, Ak = function(e) {
  for (var r = 0, i = {
    payloadType: -1,
    payloadSize: 0
  }, t = 0, n = 0; r < e.byteLength && e[r] !== xk; ) {
    for (; e[r] === 255; )
      t += 255, r++;
    for (t += e[r++]; e[r] === 255; )
      n += 255, r++;
    if (n += e[r++], !i.payload && t === MT) {
      var a = String.fromCharCode(
        e[r + 3],
        e[r + 4],
        e[r + 5],
        e[r + 6]
      );
      if (a === "GA94") {
        i.payloadType = t, i.payloadSize = n, i.payload = e.subarray(r, r + n);
        break;
      } else
        i.payload = void 0;
    }
    r += n, t = 0, n = 0;
  }
  return i;
}, wk = function(e) {
  return e.payload[0] !== 181 || (e.payload[1] << 8 | e.payload[2]) !== 49 || String.fromCharCode(
    e.payload[3],
    e.payload[4],
    e.payload[5],
    e.payload[6]
  ) !== "GA94" || e.payload[7] !== 3 ? null : e.payload.subarray(8, e.payload.length - 1);
}, Ck = function(e, r) {
  var i = [], t, n, a, s;
  if (!(r[0] & 64))
    return i;
  for (n = r[0] & 31, t = 0; t < n; t++)
    a = t * 3, s = {
      type: r[a + 2] & 3,
      pts: e
    }, r[a + 2] & 4 && (s.ccData = r[a + 3] << 8 | r[a + 4], i.push(s));
  return i;
}, Dk = function(e) {
  for (var r = e.byteLength, i = [], t = 1, n, a; t < r - 2; )
    e[t] === 0 && e[t + 1] === 0 && e[t + 2] === 3 ? (i.push(t + 2), t += 2) : t++;
  if (i.length === 0)
    return e;
  n = r - i.length, a = new Uint8Array(n);
  var s = 0;
  for (t = 0; t < n; s++, t++)
    s === i[0] && (s++, i.shift()), a[t] = e[s];
  return a;
}, NT = {
  parseSei: Ak,
  parseUserData: wk,
  parseCaptionPackets: Ck,
  discardEmulationPreventionBytes: Dk,
  USER_DATA_REGISTERED_ITU_T_T35: MT
}, il = function() {
  this.init = function() {
    var e = {};
    this.on = function(r, i) {
      e[r] || (e[r] = []), e[r] = e[r].concat(i);
    }, this.off = function(r, i) {
      var t;
      return e[r] ? (t = e[r].indexOf(i), e[r] = e[r].slice(), e[r].splice(t, 1), t > -1) : !1;
    }, this.trigger = function(r) {
      var i, t, n, a;
      if (i = e[r], !!i)
        if (arguments.length === 2)
          for (n = i.length, t = 0; t < n; ++t)
            i[t].call(this, arguments[1]);
        else {
          for (a = [], t = arguments.length, t = 1; t < arguments.length; ++t)
            a.push(arguments[t]);
          for (n = i.length, t = 0; t < n; ++t)
            i[t].apply(this, a);
        }
    }, this.dispose = function() {
      e = {};
    };
  };
};
il.prototype.pipe = function(e) {
  return this.on("data", function(r) {
    e.push(r);
  }), this.on("done", function(r) {
    e.flush(r);
  }), this.on("partialdone", function(r) {
    e.partialFlush(r);
  }), this.on("endedtimeline", function(r) {
    e.endTimeline(r);
  }), this.on("reset", function(r) {
    e.reset(r);
  }), e;
};
il.prototype.push = function(e) {
  this.trigger("data", e);
};
il.prototype.flush = function(e) {
  this.trigger("done", e);
};
il.prototype.partialFlush = function(e) {
  this.trigger("partialdone", e);
};
il.prototype.endTimeline = function(e) {
  this.trigger("endedtimeline", e);
};
il.prototype.reset = function(e) {
  this.trigger("reset", e);
};
var FT = il, Uv = FT, sf = NT, fa = function(e) {
  e = e || {}, fa.prototype.init.call(this), this.parse708captions_ = typeof e.parse708captions == "boolean" ? e.parse708captions : !0, this.captionPackets_ = [], this.ccStreams_ = [
    new Bi(0, 0),
    new Bi(0, 1),
    new Bi(1, 0),
    new Bi(1, 1)
  ], this.parse708captions_ && (this.cc708Stream_ = new Si({ captionServices: e.captionServices })), this.reset(), this.ccStreams_.forEach(function(r) {
    r.on("data", this.trigger.bind(this, "data")), r.on("partialdone", this.trigger.bind(this, "partialdone")), r.on("done", this.trigger.bind(this, "done"));
  }, this), this.parse708captions_ && (this.cc708Stream_.on("data", this.trigger.bind(this, "data")), this.cc708Stream_.on("partialdone", this.trigger.bind(this, "partialdone")), this.cc708Stream_.on("done", this.trigger.bind(this, "done")));
};
fa.prototype = new Uv();
fa.prototype.push = function(e) {
  var r, i, t;
  if (e.nalUnitType === "sei_rbsp" && (r = sf.parseSei(e.escapedRBSP), !!r.payload && r.payloadType === sf.USER_DATA_REGISTERED_ITU_T_T35 && (i = sf.parseUserData(r), !!i))) {
    if (e.dts < this.latestDts_) {
      this.ignoreNextEqualDts_ = !0;
      return;
    } else if (e.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
      this.numSameDts_--, this.numSameDts_ || (this.ignoreNextEqualDts_ = !1);
      return;
    }
    t = sf.parseCaptionPackets(e.pts, i), this.captionPackets_ = this.captionPackets_.concat(t), this.latestDts_ !== e.dts && (this.numSameDts_ = 0), this.numSameDts_++, this.latestDts_ = e.dts;
  }
};
fa.prototype.flushCCStreams = function(e) {
  this.ccStreams_.forEach(function(r) {
    return e === "flush" ? r.flush() : r.partialFlush();
  }, this);
};
fa.prototype.flushStream = function(e) {
  if (!this.captionPackets_.length) {
    this.flushCCStreams(e);
    return;
  }
  this.captionPackets_.forEach(function(r, i) {
    r.presortIndex = i;
  }), this.captionPackets_.sort(function(r, i) {
    return r.pts === i.pts ? r.presortIndex - i.presortIndex : r.pts - i.pts;
  }), this.captionPackets_.forEach(function(r) {
    r.type < 2 ? this.dispatchCea608Packet(r) : this.dispatchCea708Packet(r);
  }, this), this.captionPackets_.length = 0, this.flushCCStreams(e);
};
fa.prototype.flush = function() {
  return this.flushStream("flush");
};
fa.prototype.partialFlush = function() {
  return this.flushStream("partialFlush");
};
fa.prototype.reset = function() {
  this.latestDts_ = null, this.ignoreNextEqualDts_ = !1, this.numSameDts_ = 0, this.activeCea608Channel_ = [null, null], this.ccStreams_.forEach(function(e) {
    e.reset();
  });
};
fa.prototype.dispatchCea608Packet = function(e) {
  this.setsTextOrXDSActive(e) ? this.activeCea608Channel_[e.type] = null : this.setsChannel1Active(e) ? this.activeCea608Channel_[e.type] = 0 : this.setsChannel2Active(e) && (this.activeCea608Channel_[e.type] = 1), this.activeCea608Channel_[e.type] !== null && this.ccStreams_[(e.type << 1) + this.activeCea608Channel_[e.type]].push(e);
};
fa.prototype.setsChannel1Active = function(e) {
  return (e.ccData & 30720) === 4096;
};
fa.prototype.setsChannel2Active = function(e) {
  return (e.ccData & 30720) === 6144;
};
fa.prototype.setsTextOrXDSActive = function(e) {
  return (e.ccData & 28928) === 256 || (e.ccData & 30974) === 4138 || (e.ccData & 30974) === 6186;
};
fa.prototype.dispatchCea708Packet = function(e) {
  this.parse708captions_ && this.cc708Stream_.push(e);
};
var kk = {
  127: 9834,
  4128: 32,
  4129: 160,
  4133: 8230,
  4138: 352,
  4140: 338,
  4144: 9608,
  4145: 8216,
  4146: 8217,
  4147: 8220,
  4148: 8221,
  4149: 8226,
  4153: 8482,
  4154: 353,
  4156: 339,
  4157: 8480,
  4159: 376,
  4214: 8539,
  4215: 8540,
  4216: 8541,
  4217: 8542,
  4218: 9168,
  4219: 9124,
  4220: 9123,
  4221: 9135,
  4222: 9126,
  4223: 9121,
  4256: 12600
}, Rk = function(e) {
  var r = kk[e] || e;
  return e & 4096 && e === r ? "" : String.fromCharCode(r);
}, qf = function(e) {
  return 32 <= e && e <= 127 || 160 <= e && e <= 255;
}, So = function(e) {
  this.windowNum = e, this.reset();
};
So.prototype.reset = function() {
  this.clearText(), this.pendingNewLine = !1, this.winAttr = {}, this.penAttr = {}, this.penLoc = {}, this.penColor = {}, this.visible = 0, this.rowLock = 0, this.columnLock = 0, this.priority = 0, this.relativePositioning = 0, this.anchorVertical = 0, this.anchorHorizontal = 0, this.anchorPoint = 0, this.rowCount = 1, this.virtualRowCount = this.rowCount + 1, this.columnCount = 41, this.windowStyle = 0, this.penStyle = 0;
};
So.prototype.getText = function() {
  return this.rows.join(`
`);
};
So.prototype.clearText = function() {
  this.rows = [""], this.rowIdx = 0;
};
So.prototype.newLine = function(e) {
  for (this.rows.length >= this.virtualRowCount && typeof this.beforeRowOverflow == "function" && this.beforeRowOverflow(e), this.rows.length > 0 && (this.rows.push(""), this.rowIdx++); this.rows.length > this.virtualRowCount; )
    this.rows.shift(), this.rowIdx--;
};
So.prototype.isEmpty = function() {
  return this.rows.length === 0 ? !0 : this.rows.length === 1 ? this.rows[0] === "" : !1;
};
So.prototype.addText = function(e) {
  this.rows[this.rowIdx] += e;
};
So.prototype.backspace = function() {
  if (!this.isEmpty()) {
    var e = this.rows[this.rowIdx];
    this.rows[this.rowIdx] = e.substr(0, e.length - 1);
  }
};
var Ph = function(e, r, i) {
  this.serviceNum = e, this.text = "", this.currentWindow = new So(-1), this.windows = [], this.stream = i, typeof r == "string" && this.createTextDecoder(r);
};
Ph.prototype.init = function(e, r) {
  this.startPts = e;
  for (var i = 0; i < 8; i++)
    this.windows[i] = new So(i), typeof r == "function" && (this.windows[i].beforeRowOverflow = r);
};
Ph.prototype.setCurrentWindow = function(e) {
  this.currentWindow = this.windows[e];
};
Ph.prototype.createTextDecoder = function(e) {
  if (typeof TextDecoder > "u")
    this.stream.trigger("log", {
      level: "warn",
      message: "The `encoding` option is unsupported without TextDecoder support"
    });
  else
    try {
      this.textDecoder_ = new TextDecoder(e);
    } catch (r) {
      this.stream.trigger("log", {
        level: "warn",
        message: "TextDecoder could not be created with " + e + " encoding. " + r
      });
    }
};
var Si = function(e) {
  e = e || {}, Si.prototype.init.call(this);
  var r = this, i = e.captionServices || {}, t = {}, n;
  Object.keys(i).forEach((a) => {
    n = i[a], /^SERVICE/.test(a) && (t[a] = n.encoding);
  }), this.serviceEncodings = t, this.current708Packet = null, this.services = {}, this.push = function(a) {
    a.type === 3 ? (r.new708Packet(), r.add708Bytes(a)) : (r.current708Packet === null && r.new708Packet(), r.add708Bytes(a));
  };
};
Si.prototype = new Uv();
Si.prototype.new708Packet = function() {
  this.current708Packet !== null && this.push708Packet(), this.current708Packet = {
    data: [],
    ptsVals: []
  };
};
Si.prototype.add708Bytes = function(e) {
  var r = e.ccData, i = r >>> 8, t = r & 255;
  this.current708Packet.ptsVals.push(e.pts), this.current708Packet.data.push(i), this.current708Packet.data.push(t);
};
Si.prototype.push708Packet = function() {
  var e = this.current708Packet, r = e.data, i = null, t = null, n = 0, a = r[n++];
  for (e.seq = a >> 6, e.sizeCode = a & 63; n < r.length; n++)
    a = r[n++], i = a >> 5, t = a & 31, i === 7 && t > 0 && (a = r[n++], i = a), this.pushServiceBlock(i, n, t), t > 0 && (n += t - 1);
};
Si.prototype.pushServiceBlock = function(e, r, i) {
  var t, n = r, a = this.current708Packet.data, s = this.services[e];
  for (s || (s = this.initService(e, n)); n < r + i && n < a.length; n++)
    t = a[n], qf(t) ? n = this.handleText(n, s) : t === 24 ? n = this.multiByteCharacter(n, s) : t === 16 ? n = this.extendedCommands(n, s) : 128 <= t && t <= 135 ? n = this.setCurrentWindow(n, s) : 152 <= t && t <= 159 ? n = this.defineWindow(n, s) : t === 136 ? n = this.clearWindows(n, s) : t === 140 ? n = this.deleteWindows(n, s) : t === 137 ? n = this.displayWindows(n, s) : t === 138 ? n = this.hideWindows(n, s) : t === 139 ? n = this.toggleWindows(n, s) : t === 151 ? n = this.setWindowAttributes(n, s) : t === 144 ? n = this.setPenAttributes(n, s) : t === 145 ? n = this.setPenColor(n, s) : t === 146 ? n = this.setPenLocation(n, s) : t === 143 ? s = this.reset(n, s) : t === 8 ? s.currentWindow.backspace() : t === 12 ? s.currentWindow.clearText() : t === 13 ? s.currentWindow.pendingNewLine = !0 : t === 14 ? s.currentWindow.clearText() : t === 141 && n++;
};
Si.prototype.extendedCommands = function(e, r) {
  var i = this.current708Packet.data, t = i[++e];
  return qf(t) && (e = this.handleText(e, r, { isExtended: !0 })), e;
};
Si.prototype.getPts = function(e) {
  return this.current708Packet.ptsVals[Math.floor(e / 2)];
};
Si.prototype.initService = function(e, r) {
  var t = "SERVICE" + e, i = this, t, n;
  return t in this.serviceEncodings && (n = this.serviceEncodings[t]), this.services[e] = new Ph(e, n, i), this.services[e].init(this.getPts(r), function(a) {
    i.flushDisplayed(a, i.services[e]);
  }), this.services[e];
};
Si.prototype.handleText = function(e, r, i) {
  var t = i && i.isExtended, n = i && i.isMultiByte, a = this.current708Packet.data, s = t ? 4096 : 0, o = a[e], l = a[e + 1], u = r.currentWindow, h, c;
  return r.textDecoder_ && !t ? (n ? (c = [o, l], e++) : c = [o], h = r.textDecoder_.decode(new Uint8Array(c))) : h = Rk(s | o), u.pendingNewLine && !u.isEmpty() && u.newLine(this.getPts(e)), u.pendingNewLine = !1, u.addText(h), e;
};
Si.prototype.multiByteCharacter = function(e, r) {
  var i = this.current708Packet.data, t = i[e + 1], n = i[e + 2];
  return qf(t) && qf(n) && (e = this.handleText(++e, r, { isMultiByte: !0 })), e;
};
Si.prototype.setCurrentWindow = function(e, r) {
  var i = this.current708Packet.data, t = i[e], n = t & 7;
  return r.setCurrentWindow(n), e;
};
Si.prototype.defineWindow = function(e, r) {
  var i = this.current708Packet.data, t = i[e], n = t & 7;
  r.setCurrentWindow(n);
  var a = r.currentWindow;
  return t = i[++e], a.visible = (t & 32) >> 5, a.rowLock = (t & 16) >> 4, a.columnLock = (t & 8) >> 3, a.priority = t & 7, t = i[++e], a.relativePositioning = (t & 128) >> 7, a.anchorVertical = t & 127, t = i[++e], a.anchorHorizontal = t, t = i[++e], a.anchorPoint = (t & 240) >> 4, a.rowCount = t & 15, t = i[++e], a.columnCount = t & 63, t = i[++e], a.windowStyle = (t & 56) >> 3, a.penStyle = t & 7, a.virtualRowCount = a.rowCount + 1, e;
};
Si.prototype.setWindowAttributes = function(e, r) {
  var i = this.current708Packet.data, t = i[e], n = r.currentWindow.winAttr;
  return t = i[++e], n.fillOpacity = (t & 192) >> 6, n.fillRed = (t & 48) >> 4, n.fillGreen = (t & 12) >> 2, n.fillBlue = t & 3, t = i[++e], n.borderType = (t & 192) >> 6, n.borderRed = (t & 48) >> 4, n.borderGreen = (t & 12) >> 2, n.borderBlue = t & 3, t = i[++e], n.borderType += (t & 128) >> 5, n.wordWrap = (t & 64) >> 6, n.printDirection = (t & 48) >> 4, n.scrollDirection = (t & 12) >> 2, n.justify = t & 3, t = i[++e], n.effectSpeed = (t & 240) >> 4, n.effectDirection = (t & 12) >> 2, n.displayEffect = t & 3, e;
};
Si.prototype.flushDisplayed = function(e, r) {
  for (var i = [], t = 0; t < 8; t++)
    r.windows[t].visible && !r.windows[t].isEmpty() && i.push(r.windows[t].getText());
  r.endPts = e, r.text = i.join(`

`), this.pushCaption(r), r.startPts = e;
};
Si.prototype.pushCaption = function(e) {
  e.text !== "" && (this.trigger("data", {
    startPts: e.startPts,
    endPts: e.endPts,
    text: e.text,
    stream: "cc708_" + e.serviceNum
  }), e.text = "", e.startPts = e.endPts);
};
Si.prototype.displayWindows = function(e, r) {
  var i = this.current708Packet.data, t = i[++e], n = this.getPts(e);
  this.flushDisplayed(n, r);
  for (var a = 0; a < 8; a++)
    t & 1 << a && (r.windows[a].visible = 1);
  return e;
};
Si.prototype.hideWindows = function(e, r) {
  var i = this.current708Packet.data, t = i[++e], n = this.getPts(e);
  this.flushDisplayed(n, r);
  for (var a = 0; a < 8; a++)
    t & 1 << a && (r.windows[a].visible = 0);
  return e;
};
Si.prototype.toggleWindows = function(e, r) {
  var i = this.current708Packet.data, t = i[++e], n = this.getPts(e);
  this.flushDisplayed(n, r);
  for (var a = 0; a < 8; a++)
    t & 1 << a && (r.windows[a].visible ^= 1);
  return e;
};
Si.prototype.clearWindows = function(e, r) {
  var i = this.current708Packet.data, t = i[++e], n = this.getPts(e);
  this.flushDisplayed(n, r);
  for (var a = 0; a < 8; a++)
    t & 1 << a && r.windows[a].clearText();
  return e;
};
Si.prototype.deleteWindows = function(e, r) {
  var i = this.current708Packet.data, t = i[++e], n = this.getPts(e);
  this.flushDisplayed(n, r);
  for (var a = 0; a < 8; a++)
    t & 1 << a && r.windows[a].reset();
  return e;
};
Si.prototype.setPenAttributes = function(e, r) {
  var i = this.current708Packet.data, t = i[e], n = r.currentWindow.penAttr;
  return t = i[++e], n.textTag = (t & 240) >> 4, n.offset = (t & 12) >> 2, n.penSize = t & 3, t = i[++e], n.italics = (t & 128) >> 7, n.underline = (t & 64) >> 6, n.edgeType = (t & 56) >> 3, n.fontStyle = t & 7, e;
};
Si.prototype.setPenColor = function(e, r) {
  var i = this.current708Packet.data, t = i[e], n = r.currentWindow.penColor;
  return t = i[++e], n.fgOpacity = (t & 192) >> 6, n.fgRed = (t & 48) >> 4, n.fgGreen = (t & 12) >> 2, n.fgBlue = t & 3, t = i[++e], n.bgOpacity = (t & 192) >> 6, n.bgRed = (t & 48) >> 4, n.bgGreen = (t & 12) >> 2, n.bgBlue = t & 3, t = i[++e], n.edgeRed = (t & 48) >> 4, n.edgeGreen = (t & 12) >> 2, n.edgeBlue = t & 3, e;
};
Si.prototype.setPenLocation = function(e, r) {
  var i = this.current708Packet.data, t = i[e], n = r.currentWindow.penLoc;
  return r.currentWindow.pendingNewLine = !0, t = i[++e], n.row = t & 15, t = i[++e], n.column = t & 63, e;
};
Si.prototype.reset = function(e, r) {
  var i = this.getPts(e);
  return this.flushDisplayed(i, r), this.initService(r.serviceNum, e);
};
var Pk = {
  42: 225,
  92: 233,
  94: 237,
  95: 243,
  96: 250,
  123: 231,
  124: 247,
  125: 209,
  126: 241,
  127: 9608,
  304: 174,
  305: 176,
  306: 189,
  307: 191,
  308: 8482,
  309: 162,
  310: 163,
  311: 9834,
  312: 224,
  313: 160,
  314: 232,
  315: 226,
  316: 234,
  317: 238,
  318: 244,
  319: 251,
  544: 193,
  545: 201,
  546: 211,
  547: 218,
  548: 220,
  549: 252,
  550: 8216,
  551: 161,
  552: 42,
  553: 39,
  554: 8212,
  555: 169,
  556: 8480,
  557: 8226,
  558: 8220,
  559: 8221,
  560: 192,
  561: 194,
  562: 199,
  563: 200,
  564: 202,
  565: 203,
  566: 235,
  567: 206,
  568: 207,
  569: 239,
  570: 212,
  571: 217,
  572: 249,
  573: 219,
  574: 171,
  575: 187,
  800: 195,
  801: 227,
  802: 205,
  803: 204,
  804: 236,
  805: 210,
  806: 242,
  807: 213,
  808: 245,
  809: 123,
  810: 125,
  811: 92,
  812: 94,
  813: 95,
  814: 124,
  815: 126,
  816: 196,
  817: 228,
  818: 214,
  819: 246,
  820: 223,
  821: 165,
  822: 164,
  823: 9474,
  824: 197,
  825: 229,
  826: 216,
  827: 248,
  828: 9484,
  829: 9488,
  830: 9492,
  831: 9496
}, of = function(e) {
  return e === null ? "" : (e = Pk[e] || e, String.fromCharCode(e));
}, Oh = 14, Ok = [
  4352,
  4384,
  4608,
  4640,
  5376,
  5408,
  5632,
  5664,
  5888,
  5920,
  4096,
  4864,
  4896,
  5120,
  5152
], Hu = function() {
  for (var e = [], r = Oh + 1; r--; )
    e.push("");
  return e;
}, Bi = function(e, r) {
  Bi.prototype.init.call(this), this.field_ = e || 0, this.dataChannel_ = r || 0, this.name_ = "CC" + ((this.field_ << 1 | this.dataChannel_) + 1), this.setConstants(), this.reset(), this.push = function(i) {
    var t, n, a, s, o;
    if (t = i.ccData & 32639, t === this.lastControlCode_) {
      this.lastControlCode_ = null;
      return;
    }
    if ((t & 61440) === 4096 ? this.lastControlCode_ = t : t !== this.PADDING_ && (this.lastControlCode_ = null), a = t >>> 8, s = t & 255, t !== this.PADDING_)
      if (t === this.RESUME_CAPTION_LOADING_)
        this.mode_ = "popOn";
      else if (t === this.END_OF_CAPTION_)
        this.mode_ = "popOn", this.clearFormatting(i.pts), this.flushDisplayed(i.pts), n = this.displayed_, this.displayed_ = this.nonDisplayed_, this.nonDisplayed_ = n, this.startPts_ = i.pts;
      else if (t === this.ROLL_UP_2_ROWS_)
        this.rollUpRows_ = 2, this.setRollUp(i.pts);
      else if (t === this.ROLL_UP_3_ROWS_)
        this.rollUpRows_ = 3, this.setRollUp(i.pts);
      else if (t === this.ROLL_UP_4_ROWS_)
        this.rollUpRows_ = 4, this.setRollUp(i.pts);
      else if (t === this.CARRIAGE_RETURN_)
        this.clearFormatting(i.pts), this.flushDisplayed(i.pts), this.shiftRowsUp_(), this.startPts_ = i.pts;
      else if (t === this.BACKSPACE_)
        this.mode_ === "popOn" ? this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1) : this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1);
      else if (t === this.ERASE_DISPLAYED_MEMORY_)
        this.flushDisplayed(i.pts), this.displayed_ = Hu();
      else if (t === this.ERASE_NON_DISPLAYED_MEMORY_)
        this.nonDisplayed_ = Hu();
      else if (t === this.RESUME_DIRECT_CAPTIONING_)
        this.mode_ !== "paintOn" && (this.flushDisplayed(i.pts), this.displayed_ = Hu()), this.mode_ = "paintOn", this.startPts_ = i.pts;
      else if (this.isSpecialCharacter(a, s))
        a = (a & 3) << 8, o = of(a | s), this[this.mode_](i.pts, o), this.column_++;
      else if (this.isExtCharacter(a, s))
        this.mode_ === "popOn" ? this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1) : this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1), a = (a & 3) << 8, o = of(a | s), this[this.mode_](i.pts, o), this.column_++;
      else if (this.isMidRowCode(a, s))
        this.clearFormatting(i.pts), this[this.mode_](i.pts, " "), this.column_++, (s & 14) === 14 && this.addFormatting(i.pts, ["i"]), (s & 1) === 1 && this.addFormatting(i.pts, ["u"]);
      else if (this.isOffsetControlCode(a, s))
        this.column_ += s & 3;
      else if (this.isPAC(a, s)) {
        var l = Ok.indexOf(t & 7968);
        this.mode_ === "rollUp" && (l - this.rollUpRows_ + 1 < 0 && (l = this.rollUpRows_ - 1), this.setRollUp(i.pts, l)), l !== this.row_ && (this.clearFormatting(i.pts), this.row_ = l), s & 1 && this.formatting_.indexOf("u") === -1 && this.addFormatting(i.pts, ["u"]), (t & 16) === 16 && (this.column_ = ((t & 14) >> 1) * 4), this.isColorPAC(s) && (s & 14) === 14 && this.addFormatting(i.pts, ["i"]);
      } else
        this.isNormalChar(a) && (s === 0 && (s = null), o = of(a), o += of(s), this[this.mode_](i.pts, o), this.column_ += o.length);
  };
};
Bi.prototype = new Uv();
Bi.prototype.flushDisplayed = function(e) {
  var r = this.displayed_.map(function(i, t) {
    try {
      return i.trim();
    } catch {
      return this.trigger("log", {
        level: "warn",
        message: "Skipping a malformed 608 caption at index " + t + "."
      }), "";
    }
  }, this).join(`
`).replace(/^\n+|\n+$/g, "");
  r.length && this.trigger("data", {
    startPts: this.startPts_,
    endPts: e,
    text: r,
    stream: this.name_
  });
};
Bi.prototype.reset = function() {
  this.mode_ = "popOn", this.topRow_ = 0, this.startPts_ = 0, this.displayed_ = Hu(), this.nonDisplayed_ = Hu(), this.lastControlCode_ = null, this.column_ = 0, this.row_ = Oh, this.rollUpRows_ = 2, this.formatting_ = [];
};
Bi.prototype.setConstants = function() {
  this.dataChannel_ === 0 ? (this.BASE_ = 16, this.EXT_ = 17, this.CONTROL_ = (20 | this.field_) << 8, this.OFFSET_ = 23) : this.dataChannel_ === 1 && (this.BASE_ = 24, this.EXT_ = 25, this.CONTROL_ = (28 | this.field_) << 8, this.OFFSET_ = 31), this.PADDING_ = 0, this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 32, this.END_OF_CAPTION_ = this.CONTROL_ | 47, this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 37, this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 38, this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 39, this.CARRIAGE_RETURN_ = this.CONTROL_ | 45, this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 41, this.BACKSPACE_ = this.CONTROL_ | 33, this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 44, this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 46;
};
Bi.prototype.isSpecialCharacter = function(e, r) {
  return e === this.EXT_ && r >= 48 && r <= 63;
};
Bi.prototype.isExtCharacter = function(e, r) {
  return (e === this.EXT_ + 1 || e === this.EXT_ + 2) && r >= 32 && r <= 63;
};
Bi.prototype.isMidRowCode = function(e, r) {
  return e === this.EXT_ && r >= 32 && r <= 47;
};
Bi.prototype.isOffsetControlCode = function(e, r) {
  return e === this.OFFSET_ && r >= 33 && r <= 35;
};
Bi.prototype.isPAC = function(e, r) {
  return e >= this.BASE_ && e < this.BASE_ + 8 && r >= 64 && r <= 127;
};
Bi.prototype.isColorPAC = function(e) {
  return e >= 64 && e <= 79 || e >= 96 && e <= 127;
};
Bi.prototype.isNormalChar = function(e) {
  return e >= 32 && e <= 127;
};
Bi.prototype.setRollUp = function(e, r) {
  if (this.mode_ !== "rollUp" && (this.row_ = Oh, this.mode_ = "rollUp", this.flushDisplayed(e), this.nonDisplayed_ = Hu(), this.displayed_ = Hu()), r !== void 0 && r !== this.row_)
    for (var i = 0; i < this.rollUpRows_; i++)
      this.displayed_[r - i] = this.displayed_[this.row_ - i], this.displayed_[this.row_ - i] = "";
  r === void 0 && (r = this.row_), this.topRow_ = r - this.rollUpRows_ + 1;
};
Bi.prototype.addFormatting = function(e, r) {
  this.formatting_ = this.formatting_.concat(r);
  var i = r.reduce(function(t, n) {
    return t + "<" + n + ">";
  }, "");
  this[this.mode_](e, i);
};
Bi.prototype.clearFormatting = function(e) {
  if (!!this.formatting_.length) {
    var r = this.formatting_.reverse().reduce(function(i, t) {
      return i + "</" + t + ">";
    }, "");
    this.formatting_ = [], this[this.mode_](e, r);
  }
};
Bi.prototype.popOn = function(e, r) {
  var i = this.nonDisplayed_[this.row_];
  i += r, this.nonDisplayed_[this.row_] = i;
};
Bi.prototype.rollUp = function(e, r) {
  var i = this.displayed_[this.row_];
  i += r, this.displayed_[this.row_] = i;
};
Bi.prototype.shiftRowsUp_ = function() {
  var e;
  for (e = 0; e < this.topRow_; e++)
    this.displayed_[e] = "";
  for (e = this.row_ + 1; e < Oh + 1; e++)
    this.displayed_[e] = "";
  for (e = this.topRow_; e < this.row_; e++)
    this.displayed_[e] = this.displayed_[e + 1];
  this.displayed_[this.row_] = "";
};
Bi.prototype.paintOn = function(e, r) {
  var i = this.displayed_[this.row_];
  i += r, this.displayed_[this.row_] = i;
};
var Lk = {
  CaptionStream: fa,
  Cea608Stream: Bi,
  Cea708Stream: Si
}, Ik = NT.discardEmulationPreventionBytes, Mk = Lk.CaptionStream, Mc = Lv, Nk = Iv, Fk = Nv, Uk = Mv, u_ = ai, Bk = function(e, r) {
  for (var i = e, t = 0; t < r.length; t++) {
    var n = r[t];
    if (i < n.size)
      return n;
    i -= n.size;
  }
  return null;
}, jk = function(e, r, i) {
  var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
    logs: [],
    seiNals: []
  }, a, s, o, l;
  for (s = 0; s + 4 < e.length; s += o)
    if (o = t.getUint32(s), s += 4, !(o <= 0))
      switch (e[s] & 31) {
        case 6:
          var u = e.subarray(s + 1, s + 1 + o), h = Bk(s, r);
          if (a = {
            nalUnitType: "sei_rbsp",
            size: o,
            data: u,
            escapedRBSP: Ik(u),
            trackId: i
          }, h)
            a.pts = h.pts, a.dts = h.dts, l = h;
          else if (l)
            a.pts = l.pts, a.dts = l.dts;
          else {
            n.logs.push({
              level: "warn",
              message: "We've encountered a nal unit without data at " + s + " for trackId " + i + ". See mux.js#223."
            });
            break;
          }
          n.seiNals.push(a);
          break;
      }
  return n;
}, $k = function(e, r, i) {
  var t = r, n = i.defaultSampleDuration || 0, a = i.defaultSampleSize || 0, s = i.trackId, o = [];
  return e.forEach(function(l) {
    var u = Fk(l), h = u.samples;
    h.forEach(function(c) {
      c.duration === void 0 && (c.duration = n), c.size === void 0 && (c.size = a), c.trackId = s, c.dts = t, c.compositionTimeOffset === void 0 && (c.compositionTimeOffset = 0), typeof t == "bigint" ? (c.pts = t + u_.BigInt(c.compositionTimeOffset), t += u_.BigInt(c.duration)) : (c.pts = t + c.compositionTimeOffset, t += c.duration);
    }), o = o.concat(h);
  }), o;
}, Gk = function(e, r) {
  var i = Mc(e, ["moof", "traf"]), t = Mc(e, ["mdat"]), n = {}, a = [];
  return t.forEach(function(s, o) {
    var l = i[o];
    a.push({
      mdat: s,
      traf: l
    });
  }), a.forEach(function(s) {
    var o = s.mdat, l = s.traf, u = Mc(l, ["tfhd"]), h = Uk(u[0]), c = h.trackId, d = Mc(l, ["tfdt"]), f = d.length > 0 ? Nk(d[0]).baseMediaDecodeTime : 0, m = Mc(l, ["trun"]), p, b;
    r === c && m.length > 0 && (p = $k(m, f, h), b = jk(o, p, c), n[c] || (n[c] = { seiNals: [], logs: [] }), n[c].seiNals = n[c].seiNals.concat(b.seiNals), n[c].logs = n[c].logs.concat(b.logs));
  }), n;
}, Hk = function(e, r, i) {
  var t;
  if (r === null)
    return null;
  t = Gk(e, r);
  var n = t[r] || {};
  return {
    seiNals: n.seiNals,
    logs: n.logs,
    timescale: i
  };
}, Vk = function() {
  var e = !1, r, i, t, n, a, s;
  this.isInitialized = function() {
    return e;
  }, this.init = function(o) {
    r = new Mk(), e = !0, s = o ? o.isPartial : !1, r.on("data", function(l) {
      l.startTime = l.startPts / n, l.endTime = l.endPts / n, a.captions.push(l), a.captionStreams[l.stream] = !0;
    }), r.on("log", function(l) {
      a.logs.push(l);
    });
  }, this.isNewInit = function(o, l) {
    return o && o.length === 0 || l && typeof l == "object" && Object.keys(l).length === 0 ? !1 : t !== o[0] || n !== l[t];
  }, this.parse = function(o, l, u) {
    var h;
    if (this.isInitialized()) {
      if (!l || !u)
        return null;
      if (this.isNewInit(l, u))
        t = l[0], n = u[t];
      else if (t === null || !n)
        return i.push(o), null;
    } else
      return null;
    for (; i.length > 0; ) {
      var c = i.shift();
      this.parse(c, l, u);
    }
    return h = Hk(o, t, n), h && h.logs && (a.logs = a.logs.concat(h.logs)), h === null || !h.seiNals ? a.logs.length ? { logs: a.logs, captions: [], captionStreams: [] } : null : (this.pushNals(h.seiNals), this.flushStream(), a);
  }, this.pushNals = function(o) {
    if (!this.isInitialized() || !o || o.length === 0)
      return null;
    o.forEach(function(l) {
      r.push(l);
    });
  }, this.flushStream = function() {
    if (!this.isInitialized())
      return null;
    s ? r.partialFlush() : r.flush();
  }, this.clearParsedCaptions = function() {
    a.captions = [], a.captionStreams = {}, a.logs = [];
  }, this.resetCaptionStream = function() {
    if (!this.isInitialized())
      return null;
    r.reset();
  }, this.clearAllCaptions = function() {
    this.clearParsedCaptions(), this.resetCaptionStream();
  }, this.reset = function() {
    i = [], t = null, n = null, a ? this.clearParsedCaptions() : a = {
      captions: [],
      captionStreams: {},
      logs: []
    }, this.resetCaptionStream();
  }, this.reset();
}, qk = Vk, UT = {
  H264_STREAM_TYPE: 27,
  ADTS_STREAM_TYPE: 15,
  METADATA_STREAM_TYPE: 21
}, Wk = FT, Yk = 8589934592, Kk = 4294967296, l_ = "shared", Pg = function(e, r) {
  var i = 1;
  for (e > r && (i = -1); Math.abs(r - e) > Kk; )
    e += i * Yk;
  return e;
}, Bv = function(e) {
  var r, i;
  Bv.prototype.init.call(this), this.type_ = e || l_, this.push = function(t) {
    this.type_ !== l_ && t.type !== this.type_ || (i === void 0 && (i = t.dts), t.dts = Pg(t.dts, i), t.pts = Pg(t.pts, i), r = t.dts, this.trigger("data", t));
  }, this.flush = function() {
    i = r, this.trigger("done");
  }, this.endTimeline = function() {
    this.flush(), this.trigger("endedtimeline");
  }, this.discontinuity = function() {
    i = void 0, r = void 0;
  }, this.reset = function() {
    this.discontinuity(), this.trigger("reset");
  };
};
Bv.prototype = new Wk();
var zk = {
  TimestampRolloverStream: Bv,
  handleRollover: Pg
}, Np = UT, BT = function(e) {
  var r = e[1] & 31;
  return r <<= 8, r |= e[2], r;
}, Lh = function(e) {
  return !!(e[1] & 64);
}, Ih = function(e) {
  var r = 0;
  return (e[3] & 48) >>> 4 > 1 && (r += e[4] + 1), r;
}, Xk = function(e, r) {
  var i = BT(e);
  return i === 0 ? "pat" : i === r ? "pmt" : r ? "pes" : null;
}, Jk = function(e) {
  var r = Lh(e), i = 4 + Ih(e);
  return r && (i += e[i] + 1), (e[i + 10] & 31) << 8 | e[i + 11];
}, Qk = function(e) {
  var r = {}, i = Lh(e), t = 4 + Ih(e);
  if (i && (t += e[t] + 1), !!(e[t + 5] & 1)) {
    var n, a, s;
    n = (e[t + 1] & 15) << 8 | e[t + 2], a = 3 + n - 4, s = (e[t + 10] & 15) << 8 | e[t + 11];
    for (var o = 12 + s; o < a; ) {
      var l = t + o;
      r[(e[l + 1] & 31) << 8 | e[l + 2]] = e[l], o += ((e[l + 3] & 15) << 8 | e[l + 4]) + 5;
    }
    return r;
  }
}, Zk = function(e, r) {
  var i = BT(e), t = r[i];
  switch (t) {
    case Np.H264_STREAM_TYPE:
      return "video";
    case Np.ADTS_STREAM_TYPE:
      return "audio";
    case Np.METADATA_STREAM_TYPE:
      return "timed-metadata";
    default:
      return null;
  }
}, eR = function(e) {
  var r = Lh(e);
  if (!r)
    return null;
  var i = 4 + Ih(e);
  if (i >= e.byteLength)
    return null;
  var t = null, n;
  return n = e[i + 7], n & 192 && (t = {}, t.pts = (e[i + 9] & 14) << 27 | (e[i + 10] & 255) << 20 | (e[i + 11] & 254) << 12 | (e[i + 12] & 255) << 5 | (e[i + 13] & 254) >>> 3, t.pts *= 4, t.pts += (e[i + 13] & 6) >>> 1, t.dts = t.pts, n & 64 && (t.dts = (e[i + 14] & 14) << 27 | (e[i + 15] & 255) << 20 | (e[i + 16] & 254) << 12 | (e[i + 17] & 255) << 5 | (e[i + 18] & 254) >>> 3, t.dts *= 4, t.dts += (e[i + 18] & 6) >>> 1)), t;
}, Fp = function(e) {
  switch (e) {
    case 5:
      return "slice_layer_without_partitioning_rbsp_idr";
    case 6:
      return "sei_rbsp";
    case 7:
      return "seq_parameter_set_rbsp";
    case 8:
      return "pic_parameter_set_rbsp";
    case 9:
      return "access_unit_delimiter_rbsp";
    default:
      return null;
  }
}, tR = function(e) {
  for (var r = 4 + Ih(e), i = e.subarray(r), t = 0, n = 0, a = !1, s; n < i.byteLength - 3; n++)
    if (i[n + 2] === 1) {
      t = n + 5;
      break;
    }
  for (; t < i.byteLength; )
    switch (i[t]) {
      case 0:
        if (i[t - 1] !== 0) {
          t += 2;
          break;
        } else if (i[t - 2] !== 0) {
          t++;
          break;
        }
        n + 3 !== t - 2 && (s = Fp(i[n + 3] & 31), s === "slice_layer_without_partitioning_rbsp_idr" && (a = !0));
        do
          t++;
        while (i[t] !== 1 && t < i.length);
        n = t - 2, t += 3;
        break;
      case 1:
        if (i[t - 1] !== 0 || i[t - 2] !== 0) {
          t += 3;
          break;
        }
        s = Fp(i[n + 3] & 31), s === "slice_layer_without_partitioning_rbsp_idr" && (a = !0), n = t - 2, t += 3;
        break;
      default:
        t += 3;
        break;
    }
  return i = i.subarray(n), t -= n, n = 0, i && i.byteLength > 3 && (s = Fp(i[n + 3] & 31), s === "slice_layer_without_partitioning_rbsp_idr" && (a = !0)), a;
}, rR = {
  parseType: Xk,
  parsePat: Jk,
  parsePmt: Qk,
  parsePayloadUnitStartIndicator: Lh,
  parsePesType: Zk,
  parsePesTime: eR,
  videoPacketContainsKeyFrame: tR
}, iR = [
  96e3,
  88200,
  64e3,
  48e3,
  44100,
  32e3,
  24e3,
  22050,
  16e3,
  12e3,
  11025,
  8e3,
  7350
], jT = function(e, r) {
  var i = e[r + 6] << 21 | e[r + 7] << 14 | e[r + 8] << 7 | e[r + 9], t = e[r + 5], n = (t & 16) >> 4;
  return i = i >= 0 ? i : 0, n ? i + 20 : i + 10;
}, $T = function(e, r) {
  return e.length - r < 10 || e[r] !== "I".charCodeAt(0) || e[r + 1] !== "D".charCodeAt(0) || e[r + 2] !== "3".charCodeAt(0) ? r : (r += jT(e, r), $T(e, r));
}, nR = function(e) {
  var r = $T(e, 0);
  return e.length >= r + 2 && (e[r] & 255) === 255 && (e[r + 1] & 240) === 240 && (e[r + 1] & 22) === 16;
}, c_ = function(e) {
  return e[0] << 21 | e[1] << 14 | e[2] << 7 | e[3];
}, aR = function(e, r, i) {
  var t, n = "";
  for (t = r; t < i; t++)
    n += "%" + ("00" + e[t].toString(16)).slice(-2);
  return n;
}, sR = function(e, r, i) {
  return unescape(aR(e, r, i));
}, oR = function(e, r) {
  var i = (e[r + 5] & 224) >> 5, t = e[r + 4] << 3, n = e[r + 3] & 3 << 11;
  return n | t | i;
}, uR = function(e, r) {
  return e[r] === "I".charCodeAt(0) && e[r + 1] === "D".charCodeAt(0) && e[r + 2] === "3".charCodeAt(0) ? "timed-metadata" : e[r] & !0 && (e[r + 1] & 240) === 240 ? "audio" : null;
}, lR = function(e) {
  for (var r = 0; r + 5 < e.length; ) {
    if (e[r] !== 255 || (e[r + 1] & 246) !== 240) {
      r++;
      continue;
    }
    return iR[(e[r + 2] & 60) >>> 2];
  }
  return null;
}, cR = function(e) {
  var r, i, t, n;
  r = 10, e[5] & 64 && (r += 4, r += c_(e.subarray(10, 14)));
  do {
    if (i = c_(e.subarray(r + 4, r + 8)), i < 1)
      return null;
    if (n = String.fromCharCode(
      e[r],
      e[r + 1],
      e[r + 2],
      e[r + 3]
    ), n === "PRIV") {
      t = e.subarray(r + 10, r + i + 10);
      for (var a = 0; a < t.byteLength; a++)
        if (t[a] === 0) {
          var s = sR(t, 0, a);
          if (s === "com.apple.streaming.transportStreamTimestamp") {
            var o = t.subarray(a + 1), l = (o[3] & 1) << 30 | o[4] << 22 | o[5] << 14 | o[6] << 6 | o[7] >>> 2;
            return l *= 4, l += o[7] & 3, l;
          }
          break;
        }
    }
    r += 10, r += i;
  } while (r < e.byteLength);
  return null;
}, dR = {
  isLikelyAacData: nR,
  parseId3TagSize: jT,
  parseAdtsSize: oR,
  parseType: uR,
  parseSampleRate: lR,
  parseAacTimestamp: cR
}, jv = 9e4, $v, Gv, Mh, Hv, GT, HT, VT;
$v = function(e) {
  return e * jv;
};
Gv = function(e, r) {
  return e * r;
};
Mh = function(e) {
  return e / jv;
};
Hv = function(e, r) {
  return e / r;
};
GT = function(e, r) {
  return $v(Hv(e, r));
};
HT = function(e, r) {
  return Gv(Mh(e), r);
};
VT = function(e, r, i) {
  return Mh(i ? e : e - r);
};
var fR = {
  ONE_SECOND_IN_TS: jv,
  secondsToVideoTs: $v,
  secondsToAudioTs: Gv,
  videoTsToSeconds: Mh,
  audioTsToSeconds: Hv,
  audioTsToVideoTs: GT,
  videoTsToAudioTs: HT,
  metadataTsToSeconds: VT
}, d_ = UT, xl = zk.handleRollover, gi = {};
gi.ts = rR;
gi.aac = dR;
var Ou = fR.ONE_SECOND_IN_TS, zn = 188, Ms = 71, hR = function(e, r) {
  for (var i = 0, t = zn, n, a; t < e.byteLength; ) {
    if (e[i] === Ms && e[t] === Ms) {
      switch (n = e.subarray(i, t), a = gi.ts.parseType(n, r.pid), a) {
        case "pat":
          r.pid = gi.ts.parsePat(n);
          break;
        case "pmt":
          var s = gi.ts.parsePmt(n);
          r.table = r.table || {}, Object.keys(s).forEach(function(o) {
            r.table[o] = s[o];
          });
          break;
      }
      i += zn, t += zn;
      continue;
    }
    i++, t++;
  }
}, qT = function(e, r, i) {
  for (var t = 0, n = zn, a, s, o, l, u, h = !1; n <= e.byteLength; ) {
    if (e[t] === Ms && (e[n] === Ms || n === e.byteLength)) {
      switch (a = e.subarray(t, n), s = gi.ts.parseType(a, r.pid), s) {
        case "pes":
          o = gi.ts.parsePesType(a, r.table), l = gi.ts.parsePayloadUnitStartIndicator(a), o === "audio" && l && (u = gi.ts.parsePesTime(a), u && (u.type = "audio", i.audio.push(u), h = !0));
          break;
      }
      if (h)
        break;
      t += zn, n += zn;
      continue;
    }
    t++, n++;
  }
  for (n = e.byteLength, t = n - zn, h = !1; t >= 0; ) {
    if (e[t] === Ms && (e[n] === Ms || n === e.byteLength)) {
      switch (a = e.subarray(t, n), s = gi.ts.parseType(a, r.pid), s) {
        case "pes":
          o = gi.ts.parsePesType(a, r.table), l = gi.ts.parsePayloadUnitStartIndicator(a), o === "audio" && l && (u = gi.ts.parsePesTime(a), u && (u.type = "audio", i.audio.push(u), h = !0));
          break;
      }
      if (h)
        break;
      t -= zn, n -= zn;
      continue;
    }
    t--, n--;
  }
}, pR = function(e, r, i) {
  for (var t = 0, n = zn, a, s, o, l, u, h, c, d, f = !1, m = {
    data: [],
    size: 0
  }; n < e.byteLength; ) {
    if (e[t] === Ms && e[n] === Ms) {
      switch (a = e.subarray(t, n), s = gi.ts.parseType(a, r.pid), s) {
        case "pes":
          if (o = gi.ts.parsePesType(a, r.table), l = gi.ts.parsePayloadUnitStartIndicator(a), o === "video" && (l && !f && (u = gi.ts.parsePesTime(a), u && (u.type = "video", i.video.push(u), f = !0)), !i.firstKeyFrame)) {
            if (l && m.size !== 0) {
              for (h = new Uint8Array(m.size), c = 0; m.data.length; )
                d = m.data.shift(), h.set(d, c), c += d.byteLength;
              if (gi.ts.videoPacketContainsKeyFrame(h)) {
                var p = gi.ts.parsePesTime(h);
                p ? (i.firstKeyFrame = p, i.firstKeyFrame.type = "video") : console.warn(
                  "Failed to extract PTS/DTS from PES at first keyframe. This could be an unusual TS segment, or else mux.js did not parse your TS segment correctly. If you know your TS segments do contain PTS/DTS on keyframes please file a bug report! You can try ffprobe to double check for yourself."
                );
              }
              m.size = 0;
            }
            m.data.push(a), m.size += a.byteLength;
          }
          break;
      }
      if (f && i.firstKeyFrame)
        break;
      t += zn, n += zn;
      continue;
    }
    t++, n++;
  }
  for (n = e.byteLength, t = n - zn, f = !1; t >= 0; ) {
    if (e[t] === Ms && e[n] === Ms) {
      switch (a = e.subarray(t, n), s = gi.ts.parseType(a, r.pid), s) {
        case "pes":
          o = gi.ts.parsePesType(a, r.table), l = gi.ts.parsePayloadUnitStartIndicator(a), o === "video" && l && (u = gi.ts.parsePesTime(a), u && (u.type = "video", i.video.push(u), f = !0));
          break;
      }
      if (f)
        break;
      t -= zn, n -= zn;
      continue;
    }
    t--, n--;
  }
}, gR = function(e, r) {
  if (e.audio && e.audio.length) {
    var i = r;
    (typeof i > "u" || isNaN(i)) && (i = e.audio[0].dts), e.audio.forEach(function(a) {
      a.dts = xl(a.dts, i), a.pts = xl(a.pts, i), a.dtsTime = a.dts / Ou, a.ptsTime = a.pts / Ou;
    });
  }
  if (e.video && e.video.length) {
    var t = r;
    if ((typeof t > "u" || isNaN(t)) && (t = e.video[0].dts), e.video.forEach(function(a) {
      a.dts = xl(a.dts, t), a.pts = xl(a.pts, t), a.dtsTime = a.dts / Ou, a.ptsTime = a.pts / Ou;
    }), e.firstKeyFrame) {
      var n = e.firstKeyFrame;
      n.dts = xl(n.dts, t), n.pts = xl(n.pts, t), n.dtsTime = n.dts / Ou, n.ptsTime = n.pts / Ou;
    }
  }
}, vR = function(e) {
  for (var r = !1, i = 0, t = null, n = null, a = 0, s = 0, o; e.length - s >= 3; ) {
    var l = gi.aac.parseType(e, s);
    switch (l) {
      case "timed-metadata":
        if (e.length - s < 10) {
          r = !0;
          break;
        }
        if (a = gi.aac.parseId3TagSize(e, s), a > e.length) {
          r = !0;
          break;
        }
        n === null && (o = e.subarray(s, s + a), n = gi.aac.parseAacTimestamp(o)), s += a;
        break;
      case "audio":
        if (e.length - s < 7) {
          r = !0;
          break;
        }
        if (a = gi.aac.parseAdtsSize(e, s), a > e.length) {
          r = !0;
          break;
        }
        t === null && (o = e.subarray(s, s + a), t = gi.aac.parseSampleRate(o)), i++, s += a;
        break;
      default:
        s++;
        break;
    }
    if (r)
      return null;
  }
  if (t === null || n === null)
    return null;
  var u = Ou / t, h = {
    audio: [
      {
        type: "audio",
        dts: n,
        pts: n
      },
      {
        type: "audio",
        dts: n + i * 1024 * u,
        pts: n + i * 1024 * u
      }
    ]
  };
  return h;
}, mR = function(e) {
  var r = {
    pid: null,
    table: null
  }, i = {};
  hR(e, r);
  for (var t in r.table)
    if (r.table.hasOwnProperty(t)) {
      var n = r.table[t];
      switch (n) {
        case d_.H264_STREAM_TYPE:
          i.video = [], pR(e, r, i), i.video.length === 0 && delete i.video;
          break;
        case d_.ADTS_STREAM_TYPE:
          i.audio = [], qT(e, r, i), i.audio.length === 0 && delete i.audio;
          break;
      }
    }
  return i;
}, yR = function(e, r) {
  var i = gi.aac.isLikelyAacData(e), t;
  return i ? t = vR(e) : t = mR(e), !t || !t.audio && !t.video ? null : (gR(t, r), t);
}, _R = {
  inspect: yR,
  parseAudioPes_: qT
};
function ad(e) {
  return ad = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, ad(e);
}
function bR(e, r) {
  if (ad(e) != "object" || !e)
    return e;
  var i = e[Symbol.toPrimitive];
  if (i !== void 0) {
    var t = i.call(e, r || "default");
    if (ad(t) != "object")
      return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function TR(e) {
  var r = bR(e, "string");
  return ad(r) == "symbol" ? r : r + "";
}
function f_(e, r) {
  for (var i = 0; i < r.length; i++) {
    var t = r[i];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, TR(t.key), t);
  }
}
function SR(e, r, i) {
  return r && f_(e.prototype, r), i && f_(e, i), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Og(e, r) {
  return Og = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, t) {
    return i.__proto__ = t, i;
  }, Og(e, r);
}
function WT(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, Og(e, r);
}
var h_ = /* @__PURE__ */ function() {
  function e() {
    this.listeners = {};
  }
  var r = e.prototype;
  return r.on = function(t, n) {
    this.listeners[t] || (this.listeners[t] = []), this.listeners[t].push(n);
  }, r.off = function(t, n) {
    if (!this.listeners[t])
      return !1;
    var a = this.listeners[t].indexOf(n);
    return this.listeners[t] = this.listeners[t].slice(0), this.listeners[t].splice(a, 1), a > -1;
  }, r.trigger = function(t) {
    var n = this.listeners[t];
    if (!!n)
      if (arguments.length === 2)
        for (var a = n.length, s = 0; s < a; ++s)
          n[s].call(this, arguments[1]);
      else
        for (var o = Array.prototype.slice.call(arguments, 1), l = n.length, u = 0; u < l; ++u)
          n[u].apply(this, o);
  }, r.dispose = function() {
    this.listeners = {};
  }, r.pipe = function(t) {
    this.on("data", function(n) {
      t.push(n);
    });
  }, e;
}();
/*! @name pkcs7 @version 1.0.4 @license Apache-2.0 */
function ER(e) {
  return e.subarray(0, e.byteLength - e[e.byteLength - 1]);
}
/*! @name aes-decrypter @version 3.1.3 @license Apache-2.0 */
var xR = function() {
  var r = [[[], [], [], [], []], [[], [], [], [], []]], i = r[0], t = r[1], n = i[4], a = t[4], s, o, l, u = [], h = [], c, d, f, m, p, b;
  for (s = 0; s < 256; s++)
    h[(u[s] = s << 1 ^ (s >> 7) * 283) ^ s] = s;
  for (o = l = 0; !n[o]; o ^= c || 1, l = h[l] || 1)
    for (m = l ^ l << 1 ^ l << 2 ^ l << 3 ^ l << 4, m = m >> 8 ^ m & 255 ^ 99, n[o] = m, a[m] = o, f = u[d = u[c = u[o]]], b = f * 16843009 ^ d * 65537 ^ c * 257 ^ o * 16843008, p = u[m] * 257 ^ m * 16843008, s = 0; s < 4; s++)
      i[s][o] = p = p << 24 ^ p >>> 8, t[s][m] = b = b << 24 ^ b >>> 8;
  for (s = 0; s < 5; s++)
    i[s] = i[s].slice(0), t[s] = t[s].slice(0);
  return r;
}, Ua = null, AR = /* @__PURE__ */ function() {
  function e(i) {
    Ua || (Ua = xR()), this._tables = [[Ua[0][0].slice(), Ua[0][1].slice(), Ua[0][2].slice(), Ua[0][3].slice(), Ua[0][4].slice()], [Ua[1][0].slice(), Ua[1][1].slice(), Ua[1][2].slice(), Ua[1][3].slice(), Ua[1][4].slice()]];
    var t, n, a, s = this._tables[0][4], o = this._tables[1], l = i.length, u = 1;
    if (l !== 4 && l !== 6 && l !== 8)
      throw new Error("Invalid aes key size");
    var h = i.slice(0), c = [];
    for (this._key = [h, c], t = l; t < 4 * l + 28; t++)
      a = h[t - 1], (t % l === 0 || l === 8 && t % l === 4) && (a = s[a >>> 24] << 24 ^ s[a >> 16 & 255] << 16 ^ s[a >> 8 & 255] << 8 ^ s[a & 255], t % l === 0 && (a = a << 8 ^ a >>> 24 ^ u << 24, u = u << 1 ^ (u >> 7) * 283)), h[t] = h[t - l] ^ a;
    for (n = 0; t; n++, t--)
      a = h[n & 3 ? t : t - 4], t <= 4 || n < 4 ? c[n] = a : c[n] = o[0][s[a >>> 24]] ^ o[1][s[a >> 16 & 255]] ^ o[2][s[a >> 8 & 255]] ^ o[3][s[a & 255]];
  }
  var r = e.prototype;
  return r.decrypt = function(t, n, a, s, o, l) {
    var u = this._key[1], h = t ^ u[0], c = s ^ u[1], d = a ^ u[2], f = n ^ u[3], m, p, b, y = u.length / 4 - 2, v, g = 4, E = this._tables[1], x = E[0], w = E[1], S = E[2], T = E[3], C = E[4];
    for (v = 0; v < y; v++)
      m = x[h >>> 24] ^ w[c >> 16 & 255] ^ S[d >> 8 & 255] ^ T[f & 255] ^ u[g], p = x[c >>> 24] ^ w[d >> 16 & 255] ^ S[f >> 8 & 255] ^ T[h & 255] ^ u[g + 1], b = x[d >>> 24] ^ w[f >> 16 & 255] ^ S[h >> 8 & 255] ^ T[c & 255] ^ u[g + 2], f = x[f >>> 24] ^ w[h >> 16 & 255] ^ S[c >> 8 & 255] ^ T[d & 255] ^ u[g + 3], g += 4, h = m, c = p, d = b;
    for (v = 0; v < 4; v++)
      o[(3 & -v) + l] = C[h >>> 24] << 24 ^ C[c >> 16 & 255] << 16 ^ C[d >> 8 & 255] << 8 ^ C[f & 255] ^ u[g++], m = h, h = c, c = d, d = f, f = m;
  }, e;
}(), KT = /* @__PURE__ */ function(e) {
  WT(r, e);
  function r() {
    var t;
    return t = e.call(this, h_) || this, t.jobs = [], t.delay = 1, t.timeout_ = null, t;
  }
  var i = r.prototype;
  return i.processJob_ = function() {
    this.jobs.shift()(), this.jobs.length ? this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay) : this.timeout_ = null;
  }, i.push = function(n) {
    this.jobs.push(n), this.timeout_ || (this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay));
  }, r;
}(h_), Ga = function(r) {
  return r << 24 | (r & 65280) << 8 | (r & 16711680) >> 8 | r >>> 24;
}, zT = function(r, i, t) {
  var n = new Int32Array(r.buffer, r.byteOffset, r.byteLength >> 2), a = new AR(Array.prototype.slice.call(i)), s = new Uint8Array(r.byteLength), o = new Int32Array(s.buffer), l, u, h, c, d, f, m, p, b;
  for (l = t[0], u = t[1], h = t[2], c = t[3], b = 0; b < n.length; b += 4)
    d = Ga(n[b]), f = Ga(n[b + 1]), m = Ga(n[b + 2]), p = Ga(n[b + 3]), a.decrypt(d, f, m, p, o, b), o[b] = Ga(o[b] ^ l), o[b + 1] = Ga(o[b + 1] ^ u), o[b + 2] = Ga(o[b + 2] ^ h), o[b + 3] = Ga(o[b + 3] ^ c), l = d, u = f, h = m, c = p;
  return s;
}, wR = /* @__PURE__ */ function() {
  function e(i, t, n, a) {
    var s = e.STEP, o = new Int32Array(i.buffer), l = new Uint8Array(i.byteLength), u = 0;
    for (this.asyncStream_ = new KT(), this.asyncStream_.push(this.decryptChunk_(o.subarray(u, u + s), t, n, l)), u = s; u < o.length; u += s)
      n = new Uint32Array([Ga(o[u - 4]), Ga(o[u - 3]), Ga(o[u - 2]), Ga(o[u - 1])]), this.asyncStream_.push(this.decryptChunk_(o.subarray(u, u + s), t, n, l));
    this.asyncStream_.push(function() {
      a(null, ER(l));
    });
  }
  var r = e.prototype;
  return r.decryptChunk_ = function(t, n, a, s) {
    return function() {
      var o = zT(t, n, a);
      s.set(o, t.byteOffset);
    };
  }, SR(e, null, [{
    key: "STEP",
    get: function() {
      return 32e3;
    }
  }]), e;
}();
/**
 * @license
 * Video.js 7.6.6 <http://videojs.com/>
 * Copyright Brightcove, Inc. <https://www.brightcove.com/>
 * Available under Apache License Version 2.0
 * <https://github.com/videojs/video.js/blob/master/LICENSE>
 *
 * Includes vtt.js <https://github.com/mozilla/vtt.js>
 * Available under Apache License Version 2.0
 * <https://github.com/mozilla/vtt.js/blob/master/LICENSE>
 */
var XT = "7.6.6", ja = [], CR = function(r, i) {
  return function(t, n, a) {
    var s = i.levels[n], o = new RegExp("^(" + s + ")$");
    if (t !== "log" && a.unshift(t.toUpperCase() + ":"), a.unshift(r + ":"), ja && ja.push([].concat(a)), !!Be.console) {
      var l = Be.console[t];
      !l && t === "debug" && (l = Be.console.info || Be.console.log), !(!l || !s || !o.test(t)) && l[Array.isArray(a) ? "apply" : "call"](Be.console, a);
    }
  };
};
function JT(e) {
  var r = "info", i, t = function() {
    for (var a = arguments.length, s = new Array(a), o = 0; o < a; o++)
      s[o] = arguments[o];
    i("log", r, s);
  };
  return i = CR(e, t), t.createLogger = function(n) {
    return JT(e + ": " + n);
  }, t.levels = {
    all: "debug|log|warn|error",
    off: "",
    debug: "debug|log|warn|error",
    info: "log|warn|error",
    warn: "warn|error",
    error: "error",
    DEFAULT: r
  }, t.level = function(n) {
    if (typeof n == "string") {
      if (!t.levels.hasOwnProperty(n))
        throw new Error('"' + n + '" in not a valid log level');
      r = n;
    }
    return r;
  }, t.history = function() {
    return ja ? [].concat(ja) : [];
  }, t.history.filter = function(n) {
    return (ja || []).filter(function(a) {
      return new RegExp(".*" + n + ".*").test(a[0]);
    });
  }, t.history.clear = function() {
    ja && (ja.length = 0);
  }, t.history.disable = function() {
    ja !== null && (ja.length = 0, ja = null);
  }, t.history.enable = function() {
    ja === null && (ja = []);
  }, t.error = function() {
    for (var n = arguments.length, a = new Array(n), s = 0; s < n; s++)
      a[s] = arguments[s];
    return i("error", r, a);
  }, t.warn = function() {
    for (var n = arguments.length, a = new Array(n), s = 0; s < n; s++)
      a[s] = arguments[s];
    return i("warn", r, a);
  }, t.debug = function() {
    for (var n = arguments.length, a = new Array(n), s = 0; s < n; s++)
      a[s] = arguments[s];
    return i("debug", r, a);
  }, t;
}
var qr = JT("VIDEOJS"), QT = qr.createLogger, DR = Object.prototype.toString, ZT = function(r) {
  return tu(r) ? Object.keys(r) : [];
};
function Fl(e, r) {
  ZT(e).forEach(function(i) {
    return r(e[i], i);
  });
}
function kR(e, r, i) {
  return i === void 0 && (i = 0), ZT(e).reduce(function(t, n) {
    return r(t, e[n], n);
  }, i);
}
function Ui(e) {
  for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), t = 1; t < r; t++)
    i[t - 1] = arguments[t];
  return Object.assign ? Object.assign.apply(Object, [e].concat(i)) : (i.forEach(function(n) {
    !n || Fl(n, function(a, s) {
      e[s] = a;
    });
  }), e);
}
function tu(e) {
  return !!e && typeof e == "object";
}
function sd(e) {
  return tu(e) && DR.call(e) === "[object Object]" && e.constructor === Object;
}
function Wf(e, r) {
  if (!e || !r)
    return "";
  if (typeof Be.getComputedStyle == "function") {
    var i = Be.getComputedStyle(e);
    return i ? i.getPropertyValue(r) || i[r] : "";
  }
  return "";
}
function p_(e) {
  return typeof e == "string" && /\S/.test(e);
}
function eS(e) {
  if (/\s/.test(e))
    throw new Error("class has illegal whitespace characters");
}
function RR(e) {
  return new RegExp("(^|\\s)" + e + "($|\\s)");
}
function sc() {
  return Mt === Be.document;
}
function wd(e) {
  return tu(e) && e.nodeType === 1;
}
function tS() {
  try {
    return Be.parent !== Be.self;
  } catch {
    return !0;
  }
}
function rS(e) {
  return function(r, i) {
    if (!p_(r))
      return Mt[e](null);
    p_(i) && (i = Mt.querySelector(i));
    var t = wd(i) ? i : Mt;
    return t[e] && t[e](r);
  };
}
function Ji(e, r, i, t) {
  e === void 0 && (e = "div"), r === void 0 && (r = {}), i === void 0 && (i = {});
  var n = Mt.createElement(e);
  return Object.getOwnPropertyNames(r).forEach(function(a) {
    var s = r[a];
    a.indexOf("aria-") !== -1 || a === "role" || a === "type" ? (qr.warn(`Setting attributes in the second argument of createEl()
has been deprecated. Use the third argument instead.
` + ("createEl(type, properties, attributes). Attempting to set " + a + " to " + s + ".")), n.setAttribute(a, s)) : a === "textContent" ? oc(n, s) : n[a] = s;
  }), Object.getOwnPropertyNames(i).forEach(function(a) {
    n.setAttribute(a, i[a]);
  }), t && Wv(n, t), n;
}
function oc(e, r) {
  return typeof e.textContent > "u" ? e.innerText = r : e.textContent = r, e;
}
function Lg(e, r) {
  r.firstChild ? r.insertBefore(e, r.firstChild) : r.appendChild(e);
}
function Vu(e, r) {
  return eS(r), e.classList ? e.classList.contains(r) : RR(r).test(e.className);
}
function lo(e, r) {
  return e.classList ? e.classList.add(r) : Vu(e, r) || (e.className = (e.className + " " + r).trim()), e;
}
function Cd(e, r) {
  return e.classList ? e.classList.remove(r) : (eS(r), e.className = e.className.split(/\s+/).filter(function(i) {
    return i !== r;
  }).join(" ")), e;
}
function iS(e, r, i) {
  var t = Vu(e, r);
  if (typeof i == "function" && (i = i(e, r)), typeof i != "boolean" && (i = !t), i !== t)
    return i ? lo(e, r) : Cd(e, r), e;
}
function nS(e, r) {
  Object.getOwnPropertyNames(r).forEach(function(i) {
    var t = r[i];
    t === null || typeof t > "u" || t === !1 ? e.removeAttribute(i) : e.setAttribute(i, t === !0 ? "" : t);
  });
}
function io(e) {
  var r = {}, i = ",autoplay,controls,playsinline,loop,muted,default,defaultMuted,";
  if (e && e.attributes && e.attributes.length > 0)
    for (var t = e.attributes, n = t.length - 1; n >= 0; n--) {
      var a = t[n].name, s = t[n].value;
      (typeof e[a] == "boolean" || i.indexOf("," + a + ",") !== -1) && (s = s !== null), r[a] = s;
    }
  return r;
}
function aS(e, r) {
  return e.getAttribute(r);
}
function od(e, r, i) {
  e.setAttribute(r, i);
}
function Nh(e, r) {
  e.removeAttribute(r);
}
function sS() {
  Mt.body.focus(), Mt.onselectstart = function() {
    return !1;
  };
}
function oS() {
  Mt.onselectstart = function() {
    return !0;
  };
}
function ud(e) {
  if (e && e.getBoundingClientRect && e.parentNode) {
    var r = e.getBoundingClientRect(), i = {};
    return ["bottom", "height", "left", "right", "top", "width"].forEach(function(t) {
      r[t] !== void 0 && (i[t] = r[t]);
    }), i.height || (i.height = parseFloat(Wf(e, "height"))), i.width || (i.width = parseFloat(Wf(e, "width"))), i;
  }
}
function uS(e) {
  var r;
  if (e.getBoundingClientRect && e.parentNode && (r = e.getBoundingClientRect()), !r)
    return {
      left: 0,
      top: 0
    };
  var i = Mt.documentElement, t = Mt.body, n = i.clientLeft || t.clientLeft || 0, a = Be.pageXOffset || t.scrollLeft, s = r.left + a - n, o = i.clientTop || t.clientTop || 0, l = Be.pageYOffset || t.scrollTop, u = r.top + l - o;
  return {
    left: Math.round(s),
    top: Math.round(u)
  };
}
function Vv(e, r) {
  var i = {}, t = uS(e), n = e.offsetWidth, a = e.offsetHeight, s = t.top, o = t.left, l = r.pageY, u = r.pageX;
  return r.changedTouches && (u = r.changedTouches[0].pageX, l = r.changedTouches[0].pageY), i.y = Math.max(0, Math.min(1, (s - l + a) / a)), i.x = Math.max(0, Math.min(1, (u - o) / n)), i;
}
function lS(e) {
  return tu(e) && e.nodeType === 3;
}
function qv(e) {
  for (; e.firstChild; )
    e.removeChild(e.firstChild);
  return e;
}
function cS(e) {
  return typeof e == "function" && (e = e()), (Array.isArray(e) ? e : [e]).map(function(r) {
    if (typeof r == "function" && (r = r()), wd(r) || lS(r))
      return r;
    if (typeof r == "string" && /\S/.test(r))
      return Mt.createTextNode(r);
  }).filter(function(r) {
    return r;
  });
}
function Wv(e, r) {
  return cS(r).forEach(function(i) {
    return e.appendChild(i);
  }), e;
}
function dS(e, r) {
  return Wv(qv(e), r);
}
function zl(e) {
  return e.button === void 0 && e.buttons === void 0 || e.button === 0 && e.buttons === void 0 || e.type === "mouseup" && e.button === 0 && e.buttons === 0 ? !0 : !(e.button !== 0 || e.buttons !== 1);
}
var ru = rS("querySelector"), fS = rS("querySelectorAll"), hS = /* @__PURE__ */ Object.freeze({
  isReal: sc,
  isEl: wd,
  isInFrame: tS,
  createEl: Ji,
  textContent: oc,
  prependTo: Lg,
  hasClass: Vu,
  addClass: lo,
  removeClass: Cd,
  toggleClass: iS,
  setAttributes: nS,
  getAttributes: io,
  getAttribute: aS,
  setAttribute: od,
  removeAttribute: Nh,
  blockTextSelection: sS,
  unblockTextSelection: oS,
  getBoundingClientRect: ud,
  findPosition: uS,
  getPointerPosition: Vv,
  isTextNode: lS,
  emptyEl: qv,
  normalizeContent: cS,
  appendContent: Wv,
  insertContent: dS,
  isSingleLeftClick: zl,
  $: ru,
  $$: fS
}), pS = !1, Ig, PR = function() {
  if (!(!sc() || Ig.options.autoSetup === !1)) {
    var r = Array.prototype.slice.call(Mt.getElementsByTagName("video")), i = Array.prototype.slice.call(Mt.getElementsByTagName("audio")), t = Array.prototype.slice.call(Mt.getElementsByTagName("video-js")), n = r.concat(i, t);
    if (n && n.length > 0)
      for (var a = 0, s = n.length; a < s; a++) {
        var o = n[a];
        if (o && o.getAttribute) {
          if (o.player === void 0) {
            var l = o.getAttribute("data-setup");
            l !== null && Ig(o);
          }
        } else {
          Mg(1);
          break;
        }
      }
    else
      pS || Mg(1);
  }
};
function Mg(e, r) {
  r && (Ig = r), Be.setTimeout(PR, e);
}
function Ng() {
  pS = !0, Be.removeEventListener("load", Ng);
}
sc() && (Mt.readyState === "complete" ? Ng() : Be.addEventListener("load", Ng));
var gS = function(r) {
  var i = Mt.createElement("style");
  return i.className = r, i;
}, vS = function(r, i) {
  r.styleSheet ? r.styleSheet.cssText = i : r.textContent = i;
}, OR = 3, LR = OR;
function uu() {
  return LR++;
}
var mS;
Be.WeakMap || (mS = /* @__PURE__ */ function() {
  function e() {
    this.vdata = "vdata" + Math.floor(Be.performance && Be.performance.now() || Date.now()), this.data = {};
  }
  var r = e.prototype;
  return r.set = function(t, n) {
    var a = t[this.vdata] || uu();
    return t[this.vdata] || (t[this.vdata] = a), this.data[a] = n, this;
  }, r.get = function(t) {
    var n = t[this.vdata];
    if (n)
      return this.data[n];
    qr("We have no data for this element", t);
  }, r.has = function(t) {
    var n = t[this.vdata];
    return n in this.data;
  }, r.delete = function(t) {
    var n = t[this.vdata];
    n && (delete this.data[n], delete t[this.vdata]);
  }, e;
}());
var Zn = Be.WeakMap ? /* @__PURE__ */ new WeakMap() : new mS();
function g_(e, r) {
  if (!!Zn.has(e)) {
    var i = Zn.get(e);
    i.handlers[r].length === 0 && (delete i.handlers[r], e.removeEventListener ? e.removeEventListener(r, i.dispatcher, !1) : e.detachEvent && e.detachEvent("on" + r, i.dispatcher)), Object.getOwnPropertyNames(i.handlers).length <= 0 && (delete i.handlers, delete i.dispatcher, delete i.disabled), Object.getOwnPropertyNames(i).length === 0 && Zn.delete(e);
  }
}
function Yv(e, r, i, t) {
  i.forEach(function(n) {
    e(r, n, t);
  });
}
function Fh(e) {
  function r() {
    return !0;
  }
  function i() {
    return !1;
  }
  if (!e || !e.isPropagationStopped) {
    var t = e || Be.event;
    e = {};
    for (var n in t)
      n !== "layerX" && n !== "layerY" && n !== "keyLocation" && n !== "webkitMovementX" && n !== "webkitMovementY" && (n === "returnValue" && t.preventDefault || (e[n] = t[n]));
    if (e.target || (e.target = e.srcElement || Mt), e.relatedTarget || (e.relatedTarget = e.fromElement === e.target ? e.toElement : e.fromElement), e.preventDefault = function() {
      t.preventDefault && t.preventDefault(), e.returnValue = !1, t.returnValue = !1, e.defaultPrevented = !0;
    }, e.defaultPrevented = !1, e.stopPropagation = function() {
      t.stopPropagation && t.stopPropagation(), e.cancelBubble = !0, t.cancelBubble = !0, e.isPropagationStopped = r;
    }, e.isPropagationStopped = i, e.stopImmediatePropagation = function() {
      t.stopImmediatePropagation && t.stopImmediatePropagation(), e.isImmediatePropagationStopped = r, e.stopPropagation();
    }, e.isImmediatePropagationStopped = i, e.clientX !== null && e.clientX !== void 0) {
      var a = Mt.documentElement, s = Mt.body;
      e.pageX = e.clientX + (a && a.scrollLeft || s && s.scrollLeft || 0) - (a && a.clientLeft || s && s.clientLeft || 0), e.pageY = e.clientY + (a && a.scrollTop || s && s.scrollTop || 0) - (a && a.clientTop || s && s.clientTop || 0);
    }
    e.which = e.charCode || e.keyCode, e.button !== null && e.button !== void 0 && (e.button = e.button & 1 ? 0 : e.button & 4 ? 1 : e.button & 2 ? 2 : 0);
  }
  return e;
}
var yS = !1;
(function() {
  try {
    var e = Object.defineProperty({}, "passive", {
      get: function() {
        yS = !0;
      }
    });
    Be.addEventListener("test", null, e), Be.removeEventListener("test", null, e);
  } catch {
  }
})();
var IR = ["touchstart", "touchmove"];
function xa(e, r, i) {
  if (Array.isArray(r))
    return Yv(xa, e, r, i);
  Zn.has(e) || Zn.set(e, {});
  var t = Zn.get(e);
  if (t.handlers || (t.handlers = {}), t.handlers[r] || (t.handlers[r] = []), i.guid || (i.guid = uu()), t.handlers[r].push(i), t.dispatcher || (t.disabled = !1, t.dispatcher = function(a, s) {
    if (!t.disabled) {
      a = Fh(a);
      var o = t.handlers[a.type];
      if (o)
        for (var l = o.slice(0), u = 0, h = l.length; u < h && !a.isImmediatePropagationStopped(); u++)
          try {
            l[u].call(e, a, s);
          } catch (c) {
            qr.error(c);
          }
    }
  }), t.handlers[r].length === 1)
    if (e.addEventListener) {
      var n = !1;
      yS && IR.indexOf(r) > -1 && (n = {
        passive: !0
      }), e.addEventListener(r, t.dispatcher, n);
    } else
      e.attachEvent && e.attachEvent("on" + r, t.dispatcher);
}
function wn(e, r, i) {
  if (!!Zn.has(e)) {
    var t = Zn.get(e);
    if (!!t.handlers) {
      if (Array.isArray(r))
        return Yv(wn, e, r, i);
      var n = function(u, h) {
        t.handlers[h] = [], g_(u, h);
      };
      if (r === void 0) {
        for (var a in t.handlers)
          Object.prototype.hasOwnProperty.call(t.handlers || {}, a) && n(e, a);
        return;
      }
      var s = t.handlers[r];
      if (!!s) {
        if (!i) {
          n(e, r);
          return;
        }
        if (i.guid)
          for (var o = 0; o < s.length; o++)
            s[o].guid === i.guid && s.splice(o--, 1);
        g_(e, r);
      }
    }
  }
}
function uc(e, r, i) {
  var t = Zn.has(e) ? Zn.get(e) : {}, n = e.parentNode || e.ownerDocument;
  if (typeof r == "string" ? r = {
    type: r,
    target: e
  } : r.target || (r.target = e), r = Fh(r), t.dispatcher && t.dispatcher.call(e, r, i), n && !r.isPropagationStopped() && r.bubbles === !0)
    uc.call(null, n, r, i);
  else if (!n && !r.defaultPrevented && r.target && r.target[r.type]) {
    Zn.has(r.target) || Zn.set(r.target, {});
    var a = Zn.get(r.target);
    r.target[r.type] && (a.disabled = !0, typeof r.target[r.type] == "function" && r.target[r.type](), a.disabled = !1);
  }
  return !r.defaultPrevented;
}
function Uh(e, r, i) {
  if (Array.isArray(r))
    return Yv(Uh, e, r, i);
  var t = function n() {
    wn(e, r, n), i.apply(this, arguments);
  };
  t.guid = i.guid = i.guid || uu(), xa(e, r, t);
}
function _S(e, r, i) {
  var t = function n() {
    wn(e, r, n), i.apply(this, arguments);
  };
  t.guid = i.guid = i.guid || uu(), xa(e, r, t);
}
var MR = /* @__PURE__ */ Object.freeze({
  fixEvent: Fh,
  on: xa,
  off: wn,
  trigger: uc,
  one: Uh,
  any: _S
}), Qu = 30, Mr = function(r, i, t) {
  i.guid || (i.guid = uu());
  var n = i.bind(r);
  return n.guid = t ? t + "_" + i.guid : i.guid, n;
}, iu = function(r, i) {
  var t = Be.performance.now(), n = function() {
    var s = Be.performance.now();
    s - t >= i && (r.apply(void 0, arguments), t = s);
  };
  return n;
}, NR = function(r, i, t, n) {
  n === void 0 && (n = Be);
  var a, s = function() {
    n.clearTimeout(a), a = null;
  }, o = function() {
    var u = this, h = arguments, c = function() {
      a = null, c = null, t || r.apply(u, h);
    };
    !a && t && r.apply(u, h), n.clearTimeout(a), a = n.setTimeout(c, i);
  };
  return o.cancel = s, o;
}, vn = function() {
};
vn.prototype.allowedEvents_ = {};
vn.prototype.on = function(e, r) {
  var i = this.addEventListener;
  this.addEventListener = function() {
  }, xa(this, e, r), this.addEventListener = i;
};
vn.prototype.addEventListener = vn.prototype.on;
vn.prototype.off = function(e, r) {
  wn(this, e, r);
};
vn.prototype.removeEventListener = vn.prototype.off;
vn.prototype.one = function(e, r) {
  var i = this.addEventListener;
  this.addEventListener = function() {
  }, Uh(this, e, r), this.addEventListener = i;
};
vn.prototype.any = function(e, r) {
  var i = this.addEventListener;
  this.addEventListener = function() {
  }, _S(this, e, r), this.addEventListener = i;
};
vn.prototype.trigger = function(e) {
  var r = e.type || e;
  typeof e == "string" && (e = {
    type: r
  }), e = Fh(e), this.allowedEvents_[r] && this["on" + r] && this["on" + r](e), uc(this, e);
};
vn.prototype.dispatchEvent = vn.prototype.trigger;
var Nc;
vn.prototype.queueTrigger = function(e) {
  var r = this;
  Nc || (Nc = /* @__PURE__ */ new Map());
  var i = e.type || e, t = Nc.get(this);
  t || (t = /* @__PURE__ */ new Map(), Nc.set(this, t));
  var n = t.get(i);
  t.delete(i), Be.clearTimeout(n);
  var a = Be.setTimeout(function() {
    t.size === 0 && (t = null, Nc.delete(r)), r.trigger(e);
  }, 0);
  t.set(i, a);
};
var Zu = function(r) {
  return r instanceof vn || !!r.eventBusEl_ && ["on", "one", "off", "trigger"].every(function(i) {
    return typeof r[i] == "function";
  });
}, FR = function(r, i) {
  Zu(r) ? i() : (r.eventedCallbacks || (r.eventedCallbacks = []), r.eventedCallbacks.push(i));
}, bS = function(r) {
  return typeof r == "string" && /\S/.test(r) || Array.isArray(r) && !!r.length;
}, Kv = function(r) {
  if (!r.nodeName && !Zu(r))
    throw new Error("Invalid target; must be a DOM node or evented object.");
}, TS = function(r) {
  if (!bS(r))
    throw new Error("Invalid event type; must be a non-empty string or array.");
}, SS = function(r) {
  if (typeof r != "function")
    throw new Error("Invalid listener; must be a function.");
}, Up = function(r, i) {
  var t = i.length < 3 || i[0] === r || i[0] === r.eventBusEl_, n, a, s;
  return t ? (n = r.eventBusEl_, i.length >= 3 && i.shift(), a = i[0], s = i[1]) : (n = i[0], a = i[1], s = i[2]), Kv(n), TS(a), SS(s), s = Mr(r, s), {
    isTargetingSelf: t,
    target: n,
    type: a,
    listener: s
  };
}, ku = function(r, i, t, n) {
  Kv(r), r.nodeName ? MR[i](r, t, n) : r[i](t, n);
}, UR = {
  on: function() {
    for (var r = this, i = arguments.length, t = new Array(i), n = 0; n < i; n++)
      t[n] = arguments[n];
    var a = Up(this, t), s = a.isTargetingSelf, o = a.target, l = a.type, u = a.listener;
    if (ku(o, "on", l, u), !s) {
      var h = function() {
        return r.off(o, l, u);
      };
      h.guid = u.guid;
      var c = function() {
        return r.off("dispose", h);
      };
      c.guid = u.guid, ku(this, "on", "dispose", h), ku(o, "on", "dispose", c);
    }
  },
  one: function() {
    for (var r = this, i = arguments.length, t = new Array(i), n = 0; n < i; n++)
      t[n] = arguments[n];
    var a = Up(this, t), s = a.isTargetingSelf, o = a.target, l = a.type, u = a.listener;
    if (s)
      ku(o, "one", l, u);
    else {
      var h = function c() {
        r.off(o, l, c);
        for (var d = arguments.length, f = new Array(d), m = 0; m < d; m++)
          f[m] = arguments[m];
        u.apply(null, f);
      };
      h.guid = u.guid, ku(o, "one", l, h);
    }
  },
  any: function() {
    for (var r = this, i = arguments.length, t = new Array(i), n = 0; n < i; n++)
      t[n] = arguments[n];
    var a = Up(this, t), s = a.isTargetingSelf, o = a.target, l = a.type, u = a.listener;
    if (s)
      ku(o, "any", l, u);
    else {
      var h = function c() {
        r.off(o, l, c);
        for (var d = arguments.length, f = new Array(d), m = 0; m < d; m++)
          f[m] = arguments[m];
        u.apply(null, f);
      };
      h.guid = u.guid, ku(o, "any", l, h);
    }
  },
  off: function(r, i, t) {
    if (!r || bS(r))
      wn(this.eventBusEl_, r, i);
    else {
      var n = r, a = i;
      Kv(n), TS(a), SS(t), t = Mr(this, t), this.off("dispose", t), n.nodeName ? (wn(n, a, t), wn(n, "dispose", t)) : Zu(n) && (n.off(a, t), n.off("dispose", t));
    }
  },
  trigger: function(r, i) {
    return uc(this.eventBusEl_, r, i);
  }
};
function zv(e, r) {
  r === void 0 && (r = {});
  var i = r, t = i.eventBusKey;
  if (t) {
    if (!e[t].nodeName)
      throw new Error('The eventBusKey "' + t + '" does not refer to an element.');
    e.eventBusEl_ = e[t];
  } else
    e.eventBusEl_ = Ji("span", {
      className: "vjs-event-bus"
    });
  return Ui(e, UR), e.eventedCallbacks && e.eventedCallbacks.forEach(function(n) {
    n();
  }), e.on("dispose", function() {
    e.off(), Be.setTimeout(function() {
      e.eventBusEl_ = null;
    }, 0);
  }), e;
}
var BR = {
  state: {},
  setState: function(r) {
    var i = this;
    typeof r == "function" && (r = r());
    var t;
    return Fl(r, function(n, a) {
      i.state[a] !== n && (t = t || {}, t[a] = {
        from: i.state[a],
        to: n
      }), i.state[a] = n;
    }), t && Zu(this) && this.trigger({
      changes: t,
      type: "statechanged"
    }), t;
  }
};
function ES(e, r) {
  return Ui(e, BR), e.state = Ui({}, e.state, r), typeof e.handleStateChanged == "function" && Zu(e) && e.on("statechanged", e.handleStateChanged), e;
}
var xf = function(r) {
  return typeof r != "string" ? r : r.replace(/./, function(i) {
    return i.toLowerCase();
  });
}, Wi = function(r) {
  return typeof r != "string" ? r : r.replace(/./, function(i) {
    return i.toUpperCase();
  });
}, jR = function(r, i) {
  return Wi(r) === Wi(i);
};
function Ti() {
  for (var e = {}, r = arguments.length, i = new Array(r), t = 0; t < r; t++)
    i[t] = arguments[t];
  return i.forEach(function(n) {
    !n || Fl(n, function(a, s) {
      if (!sd(a)) {
        e[s] = a;
        return;
      }
      sd(e[s]) || (e[s] = {}), e[s] = Ti(e[s], a);
    });
  }), e;
}
var bt = /* @__PURE__ */ function() {
  function e(i, t, n) {
    if (!i && this.play ? this.player_ = i = this : this.player_ = i, this.parentComponent_ = null, this.options_ = Ti({}, this.options_), t = this.options_ = Ti(this.options_, t), this.id_ = t.id || t.el && t.el.id, !this.id_) {
      var a = i && i.id && i.id() || "no_player";
      this.id_ = a + "_component_" + uu();
    }
    this.name_ = t.name || null, t.el ? this.el_ = t.el : t.createEl !== !1 && (this.el_ = this.createEl()), t.evented !== !1 && zv(this, {
      eventBusKey: this.el_ ? "el_" : null
    }), ES(this, this.constructor.defaultState), this.children_ = [], this.childIndex_ = {}, this.childNameIndex_ = {};
    var s;
    Be.Set || (s = /* @__PURE__ */ function() {
      function o() {
        this.set_ = {};
      }
      var l = o.prototype;
      return l.has = function(h) {
        return h in this.set_;
      }, l.delete = function(h) {
        var c = this.has(h);
        return delete this.set_[h], c;
      }, l.add = function(h) {
        return this.set_[h] = 1, this;
      }, l.forEach = function(h, c) {
        for (var d in this.set_)
          h.call(c, d, d, this);
      }, o;
    }()), this.setTimeoutIds_ = Be.Set ? /* @__PURE__ */ new Set() : new s(), this.setIntervalIds_ = Be.Set ? /* @__PURE__ */ new Set() : new s(), this.rafIds_ = Be.Set ? /* @__PURE__ */ new Set() : new s(), this.clearingTimersOnDispose_ = !1, t.initChildren !== !1 && this.initChildren(), this.ready(n), t.reportTouchActivity !== !1 && this.enableTouchActivity();
  }
  var r = e.prototype;
  return r.dispose = function() {
    if (this.trigger({
      type: "dispose",
      bubbles: !1
    }), this.children_)
      for (var t = this.children_.length - 1; t >= 0; t--)
        this.children_[t].dispose && this.children_[t].dispose();
    this.children_ = null, this.childIndex_ = null, this.childNameIndex_ = null, this.parentComponent_ = null, this.el_ && (this.el_.parentNode && this.el_.parentNode.removeChild(this.el_), Zn.has(this.el_) && Zn.delete(this.el_), this.el_ = null), this.player_ = null;
  }, r.player = function() {
    return this.player_;
  }, r.options = function(t) {
    return t ? (this.options_ = Ti(this.options_, t), this.options_) : this.options_;
  }, r.el = function() {
    return this.el_;
  }, r.createEl = function(t, n, a) {
    return Ji(t, n, a);
  }, r.localize = function(t, n, a) {
    a === void 0 && (a = t);
    var s = this.player_.language && this.player_.language(), o = this.player_.languages && this.player_.languages(), l = o && o[s], u = s && s.split("-")[0], h = o && o[u], c = a;
    return l && l[t] ? c = l[t] : h && h[t] && (c = h[t]), n && (c = c.replace(/\{(\d+)\}/g, function(d, f) {
      var m = n[f - 1], p = m;
      return typeof m > "u" && (p = d), p;
    })), c;
  }, r.contentEl = function() {
    return this.contentEl_ || this.el_;
  }, r.id = function() {
    return this.id_;
  }, r.name = function() {
    return this.name_;
  }, r.children = function() {
    return this.children_;
  }, r.getChildById = function(t) {
    return this.childIndex_[t];
  }, r.getChild = function(t) {
    if (!!t)
      return this.childNameIndex_[t];
  }, r.addChild = function(t, n, a) {
    n === void 0 && (n = {}), a === void 0 && (a = this.children_.length);
    var s, o;
    if (typeof t == "string") {
      o = Wi(t);
      var l = n.componentClass || o;
      n.name = o;
      var u = e.getComponent(l);
      if (!u)
        throw new Error("Component " + l + " does not exist");
      if (typeof u != "function")
        return null;
      s = new u(this.player_ || this, n);
    } else
      s = t;
    if (s.parentComponent_ && s.parentComponent_.removeChild(s), this.children_.splice(a, 0, s), s.parentComponent_ = this, typeof s.id == "function" && (this.childIndex_[s.id()] = s), o = o || s.name && Wi(s.name()), o && (this.childNameIndex_[o] = s, this.childNameIndex_[xf(o)] = s), typeof s.el == "function" && s.el()) {
      var h = this.contentEl().children, c = h[a] || null;
      this.contentEl().insertBefore(s.el(), c);
    }
    return s;
  }, r.removeChild = function(t) {
    if (typeof t == "string" && (t = this.getChild(t)), !(!t || !this.children_)) {
      for (var n = !1, a = this.children_.length - 1; a >= 0; a--)
        if (this.children_[a] === t) {
          n = !0, this.children_.splice(a, 1);
          break;
        }
      if (!!n) {
        t.parentComponent_ = null, this.childIndex_[t.id()] = null, this.childNameIndex_[Wi(t.name())] = null, this.childNameIndex_[xf(t.name())] = null;
        var s = t.el();
        s && s.parentNode === this.contentEl() && this.contentEl().removeChild(t.el());
      }
    }
  }, r.initChildren = function() {
    var t = this, n = this.options_.children;
    if (n) {
      var a = this.options_, s = function(h) {
        var c = h.name, d = h.opts;
        if (a[c] !== void 0 && (d = a[c]), d !== !1) {
          d === !0 && (d = {}), d.playerOptions = t.options_.playerOptions;
          var f = t.addChild(c, d);
          f && (t[c] = f);
        }
      }, o, l = e.getComponent("Tech");
      Array.isArray(n) ? o = n : o = Object.keys(n), o.concat(Object.keys(this.options_).filter(function(u) {
        return !o.some(function(h) {
          return typeof h == "string" ? u === h : u === h.name;
        });
      })).map(function(u) {
        var h, c;
        return typeof u == "string" ? (h = u, c = n[h] || t.options_[h] || {}) : (h = u.name, c = u), {
          name: h,
          opts: c
        };
      }).filter(function(u) {
        var h = e.getComponent(u.opts.componentClass || Wi(u.name));
        return h && !l.isTech(h);
      }).forEach(s);
    }
  }, r.buildCSSClass = function() {
    return "";
  }, r.ready = function(t, n) {
    if (n === void 0 && (n = !1), !!t) {
      if (!this.isReady_) {
        this.readyQueue_ = this.readyQueue_ || [], this.readyQueue_.push(t);
        return;
      }
      n ? t.call(this) : this.setTimeout(t, 1);
    }
  }, r.triggerReady = function() {
    this.isReady_ = !0, this.setTimeout(function() {
      var t = this.readyQueue_;
      this.readyQueue_ = [], t && t.length > 0 && t.forEach(function(n) {
        n.call(this);
      }, this), this.trigger("ready");
    }, 1);
  }, r.$ = function(t, n) {
    return ru(t, n || this.contentEl());
  }, r.$$ = function(t, n) {
    return fS(t, n || this.contentEl());
  }, r.hasClass = function(t) {
    return Vu(this.el_, t);
  }, r.addClass = function(t) {
    lo(this.el_, t);
  }, r.removeClass = function(t) {
    Cd(this.el_, t);
  }, r.toggleClass = function(t, n) {
    iS(this.el_, t, n);
  }, r.show = function() {
    this.removeClass("vjs-hidden");
  }, r.hide = function() {
    this.addClass("vjs-hidden");
  }, r.lockShowing = function() {
    this.addClass("vjs-lock-showing");
  }, r.unlockShowing = function() {
    this.removeClass("vjs-lock-showing");
  }, r.getAttribute = function(t) {
    return aS(this.el_, t);
  }, r.setAttribute = function(t, n) {
    od(this.el_, t, n);
  }, r.removeAttribute = function(t) {
    Nh(this.el_, t);
  }, r.width = function(t, n) {
    return this.dimension("width", t, n);
  }, r.height = function(t, n) {
    return this.dimension("height", t, n);
  }, r.dimensions = function(t, n) {
    this.width(t, !0), this.height(n);
  }, r.dimension = function(t, n, a) {
    if (n !== void 0) {
      (n === null || n !== n) && (n = 0), ("" + n).indexOf("%") !== -1 || ("" + n).indexOf("px") !== -1 ? this.el_.style[t] = n : n === "auto" ? this.el_.style[t] = "" : this.el_.style[t] = n + "px", a || this.trigger("componentresize");
      return;
    }
    if (!this.el_)
      return 0;
    var s = this.el_.style[t], o = s.indexOf("px");
    return parseInt(o !== -1 ? s.slice(0, o) : this.el_["offset" + Wi(t)], 10);
  }, r.currentDimension = function(t) {
    var n = 0;
    if (t !== "width" && t !== "height")
      throw new Error("currentDimension only accepts width or height value");
    if (n = Wf(this.el_, t), n = parseFloat(n), n === 0 || isNaN(n)) {
      var a = "offset" + Wi(t);
      n = this.el_[a];
    }
    return n;
  }, r.currentDimensions = function() {
    return {
      width: this.currentDimension("width"),
      height: this.currentDimension("height")
    };
  }, r.currentWidth = function() {
    return this.currentDimension("width");
  }, r.currentHeight = function() {
    return this.currentDimension("height");
  }, r.focus = function() {
    this.el_.focus();
  }, r.blur = function() {
    this.el_.blur();
  }, r.handleKeyDown = function(t) {
    this.player_ && (t.stopPropagation(), this.player_.handleKeyDown(t));
  }, r.handleKeyPress = function(t) {
    this.handleKeyDown(t);
  }, r.emitTapEvents = function() {
    var t = 0, n = null, a = 10, s = 200, o;
    this.on("touchstart", function(u) {
      u.touches.length === 1 && (n = {
        pageX: u.touches[0].pageX,
        pageY: u.touches[0].pageY
      }, t = Be.performance.now(), o = !0);
    }), this.on("touchmove", function(u) {
      if (u.touches.length > 1)
        o = !1;
      else if (n) {
        var h = u.touches[0].pageX - n.pageX, c = u.touches[0].pageY - n.pageY, d = Math.sqrt(h * h + c * c);
        d > a && (o = !1);
      }
    });
    var l = function() {
      o = !1;
    };
    this.on("touchleave", l), this.on("touchcancel", l), this.on("touchend", function(u) {
      if (n = null, o === !0) {
        var h = Be.performance.now() - t;
        h < s && (u.preventDefault(), this.trigger("tap"));
      }
    });
  }, r.enableTouchActivity = function() {
    if (!(!this.player() || !this.player().reportUserActivity)) {
      var t = Mr(this.player(), this.player().reportUserActivity), n;
      this.on("touchstart", function() {
        t(), this.clearInterval(n), n = this.setInterval(t, 250);
      });
      var a = function(o) {
        t(), this.clearInterval(n);
      };
      this.on("touchmove", t), this.on("touchend", a), this.on("touchcancel", a);
    }
  }, r.setTimeout = function(t, n) {
    var a = this, s;
    return t = Mr(this, t), this.clearTimersOnDispose_(), s = Be.setTimeout(function() {
      a.setTimeoutIds_.has(s) && a.setTimeoutIds_.delete(s), t();
    }, n), this.setTimeoutIds_.add(s), s;
  }, r.clearTimeout = function(t) {
    return this.setTimeoutIds_.has(t) && (this.setTimeoutIds_.delete(t), Be.clearTimeout(t)), t;
  }, r.setInterval = function(t, n) {
    t = Mr(this, t), this.clearTimersOnDispose_();
    var a = Be.setInterval(t, n);
    return this.setIntervalIds_.add(a), a;
  }, r.clearInterval = function(t) {
    return this.setIntervalIds_.has(t) && (this.setIntervalIds_.delete(t), Be.clearInterval(t)), t;
  }, r.requestAnimationFrame = function(t) {
    var n = this;
    if (!this.supportsRaf_)
      return this.setTimeout(t, 1e3 / 60);
    this.clearTimersOnDispose_();
    var a;
    return t = Mr(this, t), a = Be.requestAnimationFrame(function() {
      n.rafIds_.has(a) && n.rafIds_.delete(a), t();
    }), this.rafIds_.add(a), a;
  }, r.cancelAnimationFrame = function(t) {
    return this.supportsRaf_ ? (this.rafIds_.has(t) && (this.rafIds_.delete(t), Be.cancelAnimationFrame(t)), t) : this.clearTimeout(t);
  }, r.clearTimersOnDispose_ = function() {
    var t = this;
    this.clearingTimersOnDispose_ || (this.clearingTimersOnDispose_ = !0, this.one("dispose", function() {
      [["rafIds_", "cancelAnimationFrame"], ["setTimeoutIds_", "clearTimeout"], ["setIntervalIds_", "clearInterval"]].forEach(function(n) {
        var a = n[0], s = n[1];
        t[a].forEach(t[s], t);
      }), t.clearingTimersOnDispose_ = !1;
    }));
  }, e.registerComponent = function(t, n) {
    if (typeof t != "string" || !t)
      throw new Error('Illegal component name, "' + t + '"; must be a non-empty string.');
    var a = e.getComponent("Tech"), s = a && a.isTech(n), o = e === n || e.prototype.isPrototypeOf(n.prototype);
    if (s || !o) {
      var l;
      throw s ? l = "techs must be registered using Tech.registerTech()" : l = "must be a Component subclass", new Error('Illegal component, "' + t + '"; ' + l + ".");
    }
    t = Wi(t), e.components_ || (e.components_ = {});
    var u = e.getComponent("Player");
    if (t === "Player" && u && u.players) {
      var h = u.players, c = Object.keys(h);
      if (h && c.length > 0 && c.map(function(d) {
        return h[d];
      }).every(Boolean))
        throw new Error("Can not register Player component after player has been created.");
    }
    return e.components_[t] = n, e.components_[xf(t)] = n, n;
  }, e.getComponent = function(t) {
    if (!(!t || !e.components_))
      return e.components_[t];
  }, e;
}();
bt.prototype.supportsRaf_ = typeof Be.requestAnimationFrame == "function" && typeof Be.cancelAnimationFrame == "function";
bt.registerComponent("Component", bt);
function zt(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, e.__proto__ = r;
}
function Fg(e, r) {
  return Fg = Object.setPrototypeOf || function(t, n) {
    return t.__proto__ = n, t;
  }, Fg(e, r);
}
function $R() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Af(e, r, i) {
  return $R() ? Af = Reflect.construct : Af = function(n, a, s) {
    var o = [null];
    o.push.apply(o, a);
    var l = Function.bind.apply(n, o), u = new l();
    return s && Fg(u, s.prototype), u;
  }, Af.apply(null, arguments);
}
function Rr(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
var Cn = Be.navigator && Be.navigator.userAgent || "", v_ = /AppleWebKit\/([\d.]+)/i.exec(Cn), GR = v_ ? parseFloat(v_.pop()) : null, Xv = /iPad/i.test(Cn), Jv = /iPhone/i.test(Cn) && !Xv, xS = /iPod/i.test(Cn), cs = Jv || Xv || xS, HR = function() {
  var e = Cn.match(/OS (\d+)_/i);
  return e && e[1] ? e[1] : null;
}(), lu = /Android/i.test(Cn), Qv = function() {
  var e = Cn.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
  if (!e)
    return null;
  var r = e[1] && parseFloat(e[1]), i = e[2] && parseFloat(e[2]);
  return r && i ? parseFloat(e[1] + "." + e[2]) : r || null;
}(), AS = lu && Qv < 5 && GR < 537, wS = /Firefox/i.test(Cn), Zv = /Edge/i.test(Cn), Eo = !Zv && (/Chrome/i.test(Cn) || /CriOS/i.test(Cn)), CS = function() {
  var e = Cn.match(/(Chrome|CriOS)\/(\d+)/);
  return e && e[2] ? parseFloat(e[2]) : null;
}(), em = function() {
  var e = /MSIE\s(\d+)\.\d/.exec(Cn), r = e && parseFloat(e[1]);
  return !r && /Trident\/7.0/i.test(Cn) && /rv:11.0/.test(Cn) && (r = 11), r;
}(), DS = /Safari/i.test(Cn) && !Eo && !lu && !Zv, tm = (DS || cs) && !Eo, kS = /Windows/i.test(Cn), ld = sc() && ("ontouchstart" in Be || Be.navigator.maxTouchPoints || Be.DocumentTouch && Be.document instanceof Be.DocumentTouch), VR = /* @__PURE__ */ Object.freeze({
  IS_IPAD: Xv,
  IS_IPHONE: Jv,
  IS_IPOD: xS,
  IS_IOS: cs,
  IOS_VERSION: HR,
  IS_ANDROID: lu,
  ANDROID_VERSION: Qv,
  IS_NATIVE_ANDROID: AS,
  IS_FIREFOX: wS,
  IS_EDGE: Zv,
  IS_CHROME: Eo,
  CHROME_VERSION: CS,
  IE_VERSION: em,
  IS_SAFARI: DS,
  IS_ANY_SAFARI: tm,
  IS_WINDOWS: kS,
  TOUCH_ENABLED: ld
});
function qR(e, r, i) {
  if (typeof r != "number" || r < 0 || r > i)
    throw new Error("Failed to execute '" + e + "' on 'TimeRanges': The index provided (" + r + ") is non-numeric or out of bounds (0-" + i + ").");
}
function m_(e, r, i, t) {
  return qR(e, t, i.length - 1), i[t][r];
}
function Bp(e) {
  return e === void 0 || e.length === 0 ? {
    length: 0,
    start: function() {
      throw new Error("This TimeRanges object is empty");
    },
    end: function() {
      throw new Error("This TimeRanges object is empty");
    }
  } : {
    length: e.length,
    start: m_.bind(null, "start", 0, e),
    end: m_.bind(null, "end", 1, e)
  };
}
function qu(e, r) {
  return Array.isArray(e) ? Bp(e) : e === void 0 || r === void 0 ? Bp() : Bp([[e, r]]);
}
function RS(e, r) {
  var i = 0, t, n;
  if (!r)
    return 0;
  (!e || !e.length) && (e = qu(0, 0));
  for (var a = 0; a < e.length; a++)
    t = e.start(a), n = e.end(a), n > r && (n = r), i += n - t;
  return i / r;
}
var Ug = {
  prefixed: !0
}, wf = [
  ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror", "fullscreen"],
  ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror", "-webkit-full-screen"],
  ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror", "-moz-full-screen"],
  ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError", "-ms-fullscreen"]
], y_ = wf[0], Wc;
for (var uf = 0; uf < wf.length; uf++)
  if (wf[uf][1] in Mt) {
    Wc = wf[uf];
    break;
  }
if (Wc) {
  for (var lf = 0; lf < Wc.length; lf++)
    Ug[y_[lf]] = Wc[lf];
  Ug.prefixed = Wc[0] !== y_[0];
}
function ea(e) {
  if (e instanceof ea)
    return e;
  typeof e == "number" ? this.code = e : typeof e == "string" ? this.message = e : tu(e) && (typeof e.code == "number" && (this.code = e.code), Ui(this, e)), this.message || (this.message = ea.defaultMessages[this.code] || "");
}
ea.prototype.code = 0;
ea.prototype.message = "";
ea.prototype.status = null;
ea.errorTypes = ["MEDIA_ERR_CUSTOM", "MEDIA_ERR_ABORTED", "MEDIA_ERR_NETWORK", "MEDIA_ERR_DECODE", "MEDIA_ERR_SRC_NOT_SUPPORTED", "MEDIA_ERR_ENCRYPTED"];
ea.defaultMessages = {
  1: "You aborted the media playback",
  2: "A network error caused the media download to fail part-way.",
  3: "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
  4: "The media could not be loaded, either because the server or network failed or because the format is not supported.",
  5: "The media is encrypted and we do not have the keys to decrypt it."
};
for (var Al = 0; Al < ea.errorTypes.length; Al++)
  ea[ea.errorTypes[Al]] = Al, ea.prototype[ea.errorTypes[Al]] = Al;
function Xc(e) {
  return e != null && typeof e.then == "function";
}
function Wo(e) {
  Xc(e) && e.then(null, function(r) {
  });
}
var Bg = function(r) {
  var i = ["kind", "label", "language", "id", "inBandMetadataTrackDispatchType", "mode", "src"].reduce(function(t, n, a) {
    return r[n] && (t[n] = r[n]), t;
  }, {
    cues: r.cues && Array.prototype.map.call(r.cues, function(t) {
      return {
        startTime: t.startTime,
        endTime: t.endTime,
        text: t.text,
        id: t.id
      };
    })
  });
  return i;
}, WR = function(r) {
  var i = r.$$("track"), t = Array.prototype.map.call(i, function(a) {
    return a.track;
  }), n = Array.prototype.map.call(i, function(a) {
    var s = Bg(a.track);
    return a.src && (s.src = a.src), s;
  });
  return n.concat(Array.prototype.filter.call(r.textTracks(), function(a) {
    return t.indexOf(a) === -1;
  }).map(Bg));
}, YR = function(r, i) {
  return r.forEach(function(t) {
    var n = i.addRemoteTextTrack(t).track;
    !t.src && t.cues && t.cues.forEach(function(a) {
      return n.addCue(a);
    });
  }), i.textTracks();
}, __ = {
  textTracksToJson: WR,
  jsonToTextTracks: YR,
  trackToJson_: Bg
}, jp = "vjs-modal-dialog", lc = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.opened_ = a.hasBeenOpened_ = a.hasBeenFilled_ = !1, a.closeable(!a.options_.uncloseable), a.content(a.options_.content), a.contentEl_ = Ji("div", {
      className: jp + "-content"
    }, {
      role: "document"
    }), a.descEl_ = Ji("p", {
      className: jp + "-description vjs-control-text",
      id: a.el().getAttribute("aria-describedby")
    }), oc(a.descEl_, a.description()), a.el_.appendChild(a.descEl_), a.el_.appendChild(a.contentEl_), a;
  }
  var i = r.prototype;
  return i.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: this.buildCSSClass(),
      tabIndex: -1
    }, {
      "aria-describedby": this.id() + "_description",
      "aria-hidden": "true",
      "aria-label": this.label(),
      role: "dialog"
    });
  }, i.dispose = function() {
    this.contentEl_ = null, this.descEl_ = null, this.previouslyActiveEl_ = null, e.prototype.dispose.call(this);
  }, i.buildCSSClass = function() {
    return jp + " vjs-hidden " + e.prototype.buildCSSClass.call(this);
  }, i.label = function() {
    return this.localize(this.options_.label || "Modal Window");
  }, i.description = function() {
    var n = this.options_.description || this.localize("This is a modal window.");
    return this.closeable() && (n += " " + this.localize("This modal can be closed by pressing the Escape key or activating the close button.")), n;
  }, i.open = function() {
    if (!this.opened_) {
      var n = this.player();
      this.trigger("beforemodalopen"), this.opened_ = !0, (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) && this.fill(), this.wasPlaying_ = !n.paused(), this.options_.pauseOnOpen && this.wasPlaying_ && n.pause(), this.on("keydown", this.handleKeyDown), this.hadControls_ = n.controls(), n.controls(!1), this.show(), this.conditionalFocus_(), this.el().setAttribute("aria-hidden", "false"), this.trigger("modalopen"), this.hasBeenOpened_ = !0;
    }
  }, i.opened = function(n) {
    return typeof n == "boolean" && this[n ? "open" : "close"](), this.opened_;
  }, i.close = function() {
    if (!!this.opened_) {
      var n = this.player();
      this.trigger("beforemodalclose"), this.opened_ = !1, this.wasPlaying_ && this.options_.pauseOnOpen && n.play(), this.off("keydown", this.handleKeyDown), this.hadControls_ && n.controls(!0), this.hide(), this.el().setAttribute("aria-hidden", "true"), this.trigger("modalclose"), this.conditionalBlur_(), this.options_.temporary && this.dispose();
    }
  }, i.closeable = function(n) {
    if (typeof n == "boolean") {
      var a = this.closeable_ = !!n, s = this.getChild("closeButton");
      if (a && !s) {
        var o = this.contentEl_;
        this.contentEl_ = this.el_, s = this.addChild("closeButton", {
          controlText: "Close Modal Dialog"
        }), this.contentEl_ = o, this.on(s, "close", this.close);
      }
      !a && s && (this.off(s, "close", this.close), this.removeChild(s), s.dispose());
    }
    return this.closeable_;
  }, i.fill = function() {
    this.fillWith(this.content());
  }, i.fillWith = function(n) {
    var a = this.contentEl(), s = a.parentNode, o = a.nextSibling;
    this.trigger("beforemodalfill"), this.hasBeenFilled_ = !0, s.removeChild(a), this.empty(), dS(a, n), this.trigger("modalfill"), o ? s.insertBefore(a, o) : s.appendChild(a);
    var l = this.getChild("closeButton");
    l && s.appendChild(l.el_);
  }, i.empty = function() {
    this.trigger("beforemodalempty"), qv(this.contentEl()), this.trigger("modalempty");
  }, i.content = function(n) {
    return typeof n < "u" && (this.content_ = n), this.content_;
  }, i.conditionalFocus_ = function() {
    var n = Mt.activeElement, a = this.player_.el_;
    this.previouslyActiveEl_ = null, (a.contains(n) || a === n) && (this.previouslyActiveEl_ = n, this.focus());
  }, i.conditionalBlur_ = function() {
    this.previouslyActiveEl_ && (this.previouslyActiveEl_.focus(), this.previouslyActiveEl_ = null);
  }, i.handleKeyDown = function(n) {
    if (n.stopPropagation(), Tr.isEventKey(n, "Escape") && this.closeable()) {
      n.preventDefault(), this.close();
      return;
    }
    if (!!Tr.isEventKey(n, "Tab")) {
      for (var a = this.focusableEls_(), s = this.el_.querySelector(":focus"), o, l = 0; l < a.length; l++)
        if (s === a[l]) {
          o = l;
          break;
        }
      Mt.activeElement === this.el_ && (o = 0), n.shiftKey && o === 0 ? (a[a.length - 1].focus(), n.preventDefault()) : !n.shiftKey && o === a.length - 1 && (a[0].focus(), n.preventDefault());
    }
  }, i.focusableEls_ = function() {
    var n = this.el_.querySelectorAll("*");
    return Array.prototype.filter.call(n, function(a) {
      return (a instanceof Be.HTMLAnchorElement || a instanceof Be.HTMLAreaElement) && a.hasAttribute("href") || (a instanceof Be.HTMLInputElement || a instanceof Be.HTMLSelectElement || a instanceof Be.HTMLTextAreaElement || a instanceof Be.HTMLButtonElement) && !a.hasAttribute("disabled") || a instanceof Be.HTMLIFrameElement || a instanceof Be.HTMLObjectElement || a instanceof Be.HTMLEmbedElement || a.hasAttribute("tabindex") && a.getAttribute("tabindex") !== -1 || a.hasAttribute("contenteditable");
    });
  }, r;
}(bt);
lc.prototype.options_ = {
  pauseOnOpen: !0,
  temporary: !0
};
bt.registerComponent("ModalDialog", lc);
var Xl = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t) {
    var n;
    t === void 0 && (t = []), n = e.call(this) || this, n.tracks_ = [], Object.defineProperty(Rr(n), "length", {
      get: function() {
        return this.tracks_.length;
      }
    });
    for (var a = 0; a < t.length; a++)
      n.addTrack(t[a]);
    return n;
  }
  var i = r.prototype;
  return i.addTrack = function(n) {
    var a = this.tracks_.length;
    "" + a in this || Object.defineProperty(this, a, {
      get: function() {
        return this.tracks_[a];
      }
    }), this.tracks_.indexOf(n) === -1 && (this.tracks_.push(n), this.trigger({
      track: n,
      type: "addtrack",
      target: this
    }));
  }, i.removeTrack = function(n) {
    for (var a, s = 0, o = this.length; s < o; s++)
      if (this[s] === n) {
        a = this[s], a.off && a.off(), this.tracks_.splice(s, 1);
        break;
      }
    !a || this.trigger({
      track: a,
      type: "removetrack",
      target: this
    });
  }, i.getTrackById = function(n) {
    for (var a = null, s = 0, o = this.length; s < o; s++) {
      var l = this[s];
      if (l.id === n) {
        a = l;
        break;
      }
    }
    return a;
  }, r;
}(vn);
Xl.prototype.allowedEvents_ = {
  change: "change",
  addtrack: "addtrack",
  removetrack: "removetrack"
};
for (var KR in Xl.prototype.allowedEvents_)
  Xl.prototype["on" + KR] = null;
var $p = function(r, i) {
  for (var t = 0; t < r.length; t++)
    !Object.keys(r[t]).length || i.id === r[t].id || (r[t].enabled = !1);
}, zR = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t) {
    var n;
    t === void 0 && (t = []);
    for (var a = t.length - 1; a >= 0; a--)
      if (t[a].enabled) {
        $p(t, t[a]);
        break;
      }
    return n = e.call(this, t) || this, n.changing_ = !1, n;
  }
  var i = r.prototype;
  return i.addTrack = function(n) {
    var a = this;
    n.enabled && $p(this, n), e.prototype.addTrack.call(this, n), n.addEventListener && (n.enabledChange_ = function() {
      a.changing_ || (a.changing_ = !0, $p(a, n), a.changing_ = !1, a.trigger("change"));
    }, n.addEventListener("enabledchange", n.enabledChange_));
  }, i.removeTrack = function(n) {
    e.prototype.removeTrack.call(this, n), n.removeEventListener && n.enabledChange_ && (n.removeEventListener("enabledchange", n.enabledChange_), n.enabledChange_ = null);
  }, r;
}(Xl), Gp = function(r, i) {
  for (var t = 0; t < r.length; t++)
    !Object.keys(r[t]).length || i.id === r[t].id || (r[t].selected = !1);
}, XR = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t) {
    var n;
    t === void 0 && (t = []);
    for (var a = t.length - 1; a >= 0; a--)
      if (t[a].selected) {
        Gp(t, t[a]);
        break;
      }
    return n = e.call(this, t) || this, n.changing_ = !1, Object.defineProperty(Rr(n), "selectedIndex", {
      get: function() {
        for (var o = 0; o < this.length; o++)
          if (this[o].selected)
            return o;
        return -1;
      },
      set: function() {
      }
    }), n;
  }
  var i = r.prototype;
  return i.addTrack = function(n) {
    var a = this;
    n.selected && Gp(this, n), e.prototype.addTrack.call(this, n), n.addEventListener && (n.selectedChange_ = function() {
      a.changing_ || (a.changing_ = !0, Gp(a, n), a.changing_ = !1, a.trigger("change"));
    }, n.addEventListener("selectedchange", n.selectedChange_));
  }, i.removeTrack = function(n) {
    e.prototype.removeTrack.call(this, n), n.removeEventListener && n.selectedChange_ && (n.removeEventListener("selectedchange", n.selectedChange_), n.selectedChange_ = null);
  }, r;
}(Xl), PS = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  var i = r.prototype;
  return i.addTrack = function(n) {
    var a = this;
    e.prototype.addTrack.call(this, n), this.queueChange_ || (this.queueChange_ = function() {
      return a.queueTrigger("change");
    }), this.triggerSelectedlanguagechange || (this.triggerSelectedlanguagechange_ = function() {
      return a.trigger("selectedlanguagechange");
    }), n.addEventListener("modechange", this.queueChange_);
    var s = ["metadata", "chapters"];
    s.indexOf(n.kind) === -1 && n.addEventListener("modechange", this.triggerSelectedlanguagechange_);
  }, i.removeTrack = function(n) {
    e.prototype.removeTrack.call(this, n), n.removeEventListener && (this.queueChange_ && n.removeEventListener("modechange", this.queueChange_), this.selectedlanguagechange_ && n.removeEventListener("modechange", this.triggerSelectedlanguagechange_));
  }, r;
}(Xl), JR = /* @__PURE__ */ function() {
  function e(i) {
    i === void 0 && (i = []), this.trackElements_ = [], Object.defineProperty(this, "length", {
      get: function() {
        return this.trackElements_.length;
      }
    });
    for (var t = 0, n = i.length; t < n; t++)
      this.addTrackElement_(i[t]);
  }
  var r = e.prototype;
  return r.addTrackElement_ = function(t) {
    var n = this.trackElements_.length;
    "" + n in this || Object.defineProperty(this, n, {
      get: function() {
        return this.trackElements_[n];
      }
    }), this.trackElements_.indexOf(t) === -1 && this.trackElements_.push(t);
  }, r.getTrackElementByTrack_ = function(t) {
    for (var n, a = 0, s = this.trackElements_.length; a < s; a++)
      if (t === this.trackElements_[a].track) {
        n = this.trackElements_[a];
        break;
      }
    return n;
  }, r.removeTrackElement_ = function(t) {
    for (var n = 0, a = this.trackElements_.length; n < a; n++)
      if (t === this.trackElements_[n]) {
        this.trackElements_[n].track && typeof this.trackElements_[n].track.off == "function" && this.trackElements_[n].track.off(), typeof this.trackElements_[n].off == "function" && this.trackElements_[n].off(), this.trackElements_.splice(n, 1);
        break;
      }
  }, e;
}(), b_ = /* @__PURE__ */ function() {
  function e(i) {
    e.prototype.setCues_.call(this, i), Object.defineProperty(this, "length", {
      get: function() {
        return this.length_;
      }
    });
  }
  var r = e.prototype;
  return r.setCues_ = function(t) {
    var n = this.length || 0, a = 0, s = t.length;
    this.cues_ = t, this.length_ = t.length;
    var o = function(u) {
      "" + u in this || Object.defineProperty(this, "" + u, {
        get: function() {
          return this.cues_[u];
        }
      });
    };
    if (n < s)
      for (a = n; a < s; a++)
        o.call(this, a);
  }, r.getCueById = function(t) {
    for (var n = null, a = 0, s = this.length; a < s; a++) {
      var o = this[a];
      if (o.id === t) {
        n = o;
        break;
      }
    }
    return n;
  }, e;
}(), QR = {
  alternative: "alternative",
  captions: "captions",
  main: "main",
  sign: "sign",
  subtitles: "subtitles",
  commentary: "commentary"
}, ZR = {
  alternative: "alternative",
  descriptions: "descriptions",
  main: "main",
  "main-desc": "main-desc",
  translation: "translation",
  commentary: "commentary"
}, e2 = {
  subtitles: "subtitles",
  captions: "captions",
  descriptions: "descriptions",
  chapters: "chapters",
  metadata: "metadata"
}, T_ = {
  disabled: "disabled",
  hidden: "hidden",
  showing: "showing"
}, rm = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(i) {
    var t;
    i === void 0 && (i = {}), t = e.call(this) || this;
    var n = {
      id: i.id || "vjs_track_" + uu(),
      kind: i.kind || "",
      label: i.label || "",
      language: i.language || ""
    }, a = function(l) {
      Object.defineProperty(Rr(t), l, {
        get: function() {
          return n[l];
        },
        set: function() {
        }
      });
    };
    for (var s in n)
      a(s);
    return t;
  }
  return r;
}(vn), im = function(r) {
  var i = ["protocol", "hostname", "port", "pathname", "search", "hash", "host"], t = Mt.createElement("a");
  t.href = r;
  var n = t.host === "" && t.protocol !== "file:", a;
  n && (a = Mt.createElement("div"), a.innerHTML = '<a href="' + r + '"></a>', t = a.firstChild, a.setAttribute("style", "display:none; position:absolute;"), Mt.body.appendChild(a));
  for (var s = {}, o = 0; o < i.length; o++)
    s[i[o]] = t[i[o]];
  return s.protocol === "http:" && (s.host = s.host.replace(/:80$/, "")), s.protocol === "https:" && (s.host = s.host.replace(/:443$/, "")), s.protocol || (s.protocol = Be.location.protocol), n && Mt.body.removeChild(a), s;
}, OS = function(r) {
  if (!r.match(/^https?:\/\//)) {
    var i = Mt.createElement("div");
    i.innerHTML = '<a href="' + r + '">x</a>', r = i.firstChild.href;
  }
  return r;
}, nm = function(r) {
  if (typeof r == "string") {
    var i = /^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/, t = i.exec(r);
    if (t)
      return t.pop().toLowerCase();
  }
  return "";
}, Bh = function(r) {
  var i = Be.location, t = im(r), n = t.protocol === ":" ? i.protocol : t.protocol, a = n + t.host !== i.protocol + i.host;
  return a;
}, t2 = /* @__PURE__ */ Object.freeze({
  parseUrl: im,
  getAbsoluteURL: OS,
  getFileExtension: nm,
  isCrossOrigin: Bh
}), S_ = function(r, i) {
  var t = new Be.WebVTT.Parser(Be, Be.vttjs, Be.WebVTT.StringDecoder()), n = [];
  t.oncue = function(a) {
    i.addCue(a);
  }, t.onparsingerror = function(a) {
    n.push(a);
  }, t.onflush = function() {
    i.trigger({
      type: "loadeddata",
      target: i
    });
  }, t.parse(r), n.length > 0 && (Be.console && Be.console.groupCollapsed && Be.console.groupCollapsed("Text Track parsing errors for " + i.src), n.forEach(function(a) {
    return qr.error(a);
  }), Be.console && Be.console.groupEnd && Be.console.groupEnd()), t.flush();
}, r2 = function(r, i) {
  var t = {
    uri: r
  }, n = Bh(r);
  n && (t.cors = n), jb(t, Mr(this, function(a, s, o) {
    if (a)
      return qr.error(a, s);
    i.loaded_ = !0, typeof Be.WebVTT != "function" ? i.tech_ && i.tech_.any(["vttjsloaded", "vttjserror"], function(l) {
      if (l.type === "vttjserror") {
        qr.error("vttjs failed to load, stopping trying to process " + i.src);
        return;
      }
      return S_(o, i);
    }) : S_(o, i);
  }));
}, Dd = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t) {
    var n;
    if (t === void 0 && (t = {}), !t.tech)
      throw new Error("A tech was not provided.");
    var a = Ti(t, {
      kind: e2[t.kind] || "subtitles",
      language: t.language || t.srclang || ""
    }), s = T_[a.mode] || "disabled", o = a.default;
    (a.kind === "metadata" || a.kind === "chapters") && (s = "hidden"), n = e.call(this, a) || this, n.tech_ = a.tech, n.cues_ = [], n.activeCues_ = [];
    var l = new b_(n.cues_), u = new b_(n.activeCues_), h = !1, c = Mr(Rr(n), function() {
      this.activeCues = this.activeCues, h && (this.trigger("cuechange"), h = !1);
    });
    return s !== "disabled" && n.tech_.ready(function() {
      n.tech_.on("timeupdate", c);
    }, !0), Object.defineProperties(Rr(n), {
      default: {
        get: function() {
          return o;
        },
        set: function() {
        }
      },
      mode: {
        get: function() {
          return s;
        },
        set: function(f) {
          var m = this;
          !T_[f] || (s = f, s !== "disabled" ? this.tech_.ready(function() {
            m.tech_.on("timeupdate", c);
          }, !0) : this.tech_.off("timeupdate", c), this.trigger("modechange"));
        }
      },
      cues: {
        get: function() {
          return this.loaded_ ? l : null;
        },
        set: function() {
        }
      },
      activeCues: {
        get: function() {
          if (!this.loaded_)
            return null;
          if (this.cues.length === 0)
            return u;
          for (var f = this.tech_.currentTime(), m = [], p = 0, b = this.cues.length; p < b; p++) {
            var y = this.cues[p];
            (y.startTime <= f && y.endTime >= f || y.startTime === y.endTime && y.startTime <= f && y.startTime + 0.5 >= f) && m.push(y);
          }
          if (h = !1, m.length !== this.activeCues_.length)
            h = !0;
          else
            for (var v = 0; v < m.length; v++)
              this.activeCues_.indexOf(m[v]) === -1 && (h = !0);
          return this.activeCues_ = m, u.setCues_(this.activeCues_), u;
        },
        set: function() {
        }
      }
    }), a.src ? (n.src = a.src, r2(a.src, Rr(n))) : n.loaded_ = !0, n;
  }
  var i = r.prototype;
  return i.addCue = function(n) {
    var a = n;
    if (Be.vttjs && !(n instanceof Be.vttjs.VTTCue)) {
      a = new Be.vttjs.VTTCue(n.startTime, n.endTime, n.text);
      for (var s in n)
        s in a || (a[s] = n[s]);
      a.id = n.id, a.originalCue_ = n;
    }
    for (var o = this.tech_.textTracks(), l = 0; l < o.length; l++)
      o[l] !== this && o[l].removeCue(a);
    this.cues_.push(a), this.cues.setCues_(this.cues_);
  }, i.removeCue = function(n) {
    for (var a = this.cues_.length; a--; ) {
      var s = this.cues_[a];
      if (s === n || s.originalCue_ && s.originalCue_ === n) {
        this.cues_.splice(a, 1), this.cues.setCues_(this.cues_);
        break;
      }
    }
  }, r;
}(rm);
Dd.prototype.allowedEvents_ = {
  cuechange: "cuechange"
};
var LS = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(i) {
    var t;
    i === void 0 && (i = {});
    var n = Ti(i, {
      kind: ZR[i.kind] || ""
    });
    t = e.call(this, n) || this;
    var a = !1;
    return Object.defineProperty(Rr(t), "enabled", {
      get: function() {
        return a;
      },
      set: function(o) {
        typeof o != "boolean" || o === a || (a = o, this.trigger("enabledchange"));
      }
    }), n.enabled && (t.enabled = n.enabled), t.loaded_ = !0, t;
  }
  return r;
}(rm), IS = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(i) {
    var t;
    i === void 0 && (i = {});
    var n = Ti(i, {
      kind: QR[i.kind] || ""
    });
    t = e.call(this, n) || this;
    var a = !1;
    return Object.defineProperty(Rr(t), "selected", {
      get: function() {
        return a;
      },
      set: function(o) {
        typeof o != "boolean" || o === a || (a = o, this.trigger("selectedchange"));
      }
    }), n.selected && (t.selected = n.selected), t;
  }
  return r;
}(rm), MS = 0, i2 = 1, NS = 2, n2 = 3, cc = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(i) {
    var t;
    i === void 0 && (i = {}), t = e.call(this) || this;
    var n, a = new Dd(i);
    return t.kind = a.kind, t.src = a.src, t.srclang = a.language, t.label = a.label, t.default = a.default, Object.defineProperties(Rr(t), {
      readyState: {
        get: function() {
          return n;
        }
      },
      track: {
        get: function() {
          return a;
        }
      }
    }), n = MS, a.addEventListener("loadeddata", function() {
      n = NS, t.trigger({
        type: "load",
        target: Rr(t)
      });
    }), t;
  }
  return r;
}(vn);
cc.prototype.allowedEvents_ = {
  load: "load"
};
cc.NONE = MS;
cc.LOADING = i2;
cc.LOADED = NS;
cc.ERROR = n2;
var qa = {
  audio: {
    ListClass: zR,
    TrackClass: LS,
    capitalName: "Audio"
  },
  video: {
    ListClass: XR,
    TrackClass: IS,
    capitalName: "Video"
  },
  text: {
    ListClass: PS,
    TrackClass: Dd,
    capitalName: "Text"
  }
};
Object.keys(qa).forEach(function(e) {
  qa[e].getterName = e + "Tracks", qa[e].privateName = e + "Tracks_";
});
var cd = {
  remoteText: {
    ListClass: PS,
    TrackClass: Dd,
    capitalName: "RemoteText",
    getterName: "remoteTextTracks",
    privateName: "remoteTextTracks_"
  },
  remoteTextEl: {
    ListClass: JR,
    TrackClass: cc,
    capitalName: "RemoteTextTrackEls",
    getterName: "remoteTextTrackEls",
    privateName: "remoteTextTrackEls_"
  }
}, Xn = Ti(qa, cd);
cd.names = Object.keys(cd);
qa.names = Object.keys(qa);
Xn.names = [].concat(cd.names).concat(qa.names);
function a2(e, r, i, t, n) {
  n === void 0 && (n = {});
  var a = e.textTracks();
  n.kind = r, i && (n.label = i), t && (n.language = t), n.tech = e;
  var s = new Xn.text.TrackClass(n);
  return a.addTrack(s), s;
}
var Ci = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return t === void 0 && (t = {}), n === void 0 && (n = function() {
    }), t.reportTouchActivity = !1, a = e.call(this, null, t, n) || this, a.hasStarted_ = !1, a.on("playing", function() {
      this.hasStarted_ = !0;
    }), a.on("loadstart", function() {
      this.hasStarted_ = !1;
    }), Xn.names.forEach(function(s) {
      var o = Xn[s];
      t && t[o.getterName] && (a[o.privateName] = t[o.getterName]);
    }), a.featuresProgressEvents || a.manualProgressOn(), a.featuresTimeupdateEvents || a.manualTimeUpdatesOn(), ["Text", "Audio", "Video"].forEach(function(s) {
      t["native" + s + "Tracks"] === !1 && (a["featuresNative" + s + "Tracks"] = !1);
    }), t.nativeCaptions === !1 || t.nativeTextTracks === !1 ? a.featuresNativeTextTracks = !1 : (t.nativeCaptions === !0 || t.nativeTextTracks === !0) && (a.featuresNativeTextTracks = !0), a.featuresNativeTextTracks || a.emulateTextTracks(), a.autoRemoteTextTracks_ = new Xn.text.ListClass(), a.initTrackListeners(), t.nativeControlsForTouch || a.emitTapEvents(), a.constructor && (a.name_ = a.constructor.name || "Unknown Tech"), a;
  }
  var i = r.prototype;
  return i.triggerSourceset = function(n) {
    var a = this;
    this.isReady_ || this.one("ready", function() {
      return a.setTimeout(function() {
        return a.triggerSourceset(n);
      }, 1);
    }), this.trigger({
      src: n,
      type: "sourceset"
    });
  }, i.manualProgressOn = function() {
    this.on("durationchange", this.onDurationChange), this.manualProgress = !0, this.one("ready", this.trackProgress);
  }, i.manualProgressOff = function() {
    this.manualProgress = !1, this.stopTrackingProgress(), this.off("durationchange", this.onDurationChange);
  }, i.trackProgress = function(n) {
    this.stopTrackingProgress(), this.progressInterval = this.setInterval(Mr(this, function() {
      var a = this.bufferedPercent();
      this.bufferedPercent_ !== a && this.trigger("progress"), this.bufferedPercent_ = a, a === 1 && this.stopTrackingProgress();
    }), 500);
  }, i.onDurationChange = function(n) {
    this.duration_ = this.duration();
  }, i.buffered = function() {
    return qu(0, 0);
  }, i.bufferedPercent = function() {
    return RS(this.buffered(), this.duration_);
  }, i.stopTrackingProgress = function() {
    this.clearInterval(this.progressInterval);
  }, i.manualTimeUpdatesOn = function() {
    this.manualTimeUpdates = !0, this.on("play", this.trackCurrentTime), this.on("pause", this.stopTrackingCurrentTime);
  }, i.manualTimeUpdatesOff = function() {
    this.manualTimeUpdates = !1, this.stopTrackingCurrentTime(), this.off("play", this.trackCurrentTime), this.off("pause", this.stopTrackingCurrentTime);
  }, i.trackCurrentTime = function() {
    this.currentTimeInterval && this.stopTrackingCurrentTime(), this.currentTimeInterval = this.setInterval(function() {
      this.trigger({
        type: "timeupdate",
        target: this,
        manuallyTriggered: !0
      });
    }, 250);
  }, i.stopTrackingCurrentTime = function() {
    this.clearInterval(this.currentTimeInterval), this.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    });
  }, i.dispose = function() {
    this.clearTracks(qa.names), this.manualProgress && this.manualProgressOff(), this.manualTimeUpdates && this.manualTimeUpdatesOff(), e.prototype.dispose.call(this);
  }, i.clearTracks = function(n) {
    var a = this;
    n = [].concat(n), n.forEach(function(s) {
      for (var o = a[s + "Tracks"]() || [], l = o.length; l--; ) {
        var u = o[l];
        s === "text" && a.removeRemoteTextTrack(u), o.removeTrack(u);
      }
    });
  }, i.cleanupAutoTextTracks = function() {
    for (var n = this.autoRemoteTextTracks_ || [], a = n.length; a--; ) {
      var s = n[a];
      this.removeRemoteTextTrack(s);
    }
  }, i.reset = function() {
  }, i.error = function(n) {
    return n !== void 0 && (this.error_ = new ea(n), this.trigger("error")), this.error_;
  }, i.played = function() {
    return this.hasStarted_ ? qu(0, 0) : qu();
  }, i.setCurrentTime = function() {
    this.manualTimeUpdates && this.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    });
  }, i.initTrackListeners = function() {
    var n = this;
    qa.names.forEach(function(a) {
      var s = qa[a], o = function() {
        n.trigger(a + "trackchange");
      }, l = n[s.getterName]();
      l.addEventListener("removetrack", o), l.addEventListener("addtrack", o), n.on("dispose", function() {
        l.removeEventListener("removetrack", o), l.removeEventListener("addtrack", o);
      });
    });
  }, i.addWebVttScript_ = function() {
    var n = this;
    if (!Be.WebVTT)
      if (Mt.body.contains(this.el())) {
        if (!this.options_["vtt.js"] && sd(Eg.exports) && Object.keys(Eg.exports).length > 0) {
          this.trigger("vttjsloaded");
          return;
        }
        var a = Mt.createElement("script");
        a.src = this.options_["vtt.js"] || "https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js", a.onload = function() {
          n.trigger("vttjsloaded");
        }, a.onerror = function() {
          n.trigger("vttjserror");
        }, this.on("dispose", function() {
          a.onload = null, a.onerror = null;
        }), Be.WebVTT = !0, this.el().parentNode.appendChild(a);
      } else
        this.ready(this.addWebVttScript_);
  }, i.emulateTextTracks = function() {
    var n = this, a = this.textTracks(), s = this.remoteTextTracks(), o = function(d) {
      return a.addTrack(d.track);
    }, l = function(d) {
      return a.removeTrack(d.track);
    };
    s.on("addtrack", o), s.on("removetrack", l), this.addWebVttScript_();
    var u = function() {
      return n.trigger("texttrackchange");
    }, h = function() {
      u();
      for (var d = 0; d < a.length; d++) {
        var f = a[d];
        f.removeEventListener("cuechange", u), f.mode === "showing" && f.addEventListener("cuechange", u);
      }
    };
    h(), a.addEventListener("change", h), a.addEventListener("addtrack", h), a.addEventListener("removetrack", h), this.on("dispose", function() {
      s.off("addtrack", o), s.off("removetrack", l), a.removeEventListener("change", h), a.removeEventListener("addtrack", h), a.removeEventListener("removetrack", h);
      for (var c = 0; c < a.length; c++) {
        var d = a[c];
        d.removeEventListener("cuechange", u);
      }
    });
  }, i.addTextTrack = function(n, a, s) {
    if (!n)
      throw new Error("TextTrack kind is required but was not provided");
    return a2(this, n, a, s);
  }, i.createRemoteTextTrack = function(n) {
    var a = Ti(n, {
      tech: this
    });
    return new cd.remoteTextEl.TrackClass(a);
  }, i.addRemoteTextTrack = function(n, a) {
    var s = this;
    n === void 0 && (n = {});
    var o = this.createRemoteTextTrack(n);
    return a !== !0 && a !== !1 && (qr.warn('Calling addRemoteTextTrack without explicitly setting the "manualCleanup" parameter to `true` is deprecated and default to `false` in future version of video.js'), a = !0), this.remoteTextTrackEls().addTrackElement_(o), this.remoteTextTracks().addTrack(o.track), a !== !0 && this.ready(function() {
      return s.autoRemoteTextTracks_.addTrack(o.track);
    }), o;
  }, i.removeRemoteTextTrack = function(n) {
    var a = this.remoteTextTrackEls().getTrackElementByTrack_(n);
    this.remoteTextTrackEls().removeTrackElement_(a), this.remoteTextTracks().removeTrack(n), this.autoRemoteTextTracks_.removeTrack(n);
  }, i.getVideoPlaybackQuality = function() {
    return {};
  }, i.requestPictureInPicture = function() {
    var n = this.options_.Promise || Be.Promise;
    if (n)
      return n.reject();
  }, i.setPoster = function() {
  }, i.playsinline = function() {
  }, i.setPlaysinline = function() {
  }, i.overrideNativeAudioTracks = function() {
  }, i.overrideNativeVideoTracks = function() {
  }, i.canPlayType = function() {
    return "";
  }, r.canPlayType = function() {
    return "";
  }, r.canPlaySource = function(n, a) {
    return r.canPlayType(n.type);
  }, r.isTech = function(n) {
    return n.prototype instanceof r || n instanceof r || n === r;
  }, r.registerTech = function(n, a) {
    if (r.techs_ || (r.techs_ = {}), !r.isTech(a))
      throw new Error("Tech " + n + " must be a Tech");
    if (!r.canPlayType)
      throw new Error("Techs must have a static canPlayType method on them");
    if (!r.canPlaySource)
      throw new Error("Techs must have a static canPlaySource method on them");
    return n = Wi(n), r.techs_[n] = a, r.techs_[xf(n)] = a, n !== "Tech" && r.defaultTechOrder_.push(n), a;
  }, r.getTech = function(n) {
    if (!!n) {
      if (r.techs_ && r.techs_[n])
        return r.techs_[n];
      if (n = Wi(n), Be && Be.videojs && Be.videojs[n])
        return qr.warn("The " + n + " tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)"), Be.videojs[n];
    }
  }, r;
}(bt);
Xn.names.forEach(function(e) {
  var r = Xn[e];
  Ci.prototype[r.getterName] = function() {
    return this[r.privateName] = this[r.privateName] || new r.ListClass(), this[r.privateName];
  };
});
Ci.prototype.featuresVolumeControl = !0;
Ci.prototype.featuresMuteControl = !0;
Ci.prototype.featuresFullscreenResize = !1;
Ci.prototype.featuresPlaybackRate = !1;
Ci.prototype.featuresProgressEvents = !1;
Ci.prototype.featuresSourceset = !1;
Ci.prototype.featuresTimeupdateEvents = !1;
Ci.prototype.featuresNativeTextTracks = !1;
Ci.withSourceHandlers = function(e) {
  e.registerSourceHandler = function(i, t) {
    var n = e.sourceHandlers;
    n || (n = e.sourceHandlers = []), t === void 0 && (t = n.length), n.splice(t, 0, i);
  }, e.canPlayType = function(i) {
    for (var t = e.sourceHandlers || [], n, a = 0; a < t.length; a++)
      if (n = t[a].canPlayType(i), n)
        return n;
    return "";
  }, e.selectSourceHandler = function(i, t) {
    for (var n = e.sourceHandlers || [], a, s = 0; s < n.length; s++)
      if (a = n[s].canHandleSource(i, t), a)
        return n[s];
    return null;
  }, e.canPlaySource = function(i, t) {
    var n = e.selectSourceHandler(i, t);
    return n ? n.canHandleSource(i, t) : "";
  };
  var r = ["seekable", "seeking", "duration"];
  r.forEach(function(i) {
    var t = this[i];
    typeof t == "function" && (this[i] = function() {
      return this.sourceHandler_ && this.sourceHandler_[i] ? this.sourceHandler_[i].apply(this.sourceHandler_, arguments) : t.apply(this, arguments);
    });
  }, e.prototype), e.prototype.setSource = function(i) {
    var t = e.selectSourceHandler(i, this.options_);
    t || (e.nativeSourceHandler ? t = e.nativeSourceHandler : qr.error("No source handler found for the current source.")), this.disposeSourceHandler(), this.off("dispose", this.disposeSourceHandler), t !== e.nativeSourceHandler && (this.currentSource_ = i), this.sourceHandler_ = t.handleSource(i, this, this.options_), this.one("dispose", this.disposeSourceHandler);
  }, e.prototype.disposeSourceHandler = function() {
    this.currentSource_ && (this.clearTracks(["audio", "video"]), this.currentSource_ = null), this.cleanupAutoTextTracks(), this.sourceHandler_ && (this.sourceHandler_.dispose && this.sourceHandler_.dispose(), this.sourceHandler_ = null);
  };
};
bt.registerComponent("Tech", Ci);
Ci.registerTech("Tech", Ci);
Ci.defaultTechOrder_ = [];
var Wu = {}, jg = {}, Yf = {};
function s2(e, r) {
  Wu[e] = Wu[e] || [], Wu[e].push(r);
}
function o2(e, r, i) {
  e.setTimeout(function() {
    return Lu(r, Wu[r.type], i, e);
  }, 1);
}
function u2(e, r) {
  e.forEach(function(i) {
    return i.setTech && i.setTech(r);
  });
}
function l2(e, r, i) {
  return e.reduceRight(am(i), r[i]());
}
function c2(e, r, i, t) {
  return r[i](e.reduce(am(i), t));
}
function E_(e, r, i, t) {
  t === void 0 && (t = null);
  var n = "call" + Wi(i), a = e.reduce(am(n), t), s = a === Yf, o = s ? null : r[i](a);
  return h2(e, i, o, s), o;
}
var d2 = {
  buffered: 1,
  currentTime: 1,
  duration: 1,
  seekable: 1,
  played: 1,
  paused: 1,
  volume: 1
}, f2 = {
  setCurrentTime: 1,
  setVolume: 1
}, x_ = {
  play: 1,
  pause: 1
};
function am(e) {
  return function(r, i) {
    return r === Yf ? Yf : i[e] ? i[e](r) : r;
  };
}
function h2(e, r, i, t) {
  for (var n = e.length - 1; n >= 0; n--) {
    var a = e[n];
    a[r] && a[r](t, i);
  }
}
function p2(e) {
  jg[e.id()] = null;
}
function g2(e, r) {
  var i = jg[e.id()], t = null;
  if (i == null)
    return t = r(e), jg[e.id()] = [[r, t]], t;
  for (var n = 0; n < i.length; n++) {
    var a = i[n], s = a[0], o = a[1];
    s === r && (t = o);
  }
  return t === null && (t = r(e), i.push([r, t])), t;
}
function Lu(e, r, i, t, n, a) {
  e === void 0 && (e = {}), r === void 0 && (r = []), n === void 0 && (n = []), a === void 0 && (a = !1);
  var s = r, o = s[0], l = s.slice(1);
  if (typeof o == "string")
    Lu(e, Wu[o], i, t, n, a);
  else if (o) {
    var u = g2(t, o);
    if (!u.setSource)
      return n.push(u), Lu(e, l, i, t, n, a);
    u.setSource(Ui({}, e), function(h, c) {
      if (h)
        return Lu(e, l, i, t, n, a);
      n.push(u), Lu(c, e.type === c.type ? l : Wu[c.type], i, t, n, a);
    });
  } else
    l.length ? Lu(e, l, i, t, n, a) : a ? i(e, n) : Lu(e, Wu["*"], i, t, n, !0);
}
var v2 = {
  opus: "video/ogg",
  ogv: "video/ogg",
  mp4: "video/mp4",
  mov: "video/mp4",
  m4v: "video/mp4",
  mkv: "video/x-matroska",
  m4a: "audio/mp4",
  mp3: "audio/mpeg",
  aac: "audio/aac",
  oga: "audio/ogg",
  m3u8: "application/x-mpegURL",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  png: "image/png",
  svg: "image/svg+xml",
  webp: "image/webp"
}, Kf = function(r) {
  r === void 0 && (r = "");
  var i = nm(r), t = v2[i.toLowerCase()];
  return t || "";
}, m2 = function(r, i) {
  if (!i)
    return "";
  if (r.cache_.source.src === i && r.cache_.source.type)
    return r.cache_.source.type;
  var t = r.cache_.sources.filter(function(o) {
    return o.src === i;
  });
  if (t.length)
    return t[0].type;
  for (var n = r.$$("source"), a = 0; a < n.length; a++) {
    var s = n[a];
    if (s.type && s.src && s.src === i)
      return s.type;
  }
  return Kf(i);
}, y2 = function e(r) {
  if (Array.isArray(r)) {
    var i = [];
    r.forEach(function(t) {
      t = e(t), Array.isArray(t) ? i = i.concat(t) : tu(t) && i.push(t);
    }), r = i;
  } else
    typeof r == "string" && r.trim() ? r = [A_({
      src: r
    })] : tu(r) && typeof r.src == "string" && r.src && r.src.trim() ? r = [A_(r)] : r = [];
  return r;
};
function A_(e) {
  if (!e.type) {
    var r = Kf(e.src);
    r && (e.type = r);
  }
  return e;
}
var _2 = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(i, t, n) {
    var a, s = Ti({
      createEl: !1
    }, t);
    if (a = e.call(this, i, s, n) || this, !t.playerOptions.sources || t.playerOptions.sources.length === 0)
      for (var o = 0, l = t.playerOptions.techOrder; o < l.length; o++) {
        var u = Wi(l[o]), h = Ci.getTech(u);
        if (u || (h = bt.getComponent(u)), h && h.isSupported()) {
          i.loadTech_(u);
          break;
        }
      }
    else
      i.src(t.playerOptions.sources);
    return a;
  }
  return r;
}(bt);
bt.registerComponent("MediaLoader", _2);
var jh = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.emitTapEvents(), a.enable(), a;
  }
  var i = r.prototype;
  return i.createEl = function(n, a, s) {
    n === void 0 && (n = "div"), a === void 0 && (a = {}), s === void 0 && (s = {}), a = Ui({
      innerHTML: '<span aria-hidden="true" class="vjs-icon-placeholder"></span>',
      className: this.buildCSSClass(),
      tabIndex: 0
    }, a), n === "button" && qr.error("Creating a ClickableComponent with an HTML element of " + n + " is not supported; use a Button instead."), s = Ui({
      role: "button"
    }, s), this.tabIndex_ = a.tabIndex;
    var o = e.prototype.createEl.call(this, n, a, s);
    return this.createControlTextEl(o), o;
  }, i.dispose = function() {
    this.controlTextEl_ = null, e.prototype.dispose.call(this);
  }, i.createControlTextEl = function(n) {
    return this.controlTextEl_ = Ji("span", {
      className: "vjs-control-text"
    }, {
      "aria-live": "polite"
    }), n && n.appendChild(this.controlTextEl_), this.controlText(this.controlText_, n), this.controlTextEl_;
  }, i.controlText = function(n, a) {
    if (a === void 0 && (a = this.el()), n === void 0)
      return this.controlText_ || "Need Text";
    var s = this.localize(n);
    this.controlText_ = n, oc(this.controlTextEl_, s), this.nonIconControl || a.setAttribute("title", s);
  }, i.buildCSSClass = function() {
    return "vjs-control vjs-button " + e.prototype.buildCSSClass.call(this);
  }, i.enable = function() {
    this.enabled_ || (this.enabled_ = !0, this.removeClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "false"), typeof this.tabIndex_ < "u" && this.el_.setAttribute("tabIndex", this.tabIndex_), this.on(["tap", "click"], this.handleClick), this.on("keydown", this.handleKeyDown));
  }, i.disable = function() {
    this.enabled_ = !1, this.addClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "true"), typeof this.tabIndex_ < "u" && this.el_.removeAttribute("tabIndex"), this.off("mouseover", this.handleMouseOver), this.off("mouseout", this.handleMouseOut), this.off(["tap", "click"], this.handleClick), this.off("keydown", this.handleKeyDown);
  }, i.handleClick = function(n) {
  }, i.handleKeyDown = function(n) {
    Tr.isEventKey(n, "Space") || Tr.isEventKey(n, "Enter") ? (n.preventDefault(), n.stopPropagation(), this.trigger("click")) : e.prototype.handleKeyDown.call(this, n);
  }, r;
}(bt);
bt.registerComponent("ClickableComponent", jh);
var b2 = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.update(), t.on("posterchange", Mr(Rr(a), a.update)), a;
  }
  var i = r.prototype;
  return i.dispose = function() {
    this.player().off("posterchange", this.update), e.prototype.dispose.call(this);
  }, i.createEl = function() {
    var n = Ji("div", {
      className: "vjs-poster",
      tabIndex: -1
    });
    return n;
  }, i.update = function(n) {
    var a = this.player().poster();
    this.setSrc(a), a ? this.show() : this.hide();
  }, i.setSrc = function(n) {
    var a = "";
    n && (a = 'url("' + n + '")'), this.el_.style.backgroundImage = a;
  }, i.handleClick = function(n) {
    !this.player_.controls() || (this.player_.tech(!0) && this.player_.tech(!0).focus(), this.player_.paused() ? Wo(this.player_.play()) : this.player_.pause());
  }, r;
}(jh);
bt.registerComponent("PosterImage", b2);
var Ba = "#222", w_ = "#ccc", T2 = {
  monospace: "monospace",
  sansSerif: "sans-serif",
  serif: "serif",
  monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
  monospaceSerif: '"Courier New", monospace',
  proportionalSansSerif: "sans-serif",
  proportionalSerif: "serif",
  casual: '"Comic Sans MS", Impact, fantasy',
  script: '"Monotype Corsiva", cursive',
  smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
};
function Hp(e, r) {
  var i;
  if (e.length === 4)
    i = e[1] + e[1] + e[2] + e[2] + e[3] + e[3];
  else if (e.length === 7)
    i = e.slice(1);
  else
    throw new Error("Invalid color code provided, " + e + "; must be formatted as e.g. #f0e or #f604e2.");
  return "rgba(" + parseInt(i.slice(0, 2), 16) + "," + parseInt(i.slice(2, 4), 16) + "," + parseInt(i.slice(4, 6), 16) + "," + r + ")";
}
function Vp(e, r, i) {
  try {
    e.style[r] = i;
  } catch {
    return;
  }
}
var S2 = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n, a) {
    var s;
    s = e.call(this, t, n, a) || this;
    var o = Mr(Rr(s), s.updateDisplay);
    return t.on("loadstart", Mr(Rr(s), s.toggleDisplay)), t.on("texttrackchange", o), t.on("loadedmetadata", Mr(Rr(s), s.preselectTrack)), t.ready(Mr(Rr(s), function() {
      if (t.tech_ && t.tech_.featuresNativeTextTracks) {
        this.hide();
        return;
      }
      t.on("fullscreenchange", o), t.on("playerresize", o), Be.addEventListener("orientationchange", o), t.on("dispose", function() {
        return Be.removeEventListener("orientationchange", o);
      });
      for (var l = this.options_.playerOptions.tracks || [], u = 0; u < l.length; u++)
        this.player_.addRemoteTextTrack(l[u], !0);
      this.preselectTrack();
    })), s;
  }
  var i = r.prototype;
  return i.preselectTrack = function() {
    for (var n = {
      captions: 1,
      subtitles: 1
    }, a = this.player_.textTracks(), s = this.player_.cache_.selectedLanguage, o, l, u, h = 0; h < a.length; h++) {
      var c = a[h];
      s && s.enabled && s.language && s.language === c.language && c.kind in n ? c.kind === s.kind ? u = c : u || (u = c) : s && !s.enabled ? (u = null, o = null, l = null) : c.default && (c.kind === "descriptions" && !o ? o = c : c.kind in n && !l && (l = c));
    }
    u ? u.mode = "showing" : l ? l.mode = "showing" : o && (o.mode = "showing");
  }, i.toggleDisplay = function() {
    this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks ? this.hide() : this.show();
  }, i.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-text-track-display"
    }, {
      "aria-live": "off",
      "aria-atomic": "true"
    });
  }, i.clearDisplay = function() {
    typeof Be.WebVTT == "function" && Be.WebVTT.processCues(Be, [], this.el_);
  }, i.updateDisplay = function() {
    var n = this.player_.textTracks(), a = this.options_.allowMultipleShowingTracks;
    if (this.clearDisplay(), a) {
      for (var s = [], o = 0; o < n.length; ++o) {
        var l = n[o];
        l.mode === "showing" && s.push(l);
      }
      this.updateForTrack(s);
      return;
    }
    for (var u = null, h = null, c = n.length; c--; ) {
      var d = n[c];
      d.mode === "showing" && (d.kind === "descriptions" ? u = d : h = d);
    }
    h ? (this.getAttribute("aria-live") !== "off" && this.setAttribute("aria-live", "off"), this.updateForTrack(h)) : u && (this.getAttribute("aria-live") !== "assertive" && this.setAttribute("aria-live", "assertive"), this.updateForTrack(u));
  }, i.updateDisplayState = function(n) {
    for (var a = this.player_.textTrackSettings.getValues(), s = n.activeCues, o = s.length; o--; ) {
      var l = s[o];
      if (!!l) {
        var u = l.displayState;
        if (a.color && (u.firstChild.style.color = a.color), a.textOpacity && Vp(u.firstChild, "color", Hp(a.color || "#fff", a.textOpacity)), a.backgroundColor && (u.firstChild.style.backgroundColor = a.backgroundColor), a.backgroundOpacity && Vp(u.firstChild, "backgroundColor", Hp(a.backgroundColor || "#000", a.backgroundOpacity)), a.windowColor && (a.windowOpacity ? Vp(u, "backgroundColor", Hp(a.windowColor, a.windowOpacity)) : u.style.backgroundColor = a.windowColor), a.edgeStyle && (a.edgeStyle === "dropshadow" ? u.firstChild.style.textShadow = "2px 2px 3px " + Ba + ", 2px 2px 4px " + Ba + ", 2px 2px 5px " + Ba : a.edgeStyle === "raised" ? u.firstChild.style.textShadow = "1px 1px " + Ba + ", 2px 2px " + Ba + ", 3px 3px " + Ba : a.edgeStyle === "depressed" ? u.firstChild.style.textShadow = "1px 1px " + w_ + ", 0 1px " + w_ + ", -1px -1px " + Ba + ", 0 -1px " + Ba : a.edgeStyle === "uniform" && (u.firstChild.style.textShadow = "0 0 4px " + Ba + ", 0 0 4px " + Ba + ", 0 0 4px " + Ba + ", 0 0 4px " + Ba)), a.fontPercent && a.fontPercent !== 1) {
          var h = Be.parseFloat(u.style.fontSize);
          u.style.fontSize = h * a.fontPercent + "px", u.style.height = "auto", u.style.top = "auto", u.style.bottom = "2px";
        }
        a.fontFamily && a.fontFamily !== "default" && (a.fontFamily === "small-caps" ? u.firstChild.style.fontVariant = "small-caps" : u.firstChild.style.fontFamily = T2[a.fontFamily]);
      }
    }
  }, i.updateForTrack = function(n) {
    if (Array.isArray(n) || (n = [n]), !(typeof Be.WebVTT != "function" || n.every(function(f) {
      return !f.activeCues;
    }))) {
      for (var a = [], s = 0; s < n.length; ++s)
        for (var o = n[s], l = 0; l < o.activeCues.length; ++l)
          a.push(o.activeCues[l]);
      Be.WebVTT.processCues(Be, a, this.el_);
      for (var u = 0; u < n.length; ++u) {
        for (var h = n[u], c = 0; c < h.activeCues.length; ++c) {
          var d = h.activeCues[c].displayState;
          lo(d, "vjs-text-track-cue"), lo(d, "vjs-text-track-cue-" + (h.language ? h.language : u));
        }
        this.player_.textTrackSettings && this.updateDisplayState(h);
      }
    }
  }, r;
}(bt);
bt.registerComponent("TextTrackDisplay", S2);
var E2 = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  var i = r.prototype;
  return i.createEl = function() {
    var n = this.player_.isAudio(), a = this.localize(n ? "Audio Player" : "Video Player"), s = Ji("span", {
      className: "vjs-control-text",
      innerHTML: this.localize("{1} is loading.", [a])
    }), o = e.prototype.createEl.call(this, "div", {
      className: "vjs-loading-spinner",
      dir: "ltr"
    });
    return o.appendChild(s), o;
  }, r;
}(bt);
bt.registerComponent("LoadingSpinner", E2);
var ds = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  var i = r.prototype;
  return i.createEl = function(n, a, s) {
    a === void 0 && (a = {}), s === void 0 && (s = {}), n = "button", a = Ui({
      innerHTML: '<span aria-hidden="true" class="vjs-icon-placeholder"></span>',
      className: this.buildCSSClass()
    }, a), s = Ui({
      type: "button"
    }, s);
    var o = bt.prototype.createEl.call(this, n, a, s);
    return this.createControlTextEl(o), o;
  }, i.addChild = function(n, a) {
    a === void 0 && (a = {});
    var s = this.constructor.name;
    return qr.warn("Adding an actionable (user controllable) child to a Button (" + s + ") is not supported; use a ClickableComponent instead."), bt.prototype.addChild.call(this, n, a);
  }, i.enable = function() {
    e.prototype.enable.call(this), this.el_.removeAttribute("disabled");
  }, i.disable = function() {
    e.prototype.disable.call(this), this.el_.setAttribute("disabled", "disabled");
  }, i.handleKeyDown = function(n) {
    if (Tr.isEventKey(n, "Space") || Tr.isEventKey(n, "Enter")) {
      n.stopPropagation();
      return;
    }
    e.prototype.handleKeyDown.call(this, n);
  }, r;
}(jh);
bt.registerComponent("Button", ds);
var FS = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.mouseused_ = !1, a.on("mousedown", a.handleMouseDown), a;
  }
  var i = r.prototype;
  return i.buildCSSClass = function() {
    return "vjs-big-play-button";
  }, i.handleClick = function(n) {
    var a = this.player_.play();
    if (this.mouseused_ && n.clientX && n.clientY) {
      Wo(a), this.player_.tech(!0) && this.player_.tech(!0).focus();
      return;
    }
    var s = this.player_.getChild("controlBar"), o = s && s.getChild("playToggle");
    if (!o) {
      this.player_.tech(!0).focus();
      return;
    }
    var l = function() {
      return o.focus();
    };
    Xc(a) ? a.then(l, function() {
    }) : this.setTimeout(l, 1);
  }, i.handleKeyDown = function(n) {
    this.mouseused_ = !1, e.prototype.handleKeyDown.call(this, n);
  }, i.handleMouseDown = function(n) {
    this.mouseused_ = !0;
  }, r;
}(ds);
FS.prototype.controlText_ = "Play Video";
bt.registerComponent("BigPlayButton", FS);
var x2 = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.controlText(n && n.controlText || a.localize("Close")), a;
  }
  var i = r.prototype;
  return i.buildCSSClass = function() {
    return "vjs-close-button " + e.prototype.buildCSSClass.call(this);
  }, i.handleClick = function(n) {
    this.trigger({
      type: "close",
      bubbles: !1
    });
  }, i.handleKeyDown = function(n) {
    Tr.isEventKey(n, "Esc") ? (n.preventDefault(), n.stopPropagation(), this.trigger("click")) : e.prototype.handleKeyDown.call(this, n);
  }, r;
}(ds);
bt.registerComponent("CloseButton", x2);
var US = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return n === void 0 && (n = {}), a = e.call(this, t, n) || this, n.replay = n.replay === void 0 || n.replay, a.on(t, "play", a.handlePlay), a.on(t, "pause", a.handlePause), n.replay && a.on(t, "ended", a.handleEnded), a;
  }
  var i = r.prototype;
  return i.buildCSSClass = function() {
    return "vjs-play-control " + e.prototype.buildCSSClass.call(this);
  }, i.handleClick = function(n) {
    this.player_.paused() ? this.player_.play() : this.player_.pause();
  }, i.handleSeeked = function(n) {
    this.removeClass("vjs-ended"), this.player_.paused() ? this.handlePause(n) : this.handlePlay(n);
  }, i.handlePlay = function(n) {
    this.removeClass("vjs-ended"), this.removeClass("vjs-paused"), this.addClass("vjs-playing"), this.controlText("Pause");
  }, i.handlePause = function(n) {
    this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.controlText("Play");
  }, i.handleEnded = function(n) {
    this.removeClass("vjs-playing"), this.addClass("vjs-ended"), this.controlText("Replay"), this.one(this.player_, "seeked", this.handleSeeked);
  }, r;
}(ds);
US.prototype.controlText_ = "Play";
bt.registerComponent("PlayToggle", US);
var BS = function(r, i) {
  r = r < 0 ? 0 : r;
  var t = Math.floor(r % 60), n = Math.floor(r / 60 % 60), a = Math.floor(r / 3600), s = Math.floor(i / 60 % 60), o = Math.floor(i / 3600);
  return (isNaN(r) || r === 1 / 0) && (a = n = t = "-"), a = a > 0 || o > 0 ? a + ":" : "", n = ((a || s >= 10) && n < 10 ? "0" + n : n) + ":", t = t < 10 ? "0" + t : t, a + n + t;
}, sm = BS;
function A2(e) {
  sm = e;
}
function w2() {
  sm = BS;
}
function Jl(e, r) {
  return r === void 0 && (r = e), sm(e, r);
}
var dc = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.throttledUpdateContent = iu(Mr(Rr(a), a.updateContent), Qu), a.on(t, "timeupdate", a.throttledUpdateContent), a;
  }
  var i = r.prototype;
  return i.createEl = function() {
    var n = this.buildCSSClass(), a = e.prototype.createEl.call(this, "div", {
      className: n + " vjs-time-control vjs-control",
      innerHTML: '<span class="vjs-control-text" role="presentation">' + this.localize(this.labelText_) + "\xA0</span>"
    });
    return this.contentEl_ = Ji("span", {
      className: n + "-display"
    }, {
      "aria-live": "off",
      role: "presentation"
    }), this.updateTextNode_(), a.appendChild(this.contentEl_), a;
  }, i.dispose = function() {
    this.contentEl_ = null, this.textNode_ = null, e.prototype.dispose.call(this);
  }, i.updateTextNode_ = function() {
    if (!!this.contentEl_) {
      for (; this.contentEl_.firstChild; )
        this.contentEl_.removeChild(this.contentEl_.firstChild);
      this.textNode_ = Mt.createTextNode(this.formattedTime_ || this.formatTime_(0)), this.contentEl_.appendChild(this.textNode_);
    }
  }, i.formatTime_ = function(n) {
    return Jl(n);
  }, i.updateFormattedTime_ = function(n) {
    var a = this.formatTime_(n);
    a !== this.formattedTime_ && (this.formattedTime_ = a, this.requestAnimationFrame(this.updateTextNode_));
  }, i.updateContent = function(n) {
  }, r;
}(bt);
dc.prototype.labelText_ = "Time";
dc.prototype.controlText_ = "Time";
bt.registerComponent("TimeDisplay", dc);
var om = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.on(t, "ended", a.handleEnded), a;
  }
  var i = r.prototype;
  return i.buildCSSClass = function() {
    return "vjs-current-time";
  }, i.updateContent = function(n) {
    var a = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
    this.updateFormattedTime_(a);
  }, i.handleEnded = function(n) {
    !this.player_.duration() || this.updateFormattedTime_(this.player_.duration());
  }, r;
}(dc);
om.prototype.labelText_ = "Current Time";
om.prototype.controlText_ = "Current Time";
bt.registerComponent("CurrentTimeDisplay", om);
var um = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.on(t, "durationchange", a.updateContent), a.on(t, "loadstart", a.updateContent), a.on(t, "loadedmetadata", a.throttledUpdateContent), a;
  }
  var i = r.prototype;
  return i.buildCSSClass = function() {
    return "vjs-duration";
  }, i.updateContent = function(n) {
    var a = this.player_.duration();
    this.duration_ !== a && (this.duration_ = a, this.updateFormattedTime_(a));
  }, r;
}(dc);
um.prototype.labelText_ = "Duration";
um.prototype.controlText_ = "Duration";
bt.registerComponent("DurationDisplay", um);
var C2 = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  var i = r.prototype;
  return i.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-time-control vjs-time-divider",
      innerHTML: "<div><span>/</span></div>"
    }, {
      "aria-hidden": !0
    });
  }, r;
}(bt);
bt.registerComponent("TimeDivider", C2);
var lm = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.on(t, "durationchange", a.throttledUpdateContent), a.on(t, "ended", a.handleEnded), a;
  }
  var i = r.prototype;
  return i.buildCSSClass = function() {
    return "vjs-remaining-time";
  }, i.createEl = function() {
    var n = e.prototype.createEl.call(this);
    return n.insertBefore(Ji("span", {}, {
      "aria-hidden": !0
    }, "-"), this.contentEl_), n;
  }, i.updateContent = function(n) {
    typeof this.player_.duration() == "number" && (this.player_.remainingTimeDisplay ? this.updateFormattedTime_(this.player_.remainingTimeDisplay()) : this.updateFormattedTime_(this.player_.remainingTime()));
  }, i.handleEnded = function(n) {
    !this.player_.duration() || this.updateFormattedTime_(0);
  }, r;
}(dc);
lm.prototype.labelText_ = "Remaining Time";
lm.prototype.controlText_ = "Remaining Time";
bt.registerComponent("RemainingTimeDisplay", lm);
var D2 = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.updateShowing(), a.on(a.player(), "durationchange", a.updateShowing), a;
  }
  var i = r.prototype;
  return i.createEl = function() {
    var n = e.prototype.createEl.call(this, "div", {
      className: "vjs-live-control vjs-control"
    });
    return this.contentEl_ = Ji("div", {
      className: "vjs-live-display",
      innerHTML: '<span class="vjs-control-text">' + this.localize("Stream Type") + "\xA0</span>" + this.localize("LIVE")
    }, {
      "aria-live": "off"
    }), n.appendChild(this.contentEl_), n;
  }, i.dispose = function() {
    this.contentEl_ = null, e.prototype.dispose.call(this);
  }, i.updateShowing = function(n) {
    this.player().duration() === 1 / 0 ? this.show() : this.hide();
  }, r;
}(bt);
bt.registerComponent("LiveDisplay", D2);
var jS = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.updateLiveEdgeStatus(), a.player_.liveTracker && a.on(a.player_.liveTracker, "liveedgechange", a.updateLiveEdgeStatus), a;
  }
  var i = r.prototype;
  return i.createEl = function() {
    var n = e.prototype.createEl.call(this, "button", {
      className: "vjs-seek-to-live-control vjs-control"
    });
    return this.textEl_ = Ji("span", {
      className: "vjs-seek-to-live-text",
      innerHTML: this.localize("LIVE")
    }, {
      "aria-hidden": "true"
    }), n.appendChild(this.textEl_), n;
  }, i.updateLiveEdgeStatus = function(n) {
    !this.player_.liveTracker || this.player_.liveTracker.atLiveEdge() ? (this.setAttribute("aria-disabled", !0), this.addClass("vjs-at-live-edge"), this.controlText("Seek to live, currently playing live")) : (this.setAttribute("aria-disabled", !1), this.removeClass("vjs-at-live-edge"), this.controlText("Seek to live, currently behind live"));
  }, i.handleClick = function() {
    this.player_.liveTracker.seekToLiveEdge();
  }, i.dispose = function() {
    this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatus), this.textEl_ = null, e.prototype.dispose.call(this);
  }, r;
}(ds);
jS.prototype.controlText_ = "Seek to live, currently playing live";
bt.registerComponent("SeekToLive", jS);
var cm = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.bar = a.getChild(a.options_.barName), a.vertical(!!a.options_.vertical), a.enable(), a;
  }
  var i = r.prototype;
  return i.enabled = function() {
    return this.enabled_;
  }, i.enable = function() {
    this.enabled() || (this.on("mousedown", this.handleMouseDown), this.on("touchstart", this.handleMouseDown), this.on("keydown", this.handleKeyDown), this.on("click", this.handleClick), this.on(this.player_, "controlsvisible", this.update), this.playerEvent && this.on(this.player_, this.playerEvent, this.update), this.removeClass("disabled"), this.setAttribute("tabindex", 0), this.enabled_ = !0);
  }, i.disable = function() {
    if (!!this.enabled()) {
      var n = this.bar.el_.ownerDocument;
      this.off("mousedown", this.handleMouseDown), this.off("touchstart", this.handleMouseDown), this.off("keydown", this.handleKeyDown), this.off("click", this.handleClick), this.off(this.player_, "controlsvisible", this.update), this.off(n, "mousemove", this.handleMouseMove), this.off(n, "mouseup", this.handleMouseUp), this.off(n, "touchmove", this.handleMouseMove), this.off(n, "touchend", this.handleMouseUp), this.removeAttribute("tabindex"), this.addClass("disabled"), this.playerEvent && this.off(this.player_, this.playerEvent, this.update), this.enabled_ = !1;
    }
  }, i.createEl = function(n, a, s) {
    return a === void 0 && (a = {}), s === void 0 && (s = {}), a.className = a.className + " vjs-slider", a = Ui({
      tabIndex: 0
    }, a), s = Ui({
      role: "slider",
      "aria-valuenow": 0,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      tabIndex: 0
    }, s), e.prototype.createEl.call(this, n, a, s);
  }, i.handleMouseDown = function(n) {
    var a = this.bar.el_.ownerDocument;
    n.type === "mousedown" && n.preventDefault(), n.type === "touchstart" && !Eo && n.preventDefault(), sS(), this.addClass("vjs-sliding"), this.trigger("slideractive"), this.on(a, "mousemove", this.handleMouseMove), this.on(a, "mouseup", this.handleMouseUp), this.on(a, "touchmove", this.handleMouseMove), this.on(a, "touchend", this.handleMouseUp), this.handleMouseMove(n);
  }, i.handleMouseMove = function(n) {
  }, i.handleMouseUp = function() {
    var n = this.bar.el_.ownerDocument;
    oS(), this.removeClass("vjs-sliding"), this.trigger("sliderinactive"), this.off(n, "mousemove", this.handleMouseMove), this.off(n, "mouseup", this.handleMouseUp), this.off(n, "touchmove", this.handleMouseMove), this.off(n, "touchend", this.handleMouseUp), this.update();
  }, i.update = function() {
    if (!!this.el_) {
      var n = this.getPercent(), a = this.bar;
      if (!!a) {
        (typeof n != "number" || n !== n || n < 0 || n === 1 / 0) && (n = 0);
        var s = (n * 100).toFixed(2) + "%", o = a.el().style, l = this.vertical() ? "height" : "width";
        return o[l] !== s && (o[l] = s), n;
      }
    }
  }, i.calculateDistance = function(n) {
    var a = Vv(this.el_, n);
    return this.vertical() ? a.y : a.x;
  }, i.handleKeyDown = function(n) {
    Tr.isEventKey(n, "Left") || Tr.isEventKey(n, "Down") ? (n.preventDefault(), n.stopPropagation(), this.stepBack()) : Tr.isEventKey(n, "Right") || Tr.isEventKey(n, "Up") ? (n.preventDefault(), n.stopPropagation(), this.stepForward()) : e.prototype.handleKeyDown.call(this, n);
  }, i.handleClick = function(n) {
    n.stopPropagation(), n.preventDefault();
  }, i.vertical = function(n) {
    if (n === void 0)
      return this.vertical_ || !1;
    this.vertical_ = !!n, this.vertical_ ? this.addClass("vjs-slider-vertical") : this.addClass("vjs-slider-horizontal");
  }, r;
}(bt);
bt.registerComponent("Slider", cm);
var k2 = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.partEls_ = [], a.on(t, "progress", a.update), a;
  }
  var i = r.prototype;
  return i.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-load-progress",
      innerHTML: '<span class="vjs-control-text"><span>' + this.localize("Loaded") + '</span>: <span class="vjs-control-text-loaded-percentage">0%</span></span>'
    });
  }, i.dispose = function() {
    this.partEls_ = null, e.prototype.dispose.call(this);
  }, i.update = function(n) {
    var a = this.player_.liveTracker, s = this.player_.buffered(), o = a && a.isLive() ? a.seekableEnd() : this.player_.duration(), l = this.player_.bufferedEnd(), u = this.partEls_, h = this.$(".vjs-control-text-loaded-percentage"), c = function(v, g, E) {
      var x = v / g || 0;
      return x = (x >= 1 ? 1 : x) * 100, E && (x = x.toFixed(2)), x + "%";
    };
    this.el_.style.width = c(l, o), oc(h, c(l, o, !0));
    for (var d = 0; d < s.length; d++) {
      var f = s.start(d), m = s.end(d), p = u[d];
      p || (p = this.el_.appendChild(Ji()), u[d] = p), p.style.left = c(f, l), p.style.width = c(m - f, l);
    }
    for (var b = u.length; b > s.length; b--)
      this.el_.removeChild(u[b - 1]);
    u.length = s.length;
  }, r;
}(bt);
bt.registerComponent("LoadProgressBar", k2);
var R2 = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.update = iu(Mr(Rr(a), a.update), Qu), a;
  }
  var i = r.prototype;
  return i.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-time-tooltip"
    }, {
      "aria-hidden": "true"
    });
  }, i.update = function(n, a, s) {
    var o = ud(this.el_), l = ud(this.player_.el()), u = n.width * a;
    if (!(!l || !o)) {
      var h = n.left - l.left + u, c = n.width - u + (l.right - n.right), d = o.width / 2;
      h < d ? d += d - h : c < d && (d = c), d < 0 ? d = 0 : d > o.width && (d = o.width), this.el_.style.right = "-" + d + "px", this.write(s);
    }
  }, i.write = function(n) {
    oc(this.el_, n);
  }, i.updateTime = function(n, a, s, o) {
    var l = this;
    this.rafId_ && this.cancelAnimationFrame(this.rafId_), this.rafId_ = this.requestAnimationFrame(function() {
      var u, h = l.player_.duration();
      if (l.player_.liveTracker && l.player_.liveTracker.isLive()) {
        var c = l.player_.liveTracker.liveWindow(), d = c - a * c;
        u = (d < 1 ? "" : "-") + Jl(d, c);
      } else
        u = Jl(s, h);
      l.update(n, a, u), o && o();
    });
  }, r;
}(bt);
bt.registerComponent("TimeTooltip", R2);
var dm = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.update = iu(Mr(Rr(a), a.update), Qu), a;
  }
  var i = r.prototype;
  return i.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-play-progress vjs-slider-bar"
    }, {
      "aria-hidden": "true"
    });
  }, i.update = function(n, a) {
    var s = this.getChild("timeTooltip");
    if (!!s) {
      var o = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
      s.updateTime(n, a, o);
    }
  }, r;
}(bt);
dm.prototype.options_ = {
  children: []
};
!cs && !lu && dm.prototype.options_.children.push("timeTooltip");
bt.registerComponent("PlayProgressBar", dm);
var $S = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.update = iu(Mr(Rr(a), a.update), Qu), a;
  }
  var i = r.prototype;
  return i.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-mouse-display"
    });
  }, i.update = function(n, a) {
    var s = this, o = a * this.player_.duration();
    this.getChild("timeTooltip").updateTime(n, a, o, function() {
      s.el_.style.left = n.width * a + "px";
    });
  }, r;
}(bt);
$S.prototype.options_ = {
  children: ["timeTooltip"]
};
bt.registerComponent("MouseTimeDisplay", $S);
var cf = 5, C_ = 12, D_ = 30, fm = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.setEventHandlers_(), a;
  }
  var i = r.prototype;
  return i.setEventHandlers_ = function() {
    this.update = iu(Mr(this, this.update), D_), this.on(this.player_, "timeupdate", this.update), this.on(this.player_, "ended", this.handleEnded), this.on(this.player_, "durationchange", this.update), this.player_.liveTracker && this.on(this.player_.liveTracker, "liveedgechange", this.update), this.updateInterval = null, this.on(this.player_, ["playing"], this.enableInterval_), this.on(this.player_, ["ended", "pause", "waiting"], this.disableInterval_), "hidden" in Mt && "visibilityState" in Mt && this.on(Mt, "visibilitychange", this.toggleVisibility_);
  }, i.toggleVisibility_ = function(n) {
    Mt.hidden ? this.disableInterval_(n) : (this.enableInterval_(), this.requestAnimationFrame(this.update));
  }, i.enableInterval_ = function() {
    var n = this;
    this.clearInterval(this.updateInterval), this.updateInterval = this.setInterval(function() {
      n.requestAnimationFrame(n.update);
    }, D_);
  }, i.disableInterval_ = function(n) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && n.type !== "ended" || this.clearInterval(this.updateInterval);
  }, i.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-progress-holder"
    }, {
      "aria-label": this.localize("Progress Bar")
    });
  }, i.update_ = function(n, a) {
    var s = this.player_.liveTracker, o = this.player_.duration();
    s && s.isLive() && (o = this.player_.liveTracker.liveCurrentTime()), this.el_.setAttribute("aria-valuenow", (a * 100).toFixed(2)), this.el_.setAttribute("aria-valuetext", this.localize("progress bar timing: currentTime={1} duration={2}", [Jl(n, o), Jl(o, o)], "{1} of {2}")), this.bar && this.bar.update(ud(this.el_), a);
  }, i.update = function(n) {
    if (this.el().offsetParent !== null) {
      var a = e.prototype.update.call(this);
      return this.update_(this.getCurrentTime_(), a), a;
    }
  }, i.getCurrentTime_ = function() {
    return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
  }, i.handleEnded = function(n) {
    this.update_(this.player_.duration(), 1);
  }, i.getPercent = function() {
    var n = this.getCurrentTime_(), a, s = this.player_.liveTracker;
    return s && s.isLive() ? (a = (n - s.seekableStart()) / s.liveWindow(), s.atLiveEdge() && (a = 1)) : a = n / this.player_.duration(), a >= 1 ? 1 : a || 0;
  }, i.handleMouseDown = function(n) {
    !zl(n) || (n.stopPropagation(), this.player_.scrubbing(!0), this.videoWasPlaying = !this.player_.paused(), this.player_.pause(), e.prototype.handleMouseDown.call(this, n));
  }, i.handleMouseMove = function(n) {
    if (!!zl(n)) {
      var a, s = this.calculateDistance(n), o = this.player_.liveTracker;
      if (!o || !o.isLive())
        a = s * this.player_.duration(), a === this.player_.duration() && (a = a - 0.1);
      else {
        var l = o.seekableStart(), u = o.liveCurrentTime();
        if (a = l + s * o.liveWindow(), a >= u && (a = u), a <= l && (a = l + 0.1), a === 1 / 0)
          return;
      }
      this.player_.currentTime(a);
    }
  }, i.enable = function() {
    e.prototype.enable.call(this);
    var n = this.getChild("mouseTimeDisplay");
    !n || n.show();
  }, i.disable = function() {
    e.prototype.disable.call(this);
    var n = this.getChild("mouseTimeDisplay");
    !n || n.hide();
  }, i.handleMouseUp = function(n) {
    e.prototype.handleMouseUp.call(this, n), n && n.stopPropagation(), this.player_.scrubbing(!1), this.player_.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    }), this.videoWasPlaying && Wo(this.player_.play());
  }, i.stepForward = function() {
    this.player_.currentTime(this.player_.currentTime() + cf);
  }, i.stepBack = function() {
    this.player_.currentTime(this.player_.currentTime() - cf);
  }, i.handleAction = function(n) {
    this.player_.paused() ? this.player_.play() : this.player_.pause();
  }, i.handleKeyDown = function(n) {
    if (Tr.isEventKey(n, "Space") || Tr.isEventKey(n, "Enter"))
      n.preventDefault(), n.stopPropagation(), this.handleAction(n);
    else if (Tr.isEventKey(n, "Home"))
      n.preventDefault(), n.stopPropagation(), this.player_.currentTime(0);
    else if (Tr.isEventKey(n, "End"))
      n.preventDefault(), n.stopPropagation(), this.player_.currentTime(this.player_.duration());
    else if (/^[0-9]$/.test(Tr(n))) {
      n.preventDefault(), n.stopPropagation();
      var a = (Tr.codes[Tr(n)] - Tr.codes[0]) * 10 / 100;
      this.player_.currentTime(this.player_.duration() * a);
    } else
      Tr.isEventKey(n, "PgDn") ? (n.preventDefault(), n.stopPropagation(), this.player_.currentTime(this.player_.currentTime() - cf * C_)) : Tr.isEventKey(n, "PgUp") ? (n.preventDefault(), n.stopPropagation(), this.player_.currentTime(this.player_.currentTime() + cf * C_)) : e.prototype.handleKeyDown.call(this, n);
  }, r;
}(cm);
fm.prototype.options_ = {
  children: ["loadProgressBar", "playProgressBar"],
  barName: "playProgressBar"
};
!cs && !lu && fm.prototype.options_.children.splice(1, 0, "mouseTimeDisplay");
bt.registerComponent("SeekBar", fm);
var GS = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.handleMouseMove = iu(Mr(Rr(a), a.handleMouseMove), Qu), a.throttledHandleMouseSeek = iu(Mr(Rr(a), a.handleMouseSeek), Qu), a.enable(), a;
  }
  var i = r.prototype;
  return i.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-progress-control vjs-control"
    });
  }, i.handleMouseMove = function(n) {
    var a = this.getChild("seekBar");
    if (a) {
      var s = a.getChild("mouseTimeDisplay"), o = a.el(), l = ud(o), u = Vv(o, n).x;
      u > 1 ? u = 1 : u < 0 && (u = 0), s && s.update(l, u);
    }
  }, i.handleMouseSeek = function(n) {
    var a = this.getChild("seekBar");
    a && a.handleMouseMove(n);
  }, i.enabled = function() {
    return this.enabled_;
  }, i.disable = function() {
    this.children().forEach(function(n) {
      return n.disable && n.disable();
    }), this.enabled() && (this.off(["mousedown", "touchstart"], this.handleMouseDown), this.off(this.el_, "mousemove", this.handleMouseMove), this.handleMouseUp(), this.addClass("disabled"), this.enabled_ = !1);
  }, i.enable = function() {
    this.children().forEach(function(n) {
      return n.enable && n.enable();
    }), !this.enabled() && (this.on(["mousedown", "touchstart"], this.handleMouseDown), this.on(this.el_, "mousemove", this.handleMouseMove), this.removeClass("disabled"), this.enabled_ = !0);
  }, i.handleMouseDown = function(n) {
    var a = this.el_.ownerDocument, s = this.getChild("seekBar");
    s && s.handleMouseDown(n), this.on(a, "mousemove", this.throttledHandleMouseSeek), this.on(a, "touchmove", this.throttledHandleMouseSeek), this.on(a, "mouseup", this.handleMouseUp), this.on(a, "touchend", this.handleMouseUp);
  }, i.handleMouseUp = function(n) {
    var a = this.el_.ownerDocument, s = this.getChild("seekBar");
    s && s.handleMouseUp(n), this.off(a, "mousemove", this.throttledHandleMouseSeek), this.off(a, "touchmove", this.throttledHandleMouseSeek), this.off(a, "mouseup", this.handleMouseUp), this.off(a, "touchend", this.handleMouseUp);
  }, r;
}(bt);
GS.prototype.options_ = {
  children: ["seekBar"]
};
bt.registerComponent("ProgressControl", GS);
var HS = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.on(t, ["enterpictureinpicture", "leavepictureinpicture"], a.handlePictureInPictureChange), Mt.pictureInPictureEnabled || a.disable(), a;
  }
  var i = r.prototype;
  return i.buildCSSClass = function() {
    return "vjs-picture-in-picture-control " + e.prototype.buildCSSClass.call(this);
  }, i.handlePictureInPictureChange = function(n) {
    this.player_.isInPictureInPicture() ? this.controlText("Exit Picture-in-Picture") : this.controlText("Picture-in-Picture");
  }, i.handleClick = function(n) {
    this.player_.isInPictureInPicture() ? this.player_.exitPictureInPicture() : this.player_.requestPictureInPicture();
  }, r;
}(ds);
HS.prototype.controlText_ = "Picture-in-Picture";
bt.registerComponent("PictureInPictureToggle", HS);
var VS = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.on(t, "fullscreenchange", a.handleFullscreenChange), Mt[t.fsApi_.fullscreenEnabled] === !1 && a.disable(), a;
  }
  var i = r.prototype;
  return i.buildCSSClass = function() {
    return "vjs-fullscreen-control " + e.prototype.buildCSSClass.call(this);
  }, i.handleFullscreenChange = function(n) {
    this.player_.isFullscreen() ? this.controlText("Non-Fullscreen") : this.controlText("Fullscreen");
  }, i.handleClick = function(n) {
    this.player_.isFullscreen() ? this.player_.exitFullscreen() : this.player_.requestFullscreen();
  }, r;
}(ds);
VS.prototype.controlText_ = "Fullscreen";
bt.registerComponent("FullscreenToggle", VS);
var P2 = function(r, i) {
  i.tech_ && !i.tech_.featuresVolumeControl && r.addClass("vjs-hidden"), r.on(i, "loadstart", function() {
    i.tech_.featuresVolumeControl ? r.removeClass("vjs-hidden") : r.addClass("vjs-hidden");
  });
}, O2 = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  var i = r.prototype;
  return i.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-volume-level",
      innerHTML: '<span class="vjs-control-text"></span>'
    });
  }, r;
}(bt);
bt.registerComponent("VolumeLevel", O2);
var hm = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.on("slideractive", a.updateLastVolume_), a.on(t, "volumechange", a.updateARIAAttributes), t.ready(function() {
      return a.updateARIAAttributes();
    }), a;
  }
  var i = r.prototype;
  return i.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-volume-bar vjs-slider-bar"
    }, {
      "aria-label": this.localize("Volume Level"),
      "aria-live": "polite"
    });
  }, i.handleMouseDown = function(n) {
    !zl(n) || e.prototype.handleMouseDown.call(this, n);
  }, i.handleMouseMove = function(n) {
    !zl(n) || (this.checkMuted(), this.player_.volume(this.calculateDistance(n)));
  }, i.checkMuted = function() {
    this.player_.muted() && this.player_.muted(!1);
  }, i.getPercent = function() {
    return this.player_.muted() ? 0 : this.player_.volume();
  }, i.stepForward = function() {
    this.checkMuted(), this.player_.volume(this.player_.volume() + 0.1);
  }, i.stepBack = function() {
    this.checkMuted(), this.player_.volume(this.player_.volume() - 0.1);
  }, i.updateARIAAttributes = function(n) {
    var a = this.player_.muted() ? 0 : this.volumeAsPercentage_();
    this.el_.setAttribute("aria-valuenow", a), this.el_.setAttribute("aria-valuetext", a + "%");
  }, i.volumeAsPercentage_ = function() {
    return Math.round(this.player_.volume() * 100);
  }, i.updateLastVolume_ = function() {
    var n = this, a = this.player_.volume();
    this.one("sliderinactive", function() {
      n.player_.volume() === 0 && n.player_.lastVolume_(a);
    });
  }, r;
}(cm);
hm.prototype.options_ = {
  children: ["volumeLevel"],
  barName: "volumeLevel"
};
hm.prototype.playerEvent = "volumechange";
bt.registerComponent("VolumeBar", hm);
var qS = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return n === void 0 && (n = {}), n.vertical = n.vertical || !1, (typeof n.volumeBar > "u" || sd(n.volumeBar)) && (n.volumeBar = n.volumeBar || {}, n.volumeBar.vertical = n.vertical), a = e.call(this, t, n) || this, P2(Rr(a), t), a.throttledHandleMouseMove = iu(Mr(Rr(a), a.handleMouseMove), Qu), a.on("mousedown", a.handleMouseDown), a.on("touchstart", a.handleMouseDown), a.on(a.volumeBar, ["focus", "slideractive"], function() {
      a.volumeBar.addClass("vjs-slider-active"), a.addClass("vjs-slider-active"), a.trigger("slideractive");
    }), a.on(a.volumeBar, ["blur", "sliderinactive"], function() {
      a.volumeBar.removeClass("vjs-slider-active"), a.removeClass("vjs-slider-active"), a.trigger("sliderinactive");
    }), a;
  }
  var i = r.prototype;
  return i.createEl = function() {
    var n = "vjs-volume-horizontal";
    return this.options_.vertical && (n = "vjs-volume-vertical"), e.prototype.createEl.call(this, "div", {
      className: "vjs-volume-control vjs-control " + n
    });
  }, i.handleMouseDown = function(n) {
    var a = this.el_.ownerDocument;
    this.on(a, "mousemove", this.throttledHandleMouseMove), this.on(a, "touchmove", this.throttledHandleMouseMove), this.on(a, "mouseup", this.handleMouseUp), this.on(a, "touchend", this.handleMouseUp);
  }, i.handleMouseUp = function(n) {
    var a = this.el_.ownerDocument;
    this.off(a, "mousemove", this.throttledHandleMouseMove), this.off(a, "touchmove", this.throttledHandleMouseMove), this.off(a, "mouseup", this.handleMouseUp), this.off(a, "touchend", this.handleMouseUp);
  }, i.handleMouseMove = function(n) {
    this.volumeBar.handleMouseMove(n);
  }, r;
}(bt);
qS.prototype.options_ = {
  children: ["volumeBar"]
};
bt.registerComponent("VolumeControl", qS);
var L2 = function(r, i) {
  i.tech_ && !i.tech_.featuresMuteControl && r.addClass("vjs-hidden"), r.on(i, "loadstart", function() {
    i.tech_.featuresMuteControl ? r.removeClass("vjs-hidden") : r.addClass("vjs-hidden");
  });
}, WS = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, L2(Rr(a), t), a.on(t, ["loadstart", "volumechange"], a.update), a;
  }
  var i = r.prototype;
  return i.buildCSSClass = function() {
    return "vjs-mute-control " + e.prototype.buildCSSClass.call(this);
  }, i.handleClick = function(n) {
    var a = this.player_.volume(), s = this.player_.lastVolume_();
    if (a === 0) {
      var o = s < 0.1 ? 0.1 : s;
      this.player_.volume(o), this.player_.muted(!1);
    } else
      this.player_.muted(!this.player_.muted());
  }, i.update = function(n) {
    this.updateIcon_(), this.updateControlText_();
  }, i.updateIcon_ = function() {
    var n = this.player_.volume(), a = 3;
    cs && this.player_.tech_ && this.player_.tech_.el_ && this.player_.muted(this.player_.tech_.el_.muted), n === 0 || this.player_.muted() ? a = 0 : n < 0.33 ? a = 1 : n < 0.67 && (a = 2);
    for (var s = 0; s < 4; s++)
      Cd(this.el_, "vjs-vol-" + s);
    lo(this.el_, "vjs-vol-" + a);
  }, i.updateControlText_ = function() {
    var n = this.player_.muted() || this.player_.volume() === 0, a = n ? "Unmute" : "Mute";
    this.controlText() !== a && this.controlText(a);
  }, r;
}(ds);
WS.prototype.controlText_ = "Mute";
bt.registerComponent("MuteToggle", WS);
var YS = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return n === void 0 && (n = {}), typeof n.inline < "u" ? n.inline = n.inline : n.inline = !0, (typeof n.volumeControl > "u" || sd(n.volumeControl)) && (n.volumeControl = n.volumeControl || {}, n.volumeControl.vertical = !n.inline), a = e.call(this, t, n) || this, a.on(t, ["loadstart"], a.volumePanelState_), a.on(a.muteToggle, "keyup", a.handleKeyPress), a.on(a.volumeControl, "keyup", a.handleVolumeControlKeyUp), a.on("keydown", a.handleKeyPress), a.on("mouseover", a.handleMouseOver), a.on("mouseout", a.handleMouseOut), a.on(a.volumeControl, ["slideractive"], a.sliderActive_), a.on(a.volumeControl, ["sliderinactive"], a.sliderInactive_), a;
  }
  var i = r.prototype;
  return i.sliderActive_ = function() {
    this.addClass("vjs-slider-active");
  }, i.sliderInactive_ = function() {
    this.removeClass("vjs-slider-active");
  }, i.volumePanelState_ = function() {
    this.volumeControl.hasClass("vjs-hidden") && this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-hidden"), this.volumeControl.hasClass("vjs-hidden") && !this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-mute-toggle-only");
  }, i.createEl = function() {
    var n = "vjs-volume-panel-horizontal";
    return this.options_.inline || (n = "vjs-volume-panel-vertical"), e.prototype.createEl.call(this, "div", {
      className: "vjs-volume-panel vjs-control " + n
    });
  }, i.dispose = function() {
    this.handleMouseOut(), e.prototype.dispose.call(this);
  }, i.handleVolumeControlKeyUp = function(n) {
    Tr.isEventKey(n, "Esc") && this.muteToggle.focus();
  }, i.handleMouseOver = function(n) {
    this.addClass("vjs-hover"), xa(Mt, "keyup", Mr(this, this.handleKeyPress));
  }, i.handleMouseOut = function(n) {
    this.removeClass("vjs-hover"), wn(Mt, "keyup", Mr(this, this.handleKeyPress));
  }, i.handleKeyPress = function(n) {
    Tr.isEventKey(n, "Esc") && this.handleMouseOut();
  }, r;
}(bt);
YS.prototype.options_ = {
  children: ["muteToggle", "volumeControl"]
};
bt.registerComponent("VolumePanel", YS);
var pm = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, n && (a.menuButton_ = n.menuButton), a.focusedChild_ = -1, a.on("keydown", a.handleKeyDown), a.boundHandleBlur_ = Mr(Rr(a), a.handleBlur), a.boundHandleTapClick_ = Mr(Rr(a), a.handleTapClick), a;
  }
  var i = r.prototype;
  return i.addEventListenerForItem = function(n) {
    n instanceof bt && (this.on(n, "blur", this.boundHandleBlur_), this.on(n, ["tap", "click"], this.boundHandleTapClick_));
  }, i.removeEventListenerForItem = function(n) {
    n instanceof bt && (this.off(n, "blur", this.boundHandleBlur_), this.off(n, ["tap", "click"], this.boundHandleTapClick_));
  }, i.removeChild = function(n) {
    typeof n == "string" && (n = this.getChild(n)), this.removeEventListenerForItem(n), e.prototype.removeChild.call(this, n);
  }, i.addItem = function(n) {
    var a = this.addChild(n);
    a && this.addEventListenerForItem(a);
  }, i.createEl = function() {
    var n = this.options_.contentElType || "ul";
    this.contentEl_ = Ji(n, {
      className: "vjs-menu-content"
    }), this.contentEl_.setAttribute("role", "menu");
    var a = e.prototype.createEl.call(this, "div", {
      append: this.contentEl_,
      className: "vjs-menu"
    });
    return a.appendChild(this.contentEl_), xa(a, "click", function(s) {
      s.preventDefault(), s.stopImmediatePropagation();
    }), a;
  }, i.dispose = function() {
    this.contentEl_ = null, this.boundHandleBlur_ = null, this.boundHandleTapClick_ = null, e.prototype.dispose.call(this);
  }, i.handleBlur = function(n) {
    var a = n.relatedTarget || Mt.activeElement;
    if (!this.children().some(function(o) {
      return o.el() === a;
    })) {
      var s = this.menuButton_;
      s && s.buttonPressed_ && a !== s.el().firstChild && s.unpressButton();
    }
  }, i.handleTapClick = function(n) {
    if (this.menuButton_) {
      this.menuButton_.unpressButton();
      var a = this.children();
      if (!Array.isArray(a))
        return;
      var s = a.filter(function(o) {
        return o.el() === n.target;
      })[0];
      if (!s)
        return;
      s.name() !== "CaptionSettingsMenuItem" && this.menuButton_.focus();
    }
  }, i.handleKeyDown = function(n) {
    Tr.isEventKey(n, "Left") || Tr.isEventKey(n, "Down") ? (n.preventDefault(), n.stopPropagation(), this.stepForward()) : (Tr.isEventKey(n, "Right") || Tr.isEventKey(n, "Up")) && (n.preventDefault(), n.stopPropagation(), this.stepBack());
  }, i.stepForward = function() {
    var n = 0;
    this.focusedChild_ !== void 0 && (n = this.focusedChild_ + 1), this.focus(n);
  }, i.stepBack = function() {
    var n = 0;
    this.focusedChild_ !== void 0 && (n = this.focusedChild_ - 1), this.focus(n);
  }, i.focus = function(n) {
    n === void 0 && (n = 0);
    var a = this.children().slice(), s = a.length && a[0].className && /vjs-menu-title/.test(a[0].className);
    s && a.shift(), a.length > 0 && (n < 0 ? n = 0 : n >= a.length && (n = a.length - 1), this.focusedChild_ = n, a[n].el_.focus());
  }, r;
}(bt);
bt.registerComponent("Menu", pm);
var gm = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    n === void 0 && (n = {}), a = e.call(this, t, n) || this, a.menuButton_ = new ds(t, n), a.menuButton_.controlText(a.controlText_), a.menuButton_.el_.setAttribute("aria-haspopup", "true");
    var s = ds.prototype.buildCSSClass();
    return a.menuButton_.el_.className = a.buildCSSClass() + " " + s, a.menuButton_.removeClass("vjs-control"), a.addChild(a.menuButton_), a.update(), a.enabled_ = !0, a.on(a.menuButton_, "tap", a.handleClick), a.on(a.menuButton_, "click", a.handleClick), a.on(a.menuButton_, "keydown", a.handleKeyDown), a.on(a.menuButton_, "mouseenter", function() {
      a.addClass("vjs-hover"), a.menu.show(), xa(Mt, "keyup", Mr(Rr(a), a.handleMenuKeyUp));
    }), a.on("mouseleave", a.handleMouseLeave), a.on("keydown", a.handleSubmenuKeyDown), a;
  }
  var i = r.prototype;
  return i.update = function() {
    var n = this.createMenu();
    this.menu && (this.menu.dispose(), this.removeChild(this.menu)), this.menu = n, this.addChild(n), this.buttonPressed_ = !1, this.menuButton_.el_.setAttribute("aria-expanded", "false"), this.items && this.items.length <= this.hideThreshold_ ? this.hide() : this.show();
  }, i.createMenu = function() {
    var n = new pm(this.player_, {
      menuButton: this
    });
    if (this.hideThreshold_ = 0, this.options_.title) {
      var a = Ji("li", {
        className: "vjs-menu-title",
        innerHTML: Wi(this.options_.title),
        tabIndex: -1
      });
      this.hideThreshold_ += 1;
      var s = new bt(this.player_, {
        el: a
      });
      n.addItem(s);
    }
    if (this.items = this.createItems(), this.items)
      for (var o = 0; o < this.items.length; o++)
        n.addItem(this.items[o]);
    return n;
  }, i.createItems = function() {
  }, i.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: this.buildWrapperCSSClass()
    }, {});
  }, i.buildWrapperCSSClass = function() {
    var n = "vjs-menu-button";
    this.options_.inline === !0 ? n += "-inline" : n += "-popup";
    var a = ds.prototype.buildCSSClass();
    return "vjs-menu-button " + n + " " + a + " " + e.prototype.buildCSSClass.call(this);
  }, i.buildCSSClass = function() {
    var n = "vjs-menu-button";
    return this.options_.inline === !0 ? n += "-inline" : n += "-popup", "vjs-menu-button " + n + " " + e.prototype.buildCSSClass.call(this);
  }, i.controlText = function(n, a) {
    return a === void 0 && (a = this.menuButton_.el()), this.menuButton_.controlText(n, a);
  }, i.dispose = function() {
    this.handleMouseLeave(), e.prototype.dispose.call(this);
  }, i.handleClick = function(n) {
    this.buttonPressed_ ? this.unpressButton() : this.pressButton();
  }, i.handleMouseLeave = function(n) {
    this.removeClass("vjs-hover"), wn(Mt, "keyup", Mr(this, this.handleMenuKeyUp));
  }, i.focus = function() {
    this.menuButton_.focus();
  }, i.blur = function() {
    this.menuButton_.blur();
  }, i.handleKeyDown = function(n) {
    Tr.isEventKey(n, "Esc") || Tr.isEventKey(n, "Tab") ? (this.buttonPressed_ && this.unpressButton(), Tr.isEventKey(n, "Tab") || (n.preventDefault(), this.menuButton_.focus())) : (Tr.isEventKey(n, "Up") || Tr.isEventKey(n, "Down")) && (this.buttonPressed_ || (n.preventDefault(), this.pressButton()));
  }, i.handleMenuKeyUp = function(n) {
    (Tr.isEventKey(n, "Esc") || Tr.isEventKey(n, "Tab")) && this.removeClass("vjs-hover");
  }, i.handleSubmenuKeyPress = function(n) {
    this.handleSubmenuKeyDown(n);
  }, i.handleSubmenuKeyDown = function(n) {
    (Tr.isEventKey(n, "Esc") || Tr.isEventKey(n, "Tab")) && (this.buttonPressed_ && this.unpressButton(), Tr.isEventKey(n, "Tab") || (n.preventDefault(), this.menuButton_.focus()));
  }, i.pressButton = function() {
    if (this.enabled_) {
      if (this.buttonPressed_ = !0, this.menu.show(), this.menu.lockShowing(), this.menuButton_.el_.setAttribute("aria-expanded", "true"), cs && tS())
        return;
      this.menu.focus();
    }
  }, i.unpressButton = function() {
    this.enabled_ && (this.buttonPressed_ = !1, this.menu.unlockShowing(), this.menu.hide(), this.menuButton_.el_.setAttribute("aria-expanded", "false"));
  }, i.disable = function() {
    this.unpressButton(), this.enabled_ = !1, this.addClass("vjs-disabled"), this.menuButton_.disable();
  }, i.enable = function() {
    this.enabled_ = !0, this.removeClass("vjs-disabled"), this.menuButton_.enable();
  }, r;
}(bt);
bt.registerComponent("MenuButton", gm);
var vm = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(i, t) {
    var n, a = t.tracks;
    if (n = e.call(this, i, t) || this, n.items.length <= 1 && n.hide(), !a)
      return Rr(n);
    var s = Mr(Rr(n), n.update);
    return a.addEventListener("removetrack", s), a.addEventListener("addtrack", s), n.player_.on("ready", s), n.player_.on("dispose", function() {
      a.removeEventListener("removetrack", s), a.removeEventListener("addtrack", s);
    }), n;
  }
  return r;
}(gm);
bt.registerComponent("TrackButton", vm);
var I2 = ["Tab", "Esc", "Up", "Down", "Right", "Left"], kd = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.selectable = n.selectable, a.isSelected_ = n.selected || !1, a.multiSelectable = n.multiSelectable, a.selected(a.isSelected_), a.selectable ? a.multiSelectable ? a.el_.setAttribute("role", "menuitemcheckbox") : a.el_.setAttribute("role", "menuitemradio") : a.el_.setAttribute("role", "menuitem"), a;
  }
  var i = r.prototype;
  return i.createEl = function(n, a, s) {
    return this.nonIconControl = !0, e.prototype.createEl.call(this, "li", Ui({
      className: "vjs-menu-item",
      innerHTML: '<span class="vjs-menu-item-text">' + this.localize(this.options_.label) + "</span>",
      tabIndex: -1
    }, a), s);
  }, i.handleKeyDown = function(n) {
    I2.some(function(a) {
      return Tr.isEventKey(n, a);
    }) || e.prototype.handleKeyDown.call(this, n);
  }, i.handleClick = function(n) {
    this.selected(!0);
  }, i.selected = function(n) {
    this.selectable && (n ? (this.addClass("vjs-selected"), this.el_.setAttribute("aria-checked", "true"), this.controlText(", selected"), this.isSelected_ = !0) : (this.removeClass("vjs-selected"), this.el_.setAttribute("aria-checked", "false"), this.controlText(""), this.isSelected_ = !1));
  }, r;
}(jh);
bt.registerComponent("MenuItem", kd);
var Rd = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a, s = n.track, o = t.textTracks();
    n.label = s.label || s.language || "Unknown", n.selected = s.mode === "showing", a = e.call(this, t, n) || this, a.track = s, a.kinds = (n.kinds || [n.kind || a.track.kind]).filter(Boolean);
    var l = function() {
      for (var d = arguments.length, f = new Array(d), m = 0; m < d; m++)
        f[m] = arguments[m];
      a.handleTracksChange.apply(Rr(a), f);
    }, u = function() {
      for (var d = arguments.length, f = new Array(d), m = 0; m < d; m++)
        f[m] = arguments[m];
      a.handleSelectedLanguageChange.apply(Rr(a), f);
    };
    if (t.on(["loadstart", "texttrackchange"], l), o.addEventListener("change", l), o.addEventListener("selectedlanguagechange", u), a.on("dispose", function() {
      t.off(["loadstart", "texttrackchange"], l), o.removeEventListener("change", l), o.removeEventListener("selectedlanguagechange", u);
    }), o.onchange === void 0) {
      var h;
      a.on(["tap", "click"], function() {
        if (typeof Be.Event != "object")
          try {
            h = new Be.Event("change");
          } catch {
          }
        h || (h = Mt.createEvent("Event"), h.initEvent("change", !0, !0)), o.dispatchEvent(h);
      });
    }
    return a.handleTracksChange(), a;
  }
  var i = r.prototype;
  return i.handleClick = function(n) {
    var a = this.track, s = this.player_.textTracks();
    if (e.prototype.handleClick.call(this, n), !!s)
      for (var o = 0; o < s.length; o++) {
        var l = s[o];
        this.kinds.indexOf(l.kind) !== -1 && (l === a ? l.mode !== "showing" && (l.mode = "showing") : l.mode !== "disabled" && (l.mode = "disabled"));
      }
  }, i.handleTracksChange = function(n) {
    var a = this.track.mode === "showing";
    a !== this.isSelected_ && this.selected(a);
  }, i.handleSelectedLanguageChange = function(n) {
    if (this.track.mode === "showing") {
      var a = this.player_.cache_.selectedLanguage;
      if (a && a.enabled && a.language === this.track.language && a.kind !== this.track.kind)
        return;
      this.player_.cache_.selectedLanguage = {
        enabled: !0,
        language: this.track.language,
        kind: this.track.kind
      };
    }
  }, i.dispose = function() {
    this.track = null, e.prototype.dispose.call(this);
  }, r;
}(kd);
bt.registerComponent("TextTrackMenuItem", Rd);
var KS = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    return n.track = {
      player: t,
      kind: n.kind,
      kinds: n.kinds,
      default: !1,
      mode: "disabled"
    }, n.kinds || (n.kinds = [n.kind]), n.label ? n.track.label = n.label : n.track.label = n.kinds.join(" and ") + " off", n.selectable = !0, n.multiSelectable = !1, e.call(this, t, n) || this;
  }
  var i = r.prototype;
  return i.handleTracksChange = function(n) {
    for (var a = this.player().textTracks(), s = !0, o = 0, l = a.length; o < l; o++) {
      var u = a[o];
      if (this.options_.kinds.indexOf(u.kind) > -1 && u.mode === "showing") {
        s = !1;
        break;
      }
    }
    s !== this.isSelected_ && this.selected(s);
  }, i.handleSelectedLanguageChange = function(n) {
    for (var a = this.player().textTracks(), s = !0, o = 0, l = a.length; o < l; o++) {
      var u = a[o];
      if (["captions", "descriptions", "subtitles"].indexOf(u.kind) > -1 && u.mode === "showing") {
        s = !1;
        break;
      }
    }
    s && (this.player_.cache_.selectedLanguage = {
      enabled: !1
    });
  }, r;
}(Rd);
bt.registerComponent("OffTextTrackMenuItem", KS);
var fc = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    return n === void 0 && (n = {}), n.tracks = t.textTracks(), e.call(this, t, n) || this;
  }
  var i = r.prototype;
  return i.createItems = function(n, a) {
    n === void 0 && (n = []), a === void 0 && (a = Rd);
    var s;
    this.label_ && (s = this.label_ + " off"), n.push(new KS(this.player_, {
      kinds: this.kinds_,
      kind: this.kind_,
      label: s
    })), this.hideThreshold_ += 1;
    var o = this.player_.textTracks();
    Array.isArray(this.kinds_) || (this.kinds_ = [this.kind_]);
    for (var l = 0; l < o.length; l++) {
      var u = o[l];
      if (this.kinds_.indexOf(u.kind) > -1) {
        var h = new a(this.player_, {
          track: u,
          kinds: this.kinds_,
          kind: this.kind_,
          selectable: !0,
          multiSelectable: !1
        });
        h.addClass("vjs-" + u.kind + "-menu-item"), n.push(h);
      }
    }
    return n;
  }, r;
}(vm);
bt.registerComponent("TextTrackButton", fc);
var zS = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a, s = n.track, o = n.cue, l = t.currentTime();
    return n.selectable = !0, n.multiSelectable = !1, n.label = o.text, n.selected = o.startTime <= l && l < o.endTime, a = e.call(this, t, n) || this, a.track = s, a.cue = o, s.addEventListener("cuechange", Mr(Rr(a), a.update)), a;
  }
  var i = r.prototype;
  return i.handleClick = function(n) {
    e.prototype.handleClick.call(this), this.player_.currentTime(this.cue.startTime), this.update(this.cue.startTime);
  }, i.update = function(n) {
    var a = this.cue, s = this.player_.currentTime();
    this.selected(a.startTime <= s && s < a.endTime);
  }, r;
}(kd);
bt.registerComponent("ChaptersTrackMenuItem", zS);
var mm = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n, a) {
    return e.call(this, t, n, a) || this;
  }
  var i = r.prototype;
  return i.buildCSSClass = function() {
    return "vjs-chapters-button " + e.prototype.buildCSSClass.call(this);
  }, i.buildWrapperCSSClass = function() {
    return "vjs-chapters-button " + e.prototype.buildWrapperCSSClass.call(this);
  }, i.update = function(n) {
    (!this.track_ || n && (n.type === "addtrack" || n.type === "removetrack")) && this.setTrack(this.findChaptersTrack()), e.prototype.update.call(this);
  }, i.setTrack = function(n) {
    if (this.track_ !== n) {
      if (this.updateHandler_ || (this.updateHandler_ = this.update.bind(this)), this.track_) {
        var a = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
        a && a.removeEventListener("load", this.updateHandler_), this.track_ = null;
      }
      if (this.track_ = n, this.track_) {
        this.track_.mode = "hidden";
        var s = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
        s && s.addEventListener("load", this.updateHandler_);
      }
    }
  }, i.findChaptersTrack = function() {
    for (var n = this.player_.textTracks() || [], a = n.length - 1; a >= 0; a--) {
      var s = n[a];
      if (s.kind === this.kind_)
        return s;
    }
  }, i.getMenuCaption = function() {
    return this.track_ && this.track_.label ? this.track_.label : this.localize(Wi(this.kind_));
  }, i.createMenu = function() {
    return this.options_.title = this.getMenuCaption(), e.prototype.createMenu.call(this);
  }, i.createItems = function() {
    var n = [];
    if (!this.track_)
      return n;
    var a = this.track_.cues;
    if (!a)
      return n;
    for (var s = 0, o = a.length; s < o; s++) {
      var l = a[s], u = new zS(this.player_, {
        track: this.track_,
        cue: l
      });
      n.push(u);
    }
    return n;
  }, r;
}(fc);
mm.prototype.kind_ = "chapters";
mm.prototype.controlText_ = "Chapters";
bt.registerComponent("ChaptersButton", mm);
var ym = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n, a) {
    var s;
    s = e.call(this, t, n, a) || this;
    var o = t.textTracks(), l = Mr(Rr(s), s.handleTracksChange);
    return o.addEventListener("change", l), s.on("dispose", function() {
      o.removeEventListener("change", l);
    }), s;
  }
  var i = r.prototype;
  return i.handleTracksChange = function(n) {
    for (var a = this.player().textTracks(), s = !1, o = 0, l = a.length; o < l; o++) {
      var u = a[o];
      if (u.kind !== this.kind_ && u.mode === "showing") {
        s = !0;
        break;
      }
    }
    s ? this.disable() : this.enable();
  }, i.buildCSSClass = function() {
    return "vjs-descriptions-button " + e.prototype.buildCSSClass.call(this);
  }, i.buildWrapperCSSClass = function() {
    return "vjs-descriptions-button " + e.prototype.buildWrapperCSSClass.call(this);
  }, r;
}(fc);
ym.prototype.kind_ = "descriptions";
ym.prototype.controlText_ = "Descriptions";
bt.registerComponent("DescriptionsButton", ym);
var _m = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n, a) {
    return e.call(this, t, n, a) || this;
  }
  var i = r.prototype;
  return i.buildCSSClass = function() {
    return "vjs-subtitles-button " + e.prototype.buildCSSClass.call(this);
  }, i.buildWrapperCSSClass = function() {
    return "vjs-subtitles-button " + e.prototype.buildWrapperCSSClass.call(this);
  }, r;
}(fc);
_m.prototype.kind_ = "subtitles";
_m.prototype.controlText_ = "Subtitles";
bt.registerComponent("SubtitlesButton", _m);
var bm = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return n.track = {
      player: t,
      kind: n.kind,
      label: n.kind + " settings",
      selectable: !1,
      default: !1,
      mode: "disabled"
    }, n.selectable = !1, n.name = "CaptionSettingsMenuItem", a = e.call(this, t, n) || this, a.addClass("vjs-texttrack-settings"), a.controlText(", opens " + n.kind + " settings dialog"), a;
  }
  var i = r.prototype;
  return i.handleClick = function(n) {
    this.player().getChild("textTrackSettings").open();
  }, r;
}(Rd);
bt.registerComponent("CaptionSettingsMenuItem", bm);
var Tm = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n, a) {
    return e.call(this, t, n, a) || this;
  }
  var i = r.prototype;
  return i.buildCSSClass = function() {
    return "vjs-captions-button " + e.prototype.buildCSSClass.call(this);
  }, i.buildWrapperCSSClass = function() {
    return "vjs-captions-button " + e.prototype.buildWrapperCSSClass.call(this);
  }, i.createItems = function() {
    var n = [];
    return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (n.push(new bm(this.player_, {
      kind: this.kind_
    })), this.hideThreshold_ += 1), e.prototype.createItems.call(this, n);
  }, r;
}(fc);
Tm.prototype.kind_ = "captions";
Tm.prototype.controlText_ = "Captions";
bt.registerComponent("CaptionsButton", Tm);
var XS = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  var i = r.prototype;
  return i.createEl = function(n, a, s) {
    var o = '<span class="vjs-menu-item-text">' + this.localize(this.options_.label);
    this.options_.track.kind === "captions" && (o += `
        <span aria-hidden="true" class="vjs-icon-placeholder"></span>
        <span class="vjs-control-text"> ` + this.localize("Captions") + `</span>
      `), o += "</span>";
    var l = e.prototype.createEl.call(this, n, Ui({
      innerHTML: o
    }, a), s);
    return l;
  }, r;
}(Rd);
bt.registerComponent("SubsCapsMenuItem", XS);
var Sm = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return n === void 0 && (n = {}), a = e.call(this, t, n) || this, a.label_ = "subtitles", ["en", "en-us", "en-ca", "fr-ca"].indexOf(a.player_.language_) > -1 && (a.label_ = "captions"), a.menuButton_.controlText(Wi(a.label_)), a;
  }
  var i = r.prototype;
  return i.buildCSSClass = function() {
    return "vjs-subs-caps-button " + e.prototype.buildCSSClass.call(this);
  }, i.buildWrapperCSSClass = function() {
    return "vjs-subs-caps-button " + e.prototype.buildWrapperCSSClass.call(this);
  }, i.createItems = function() {
    var n = [];
    return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (n.push(new bm(this.player_, {
      kind: this.label_
    })), this.hideThreshold_ += 1), n = e.prototype.createItems.call(this, n, XS), n;
  }, r;
}(fc);
Sm.prototype.kinds_ = ["captions", "subtitles"];
Sm.prototype.controlText_ = "Subtitles";
bt.registerComponent("SubsCapsButton", Sm);
var JS = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a, s = n.track, o = t.audioTracks();
    n.label = s.label || s.language || "Unknown", n.selected = s.enabled, a = e.call(this, t, n) || this, a.track = s, a.addClass("vjs-" + s.kind + "-menu-item");
    var l = function() {
      for (var h = arguments.length, c = new Array(h), d = 0; d < h; d++)
        c[d] = arguments[d];
      a.handleTracksChange.apply(Rr(a), c);
    };
    return o.addEventListener("change", l), a.on("dispose", function() {
      o.removeEventListener("change", l);
    }), a;
  }
  var i = r.prototype;
  return i.createEl = function(n, a, s) {
    var o = '<span class="vjs-menu-item-text">' + this.localize(this.options_.label);
    this.options_.track.kind === "main-desc" && (o += `
        <span aria-hidden="true" class="vjs-icon-placeholder"></span>
        <span class="vjs-control-text"> ` + this.localize("Descriptions") + `</span>
      `), o += "</span>";
    var l = e.prototype.createEl.call(this, n, Ui({
      innerHTML: o
    }, a), s);
    return l;
  }, i.handleClick = function(n) {
    var a = this.player_.audioTracks();
    e.prototype.handleClick.call(this, n);
    for (var s = 0; s < a.length; s++) {
      var o = a[s];
      o.enabled = o === this.track;
    }
  }, i.handleTracksChange = function(n) {
    this.selected(this.track.enabled);
  }, r;
}(kd);
bt.registerComponent("AudioTrackMenuItem", JS);
var QS = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    return n === void 0 && (n = {}), n.tracks = t.audioTracks(), e.call(this, t, n) || this;
  }
  var i = r.prototype;
  return i.buildCSSClass = function() {
    return "vjs-audio-button " + e.prototype.buildCSSClass.call(this);
  }, i.buildWrapperCSSClass = function() {
    return "vjs-audio-button " + e.prototype.buildWrapperCSSClass.call(this);
  }, i.createItems = function(n) {
    n === void 0 && (n = []), this.hideThreshold_ = 1;
    for (var a = this.player_.audioTracks(), s = 0; s < a.length; s++) {
      var o = a[s];
      n.push(new JS(this.player_, {
        track: o,
        selectable: !0,
        multiSelectable: !1
      }));
    }
    return n;
  }, r;
}(vm);
QS.prototype.controlText_ = "Audio Track";
bt.registerComponent("AudioTrackButton", QS);
var Em = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a, s = n.rate, o = parseFloat(s, 10);
    return n.label = s, n.selected = o === 1, n.selectable = !0, n.multiSelectable = !1, a = e.call(this, t, n) || this, a.label = s, a.rate = o, a.on(t, "ratechange", a.update), a;
  }
  var i = r.prototype;
  return i.handleClick = function(n) {
    e.prototype.handleClick.call(this), this.player().playbackRate(this.rate);
  }, i.update = function(n) {
    this.selected(this.player().playbackRate() === this.rate);
  }, r;
}(kd);
Em.prototype.contentElType = "button";
bt.registerComponent("PlaybackRateMenuItem", Em);
var ZS = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.updateVisibility(), a.updateLabel(), a.on(t, "loadstart", a.updateVisibility), a.on(t, "ratechange", a.updateLabel), a;
  }
  var i = r.prototype;
  return i.createEl = function() {
    var n = e.prototype.createEl.call(this);
    return this.labelEl_ = Ji("div", {
      className: "vjs-playback-rate-value",
      innerHTML: "1x"
    }), n.appendChild(this.labelEl_), n;
  }, i.dispose = function() {
    this.labelEl_ = null, e.prototype.dispose.call(this);
  }, i.buildCSSClass = function() {
    return "vjs-playback-rate " + e.prototype.buildCSSClass.call(this);
  }, i.buildWrapperCSSClass = function() {
    return "vjs-playback-rate " + e.prototype.buildWrapperCSSClass.call(this);
  }, i.createMenu = function() {
    var n = new pm(this.player()), a = this.playbackRates();
    if (a)
      for (var s = a.length - 1; s >= 0; s--)
        n.addChild(new Em(this.player(), {
          rate: a[s] + "x"
        }));
    return n;
  }, i.updateARIAAttributes = function() {
    this.el().setAttribute("aria-valuenow", this.player().playbackRate());
  }, i.handleClick = function(n) {
    for (var a = this.player().playbackRate(), s = this.playbackRates(), o = s[0], l = 0; l < s.length; l++)
      if (s[l] > a) {
        o = s[l];
        break;
      }
    this.player().playbackRate(o);
  }, i.playbackRates = function() {
    return this.options_.playbackRates || this.options_.playerOptions && this.options_.playerOptions.playbackRates;
  }, i.playbackRateSupported = function() {
    return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
  }, i.updateVisibility = function(n) {
    this.playbackRateSupported() ? this.removeClass("vjs-hidden") : this.addClass("vjs-hidden");
  }, i.updateLabel = function(n) {
    this.playbackRateSupported() && (this.labelEl_.innerHTML = this.player().playbackRate() + "x");
  }, r;
}(gm);
ZS.prototype.controlText_ = "Playback Rate";
bt.registerComponent("PlaybackRateMenuButton", ZS);
var eE = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  var i = r.prototype;
  return i.buildCSSClass = function() {
    return "vjs-spacer " + e.prototype.buildCSSClass.call(this);
  }, i.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: this.buildCSSClass()
    });
  }, r;
}(bt);
bt.registerComponent("Spacer", eE);
var M2 = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  var i = r.prototype;
  return i.buildCSSClass = function() {
    return "vjs-custom-control-spacer " + e.prototype.buildCSSClass.call(this);
  }, i.createEl = function() {
    var n = e.prototype.createEl.call(this, {
      className: this.buildCSSClass()
    });
    return n.innerHTML = "\xA0", n;
  }, r;
}(eE);
bt.registerComponent("CustomControlSpacer", M2);
var zf = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  var i = r.prototype;
  return i.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-control-bar",
      dir: "ltr"
    });
  }, r;
}(bt);
zf.prototype.options_ = {
  children: ["playToggle", "volumePanel", "currentTimeDisplay", "timeDivider", "durationDisplay", "progressControl", "liveDisplay", "seekToLive", "remainingTimeDisplay", "customControlSpacer", "playbackRateMenuButton", "chaptersButton", "descriptionsButton", "subsCapsButton", "audioTrackButton", "fullscreenToggle"]
};
"exitPictureInPicture" in Mt && zf.prototype.options_.children.splice(zf.prototype.options_.children.length - 1, 0, "pictureInPictureToggle");
bt.registerComponent("ControlBar", zf);
var tE = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return a = e.call(this, t, n) || this, a.on(t, "error", a.open), a;
  }
  var i = r.prototype;
  return i.buildCSSClass = function() {
    return "vjs-error-display " + e.prototype.buildCSSClass.call(this);
  }, i.content = function() {
    var n = this.player().error();
    return n ? this.localize(n.message) : "";
  }, r;
}(lc);
tE.prototype.options_ = Ti(lc.prototype.options_, {
  pauseOnOpen: !1,
  fillAlways: !0,
  temporary: !1,
  uncloseable: !0
});
bt.registerComponent("ErrorDisplay", tE);
var qp = "vjs-text-track-settings", k_ = ["#000", "Black"], R_ = ["#00F", "Blue"], P_ = ["#0FF", "Cyan"], O_ = ["#0F0", "Green"], L_ = ["#F0F", "Magenta"], I_ = ["#F00", "Red"], M_ = ["#FFF", "White"], N_ = ["#FF0", "Yellow"], Wp = ["1", "Opaque"], Yp = ["0.5", "Semi-Transparent"], F_ = ["0", "Transparent"], Iu = {
  backgroundColor: {
    selector: ".vjs-bg-color > select",
    id: "captions-background-color-%s",
    label: "Color",
    options: [k_, M_, I_, O_, R_, N_, L_, P_]
  },
  backgroundOpacity: {
    selector: ".vjs-bg-opacity > select",
    id: "captions-background-opacity-%s",
    label: "Transparency",
    options: [Wp, Yp, F_]
  },
  color: {
    selector: ".vjs-fg-color > select",
    id: "captions-foreground-color-%s",
    label: "Color",
    options: [M_, k_, I_, O_, R_, N_, L_, P_]
  },
  edgeStyle: {
    selector: ".vjs-edge-style > select",
    id: "%s",
    label: "Text Edge Style",
    options: [["none", "None"], ["raised", "Raised"], ["depressed", "Depressed"], ["uniform", "Uniform"], ["dropshadow", "Dropshadow"]]
  },
  fontFamily: {
    selector: ".vjs-font-family > select",
    id: "captions-font-family-%s",
    label: "Font Family",
    options: [["proportionalSansSerif", "Proportional Sans-Serif"], ["monospaceSansSerif", "Monospace Sans-Serif"], ["proportionalSerif", "Proportional Serif"], ["monospaceSerif", "Monospace Serif"], ["casual", "Casual"], ["script", "Script"], ["small-caps", "Small Caps"]]
  },
  fontPercent: {
    selector: ".vjs-font-percent > select",
    id: "captions-font-size-%s",
    label: "Font Size",
    options: [["0.50", "50%"], ["0.75", "75%"], ["1.00", "100%"], ["1.25", "125%"], ["1.50", "150%"], ["1.75", "175%"], ["2.00", "200%"], ["3.00", "300%"], ["4.00", "400%"]],
    default: 2,
    parser: function(r) {
      return r === "1.00" ? null : Number(r);
    }
  },
  textOpacity: {
    selector: ".vjs-text-opacity > select",
    id: "captions-foreground-opacity-%s",
    label: "Transparency",
    options: [Wp, Yp]
  },
  windowColor: {
    selector: ".vjs-window-color > select",
    id: "captions-window-color-%s",
    label: "Color"
  },
  windowOpacity: {
    selector: ".vjs-window-opacity > select",
    id: "captions-window-opacity-%s",
    label: "Transparency",
    options: [F_, Yp, Wp]
  }
};
Iu.windowColor.options = Iu.backgroundColor.options;
function rE(e, r) {
  if (r && (e = r(e)), e && e !== "none")
    return e;
}
function N2(e, r) {
  var i = e.options[e.options.selectedIndex].value;
  return rE(i, r);
}
function F2(e, r, i) {
  if (!!r) {
    for (var t = 0; t < e.options.length; t++)
      if (rE(e.options[t].value, i) === r) {
        e.selectedIndex = t;
        break;
      }
  }
}
var U2 = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    return n.temporary = !1, a = e.call(this, t, n) || this, a.updateDisplay = Mr(Rr(a), a.updateDisplay), a.fill(), a.hasBeenOpened_ = a.hasBeenFilled_ = !0, a.endDialog = Ji("p", {
      className: "vjs-control-text",
      textContent: a.localize("End of dialog window.")
    }), a.el().appendChild(a.endDialog), a.setDefaults(), n.persistTextTrackSettings === void 0 && (a.options_.persistTextTrackSettings = a.options_.playerOptions.persistTextTrackSettings), a.on(a.$(".vjs-done-button"), "click", function() {
      a.saveSettings(), a.close();
    }), a.on(a.$(".vjs-default-button"), "click", function() {
      a.setDefaults(), a.updateDisplay();
    }), Fl(Iu, function(s) {
      a.on(a.$(s.selector), "change", a.updateDisplay);
    }), a.options_.persistTextTrackSettings && a.restoreSettings(), a;
  }
  var i = r.prototype;
  return i.dispose = function() {
    this.endDialog = null, e.prototype.dispose.call(this);
  }, i.createElSelect_ = function(n, a, s) {
    var o = this;
    a === void 0 && (a = ""), s === void 0 && (s = "label");
    var l = Iu[n], u = l.id.replace("%s", this.id_), h = [a, u].join(" ").trim();
    return ["<" + s + ' id="' + u + '" class="' + (s === "label" ? "vjs-label" : "") + '">', this.localize(l.label), "</" + s + ">", '<select aria-labelledby="' + h + '">'].concat(l.options.map(function(c) {
      var d = u + "-" + c[1].replace(/\W+/g, "");
      return ['<option id="' + d + '" value="' + c[0] + '" ', 'aria-labelledby="' + h + " " + d + '">', o.localize(c[1]), "</option>"].join("");
    })).concat("</select>").join("");
  }, i.createElFgColor_ = function() {
    var n = "captions-text-legend-" + this.id_;
    return ['<fieldset class="vjs-fg-color vjs-track-setting">', '<legend id="' + n + '">', this.localize("Text"), "</legend>", this.createElSelect_("color", n), '<span class="vjs-text-opacity vjs-opacity">', this.createElSelect_("textOpacity", n), "</span>", "</fieldset>"].join("");
  }, i.createElBgColor_ = function() {
    var n = "captions-background-" + this.id_;
    return ['<fieldset class="vjs-bg-color vjs-track-setting">', '<legend id="' + n + '">', this.localize("Background"), "</legend>", this.createElSelect_("backgroundColor", n), '<span class="vjs-bg-opacity vjs-opacity">', this.createElSelect_("backgroundOpacity", n), "</span>", "</fieldset>"].join("");
  }, i.createElWinColor_ = function() {
    var n = "captions-window-" + this.id_;
    return ['<fieldset class="vjs-window-color vjs-track-setting">', '<legend id="' + n + '">', this.localize("Window"), "</legend>", this.createElSelect_("windowColor", n), '<span class="vjs-window-opacity vjs-opacity">', this.createElSelect_("windowOpacity", n), "</span>", "</fieldset>"].join("");
  }, i.createElColors_ = function() {
    return Ji("div", {
      className: "vjs-track-settings-colors",
      innerHTML: [this.createElFgColor_(), this.createElBgColor_(), this.createElWinColor_()].join("")
    });
  }, i.createElFont_ = function() {
    return Ji("div", {
      className: "vjs-track-settings-font",
      innerHTML: ['<fieldset class="vjs-font-percent vjs-track-setting">', this.createElSelect_("fontPercent", "", "legend"), "</fieldset>", '<fieldset class="vjs-edge-style vjs-track-setting">', this.createElSelect_("edgeStyle", "", "legend"), "</fieldset>", '<fieldset class="vjs-font-family vjs-track-setting">', this.createElSelect_("fontFamily", "", "legend"), "</fieldset>"].join("")
    });
  }, i.createElControls_ = function() {
    var n = this.localize("restore all settings to the default values");
    return Ji("div", {
      className: "vjs-track-settings-controls",
      innerHTML: ['<button type="button" class="vjs-default-button" title="' + n + '">', this.localize("Reset"), '<span class="vjs-control-text"> ' + n + "</span>", "</button>", '<button type="button" class="vjs-done-button">' + this.localize("Done") + "</button>"].join("")
    });
  }, i.content = function() {
    return [this.createElColors_(), this.createElFont_(), this.createElControls_()];
  }, i.label = function() {
    return this.localize("Caption Settings Dialog");
  }, i.description = function() {
    return this.localize("Beginning of dialog window. Escape will cancel and close the window.");
  }, i.buildCSSClass = function() {
    return e.prototype.buildCSSClass.call(this) + " vjs-text-track-settings";
  }, i.getValues = function() {
    var n = this;
    return kR(Iu, function(a, s, o) {
      var l = N2(n.$(s.selector), s.parser);
      return l !== void 0 && (a[o] = l), a;
    }, {});
  }, i.setValues = function(n) {
    var a = this;
    Fl(Iu, function(s, o) {
      F2(a.$(s.selector), n[o], s.parser);
    });
  }, i.setDefaults = function() {
    var n = this;
    Fl(Iu, function(a) {
      var s = a.hasOwnProperty("default") ? a.default : 0;
      n.$(a.selector).selectedIndex = s;
    });
  }, i.restoreSettings = function() {
    var n;
    try {
      n = JSON.parse(Be.localStorage.getItem(qp));
    } catch (a) {
      qr.warn(a);
    }
    n && this.setValues(n);
  }, i.saveSettings = function() {
    if (!!this.options_.persistTextTrackSettings) {
      var n = this.getValues();
      try {
        Object.keys(n).length ? Be.localStorage.setItem(qp, JSON.stringify(n)) : Be.localStorage.removeItem(qp);
      } catch (a) {
        qr.warn(a);
      }
    }
  }, i.updateDisplay = function() {
    var n = this.player_.getChild("textTrackDisplay");
    n && n.updateDisplay();
  }, i.conditionalBlur_ = function() {
    this.previouslyActiveEl_ = null;
    var n = this.player_.controlBar, a = n && n.subsCapsButton, s = n && n.captionsButton;
    a ? a.focus() : s && s.focus();
  }, r;
}(lc);
bt.registerComponent("TextTrackSettings", U2);
var B2 = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a, s = n.ResizeObserver || Be.ResizeObserver;
    n.ResizeObserver === null && (s = !1);
    var o = Ti({
      createEl: !s,
      reportTouchActivity: !1
    }, n);
    return a = e.call(this, t, o) || this, a.ResizeObserver = n.ResizeObserver || Be.ResizeObserver, a.loadListener_ = null, a.resizeObserver_ = null, a.debouncedHandler_ = NR(function() {
      a.resizeHandler();
    }, 100, !1, Rr(a)), s ? (a.resizeObserver_ = new a.ResizeObserver(a.debouncedHandler_), a.resizeObserver_.observe(t.el())) : (a.loadListener_ = function() {
      if (!(!a.el_ || !a.el_.contentWindow)) {
        var l = a.debouncedHandler_, u = a.unloadListener_ = function() {
          wn(this, "resize", l), wn(this, "unload", u), u = null;
        };
        xa(a.el_.contentWindow, "unload", u), xa(a.el_.contentWindow, "resize", l);
      }
    }, a.one("load", a.loadListener_)), a;
  }
  var i = r.prototype;
  return i.createEl = function() {
    return e.prototype.createEl.call(this, "iframe", {
      className: "vjs-resize-manager",
      tabIndex: -1
    }, {
      "aria-hidden": "true"
    });
  }, i.resizeHandler = function() {
    !this.player_ || !this.player_.trigger || this.player_.trigger("playerresize");
  }, i.dispose = function() {
    this.debouncedHandler_ && this.debouncedHandler_.cancel(), this.resizeObserver_ && (this.player_.el() && this.resizeObserver_.unobserve(this.player_.el()), this.resizeObserver_.disconnect()), this.loadListener_ && this.off("load", this.loadListener_), this.el_ && this.el_.contentWindow && this.unloadListener_ && this.unloadListener_.call(this.el_.contentWindow), this.ResizeObserver = null, this.resizeObserver = null, this.debouncedHandler_ = null, this.loadListener_ = null, e.prototype.dispose.call(this);
  }, r;
}(bt);
bt.registerComponent("ResizeManager", B2);
var j2 = function(r) {
  var i = Math.floor(r.length / 2), t = [].concat(r).sort(function(n, a) {
    return n - a;
  });
  return r.length % 2 !== 0 ? t[i] : (t[i - 1] + t[i]) / 2;
}, $2 = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a, s = Ti({
      createEl: !1
    }, n);
    return a = e.call(this, t, s) || this, a.reset_(), a.on(a.player_, "durationchange", a.handleDurationchange), em && "hidden" in Mt && "visibilityState" in Mt && a.on(Mt, "visibilitychange", a.handleVisibilityChange), a;
  }
  var i = r.prototype;
  return i.handleVisibilityChange = function() {
    this.player_.duration() === 1 / 0 && (Mt.hidden ? this.stopTracking() : this.startTracking());
  }, i.isBehind_ = function() {
    if (!this.timeupdateSeen_)
      return !1;
    var n = this.liveCurrentTime(), a = this.player_.currentTime(), s = this.seekableIncrement_ * 2 + 0.07;
    return n !== 1 / 0 && n - s >= a;
  }, i.trackLive_ = function() {
    this.pastSeekEnd_ = this.pastSeekEnd_;
    var n = this.player_.seekable();
    if (!(!n || !n.length)) {
      var a = this.seekableEnd();
      a !== this.lastSeekEnd_ && (this.lastSeekEnd_ && (this.seekableIncrementList_ = this.seekableIncrementList_.slice(-11), this.seekableIncrementList_.push(Math.abs(a - this.lastSeekEnd_)), this.seekableIncrementList_.length > 3 && (this.seekableIncrement_ = j2(this.seekableIncrementList_))), this.pastSeekEnd_ = 0, this.lastSeekEnd_ = a, this.trigger("seekableendchange")), this.pastSeekEnd_ = this.pastSeekEnd() + 0.03, this.isBehind_() !== this.behindLiveEdge() && (this.behindLiveEdge_ = this.isBehind_(), this.trigger("liveedgechange"));
    }
  }, i.handleDurationchange = function() {
    this.player_.duration() === 1 / 0 ? this.startTracking() : this.stopTracking();
  }, i.startTracking = function() {
    var n = this;
    this.isTracking() || (this.timeupdateSeen_ || (this.timeupdateSeen_ = this.player_.hasStarted()), this.trackingInterval_ = this.setInterval(this.trackLive_, 30), this.trackLive_(), this.on(this.player_, "play", this.trackLive_), this.on(this.player_, "pause", this.trackLive_), this.timeupdateSeen_ || (this.one(this.player_, "play", this.handlePlay), this.handleTimeupdate = function() {
      n.timeupdateSeen_ = !0, n.handleTimeupdate = null;
    }, this.one(this.player_, "timeupdate", this.handleTimeupdate)));
  }, i.handlePlay = function() {
    this.one(this.player_, "timeupdate", this.seekToLiveEdge);
  }, i.reset_ = function() {
    this.pastSeekEnd_ = 0, this.lastSeekEnd_ = null, this.behindLiveEdge_ = null, this.timeupdateSeen_ = !1, this.clearInterval(this.trackingInterval_), this.trackingInterval_ = null, this.seekableIncrement_ = 12, this.seekableIncrementList_ = [], this.off(this.player_, "play", this.trackLive_), this.off(this.player_, "pause", this.trackLive_), this.off(this.player_, "play", this.handlePlay), this.off(this.player_, "timeupdate", this.seekToLiveEdge), this.handleTimeupdate && (this.off(this.player_, "timeupdate", this.handleTimeupdate), this.handleTimeupdate = null);
  }, i.stopTracking = function() {
    !this.isTracking() || this.reset_();
  }, i.seekableEnd = function() {
    for (var n = this.player_.seekable(), a = [], s = n ? n.length : 0; s--; )
      a.push(n.end(s));
    return a.length ? a.sort()[a.length - 1] : 1 / 0;
  }, i.seekableStart = function() {
    for (var n = this.player_.seekable(), a = [], s = n ? n.length : 0; s--; )
      a.push(n.start(s));
    return a.length ? a.sort()[0] : 0;
  }, i.liveWindow = function() {
    var n = this.liveCurrentTime();
    return n === 1 / 0 ? 1 / 0 : n - this.seekableStart();
  }, i.isLive = function() {
    return this.isTracking();
  }, i.atLiveEdge = function() {
    return !this.behindLiveEdge();
  }, i.liveCurrentTime = function() {
    return this.pastSeekEnd() + this.seekableEnd();
  }, i.pastSeekEnd = function() {
    return this.pastSeekEnd_;
  }, i.behindLiveEdge = function() {
    return this.behindLiveEdge_;
  }, i.isTracking = function() {
    return typeof this.trackingInterval_ == "number";
  }, i.seekToLiveEdge = function() {
    this.atLiveEdge() || (this.player_.currentTime(this.liveCurrentTime()), this.player_.paused() && this.player_.play());
  }, i.dispose = function() {
    this.stopTracking(), e.prototype.dispose.call(this);
  }, r;
}(bt);
bt.registerComponent("LiveTracker", $2);
var $g = function(r) {
  var i = r.el();
  if (i.hasAttribute("src"))
    return r.triggerSourceset(i.src), !0;
  var t = r.$$("source"), n = [], a = "";
  if (!t.length)
    return !1;
  for (var s = 0; s < t.length; s++) {
    var o = t[s].src;
    o && n.indexOf(o) === -1 && n.push(o);
  }
  return n.length ? (n.length === 1 && (a = n[0]), r.triggerSourceset(a), !0) : !1;
}, G2 = Object.defineProperty({}, "innerHTML", {
  get: function() {
    return this.cloneNode(!0).innerHTML;
  },
  set: function(r) {
    var i = Mt.createElement(this.nodeName.toLowerCase());
    i.innerHTML = r;
    for (var t = Mt.createDocumentFragment(); i.childNodes.length; )
      t.appendChild(i.childNodes[0]);
    return this.innerText = "", Be.Element.prototype.appendChild.call(this, t), this.innerHTML;
  }
}), iE = function(r, i) {
  for (var t = {}, n = 0; n < r.length && (t = Object.getOwnPropertyDescriptor(r[n], i), !(t && t.set && t.get)); n++)
    ;
  return t.enumerable = !0, t.configurable = !0, t;
}, H2 = function(r) {
  return iE([r.el(), Be.HTMLMediaElement.prototype, Be.Element.prototype, G2], "innerHTML");
}, U_ = function(r) {
  var i = r.el();
  if (!i.resetSourceWatch_) {
    var t = {}, n = H2(r), a = function(o) {
      return function() {
        for (var l = arguments.length, u = new Array(l), h = 0; h < l; h++)
          u[h] = arguments[h];
        var c = o.apply(i, u);
        return $g(r), c;
      };
    };
    ["append", "appendChild", "insertAdjacentHTML"].forEach(function(s) {
      !i[s] || (t[s] = i[s], i[s] = a(t[s]));
    }), Object.defineProperty(i, "innerHTML", Ti(n, {
      set: a(n.set)
    })), i.resetSourceWatch_ = function() {
      i.resetSourceWatch_ = null, Object.keys(t).forEach(function(s) {
        i[s] = t[s];
      }), Object.defineProperty(i, "innerHTML", n);
    }, r.one("sourceset", i.resetSourceWatch_);
  }
}, V2 = Object.defineProperty({}, "src", {
  get: function() {
    return this.hasAttribute("src") ? OS(Be.Element.prototype.getAttribute.call(this, "src")) : "";
  },
  set: function(r) {
    return Be.Element.prototype.setAttribute.call(this, "src", r), r;
  }
}), q2 = function(r) {
  return iE([r.el(), Be.HTMLMediaElement.prototype, V2], "src");
}, W2 = function(r) {
  if (!!r.featuresSourceset) {
    var i = r.el();
    if (!i.resetSourceset_) {
      var t = q2(r), n = i.setAttribute, a = i.load;
      Object.defineProperty(i, "src", Ti(t, {
        set: function(o) {
          var l = t.set.call(i, o);
          return r.triggerSourceset(i.src), l;
        }
      })), i.setAttribute = function(s, o) {
        var l = n.call(i, s, o);
        return /src/i.test(s) && r.triggerSourceset(i.src), l;
      }, i.load = function() {
        var s = a.call(i);
        return $g(r) || (r.triggerSourceset(""), U_(r)), s;
      }, i.currentSrc ? r.triggerSourceset(i.currentSrc) : $g(r) || U_(r), i.resetSourceset_ = function() {
        i.resetSourceset_ = null, i.load = a, i.setAttribute = n, Object.defineProperty(i, "src", t), i.resetSourceWatch_ && i.resetSourceWatch_();
      };
    }
  }
}, jt = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n) {
    var a;
    a = e.call(this, t, n) || this;
    var s = t.source, o = !1;
    if (s && (a.el_.currentSrc !== s.src || t.tag && t.tag.initNetworkState_ === 3) ? a.setSource(s) : a.handleLateInit_(a.el_), t.enableSourceset && a.setupSourcesetHandling_(), a.el_.hasChildNodes()) {
      for (var l = a.el_.childNodes, u = l.length, h = []; u--; ) {
        var c = l[u], d = c.nodeName.toLowerCase();
        d === "track" && (a.featuresNativeTextTracks ? (a.remoteTextTrackEls().addTrackElement_(c), a.remoteTextTracks().addTrack(c.track), a.textTracks().addTrack(c.track), !o && !a.el_.hasAttribute("crossorigin") && Bh(c.src) && (o = !0)) : h.push(c));
      }
      for (var f = 0; f < h.length; f++)
        a.el_.removeChild(h[f]);
    }
    return a.proxyNativeTracks_(), a.featuresNativeTextTracks && o && qr.warn(`Text Tracks are being loaded from another origin but the crossorigin attribute isn't used.
This may prevent text tracks from loading.`), a.restoreMetadataTracksInIOSNativePlayer_(), (ld || Jv || AS) && t.nativeControlsForTouch === !0 && a.setControls(!0), a.proxyWebkitFullscreen_(), a.triggerReady(), a;
  }
  var i = r.prototype;
  return i.dispose = function() {
    this.el_ && this.el_.resetSourceset_ && this.el_.resetSourceset_(), r.disposeMediaElement(this.el_), this.options_ = null, e.prototype.dispose.call(this);
  }, i.setupSourcesetHandling_ = function() {
    W2(this);
  }, i.restoreMetadataTracksInIOSNativePlayer_ = function() {
    var n = this.textTracks(), a, s = function() {
      a = [];
      for (var u = 0; u < n.length; u++) {
        var h = n[u];
        h.kind === "metadata" && a.push({
          track: h,
          storedMode: h.mode
        });
      }
    };
    s(), n.addEventListener("change", s), this.on("dispose", function() {
      return n.removeEventListener("change", s);
    });
    var o = function l() {
      for (var u = 0; u < a.length; u++) {
        var h = a[u];
        h.track.mode === "disabled" && h.track.mode !== h.storedMode && (h.track.mode = h.storedMode);
      }
      n.removeEventListener("change", l);
    };
    this.on("webkitbeginfullscreen", function() {
      n.removeEventListener("change", s), n.removeEventListener("change", o), n.addEventListener("change", o);
    }), this.on("webkitendfullscreen", function() {
      n.removeEventListener("change", s), n.addEventListener("change", s), n.removeEventListener("change", o);
    });
  }, i.overrideNative_ = function(n, a) {
    var s = this;
    if (a === this["featuresNative" + n + "Tracks"]) {
      var o = n.toLowerCase();
      this[o + "TracksListeners_"] && Object.keys(this[o + "TracksListeners_"]).forEach(function(l) {
        var u = s.el()[o + "Tracks"];
        u.removeEventListener(l, s[o + "TracksListeners_"][l]);
      }), this["featuresNative" + n + "Tracks"] = !a, this[o + "TracksListeners_"] = null, this.proxyNativeTracksForType_(o);
    }
  }, i.overrideNativeAudioTracks = function(n) {
    this.overrideNative_("Audio", n);
  }, i.overrideNativeVideoTracks = function(n) {
    this.overrideNative_("Video", n);
  }, i.proxyNativeTracksForType_ = function(n) {
    var a = this, s = qa[n], o = this.el()[s.getterName], l = this[s.getterName]();
    if (!(!this["featuresNative" + s.capitalName + "Tracks"] || !o || !o.addEventListener)) {
      var u = {
        change: function(d) {
          l.trigger({
            type: "change",
            target: l,
            currentTarget: l,
            srcElement: l
          });
        },
        addtrack: function(d) {
          l.addTrack(d.track);
        },
        removetrack: function(d) {
          l.removeTrack(d.track);
        }
      }, h = function() {
        for (var d = [], f = 0; f < l.length; f++) {
          for (var m = !1, p = 0; p < o.length; p++)
            if (o[p] === l[f]) {
              m = !0;
              break;
            }
          m || d.push(l[f]);
        }
        for (; d.length; )
          l.removeTrack(d.shift());
      };
      this[s.getterName + "Listeners_"] = u, Object.keys(u).forEach(function(c) {
        var d = u[c];
        o.addEventListener(c, d), a.on("dispose", function(f) {
          return o.removeEventListener(c, d);
        });
      }), this.on("loadstart", h), this.on("dispose", function(c) {
        return a.off("loadstart", h);
      });
    }
  }, i.proxyNativeTracks_ = function() {
    var n = this;
    qa.names.forEach(function(a) {
      n.proxyNativeTracksForType_(a);
    });
  }, i.createEl = function() {
    var n = this.options_.tag;
    if (!n || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
      if (n) {
        var a = n.cloneNode(!0);
        n.parentNode && n.parentNode.insertBefore(a, n), r.disposeMediaElement(n), n = a;
      } else {
        n = Mt.createElement("video");
        var s = this.options_.tag && io(this.options_.tag), o = Ti({}, s);
        (!ld || this.options_.nativeControlsForTouch !== !0) && delete o.controls, nS(n, Ui(o, {
          id: this.options_.techId,
          class: "vjs-tech"
        }));
      }
      n.playerId = this.options_.playerId;
    }
    typeof this.options_.preload < "u" && od(n, "preload", this.options_.preload);
    for (var l = ["loop", "muted", "playsinline", "autoplay"], u = 0; u < l.length; u++) {
      var h = l[u], c = this.options_[h];
      typeof c < "u" && (c ? od(n, h, h) : Nh(n, h), n[h] = c);
    }
    return n;
  }, i.handleLateInit_ = function(n) {
    if (!(n.networkState === 0 || n.networkState === 3)) {
      if (n.readyState === 0) {
        var a = !1, s = function() {
          a = !0;
        };
        this.on("loadstart", s);
        var o = function() {
          a || this.trigger("loadstart");
        };
        this.on("loadedmetadata", o), this.ready(function() {
          this.off("loadstart", s), this.off("loadedmetadata", o), a || this.trigger("loadstart");
        });
        return;
      }
      var l = ["loadstart"];
      l.push("loadedmetadata"), n.readyState >= 2 && l.push("loadeddata"), n.readyState >= 3 && l.push("canplay"), n.readyState >= 4 && l.push("canplaythrough"), this.ready(function() {
        l.forEach(function(u) {
          this.trigger(u);
        }, this);
      });
    }
  }, i.setCurrentTime = function(n) {
    try {
      this.el_.currentTime = n;
    } catch (a) {
      qr(a, "Video is not ready. (Video.js)");
    }
  }, i.duration = function() {
    var n = this;
    if (this.el_.duration === 1 / 0 && lu && Eo && this.el_.currentTime === 0) {
      var a = function s() {
        n.el_.currentTime > 0 && (n.el_.duration === 1 / 0 && n.trigger("durationchange"), n.off("timeupdate", s));
      };
      return this.on("timeupdate", a), NaN;
    }
    return this.el_.duration || NaN;
  }, i.width = function() {
    return this.el_.offsetWidth;
  }, i.height = function() {
    return this.el_.offsetHeight;
  }, i.proxyWebkitFullscreen_ = function() {
    var n = this;
    if ("webkitDisplayingFullscreen" in this.el_) {
      var a = function() {
        this.trigger("fullscreenchange", {
          isFullscreen: !1
        });
      }, s = function() {
        "webkitPresentationMode" in this.el_ && this.el_.webkitPresentationMode !== "picture-in-picture" && (this.one("webkitendfullscreen", a), this.trigger("fullscreenchange", {
          isFullscreen: !0
        }));
      };
      this.on("webkitbeginfullscreen", s), this.on("dispose", function() {
        n.off("webkitbeginfullscreen", s), n.off("webkitendfullscreen", a);
      });
    }
  }, i.supportsFullScreen = function() {
    if (typeof this.el_.webkitEnterFullScreen == "function") {
      var n = Be.navigator && Be.navigator.userAgent || "";
      if (/Android/.test(n) || !/Chrome|Mac OS X 10.5/.test(n))
        return !0;
    }
    return !1;
  }, i.enterFullScreen = function() {
    var n = this.el_;
    n.paused && n.networkState <= n.HAVE_METADATA ? (this.el_.play(), this.setTimeout(function() {
      n.pause(), n.webkitEnterFullScreen();
    }, 0)) : n.webkitEnterFullScreen();
  }, i.exitFullScreen = function() {
    this.el_.webkitExitFullScreen();
  }, i.requestPictureInPicture = function() {
    return this.el_.requestPictureInPicture();
  }, i.src = function(n) {
    if (n === void 0)
      return this.el_.src;
    this.setSrc(n);
  }, i.reset = function() {
    r.resetMediaElement(this.el_);
  }, i.currentSrc = function() {
    return this.currentSource_ ? this.currentSource_.src : this.el_.currentSrc;
  }, i.setControls = function(n) {
    this.el_.controls = !!n;
  }, i.addTextTrack = function(n, a, s) {
    return this.featuresNativeTextTracks ? this.el_.addTextTrack(n, a, s) : e.prototype.addTextTrack.call(this, n, a, s);
  }, i.createRemoteTextTrack = function(n) {
    if (!this.featuresNativeTextTracks)
      return e.prototype.createRemoteTextTrack.call(this, n);
    var a = Mt.createElement("track");
    return n.kind && (a.kind = n.kind), n.label && (a.label = n.label), (n.language || n.srclang) && (a.srclang = n.language || n.srclang), n.default && (a.default = n.default), n.id && (a.id = n.id), n.src && (a.src = n.src), a;
  }, i.addRemoteTextTrack = function(n, a) {
    var s = e.prototype.addRemoteTextTrack.call(this, n, a);
    return this.featuresNativeTextTracks && this.el().appendChild(s), s;
  }, i.removeRemoteTextTrack = function(n) {
    if (e.prototype.removeRemoteTextTrack.call(this, n), this.featuresNativeTextTracks)
      for (var a = this.$$("track"), s = a.length; s--; )
        (n === a[s] || n === a[s].track) && this.el().removeChild(a[s]);
  }, i.getVideoPlaybackQuality = function() {
    if (typeof this.el().getVideoPlaybackQuality == "function")
      return this.el().getVideoPlaybackQuality();
    var n = {};
    return typeof this.el().webkitDroppedFrameCount < "u" && typeof this.el().webkitDecodedFrameCount < "u" && (n.droppedVideoFrames = this.el().webkitDroppedFrameCount, n.totalVideoFrames = this.el().webkitDecodedFrameCount), Be.performance && typeof Be.performance.now == "function" ? n.creationTime = Be.performance.now() : Be.performance && Be.performance.timing && typeof Be.performance.timing.navigationStart == "number" && (n.creationTime = Be.Date.now() - Be.performance.timing.navigationStart), n;
  }, r;
}(Ci);
if (sc()) {
  jt.TEST_VID = Mt.createElement("video");
  var df = Mt.createElement("track");
  df.kind = "captions", df.srclang = "en", df.label = "English", jt.TEST_VID.appendChild(df);
}
jt.isSupported = function() {
  try {
    jt.TEST_VID.volume = 0.5;
  } catch {
    return !1;
  }
  return !!(jt.TEST_VID && jt.TEST_VID.canPlayType);
};
jt.canPlayType = function(e) {
  return jt.TEST_VID.canPlayType(e);
};
jt.canPlaySource = function(e, r) {
  return jt.canPlayType(e.type);
};
jt.canControlVolume = function() {
  try {
    var e = jt.TEST_VID.volume;
    return jt.TEST_VID.volume = e / 2 + 0.1, e !== jt.TEST_VID.volume;
  } catch {
    return !1;
  }
};
jt.canMuteVolume = function() {
  try {
    var e = jt.TEST_VID.muted;
    return jt.TEST_VID.muted = !e, jt.TEST_VID.muted ? od(jt.TEST_VID, "muted", "muted") : Nh(jt.TEST_VID, "muted", "muted"), e !== jt.TEST_VID.muted;
  } catch {
    return !1;
  }
};
jt.canControlPlaybackRate = function() {
  if (lu && Eo && CS < 58)
    return !1;
  try {
    var e = jt.TEST_VID.playbackRate;
    return jt.TEST_VID.playbackRate = e / 2 + 0.1, e !== jt.TEST_VID.playbackRate;
  } catch {
    return !1;
  }
};
jt.canOverrideAttributes = function() {
  try {
    var e = function() {
    };
    Object.defineProperty(Mt.createElement("video"), "src", {
      get: e,
      set: e
    }), Object.defineProperty(Mt.createElement("audio"), "src", {
      get: e,
      set: e
    }), Object.defineProperty(Mt.createElement("video"), "innerHTML", {
      get: e,
      set: e
    }), Object.defineProperty(Mt.createElement("audio"), "innerHTML", {
      get: e,
      set: e
    });
  } catch {
    return !1;
  }
  return !0;
};
jt.supportsNativeTextTracks = function() {
  return tm || cs && Eo;
};
jt.supportsNativeVideoTracks = function() {
  return !!(jt.TEST_VID && jt.TEST_VID.videoTracks);
};
jt.supportsNativeAudioTracks = function() {
  return !!(jt.TEST_VID && jt.TEST_VID.audioTracks);
};
jt.Events = ["loadstart", "suspend", "abort", "error", "emptied", "stalled", "loadedmetadata", "loadeddata", "canplay", "canplaythrough", "playing", "waiting", "seeking", "seeked", "ended", "durationchange", "timeupdate", "progress", "play", "pause", "ratechange", "resize", "volumechange"];
jt.prototype.featuresVolumeControl = jt.canControlVolume();
jt.prototype.featuresMuteControl = jt.canMuteVolume();
jt.prototype.featuresPlaybackRate = jt.canControlPlaybackRate();
jt.prototype.featuresSourceset = jt.canOverrideAttributes();
jt.prototype.movingMediaElementInDOM = !cs;
jt.prototype.featuresFullscreenResize = !0;
jt.prototype.featuresProgressEvents = !0;
jt.prototype.featuresTimeupdateEvents = !0;
jt.prototype.featuresNativeTextTracks = jt.supportsNativeTextTracks();
jt.prototype.featuresNativeVideoTracks = jt.supportsNativeVideoTracks();
jt.prototype.featuresNativeAudioTracks = jt.supportsNativeAudioTracks();
var nE = jt.TEST_VID && jt.TEST_VID.constructor.prototype.canPlayType, Y2 = /^application\/(?:x-|vnd\.apple\.)mpegurl/i;
jt.patchCanPlayType = function() {
  Qv >= 4 && !wS && !Eo && (jt.TEST_VID.constructor.prototype.canPlayType = function(e) {
    return e && Y2.test(e) ? "maybe" : nE.call(this, e);
  });
};
jt.unpatchCanPlayType = function() {
  var e = jt.TEST_VID.constructor.prototype.canPlayType;
  return jt.TEST_VID.constructor.prototype.canPlayType = nE, e;
};
jt.patchCanPlayType();
jt.disposeMediaElement = function(e) {
  if (!!e) {
    for (e.parentNode && e.parentNode.removeChild(e); e.hasChildNodes(); )
      e.removeChild(e.firstChild);
    e.removeAttribute("src"), typeof e.load == "function" && function() {
      try {
        e.load();
      } catch {
      }
    }();
  }
};
jt.resetMediaElement = function(e) {
  if (!!e) {
    for (var r = e.querySelectorAll("source"), i = r.length; i--; )
      e.removeChild(r[i]);
    e.removeAttribute("src"), typeof e.load == "function" && function() {
      try {
        e.load();
      } catch {
      }
    }();
  }
};
[
  "muted",
  "defaultMuted",
  "autoplay",
  "controls",
  "loop",
  "playsinline"
].forEach(function(e) {
  jt.prototype[e] = function() {
    return this.el_[e] || this.el_.hasAttribute(e);
  };
});
[
  "muted",
  "defaultMuted",
  "autoplay",
  "loop",
  "playsinline"
].forEach(function(e) {
  jt.prototype["set" + Wi(e)] = function(r) {
    this.el_[e] = r, r ? this.el_.setAttribute(e, e) : this.el_.removeAttribute(e);
  };
});
[
  "paused",
  "currentTime",
  "buffered",
  "volume",
  "poster",
  "preload",
  "error",
  "seeking",
  "seekable",
  "ended",
  "playbackRate",
  "defaultPlaybackRate",
  "played",
  "networkState",
  "readyState",
  "videoWidth",
  "videoHeight"
].forEach(function(e) {
  jt.prototype[e] = function() {
    return this.el_[e];
  };
});
[
  "volume",
  "src",
  "poster",
  "preload",
  "playbackRate",
  "defaultPlaybackRate"
].forEach(function(e) {
  jt.prototype["set" + Wi(e)] = function(r) {
    this.el_[e] = r;
  };
});
[
  "pause",
  "load",
  "play"
].forEach(function(e) {
  jt.prototype[e] = function() {
    return this.el_[e]();
  };
});
Ci.withSourceHandlers(jt);
jt.nativeSourceHandler = {};
jt.nativeSourceHandler.canPlayType = function(e) {
  try {
    return jt.TEST_VID.canPlayType(e);
  } catch {
    return "";
  }
};
jt.nativeSourceHandler.canHandleSource = function(e, r) {
  if (e.type)
    return jt.nativeSourceHandler.canPlayType(e.type);
  if (e.src) {
    var i = nm(e.src);
    return jt.nativeSourceHandler.canPlayType("video/" + i);
  }
  return "";
};
jt.nativeSourceHandler.handleSource = function(e, r, i) {
  r.setSrc(e.src);
};
jt.nativeSourceHandler.dispose = function() {
};
jt.registerSourceHandler(jt.nativeSourceHandler);
Ci.registerTech("Html5", jt);
var aE = [
  "progress",
  "abort",
  "suspend",
  "emptied",
  "stalled",
  "loadedmetadata",
  "loadeddata",
  "timeupdate",
  "resize",
  "volumechange",
  "texttrackchange"
], Kp = {
  canplay: "CanPlay",
  canplaythrough: "CanPlayThrough",
  playing: "Playing",
  seeked: "Seeked"
}, Gg = ["tiny", "xsmall", "small", "medium", "large", "xlarge", "huge"], Cf = {};
Gg.forEach(function(e) {
  var r = e.charAt(0) === "x" ? "x-" + e.substring(1) : e;
  Cf[e] = "vjs-layout-" + r;
});
var K2 = {
  tiny: 210,
  xsmall: 320,
  small: 425,
  medium: 768,
  large: 1440,
  xlarge: 2560,
  huge: 1 / 0
}, hn = /* @__PURE__ */ function(e) {
  zt(r, e);
  function r(t, n, a) {
    var s;
    if (t.id = t.id || n.id || "vjs_video_" + uu(), n = Ui(r.getTagSettings(t), n), n.initChildren = !1, n.createEl = !1, n.evented = !1, n.reportTouchActivity = !1, !n.language)
      if (typeof t.closest == "function") {
        var o = t.closest("[lang]");
        o && o.getAttribute && (n.language = o.getAttribute("lang"));
      } else
        for (var l = t; l && l.nodeType === 1; ) {
          if (io(l).hasOwnProperty("lang")) {
            n.language = l.getAttribute("lang");
            break;
          }
          l = l.parentNode;
        }
    if (s = e.call(this, null, n, a) || this, s.boundDocumentFullscreenChange_ = Mr(Rr(s), s.documentFullscreenChange_), s.boundFullWindowOnEscKey_ = Mr(Rr(s), s.fullWindowOnEscKey), s.log = QT(s.id_), s.fsApi_ = Ug, s.isPosterFromTech_ = !1, s.queuedCallbacks_ = [], s.isReady_ = !1, s.hasStarted_ = !1, s.userActive_ = !1, !s.options_ || !s.options_.techOrder || !s.options_.techOrder.length)
      throw new Error("No techOrder specified. Did you overwrite videojs.options instead of just changing the properties you want to override?");
    if (s.tag = t, s.tagAttributes = t && io(t), s.language(s.options_.language), n.languages) {
      var u = {};
      Object.getOwnPropertyNames(n.languages).forEach(function(d) {
        u[d.toLowerCase()] = n.languages[d];
      }), s.languages_ = u;
    } else
      s.languages_ = r.prototype.options_.languages;
    s.resetCache_(), s.poster_ = n.poster || "", s.controls_ = !!n.controls, t.controls = !1, t.removeAttribute("controls"), s.changingSrc_ = !1, s.playCallbacks_ = [], s.playTerminatedQueue_ = [], t.hasAttribute("autoplay") ? s.autoplay(!0) : s.autoplay(s.options_.autoplay), n.plugins && Object.keys(n.plugins).forEach(function(d) {
      if (typeof s[d] != "function")
        throw new Error('plugin "' + d + '" does not exist');
    }), s.scrubbing_ = !1, s.el_ = s.createEl(), zv(Rr(s), {
      eventBusKey: "el_"
    }), s.fluid_ && s.on("playerreset", s.updateStyleEl_);
    var h = Ti(s.options_);
    n.plugins && Object.keys(n.plugins).forEach(function(d) {
      s[d](n.plugins[d]);
    }), s.options_.playerOptions = h, s.middleware_ = [], s.initChildren(), s.isAudio(t.nodeName.toLowerCase() === "audio"), s.controls() ? s.addClass("vjs-controls-enabled") : s.addClass("vjs-controls-disabled"), s.el_.setAttribute("role", "region"), s.isAudio() ? s.el_.setAttribute("aria-label", s.localize("Audio Player")) : s.el_.setAttribute("aria-label", s.localize("Video Player")), s.isAudio() && s.addClass("vjs-audio"), s.flexNotSupported_() && s.addClass("vjs-no-flex"), ld && s.addClass("vjs-touch-enabled"), cs || s.addClass("vjs-workinghover"), r.players[s.id_] = Rr(s);
    var c = XT.split(".")[0];
    return s.addClass("vjs-v" + c), s.userActive(!0), s.reportUserActivity(), s.one("play", s.listenForUserActivity_), s.on("stageclick", s.handleStageClick_), s.on("keydown", s.handleKeyDown), s.breakpoints(s.options_.breakpoints), s.responsive(s.options_.responsive), s;
  }
  var i = r.prototype;
  return i.dispose = function() {
    var n = this;
    this.trigger("dispose"), this.off("dispose"), wn(Mt, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), wn(Mt, "keydown", this.boundFullWindowOnEscKey_), this.styleEl_ && this.styleEl_.parentNode && (this.styleEl_.parentNode.removeChild(this.styleEl_), this.styleEl_ = null), r.players[this.id_] = null, this.tag && this.tag.player && (this.tag.player = null), this.el_ && this.el_.player && (this.el_.player = null), this.tech_ && (this.tech_.dispose(), this.isPosterFromTech_ = !1, this.poster_ = ""), this.playerElIngest_ && (this.playerElIngest_ = null), this.tag && (this.tag = null), p2(this), Xn.names.forEach(function(a) {
      var s = Xn[a], o = n[s.getterName]();
      o && o.off && o.off();
    }), e.prototype.dispose.call(this);
  }, i.createEl = function() {
    var n = this.tag, a, s = this.playerElIngest_ = n.parentNode && n.parentNode.hasAttribute && n.parentNode.hasAttribute("data-vjs-player"), o = this.tag.tagName.toLowerCase() === "video-js";
    s ? a = this.el_ = n.parentNode : o || (a = this.el_ = e.prototype.createEl.call(this, "div"));
    var l = io(n);
    if (o) {
      for (a = this.el_ = n, n = this.tag = Mt.createElement("video"); a.children.length; )
        n.appendChild(a.firstChild);
      Vu(a, "video-js") || lo(a, "video-js"), a.appendChild(n), s = this.playerElIngest_ = a, Object.keys(a).forEach(function(m) {
        try {
          n[m] = a[m];
        } catch {
        }
      });
    }
    if (n.setAttribute("tabindex", "-1"), l.tabindex = "-1", (em || Eo && kS) && (n.setAttribute("role", "application"), l.role = "application"), n.removeAttribute("width"), n.removeAttribute("height"), "width" in l && delete l.width, "height" in l && delete l.height, Object.getOwnPropertyNames(l).forEach(function(m) {
      o && m === "class" || a.setAttribute(m, l[m]), o && n.setAttribute(m, l[m]);
    }), n.playerId = n.id, n.id += "_html5_api", n.className = "vjs-tech", n.player = a.player = this, this.addClass("vjs-paused"), Be.VIDEOJS_NO_DYNAMIC_STYLE !== !0) {
      this.styleEl_ = gS("vjs-styles-dimensions");
      var u = ru(".vjs-styles-defaults"), h = ru("head");
      h.insertBefore(this.styleEl_, u ? u.nextSibling : h.firstChild);
    }
    this.fill_ = !1, this.fluid_ = !1, this.width(this.options_.width), this.height(this.options_.height), this.fill(this.options_.fill), this.fluid(this.options_.fluid), this.aspectRatio(this.options_.aspectRatio);
    for (var c = n.getElementsByTagName("a"), d = 0; d < c.length; d++) {
      var f = c.item(d);
      lo(f, "vjs-hidden"), f.setAttribute("hidden", "hidden");
    }
    return n.initNetworkState_ = n.networkState, n.parentNode && !s && n.parentNode.insertBefore(a, n), Lg(n, a), this.children_.unshift(n), this.el_.setAttribute("lang", this.language_), this.el_ = a, a;
  }, i.width = function(n) {
    return this.dimension("width", n);
  }, i.height = function(n) {
    return this.dimension("height", n);
  }, i.dimension = function(n, a) {
    var s = n + "_";
    if (a === void 0)
      return this[s] || 0;
    if (a === "") {
      this[s] = void 0, this.updateStyleEl_();
      return;
    }
    var o = parseFloat(a);
    if (isNaN(o)) {
      qr.error('Improper value "' + a + '" supplied for for ' + n);
      return;
    }
    this[s] = o, this.updateStyleEl_();
  }, i.fluid = function(n) {
    if (n === void 0)
      return !!this.fluid_;
    this.fluid_ = !!n, Zu(this) && this.off("playerreset", this.updateStyleEl_), n ? (this.addClass("vjs-fluid"), this.fill(!1), FR(function() {
      this.on("playerreset", this.updateStyleEl_);
    })) : this.removeClass("vjs-fluid"), this.updateStyleEl_();
  }, i.fill = function(n) {
    if (n === void 0)
      return !!this.fill_;
    this.fill_ = !!n, n ? (this.addClass("vjs-fill"), this.fluid(!1)) : this.removeClass("vjs-fill");
  }, i.aspectRatio = function(n) {
    if (n === void 0)
      return this.aspectRatio_;
    if (!/^\d+\:\d+$/.test(n))
      throw new Error("Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.");
    this.aspectRatio_ = n, this.fluid(!0), this.updateStyleEl_();
  }, i.updateStyleEl_ = function() {
    if (Be.VIDEOJS_NO_DYNAMIC_STYLE === !0) {
      var n = typeof this.width_ == "number" ? this.width_ : this.options_.width, a = typeof this.height_ == "number" ? this.height_ : this.options_.height, s = this.tech_ && this.tech_.el();
      s && (n >= 0 && (s.width = n), a >= 0 && (s.height = a));
      return;
    }
    var o, l, u, h;
    this.aspectRatio_ !== void 0 && this.aspectRatio_ !== "auto" ? u = this.aspectRatio_ : this.videoWidth() > 0 ? u = this.videoWidth() + ":" + this.videoHeight() : u = "16:9";
    var c = u.split(":"), d = c[1] / c[0];
    this.width_ !== void 0 ? o = this.width_ : this.height_ !== void 0 ? o = this.height_ / d : o = this.videoWidth() || 300, this.height_ !== void 0 ? l = this.height_ : l = o * d, /^[^a-zA-Z]/.test(this.id()) ? h = "dimensions-" + this.id() : h = this.id() + "-dimensions", this.addClass(h), vS(this.styleEl_, `
      .` + h + ` {
        width: ` + o + `px;
        height: ` + l + `px;
      }

      .` + h + `.vjs-fluid {
        padding-top: ` + d * 100 + `%;
      }
    `);
  }, i.loadTech_ = function(n, a) {
    var s = this;
    this.tech_ && this.unloadTech_();
    var o = Wi(n), l = n.charAt(0).toLowerCase() + n.slice(1);
    o !== "Html5" && this.tag && (Ci.getTech("Html5").disposeMediaElement(this.tag), this.tag.player = null, this.tag = null), this.techName_ = o, this.isReady_ = !1;
    var u = typeof this.autoplay() == "string" ? !1 : this.autoplay(), h = {
      source: a,
      autoplay: u,
      nativeControlsForTouch: this.options_.nativeControlsForTouch,
      playerId: this.id(),
      techId: this.id() + "_" + l + "_api",
      playsinline: this.options_.playsinline,
      preload: this.options_.preload,
      loop: this.options_.loop,
      muted: this.options_.muted,
      poster: this.poster(),
      language: this.language(),
      playerElIngest: this.playerElIngest_ || !1,
      "vtt.js": this.options_["vtt.js"],
      canOverridePoster: !!this.options_.techCanOverridePoster,
      enableSourceset: this.options_.enableSourceset,
      Promise: this.options_.Promise
    };
    Xn.names.forEach(function(d) {
      var f = Xn[d];
      h[f.getterName] = s[f.privateName];
    }), Ui(h, this.options_[o]), Ui(h, this.options_[l]), Ui(h, this.options_[n.toLowerCase()]), this.tag && (h.tag = this.tag), a && a.src === this.cache_.src && this.cache_.currentTime > 0 && (h.startTime = this.cache_.currentTime);
    var c = Ci.getTech(n);
    if (!c)
      throw new Error("No Tech named '" + o + "' exists! '" + o + "' should be registered using videojs.registerTech()'");
    this.tech_ = new c(h), this.tech_.ready(Mr(this, this.handleTechReady_), !0), __.jsonToTextTracks(this.textTracksJson_ || [], this.tech_), aE.forEach(function(d) {
      s.on(s.tech_, d, s["handleTech" + Wi(d) + "_"]);
    }), Object.keys(Kp).forEach(function(d) {
      s.on(s.tech_, d, function(f) {
        if (s.tech_.playbackRate() === 0 && s.tech_.seeking()) {
          s.queuedCallbacks_.push({
            callback: s["handleTech" + Kp[d] + "_"].bind(s),
            event: f
          });
          return;
        }
        s["handleTech" + Kp[d] + "_"](f);
      });
    }), this.on(this.tech_, "loadstart", this.handleTechLoadStart_), this.on(this.tech_, "sourceset", this.handleTechSourceset_), this.on(this.tech_, "waiting", this.handleTechWaiting_), this.on(this.tech_, "ended", this.handleTechEnded_), this.on(this.tech_, "seeking", this.handleTechSeeking_), this.on(this.tech_, "play", this.handleTechPlay_), this.on(this.tech_, "firstplay", this.handleTechFirstPlay_), this.on(this.tech_, "pause", this.handleTechPause_), this.on(this.tech_, "durationchange", this.handleTechDurationChange_), this.on(this.tech_, "fullscreenchange", this.handleTechFullscreenChange_), this.on(this.tech_, "enterpictureinpicture", this.handleTechEnterPictureInPicture_), this.on(this.tech_, "leavepictureinpicture", this.handleTechLeavePictureInPicture_), this.on(this.tech_, "error", this.handleTechError_), this.on(this.tech_, "loadedmetadata", this.updateStyleEl_), this.on(this.tech_, "posterchange", this.handleTechPosterChange_), this.on(this.tech_, "textdata", this.handleTechTextData_), this.on(this.tech_, "ratechange", this.handleTechRateChange_), this.usingNativeControls(this.techGet_("controls")), this.controls() && !this.usingNativeControls() && this.addTechControlsListeners_(), this.tech_.el().parentNode !== this.el() && (o !== "Html5" || !this.tag) && Lg(this.tech_.el(), this.el()), this.tag && (this.tag.player = null, this.tag = null);
  }, i.unloadTech_ = function() {
    var n = this;
    Xn.names.forEach(function(a) {
      var s = Xn[a];
      n[s.privateName] = n[s.getterName]();
    }), this.textTracksJson_ = __.textTracksToJson(this.tech_), this.isReady_ = !1, this.tech_.dispose(), this.tech_ = !1, this.isPosterFromTech_ && (this.poster_ = "", this.trigger("posterchange")), this.isPosterFromTech_ = !1;
  }, i.tech = function(n) {
    return n === void 0 && qr.warn(`Using the tech directly can be dangerous. I hope you know what you're doing.
See https://github.com/videojs/video.js/issues/2617 for more info.
`), this.tech_;
  }, i.addTechControlsListeners_ = function() {
    this.removeTechControlsListeners_(), this.on(this.tech_, "mouseup", this.handleTechClick_), this.on(this.tech_, "dblclick", this.handleTechDoubleClick_), this.on(this.tech_, "touchstart", this.handleTechTouchStart_), this.on(this.tech_, "touchmove", this.handleTechTouchMove_), this.on(this.tech_, "touchend", this.handleTechTouchEnd_), this.on(this.tech_, "tap", this.handleTechTap_);
  }, i.removeTechControlsListeners_ = function() {
    this.off(this.tech_, "tap", this.handleTechTap_), this.off(this.tech_, "touchstart", this.handleTechTouchStart_), this.off(this.tech_, "touchmove", this.handleTechTouchMove_), this.off(this.tech_, "touchend", this.handleTechTouchEnd_), this.off(this.tech_, "mouseup", this.handleTechClick_), this.off(this.tech_, "dblclick", this.handleTechDoubleClick_);
  }, i.handleTechReady_ = function() {
    this.triggerReady(), this.cache_.volume && this.techCall_("setVolume", this.cache_.volume), this.handleTechPosterChange_(), this.handleTechDurationChange_();
  }, i.handleTechLoadStart_ = function() {
    this.removeClass("vjs-ended"), this.removeClass("vjs-seeking"), this.error(null), this.handleTechDurationChange_(), this.paused() ? (this.hasStarted(!1), this.trigger("loadstart")) : (this.trigger("loadstart"), this.trigger("firstplay")), this.manualAutoplay_(this.autoplay());
  }, i.manualAutoplay_ = function(n) {
    var a = this;
    if (!(!this.tech_ || typeof n != "string")) {
      var s = function() {
        var u = a.muted();
        a.muted(!0);
        var h = function() {
          a.muted(u);
        };
        a.playTerminatedQueue_.push(h);
        var c = a.play();
        if (!!Xc(c))
          return c.catch(h);
      }, o;
      if (n === "any" && this.muted() !== !0 ? (o = this.play(), Xc(o) && (o = o.catch(s))) : n === "muted" && this.muted() !== !0 ? o = s() : o = this.play(), !!Xc(o))
        return o.then(function() {
          a.trigger({
            type: "autoplay-success",
            autoplay: n
          });
        }).catch(function(l) {
          a.trigger({
            type: "autoplay-failure",
            autoplay: n
          });
        });
    }
  }, i.updateSourceCaches_ = function(n) {
    n === void 0 && (n = "");
    var a = n, s = "";
    typeof a != "string" && (a = n.src, s = n.type), this.cache_.source = this.cache_.source || {}, this.cache_.sources = this.cache_.sources || [], a && !s && (s = m2(this, a)), this.cache_.source = Ti({}, n, {
      src: a,
      type: s
    });
    for (var o = this.cache_.sources.filter(function(f) {
      return f.src && f.src === a;
    }), l = [], u = this.$$("source"), h = [], c = 0; c < u.length; c++) {
      var d = io(u[c]);
      l.push(d), d.src && d.src === a && h.push(d.src);
    }
    h.length && !o.length ? this.cache_.sources = l : o.length || (this.cache_.sources = [this.cache_.source]), this.cache_.src = a;
  }, i.handleTechSourceset_ = function(n) {
    var a = this;
    if (!this.changingSrc_) {
      var s = function(h) {
        return a.updateSourceCaches_(h);
      }, o = this.currentSource().src, l = n.src;
      o && !/^blob:/.test(o) && /^blob:/.test(l) && (!this.lastSource_ || this.lastSource_.tech !== l && this.lastSource_.player !== o) && (s = function() {
      }), s(l), n.src || this.tech_.any(["sourceset", "loadstart"], function(u) {
        if (u.type !== "sourceset") {
          var h = a.techGet("currentSrc");
          a.lastSource_.tech = h, a.updateSourceCaches_(h);
        }
      });
    }
    this.lastSource_ = {
      player: this.currentSource().src,
      tech: n.src
    }, this.trigger({
      src: n.src,
      type: "sourceset"
    });
  }, i.hasStarted = function(n) {
    if (n === void 0)
      return this.hasStarted_;
    n !== this.hasStarted_ && (this.hasStarted_ = n, this.hasStarted_ ? (this.addClass("vjs-has-started"), this.trigger("firstplay")) : this.removeClass("vjs-has-started"));
  }, i.handleTechPlay_ = function() {
    this.removeClass("vjs-ended"), this.removeClass("vjs-paused"), this.addClass("vjs-playing"), this.hasStarted(!0), this.trigger("play");
  }, i.handleTechRateChange_ = function() {
    this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0 && (this.queuedCallbacks_.forEach(function(n) {
      return n.callback(n.event);
    }), this.queuedCallbacks_ = []), this.cache_.lastPlaybackRate = this.tech_.playbackRate(), this.trigger("ratechange");
  }, i.handleTechWaiting_ = function() {
    var n = this;
    this.addClass("vjs-waiting"), this.trigger("waiting");
    var a = this.currentTime(), s = function o() {
      a !== n.currentTime() && (n.removeClass("vjs-waiting"), n.off("timeupdate", o));
    };
    this.on("timeupdate", s);
  }, i.handleTechCanPlay_ = function() {
    this.removeClass("vjs-waiting"), this.trigger("canplay");
  }, i.handleTechCanPlayThrough_ = function() {
    this.removeClass("vjs-waiting"), this.trigger("canplaythrough");
  }, i.handleTechPlaying_ = function() {
    this.removeClass("vjs-waiting"), this.trigger("playing");
  }, i.handleTechSeeking_ = function() {
    this.addClass("vjs-seeking"), this.trigger("seeking");
  }, i.handleTechSeeked_ = function() {
    this.removeClass("vjs-seeking"), this.removeClass("vjs-ended"), this.trigger("seeked");
  }, i.handleTechFirstPlay_ = function() {
    this.options_.starttime && (qr.warn("Passing the `starttime` option to the player will be deprecated in 6.0"), this.currentTime(this.options_.starttime)), this.addClass("vjs-has-started"), this.trigger("firstplay");
  }, i.handleTechPause_ = function() {
    this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.trigger("pause");
  }, i.handleTechEnded_ = function() {
    this.addClass("vjs-ended"), this.options_.loop ? (this.currentTime(0), this.play()) : this.paused() || this.pause(), this.trigger("ended");
  }, i.handleTechDurationChange_ = function() {
    this.duration(this.techGet_("duration"));
  }, i.handleTechClick_ = function(n) {
    !zl(n) || !this.controls_ || (this.paused() ? Wo(this.play()) : this.pause());
  }, i.handleTechDoubleClick_ = function(n) {
    if (!!this.controls_) {
      var a = Array.prototype.some.call(this.$$(".vjs-control-bar, .vjs-modal-dialog"), function(s) {
        return s.contains(n.target);
      });
      a || (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.doubleClick === void 0 || this.options_.userActions.doubleClick !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.doubleClick == "function" ? this.options_.userActions.doubleClick.call(this, n) : this.isFullscreen() ? this.exitFullscreen() : this.requestFullscreen());
    }
  }, i.handleTechTap_ = function() {
    this.userActive(!this.userActive());
  }, i.handleTechTouchStart_ = function() {
    this.userWasActive = this.userActive();
  }, i.handleTechTouchMove_ = function() {
    this.userWasActive && this.reportUserActivity();
  }, i.handleTechTouchEnd_ = function(n) {
    n.preventDefault();
  }, i.handleStageClick_ = function() {
    this.reportUserActivity();
  }, i.toggleFullscreenClass_ = function() {
    this.isFullscreen() ? this.addClass("vjs-fullscreen") : this.removeClass("vjs-fullscreen");
  }, i.documentFullscreenChange_ = function(n) {
    var a = this.el(), s = Mt[this.fsApi_.fullscreenElement] === a;
    !s && a.matches ? s = a.matches(":" + this.fsApi_.fullscreen) : !s && a.msMatchesSelector && (s = a.msMatchesSelector(":" + this.fsApi_.fullscreen)), this.isFullscreen(s), this.isFullscreen() === !1 && wn(Mt, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), this.fsApi_.prefixed && this.trigger("fullscreenchange");
  }, i.handleTechFullscreenChange_ = function(n, a) {
    a && this.isFullscreen(a.isFullscreen), this.trigger("fullscreenchange");
  }, i.togglePictureInPictureClass_ = function() {
    this.isInPictureInPicture() ? this.addClass("vjs-picture-in-picture") : this.removeClass("vjs-picture-in-picture");
  }, i.handleTechEnterPictureInPicture_ = function(n) {
    this.isInPictureInPicture(!0);
  }, i.handleTechLeavePictureInPicture_ = function(n) {
    this.isInPictureInPicture(!1);
  }, i.handleTechError_ = function() {
    var n = this.tech_.error();
    this.error(n);
  }, i.handleTechTextData_ = function() {
    var n = null;
    arguments.length > 1 && (n = arguments[1]), this.trigger("textdata", n);
  }, i.getCache = function() {
    return this.cache_;
  }, i.resetCache_ = function() {
    this.cache_ = {
      currentTime: 0,
      inactivityTimeout: this.options_.inactivityTimeout,
      duration: NaN,
      lastVolume: 1,
      lastPlaybackRate: this.defaultPlaybackRate(),
      media: null,
      src: "",
      source: {},
      sources: [],
      volume: 1
    };
  }, i.techCall_ = function(n, a) {
    this.ready(function() {
      if (n in f2)
        return c2(this.middleware_, this.tech_, n, a);
      if (n in x_)
        return E_(this.middleware_, this.tech_, n, a);
      try {
        this.tech_ && this.tech_[n](a);
      } catch (s) {
        throw qr(s), s;
      }
    }, !0);
  }, i.techGet_ = function(n) {
    if (!(!this.tech_ || !this.tech_.isReady_)) {
      if (n in d2)
        return l2(this.middleware_, this.tech_, n);
      if (n in x_)
        return E_(this.middleware_, this.tech_, n);
      try {
        return this.tech_[n]();
      } catch (a) {
        throw this.tech_[n] === void 0 ? (qr("Video.js: " + n + " method not defined for " + this.techName_ + " playback technology.", a), a) : a.name === "TypeError" ? (qr("Video.js: " + n + " unavailable on " + this.techName_ + " playback technology element.", a), this.tech_.isReady_ = !1, a) : (qr(a), a);
      }
    }
  }, i.play = function() {
    var n = this, a = this.options_.Promise || Be.Promise;
    return a ? new a(function(s) {
      n.play_(s);
    }) : this.play_();
  }, i.play_ = function(n) {
    var a = this;
    n === void 0 && (n = Wo), this.playCallbacks_.push(n);
    var s = Boolean(!this.changingSrc_ && (this.src() || this.currentSrc()));
    if (this.waitToPlay_ && (this.off(["ready", "loadstart"], this.waitToPlay_), this.waitToPlay_ = null), !this.isReady_ || !s) {
      this.waitToPlay_ = function(l) {
        a.play_();
      }, this.one(["ready", "loadstart"], this.waitToPlay_), !s && (tm || cs) && this.load();
      return;
    }
    var o = this.techGet_("play");
    o === null ? this.runPlayTerminatedQueue_() : this.runPlayCallbacks_(o);
  }, i.runPlayTerminatedQueue_ = function() {
    var n = this.playTerminatedQueue_.slice(0);
    this.playTerminatedQueue_ = [], n.forEach(function(a) {
      a();
    });
  }, i.runPlayCallbacks_ = function(n) {
    var a = this.playCallbacks_.slice(0);
    this.playCallbacks_ = [], this.playTerminatedQueue_ = [], a.forEach(function(s) {
      s(n);
    });
  }, i.pause = function() {
    this.techCall_("pause");
  }, i.paused = function() {
    return this.techGet_("paused") !== !1;
  }, i.played = function() {
    return this.techGet_("played") || qu(0, 0);
  }, i.scrubbing = function(n) {
    if (typeof n > "u")
      return this.scrubbing_;
    this.scrubbing_ = !!n, n ? this.addClass("vjs-scrubbing") : this.removeClass("vjs-scrubbing");
  }, i.currentTime = function(n) {
    if (typeof n < "u") {
      n < 0 && (n = 0), this.techCall_("setCurrentTime", n);
      return;
    }
    return this.cache_.currentTime = this.techGet_("currentTime") || 0, this.cache_.currentTime;
  }, i.duration = function(n) {
    if (n === void 0)
      return this.cache_.duration !== void 0 ? this.cache_.duration : NaN;
    n = parseFloat(n), n < 0 && (n = 1 / 0), n !== this.cache_.duration && (this.cache_.duration = n, n === 1 / 0 ? (this.addClass("vjs-live"), this.options_.liveui && this.player_.liveTracker && this.addClass("vjs-liveui")) : (this.removeClass("vjs-live"), this.removeClass("vjs-liveui")), isNaN(n) || this.trigger("durationchange"));
  }, i.remainingTime = function() {
    return this.duration() - this.currentTime();
  }, i.remainingTimeDisplay = function() {
    return Math.floor(this.duration()) - Math.floor(this.currentTime());
  }, i.buffered = function() {
    var n = this.techGet_("buffered");
    return (!n || !n.length) && (n = qu(0, 0)), n;
  }, i.bufferedPercent = function() {
    return RS(this.buffered(), this.duration());
  }, i.bufferedEnd = function() {
    var n = this.buffered(), a = this.duration(), s = n.end(n.length - 1);
    return s > a && (s = a), s;
  }, i.volume = function(n) {
    var a;
    if (n !== void 0) {
      a = Math.max(0, Math.min(1, parseFloat(n))), this.cache_.volume = a, this.techCall_("setVolume", a), a > 0 && this.lastVolume_(a);
      return;
    }
    return a = parseFloat(this.techGet_("volume")), isNaN(a) ? 1 : a;
  }, i.muted = function(n) {
    if (n !== void 0) {
      this.techCall_("setMuted", n);
      return;
    }
    return this.techGet_("muted") || !1;
  }, i.defaultMuted = function(n) {
    return n !== void 0 ? this.techCall_("setDefaultMuted", n) : this.techGet_("defaultMuted") || !1;
  }, i.lastVolume_ = function(n) {
    if (n !== void 0 && n !== 0) {
      this.cache_.lastVolume = n;
      return;
    }
    return this.cache_.lastVolume;
  }, i.supportsFullScreen = function() {
    return this.techGet_("supportsFullScreen") || !1;
  }, i.isFullscreen = function(n) {
    if (n !== void 0) {
      this.isFullscreen_ = !!n, this.toggleFullscreenClass_();
      return;
    }
    return !!this.isFullscreen_;
  }, i.requestFullscreen = function(n) {
    var a;
    this.isFullscreen(!0), this.fsApi_.requestFullscreen ? (xa(Mt, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), this.fsApi_.prefixed || (a = this.options_.fullscreen && this.options_.fullscreen.options || {}, n !== void 0 && (a = n)), Wo(this.el_[this.fsApi_.requestFullscreen](a))) : this.tech_.supportsFullScreen() ? this.techCall_("enterFullScreen") : (this.enterFullWindow(), this.trigger("fullscreenchange"));
  }, i.exitFullscreen = function() {
    this.isFullscreen(!1), this.fsApi_.requestFullscreen ? Wo(Mt[this.fsApi_.exitFullscreen]()) : this.tech_.supportsFullScreen() ? this.techCall_("exitFullScreen") : (this.exitFullWindow(), this.trigger("fullscreenchange"));
  }, i.enterFullWindow = function() {
    this.isFullWindow = !0, this.docOrigOverflow = Mt.documentElement.style.overflow, xa(Mt, "keydown", this.boundFullWindowOnEscKey_), Mt.documentElement.style.overflow = "hidden", lo(Mt.body, "vjs-full-window"), this.trigger("enterFullWindow");
  }, i.fullWindowOnEscKey = function(n) {
    Tr.isEventKey(n, "Esc") && (this.isFullscreen() === !0 ? this.exitFullscreen() : this.exitFullWindow());
  }, i.exitFullWindow = function() {
    this.isFullWindow = !1, wn(Mt, "keydown", this.boundFullWindowOnEscKey_), Mt.documentElement.style.overflow = this.docOrigOverflow, Cd(Mt.body, "vjs-full-window"), this.trigger("exitFullWindow");
  }, i.isInPictureInPicture = function(n) {
    if (n !== void 0) {
      this.isInPictureInPicture_ = !!n, this.togglePictureInPictureClass_();
      return;
    }
    return !!this.isInPictureInPicture_;
  }, i.requestPictureInPicture = function() {
    if ("pictureInPictureEnabled" in Mt)
      return this.techGet_("requestPictureInPicture");
  }, i.exitPictureInPicture = function() {
    if ("pictureInPictureEnabled" in Mt)
      return Mt.exitPictureInPicture();
  }, i.handleKeyDown = function(n) {
    var a = this.options_.userActions;
    if (!(!a || !a.hotkeys)) {
      var s = function(l) {
        var u = l.tagName.toLowerCase();
        if (l.isContentEditable)
          return !0;
        var h = ["button", "checkbox", "hidden", "radio", "reset", "submit"];
        if (u === "input")
          return h.indexOf(l.type) === -1;
        var c = ["textarea"];
        return c.indexOf(u) !== -1;
      };
      s(this.el_.ownerDocument.activeElement) || (typeof a.hotkeys == "function" ? a.hotkeys.call(this, n) : this.handleHotkeys(n));
    }
  }, i.handleHotkeys = function(n) {
    var a = this.options_.userActions ? this.options_.userActions.hotkeys : {}, s = a.fullscreenKey, o = s === void 0 ? function(p) {
      return Tr.isEventKey(p, "f");
    } : s, l = a.muteKey, u = l === void 0 ? function(p) {
      return Tr.isEventKey(p, "m");
    } : l, h = a.playPauseKey, c = h === void 0 ? function(p) {
      return Tr.isEventKey(p, "k") || Tr.isEventKey(p, "Space");
    } : h;
    if (o.call(this, n)) {
      n.preventDefault(), n.stopPropagation();
      var d = bt.getComponent("FullscreenToggle");
      Mt[this.fsApi_.fullscreenEnabled] !== !1 && d.prototype.handleClick.call(this, n);
    } else if (u.call(this, n)) {
      n.preventDefault(), n.stopPropagation();
      var f = bt.getComponent("MuteToggle");
      f.prototype.handleClick.call(this, n);
    } else if (c.call(this, n)) {
      n.preventDefault(), n.stopPropagation();
      var m = bt.getComponent("PlayToggle");
      m.prototype.handleClick.call(this, n);
    }
  }, i.canPlayType = function(n) {
    for (var a, s = 0, o = this.options_.techOrder; s < o.length; s++) {
      var l = o[s], u = Ci.getTech(l);
      if (u || (u = bt.getComponent(l)), !u) {
        qr.error('The "' + l + '" tech is undefined. Skipped browser support check for that tech.');
        continue;
      }
      if (u.isSupported() && (a = u.canPlayType(n), a))
        return a;
    }
    return "";
  }, i.selectSource = function(n) {
    var a = this, s = this.options_.techOrder.map(function(c) {
      return [c, Ci.getTech(c)];
    }).filter(function(c) {
      var d = c[0], f = c[1];
      return f ? f.isSupported() : (qr.error('The "' + d + '" tech is undefined. Skipped browser support check for that tech.'), !1);
    }), o = function(d, f, m) {
      var p;
      return d.some(function(b) {
        return f.some(function(y) {
          if (p = m(b, y), p)
            return !0;
        });
      }), p;
    }, l, u = function(d) {
      return function(f, m) {
        return d(m, f);
      };
    }, h = function(d, f) {
      var m = d[0], p = d[1];
      if (p.canPlaySource(f, a.options_[m.toLowerCase()]))
        return {
          source: f,
          tech: m
        };
    };
    return this.options_.sourceOrder ? l = o(n, s, u(h)) : l = o(s, n, h), l || !1;
  }, i.src = function(n) {
    var a = this;
    if (typeof n > "u")
      return this.cache_.src || "";
    var s = y2(n);
    if (!s.length) {
      this.setTimeout(function() {
        this.error({
          code: 4,
          message: this.localize(this.options_.notSupportedMessage)
        });
      }, 0);
      return;
    }
    this.changingSrc_ = !0, this.cache_.sources = s, this.updateSourceCaches_(s[0]), o2(this, s[0], function(o, l) {
      a.middleware_ = l, a.cache_.sources = s, a.updateSourceCaches_(o);
      var u = a.src_(o);
      if (u) {
        if (s.length > 1)
          return a.src(s.slice(1));
        a.changingSrc_ = !1, a.setTimeout(function() {
          this.error({
            code: 4,
            message: this.localize(this.options_.notSupportedMessage)
          });
        }, 0), a.triggerReady();
        return;
      }
      u2(l, a.tech_);
    });
  }, i.src_ = function(n) {
    var a = this, s = this.selectSource([n]);
    return s ? jR(s.tech, this.techName_) ? (this.ready(function() {
      this.tech_.constructor.prototype.hasOwnProperty("setSource") ? this.techCall_("setSource", n) : this.techCall_("src", n.src), this.changingSrc_ = !1;
    }, !0), !1) : (this.changingSrc_ = !0, this.loadTech_(s.tech, s.source), this.tech_.ready(function() {
      a.changingSrc_ = !1;
    }), !1) : !0;
  }, i.load = function() {
    this.techCall_("load");
  }, i.reset = function() {
    var n = this, a = this.options_.Promise || Be.Promise;
    if (this.paused() || !a)
      this.doReset_();
    else {
      var s = this.play();
      Wo(s.then(function() {
        return n.doReset_();
      }));
    }
  }, i.doReset_ = function() {
    this.tech_ && this.tech_.clearTracks("text"), this.resetCache_(), this.poster(""), this.loadTech_(this.options_.techOrder[0], null), this.techCall_("reset"), this.resetControlBarUI_(), Zu(this) && this.trigger("playerreset");
  }, i.resetControlBarUI_ = function() {
    this.resetProgressBar_(), this.resetPlaybackRate_(), this.resetVolumeBar_();
  }, i.resetProgressBar_ = function() {
    this.currentTime(0);
    var n = this.controlBar, a = n.durationDisplay, s = n.remainingTimeDisplay;
    a && a.updateContent(), s && s.updateContent();
  }, i.resetPlaybackRate_ = function() {
    this.playbackRate(this.defaultPlaybackRate()), this.handleTechRateChange_();
  }, i.resetVolumeBar_ = function() {
    this.volume(1), this.trigger("volumechange");
  }, i.currentSources = function() {
    var n = this.currentSource(), a = [];
    return Object.keys(n).length !== 0 && a.push(n), this.cache_.sources || a;
  }, i.currentSource = function() {
    return this.cache_.source || {};
  }, i.currentSrc = function() {
    return this.currentSource() && this.currentSource().src || "";
  }, i.currentType = function() {
    return this.currentSource() && this.currentSource().type || "";
  }, i.preload = function(n) {
    if (n !== void 0) {
      this.techCall_("setPreload", n), this.options_.preload = n;
      return;
    }
    return this.techGet_("preload");
  }, i.autoplay = function(n) {
    if (n === void 0)
      return this.options_.autoplay || !1;
    var a;
    typeof n == "string" && /(any|play|muted)/.test(n) ? (this.options_.autoplay = n, this.manualAutoplay_(n), a = !1) : n ? this.options_.autoplay = !0 : this.options_.autoplay = !1, a = typeof a > "u" ? this.options_.autoplay : a, this.tech_ && this.techCall_("setAutoplay", a);
  }, i.playsinline = function(n) {
    return n !== void 0 ? (this.techCall_("setPlaysinline", n), this.options_.playsinline = n, this) : this.techGet_("playsinline");
  }, i.loop = function(n) {
    if (n !== void 0) {
      this.techCall_("setLoop", n), this.options_.loop = n;
      return;
    }
    return this.techGet_("loop");
  }, i.poster = function(n) {
    if (n === void 0)
      return this.poster_;
    n || (n = ""), n !== this.poster_ && (this.poster_ = n, this.techCall_("setPoster", n), this.isPosterFromTech_ = !1, this.trigger("posterchange"));
  }, i.handleTechPosterChange_ = function() {
    if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
      var n = this.tech_.poster() || "";
      n !== this.poster_ && (this.poster_ = n, this.isPosterFromTech_ = !0, this.trigger("posterchange"));
    }
  }, i.controls = function(n) {
    if (n === void 0)
      return !!this.controls_;
    n = !!n, this.controls_ !== n && (this.controls_ = n, this.usingNativeControls() && this.techCall_("setControls", n), this.controls_ ? (this.removeClass("vjs-controls-disabled"), this.addClass("vjs-controls-enabled"), this.trigger("controlsenabled"), this.usingNativeControls() || this.addTechControlsListeners_()) : (this.removeClass("vjs-controls-enabled"), this.addClass("vjs-controls-disabled"), this.trigger("controlsdisabled"), this.usingNativeControls() || this.removeTechControlsListeners_()));
  }, i.usingNativeControls = function(n) {
    if (n === void 0)
      return !!this.usingNativeControls_;
    n = !!n, this.usingNativeControls_ !== n && (this.usingNativeControls_ = n, this.usingNativeControls_ ? (this.addClass("vjs-using-native-controls"), this.trigger("usingnativecontrols")) : (this.removeClass("vjs-using-native-controls"), this.trigger("usingcustomcontrols")));
  }, i.error = function(n) {
    if (n === void 0)
      return this.error_ || null;
    if (this.options_.suppressNotSupportedError && n && n.message && n.message === this.localize(this.options_.notSupportedMessage)) {
      var a = function() {
        this.error(n);
      };
      this.options_.suppressNotSupportedError = !1, this.any(["click", "touchstart"], a), this.one("loadstart", function() {
        this.off(["click", "touchstart"], a);
      });
      return;
    }
    if (n === null) {
      this.error_ = n, this.removeClass("vjs-error"), this.errorDisplay && this.errorDisplay.close();
      return;
    }
    this.error_ = new ea(n), this.addClass("vjs-error"), qr.error("(CODE:" + this.error_.code + " " + ea.errorTypes[this.error_.code] + ")", this.error_.message, this.error_), this.trigger("error");
  }, i.reportUserActivity = function(n) {
    this.userActivity_ = !0;
  }, i.userActive = function(n) {
    if (n === void 0)
      return this.userActive_;
    if (n = !!n, n !== this.userActive_) {
      if (this.userActive_ = n, this.userActive_) {
        this.userActivity_ = !0, this.removeClass("vjs-user-inactive"), this.addClass("vjs-user-active"), this.trigger("useractive");
        return;
      }
      this.tech_ && this.tech_.one("mousemove", function(a) {
        a.stopPropagation(), a.preventDefault();
      }), this.userActivity_ = !1, this.removeClass("vjs-user-active"), this.addClass("vjs-user-inactive"), this.trigger("userinactive");
    }
  }, i.listenForUserActivity_ = function() {
    var n, a, s, o = Mr(this, this.reportUserActivity), l = function(m) {
      (m.screenX !== a || m.screenY !== s) && (a = m.screenX, s = m.screenY, o());
    }, u = function() {
      o(), this.clearInterval(n), n = this.setInterval(o, 250);
    }, h = function(m) {
      o(), this.clearInterval(n);
    };
    this.on("mousedown", u), this.on("mousemove", l), this.on("mouseup", h);
    var c = this.getChild("controlBar");
    c && !cs && !lu && (c.on("mouseenter", function(f) {
      this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout, this.player().options_.inactivityTimeout = 0;
    }), c.on("mouseleave", function(f) {
      this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
    })), this.on("keydown", o), this.on("keyup", o);
    var d;
    this.setInterval(function() {
      if (!!this.userActivity_) {
        this.userActivity_ = !1, this.userActive(!0), this.clearTimeout(d);
        var f = this.options_.inactivityTimeout;
        f <= 0 || (d = this.setTimeout(function() {
          this.userActivity_ || this.userActive(!1);
        }, f));
      }
    }, 250);
  }, i.playbackRate = function(n) {
    if (n !== void 0) {
      this.techCall_("setPlaybackRate", n);
      return;
    }
    return this.tech_ && this.tech_.featuresPlaybackRate ? this.cache_.lastPlaybackRate || this.techGet_("playbackRate") : 1;
  }, i.defaultPlaybackRate = function(n) {
    return n !== void 0 ? this.techCall_("setDefaultPlaybackRate", n) : this.tech_ && this.tech_.featuresPlaybackRate ? this.techGet_("defaultPlaybackRate") : 1;
  }, i.isAudio = function(n) {
    if (n !== void 0) {
      this.isAudio_ = !!n;
      return;
    }
    return !!this.isAudio_;
  }, i.addTextTrack = function(n, a, s) {
    if (this.tech_)
      return this.tech_.addTextTrack(n, a, s);
  }, i.addRemoteTextTrack = function(n, a) {
    if (this.tech_)
      return this.tech_.addRemoteTextTrack(n, a);
  }, i.removeRemoteTextTrack = function(n) {
    n === void 0 && (n = {});
    var a = n, s = a.track;
    if (s || (s = n), this.tech_)
      return this.tech_.removeRemoteTextTrack(s);
  }, i.getVideoPlaybackQuality = function() {
    return this.techGet_("getVideoPlaybackQuality");
  }, i.videoWidth = function() {
    return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
  }, i.videoHeight = function() {
    return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
  }, i.language = function(n) {
    if (n === void 0)
      return this.language_;
    this.language_ = String(n).toLowerCase();
  }, i.languages = function() {
    return Ti(r.prototype.options_.languages, this.languages_);
  }, i.toJSON = function() {
    var n = Ti(this.options_), a = n.tracks;
    n.tracks = [];
    for (var s = 0; s < a.length; s++) {
      var o = a[s];
      o = Ti(o), o.player = void 0, n.tracks[s] = o;
    }
    return n;
  }, i.createModal = function(n, a) {
    var s = this;
    a = a || {}, a.content = n || "";
    var o = new lc(this, a);
    return this.addChild(o), o.on("dispose", function() {
      s.removeChild(o);
    }), o.open(), o;
  }, i.updateCurrentBreakpoint_ = function() {
    if (!!this.responsive())
      for (var n = this.currentBreakpoint(), a = this.currentWidth(), s = 0; s < Gg.length; s++) {
        var o = Gg[s], l = this.breakpoints_[o];
        if (a <= l) {
          if (n === o)
            return;
          n && this.removeClass(Cf[n]), this.addClass(Cf[o]), this.breakpoint_ = o;
          break;
        }
      }
  }, i.removeCurrentBreakpoint_ = function() {
    var n = this.currentBreakpointClass();
    this.breakpoint_ = "", n && this.removeClass(n);
  }, i.breakpoints = function(n) {
    return n === void 0 ? Ui(this.breakpoints_) : (this.breakpoint_ = "", this.breakpoints_ = Ui({}, K2, n), this.updateCurrentBreakpoint_(), Ui(this.breakpoints_));
  }, i.responsive = function(n) {
    if (n === void 0)
      return this.responsive_;
    n = Boolean(n);
    var a = this.responsive_;
    if (n !== a)
      return this.responsive_ = n, n ? (this.on("playerresize", this.updateCurrentBreakpoint_), this.updateCurrentBreakpoint_()) : (this.off("playerresize", this.updateCurrentBreakpoint_), this.removeCurrentBreakpoint_()), n;
  }, i.currentBreakpoint = function() {
    return this.breakpoint_;
  }, i.currentBreakpointClass = function() {
    return Cf[this.breakpoint_] || "";
  }, i.loadMedia = function(n, a) {
    var s = this;
    if (!(!n || typeof n != "object")) {
      this.reset(), this.cache_.media = Ti(n);
      var o = this.cache_.media, l = o.artwork, u = o.poster, h = o.src, c = o.textTracks;
      !l && u && (this.cache_.media.artwork = [{
        src: u,
        type: Kf(u)
      }]), h && this.src(h), u && this.poster(u), Array.isArray(c) && c.forEach(function(d) {
        return s.addRemoteTextTrack(d, !1);
      }), this.ready(a);
    }
  }, i.getMedia = function() {
    if (!this.cache_.media) {
      var n = this.poster(), a = this.currentSources(), s = Array.prototype.map.call(this.remoteTextTracks(), function(l) {
        return {
          kind: l.kind,
          label: l.label,
          language: l.language,
          src: l.src
        };
      }), o = {
        src: a,
        textTracks: s
      };
      return n && (o.poster = n, o.artwork = [{
        src: o.poster,
        type: Kf(o.poster)
      }]), o;
    }
    return Ti(this.cache_.media);
  }, r.getTagSettings = function(n) {
    var a = {
      sources: [],
      tracks: []
    }, s = io(n), o = s["data-setup"];
    if (Vu(n, "vjs-fill") && (s.fill = !0), Vu(n, "vjs-fluid") && (s.fluid = !0), o !== null) {
      var l = U1(o || "{}"), u = l[0], h = l[1];
      u && qr.error(u), Ui(s, h);
    }
    if (Ui(a, s), n.hasChildNodes())
      for (var c = n.childNodes, d = 0, f = c.length; d < f; d++) {
        var m = c[d], p = m.nodeName.toLowerCase();
        p === "source" ? a.sources.push(io(m)) : p === "track" && a.tracks.push(io(m));
      }
    return a;
  }, i.flexNotSupported_ = function() {
    var n = Mt.createElement("i");
    return !("flexBasis" in n.style || "webkitFlexBasis" in n.style || "mozFlexBasis" in n.style || "msFlexBasis" in n.style || "msFlexOrder" in n.style);
  }, r;
}(bt);
Xn.names.forEach(function(e) {
  var r = Xn[e];
  hn.prototype[r.getterName] = function() {
    return this.tech_ ? this.tech_[r.getterName]() : (this[r.privateName] = this[r.privateName] || new r.ListClass(), this[r.privateName]);
  };
});
hn.players = {};
var Fc = Be.navigator;
hn.prototype.options_ = {
  techOrder: Ci.defaultTechOrder_,
  html5: {},
  flash: {},
  inactivityTimeout: 2e3,
  playbackRates: [],
  liveui: !1,
  children: ["mediaLoader", "posterImage", "textTrackDisplay", "loadingSpinner", "bigPlayButton", "liveTracker", "controlBar", "errorDisplay", "textTrackSettings", "resizeManager"],
  language: Fc && (Fc.languages && Fc.languages[0] || Fc.userLanguage || Fc.language) || "en",
  languages: {},
  notSupportedMessage: "No compatible source was found for this media.",
  fullscreen: {
    options: {
      navigationUI: "hide"
    }
  },
  breakpoints: {},
  responsive: !1
};
[
  "ended",
  "seeking",
  "seekable",
  "networkState",
  "readyState"
].forEach(function(e) {
  hn.prototype[e] = function() {
    return this.techGet_(e);
  };
});
aE.forEach(function(e) {
  hn.prototype["handleTech" + Wi(e) + "_"] = function() {
    return this.trigger(e);
  };
});
bt.registerComponent("Player", hn);
var Xf = "plugin", Ul = "activePlugins_", Pl = {}, Jf = function(r) {
  return Pl.hasOwnProperty(r);
}, Df = function(r) {
  return Jf(r) ? Pl[r] : void 0;
}, sE = function(r, i) {
  r[Ul] = r[Ul] || {}, r[Ul][i] = !0;
}, Qf = function(r, i, t) {
  var n = (t ? "before" : "") + "pluginsetup";
  r.trigger(n, i), r.trigger(n + ":" + i.name, i);
}, z2 = function(r, i) {
  var t = function() {
    Qf(this, {
      name: r,
      plugin: i,
      instance: null
    }, !0);
    var a = i.apply(this, arguments);
    return sE(this, r), Qf(this, {
      name: r,
      plugin: i,
      instance: a
    }), a;
  };
  return Object.keys(i).forEach(function(n) {
    t[n] = i[n];
  }), t;
}, B_ = function(r, i) {
  return i.prototype.name = r, function() {
    Qf(this, {
      name: r,
      plugin: i,
      instance: null
    }, !0);
    for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
      n[a] = arguments[a];
    var s = Af(i, [this].concat(n));
    return this[r] = function() {
      return s;
    }, Qf(this, s.getEventHash()), s;
  };
}, Bs = /* @__PURE__ */ function() {
  function e(i) {
    if (this.constructor === e)
      throw new Error("Plugin must be sub-classed; not directly instantiated.");
    this.player = i, zv(this), delete this.trigger, ES(this, this.constructor.defaultState), sE(i, this.name), this.dispose = Mr(this, this.dispose), i.on("dispose", this.dispose);
  }
  var r = e.prototype;
  return r.version = function() {
    return this.constructor.VERSION;
  }, r.getEventHash = function(t) {
    return t === void 0 && (t = {}), t.name = this.name, t.plugin = this.constructor, t.instance = this, t;
  }, r.trigger = function(t, n) {
    return n === void 0 && (n = {}), uc(this.eventBusEl_, t, this.getEventHash(n));
  }, r.handleStateChanged = function(t) {
  }, r.dispose = function() {
    var t = this.name, n = this.player;
    this.trigger("dispose"), this.off(), n.off("dispose", this.dispose), n[Ul][t] = !1, this.player = this.state = null, n[t] = B_(t, Pl[t]);
  }, e.isBasic = function(t) {
    var n = typeof t == "string" ? Df(t) : t;
    return typeof n == "function" && !e.prototype.isPrototypeOf(n.prototype);
  }, e.registerPlugin = function(t, n) {
    if (typeof t != "string")
      throw new Error('Illegal plugin name, "' + t + '", must be a string, was ' + typeof t + ".");
    if (Jf(t))
      qr.warn('A plugin named "' + t + '" already exists. You may want to avoid re-registering plugins!');
    else if (hn.prototype.hasOwnProperty(t))
      throw new Error('Illegal plugin name, "' + t + '", cannot share a name with an existing player method!');
    if (typeof n != "function")
      throw new Error('Illegal plugin for "' + t + '", must be a function, was ' + typeof n + ".");
    return Pl[t] = n, t !== Xf && (e.isBasic(n) ? hn.prototype[t] = z2(t, n) : hn.prototype[t] = B_(t, n)), n;
  }, e.deregisterPlugin = function(t) {
    if (t === Xf)
      throw new Error("Cannot de-register base plugin.");
    Jf(t) && (delete Pl[t], delete hn.prototype[t]);
  }, e.getPlugins = function(t) {
    t === void 0 && (t = Object.keys(Pl));
    var n;
    return t.forEach(function(a) {
      var s = Df(a);
      s && (n = n || {}, n[a] = s);
    }), n;
  }, e.getPluginVersion = function(t) {
    var n = Df(t);
    return n && n.VERSION || "";
  }, e;
}();
Bs.getPlugin = Df;
Bs.BASE_PLUGIN_NAME = Xf;
Bs.registerPlugin(Xf, Bs);
hn.prototype.usingPlugin = function(e) {
  return !!this[Ul] && this[Ul][e] === !0;
};
hn.prototype.hasPlugin = function(e) {
  return !!Jf(e);
};
var X2 = function(r, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof i);
  r.prototype = Object.create(i && i.prototype, {
    constructor: {
      value: r,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), i && (r.super_ = i);
}, J2 = function(r, i) {
  i === void 0 && (i = {});
  var t = function() {
    r.apply(this, arguments);
  }, n = {};
  typeof i == "object" ? (i.constructor !== Object.prototype.constructor && (t = i.constructor), n = i) : typeof i == "function" && (t = i), X2(t, r);
  for (var a in n)
    n.hasOwnProperty(a) && (t.prototype[a] = n[a]);
  return t;
}, oE = function(r) {
  return r.indexOf("#") === 0 ? r.slice(1) : r;
};
function re(e, r, i) {
  var t = re.getPlayer(e);
  if (t)
    return r && qr.warn('Player "' + e + '" is already initialised. Options will not be applied.'), i && t.ready(i), t;
  var n = typeof e == "string" ? ru("#" + oE(e)) : e;
  if (!wd(n))
    throw new TypeError("The element or ID supplied is not valid. (videojs)");
  (!n.ownerDocument.defaultView || !n.ownerDocument.body.contains(n)) && qr.warn("The element supplied is not included in the DOM"), r = r || {}, re.hooks("beforesetup").forEach(function(s) {
    var o = s(n, Ti(r));
    if (!tu(o) || Array.isArray(o)) {
      qr.error("please return an object in beforesetup hooks");
      return;
    }
    r = Ti(r, o);
  });
  var a = bt.getComponent("Player");
  return t = new a(n, r, i), re.hooks("setup").forEach(function(s) {
    return s(t);
  }), t;
}
re.hooks_ = {};
re.hooks = function(e, r) {
  return re.hooks_[e] = re.hooks_[e] || [], r && (re.hooks_[e] = re.hooks_[e].concat(r)), re.hooks_[e];
};
re.hook = function(e, r) {
  re.hooks(e, r);
};
re.hookOnce = function(e, r) {
  re.hooks(e, [].concat(r).map(function(i) {
    var t = function n() {
      return re.removeHook(e, n), i.apply(void 0, arguments);
    };
    return t;
  }));
};
re.removeHook = function(e, r) {
  var i = re.hooks(e).indexOf(r);
  return i <= -1 ? !1 : (re.hooks_[e] = re.hooks_[e].slice(), re.hooks_[e].splice(i, 1), !0);
};
if (Be.VIDEOJS_NO_DYNAMIC_STYLE !== !0 && sc()) {
  var ff = ru(".vjs-styles-defaults");
  if (!ff) {
    ff = gS("vjs-styles-defaults");
    var zp = ru("head");
    zp && zp.insertBefore(ff, zp.firstChild), vS(ff, `
      .video-js {
        width: 300px;
        height: 150px;
      }

      .vjs-fluid {
        padding-top: 56.25%
      }
    `);
  }
}
Mg(1, re);
re.VERSION = XT;
re.options = hn.prototype.options_;
re.getPlayers = function() {
  return hn.players;
};
re.getPlayer = function(e) {
  var r = hn.players, i;
  if (typeof e == "string") {
    var t = oE(e), n = r[t];
    if (n)
      return n;
    i = ru("#" + t);
  } else
    i = e;
  if (wd(i)) {
    var a = i, s = a.player, o = a.playerId;
    if (s || r[o])
      return s || r[o];
  }
};
re.getAllPlayers = function() {
  return Object.keys(hn.players).map(function(e) {
    return hn.players[e];
  }).filter(Boolean);
};
re.players = hn.players;
re.getComponent = bt.getComponent;
re.registerComponent = function(e, r) {
  Ci.isTech(r) && qr.warn("The " + e + " tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)"), bt.registerComponent.call(bt, e, r);
};
re.getTech = Ci.getTech;
re.registerTech = Ci.registerTech;
re.use = s2;
Object.defineProperty(re, "middleware", {
  value: {},
  writeable: !1,
  enumerable: !0
});
Object.defineProperty(re.middleware, "TERMINATOR", {
  value: Yf,
  writeable: !1,
  enumerable: !0
});
re.browser = VR;
re.TOUCH_ENABLED = ld;
re.extend = J2;
re.mergeOptions = Ti;
re.bind = Mr;
re.registerPlugin = Bs.registerPlugin;
re.deregisterPlugin = Bs.deregisterPlugin;
re.plugin = function(e, r) {
  return qr.warn("videojs.plugin() is deprecated; use videojs.registerPlugin() instead"), Bs.registerPlugin(e, r);
};
re.getPlugins = Bs.getPlugins;
re.getPlugin = Bs.getPlugin;
re.getPluginVersion = Bs.getPluginVersion;
re.addLanguage = function(e, r) {
  var i;
  return e = ("" + e).toLowerCase(), re.options.languages = Ti(re.options.languages, (i = {}, i[e] = r, i)), re.options.languages[e];
};
re.log = qr;
re.createLogger = QT;
re.createTimeRange = re.createTimeRanges = qu;
re.formatTime = Jl;
re.setFormatTime = A2;
re.resetFormatTime = w2;
re.parseUrl = im;
re.isCrossOrigin = Bh;
re.EventTarget = vn;
re.on = xa;
re.one = Uh;
re.off = wn;
re.trigger = uc;
re.xhr = jb;
re.TextTrack = Dd;
re.AudioTrack = LS;
re.VideoTrack = IS;
["isEl", "isTextNode", "createEl", "hasClass", "addClass", "removeClass", "toggleClass", "setAttributes", "getAttributes", "emptyEl", "appendContent", "insertContent"].forEach(function(e) {
  re[e] = function() {
    return qr.warn("videojs." + e + "() is deprecated; use videojs.dom." + e + "() instead"), hS[e].apply(null, arguments);
  };
});
re.computedStyle = Wf;
re.dom = hS;
re.url = t2;
/**
 * @videojs/http-streaming
 * @version 1.10.6
 * @copyright 2019 Brightcove, Inc
 * @license Apache-2.0
 */
var Yu = function(r, i) {
  return /^[a-z]+:/i.test(i) ? i : (/\/\//i.test(r) || (r = Uf.buildAbsoluteURL(Be.location.href, r)), Uf.buildAbsoluteURL(r, i));
}, Zf = function(r, i, t) {
  return r && t.responseURL && i !== t.responseURL ? t.responseURL : i;
}, Wa = function(r, i) {
  if (!(r instanceof i))
    throw new TypeError("Cannot call a class as a function");
}, gs = function() {
  function e(r, i) {
    for (var t = 0; t < i.length; t++) {
      var n = i[t];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, n.key, n);
    }
  }
  return function(r, i, t) {
    return i && e(r.prototype, i), t && e(r, t), r;
  };
}(), Q2 = function e(r, i, t) {
  r === null && (r = Function.prototype);
  var n = Object.getOwnPropertyDescriptor(r, i);
  if (n === void 0) {
    var a = Object.getPrototypeOf(r);
    return a === null ? void 0 : e(a, i, t);
  } else {
    if ("value" in n)
      return n.value;
    var s = n.get;
    return s === void 0 ? void 0 : s.call(t);
  }
}, xo = function(r, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof i);
  r.prototype = Object.create(i && i.prototype, {
    constructor: {
      value: r,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), i && (Object.setPrototypeOf ? Object.setPrototypeOf(r, i) : r.__proto__ = i);
}, js = function(r, i) {
  if (!r)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return i && (typeof i == "object" || typeof i == "function") ? i : r;
}, Z2 = function() {
  function e(r, i) {
    var t = [], n = !0, a = !1, s = void 0;
    try {
      for (var o = r[Symbol.iterator](), l; !(n = (l = o.next()).done) && (t.push(l.value), !(i && t.length === i)); n = !0)
        ;
    } catch (u) {
      a = !0, s = u;
    } finally {
      try {
        !n && o.return && o.return();
      } finally {
        if (a)
          throw s;
      }
    }
    return t;
  }
  return function(r, i) {
    if (Array.isArray(r))
      return r;
    if (Symbol.iterator in Object(r))
      return e(r, i);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
}(), Hg = re.mergeOptions, eP = re.EventTarget, tP = re.log, $h = function(r, i) {
  ["AUDIO", "SUBTITLES"].forEach(function(t) {
    for (var n in r.mediaGroups[t])
      for (var a in r.mediaGroups[t][n]) {
        var s = r.mediaGroups[t][n][a];
        i(s, t, n, a);
      }
  });
}, rP = function(r, i, t) {
  var n = i.slice();
  t = t || 0;
  for (var a = Math.min(r.length, i.length + t), s = t; s < a; s++)
    n[s - t] = Hg(r[s], n[s - t]);
  return n;
}, iP = function(r, i) {
  r.resolvedUri || (r.resolvedUri = Yu(i, r.uri)), r.key && !r.key.resolvedUri && (r.key.resolvedUri = Yu(i, r.key.uri)), r.map && !r.map.resolvedUri && (r.map.resolvedUri = Yu(i, r.map.uri));
}, Vg = function(r, i) {
  var t = Hg(r, {}), n = t.playlists[i.uri];
  if (!n || n.segments && i.segments && n.segments.length === i.segments.length && n.endList === i.endList && n.mediaSequence === i.mediaSequence)
    return null;
  var a = Hg(n, i);
  n.segments && (a.segments = rP(n.segments, i.segments, i.mediaSequence - n.mediaSequence)), a.segments.forEach(function(o) {
    iP(o, a.resolvedUri);
  });
  for (var s = 0; s < t.playlists.length; s++)
    t.playlists[s].uri === i.uri && (t.playlists[s] = a);
  return t.playlists[i.uri] = a, t;
}, uE = function(r) {
  for (var i = r.playlists.length; i--; ) {
    var t = r.playlists[i];
    r.playlists[t.uri] = t, t.resolvedUri = Yu(r.uri, t.uri), t.id = i, t.attributes || (t.attributes = {}, tP.warn("Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute."));
  }
}, lE = function(r) {
  $h(r, function(i) {
    i.uri && (i.resolvedUri = Yu(r.uri, i.uri));
  });
}, cE = function(r, i) {
  var t = r.segments[r.segments.length - 1], n = void 0;
  return i && t && t.duration ? n = t.duration * 1e3 : n = (r.targetDuration || 10) * 500, n;
}, eh = function(e) {
  xo(r, e);
  function r(i, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    Wa(this, r);
    var a = js(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this)), s = n.withCredentials, o = s === void 0 ? !1 : s, l = n.handleManifestRedirects, u = l === void 0 ? !1 : l;
    a.srcUrl = i, a.hls_ = t, a.withCredentials = o, a.handleManifestRedirects = u;
    var h = t.options_;
    if (a.customTagParsers = h && h.customTagParsers || [], a.customTagMappers = h && h.customTagMappers || [], !a.srcUrl)
      throw new Error("A non-empty playlist URL is required");
    return a.state = "HAVE_NOTHING", a.on("mediaupdatetimeout", function() {
      a.state === "HAVE_METADATA" && (a.state = "HAVE_CURRENT_METADATA", a.request = a.hls_.xhr({
        uri: Yu(a.master.uri, a.media().uri),
        withCredentials: a.withCredentials
      }, function(c, d) {
        if (!!a.request) {
          if (c)
            return a.playlistRequestError(a.request, a.media().uri, "HAVE_METADATA");
          a.haveMetadata(a.request, a.media().uri);
        }
      }));
    }), a;
  }
  return gs(r, [{
    key: "playlistRequestError",
    value: function(t, n, a) {
      this.request = null, a && (this.state = a), this.error = {
        playlist: this.master.playlists[n],
        status: t.status,
        message: "HLS playlist request error at URL: " + n + ".",
        responseText: t.responseText,
        code: t.status >= 500 ? 4 : 2
      }, this.trigger("error");
    }
  }, {
    key: "haveMetadata",
    value: function(t, n) {
      var a = this;
      this.request = null, this.state = "HAVE_METADATA";
      var s = new xg();
      this.customTagParsers.forEach(function(l) {
        return s.addParser(l);
      }), this.customTagMappers.forEach(function(l) {
        return s.addTagMapper(l);
      }), s.push(t.responseText), s.end(), s.manifest.uri = n, s.manifest.attributes = s.manifest.attributes || {};
      var o = Vg(this.master, s.manifest);
      this.targetDuration = s.manifest.targetDuration, o ? (this.master = o, this.media_ = this.master.playlists[s.manifest.uri]) : this.trigger("playlistunchanged"), this.media().endList || (Be.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = Be.setTimeout(function() {
        a.trigger("mediaupdatetimeout");
      }, cE(this.media(), !!o))), this.trigger("loadedplaylist");
    }
  }, {
    key: "dispose",
    value: function() {
      this.stopRequest(), Be.clearTimeout(this.mediaUpdateTimeout), Be.clearTimeout(this.finalRenditionTimeout);
    }
  }, {
    key: "stopRequest",
    value: function() {
      if (this.request) {
        var t = this.request;
        this.request = null, t.onreadystatechange = null, t.abort();
      }
    }
  }, {
    key: "media",
    value: function(t, n) {
      var a = this;
      if (!t)
        return this.media_;
      if (this.state === "HAVE_NOTHING")
        throw new Error("Cannot switch media playlist from " + this.state);
      if (typeof t == "string") {
        if (!this.master.playlists[t])
          throw new Error("Unknown playlist URI: " + t);
        t = this.master.playlists[t];
      }
      if (Be.clearTimeout(this.finalRenditionTimeout), n) {
        var s = t.targetDuration / 2 * 1e3 || 5e3;
        this.finalRenditionTimeout = Be.setTimeout(this.media.bind(this, t, !1), s);
        return;
      }
      var o = this.state, l = !this.media_ || t.uri !== this.media_.uri;
      if (this.master.playlists[t.uri].endList) {
        this.request && (this.request.onreadystatechange = null, this.request.abort(), this.request = null), this.state = "HAVE_METADATA", this.media_ = t, l && (this.trigger("mediachanging"), this.trigger("mediachange"));
        return;
      }
      if (!!l) {
        if (this.state = "SWITCHING_MEDIA", this.request) {
          if (t.resolvedUri === this.request.url)
            return;
          this.request.onreadystatechange = null, this.request.abort(), this.request = null;
        }
        this.media_ && this.trigger("mediachanging"), this.request = this.hls_.xhr({
          uri: t.resolvedUri,
          withCredentials: this.withCredentials
        }, function(u, h) {
          if (!!a.request) {
            if (t.resolvedUri = Zf(a.handleManifestRedirects, t.resolvedUri, h), u)
              return a.playlistRequestError(a.request, t.uri, o);
            a.haveMetadata(h, t.uri), o === "HAVE_MASTER" ? a.trigger("loadedmetadata") : a.trigger("mediachange");
          }
        });
      }
    }
  }, {
    key: "pause",
    value: function() {
      this.stopRequest(), Be.clearTimeout(this.mediaUpdateTimeout), this.state === "HAVE_NOTHING" && (this.started = !1), this.state === "SWITCHING_MEDIA" ? this.media_ ? this.state = "HAVE_METADATA" : this.state = "HAVE_MASTER" : this.state === "HAVE_CURRENT_METADATA" && (this.state = "HAVE_METADATA");
    }
  }, {
    key: "load",
    value: function(t) {
      var n = this;
      Be.clearTimeout(this.mediaUpdateTimeout);
      var a = this.media();
      if (t) {
        var s = a ? a.targetDuration / 2 * 1e3 : 5e3;
        this.mediaUpdateTimeout = Be.setTimeout(function() {
          return n.load();
        }, s);
        return;
      }
      if (!this.started) {
        this.start();
        return;
      }
      a && !a.endList ? this.trigger("mediaupdatetimeout") : this.trigger("loadedplaylist");
    }
  }, {
    key: "start",
    value: function() {
      var t = this;
      this.started = !0, this.request = this.hls_.xhr({
        uri: this.srcUrl,
        withCredentials: this.withCredentials
      }, function(n, a) {
        if (!!t.request) {
          if (t.request = null, n)
            return t.error = {
              status: a.status,
              message: "HLS playlist request error at URL: " + t.srcUrl + ".",
              responseText: a.responseText,
              code: 2
            }, t.state === "HAVE_NOTHING" && (t.started = !1), t.trigger("error");
          var s = new xg();
          if (t.customTagParsers.forEach(function(o) {
            return s.addParser(o);
          }), t.customTagMappers.forEach(function(o) {
            return s.addTagMapper(o);
          }), s.push(a.responseText), s.end(), t.state = "HAVE_MASTER", t.srcUrl = Zf(t.handleManifestRedirects, t.srcUrl, a), s.manifest.uri = t.srcUrl, s.manifest.playlists) {
            t.master = s.manifest, uE(t.master), lE(t.master), t.trigger("loadedplaylist"), t.request || t.media(s.manifest.playlists[0]);
            return;
          }
          return t.master = {
            mediaGroups: {
              AUDIO: {},
              VIDEO: {},
              "CLOSED-CAPTIONS": {},
              SUBTITLES: {}
            },
            uri: Be.location.href,
            playlists: [{
              uri: t.srcUrl,
              id: 0,
              resolvedUri: t.srcUrl,
              attributes: {}
            }]
          }, t.master.playlists[t.srcUrl] = t.master.playlists[0], t.haveMetadata(a, t.srcUrl), t.trigger("loadedmetadata");
        }
      });
    }
  }]), r;
}(eP), j_ = re.createTimeRange, nP = function(r, i) {
  var t = 0, n = i - r.mediaSequence, a = r.segments[n];
  if (a) {
    if (typeof a.start < "u")
      return {
        result: a.start,
        precise: !0
      };
    if (typeof a.end < "u")
      return {
        result: a.end - a.duration,
        precise: !0
      };
  }
  for (; n--; ) {
    if (a = r.segments[n], typeof a.end < "u")
      return {
        result: t + a.end,
        precise: !0
      };
    if (t += a.duration, typeof a.start < "u")
      return {
        result: t + a.start,
        precise: !0
      };
  }
  return {
    result: t,
    precise: !1
  };
}, aP = function(r, i) {
  for (var t = 0, n = void 0, a = i - r.mediaSequence; a < r.segments.length; a++) {
    if (n = r.segments[a], typeof n.start < "u")
      return {
        result: n.start - t,
        precise: !0
      };
    if (t += n.duration, typeof n.end < "u")
      return {
        result: n.end - t,
        precise: !0
      };
  }
  return {
    result: -1,
    precise: !1
  };
}, dE = function(r, i, t) {
  var n = void 0, a = void 0;
  return typeof i > "u" && (i = r.mediaSequence + r.segments.length), i < r.mediaSequence ? 0 : (n = nP(r, i), n.precise ? n.result : (a = aP(r, i), a.precise ? a.result : n.result + t));
}, fE = function(r, i, t) {
  if (!r)
    return 0;
  if (typeof t != "number" && (t = 0), typeof i > "u") {
    if (r.totalDuration)
      return r.totalDuration;
    if (!r.endList)
      return Be.Infinity;
  }
  return dE(r, i, t);
}, Jc = function(r, i, t) {
  var n = 0;
  if (i > t) {
    var a = [t, i];
    i = a[0], t = a[1];
  }
  if (i < 0) {
    for (var s = i; s < Math.min(0, t); s++)
      n += r.targetDuration;
    i = 0;
  }
  for (var o = i; o < t; o++)
    n += r.segments[o].duration;
  return n;
}, hE = function(r) {
  if (!r.segments.length)
    return 0;
  for (var i = r.segments.length - 1, t = r.segments[i].duration || r.targetDuration, n = t + r.targetDuration * 2; i-- && (t += r.segments[i].duration, !(t >= n)); )
    ;
  return Math.max(0, i);
}, pE = function(r, i, t) {
  if (!r || !r.segments)
    return null;
  if (r.endList)
    return fE(r);
  if (i === null)
    return null;
  i = i || 0;
  var n = t ? hE(r) : r.segments.length;
  return dE(r, r.mediaSequence + n, i);
}, sP = function(r, i) {
  var t = !0, n = i || 0, a = pE(r, i, t);
  return a === null ? j_() : j_(n, a);
}, $_ = function(r) {
  return r - Math.floor(r) === 0;
}, gE = function(r, i) {
  if ($_(i))
    return i + r * 0.1;
  for (var t = i.toString().split(".")[1].length, n = 1; n <= t; n++) {
    var a = Math.pow(10, n), s = i * a;
    if ($_(s) || n === t)
      return (s + r) / a;
  }
}, oP = gE.bind(null, 1), uP = gE.bind(null, -1), lP = function(r, i, t, n) {
  var a = void 0, s = void 0, o = r.segments.length, l = i - n;
  if (l < 0) {
    if (t > 0) {
      for (a = t - 1; a >= 0; a--)
        if (s = r.segments[a], l += uP(s.duration), l > 0)
          return {
            mediaIndex: a,
            startTime: n - Jc(r, t, a)
          };
    }
    return {
      mediaIndex: 0,
      startTime: i
    };
  }
  if (t < 0) {
    for (a = t; a < 0; a++)
      if (l -= r.targetDuration, l < 0)
        return {
          mediaIndex: 0,
          startTime: i
        };
    t = 0;
  }
  for (a = t; a < o; a++)
    if (s = r.segments[a], l -= oP(s.duration), l < 0)
      return {
        mediaIndex: a,
        startTime: n + Jc(r, t, a)
      };
  return {
    mediaIndex: o - 1,
    startTime: i
  };
}, vE = function(r) {
  return r.excludeUntil && r.excludeUntil > Date.now();
}, xm = function(r) {
  return r.excludeUntil && r.excludeUntil === 1 / 0;
}, Gh = function(r) {
  var i = vE(r);
  return !r.disabled && !i;
}, cP = function(r) {
  return r.disabled;
}, dP = function(r) {
  for (var i = 0; i < r.segments.length; i++)
    if (r.segments[i].key)
      return !0;
  return !1;
}, fP = function(r) {
  for (var i = 0; i < r.segments.length; i++)
    if (r.segments[i].map)
      return !0;
  return !1;
}, mE = function(r, i) {
  return i.attributes && i.attributes[r];
}, hP = function(r, i, t) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  if (!mE("BANDWIDTH", t))
    return NaN;
  var a = r * t.attributes.BANDWIDTH;
  return (a - n * 8) / i;
}, qg = function(r, i) {
  if (r.playlists.length === 1)
    return !0;
  var t = i.attributes.BANDWIDTH || Number.MAX_VALUE;
  return r.playlists.filter(function(n) {
    return Gh(n) ? (n.attributes.BANDWIDTH || 0) < t : !1;
  }).length === 0;
}, ua = {
  duration: fE,
  seekable: sP,
  safeLiveIndex: hE,
  getMediaInfoForTime: lP,
  isEnabled: Gh,
  isDisabled: cP,
  isBlacklisted: vE,
  isIncompatible: xm,
  playlistEnd: pE,
  isAes: dP,
  isFmp4: fP,
  hasAttribute: mE,
  estimateSegmentRequestTime: hP,
  isLowestEnabledRendition: qg
}, pP = re.xhr, gP = re.mergeOptions, yE = function() {
  var r = function i(t, n) {
    t = gP({
      timeout: 45e3
    }, t);
    var a = i.beforeRequest || re.Hls.xhr.beforeRequest;
    if (a && typeof a == "function") {
      var s = a(t);
      s && (t = s);
    }
    var o = pP(t, function(u, h) {
      var c = o.response;
      !u && c && (o.responseTime = Date.now(), o.roundTripTime = o.responseTime - o.requestTime, o.bytesReceived = c.byteLength || c.length, o.bandwidth || (o.bandwidth = Math.floor(o.bytesReceived / o.roundTripTime * 8 * 1e3))), h.headers && (o.responseHeaders = h.headers), u && u.code === "ETIMEDOUT" && (o.timedout = !0), !u && !o.aborted && h.statusCode !== 200 && h.statusCode !== 206 && h.statusCode !== 0 && (u = new Error("XHR Failed with a response of: " + (o && (c || o.responseText)))), n(u, o);
    }), l = o.abort;
    return o.abort = function() {
      return o.aborted = !0, l.apply(o, arguments);
    }, o.uri = t.uri, o.requestTime = Date.now(), o;
  };
  return r;
}, vP = function(r) {
  var i = void 0, t = void 0;
  return t = r.offset + r.length - 1, i = r.offset, "bytes=" + i + "-" + t;
}, Wg = function(r) {
  var i = {};
  return r.byterange && (i.Range = vP(r.byterange)), i;
}, mP = function(r, i) {
  return r.start(i) + "-" + r.end(i);
}, yP = function(r, i) {
  var t = r.toString(16);
  return "00".substring(0, 2 - t.length) + t + (i % 2 ? " " : "");
}, _P = function(r) {
  return r >= 32 && r < 126 ? String.fromCharCode(r) : ".";
}, _E = function(r) {
  var i = {};
  return Object.keys(r).forEach(function(t) {
    var n = r[t];
    ArrayBuffer.isView(n) ? i[t] = {
      bytes: n.buffer,
      byteOffset: n.byteOffset,
      byteLength: n.byteLength
    } : i[t] = n;
  }), i;
}, th = function(r) {
  var i = r.byterange || {
    length: 1 / 0,
    offset: 0
  };
  return [i.length, i.offset, r.resolvedUri].join(",");
}, bE = function(r) {
  return r.resolvedUri;
}, TE = function(r) {
  for (var i = Array.prototype.slice.call(r), t = 16, n = "", a = void 0, s = void 0, o = 0; o < i.length / t; o++)
    a = i.slice(o * t, o * t + t).map(yP).join(""), s = i.slice(o * t, o * t + t).map(_P).join(""), n += a + " " + s + `
`;
  return n;
}, bP = function(r) {
  var i = r.bytes;
  return TE(i);
}, TP = function(r) {
  var i = "", t = void 0;
  for (t = 0; t < r.length; t++)
    i += mP(r, t) + " ";
  return i;
}, SP = /* @__PURE__ */ Object.freeze({
  createTransferableMessage: _E,
  initSegmentId: th,
  segmentKeyId: bE,
  hexDump: TE,
  tagDump: bP,
  textRanges: TP
}), SE = 0.25, EP = function(r, i) {
  if (!i.dateTimeObject)
    return null;
  var t = i.videoTimingInfo.transmuxerPrependedSeconds, n = i.videoTimingInfo.transmuxedPresentationStart, a = n + t, s = r - a;
  return new Date(i.dateTimeObject.getTime() + s * 1e3);
}, xP = function(r) {
  return r.transmuxedPresentationEnd - r.transmuxedPresentationStart - r.transmuxerPrependedSeconds;
}, AP = function(r, i) {
  var t = void 0;
  try {
    t = new Date(r);
  } catch {
    return null;
  }
  if (!i || !i.segments || i.segments.length === 0)
    return null;
  var n = i.segments[0];
  if (t < n.dateTimeObject)
    return null;
  for (var a = 0; a < i.segments.length - 1; a++) {
    n = i.segments[a];
    var s = i.segments[a + 1].dateTimeObject;
    if (t < s)
      break;
  }
  var o = i.segments[i.segments.length - 1], l = o.dateTimeObject, u = o.videoTimingInfo ? xP(o.videoTimingInfo) : o.duration + o.duration * SE, h = new Date(l.getTime() + u * 1e3);
  return t > h ? null : (t > l && (n = o), {
    segment: n,
    estimatedStart: n.videoTimingInfo ? n.videoTimingInfo.transmuxedPresentationStart : ua.duration(i, i.mediaSequence + i.segments.indexOf(n)),
    type: n.videoTimingInfo ? "accurate" : "estimate"
  });
}, wP = function(r, i) {
  if (!i || !i.segments || i.segments.length === 0)
    return null;
  for (var t = 0, n = void 0, a = 0; a < i.segments.length && (n = i.segments[a], t = n.videoTimingInfo ? n.videoTimingInfo.transmuxedPresentationEnd : t + n.duration, !(r <= t)); a++)
    ;
  var s = i.segments[i.segments.length - 1];
  if (s.videoTimingInfo && s.videoTimingInfo.transmuxedPresentationEnd < r)
    return null;
  if (r > t) {
    if (r > t + s.duration * SE)
      return null;
    n = s;
  }
  return {
    segment: n,
    estimatedStart: n.videoTimingInfo ? n.videoTimingInfo.transmuxedPresentationStart : t - n.duration,
    type: n.videoTimingInfo ? "accurate" : "estimate"
  };
}, CP = function(r, i) {
  var t = void 0, n = void 0;
  try {
    t = new Date(r), n = new Date(i);
  } catch {
  }
  var a = t.getTime(), s = n.getTime();
  return (s - a) / 1e3;
}, DP = function(r) {
  if (!r.segments || r.segments.length === 0)
    return !1;
  for (var i = 0; i < r.segments.length; i++) {
    var t = r.segments[i];
    if (!t.dateTimeObject)
      return !1;
  }
  return !0;
}, kP = function(r) {
  var i = r.playlist, t = r.time, n = t === void 0 ? void 0 : t, a = r.callback;
  if (!a)
    throw new Error("getProgramTime: callback must be provided");
  if (!i || n === void 0)
    return a({
      message: "getProgramTime: playlist and time must be provided"
    });
  var s = wP(n, i);
  if (!s)
    return a({
      message: "valid programTime was not found"
    });
  if (s.type === "estimate")
    return a({
      message: "Accurate programTime could not be determined. Please seek to e.seekTime and try again",
      seekTime: s.estimatedStart
    });
  var o = {
    mediaSeconds: n
  }, l = EP(n, s.segment);
  return l && (o.programDateTime = l.toISOString()), a(null, o);
}, RP = function e(r) {
  var i = r.programTime, t = r.playlist, n = r.retryCount, a = n === void 0 ? 2 : n, s = r.seekTo, o = r.pauseAfterSeek, l = o === void 0 ? !0 : o, u = r.tech, h = r.callback;
  if (!h)
    throw new Error("seekToProgramTime: callback must be provided");
  if (typeof i > "u" || !t || !s)
    return h({
      message: "seekToProgramTime: programTime, seekTo and playlist must be provided"
    });
  if (!t.endList && !u.hasStarted_)
    return h({
      message: "player must be playing a live stream to start buffering"
    });
  if (!DP(t))
    return h({
      message: "programDateTime tags must be provided in the manifest " + t.resolvedUri
    });
  var c = AP(i, t);
  if (!c)
    return h({
      message: i + " was not found in the stream"
    });
  var d = c.segment, f = CP(d.dateTimeObject, i);
  if (c.type === "estimate") {
    if (a === 0)
      return h({
        message: i + " is not buffered yet. Try again"
      });
    s(c.estimatedStart + f), u.one("seeked", function() {
      e({
        programTime: i,
        playlist: t,
        retryCount: a - 1,
        seekTo: s,
        pauseAfterSeek: l,
        tech: u,
        callback: h
      });
    });
    return;
  }
  var m = d.start + f, p = function() {
    return h(null, u.currentTime());
  };
  u.one("seeked", p), l && u.pause(), s(m);
}, Hh = 1 / 30, ao = Hh * 3, EE = function(r, i) {
  var t = [], n = void 0;
  if (r && r.length)
    for (n = 0; n < r.length; n++)
      i(r.start(n), r.end(n)) && t.push([r.start(n), r.end(n)]);
  return re.createTimeRanges(t);
}, xE = function(r, i) {
  return EE(r, function(t, n) {
    return t - ao <= i && n + ao >= i;
  });
}, G_ = function(r, i) {
  return EE(r, function(t) {
    return t - Hh >= i;
  });
}, PP = function(r) {
  if (r.length < 2)
    return re.createTimeRanges();
  for (var i = [], t = 1; t < r.length; t++) {
    var n = r.end(t - 1), a = r.start(t);
    i.push([n, a]);
  }
  return re.createTimeRanges(i);
}, Am = function(r) {
  var i = [];
  if (!r || !r.length)
    return "";
  for (var t = 0; t < r.length; t++)
    i.push(r.start(t) + " => " + r.end(t));
  return i.join(", ");
}, OP = function(r, i) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, n = r.length ? r.end(r.length - 1) : 0;
  return (n - i) / t;
}, H_ = function(r) {
  for (var i = [], t = 0; t < r.length; t++)
    i.push({
      start: r.start(t),
      end: r.end(t)
    });
  return i;
}, LP = function(r, i, t) {
  var n = i.player_;
  if (t.captions && t.captions.length) {
    r.inbandTextTracks_ || (r.inbandTextTracks_ = {});
    for (var a in t.captionStreams)
      if (!r.inbandTextTracks_[a]) {
        n.tech_.trigger({
          type: "usage",
          name: "hls-608"
        });
        var s = n.textTracks().getTrackById(a);
        s ? r.inbandTextTracks_[a] = s : r.inbandTextTracks_[a] = n.addRemoteTextTrack({
          kind: "captions",
          id: a,
          label: a
        }, !1).track;
      }
  }
  t.metadata && t.metadata.length && !r.metadataTrack_ && (r.metadataTrack_ = n.addRemoteTextTrack({
    kind: "metadata",
    label: "Timed Metadata"
  }, !1).track, r.metadataTrack_.inBandMetadataTrackDispatchType = t.metadata.dispatchType);
}, Bl = function(r, i, t) {
  var n = void 0, a = void 0;
  if (!!t && !!t.cues)
    for (n = t.cues.length; n--; )
      a = t.cues[n], a.startTime <= i && a.endTime >= r && t.removeCue(a);
}, IP = function(r) {
  Object.defineProperties(r.frame, {
    id: {
      get: function() {
        return re.log.warn("cue.frame.id is deprecated. Use cue.value.key instead."), r.value.key;
      }
    },
    value: {
      get: function() {
        return re.log.warn("cue.frame.value is deprecated. Use cue.value.data instead."), r.value.data;
      }
    },
    privateData: {
      get: function() {
        return re.log.warn("cue.frame.privateData is deprecated. Use cue.value.data instead."), r.value.data;
      }
    }
  });
}, AE = function(r) {
  var i = void 0;
  return isNaN(r) || Math.abs(r) === 1 / 0 ? i = Number.MAX_VALUE : i = r, i;
}, MP = function(r, i, t) {
  var n = Be.WebKitDataCue || Be.VTTCue;
  if (i && i.forEach(function(c) {
    var d = c.stream;
    this.inbandTextTracks_[d].addCue(new n(c.startTime + this.timestampOffset, c.endTime + this.timestampOffset, c.text));
  }, r), t) {
    var a = AE(r.mediaSource_.duration);
    if (t.forEach(function(c) {
      var d = c.cueTime + this.timestampOffset;
      typeof d != "number" || Be.isNaN(d) || d < 0 || !(d < 1 / 0) || c.frames.forEach(function(f) {
        var m = new n(d, d, f.value || f.url || f.data || "");
        m.frame = f, m.value = f, IP(m), this.metadataTrack_.addCue(m);
      }, this);
    }, r), r.metadataTrack_ && r.metadataTrack_.cues && r.metadataTrack_.cues.length) {
      for (var s = r.metadataTrack_.cues, o = [], l = 0; l < s.length; l++)
        s[l] && o.push(s[l]);
      var u = o.reduce(function(c, d) {
        var f = c[d.startTime] || [];
        return f.push(d), c[d.startTime] = f, c;
      }, {}), h = Object.keys(u).sort(function(c, d) {
        return Number(c) - Number(d);
      });
      h.forEach(function(c, d) {
        var f = u[c], m = Number(h[d + 1]) || a;
        f.forEach(function(p) {
          p.endTime = m;
        });
      });
    }
  }
}, Bu = typeof window < "u" ? window : {}, Xp = typeof Symbol > "u" ? "__target" : Symbol(), NP = "application/javascript", FP = Bu.BlobBuilder || Bu.WebKitBlobBuilder || Bu.MozBlobBuilder || Bu.MSBlobBuilder, Ql = Bu.URL || Bu.webkitURL || Ql && Ql.msURL, jl = Bu.Worker;
function wE(e, r) {
  return function(t) {
    var n = this;
    if (r)
      if (jl && !t) {
        var a = r.toString().replace(/^function.+?{/, "").slice(0, -1), s = CE(a);
        return this[Xp] = new jl(s), UP(this[Xp], s), this[Xp];
      } else {
        var o = {
          postMessage: function(u) {
            n.onmessage && setTimeout(function() {
              n.onmessage({
                data: u,
                target: o
              });
            });
          }
        };
        r.call(o), this.postMessage = function(l) {
          setTimeout(function() {
            o.onmessage({
              data: l,
              target: n
            });
          });
        }, this.isThisThread = !0;
      }
    else
      return new jl(e);
  };
}
if (jl) {
  var hf, V_ = CE("self.onmessage = function () {}"), q_ = new Uint8Array(1);
  try {
    hf = new jl(V_), hf.postMessage(q_, [q_.buffer]);
  } catch {
    jl = null;
  } finally {
    Ql.revokeObjectURL(V_), hf && hf.terminate();
  }
}
function CE(e) {
  try {
    return Ql.createObjectURL(new Blob([e], {
      type: NP
    }));
  } catch {
    var r = new FP();
    return r.append(e), Ql.createObjectURL(r.getBlob(type));
  }
}
function UP(e, r) {
  if (!(!e || !r)) {
    var i = e.terminate;
    e.objURL = r, e.terminate = function() {
      e.objURL && Ql.revokeObjectURL(e.objURL), i.call(e);
    };
  }
}
var BP = new wE("./transmuxer-worker.worker.js", function(e, r) {
  var i = this;
  (function() {
    var t = function() {
      this.init = function() {
        var q = {};
        this.on = function(z, ie) {
          q[z] || (q[z] = []), q[z] = q[z].concat(ie);
        }, this.off = function(z, ie) {
          var ne;
          return q[z] ? (ne = q[z].indexOf(ie), q[z] = q[z].slice(), q[z].splice(ne, 1), ne > -1) : !1;
        }, this.trigger = function(z) {
          var ie, ne, pe, ve;
          if (ie = q[z], !!ie)
            if (arguments.length === 2)
              for (pe = ie.length, ne = 0; ne < pe; ++ne)
                ie[ne].call(this, arguments[1]);
            else {
              for (ve = [], ne = arguments.length, ne = 1; ne < arguments.length; ++ne)
                ve.push(arguments[ne]);
              for (pe = ie.length, ne = 0; ne < pe; ++ne)
                ie[ne].apply(this, ve);
            }
        }, this.dispose = function() {
          q = {};
        };
      };
    };
    t.prototype.pipe = function(xe) {
      return this.on("data", function(q) {
        xe.push(q);
      }), this.on("done", function(q) {
        xe.flush(q);
      }), this.on("partialdone", function(q) {
        xe.partialFlush(q);
      }), this.on("endedtimeline", function(q) {
        xe.endTimeline(q);
      }), this.on("reset", function(q) {
        xe.reset(q);
      }), xe;
    }, t.prototype.push = function(xe) {
      this.trigger("data", xe);
    }, t.prototype.flush = function(xe) {
      this.trigger("done", xe);
    }, t.prototype.partialFlush = function(xe) {
      this.trigger("partialdone", xe);
    }, t.prototype.endTimeline = function(xe) {
      this.trigger("endedtimeline", xe);
    }, t.prototype.reset = function(xe) {
      this.trigger("reset", xe);
    };
    var n = t, a = Math.pow(2, 32) - 1, s, o, l, u, h, c, d, f, m, p, b, y, v, g, E, x, w, S, T, C, D, R, P, N, $, O, M, F, G, K, J, ue, ce, ee, me, Ce;
    (function() {
      var xe;
      if (P = {
        avc1: [],
        avcC: [],
        btrt: [],
        dinf: [],
        dref: [],
        esds: [],
        ftyp: [],
        hdlr: [],
        mdat: [],
        mdhd: [],
        mdia: [],
        mfhd: [],
        minf: [],
        moof: [],
        moov: [],
        mp4a: [],
        mvex: [],
        mvhd: [],
        pasp: [],
        sdtp: [],
        smhd: [],
        stbl: [],
        stco: [],
        stsc: [],
        stsd: [],
        stsz: [],
        stts: [],
        styp: [],
        tfdt: [],
        tfhd: [],
        traf: [],
        trak: [],
        trun: [],
        trex: [],
        tkhd: [],
        vmhd: []
      }, !(typeof Uint8Array > "u")) {
        for (xe in P)
          P.hasOwnProperty(xe) && (P[xe] = [xe.charCodeAt(0), xe.charCodeAt(1), xe.charCodeAt(2), xe.charCodeAt(3)]);
        N = new Uint8Array(["i".charCodeAt(0), "s".charCodeAt(0), "o".charCodeAt(0), "m".charCodeAt(0)]), O = new Uint8Array(["a".charCodeAt(0), "v".charCodeAt(0), "c".charCodeAt(0), "1".charCodeAt(0)]), $ = new Uint8Array([0, 0, 0, 1]), M = new Uint8Array([
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          118,
          105,
          100,
          101,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          86,
          105,
          100,
          101,
          111,
          72,
          97,
          110,
          100,
          108,
          101,
          114,
          0
        ]), F = new Uint8Array([
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          115,
          111,
          117,
          110,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          83,
          111,
          117,
          110,
          100,
          72,
          97,
          110,
          100,
          108,
          101,
          114,
          0
        ]), G = {
          video: M,
          audio: F
        }, ue = new Uint8Array([
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          12,
          117,
          114,
          108,
          32,
          0,
          0,
          0,
          1
        ]), J = new Uint8Array([
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]), ce = new Uint8Array([
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]), ee = ce, me = new Uint8Array([
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]), Ce = ce, K = new Uint8Array([
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]);
      }
    })(), s = function(q) {
      var z = [], ie = 0, ne, pe, ve;
      for (ne = 1; ne < arguments.length; ne++)
        z.push(arguments[ne]);
      for (ne = z.length; ne--; )
        ie += z[ne].byteLength;
      for (pe = new Uint8Array(ie + 8), ve = new DataView(pe.buffer, pe.byteOffset, pe.byteLength), ve.setUint32(0, pe.byteLength), pe.set(q, 4), ne = 0, ie = 8; ne < z.length; ne++)
        pe.set(z[ne], ie), ie += z[ne].byteLength;
      return pe;
    }, o = function() {
      return s(P.dinf, s(P.dref, ue));
    }, l = function(q) {
      return s(P.esds, new Uint8Array([
        0,
        0,
        0,
        0,
        3,
        25,
        0,
        0,
        0,
        4,
        17,
        64,
        21,
        0,
        6,
        0,
        0,
        0,
        218,
        192,
        0,
        0,
        218,
        192,
        5,
        2,
        q.audioobjecttype << 3 | q.samplingfrequencyindex >>> 1,
        q.samplingfrequencyindex << 7 | q.channelcount << 3,
        6,
        1,
        2
      ]));
    }, u = function() {
      return s(P.ftyp, N, $, N, O);
    }, x = function(q) {
      return s(P.hdlr, G[q]);
    }, h = function(q) {
      return s(P.mdat, q);
    }, E = function(q) {
      var z = new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        3,
        0,
        1,
        95,
        144,
        q.duration >>> 24 & 255,
        q.duration >>> 16 & 255,
        q.duration >>> 8 & 255,
        q.duration & 255,
        85,
        196,
        0,
        0
      ]);
      return q.samplerate && (z[12] = q.samplerate >>> 24 & 255, z[13] = q.samplerate >>> 16 & 255, z[14] = q.samplerate >>> 8 & 255, z[15] = q.samplerate & 255), s(P.mdhd, z);
    }, g = function(q) {
      return s(P.mdia, E(q), x(q.type), d(q));
    }, c = function(q) {
      return s(P.mfhd, new Uint8Array([
        0,
        0,
        0,
        0,
        (q & 4278190080) >> 24,
        (q & 16711680) >> 16,
        (q & 65280) >> 8,
        q & 255
      ]));
    }, d = function(q) {
      return s(P.minf, q.type === "video" ? s(P.vmhd, K) : s(P.smhd, J), o(), S(q));
    }, f = function(q, z) {
      for (var ie = [], ne = z.length; ne--; )
        ie[ne] = C(z[ne]);
      return s.apply(null, [P.moof, c(q)].concat(ie));
    }, m = function(q) {
      for (var z = q.length, ie = []; z--; )
        ie[z] = y(q[z]);
      return s.apply(null, [P.moov, b(4294967295)].concat(ie).concat(p(q)));
    }, p = function(q) {
      for (var z = q.length, ie = []; z--; )
        ie[z] = D(q[z]);
      return s.apply(null, [P.mvex].concat(ie));
    }, b = function(q) {
      var z = new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        2,
        0,
        1,
        95,
        144,
        (q & 4278190080) >> 24,
        (q & 16711680) >> 16,
        (q & 65280) >> 8,
        q & 255,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        64,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        255,
        255,
        255,
        255
      ]);
      return s(P.mvhd, z);
    }, w = function(q) {
      var z = q.samples || [], ie = new Uint8Array(4 + z.length), ne, pe;
      for (pe = 0; pe < z.length; pe++)
        ne = z[pe].flags, ie[pe + 4] = ne.dependsOn << 4 | ne.isDependedOn << 2 | ne.hasRedundancy;
      return s(P.sdtp, ie);
    }, S = function(q) {
      return s(P.stbl, T(q), s(P.stts, Ce), s(P.stsc, ee), s(P.stsz, me), s(P.stco, ce));
    }, function() {
      var xe, q;
      T = function(ie) {
        return s(P.stsd, new Uint8Array([
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1
        ]), ie.type === "video" ? xe(ie) : q(ie));
      }, xe = function(ie) {
        var ne = ie.sps || [], pe = ie.pps || [], ve = [], Ae = [], ke, Ve;
        for (ke = 0; ke < ne.length; ke++)
          ve.push((ne[ke].byteLength & 65280) >>> 8), ve.push(ne[ke].byteLength & 255), ve = ve.concat(Array.prototype.slice.call(ne[ke]));
        for (ke = 0; ke < pe.length; ke++)
          Ae.push((pe[ke].byteLength & 65280) >>> 8), Ae.push(pe[ke].byteLength & 255), Ae = Ae.concat(Array.prototype.slice.call(pe[ke]));
        if (Ve = [P.avc1, new Uint8Array([
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          (ie.width & 65280) >> 8,
          ie.width & 255,
          (ie.height & 65280) >> 8,
          ie.height & 255,
          0,
          72,
          0,
          0,
          0,
          72,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          19,
          118,
          105,
          100,
          101,
          111,
          106,
          115,
          45,
          99,
          111,
          110,
          116,
          114,
          105,
          98,
          45,
          104,
          108,
          115,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          24,
          17,
          17
        ]), s(P.avcC, new Uint8Array([
          1,
          ie.profileIdc,
          ie.profileCompatibility,
          ie.levelIdc,
          255
        ].concat(
          [ne.length],
          ve,
          [pe.length],
          Ae
        ))), s(P.btrt, new Uint8Array([
          0,
          28,
          156,
          128,
          0,
          45,
          198,
          192,
          0,
          45,
          198,
          192
        ]))], ie.sarRatio) {
          var st = ie.sarRatio[0], Ft = ie.sarRatio[1];
          Ve.push(s(P.pasp, new Uint8Array([(st & 4278190080) >> 24, (st & 16711680) >> 16, (st & 65280) >> 8, st & 255, (Ft & 4278190080) >> 24, (Ft & 16711680) >> 16, (Ft & 65280) >> 8, Ft & 255])));
        }
        return s.apply(null, Ve);
      }, q = function(ie) {
        return s(P.mp4a, new Uint8Array([
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          (ie.channelcount & 65280) >> 8,
          ie.channelcount & 255,
          (ie.samplesize & 65280) >> 8,
          ie.samplesize & 255,
          0,
          0,
          0,
          0,
          (ie.samplerate & 65280) >> 8,
          ie.samplerate & 255,
          0,
          0
        ]), l(ie));
      };
    }(), v = function(q) {
      var z = new Uint8Array([
        0,
        0,
        0,
        7,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        (q.id & 4278190080) >> 24,
        (q.id & 16711680) >> 16,
        (q.id & 65280) >> 8,
        q.id & 255,
        0,
        0,
        0,
        0,
        (q.duration & 4278190080) >> 24,
        (q.duration & 16711680) >> 16,
        (q.duration & 65280) >> 8,
        q.duration & 255,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        64,
        0,
        0,
        0,
        (q.width & 65280) >> 8,
        q.width & 255,
        0,
        0,
        (q.height & 65280) >> 8,
        q.height & 255,
        0,
        0
      ]);
      return s(P.tkhd, z);
    }, C = function(q) {
      var z, ie, ne, pe, ve, Ae, ke;
      return z = s(P.tfhd, new Uint8Array([
        0,
        0,
        0,
        58,
        (q.id & 4278190080) >> 24,
        (q.id & 16711680) >> 16,
        (q.id & 65280) >> 8,
        q.id & 255,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ])), Ae = Math.floor(q.baseMediaDecodeTime / (a + 1)), ke = Math.floor(q.baseMediaDecodeTime % (a + 1)), ie = s(P.tfdt, new Uint8Array([
        1,
        0,
        0,
        0,
        Ae >>> 24 & 255,
        Ae >>> 16 & 255,
        Ae >>> 8 & 255,
        Ae & 255,
        ke >>> 24 & 255,
        ke >>> 16 & 255,
        ke >>> 8 & 255,
        ke & 255
      ])), ve = 32 + 20 + 8 + 16 + 8 + 8, q.type === "audio" ? (ne = R(q, ve), s(P.traf, z, ie, ne)) : (pe = w(q), ne = R(q, pe.length + ve), s(P.traf, z, ie, ne, pe));
    }, y = function(q) {
      return q.duration = q.duration || 4294967295, s(P.trak, v(q), g(q));
    }, D = function(q) {
      var z = new Uint8Array([
        0,
        0,
        0,
        0,
        (q.id & 4278190080) >> 24,
        (q.id & 16711680) >> 16,
        (q.id & 65280) >> 8,
        q.id & 255,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1
      ]);
      return q.type !== "video" && (z[z.length - 1] = 0), s(P.trex, z);
    }, function() {
      var xe, q, z;
      z = function(ne, pe) {
        var ve = 0, Ae = 0, ke = 0, Ve = 0;
        return ne.length && (ne[0].duration !== void 0 && (ve = 1), ne[0].size !== void 0 && (Ae = 2), ne[0].flags !== void 0 && (ke = 4), ne[0].compositionTimeOffset !== void 0 && (Ve = 8)), [
          0,
          0,
          ve | Ae | ke | Ve,
          1,
          (ne.length & 4278190080) >>> 24,
          (ne.length & 16711680) >>> 16,
          (ne.length & 65280) >>> 8,
          ne.length & 255,
          (pe & 4278190080) >>> 24,
          (pe & 16711680) >>> 16,
          (pe & 65280) >>> 8,
          pe & 255
        ];
      }, q = function(ne, pe) {
        var ve, Ae, ke, Ve;
        for (Ae = ne.samples || [], pe += 8 + 12 + 16 * Ae.length, ve = z(Ae, pe), Ve = 0; Ve < Ae.length; Ve++)
          ke = Ae[Ve], ve = ve.concat([
            (ke.duration & 4278190080) >>> 24,
            (ke.duration & 16711680) >>> 16,
            (ke.duration & 65280) >>> 8,
            ke.duration & 255,
            (ke.size & 4278190080) >>> 24,
            (ke.size & 16711680) >>> 16,
            (ke.size & 65280) >>> 8,
            ke.size & 255,
            ke.flags.isLeading << 2 | ke.flags.dependsOn,
            ke.flags.isDependedOn << 6 | ke.flags.hasRedundancy << 4 | ke.flags.paddingValue << 1 | ke.flags.isNonSyncSample,
            ke.flags.degradationPriority & 240 << 8,
            ke.flags.degradationPriority & 15,
            (ke.compositionTimeOffset & 4278190080) >>> 24,
            (ke.compositionTimeOffset & 16711680) >>> 16,
            (ke.compositionTimeOffset & 65280) >>> 8,
            ke.compositionTimeOffset & 255
          ]);
        return s(P.trun, new Uint8Array(ve));
      }, xe = function(ne, pe) {
        var ve, Ae, ke, Ve;
        for (Ae = ne.samples || [], pe += 8 + 12 + 8 * Ae.length, ve = z(Ae, pe), Ve = 0; Ve < Ae.length; Ve++)
          ke = Ae[Ve], ve = ve.concat([
            (ke.duration & 4278190080) >>> 24,
            (ke.duration & 16711680) >>> 16,
            (ke.duration & 65280) >>> 8,
            ke.duration & 255,
            (ke.size & 4278190080) >>> 24,
            (ke.size & 16711680) >>> 16,
            (ke.size & 65280) >>> 8,
            ke.size & 255
          ]);
        return s(P.trun, new Uint8Array(ve));
      }, R = function(ne, pe) {
        return ne.type === "audio" ? xe(ne, pe) : q(ne, pe);
      };
    }();
    var Ne = {
      ftyp: u,
      mdat: h,
      moof: f,
      moov: m,
      initSegment: function(q) {
        var z = u(), ie = m(q), ne;
        return ne = new Uint8Array(z.byteLength + ie.byteLength), ne.set(z), ne.set(ie, z.byteLength), ne;
      }
    }, ot = function(q) {
      var z, ie, ne = [], pe = [];
      for (pe.byteLength = 0, pe.nalCount = 0, pe.duration = 0, ne.byteLength = 0, z = 0; z < q.length; z++)
        ie = q[z], ie.nalUnitType === "access_unit_delimiter_rbsp" ? (ne.length && (ne.duration = ie.dts - ne.dts, pe.byteLength += ne.byteLength, pe.nalCount += ne.length, pe.duration += ne.duration, pe.push(ne)), ne = [ie], ne.byteLength = ie.data.byteLength, ne.pts = ie.pts, ne.dts = ie.dts) : (ie.nalUnitType === "slice_layer_without_partitioning_rbsp_idr" && (ne.keyFrame = !0), ne.duration = ie.dts - ne.dts, ne.byteLength += ie.data.byteLength, ne.push(ie));
      return pe.length && (!ne.duration || ne.duration <= 0) && (ne.duration = pe[pe.length - 1].duration), pe.byteLength += ne.byteLength, pe.nalCount += ne.length, pe.duration += ne.duration, pe.push(ne), pe;
    }, ze = function(q) {
      var z, ie, ne = [], pe = [];
      for (ne.byteLength = 0, ne.nalCount = 0, ne.duration = 0, ne.pts = q[0].pts, ne.dts = q[0].dts, pe.byteLength = 0, pe.nalCount = 0, pe.duration = 0, pe.pts = q[0].pts, pe.dts = q[0].dts, z = 0; z < q.length; z++)
        ie = q[z], ie.keyFrame ? (ne.length && (pe.push(ne), pe.byteLength += ne.byteLength, pe.nalCount += ne.nalCount, pe.duration += ne.duration), ne = [ie], ne.nalCount = ie.length, ne.byteLength = ie.byteLength, ne.pts = ie.pts, ne.dts = ie.dts, ne.duration = ie.duration) : (ne.duration += ie.duration, ne.nalCount += ie.length, ne.byteLength += ie.byteLength, ne.push(ie));
      return pe.length && ne.duration <= 0 && (ne.duration = pe[pe.length - 1].duration), pe.byteLength += ne.byteLength, pe.nalCount += ne.nalCount, pe.duration += ne.duration, pe.push(ne), pe;
    }, $e = function(q) {
      var z;
      return !q[0][0].keyFrame && q.length > 1 && (z = q.shift(), q.byteLength -= z.byteLength, q.nalCount -= z.nalCount, q[0][0].dts = z.dts, q[0][0].pts = z.pts, q[0][0].duration += z.duration), q;
    }, Ze = function() {
      return {
        size: 0,
        flags: {
          isLeading: 0,
          dependsOn: 1,
          isDependedOn: 0,
          hasRedundancy: 0,
          degradationPriority: 0,
          isNonSyncSample: 1
        }
      };
    }, Ut = function(q, z) {
      var ie = Ze();
      return ie.dataOffset = z, ie.compositionTimeOffset = q.pts - q.dts, ie.duration = q.duration, ie.size = 4 * q.length, ie.size += q.byteLength, q.keyFrame && (ie.flags.dependsOn = 2, ie.flags.isNonSyncSample = 0), ie;
    }, qt = function(q, z) {
      var ie, ne, pe, ve, Ae, ke = z || 0, Ve = [];
      for (ie = 0; ie < q.length; ie++)
        for (ve = q[ie], ne = 0; ne < ve.length; ne++)
          Ae = ve[ne], pe = Ut(Ae, ke), ke += pe.size, Ve.push(pe);
      return Ve;
    }, ir = function(q) {
      var z, ie, ne, pe, ve, Ae, ke = 0, Ve = q.byteLength, st = q.nalCount, Ft = Ve + 4 * st, Zt = new Uint8Array(Ft), nr = new DataView(Zt.buffer);
      for (z = 0; z < q.length; z++)
        for (pe = q[z], ie = 0; ie < pe.length; ie++)
          for (ve = pe[ie], ne = 0; ne < ve.length; ne++)
            Ae = ve[ne], nr.setUint32(ke, Ae.data.byteLength), ke += 4, Zt.set(Ae.data, ke), ke += Ae.data.byteLength;
      return Zt;
    }, We = function(q, z) {
      var ie, ne = z || 0, pe = [];
      return ie = Ut(q, ne), pe.push(ie), pe;
    }, vt = function(q) {
      var z, ie, ne = 0, pe = q.byteLength, ve = q.length, Ae = pe + 4 * ve, ke = new Uint8Array(Ae), Ve = new DataView(ke.buffer);
      for (z = 0; z < q.length; z++)
        ie = q[z], Ve.setUint32(ne, ie.data.byteLength), ne += 4, ke.set(ie.data, ne), ne += ie.data.byteLength;
      return ke;
    }, Tt = {
      groupNalsIntoFrames: ot,
      groupFramesIntoGops: ze,
      extendFirstKeyFrame: $e,
      generateSampleTable: qt,
      concatenateNalData: ir,
      generateSampleTableForFrame: We,
      concatenateNalDataForFrame: vt
    }, xt = [33, 16, 5, 32, 164, 27], Pt = [33, 65, 108, 84, 1, 2, 4, 8, 168, 2, 4, 8, 17, 191, 252], at = function(q) {
      for (var z = []; q--; )
        z.push(0);
      return z;
    }, Ot = function(q) {
      return Object.keys(q).reduce(function(z, ie) {
        return z[ie] = new Uint8Array(q[ie].reduce(function(ne, pe) {
          return ne.concat(pe);
        }, [])), z;
      }, {});
    }, It = {
      96e3: [xt, [227, 64], at(154), [56]],
      88200: [xt, [231], at(170), [56]],
      64e3: [xt, [248, 192], at(240), [56]],
      48e3: [xt, [255, 192], at(268), [55, 148, 128], at(54), [112]],
      44100: [xt, [255, 192], at(268), [55, 163, 128], at(84), [112]],
      32e3: [xt, [255, 192], at(268), [55, 234], at(226), [112]],
      24e3: [xt, [255, 192], at(268), [55, 255, 128], at(268), [111, 112], at(126), [224]],
      16e3: [xt, [255, 192], at(268), [55, 255, 128], at(268), [111, 255], at(269), [223, 108], at(195), [1, 192]],
      12e3: [Pt, at(268), [3, 127, 248], at(268), [6, 255, 240], at(268), [13, 255, 224], at(268), [27, 253, 128], at(259), [56]],
      11025: [Pt, at(268), [3, 127, 248], at(268), [6, 255, 240], at(268), [13, 255, 224], at(268), [27, 255, 192], at(268), [55, 175, 128], at(108), [112]],
      8e3: [Pt, at(268), [3, 121, 16], at(47), [7]]
    }, sr = Ot(It), lt = 9e4, ri, Qr, xr, _i, Gr, li, ci;
    ri = function(q) {
      return q * lt;
    }, Qr = function(q, z) {
      return q * z;
    }, xr = function(q) {
      return q / lt;
    }, _i = function(q, z) {
      return q / z;
    }, Gr = function(q, z) {
      return ri(_i(q, z));
    }, li = function(q, z) {
      return Qr(xr(q), z);
    }, ci = function(q, z, ie) {
      return xr(ie ? q : q - z);
    };
    var oi = {
      ONE_SECOND_IN_TS: lt,
      secondsToVideoTs: ri,
      secondsToAudioTs: Qr,
      videoTsToSeconds: xr,
      audioTsToSeconds: _i,
      audioTsToVideoTs: Gr,
      videoTsToAudioTs: li,
      metadataTsToSeconds: ci
    }, Kr = function(q) {
      var z, ie, ne = 0;
      for (z = 0; z < q.length; z++)
        ie = q[z], ne += ie.data.byteLength;
      return ne;
    }, mn = function(q, z, ie, ne) {
      var pe, ve = 0, Ae = 0, ke = 0, Ve = 0, st, Ft, Zt;
      if (!!z.length && (pe = oi.audioTsToVideoTs(q.baseMediaDecodeTime, q.samplerate), ve = Math.ceil(oi.ONE_SECOND_IN_TS / (q.samplerate / 1024)), ie && ne && (Ae = pe - Math.max(ie, ne), ke = Math.floor(Ae / ve), Ve = ke * ve), !(ke < 1 || Ve > oi.ONE_SECOND_IN_TS / 2))) {
        for (st = sr[q.samplerate], st || (st = z[0].data), Ft = 0; Ft < ke; Ft++)
          Zt = z[0], z.splice(0, 0, {
            data: st,
            dts: Zt.dts - ve,
            pts: Zt.pts - ve
          });
        q.baseMediaDecodeTime -= Math.floor(oi.videoTsToAudioTs(Ve, q.samplerate));
      }
    }, wa = function(q, z, ie) {
      return z.minSegmentDts >= ie ? q : (z.minSegmentDts = 1 / 0, q.filter(function(ne) {
        return ne.dts >= ie ? (z.minSegmentDts = Math.min(z.minSegmentDts, ne.dts), z.minSegmentPts = z.minSegmentDts, !0) : !1;
      }));
    }, Ys = function(q) {
      var z, ie, ne = [];
      for (z = 0; z < q.length; z++)
        ie = q[z], ne.push({
          size: ie.data.byteLength,
          duration: 1024
        });
      return ne;
    }, za = function(q) {
      var z, ie, ne = 0, pe = new Uint8Array(Kr(q));
      for (z = 0; z < q.length; z++)
        ie = q[z], pe.set(ie.data, ne), ne += ie.data.byteLength;
      return pe;
    }, jn = {
      prefixWithSilence: mn,
      trimAdtsFramesByEarliestDts: wa,
      generateSampleTable: Ys,
      concatenateFrameData: za
    }, Xa = oi.ONE_SECOND_IN_TS, Ks = function(q, z) {
      typeof z.pts == "number" && (q.timelineStartInfo.pts === void 0 && (q.timelineStartInfo.pts = z.pts), q.minSegmentPts === void 0 ? q.minSegmentPts = z.pts : q.minSegmentPts = Math.min(q.minSegmentPts, z.pts), q.maxSegmentPts === void 0 ? q.maxSegmentPts = z.pts : q.maxSegmentPts = Math.max(q.maxSegmentPts, z.pts)), typeof z.dts == "number" && (q.timelineStartInfo.dts === void 0 && (q.timelineStartInfo.dts = z.dts), q.minSegmentDts === void 0 ? q.minSegmentDts = z.dts : q.minSegmentDts = Math.min(q.minSegmentDts, z.dts), q.maxSegmentDts === void 0 ? q.maxSegmentDts = z.dts : q.maxSegmentDts = Math.max(q.maxSegmentDts, z.dts));
    }, yn = function(q) {
      delete q.minSegmentDts, delete q.maxSegmentDts, delete q.minSegmentPts, delete q.maxSegmentPts;
    }, ha = function(q, z) {
      var ie, ne, pe = q.minSegmentDts;
      return z || (pe -= q.timelineStartInfo.dts), ie = q.timelineStartInfo.baseMediaDecodeTime, ie += pe, ie = Math.max(0, ie), q.type === "audio" && (ne = q.samplerate / Xa, ie *= ne, ie = Math.floor(ie)), ie;
    }, Ei = {
      clearDtsInfo: yn,
      calculateTrackBaseMediaDecodeTime: ha,
      collectDtsInfo: Ks
    }, ys = 4, Ro = 128, zs = function(q) {
      for (var z = 0, ie = {
        payloadType: -1,
        payloadSize: 0
      }, ne = 0, pe = 0; z < q.byteLength && q[z] !== Ro; ) {
        for (; q[z] === 255; )
          ne += 255, z++;
        for (ne += q[z++]; q[z] === 255; )
          pe += 255, z++;
        if (pe += q[z++], !ie.payload && ne === ys) {
          ie.payloadType = ne, ie.payloadSize = pe, ie.payload = q.subarray(z, z + pe);
          break;
        }
        z += pe, ne = 0, pe = 0;
      }
      return ie;
    }, Ja = function(q) {
      return q.payload[0] !== 181 || (q.payload[1] << 8 | q.payload[2]) !== 49 || String.fromCharCode(q.payload[3], q.payload[4], q.payload[5], q.payload[6]) !== "GA94" || q.payload[7] !== 3 ? null : q.payload.subarray(8, q.payload.length - 1);
    }, _n = function(q, z) {
      var ie = [], ne, pe, ve, Ae;
      if (!(z[0] & 64))
        return ie;
      for (pe = z[0] & 31, ne = 0; ne < pe; ne++)
        ve = ne * 3, Ae = {
          type: z[ve + 2] & 3,
          pts: q
        }, z[ve + 2] & 4 && (Ae.ccData = z[ve + 3] << 8 | z[ve + 4], ie.push(Ae));
      return ie;
    }, Ca = function(q) {
      for (var z = q.byteLength, ie = [], ne = 1, pe, ve; ne < z - 2; )
        q[ne] === 0 && q[ne + 1] === 0 && q[ne + 2] === 3 ? (ie.push(ne + 2), ne += 2) : ne++;
      if (ie.length === 0)
        return q;
      pe = z - ie.length, ve = new Uint8Array(pe);
      var Ae = 0;
      for (ne = 0; ne < pe; Ae++, ne++)
        Ae === ie[0] && (Ae++, ie.shift()), ve[ne] = q[Ae];
      return ve;
    }, Da = {
      parseSei: zs,
      parseUserData: Ja,
      parseCaptionPackets: _n,
      discardEmulationPreventionBytes: Ca,
      USER_DATA_REGISTERED_ITU_T_T35: ys
    }, on = function xe() {
      xe.prototype.init.call(this), this.captionPackets_ = [], this.ccStreams_ = [
        new ui(0, 0),
        new ui(0, 1),
        new ui(1, 0),
        new ui(1, 1)
      ], this.reset(), this.ccStreams_.forEach(function(q) {
        q.on("data", this.trigger.bind(this, "data")), q.on("partialdone", this.trigger.bind(this, "partialdone")), q.on("done", this.trigger.bind(this, "done"));
      }, this);
    };
    on.prototype = new n(), on.prototype.push = function(xe) {
      var q, z, ie;
      if (xe.nalUnitType === "sei_rbsp" && (q = Da.parseSei(xe.escapedRBSP), q.payloadType === Da.USER_DATA_REGISTERED_ITU_T_T35 && (z = Da.parseUserData(q), !!z))) {
        if (xe.dts < this.latestDts_) {
          this.ignoreNextEqualDts_ = !0;
          return;
        } else if (xe.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
          this.numSameDts_--, this.numSameDts_ || (this.ignoreNextEqualDts_ = !1);
          return;
        }
        ie = Da.parseCaptionPackets(xe.pts, z), this.captionPackets_ = this.captionPackets_.concat(ie), this.latestDts_ !== xe.dts && (this.numSameDts_ = 0), this.numSameDts_++, this.latestDts_ = xe.dts;
      }
    }, on.prototype.flushCCStreams = function(xe) {
      this.ccStreams_.forEach(function(q) {
        return xe === "flush" ? q.flush() : q.partialFlush();
      }, this);
    }, on.prototype.flushStream = function(xe) {
      if (!this.captionPackets_.length) {
        this.flushCCStreams(xe);
        return;
      }
      this.captionPackets_.forEach(function(q, z) {
        q.presortIndex = z;
      }), this.captionPackets_.sort(function(q, z) {
        return q.pts === z.pts ? q.presortIndex - z.presortIndex : q.pts - z.pts;
      }), this.captionPackets_.forEach(function(q) {
        q.type < 2 && this.dispatchCea608Packet(q);
      }, this), this.captionPackets_.length = 0, this.flushCCStreams(xe);
    }, on.prototype.flush = function() {
      return this.flushStream("flush");
    }, on.prototype.partialFlush = function() {
      return this.flushStream("partialFlush");
    }, on.prototype.reset = function() {
      this.latestDts_ = null, this.ignoreNextEqualDts_ = !1, this.numSameDts_ = 0, this.activeCea608Channel_ = [null, null], this.ccStreams_.forEach(function(xe) {
        xe.reset();
      });
    }, on.prototype.dispatchCea608Packet = function(xe) {
      this.setsTextOrXDSActive(xe) ? this.activeCea608Channel_[xe.type] = null : this.setsChannel1Active(xe) ? this.activeCea608Channel_[xe.type] = 0 : this.setsChannel2Active(xe) && (this.activeCea608Channel_[xe.type] = 1), this.activeCea608Channel_[xe.type] !== null && this.ccStreams_[(xe.type << 1) + this.activeCea608Channel_[xe.type]].push(xe);
    }, on.prototype.setsChannel1Active = function(xe) {
      return (xe.ccData & 30720) === 4096;
    }, on.prototype.setsChannel2Active = function(xe) {
      return (xe.ccData & 30720) === 6144;
    }, on.prototype.setsTextOrXDSActive = function(xe) {
      return (xe.ccData & 28928) === 256 || (xe.ccData & 30974) === 4138 || (xe.ccData & 30974) === 6186;
    };
    var Po = {
      42: 225,
      92: 233,
      94: 237,
      95: 243,
      96: 250,
      123: 231,
      124: 247,
      125: 209,
      126: 241,
      127: 9608,
      304: 174,
      305: 176,
      306: 189,
      307: 191,
      308: 8482,
      309: 162,
      310: 163,
      311: 9834,
      312: 224,
      313: 160,
      314: 232,
      315: 226,
      316: 234,
      317: 238,
      318: 244,
      319: 251,
      544: 193,
      545: 201,
      546: 211,
      547: 218,
      548: 220,
      549: 252,
      550: 8216,
      551: 161,
      552: 42,
      553: 39,
      554: 8212,
      555: 169,
      556: 8480,
      557: 8226,
      558: 8220,
      559: 8221,
      560: 192,
      561: 194,
      562: 199,
      563: 200,
      564: 202,
      565: 203,
      566: 235,
      567: 206,
      568: 207,
      569: 239,
      570: 212,
      571: 217,
      572: 249,
      573: 219,
      574: 171,
      575: 187,
      800: 195,
      801: 227,
      802: 205,
      803: 204,
      804: 236,
      805: 210,
      806: 242,
      807: 213,
      808: 245,
      809: 123,
      810: 125,
      811: 92,
      812: 94,
      813: 95,
      814: 124,
      815: 126,
      816: 196,
      817: 228,
      818: 214,
      819: 246,
      820: 223,
      821: 165,
      822: 164,
      823: 9474,
      824: 197,
      825: 229,
      826: 216,
      827: 248,
      828: 9484,
      829: 9488,
      830: 9492,
      831: 9496
    }, _s = function(q) {
      return q === null ? "" : (q = Po[q] || q, String.fromCharCode(q));
    }, bs = 14, Oo = [4352, 4384, 4608, 4640, 5376, 5408, 5632, 5664, 5888, 5920, 4096, 4864, 4896, 5120, 5152], $n = function() {
      for (var q = [], z = bs + 1; z--; )
        q.push("");
      return q;
    }, ui = function xe(q, z) {
      xe.prototype.init.call(this), this.field_ = q || 0, this.dataChannel_ = z || 0, this.name_ = "CC" + ((this.field_ << 1 | this.dataChannel_) + 1), this.setConstants(), this.reset(), this.push = function(ie) {
        var ne, pe, ve, Ae, ke;
        if (ne = ie.ccData & 32639, ne === this.lastControlCode_) {
          this.lastControlCode_ = null;
          return;
        }
        if ((ne & 61440) === 4096 ? this.lastControlCode_ = ne : ne !== this.PADDING_ && (this.lastControlCode_ = null), ve = ne >>> 8, Ae = ne & 255, ne !== this.PADDING_)
          if (ne === this.RESUME_CAPTION_LOADING_)
            this.mode_ = "popOn";
          else if (ne === this.END_OF_CAPTION_)
            this.mode_ = "popOn", this.clearFormatting(ie.pts), this.flushDisplayed(ie.pts), pe = this.displayed_, this.displayed_ = this.nonDisplayed_, this.nonDisplayed_ = pe, this.startPts_ = ie.pts;
          else if (ne === this.ROLL_UP_2_ROWS_)
            this.rollUpRows_ = 2, this.setRollUp(ie.pts);
          else if (ne === this.ROLL_UP_3_ROWS_)
            this.rollUpRows_ = 3, this.setRollUp(ie.pts);
          else if (ne === this.ROLL_UP_4_ROWS_)
            this.rollUpRows_ = 4, this.setRollUp(ie.pts);
          else if (ne === this.CARRIAGE_RETURN_)
            this.clearFormatting(ie.pts), this.flushDisplayed(ie.pts), this.shiftRowsUp_(), this.startPts_ = ie.pts;
          else if (ne === this.BACKSPACE_)
            this.mode_ === "popOn" ? this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1) : this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1);
          else if (ne === this.ERASE_DISPLAYED_MEMORY_)
            this.flushDisplayed(ie.pts), this.displayed_ = $n();
          else if (ne === this.ERASE_NON_DISPLAYED_MEMORY_)
            this.nonDisplayed_ = $n();
          else if (ne === this.RESUME_DIRECT_CAPTIONING_)
            this.mode_ !== "paintOn" && (this.flushDisplayed(ie.pts), this.displayed_ = $n()), this.mode_ = "paintOn", this.startPts_ = ie.pts;
          else if (this.isSpecialCharacter(ve, Ae))
            ve = (ve & 3) << 8, ke = _s(ve | Ae), this[this.mode_](ie.pts, ke), this.column_++;
          else if (this.isExtCharacter(ve, Ae))
            this.mode_ === "popOn" ? this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1) : this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1), ve = (ve & 3) << 8, ke = _s(ve | Ae), this[this.mode_](ie.pts, ke), this.column_++;
          else if (this.isMidRowCode(ve, Ae))
            this.clearFormatting(ie.pts), this[this.mode_](ie.pts, " "), this.column_++, (Ae & 14) === 14 && this.addFormatting(ie.pts, ["i"]), (Ae & 1) === 1 && this.addFormatting(ie.pts, ["u"]);
          else if (this.isOffsetControlCode(ve, Ae))
            this.column_ += Ae & 3;
          else if (this.isPAC(ve, Ae)) {
            var Ve = Oo.indexOf(ne & 7968);
            this.mode_ === "rollUp" && (Ve - this.rollUpRows_ + 1 < 0 && (Ve = this.rollUpRows_ - 1), this.setRollUp(ie.pts, Ve)), Ve !== this.row_ && (this.clearFormatting(ie.pts), this.row_ = Ve), Ae & 1 && this.formatting_.indexOf("u") === -1 && this.addFormatting(ie.pts, ["u"]), (ne & 16) === 16 && (this.column_ = ((ne & 14) >> 1) * 4), this.isColorPAC(Ae) && (Ae & 14) === 14 && this.addFormatting(ie.pts, ["i"]);
          } else
            this.isNormalChar(ve) && (Ae === 0 && (Ae = null), ke = _s(ve), ke += _s(Ae), this[this.mode_](ie.pts, ke), this.column_ += ke.length);
      };
    };
    ui.prototype = new n(), ui.prototype.flushDisplayed = function(xe) {
      var q = this.displayed_.map(function(z) {
        try {
          return z.trim();
        } catch {
          return console.error("Skipping malformed caption."), "";
        }
      }).join(`
`).replace(/^\n+|\n+$/g, "");
      q.length && this.trigger("data", {
        startPts: this.startPts_,
        endPts: xe,
        text: q,
        stream: this.name_
      });
    }, ui.prototype.reset = function() {
      this.mode_ = "popOn", this.topRow_ = 0, this.startPts_ = 0, this.displayed_ = $n(), this.nonDisplayed_ = $n(), this.lastControlCode_ = null, this.column_ = 0, this.row_ = bs, this.rollUpRows_ = 2, this.formatting_ = [];
    }, ui.prototype.setConstants = function() {
      this.dataChannel_ === 0 ? (this.BASE_ = 16, this.EXT_ = 17, this.CONTROL_ = (20 | this.field_) << 8, this.OFFSET_ = 23) : this.dataChannel_ === 1 && (this.BASE_ = 24, this.EXT_ = 25, this.CONTROL_ = (28 | this.field_) << 8, this.OFFSET_ = 31), this.PADDING_ = 0, this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 32, this.END_OF_CAPTION_ = this.CONTROL_ | 47, this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 37, this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 38, this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 39, this.CARRIAGE_RETURN_ = this.CONTROL_ | 45, this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 41, this.BACKSPACE_ = this.CONTROL_ | 33, this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 44, this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 46;
    }, ui.prototype.isSpecialCharacter = function(xe, q) {
      return xe === this.EXT_ && q >= 48 && q <= 63;
    }, ui.prototype.isExtCharacter = function(xe, q) {
      return (xe === this.EXT_ + 1 || xe === this.EXT_ + 2) && q >= 32 && q <= 63;
    }, ui.prototype.isMidRowCode = function(xe, q) {
      return xe === this.EXT_ && q >= 32 && q <= 47;
    }, ui.prototype.isOffsetControlCode = function(xe, q) {
      return xe === this.OFFSET_ && q >= 33 && q <= 35;
    }, ui.prototype.isPAC = function(xe, q) {
      return xe >= this.BASE_ && xe < this.BASE_ + 8 && q >= 64 && q <= 127;
    }, ui.prototype.isColorPAC = function(xe) {
      return xe >= 64 && xe <= 79 || xe >= 96 && xe <= 127;
    }, ui.prototype.isNormalChar = function(xe) {
      return xe >= 32 && xe <= 127;
    }, ui.prototype.setRollUp = function(xe, q) {
      if (this.mode_ !== "rollUp" && (this.row_ = bs, this.mode_ = "rollUp", this.flushDisplayed(xe), this.nonDisplayed_ = $n(), this.displayed_ = $n()), q !== void 0 && q !== this.row_)
        for (var z = 0; z < this.rollUpRows_; z++)
          this.displayed_[q - z] = this.displayed_[this.row_ - z], this.displayed_[this.row_ - z] = "";
      q === void 0 && (q = this.row_), this.topRow_ = q - this.rollUpRows_ + 1;
    }, ui.prototype.addFormatting = function(xe, q) {
      this.formatting_ = this.formatting_.concat(q);
      var z = q.reduce(function(ie, ne) {
        return ie + "<" + ne + ">";
      }, "");
      this[this.mode_](xe, z);
    }, ui.prototype.clearFormatting = function(xe) {
      if (!!this.formatting_.length) {
        var q = this.formatting_.reverse().reduce(function(z, ie) {
          return z + "</" + ie + ">";
        }, "");
        this.formatting_ = [], this[this.mode_](xe, q);
      }
    }, ui.prototype.popOn = function(xe, q) {
      var z = this.nonDisplayed_[this.row_];
      z += q, this.nonDisplayed_[this.row_] = z;
    }, ui.prototype.rollUp = function(xe, q) {
      var z = this.displayed_[this.row_];
      z += q, this.displayed_[this.row_] = z;
    }, ui.prototype.shiftRowsUp_ = function() {
      var xe;
      for (xe = 0; xe < this.topRow_; xe++)
        this.displayed_[xe] = "";
      for (xe = this.row_ + 1; xe < bs + 1; xe++)
        this.displayed_[xe] = "";
      for (xe = this.topRow_; xe < this.row_; xe++)
        this.displayed_[xe] = this.displayed_[xe + 1];
      this.displayed_[this.row_] = "";
    }, ui.prototype.paintOn = function(xe, q) {
      var z = this.displayed_[this.row_];
      z += q, this.displayed_[this.row_] = z;
    };
    var Ts = {
      CaptionStream: on,
      Cea608Stream: ui
    }, Qi = {
      H264_STREAM_TYPE: 27,
      ADTS_STREAM_TYPE: 15,
      METADATA_STREAM_TYPE: 21
    }, Ss = 8589934592, ka = 4294967296, pa = "shared", Qa = function(q, z) {
      var ie = 1;
      for (q > z && (ie = -1); Math.abs(z - q) > ka; )
        q += ie * Ss;
      return q;
    }, Za = function xe(q) {
      var z, ie;
      xe.prototype.init.call(this), this.type_ = q || pa, this.push = function(ne) {
        this.type_ !== pa && ne.type !== this.type_ || (ie === void 0 && (ie = ne.dts), ne.dts = Qa(ne.dts, ie), ne.pts = Qa(ne.pts, ie), z = ne.dts, this.trigger("data", ne));
      }, this.flush = function() {
        ie = z, this.trigger("done");
      }, this.endTimeline = function() {
        this.flush(), this.trigger("endedtimeline");
      }, this.discontinuity = function() {
        ie = void 0, z = void 0;
      }, this.reset = function() {
        this.discontinuity(), this.trigger("reset");
      };
    };
    Za.prototype = new n();
    var xi = {
      TimestampRolloverStream: Za,
      handleRollover: Qa
    }, bn = function(q, z, ie) {
      var ne, pe = "";
      for (ne = z; ne < ie; ne++)
        pe += "%" + ("00" + q[ne].toString(16)).slice(-2);
      return pe;
    }, Es = function(q, z, ie) {
      return decodeURIComponent(bn(q, z, ie));
    }, Ra = function(q, z, ie) {
      return unescape(bn(q, z, ie));
    }, Dn = function(q) {
      return q[0] << 21 | q[1] << 14 | q[2] << 7 | q[3];
    }, xs = {
      TXXX: function(q) {
        var z;
        if (q.data[0] === 3) {
          for (z = 1; z < q.data.length; z++)
            if (q.data[z] === 0) {
              q.description = Es(q.data, 1, z), q.value = Es(q.data, z + 1, q.data.length).replace(/\0*$/, "");
              break;
            }
          q.data = q.value;
        }
      },
      WXXX: function(q) {
        var z;
        if (q.data[0] === 3) {
          for (z = 1; z < q.data.length; z++)
            if (q.data[z] === 0) {
              q.description = Es(q.data, 1, z), q.url = Es(q.data, z + 1, q.data.length);
              break;
            }
        }
      },
      PRIV: function(q) {
        var z;
        for (z = 0; z < q.data.length; z++)
          if (q.data[z] === 0) {
            q.owner = Ra(q.data, 0, z);
            break;
          }
        q.privateData = q.data.subarray(z + 1), q.data = q.privateData;
      }
    }, ta;
    ta = function(q) {
      var z = {
        debug: !!(q && q.debug),
        descriptor: q && q.descriptor
      }, ie = 0, ne = [], pe = 0, ve;
      if (ta.prototype.init.call(this), this.dispatchType = Qi.METADATA_STREAM_TYPE.toString(16), z.descriptor)
        for (ve = 0; ve < z.descriptor.length; ve++)
          this.dispatchType += ("00" + z.descriptor[ve].toString(16)).slice(-2);
      this.push = function(Ae) {
        var ke, Ve, st, Ft, Zt, nr;
        if (Ae.type === "timed-metadata") {
          if (Ae.dataAlignmentIndicator && (pe = 0, ne.length = 0), ne.length === 0 && (Ae.data.length < 10 || Ae.data[0] !== "I".charCodeAt(0) || Ae.data[1] !== "D".charCodeAt(0) || Ae.data[2] !== "3".charCodeAt(0))) {
            z.debug && console.log("Skipping unrecognized metadata packet");
            return;
          }
          if (ne.push(Ae), pe += Ae.data.byteLength, ne.length === 1 && (ie = Dn(Ae.data.subarray(6, 10)), ie += 10), !(pe < ie)) {
            for (ke = {
              data: new Uint8Array(ie),
              frames: [],
              pts: ne[0].pts,
              dts: ne[0].dts
            }, Zt = 0; Zt < ie; )
              ke.data.set(ne[0].data.subarray(0, ie - Zt), Zt), Zt += ne[0].data.byteLength, pe -= ne[0].data.byteLength, ne.shift();
            Ve = 10, ke.data[5] & 64 && (Ve += 4, Ve += Dn(ke.data.subarray(10, 14)), ie -= Dn(ke.data.subarray(16, 20)));
            do {
              if (st = Dn(ke.data.subarray(Ve + 4, Ve + 8)), st < 1)
                return console.log("Malformed ID3 frame encountered. Skipping metadata parsing.");
              if (nr = String.fromCharCode(ke.data[Ve], ke.data[Ve + 1], ke.data[Ve + 2], ke.data[Ve + 3]), Ft = {
                id: nr,
                data: ke.data.subarray(Ve + 10, Ve + st + 10)
              }, Ft.key = Ft.id, xs[Ft.id] && (xs[Ft.id](Ft), Ft.owner === "com.apple.streaming.transportStreamTimestamp")) {
                var br = Ft.data, Cr = (br[3] & 1) << 30 | br[4] << 22 | br[5] << 14 | br[6] << 6 | br[7] >>> 2;
                Cr *= 4, Cr += br[7] & 3, Ft.timeStamp = Cr, ke.pts === void 0 && ke.dts === void 0 && (ke.pts = Ft.timeStamp, ke.dts = Ft.timeStamp), this.trigger("timestamp", Ft);
              }
              ke.frames.push(Ft), Ve += 10, Ve += st;
            } while (Ve < ie);
            this.trigger("data", ke);
          }
        }
      };
    }, ta.prototype = new n();
    var Pa = ta, Xs = xi.TimestampRolloverStream, Tn, es, ga, un = 188, As = 71;
    Tn = function() {
      var q = new Uint8Array(un), z = 0;
      Tn.prototype.init.call(this), this.push = function(ie) {
        var ne = 0, pe = un, ve;
        for (z ? (ve = new Uint8Array(ie.byteLength + z), ve.set(q.subarray(0, z)), ve.set(ie, z), z = 0) : ve = ie; pe < ve.byteLength; ) {
          if (ve[ne] === As && ve[pe] === As) {
            this.trigger("data", ve.subarray(ne, pe)), ne += un, pe += un;
            continue;
          }
          ne++, pe++;
        }
        ne < ve.byteLength && (q.set(ve.subarray(ne), 0), z = ve.byteLength - ne);
      }, this.flush = function() {
        z === un && q[0] === As && (this.trigger("data", q), z = 0), this.trigger("done");
      }, this.endTimeline = function() {
        this.flush(), this.trigger("endedtimeline");
      }, this.reset = function() {
        z = 0, this.trigger("reset");
      };
    }, Tn.prototype = new n(), es = function() {
      var q, z, ie, ne;
      es.prototype.init.call(this), ne = this, this.packetsWaitingForPmt = [], this.programMapTable = void 0, q = function(ve, Ae) {
        var ke = 0;
        Ae.payloadUnitStartIndicator && (ke += ve[ke] + 1), Ae.type === "pat" ? z(ve.subarray(ke), Ae) : ie(ve.subarray(ke), Ae);
      }, z = function(ve, Ae) {
        Ae.section_number = ve[7], Ae.last_section_number = ve[8], ne.pmtPid = (ve[10] & 31) << 8 | ve[11], Ae.pmtPid = ne.pmtPid;
      }, ie = function(ve, Ae) {
        var ke, Ve, st, Ft;
        if (!!(ve[5] & 1)) {
          for (ne.programMapTable = {
            video: null,
            audio: null,
            "timed-metadata": {}
          }, ke = (ve[1] & 15) << 8 | ve[2], Ve = 3 + ke - 4, st = (ve[10] & 15) << 8 | ve[11], Ft = 12 + st; Ft < Ve; ) {
            var Zt = ve[Ft], nr = (ve[Ft + 1] & 31) << 8 | ve[Ft + 2];
            Zt === Qi.H264_STREAM_TYPE && ne.programMapTable.video === null ? ne.programMapTable.video = nr : Zt === Qi.ADTS_STREAM_TYPE && ne.programMapTable.audio === null ? ne.programMapTable.audio = nr : Zt === Qi.METADATA_STREAM_TYPE && (ne.programMapTable["timed-metadata"][nr] = Zt), Ft += ((ve[Ft + 3] & 15) << 8 | ve[Ft + 4]) + 5;
          }
          Ae.programMapTable = ne.programMapTable;
        }
      }, this.push = function(pe) {
        var ve = {}, Ae = 4;
        if (ve.payloadUnitStartIndicator = !!(pe[1] & 64), ve.pid = pe[1] & 31, ve.pid <<= 8, ve.pid |= pe[2], (pe[3] & 48) >>> 4 > 1 && (Ae += pe[Ae] + 1), ve.pid === 0)
          ve.type = "pat", q(pe.subarray(Ae), ve), this.trigger("data", ve);
        else if (ve.pid === this.pmtPid)
          for (ve.type = "pmt", q(pe.subarray(Ae), ve), this.trigger("data", ve); this.packetsWaitingForPmt.length; )
            this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
        else
          this.programMapTable === void 0 ? this.packetsWaitingForPmt.push([pe, Ae, ve]) : this.processPes_(pe, Ae, ve);
      }, this.processPes_ = function(pe, ve, Ae) {
        Ae.pid === this.programMapTable.video ? Ae.streamType = Qi.H264_STREAM_TYPE : Ae.pid === this.programMapTable.audio ? Ae.streamType = Qi.ADTS_STREAM_TYPE : Ae.streamType = this.programMapTable["timed-metadata"][Ae.pid], Ae.type = "pes", Ae.data = pe.subarray(ve), this.trigger("data", Ae);
      };
    }, es.prototype = new n(), es.STREAM_TYPES = {
      h264: 27,
      adts: 15
    }, ga = function() {
      var q = this, z = {
        data: [],
        size: 0
      }, ie = {
        data: [],
        size: 0
      }, ne = {
        data: [],
        size: 0
      }, pe, ve = function(Ve, st) {
        var Ft;
        st.packetLength = 6 + (Ve[4] << 8 | Ve[5]), st.dataAlignmentIndicator = (Ve[6] & 4) !== 0, Ft = Ve[7], Ft & 192 && (st.pts = (Ve[9] & 14) << 27 | (Ve[10] & 255) << 20 | (Ve[11] & 254) << 12 | (Ve[12] & 255) << 5 | (Ve[13] & 254) >>> 3, st.pts *= 4, st.pts += (Ve[13] & 6) >>> 1, st.dts = st.pts, Ft & 64 && (st.dts = (Ve[14] & 14) << 27 | (Ve[15] & 255) << 20 | (Ve[16] & 254) << 12 | (Ve[17] & 255) << 5 | (Ve[18] & 254) >>> 3, st.dts *= 4, st.dts += (Ve[18] & 6) >>> 1)), st.data = Ve.subarray(9 + Ve[8]);
      }, Ae = function(Ve, st, Ft) {
        var Zt = new Uint8Array(Ve.size), nr = {
          type: st
        }, br = 0, Cr = 0, Rt = !1, Oi;
        if (!(!Ve.data.length || Ve.size < 9)) {
          for (nr.trackId = Ve.data[0].pid, br = 0; br < Ve.data.length; br++)
            Oi = Ve.data[br], Zt.set(Oi.data, Cr), Cr += Oi.data.byteLength;
          ve(Zt, nr), Rt = st === "video" || nr.packetLength <= Ve.size, (Ft || Rt) && (Ve.size = 0, Ve.data.length = 0), Rt && q.trigger("data", nr);
        }
      };
      ga.prototype.init.call(this), this.push = function(ke) {
        ({
          pat: function() {
          },
          pes: function() {
            var st, Ft;
            switch (ke.streamType) {
              case Qi.H264_STREAM_TYPE:
              case Qi.H264_STREAM_TYPE:
                st = z, Ft = "video";
                break;
              case Qi.ADTS_STREAM_TYPE:
                st = ie, Ft = "audio";
                break;
              case Qi.METADATA_STREAM_TYPE:
                st = ne, Ft = "timed-metadata";
                break;
              default:
                return;
            }
            ke.payloadUnitStartIndicator && Ae(st, Ft, !0), st.data.push(ke), st.size += ke.data.byteLength;
          },
          pmt: function() {
            var st = {
              type: "metadata",
              tracks: []
            };
            pe = ke.programMapTable, pe.video !== null && st.tracks.push({
              timelineStartInfo: {
                baseMediaDecodeTime: 0
              },
              id: +pe.video,
              codec: "avc",
              type: "video"
            }), pe.audio !== null && st.tracks.push({
              timelineStartInfo: {
                baseMediaDecodeTime: 0
              },
              id: +pe.audio,
              codec: "adts",
              type: "audio"
            }), q.trigger("data", st);
          }
        })[ke.type]();
      }, this.reset = function() {
        z.size = 0, z.data.length = 0, ie.size = 0, ie.data.length = 0, this.trigger("reset");
      }, this.flushStreams_ = function() {
        Ae(z, "video"), Ae(ie, "audio"), Ae(ne, "timed-metadata");
      }, this.flush = function() {
        this.flushStreams_(), this.trigger("done");
      };
    }, ga.prototype = new n();
    var Oa = {
      PAT_PID: 0,
      MP2T_PACKET_LENGTH: un,
      TransportPacketStream: Tn,
      TransportParseStream: es,
      ElementaryStream: ga,
      TimestampRolloverStream: Xs,
      CaptionStream: Ts.CaptionStream,
      Cea608Stream: Ts.Cea608Stream,
      MetadataStream: Pa
    };
    for (var Gn in Qi)
      Qi.hasOwnProperty(Gn) && (Oa[Gn] = Qi[Gn]);
    var Hn = Oa, Lo = oi.ONE_SECOND_IN_TS, de, Ee = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
    de = function(q) {
      var z, ie = 0;
      de.prototype.init.call(this), this.push = function(ne) {
        var pe = 0, ve, Ae, ke, Ve, st, Ft;
        if (q || (ie = 0), ne.type === "audio")
          for (z ? (Ve = z, z = new Uint8Array(Ve.byteLength + ne.data.byteLength), z.set(Ve), z.set(ne.data, Ve.byteLength)) : z = ne.data; pe + 5 < z.length; ) {
            if (z[pe] !== 255 || (z[pe + 1] & 246) !== 240) {
              pe++;
              continue;
            }
            if (Ae = (~z[pe + 1] & 1) * 2, ve = (z[pe + 3] & 3) << 11 | z[pe + 4] << 3 | (z[pe + 5] & 224) >> 5, st = ((z[pe + 6] & 3) + 1) * 1024, Ft = st * Lo / Ee[(z[pe + 2] & 60) >>> 2], ke = pe + ve, z.byteLength < ke)
              return;
            if (this.trigger("data", {
              pts: ne.pts + ie * Ft,
              dts: ne.dts + ie * Ft,
              sampleCount: st,
              audioobjecttype: (z[pe + 2] >>> 6 & 3) + 1,
              channelcount: (z[pe + 2] & 1) << 2 | (z[pe + 3] & 192) >>> 6,
              samplerate: Ee[(z[pe + 2] & 60) >>> 2],
              samplingfrequencyindex: (z[pe + 2] & 60) >>> 2,
              samplesize: 16,
              data: z.subarray(pe + 7 + Ae, ke)
            }), ie++, z.byteLength === ke) {
              z = void 0;
              return;
            }
            z = z.subarray(ke);
          }
      }, this.flush = function() {
        ie = 0, this.trigger("done");
      }, this.reset = function() {
        z = void 0, this.trigger("reset");
      }, this.endTimeline = function() {
        z = void 0, this.trigger("endedtimeline");
      };
    }, de.prototype = new n();
    var ge = de, Me;
    Me = function(q) {
      var z = q.byteLength, ie = 0, ne = 0;
      this.length = function() {
        return 8 * z;
      }, this.bitsAvailable = function() {
        return 8 * z + ne;
      }, this.loadWord = function() {
        var pe = q.byteLength - z, ve = new Uint8Array(4), Ae = Math.min(4, z);
        if (Ae === 0)
          throw new Error("no bytes available");
        ve.set(q.subarray(pe, pe + Ae)), ie = new DataView(ve.buffer).getUint32(0), ne = Ae * 8, z -= Ae;
      }, this.skipBits = function(pe) {
        var ve;
        ne > pe ? (ie <<= pe, ne -= pe) : (pe -= ne, ve = Math.floor(pe / 8), pe -= ve * 8, z -= ve, this.loadWord(), ie <<= pe, ne -= pe);
      }, this.readBits = function(pe) {
        var ve = Math.min(ne, pe), Ae = ie >>> 32 - ve;
        return ne -= ve, ne > 0 ? ie <<= ve : z > 0 && this.loadWord(), ve = pe - ve, ve > 0 ? Ae << ve | this.readBits(ve) : Ae;
      }, this.skipLeadingZeros = function() {
        var pe;
        for (pe = 0; pe < ne; ++pe)
          if ((ie & 2147483648 >>> pe) !== 0)
            return ie <<= pe, ne -= pe, pe;
        return this.loadWord(), pe + this.skipLeadingZeros();
      }, this.skipUnsignedExpGolomb = function() {
        this.skipBits(1 + this.skipLeadingZeros());
      }, this.skipExpGolomb = function() {
        this.skipBits(1 + this.skipLeadingZeros());
      }, this.readUnsignedExpGolomb = function() {
        var pe = this.skipLeadingZeros();
        return this.readBits(pe + 1) - 1;
      }, this.readExpGolomb = function() {
        var pe = this.readUnsignedExpGolomb();
        return 1 & pe ? 1 + pe >>> 1 : -1 * (pe >>> 1);
      }, this.readBoolean = function() {
        return this.readBits(1) === 1;
      }, this.readUnsignedByte = function() {
        return this.readBits(8);
      }, this.loadWord();
    };
    var Ge = Me, Le, et, yt;
    et = function() {
      var q = 0, z, ie;
      et.prototype.init.call(this), this.push = function(ne) {
        var pe;
        ie ? (pe = new Uint8Array(ie.byteLength + ne.data.byteLength), pe.set(ie), pe.set(ne.data, ie.byteLength), ie = pe) : ie = ne.data;
        for (var ve = ie.byteLength; q < ve - 3; q++)
          if (ie[q + 2] === 1) {
            z = q + 5;
            break;
          }
        for (; z < ve; )
          switch (ie[z]) {
            case 0:
              if (ie[z - 1] !== 0) {
                z += 2;
                break;
              } else if (ie[z - 2] !== 0) {
                z++;
                break;
              }
              q + 3 !== z - 2 && this.trigger("data", ie.subarray(q + 3, z - 2));
              do
                z++;
              while (ie[z] !== 1 && z < ve);
              q = z - 2, z += 3;
              break;
            case 1:
              if (ie[z - 1] !== 0 || ie[z - 2] !== 0) {
                z += 3;
                break;
              }
              this.trigger("data", ie.subarray(q + 3, z - 2)), q = z - 2, z += 3;
              break;
            default:
              z += 3;
              break;
          }
        ie = ie.subarray(q), z -= q, q = 0;
      }, this.reset = function() {
        ie = null, q = 0, this.trigger("reset");
      }, this.flush = function() {
        ie && ie.byteLength > 3 && this.trigger("data", ie.subarray(q + 3)), ie = null, q = 0, this.trigger("done");
      }, this.endTimeline = function() {
        this.flush(), this.trigger("endedtimeline");
      };
    }, et.prototype = new n(), yt = {
      100: !0,
      110: !0,
      122: !0,
      244: !0,
      44: !0,
      83: !0,
      86: !0,
      118: !0,
      128: !0,
      138: !0,
      139: !0,
      134: !0
    }, Le = function() {
      var q = new et(), z, ie, ne, pe, ve, Ae, ke;
      Le.prototype.init.call(this), z = this, this.push = function(Ve) {
        Ve.type === "video" && (ie = Ve.trackId, ne = Ve.pts, pe = Ve.dts, q.push(Ve));
      }, q.on("data", function(Ve) {
        var st = {
          trackId: ie,
          pts: ne,
          dts: pe,
          data: Ve
        };
        switch (Ve[0] & 31) {
          case 5:
            st.nalUnitType = "slice_layer_without_partitioning_rbsp_idr";
            break;
          case 6:
            st.nalUnitType = "sei_rbsp", st.escapedRBSP = ve(Ve.subarray(1));
            break;
          case 7:
            st.nalUnitType = "seq_parameter_set_rbsp", st.escapedRBSP = ve(Ve.subarray(1)), st.config = Ae(st.escapedRBSP);
            break;
          case 8:
            st.nalUnitType = "pic_parameter_set_rbsp";
            break;
          case 9:
            st.nalUnitType = "access_unit_delimiter_rbsp";
            break;
        }
        z.trigger("data", st);
      }), q.on("done", function() {
        z.trigger("done");
      }), q.on("partialdone", function() {
        z.trigger("partialdone");
      }), q.on("reset", function() {
        z.trigger("reset");
      }), q.on("endedtimeline", function() {
        z.trigger("endedtimeline");
      }), this.flush = function() {
        q.flush();
      }, this.partialFlush = function() {
        q.partialFlush();
      }, this.reset = function() {
        q.reset();
      }, this.endTimeline = function() {
        q.endTimeline();
      }, ke = function(st, Ft) {
        var Zt = 8, nr = 8, br, Cr;
        for (br = 0; br < st; br++)
          nr !== 0 && (Cr = Ft.readExpGolomb(), nr = (Zt + Cr + 256) % 256), Zt = nr === 0 ? Zt : nr;
      }, ve = function(st) {
        for (var Ft = st.byteLength, Zt = [], nr = 1, br, Cr; nr < Ft - 2; )
          st[nr] === 0 && st[nr + 1] === 0 && st[nr + 2] === 3 ? (Zt.push(nr + 2), nr += 2) : nr++;
        if (Zt.length === 0)
          return st;
        br = Ft - Zt.length, Cr = new Uint8Array(br);
        var Rt = 0;
        for (nr = 0; nr < br; Rt++, nr++)
          Rt === Zt[0] && (Rt++, Zt.shift()), Cr[nr] = st[Rt];
        return Cr;
      }, Ae = function(st) {
        var Ft = 0, Zt = 0, nr = 0, br = 0, Cr = 1, Rt, Oi, qn, Ds, _a, No, gu, ts, vu, Fo, Zi, wi, mu, rs;
        if (Rt = new Ge(st), Oi = Rt.readUnsignedByte(), Ds = Rt.readUnsignedByte(), qn = Rt.readUnsignedByte(), Rt.skipUnsignedExpGolomb(), yt[Oi] && (_a = Rt.readUnsignedExpGolomb(), _a === 3 && Rt.skipBits(1), Rt.skipUnsignedExpGolomb(), Rt.skipUnsignedExpGolomb(), Rt.skipBits(1), Rt.readBoolean()))
          for (Zi = _a !== 3 ? 8 : 12, rs = 0; rs < Zi; rs++)
            Rt.readBoolean() && (rs < 6 ? ke(16, Rt) : ke(64, Rt));
        if (Rt.skipUnsignedExpGolomb(), No = Rt.readUnsignedExpGolomb(), No === 0)
          Rt.readUnsignedExpGolomb();
        else if (No === 1)
          for (Rt.skipBits(1), Rt.skipExpGolomb(), Rt.skipExpGolomb(), gu = Rt.readUnsignedExpGolomb(), rs = 0; rs < gu; rs++)
            Rt.skipExpGolomb();
        if (Rt.skipUnsignedExpGolomb(), Rt.skipBits(1), ts = Rt.readUnsignedExpGolomb(), vu = Rt.readUnsignedExpGolomb(), Fo = Rt.readBits(1), Fo === 0 && Rt.skipBits(1), Rt.skipBits(1), Rt.readBoolean() && (Ft = Rt.readUnsignedExpGolomb(), Zt = Rt.readUnsignedExpGolomb(), nr = Rt.readUnsignedExpGolomb(), br = Rt.readUnsignedExpGolomb()), Rt.readBoolean() && Rt.readBoolean()) {
          switch (mu = Rt.readUnsignedByte(), mu) {
            case 1:
              wi = [1, 1];
              break;
            case 2:
              wi = [12, 11];
              break;
            case 3:
              wi = [10, 11];
              break;
            case 4:
              wi = [16, 11];
              break;
            case 5:
              wi = [40, 33];
              break;
            case 6:
              wi = [24, 11];
              break;
            case 7:
              wi = [20, 11];
              break;
            case 8:
              wi = [32, 11];
              break;
            case 9:
              wi = [80, 33];
              break;
            case 10:
              wi = [18, 11];
              break;
            case 11:
              wi = [15, 11];
              break;
            case 12:
              wi = [64, 33];
              break;
            case 13:
              wi = [160, 99];
              break;
            case 14:
              wi = [4, 3];
              break;
            case 15:
              wi = [3, 2];
              break;
            case 16:
              wi = [2, 1];
              break;
            case 255: {
              wi = [Rt.readUnsignedByte() << 8 | Rt.readUnsignedByte(), Rt.readUnsignedByte() << 8 | Rt.readUnsignedByte()];
              break;
            }
          }
          wi && (Cr = wi[0] / wi[1]);
        }
        return {
          profileIdc: Oi,
          levelIdc: qn,
          profileCompatibility: Ds,
          width: Math.ceil(((ts + 1) * 16 - Ft * 2 - Zt * 2) * Cr),
          height: (2 - Fo) * (vu + 1) * 16 - nr * 2 - br * 2,
          sarRatio: wi
        };
      };
    }, Le.prototype = new n();
    var gt = {
      H264Stream: Le,
      NalByteStream: et
    }, St = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350], kt = function(q) {
      return q[0] === "I".charCodeAt(0) && q[1] === "D".charCodeAt(0) && q[2] === "3".charCodeAt(0);
    }, Qt = function(q) {
      return q[0] << 21 | q[1] << 14 | q[2] << 7 | q[3];
    }, _r = function(q, z, ie) {
      var ne, pe = "";
      for (ne = z; ne < ie; ne++)
        pe += "%" + ("00" + q[ne].toString(16)).slice(-2);
      return pe;
    }, Br = function(q, z, ie) {
      return unescape(_r(q, z, ie));
    }, jr = function(q, z) {
      var ie = q[z + 6] << 21 | q[z + 7] << 14 | q[z + 8] << 7 | q[z + 9], ne = q[z + 5], pe = (ne & 16) >> 4;
      return pe ? ie + 20 : ie + 10;
    }, Ai = function(q, z) {
      var ie = (q[z + 5] & 224) >> 5, ne = q[z + 4] << 3, pe = q[z + 3] & 3 << 11;
      return pe | ne | ie;
    }, mr = function(q, z) {
      return q[z] === "I".charCodeAt(0) && q[z + 1] === "D".charCodeAt(0) && q[z + 2] === "3".charCodeAt(0) ? "timed-metadata" : q[z] & !0 && (q[z + 1] & 240) === 240 ? "audio" : null;
    }, Ki = function(q) {
      for (var z = 0; z + 5 < q.length; ) {
        if (q[z] !== 255 || (q[z + 1] & 246) !== 240) {
          z++;
          continue;
        }
        return St[(q[z + 2] & 60) >>> 2];
      }
      return null;
    }, ra = function(q) {
      var z, ie, ne, pe;
      z = 10, q[5] & 64 && (z += 4, z += Qt(q.subarray(10, 14)));
      do {
        if (ie = Qt(q.subarray(z + 4, z + 8)), ie < 1)
          return null;
        if (pe = String.fromCharCode(q[z], q[z + 1], q[z + 2], q[z + 3]), pe === "PRIV") {
          ne = q.subarray(z + 10, z + ie + 10);
          for (var ve = 0; ve < ne.byteLength; ve++)
            if (ne[ve] === 0) {
              var Ae = Br(ne, 0, ve);
              if (Ae === "com.apple.streaming.transportStreamTimestamp") {
                var ke = ne.subarray(ve + 1), Ve = (ke[3] & 1) << 30 | ke[4] << 22 | ke[5] << 14 | ke[6] << 6 | ke[7] >>> 2;
                return Ve *= 4, Ve += ke[7] & 3, Ve;
              }
              break;
            }
        }
        z += 10, z += ie;
      } while (z < q.byteLength);
      return null;
    }, La = {
      isLikelyAacData: kt,
      parseId3TagSize: jr,
      parseAdtsSize: Ai,
      parseType: mr,
      parseSampleRate: Ki,
      parseAacTimestamp: ra
    }, Sn;
    Sn = function() {
      var q = new Uint8Array(), z = 0;
      Sn.prototype.init.call(this), this.setTimestamp = function(ie) {
        z = ie;
      }, this.push = function(ie) {
        var ne = 0, pe = 0, ve, Ae, ke, Ve;
        for (q.length ? (Ve = q.length, q = new Uint8Array(ie.byteLength + Ve), q.set(q.subarray(0, Ve)), q.set(ie, Ve)) : q = ie; q.length - pe >= 3; ) {
          if (q[pe] === "I".charCodeAt(0) && q[pe + 1] === "D".charCodeAt(0) && q[pe + 2] === "3".charCodeAt(0)) {
            if (q.length - pe < 10 || (ne = La.parseId3TagSize(q, pe), pe + ne > q.length))
              break;
            Ae = {
              type: "timed-metadata",
              data: q.subarray(pe, pe + ne)
            }, this.trigger("data", Ae), pe += ne;
            continue;
          } else if ((q[pe] & 255) === 255 && (q[pe + 1] & 240) === 240) {
            if (q.length - pe < 7 || (ne = La.parseAdtsSize(q, pe), pe + ne > q.length))
              break;
            ke = {
              type: "audio",
              data: q.subarray(pe, pe + ne),
              pts: z,
              dts: z
            }, this.trigger("data", ke), pe += ne;
            continue;
          }
          pe++;
        }
        ve = q.length - pe, ve > 0 ? q = q.subarray(pe) : q = new Uint8Array();
      }, this.reset = function() {
        q = new Uint8Array(), this.trigger("reset");
      }, this.endTimeline = function() {
        q = new Uint8Array(), this.trigger("endedtimeline");
      };
    }, Sn.prototype = new n();
    var Ia = Sn, Io = gt.H264Stream, Vn = La.isLikelyAacData, ia = oi.ONE_SECOND_IN_TS, va = ["audioobjecttype", "channelcount", "samplerate", "samplingfrequencyindex", "samplesize"], Js = ["width", "height", "profileIdc", "levelIdc", "profileCompatibility", "sarRatio"], ws, ma, Qs, ya, fl = function(q, z) {
      var ie;
      if (q.length !== z.length)
        return !1;
      for (ie = 0; ie < q.length; ie++)
        if (q[ie] !== z[ie])
          return !1;
      return !0;
    }, na = function(q, z, ie, ne, pe, ve) {
      var Ae = ie - z, ke = ne - z, Ve = pe - ie;
      return {
        start: {
          dts: q,
          pts: q + Ae
        },
        end: {
          dts: q + ke,
          pts: q + Ve
        },
        prependedContentDuration: ve,
        baseMediaDecodeTime: q
      };
    };
    ma = function(q, z) {
      var ie = [], ne = 0, pe = 0, ve = 0, Ae = 1 / 0;
      z = z || {}, ma.prototype.init.call(this), this.push = function(ke) {
        Ei.collectDtsInfo(q, ke), q && va.forEach(function(Ve) {
          q[Ve] = ke[Ve];
        }), ie.push(ke);
      }, this.setEarliestDts = function(ke) {
        pe = ke - q.timelineStartInfo.baseMediaDecodeTime;
      }, this.setVideoBaseMediaDecodeTime = function(ke) {
        Ae = ke;
      }, this.setAudioAppendStart = function(ke) {
        ve = ke;
      }, this.flush = function() {
        var ke, Ve, st, Ft, Zt;
        if (ie.length === 0) {
          this.trigger("done", "AudioSegmentStream");
          return;
        }
        ke = jn.trimAdtsFramesByEarliestDts(ie, q, pe), q.baseMediaDecodeTime = Ei.calculateTrackBaseMediaDecodeTime(q, z.keepOriginalTimestamps), jn.prefixWithSilence(q, ke, ve, Ae), q.samples = jn.generateSampleTable(ke), st = Ne.mdat(jn.concatenateFrameData(ke)), ie = [], Ve = Ne.moof(ne, [q]), Ft = new Uint8Array(Ve.byteLength + st.byteLength), ne++, Ft.set(Ve), Ft.set(st, Ve.byteLength), Ei.clearDtsInfo(q), Zt = Math.ceil(ia * 1024 / q.samplerate), ke.length && this.trigger("timingInfo", {
          start: ke[0].dts,
          end: ke[0].dts + ke.length * Zt
        }), this.trigger("data", {
          track: q,
          boxes: Ft
        }), this.trigger("done", "AudioSegmentStream");
      }, this.reset = function() {
        Ei.clearDtsInfo(q), ie = [], this.trigger("reset");
      };
    }, ma.prototype = new n(), ws = function(q, z) {
      var ie = 0, ne = [], pe = [], ve, Ae;
      z = z || {}, ws.prototype.init.call(this), delete q.minPTS, this.gopCache_ = [], this.push = function(ke) {
        Ei.collectDtsInfo(q, ke), ke.nalUnitType === "seq_parameter_set_rbsp" && !ve && (ve = ke.config, q.sps = [ke.data], Js.forEach(function(Ve) {
          q[Ve] = ve[Ve];
        }, this)), ke.nalUnitType === "pic_parameter_set_rbsp" && !Ae && (Ae = ke.data, q.pps = [ke.data]), ne.push(ke);
      }, this.flush = function() {
        for (var ke, Ve, st, Ft, Zt, nr, br = 0, Cr, Rt; ne.length && ne[0].nalUnitType !== "access_unit_delimiter_rbsp"; )
          ne.shift();
        if (ne.length === 0) {
          this.resetStream_(), this.trigger("done", "VideoSegmentStream");
          return;
        }
        if (ke = Tt.groupNalsIntoFrames(ne), st = Tt.groupFramesIntoGops(ke), st[0][0].keyFrame || (Ve = this.getGopForFusion_(ne[0], q), Ve ? (br = Ve.duration, st.unshift(Ve), st.byteLength += Ve.byteLength, st.nalCount += Ve.nalCount, st.pts = Ve.pts, st.dts = Ve.dts, st.duration += Ve.duration) : st = Tt.extendFirstKeyFrame(st)), pe.length) {
          var Oi;
          if (z.alignGopsAtEnd ? Oi = this.alignGopsAtEnd_(st) : Oi = this.alignGopsAtStart_(st), !Oi) {
            this.gopCache_.unshift({
              gop: st.pop(),
              pps: q.pps,
              sps: q.sps
            }), this.gopCache_.length = Math.min(6, this.gopCache_.length), ne = [], this.resetStream_(), this.trigger("done", "VideoSegmentStream");
            return;
          }
          Ei.clearDtsInfo(q), st = Oi;
        }
        Ei.collectDtsInfo(q, st), q.samples = Tt.generateSampleTable(st), Zt = Ne.mdat(Tt.concatenateNalData(st)), q.baseMediaDecodeTime = Ei.calculateTrackBaseMediaDecodeTime(q, z.keepOriginalTimestamps), this.trigger("processedGopsInfo", st.map(function(qn) {
          return {
            pts: qn.pts,
            dts: qn.dts,
            byteLength: qn.byteLength
          };
        })), Cr = st[0], Rt = st[st.length - 1], this.trigger("segmentTimingInfo", na(q.baseMediaDecodeTime, Cr.dts, Cr.pts, Rt.dts + Rt.duration, Rt.pts + Rt.duration, br)), this.trigger("timingInfo", {
          start: st[0].dts,
          end: st[st.length - 1].dts + st[st.length - 1].duration
        }), this.gopCache_.unshift({
          gop: st.pop(),
          pps: q.pps,
          sps: q.sps
        }), this.gopCache_.length = Math.min(6, this.gopCache_.length), ne = [], this.trigger("baseMediaDecodeTime", q.baseMediaDecodeTime), this.trigger("timelineStartInfo", q.timelineStartInfo), Ft = Ne.moof(ie, [q]), nr = new Uint8Array(Ft.byteLength + Zt.byteLength), ie++, nr.set(Ft), nr.set(Zt, Ft.byteLength), this.trigger("data", {
          track: q,
          boxes: nr
        }), this.resetStream_(), this.trigger("done", "VideoSegmentStream");
      }, this.reset = function() {
        this.resetStream_(), ne = [], this.gopCache_.length = 0, pe.length = 0, this.trigger("reset");
      }, this.resetStream_ = function() {
        Ei.clearDtsInfo(q), ve = void 0, Ae = void 0;
      }, this.getGopForFusion_ = function(ke) {
        var Ve = 45e3, st = 1e4, Ft = 1 / 0, Zt, nr, br, Cr, Rt;
        for (Rt = 0; Rt < this.gopCache_.length; Rt++)
          Cr = this.gopCache_[Rt], br = Cr.gop, !(!(q.pps && fl(q.pps[0], Cr.pps[0])) || !(q.sps && fl(q.sps[0], Cr.sps[0]))) && (br.dts < q.timelineStartInfo.dts || (Zt = ke.dts - br.dts - br.duration, Zt >= -st && Zt <= Ve && (!nr || Ft > Zt) && (nr = Cr, Ft = Zt)));
        return nr ? nr.gop : null;
      }, this.alignGopsAtStart_ = function(ke) {
        var Ve, st, Ft, Zt, nr, br, Cr, Rt;
        for (nr = ke.byteLength, br = ke.nalCount, Cr = ke.duration, Ve = st = 0; Ve < pe.length && st < ke.length && (Ft = pe[Ve], Zt = ke[st], Ft.pts !== Zt.pts); ) {
          if (Zt.pts > Ft.pts) {
            Ve++;
            continue;
          }
          st++, nr -= Zt.byteLength, br -= Zt.nalCount, Cr -= Zt.duration;
        }
        return st === 0 ? ke : st === ke.length ? null : (Rt = ke.slice(st), Rt.byteLength = nr, Rt.duration = Cr, Rt.nalCount = br, Rt.pts = Rt[0].pts, Rt.dts = Rt[0].dts, Rt);
      }, this.alignGopsAtEnd_ = function(ke) {
        var Ve, st, Ft, Zt, nr, br;
        for (Ve = pe.length - 1, st = ke.length - 1, nr = null, br = !1; Ve >= 0 && st >= 0; ) {
          if (Ft = pe[Ve], Zt = ke[st], Ft.pts === Zt.pts) {
            br = !0;
            break;
          }
          if (Ft.pts > Zt.pts) {
            Ve--;
            continue;
          }
          Ve === pe.length - 1 && (nr = st), st--;
        }
        if (!br && nr === null)
          return null;
        var Cr;
        if (br ? Cr = st : Cr = nr, Cr === 0)
          return ke;
        var Rt = ke.slice(Cr), Oi = Rt.reduce(function(qn, Ds) {
          return qn.byteLength += Ds.byteLength, qn.duration += Ds.duration, qn.nalCount += Ds.nalCount, qn;
        }, {
          byteLength: 0,
          duration: 0,
          nalCount: 0
        });
        return Rt.byteLength = Oi.byteLength, Rt.duration = Oi.duration, Rt.nalCount = Oi.nalCount, Rt.pts = Rt[0].pts, Rt.dts = Rt[0].dts, Rt;
      }, this.alignGopsWith = function(ke) {
        pe = ke;
      };
    }, ws.prototype = new n(), ya = function(q, z) {
      this.numberOfTracks = 0, this.metadataStream = z, q = q || {}, typeof q.remux < "u" ? this.remuxTracks = !!q.remux : this.remuxTracks = !0, typeof q.keepOriginalTimestamps == "boolean" ? this.keepOriginalTimestamps = q.keepOriginalTimestamps : this.keepOriginalTimestamps = !1, this.pendingTracks = [], this.videoTrack = null, this.pendingBoxes = [], this.pendingCaptions = [], this.pendingMetadata = [], this.pendingBytes = 0, this.emittedTracks = 0, ya.prototype.init.call(this), this.push = function(ie) {
        if (ie.text)
          return this.pendingCaptions.push(ie);
        if (ie.frames)
          return this.pendingMetadata.push(ie);
        this.pendingTracks.push(ie.track), this.pendingBytes += ie.boxes.byteLength, ie.track.type === "video" && (this.videoTrack = ie.track, this.pendingBoxes.push(ie.boxes)), ie.track.type === "audio" && (this.audioTrack = ie.track, this.pendingBoxes.unshift(ie.boxes));
      };
    }, ya.prototype = new n(), ya.prototype.flush = function(xe) {
      var q = 0, z = {
        captions: [],
        captionStreams: {},
        metadata: [],
        info: {}
      }, ie, ne, pe, ve = 0, Ae;
      if (this.pendingTracks.length < this.numberOfTracks) {
        if (xe !== "VideoSegmentStream" && xe !== "AudioSegmentStream")
          return;
        if (this.remuxTracks)
          return;
        if (this.pendingTracks.length === 0) {
          this.emittedTracks++, this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
          return;
        }
      }
      if (this.videoTrack ? (ve = this.videoTrack.timelineStartInfo.pts, Js.forEach(function(ke) {
        z.info[ke] = this.videoTrack[ke];
      }, this)) : this.audioTrack && (ve = this.audioTrack.timelineStartInfo.pts, va.forEach(function(ke) {
        z.info[ke] = this.audioTrack[ke];
      }, this)), this.videoTrack || this.audioTrack) {
        for (this.pendingTracks.length === 1 ? z.type = this.pendingTracks[0].type : z.type = "combined", this.emittedTracks += this.pendingTracks.length, pe = Ne.initSegment(this.pendingTracks), z.initSegment = new Uint8Array(pe.byteLength), z.initSegment.set(pe), z.data = new Uint8Array(this.pendingBytes), Ae = 0; Ae < this.pendingBoxes.length; Ae++)
          z.data.set(this.pendingBoxes[Ae], q), q += this.pendingBoxes[Ae].byteLength;
        for (Ae = 0; Ae < this.pendingCaptions.length; Ae++)
          ie = this.pendingCaptions[Ae], ie.startTime = oi.metadataTsToSeconds(ie.startPts, ve, this.keepOriginalTimestamps), ie.endTime = oi.metadataTsToSeconds(ie.endPts, ve, this.keepOriginalTimestamps), z.captionStreams[ie.stream] = !0, z.captions.push(ie);
        for (Ae = 0; Ae < this.pendingMetadata.length; Ae++)
          ne = this.pendingMetadata[Ae], ne.cueTime = oi.metadataTsToSeconds(ne.pts, ve, this.keepOriginalTimestamps), z.metadata.push(ne);
        for (z.metadata.dispatchType = this.metadataStream.dispatchType, this.pendingTracks.length = 0, this.videoTrack = null, this.pendingBoxes.length = 0, this.pendingCaptions.length = 0, this.pendingBytes = 0, this.pendingMetadata.length = 0, this.trigger("data", z), Ae = 0; Ae < z.captions.length; Ae++)
          ie = z.captions[Ae], this.trigger("caption", ie);
        for (Ae = 0; Ae < z.metadata.length; Ae++)
          ne = z.metadata[Ae], this.trigger("id3Frame", ne);
      }
      this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
    }, ya.prototype.setRemux = function(xe) {
      this.remuxTracks = xe;
    }, Qs = function(q) {
      var z = this, ie = !0, ne, pe;
      Qs.prototype.init.call(this), q = q || {}, this.baseMediaDecodeTime = q.baseMediaDecodeTime || 0, this.transmuxPipeline_ = {}, this.setupAacPipeline = function() {
        var ve = {};
        this.transmuxPipeline_ = ve, ve.type = "aac", ve.metadataStream = new Hn.MetadataStream(), ve.aacStream = new Ia(), ve.audioTimestampRolloverStream = new Hn.TimestampRolloverStream("audio"), ve.timedMetadataTimestampRolloverStream = new Hn.TimestampRolloverStream("timed-metadata"), ve.adtsStream = new ge(), ve.coalesceStream = new ya(q, ve.metadataStream), ve.headOfPipeline = ve.aacStream, ve.aacStream.pipe(ve.audioTimestampRolloverStream).pipe(ve.adtsStream), ve.aacStream.pipe(ve.timedMetadataTimestampRolloverStream).pipe(ve.metadataStream).pipe(ve.coalesceStream), ve.metadataStream.on("timestamp", function(Ae) {
          ve.aacStream.setTimestamp(Ae.timeStamp);
        }), ve.aacStream.on("data", function(Ae) {
          Ae.type === "timed-metadata" && !ve.audioSegmentStream && (pe = pe || {
            timelineStartInfo: {
              baseMediaDecodeTime: z.baseMediaDecodeTime
            },
            codec: "adts",
            type: "audio"
          }, ve.coalesceStream.numberOfTracks++, ve.audioSegmentStream = new ma(pe, q), ve.audioSegmentStream.on("timingInfo", z.trigger.bind(z, "audioTimingInfo")), ve.adtsStream.pipe(ve.audioSegmentStream).pipe(ve.coalesceStream)), z.trigger("trackinfo", {
            hasAudio: !!pe,
            hasVideo: !!ne
          });
        }), ve.coalesceStream.on("data", this.trigger.bind(this, "data")), ve.coalesceStream.on("done", this.trigger.bind(this, "done"));
      }, this.setupTsPipeline = function() {
        var ve = {};
        this.transmuxPipeline_ = ve, ve.type = "ts", ve.metadataStream = new Hn.MetadataStream(), ve.packetStream = new Hn.TransportPacketStream(), ve.parseStream = new Hn.TransportParseStream(), ve.elementaryStream = new Hn.ElementaryStream(), ve.timestampRolloverStream = new Hn.TimestampRolloverStream(), ve.adtsStream = new ge(), ve.h264Stream = new Io(), ve.captionStream = new Hn.CaptionStream(), ve.coalesceStream = new ya(q, ve.metadataStream), ve.headOfPipeline = ve.packetStream, ve.packetStream.pipe(ve.parseStream).pipe(ve.elementaryStream).pipe(ve.timestampRolloverStream), ve.timestampRolloverStream.pipe(ve.h264Stream), ve.timestampRolloverStream.pipe(ve.adtsStream), ve.timestampRolloverStream.pipe(ve.metadataStream).pipe(ve.coalesceStream), ve.h264Stream.pipe(ve.captionStream).pipe(ve.coalesceStream), ve.elementaryStream.on("data", function(Ae) {
          var ke;
          if (Ae.type === "metadata") {
            for (ke = Ae.tracks.length; ke--; )
              !ne && Ae.tracks[ke].type === "video" ? (ne = Ae.tracks[ke], ne.timelineStartInfo.baseMediaDecodeTime = z.baseMediaDecodeTime) : !pe && Ae.tracks[ke].type === "audio" && (pe = Ae.tracks[ke], pe.timelineStartInfo.baseMediaDecodeTime = z.baseMediaDecodeTime);
            ne && !ve.videoSegmentStream && (ve.coalesceStream.numberOfTracks++, ve.videoSegmentStream = new ws(ne, q), ve.videoSegmentStream.on("timelineStartInfo", function(Ve) {
              pe && (pe.timelineStartInfo = Ve, ve.audioSegmentStream.setEarliestDts(Ve.dts));
            }), ve.videoSegmentStream.on("processedGopsInfo", z.trigger.bind(z, "gopInfo")), ve.videoSegmentStream.on("segmentTimingInfo", z.trigger.bind(z, "videoSegmentTimingInfo")), ve.videoSegmentStream.on("baseMediaDecodeTime", function(Ve) {
              pe && ve.audioSegmentStream.setVideoBaseMediaDecodeTime(Ve);
            }), ve.videoSegmentStream.on("timingInfo", z.trigger.bind(z, "videoTimingInfo")), ve.h264Stream.pipe(ve.videoSegmentStream).pipe(ve.coalesceStream)), pe && !ve.audioSegmentStream && (ve.coalesceStream.numberOfTracks++, ve.audioSegmentStream = new ma(pe, q), ve.audioSegmentStream.on("timingInfo", z.trigger.bind(z, "audioTimingInfo")), ve.adtsStream.pipe(ve.audioSegmentStream).pipe(ve.coalesceStream)), z.trigger("trackinfo", {
              hasAudio: !!pe,
              hasVideo: !!ne
            });
          }
        }), ve.coalesceStream.on("data", this.trigger.bind(this, "data")), ve.coalesceStream.on("id3Frame", function(Ae) {
          Ae.dispatchType = ve.metadataStream.dispatchType, z.trigger("id3Frame", Ae);
        }), ve.coalesceStream.on("caption", this.trigger.bind(this, "caption")), ve.coalesceStream.on("done", this.trigger.bind(this, "done"));
      }, this.setBaseMediaDecodeTime = function(ve) {
        var Ae = this.transmuxPipeline_;
        q.keepOriginalTimestamps || (this.baseMediaDecodeTime = ve), pe && (pe.timelineStartInfo.dts = void 0, pe.timelineStartInfo.pts = void 0, Ei.clearDtsInfo(pe), q.keepOriginalTimestamps || (pe.timelineStartInfo.baseMediaDecodeTime = ve), Ae.audioTimestampRolloverStream && Ae.audioTimestampRolloverStream.discontinuity()), ne && (Ae.videoSegmentStream && (Ae.videoSegmentStream.gopCache_ = []), ne.timelineStartInfo.dts = void 0, ne.timelineStartInfo.pts = void 0, Ei.clearDtsInfo(ne), Ae.captionStream.reset(), q.keepOriginalTimestamps || (ne.timelineStartInfo.baseMediaDecodeTime = ve)), Ae.timestampRolloverStream && Ae.timestampRolloverStream.discontinuity();
      }, this.setAudioAppendStart = function(ve) {
        pe && this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(ve);
      }, this.setRemux = function(ve) {
        var Ae = this.transmuxPipeline_;
        q.remux = ve, Ae && Ae.coalesceStream && Ae.coalesceStream.setRemux(ve);
      }, this.alignGopsWith = function(ve) {
        ne && this.transmuxPipeline_.videoSegmentStream && this.transmuxPipeline_.videoSegmentStream.alignGopsWith(ve);
      }, this.push = function(ve) {
        if (ie) {
          var Ae = Vn(ve);
          Ae && this.transmuxPipeline_.type !== "aac" ? this.setupAacPipeline() : !Ae && this.transmuxPipeline_.type !== "ts" && this.setupTsPipeline(), ie = !1;
        }
        this.transmuxPipeline_.headOfPipeline.push(ve);
      }, this.flush = function() {
        ie = !0, this.transmuxPipeline_.headOfPipeline.flush();
      }, this.endTimeline = function() {
        this.transmuxPipeline_.headOfPipeline.endTimeline();
      }, this.reset = function() {
        this.transmuxPipeline_.headOfPipeline && this.transmuxPipeline_.headOfPipeline.reset();
      }, this.resetCaptions = function() {
        this.transmuxPipeline_.captionStream && this.transmuxPipeline_.captionStream.reset();
      };
    }, Qs.prototype = new n();
    var Cs = {
      Transmuxer: Qs,
      VideoSegmentStream: ws,
      AudioSegmentStream: ma,
      AUDIO_PROPERTIES: va,
      VIDEO_PROPERTIES: Js,
      generateVideoSegmentTimingInfo: na
    }, pu = function(q, z) {
      if (!(q instanceof z))
        throw new TypeError("Cannot call a class as a function");
    }, Mo = function() {
      function xe(q, z) {
        for (var ie = 0; ie < z.length; ie++) {
          var ne = z[ie];
          ne.enumerable = ne.enumerable || !1, ne.configurable = !0, "value" in ne && (ne.writable = !0), Object.defineProperty(q, ne.key, ne);
        }
      }
      return function(q, z, ie) {
        return z && xe(q.prototype, z), ie && xe(q, ie), q;
      };
    }(), hl = function(q, z) {
      z.on("data", function(ie) {
        var ne = ie.initSegment;
        ie.initSegment = {
          data: ne.buffer,
          byteOffset: ne.byteOffset,
          byteLength: ne.byteLength
        };
        var pe = ie.data;
        ie.data = pe.buffer, q.postMessage({
          action: "data",
          segment: ie,
          byteOffset: pe.byteOffset,
          byteLength: pe.byteLength
        }, [ie.data]);
      }), z.captionStream && z.captionStream.on("data", function(ie) {
        q.postMessage({
          action: "caption",
          data: ie
        });
      }), z.on("done", function(ie) {
        q.postMessage({
          action: "done"
        });
      }), z.on("gopInfo", function(ie) {
        q.postMessage({
          action: "gopInfo",
          gopInfo: ie
        });
      }), z.on("videoSegmentTimingInfo", function(ie) {
        q.postMessage({
          action: "videoSegmentTimingInfo",
          videoSegmentTimingInfo: ie
        });
      });
    }, pl = function() {
      function xe(q, z) {
        pu(this, xe), this.options = z || {}, this.self = q, this.init();
      }
      return Mo(xe, [{
        key: "init",
        value: function() {
          this.transmuxer && this.transmuxer.dispose(), this.transmuxer = new Cs.Transmuxer(this.options), hl(this.self, this.transmuxer);
        }
      }, {
        key: "push",
        value: function(z) {
          var ie = new Uint8Array(z.data, z.byteOffset, z.byteLength);
          this.transmuxer.push(ie);
        }
      }, {
        key: "reset",
        value: function() {
          this.init();
        }
      }, {
        key: "setTimestampOffset",
        value: function(z) {
          var ie = z.timestampOffset || 0;
          this.transmuxer.setBaseMediaDecodeTime(Math.round(ie * 9e4));
        }
      }, {
        key: "setAudioAppendStart",
        value: function(z) {
          this.transmuxer.setAudioAppendStart(Math.ceil(z.appendStart * 9e4));
        }
      }, {
        key: "flush",
        value: function(z) {
          this.transmuxer.flush();
        }
      }, {
        key: "resetCaptions",
        value: function() {
          this.transmuxer.resetCaptions();
        }
      }, {
        key: "alignGopsWith",
        value: function(z) {
          this.transmuxer.alignGopsWith(z.gopsToAlignWith.slice());
        }
      }]), xe;
    }(), Sc = function(q) {
      q.onmessage = function(z) {
        if (z.data.action === "init" && z.data.options) {
          this.messageHandlers = new pl(q, z.data.options);
          return;
        }
        this.messageHandlers || (this.messageHandlers = new pl(q)), z.data && z.data.action && z.data.action !== "init" && this.messageHandlers[z.data.action] && this.messageHandlers[z.data.action](z.data);
      };
    }, Ec = new Sc(i);
    return Ec;
  })();
}), DE = {
  videoCodec: "avc1",
  videoObjectTypeIndicator: ".4d400d",
  audioProfile: "2"
}, kE = function(r) {
  return r.map(function(i) {
    return i.replace(/avc1\.(\d+)\.(\d+)/i, function(t, n, a) {
      var s = ("00" + Number(n).toString(16)).slice(-2), o = ("00" + Number(a).toString(16)).slice(-2);
      return "avc1." + s + "00" + o;
    });
  });
}, dd = function() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", i = {
    codecCount: 0
  }, t = void 0;
  return i.codecCount = r.split(",").length, i.codecCount = i.codecCount || 2, t = /(^|\s|,)+(avc[13])([^ ,]*)/i.exec(r), t && (i.videoCodec = t[2], i.videoObjectTypeIndicator = t[3]), i.audioProfile = /(^|\s|,)+mp4a.[0-9A-Fa-f]+\.([0-9A-Fa-f]+)/i.exec(r), i.audioProfile = i.audioProfile && i.audioProfile[2], i;
}, jP = function(r) {
  return r.replace(/avc1\.(\d+)\.(\d+)/i, function(i) {
    return kE([i])[0];
  });
}, Jp = function(r, i, t) {
  return r + "/" + i + '; codecs="' + t.filter(function(n) {
    return !!n;
  }).join(", ") + '"';
}, $P = function(r) {
  return r.segments && r.segments.length && r.segments[0].map ? "mp4" : "mp2t";
}, GP = function(r) {
  var i = r.attributes || {};
  return i.CODECS ? dd(i.CODECS) : DE;
}, HP = function(r, i) {
  if (!r.mediaGroups.AUDIO || !i)
    return null;
  var t = r.mediaGroups.AUDIO[i];
  if (!t)
    return null;
  for (var n in t) {
    var a = t[n];
    if (a.default && a.playlists)
      return dd(a.playlists[0].attributes.CODECS).audioProfile;
  }
  return null;
}, VP = function(r, i) {
  var t = $P(i), n = GP(i), a = i.attributes || {}, s = !0, o = !1;
  if (!i)
    return [];
  if (r.mediaGroups.AUDIO && a.AUDIO) {
    var l = r.mediaGroups.AUDIO[a.AUDIO];
    if (l) {
      o = !0, s = !1;
      for (var u in l)
        if (!l[u].uri && !l[u].playlists) {
          s = !0;
          break;
        }
    }
  }
  o && !n.audioProfile && (s || (n.audioProfile = HP(r, a.AUDIO)), n.audioProfile || (re.log.warn("Multiple audio tracks present but no audio codec string is specified. Attempting to use the default audio codec (mp4a.40.2)"), n.audioProfile = DE.audioProfile));
  var h = {};
  n.videoCodec && (h.video = "" + n.videoCodec + n.videoObjectTypeIndicator), n.audioProfile && (h.audio = "mp4a.40." + n.audioProfile);
  var c = Jp("audio", t, [h.audio]), d = Jp("video", t, [h.video]), f = Jp("video", t, [h.video, h.audio]);
  return o ? !s && h.video ? [d, c] : !s && !h.video ? [c, c] : [f, c] : h.video ? [f] : [c];
}, qP = function(r) {
  var i = {
    type: "",
    parameters: {}
  }, t = r.trim().split(";");
  return i.type = t.shift().trim(), t.forEach(function(n) {
    var a = n.trim().split("=");
    if (a.length > 1) {
      var s = a[0].replace(/"/g, "").trim(), o = a[1].replace(/"/g, "").trim();
      i.parameters[s] = o;
    }
  }), i;
}, RE = function(r) {
  return /mp4a\.\d+.\d+/i.test(r);
}, PE = function(r) {
  return /avc1\.[\da-f]+/i.test(r);
}, WP = function(r, i, t) {
  if (typeof i > "u" || i === null || !r.length)
    return [];
  var n = Math.ceil((i - t + 3) * 9e4), a = void 0;
  for (a = 0; a < r.length && !(r[a].pts > n); a++)
    ;
  return r.slice(a);
}, YP = function(r, i, t) {
  if (!i.length)
    return r;
  if (t)
    return i.slice();
  var n = i[0].pts, a = 0;
  for (a; a < r.length && !(r[a].pts >= n); a++)
    ;
  return r.slice(0, a).concat(i);
}, KP = function(r, i, t, n) {
  for (var a = Math.ceil((i - n) * 9e4), s = Math.ceil((t - n) * 9e4), o = r.slice(), l = r.length; l-- && !(r[l].pts <= s); )
    ;
  if (l === -1)
    return o;
  for (var u = l + 1; u-- && !(r[u].pts <= a); )
    ;
  return u = Math.max(u, 0), o.splice(u, l - u + 1), o;
}, zP = function(r, i, t) {
  var n = null, a = null, s = 0, o = [], l = [];
  if (!r && !i)
    return re.createTimeRange();
  if (!r)
    return i.buffered;
  if (!i || t)
    return r.buffered;
  if (r.buffered.length === 0 && i.buffered.length === 0)
    return re.createTimeRange();
  for (var u = r.buffered, h = i.buffered, c = u.length; c--; )
    o.push({
      time: u.start(c),
      type: "start"
    }), o.push({
      time: u.end(c),
      type: "end"
    });
  for (c = h.length; c--; )
    o.push({
      time: h.start(c),
      type: "start"
    }), o.push({
      time: h.end(c),
      type: "end"
    });
  for (o.sort(function(d, f) {
    return d.time - f.time;
  }), c = 0; c < o.length; c++)
    o[c].type === "start" ? (s++, s === 2 && (n = o[c].time)) : o[c].type === "end" && (s--, s === 1 && (a = o[c].time)), n !== null && a !== null && (l.push([n, a]), n = null, a = null);
  return re.createTimeRanges(l);
}, wl = 9e4, XP = function(r, i) {
  var t = r.addSourceBuffer(i), n = /* @__PURE__ */ Object.create(null);
  n.updating = !1, n.realBuffer_ = t;
  var a = function(l) {
    typeof t[l] == "function" ? n[l] = function() {
      return t[l].apply(t, arguments);
    } : typeof n[l] > "u" && Object.defineProperty(n, l, {
      get: function() {
        return t[l];
      },
      set: function(h) {
        return t[l] = h;
      }
    });
  };
  for (var s in t)
    a(s);
  return n;
}, JP = function(e) {
  xo(r, e);
  function r(i, t) {
    Wa(this, r);
    var n = js(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, re.EventTarget));
    n.timestampOffset_ = 0, n.pendingBuffers_ = [], n.bufferUpdating_ = !1, n.mediaSource_ = i, n.codecs_ = t, n.audioCodec_ = null, n.videoCodec_ = null, n.audioDisabled_ = !1, n.appendAudioInitSegment_ = !0, n.gopBuffer_ = [], n.timeMapping_ = 0, n.safeAppend_ = re.browser.IE_VERSION >= 11;
    var a = {
      remux: !1,
      alignGopsAtEnd: n.safeAppend_
    };
    return n.codecs_.forEach(function(s) {
      RE(s) ? n.audioCodec_ = s : PE(s) && (n.videoCodec_ = s);
    }), n.transmuxer_ = new BP(), n.transmuxer_.postMessage({
      action: "init",
      options: a
    }), n.transmuxer_.onmessage = function(s) {
      if (s.data.action === "data")
        return n.data_(s);
      if (s.data.action === "done")
        return n.done_(s);
      if (s.data.action === "gopInfo")
        return n.appendGopInfo_(s);
      if (s.data.action === "videoSegmentTimingInfo")
        return n.videoSegmentTimingInfo_(s.data.videoSegmentTimingInfo);
    }, Object.defineProperty(n, "timestampOffset", {
      get: function() {
        return this.timestampOffset_;
      },
      set: function(o) {
        typeof o == "number" && o >= 0 && (this.timestampOffset_ = o, this.appendAudioInitSegment_ = !0, this.gopBuffer_.length = 0, this.timeMapping_ = 0, this.transmuxer_.postMessage({
          action: "setTimestampOffset",
          timestampOffset: o
        }));
      }
    }), Object.defineProperty(n, "appendWindowStart", {
      get: function() {
        return (this.videoBuffer_ || this.audioBuffer_).appendWindowStart;
      },
      set: function(o) {
        this.videoBuffer_ && (this.videoBuffer_.appendWindowStart = o), this.audioBuffer_ && (this.audioBuffer_.appendWindowStart = o);
      }
    }), Object.defineProperty(n, "updating", {
      get: function() {
        return !!(this.bufferUpdating_ || !this.audioDisabled_ && this.audioBuffer_ && this.audioBuffer_.updating || this.videoBuffer_ && this.videoBuffer_.updating);
      }
    }), Object.defineProperty(n, "buffered", {
      get: function() {
        return zP(this.videoBuffer_, this.audioBuffer_, this.audioDisabled_);
      }
    }), n;
  }
  return gs(r, [{
    key: "data_",
    value: function(t) {
      var n = t.data.segment;
      n.data = new Uint8Array(n.data, t.data.byteOffset, t.data.byteLength), n.initSegment = new Uint8Array(n.initSegment.data, n.initSegment.byteOffset, n.initSegment.byteLength), LP(this, this.mediaSource_, n), this.pendingBuffers_.push(n);
    }
  }, {
    key: "done_",
    value: function(t) {
      if (this.mediaSource_.readyState === "closed") {
        this.pendingBuffers_.length = 0;
        return;
      }
      this.processPendingSegments_();
    }
  }, {
    key: "videoSegmentTimingInfo_",
    value: function(t) {
      var n = {
        start: {
          decode: t.start.dts / wl,
          presentation: t.start.pts / wl
        },
        end: {
          decode: t.end.dts / wl,
          presentation: t.end.pts / wl
        },
        baseMediaDecodeTime: t.baseMediaDecodeTime / wl
      };
      t.prependedContentDuration && (n.prependedContentDuration = t.prependedContentDuration / wl), this.trigger({
        type: "videoSegmentTimingInfo",
        videoSegmentTimingInfo: n
      });
    }
  }, {
    key: "createRealSourceBuffers_",
    value: function() {
      var t = this, n = ["audio", "video"];
      n.forEach(function(a) {
        if (!!t[a + "Codec_"] && !t[a + "Buffer_"]) {
          var s = null;
          if (t.mediaSource_[a + "Buffer_"])
            s = t.mediaSource_[a + "Buffer_"], s.updating = !1;
          else {
            var o = a + "Codec_", l = a + '/mp4;codecs="' + t[o] + '"';
            s = XP(t.mediaSource_.nativeMediaSource_, l), t.mediaSource_[a + "Buffer_"] = s;
          }
          t[a + "Buffer_"] = s, ["update", "updatestart", "updateend"].forEach(function(u) {
            s.addEventListener(u, function() {
              if (!(a === "audio" && t.audioDisabled_)) {
                u === "updateend" && (t[a + "Buffer_"].updating = !1);
                var h = n.every(function(c) {
                  return c === "audio" && t.audioDisabled_ ? !0 : !(a !== c && t[c + "Buffer_"] && t[c + "Buffer_"].updating);
                });
                if (h)
                  return t.trigger(u);
              }
            });
          });
        }
      });
    }
  }, {
    key: "appendBuffer",
    value: function(t) {
      if (this.bufferUpdating_ = !0, this.audioBuffer_ && this.audioBuffer_.buffered.length) {
        var n = this.audioBuffer_.buffered;
        this.transmuxer_.postMessage({
          action: "setAudioAppendStart",
          appendStart: n.end(n.length - 1)
        });
      }
      this.videoBuffer_ && this.transmuxer_.postMessage({
        action: "alignGopsWith",
        gopsToAlignWith: WP(this.gopBuffer_, this.mediaSource_.player_ ? this.mediaSource_.player_.currentTime() : null, this.timeMapping_)
      }), this.transmuxer_.postMessage({
        action: "push",
        data: t.buffer,
        byteOffset: t.byteOffset,
        byteLength: t.byteLength
      }, [t.buffer]), this.transmuxer_.postMessage({
        action: "flush"
      });
    }
  }, {
    key: "appendGopInfo_",
    value: function(t) {
      this.gopBuffer_ = YP(this.gopBuffer_, t.data.gopInfo, this.safeAppend_);
    }
  }, {
    key: "remove",
    value: function(t, n) {
      if (this.videoBuffer_ && (this.videoBuffer_.updating = !0, this.videoBuffer_.remove(t, n), this.gopBuffer_ = KP(this.gopBuffer_, t, n, this.timeMapping_)), !this.audioDisabled_ && this.audioBuffer_ && (this.audioBuffer_.updating = !0, this.audioBuffer_.remove(t, n)), Bl(t, n, this.metadataTrack_), this.inbandTextTracks_)
        for (var a in this.inbandTextTracks_)
          Bl(t, n, this.inbandTextTracks_[a]);
    }
  }, {
    key: "processPendingSegments_",
    value: function() {
      var t = {
        video: {
          segments: [],
          bytes: 0
        },
        audio: {
          segments: [],
          bytes: 0
        },
        captions: [],
        metadata: []
      };
      if (!this.pendingBuffers_.length) {
        this.trigger("updateend"), this.bufferUpdating_ = !1;
        return;
      }
      t = this.pendingBuffers_.reduce(function(a, s) {
        var o = s.type, l = s.data, u = s.initSegment;
        return a[o].segments.push(l), a[o].bytes += l.byteLength, a[o].initSegment = u, s.captions && (a.captions = a.captions.concat(s.captions)), s.info && (a[o].info = s.info), s.metadata && (a.metadata = a.metadata.concat(s.metadata)), a;
      }, t), !this.videoBuffer_ && !this.audioBuffer_ && (t.video.bytes === 0 && (this.videoCodec_ = null), t.audio.bytes === 0 && (this.audioCodec_ = null), this.createRealSourceBuffers_()), t.audio.info && this.mediaSource_.trigger({
        type: "audioinfo",
        info: t.audio.info
      }), t.video.info && this.mediaSource_.trigger({
        type: "videoinfo",
        info: t.video.info
      }), this.appendAudioInitSegment_ && (!this.audioDisabled_ && this.audioBuffer_ && (t.audio.segments.unshift(t.audio.initSegment), t.audio.bytes += t.audio.initSegment.byteLength), this.appendAudioInitSegment_ = !1);
      var n = !1;
      this.videoBuffer_ && t.video.bytes ? (t.video.segments.unshift(t.video.initSegment), t.video.bytes += t.video.initSegment.byteLength, this.concatAndAppendSegments_(t.video, this.videoBuffer_)) : this.videoBuffer_ && (this.audioDisabled_ || !this.audioBuffer_) && (n = !0), MP(this, t.captions, t.metadata), !this.audioDisabled_ && this.audioBuffer_ && this.concatAndAppendSegments_(t.audio, this.audioBuffer_), this.pendingBuffers_.length = 0, n && this.trigger("updateend"), this.bufferUpdating_ = !1;
    }
  }, {
    key: "concatAndAppendSegments_",
    value: function(t, n) {
      var a = 0, s = void 0;
      if (t.bytes) {
        s = new Uint8Array(t.bytes), t.segments.forEach(function(o) {
          s.set(o, a), a += o.byteLength;
        });
        try {
          n.updating = !0, n.appendBuffer(s);
        } catch (o) {
          this.mediaSource_.player_ && this.mediaSource_.player_.error({
            code: -3,
            type: "APPEND_BUFFER_ERR",
            message: o.message,
            originalError: o
          });
        }
      }
    }
  }, {
    key: "abort",
    value: function() {
      this.videoBuffer_ && this.videoBuffer_.abort(), !this.audioDisabled_ && this.audioBuffer_ && this.audioBuffer_.abort(), this.transmuxer_ && this.transmuxer_.postMessage({
        action: "reset"
      }), this.pendingBuffers_.length = 0, this.bufferUpdating_ = !1;
    }
  }]), r;
}(re.EventTarget), Yg = function(e) {
  xo(r, e);
  function r() {
    Wa(this, r);
    var i = js(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this)), t = void 0;
    i.nativeMediaSource_ = new Be.MediaSource();
    for (t in i.nativeMediaSource_)
      !(t in r.prototype) && typeof i.nativeMediaSource_[t] == "function" && (i[t] = i.nativeMediaSource_[t].bind(i.nativeMediaSource_));
    return i.duration_ = NaN, Object.defineProperty(i, "duration", {
      get: function() {
        return this.duration_ === 1 / 0 ? this.duration_ : this.nativeMediaSource_.duration;
      },
      set: function(a) {
        if (this.duration_ = a, a !== 1 / 0) {
          this.nativeMediaSource_.duration = a;
          return;
        }
      }
    }), Object.defineProperty(i, "seekable", {
      get: function() {
        return this.duration_ === 1 / 0 ? re.createTimeRanges([[0, this.nativeMediaSource_.duration]]) : this.nativeMediaSource_.seekable;
      }
    }), Object.defineProperty(i, "readyState", {
      get: function() {
        return this.nativeMediaSource_.readyState;
      }
    }), Object.defineProperty(i, "activeSourceBuffers", {
      get: function() {
        return this.activeSourceBuffers_;
      }
    }), i.sourceBuffers = [], i.activeSourceBuffers_ = [], i.updateActiveSourceBuffers_ = function() {
      if (i.activeSourceBuffers_.length = 0, i.sourceBuffers.length === 1) {
        var n = i.sourceBuffers[0];
        n.appendAudioInitSegment_ = !0, n.audioDisabled_ = !n.audioCodec_, i.activeSourceBuffers_.push(n);
        return;
      }
      for (var a = !1, s = !0, o = 0; o < i.player_.audioTracks().length; o++) {
        var l = i.player_.audioTracks()[o];
        if (l.enabled && l.kind !== "main") {
          a = !0, s = !1;
          break;
        }
      }
      i.sourceBuffers.forEach(function(u, h) {
        if (u.appendAudioInitSegment_ = !0, u.videoCodec_ && u.audioCodec_)
          u.audioDisabled_ = a;
        else if (u.videoCodec_ && !u.audioCodec_)
          u.audioDisabled_ = !0, s = !1;
        else if (!u.videoCodec_ && u.audioCodec_ && (u.audioDisabled_ = h ? s : !s, u.audioDisabled_))
          return;
        i.activeSourceBuffers_.push(u);
      });
    }, i.onPlayerMediachange_ = function() {
      i.sourceBuffers.forEach(function(n) {
        n.appendAudioInitSegment_ = !0;
      });
    }, i.onHlsReset_ = function() {
      i.sourceBuffers.forEach(function(n) {
        n.transmuxer_ && n.transmuxer_.postMessage({
          action: "resetCaptions"
        });
      });
    }, i.onHlsSegmentTimeMapping_ = function(n) {
      i.sourceBuffers.forEach(function(a) {
        return a.timeMapping_ = n.mapping;
      });
    }, ["sourceopen", "sourceclose", "sourceended"].forEach(function(n) {
      this.nativeMediaSource_.addEventListener(n, this.trigger.bind(this));
    }, i), i.on("sourceopen", function(n) {
      var a = Mt.querySelector('[src="' + i.url_ + '"]');
      !a || (i.player_ = re(a.parentNode), i.player_ && (i.player_.tech_.on("hls-reset", i.onHlsReset_), i.player_.tech_.on("hls-segment-time-mapping", i.onHlsSegmentTimeMapping_), i.player_.audioTracks && i.player_.audioTracks() && (i.player_.audioTracks().on("change", i.updateActiveSourceBuffers_), i.player_.audioTracks().on("addtrack", i.updateActiveSourceBuffers_), i.player_.audioTracks().on("removetrack", i.updateActiveSourceBuffers_)), i.player_.on("mediachange", i.onPlayerMediachange_)));
    }), i.on("sourceended", function(n) {
      for (var a = AE(i.duration), s = 0; s < i.sourceBuffers.length; s++) {
        var o = i.sourceBuffers[s], l = o.metadataTrack_ && o.metadataTrack_.cues;
        l && l.length && (l[l.length - 1].endTime = a);
      }
    }), i.on("sourceclose", function(n) {
      this.sourceBuffers.forEach(function(a) {
        a.transmuxer_ && a.transmuxer_.terminate();
      }), this.sourceBuffers.length = 0, this.player_ && (this.player_.audioTracks && this.player_.audioTracks() && (this.player_.audioTracks().off("change", this.updateActiveSourceBuffers_), this.player_.audioTracks().off("addtrack", this.updateActiveSourceBuffers_), this.player_.audioTracks().off("removetrack", this.updateActiveSourceBuffers_)), this.player_.el_ && this.player_.off("mediachange", this.onPlayerMediachange_), this.player_.tech_ && this.player_.tech_.el_ && (this.player_.tech_.off("hls-reset", this.onHlsReset_), this.player_.tech_.off("hls-segment-time-mapping", this.onHlsSegmentTimeMapping_)));
    }), i;
  }
  return gs(r, [{
    key: "addSeekableRange_",
    value: function(t, n) {
      var a = void 0;
      if (this.duration !== 1 / 0)
        throw a = new Error("MediaSource.addSeekableRange() can only be invoked when the duration is Infinity"), a.name = "InvalidStateError", a.code = 11, a;
      (n > this.nativeMediaSource_.duration || isNaN(this.nativeMediaSource_.duration)) && (this.nativeMediaSource_.duration = n);
    }
  }, {
    key: "addSourceBuffer",
    value: function(t) {
      var n = void 0, a = qP(t);
      if (/^(video|audio)\/mp2t$/i.test(a.type)) {
        var s = [];
        a.parameters && a.parameters.codecs && (s = a.parameters.codecs.split(","), s = kE(s), s = s.filter(function(o) {
          return RE(o) || PE(o);
        })), s.length === 0 && (s = ["avc1.4d400d", "mp4a.40.2"]), n = new JP(this, s), this.sourceBuffers.length !== 0 && (this.sourceBuffers[0].createRealSourceBuffers_(), n.createRealSourceBuffers_(), this.sourceBuffers[0].audioDisabled_ = !0);
      } else
        n = this.nativeMediaSource_.addSourceBuffer(t);
      return this.sourceBuffers.push(n), n;
    }
  }]), r;
}(re.EventTarget), W_ = 0;
re.mediaSources = {};
var OE = function(r, i) {
  var t = re.mediaSources[r];
  if (t)
    t.trigger({
      type: "sourceopen",
      swfId: i
    });
  else
    throw new Error("Media Source not found (Video.js)");
}, Kg = function() {
  return !!Be.MediaSource && !!Be.MediaSource.isTypeSupported && Be.MediaSource.isTypeSupported('video/mp4;codecs="avc1.4d400d,mp4a.40.2"');
}, Pd = function() {
  if (this.MediaSource = {
    open: OE,
    supportsNativeMediaSources: Kg
  }, Kg())
    return new Yg();
  throw new Error("Cannot use create a virtual MediaSource for this video");
};
Pd.open = OE;
Pd.supportsNativeMediaSources = Kg;
var LE = {
  createObjectURL: function(r) {
    var i = "blob:vjs-media-source/", t = void 0;
    return r instanceof Yg ? (t = Be.URL.createObjectURL(r.nativeMediaSource_), r.url_ = t, t) : r instanceof Yg ? (t = i + W_, W_++, re.mediaSources[t] = r, t) : (t = Be.URL.createObjectURL(r), r.url_ = t, t);
  }
};
re.MediaSource = Pd;
re.URL = LE;
var QP = re.EventTarget, IE = re.mergeOptions, Y_ = function(r, i) {
  for (var t = void 0, n = IE(r, {
    duration: i.duration,
    minimumUpdatePeriod: i.minimumUpdatePeriod
  }), a = 0; a < i.playlists.length; a++) {
    var s = Vg(n, i.playlists[a]);
    s ? n = s : t = !0;
  }
  return $h(i, function(o, l, u, h) {
    if (o.playlists && o.playlists.length) {
      var c = o.playlists[0].uri, d = Vg(n, o.playlists[0]);
      d && (n = d, n.mediaGroups[l][u][h].playlists[0] = n.playlists[c], t = !1);
    }
  }), t ? null : n;
}, zg = function(r) {
  var i = r.byterange.offset + r.byterange.length - 1;
  return r.uri + "-" + r.byterange.offset + "-" + i;
}, ZP = function(r, i) {
  var t = Boolean(!r.map && !i.map), n = t || Boolean(r.map && i.map && r.map.byterange.offset === i.map.byterange.offset && r.map.byterange.length === i.map.byterange.length);
  return n && r.uri === i.uri && r.byterange.offset === i.byterange.offset && r.byterange.length === i.byterange.length;
}, K_ = function(r, i) {
  var t = {};
  for (var n in r) {
    var a = r[n], s = a.sidx;
    if (s) {
      var o = zg(s);
      if (!i[o])
        break;
      var l = i[o].sidxInfo;
      ZP(l, s) && (t[o] = i[o]);
    }
  }
  return t;
}, eO = function(r, i, t, n) {
  var a = CT(r, {
    manifestUri: i,
    clientOffset: t
  }), s = K_(a.playlists, n), o = s;
  return $h(a, function(l, u, h, c) {
    if (l.playlists && l.playlists.length) {
      var d = l.playlists;
      o = IE(o, K_(d, n));
    }
  }), o;
}, z_ = function(r, i, t, n, a) {
  var s = {
    uri: Zf(n.handleManifestRedirects, r.resolvedUri),
    byterange: r.byterange,
    playlist: i
  }, o = re.mergeOptions(s, {
    responseType: "arraybuffer",
    headers: Wg(s)
  });
  return t(o, a);
}, Xg = function(e) {
  xo(r, e);
  function r(i, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = arguments[3];
    Wa(this, r);
    var s = js(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this)), o = n.withCredentials, l = o === void 0 ? !1 : o, u = n.handleManifestRedirects, h = u === void 0 ? !1 : u;
    if (s.hls_ = t, s.withCredentials = l, s.handleManifestRedirects = h, !i)
      throw new Error("A non-empty playlist URL or playlist is required");
    return s.on("minimumUpdatePeriod", function() {
      s.refreshXml_();
    }), s.on("mediaupdatetimeout", function() {
      s.refreshMedia_(s.media().uri);
    }), s.state = "HAVE_NOTHING", s.loadedPlaylists_ = {}, typeof i == "string" ? (s.srcUrl = i, s.sidxMapping_ = {}, js(s)) : (s.setupChildLoader(a, i), s);
  }
  return gs(r, [{
    key: "setupChildLoader",
    value: function(t, n) {
      this.masterPlaylistLoader_ = t, this.childPlaylist_ = n;
    }
  }, {
    key: "dispose",
    value: function() {
      this.stopRequest(), this.loadedPlaylists_ = {}, Be.clearTimeout(this.minimumUpdatePeriodTimeout_), Be.clearTimeout(this.mediaRequest_), Be.clearTimeout(this.mediaUpdateTimeout);
    }
  }, {
    key: "hasPendingRequest",
    value: function() {
      return this.request || this.mediaRequest_;
    }
  }, {
    key: "stopRequest",
    value: function() {
      if (this.request) {
        var t = this.request;
        this.request = null, t.onreadystatechange = null, t.abort();
      }
    }
  }, {
    key: "sidxRequestFinished_",
    value: function(t, n, a, s) {
      var o = this;
      return function(l, u) {
        if (!!o.request) {
          if (o.request = null, l)
            return o.error = {
              status: u.status,
              message: "DASH playlist request error at URL: " + t.uri,
              response: u.response,
              code: 2
            }, a && (o.state = a), o.trigger("error"), s(n, null);
          var h = new Uint8Array(u.response), c = _k.parseSidx(h.subarray(8));
          return s(n, c);
        }
      };
    }
  }, {
    key: "media",
    value: function(t) {
      var n = this;
      if (!t)
        return this.media_;
      if (this.state === "HAVE_NOTHING")
        throw new Error("Cannot switch media playlist from " + this.state);
      var a = this.state;
      if (typeof t == "string") {
        if (!this.master.playlists[t])
          throw new Error("Unknown playlist URI: " + t);
        t = this.master.playlists[t];
      }
      var s = !this.media_ || t.uri !== this.media_.uri;
      if (s && this.loadedPlaylists_[t.uri] && this.loadedPlaylists_[t.uri].endList) {
        this.state = "HAVE_METADATA", this.media_ = t, s && (this.trigger("mediachanging"), this.trigger("mediachange"));
        return;
      }
      if (!!s) {
        if (this.media_ && this.trigger("mediachanging"), !t.sidx) {
          this.mediaRequest_ = Be.setTimeout(this.haveMetadata.bind(this, {
            startingState: a,
            playlist: t
          }), 0);
          return;
        }
        var o = void 0, l = void 0;
        this.masterPlaylistLoader_ ? (o = this.masterPlaylistLoader_.master, l = this.masterPlaylistLoader_.sidxMapping_) : (o = this.master, l = this.sidxMapping_);
        var u = zg(t.sidx);
        l[u] = {
          sidxInfo: t.sidx
        }, this.request = z_(t.sidx, t, this.hls_.xhr, {
          handleManifestRedirects: this.handleManifestRedirects
        }, this.sidxRequestFinished_(t, o, a, function(h, c) {
          if (!h || !c)
            throw new Error("failed to request sidx");
          l[u].sidx = c, n.haveMetadata({
            startingState: a,
            playlist: h.playlists[t.uri]
          });
        }));
      }
    }
  }, {
    key: "haveMetadata",
    value: function(t) {
      var n = t.startingState, a = t.playlist;
      this.state = "HAVE_METADATA", this.loadedPlaylists_[a.uri] = a, this.mediaRequest_ = null, this.refreshMedia_(a.uri), n === "HAVE_MASTER" ? this.trigger("loadedmetadata") : this.trigger("mediachange");
    }
  }, {
    key: "pause",
    value: function() {
      this.stopRequest(), Be.clearTimeout(this.mediaUpdateTimeout), Be.clearTimeout(this.minimumUpdatePeriodTimeout_), this.state === "HAVE_NOTHING" && (this.started = !1);
    }
  }, {
    key: "load",
    value: function(t) {
      var n = this;
      Be.clearTimeout(this.mediaUpdateTimeout), Be.clearTimeout(this.minimumUpdatePeriodTimeout_);
      var a = this.media();
      if (t) {
        var s = a ? a.targetDuration / 2 * 1e3 : 5e3;
        this.mediaUpdateTimeout = Be.setTimeout(function() {
          return n.load();
        }, s);
        return;
      }
      if (!this.started) {
        this.start();
        return;
      }
      this.trigger("loadedplaylist");
    }
  }, {
    key: "parseMasterXml",
    value: function() {
      var t = CT(this.masterXml_, {
        manifestUri: this.srcUrl,
        clientOffset: this.clientOffset_,
        sidxMapping: this.sidxMapping_
      });
      t.uri = this.srcUrl;
      for (var n = 0; n < t.playlists.length; n++) {
        var a = "placeholder-uri-" + n;
        t.playlists[n].uri = a, t.playlists[a] = t.playlists[n];
      }
      return $h(t, function(s, o, l, u) {
        if (s.playlists && s.playlists.length) {
          var h = "placeholder-uri-" + o + "-" + l + "-" + u;
          s.playlists[0].uri = h, t.playlists[h] = s.playlists[0];
        }
      }), uE(t), lE(t), t;
    }
  }, {
    key: "start",
    value: function() {
      var t = this;
      if (this.started = !0, this.masterPlaylistLoader_) {
        this.mediaRequest_ = Be.setTimeout(this.haveMaster_.bind(this), 0);
        return;
      }
      this.request = this.hls_.xhr({
        uri: this.srcUrl,
        withCredentials: this.withCredentials
      }, function(n, a) {
        if (!!t.request) {
          if (t.request = null, n)
            return t.error = {
              status: a.status,
              message: "DASH playlist request error at URL: " + t.srcUrl,
              responseText: a.responseText,
              code: 2
            }, t.state === "HAVE_NOTHING" && (t.started = !1), t.trigger("error");
          t.masterXml_ = a.responseText, a.responseHeaders && a.responseHeaders.date ? t.masterLoaded_ = Date.parse(a.responseHeaders.date) : t.masterLoaded_ = Date.now(), t.srcUrl = Zf(t.handleManifestRedirects, t.srcUrl, a), t.syncClientServerClock_(t.onClientServerClockSync_.bind(t));
        }
      });
    }
  }, {
    key: "syncClientServerClock_",
    value: function(t) {
      var n = this, a = tk(this.masterXml_);
      if (a === null)
        return this.clientOffset_ = this.masterLoaded_ - Date.now(), t();
      if (a.method === "DIRECT")
        return this.clientOffset_ = a.value - Date.now(), t();
      this.request = this.hls_.xhr({
        uri: Yu(this.srcUrl, a.value),
        method: a.method,
        withCredentials: this.withCredentials
      }, function(s, o) {
        if (!!n.request) {
          if (s)
            return n.clientOffset_ = n.masterLoaded_ - Date.now(), t();
          var l = void 0;
          a.method === "HEAD" ? !o.responseHeaders || !o.responseHeaders.date ? l = n.masterLoaded_ : l = Date.parse(o.responseHeaders.date) : l = Date.parse(o.responseText), n.clientOffset_ = l - Date.now(), t();
        }
      });
    }
  }, {
    key: "haveMaster_",
    value: function() {
      this.state = "HAVE_MASTER", this.mediaRequest_ = null, this.masterPlaylistLoader_ ? this.media_ || this.media(this.childPlaylist_) : (this.master = this.parseMasterXml(), this.trigger("loadedplaylist"));
    }
  }, {
    key: "onClientServerClockSync_",
    value: function() {
      var t = this;
      this.haveMaster_(), !this.hasPendingRequest() && !this.media_ && this.media(this.master.playlists[0]), this.master && this.master.minimumUpdatePeriod && (this.minimumUpdatePeriodTimeout_ = Be.setTimeout(function() {
        t.trigger("minimumUpdatePeriod");
      }, this.master.minimumUpdatePeriod));
    }
  }, {
    key: "refreshXml_",
    value: function() {
      var t = this;
      this.request = this.hls_.xhr({
        uri: this.srcUrl,
        withCredentials: this.withCredentials
      }, function(n, a) {
        if (!!t.request) {
          if (t.request = null, n)
            return t.error = {
              status: a.status,
              message: "DASH playlist request error at URL: " + t.srcUrl,
              responseText: a.responseText,
              code: 2
            }, t.state === "HAVE_NOTHING" && (t.started = !1), t.trigger("error");
          t.masterXml_ = a.responseText, t.sidxMapping_ = eO(t.masterXml_, t.srcUrl, t.clientOffset_, t.sidxMapping_);
          var s = t.parseMasterXml(), o = Y_(t.master, s), l = t.media().sidx;
          if (o)
            if (l) {
              var u = zg(l);
              if (!t.sidxMapping_[u]) {
                var h = t.media();
                t.request = z_(h.sidx, h, t.hls_.xhr, {
                  handleManifestRedirects: t.handleManifestRedirects
                }, t.sidxRequestFinished_(h, s, t.state, function(c, d) {
                  if (!c || !d)
                    throw new Error("failed to request sidx on minimumUpdatePeriod");
                  t.sidxMapping_[u].sidx = d, t.minimumUpdatePeriodTimeout_ = Be.setTimeout(function() {
                    t.trigger("minimumUpdatePeriod");
                  }, t.master.minimumUpdatePeriod), t.refreshMedia_(t.media().uri);
                }));
              }
            } else
              t.master = o;
          t.minimumUpdatePeriodTimeout_ = Be.setTimeout(function() {
            t.trigger("minimumUpdatePeriod");
          }, t.master.minimumUpdatePeriod);
        }
      });
    }
  }, {
    key: "refreshMedia_",
    value: function(t) {
      var n = this;
      if (!t)
        throw new Error("refreshMedia_ must take a media uri");
      var a = void 0, s = void 0;
      this.masterPlaylistLoader_ ? (a = this.masterPlaylistLoader_.master, s = this.masterPlaylistLoader_.parseMasterXml()) : (a = this.master, s = this.parseMasterXml());
      var o = Y_(a, s);
      o ? (this.masterPlaylistLoader_ ? this.masterPlaylistLoader_.master = o : this.master = o, this.media_ = o.playlists[t]) : (this.media_ = s.playlists[t], this.trigger("playlistunchanged")), this.media().endList || (this.mediaUpdateTimeout = Be.setTimeout(function() {
        n.trigger("mediaupdatetimeout");
      }, cE(this.media(), !!o))), this.trigger("loadedplaylist");
    }
  }]), r;
}(QP), Od = function(r) {
  return re.log.debug ? re.log.debug.bind(re, "VHS:", r + " >") : function() {
  };
};
function Ol() {
}
var tO = function() {
  function e(r, i, t, n) {
    Wa(this, e), this.callbacks_ = [], this.pendingCallback_ = null, this.timestampOffset_ = 0, this.mediaSource = r, this.processedAppend_ = !1, this.type_ = t, this.mimeType_ = i, this.logger_ = Od("SourceUpdater[" + t + "][" + i + "]"), r.readyState === "closed" ? r.addEventListener("sourceopen", this.createSourceBuffer_.bind(this, i, n)) : this.createSourceBuffer_(i, n);
  }
  return gs(e, [{
    key: "createSourceBuffer_",
    value: function(i, t) {
      var n = this;
      if (this.sourceBuffer_ = this.mediaSource.addSourceBuffer(i), this.logger_("created SourceBuffer"), t && (t.trigger("sourcebufferadded"), this.mediaSource.sourceBuffers.length < 2)) {
        t.on("sourcebufferadded", function() {
          n.start_();
        });
        return;
      }
      this.start_();
    }
  }, {
    key: "start_",
    value: function() {
      var i = this;
      this.started_ = !0, this.onUpdateendCallback_ = function() {
        var t = i.pendingCallback_;
        i.pendingCallback_ = null, i.sourceBuffer_.removing = !1, i.logger_("buffered [" + Am(i.buffered()) + "]"), t && t(), i.runCallback_();
      }, this.sourceBuffer_.addEventListener("updateend", this.onUpdateendCallback_), this.runCallback_();
    }
  }, {
    key: "abort",
    value: function(i) {
      var t = this;
      this.processedAppend_ && this.queueCallback_(function() {
        t.sourceBuffer_.abort();
      }, i);
    }
  }, {
    key: "appendBuffer",
    value: function(i, t) {
      var n = this;
      this.processedAppend_ = !0, this.queueCallback_(function() {
        i.videoSegmentTimingInfoCallback && n.sourceBuffer_.addEventListener("videoSegmentTimingInfo", i.videoSegmentTimingInfoCallback), n.sourceBuffer_.appendBuffer(i.bytes);
      }, function() {
        i.videoSegmentTimingInfoCallback && n.sourceBuffer_.removeEventListener("videoSegmentTimingInfo", i.videoSegmentTimingInfoCallback), t();
      });
    }
  }, {
    key: "buffered",
    value: function() {
      return this.sourceBuffer_ ? this.sourceBuffer_.buffered : re.createTimeRanges();
    }
  }, {
    key: "remove",
    value: function(i, t) {
      var n = this, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ol;
      this.processedAppend_ && this.queueCallback_(function() {
        n.logger_("remove [" + i + " => " + t + "]"), n.sourceBuffer_.removing = !0, n.sourceBuffer_.remove(i, t);
      }, a);
    }
  }, {
    key: "updating",
    value: function() {
      return !this.sourceBuffer_ || this.sourceBuffer_.updating || !!this.pendingCallback_ && this.pendingCallback_ !== Ol;
    }
  }, {
    key: "timestampOffset",
    value: function(i) {
      var t = this;
      return typeof i < "u" && (this.queueCallback_(function() {
        t.sourceBuffer_.timestampOffset = i, t.runCallback_();
      }), this.timestampOffset_ = i), this.timestampOffset_;
    }
  }, {
    key: "queueCallback_",
    value: function(i, t) {
      this.callbacks_.push([i.bind(this), t]), this.runCallback_();
    }
  }, {
    key: "runCallback_",
    value: function() {
      var i = void 0;
      !this.updating() && this.callbacks_.length && this.started_ && (i = this.callbacks_.shift(), this.pendingCallback_ = i[1], i[0]());
    }
  }, {
    key: "dispose",
    value: function() {
      var i = this, t = function n() {
        i.sourceBuffer_ && i.mediaSource.readyState === "open" && i.sourceBuffer_.abort(), i.sourceBuffer_.removeEventListener("updateend", n);
      };
      this.sourceBuffer_.removeEventListener("updateend", this.onUpdateendCallback_), this.sourceBuffer_.removing ? this.sourceBuffer_.addEventListener("updateend", t) : t();
    }
  }]), e;
}(), Sa = {
  GOAL_BUFFER_LENGTH: 30,
  MAX_GOAL_BUFFER_LENGTH: 60,
  GOAL_BUFFER_LENGTH_RATE: 1,
  INITIAL_BANDWIDTH: 4194304,
  BANDWIDTH_VARIANCE: 1.2,
  BUFFER_LOW_WATER_LINE: 0,
  MAX_BUFFER_LOW_WATER_LINE: 30,
  BUFFER_LOW_WATER_LINE_RATE: 1
}, Qo = {
  FAILURE: 2,
  TIMEOUT: -101,
  ABORTED: -102
}, ME = function(r) {
  r.forEach(function(i) {
    i.abort();
  });
}, rO = function(r) {
  return {
    bandwidth: r.bandwidth,
    bytesReceived: r.bytesReceived || 0,
    roundTripTime: r.roundTripTime || 0
  };
}, iO = function(r) {
  var i = r.target, t = Date.now() - i.requestTime, n = {
    bandwidth: 1 / 0,
    bytesReceived: 0,
    roundTripTime: t || 0
  };
  return n.bytesReceived = r.loaded, n.bandwidth = Math.floor(n.bytesReceived / n.roundTripTime * 8 * 1e3), n;
}, wm = function(r, i) {
  return i.timedout ? {
    status: i.status,
    message: "HLS request timed-out at URL: " + i.uri,
    code: Qo.TIMEOUT,
    xhr: i
  } : i.aborted ? {
    status: i.status,
    message: "HLS request aborted at URL: " + i.uri,
    code: Qo.ABORTED,
    xhr: i
  } : r ? {
    status: i.status,
    message: "HLS request errored at URL: " + i.uri,
    code: Qo.FAILURE,
    xhr: i
  } : null;
}, nO = function(r, i) {
  return function(t, n) {
    var a = n.response, s = wm(t, n);
    if (s)
      return i(s, r);
    if (a.byteLength !== 16)
      return i({
        status: n.status,
        message: "Invalid HLS key at URL: " + n.uri,
        code: Qo.FAILURE,
        xhr: n
      }, r);
    var o = new DataView(a);
    return r.key.bytes = new Uint32Array([o.getUint32(0), o.getUint32(4), o.getUint32(8), o.getUint32(12)]), i(null, r);
  };
}, aO = function(r, i, t) {
  return function(n, a) {
    var s = a.response, o = wm(n, a);
    return o ? t(o, r) : s.byteLength === 0 ? t({
      status: a.status,
      message: "Empty HLS segment content at URL: " + a.uri,
      code: Qo.FAILURE,
      xhr: a
    }, r) : (r.map.bytes = new Uint8Array(a.response), i && !i.isInitialized() && i.init(), r.map.timescales = Vf.timescale(r.map.bytes), r.map.videoTrackIds = Vf.videoTrackIds(r.map.bytes), t(null, r));
  };
}, sO = function(r, i, t) {
  return function(n, a) {
    var s = a.response, o = wm(n, a), l = void 0;
    return o ? t(o, r) : s.byteLength === 0 ? t({
      status: a.status,
      message: "Empty HLS segment content at URL: " + a.uri,
      code: Qo.FAILURE,
      xhr: a
    }, r) : (r.stats = rO(a), r.key ? r.encryptedBytes = new Uint8Array(a.response) : r.bytes = new Uint8Array(a.response), i && r.map && r.map.bytes && (i.isInitialized() || i.init(), l = i.parse(r.bytes, r.map.videoTrackIds, r.map.timescales), l && l.captions && (r.captionStreams = l.captionStreams, r.fmp4Captions = l.captions)), t(null, r));
  };
}, oO = function(r, i, t) {
  var n = function s(o) {
    if (o.data.source === i.requestId) {
      r.removeEventListener("message", s);
      var l = o.data.decrypted;
      return i.bytes = new Uint8Array(l.bytes, l.byteOffset, l.byteLength), t(null, i);
    }
  };
  r.addEventListener("message", n);
  var a = void 0;
  i.key.bytes.slice ? a = i.key.bytes.slice() : a = new Uint32Array(Array.prototype.slice.call(i.key.bytes)), r.postMessage(_E({
    source: i.requestId,
    encrypted: i.encryptedBytes,
    key: a,
    iv: i.key.iv
  }), [i.encryptedBytes.buffer, a.buffer]);
}, uO = function(r, i, t) {
  var n = 0, a = !1;
  return function(s, o) {
    if (!a) {
      if (s)
        return a = !0, ME(r), t(s, o);
      if (n += 1, n === r.length)
        return o.endOfAllRequests = Date.now(), o.encryptedBytes ? oO(i, o, t) : t(null, o);
    }
  };
}, lO = function(r, i) {
  return function(t) {
    return r.stats = re.mergeOptions(r.stats, iO(t)), !r.stats.firstBytesReceivedAt && r.stats.bytesReceived && (r.stats.firstBytesReceivedAt = Date.now()), i(t, r);
  };
}, cO = function(r, i, t, n, a, s, o) {
  var l = [], u = uO(l, t, o);
  if (a.key && !a.key.bytes) {
    var h = re.mergeOptions(i, {
      uri: a.key.resolvedUri,
      responseType: "arraybuffer"
    }), c = nO(a, u), d = r(h, c);
    l.push(d);
  }
  if (a.map && !a.map.bytes) {
    var f = re.mergeOptions(i, {
      uri: a.map.resolvedUri,
      responseType: "arraybuffer",
      headers: Wg(a.map)
    }), m = aO(a, n, u), p = r(f, m);
    l.push(p);
  }
  var b = re.mergeOptions(i, {
    uri: a.resolvedUri,
    responseType: "arraybuffer",
    headers: Wg(a)
  }), y = sO(a, n, u), v = r(b, y);
  return v.addEventListener("progress", lO(a, s)), l.push(v), function() {
    return ME(l);
  };
}, X_ = function(r, i) {
  var t = void 0;
  return !r || (t = Be.getComputedStyle(r), !t) ? "" : t[i];
}, fd = function(r, i) {
  var t = r.slice();
  r.sort(function(n, a) {
    var s = i(n, a);
    return s === 0 ? t.indexOf(n) - t.indexOf(a) : s;
  });
}, Cm = function(r, i) {
  var t = void 0, n = void 0;
  return r.attributes.BANDWIDTH && (t = r.attributes.BANDWIDTH), t = t || Be.Number.MAX_VALUE, i.attributes.BANDWIDTH && (n = i.attributes.BANDWIDTH), n = n || Be.Number.MAX_VALUE, t - n;
}, dO = function(r, i) {
  var t = void 0, n = void 0;
  return r.attributes.RESOLUTION && r.attributes.RESOLUTION.width && (t = r.attributes.RESOLUTION.width), t = t || Be.Number.MAX_VALUE, i.attributes.RESOLUTION && i.attributes.RESOLUTION.width && (n = i.attributes.RESOLUTION.width), n = n || Be.Number.MAX_VALUE, t === n && r.attributes.BANDWIDTH && i.attributes.BANDWIDTH ? r.attributes.BANDWIDTH - i.attributes.BANDWIDTH : t - n;
}, fO = function(r, i, t, n, a) {
  var s = r.playlists.map(function(g) {
    var E = void 0, x = void 0, w = void 0;
    return E = g.attributes.RESOLUTION && g.attributes.RESOLUTION.width, x = g.attributes.RESOLUTION && g.attributes.RESOLUTION.height, w = g.attributes.BANDWIDTH, w = w || Be.Number.MAX_VALUE, {
      bandwidth: w,
      width: E,
      height: x,
      playlist: g
    };
  });
  fd(s, function(g, E) {
    return g.bandwidth - E.bandwidth;
  }), s = s.filter(function(g) {
    return !ua.isIncompatible(g.playlist);
  });
  var o = s.filter(function(g) {
    return ua.isEnabled(g.playlist);
  });
  o.length || (o = s.filter(function(g) {
    return !ua.isDisabled(g.playlist);
  }));
  var l = o.filter(function(g) {
    return g.bandwidth * Sa.BANDWIDTH_VARIANCE < i;
  }), u = l[l.length - 1], h = l.filter(function(g) {
    return g.bandwidth === u.bandwidth;
  })[0];
  if (a === !1) {
    var c = h || o[0] || s[0];
    return c ? c.playlist : null;
  }
  var d = l.filter(function(g) {
    return g.width && g.height;
  });
  fd(d, function(g, E) {
    return g.width - E.width;
  });
  var f = d.filter(function(g) {
    return g.width === t && g.height === n;
  });
  u = f[f.length - 1];
  var m = f.filter(function(g) {
    return g.bandwidth === u.bandwidth;
  })[0], p = void 0, b = void 0, y = void 0;
  m || (p = d.filter(function(g) {
    return g.width > t || g.height > n;
  }), b = p.filter(function(g) {
    return g.width === p[0].width && g.height === p[0].height;
  }), u = b[b.length - 1], y = b.filter(function(g) {
    return g.bandwidth === u.bandwidth;
  })[0]);
  var v = y || m || h || o[0] || s[0];
  return v ? v.playlist : null;
}, hO = function() {
  return fO(this.playlists.master, this.systemBandwidth, parseInt(X_(this.tech_.el(), "width"), 10), parseInt(X_(this.tech_.el(), "height"), 10), this.limitRenditionByPlayerDimensions);
}, pO = function(r) {
  var i = r.master, t = r.currentTime, n = r.bandwidth, a = r.duration, s = r.segmentDuration, o = r.timeUntilRebuffer, l = r.currentTimeline, u = r.syncController, h = i.playlists.filter(function(p) {
    return !ua.isIncompatible(p);
  }), c = h.filter(ua.isEnabled);
  c.length || (c = h.filter(function(p) {
    return !ua.isDisabled(p);
  }));
  var d = c.filter(ua.hasAttribute.bind(null, "BANDWIDTH")), f = d.map(function(p) {
    var b = u.getSyncPoint(p, a, l, t), y = b ? 1 : 2, v = ua.estimateSegmentRequestTime(s, n, p), g = v * y - o;
    return {
      playlist: p,
      rebufferingImpact: g
    };
  }), m = f.filter(function(p) {
    return p.rebufferingImpact <= 0;
  });
  return fd(m, function(p, b) {
    return Cm(b.playlist, p.playlist);
  }), m.length ? m[0] : (fd(f, function(p, b) {
    return p.rebufferingImpact - b.rebufferingImpact;
  }), f[0] || null);
}, gO = function() {
  var r = this.playlists.master.playlists.filter(ua.isEnabled);
  fd(r, function(t, n) {
    return Cm(t, n);
  });
  var i = r.filter(function(t) {
    return dd(t.attributes.CODECS).videoCodec;
  });
  return i[0] || null;
}, vO = function(r, i, t) {
  for (var n in t)
    if (!r[n]) {
      i.trigger({
        type: "usage",
        name: "hls-608"
      });
      var a = i.textTracks().getTrackById(n);
      a ? r[n] = a : r[n] = i.addRemoteTextTrack({
        kind: "captions",
        id: n,
        label: n
      }, !1).track;
    }
}, mO = function(r) {
  var i = r.inbandTextTracks, t = r.captionArray, n = r.timestampOffset;
  if (!!t) {
    var a = window.WebKitDataCue || window.VTTCue;
    t.forEach(function(s) {
      var o = s.stream, l = s.startTime, u = s.endTime;
      !i[o] || (l += n, u += n, i[o].addCue(new a(l, u, s.text)));
    });
  }
}, yO = 500, _O = function(r, i, t) {
  if (!r || !i)
    return !1;
  var n = r.segments, a = t === n.length;
  return r.endList && i.readyState === "open" && a;
}, J_ = function(r) {
  return typeof r == "number" && isFinite(r);
}, bO = function(r, i, t) {
  return r !== "main" || !i || !t ? null : !t.containsAudio && !t.containsVideo ? "Neither audio nor video found in segment." : i.containsVideo && !t.containsVideo ? "Only audio found in segment when we expected video. We can't switch to audio only from a stream that had video. To get rid of this message, please add codec information to the manifest." : !i.containsVideo && t.containsVideo ? "Video found in segment when we expected only audio. We can't switch to a stream with video from an audio only stream. To get rid of this message, please add codec information to the manifest." : null;
}, TO = function(r, i, t) {
  var n = void 0;
  return r.length && r.start(0) > 0 && r.start(0) < i ? n = r.start(0) : n = i - 30, Math.min(n, i - t);
}, SO = function(r) {
  var i = r.segment, t = i.start, n = i.end, a = r.playlist, s = a.mediaSequence, o = a.id, l = a.segments, u = l === void 0 ? [] : l, h = r.mediaIndex, c = r.timeline;
  return ["appending [" + h + "] of [" + s + ", " + (s + u.length) + "] from playlist [" + o + "]", "[" + t + " => " + n + "] in timeline [" + c + "]"].join(" ");
}, Jg = function(e) {
  xo(r, e);
  function r(i) {
    Wa(this, r);
    var t = js(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this));
    if (!i)
      throw new TypeError("Initialization settings are required");
    if (typeof i.currentTime != "function")
      throw new TypeError("No currentTime getter specified");
    if (!i.mediaSource)
      throw new TypeError("No MediaSource specified");
    return t.bandwidth = i.bandwidth, t.throughput = {
      rate: 0,
      count: 0
    }, t.roundTrip = NaN, t.resetStats_(), t.mediaIndex = null, t.hasPlayed_ = i.hasPlayed, t.currentTime_ = i.currentTime, t.seekable_ = i.seekable, t.seeking_ = i.seeking, t.duration_ = i.duration, t.mediaSource_ = i.mediaSource, t.hls_ = i.hls, t.loaderType_ = i.loaderType, t.startingMedia_ = void 0, t.segmentMetadataTrack_ = i.segmentMetadataTrack, t.goalBufferLength_ = i.goalBufferLength, t.sourceType_ = i.sourceType, t.inbandTextTracks_ = i.inbandTextTracks, t.state_ = "INIT", t.checkBufferTimeout_ = null, t.error_ = void 0, t.currentTimeline_ = -1, t.pendingSegment_ = null, t.mimeType_ = null, t.sourceUpdater_ = null, t.xhrOptions_ = null, t.activeInitSegmentId_ = null, t.initSegments_ = {}, t.cacheEncryptionKeys_ = i.cacheEncryptionKeys, t.keyCache_ = {}, t.loaderType_ === "main" ? t.captionParser_ = new qk() : t.captionParser_ = null, t.decrypter_ = i.decrypter, t.syncController_ = i.syncController, t.syncPoint_ = {
      segmentIndex: 0,
      time: 0
    }, t.syncController_.on("syncinfoupdate", function() {
      return t.trigger("syncinfoupdate");
    }), t.mediaSource_.addEventListener("sourceopen", function() {
      return t.ended_ = !1;
    }), t.fetchAtBuffer_ = !1, t.logger_ = Od("SegmentLoader[" + t.loaderType_ + "]"), Object.defineProperty(t, "state", {
      get: function() {
        return this.state_;
      },
      set: function(a) {
        a !== this.state_ && (this.logger_(this.state_ + " -> " + a), this.state_ = a);
      }
    }), t;
  }
  return gs(r, [{
    key: "resetStats_",
    value: function() {
      this.mediaBytesTransferred = 0, this.mediaRequests = 0, this.mediaRequestsAborted = 0, this.mediaRequestsTimedout = 0, this.mediaRequestsErrored = 0, this.mediaTransferDuration = 0, this.mediaSecondsLoaded = 0;
    }
  }, {
    key: "dispose",
    value: function() {
      this.state = "DISPOSED", this.pause(), this.abort_(), this.sourceUpdater_ && this.sourceUpdater_.dispose(), this.resetStats_(), this.captionParser_ && this.captionParser_.reset();
    }
  }, {
    key: "abort",
    value: function() {
      if (this.state !== "WAITING") {
        this.pendingSegment_ && (this.pendingSegment_ = null);
        return;
      }
      this.abort_(), this.state = "READY", this.paused() || this.monitorBuffer_();
    }
  }, {
    key: "abort_",
    value: function() {
      this.pendingSegment_ && this.pendingSegment_.abortRequests(), this.pendingSegment_ = null;
    }
  }, {
    key: "error",
    value: function(t) {
      return typeof t < "u" && (this.error_ = t), this.pendingSegment_ = null, this.error_;
    }
  }, {
    key: "endOfStream",
    value: function() {
      this.ended_ = !0, this.pause(), this.trigger("ended");
    }
  }, {
    key: "buffered_",
    value: function() {
      return this.sourceUpdater_ ? this.sourceUpdater_.buffered() : re.createTimeRanges();
    }
  }, {
    key: "initSegment",
    value: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (!t)
        return null;
      var a = th(t), s = this.initSegments_[a];
      return n && !s && t.bytes && (this.initSegments_[a] = s = {
        resolvedUri: t.resolvedUri,
        byterange: t.byterange,
        bytes: t.bytes,
        timescales: t.timescales,
        videoTrackIds: t.videoTrackIds
      }), s || t;
    }
  }, {
    key: "segmentKey",
    value: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (!t)
        return null;
      var a = bE(t), s = this.keyCache_[a];
      this.cacheEncryptionKeys_ && n && !s && t.bytes && (this.keyCache_[a] = s = {
        resolvedUri: t.resolvedUri,
        bytes: t.bytes
      });
      var o = {
        resolvedUri: (s || t).resolvedUri
      };
      return s && (o.bytes = s.bytes), o;
    }
  }, {
    key: "couldBeginLoading_",
    value: function() {
      return this.playlist_ && (this.sourceUpdater_ || this.mimeType_ && this.state === "INIT") && !this.paused();
    }
  }, {
    key: "load",
    value: function() {
      if (this.monitorBuffer_(), !!this.playlist_) {
        if (this.syncController_.setDateTimeMapping(this.playlist_), this.state === "INIT" && this.couldBeginLoading_())
          return this.init_();
        !this.couldBeginLoading_() || this.state !== "READY" && this.state !== "INIT" || (this.state = "READY");
      }
    }
  }, {
    key: "init_",
    value: function() {
      return this.state = "READY", this.sourceUpdater_ = new tO(this.mediaSource_, this.mimeType_, this.loaderType_, this.sourceBufferEmitter_), this.resetEverything(), this.monitorBuffer_();
    }
  }, {
    key: "playlist",
    value: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!!t) {
        var a = this.playlist_, s = this.pendingSegment_;
        this.playlist_ = t, this.xhrOptions_ = n, this.hasPlayed_() || (t.syncInfo = {
          mediaSequence: t.mediaSequence,
          time: 0
        });
        var o = null;
        if (a && (a.id ? o = a.id : a.uri && (o = a.uri)), this.logger_("playlist update [" + o + " => " + (t.id || t.uri) + "]"), this.trigger("syncinfoupdate"), this.state === "INIT" && this.couldBeginLoading_())
          return this.init_();
        if (!a || a.uri !== t.uri) {
          this.mediaIndex !== null && this.resyncLoader();
          return;
        }
        var l = t.mediaSequence - a.mediaSequence;
        this.logger_("live window shift [" + l + "]"), this.mediaIndex !== null && (this.mediaIndex -= l), s && (s.mediaIndex -= l, s.mediaIndex >= 0 && (s.segment = t.segments[s.mediaIndex])), this.syncController_.saveExpiredSegmentInfo(a, t);
      }
    }
  }, {
    key: "pause",
    value: function() {
      this.checkBufferTimeout_ && (Be.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = null);
    }
  }, {
    key: "paused",
    value: function() {
      return this.checkBufferTimeout_ === null;
    }
  }, {
    key: "mimeType",
    value: function(t, n) {
      this.mimeType_ || (this.mimeType_ = t, this.sourceBufferEmitter_ = n, this.state === "INIT" && this.couldBeginLoading_() && this.init_());
    }
  }, {
    key: "resetEverything",
    value: function(t) {
      this.ended_ = !1, this.resetLoader(), this.remove(0, this.duration_(), t), this.captionParser_ && this.captionParser_.clearAllCaptions(), this.trigger("reseteverything");
    }
  }, {
    key: "resetLoader",
    value: function() {
      this.fetchAtBuffer_ = !1, this.resyncLoader();
    }
  }, {
    key: "resyncLoader",
    value: function() {
      this.mediaIndex = null, this.syncPoint_ = null, this.abort();
    }
  }, {
    key: "remove",
    value: function(t, n, a) {
      if (this.sourceUpdater_ && this.sourceUpdater_.remove(t, n, a), Bl(t, n, this.segmentMetadataTrack_), this.inbandTextTracks_)
        for (var s in this.inbandTextTracks_)
          Bl(t, n, this.inbandTextTracks_[s]);
    }
  }, {
    key: "monitorBuffer_",
    value: function() {
      this.checkBufferTimeout_ && Be.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = Be.setTimeout(this.monitorBufferTick_.bind(this), 1);
    }
  }, {
    key: "monitorBufferTick_",
    value: function() {
      this.state === "READY" && this.fillBuffer_(), this.checkBufferTimeout_ && Be.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = Be.setTimeout(this.monitorBufferTick_.bind(this), yO);
    }
  }, {
    key: "fillBuffer_",
    value: function() {
      if (!this.sourceUpdater_.updating()) {
        this.syncPoint_ || (this.syncPoint_ = this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_()));
        var t = this.checkBuffer_(this.buffered_(), this.playlist_, this.mediaIndex, this.hasPlayed_(), this.currentTime_(), this.syncPoint_);
        if (!!t) {
          if (this.isEndOfStream_(t.mediaIndex)) {
            this.endOfStream();
            return;
          }
          t.mediaIndex === this.playlist_.segments.length - 1 && this.mediaSource_.readyState === "ended" && !this.seeking_() || (t.timeline !== this.currentTimeline_ && (this.syncController_.reset(), t.timestampOffset = t.startOfSegment, this.captionParser_ && this.captionParser_.clearAllCaptions()), this.loadSegment_(t));
        }
      }
    }
  }, {
    key: "isEndOfStream_",
    value: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.playlist_;
      return _O(n, this.mediaSource_, t) && !this.sourceUpdater_.updating();
    }
  }, {
    key: "checkBuffer_",
    value: function(t, n, a, s, o, l) {
      var u = 0, h = void 0;
      t.length && (u = t.end(t.length - 1));
      var c = Math.max(0, u - o);
      if (!n.segments.length || c >= this.goalBufferLength_() || !s && c >= 1)
        return null;
      if (l === null)
        return a = this.getSyncSegmentCandidate_(n), this.generateSegmentInfo_(n, a, null, !0);
      if (a !== null)
        return n.segments[a], h = u, this.generateSegmentInfo_(n, a + 1, h, !1);
      if (this.fetchAtBuffer_) {
        var d = ua.getMediaInfoForTime(n, u, l.segmentIndex, l.time);
        a = d.mediaIndex, h = d.startTime;
      } else {
        var f = ua.getMediaInfoForTime(n, o, l.segmentIndex, l.time);
        a = f.mediaIndex, h = f.startTime;
      }
      return this.generateSegmentInfo_(n, a, h, !1);
    }
  }, {
    key: "getSyncSegmentCandidate_",
    value: function(t) {
      var n = this;
      if (this.currentTimeline_ === -1)
        return 0;
      var a = t.segments.map(function(s, o) {
        return {
          timeline: s.timeline,
          segmentIndex: o
        };
      }).filter(function(s) {
        return s.timeline === n.currentTimeline_;
      });
      return a.length ? a[Math.min(a.length - 1, 1)].segmentIndex : Math.max(t.segments.length - 1, 0);
    }
  }, {
    key: "generateSegmentInfo_",
    value: function(t, n, a, s) {
      if (n < 0 || n >= t.segments.length)
        return null;
      var o = t.segments[n];
      return {
        requestId: "segment-loader-" + Math.random(),
        uri: o.resolvedUri,
        mediaIndex: n,
        isSyncRequest: s,
        startOfSegment: a,
        playlist: t,
        bytes: null,
        encryptedBytes: null,
        timestampOffset: null,
        timeline: o.timeline,
        duration: o.duration,
        segment: o
      };
    }
  }, {
    key: "abortRequestEarly_",
    value: function(t) {
      if (this.hls_.tech_.paused() || !this.xhrOptions_.timeout || !this.playlist_.attributes.BANDWIDTH || Date.now() - (t.firstBytesReceivedAt || Date.now()) < 1e3)
        return !1;
      var n = this.currentTime_(), a = t.bandwidth, s = this.pendingSegment_.duration, o = ua.estimateSegmentRequestTime(s, a, this.playlist_, t.bytesReceived), l = OP(this.buffered_(), n, this.hls_.tech_.playbackRate()) - 1;
      if (o <= l)
        return !1;
      var u = pO({
        master: this.hls_.playlists.master,
        currentTime: n,
        bandwidth: a,
        duration: this.duration_(),
        segmentDuration: s,
        timeUntilRebuffer: l,
        currentTimeline: this.currentTimeline_,
        syncController: this.syncController_
      });
      if (!!u) {
        var h = o - l, c = h - u.rebufferingImpact, d = 0.5;
        return l <= Hh && (d = 1), !u.playlist || u.playlist.uri === this.playlist_.uri || c < d ? !1 : (this.bandwidth = u.playlist.attributes.BANDWIDTH * Sa.BANDWIDTH_VARIANCE + 1, this.abort(), this.trigger("earlyabort"), !0);
      }
    }
  }, {
    key: "handleProgress_",
    value: function(t, n) {
      !this.pendingSegment_ || n.requestId !== this.pendingSegment_.requestId || this.abortRequestEarly_(n.stats) || this.trigger("progress");
    }
  }, {
    key: "loadSegment_",
    value: function(t) {
      this.state = "WAITING", this.pendingSegment_ = t, this.trimBackBuffer_(t), t.abortRequests = cO(
        this.hls_.xhr,
        this.xhrOptions_,
        this.decrypter_,
        this.captionParser_,
        this.createSimplifiedSegmentObj_(t),
        this.handleProgress_.bind(this),
        this.segmentRequestFinished_.bind(this)
      );
    }
  }, {
    key: "trimBackBuffer_",
    value: function(t) {
      var n = TO(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10);
      n > 0 && this.remove(0, n);
    }
  }, {
    key: "createSimplifiedSegmentObj_",
    value: function(t) {
      var n = t.segment, a = {
        resolvedUri: n.resolvedUri,
        byterange: n.byterange,
        requestId: t.requestId
      };
      if (n.key) {
        var s = n.key.iv || new Uint32Array([0, 0, 0, t.mediaIndex + t.playlist.mediaSequence]);
        a.key = this.segmentKey(n.key), a.key.iv = s;
      }
      return n.map && (a.map = this.initSegment(n.map)), a;
    }
  }, {
    key: "segmentRequestFinished_",
    value: function(t, n) {
      if (this.mediaRequests += 1, n.stats && (this.mediaBytesTransferred += n.stats.bytesReceived, this.mediaTransferDuration += n.stats.roundTripTime), !this.pendingSegment_) {
        this.mediaRequestsAborted += 1;
        return;
      }
      if (n.requestId === this.pendingSegment_.requestId) {
        if (t) {
          if (this.pendingSegment_ = null, this.state = "READY", t.code === Qo.ABORTED) {
            this.mediaRequestsAborted += 1;
            return;
          }
          if (this.pause(), t.code === Qo.TIMEOUT) {
            this.mediaRequestsTimedout += 1, this.bandwidth = 1, this.roundTrip = NaN, this.trigger("bandwidthupdate");
            return;
          }
          this.mediaRequestsErrored += 1, this.error(t), this.trigger("error");
          return;
        }
        this.bandwidth = n.stats.bandwidth, this.roundTrip = n.stats.roundTripTime, n.map && (n.map = this.initSegment(n.map, !0)), n.key && this.segmentKey(n.key, !0), this.processSegmentResponse_(n);
      }
    }
  }, {
    key: "processSegmentResponse_",
    value: function(t) {
      var n = this.pendingSegment_;
      n.bytes = t.bytes, t.map && (n.segment.map.bytes = t.map.bytes), n.endOfAllRequests = t.endOfAllRequests, t.fmp4Captions && (vO(this.inbandTextTracks_, this.hls_.tech_, t.captionStreams), mO({
        inbandTextTracks: this.inbandTextTracks_,
        captionArray: t.fmp4Captions,
        timestampOffset: 0
      }), this.captionParser_ && this.captionParser_.clearParsedCaptions()), this.handleSegment_();
    }
  }, {
    key: "handleSegment_",
    value: function() {
      var t = this;
      if (!this.pendingSegment_) {
        this.state = "READY";
        return;
      }
      var n = this.pendingSegment_, a = n.segment, s = this.syncController_.probeSegmentInfo(n);
      typeof this.startingMedia_ > "u" && s && (s.containsAudio || s.containsVideo) && (this.startingMedia_ = {
        containsAudio: s.containsAudio,
        containsVideo: s.containsVideo
      });
      var o = bO(this.loaderType_, this.startingMedia_, s);
      if (o) {
        this.error({
          message: o,
          blacklistDuration: 1 / 0
        }), this.trigger("error");
        return;
      }
      if (n.isSyncRequest) {
        this.trigger("syncinfoupdate"), this.pendingSegment_ = null, this.state = "READY";
        return;
      }
      if (n.timestampOffset !== null && n.timestampOffset !== this.sourceUpdater_.timestampOffset()) {
        if (s && s.segmentTimestampInfo) {
          var l = s.segmentTimestampInfo[0].ptsTime, u = s.segmentTimestampInfo[0].dtsTime;
          n.timestampOffset -= l - u;
        }
        this.sourceUpdater_.timestampOffset(n.timestampOffset), this.trigger("timestampoffset");
      }
      var h = this.syncController_.mappingForTimeline(n.timeline);
      if (h !== null && this.trigger({
        type: "segmenttimemapping",
        mapping: h
      }), this.state = "APPENDING", a.map) {
        var c = th(a.map);
        if (!this.activeInitSegmentId_ || this.activeInitSegmentId_ !== c) {
          var d = this.initSegment(a.map);
          this.sourceUpdater_.appendBuffer({
            bytes: d.bytes
          }, function() {
            t.activeInitSegmentId_ = c;
          });
        }
      }
      n.byteLength = n.bytes.byteLength, typeof a.start == "number" && typeof a.end == "number" ? this.mediaSecondsLoaded += a.end - a.start : this.mediaSecondsLoaded += a.duration, this.logger_(SO(n)), this.sourceUpdater_.appendBuffer({
        bytes: n.bytes,
        videoSegmentTimingInfoCallback: this.handleVideoSegmentTimingInfo_.bind(this, n.requestId)
      }, this.handleUpdateEnd_.bind(this));
    }
  }, {
    key: "handleVideoSegmentTimingInfo_",
    value: function(t, n) {
      if (!(!this.pendingSegment_ || t !== this.pendingSegment_.requestId)) {
        var a = this.pendingSegment_.segment;
        a.videoTimingInfo || (a.videoTimingInfo = {}), a.videoTimingInfo.transmuxerPrependedSeconds = n.videoSegmentTimingInfo.prependedContentDuration || 0, a.videoTimingInfo.transmuxedPresentationStart = n.videoSegmentTimingInfo.start.presentation, a.videoTimingInfo.transmuxedPresentationEnd = n.videoSegmentTimingInfo.end.presentation, a.videoTimingInfo.baseMediaDecodeTime = n.videoSegmentTimingInfo.baseMediaDecodeTime;
      }
    }
  }, {
    key: "handleUpdateEnd_",
    value: function() {
      if (!this.pendingSegment_) {
        this.state = "READY", this.paused() || this.monitorBuffer_();
        return;
      }
      var t = this.pendingSegment_, n = t.segment, a = this.mediaIndex !== null;
      if (this.pendingSegment_ = null, this.recordThroughput_(t), this.addSegmentMetadataCue_(t), this.state = "READY", this.mediaIndex = t.mediaIndex, this.fetchAtBuffer_ = !0, this.currentTimeline_ = t.timeline, this.trigger("syncinfoupdate"), n.end && this.currentTime_() - n.end > t.playlist.targetDuration * 3) {
        this.resetEverything();
        return;
      }
      a && this.trigger("bandwidthupdate"), this.trigger("progress"), this.isEndOfStream_(t.mediaIndex + 1, t.playlist) && this.endOfStream(), this.paused() || this.monitorBuffer_();
    }
  }, {
    key: "recordThroughput_",
    value: function(t) {
      var n = this.throughput.rate, a = Date.now() - t.endOfAllRequests + 1, s = Math.floor(t.byteLength / a * 8 * 1e3);
      this.throughput.rate += (s - n) / ++this.throughput.count;
    }
  }, {
    key: "addSegmentMetadataCue_",
    value: function(t) {
      if (!!this.segmentMetadataTrack_) {
        var n = t.segment, a = n.start, s = n.end;
        if (!(!J_(a) || !J_(s))) {
          Bl(a, s, this.segmentMetadataTrack_);
          var o = Be.WebKitDataCue || Be.VTTCue, l = {
            custom: n.custom,
            dateTimeObject: n.dateTimeObject,
            dateTimeString: n.dateTimeString,
            bandwidth: t.playlist.attributes.BANDWIDTH,
            resolution: t.playlist.attributes.RESOLUTION,
            codecs: t.playlist.attributes.CODECS,
            byteLength: t.byteLength,
            uri: t.uri,
            timeline: t.timeline,
            playlist: t.playlist.uri,
            start: a,
            end: s
          }, u = JSON.stringify(l), h = new o(a, s, u);
          h.value = l, this.segmentMetadataTrack_.addCue(h);
        }
      }
    }
  }]), r;
}(re.EventTarget), Q_ = function(r) {
  return decodeURIComponent(escape(String.fromCharCode.apply(null, r)));
}, Z_ = new Uint8Array(`

`.split("").map(function(e) {
  return e.charCodeAt(0);
})), EO = function(e) {
  xo(r, e);
  function r(i) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Wa(this, r);
    var n = js(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, i, t));
    return n.mediaSource_ = null, n.subtitlesTrack_ = null, n;
  }
  return gs(r, [{
    key: "buffered_",
    value: function() {
      if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues.length)
        return re.createTimeRanges();
      var t = this.subtitlesTrack_.cues, n = t[0].startTime, a = t[t.length - 1].startTime;
      return re.createTimeRanges([[n, a]]);
    }
  }, {
    key: "initSegment",
    value: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (!t)
        return null;
      var a = th(t), s = this.initSegments_[a];
      if (n && !s && t.bytes) {
        var o = Z_.byteLength + t.bytes.byteLength, l = new Uint8Array(o);
        l.set(t.bytes), l.set(Z_, t.bytes.byteLength), this.initSegments_[a] = s = {
          resolvedUri: t.resolvedUri,
          byterange: t.byterange,
          bytes: l
        };
      }
      return s || t;
    }
  }, {
    key: "couldBeginLoading_",
    value: function() {
      return this.playlist_ && this.subtitlesTrack_ && !this.paused();
    }
  }, {
    key: "init_",
    value: function() {
      return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
    }
  }, {
    key: "track",
    value: function(t) {
      return typeof t > "u" ? this.subtitlesTrack_ : (this.subtitlesTrack_ = t, this.state === "INIT" && this.couldBeginLoading_() && this.init_(), this.subtitlesTrack_);
    }
  }, {
    key: "remove",
    value: function(t, n) {
      Bl(t, n, this.subtitlesTrack_);
    }
  }, {
    key: "fillBuffer_",
    value: function() {
      var t = this;
      this.syncPoint_ || (this.syncPoint_ = this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_()));
      var n = this.checkBuffer_(this.buffered_(), this.playlist_, this.mediaIndex, this.hasPlayed_(), this.currentTime_(), this.syncPoint_);
      if (n = this.skipEmptySegments_(n), !!n) {
        if (this.syncController_.timestampOffsetForTimeline(n.timeline) === null) {
          var a = function() {
            t.state = "READY", t.paused() || t.monitorBuffer_();
          };
          this.syncController_.one("timestampoffset", a), this.state = "WAITING_ON_TIMELINE";
          return;
        }
        this.loadSegment_(n);
      }
    }
  }, {
    key: "skipEmptySegments_",
    value: function(t) {
      for (; t && t.segment.empty; )
        t = this.generateSegmentInfo_(t.playlist, t.mediaIndex + 1, t.startOfSegment + t.duration, t.isSyncRequest);
      return t;
    }
  }, {
    key: "handleSegment_",
    value: function() {
      var t = this;
      if (!this.pendingSegment_ || !this.subtitlesTrack_) {
        this.state = "READY";
        return;
      }
      this.state = "APPENDING";
      var n = this.pendingSegment_, a = n.segment;
      if (typeof Be.WebVTT != "function" && this.subtitlesTrack_ && this.subtitlesTrack_.tech_) {
        var s = void 0, o = function() {
          t.subtitlesTrack_.tech_.off("vttjsloaded", s), t.error({
            message: "Error loading vtt.js"
          }), t.state = "READY", t.pause(), t.trigger("error");
        };
        s = function() {
          t.subtitlesTrack_.tech_.off("vttjserror", o), t.handleSegment_();
        }, this.state = "WAITING_ON_VTTJS", this.subtitlesTrack_.tech_.one("vttjsloaded", s), this.subtitlesTrack_.tech_.one("vttjserror", o);
        return;
      }
      a.requested = !0;
      try {
        this.parseVTTCues_(n);
      } catch (l) {
        return this.error({
          message: l.message
        }), this.state = "READY", this.pause(), this.trigger("error");
      }
      if (this.updateTimeMapping_(n, this.syncController_.timelines[n.timeline], this.playlist_), n.isSyncRequest) {
        this.trigger("syncinfoupdate"), this.pendingSegment_ = null, this.state = "READY";
        return;
      }
      n.byteLength = n.bytes.byteLength, this.mediaSecondsLoaded += a.duration, n.cues.length && this.remove(n.cues[0].endTime, n.cues[n.cues.length - 1].endTime), n.cues.forEach(function(l) {
        t.subtitlesTrack_.addCue(l);
      }), this.handleUpdateEnd_();
    }
  }, {
    key: "parseVTTCues_",
    value: function(t) {
      var n = void 0, a = !1;
      typeof Be.TextDecoder == "function" ? n = new Be.TextDecoder("utf8") : (n = Be.WebVTT.StringDecoder(), a = !0);
      var s = new Be.WebVTT.Parser(Be, Be.vttjs, n);
      if (t.cues = [], t.timestampmap = {
        MPEGTS: 0,
        LOCAL: 0
      }, s.oncue = t.cues.push.bind(t.cues), s.ontimestampmap = function(u) {
        return t.timestampmap = u;
      }, s.onparsingerror = function(u) {
        re.log.warn("Error encountered when parsing cues: " + u.message);
      }, t.segment.map) {
        var o = t.segment.map.bytes;
        a && (o = Q_(o)), s.parse(o);
      }
      var l = t.bytes;
      a && (l = Q_(l)), s.parse(l), s.flush();
    }
  }, {
    key: "updateTimeMapping_",
    value: function(t, n, a) {
      var s = t.segment;
      if (!!n) {
        if (!t.cues.length) {
          s.empty = !0;
          return;
        }
        var o = t.timestampmap, l = o.MPEGTS / 9e4 - o.LOCAL + n.mapping;
        if (t.cues.forEach(function(c) {
          c.startTime += l, c.endTime += l;
        }), !a.syncInfo) {
          var u = t.cues[0].startTime, h = t.cues[t.cues.length - 1].startTime;
          a.syncInfo = {
            mediaSequence: a.mediaSequence + t.mediaIndex,
            time: Math.min(u, h - s.duration)
          };
        }
      }
    }
  }]), r;
}(Jg), xO = function(r, i) {
  for (var t = r.cues, n = 0; n < t.length; n++) {
    var a = t[n];
    if (i >= a.adStartTime && i <= a.adEndTime)
      return a;
  }
  return null;
}, AO = function(r, i) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
  if (!!r.segments)
    for (var n = t, a = void 0, s = 0; s < r.segments.length; s++) {
      var o = r.segments[s];
      if (a || (a = xO(i, n + o.duration / 2)), a) {
        if ("cueIn" in o) {
          a.endTime = n, a.adEndTime = n, n += o.duration, a = null;
          continue;
        }
        if (n < a.endTime) {
          n += o.duration;
          continue;
        }
        a.endTime += o.duration;
      } else if ("cueOut" in o && (a = new Be.VTTCue(n, n + o.duration, o.cueOut), a.adStartTime = n, a.adEndTime = n + parseFloat(o.cueOut), i.addCue(a)), "cueOutCont" in o) {
        var l = void 0, u = void 0, h = o.cueOutCont.split("/").map(parseFloat), c = Z2(h, 2);
        l = c[0], u = c[1], a = new Be.VTTCue(n, n + o.duration, ""), a.adStartTime = n - l, a.adEndTime = a.adStartTime + u, i.addCue(a);
      }
      n += o.duration;
    }
}, wO = _R.inspect, eb = [
  {
    name: "VOD",
    run: function(r, i, t, n, a) {
      if (t !== 1 / 0) {
        var s = {
          time: 0,
          segmentIndex: 0
        };
        return s;
      }
      return null;
    }
  },
  {
    name: "ProgramDateTime",
    run: function(r, i, t, n, a) {
      if (!r.datetimeToDisplayTime)
        return null;
      var s = i.segments || [], o = null, l = null;
      a = a || 0;
      for (var u = 0; u < s.length; u++) {
        var h = s[u];
        if (h.dateTimeObject) {
          var c = h.dateTimeObject.getTime() / 1e3, d = c + r.datetimeToDisplayTime, f = Math.abs(a - d);
          if (l !== null && (f === 0 || l < f))
            break;
          l = f, o = {
            time: d,
            segmentIndex: u
          };
        }
      }
      return o;
    }
  },
  {
    name: "Segment",
    run: function(r, i, t, n, a) {
      var s = i.segments || [], o = null, l = null;
      a = a || 0;
      for (var u = 0; u < s.length; u++) {
        var h = s[u];
        if (h.timeline === n && typeof h.start < "u") {
          var c = Math.abs(a - h.start);
          if (l !== null && l < c)
            break;
          (!o || l === null || l >= c) && (l = c, o = {
            time: h.start,
            segmentIndex: u
          });
        }
      }
      return o;
    }
  },
  {
    name: "Discontinuity",
    run: function(r, i, t, n, a) {
      var s = null;
      if (a = a || 0, i.discontinuityStarts && i.discontinuityStarts.length)
        for (var o = null, l = 0; l < i.discontinuityStarts.length; l++) {
          var u = i.discontinuityStarts[l], h = i.discontinuitySequence + l + 1, c = r.discontinuities[h];
          if (c) {
            var d = Math.abs(a - c.time);
            if (o !== null && o < d)
              break;
            (!s || o === null || o >= d) && (o = d, s = {
              time: c.time,
              segmentIndex: u
            });
          }
        }
      return s;
    }
  },
  {
    name: "Playlist",
    run: function(r, i, t, n, a) {
      if (i.syncInfo) {
        var s = {
          time: i.syncInfo.time,
          segmentIndex: i.syncInfo.mediaSequence - i.mediaSequence
        };
        return s;
      }
      return null;
    }
  }
], CO = function(e) {
  xo(r, e);
  function r() {
    Wa(this, r);
    var i = js(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this));
    return i.inspectCache_ = void 0, i.timelines = [], i.discontinuities = [], i.datetimeToDisplayTime = null, i.logger_ = Od("SyncController"), i;
  }
  return gs(r, [{
    key: "getSyncPoint",
    value: function(t, n, a, s) {
      var o = this.runStrategies_(t, n, a, s);
      return o.length ? this.selectSyncPoint_(o, {
        key: "time",
        value: s
      }) : null;
    }
  }, {
    key: "getExpiredTime",
    value: function(t, n) {
      if (!t || !t.segments)
        return null;
      var a = this.runStrategies_(t, n, t.discontinuitySequence, 0);
      if (!a.length)
        return null;
      var s = this.selectSyncPoint_(a, {
        key: "segmentIndex",
        value: 0
      });
      return s.segmentIndex > 0 && (s.time *= -1), Math.abs(s.time + Jc(t, s.segmentIndex, 0));
    }
  }, {
    key: "runStrategies_",
    value: function(t, n, a, s) {
      for (var o = [], l = 0; l < eb.length; l++) {
        var u = eb[l], h = u.run(this, t, n, a, s);
        h && (h.strategy = u.name, o.push({
          strategy: u.name,
          syncPoint: h
        }));
      }
      return o;
    }
  }, {
    key: "selectSyncPoint_",
    value: function(t, n) {
      for (var a = t[0].syncPoint, s = Math.abs(t[0].syncPoint[n.key] - n.value), o = t[0].strategy, l = 1; l < t.length; l++) {
        var u = Math.abs(t[l].syncPoint[n.key] - n.value);
        u < s && (s = u, a = t[l].syncPoint, o = t[l].strategy);
      }
      return this.logger_("syncPoint for [" + n.key + ": " + n.value + "] chosen with strategy" + (" [" + o + "]: [time:" + a.time + ",") + (" segmentIndex:" + a.segmentIndex + "]")), a;
    }
  }, {
    key: "saveExpiredSegmentInfo",
    value: function(t, n) {
      for (var a = n.mediaSequence - t.mediaSequence, s = a - 1; s >= 0; s--) {
        var o = t.segments[s];
        if (o && typeof o.start < "u") {
          n.syncInfo = {
            mediaSequence: t.mediaSequence + s,
            time: o.start
          }, this.logger_("playlist refresh sync: [time:" + n.syncInfo.time + "," + (" mediaSequence: " + n.syncInfo.mediaSequence + "]")), this.trigger("syncinfoupdate");
          break;
        }
      }
    }
  }, {
    key: "setDateTimeMapping",
    value: function(t) {
      if (!this.datetimeToDisplayTime && t.segments && t.segments.length && t.segments[0].dateTimeObject) {
        var n = t.segments[0].dateTimeObject.getTime() / 1e3;
        this.datetimeToDisplayTime = -n;
      }
    }
  }, {
    key: "reset",
    value: function() {
      this.inspectCache_ = void 0;
    }
  }, {
    key: "probeSegmentInfo",
    value: function(t) {
      var n = t.segment, a = t.playlist, s = void 0;
      return n.map ? s = this.probeMp4Segment_(t) : s = this.probeTsSegment_(t), s && this.calculateSegmentTimeMapping_(t, s) && (this.saveDiscontinuitySyncInfo_(t), a.syncInfo || (a.syncInfo = {
        mediaSequence: a.mediaSequence + t.mediaIndex,
        time: n.start
      })), s;
    }
  }, {
    key: "probeMp4Segment_",
    value: function(t) {
      var n = t.segment, a = Vf.timescale(n.map.bytes), s = Vf.startTime(a, t.bytes);
      return t.timestampOffset !== null && (t.timestampOffset -= s), {
        start: s,
        end: s + n.duration
      };
    }
  }, {
    key: "probeTsSegment_",
    value: function(t) {
      var n = wO(t.bytes, this.inspectCache_), a = void 0, s = void 0, o = void 0;
      if (!n)
        return null;
      n.video && n.video.length === 2 ? (this.inspectCache_ = n.video[1].dts, a = n.video[0].dtsTime, s = n.video[1].dtsTime, o = n.video) : n.audio && n.audio.length === 2 && (this.inspectCache_ = n.audio[1].dts, a = n.audio[0].dtsTime, s = n.audio[1].dtsTime, o = n.audio);
      var l = {
        segmentTimestampInfo: o,
        start: a,
        end: s,
        containsVideo: n.video && n.video.length === 2,
        containsAudio: n.audio && n.audio.length === 2
      };
      return l;
    }
  }, {
    key: "timestampOffsetForTimeline",
    value: function(t) {
      return typeof this.timelines[t] > "u" ? null : this.timelines[t].time;
    }
  }, {
    key: "mappingForTimeline",
    value: function(t) {
      return typeof this.timelines[t] > "u" ? null : this.timelines[t].mapping;
    }
  }, {
    key: "calculateSegmentTimeMapping_",
    value: function(t, n) {
      var a = t.segment, s = this.timelines[t.timeline];
      if (t.timestampOffset !== null)
        s = {
          time: t.startOfSegment,
          mapping: t.startOfSegment - n.start
        }, this.timelines[t.timeline] = s, this.trigger("timestampoffset"), this.logger_("time mapping for timeline " + t.timeline + ": " + ("[time: " + s.time + "] [mapping: " + s.mapping + "]")), a.start = t.startOfSegment, a.end = n.end + s.mapping;
      else if (s)
        a.start = n.start + s.mapping, a.end = n.end + s.mapping;
      else
        return !1;
      return !0;
    }
  }, {
    key: "saveDiscontinuitySyncInfo_",
    value: function(t) {
      var n = t.playlist, a = t.segment;
      if (a.discontinuity)
        this.discontinuities[a.timeline] = {
          time: a.start,
          accuracy: 0
        };
      else if (n.discontinuityStarts && n.discontinuityStarts.length)
        for (var s = 0; s < n.discontinuityStarts.length; s++) {
          var o = n.discontinuityStarts[s], l = n.discontinuitySequence + s + 1, u = o - t.mediaIndex, h = Math.abs(u);
          if (!this.discontinuities[l] || this.discontinuities[l].accuracy > h) {
            var c = void 0;
            u < 0 ? c = a.start - Jc(n, t.mediaIndex, o) : c = a.end + Jc(n, t.mediaIndex + 1, o), this.discontinuities[l] = {
              time: c,
              accuracy: h
            };
          }
        }
    }
  }]), r;
}(re.EventTarget), DO = new wE("./decrypter-worker.worker.js", function(e, r) {
  var i = this;
  (function() {
    function t(g) {
      return g.subarray(0, g.byteLength - g[g.byteLength - 1]);
    }
    var n = function(E, x) {
      if (!(E instanceof x))
        throw new TypeError("Cannot call a class as a function");
    }, a = function() {
      function g(E, x) {
        for (var w = 0; w < x.length; w++) {
          var S = x[w];
          S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(E, S.key, S);
        }
      }
      return function(E, x, w) {
        return x && g(E.prototype, x), w && g(E, w), E;
      };
    }(), s = function(E, x) {
      if (typeof x != "function" && x !== null)
        throw new TypeError("Super expression must either be null or a function, not " + typeof x);
      E.prototype = Object.create(x && x.prototype, {
        constructor: {
          value: E,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), x && (Object.setPrototypeOf ? Object.setPrototypeOf(E, x) : E.__proto__ = x);
    }, o = function(E, x) {
      if (!E)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return x && (typeof x == "object" || typeof x == "function") ? x : E;
    }, l = function() {
      var E = [[[], [], [], [], []], [[], [], [], [], []]], x = E[0], w = E[1], S = x[4], T = w[4], C = void 0, D = void 0, R = void 0, P = [], N = [], $ = void 0, O = void 0, M = void 0, F = void 0, G = void 0, K = void 0;
      for (C = 0; C < 256; C++)
        N[(P[C] = C << 1 ^ (C >> 7) * 283) ^ C] = C;
      for (D = R = 0; !S[D]; D ^= $ || 1, R = N[R] || 1)
        for (F = R ^ R << 1 ^ R << 2 ^ R << 3 ^ R << 4, F = F >> 8 ^ F & 255 ^ 99, S[D] = F, T[F] = D, M = P[O = P[$ = P[D]]], K = M * 16843009 ^ O * 65537 ^ $ * 257 ^ D * 16843008, G = P[F] * 257 ^ F * 16843008, C = 0; C < 4; C++)
          x[C][D] = G = G << 24 ^ G >>> 8, w[C][F] = K = K << 24 ^ K >>> 8;
      for (C = 0; C < 5; C++)
        x[C] = x[C].slice(0), w[C] = w[C].slice(0);
      return E;
    }, u = null, h = function() {
      function g(E) {
        n(this, g), u || (u = l()), this._tables = [[u[0][0].slice(), u[0][1].slice(), u[0][2].slice(), u[0][3].slice(), u[0][4].slice()], [u[1][0].slice(), u[1][1].slice(), u[1][2].slice(), u[1][3].slice(), u[1][4].slice()]];
        var x = void 0, w = void 0, S = void 0, T = void 0, C = void 0, D = this._tables[0][4], R = this._tables[1], P = E.length, N = 1;
        if (P !== 4 && P !== 6 && P !== 8)
          throw new Error("Invalid aes key size");
        for (T = E.slice(0), C = [], this._key = [T, C], x = P; x < 4 * P + 28; x++)
          S = T[x - 1], (x % P === 0 || P === 8 && x % P === 4) && (S = D[S >>> 24] << 24 ^ D[S >> 16 & 255] << 16 ^ D[S >> 8 & 255] << 8 ^ D[S & 255], x % P === 0 && (S = S << 8 ^ S >>> 24 ^ N << 24, N = N << 1 ^ (N >> 7) * 283)), T[x] = T[x - P] ^ S;
        for (w = 0; x; w++, x--)
          S = T[w & 3 ? x : x - 4], x <= 4 || w < 4 ? C[w] = S : C[w] = R[0][D[S >>> 24]] ^ R[1][D[S >> 16 & 255]] ^ R[2][D[S >> 8 & 255]] ^ R[3][D[S & 255]];
      }
      return g.prototype.decrypt = function(x, w, S, T, C, D) {
        var R = this._key[1], P = x ^ R[0], N = T ^ R[1], $ = S ^ R[2], O = w ^ R[3], M = void 0, F = void 0, G = void 0, K = R.length / 4 - 2, J = void 0, ue = 4, ce = this._tables[1], ee = ce[0], me = ce[1], Ce = ce[2], Ne = ce[3], ot = ce[4];
        for (J = 0; J < K; J++)
          M = ee[P >>> 24] ^ me[N >> 16 & 255] ^ Ce[$ >> 8 & 255] ^ Ne[O & 255] ^ R[ue], F = ee[N >>> 24] ^ me[$ >> 16 & 255] ^ Ce[O >> 8 & 255] ^ Ne[P & 255] ^ R[ue + 1], G = ee[$ >>> 24] ^ me[O >> 16 & 255] ^ Ce[P >> 8 & 255] ^ Ne[N & 255] ^ R[ue + 2], O = ee[O >>> 24] ^ me[P >> 16 & 255] ^ Ce[N >> 8 & 255] ^ Ne[$ & 255] ^ R[ue + 3], ue += 4, P = M, N = F, $ = G;
        for (J = 0; J < 4; J++)
          C[(3 & -J) + D] = ot[P >>> 24] << 24 ^ ot[N >> 16 & 255] << 16 ^ ot[$ >> 8 & 255] << 8 ^ ot[O & 255] ^ R[ue++], M = P, P = N, N = $, $ = O, O = M;
      }, g;
    }(), c = function() {
      function g() {
        n(this, g), this.listeners = {};
      }
      return g.prototype.on = function(x, w) {
        this.listeners[x] || (this.listeners[x] = []), this.listeners[x].push(w);
      }, g.prototype.off = function(x, w) {
        if (!this.listeners[x])
          return !1;
        var S = this.listeners[x].indexOf(w);
        return this.listeners[x].splice(S, 1), S > -1;
      }, g.prototype.trigger = function(x) {
        var w = this.listeners[x];
        if (!!w)
          if (arguments.length === 2)
            for (var S = w.length, T = 0; T < S; ++T)
              w[T].call(this, arguments[1]);
          else
            for (var C = Array.prototype.slice.call(arguments, 1), D = w.length, R = 0; R < D; ++R)
              w[R].apply(this, C);
      }, g.prototype.dispose = function() {
        this.listeners = {};
      }, g.prototype.pipe = function(x) {
        this.on("data", function(w) {
          x.push(w);
        });
      }, g;
    }(), d = function(g) {
      s(E, g);
      function E() {
        n(this, E);
        var x = o(this, g.call(this, c));
        return x.jobs = [], x.delay = 1, x.timeout_ = null, x;
      }
      return E.prototype.processJob_ = function() {
        this.jobs.shift()(), this.jobs.length ? this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay) : this.timeout_ = null;
      }, E.prototype.push = function(w) {
        this.jobs.push(w), this.timeout_ || (this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay));
      }, E;
    }(c), f = function(E) {
      return E << 24 | (E & 65280) << 8 | (E & 16711680) >> 8 | E >>> 24;
    }, m = function(E, x, w) {
      var S = new Int32Array(E.buffer, E.byteOffset, E.byteLength >> 2), T = new h(Array.prototype.slice.call(x)), C = new Uint8Array(E.byteLength), D = new Int32Array(C.buffer), R = void 0, P = void 0, N = void 0, $ = void 0, O = void 0, M = void 0, F = void 0, G = void 0, K = void 0;
      for (R = w[0], P = w[1], N = w[2], $ = w[3], K = 0; K < S.length; K += 4)
        O = f(S[K]), M = f(S[K + 1]), F = f(S[K + 2]), G = f(S[K + 3]), T.decrypt(O, M, F, G, D, K), D[K] = f(D[K] ^ R), D[K + 1] = f(D[K + 1] ^ P), D[K + 2] = f(D[K + 2] ^ N), D[K + 3] = f(D[K + 3] ^ $), R = O, P = M, N = F, $ = G;
      return C;
    }, p = function() {
      function g(E, x, w, S) {
        n(this, g);
        var T = g.STEP, C = new Int32Array(E.buffer), D = new Uint8Array(E.byteLength), R = 0;
        for (this.asyncStream_ = new d(), this.asyncStream_.push(this.decryptChunk_(C.subarray(R, R + T), x, w, D)), R = T; R < C.length; R += T)
          w = new Uint32Array([f(C[R - 4]), f(C[R - 3]), f(C[R - 2]), f(C[R - 1])]), this.asyncStream_.push(this.decryptChunk_(C.subarray(R, R + T), x, w, D));
        this.asyncStream_.push(function() {
          S(null, t(D));
        });
      }
      return g.prototype.decryptChunk_ = function(x, w, S, T) {
        return function() {
          var C = m(x, w, S);
          T.set(C, x.byteOffset);
        };
      }, a(g, null, [{
        key: "STEP",
        get: function() {
          return 32e3;
        }
      }]), g;
    }(), b = function(E) {
      var x = {};
      return Object.keys(E).forEach(function(w) {
        var S = E[w];
        ArrayBuffer.isView(S) ? x[w] = {
          bytes: S.buffer,
          byteOffset: S.byteOffset,
          byteLength: S.byteLength
        } : x[w] = S;
      }), x;
    }, y = function(E) {
      E.onmessage = function(x) {
        var w = x.data, S = new Uint8Array(w.encrypted.bytes, w.encrypted.byteOffset, w.encrypted.byteLength), T = new Uint32Array(w.key.bytes, w.key.byteOffset, w.key.byteLength / 4), C = new Uint32Array(w.iv.bytes, w.iv.byteOffset, w.iv.byteLength / 4);
        new p(S, T, C, function(D, R) {
          E.postMessage(b({
            source: w.source,
            decrypted: R
          }), [R.buffer]);
        });
      };
    }, v = new y(i);
    return v;
  })();
}), kO = function(r) {
  var i = r.default ? "main" : "alternative";
  return r.characteristics && r.characteristics.indexOf("public.accessibility.describes-video") >= 0 && (i = "main-desc"), i;
}, rh = function(r, i) {
  r.abort(), r.pause(), i && i.activePlaylistLoader && (i.activePlaylistLoader.pause(), i.activePlaylistLoader = null);
}, Qg = function(r, i) {
  i.activePlaylistLoader = r, r.load();
}, RO = function(r, i) {
  return function() {
    var t = i.segmentLoaders, n = t[r], a = t.main, s = i.mediaTypes[r], o = s.activeTrack(), l = s.activeGroup(o), u = s.activePlaylistLoader;
    if (rh(n, s), !!l) {
      if (!l.playlistLoader) {
        u && a.resetEverything();
        return;
      }
      n.resyncLoader(), Qg(l.playlistLoader, s);
    }
  };
}, PO = function(r, i) {
  return function() {
    var t = i.segmentLoaders, n = t[r], a = t.main, s = i.mediaTypes[r], o = s.activeTrack(), l = s.activeGroup(o), u = s.activePlaylistLoader;
    if (rh(n, s), !!l) {
      if (!l.playlistLoader) {
        a.resetEverything();
        return;
      }
      if (u === l.playlistLoader) {
        Qg(l.playlistLoader, s);
        return;
      }
      n.track && n.track(o), n.resetEverything(), Qg(l.playlistLoader, s);
    }
  };
}, ih = {
  AUDIO: function(r, i) {
    return function() {
      var t = i.segmentLoaders[r], n = i.mediaTypes[r], a = i.blacklistCurrentPlaylist;
      rh(t, n);
      var s = n.activeTrack(), o = n.activeGroup(), l = (o.filter(function(c) {
        return c.default;
      })[0] || o[0]).id, u = n.tracks[l];
      if (s === u) {
        a({
          message: "Problem encountered loading the default audio track."
        });
        return;
      }
      re.log.warn("Problem encountered loading the alternate audio track.Switching back to default.");
      for (var h in n.tracks)
        n.tracks[h].enabled = n.tracks[h] === u;
      n.onTrackChanged();
    };
  },
  SUBTITLES: function(r, i) {
    return function() {
      var t = i.segmentLoaders[r], n = i.mediaTypes[r];
      re.log.warn("Problem encountered loading the subtitle track.Disabling subtitle track."), rh(t, n);
      var a = n.activeTrack();
      a && (a.mode = "disabled"), n.onTrackChanged();
    };
  }
}, tb = {
  AUDIO: function(r, i, t) {
    if (!!i) {
      var n = t.tech, a = t.requestOptions, s = t.segmentLoaders[r];
      i.on("loadedmetadata", function() {
        var o = i.media();
        s.playlist(o, a), (!n.paused() || o.endList && n.preload() !== "none") && s.load();
      }), i.on("loadedplaylist", function() {
        s.playlist(i.media(), a), n.paused() || s.load();
      }), i.on("error", ih[r](r, t));
    }
  },
  SUBTITLES: function(r, i, t) {
    var n = t.tech, a = t.requestOptions, s = t.segmentLoaders[r], o = t.mediaTypes[r];
    i.on("loadedmetadata", function() {
      var l = i.media();
      s.playlist(l, a), s.track(o.activeTrack()), (!n.paused() || l.endList && n.preload() !== "none") && s.load();
    }), i.on("loadedplaylist", function() {
      s.playlist(i.media(), a), n.paused() || s.load();
    }), i.on("error", ih[r](r, t));
  }
}, OO = {
  AUDIO: function(r, i) {
    var t = i.hls, n = i.sourceType, a = i.segmentLoaders[r], s = i.requestOptions, o = i.master.mediaGroups, l = i.mediaTypes[r], u = l.groups, h = l.tracks, c = i.masterPlaylistLoader;
    (!o[r] || Object.keys(o[r]).length === 0) && (o[r] = {
      main: {
        default: {
          default: !0
        }
      }
    });
    for (var d in o[r]) {
      u[d] || (u[d] = []);
      for (var f in o[r][d]) {
        var m = o[r][d][f], p = void 0;
        if (m.resolvedUri ? p = new eh(m.resolvedUri, t, s) : m.playlists && n === "dash" ? p = new Xg(m.playlists[0], t, s, c) : p = null, m = re.mergeOptions({
          id: f,
          playlistLoader: p
        }, m), tb[r](r, m.playlistLoader, i), u[d].push(m), typeof h[f] > "u") {
          var b = new re.AudioTrack({
            id: f,
            kind: kO(m),
            enabled: !1,
            language: m.language,
            default: m.default,
            label: f
          });
          h[f] = b;
        }
      }
    }
    a.on("error", ih[r](r, i));
  },
  SUBTITLES: function(r, i) {
    var t = i.tech, n = i.hls, a = i.sourceType, s = i.segmentLoaders[r], o = i.requestOptions, l = i.master.mediaGroups, u = i.mediaTypes[r], h = u.groups, c = u.tracks, d = i.masterPlaylistLoader;
    for (var f in l[r]) {
      h[f] || (h[f] = []);
      for (var m in l[r][f])
        if (!l[r][f][m].forced) {
          var p = l[r][f][m], b = void 0;
          if (a === "hls" ? b = new eh(p.resolvedUri, n, o) : a === "dash" && (b = new Xg(p.playlists[0], n, o, d)), p = re.mergeOptions({
            id: m,
            playlistLoader: b
          }, p), tb[r](r, p.playlistLoader, i), h[f].push(p), typeof c[m] > "u") {
            var y = t.addRemoteTextTrack({
              id: m,
              kind: "subtitles",
              default: p.default && p.autoselect,
              language: p.language,
              label: m
            }, !1).track;
            c[m] = y;
          }
        }
    }
    s.on("error", ih[r](r, i));
  },
  "CLOSED-CAPTIONS": function(r, i) {
    var t = i.tech, n = i.master.mediaGroups, a = i.mediaTypes[r], s = a.groups, o = a.tracks;
    for (var l in n[r]) {
      s[l] || (s[l] = []);
      for (var u in n[r][l]) {
        var h = n[r][l][u];
        if (!!h.instreamId.match(/CC\d/) && (s[l].push(re.mergeOptions({
          id: u
        }, h)), typeof o[u] > "u")) {
          var c = t.addRemoteTextTrack({
            id: h.instreamId,
            kind: "captions",
            default: h.default && h.autoselect,
            language: h.language,
            label: u
          }, !1).track;
          o[u] = c;
        }
      }
    }
  }
}, LO = function(r, i) {
  return function(t) {
    var n = i.masterPlaylistLoader, a = i.mediaTypes[r].groups, s = n.media();
    if (!s)
      return null;
    var o = null;
    return s.attributes[r] && (o = a[s.attributes[r]]), o = o || a.main, typeof t > "u" ? o : t === null ? null : o.filter(function(l) {
      return l.id === t.id;
    })[0] || null;
  };
}, IO = {
  AUDIO: function(r, i) {
    return function() {
      var t = i.mediaTypes[r].tracks;
      for (var n in t)
        if (t[n].enabled)
          return t[n];
      return null;
    };
  },
  SUBTITLES: function(r, i) {
    return function() {
      var t = i.mediaTypes[r].tracks;
      for (var n in t)
        if (t[n].mode === "showing")
          return t[n];
      return null;
    };
  }
}, MO = function(r) {
  ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach(function(h) {
    OO[h](h, r);
  });
  var i = r.mediaTypes, t = r.masterPlaylistLoader, n = r.tech, a = r.hls;
  ["AUDIO", "SUBTITLES"].forEach(function(h) {
    i[h].activeGroup = LO(h, r), i[h].activeTrack = IO[h](h, r), i[h].onGroupChanged = RO(h, r), i[h].onTrackChanged = PO(h, r);
  });
  var s = i.AUDIO.activeGroup(), o = (s.filter(function(h) {
    return h.default;
  })[0] || s[0]).id;
  i.AUDIO.tracks[o].enabled = !0, i.AUDIO.onTrackChanged(), t.on("mediachange", function() {
    ["AUDIO", "SUBTITLES"].forEach(function(h) {
      return i[h].onGroupChanged();
    });
  });
  var l = function() {
    i.AUDIO.onTrackChanged(), n.trigger({
      type: "usage",
      name: "hls-audio-change"
    });
  };
  n.audioTracks().addEventListener("change", l), n.remoteTextTracks().addEventListener("change", i.SUBTITLES.onTrackChanged), a.on("dispose", function() {
    n.audioTracks().removeEventListener("change", l), n.remoteTextTracks().removeEventListener("change", i.SUBTITLES.onTrackChanged);
  }), n.clearTracks("audio");
  for (var u in i.AUDIO.tracks)
    n.audioTracks().addTrack(i.AUDIO.tracks[u]);
}, NO = function() {
  var r = {};
  return ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach(function(i) {
    r[i] = {
      groups: {},
      tracks: {},
      activePlaylistLoader: null,
      activeGroup: Ol,
      activeTrack: Ol,
      onGroupChanged: Ol,
      onTrackChanged: Ol
    };
  }), r;
}, FO = 60 * 2, Vo = void 0, UO = ["mediaRequests", "mediaRequestsAborted", "mediaRequestsTimedout", "mediaRequestsErrored", "mediaTransferDuration", "mediaBytesTransferred"], BO = function(r) {
  return this.audioSegmentLoader_[r] + this.mainSegmentLoader_[r];
}, jO = function(e) {
  xo(r, e);
  function r(i) {
    Wa(this, r);
    var t = js(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this)), n = i.url, a = i.handleManifestRedirects, s = i.withCredentials, o = i.tech, l = i.bandwidth, u = i.externHls, h = i.useCueTags, c = i.blacklistDuration, d = i.enableLowInitialPlaylist, f = i.sourceType, m = i.seekTo, p = i.cacheEncryptionKeys;
    if (!n)
      throw new Error("A non-empty playlist URL is required");
    Vo = u, t.withCredentials = s, t.tech_ = o, t.hls_ = o.hls, t.seekTo_ = m, t.sourceType_ = f, t.useCueTags_ = h, t.blacklistDuration = c, t.enableLowInitialPlaylist = d, t.useCueTags_ && (t.cueTagsTrack_ = t.tech_.addTextTrack("metadata", "ad-cues"), t.cueTagsTrack_.inBandMetadataTrackDispatchType = ""), t.requestOptions_ = {
      withCredentials: s,
      handleManifestRedirects: a,
      timeout: null
    }, t.mediaTypes_ = NO(), t.mediaSource = new re.MediaSource(), t.mediaSource.addEventListener("sourceopen", t.handleSourceOpen_.bind(t)), t.seekable_ = re.createTimeRanges(), t.hasPlayed_ = function() {
      return !1;
    }, t.syncController_ = new CO(i), t.segmentMetadataTrack_ = o.addRemoteTextTrack({
      kind: "metadata",
      label: "segment-metadata"
    }, !1).track, t.decrypter_ = new DO(), t.inbandTextTracks_ = {};
    var b = {
      hls: t.hls_,
      mediaSource: t.mediaSource,
      currentTime: t.tech_.currentTime.bind(t.tech_),
      seekable: function() {
        return t.seekable();
      },
      seeking: function() {
        return t.tech_.seeking();
      },
      duration: function() {
        return t.mediaSource.duration;
      },
      hasPlayed: function() {
        return t.hasPlayed_();
      },
      goalBufferLength: function() {
        return t.goalBufferLength();
      },
      bandwidth: l,
      syncController: t.syncController_,
      decrypter: t.decrypter_,
      sourceType: t.sourceType_,
      inbandTextTracks: t.inbandTextTracks_,
      cacheEncryptionKeys: p
    };
    return t.masterPlaylistLoader_ = t.sourceType_ === "dash" ? new Xg(n, t.hls_, t.requestOptions_) : new eh(n, t.hls_, t.requestOptions_), t.setupMasterPlaylistLoaderListeners_(), t.mainSegmentLoader_ = new Jg(re.mergeOptions(b, {
      segmentMetadataTrack: t.segmentMetadataTrack_,
      loaderType: "main"
    }), i), t.audioSegmentLoader_ = new Jg(re.mergeOptions(b, {
      loaderType: "audio"
    }), i), t.subtitleSegmentLoader_ = new EO(re.mergeOptions(b, {
      loaderType: "vtt"
    }), i), t.setupSegmentLoaderListeners_(), UO.forEach(function(y) {
      t[y + "_"] = BO.bind(t, y);
    }), t.logger_ = Od("MPC"), t.masterPlaylistLoader_.load(), t;
  }
  return gs(r, [{
    key: "setupMasterPlaylistLoaderListeners_",
    value: function() {
      var t = this;
      this.masterPlaylistLoader_.on("loadedmetadata", function() {
        var n = t.masterPlaylistLoader_.media(), a = n.targetDuration * 1.5 * 1e3;
        qg(t.masterPlaylistLoader_.master, t.masterPlaylistLoader_.media()) ? t.requestOptions_.timeout = 0 : t.requestOptions_.timeout = a, n.endList && t.tech_.preload() !== "none" && (t.mainSegmentLoader_.playlist(n, t.requestOptions_), t.mainSegmentLoader_.load()), MO({
          sourceType: t.sourceType_,
          segmentLoaders: {
            AUDIO: t.audioSegmentLoader_,
            SUBTITLES: t.subtitleSegmentLoader_,
            main: t.mainSegmentLoader_
          },
          tech: t.tech_,
          requestOptions: t.requestOptions_,
          masterPlaylistLoader: t.masterPlaylistLoader_,
          hls: t.hls_,
          master: t.master(),
          mediaTypes: t.mediaTypes_,
          blacklistCurrentPlaylist: t.blacklistCurrentPlaylist.bind(t)
        }), t.triggerPresenceUsage_(t.master(), n);
        try {
          t.setupSourceBuffers_();
        } catch (s) {
          return re.log.warn("Failed to create SourceBuffers", s), t.mediaSource.endOfStream("decode");
        }
        t.setupFirstPlay(), !t.mediaTypes_.AUDIO.activePlaylistLoader || t.mediaTypes_.AUDIO.activePlaylistLoader.media() ? t.trigger("selectedinitialmedia") : t.mediaTypes_.AUDIO.activePlaylistLoader.one("loadedmetadata", function() {
          t.trigger("selectedinitialmedia");
        });
      }), this.masterPlaylistLoader_.on("loadedplaylist", function() {
        var n = t.masterPlaylistLoader_.media();
        if (!n) {
          t.excludeUnsupportedVariants_();
          var a = void 0;
          t.enableLowInitialPlaylist && (a = t.selectInitialPlaylist()), a || (a = t.selectPlaylist()), t.initialMedia_ = a, t.masterPlaylistLoader_.media(t.initialMedia_);
          return;
        }
        if (t.useCueTags_ && t.updateAdCues_(n), t.mainSegmentLoader_.playlist(n, t.requestOptions_), t.updateDuration(), t.tech_.paused() || (t.mainSegmentLoader_.load(), t.audioSegmentLoader_ && t.audioSegmentLoader_.load()), !n.endList) {
          var s = function() {
            var u = t.seekable();
            u.length !== 0 && t.mediaSource.addSeekableRange_(u.start(0), u.end(0));
          };
          if (t.duration() !== 1 / 0) {
            var o = function l() {
              t.duration() === 1 / 0 ? s() : t.tech_.one("durationchange", l);
            };
            t.tech_.one("durationchange", o);
          } else
            s();
        }
      }), this.masterPlaylistLoader_.on("error", function() {
        t.blacklistCurrentPlaylist(t.masterPlaylistLoader_.error);
      }), this.masterPlaylistLoader_.on("mediachanging", function() {
        t.mainSegmentLoader_.abort(), t.mainSegmentLoader_.pause();
      }), this.masterPlaylistLoader_.on("mediachange", function() {
        var n = t.masterPlaylistLoader_.media(), a = n.targetDuration * 1.5 * 1e3;
        qg(t.masterPlaylistLoader_.master, t.masterPlaylistLoader_.media()) ? t.requestOptions_.timeout = 0 : t.requestOptions_.timeout = a, t.mainSegmentLoader_.playlist(n, t.requestOptions_), t.mainSegmentLoader_.load(), t.tech_.trigger({
          type: "mediachange",
          bubbles: !0
        });
      }), this.masterPlaylistLoader_.on("playlistunchanged", function() {
        var n = t.masterPlaylistLoader_.media(), a = t.stuckAtPlaylistEnd_(n);
        a && (t.blacklistCurrentPlaylist({
          message: "Playlist no longer updating."
        }), t.tech_.trigger("playliststuck"));
      }), this.masterPlaylistLoader_.on("renditiondisabled", function() {
        t.tech_.trigger({
          type: "usage",
          name: "hls-rendition-disabled"
        });
      }), this.masterPlaylistLoader_.on("renditionenabled", function() {
        t.tech_.trigger({
          type: "usage",
          name: "hls-rendition-enabled"
        });
      });
    }
  }, {
    key: "triggerPresenceUsage_",
    value: function(t, n) {
      var a = t.mediaGroups || {}, s = !0, o = Object.keys(a.AUDIO);
      for (var l in a.AUDIO)
        for (var u in a.AUDIO[l]) {
          var h = a.AUDIO[l][u];
          h.uri || (s = !1);
        }
      s && this.tech_.trigger({
        type: "usage",
        name: "hls-demuxed"
      }), Object.keys(a.SUBTITLES).length && this.tech_.trigger({
        type: "usage",
        name: "hls-webvtt"
      }), Vo.Playlist.isAes(n) && this.tech_.trigger({
        type: "usage",
        name: "hls-aes"
      }), Vo.Playlist.isFmp4(n) && this.tech_.trigger({
        type: "usage",
        name: "hls-fmp4"
      }), o.length && Object.keys(a.AUDIO[o[0]]).length > 1 && this.tech_.trigger({
        type: "usage",
        name: "hls-alternate-audio"
      }), this.useCueTags_ && this.tech_.trigger({
        type: "usage",
        name: "hls-playlist-cue-tags"
      });
    }
  }, {
    key: "setupSegmentLoaderListeners_",
    value: function() {
      var t = this;
      this.mainSegmentLoader_.on("bandwidthupdate", function() {
        var n = t.selectPlaylist(), a = t.masterPlaylistLoader_.media(), s = t.tech_.buffered(), o = s.length ? s.end(s.length - 1) - t.tech_.currentTime() : 0, l = t.bufferLowWaterLine();
        (!a.endList || t.duration() < Sa.MAX_BUFFER_LOW_WATER_LINE || n.attributes.BANDWIDTH < a.attributes.BANDWIDTH || o >= l) && t.masterPlaylistLoader_.media(n), t.tech_.trigger("bandwidthupdate");
      }), this.mainSegmentLoader_.on("progress", function() {
        t.trigger("progress");
      }), this.mainSegmentLoader_.on("error", function() {
        t.blacklistCurrentPlaylist(t.mainSegmentLoader_.error());
      }), this.mainSegmentLoader_.on("syncinfoupdate", function() {
        t.onSyncInfoUpdate_();
      }), this.mainSegmentLoader_.on("timestampoffset", function() {
        t.tech_.trigger({
          type: "usage",
          name: "hls-timestamp-offset"
        });
      }), this.audioSegmentLoader_.on("syncinfoupdate", function() {
        t.onSyncInfoUpdate_();
      }), this.mainSegmentLoader_.on("ended", function() {
        t.onEndOfStream();
      }), this.mainSegmentLoader_.on("earlyabort", function() {
        t.blacklistCurrentPlaylist({
          message: "Aborted early because there isn't enough bandwidth to complete the request without rebuffering."
        }, FO);
      }), this.mainSegmentLoader_.on("reseteverything", function() {
        t.tech_.trigger("hls-reset");
      }), this.mainSegmentLoader_.on("segmenttimemapping", function(n) {
        t.tech_.trigger({
          type: "hls-segment-time-mapping",
          mapping: n.mapping
        });
      }), this.audioSegmentLoader_.on("ended", function() {
        t.onEndOfStream();
      });
    }
  }, {
    key: "mediaSecondsLoaded_",
    value: function() {
      return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded);
    }
  }, {
    key: "load",
    value: function() {
      this.mainSegmentLoader_.load(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.load(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.load();
    }
  }, {
    key: "smoothQualityChange_",
    value: function() {
      var t = this.selectPlaylist();
      t !== this.masterPlaylistLoader_.media() && (this.masterPlaylistLoader_.media(t), this.mainSegmentLoader_.resetLoader());
    }
  }, {
    key: "fastQualityChange_",
    value: function() {
      var t = this, n = this.selectPlaylist();
      n !== this.masterPlaylistLoader_.media() && (this.masterPlaylistLoader_.media(n), this.mainSegmentLoader_.resetEverything(function() {
        re.browser.IE_VERSION || re.browser.IS_EDGE ? t.tech_.setCurrentTime(t.tech_.currentTime() + 0.04) : t.tech_.setCurrentTime(t.tech_.currentTime());
      }));
    }
  }, {
    key: "play",
    value: function() {
      if (!this.setupFirstPlay()) {
        this.tech_.ended() && this.seekTo_(0), this.hasPlayed_() && this.load();
        var t = this.tech_.seekable();
        if (this.tech_.duration() === 1 / 0 && this.tech_.currentTime() < t.start(0))
          return this.seekTo_(t.end(t.length - 1));
      }
    }
  }, {
    key: "setupFirstPlay",
    value: function() {
      var t = this, n = this.masterPlaylistLoader_.media();
      if (!n || this.tech_.paused() || this.hasPlayed_())
        return !1;
      if (!n.endList) {
        var a = this.seekable();
        if (!a.length)
          return !1;
        if (re.browser.IE_VERSION && this.tech_.readyState() === 0)
          return this.tech_.one("loadedmetadata", function() {
            t.trigger("firstplay"), t.seekTo_(a.end(0)), t.hasPlayed_ = function() {
              return !0;
            };
          }), !1;
        this.trigger("firstplay"), this.seekTo_(a.end(0));
      }
      return this.hasPlayed_ = function() {
        return !0;
      }, this.load(), !0;
    }
  }, {
    key: "handleSourceOpen_",
    value: function() {
      try {
        this.setupSourceBuffers_();
      } catch (n) {
        return re.log.warn("Failed to create Source Buffers", n), this.mediaSource.endOfStream("decode");
      }
      if (this.tech_.autoplay()) {
        var t = this.tech_.play();
        typeof t < "u" && typeof t.then == "function" && t.then(null, function(n) {
        });
      }
      this.trigger("sourceopen");
    }
  }, {
    key: "onEndOfStream",
    value: function() {
      var t = this.mainSegmentLoader_.ended_;
      if (this.mediaTypes_.AUDIO.activePlaylistLoader && (!this.mainSegmentLoader_.startingMedia_ || this.mainSegmentLoader_.startingMedia_.containsVideo ? t = t && this.audioSegmentLoader_.ended_ : t = this.audioSegmentLoader_.ended_), !!t) {
        this.logger_("calling mediaSource.endOfStream()");
        try {
          this.mediaSource.endOfStream();
        } catch (n) {
          re.log.warn("Failed to call media source endOfStream", n);
        }
      }
    }
  }, {
    key: "stuckAtPlaylistEnd_",
    value: function(t) {
      var n = this.seekable();
      if (!n.length)
        return !1;
      var a = this.syncController_.getExpiredTime(t, this.mediaSource.duration);
      if (a === null)
        return !1;
      var s = Vo.Playlist.playlistEnd(t, a), o = this.tech_.currentTime(), l = this.tech_.buffered();
      if (!l.length)
        return s - o <= ao;
      var u = l.end(l.length - 1);
      return u - o <= ao && s - u <= ao;
    }
  }, {
    key: "blacklistCurrentPlaylist",
    value: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments[1], a = void 0, s = void 0;
      if (a = t.playlist || this.masterPlaylistLoader_.media(), n = n || t.blacklistDuration || this.blacklistDuration, !a) {
        this.error = t;
        try {
          return this.mediaSource.endOfStream("network");
        } catch {
          return this.trigger("error");
        }
      }
      var o = this.masterPlaylistLoader_.master.playlists.filter(Gh).length === 1, l = this.masterPlaylistLoader_.master.playlists;
      return l.length === 1 ? (re.log.warn("Problem encountered with the current HLS playlist. Trying again since it is the only playlist."), this.tech_.trigger("retryplaylist"), this.masterPlaylistLoader_.load(o)) : (o && (re.log.warn("Removing all playlists from the blacklist because the last rendition is about to be blacklisted."), l.forEach(function(u) {
        u.excludeUntil !== 1 / 0 && delete u.excludeUntil;
      }), this.tech_.trigger("retryplaylist")), a.excludeUntil = Date.now() + n * 1e3, this.tech_.trigger("blacklistplaylist"), this.tech_.trigger({
        type: "usage",
        name: "hls-rendition-blacklisted"
      }), s = this.selectPlaylist(), re.log.warn("Problem encountered with the current HLS playlist." + (t.message ? " " + t.message : "") + " Switching to another playlist."), this.masterPlaylistLoader_.media(s, o));
    }
  }, {
    key: "pauseLoading",
    value: function() {
      this.mainSegmentLoader_.pause(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.pause(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.pause();
    }
  }, {
    key: "setCurrentTime",
    value: function(t) {
      var n = xE(this.tech_.buffered(), t);
      if (!(this.masterPlaylistLoader_ && this.masterPlaylistLoader_.media()) || !this.masterPlaylistLoader_.media().segments)
        return 0;
      if (n && n.length)
        return t;
      this.mainSegmentLoader_.resetEverything(), this.mainSegmentLoader_.abort(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.resetEverything(), this.audioSegmentLoader_.abort()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.resetEverything(), this.subtitleSegmentLoader_.abort()), this.load();
    }
  }, {
    key: "duration",
    value: function() {
      return this.masterPlaylistLoader_ ? this.mediaSource ? this.mediaSource.duration : Vo.Playlist.duration(this.masterPlaylistLoader_.media()) : 0;
    }
  }, {
    key: "seekable",
    value: function() {
      return this.seekable_;
    }
  }, {
    key: "onSyncInfoUpdate_",
    value: function() {
      var t = void 0, n = void 0;
      if (!!this.masterPlaylistLoader_) {
        var a = this.masterPlaylistLoader_.media();
        if (!!a) {
          var s = this.syncController_.getExpiredTime(a, this.mediaSource.duration);
          if (s !== null && (t = Vo.Playlist.seekable(a, s), t.length !== 0 && !(this.mediaTypes_.AUDIO.activePlaylistLoader && (a = this.mediaTypes_.AUDIO.activePlaylistLoader.media(), s = this.syncController_.getExpiredTime(a, this.mediaSource.duration), s === null || (n = Vo.Playlist.seekable(a, s), n.length === 0))))) {
            var o = void 0, l = void 0;
            this.seekable_ && this.seekable_.length && (o = this.seekable_.end(0), l = this.seekable_.start(0)), n ? n.start(0) > t.end(0) || t.start(0) > n.end(0) ? this.seekable_ = t : this.seekable_ = re.createTimeRanges([[n.start(0) > t.start(0) ? n.start(0) : t.start(0), n.end(0) < t.end(0) ? n.end(0) : t.end(0)]]) : this.seekable_ = t, !(this.seekable_ && this.seekable_.length && this.seekable_.end(0) === o && this.seekable_.start(0) === l) && (this.logger_("seekable updated [" + Am(this.seekable_) + "]"), this.tech_.trigger("seekablechanged"));
          }
        }
      }
    }
  }, {
    key: "updateDuration",
    value: function() {
      var t = this, n = this.mediaSource.duration, a = Vo.Playlist.duration(this.masterPlaylistLoader_.media()), s = this.tech_.buffered(), o = function l() {
        t.logger_("Setting duration from " + t.mediaSource.duration + " => " + a);
        try {
          t.mediaSource.duration = a;
        } catch (u) {
          re.log.warn("Failed to set media source duration", u);
        }
        t.tech_.trigger("durationchange"), t.mediaSource.removeEventListener("sourceopen", l);
      };
      s.length > 0 && (a = Math.max(a, s.end(s.length - 1))), n !== a && (this.mediaSource.readyState !== "open" ? this.mediaSource.addEventListener("sourceopen", o) : o());
    }
  }, {
    key: "dispose",
    value: function() {
      var t = this;
      this.decrypter_.terminate(), this.masterPlaylistLoader_.dispose(), this.mainSegmentLoader_.dispose(), ["AUDIO", "SUBTITLES"].forEach(function(n) {
        var a = t.mediaTypes_[n].groups;
        for (var s in a)
          a[s].forEach(function(o) {
            o.playlistLoader && o.playlistLoader.dispose();
          });
      }), this.audioSegmentLoader_.dispose(), this.subtitleSegmentLoader_.dispose();
    }
  }, {
    key: "master",
    value: function() {
      return this.masterPlaylistLoader_.master;
    }
  }, {
    key: "media",
    value: function() {
      return this.masterPlaylistLoader_.media() || this.initialMedia_;
    }
  }, {
    key: "setupSourceBuffers_",
    value: function() {
      var t = this.masterPlaylistLoader_.media(), n = void 0;
      if (!(!t || this.mediaSource.readyState !== "open")) {
        if (n = VP(this.masterPlaylistLoader_.master, t), n.length < 1)
          return this.error = "No compatible SourceBuffer configuration for the variant stream:" + t.resolvedUri, this.mediaSource.endOfStream("decode");
        this.configureLoaderMimeTypes_(n), this.excludeIncompatibleVariants_(t);
      }
    }
  }, {
    key: "configureLoaderMimeTypes_",
    value: function(t) {
      var n = t.length > 1 && t[0].indexOf(",") === -1 && t[0] !== t[1] ? new re.EventTarget() : null;
      this.mainSegmentLoader_.mimeType(t[0], n), t[1] && this.audioSegmentLoader_.mimeType(t[1], n);
    }
  }, {
    key: "excludeUnsupportedVariants_",
    value: function() {
      this.master().playlists.forEach(function(t) {
        t.attributes.CODECS && Be.MediaSource && Be.MediaSource.isTypeSupported && !Be.MediaSource.isTypeSupported('video/mp4; codecs="' + jP(t.attributes.CODECS) + '"') && (t.excludeUntil = 1 / 0);
      });
    }
  }, {
    key: "excludeIncompatibleVariants_",
    value: function(t) {
      var n = 2, a = null, s = void 0;
      t.attributes.CODECS && (s = dd(t.attributes.CODECS), a = s.videoCodec, n = s.codecCount), this.master().playlists.forEach(function(o) {
        var l = {
          codecCount: 2,
          videoCodec: null
        };
        o.attributes.CODECS && (l = dd(o.attributes.CODECS)), l.codecCount !== n && (o.excludeUntil = 1 / 0), l.videoCodec !== a && (o.excludeUntil = 1 / 0);
      });
    }
  }, {
    key: "updateAdCues_",
    value: function(t) {
      var n = 0, a = this.seekable();
      a.length && (n = a.start(0)), AO(t, this.cueTagsTrack_, n);
    }
  }, {
    key: "goalBufferLength",
    value: function() {
      var t = this.tech_.currentTime(), n = Sa.GOAL_BUFFER_LENGTH, a = Sa.GOAL_BUFFER_LENGTH_RATE, s = Math.max(n, Sa.MAX_GOAL_BUFFER_LENGTH);
      return Math.min(n + t * a, s);
    }
  }, {
    key: "bufferLowWaterLine",
    value: function() {
      var t = this.tech_.currentTime(), n = Sa.BUFFER_LOW_WATER_LINE, a = Sa.BUFFER_LOW_WATER_LINE_RATE, s = Math.max(n, Sa.MAX_BUFFER_LOW_WATER_LINE);
      return Math.min(n + t * a, s);
    }
  }]), r;
}(re.EventTarget), $O = function(r, i, t) {
  return function(n) {
    var a = r.master.playlists[i], s = xm(a), o = Gh(a);
    return typeof n > "u" ? o : (n ? delete a.disabled : a.disabled = !0, n !== o && !s && (t(), n ? r.trigger("renditionenabled") : r.trigger("renditiondisabled")), n);
  };
}, GO = function e(r, i, t) {
  Wa(this, e);
  var n = r.masterPlaylistController_, a = r.options_.smoothQualityChange, s = a ? "smooth" : "fast", o = n[s + "QualityChange_"].bind(n);
  if (i.attributes.RESOLUTION) {
    var l = i.attributes.RESOLUTION;
    this.width = l.width, this.height = l.height;
  }
  this.bandwidth = i.attributes.BANDWIDTH, this.id = t, this.enabled = $O(r.playlists, i.uri, o);
}, HO = function(r) {
  var i = r.playlists;
  r.representations = function() {
    return i.master.playlists.filter(function(t) {
      return !xm(t);
    }).map(function(t, n) {
      return new GO(r, t, t.uri);
    });
  };
}, rb = ["seeking", "seeked", "pause", "playing", "error"], VO = function() {
  function e(r) {
    var i = this;
    Wa(this, e), this.tech_ = r.tech, this.seekable = r.seekable, this.seekTo = r.seekTo, this.allowSeeksWithinUnsafeLiveWindow = r.allowSeeksWithinUnsafeLiveWindow, this.media = r.media, this.consecutiveUpdates = 0, this.lastRecordedTime = null, this.timer_ = null, this.checkCurrentTimeTimeout_ = null, this.logger_ = Od("PlaybackWatcher"), this.logger_("initialize");
    var t = function() {
      return i.monitorCurrentTime_();
    }, n = function() {
      return i.techWaiting_();
    }, a = function() {
      return i.cancelTimer_();
    }, s = function() {
      return i.fixesBadSeeks_();
    };
    this.tech_.on("seekablechanged", s), this.tech_.on("waiting", n), this.tech_.on(rb, a), this.tech_.on("canplay", t), this.dispose = function() {
      i.logger_("dispose"), i.tech_.off("seekablechanged", s), i.tech_.off("waiting", n), i.tech_.off(rb, a), i.tech_.off("canplay", t), i.checkCurrentTimeTimeout_ && Be.clearTimeout(i.checkCurrentTimeTimeout_), i.cancelTimer_();
    };
  }
  return gs(e, [{
    key: "monitorCurrentTime_",
    value: function() {
      this.checkCurrentTime_(), this.checkCurrentTimeTimeout_ && Be.clearTimeout(this.checkCurrentTimeTimeout_), this.checkCurrentTimeTimeout_ = Be.setTimeout(this.monitorCurrentTime_.bind(this), 250);
    }
  }, {
    key: "checkCurrentTime_",
    value: function() {
      if (this.tech_.seeking() && this.fixesBadSeeks_()) {
        this.consecutiveUpdates = 0, this.lastRecordedTime = this.tech_.currentTime();
        return;
      }
      if (!(this.tech_.paused() || this.tech_.seeking())) {
        var i = this.tech_.currentTime(), t = this.tech_.buffered();
        if (this.lastRecordedTime === i && (!t.length || i + ao >= t.end(t.length - 1)))
          return this.techWaiting_();
        this.consecutiveUpdates >= 5 && i === this.lastRecordedTime ? (this.consecutiveUpdates++, this.waiting_()) : i === this.lastRecordedTime ? this.consecutiveUpdates++ : (this.consecutiveUpdates = 0, this.lastRecordedTime = i);
      }
    }
  }, {
    key: "cancelTimer_",
    value: function() {
      this.consecutiveUpdates = 0, this.timer_ && (this.logger_("cancelTimer_"), clearTimeout(this.timer_)), this.timer_ = null;
    }
  }, {
    key: "fixesBadSeeks_",
    value: function() {
      var i = this.tech_.seeking();
      if (!i)
        return !1;
      var t = this.seekable(), n = this.tech_.currentTime(), a = this.afterSeekableWindow_(t, n, this.media(), this.allowSeeksWithinUnsafeLiveWindow), s = void 0;
      if (a) {
        var o = t.end(t.length - 1);
        s = o;
      }
      if (this.beforeSeekableWindow_(t, n)) {
        var l = t.start(0);
        s = l + ao;
      }
      return typeof s < "u" ? (this.logger_("Trying to seek outside of seekable at time " + n + " with " + ("seekable range " + Am(t) + ". Seeking to ") + (s + ".")), this.seekTo(s), !0) : !1;
    }
  }, {
    key: "waiting_",
    value: function() {
      if (!this.techWaiting_()) {
        var i = this.tech_.currentTime(), t = this.tech_.buffered(), n = xE(t, i);
        if (n.length && i + 3 <= n.end(0)) {
          this.cancelTimer_(), this.seekTo(i), this.logger_("Stopped at " + i + " while inside a buffered region " + ("[" + n.start(0) + " -> " + n.end(0) + "]. Attempting to resume ") + "playback by seeking to the current time."), this.tech_.trigger({
            type: "usage",
            name: "hls-unknown-waiting"
          });
          return;
        }
      }
    }
  }, {
    key: "techWaiting_",
    value: function() {
      var i = this.seekable(), t = this.tech_.currentTime();
      if (this.tech_.seeking() && this.fixesBadSeeks_() || this.tech_.seeking() || this.timer_ !== null)
        return !0;
      if (this.beforeSeekableWindow_(i, t)) {
        var n = i.end(i.length - 1);
        return this.logger_("Fell out of live window at time " + t + ". Seeking to " + ("live point (seekable end) " + n)), this.cancelTimer_(), this.seekTo(n), this.tech_.trigger({
          type: "usage",
          name: "hls-live-resync"
        }), !0;
      }
      var a = this.tech_.buffered(), s = G_(a, t);
      if (this.videoUnderflow_(s, a, t))
        return this.cancelTimer_(), this.seekTo(t), this.tech_.trigger({
          type: "usage",
          name: "hls-video-underflow"
        }), !0;
      if (s.length > 0) {
        var o = s.start(0) - t;
        return this.logger_("Stopped at " + t + ", setting timer for " + o + ", seeking " + ("to " + s.start(0))), this.timer_ = setTimeout(this.skipTheGap_.bind(this), o * 1e3, t), !0;
      }
      return !1;
    }
  }, {
    key: "afterSeekableWindow_",
    value: function(i, t, n) {
      var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
      if (!i.length)
        return !1;
      var s = i.end(i.length - 1) + ao, o = !n.endList;
      return o && a && (s = i.end(i.length - 1) + n.targetDuration * 3), t > s;
    }
  }, {
    key: "beforeSeekableWindow_",
    value: function(i, t) {
      return !!(i.length && i.start(0) > 0 && t < i.start(0) - ao);
    }
  }, {
    key: "videoUnderflow_",
    value: function(i, t, n) {
      if (i.length === 0) {
        var a = this.gapFromVideoUnderflow_(t, n);
        if (a)
          return this.logger_("Encountered a gap in video from " + a.start + " to " + a.end + ". " + ("Seeking to current time " + n)), !0;
      }
      return !1;
    }
  }, {
    key: "skipTheGap_",
    value: function(i) {
      var t = this.tech_.buffered(), n = this.tech_.currentTime(), a = G_(t, n);
      this.cancelTimer_(), !(a.length === 0 || n !== i) && (this.logger_("skipTheGap_:", "currentTime:", n, "scheduled currentTime:", i, "nextRange start:", a.start(0)), this.seekTo(a.start(0) + Hh), this.tech_.trigger({
        type: "usage",
        name: "hls-gap-skip"
      }));
    }
  }, {
    key: "gapFromVideoUnderflow_",
    value: function(i, t) {
      for (var n = PP(i), a = 0; a < n.length; a++) {
        var s = n.start(a), o = n.end(a);
        if (t - s < 4 && t - s > 2)
          return {
            start: s,
            end: o
          };
      }
      return null;
    }
  }]), e;
}(), qO = {
  errorInterval: 30,
  getSource: function(r) {
    var i = this.tech({
      IWillNotUseThisInPlugins: !0
    }), t = i.currentSource_;
    return r(t);
  }
}, WO = function e(r, i) {
  var t = 0, n = 0, a = re.mergeOptions(qO, i);
  r.ready(function() {
    r.trigger({
      type: "usage",
      name: "hls-error-reload-initialized"
    });
  });
  var s = function() {
    n && r.currentTime(n);
  }, o = function(d) {
    d != null && (n = r.duration() !== 1 / 0 && r.currentTime() || 0, r.one("loadedmetadata", s), r.src(d), r.trigger({
      type: "usage",
      name: "hls-error-reload"
    }), r.play());
  }, l = function() {
    if (Date.now() - t < a.errorInterval * 1e3) {
      r.trigger({
        type: "usage",
        name: "hls-error-reload-canceled"
      });
      return;
    }
    if (!a.getSource || typeof a.getSource != "function") {
      re.log.error("ERROR: reloadSourceOnError - The option getSource must be a function!");
      return;
    }
    return t = Date.now(), a.getSource.call(r, o);
  }, u = function c() {
    r.off("loadedmetadata", s), r.off("error", l), r.off("dispose", c);
  }, h = function(d) {
    u(), e(r, d);
  };
  r.on("error", l), r.on("dispose", u), r.reloadSourceOnError = h;
}, ib = function(r) {
  WO(this, r);
}, YO = "1.10.6";
re.use("*", function(e) {
  return {
    setSource: function(i, t) {
      t(null, i);
    },
    setCurrentTime: function(i) {
      return e.vhs && e.currentSource().src === e.vhs.source_.src && e.vhs.setCurrentTime(i), i;
    },
    play: function() {
      e.vhs && e.currentSource().src === e.vhs.source_.src && e.vhs.setCurrentTime(e.tech_.currentTime());
    }
  };
});
var la = {
  PlaylistLoader: eh,
  Playlist: ua,
  Decrypter: wR,
  AsyncStream: KT,
  decrypt: zT,
  utils: SP,
  STANDARD_PLAYLIST_SELECTOR: hO,
  INITIAL_PLAYLIST_SELECTOR: gO,
  comparePlaylistBandwidth: Cm,
  comparePlaylistResolution: dO,
  xhr: yE()
};
["GOAL_BUFFER_LENGTH", "MAX_GOAL_BUFFER_LENGTH", "GOAL_BUFFER_LENGTH_RATE", "BUFFER_LOW_WATER_LINE", "MAX_BUFFER_LOW_WATER_LINE", "BUFFER_LOW_WATER_LINE_RATE", "BANDWIDTH_VARIANCE"].forEach(function(e) {
  Object.defineProperty(la, e, {
    get: function() {
      return re.log.warn("using Hls." + e + " is UNSAFE be sure you know what you are doing"), Sa[e];
    },
    set: function(i) {
      if (re.log.warn("using Hls." + e + " is UNSAFE be sure you know what you are doing"), typeof i != "number" || i < 0) {
        re.log.warn("value of Hls." + e + " must be greater than or equal to 0");
        return;
      }
      Sa[e] = i;
    }
  });
});
var NE = "videojs-vhs", FE = function(r) {
  var i = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i;
  if (i.test(r))
    return "hls";
  var t = /^application\/dash\+xml/i;
  return t.test(r) ? "dash" : null;
}, UE = function(r, i) {
  for (var t = i.media(), n = -1, a = 0; a < r.length; a++)
    if (r[a].id === t.uri) {
      n = a;
      break;
    }
  r.selectedIndex_ = n, r.trigger({
    selectedIndex: n,
    type: "change"
  });
}, KO = function(r, i) {
  i.representations().forEach(function(t) {
    r.addQualityLevel(t);
  }), UE(r, i.playlists);
};
la.canPlaySource = function() {
  return re.log.warn("HLS is no longer a tech. Please remove it from your player's techOrder.");
};
var zO = function(r, i, t) {
  if (!r)
    return r;
  var n = {};
  for (var a in r)
    n[a] = {
      audioContentType: 'audio/mp4; codecs="' + t.attributes.CODECS + '"',
      videoContentType: 'video/mp4; codecs="' + i.attributes.CODECS + '"'
    }, i.contentProtection && i.contentProtection[a] && i.contentProtection[a].pssh && (n[a].pssh = i.contentProtection[a].pssh), typeof r[a] == "string" && (n[a].url = r[a]);
  return re.mergeOptions(r, n);
}, XO = function(r) {
  if (r.options_.sourceType === "dash") {
    var i = re.players[r.tech_.options_.playerId];
    if (i.eme) {
      var t = zO(r.source_.keySystems, r.playlists.media(), r.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader.media());
      t && (i.currentSource().keySystems = t, i.eme.initializeMediaKeys && i.eme.initializeMediaKeys());
    }
  }
}, BE = function() {
  if (!window.localStorage)
    return null;
  var r = window.localStorage.getItem(NE);
  if (!r)
    return null;
  try {
    return JSON.parse(r);
  } catch {
    return null;
  }
}, JO = function(r) {
  if (!window.localStorage)
    return !1;
  var i = BE();
  i = i ? re.mergeOptions(i, r) : r;
  try {
    window.localStorage.setItem(NE, JSON.stringify(i));
  } catch {
    return !1;
  }
  return i;
};
la.supportsNativeHls = function() {
  var e = Mt.createElement("video");
  if (!re.getTech("Html5").isSupported())
    return !1;
  var r = [
    "application/vnd.apple.mpegurl",
    "audio/mpegurl",
    "audio/x-mpegurl",
    "application/x-mpegurl",
    "video/x-mpegurl",
    "video/mpegurl",
    "application/mpegurl"
  ];
  return r.some(function(i) {
    return /maybe|probably/i.test(e.canPlayType(i));
  });
}();
la.supportsNativeDash = function() {
  return re.getTech("Html5").isSupported() ? /maybe|probably/i.test(Mt.createElement("video").canPlayType("application/dash+xml")) : !1;
}();
la.supportsTypeNatively = function(e) {
  return e === "hls" ? la.supportsNativeHls : e === "dash" ? la.supportsNativeDash : !1;
};
la.isSupported = function() {
  return re.log.warn("HLS is no longer a tech. Please remove it from your player's techOrder.");
};
var QO = re.getComponent("Component"), jE = function(e) {
  xo(r, e);
  function r(i, t, n) {
    Wa(this, r);
    var a = js(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, t, n.hls));
    if (t.options_ && t.options_.playerId) {
      var s = re(t.options_.playerId);
      s.hasOwnProperty("hls") || Object.defineProperty(s, "hls", {
        get: function() {
          return re.log.warn("player.hls is deprecated. Use player.tech().hls instead."), t.trigger({
            type: "usage",
            name: "hls-player-access"
          }), a;
        },
        configurable: !0
      }), s.vhs = a, s.dash = a, a.player_ = s;
    }
    if (a.tech_ = t, a.source_ = i, a.stats = {}, a.setOptions_(), a.options_.overrideNative && t.overrideNativeAudioTracks && t.overrideNativeVideoTracks)
      t.overrideNativeAudioTracks(!0), t.overrideNativeVideoTracks(!0);
    else if (a.options_.overrideNative && (t.featuresNativeVideoTracks || t.featuresNativeAudioTracks))
      throw new Error("Overriding native HLS requires emulated tracks. See https://git.io/vMpjB");
    return a.on(Mt, ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"], function(o) {
      var l = Mt.fullscreenElement || Mt.webkitFullscreenElement || Mt.mozFullScreenElement || Mt.msFullscreenElement;
      l && l.contains(a.tech_.el()) && a.masterPlaylistController_.smoothQualityChange_();
    }), a.on(a.tech_, "seeking", function() {
      this.tech_.currentTime() === 0 && this.tech_.player_.loop() && this.setCurrentTime(0);
    }), a.on(a.tech_, "error", function() {
      this.masterPlaylistController_ && this.masterPlaylistController_.pauseLoading();
    }), a.on(a.tech_, "play", a.play), a;
  }
  return gs(r, [{
    key: "setOptions_",
    value: function() {
      var t = this;
      if (this.options_.withCredentials = this.options_.withCredentials || !1, this.options_.handleManifestRedirects = this.options_.handleManifestRedirects || !1, this.options_.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions !== !1, this.options_.smoothQualityChange = this.options_.smoothQualityChange || !1, this.options_.useBandwidthFromLocalStorage = typeof this.source_.useBandwidthFromLocalStorage < "u" ? this.source_.useBandwidthFromLocalStorage : this.options_.useBandwidthFromLocalStorage || !1, this.options_.customTagParsers = this.options_.customTagParsers || [], this.options_.customTagMappers = this.options_.customTagMappers || [], this.options_.cacheEncryptionKeys = this.options_.cacheEncryptionKeys || !1, typeof this.options_.blacklistDuration != "number" && (this.options_.blacklistDuration = 5 * 60), typeof this.options_.bandwidth != "number" && this.options_.useBandwidthFromLocalStorage) {
        var n = BE();
        n && n.bandwidth && (this.options_.bandwidth = n.bandwidth, this.tech_.trigger({
          type: "usage",
          name: "hls-bandwidth-from-local-storage"
        })), n && n.throughput && (this.options_.throughput = n.throughput, this.tech_.trigger({
          type: "usage",
          name: "hls-throughput-from-local-storage"
        }));
      }
      typeof this.options_.bandwidth != "number" && (this.options_.bandwidth = Sa.INITIAL_BANDWIDTH), this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === Sa.INITIAL_BANDWIDTH, ["withCredentials", "limitRenditionByPlayerDimensions", "bandwidth", "smoothQualityChange", "customTagParsers", "customTagMappers", "handleManifestRedirects", "cacheEncryptionKeys"].forEach(function(a) {
        typeof t.source_[a] < "u" && (t.options_[a] = t.source_[a]);
      }), this.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions;
    }
  }, {
    key: "src",
    value: function(t, n) {
      var a = this;
      !t || (this.setOptions_(), this.options_.url = this.source_.src, this.options_.tech = this.tech_, this.options_.externHls = la, this.options_.sourceType = FE(n), this.options_.seekTo = function(s) {
        a.tech_.setCurrentTime(s), a.setCurrentTime(s);
      }, this.masterPlaylistController_ = new jO(this.options_), this.playbackWatcher_ = new VO(re.mergeOptions(this.options_, {
        seekable: function() {
          return a.seekable();
        },
        media: function() {
          return a.masterPlaylistController_.media();
        }
      })), this.masterPlaylistController_.on("error", function() {
        var s = re.players[a.tech_.options_.playerId];
        s.error(a.masterPlaylistController_.error);
      }), this.masterPlaylistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : la.STANDARD_PLAYLIST_SELECTOR.bind(this), this.masterPlaylistController_.selectInitialPlaylist = la.INITIAL_PLAYLIST_SELECTOR.bind(this), this.playlists = this.masterPlaylistController_.masterPlaylistLoader_, this.mediaSource = this.masterPlaylistController_.mediaSource, Object.defineProperties(this, {
        selectPlaylist: {
          get: function() {
            return this.masterPlaylistController_.selectPlaylist;
          },
          set: function(o) {
            this.masterPlaylistController_.selectPlaylist = o.bind(this);
          }
        },
        throughput: {
          get: function() {
            return this.masterPlaylistController_.mainSegmentLoader_.throughput.rate;
          },
          set: function(o) {
            this.masterPlaylistController_.mainSegmentLoader_.throughput.rate = o, this.masterPlaylistController_.mainSegmentLoader_.throughput.count = 1;
          }
        },
        bandwidth: {
          get: function() {
            return this.masterPlaylistController_.mainSegmentLoader_.bandwidth;
          },
          set: function(o) {
            this.masterPlaylistController_.mainSegmentLoader_.bandwidth = o, this.masterPlaylistController_.mainSegmentLoader_.throughput = {
              rate: 0,
              count: 0
            };
          }
        },
        systemBandwidth: {
          get: function() {
            var o = 1 / (this.bandwidth || 1), l = void 0;
            this.throughput > 0 ? l = 1 / this.throughput : l = 0;
            var u = Math.floor(1 / (o + l));
            return u;
          },
          set: function() {
            re.log.error('The "systemBandwidth" property is read-only');
          }
        }
      }), this.options_.bandwidth && (this.bandwidth = this.options_.bandwidth), this.options_.throughput && (this.throughput = this.options_.throughput), Object.defineProperties(this.stats, {
        bandwidth: {
          get: function() {
            return a.bandwidth || 0;
          },
          enumerable: !0
        },
        mediaRequests: {
          get: function() {
            return a.masterPlaylistController_.mediaRequests_() || 0;
          },
          enumerable: !0
        },
        mediaRequestsAborted: {
          get: function() {
            return a.masterPlaylistController_.mediaRequestsAborted_() || 0;
          },
          enumerable: !0
        },
        mediaRequestsTimedout: {
          get: function() {
            return a.masterPlaylistController_.mediaRequestsTimedout_() || 0;
          },
          enumerable: !0
        },
        mediaRequestsErrored: {
          get: function() {
            return a.masterPlaylistController_.mediaRequestsErrored_() || 0;
          },
          enumerable: !0
        },
        mediaTransferDuration: {
          get: function() {
            return a.masterPlaylistController_.mediaTransferDuration_() || 0;
          },
          enumerable: !0
        },
        mediaBytesTransferred: {
          get: function() {
            return a.masterPlaylistController_.mediaBytesTransferred_() || 0;
          },
          enumerable: !0
        },
        mediaSecondsLoaded: {
          get: function() {
            return a.masterPlaylistController_.mediaSecondsLoaded_() || 0;
          },
          enumerable: !0
        },
        buffered: {
          get: function() {
            return H_(a.tech_.buffered());
          },
          enumerable: !0
        },
        currentTime: {
          get: function() {
            return a.tech_.currentTime();
          },
          enumerable: !0
        },
        currentSource: {
          get: function() {
            return a.tech_.currentSource_;
          },
          enumerable: !0
        },
        currentTech: {
          get: function() {
            return a.tech_.name_;
          },
          enumerable: !0
        },
        duration: {
          get: function() {
            return a.tech_.duration();
          },
          enumerable: !0
        },
        master: {
          get: function() {
            return a.playlists.master;
          },
          enumerable: !0
        },
        playerDimensions: {
          get: function() {
            return a.tech_.currentDimensions();
          },
          enumerable: !0
        },
        seekable: {
          get: function() {
            return H_(a.tech_.seekable());
          },
          enumerable: !0
        },
        timestamp: {
          get: function() {
            return Date.now();
          },
          enumerable: !0
        },
        videoPlaybackQuality: {
          get: function() {
            return a.tech_.getVideoPlaybackQuality();
          },
          enumerable: !0
        }
      }), this.tech_.one("canplay", this.masterPlaylistController_.setupFirstPlay.bind(this.masterPlaylistController_)), this.tech_.on("bandwidthupdate", function() {
        a.options_.useBandwidthFromLocalStorage && JO({
          bandwidth: a.bandwidth,
          throughput: Math.round(a.throughput)
        });
      }), this.masterPlaylistController_.on("selectedinitialmedia", function() {
        HO(a), XO(a);
      }), this.on(this.masterPlaylistController_, "progress", function() {
        this.tech_.trigger("progress");
      }), this.tech_.ready(function() {
        return a.setupQualityLevels_();
      }), this.tech_.el() && this.tech_.src(re.URL.createObjectURL(this.masterPlaylistController_.mediaSource)));
    }
  }, {
    key: "setupQualityLevels_",
    value: function() {
      var t = this, n = re.players[this.tech_.options_.playerId];
      n && n.qualityLevels && (this.qualityLevels_ = n.qualityLevels(), this.masterPlaylistController_.on("selectedinitialmedia", function() {
        KO(t.qualityLevels_, t);
      }), this.playlists.on("mediachange", function() {
        UE(t.qualityLevels_, t.playlists);
      }));
    }
  }, {
    key: "play",
    value: function() {
      this.masterPlaylistController_.play();
    }
  }, {
    key: "setCurrentTime",
    value: function(t) {
      this.masterPlaylistController_.setCurrentTime(t);
    }
  }, {
    key: "duration",
    value: function() {
      return this.masterPlaylistController_.duration();
    }
  }, {
    key: "seekable",
    value: function() {
      return this.masterPlaylistController_.seekable();
    }
  }, {
    key: "dispose",
    value: function() {
      this.playbackWatcher_ && this.playbackWatcher_.dispose(), this.masterPlaylistController_ && this.masterPlaylistController_.dispose(), this.qualityLevels_ && this.qualityLevels_.dispose(), this.player_ && (delete this.player_.vhs, delete this.player_.dash, delete this.player_.hls), this.tech_ && this.tech_.hls && delete this.tech_.hls, Q2(r.prototype.__proto__ || Object.getPrototypeOf(r.prototype), "dispose", this).call(this);
    }
  }, {
    key: "convertToProgramTime",
    value: function(t, n) {
      return kP({
        playlist: this.masterPlaylistController_.media(),
        time: t,
        callback: n
      });
    }
  }, {
    key: "seekToProgramTime",
    value: function(t, n) {
      var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2;
      return RP({
        programTime: t,
        playlist: this.masterPlaylistController_.media(),
        retryCount: s,
        pauseAfterSeek: a,
        seekTo: this.options_.seekTo,
        tech: this.options_.tech,
        callback: n
      });
    }
  }]), r;
}(QO), Dm = {
  name: "videojs-http-streaming",
  VERSION: YO,
  canHandleSource: function(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = re.mergeOptions(re.options, i);
    return Dm.canPlayType(r.type, t);
  },
  handleSource: function(r, i) {
    var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = re.mergeOptions(re.options, t);
    return i.hls = new jE(r, i, n), i.hls.xhr = yE(), i.hls.src(r.src, r.type), i.hls;
  },
  canPlayType: function(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = re.mergeOptions(re.options, i), n = t.hls.overrideNative, a = FE(r), s = a && (!la.supportsTypeNatively(a) || n);
    return s ? "maybe" : "";
  }
};
(typeof re.MediaSource > "u" || typeof re.URL > "u") && (re.MediaSource = Pd, re.URL = LE);
Pd.supportsNativeMediaSources() && re.getTech("Html5").registerSourceHandler(Dm, 0);
re.HlsHandler = jE;
re.HlsSourceHandler = Dm;
re.Hls = la;
re.use || re.registerComponent("Hls", la);
re.options.hls = re.options.hls || {};
re.registerPlugin ? re.registerPlugin("reloadSourceOnError", ib) : re.plugin("reloadSourceOnError", ib);
const ZO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: re
}, Symbol.toStringTag, { value: "Module" })), eL = "stream-engine-player", tL = "0.0.31", rL = "Stream engine player", iL = "module", nL = [
  "dist",
  "src",
  "index.js",
  "README.md",
  "LICENSE",
  "package.json",
  "vite.config.js"
], aL = {
  ".": {
    import: "./dist/stream-engine-player.mjs",
    require: "./dist/stream-engine-player.js"
  },
  "./style": {
    import: "./dist/style.css",
    require: "./dist/style.css"
  },
  "./bundle": {
    import: "./dist/stream-engine-player-bundle.mjs",
    require: "./dist/stream-engine-player-bundle.js"
  }
}, sL = "dist/stream-engine-player.js", oL = "Dok Umansky", uL = {
  dev: "vite serve",
  build: 'concurrently "vite build --mode bundle" "vite build"',
  serve: "vite preview",
  start: "npm run dev",
  prebuild: "rm -rf dist",
  "version:patch": "npm version patch",
  lint: "./node_modules/.bin/eslint src",
  format: 'prettier "src/**/*.{ts,js,json,scss,css}" --write',
  watch: 'concurrently "vite build --watch" "vite serve"',
  "build:watch": "vite build --watch --minify=false"
}, lL = {
  angular: "~1.4.8",
  "angular-cookies": "~1.4.8",
  "font-awesome": "^4.7.0",
  "hls.js": "^0.12.4",
  "include-media": "^2.0.0",
  "infront-logger": "1.1.11",
  localforage: "^1.10.0",
  "m3u8-parser": "^7.1.0",
  "mixpanel-browser": "2.52.0",
  moment: "^2.30.1",
  "video.js": "7.6.6",
  "videojs-contrib-ads": "6.6.5",
  "videojs-ima": "1.7.5",
  "videojs-mux": "4.19.0",
  "videojs-sprite-thumbnails": "^1.2.1",
  "videojs-youtube": "^2.6.1"
}, cL = {
  concurrently: "^8.2.1",
  eslint: "^8.24.0",
  "eslint-config-prettier": "^8.5.0",
  "eslint-plugin-angular": "^4.1.0",
  "eslint-plugin-prettier": "^4.2.1",
  husky: "^8.0.1",
  hygen: "^6.2.11",
  "lint-staged": "^13.0.3",
  prettier: "^2.7.1",
  sass: "^1.55.0",
  vite: "^3.2.7"
}, dL = {
  hooks: {
    "pre-commit": "lint-staged"
  }
}, fL = {
  name: eL,
  version: tL,
  description: rL,
  type: iL,
  files: nL,
  exports: aL,
  main: sL,
  author: oL,
  scripts: uL,
  dependencies: lL,
  devDependencies: cL,
  husky: dL,
  "lint-staged": {
    "*.{ts,js,json,scss,css}": [
      "prettier --write",
      "git add"
    ]
  }
};
class hL {
  constructor() {
    this._player = null, this._pendingEvents = [];
  }
  setPlayer(r) {
    this._player = r, this._processPendingEvents();
  }
  play() {
    return this._player ? this._player.play() : Promise.reject(new Error("Player not initialized"));
  }
  pause() {
    return this._player ? Promise.resolve(this._player.pause()) : Promise.reject(new Error("Player not initialized"));
  }
  on(r, i) {
    return this._player ? (this._player.on(r, i), () => this._player.off(r, i)) : (this._pendingEvents.push({ event: r, callback: i }), () => this._removePendingEvent(r, i));
  }
  _processPendingEvents() {
    !this._player || (this._pendingEvents.forEach(({ event: r, callback: i }) => {
      this._player.on(r, i);
    }), this._pendingEvents = []);
  }
  _removePendingEvent(r, i) {
    const t = this._pendingEvents.findIndex(
      (n) => n.event === r && n.callback === i
    );
    t !== -1 && this._pendingEvents.splice(t, 1);
  }
  dispose() {
    !this._player || (this._pendingEvents = [], this._player.dispose(), this._player = null);
  }
}
/**
 * @license AngularJS v1.4.14
 * (c) 2010-2015 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(e, r, i) {
  r.module("ngCookies", ["ng"]).provider("$cookies", [function() {
    var a = this.defaults = {};
    function s(o) {
      return o ? r.extend({}, a, o) : a;
    }
    this.$get = ["$$cookieReader", "$$cookieWriter", function(o, l) {
      return {
        get: function(u) {
          return o()[u];
        },
        getObject: function(u) {
          var h = this.get(u);
          return h && r.fromJson(h);
        },
        getAll: function() {
          return o();
        },
        put: function(u, h, c) {
          l(u, h, s(c));
        },
        putObject: function(u, h, c) {
          this.put(u, r.toJson(h), c);
        },
        remove: function(u, h) {
          l(u, i, s(h));
        }
      };
    }];
  }]), r.module("ngCookies").factory("$cookieStore", ["$cookies", function(n) {
    return {
      get: function(a) {
        return n.getObject(a);
      },
      put: function(a, s) {
        n.putObject(a, s);
      },
      remove: function(a) {
        n.remove(a);
      }
    };
  }]);
  function t(n, a, s) {
    var o = s.baseHref(), l = n[0];
    function u(h, c, d) {
      var f, m;
      d = d || {}, m = d.expires, f = r.isDefined(d.path) ? d.path : o, r.isUndefined(c) && (m = "Thu, 01 Jan 1970 00:00:00 GMT", c = ""), r.isString(m) && (m = new Date(m));
      var p = encodeURIComponent(h) + "=" + encodeURIComponent(c);
      p += f ? ";path=" + f : "", p += d.domain ? ";domain=" + d.domain : "", p += m ? ";expires=" + m.toUTCString() : "", p += d.secure ? ";secure" : "";
      var b = p.length + 1;
      return b > 4096 && a.warn("Cookie '" + h + "' possibly not set or overflowed because it was too large (" + b + " > 4096 bytes)!"), p;
    }
    return function(h, c, d) {
      l.cookie = u(h, c, d);
    };
  }
  t.$inject = ["$document", "$log", "$browser"], r.module("ngCookies").provider("$$cookieWriter", function() {
    this.$get = t;
  });
})(window, window.angular);
var pL = "ngCookies";
let fr = Nb.module("stream-engine-player", [pL]);
function pf(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var $E = { exports: {} };
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/
(function(e, r) {
  (function(i) {
    e.exports = i();
  })(function() {
    return function i(t, n, a) {
      function s(u, h) {
        if (!n[u]) {
          if (!t[u]) {
            var c = typeof pf == "function" && pf;
            if (!h && c)
              return c(u, !0);
            if (o)
              return o(u, !0);
            var d = new Error("Cannot find module '" + u + "'");
            throw d.code = "MODULE_NOT_FOUND", d;
          }
          var f = n[u] = { exports: {} };
          t[u][0].call(f.exports, function(m) {
            var p = t[u][1][m];
            return s(p || m);
          }, f, f.exports, i, t, n, a);
        }
        return n[u].exports;
      }
      for (var o = typeof pf == "function" && pf, l = 0; l < a.length; l++)
        s(a[l]);
      return s;
    }({ 1: [function(i, t, n) {
      (function(a) {
        var s = a.MutationObserver || a.WebKitMutationObserver, o;
        if (s) {
          var l = 0, u = new s(m), h = a.document.createTextNode("");
          u.observe(h, {
            characterData: !0
          }), o = function() {
            h.data = l = ++l % 2;
          };
        } else if (!a.setImmediate && typeof a.MessageChannel < "u") {
          var c = new a.MessageChannel();
          c.port1.onmessage = m, o = function() {
            c.port2.postMessage(0);
          };
        } else
          "document" in a && "onreadystatechange" in a.document.createElement("script") ? o = function() {
            var b = a.document.createElement("script");
            b.onreadystatechange = function() {
              m(), b.onreadystatechange = null, b.parentNode.removeChild(b), b = null;
            }, a.document.documentElement.appendChild(b);
          } : o = function() {
            setTimeout(m, 0);
          };
        var d, f = [];
        function m() {
          d = !0;
          for (var b, y, v = f.length; v; ) {
            for (y = f, f = [], b = -1; ++b < v; )
              y[b]();
            v = f.length;
          }
          d = !1;
        }
        t.exports = p;
        function p(b) {
          f.push(b) === 1 && !d && o();
        }
      }).call(this, typeof fn < "u" ? fn : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}], 2: [function(i, t, n) {
      var a = i(1);
      function s() {
      }
      var o = {}, l = ["REJECTED"], u = ["FULFILLED"], h = ["PENDING"];
      t.exports = c;
      function c(x) {
        if (typeof x != "function")
          throw new TypeError("resolver must be a function");
        this.state = h, this.queue = [], this.outcome = void 0, x !== s && p(this, x);
      }
      c.prototype.catch = function(x) {
        return this.then(null, x);
      }, c.prototype.then = function(x, w) {
        if (typeof x != "function" && this.state === u || typeof w != "function" && this.state === l)
          return this;
        var S = new this.constructor(s);
        if (this.state !== h) {
          var T = this.state === u ? x : w;
          f(S, T, this.outcome);
        } else
          this.queue.push(new d(S, x, w));
        return S;
      };
      function d(x, w, S) {
        this.promise = x, typeof w == "function" && (this.onFulfilled = w, this.callFulfilled = this.otherCallFulfilled), typeof S == "function" && (this.onRejected = S, this.callRejected = this.otherCallRejected);
      }
      d.prototype.callFulfilled = function(x) {
        o.resolve(this.promise, x);
      }, d.prototype.otherCallFulfilled = function(x) {
        f(this.promise, this.onFulfilled, x);
      }, d.prototype.callRejected = function(x) {
        o.reject(this.promise, x);
      }, d.prototype.otherCallRejected = function(x) {
        f(this.promise, this.onRejected, x);
      };
      function f(x, w, S) {
        a(function() {
          var T;
          try {
            T = w(S);
          } catch (C) {
            return o.reject(x, C);
          }
          T === x ? o.reject(x, new TypeError("Cannot resolve promise with itself")) : o.resolve(x, T);
        });
      }
      o.resolve = function(x, w) {
        var S = b(m, w);
        if (S.status === "error")
          return o.reject(x, S.value);
        var T = S.value;
        if (T)
          p(x, T);
        else {
          x.state = u, x.outcome = w;
          for (var C = -1, D = x.queue.length; ++C < D; )
            x.queue[C].callFulfilled(w);
        }
        return x;
      }, o.reject = function(x, w) {
        x.state = l, x.outcome = w;
        for (var S = -1, T = x.queue.length; ++S < T; )
          x.queue[S].callRejected(w);
        return x;
      };
      function m(x) {
        var w = x && x.then;
        if (x && (typeof x == "object" || typeof x == "function") && typeof w == "function")
          return function() {
            w.apply(x, arguments);
          };
      }
      function p(x, w) {
        var S = !1;
        function T(P) {
          S || (S = !0, o.reject(x, P));
        }
        function C(P) {
          S || (S = !0, o.resolve(x, P));
        }
        function D() {
          w(C, T);
        }
        var R = b(D);
        R.status === "error" && T(R.value);
      }
      function b(x, w) {
        var S = {};
        try {
          S.value = x(w), S.status = "success";
        } catch (T) {
          S.status = "error", S.value = T;
        }
        return S;
      }
      c.resolve = y;
      function y(x) {
        return x instanceof this ? x : o.resolve(new this(s), x);
      }
      c.reject = v;
      function v(x) {
        var w = new this(s);
        return o.reject(w, x);
      }
      c.all = g;
      function g(x) {
        var w = this;
        if (Object.prototype.toString.call(x) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var S = x.length, T = !1;
        if (!S)
          return this.resolve([]);
        for (var C = new Array(S), D = 0, R = -1, P = new this(s); ++R < S; )
          N(x[R], R);
        return P;
        function N($, O) {
          w.resolve($).then(M, function(F) {
            T || (T = !0, o.reject(P, F));
          });
          function M(F) {
            C[O] = F, ++D === S && !T && (T = !0, o.resolve(P, C));
          }
        }
      }
      c.race = E;
      function E(x) {
        var w = this;
        if (Object.prototype.toString.call(x) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var S = x.length, T = !1;
        if (!S)
          return this.resolve([]);
        for (var C = -1, D = new this(s); ++C < S; )
          R(x[C]);
        return D;
        function R(P) {
          w.resolve(P).then(function(N) {
            T || (T = !0, o.resolve(D, N));
          }, function(N) {
            T || (T = !0, o.reject(D, N));
          });
        }
      }
    }, { 1: 1 }], 3: [function(i, t, n) {
      (function(a) {
        typeof a.Promise != "function" && (a.Promise = i(2));
      }).call(this, typeof fn < "u" ? fn : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, { 2: 2 }], 4: [function(i, t, n) {
      var a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(de) {
        return typeof de;
      } : function(de) {
        return de && typeof Symbol == "function" && de.constructor === Symbol && de !== Symbol.prototype ? "symbol" : typeof de;
      };
      function s(de, Ee) {
        if (!(de instanceof Ee))
          throw new TypeError("Cannot call a class as a function");
      }
      function o() {
        try {
          if (typeof indexedDB < "u")
            return indexedDB;
          if (typeof webkitIndexedDB < "u")
            return webkitIndexedDB;
          if (typeof mozIndexedDB < "u")
            return mozIndexedDB;
          if (typeof OIndexedDB < "u")
            return OIndexedDB;
          if (typeof msIndexedDB < "u")
            return msIndexedDB;
        } catch {
          return;
        }
      }
      var l = o();
      function u() {
        try {
          if (!l || !l.open)
            return !1;
          var de = typeof openDatabase < "u" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform), Ee = typeof fetch == "function" && fetch.toString().indexOf("[native code") !== -1;
          return (!de || Ee) && typeof indexedDB < "u" && typeof IDBKeyRange < "u";
        } catch {
          return !1;
        }
      }
      function h(de, Ee) {
        de = de || [], Ee = Ee || {};
        try {
          return new Blob(de, Ee);
        } catch (Le) {
          if (Le.name !== "TypeError")
            throw Le;
          for (var ge = typeof BlobBuilder < "u" ? BlobBuilder : typeof MSBlobBuilder < "u" ? MSBlobBuilder : typeof MozBlobBuilder < "u" ? MozBlobBuilder : WebKitBlobBuilder, Me = new ge(), Ge = 0; Ge < de.length; Ge += 1)
            Me.append(de[Ge]);
          return Me.getBlob(Ee.type);
        }
      }
      typeof Promise > "u" && i(3);
      var c = Promise;
      function d(de, Ee) {
        Ee && de.then(function(ge) {
          Ee(null, ge);
        }, function(ge) {
          Ee(ge);
        });
      }
      function f(de, Ee, ge) {
        typeof Ee == "function" && de.then(Ee), typeof ge == "function" && de.catch(ge);
      }
      function m(de) {
        return typeof de != "string" && (console.warn(de + " used as a key, but it is not a string."), de = String(de)), de;
      }
      function p() {
        if (arguments.length && typeof arguments[arguments.length - 1] == "function")
          return arguments[arguments.length - 1];
      }
      var b = "local-forage-detect-blob-support", y = void 0, v = {}, g = Object.prototype.toString, E = "readonly", x = "readwrite";
      function w(de) {
        for (var Ee = de.length, ge = new ArrayBuffer(Ee), Me = new Uint8Array(ge), Ge = 0; Ge < Ee; Ge++)
          Me[Ge] = de.charCodeAt(Ge);
        return ge;
      }
      function S(de) {
        return new c(function(Ee) {
          var ge = de.transaction(b, x), Me = h([""]);
          ge.objectStore(b).put(Me, "key"), ge.onabort = function(Ge) {
            Ge.preventDefault(), Ge.stopPropagation(), Ee(!1);
          }, ge.oncomplete = function() {
            var Ge = navigator.userAgent.match(/Chrome\/(\d+)/), Le = navigator.userAgent.match(/Edge\//);
            Ee(Le || !Ge || parseInt(Ge[1], 10) >= 43);
          };
        }).catch(function() {
          return !1;
        });
      }
      function T(de) {
        return typeof y == "boolean" ? c.resolve(y) : S(de).then(function(Ee) {
          return y = Ee, y;
        });
      }
      function C(de) {
        var Ee = v[de.name], ge = {};
        ge.promise = new c(function(Me, Ge) {
          ge.resolve = Me, ge.reject = Ge;
        }), Ee.deferredOperations.push(ge), Ee.dbReady ? Ee.dbReady = Ee.dbReady.then(function() {
          return ge.promise;
        }) : Ee.dbReady = ge.promise;
      }
      function D(de) {
        var Ee = v[de.name], ge = Ee.deferredOperations.pop();
        if (ge)
          return ge.resolve(), ge.promise;
      }
      function R(de, Ee) {
        var ge = v[de.name], Me = ge.deferredOperations.pop();
        if (Me)
          return Me.reject(Ee), Me.promise;
      }
      function P(de, Ee) {
        return new c(function(ge, Me) {
          if (v[de.name] = v[de.name] || ce(), de.db)
            if (Ee)
              C(de), de.db.close();
            else
              return ge(de.db);
          var Ge = [de.name];
          Ee && Ge.push(de.version);
          var Le = l.open.apply(l, Ge);
          Ee && (Le.onupgradeneeded = function(et) {
            var yt = Le.result;
            try {
              yt.createObjectStore(de.storeName), et.oldVersion <= 1 && yt.createObjectStore(b);
            } catch (gt) {
              if (gt.name === "ConstraintError")
                console.warn('The database "' + de.name + '" has been upgraded from version ' + et.oldVersion + " to version " + et.newVersion + ', but the storage "' + de.storeName + '" already exists.');
              else
                throw gt;
            }
          }), Le.onerror = function(et) {
            et.preventDefault(), Me(Le.error);
          }, Le.onsuccess = function() {
            var et = Le.result;
            et.onversionchange = function(yt) {
              yt.target.close();
            }, ge(et), D(de);
          };
        });
      }
      function N(de) {
        return P(de, !1);
      }
      function $(de) {
        return P(de, !0);
      }
      function O(de, Ee) {
        if (!de.db)
          return !0;
        var ge = !de.db.objectStoreNames.contains(de.storeName), Me = de.version < de.db.version, Ge = de.version > de.db.version;
        if (Me && (de.version !== Ee && console.warn('The database "' + de.name + `" can't be downgraded from version ` + de.db.version + " to version " + de.version + "."), de.version = de.db.version), Ge || ge) {
          if (ge) {
            var Le = de.db.version + 1;
            Le > de.version && (de.version = Le);
          }
          return !0;
        }
        return !1;
      }
      function M(de) {
        return new c(function(Ee, ge) {
          var Me = new FileReader();
          Me.onerror = ge, Me.onloadend = function(Ge) {
            var Le = btoa(Ge.target.result || "");
            Ee({
              __local_forage_encoded_blob: !0,
              data: Le,
              type: de.type
            });
          }, Me.readAsBinaryString(de);
        });
      }
      function F(de) {
        var Ee = w(atob(de.data));
        return h([Ee], { type: de.type });
      }
      function G(de) {
        return de && de.__local_forage_encoded_blob;
      }
      function K(de) {
        var Ee = this, ge = Ee._initReady().then(function() {
          var Me = v[Ee._dbInfo.name];
          if (Me && Me.dbReady)
            return Me.dbReady;
        });
        return f(ge, de, de), ge;
      }
      function J(de) {
        C(de);
        for (var Ee = v[de.name], ge = Ee.forages, Me = 0; Me < ge.length; Me++) {
          var Ge = ge[Me];
          Ge._dbInfo.db && (Ge._dbInfo.db.close(), Ge._dbInfo.db = null);
        }
        return de.db = null, N(de).then(function(Le) {
          return de.db = Le, O(de) ? $(de) : Le;
        }).then(function(Le) {
          de.db = Ee.db = Le;
          for (var et = 0; et < ge.length; et++)
            ge[et]._dbInfo.db = Le;
        }).catch(function(Le) {
          throw R(de, Le), Le;
        });
      }
      function ue(de, Ee, ge, Me) {
        Me === void 0 && (Me = 1);
        try {
          var Ge = de.db.transaction(de.storeName, Ee);
          ge(null, Ge);
        } catch (Le) {
          if (Me > 0 && (!de.db || Le.name === "InvalidStateError" || Le.name === "NotFoundError"))
            return c.resolve().then(function() {
              if (!de.db || Le.name === "NotFoundError" && !de.db.objectStoreNames.contains(de.storeName) && de.version <= de.db.version)
                return de.db && (de.version = de.db.version + 1), $(de);
            }).then(function() {
              return J(de).then(function() {
                ue(de, Ee, ge, Me - 1);
              });
            }).catch(ge);
          ge(Le);
        }
      }
      function ce() {
        return {
          forages: [],
          db: null,
          dbReady: null,
          deferredOperations: []
        };
      }
      function ee(de) {
        var Ee = this, ge = {
          db: null
        };
        if (de)
          for (var Me in de)
            ge[Me] = de[Me];
        var Ge = v[ge.name];
        Ge || (Ge = ce(), v[ge.name] = Ge), Ge.forages.push(Ee), Ee._initReady || (Ee._initReady = Ee.ready, Ee.ready = K);
        var Le = [];
        function et() {
          return c.resolve();
        }
        for (var yt = 0; yt < Ge.forages.length; yt++) {
          var gt = Ge.forages[yt];
          gt !== Ee && Le.push(gt._initReady().catch(et));
        }
        var St = Ge.forages.slice(0);
        return c.all(Le).then(function() {
          return ge.db = Ge.db, N(ge);
        }).then(function(kt) {
          return ge.db = kt, O(ge, Ee._defaultConfig.version) ? $(ge) : kt;
        }).then(function(kt) {
          ge.db = Ge.db = kt, Ee._dbInfo = ge;
          for (var Qt = 0; Qt < St.length; Qt++) {
            var _r = St[Qt];
            _r !== Ee && (_r._dbInfo.db = ge.db, _r._dbInfo.version = ge.version);
          }
        });
      }
      function me(de, Ee) {
        var ge = this;
        de = m(de);
        var Me = new c(function(Ge, Le) {
          ge.ready().then(function() {
            ue(ge._dbInfo, E, function(et, yt) {
              if (et)
                return Le(et);
              try {
                var gt = yt.objectStore(ge._dbInfo.storeName), St = gt.get(de);
                St.onsuccess = function() {
                  var kt = St.result;
                  kt === void 0 && (kt = null), G(kt) && (kt = F(kt)), Ge(kt);
                }, St.onerror = function() {
                  Le(St.error);
                };
              } catch (kt) {
                Le(kt);
              }
            });
          }).catch(Le);
        });
        return d(Me, Ee), Me;
      }
      function Ce(de, Ee) {
        var ge = this, Me = new c(function(Ge, Le) {
          ge.ready().then(function() {
            ue(ge._dbInfo, E, function(et, yt) {
              if (et)
                return Le(et);
              try {
                var gt = yt.objectStore(ge._dbInfo.storeName), St = gt.openCursor(), kt = 1;
                St.onsuccess = function() {
                  var Qt = St.result;
                  if (Qt) {
                    var _r = Qt.value;
                    G(_r) && (_r = F(_r));
                    var Br = de(_r, Qt.key, kt++);
                    Br !== void 0 ? Ge(Br) : Qt.continue();
                  } else
                    Ge();
                }, St.onerror = function() {
                  Le(St.error);
                };
              } catch (Qt) {
                Le(Qt);
              }
            });
          }).catch(Le);
        });
        return d(Me, Ee), Me;
      }
      function Ne(de, Ee, ge) {
        var Me = this;
        de = m(de);
        var Ge = new c(function(Le, et) {
          var yt;
          Me.ready().then(function() {
            return yt = Me._dbInfo, g.call(Ee) === "[object Blob]" ? T(yt.db).then(function(gt) {
              return gt ? Ee : M(Ee);
            }) : Ee;
          }).then(function(gt) {
            ue(Me._dbInfo, x, function(St, kt) {
              if (St)
                return et(St);
              try {
                var Qt = kt.objectStore(Me._dbInfo.storeName);
                gt === null && (gt = void 0);
                var _r = Qt.put(gt, de);
                kt.oncomplete = function() {
                  gt === void 0 && (gt = null), Le(gt);
                }, kt.onabort = kt.onerror = function() {
                  var Br = _r.error ? _r.error : _r.transaction.error;
                  et(Br);
                };
              } catch (Br) {
                et(Br);
              }
            });
          }).catch(et);
        });
        return d(Ge, ge), Ge;
      }
      function ot(de, Ee) {
        var ge = this;
        de = m(de);
        var Me = new c(function(Ge, Le) {
          ge.ready().then(function() {
            ue(ge._dbInfo, x, function(et, yt) {
              if (et)
                return Le(et);
              try {
                var gt = yt.objectStore(ge._dbInfo.storeName), St = gt.delete(de);
                yt.oncomplete = function() {
                  Ge();
                }, yt.onerror = function() {
                  Le(St.error);
                }, yt.onabort = function() {
                  var kt = St.error ? St.error : St.transaction.error;
                  Le(kt);
                };
              } catch (kt) {
                Le(kt);
              }
            });
          }).catch(Le);
        });
        return d(Me, Ee), Me;
      }
      function ze(de) {
        var Ee = this, ge = new c(function(Me, Ge) {
          Ee.ready().then(function() {
            ue(Ee._dbInfo, x, function(Le, et) {
              if (Le)
                return Ge(Le);
              try {
                var yt = et.objectStore(Ee._dbInfo.storeName), gt = yt.clear();
                et.oncomplete = function() {
                  Me();
                }, et.onabort = et.onerror = function() {
                  var St = gt.error ? gt.error : gt.transaction.error;
                  Ge(St);
                };
              } catch (St) {
                Ge(St);
              }
            });
          }).catch(Ge);
        });
        return d(ge, de), ge;
      }
      function $e(de) {
        var Ee = this, ge = new c(function(Me, Ge) {
          Ee.ready().then(function() {
            ue(Ee._dbInfo, E, function(Le, et) {
              if (Le)
                return Ge(Le);
              try {
                var yt = et.objectStore(Ee._dbInfo.storeName), gt = yt.count();
                gt.onsuccess = function() {
                  Me(gt.result);
                }, gt.onerror = function() {
                  Ge(gt.error);
                };
              } catch (St) {
                Ge(St);
              }
            });
          }).catch(Ge);
        });
        return d(ge, de), ge;
      }
      function Ze(de, Ee) {
        var ge = this, Me = new c(function(Ge, Le) {
          if (de < 0) {
            Ge(null);
            return;
          }
          ge.ready().then(function() {
            ue(ge._dbInfo, E, function(et, yt) {
              if (et)
                return Le(et);
              try {
                var gt = yt.objectStore(ge._dbInfo.storeName), St = !1, kt = gt.openKeyCursor();
                kt.onsuccess = function() {
                  var Qt = kt.result;
                  if (!Qt) {
                    Ge(null);
                    return;
                  }
                  de === 0 || St ? Ge(Qt.key) : (St = !0, Qt.advance(de));
                }, kt.onerror = function() {
                  Le(kt.error);
                };
              } catch (Qt) {
                Le(Qt);
              }
            });
          }).catch(Le);
        });
        return d(Me, Ee), Me;
      }
      function Ut(de) {
        var Ee = this, ge = new c(function(Me, Ge) {
          Ee.ready().then(function() {
            ue(Ee._dbInfo, E, function(Le, et) {
              if (Le)
                return Ge(Le);
              try {
                var yt = et.objectStore(Ee._dbInfo.storeName), gt = yt.openKeyCursor(), St = [];
                gt.onsuccess = function() {
                  var kt = gt.result;
                  if (!kt) {
                    Me(St);
                    return;
                  }
                  St.push(kt.key), kt.continue();
                }, gt.onerror = function() {
                  Ge(gt.error);
                };
              } catch (kt) {
                Ge(kt);
              }
            });
          }).catch(Ge);
        });
        return d(ge, de), ge;
      }
      function qt(de, Ee) {
        Ee = p.apply(this, arguments);
        var ge = this.config();
        de = typeof de != "function" && de || {}, de.name || (de.name = de.name || ge.name, de.storeName = de.storeName || ge.storeName);
        var Me = this, Ge;
        if (!de.name)
          Ge = c.reject("Invalid arguments");
        else {
          var Le = de.name === ge.name && Me._dbInfo.db, et = Le ? c.resolve(Me._dbInfo.db) : N(de).then(function(yt) {
            var gt = v[de.name], St = gt.forages;
            gt.db = yt;
            for (var kt = 0; kt < St.length; kt++)
              St[kt]._dbInfo.db = yt;
            return yt;
          });
          de.storeName ? Ge = et.then(function(yt) {
            if (!!yt.objectStoreNames.contains(de.storeName)) {
              var gt = yt.version + 1;
              C(de);
              var St = v[de.name], kt = St.forages;
              yt.close();
              for (var Qt = 0; Qt < kt.length; Qt++) {
                var _r = kt[Qt];
                _r._dbInfo.db = null, _r._dbInfo.version = gt;
              }
              var Br = new c(function(jr, Ai) {
                var mr = l.open(de.name, gt);
                mr.onerror = function(Ki) {
                  var ra = mr.result;
                  ra.close(), Ai(Ki);
                }, mr.onupgradeneeded = function() {
                  var Ki = mr.result;
                  Ki.deleteObjectStore(de.storeName);
                }, mr.onsuccess = function() {
                  var Ki = mr.result;
                  Ki.close(), jr(Ki);
                };
              });
              return Br.then(function(jr) {
                St.db = jr;
                for (var Ai = 0; Ai < kt.length; Ai++) {
                  var mr = kt[Ai];
                  mr._dbInfo.db = jr, D(mr._dbInfo);
                }
              }).catch(function(jr) {
                throw (R(de, jr) || c.resolve()).catch(function() {
                }), jr;
              });
            }
          }) : Ge = et.then(function(yt) {
            C(de);
            var gt = v[de.name], St = gt.forages;
            yt.close();
            for (var kt = 0; kt < St.length; kt++) {
              var Qt = St[kt];
              Qt._dbInfo.db = null;
            }
            var _r = new c(function(Br, jr) {
              var Ai = l.deleteDatabase(de.name);
              Ai.onerror = function() {
                var mr = Ai.result;
                mr && mr.close(), jr(Ai.error);
              }, Ai.onblocked = function() {
                console.warn('dropInstance blocked for database "' + de.name + '" until all open connections are closed');
              }, Ai.onsuccess = function() {
                var mr = Ai.result;
                mr && mr.close(), Br(mr);
              };
            });
            return _r.then(function(Br) {
              gt.db = Br;
              for (var jr = 0; jr < St.length; jr++) {
                var Ai = St[jr];
                D(Ai._dbInfo);
              }
            }).catch(function(Br) {
              throw (R(de, Br) || c.resolve()).catch(function() {
              }), Br;
            });
          });
        }
        return d(Ge, Ee), Ge;
      }
      var ir = {
        _driver: "asyncStorage",
        _initStorage: ee,
        _support: u(),
        iterate: Ce,
        getItem: me,
        setItem: Ne,
        removeItem: ot,
        clear: ze,
        length: $e,
        key: Ze,
        keys: Ut,
        dropInstance: qt
      };
      function We() {
        return typeof openDatabase == "function";
      }
      var vt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Tt = "~~local_forage_type~", xt = /^~~local_forage_type~([^~]+)~/, Pt = "__lfsc__:", at = Pt.length, Ot = "arbf", It = "blob", sr = "si08", lt = "ui08", ri = "uic8", Qr = "si16", xr = "si32", _i = "ur16", Gr = "ui32", li = "fl32", ci = "fl64", oi = at + Ot.length, Kr = Object.prototype.toString;
      function mn(de) {
        var Ee = de.length * 0.75, ge = de.length, Me, Ge = 0, Le, et, yt, gt;
        de[de.length - 1] === "=" && (Ee--, de[de.length - 2] === "=" && Ee--);
        var St = new ArrayBuffer(Ee), kt = new Uint8Array(St);
        for (Me = 0; Me < ge; Me += 4)
          Le = vt.indexOf(de[Me]), et = vt.indexOf(de[Me + 1]), yt = vt.indexOf(de[Me + 2]), gt = vt.indexOf(de[Me + 3]), kt[Ge++] = Le << 2 | et >> 4, kt[Ge++] = (et & 15) << 4 | yt >> 2, kt[Ge++] = (yt & 3) << 6 | gt & 63;
        return St;
      }
      function wa(de) {
        var Ee = new Uint8Array(de), ge = "", Me;
        for (Me = 0; Me < Ee.length; Me += 3)
          ge += vt[Ee[Me] >> 2], ge += vt[(Ee[Me] & 3) << 4 | Ee[Me + 1] >> 4], ge += vt[(Ee[Me + 1] & 15) << 2 | Ee[Me + 2] >> 6], ge += vt[Ee[Me + 2] & 63];
        return Ee.length % 3 === 2 ? ge = ge.substring(0, ge.length - 1) + "=" : Ee.length % 3 === 1 && (ge = ge.substring(0, ge.length - 2) + "=="), ge;
      }
      function Ys(de, Ee) {
        var ge = "";
        if (de && (ge = Kr.call(de)), de && (ge === "[object ArrayBuffer]" || de.buffer && Kr.call(de.buffer) === "[object ArrayBuffer]")) {
          var Me, Ge = Pt;
          de instanceof ArrayBuffer ? (Me = de, Ge += Ot) : (Me = de.buffer, ge === "[object Int8Array]" ? Ge += sr : ge === "[object Uint8Array]" ? Ge += lt : ge === "[object Uint8ClampedArray]" ? Ge += ri : ge === "[object Int16Array]" ? Ge += Qr : ge === "[object Uint16Array]" ? Ge += _i : ge === "[object Int32Array]" ? Ge += xr : ge === "[object Uint32Array]" ? Ge += Gr : ge === "[object Float32Array]" ? Ge += li : ge === "[object Float64Array]" ? Ge += ci : Ee(new Error("Failed to get type for BinaryArray"))), Ee(Ge + wa(Me));
        } else if (ge === "[object Blob]") {
          var Le = new FileReader();
          Le.onload = function() {
            var et = Tt + de.type + "~" + wa(this.result);
            Ee(Pt + It + et);
          }, Le.readAsArrayBuffer(de);
        } else
          try {
            Ee(JSON.stringify(de));
          } catch (et) {
            console.error("Couldn't convert value into a JSON string: ", de), Ee(null, et);
          }
      }
      function za(de) {
        if (de.substring(0, at) !== Pt)
          return JSON.parse(de);
        var Ee = de.substring(oi), ge = de.substring(at, oi), Me;
        if (ge === It && xt.test(Ee)) {
          var Ge = Ee.match(xt);
          Me = Ge[1], Ee = Ee.substring(Ge[0].length);
        }
        var Le = mn(Ee);
        switch (ge) {
          case Ot:
            return Le;
          case It:
            return h([Le], { type: Me });
          case sr:
            return new Int8Array(Le);
          case lt:
            return new Uint8Array(Le);
          case ri:
            return new Uint8ClampedArray(Le);
          case Qr:
            return new Int16Array(Le);
          case _i:
            return new Uint16Array(Le);
          case xr:
            return new Int32Array(Le);
          case Gr:
            return new Uint32Array(Le);
          case li:
            return new Float32Array(Le);
          case ci:
            return new Float64Array(Le);
          default:
            throw new Error("Unkown type: " + ge);
        }
      }
      var jn = {
        serialize: Ys,
        deserialize: za,
        stringToBuffer: mn,
        bufferToString: wa
      };
      function Xa(de, Ee, ge, Me) {
        de.executeSql("CREATE TABLE IF NOT EXISTS " + Ee.storeName + " (id INTEGER PRIMARY KEY, key unique, value)", [], ge, Me);
      }
      function Ks(de) {
        var Ee = this, ge = {
          db: null
        };
        if (de)
          for (var Me in de)
            ge[Me] = typeof de[Me] != "string" ? de[Me].toString() : de[Me];
        var Ge = new c(function(Le, et) {
          try {
            ge.db = openDatabase(ge.name, String(ge.version), ge.description, ge.size);
          } catch (yt) {
            return et(yt);
          }
          ge.db.transaction(function(yt) {
            Xa(yt, ge, function() {
              Ee._dbInfo = ge, Le();
            }, function(gt, St) {
              et(St);
            });
          }, et);
        });
        return ge.serializer = jn, Ge;
      }
      function yn(de, Ee, ge, Me, Ge, Le) {
        de.executeSql(ge, Me, Ge, function(et, yt) {
          yt.code === yt.SYNTAX_ERR ? et.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [Ee.storeName], function(gt, St) {
            St.rows.length ? Le(gt, yt) : Xa(gt, Ee, function() {
              gt.executeSql(ge, Me, Ge, Le);
            }, Le);
          }, Le) : Le(et, yt);
        }, Le);
      }
      function ha(de, Ee) {
        var ge = this;
        de = m(de);
        var Me = new c(function(Ge, Le) {
          ge.ready().then(function() {
            var et = ge._dbInfo;
            et.db.transaction(function(yt) {
              yn(yt, et, "SELECT * FROM " + et.storeName + " WHERE key = ? LIMIT 1", [de], function(gt, St) {
                var kt = St.rows.length ? St.rows.item(0).value : null;
                kt && (kt = et.serializer.deserialize(kt)), Ge(kt);
              }, function(gt, St) {
                Le(St);
              });
            });
          }).catch(Le);
        });
        return d(Me, Ee), Me;
      }
      function Ei(de, Ee) {
        var ge = this, Me = new c(function(Ge, Le) {
          ge.ready().then(function() {
            var et = ge._dbInfo;
            et.db.transaction(function(yt) {
              yn(yt, et, "SELECT * FROM " + et.storeName, [], function(gt, St) {
                for (var kt = St.rows, Qt = kt.length, _r = 0; _r < Qt; _r++) {
                  var Br = kt.item(_r), jr = Br.value;
                  if (jr && (jr = et.serializer.deserialize(jr)), jr = de(jr, Br.key, _r + 1), jr !== void 0) {
                    Ge(jr);
                    return;
                  }
                }
                Ge();
              }, function(gt, St) {
                Le(St);
              });
            });
          }).catch(Le);
        });
        return d(Me, Ee), Me;
      }
      function ys(de, Ee, ge, Me) {
        var Ge = this;
        de = m(de);
        var Le = new c(function(et, yt) {
          Ge.ready().then(function() {
            Ee === void 0 && (Ee = null);
            var gt = Ee, St = Ge._dbInfo;
            St.serializer.serialize(Ee, function(kt, Qt) {
              Qt ? yt(Qt) : St.db.transaction(function(_r) {
                yn(_r, St, "INSERT OR REPLACE INTO " + St.storeName + " (key, value) VALUES (?, ?)", [de, kt], function() {
                  et(gt);
                }, function(Br, jr) {
                  yt(jr);
                });
              }, function(_r) {
                if (_r.code === _r.QUOTA_ERR) {
                  if (Me > 0) {
                    et(ys.apply(Ge, [de, gt, ge, Me - 1]));
                    return;
                  }
                  yt(_r);
                }
              });
            });
          }).catch(yt);
        });
        return d(Le, ge), Le;
      }
      function Ro(de, Ee, ge) {
        return ys.apply(this, [de, Ee, ge, 1]);
      }
      function zs(de, Ee) {
        var ge = this;
        de = m(de);
        var Me = new c(function(Ge, Le) {
          ge.ready().then(function() {
            var et = ge._dbInfo;
            et.db.transaction(function(yt) {
              yn(yt, et, "DELETE FROM " + et.storeName + " WHERE key = ?", [de], function() {
                Ge();
              }, function(gt, St) {
                Le(St);
              });
            });
          }).catch(Le);
        });
        return d(Me, Ee), Me;
      }
      function Ja(de) {
        var Ee = this, ge = new c(function(Me, Ge) {
          Ee.ready().then(function() {
            var Le = Ee._dbInfo;
            Le.db.transaction(function(et) {
              yn(et, Le, "DELETE FROM " + Le.storeName, [], function() {
                Me();
              }, function(yt, gt) {
                Ge(gt);
              });
            });
          }).catch(Ge);
        });
        return d(ge, de), ge;
      }
      function _n(de) {
        var Ee = this, ge = new c(function(Me, Ge) {
          Ee.ready().then(function() {
            var Le = Ee._dbInfo;
            Le.db.transaction(function(et) {
              yn(et, Le, "SELECT COUNT(key) as c FROM " + Le.storeName, [], function(yt, gt) {
                var St = gt.rows.item(0).c;
                Me(St);
              }, function(yt, gt) {
                Ge(gt);
              });
            });
          }).catch(Ge);
        });
        return d(ge, de), ge;
      }
      function Ca(de, Ee) {
        var ge = this, Me = new c(function(Ge, Le) {
          ge.ready().then(function() {
            var et = ge._dbInfo;
            et.db.transaction(function(yt) {
              yn(yt, et, "SELECT key FROM " + et.storeName + " WHERE id = ? LIMIT 1", [de + 1], function(gt, St) {
                var kt = St.rows.length ? St.rows.item(0).key : null;
                Ge(kt);
              }, function(gt, St) {
                Le(St);
              });
            });
          }).catch(Le);
        });
        return d(Me, Ee), Me;
      }
      function Da(de) {
        var Ee = this, ge = new c(function(Me, Ge) {
          Ee.ready().then(function() {
            var Le = Ee._dbInfo;
            Le.db.transaction(function(et) {
              yn(et, Le, "SELECT key FROM " + Le.storeName, [], function(yt, gt) {
                for (var St = [], kt = 0; kt < gt.rows.length; kt++)
                  St.push(gt.rows.item(kt).key);
                Me(St);
              }, function(yt, gt) {
                Ge(gt);
              });
            });
          }).catch(Ge);
        });
        return d(ge, de), ge;
      }
      function on(de) {
        return new c(function(Ee, ge) {
          de.transaction(function(Me) {
            Me.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(Ge, Le) {
              for (var et = [], yt = 0; yt < Le.rows.length; yt++)
                et.push(Le.rows.item(yt).name);
              Ee({
                db: de,
                storeNames: et
              });
            }, function(Ge, Le) {
              ge(Le);
            });
          }, function(Me) {
            ge(Me);
          });
        });
      }
      function Po(de, Ee) {
        Ee = p.apply(this, arguments);
        var ge = this.config();
        de = typeof de != "function" && de || {}, de.name || (de.name = de.name || ge.name, de.storeName = de.storeName || ge.storeName);
        var Me = this, Ge;
        return de.name ? Ge = new c(function(Le) {
          var et;
          de.name === ge.name ? et = Me._dbInfo.db : et = openDatabase(de.name, "", "", 0), de.storeName ? Le({
            db: et,
            storeNames: [de.storeName]
          }) : Le(on(et));
        }).then(function(Le) {
          return new c(function(et, yt) {
            Le.db.transaction(function(gt) {
              function St(Br) {
                return new c(function(jr, Ai) {
                  gt.executeSql("DROP TABLE IF EXISTS " + Br, [], function() {
                    jr();
                  }, function(mr, Ki) {
                    Ai(Ki);
                  });
                });
              }
              for (var kt = [], Qt = 0, _r = Le.storeNames.length; Qt < _r; Qt++)
                kt.push(St(Le.storeNames[Qt]));
              c.all(kt).then(function() {
                et();
              }).catch(function(Br) {
                yt(Br);
              });
            }, function(gt) {
              yt(gt);
            });
          });
        }) : Ge = c.reject("Invalid arguments"), d(Ge, Ee), Ge;
      }
      var _s = {
        _driver: "webSQLStorage",
        _initStorage: Ks,
        _support: We(),
        iterate: Ei,
        getItem: ha,
        setItem: Ro,
        removeItem: zs,
        clear: Ja,
        length: _n,
        key: Ca,
        keys: Da,
        dropInstance: Po
      };
      function bs() {
        try {
          return typeof localStorage < "u" && "setItem" in localStorage && !!localStorage.setItem;
        } catch {
          return !1;
        }
      }
      function Oo(de, Ee) {
        var ge = de.name + "/";
        return de.storeName !== Ee.storeName && (ge += de.storeName + "/"), ge;
      }
      function $n() {
        var de = "_localforage_support_test";
        try {
          return localStorage.setItem(de, !0), localStorage.removeItem(de), !1;
        } catch {
          return !0;
        }
      }
      function ui() {
        return !$n() || localStorage.length > 0;
      }
      function Ts(de) {
        var Ee = this, ge = {};
        if (de)
          for (var Me in de)
            ge[Me] = de[Me];
        return ge.keyPrefix = Oo(de, Ee._defaultConfig), ui() ? (Ee._dbInfo = ge, ge.serializer = jn, c.resolve()) : c.reject();
      }
      function Qi(de) {
        var Ee = this, ge = Ee.ready().then(function() {
          for (var Me = Ee._dbInfo.keyPrefix, Ge = localStorage.length - 1; Ge >= 0; Ge--) {
            var Le = localStorage.key(Ge);
            Le.indexOf(Me) === 0 && localStorage.removeItem(Le);
          }
        });
        return d(ge, de), ge;
      }
      function Ss(de, Ee) {
        var ge = this;
        de = m(de);
        var Me = ge.ready().then(function() {
          var Ge = ge._dbInfo, Le = localStorage.getItem(Ge.keyPrefix + de);
          return Le && (Le = Ge.serializer.deserialize(Le)), Le;
        });
        return d(Me, Ee), Me;
      }
      function ka(de, Ee) {
        var ge = this, Me = ge.ready().then(function() {
          for (var Ge = ge._dbInfo, Le = Ge.keyPrefix, et = Le.length, yt = localStorage.length, gt = 1, St = 0; St < yt; St++) {
            var kt = localStorage.key(St);
            if (kt.indexOf(Le) === 0) {
              var Qt = localStorage.getItem(kt);
              if (Qt && (Qt = Ge.serializer.deserialize(Qt)), Qt = de(Qt, kt.substring(et), gt++), Qt !== void 0)
                return Qt;
            }
          }
        });
        return d(Me, Ee), Me;
      }
      function pa(de, Ee) {
        var ge = this, Me = ge.ready().then(function() {
          var Ge = ge._dbInfo, Le;
          try {
            Le = localStorage.key(de);
          } catch {
            Le = null;
          }
          return Le && (Le = Le.substring(Ge.keyPrefix.length)), Le;
        });
        return d(Me, Ee), Me;
      }
      function Qa(de) {
        var Ee = this, ge = Ee.ready().then(function() {
          for (var Me = Ee._dbInfo, Ge = localStorage.length, Le = [], et = 0; et < Ge; et++) {
            var yt = localStorage.key(et);
            yt.indexOf(Me.keyPrefix) === 0 && Le.push(yt.substring(Me.keyPrefix.length));
          }
          return Le;
        });
        return d(ge, de), ge;
      }
      function Za(de) {
        var Ee = this, ge = Ee.keys().then(function(Me) {
          return Me.length;
        });
        return d(ge, de), ge;
      }
      function xi(de, Ee) {
        var ge = this;
        de = m(de);
        var Me = ge.ready().then(function() {
          var Ge = ge._dbInfo;
          localStorage.removeItem(Ge.keyPrefix + de);
        });
        return d(Me, Ee), Me;
      }
      function bn(de, Ee, ge) {
        var Me = this;
        de = m(de);
        var Ge = Me.ready().then(function() {
          Ee === void 0 && (Ee = null);
          var Le = Ee;
          return new c(function(et, yt) {
            var gt = Me._dbInfo;
            gt.serializer.serialize(Ee, function(St, kt) {
              if (kt)
                yt(kt);
              else
                try {
                  localStorage.setItem(gt.keyPrefix + de, St), et(Le);
                } catch (Qt) {
                  (Qt.name === "QuotaExceededError" || Qt.name === "NS_ERROR_DOM_QUOTA_REACHED") && yt(Qt), yt(Qt);
                }
            });
          });
        });
        return d(Ge, ge), Ge;
      }
      function Es(de, Ee) {
        if (Ee = p.apply(this, arguments), de = typeof de != "function" && de || {}, !de.name) {
          var ge = this.config();
          de.name = de.name || ge.name, de.storeName = de.storeName || ge.storeName;
        }
        var Me = this, Ge;
        return de.name ? Ge = new c(function(Le) {
          de.storeName ? Le(Oo(de, Me._defaultConfig)) : Le(de.name + "/");
        }).then(function(Le) {
          for (var et = localStorage.length - 1; et >= 0; et--) {
            var yt = localStorage.key(et);
            yt.indexOf(Le) === 0 && localStorage.removeItem(yt);
          }
        }) : Ge = c.reject("Invalid arguments"), d(Ge, Ee), Ge;
      }
      var Ra = {
        _driver: "localStorageWrapper",
        _initStorage: Ts,
        _support: bs(),
        iterate: ka,
        getItem: Ss,
        setItem: bn,
        removeItem: xi,
        clear: Qi,
        length: Za,
        key: pa,
        keys: Qa,
        dropInstance: Es
      }, Dn = function(Ee, ge) {
        return Ee === ge || typeof Ee == "number" && typeof ge == "number" && isNaN(Ee) && isNaN(ge);
      }, xs = function(Ee, ge) {
        for (var Me = Ee.length, Ge = 0; Ge < Me; ) {
          if (Dn(Ee[Ge], ge))
            return !0;
          Ge++;
        }
        return !1;
      }, ta = Array.isArray || function(de) {
        return Object.prototype.toString.call(de) === "[object Array]";
      }, Pa = {}, Xs = {}, Tn = {
        INDEXEDDB: ir,
        WEBSQL: _s,
        LOCALSTORAGE: Ra
      }, es = [Tn.INDEXEDDB._driver, Tn.WEBSQL._driver, Tn.LOCALSTORAGE._driver], ga = ["dropInstance"], un = ["clear", "getItem", "iterate", "key", "keys", "length", "removeItem", "setItem"].concat(ga), As = {
        description: "",
        driver: es.slice(),
        name: "localforage",
        size: 4980736,
        storeName: "keyvaluepairs",
        version: 1
      };
      function Oa(de, Ee) {
        de[Ee] = function() {
          var ge = arguments;
          return de.ready().then(function() {
            return de[Ee].apply(de, ge);
          });
        };
      }
      function Gn() {
        for (var de = 1; de < arguments.length; de++) {
          var Ee = arguments[de];
          if (Ee)
            for (var ge in Ee)
              Ee.hasOwnProperty(ge) && (ta(Ee[ge]) ? arguments[0][ge] = Ee[ge].slice() : arguments[0][ge] = Ee[ge]);
        }
        return arguments[0];
      }
      var Hn = function() {
        function de(Ee) {
          s(this, de);
          for (var ge in Tn)
            if (Tn.hasOwnProperty(ge)) {
              var Me = Tn[ge], Ge = Me._driver;
              this[ge] = Ge, Pa[Ge] || this.defineDriver(Me);
            }
          this._defaultConfig = Gn({}, As), this._config = Gn({}, this._defaultConfig, Ee), this._driverSet = null, this._initDriver = null, this._ready = !1, this._dbInfo = null, this._wrapLibraryMethodsWithReady(), this.setDriver(this._config.driver).catch(function() {
          });
        }
        return de.prototype.config = function(ge) {
          if ((typeof ge > "u" ? "undefined" : a(ge)) === "object") {
            if (this._ready)
              return new Error("Can't call config() after localforage has been used.");
            for (var Me in ge) {
              if (Me === "storeName" && (ge[Me] = ge[Me].replace(/\W/g, "_")), Me === "version" && typeof ge[Me] != "number")
                return new Error("Database version must be a number.");
              this._config[Me] = ge[Me];
            }
            return "driver" in ge && ge.driver ? this.setDriver(this._config.driver) : !0;
          } else
            return typeof ge == "string" ? this._config[ge] : this._config;
        }, de.prototype.defineDriver = function(ge, Me, Ge) {
          var Le = new c(function(et, yt) {
            try {
              var gt = ge._driver, St = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
              if (!ge._driver) {
                yt(St);
                return;
              }
              for (var kt = un.concat("_initStorage"), Qt = 0, _r = kt.length; Qt < _r; Qt++) {
                var Br = kt[Qt], jr = !xs(ga, Br);
                if ((jr || ge[Br]) && typeof ge[Br] != "function") {
                  yt(St);
                  return;
                }
              }
              var Ai = function() {
                for (var ra = function(Vn) {
                  return function() {
                    var ia = new Error("Method " + Vn + " is not implemented by the current driver"), va = c.reject(ia);
                    return d(va, arguments[arguments.length - 1]), va;
                  };
                }, La = 0, Sn = ga.length; La < Sn; La++) {
                  var Ia = ga[La];
                  ge[Ia] || (ge[Ia] = ra(Ia));
                }
              };
              Ai();
              var mr = function(ra) {
                Pa[gt] && console.info("Redefining LocalForage driver: " + gt), Pa[gt] = ge, Xs[gt] = ra, et();
              };
              "_support" in ge ? ge._support && typeof ge._support == "function" ? ge._support().then(mr, yt) : mr(!!ge._support) : mr(!0);
            } catch (Ki) {
              yt(Ki);
            }
          });
          return f(Le, Me, Ge), Le;
        }, de.prototype.driver = function() {
          return this._driver || null;
        }, de.prototype.getDriver = function(ge, Me, Ge) {
          var Le = Pa[ge] ? c.resolve(Pa[ge]) : c.reject(new Error("Driver not found."));
          return f(Le, Me, Ge), Le;
        }, de.prototype.getSerializer = function(ge) {
          var Me = c.resolve(jn);
          return f(Me, ge), Me;
        }, de.prototype.ready = function(ge) {
          var Me = this, Ge = Me._driverSet.then(function() {
            return Me._ready === null && (Me._ready = Me._initDriver()), Me._ready;
          });
          return f(Ge, ge, ge), Ge;
        }, de.prototype.setDriver = function(ge, Me, Ge) {
          var Le = this;
          ta(ge) || (ge = [ge]);
          var et = this._getSupportedDrivers(ge);
          function yt() {
            Le._config.driver = Le.driver();
          }
          function gt(Qt) {
            return Le._extend(Qt), yt(), Le._ready = Le._initStorage(Le._config), Le._ready;
          }
          function St(Qt) {
            return function() {
              var _r = 0;
              function Br() {
                for (; _r < Qt.length; ) {
                  var jr = Qt[_r];
                  return _r++, Le._dbInfo = null, Le._ready = null, Le.getDriver(jr).then(gt).catch(Br);
                }
                yt();
                var Ai = new Error("No available storage method found.");
                return Le._driverSet = c.reject(Ai), Le._driverSet;
              }
              return Br();
            };
          }
          var kt = this._driverSet !== null ? this._driverSet.catch(function() {
            return c.resolve();
          }) : c.resolve();
          return this._driverSet = kt.then(function() {
            var Qt = et[0];
            return Le._dbInfo = null, Le._ready = null, Le.getDriver(Qt).then(function(_r) {
              Le._driver = _r._driver, yt(), Le._wrapLibraryMethodsWithReady(), Le._initDriver = St(et);
            });
          }).catch(function() {
            yt();
            var Qt = new Error("No available storage method found.");
            return Le._driverSet = c.reject(Qt), Le._driverSet;
          }), f(this._driverSet, Me, Ge), this._driverSet;
        }, de.prototype.supports = function(ge) {
          return !!Xs[ge];
        }, de.prototype._extend = function(ge) {
          Gn(this, ge);
        }, de.prototype._getSupportedDrivers = function(ge) {
          for (var Me = [], Ge = 0, Le = ge.length; Ge < Le; Ge++) {
            var et = ge[Ge];
            this.supports(et) && Me.push(et);
          }
          return Me;
        }, de.prototype._wrapLibraryMethodsWithReady = function() {
          for (var ge = 0, Me = un.length; ge < Me; ge++)
            Oa(this, un[ge]);
        }, de.prototype.createInstance = function(ge) {
          return new de(ge);
        }, de;
      }(), Lo = new Hn();
      t.exports = Lo;
    }, { 3: 3 }] }, {}, [4])(4);
  });
})($E);
const Qp = $E.exports;
fr.service(
  "StorageService",
  function() {
    return this.store = function(e, r) {
      return Qp.setItem(e, r);
    }, this.load = function(e) {
      return Qp.getItem(e);
    }, this.delete = function(e) {
      return Qp.removeItem(e);
    }, this;
  }
);
const gL = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/, vL = /(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/, mL = /^(?:https?:\/\/)?(?:www\.|go\.)?twitch\.tv\/videos\/([a-z0-9_]+)($|\?)/, yL = /^(?:https?:\/\/)?(?:www\.|go\.)?twitch\.tv\/([a-z0-9_]+)($|\?)/;
function _L(e) {
  return e.match(vL) ? "vimeo" : e.match(gL) ? "youtube" : e.match(mL) || e.match(yL) ? "twitch" : "normal";
}
function bL(e) {
  return e.match(/(?:([^:\?#]+):)?(?:\/([^\/?#]*))?([^?#]*\.(?:jpg|jpeg|gif|png))(?:\?([^#]*))?(?:#(.*))?/) !== null || TL(e);
}
function TL(e) {
  return e && e.match(/data:image\/([a-zA-Z]*);base64,([^\"]*)/) !== null;
}
function SL(e) {
  return !bL(e);
}
function EL(e) {
  return e && SL(e) && (e.indexOf(".m3u8") > 0 || e.indexOf("=m3u8") > 0);
}
function xL(e) {
  let r = e || location.search.substring(1);
  try {
    return JSON.parse('{"' + r.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function(i, t) {
      return i === "" ? t : decodeURIComponent(t);
    });
  } catch {
    return {};
  }
}
fr.service(
  "Utils",
  function() {
    return this.uuid = () => {
      function e() {
        return Math.floor((1 + Math.random()) * 65536).toString(16).substring(1);
      }
      return e() + e() + e() + e() + e() + e() + e() + e();
    }, this;
  }
);
fr.factory("Player", ["$q", "$rootScope", "StorageService", "Utils", (e, r, i, t) => {
  let n = e.defer(), a = e.defer(), s = e.defer(), o = e.defer();
  const l = function(h) {
    this.loadData(h), this.playerReady = n.promise, this.videoReady = a.promise, this.imageReady = s.promise, this.videoCompleted = o.promise, this.uuid = t.uuid(), this.muted = !1, this.volume = 100, i.load("vf-player-volume").then((c) => {
      c && (this.muted = c.muted, this.volume = c.volume, this.setVolume(this.muted, this.volume));
    });
  };
  return l.prototype = {
    loadData: function(u) {
      angular.extend(this, u);
    },
    exec: function(u, h) {
      this[u] && ((!h || h.constructor !== Array) && (h = [h]), this[u].apply(this, h));
    },
    whenReady: function() {
      return this.playerReady;
    },
    ready: function() {
      n.resolve();
    },
    whenVideoReady: function() {
      return this.videoReady;
    },
    setVideoReady: function(u) {
      u ? a.resolve() : (a = e.defer(), this.videoReady = a.promise);
    },
    whenVideoCompleted: function() {
      return this.videoCompleted;
    },
    setVideoCompleted: function(u) {
      u ? o.resolve() : (o = e.defer(), this.videoCompleted = o.promise);
    },
    whenImageReady: function() {
      return this.imageReady;
    },
    setImageReady: function(u) {
      u ? s.resolve() : (s = e.defer(), this.imageReady = s.promise);
    },
    setPlayerReady: function(u) {
      u ? n.resolve() : (n = e.defer(), this.playerReady = a.promise);
    },
    abortPromises: function() {
      a.reject(), s.reject(), n.reject();
    },
    broadcast: function(u, h) {
      r.$broadcast(u, h);
    },
    emit: function(u, h) {
      if (window.top !== window.self) {
        var c = {
          type: u,
          payload: h
        };
        window.parent.postMessage(JSON.stringify(c), "*");
      }
    },
    isContainerTransparent: function() {
      try {
        return window.frameElement && window.frameElement.getAttribute("is-transparent") === "true";
      } catch {
        return !1;
      }
    },
    setVolume: function(u, h) {
      h = h || this.volume, document.querySelectorAll(".video").forEach((c) => {
        c.muted = u, c.volume = h / 100;
      });
    },
    getStartPage: function() {
      return this.startPage;
    },
    isNoContent: function() {
      return this.noContent;
    }
  }, l;
}]);
fr.directive("header", () => ({
  restrict: "E",
  template: `
                    <h1>THIS IS A HEADER!!</h1>    
                `,
  replace: !0
}));
fr.constant("PlayerEvents", {
  STATUS: "vf-status",
  PLAY: "vf-play",
  REPLAY: "vf-replay",
  STARTED: "vf-started",
  RESIZE: "vf-resize",
  SEEK: "vf-seek",
  STEREO: "vf-stereo",
  PAGE_LOADED: "vf-page-loaded",
  SHOW_CONTROLS: "vf-show-controls",
  LOW_PERFORMANCE: "vf-low-performance",
  HIDE_INSERTS: "vf-hide-inserts",
  ERROR: "vf-error",
  MANIFEST_PARSED: "vf-manifest-parsed",
  SET_BUFFER: "vf-set-buffer",
  OUTPUT: "vf-output",
  LINK: "vf-link",
  CROP: "vf-crop",
  TRANSFORM: "vf-transform",
  AUDIO_TRACK: "vf-audio-track",
  LOADED: "vf-loaded",
  PLAYING: "vf-playing",
  PAUSED: "vf-paused",
  FAILED: "vf-failed",
  ITEM_CHANGE: "vf-itemchange",
  CURRENT_TIME: "currenttime",
  SECTION_WATCHED: "sectionwatched",
  VIDEO_END: "videoend",
  IMPRESSION: "impression",
  AD_START: "adstart",
  AD_IMPRESSION: "adimpression",
  AD_SKIP: "adskip",
  AD_COMPLETED: "adcompleted"
}).constant("GfxOverlayEvents", {
  RECEIVED: "vf-gfx-events",
  LOADED: "vf-gfx-loaded"
}).constant("NavigationEvents", {
  RELOAD: "vf-reload-navigation",
  RELOAD_FINISHED: "vf-reload-navigation-finished",
  REMOVE: "vf-remove-item",
  REFRESH_TAGS: "vf-refresh-items-tags",
  UPDATE_PRIVACY: "vf-update-privacy",
  UPDATE_API_KEY: "vf-update-api-key",
  SORT: "vf-nav-sort",
  FILTER: "vf-input-filter"
}).constant("WebSocketEvents", {
  EVENT: "vf-ws-event",
  RECONNECT: "vf-ws-reconnect"
}).constant("PaymentEvents", {
  INVOICE_PAYMENT_SUCCESS: "invoice_payment_success",
  INVOICE_PAYMENT_ERROR: "invoice_payment_error"
}).constant("AUTH_EVENTS", {
  loginError: "login-error",
  signupError: "signup-error",
  sessionTimeout: "session-timeout",
  logout: "user-logout",
  login: "user-login"
}).constant("OVERLAY_EVENTS", {
  SERVE_SET_UP: "vf-serve-set-up",
  SERVE_TEAR_DOWN: "vf-serve-tear-down",
  DEPLOYED: "vf-deployed"
}).constant("EntitiesEvents", {
  NEW_ENTITY_CREATED: "new-entity-created",
  NEW_GROUP_CREATED: "new-group-created"
}).constant("ControllerV1Events", {
  TAKE: "controller-v1-take",
  VFF_LOADED: "controller-v1-vff-loaded"
}).constant("ProjectStatsEvents", {
  UPDATED: "project-stats-updated",
  RESIZE: "project-stats-resize",
  WIDGET_CHANGED: "project-stats-widget-changed",
  WIDGET_REMOVE: "project-stats-widget-remove"
}).constant("AppEvents", {
  LOADING: "app-events-loading",
  NO_CONNECTION: "app-events-no-connection"
}).constant("WorkflowEvents", {
  ELEMENT_CHANGED: "workflow-changed",
  ELEMENT_SELECTED: "workflow-element-selected",
  ELEMENT_PREVIEW: "workflow-element-preview",
  REDRAW: "workflow-redraw",
  VALIDATE: "workflow-validate",
  VALIDATION_FINISHED: "workflow-validation-finished",
  DELETE_SELECTED: "workflow-delete-selected",
  OPEN_SETTINGS: "workflow-open-settings",
  PREVIEW: "workflow-preview",
  PREVIEW_NEW_TAB: "workflow-preview-new-tab",
  CONTROLLER: "workflow-controller",
  ENFORCE_HARD_SAVE: "workflow-enforce-hard-save",
  DUPLICATE: "workflow-duplicate",
  COPY: "workflow-copy",
  PASTE: "workflow-paste"
}).constant("ControllerEvents", {
  PAGE_SELECTED: "vf-controller-page-selected",
  MACRO_SELECTED: "vff-macro-selected",
  CONTROLLER_SETTINGS_UPDATED: "vff-controller-settings-updated",
  QUERY_PARAM_SELECTED: "vff-controller-query-param-selected",
  TAKE_BUTTON_FORCE_DISABLE: "vff-controller-take-button-force-disable",
  TAKE: "vff-controller-take",
  IS_LIVE: "vff-controller-is-live",
  STREAM_HEALTH_UPDATE: "vff-controller-stream-health-update",
  VFF_CONTROLS_LOADED: "vff-controls-loaded",
  UPDATE_TEMPLATE_CONTROL_HEIGHT: "vff-controller-update-control-height"
}).constant("UploadEvents", {
  FILE_UPLOAD: "vf-file-upload",
  FILE_UPLOADED: "vf-file-uploaded"
}).constant("StatisticsEvents", {
  SOURCE: {
    SYSTEM: "system",
    TRACK: "track"
  },
  CHANNEL_VIEW: "channel view",
  IMPRESSION: "impression",
  RESOLUTION_RANGE_CHANGED: "resolution_range_changed"
}).constant("CRUDEvents", {
  INPUT_CREATED: "input:create",
  INPUT_UPDATED: "input:update",
  INPUT_DELETED: "input:delete"
});
fr.service("VJSPlaylistPlugin", function() {
  const e = re.getPlugin("plugin"), r = re.extend(e, {
    constructor: function(i, t) {
      e.call(this, i, t), this.setList(t.list || []);
      const n = () => {
        if (i.info.wasLive || i.isIVS())
          this.reloadItem();
        else {
          let a = this.list[++this.index];
          !a && t.loop && (this.index = 0, a = this.list[this.index]), a ? (this.notFirst = !0, this.setItem(a), i.play()) : i.off("ended", n);
        }
      };
      i.on("ended", n);
    },
    reloadItem() {
      const i = this.list[this.index];
      this.player.src({ src: i.src, type: i.type, duration: i.duration }), this.player.play(), setTimeout(() => {
        this.player.play();
      });
    },
    setList: function(i) {
      this.list = i, this.index = 0, this.setItem(this.list[this.index]);
    },
    setItem: function(i) {
      this.notFirst && this.player.bigPlayButton && this.player.bigPlayButton.hide(), this.player.setItem(i);
    }
  });
  return r.pluginName = "playlist", r;
});
fr.service("VJSStreamrootHlsjsPlugin", function() {
  window.hlsSourceHandler = function(e) {
    var r = {};
    function i(t) {
      if (r[t])
        return r[t].exports;
      var n = r[t] = { i: t, l: !1, exports: {} };
      return e[t].call(n.exports, n, n.exports, i), n.l = !0, n.exports;
    }
    return i.m = e, i.c = r, i.d = function(t, n, a) {
      i.o(t, n) || Object.defineProperty(t, n, { enumerable: !0, get: a });
    }, i.r = function(t) {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
    }, i.t = function(t, n) {
      if (1 & n && (t = i(t)), 8 & n || 4 & n && typeof t == "object" && t && t.__esModule)
        return t;
      var a = /* @__PURE__ */ Object.create(null);
      if (i.r(a), Object.defineProperty(a, "default", { enumerable: !0, value: t }), 2 & n && typeof t != "string")
        for (var s in t)
          i.d(a, s, function(o) {
            return t[o];
          }.bind(null, s));
      return a;
    }, i.n = function(t) {
      var n = t && t.__esModule ? function() {
        return t.default;
      } : function() {
        return t;
      };
      return i.d(n, "a", n), n;
    }, i.o = function(t, n) {
      return Object.prototype.hasOwnProperty.call(t, n);
    }, i.p = "", i(i.s = 0);
  }([function(e, r, i) {
    var t = i(1);
    window.videojs && (t.registerConfigPlugin(window.videojs), t.registerSourceHandler(window.videojs)), e.exports = { register: t.registerSourceHandler };
  }, function(e, r, i) {
    var t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
      return typeof s;
    } : function(s) {
      return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
    }, n = i(2);
    function a(s) {
      var o = this;
      s && (o.srOptions_ || (o.srOptions_ = {}), o.srOptions_.hlsjsConfig || (o.srOptions_.hlsjsConfig = s.hlsjsConfig), o.srOptions_.captionConfig || (o.srOptions_.captionConfig = s.captionConfig));
    }
    e.exports = { registerSourceHandler: function(s) {
      var o = {};
      function l(h, c) {
        c.name_ = "StreamrootHlsjs";
        var d, f = c.el(), m = {}, p = null, b = null, y = null, v = null, g = null, E = null, x = s(c.options_.playerId), w = !1;
        function S(J) {
          m[n.ErrorTypes.MEDIA_ERROR] === 1 ? d.recoverMediaError() : m[n.ErrorTypes.MEDIA_ERROR] === 2 ? (d.swapAudioCodec(), d.recoverMediaError()) : 2 < m[n.ErrorTypes.MEDIA_ERROR] && (c.error = function() {
            return J;
          }, c.trigger("error"));
        }
        function T(J) {
          d.nextLevel = J;
        }
        function C(J, ue) {
          return typeof ue == "boolean" && (this[J]._enabled = ue, function(ce) {
            for (var ee = !0, me = 0; me < ce.length; me++)
              if (!ce[me]._enabled) {
                ee = !1;
                break;
              }
            if (ee)
              d.currentLevel = -1;
            else {
              var Ce;
              for (Ce = ce.length - 1; 0 <= Ce && !ce[Ce]._enabled; Ce--)
                ;
              d.currentLevel = Ce;
            }
          }(this)), this[J]._enabled;
        }
        function D() {
          if (b) {
            var J = [];
            if (1 < b.levels.length) {
              var ue = { id: -1, label: "auto", selected: d.manualLevel === -1 };
              J.push(ue);
            }
            b.levels.forEach(function(ee, me) {
              var Ce = {};
              Ce.id = me, Ce.selected = me === d.manualLevel, Ce.label = function(Ne) {
                return Ne.height ? Ne.height + "p" : Ne.width ? Math.round(9 * Ne.width / 16) + "p" : Ne.bitrate ? Ne.bitrate / 1e3 + "kbps" : 0;
              }(ee), J.push(Ce);
            });
            var ce = { qualityData: { video: J }, qualitySwitchCallback: T };
            c.trigger("loadedqualitydata", ce), f.removeEventListener("playing", D);
          }
        }
        function R() {
          for (var J = c.audioTracks(), ue = 0; ue < J.length; ue++)
            if (J[ue].enabled) {
              d.audioTrack = ue;
              break;
            }
        }
        function P() {
          var J = d.audioTracks, ue = c.audioTracks();
          if (1 < J.length && ue.length === 0) {
            for (var ce = 0; ce < J.length; ce++)
              ue.addTrack(new s.AudioTrack({ id: ce, kind: "alternative", label: J[ce].name || J[ce].lang, language: J[ce].lang, enabled: ce === d.audioTrack }));
            ue.addEventListener("change", R);
          }
        }
        function N(J) {
          return J.label ? J.label : J.language;
        }
        function $(J, ue) {
          return N(J) === N(ue) && J.kind === ue.kind;
        }
        function O() {
          for (var J = x.textTracks(), ue = null, ce = 0; ce < J.length; ce++)
            if (J[ce].mode === "showing") {
              ue = J[ce];
              break;
            }
          for (var ee = f.textTracks, me = 0; me < ee.length; me++)
            ee[me].kind !== "subtitles" && ee[me].kind !== "captions" || (ee[me].mode = ue && $(ee[me], ue) ? "showing" : "disabled");
        }
        function M() {
          d.startLoad(-1), f.removeEventListener("play", M);
        }
        function F() {
          for (var J = function(Ne) {
            for (var ot = [], ze = 0; ze < Ne.length; ze++)
              Ne[ze].kind !== "subtitles" && Ne[ze].kind !== "captions" || ot.push(Ne[ze]);
            return ot;
          }(f.textTracks), ue = x.textTracks(), ce = 0; ce < J.length; ce++) {
            for (var ee = !1, me = 0; me < ue.length; me++)
              if ($(J[ce], ue[me])) {
                ee = !0;
                break;
              }
            if (!ee) {
              var Ce = J[ce];
              x.addRemoteTextTrack({ kind: Ce.kind, label: N(Ce), language: Ce.language, srclang: Ce.language, mode: Ce.mode }, !1);
            }
          }
          O(), w || (ue.addEventListener("change", O), w = !0);
        }
        function G(J, ue) {
          b = ue, function() {
            if (b) {
              var ce = x.qualityLevels && x.qualityLevels();
              if (ce)
                for (var ee = 0; ee < b.levels.length; ee++) {
                  var me = b.levels[ee], Ce = { id: ee, width: me.width, height: me.height, bandwidth: me.bitrate, bitrate: me.bitrate, _enabled: !0 };
                  Ce.enabled = C.bind(ce, ee), ce.addQualityLevel(Ce);
                }
            }
          }();
        }
        function K() {
          var J = x.srOptions_ && x.srOptions_.hlsjsConfig || c.options_.hlsjsConfig;
          E = J ? function(ce) {
            for (var ee = {}, me = Object.keys(ce), Ce = 0; Ce < me.length; Ce++)
              ee[me[Ce]] = ce[me[Ce]];
            return ee;
          }(J) : {}, ["", "auto"].indexOf(f.preload) !== -1 || f.autoplay || E.autoStartLoad !== void 0 || (E.autoStartLoad = !1);
          var ue = x.srOptions_ && x.srOptions_.captionConfig || c.options_.captionConfig;
          ue && (E.cueHandler = function(ce) {
            return { newCue: function(ee, me, Ce, Ne) {
              for (var ot, ze, $e, Ze = window.VTTCue || window.TextTrackCue, Ut = 0; Ut < Ne.rows.length; Ut++)
                if ($e = "", !(ot = Ne.rows[Ut]).isEmpty()) {
                  for (var qt = 0; qt < ot.chars.length; qt++)
                    $e += ot.chars[qt].uchar;
                  if (ze = new Ze(me, Ce, $e.trim()), ce != null && (ce === void 0 ? "undefined" : t(ce)) === "object")
                    for (var ir = Object.keys(ce), We = 0; We < ir.length; We++)
                      ze[ir[We]] = ce[ir[We]];
                  ee.addCue(ze), Ce === me && ee.addCue(new Ze(Ce + 5, ""));
                }
            } };
          }(ue)), E.autoStartLoad === !1 && f.addEventListener("play", M), f.addEventListener("playing", D), d = new n(E), function(ce) {
            if (o[ce] !== void 0)
              for (var ee = 0; ee < o[ce].length; ee++)
                o[ce][ee](x, d);
          }("beforeinitialize"), d.on(n.Events.ERROR, function(ce, ee) {
            (function(me, Ce) {
              var Ne = { message: "HLS.js error: " + Ce.type + " - fatal: " + Ce.fatal + " - " + Ce.details };
              if (m[Ce.type] ? m[Ce.type] += 1 : m[Ce.type] = 1, Ce.fatal)
                switch (Ce.type) {
                  case n.ErrorTypes.NETWORK_ERROR:
                    Ne.code = 2, c.error = function() {
                      return Ne;
                    }, c.trigger("error");
                    break;
                  case n.ErrorTypes.MEDIA_ERROR:
                    Ne.code = 3, S(Ne);
                    break;
                  default:
                    d.destroy(), c.error = function() {
                      return Ne;
                    }, c.trigger("error");
                }
            })(0, ee);
          }), d.on(n.Events.AUDIO_TRACKS_UPDATED, P), d.on(n.Events.MANIFEST_PARSED, G), d.on(n.Events.LEVEL_LOADED, function(ce, ee) {
            E.liveSyncDuration ? g = E.liveSyncDuration : E.liveSyncDurationCount && (g = E.liveSyncDurationCount * ee.details.targetduration), y = ee.details.live, v = ee.details.totalduration, p = y ? 1 / 0 : ee.details.totalduration;
          }), d.once(n.Events.FRAG_LOADED, function() {
            c.trigger("loadedmetadata");
          }), d.attachMedia(f), f.textTracks.addEventListener("addtrack", F), d.loadSource(h.src);
        }
        this.duration = function() {
          return p || f.duration || 0;
        }, this.seekable = function() {
          if (d.media) {
            if (!y)
              return s.createTimeRanges(0, d.media.duration);
            var J = Math.round(d.media.duration - v), ue = Math.round(d.media.duration - g);
            return s.createTimeRanges(J, ue);
          }
          return s.createTimeRanges();
        }, this.dispose = function() {
          f.removeEventListener("play", M), f.textTracks.removeEventListener("addtrack", F), f.removeEventListener("playing", D), x.textTracks().removeEventListener("change", O), w = !1, x.audioTracks().removeEventListener("change", R), d.destroy();
        }, f.addEventListener("error", function(J) {
          var ue = J.currentTarget.error;
          switch (ue.code) {
            case ue.MEDIA_ERR_ABORTED:
              break;
            case ue.MEDIA_ERR_DECODE:
              S(ue);
              break;
            case ue.MEDIA_ERR_NETWORK:
              break;
            case ue.MEDIA_ERR_SRC_NOT_SUPPORTED:
              break;
            default:
              ue.message;
          }
        }), K();
      }
      if (l.addHook = function(h, c) {
        o[h] = o[h] || [], o[h].push(c);
      }, l.removeHook = function(h, c) {
        if (o[h] === void 0)
          return !1;
        var d = o[h].indexOf(c);
        return d !== -1 && (o[h].splice(d, 1), !0);
      }, n.isSupported()) {
        var u;
        if (typeof s.getTech == "function")
          u = s.getTech("Html5");
        else {
          if (typeof s.getComponent != "function")
            return;
          u = s.getComponent("Html5");
        }
        if (!u)
          return;
        u.registerSourceHandler({ canHandleSource: function(h) {
          return /^application\/x-mpegURL|application\/vnd\.apple\.mpegurl$/i.test(h.type) ? "probably" : /\.m3u8/i.test(h.src) ? "maybe" : "";
        }, handleSource: function(h, c) {
          return c.hlsProvider && c.hlsProvider.dispose(), c.hlsProvider = new l(h, c), c.hlsProvider;
        } }, 0), s.Html5Hlsjs = l;
      }
    }, registerConfigPlugin: function(s) {
      (s.registerPlugin || s.plugin)("streamrootHls", a);
    } };
  }, function(e, r, i) {
    var t;
    typeof window < "u" && (t = function() {
      return (s = {}, n.m = a = { "./node_modules/eventemitter3/index.js": function(o, l, u) {
        var h = Object.prototype.hasOwnProperty, c = "~";
        function d() {
        }
        function f(y, v, g) {
          this.fn = y, this.context = v, this.once = g || !1;
        }
        function m(y, v, g, E, x) {
          if (typeof g != "function")
            throw new TypeError("The listener must be a function");
          var w = new f(g, E || y, x), S = c ? c + v : v;
          return y._events[S] ? y._events[S].fn ? y._events[S] = [y._events[S], w] : y._events[S].push(w) : (y._events[S] = w, y._eventsCount++), y;
        }
        function p(y, v) {
          --y._eventsCount == 0 ? y._events = new d() : delete y._events[v];
        }
        function b() {
          this._events = new d(), this._eventsCount = 0;
        }
        Object.create && (d.prototype = /* @__PURE__ */ Object.create(null), new d().__proto__ || (c = !1)), b.prototype.eventNames = function() {
          var y, v, g = [];
          if (this._eventsCount === 0)
            return g;
          for (v in y = this._events)
            h.call(y, v) && g.push(c ? v.slice(1) : v);
          return Object.getOwnPropertySymbols ? g.concat(Object.getOwnPropertySymbols(y)) : g;
        }, b.prototype.listeners = function(y) {
          var v = c ? c + y : y, g = this._events[v];
          if (!g)
            return [];
          if (g.fn)
            return [g.fn];
          for (var E = 0, x = g.length, w = new Array(x); E < x; E++)
            w[E] = g[E].fn;
          return w;
        }, b.prototype.listenerCount = function(y) {
          var v = c ? c + y : y, g = this._events[v];
          return g ? g.fn ? 1 : g.length : 0;
        }, b.prototype.emit = function(y, v, g, E, x, w) {
          var S = c ? c + y : y;
          if (!this._events[S])
            return !1;
          var T, C, D = this._events[S], R = arguments.length;
          if (D.fn) {
            switch (D.once && this.removeListener(y, D.fn, void 0, !0), R) {
              case 1:
                return D.fn.call(D.context), !0;
              case 2:
                return D.fn.call(D.context, v), !0;
              case 3:
                return D.fn.call(D.context, v, g), !0;
              case 4:
                return D.fn.call(D.context, v, g, E), !0;
              case 5:
                return D.fn.call(D.context, v, g, E, x), !0;
              case 6:
                return D.fn.call(D.context, v, g, E, x, w), !0;
            }
            for (C = 1, T = new Array(R - 1); C < R; C++)
              T[C - 1] = arguments[C];
            D.fn.apply(D.context, T);
          } else {
            var P, N = D.length;
            for (C = 0; C < N; C++)
              switch (D[C].once && this.removeListener(y, D[C].fn, void 0, !0), R) {
                case 1:
                  D[C].fn.call(D[C].context);
                  break;
                case 2:
                  D[C].fn.call(D[C].context, v);
                  break;
                case 3:
                  D[C].fn.call(D[C].context, v, g);
                  break;
                case 4:
                  D[C].fn.call(D[C].context, v, g, E);
                  break;
                default:
                  if (!T)
                    for (P = 1, T = new Array(R - 1); P < R; P++)
                      T[P - 1] = arguments[P];
                  D[C].fn.apply(D[C].context, T);
              }
          }
          return !0;
        }, b.prototype.on = function(y, v, g) {
          return m(this, y, v, g, !1);
        }, b.prototype.once = function(y, v, g) {
          return m(this, y, v, g, !0);
        }, b.prototype.removeListener = function(y, v, g, E) {
          var x = c ? c + y : y;
          if (!this._events[x])
            return this;
          if (!v)
            return p(this, x), this;
          var w = this._events[x];
          if (w.fn)
            w.fn !== v || E && !w.once || g && w.context !== g || p(this, x);
          else {
            for (var S = 0, T = [], C = w.length; S < C; S++)
              (w[S].fn !== v || E && !w[S].once || g && w[S].context !== g) && T.push(w[S]);
            T.length ? this._events[x] = T.length === 1 ? T[0] : T : p(this, x);
          }
          return this;
        }, b.prototype.removeAllListeners = function(y) {
          var v;
          return y ? (v = c ? c + y : y, this._events[v] && p(this, v)) : (this._events = new d(), this._eventsCount = 0), this;
        }, b.prototype.off = b.prototype.removeListener, b.prototype.addListener = b.prototype.on, b.prefixed = c, b.EventEmitter = b, o.exports = b;
      }, "./node_modules/node-libs-browser/node_modules/events/events.js": function(o, l) {
        function u() {
          this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
        }
        function h(f) {
          return typeof f == "function";
        }
        function c(f) {
          return typeof f == "object" && f !== null;
        }
        function d(f) {
          return f === void 0;
        }
        ((o.exports = u).EventEmitter = u).prototype._events = void 0, u.prototype._maxListeners = void 0, u.defaultMaxListeners = 10, u.prototype.setMaxListeners = function(f) {
          if (!function(m) {
            return typeof m == "number";
          }(f) || f < 0 || isNaN(f))
            throw TypeError("n must be a positive number");
          return this._maxListeners = f, this;
        }, u.prototype.emit = function(f) {
          var m, p, b, y, v, g;
          if (this._events || (this._events = {}), f === "error" && (!this._events.error || c(this._events.error) && !this._events.error.length)) {
            if ((m = arguments[1]) instanceof Error)
              throw m;
            var E = new Error('Uncaught, unspecified "error" event. (' + m + ")");
            throw E.context = m, E;
          }
          if (d(p = this._events[f]))
            return !1;
          if (h(p))
            switch (arguments.length) {
              case 1:
                p.call(this);
                break;
              case 2:
                p.call(this, arguments[1]);
                break;
              case 3:
                p.call(this, arguments[1], arguments[2]);
                break;
              default:
                y = Array.prototype.slice.call(arguments, 1), p.apply(this, y);
            }
          else if (c(p))
            for (y = Array.prototype.slice.call(arguments, 1), b = (g = p.slice()).length, v = 0; v < b; v++)
              g[v].apply(this, y);
          return !0;
        }, u.prototype.on = u.prototype.addListener = function(f, m) {
          var p;
          if (!h(m))
            throw TypeError("listener must be a function");
          return this._events || (this._events = {}), this._events.newListener && this.emit("newListener", f, h(m.listener) ? m.listener : m), this._events[f] ? c(this._events[f]) ? this._events[f].push(m) : this._events[f] = [this._events[f], m] : this._events[f] = m, c(this._events[f]) && !this._events[f].warned && (p = d(this._maxListeners) ? u.defaultMaxListeners : this._maxListeners) && 0 < p && this._events[f].length > p && (this._events[f].warned = !0), this;
        }, u.prototype.once = function(f, m) {
          if (!h(m))
            throw TypeError("listener must be a function");
          var p = !1;
          function b() {
            this.removeListener(f, b), p || (p = !0, m.apply(this, arguments));
          }
          return b.listener = m, this.on(f, b), this;
        }, u.prototype.removeListener = function(f, m) {
          var p, b, y, v;
          if (!h(m))
            throw TypeError("listener must be a function");
          if (!this._events || !this._events[f])
            return this;
          if (y = (p = this._events[f]).length, b = -1, p === m || h(p.listener) && p.listener === m)
            delete this._events[f], this._events.removeListener && this.emit("removeListener", f, m);
          else if (c(p)) {
            for (v = y; 0 < v--; )
              if (p[v] === m || p[v].listener && p[v].listener === m) {
                b = v;
                break;
              }
            if (b < 0)
              return this;
            p.length === 1 ? (p.length = 0, delete this._events[f]) : p.splice(b, 1), this._events.removeListener && this.emit("removeListener", f, m);
          }
          return this;
        }, u.prototype.removeAllListeners = function(f) {
          var m, p;
          if (!this._events)
            return this;
          if (!this._events.removeListener)
            return arguments.length === 0 ? this._events = {} : this._events[f] && delete this._events[f], this;
          if (arguments.length === 0) {
            for (m in this._events)
              m !== "removeListener" && this.removeAllListeners(m);
            return this.removeAllListeners("removeListener"), this._events = {}, this;
          }
          if (h(p = this._events[f]))
            this.removeListener(f, p);
          else if (p)
            for (; p.length; )
              this.removeListener(f, p[p.length - 1]);
          return delete this._events[f], this;
        }, u.prototype.listeners = function(f) {
          return this._events && this._events[f] ? h(this._events[f]) ? [this._events[f]] : this._events[f].slice() : [];
        }, u.prototype.listenerCount = function(f) {
          if (this._events) {
            var m = this._events[f];
            if (h(m))
              return 1;
            if (m)
              return m.length;
          }
          return 0;
        }, u.listenerCount = function(f, m) {
          return f.listenerCount(m);
        };
      }, "./node_modules/url-toolkit/src/url-toolkit.js": function(o, l, u) {
        var h, c, d, f, m;
        h = /^((?:[a-zA-Z0-9+\-.]+:)?)(\/\/[^\/?#]*)?((?:[^\/\?#]*\/)*.*?)??(;.*?)?(\?.*?)?(#.*?)?$/, c = /^([^\/?#]*)(.*)$/, d = /(?:\/|^)\.(?=\/)/g, f = /(?:\/|^)\.\.\/(?!\.\.\/).*?(?=\/)/g, m = { buildAbsoluteURL: function(p, b, y) {
          if (y = y || {}, p = p.trim(), !(b = b.trim())) {
            if (!y.alwaysNormalize)
              return p;
            var v = m.parseURL(p);
            if (!v)
              throw new Error("Error trying to parse base URL.");
            return v.path = m.normalizePath(v.path), m.buildURLFromParts(v);
          }
          var g = m.parseURL(b);
          if (!g)
            throw new Error("Error trying to parse relative URL.");
          if (g.scheme)
            return y.alwaysNormalize ? (g.path = m.normalizePath(g.path), m.buildURLFromParts(g)) : b;
          var E = m.parseURL(p);
          if (!E)
            throw new Error("Error trying to parse base URL.");
          if (!E.netLoc && E.path && E.path[0] !== "/") {
            var x = c.exec(E.path);
            E.netLoc = x[1], E.path = x[2];
          }
          E.netLoc && !E.path && (E.path = "/");
          var w = { scheme: E.scheme, netLoc: g.netLoc, path: null, params: g.params, query: g.query, fragment: g.fragment };
          if (!g.netLoc && (w.netLoc = E.netLoc, g.path[0] !== "/"))
            if (g.path) {
              var S = E.path, T = S.substring(0, S.lastIndexOf("/") + 1) + g.path;
              w.path = m.normalizePath(T);
            } else
              w.path = E.path, g.params || (w.params = E.params, g.query || (w.query = E.query));
          return w.path === null && (w.path = y.alwaysNormalize ? m.normalizePath(g.path) : g.path), m.buildURLFromParts(w);
        }, parseURL: function(p) {
          var b = h.exec(p);
          return b ? { scheme: b[1] || "", netLoc: b[2] || "", path: b[3] || "", params: b[4] || "", query: b[5] || "", fragment: b[6] || "" } : null;
        }, normalizePath: function(p) {
          for (p = p.split("").reverse().join("").replace(d, ""); p.length !== (p = p.replace(f, "")).length; )
            ;
          return p.split("").reverse().join("");
        }, buildURLFromParts: function(p) {
          return p.scheme + p.netLoc + p.path + p.params + p.query + p.fragment;
        } }, o.exports = m;
      }, "./node_modules/webworkify-webpack/index.js": function(o, l, u) {
        function h(b) {
          var y = {};
          function v(E) {
            if (y[E])
              return y[E].exports;
            var x = y[E] = { i: E, l: !1, exports: {} };
            return b[E].call(x.exports, x, x.exports, v), x.l = !0, x.exports;
          }
          v.m = b, v.c = y, v.i = function(E) {
            return E;
          }, v.d = function(E, x, w) {
            v.o(E, x) || Object.defineProperty(E, x, { configurable: !1, enumerable: !0, get: w });
          }, v.r = function(E) {
            Object.defineProperty(E, "__esModule", { value: !0 });
          }, v.n = function(E) {
            var x = E && E.__esModule ? function() {
              return E.default;
            } : function() {
              return E;
            };
            return v.d(x, "a", x), x;
          }, v.o = function(E, x) {
            return Object.prototype.hasOwnProperty.call(E, x);
          }, v.p = "/", v.oe = function(E) {
            throw E;
          };
          var g = v(v.s = ENTRY_MODULE);
          return g.default || g;
        }
        var c = "[\\.|\\-|\\+|\\w|/|@]+", d = "\\((/\\*.*?\\*/)?s?.*?(" + c + ").*?\\)";
        function f(b) {
          return (b + "").replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
        }
        function m(b, y, v) {
          var g = {};
          g[v] = [];
          var E = y.toString(), x = E.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);
          if (!x)
            return g;
          for (var w, S = x[1], T = new RegExp("(\\\\n|\\W)" + f(S) + d, "g"); w = T.exec(E); )
            w[3] !== "dll-reference" && g[v].push(w[3]);
          for (T = new RegExp("\\(" + f(S) + '\\("(dll-reference\\s(' + c + '))"\\)\\)' + d, "g"); w = T.exec(E); )
            b[w[2]] || (g[v].push(w[1]), b[w[2]] = u(w[1]).m), g[w[2]] = g[w[2]] || [], g[w[2]].push(w[4]);
          for (var C, D = Object.keys(g), R = 0; R < D.length; R++)
            for (var P = 0; P < g[D[R]].length; P++)
              C = g[D[R]][P], isNaN(1 * C) || (g[D[R]][P] = 1 * g[D[R]][P]);
          return g;
        }
        function p(b) {
          return Object.keys(b).reduce(function(y, v) {
            return y || 0 < b[v].length;
          }, !1);
        }
        o.exports = function(b, y) {
          y = y || {};
          var v = { main: u.m }, g = y.all ? { main: Object.keys(v.main) } : function(T, C) {
            for (var D = { main: [C] }, R = { main: [] }, P = { main: {} }; p(D); )
              for (var N = Object.keys(D), $ = 0; $ < N.length; $++) {
                var O = N[$], M = D[O].pop();
                if (P[O] = P[O] || {}, !P[O][M] && T[O][M]) {
                  P[O][M] = !0, R[O] = R[O] || [], R[O].push(M);
                  for (var F = m(T, T[O][M], O), G = Object.keys(F), K = 0; K < G.length; K++)
                    D[G[K]] = D[G[K]] || [], D[G[K]] = D[G[K]].concat(F[G[K]]);
                }
              }
            return R;
          }(v, b), E = "";
          Object.keys(g).filter(function(T) {
            return T !== "main";
          }).forEach(function(T) {
            for (var C = 0; g[T][C]; )
              C++;
            g[T].push(C), v[T][C] = "(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })", E = E + "var " + T + " = (" + h.toString().replace("ENTRY_MODULE", JSON.stringify(C)) + ")({" + g[T].map(function(D) {
              return JSON.stringify(D) + ": " + v[T][D].toString();
            }).join(",") + `});
`;
          }), E = E + "new ((" + h.toString().replace("ENTRY_MODULE", JSON.stringify(b)) + ")({" + g.main.map(function(T) {
            return JSON.stringify(T) + ": " + v.main[T].toString();
          }).join(",") + "}))(self);";
          var x = new window.Blob([E], { type: "text/javascript" });
          if (y.bare)
            return x;
          var w = (window.URL || window.webkitURL || window.mozURL || window.msURL).createObjectURL(x), S = new window.Worker(w);
          return S.objectURL = w, S;
        };
      }, "./src/config.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./src/controller/abr-controller.js"), c = u("./src/controller/buffer-controller.js"), d = u("./src/controller/cap-level-controller.js"), f = u("./src/controller/fps-controller.js"), m = u("./src/utils/xhr-loader.js"), p = u("./src/controller/audio-track-controller.js"), b = u("./src/controller/audio-stream-controller.js"), y = u("./src/utils/cues.js"), v = u("./src/controller/timeline-controller.js"), g = u("./src/controller/subtitle-track-controller.js"), E = u("./src/controller/subtitle-stream-controller.js"), x = u("./src/controller/eme-controller.js"), w = u("./src/utils/mediakeys-helper.js");
        l.hlsDefaultConfig = { autoStartLoad: !0, startPosition: -1, defaultAudioCodec: void 0, debug: !1, capLevelOnFPSDrop: !1, capLevelToPlayerSize: !1, initialLiveManifestSize: 1, maxBufferLength: 30, maxBufferSize: 6e7, maxBufferHole: 0.5, lowBufferWatchdogPeriod: 0.5, highBufferWatchdogPeriod: 3, nudgeOffset: 0.1, nudgeMaxRetry: 3, maxFragLookUpTolerance: 0.25, liveSyncDurationCount: 3, liveMaxLatencyDurationCount: 1 / 0, liveSyncDuration: void 0, liveMaxLatencyDuration: void 0, liveDurationInfinity: !1, liveBackBufferLength: 1 / 0, maxMaxBufferLength: 600, enableWorker: !0, enableSoftwareAES: !0, manifestLoadingTimeOut: 1e4, manifestLoadingMaxRetry: 1, manifestLoadingRetryDelay: 1e3, manifestLoadingMaxRetryTimeout: 64e3, startLevel: void 0, levelLoadingTimeOut: 1e4, levelLoadingMaxRetry: 4, levelLoadingRetryDelay: 1e3, levelLoadingMaxRetryTimeout: 64e3, fragLoadingTimeOut: 2e4, fragLoadingMaxRetry: 6, fragLoadingRetryDelay: 1e3, fragLoadingMaxRetryTimeout: 64e3, startFragPrefetch: !1, fpsDroppedMonitoringPeriod: 5e3, fpsDroppedMonitoringThreshold: 0.2, appendErrorMaxRetry: 3, loader: m.default, fLoader: void 0, pLoader: void 0, xhrSetup: void 0, licenseXhrSetup: void 0, abrController: h.default, bufferController: c.default, capLevelController: d.default, fpsController: f.default, stretchShortVideoTrack: !1, maxAudioFramesDrift: 1, forceKeyFrameOnDiscontinuity: !0, abrEwmaFastLive: 3, abrEwmaSlowLive: 9, abrEwmaFastVoD: 3, abrEwmaSlowVoD: 9, abrEwmaDefaultEstimate: 5e5, abrBandWidthFactor: 0.95, abrBandWidthUpFactor: 0.7, abrMaxWithRealBitrate: !1, maxStarvationDelay: 4, maxLoadingDelay: 4, minAutoBitrate: 0, emeEnabled: !1, widevineLicenseUrl: void 0, requestMediaKeySystemAccessFunc: w.requestMediaKeySystemAccess }, l.hlsDefaultConfig.subtitleStreamController = E.SubtitleStreamController, l.hlsDefaultConfig.subtitleTrackController = g.default, l.hlsDefaultConfig.timelineController = v.default, l.hlsDefaultConfig.cueHandler = y, l.hlsDefaultConfig.enableCEA708Captions = !0, l.hlsDefaultConfig.enableWebVTT = !0, l.hlsDefaultConfig.captionsTextTrack1Label = "English", l.hlsDefaultConfig.captionsTextTrack1LanguageCode = "en", l.hlsDefaultConfig.captionsTextTrack2Label = "Spanish", l.hlsDefaultConfig.captionsTextTrack2LanguageCode = "es", l.hlsDefaultConfig.audioStreamController = b.default, l.hlsDefaultConfig.audioTrackController = p.default, l.hlsDefaultConfig.emeController = x.default;
      }, "./src/controller/abr-controller.js": function(o, l, u) {
        (function(h) {
          var c, d = this && this.__extends || (c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(S, T) {
            S.__proto__ = T;
          } || function(S, T) {
            for (var C in T)
              T.hasOwnProperty(C) && (S[C] = T[C]);
          }, function(S, T) {
            function C() {
              this.constructor = S;
            }
            c(S, T), S.prototype = T === null ? Object.create(T) : (C.prototype = T.prototype, new C());
          });
          Object.defineProperty(l, "__esModule", { value: !0 });
          var f, m = u("./src/events.js"), p = u("./src/event-handler.js"), b = u("./src/utils/buffer-helper.js"), y = u("./src/errors.js"), v = u("./src/utils/logger.js"), g = u("./src/utils/ewma-bandwidth-estimator.js"), E = window.performance, x = (f = p.default, d(w, f), w.prototype.destroy = function() {
            this.clearTimer(), p.default.prototype.destroy.call(this);
          }, w.prototype.onFragLoading = function(S) {
            var T = S.frag;
            if (T.type === "main" && (this.timer || (this.fragCurrent = T, this.timer = setInterval(this.onCheck, 100)), !this._bwEstimator)) {
              var C = this.hls, D = C.config, R = T.level, P = void 0, N = void 0;
              N = C.levels[R].details.live ? (P = D.abrEwmaFastLive, D.abrEwmaSlowLive) : (P = D.abrEwmaFastVoD, D.abrEwmaSlowVoD), this._bwEstimator = new g.default(C, N, P, D.abrEwmaDefaultEstimate);
            }
          }, w.prototype._abandonRulesCheck = function() {
            var S = this.hls, T = S.media, C = this.fragCurrent;
            if (C) {
              var D = C.loader, R = S.minAutoLevel;
              if (!D || D.stats && D.stats.aborted)
                return v.logger.warn("frag loader destroy or aborted, disarm abandonRules"), this.clearTimer(), void (this._nextAutoLevel = -1);
              var P = D.stats;
              if (T && P && (!T.paused && T.playbackRate !== 0 || !T.readyState) && C.autoLevel && C.level) {
                var N = E.now() - P.trequest, $ = Math.abs(T.playbackRate);
                if (N > 500 * C.duration / $) {
                  var O = S.levels, M = Math.max(1, P.bw ? P.bw / 8 : 1e3 * P.loaded / N), F = O[C.level], G = F.realBitrate ? Math.max(F.realBitrate, F.bitrate) : F.bitrate, K = P.total ? P.total : Math.max(P.loaded, Math.round(C.duration * G / 8)), J = T.currentTime, ue = (K - P.loaded) / M, ce = (b.BufferHelper.bufferInfo(T, J, S.config.maxBufferHole).end - J) / $;
                  if (ce < 2 * C.duration / $ && ce < ue) {
                    var ee = void 0, me = void 0;
                    for (me = C.level - 1; R < me; me--) {
                      var Ce = O[me].realBitrate ? Math.max(O[me].realBitrate, O[me].bitrate) : O[me].bitrate;
                      if ((ee = C.duration * Ce / (6.4 * M)) < ce)
                        break;
                    }
                    ee < ue && (v.logger.warn("loading too slow, abort fragment loading and switch to level " + me + ":fragLoadedDelay[" + me + "]<fragLoadedDelay[" + (C.level - 1) + "];bufferStarvationDelay:" + ee.toFixed(1) + "<" + ue.toFixed(1) + ":" + ce.toFixed(1)), S.nextLoadLevel = me, this._bwEstimator.sample(N, P.loaded), D.abort(), this.clearTimer(), S.trigger(m.default.FRAG_LOAD_EMERGENCY_ABORTED, { frag: C, stats: P }));
                  }
                }
              }
            }
          }, w.prototype.onFragLoaded = function(S) {
            var T = S.frag;
            if (T.type === "main" && h.isFinite(T.sn)) {
              if (this.clearTimer(), this.lastLoadedFragLevel = T.level, this._nextAutoLevel = -1, this.hls.config.abrMaxWithRealBitrate) {
                var C = this.hls.levels[T.level], D = (C.loaded ? C.loaded.bytes : 0) + S.stats.loaded, R = (C.loaded ? C.loaded.duration : 0) + S.frag.duration;
                C.loaded = { bytes: D, duration: R }, C.realBitrate = Math.round(8 * D / R);
              }
              if (S.frag.bitrateTest) {
                var P = S.stats;
                P.tparsed = P.tbuffered = P.tload, this.onFragBuffered(S);
              }
            }
          }, w.prototype.onFragBuffered = function(S) {
            var T = S.stats, C = S.frag;
            if (T.aborted !== !0 && C.type === "main" && h.isFinite(C.sn) && (!C.bitrateTest || T.tload === T.tbuffered)) {
              var D = T.tparsed - T.trequest;
              v.logger.log("latency/loading/parsing/append/kbps:" + Math.round(T.tfirst - T.trequest) + "/" + Math.round(T.tload - T.tfirst) + "/" + Math.round(T.tparsed - T.tload) + "/" + Math.round(T.tbuffered - T.tparsed) + "/" + Math.round(8 * T.loaded / (T.tbuffered - T.trequest))), this._bwEstimator.sample(D, T.loaded), T.bwEstimate = this._bwEstimator.getEstimate(), C.bitrateTest ? this.bitrateTestDelay = D / 1e3 : this.bitrateTestDelay = 0;
            }
          }, w.prototype.onError = function(S) {
            switch (S.details) {
              case y.ErrorDetails.FRAG_LOAD_ERROR:
              case y.ErrorDetails.FRAG_LOAD_TIMEOUT:
                this.clearTimer();
            }
          }, w.prototype.clearTimer = function() {
            clearInterval(this.timer), this.timer = null;
          }, Object.defineProperty(w.prototype, "nextAutoLevel", { get: function() {
            var S = this._nextAutoLevel, T = this._bwEstimator;
            if (!(S === -1 || T && T.canEstimate()))
              return S;
            var C = this._nextABRAutoLevel;
            return S !== -1 && (C = Math.min(S, C)), C;
          }, set: function(S) {
            this._nextAutoLevel = S;
          }, enumerable: !0, configurable: !0 }), Object.defineProperty(w.prototype, "_nextABRAutoLevel", { get: function() {
            var S = this.hls, T = S.maxAutoLevel, C = S.levels, D = S.config, R = S.minAutoLevel, P = S.media, N = this.lastLoadedFragLevel, $ = this.fragCurrent ? this.fragCurrent.duration : 0, O = P ? P.currentTime : 0, M = P && P.playbackRate !== 0 ? Math.abs(P.playbackRate) : 1, F = this._bwEstimator ? this._bwEstimator.getEstimate() : D.abrEwmaDefaultEstimate, G = (b.BufferHelper.bufferInfo(P, O, D.maxBufferHole).end - O) / M, K = this._findBestLevel(N, $, F, R, T, G, D.abrBandWidthFactor, D.abrBandWidthUpFactor, C);
            if (0 <= K)
              return K;
            v.logger.trace("rebuffering expected to happen, lets try to find a quality level minimizing the rebuffering");
            var J = $ ? Math.min($, D.maxStarvationDelay) : D.maxStarvationDelay, ue = D.abrBandWidthFactor, ce = D.abrBandWidthUpFactor;
            if (G == 0) {
              var ee = this.bitrateTestDelay;
              ee && (J = ($ ? Math.min($, D.maxLoadingDelay) : D.maxLoadingDelay) - ee, v.logger.trace("bitrate test took " + Math.round(1e3 * ee) + "ms, set first fragment max fetchDuration to " + Math.round(1e3 * J) + " ms"), ue = ce = 1);
            }
            return K = this._findBestLevel(N, $, F, R, T, G + J, ue, ce, C), Math.max(K, 0);
          }, enumerable: !0, configurable: !0 }), w.prototype._findBestLevel = function(S, T, C, D, R, P, N, $, O) {
            for (var M = R; D <= M; M--) {
              var F = O[M];
              if (F) {
                var G = F.details, K = G ? G.totalduration / G.fragments.length : T, J = !!G && G.live, ue = void 0;
                ue = M <= S ? N * C : $ * C;
                var ce = O[M].realBitrate ? Math.max(O[M].realBitrate, O[M].bitrate) : O[M].bitrate, ee = ce * K / ue;
                if (v.logger.trace("level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: " + M + "/" + Math.round(ue) + "/" + ce + "/" + K + "/" + P + "/" + ee), ce < ue && (!ee || J && !this.bitrateTestDelay || ee < P))
                  return M;
              }
            }
            return -1;
          }, w);
          function w(S) {
            var T = f.call(this, S, m.default.FRAG_LOADING, m.default.FRAG_LOADED, m.default.FRAG_BUFFERED, m.default.ERROR) || this;
            return T.lastLoadedFragLevel = 0, T._nextAutoLevel = -1, T.hls = S, T.timer = null, T._bwEstimator = null, T.onCheck = T._abandonRulesCheck.bind(T), T;
          }
          l.default = x;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/controller/audio-stream-controller.js": function(o, l, u) {
        (function(h) {
          var c, d = this && this.__extends || (c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(N, $) {
            N.__proto__ = $;
          } || function(N, $) {
            for (var O in $)
              $.hasOwnProperty(O) && (N[O] = $[O]);
          }, function(N, $) {
            function O() {
              this.constructor = N;
            }
            c(N, $), N.prototype = $ === null ? Object.create($) : (O.prototype = $.prototype, new O());
          });
          Object.defineProperty(l, "__esModule", { value: !0 });
          var f, m = u("./src/utils/binary-search.js"), p = u("./src/utils/buffer-helper.js"), b = u("./src/demux/demuxer.js"), y = u("./src/events.js"), v = u("./src/controller/level-helper.js"), g = u("./src/utils/time-ranges.js"), E = u("./src/errors.js"), x = u("./src/utils/logger.js"), w = u("./src/utils/discontinuities.js"), S = u("./src/controller/fragment-tracker.js"), T = u("./src/loader/fragment.js"), C = u("./src/controller/base-stream-controller.js"), D = window.performance, R = (f = C.default, d(P, f), P.prototype.onInitPtsFound = function(N) {
            var $ = N.id, O = N.frag.cc, M = N.initPTS;
            $ === "main" && (this.initPTS[O] = M, this.videoTrackCC = O, x.logger.log("InitPTS for cc: " + O + " found from video track: " + M), this.state === C.State.WAITING_INIT_PTS && this.tick());
          }, P.prototype.startLoad = function(N) {
            if (this.tracks) {
              var $ = this.lastCurrentTime;
              this.stopLoad(), this.setInterval(100), (this.fragLoadError = 0) < $ && N === -1 ? (x.logger.log("audio:override startPosition with lastCurrentTime @" + $.toFixed(3)), this.state = C.State.IDLE) : (this.lastCurrentTime = this.startPosition ? this.startPosition : N, this.state = C.State.STARTING), this.nextLoadPosition = this.startPosition = this.lastCurrentTime, this.tick();
            } else
              this.startPosition = N, this.state = C.State.STOPPED;
          }, Object.defineProperty(P.prototype, "state", { get: function() {
            return this._state;
          }, set: function(N) {
            if (this.state !== N) {
              var $ = this.state;
              this._state = N, x.logger.log("audio stream:" + $ + "->" + N);
            }
          }, enumerable: !0, configurable: !0 }), P.prototype.doTick = function() {
            var N, $, O, M = this.hls, F = M.config;
            switch (this.state) {
              case C.State.ERROR:
              case C.State.PAUSED:
              case C.State.BUFFER_FLUSHING:
                break;
              case C.State.STARTING:
                this.state = C.State.WAITING_TRACK, this.loadedmetadata = !1;
                break;
              case C.State.IDLE:
                var G = this.tracks;
                if (!G || !this.media && (this.startFragRequested || !F.startFragPrefetch))
                  break;
                if (this.loadedmetadata)
                  N = this.media.currentTime;
                else if ((N = this.nextLoadPosition) === void 0)
                  break;
                var K = this.mediaBuffer ? this.mediaBuffer : this.media, J = this.videoBuffer ? this.videoBuffer : this.media, ue = p.BufferHelper.bufferInfo(K, N, F.maxBufferHole), ce = p.BufferHelper.bufferInfo(J, N, F.maxBufferHole), ee = ue.len, me = ue.end, Ce = this.fragPrevious, Ne = Math.min(F.maxBufferLength, F.maxMaxBufferLength), ot = Math.max(Ne, ce.len), ze = this.audioSwitch, $e = this.trackId;
                if ((ee < ot || ze) && $e < G.length) {
                  if ((O = G[$e].details) === void 0) {
                    this.state = C.State.WAITING_TRACK;
                    break;
                  }
                  if (!ze && this._streamEnded(ue, O))
                    return this.hls.trigger(y.default.BUFFER_EOS, { type: "audio" }), void (this.state = C.State.ENDED);
                  var Ze = O.fragments, Ut = Ze.length, qt = Ze[0].start, ir = Ze[Ut - 1].start + Ze[Ut - 1].duration, We = void 0;
                  if (ze) {
                    if (O.live && !O.PTSKnown)
                      x.logger.log("switching audiotrack, live stream, unknown PTS,load first fragment"), me = 0;
                    else if (me = N, O.PTSKnown && N < qt) {
                      if (!(ue.end > qt || ue.nextStart))
                        return;
                      x.logger.log("alt audio track ahead of main track, seek to start of alt audio track"), this.media.currentTime = qt + 0.05;
                    }
                  }
                  if (O.initSegment && !O.initSegment.data)
                    We = O.initSegment;
                  else if (me <= qt) {
                    if (We = Ze[0], this.videoTrackCC !== null && We.cc !== this.videoTrackCC && (We = w.findFragWithCC(Ze, this.videoTrackCC)), O.live && We.loadIdx && We.loadIdx === this.fragLoadIdx) {
                      var vt = ue.nextStart ? ue.nextStart : qt;
                      return x.logger.log("no alt audio available @currentTime:" + this.media.currentTime + ", seeking @" + (vt + 0.05)), void (this.media.currentTime = vt + 0.05);
                    }
                  } else {
                    var Tt = void 0, xt = F.maxFragLookUpTolerance, Pt = Ce ? Ze[Ce.sn - Ze[0].sn + 1] : void 0, at = function(xr) {
                      var _i = Math.min(xt, xr.duration);
                      return xr.start + xr.duration - _i <= me ? 1 : xr.start - _i > me && xr.start ? -1 : 0;
                    };
                    (Tt = me < ir ? (ir - xt < me && (xt = 0), Pt && !at(Pt) ? Pt : m.default.search(Ze, at)) : Ze[Ut - 1]) && (qt = (We = Tt).start, Ce && We.level === Ce.level && We.sn === Ce.sn && (We.sn < O.endSN ? (We = Ze[We.sn + 1 - O.startSN], x.logger.log("SN just loaded, load next one: " + We.sn)) : We = null));
                  }
                  We && (We.encrypted ? (x.logger.log("Loading key for " + We.sn + " of [" + O.startSN + " ," + O.endSN + "],track " + $e), this.state = C.State.KEY_LOADING, M.trigger(y.default.KEY_LOADING, { frag: We })) : (x.logger.log("Loading " + We.sn + ", cc: " + We.cc + " of [" + O.startSN + " ," + O.endSN + "],track " + $e + ", currentTime:" + N + ",bufferEnd:" + me.toFixed(3)), this.fragCurrent = We, !ze && this.fragmentTracker.getState(We) !== S.FragmentState.NOT_LOADED || (this.startFragRequested = !0, h.isFinite(We.sn) && (this.nextLoadPosition = We.start + We.duration), M.trigger(y.default.FRAG_LOADING, { frag: We }), this.state = C.State.FRAG_LOADING)));
                }
                break;
              case C.State.WAITING_TRACK:
                ($ = this.tracks[this.trackId]) && $.details && (this.state = C.State.IDLE);
                break;
              case C.State.FRAG_LOADING_WAITING_RETRY:
                var Ot = D.now(), It = this.retryDate, sr = (K = this.media) && K.seeking;
                (!It || It <= Ot || sr) && (x.logger.log("audioStreamController: retryDate reached, switch back to IDLE state"), this.state = C.State.IDLE);
                break;
              case C.State.WAITING_INIT_PTS:
                var lt = this.videoTrackCC;
                if (this.initPTS[lt] === void 0)
                  break;
                var ri = this.waitingFragment;
                if (ri) {
                  var Qr = ri.frag.cc;
                  lt !== Qr ? ($ = this.tracks[this.trackId]).details && $.details.live && (x.logger.warn("Waiting fragment CC (" + Qr + ") does not match video track CC (" + lt + ")"), this.waitingFragment = null, this.state = C.State.IDLE) : (this.state = C.State.FRAG_LOADING, this.onFragLoaded(this.waitingFragment), this.waitingFragment = null);
                } else
                  this.state = C.State.IDLE;
                break;
              case C.State.STOPPED:
              case C.State.FRAG_LOADING:
              case C.State.PARSING:
              case C.State.PARSED:
              case C.State.ENDED:
            }
          }, P.prototype.onMediaAttached = function(N) {
            var $ = this.media = this.mediaBuffer = N.media;
            this.onvseeking = this.onMediaSeeking.bind(this), this.onvended = this.onMediaEnded.bind(this), $.addEventListener("seeking", this.onvseeking), $.addEventListener("ended", this.onvended);
            var O = this.config;
            this.tracks && O.autoStartLoad && this.startLoad(O.startPosition);
          }, P.prototype.onMediaDetaching = function() {
            var N = this.media;
            N && N.ended && (x.logger.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0), N && (N.removeEventListener("seeking", this.onvseeking), N.removeEventListener("ended", this.onvended), this.onvseeking = this.onvseeked = this.onvended = null), this.media = this.mediaBuffer = this.videoBuffer = null, this.loadedmetadata = !1, this.stopLoad();
          }, P.prototype.onAudioTracksUpdated = function(N) {
            x.logger.log("audio tracks updated"), this.tracks = N.audioTracks;
          }, P.prototype.onAudioTrackSwitching = function(N) {
            var $ = !!N.url;
            this.trackId = N.id, this.fragCurrent = null, this.state = C.State.PAUSED, this.waitingFragment = null, $ ? this.setInterval(100) : this.demuxer && (this.demuxer.destroy(), this.demuxer = null), $ && (this.audioSwitch = !0, this.state = C.State.IDLE), this.tick();
          }, P.prototype.onAudioTrackLoaded = function(N) {
            var $ = N.details, O = N.id, M = this.tracks[O], F = $.totalduration, G = 0;
            if (x.logger.log("track " + O + " loaded [" + $.startSN + "," + $.endSN + "],duration:" + F), $.live) {
              var K = M.details;
              K && 0 < $.fragments.length ? (v.mergeDetails(K, $), G = $.fragments[0].start, $.PTSKnown ? x.logger.log("live audio playlist sliding:" + G.toFixed(3)) : x.logger.log("live audio playlist - outdated PTS, unknown sliding")) : ($.PTSKnown = !1, x.logger.log("live audio playlist - first load, unknown sliding"));
            } else
              $.PTSKnown = !1;
            if (M.details = $, !this.startFragRequested) {
              if (this.startPosition === -1) {
                var J = $.startTimeOffset;
                h.isFinite(J) ? (x.logger.log("start time offset found in playlist, adjust startPosition to " + J), this.startPosition = J) : this.startPosition = 0;
              }
              this.nextLoadPosition = this.startPosition;
            }
            this.state === C.State.WAITING_TRACK && (this.state = C.State.IDLE), this.tick();
          }, P.prototype.onKeyLoaded = function() {
            this.state === C.State.KEY_LOADING && (this.state = C.State.IDLE, this.tick());
          }, P.prototype.onFragLoaded = function(N) {
            var $ = this.fragCurrent, O = N.frag;
            if (this.state === C.State.FRAG_LOADING && $ && O.type === "audio" && O.level === $.level && O.sn === $.sn) {
              var M = this.tracks[this.trackId], F = M.details, G = F.totalduration, K = $.level, J = $.sn, ue = $.cc, ce = this.config.defaultAudioCodec || M.audioCodec || "mp4a.40.2", ee = this.stats = N.stats;
              if (J === "initSegment")
                this.state = C.State.IDLE, ee.tparsed = ee.tbuffered = D.now(), F.initSegment.data = N.payload, this.hls.trigger(y.default.FRAG_BUFFERED, { stats: ee, frag: $, id: "audio" }), this.tick();
              else {
                this.state = C.State.PARSING, this.appended = !1, this.demuxer || (this.demuxer = new b.default(this.hls, "audio"));
                var me = this.initPTS[ue], Ce = F.initSegment ? F.initSegment.data : [];
                F.initSegment || me !== void 0 ? (this.pendingBuffering = !0, x.logger.log("Demuxing " + J + " of [" + F.startSN + " ," + F.endSN + "],track " + K), this.demuxer.push(N.payload, Ce, ce, null, $, G, !1, me)) : (x.logger.log("unknown video PTS for continuity counter " + ue + ", waiting for video PTS before demuxing audio frag " + J + " of [" + F.startSN + " ," + F.endSN + "],track " + K), this.waitingFragment = N, this.state = C.State.WAITING_INIT_PTS);
              }
            }
            this.fragLoadError = 0;
          }, P.prototype.onFragParsingInitSegment = function(N) {
            var $ = this.fragCurrent, O = N.frag;
            if ($ && N.id === "audio" && O.sn === $.sn && O.level === $.level && this.state === C.State.PARSING) {
              var M = N.tracks, F = void 0;
              if (M.video && delete M.video, F = M.audio) {
                F.levelCodec = F.codec, F.id = N.id, this.hls.trigger(y.default.BUFFER_CODECS, M), x.logger.log("audio track:audio,container:" + F.container + ",codecs[level/parsed]=[" + F.levelCodec + "/" + F.codec + "]");
                var G = F.initSegment;
                if (G) {
                  var K = { type: "audio", data: G, parent: "audio", content: "initSegment" };
                  this.audioSwitch ? this.pendingData = [K] : (this.appended = !0, this.pendingBuffering = !0, this.hls.trigger(y.default.BUFFER_APPENDING, K));
                }
                this.tick();
              }
            }
          }, P.prototype.onFragParsingData = function(N) {
            var $ = this, O = this.fragCurrent, M = N.frag;
            if (O && N.id === "audio" && N.type === "audio" && M.sn === O.sn && M.level === O.level && this.state === C.State.PARSING) {
              var F = this.trackId, G = this.tracks[F], K = this.hls;
              h.isFinite(N.endPTS) || (N.endPTS = N.startPTS + O.duration, N.endDTS = N.startDTS + O.duration), O.addElementaryStream(T.default.ElementaryStreamTypes.AUDIO), x.logger.log("parsed " + N.type + ",PTS:[" + N.startPTS.toFixed(3) + "," + N.endPTS.toFixed(3) + "],DTS:[" + N.startDTS.toFixed(3) + "/" + N.endDTS.toFixed(3) + "],nb:" + N.nb), v.updateFragPTSDTS(G.details, O, N.startPTS, N.endPTS);
              var J = this.audioSwitch, ue = this.media, ce = !1;
              if (J && ue)
                if (ue.readyState) {
                  var ee = ue.currentTime;
                  x.logger.log("switching audio track : currentTime:" + ee), ee >= N.startPTS && (x.logger.log("switching audio track : flushing all audio"), this.state = C.State.BUFFER_FLUSHING, K.trigger(y.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: h.POSITIVE_INFINITY, type: "audio" }), ce = !0, this.audioSwitch = !1, K.trigger(y.default.AUDIO_TRACK_SWITCHED, { id: F }));
                } else
                  this.audioSwitch = !1, K.trigger(y.default.AUDIO_TRACK_SWITCHED, { id: F });
              var me = this.pendingData;
              if (!me)
                return x.logger.warn("Apparently attempt to enqueue media payload without codec initialization data upfront"), void K.trigger(y.default.ERROR, { type: E.ErrorTypes.MEDIA_ERROR, details: null, fatal: !0 });
              this.audioSwitch || ([N.data1, N.data2].forEach(function(Ce) {
                Ce && Ce.length && me.push({ type: N.type, data: Ce, parent: "audio", content: "data" });
              }), !ce && me.length && (me.forEach(function(Ce) {
                $.state === C.State.PARSING && ($.pendingBuffering = !0, $.hls.trigger(y.default.BUFFER_APPENDING, Ce));
              }), this.pendingData = [], this.appended = !0)), this.tick();
            }
          }, P.prototype.onFragParsed = function(N) {
            var $ = this.fragCurrent, O = N.frag;
            $ && N.id === "audio" && O.sn === $.sn && O.level === $.level && this.state === C.State.PARSING && (this.stats.tparsed = D.now(), this.state = C.State.PARSED, this._checkAppendedParsed());
          }, P.prototype.onBufferReset = function() {
            this.mediaBuffer = this.videoBuffer = null, this.loadedmetadata = !1;
          }, P.prototype.onBufferCreated = function(N) {
            var $ = N.tracks.audio;
            $ && (this.mediaBuffer = $.buffer, this.loadedmetadata = !0), N.tracks.video && (this.videoBuffer = N.tracks.video.buffer);
          }, P.prototype.onBufferAppended = function(N) {
            if (N.parent === "audio") {
              var $ = this.state;
              $ !== C.State.PARSING && $ !== C.State.PARSED || (this.pendingBuffering = 0 < N.pending, this._checkAppendedParsed());
            }
          }, P.prototype._checkAppendedParsed = function() {
            if (!(this.state !== C.State.PARSED || this.appended && this.pendingBuffering)) {
              var N = this.fragCurrent, $ = this.stats, O = this.hls;
              if (N) {
                this.fragPrevious = N, $.tbuffered = D.now(), O.trigger(y.default.FRAG_BUFFERED, { stats: $, frag: N, id: "audio" });
                var M = this.mediaBuffer ? this.mediaBuffer : this.media;
                x.logger.log("audio buffered : " + g.default.toString(M.buffered)), this.audioSwitch && this.appended && (this.audioSwitch = !1, O.trigger(y.default.AUDIO_TRACK_SWITCHED, { id: this.trackId })), this.state = C.State.IDLE;
              }
              this.tick();
            }
          }, P.prototype.onError = function(N) {
            var $ = N.frag;
            if (!$ || $.type === "audio")
              switch (N.details) {
                case E.ErrorDetails.FRAG_LOAD_ERROR:
                case E.ErrorDetails.FRAG_LOAD_TIMEOUT:
                  var O = N.frag;
                  if (O && O.type !== "audio")
                    break;
                  if (!N.fatal) {
                    var M = this.fragLoadError;
                    if (M ? M++ : M = 1, M <= (G = this.config).fragLoadingMaxRetry) {
                      this.fragLoadError = M;
                      var F = Math.min(Math.pow(2, M - 1) * G.fragLoadingRetryDelay, G.fragLoadingMaxRetryTimeout);
                      x.logger.warn("AudioStreamController: frag loading failed, retry in " + F + " ms"), this.retryDate = D.now() + F, this.state = C.State.FRAG_LOADING_WAITING_RETRY;
                    } else
                      x.logger.error("AudioStreamController: " + N.details + " reaches max retry, redispatch as fatal ..."), N.fatal = !0, this.state = C.State.ERROR;
                  }
                  break;
                case E.ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
                case E.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
                case E.ErrorDetails.KEY_LOAD_ERROR:
                case E.ErrorDetails.KEY_LOAD_TIMEOUT:
                  this.state !== C.State.ERROR && (this.state = N.fatal ? C.State.ERROR : C.State.IDLE, x.logger.warn("AudioStreamController: " + N.details + " while loading frag, now switching to " + this.state + " state ..."));
                  break;
                case E.ErrorDetails.BUFFER_FULL_ERROR:
                  if (N.parent === "audio" && (this.state === C.State.PARSING || this.state === C.State.PARSED)) {
                    var G, K = this.mediaBuffer, J = this.media.currentTime;
                    K && p.BufferHelper.isBuffered(K, J) && p.BufferHelper.isBuffered(K, J + 0.5) ? ((G = this.config).maxMaxBufferLength >= G.maxBufferLength && (G.maxMaxBufferLength /= 2, x.logger.warn("AudioStreamController: reduce max buffer length to " + G.maxMaxBufferLength + "s")), this.state = C.State.IDLE) : (x.logger.warn("AudioStreamController: buffer full error also media.currentTime is not buffered, flush audio buffer"), this.fragCurrent = null, this.state = C.State.BUFFER_FLUSHING, this.hls.trigger(y.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: h.POSITIVE_INFINITY, type: "audio" }));
                  }
              }
          }, P.prototype.onBufferFlushed = function() {
            var N = this, $ = this.pendingData;
            $ && $.length ? (x.logger.log("AudioStreamController: appending pending audio data after buffer flushed"), $.forEach(function(O) {
              N.hls.trigger(y.default.BUFFER_APPENDING, O);
            }), this.appended = !0, this.pendingData = [], this.state = C.State.PARSED) : (this.state = C.State.IDLE, this.fragPrevious = null, this.tick());
          }, P);
          function P(N, $) {
            var O = f.call(this, N, y.default.MEDIA_ATTACHED, y.default.MEDIA_DETACHING, y.default.AUDIO_TRACKS_UPDATED, y.default.AUDIO_TRACK_SWITCHING, y.default.AUDIO_TRACK_LOADED, y.default.KEY_LOADED, y.default.FRAG_LOADED, y.default.FRAG_PARSING_INIT_SEGMENT, y.default.FRAG_PARSING_DATA, y.default.FRAG_PARSED, y.default.ERROR, y.default.BUFFER_RESET, y.default.BUFFER_CREATED, y.default.BUFFER_APPENDED, y.default.BUFFER_FLUSHED, y.default.INIT_PTS_FOUND) || this;
            return O.fragmentTracker = $, O.config = N.config, O.audioCodecSwap = !1, O._state = C.State.STOPPED, O.initPTS = [], O.waitingFragment = null, O.videoTrackCC = null, O;
          }
          l.default = R;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/controller/audio-track-controller.js": function(o, l, u) {
        var h, c = this && this.__extends || (h = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(g, E) {
          g.__proto__ = E;
        } || function(g, E) {
          for (var x in E)
            E.hasOwnProperty(x) && (g[x] = E[x]);
        }, function(g, E) {
          function x() {
            this.constructor = g;
          }
          h(g, E), g.prototype = E === null ? Object.create(E) : (x.prototype = E.prototype, new x());
        });
        Object.defineProperty(l, "__esModule", { value: !0 });
        var d, f = u("./src/events.js"), m = u("./src/task-loop.js"), p = u("./src/utils/logger.js"), b = u("./src/errors.js"), y = (d = m.default, c(v, d), v.prototype.onManifestLoading = function() {
          this.tracks = [], this._trackId = -1, this._selectDefaultTrack = !0;
        }, v.prototype.onManifestParsed = function(g) {
          var E = this.tracks = g.audioTracks || [];
          this.hls.trigger(f.default.AUDIO_TRACKS_UPDATED, { audioTracks: E });
        }, v.prototype.onAudioTrackLoaded = function(g) {
          if (g.id >= this.tracks.length)
            p.logger.warn("Invalid audio track id:", g.id);
          else {
            if (p.logger.log("audioTrack " + g.id + " loaded"), this.tracks[g.id].details = g.details, g.details.live && !this.hasInterval()) {
              var E = 1e3 * g.details.targetduration;
              this.setInterval(E);
            }
            !g.details.live && this.hasInterval() && this.clearInterval();
          }
        }, v.prototype.onAudioTrackSwitched = function(g) {
          var E = this.tracks[g.id].groupId;
          E && this.audioGroupId !== E && (this.audioGroupId = E);
        }, v.prototype.onLevelLoaded = function(g) {
          var E = this.hls.levels[g.level];
          if (E.audioGroupIds) {
            var x = E.audioGroupIds[E.urlId];
            this.audioGroupId !== x && (this.audioGroupId = x, this._selectInitialAudioTrack());
          }
        }, v.prototype.onError = function(g) {
          g.type === b.ErrorTypes.NETWORK_ERROR && (g.fatal && this.clearInterval(), g.details === b.ErrorDetails.AUDIO_TRACK_LOAD_ERROR && (p.logger.warn("Network failure on audio-track id:", g.context.id), this._handleLoadError()));
        }, Object.defineProperty(v.prototype, "audioTracks", { get: function() {
          return this.tracks;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(v.prototype, "audioTrack", { get: function() {
          return this._trackId;
        }, set: function(g) {
          this._setAudioTrack(g), this._selectDefaultTrack = !1;
        }, enumerable: !0, configurable: !0 }), v.prototype._setAudioTrack = function(g) {
          if (this._trackId === g && this.tracks[this._trackId].details)
            p.logger.debug("Same id as current audio-track passed, and track details available -> no-op");
          else if (g < 0 || g >= this.tracks.length)
            p.logger.warn("Invalid id passed to audio-track controller");
          else {
            var E = this.tracks[g];
            p.logger.log("Now switching to audio-track index " + g), this.clearInterval(), this._trackId = g;
            var x = E.url, w = E.type, S = E.id;
            this.hls.trigger(f.default.AUDIO_TRACK_SWITCHING, { id: S, type: w, url: x }), this._loadTrackDetailsIfNeeded(E);
          }
        }, v.prototype.doTick = function() {
          this._updateTrack(this._trackId);
        }, v.prototype._selectInitialAudioTrack = function() {
          var g = this, E = this.tracks;
          if (E.length) {
            var x = this.tracks[this._trackId], w = null;
            if (x && (w = x.name), this._selectDefaultTrack) {
              var S = E.filter(function(D) {
                return D.default;
              });
              S.length ? E = S : p.logger.warn("No default audio tracks defined");
            }
            var T = !1, C = function() {
              E.forEach(function(D) {
                T || g.audioGroupId && D.groupId !== g.audioGroupId || w && w !== D.name || (g._setAudioTrack(D.id), T = !0);
              });
            };
            C(), T || (w = null, C()), T || (p.logger.error("No track found for running audio group-ID: " + this.audioGroupId), this.hls.trigger(f.default.ERROR, { type: b.ErrorTypes.MEDIA_ERROR, details: b.ErrorDetails.AUDIO_TRACK_LOAD_ERROR, fatal: !0 }));
          }
        }, v.prototype._needsTrackLoading = function(g) {
          var E = g.details, x = g.url;
          return !(E && !E.live || !x);
        }, v.prototype._loadTrackDetailsIfNeeded = function(g) {
          if (this._needsTrackLoading(g)) {
            var E = g.url, x = g.id;
            p.logger.log("loading audio-track playlist for id: " + x), this.hls.trigger(f.default.AUDIO_TRACK_LOADING, { url: E, id: x });
          }
        }, v.prototype._updateTrack = function(g) {
          if (!(g < 0 || g >= this.tracks.length)) {
            this.clearInterval(), this._trackId = g, p.logger.log("trying to update audio-track " + g);
            var E = this.tracks[g];
            this._loadTrackDetailsIfNeeded(E);
          }
        }, v.prototype._handleLoadError = function() {
          this.trackIdBlacklist[this._trackId] = !0;
          var g = this._trackId, E = this.tracks[g], x = E.name, w = E.language, S = E.groupId;
          p.logger.warn("Loading failed on audio track id: " + g + ", group-id: " + S + ', name/language: "' + x + '" / "' + w + '"');
          for (var T = g, C = 0; C < this.tracks.length; C++)
            if (!this.trackIdBlacklist[C] && this.tracks[C].name === x) {
              T = C;
              break;
            }
          T !== g ? (p.logger.log("Attempting audio-track fallback id:", T, "group-id:", this.tracks[T].groupId), this._setAudioTrack(T)) : p.logger.warn('No fallback audio-track found for name/language: "' + x + '" / "' + w + '"');
        }, v);
        function v(g) {
          var E = d.call(this, g, f.default.MANIFEST_LOADING, f.default.MANIFEST_PARSED, f.default.AUDIO_TRACK_LOADED, f.default.AUDIO_TRACK_SWITCHED, f.default.LEVEL_LOADED, f.default.ERROR) || this;
          return E._trackId = -1, E._selectDefaultTrack = !0, E.tracks = [], E.trackIdBlacklist = /* @__PURE__ */ Object.create(null), E.audioGroupId = null, E;
        }
        l.default = y;
      }, "./src/controller/base-stream-controller.js": function(o, l, u) {
        (function(h) {
          var c, d = this && this.__extends || (c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(E, x) {
            E.__proto__ = x;
          } || function(E, x) {
            for (var w in x)
              x.hasOwnProperty(w) && (E[w] = x[w]);
          }, function(E, x) {
            function w() {
              this.constructor = E;
            }
            c(E, x), E.prototype = x === null ? Object.create(x) : (w.prototype = x.prototype, new w());
          });
          Object.defineProperty(l, "__esModule", { value: !0 });
          var f = u("./src/task-loop.js"), m = u("./src/controller/fragment-tracker.js"), p = u("./src/utils/buffer-helper.js"), b = u("./src/utils/logger.js");
          l.State = { STOPPED: "STOPPED", STARTING: "STARTING", IDLE: "IDLE", PAUSED: "PAUSED", KEY_LOADING: "KEY_LOADING", FRAG_LOADING: "FRAG_LOADING", FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY", WAITING_TRACK: "WAITING_TRACK", PARSING: "PARSING", PARSED: "PARSED", BUFFER_FLUSHING: "BUFFER_FLUSHING", ENDED: "ENDED", ERROR: "ERROR", WAITING_INIT_PTS: "WAITING_INIT_PTS", WAITING_LEVEL: "WAITING_LEVEL" };
          var y, v = (y = f.default, d(g, y), g.prototype.doTick = function() {
          }, g.prototype.startLoad = function() {
          }, g.prototype.stopLoad = function() {
            var E = this.fragCurrent;
            E && (E.loader && E.loader.abort(), this.fragmentTracker.removeFragment(E)), this.demuxer && (this.demuxer.destroy(), this.demuxer = null), this.fragCurrent = null, this.fragPrevious = null, this.clearInterval(), this.clearNextTick(), this.state = l.State.STOPPED;
          }, g.prototype._streamEnded = function(E, x) {
            var w = this.fragCurrent, S = this.fragmentTracker;
            if (x.live || !w || w.backtracked || w.sn !== x.endSN || E.nextStart)
              return !1;
            var T = S.getState(w);
            return T === m.FragmentState.PARTIAL || T === m.FragmentState.OK;
          }, g.prototype.onMediaSeeking = function() {
            var E = this.config, x = this.media, w = this.mediaBuffer, S = this.state, T = x ? x.currentTime : null, C = p.BufferHelper.bufferInfo(w || x, T, this.config.maxBufferHole);
            if (h.isFinite(T) && b.logger.log("media seeking to " + T.toFixed(3)), S === l.State.FRAG_LOADING) {
              var D = this.fragCurrent;
              if (C.len === 0 && D) {
                var R = E.maxFragLookUpTolerance, P = D.start - R, N = D.start + D.duration + R;
                T < P || N < T ? (D.loader && (b.logger.log("seeking outside of buffer while fragment load in progress, cancel fragment load"), D.loader.abort()), this.fragCurrent = null, this.fragPrevious = null, this.state = l.State.IDLE) : b.logger.log("seeking outside of buffer but within currently loaded fragment range");
              }
            } else
              S === l.State.ENDED && (C.len === 0 && (this.fragPrevious = null, this.fragCurrent = null), this.state = l.State.IDLE);
            x && (this.lastCurrentTime = T), this.loadedmetadata || (this.nextLoadPosition = this.startPosition = T), this.tick();
          }, g.prototype.onMediaEnded = function() {
            this.startPosition = this.lastCurrentTime = 0;
          }, g.prototype.onHandlerDestroying = function() {
            this.stopLoad(), y.prototype.onHandlerDestroying.call(this);
          }, g.prototype.onHandlerDestroyed = function() {
            this.state = l.State.STOPPED, this.fragmentTracker = null;
          }, g);
          function g() {
            return y !== null && y.apply(this, arguments) || this;
          }
          l.default = v;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/controller/buffer-controller.js": function(o, l, u) {
        (function(h) {
          var c, d = this && this.__extends || (c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(x, w) {
            x.__proto__ = w;
          } || function(x, w) {
            for (var S in w)
              w.hasOwnProperty(S) && (x[S] = w[S]);
          }, function(x, w) {
            function S() {
              this.constructor = x;
            }
            c(x, w), x.prototype = w === null ? Object.create(w) : (S.prototype = w.prototype, new S());
          });
          Object.defineProperty(l, "__esModule", { value: !0 });
          var f, m = u("./src/events.js"), p = u("./src/event-handler.js"), b = u("./src/utils/logger.js"), y = u("./src/errors.js"), v = u("./src/utils/mediasource-helper.js").getMediaSource(), g = (f = p.default, d(E, f), E.prototype.destroy = function() {
            p.default.prototype.destroy.call(this);
          }, E.prototype.onLevelPtsUpdated = function(x) {
            var w = x.type, S = this.tracks.audio;
            if (w === "audio" && S && S.container === "audio/mpeg") {
              var T = this.sourceBuffer.audio;
              if (0.1 < Math.abs(T.timestampOffset - x.start)) {
                var C = T.updating;
                try {
                  T.abort();
                } catch (D) {
                  b.logger.warn("can not abort audio buffer: " + D);
                }
                C ? this.audioTimestampOffset = x.start : (b.logger.warn("change mpeg audio timestamp offset from " + T.timestampOffset + " to " + x.start), T.timestampOffset = x.start);
              }
            }
          }, E.prototype.onManifestParsed = function(x) {
            this.bufferCodecEventsExpected = x.altAudio ? 2 : 1, b.logger.log(this.bufferCodecEventsExpected + " bufferCodec event(s) expected");
          }, E.prototype.onMediaAttaching = function(x) {
            var w = this.media = x.media;
            if (w) {
              var S = this.mediaSource = new v();
              this.onmso = this.onMediaSourceOpen.bind(this), this.onmse = this.onMediaSourceEnded.bind(this), this.onmsc = this.onMediaSourceClose.bind(this), S.addEventListener("sourceopen", this.onmso), S.addEventListener("sourceended", this.onmse), S.addEventListener("sourceclose", this.onmsc), w.src = window.URL.createObjectURL(S), this._objectUrl = w.src;
            }
          }, E.prototype.onMediaDetaching = function() {
            b.logger.log("media source detaching");
            var x = this.mediaSource;
            if (x) {
              if (x.readyState === "open")
                try {
                  x.endOfStream();
                } catch (w) {
                  b.logger.warn("onMediaDetaching:" + w.message + " while calling endOfStream");
                }
              x.removeEventListener("sourceopen", this.onmso), x.removeEventListener("sourceended", this.onmse), x.removeEventListener("sourceclose", this.onmsc), this.media && (window.URL.revokeObjectURL(this._objectUrl), this.media.src === this._objectUrl ? (this.media.removeAttribute("src"), this.media.load()) : b.logger.warn("media.src was changed by a third party - skip cleanup")), this.mediaSource = null, this.media = null, this._objectUrl = null, this.pendingTracks = {}, this.tracks = {}, this.sourceBuffer = {}, this.flushRange = [], this.segments = [], this.appended = 0;
            }
            this.onmso = this.onmse = this.onmsc = null, this.hls.trigger(m.default.MEDIA_DETACHED);
          }, E.prototype.onMediaSourceOpen = function() {
            b.logger.log("media source opened"), this.hls.trigger(m.default.MEDIA_ATTACHED, { media: this.media });
            var x = this.mediaSource;
            x && x.removeEventListener("sourceopen", this.onmso), this.checkPendingTracks();
          }, E.prototype.checkPendingTracks = function() {
            var x = this.bufferCodecEventsExpected, w = this.pendingTracks, S = Object.keys(w).length;
            (S && !x || S === 2) && (this.createSourceBuffers(w), this.pendingTracks = {}, this.doAppending());
          }, E.prototype.onMediaSourceClose = function() {
            b.logger.log("media source closed");
          }, E.prototype.onMediaSourceEnded = function() {
            b.logger.log("media source ended");
          }, E.prototype.onSBUpdateEnd = function() {
            if (this.audioTimestampOffset) {
              var x = this.sourceBuffer.audio;
              b.logger.warn("change mpeg audio timestamp offset from " + x.timestampOffset + " to " + this.audioTimestampOffset), x.timestampOffset = this.audioTimestampOffset, delete this.audioTimestampOffset;
            }
            this._needsFlush && this.doFlush(), this._needsEos && this.checkEos(), this.appending = !1;
            var w = this.parent, S = this.segments.reduce(function(R, P) {
              return P.parent === w ? R + 1 : R;
            }, 0), T = {}, C = this.sourceBuffer;
            for (var D in C)
              T[D] = C[D].buffered;
            this.hls.trigger(m.default.BUFFER_APPENDED, { parent: w, pending: S, timeRanges: T }), this._needsFlush || this.doAppending(), this.updateMediaElementDuration(), S === 0 && this.flushLiveBackBuffer();
          }, E.prototype.onSBUpdateError = function(x) {
            b.logger.error("sourceBuffer error:", x), this.hls.trigger(m.default.ERROR, { type: y.ErrorTypes.MEDIA_ERROR, details: y.ErrorDetails.BUFFER_APPENDING_ERROR, fatal: !1 });
          }, E.prototype.onBufferReset = function() {
            var x = this.sourceBuffer;
            for (var w in x) {
              var S = x[w];
              try {
                this.mediaSource.removeSourceBuffer(S), S.removeEventListener("updateend", this.onsbue), S.removeEventListener("error", this.onsbe);
              } catch {
              }
            }
            this.sourceBuffer = {}, this.flushRange = [], this.segments = [], this.appended = 0;
          }, E.prototype.onBufferCodecs = function(x) {
            var w = this;
            if (!Object.keys(this.sourceBuffer).length) {
              Object.keys(x).forEach(function(T) {
                w.pendingTracks[T] = x[T];
              });
              var S = this.mediaSource;
              this.bufferCodecEventsExpected = Math.max(this.bufferCodecEventsExpected - 1, 0), S && S.readyState === "open" && this.checkPendingTracks();
            }
          }, E.prototype.createSourceBuffers = function(x) {
            var w = this.sourceBuffer, S = this.mediaSource;
            for (var T in x)
              if (!w[T]) {
                var C = x[T], D = C.levelCodec || C.codec, R = C.container + ";codecs=" + D;
                b.logger.log("creating sourceBuffer(" + R + ")");
                try {
                  var P = w[T] = S.addSourceBuffer(R);
                  P.addEventListener("updateend", this.onsbue), P.addEventListener("error", this.onsbe), this.tracks[T] = { codec: D, container: C.container }, C.buffer = P;
                } catch (N) {
                  b.logger.error("error while trying to add sourceBuffer:" + N.message), this.hls.trigger(m.default.ERROR, { type: y.ErrorTypes.MEDIA_ERROR, details: y.ErrorDetails.BUFFER_ADD_CODEC_ERROR, fatal: !1, err: N, mimeType: R });
                }
              }
            this.hls.trigger(m.default.BUFFER_CREATED, { tracks: x });
          }, E.prototype.onBufferAppending = function(x) {
            this._needsFlush || (this.segments ? this.segments.push(x) : this.segments = [x], this.doAppending());
          }, E.prototype.onBufferAppendFail = function(x) {
            b.logger.error("sourceBuffer error:", x.event), this.hls.trigger(m.default.ERROR, { type: y.ErrorTypes.MEDIA_ERROR, details: y.ErrorDetails.BUFFER_APPENDING_ERROR, fatal: !1 });
          }, E.prototype.onBufferEos = function(x) {
            var w = this.sourceBuffer, S = x.type;
            for (var T in w)
              S && T !== S || w[T].ended || (w[T].ended = !0, b.logger.log(T + " sourceBuffer now EOS"));
            this.checkEos();
          }, E.prototype.checkEos = function() {
            var x = this.sourceBuffer, w = this.mediaSource;
            if (w && w.readyState === "open") {
              for (var S in x) {
                var T = x[S];
                if (!T.ended)
                  return;
                if (T.updating)
                  return void (this._needsEos = !0);
              }
              b.logger.log("all media data are available, signal endOfStream() to MediaSource and stop loading fragment");
              try {
                w.endOfStream();
              } catch {
                b.logger.warn("exception while calling mediaSource.endOfStream()");
              }
              this._needsEos = !1;
            } else
              this._needsEos = !1;
          }, E.prototype.onBufferFlushing = function(x) {
            this.flushRange.push({ start: x.startOffset, end: x.endOffset, type: x.type }), this.flushBufferCounter = 0, this.doFlush();
          }, E.prototype.flushLiveBackBuffer = function() {
            if (this._live) {
              var x = this.hls.config.liveBackBufferLength;
              if (isFinite(x) && !(x < 0))
                for (var w = this.media.currentTime, S = this.sourceBuffer, T = Object.keys(S), C = w - Math.max(x, this._levelTargetDuration), D = T.length - 1; 0 <= D; D--) {
                  var R = T[D], P = S[R].buffered;
                  0 < P.length && C > P.start(0) && this.removeBufferRange(R, S[R], 0, C);
                }
            }
          }, E.prototype.onLevelUpdated = function(x) {
            var w = x.details;
            0 < w.fragments.length && (this._levelDuration = w.totalduration + w.fragments[0].start, this._levelTargetDuration = w.averagetargetduration || w.targetduration || 10, this._live = w.live, this.updateMediaElementDuration());
          }, E.prototype.updateMediaElementDuration = function() {
            var x, w = this.hls.config;
            if (this._levelDuration !== null && this.media && this.mediaSource && this.sourceBuffer && this.media.readyState !== 0 && this.mediaSource.readyState === "open") {
              for (var S in this.sourceBuffer)
                if (this.sourceBuffer[S].updating === !0)
                  return;
              x = this.media.duration, this._msDuration === null && (this._msDuration = this.mediaSource.duration), this._live === !0 && w.liveDurationInfinity === !0 ? (b.logger.log("Media Source duration is set to Infinity"), this._msDuration = this.mediaSource.duration = 1 / 0) : (this._levelDuration > this._msDuration && this._levelDuration > x || !h.isFinite(x)) && (b.logger.log("Updating Media Source duration to " + this._levelDuration.toFixed(3)), this._msDuration = this.mediaSource.duration = this._levelDuration);
            }
          }, E.prototype.doFlush = function() {
            for (; this.flushRange.length; ) {
              var x = this.flushRange[0];
              if (!this.flushBuffer(x.start, x.end, x.type))
                return void (this._needsFlush = !0);
              this.flushRange.shift(), this.flushBufferCounter = 0;
            }
            if (this.flushRange.length === 0) {
              this._needsFlush = !1;
              var w = 0, S = this.sourceBuffer;
              try {
                for (var T in S)
                  w += S[T].buffered.length;
              } catch {
                b.logger.error("error while accessing sourceBuffer.buffered");
              }
              this.appended = w, this.hls.trigger(m.default.BUFFER_FLUSHED);
            }
          }, E.prototype.doAppending = function() {
            var x = this.hls, w = this.segments, S = this.sourceBuffer;
            if (Object.keys(S).length) {
              if (this.media.error)
                return this.segments = [], void b.logger.error("trying to append although a media error occured, flush segment and abort");
              if (this.appending)
                return;
              if (w && w.length) {
                var T = w.shift();
                try {
                  var C = S[T.type];
                  C ? C.updating ? w.unshift(T) : (C.ended = !1, this.parent = T.parent, C.appendBuffer(T.data), this.appendError = 0, this.appended++, this.appending = !0) : this.onSBUpdateEnd();
                } catch (R) {
                  b.logger.error("error while trying to append buffer:" + R.message), w.unshift(T);
                  var D = { type: y.ErrorTypes.MEDIA_ERROR, parent: T.parent };
                  R.code !== 22 ? (this.appendError ? this.appendError++ : this.appendError = 1, D.details = y.ErrorDetails.BUFFER_APPEND_ERROR, this.appendError > x.config.appendErrorMaxRetry ? (b.logger.log("fail " + x.config.appendErrorMaxRetry + " times to append segment in sourceBuffer"), this.segments = [], D.fatal = !0) : D.fatal = !1) : (this.segments = [], D.details = y.ErrorDetails.BUFFER_FULL_ERROR, D.fatal = !1), x.trigger(m.default.ERROR, D);
                }
              }
            }
          }, E.prototype.flushBuffer = function(x, w, S) {
            var T, C = this.sourceBuffer;
            if (Object.keys(C).length) {
              if (b.logger.log("flushBuffer,pos/start/end: " + this.media.currentTime.toFixed(3) + "/" + x + "/" + w), this.flushBufferCounter < this.appended) {
                for (var D in C)
                  if (!S || D === S) {
                    if ((T = C[D]).ended = !1, T.updating)
                      return b.logger.warn("cannot flush, sb updating in progress"), !1;
                    if (this.removeBufferRange(D, T, x, w))
                      return this.flushBufferCounter++, !1;
                  }
              } else
                b.logger.warn("abort flushing too many retries");
              b.logger.log("buffer flushed");
            }
            return !0;
          }, E.prototype.removeBufferRange = function(x, w, S, T) {
            try {
              for (var C = 0; C < w.buffered.length; C++) {
                var D = w.buffered.start(C), R = w.buffered.end(C), P = Math.max(D, S), N = Math.min(R, T);
                if (0.5 < Math.min(N, R) - P)
                  return b.logger.log("sb remove " + x + " [" + P + "," + N + "], of [" + D + "," + R + "], pos:" + this.media.currentTime), w.remove(P, N), !0;
              }
            } catch ($) {
              b.logger.warn("removeBufferRange failed", $);
            }
            return !1;
          }, E);
          function E(x) {
            var w = f.call(this, x, m.default.MEDIA_ATTACHING, m.default.MEDIA_DETACHING, m.default.MANIFEST_PARSED, m.default.BUFFER_RESET, m.default.BUFFER_APPENDING, m.default.BUFFER_CODECS, m.default.BUFFER_EOS, m.default.BUFFER_FLUSHING, m.default.LEVEL_PTS_UPDATED, m.default.LEVEL_UPDATED) || this;
            return w._msDuration = null, w._levelDuration = null, w._levelTargetDuration = 10, w._live = null, w._objectUrl = null, w.bufferCodecEventsExpected = 0, w.onsbue = w.onSBUpdateEnd.bind(w), w.onsbe = w.onSBUpdateError.bind(w), w.pendingTracks = {}, w.tracks = {}, w;
          }
          l.default = g;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/controller/cap-level-controller.js": function(o, l, u) {
        (function(h) {
          var c, d = this && this.__extends || (c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, g) {
            v.__proto__ = g;
          } || function(v, g) {
            for (var E in g)
              g.hasOwnProperty(E) && (v[E] = g[E]);
          }, function(v, g) {
            function E() {
              this.constructor = v;
            }
            c(v, g), v.prototype = g === null ? Object.create(g) : (E.prototype = g.prototype, new E());
          });
          Object.defineProperty(l, "__esModule", { value: !0 });
          var f, m = u("./src/events.js"), p = u("./src/event-handler.js"), b = (f = p.default, d(y, f), y.prototype.destroy = function() {
            this.hls.config.capLevelToPlayerSize && (this.media = null, this._stopCapping());
          }, y.prototype.onFpsDropLevelCapping = function(v) {
            y.isLevelAllowed(v.droppedLevel, this.restrictedLevels) && this.restrictedLevels.push(v.droppedLevel);
          }, y.prototype.onMediaAttaching = function(v) {
            this.media = v.media instanceof window.HTMLVideoElement ? v.media : null;
          }, y.prototype.onManifestParsed = function(v) {
            var g = this.hls;
            this.restrictedLevels = [], this.levels = v.levels, this.firstLevel = v.firstLevel, g.config.capLevelToPlayerSize && v.video && this._startCapping();
          }, y.prototype.onBufferCodecs = function(v) {
            this.hls.config.capLevelToPlayerSize && v.video && this._startCapping();
          }, y.prototype.onLevelsUpdated = function(v) {
            this.levels = v.levels;
          }, y.prototype.onMediaDetaching = function() {
            this._stopCapping();
          }, y.prototype.detectPlayerSize = function() {
            if (this.media) {
              var v = this.levels ? this.levels.length : 0;
              if (v) {
                var g = this.hls;
                g.autoLevelCapping = this.getMaxLevel(v - 1), g.autoLevelCapping > this.autoLevelCapping && g.streamController.nextLevelSwitch(), this.autoLevelCapping = g.autoLevelCapping;
              }
            }
          }, y.prototype.getMaxLevel = function(v) {
            var g = this;
            if (!this.levels)
              return -1;
            var E = this.levels.filter(function(x, w) {
              return y.isLevelAllowed(w, g.restrictedLevels) && w <= v;
            });
            return y.getMaxLevelByMediaSize(E, this.mediaWidth, this.mediaHeight);
          }, y.prototype._startCapping = function() {
            this.timer || (this.autoLevelCapping = h.POSITIVE_INFINITY, this.hls.firstLevel = this.getMaxLevel(this.firstLevel), clearInterval(this.timer), this.timer = setInterval(this.detectPlayerSize.bind(this), 1e3), this.detectPlayerSize());
          }, y.prototype._stopCapping = function() {
            this.restrictedLevels = [], this.firstLevel = null, this.autoLevelCapping = h.POSITIVE_INFINITY, this.timer && (this.timer = clearInterval(this.timer), this.timer = null);
          }, Object.defineProperty(y.prototype, "mediaWidth", { get: function() {
            var v, g = this.media;
            return g && (v = g.width || g.clientWidth || g.offsetWidth, v *= y.contentScaleFactor), v;
          }, enumerable: !0, configurable: !0 }), Object.defineProperty(y.prototype, "mediaHeight", { get: function() {
            var v, g = this.media;
            return g && (v = g.height || g.clientHeight || g.offsetHeight, v *= y.contentScaleFactor), v;
          }, enumerable: !0, configurable: !0 }), Object.defineProperty(y, "contentScaleFactor", { get: function() {
            var v = 1;
            try {
              v = window.devicePixelRatio;
            } catch {
            }
            return v;
          }, enumerable: !0, configurable: !0 }), y.isLevelAllowed = function(v, g) {
            return g === void 0 && (g = []), g.indexOf(v) === -1;
          }, y.getMaxLevelByMediaSize = function(v, g, E) {
            if (!v || v && !v.length)
              return -1;
            for (var x, w, S = v.length - 1, T = 0; T < v.length; T += 1) {
              var C = v[T];
              if ((C.width >= g || C.height >= E) && (x = C, !(w = v[T + 1]) || x.width !== w.width || x.height !== w.height)) {
                S = T;
                break;
              }
            }
            return S;
          }, y);
          function y(v) {
            var g = f.call(this, v, m.default.FPS_DROP_LEVEL_CAPPING, m.default.MEDIA_ATTACHING, m.default.MANIFEST_PARSED, m.default.BUFFER_CODECS, m.default.MEDIA_DETACHING) || this;
            return g.autoLevelCapping = h.POSITIVE_INFINITY, g.firstLevel = null, g.levels = [], g.media = null, g.restrictedLevels = [], g.timer = null, g;
          }
          l.default = b;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/controller/eme-controller.js": function(o, l, u) {
        var h, c = this && this.__extends || (h = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(w, S) {
          w.__proto__ = S;
        } || function(w, S) {
          for (var T in S)
            S.hasOwnProperty(T) && (w[T] = S[T]);
        }, function(w, S) {
          function T() {
            this.constructor = w;
          }
          h(w, S), w.prototype = S === null ? Object.create(S) : (T.prototype = S.prototype, new T());
        });
        Object.defineProperty(l, "__esModule", { value: !0 });
        var d, f = u("./src/event-handler.js"), m = u("./src/events.js"), p = u("./src/errors.js"), b = u("./src/utils/logger.js"), y = window.XMLHttpRequest, v = "com.widevine.alpha", g = "com.microsoft.playready", E = (d = f.default, c(x, d), x.prototype.getLicenseServerUrl = function(w) {
          var S;
          switch (w) {
            case v:
              S = this._widevineLicenseUrl;
              break;
            default:
              S = null;
          }
          return S || (b.logger.error('No license server URL configured for key-system "' + w + '"'), this.hls.trigger(m.default.ERROR, { type: p.ErrorTypes.KEY_SYSTEM_ERROR, details: p.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED, fatal: !0 })), S;
        }, x.prototype._attemptKeySystemAccess = function(w, S, T) {
          var C = this, D = function(R, P, N) {
            switch (R) {
              case v:
                return function($, O) {
                  var M = { videoCapabilities: [] };
                  return O.forEach(function(F) {
                    M.videoCapabilities.push({ contentType: 'video/mp4; codecs="' + F + '"' });
                  }), [M];
                }(0, N);
              default:
                throw Error("Unknown key-system: " + R);
            }
          }(w, 0, T);
          D ? (b.logger.log("Requesting encrypted media key-system access"), this.requestMediaKeySystemAccess(w, D).then(function(R) {
            C._onMediaKeySystemAccessObtained(w, R);
          }).catch(function(R) {
            b.logger.error('Failed to obtain key-system "' + w + '" access:', R);
          })) : b.logger.warn("Can not create config for key-system (maybe because platform is not supported):", w);
        }, Object.defineProperty(x.prototype, "requestMediaKeySystemAccess", { get: function() {
          if (!this._requestMediaKeySystemAccess)
            throw new Error("No requestMediaKeySystemAccess function configured");
          return this._requestMediaKeySystemAccess;
        }, enumerable: !0, configurable: !0 }), x.prototype._onMediaKeySystemAccessObtained = function(w, S) {
          var T = this;
          b.logger.log('Access for key-system "' + w + '" obtained');
          var C = { mediaKeys: null, mediaKeysSession: null, mediaKeysSessionInitialized: !1, mediaKeySystemAccess: S, mediaKeySystemDomain: w };
          this._mediaKeysList.push(C), S.createMediaKeys().then(function(D) {
            C.mediaKeys = D, b.logger.log('Media-keys created for key-system "' + w + '"'), T._onMediaKeysCreated();
          }).catch(function(D) {
            b.logger.error("Failed to create media-keys:", D);
          });
        }, x.prototype._onMediaKeysCreated = function() {
          var w = this;
          this._mediaKeysList.forEach(function(S) {
            S.mediaKeysSession || (S.mediaKeysSession = S.mediaKeys.createSession(), w._onNewMediaKeySession(S.mediaKeysSession));
          });
        }, x.prototype._onNewMediaKeySession = function(w) {
          var S = this;
          b.logger.log("New key-system session " + w.sessionId), w.addEventListener("message", function(T) {
            S._onKeySessionMessage(w, T.message);
          }, !1);
        }, x.prototype._onKeySessionMessage = function(w, S) {
          b.logger.log("Got EME message event, creating license request"), this._requestLicense(S, function(T) {
            b.logger.log("Received license data, updating key-session"), w.update(T);
          });
        }, x.prototype._onMediaEncrypted = function(w, S) {
          b.logger.log('Media is encrypted using "' + w + '" init data type'), this._isMediaEncrypted = !0, this._mediaEncryptionInitDataType = w, this._mediaEncryptionInitData = S, this._attemptSetMediaKeys(), this._generateRequestWithPreferredKeySession();
        }, x.prototype._attemptSetMediaKeys = function() {
          if (!this._hasSetMediaKeys) {
            var w = this._mediaKeysList[0];
            if (!w || !w.mediaKeys)
              return b.logger.error("Fatal: Media is encrypted but no CDM access or no keys have been obtained yet"), void this.hls.trigger(m.default.ERROR, { type: p.ErrorTypes.KEY_SYSTEM_ERROR, details: p.ErrorDetails.KEY_SYSTEM_NO_KEYS, fatal: !0 });
            b.logger.log("Setting keys for encrypted media"), this._media.setMediaKeys(w.mediaKeys), this._hasSetMediaKeys = !0;
          }
        }, x.prototype._generateRequestWithPreferredKeySession = function() {
          var w = this, S = this._mediaKeysList[0];
          if (!S)
            return b.logger.error("Fatal: Media is encrypted but not any key-system access has been obtained yet"), void this.hls.trigger(m.default.ERROR, { type: p.ErrorTypes.KEY_SYSTEM_ERROR, details: p.ErrorDetails.KEY_SYSTEM_NO_ACCESS, fatal: !0 });
          if (S.mediaKeysSessionInitialized)
            b.logger.warn("Key-Session already initialized but requested again");
          else {
            var T = S.mediaKeysSession;
            T || (b.logger.error("Fatal: Media is encrypted but no key-session existing"), this.hls.trigger(m.default.ERROR, { type: p.ErrorTypes.KEY_SYSTEM_ERROR, details: p.ErrorDetails.KEY_SYSTEM_NO_SESSION, fatal: !0 }));
            var C = this._mediaEncryptionInitDataType, D = this._mediaEncryptionInitData;
            b.logger.log('Generating key-session request for "' + C + '" init data type'), S.mediaKeysSessionInitialized = !0, T.generateRequest(C, D).then(function() {
              b.logger.debug("Key-session generation succeeded");
            }).catch(function(R) {
              b.logger.error("Error generating key-session request:", R), w.hls.trigger(m.default.ERROR, { type: p.ErrorTypes.KEY_SYSTEM_ERROR, details: p.ErrorDetails.KEY_SYSTEM_NO_SESSION, fatal: !1 });
            });
          }
        }, x.prototype._createLicenseXhr = function(w, S, T) {
          var C = new y(), D = this._licenseXhrSetup;
          try {
            if (D)
              try {
                D(C, w);
              } catch {
                C.open("POST", w, !0), D(C, w);
              }
            C.readyState || C.open("POST", w, !0);
          } catch (R) {
            return b.logger.error("Error setting up key-system license XHR", R), void this.hls.trigger(m.default.ERROR, { type: p.ErrorTypes.KEY_SYSTEM_ERROR, details: p.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED, fatal: !0 });
          }
          return C.responseType = "arraybuffer", C.onreadystatechange = this._onLicenseRequestReadyStageChange.bind(this, C, w, S, T), C;
        }, x.prototype._onLicenseRequestReadyStageChange = function(w, S, T, C) {
          switch (w.readyState) {
            case 4:
              if (w.status === 200)
                this._requestLicenseFailureCount = 0, b.logger.log("License request succeeded"), C(w.response);
              else {
                if (b.logger.error("License Request XHR failed (" + S + "). Status: " + w.status + " (" + w.statusText + ")"), this._requestLicenseFailureCount++, this._requestLicenseFailureCount <= 3) {
                  var D = 3 - this._requestLicenseFailureCount + 1;
                  return b.logger.warn("Retrying license request, " + D + " attempts left"), void this._requestLicense(T, C);
                }
                this.hls.trigger(m.default.ERROR, { type: p.ErrorTypes.KEY_SYSTEM_ERROR, details: p.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED, fatal: !0 });
              }
          }
        }, x.prototype._generateLicenseRequestChallenge = function(w, S) {
          var T;
          return w.mediaKeySystemDomain === g ? b.logger.error("PlayReady is not supported (yet)") : w.mediaKeySystemDomain === v ? T = S : b.logger.error("Unsupported key-system:", w.mediaKeySystemDomain), T;
        }, x.prototype._requestLicense = function(w, S) {
          b.logger.log("Requesting content license for key-system");
          var T = this._mediaKeysList[0];
          if (!T)
            return b.logger.error("Fatal error: Media is encrypted but no key-system access has been obtained yet"), void this.hls.trigger(m.default.ERROR, { type: p.ErrorTypes.KEY_SYSTEM_ERROR, details: p.ErrorDetails.KEY_SYSTEM_NO_ACCESS, fatal: !0 });
          var C = this.getLicenseServerUrl(T.mediaKeySystemDomain), D = this._createLicenseXhr(C, w, S);
          b.logger.log("Sending license request to URL: " + C), D.send(this._generateLicenseRequestChallenge(T, w));
        }, x.prototype.onMediaAttached = function(w) {
          var S = this;
          if (this._emeEnabled) {
            var T = w.media;
            (this._media = T).addEventListener("encrypted", function(C) {
              S._onMediaEncrypted(C.initDataType, C.initData);
            });
          }
        }, x.prototype.onManifestParsed = function(w) {
          if (this._emeEnabled) {
            var S = w.levels.map(function(C) {
              return C.audioCodec;
            }), T = w.levels.map(function(C) {
              return C.videoCodec;
            });
            this._attemptKeySystemAccess(v, S, T);
          }
        }, x);
        function x(w) {
          var S = d.call(this, w, m.default.MEDIA_ATTACHED, m.default.MANIFEST_PARSED) || this;
          return S._widevineLicenseUrl = w.config.widevineLicenseUrl, S._licenseXhrSetup = w.config.licenseXhrSetup, S._emeEnabled = w.config.emeEnabled, S._requestMediaKeySystemAccess = w.config.requestMediaKeySystemAccessFunc, S._mediaKeysList = [], S._media = null, S._hasSetMediaKeys = !1, S._isMediaEncrypted = !1, S._requestLicenseFailureCount = 0, S;
        }
        l.default = E;
      }, "./src/controller/fps-controller.js": function(o, l, u) {
        var h, c = this && this.__extends || (h = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(g, E) {
          g.__proto__ = E;
        } || function(g, E) {
          for (var x in E)
            E.hasOwnProperty(x) && (g[x] = E[x]);
        }, function(g, E) {
          function x() {
            this.constructor = g;
          }
          h(g, E), g.prototype = E === null ? Object.create(E) : (x.prototype = E.prototype, new x());
        });
        Object.defineProperty(l, "__esModule", { value: !0 });
        var d, f = u("./src/events.js"), m = u("./src/event-handler.js"), p = u("./src/utils/logger.js"), b = window.performance, y = (d = m.default, c(v, d), v.prototype.destroy = function() {
          this.timer && clearInterval(this.timer), this.isVideoPlaybackQualityAvailable = !1;
        }, v.prototype.onMediaAttaching = function(g) {
          var E = this.hls.config;
          E.capLevelOnFPSDrop && (typeof (this.video = g.media instanceof window.HTMLVideoElement ? g.media : null).getVideoPlaybackQuality == "function" && (this.isVideoPlaybackQualityAvailable = !0), clearInterval(this.timer), this.timer = setInterval(this.checkFPSInterval.bind(this), E.fpsDroppedMonitoringPeriod));
        }, v.prototype.checkFPS = function(g, E, x) {
          var w = b.now();
          if (E) {
            if (this.lastTime) {
              var S = w - this.lastTime, T = x - this.lastDroppedFrames, C = E - this.lastDecodedFrames, D = 1e3 * T / S, R = this.hls;
              if (R.trigger(f.default.FPS_DROP, { currentDropped: T, currentDecoded: C, totalDroppedFrames: x }), 0 < D && T > R.config.fpsDroppedMonitoringThreshold * C) {
                var P = R.currentLevel;
                p.logger.warn("drop FPS ratio greater than max allowed value for currentLevel: " + P), 0 < P && (R.autoLevelCapping === -1 || R.autoLevelCapping >= P) && (P -= 1, R.trigger(f.default.FPS_DROP_LEVEL_CAPPING, { level: P, droppedLevel: R.currentLevel }), R.autoLevelCapping = P, R.streamController.nextLevelSwitch());
              }
            }
            this.lastTime = w, this.lastDroppedFrames = x, this.lastDecodedFrames = E;
          }
        }, v.prototype.checkFPSInterval = function() {
          var g = this.video;
          if (g)
            if (this.isVideoPlaybackQualityAvailable) {
              var E = g.getVideoPlaybackQuality();
              this.checkFPS(g, E.totalVideoFrames, E.droppedVideoFrames);
            } else
              this.checkFPS(g, g.webkitDecodedFrameCount, g.webkitDroppedFrameCount);
        }, v);
        function v(g) {
          return d.call(this, g, f.default.MEDIA_ATTACHING) || this;
        }
        l.default = y;
      }, "./src/controller/fragment-finders.js": function(o, l, u) {
        (function(h) {
          Object.defineProperty(l, "__esModule", { value: !0 });
          var c = u("./src/utils/binary-search.js");
          function d(m, p, b) {
            m === void 0 && (m = 0), p === void 0 && (p = 0);
            var y = Math.min(p, b.duration + (b.deltaPTS ? b.deltaPTS : 0));
            return b.start + b.duration - y <= m ? 1 : b.start - y > m && b.start ? -1 : 0;
          }
          function f(m, p, b) {
            var y = 1e3 * Math.min(p, b.duration + (b.deltaPTS ? b.deltaPTS : 0));
            return b.endProgramDateTime - y > m;
          }
          l.findFragmentByPDT = function(m, p, b) {
            if (!Array.isArray(m) || !m.length || !h.isFinite(p) || p < m[0].programDateTime || p >= m[m.length - 1].endProgramDateTime)
              return null;
            b = b || 0;
            for (var y = 0; y < m.length; ++y) {
              var v = m[y];
              if (f(p, b, v))
                return v;
            }
            return null;
          }, l.findFragmentByPTS = function(m, p, b, y) {
            b === void 0 && (b = 0), y === void 0 && (y = 0);
            var v = m ? p[m.sn - p[0].sn + 1] : null;
            return v && !d(b, y, v) ? v : c.default.search(p, d.bind(null, b, y));
          }, l.fragmentWithinToleranceTest = d, l.pdtWithinToleranceTest = f;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/controller/fragment-tracker.js": function(o, l, u) {
        (function(h) {
          var c, d = this && this.__extends || (c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, g) {
            v.__proto__ = g;
          } || function(v, g) {
            for (var E in g)
              g.hasOwnProperty(E) && (v[E] = g[E]);
          }, function(v, g) {
            function E() {
              this.constructor = v;
            }
            c(v, g), v.prototype = g === null ? Object.create(g) : (E.prototype = g.prototype, new E());
          });
          Object.defineProperty(l, "__esModule", { value: !0 });
          var f = u("./src/event-handler.js"), m = u("./src/events.js");
          l.FragmentState = { NOT_LOADED: "NOT_LOADED", APPENDING: "APPENDING", PARTIAL: "PARTIAL", OK: "OK" };
          var p, b = (p = f.default, d(y, p), y.prototype.destroy = function() {
            this.fragments = /* @__PURE__ */ Object.create(null), this.timeRanges = /* @__PURE__ */ Object.create(null), this.config = null, f.default.prototype.destroy.call(this), p.prototype.destroy.call(this);
          }, y.prototype.getBufferedFrag = function(v, g) {
            var E = this.fragments, x = Object.keys(E).filter(function(S) {
              var T = E[S];
              if (T.body.type !== g || !T.buffered)
                return !1;
              var C = T.body;
              return C.startPTS <= v && v <= C.endPTS;
            });
            if (x.length === 0)
              return null;
            var w = x.pop();
            return E[w].body;
          }, y.prototype.detectEvictedFragments = function(v, g) {
            var E, x, w = this;
            Object.keys(this.fragments).forEach(function(S) {
              var T = w.fragments[S];
              if (T.buffered === !0) {
                var C = T.range[v];
                if (C) {
                  E = C.time;
                  for (var D = 0; D < E.length; D++)
                    if (x = E[D], w.isTimeBuffered(x.startPTS, x.endPTS, g) === !1) {
                      w.removeFragment(T.body);
                      break;
                    }
                }
              }
            });
          }, y.prototype.detectPartialFragments = function(v) {
            var g = this, E = this.getFragmentKey(v), x = this.fragments[E];
            x && (x.buffered = !0, Object.keys(this.timeRanges).forEach(function(w) {
              if (v.hasElementaryStream(w)) {
                var S = g.timeRanges[w];
                x.range[w] = g.getBufferedTimes(v.startPTS, v.endPTS, S);
              }
            }));
          }, y.prototype.getBufferedTimes = function(v, g, E) {
            for (var x, w, S = [], T = !1, C = 0; C < E.length; C++) {
              if (x = E.start(C) - this.bufferPadding, w = E.end(C) + this.bufferPadding, x <= v && g <= w) {
                S.push({ startPTS: Math.max(v, E.start(C)), endPTS: Math.min(g, E.end(C)) });
                break;
              }
              if (v < w && x < g)
                S.push({ startPTS: Math.max(v, E.start(C)), endPTS: Math.min(g, E.end(C)) }), T = !0;
              else if (g <= x)
                break;
            }
            return { time: S, partial: T };
          }, y.prototype.getFragmentKey = function(v) {
            return v.type + "_" + v.level + "_" + v.urlId + "_" + v.sn;
          }, y.prototype.getPartialFragment = function(v) {
            var g, E, x, w = this, S = null, T = 0;
            return Object.keys(this.fragments).forEach(function(C) {
              var D = w.fragments[C];
              w.isPartial(D) && (E = D.body.startPTS - w.bufferPadding, x = D.body.endPTS + w.bufferPadding, E <= v && v <= x && (g = Math.min(v - E, x - v), T <= g && (S = D.body, T = g)));
            }), S;
          }, y.prototype.getState = function(v) {
            var g = this.getFragmentKey(v), E = this.fragments[g], x = l.FragmentState.NOT_LOADED;
            return E !== void 0 && (x = E.buffered ? this.isPartial(E) === !0 ? l.FragmentState.PARTIAL : l.FragmentState.OK : l.FragmentState.APPENDING), x;
          }, y.prototype.isPartial = function(v) {
            return v.buffered === !0 && (v.range.video !== void 0 && v.range.video.partial === !0 || v.range.audio !== void 0 && v.range.audio.partial === !0);
          }, y.prototype.isTimeBuffered = function(v, g, E) {
            for (var x, w, S = 0; S < E.length; S++) {
              if (x = E.start(S) - this.bufferPadding, w = E.end(S) + this.bufferPadding, x <= v && g <= w)
                return !0;
              if (g <= x)
                return !1;
            }
            return !1;
          }, y.prototype.onFragLoaded = function(v) {
            var g = v.frag;
            h.isFinite(g.sn) && !g.bitrateTest && (this.fragments[this.getFragmentKey(g)] = { body: g, range: /* @__PURE__ */ Object.create(null), buffered: !1 });
          }, y.prototype.onBufferAppended = function(v) {
            var g = this;
            this.timeRanges = v.timeRanges, Object.keys(this.timeRanges).forEach(function(E) {
              var x = g.timeRanges[E];
              g.detectEvictedFragments(E, x);
            });
          }, y.prototype.onFragBuffered = function(v) {
            this.detectPartialFragments(v.frag);
          }, y.prototype.hasFragment = function(v) {
            var g = this.getFragmentKey(v);
            return this.fragments[g] !== void 0;
          }, y.prototype.removeFragment = function(v) {
            var g = this.getFragmentKey(v);
            delete this.fragments[g];
          }, y.prototype.removeAllFragments = function() {
            this.fragments = /* @__PURE__ */ Object.create(null);
          }, y);
          function y(v) {
            var g = p.call(this, v, m.default.BUFFER_APPENDED, m.default.FRAG_BUFFERED, m.default.FRAG_LOADED) || this;
            return g.bufferPadding = 0.2, g.fragments = /* @__PURE__ */ Object.create(null), g.timeRanges = /* @__PURE__ */ Object.create(null), g.config = v.config, g;
          }
          l.FragmentTracker = b;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/controller/gap-controller.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./src/utils/buffer-helper.js"), c = u("./src/errors.js"), d = u("./src/events.js"), f = u("./src/utils/logger.js"), m = (p.prototype.poll = function(b, y) {
          var v = this.config, g = this.media, E = g.currentTime, x = window.performance.now();
          if (E !== b)
            return this.stallReported && (f.logger.warn("playback not stuck anymore @" + E + ", after " + Math.round(x - this.stalled) + "ms"), this.stallReported = !1), this.stalled = null, void (this.nudgeRetry = 0);
          if (!(g.ended || !g.buffered.length || 2 < g.readyState || g.seeking && h.BufferHelper.isBuffered(g, E))) {
            var w = x - this.stalled, S = h.BufferHelper.bufferInfo(g, E, v.maxBufferHole);
            this.stalled ? (1e3 <= w && this._reportStall(S.len), this._tryFixBufferStall(S, w)) : this.stalled = x;
          }
        }, p.prototype._tryFixBufferStall = function(b, y) {
          var v = this.config, g = this.fragmentTracker, E = this.media.currentTime, x = g.getPartialFragment(E);
          x && this._trySkipBufferHole(x), 0.5 < b.len && y > 1e3 * v.highBufferWatchdogPeriod && (this.stalled = null, this._tryNudgeBuffer());
        }, p.prototype._reportStall = function(b) {
          var y = this.hls, v = this.media;
          this.stallReported || (this.stallReported = !0, f.logger.warn("Playback stalling at @" + v.currentTime + " due to low buffer"), y.trigger(d.default.ERROR, { type: c.ErrorTypes.MEDIA_ERROR, details: c.ErrorDetails.BUFFER_STALLED_ERROR, fatal: !1, buffer: b }));
        }, p.prototype._trySkipBufferHole = function(b) {
          for (var y = this.hls, v = this.media, g = v.currentTime, E = 0, x = 0; x < v.buffered.length; x++) {
            var w = v.buffered.start(x);
            if (E <= g && g < w)
              return v.currentTime = Math.max(w, v.currentTime + 0.1), f.logger.warn("skipping hole, adjusting currentTime from " + g + " to " + v.currentTime), this.stalled = null, void y.trigger(d.default.ERROR, { type: c.ErrorTypes.MEDIA_ERROR, details: c.ErrorDetails.BUFFER_SEEK_OVER_HOLE, fatal: !1, reason: "fragment loaded with buffer holes, seeking from " + g + " to " + v.currentTime, frag: b });
            E = v.buffered.end(x);
          }
        }, p.prototype._tryNudgeBuffer = function() {
          var b = this.config, y = this.hls, v = this.media, g = v.currentTime, E = (this.nudgeRetry || 0) + 1;
          if ((this.nudgeRetry = E) < b.nudgeMaxRetry) {
            var x = g + E * b.nudgeOffset;
            f.logger.log("adjust currentTime from " + g + " to " + x), v.currentTime = x, y.trigger(d.default.ERROR, { type: c.ErrorTypes.MEDIA_ERROR, details: c.ErrorDetails.BUFFER_NUDGE_ON_STALL, fatal: !1 });
          } else
            f.logger.error("still stuck in high buffer @" + g + " after " + b.nudgeMaxRetry + ", raise fatal error"), y.trigger(d.default.ERROR, { type: c.ErrorTypes.MEDIA_ERROR, details: c.ErrorDetails.BUFFER_STALLED_ERROR, fatal: !0 });
        }, p);
        function p(b, y, v, g) {
          this.config = b, this.media = y, this.fragmentTracker = v, this.hls = g, this.stallReported = !1;
        }
        l.default = m;
      }, "./src/controller/id3-track-controller.js": function(o, l, u) {
        var h, c = this && this.__extends || (h = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(g, E) {
          g.__proto__ = E;
        } || function(g, E) {
          for (var x in E)
            E.hasOwnProperty(x) && (g[x] = E[x]);
        }, function(g, E) {
          function x() {
            this.constructor = g;
          }
          h(g, E), g.prototype = E === null ? Object.create(E) : (x.prototype = E.prototype, new x());
        });
        Object.defineProperty(l, "__esModule", { value: !0 });
        var d, f = u("./src/events.js"), m = u("./src/event-handler.js"), p = u("./src/demux/id3.js"), b = u("./src/utils/texttrack-utils.js"), y = (d = m.default, c(v, d), v.prototype.destroy = function() {
          m.default.prototype.destroy.call(this);
        }, v.prototype.onMediaAttached = function(g) {
          this.media = g.media, this.media;
        }, v.prototype.onMediaDetaching = function() {
          b.clearCurrentCues(this.id3Track), this.id3Track = void 0, this.media = void 0;
        }, v.prototype.getID3Track = function(g) {
          for (var E = 0; E < g.length; E++) {
            var x = g[E];
            if (x.kind === "metadata" && x.label === "id3")
              return b.sendAddTrackEvent(x, this.media), x;
          }
          return this.media.addTextTrack("metadata", "id3");
        }, v.prototype.onFragParsingMetadata = function(g) {
          var E = g.frag, x = g.samples;
          this.id3Track || (this.id3Track = this.getID3Track(this.media.textTracks), this.id3Track.mode = "hidden");
          for (var w = window.WebKitDataCue || window.VTTCue || window.TextTrackCue, S = 0; S < x.length; S++) {
            var T = p.default.getID3Frames(x[S].data);
            if (T) {
              var C = x[S].pts, D = S < x.length - 1 ? x[S + 1].pts : E.endPTS;
              C === D && (D += 1e-4);
              for (var R = 0; R < T.length; R++) {
                var P = T[R];
                if (!p.default.isTimeStampFrame(P)) {
                  var N = new w(C, D, "");
                  N.value = P, this.id3Track.addCue(N);
                }
              }
            }
          }
        }, v);
        function v(g) {
          var E = d.call(this, g, f.default.MEDIA_ATTACHED, f.default.MEDIA_DETACHING, f.default.FRAG_PARSING_METADATA) || this;
          return E.id3Track = void 0, E.media = void 0, E;
        }
        l.default = y;
      }, "./src/controller/level-controller.js": function(o, l, u) {
        var h, c = this && this.__extends || (h = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(w, S) {
          w.__proto__ = S;
        } || function(w, S) {
          for (var T in S)
            S.hasOwnProperty(T) && (w[T] = S[T]);
        }, function(w, S) {
          function T() {
            this.constructor = w;
          }
          h(w, S), w.prototype = S === null ? Object.create(S) : (T.prototype = S.prototype, new T());
        });
        Object.defineProperty(l, "__esModule", { value: !0 });
        var d, f, m = u("./src/events.js"), p = u("./src/event-handler.js"), b = u("./src/utils/logger.js"), y = u("./src/errors.js"), v = u("./src/utils/codecs.js"), g = u("./src/controller/level-helper.js"), E = (f = p.default, c(x, f), x.prototype.onHandlerDestroying = function() {
          this.clearTimer(), this.manualLevelIndex = -1;
        }, x.prototype.clearTimer = function() {
          this.timer !== null && (clearTimeout(this.timer), this.timer = null);
        }, x.prototype.startLoad = function() {
          var w = this._levels;
          this.canload = !0, this.levelRetryCount = 0, w && w.forEach(function(S) {
            S.loadError = 0;
            var T = S.details;
            T && T.live && (S.details = void 0);
          }), this.timer !== null && this.loadLevel();
        }, x.prototype.stopLoad = function() {
          this.canload = !1;
        }, x.prototype.onManifestLoaded = function(w) {
          var S, T = [], C = [], D = {}, R = null, P = !1, N = !1;
          if (w.levels.forEach(function(O) {
            var M = O.attrs;
            O.loadError = 0, O.fragmentError = !1, P = P || !!O.videoCodec, N = N || !!O.audioCodec, d && O.audioCodec && O.audioCodec.indexOf("mp4a.40.34") !== -1 && (O.audioCodec = void 0), (R = D[O.bitrate]) ? R.url.push(O.url) : (O.url = [O.url], O.urlId = 0, D[O.bitrate] = O, T.push(O)), M && (M.AUDIO && (N = !0, g.addGroupId(R || O, "audio", M.AUDIO)), M.SUBTITLES && g.addGroupId(R || O, "text", M.SUBTITLES));
          }), P && N && (T = T.filter(function(O) {
            return !!O.videoCodec;
          })), T = T.filter(function(O) {
            var M = O.audioCodec, F = O.videoCodec;
            return (!M || v.isCodecSupportedInMp4(M, "audio")) && (!F || v.isCodecSupportedInMp4(F, "video"));
          }), w.audioTracks && (C = w.audioTracks.filter(function(O) {
            return !O.audioCodec || v.isCodecSupportedInMp4(O.audioCodec, "audio");
          })).forEach(function(O, M) {
            O.id = M;
          }), 0 < T.length) {
            S = T[0].bitrate, T.sort(function(O, M) {
              return O.bitrate - M.bitrate;
            }), this._levels = T;
            for (var $ = 0; $ < T.length; $++)
              if (T[$].bitrate === S) {
                this._firstLevel = $, b.logger.log("manifest loaded," + T.length + " level(s) found, first bitrate:" + S);
                break;
              }
            this.hls.trigger(m.default.MANIFEST_PARSED, { levels: T, audioTracks: C, firstLevel: this._firstLevel, stats: w.stats, audio: N, video: P, altAudio: C.some(function(O) {
              return !!O.url;
            }) });
          } else
            this.hls.trigger(m.default.ERROR, { type: y.ErrorTypes.MEDIA_ERROR, details: y.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR, fatal: !0, url: this.hls.url, reason: "no level with compatible codecs found in manifest" });
        }, Object.defineProperty(x.prototype, "levels", { get: function() {
          return this._levels;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(x.prototype, "level", { get: function() {
          return this.currentLevelIndex;
        }, set: function(w) {
          var S = this._levels;
          S && (w = Math.min(w, S.length - 1), this.currentLevelIndex === w && S[w].details || this.setLevelInternal(w));
        }, enumerable: !0, configurable: !0 }), x.prototype.setLevelInternal = function(w) {
          var S = this._levels, T = this.hls;
          if (0 <= w && w < S.length) {
            if (this.clearTimer(), this.currentLevelIndex !== w) {
              b.logger.log("switching to level " + w);
              var C = S[this.currentLevelIndex = w];
              C.level = w, T.trigger(m.default.LEVEL_SWITCHING, C);
            }
            var D = S[w], R = D.details;
            if (!R || R.live) {
              var P = D.urlId;
              T.trigger(m.default.LEVEL_LOADING, { url: D.url[P], level: w, id: P });
            }
          } else
            T.trigger(m.default.ERROR, { type: y.ErrorTypes.OTHER_ERROR, details: y.ErrorDetails.LEVEL_SWITCH_ERROR, level: w, fatal: !1, reason: "invalid level idx" });
        }, Object.defineProperty(x.prototype, "manualLevel", { get: function() {
          return this.manualLevelIndex;
        }, set: function(w) {
          this.manualLevelIndex = w, this._startLevel === void 0 && (this._startLevel = w), w !== -1 && (this.level = w);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(x.prototype, "firstLevel", { get: function() {
          return this._firstLevel;
        }, set: function(w) {
          this._firstLevel = w;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(x.prototype, "startLevel", { get: function() {
          if (this._startLevel !== void 0)
            return this._startLevel;
          var w = this.hls.config.startLevel;
          return w !== void 0 ? w : this._firstLevel;
        }, set: function(w) {
          this._startLevel = w;
        }, enumerable: !0, configurable: !0 }), x.prototype.onError = function(w) {
          if (w.fatal)
            w.type === y.ErrorTypes.NETWORK_ERROR && this.clearTimer();
          else {
            var S, T = !1, C = !1;
            switch (w.details) {
              case y.ErrorDetails.FRAG_LOAD_ERROR:
              case y.ErrorDetails.FRAG_LOAD_TIMEOUT:
              case y.ErrorDetails.KEY_LOAD_ERROR:
              case y.ErrorDetails.KEY_LOAD_TIMEOUT:
                S = w.frag.level, C = !0;
                break;
              case y.ErrorDetails.LEVEL_LOAD_ERROR:
              case y.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                S = w.context.level, T = !0;
                break;
              case y.ErrorDetails.REMUX_ALLOC_ERROR:
                S = w.level, T = !0;
            }
            S !== void 0 && this.recoverLevel(w, S, T, C);
          }
        }, x.prototype.recoverLevel = function(w, S, T, C) {
          var D, R, P, N = this, $ = this.hls.config, O = w.details, M = this._levels[S];
          if (M.loadError++, M.fragmentError = C, T) {
            if (!(this.levelRetryCount + 1 <= $.levelLoadingMaxRetry))
              return b.logger.error("level controller, cannot recover from " + O + " error"), this.currentLevelIndex = null, this.clearTimer(), void (w.fatal = !0);
            R = Math.min(Math.pow(2, this.levelRetryCount) * $.levelLoadingRetryDelay, $.levelLoadingMaxRetryTimeout), this.timer = setTimeout(function() {
              return N.loadLevel();
            }, R), w.levelRetry = !0, this.levelRetryCount++, b.logger.warn("level controller, " + O + ", retry in " + R + " ms, current retry count is " + this.levelRetryCount);
          }
          (T || C) && (1 < (D = M.url.length) && M.loadError < D ? (M.urlId = (M.urlId + 1) % D, M.details = void 0, b.logger.warn("level controller, " + O + " for level " + S + ": switching to redundant URL-id " + M.urlId)) : this.manualLevelIndex === -1 ? (P = S === 0 ? this._levels.length - 1 : S - 1, b.logger.warn("level controller, " + O + ": switch to " + P), this.hls.nextAutoLevel = this.currentLevelIndex = P) : C && (b.logger.warn("level controller, " + O + ": reload a fragment"), this.currentLevelIndex = null));
        }, x.prototype.onFragLoaded = function(w) {
          var S = w.frag;
          if (S !== void 0 && S.type === "main") {
            var T = this._levels[S.level];
            T !== void 0 && (T.fragmentError = !1, T.loadError = 0, this.levelRetryCount = 0);
          }
        }, x.prototype.onLevelLoaded = function(w) {
          var S = this, T = w.level, C = w.details;
          if (T === this.currentLevelIndex) {
            var D = this._levels[T];
            if (D.fragmentError || (D.loadError = 0, this.levelRetryCount = 0), C.live) {
              var R = g.computeReloadInterval(D.details, C, w.stats.trequest);
              b.logger.log("live playlist, reload in " + Math.round(R) + " ms"), this.timer = setTimeout(function() {
                return S.loadLevel();
              }, R);
            } else
              this.clearTimer();
          }
        }, x.prototype.onAudioTrackSwitched = function(w) {
          var S = this.hls.audioTracks[w.id].groupId, T = this.hls.levels[this.currentLevelIndex];
          if (T && T.audioGroupIds) {
            for (var C = -1, D = 0; D < T.audioGroupIds.length; D++)
              if (T.audioGroupIds[D] === S) {
                C = D;
                break;
              }
            C !== T.urlId && (T.urlId = C, this.startLoad());
          }
        }, x.prototype.loadLevel = function() {
          if (b.logger.debug("call to loadLevel"), this.currentLevelIndex !== null && this.canload) {
            var w = this._levels[this.currentLevelIndex];
            if (typeof w == "object" && 0 < w.url.length) {
              var S = this.currentLevelIndex, T = w.urlId, C = w.url[T];
              b.logger.log("Attempt loading level index " + S + " with URL-id " + T), this.hls.trigger(m.default.LEVEL_LOADING, { url: C, level: S, id: T });
            }
          }
        }, Object.defineProperty(x.prototype, "nextLoadLevel", { get: function() {
          return this.manualLevelIndex !== -1 ? this.manualLevelIndex : this.hls.nextAutoLevel;
        }, set: function(w) {
          this.level = w, this.manualLevelIndex === -1 && (this.hls.nextAutoLevel = w);
        }, enumerable: !0, configurable: !0 }), x);
        function x(w) {
          var S = f.call(this, w, m.default.MANIFEST_LOADED, m.default.LEVEL_LOADED, m.default.AUDIO_TRACK_SWITCHED, m.default.FRAG_LOADED, m.default.ERROR) || this;
          return S.canload = !1, S.currentLevelIndex = null, S.manualLevelIndex = -1, S.timer = null, d = /chrome|firefox/.test(navigator.userAgent.toLowerCase()), S;
        }
        l.default = E;
      }, "./src/controller/level-helper.js": function(o, l, u) {
        (function(h) {
          Object.defineProperty(l, "__esModule", { value: !0 });
          var c = u("./src/utils/logger.js");
          function d(b, y, v) {
            var g = b[y], E = b[v], x = E.startPTS;
            h.isFinite(x) ? y < v ? (g.duration = x - g.start, g.duration < 0 && c.logger.warn("negative duration computed for frag " + g.sn + ",level " + g.level + ", there should be some duration drift between playlist and fragment!")) : (E.duration = g.start - x, E.duration < 0 && c.logger.warn("negative duration computed for frag " + E.sn + ",level " + E.level + ", there should be some duration drift between playlist and fragment!")) : E.start = y < v ? g.start + g.duration : Math.max(g.start - E.duration, 0);
          }
          function f(b, y, v, g, E, x) {
            var w = v;
            if (h.isFinite(y.startPTS)) {
              var S = Math.abs(y.startPTS - v);
              h.isFinite(y.deltaPTS) ? y.deltaPTS = Math.max(S, y.deltaPTS) : y.deltaPTS = S, w = Math.max(v, y.startPTS), v = Math.min(v, y.startPTS), g = Math.max(g, y.endPTS), E = Math.min(E, y.startDTS), x = Math.max(x, y.endDTS);
            }
            var T = v - y.start;
            y.start = y.startPTS = v, y.maxStartPTS = w, y.endPTS = g, y.startDTS = E, y.endDTS = x, y.duration = g - v;
            var C, D, R, P = y.sn;
            if (!b || P < b.startSN || P > b.endSN)
              return 0;
            for (C = P - b.startSN, (D = b.fragments)[C] = y, R = C; 0 < R; R--)
              d(D, R, R - 1);
            for (R = C; R < D.length - 1; R++)
              d(D, R, R + 1);
            return b.PTSKnown = !0, T;
          }
          function m(b, y, v) {
            if (b && y)
              for (var g = Math.max(b.startSN, y.startSN) - y.startSN, E = Math.min(b.endSN, y.endSN) - y.startSN, x = y.startSN - b.startSN, w = g; w <= E; w++) {
                var S = b.fragments[x + w], T = y.fragments[w];
                if (!S || !T)
                  break;
                v(S, T, w);
              }
          }
          function p(b, y) {
            var v = y.startSN - b.startSN, g = b.fragments, E = y.fragments;
            if (!(v < 0 || v > g.length))
              for (var x = 0; x < E.length; x++)
                E[x].start += g[v].start;
          }
          l.addGroupId = function(b, y, v) {
            switch (y) {
              case "audio":
                b.audioGroupIds || (b.audioGroupIds = []), b.audioGroupIds.push(v);
                break;
              case "text":
                b.textGroupIds || (b.textGroupIds = []), b.textGroupIds.push(v);
            }
          }, l.updatePTS = d, l.updateFragPTSDTS = f, l.mergeDetails = function(b, y) {
            y.initSegment && b.initSegment && (y.initSegment = b.initSegment);
            var v, g = 0;
            if (m(b, y, function(w, S) {
              g = w.cc - S.cc, h.isFinite(w.startPTS) && (S.start = S.startPTS = w.startPTS, S.endPTS = w.endPTS, S.duration = w.duration, S.backtracked = w.backtracked, S.dropped = w.dropped, v = S), y.PTSKnown = !0;
            }), y.PTSKnown) {
              if (g) {
                c.logger.log("discontinuity sliding from playlist, take drift into account");
                for (var E = y.fragments, x = 0; x < E.length; x++)
                  E[x].cc += g;
              }
              v ? f(y, v, v.startPTS, v.endPTS, v.startDTS, v.endDTS) : p(b, y), y.PTSKnown = b.PTSKnown;
            }
          }, l.mergeSubtitlePlaylists = function(b, y, v) {
            v === void 0 && (v = 0);
            var g = -1;
            m(b, y, function(w, S, T) {
              S.start = w.start, g = T;
            });
            var E = y.fragments;
            if (g < 0)
              E.forEach(function(w) {
                w.start += v;
              });
            else
              for (var x = g + 1; x < E.length; x++)
                E[x].start = E[x - 1].start + E[x - 1].duration;
          }, l.mapFragmentIntersection = m, l.adjustSliding = p, l.computeReloadInterval = function(b, y, v) {
            var g = 1e3 * (y.averagetargetduration ? y.averagetargetduration : y.targetduration), E = g / 2;
            return b && y.endSN === b.endSN && (g = E), v && (g = Math.max(E, g - (window.performance.now() - v))), Math.round(g);
          };
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/controller/stream-controller.js": function(o, l, u) {
        (function(h) {
          var c, d = this && this.__extends || (c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(O, M) {
            O.__proto__ = M;
          } || function(O, M) {
            for (var F in M)
              M.hasOwnProperty(F) && (O[F] = M[F]);
          }, function(O, M) {
            function F() {
              this.constructor = O;
            }
            c(O, M), O.prototype = M === null ? Object.create(M) : (F.prototype = M.prototype, new F());
          });
          Object.defineProperty(l, "__esModule", { value: !0 });
          var f, m = u("./src/utils/binary-search.js"), p = u("./src/utils/buffer-helper.js"), b = u("./src/demux/demuxer.js"), y = u("./src/events.js"), v = u("./src/controller/fragment-tracker.js"), g = u("./src/loader/fragment.js"), E = u("./src/loader/playlist-loader.js"), x = u("./src/controller/level-helper.js"), w = u("./src/utils/time-ranges.js"), S = u("./src/errors.js"), T = u("./src/utils/logger.js"), C = u("./src/utils/discontinuities.js"), D = u("./src/controller/fragment-finders.js"), R = u("./src/controller/gap-controller.js"), P = u("./src/controller/base-stream-controller.js"), N = (f = P.default, d($, f), $.prototype.startLoad = function(O) {
            if (this.levels) {
              var M = this.lastCurrentTime, F = this.hls;
              if (this.stopLoad(), this.setInterval(100), this.level = -1, this.fragLoadError = 0, !this.startFragRequested) {
                var G = F.startLevel;
                G === -1 && (G = 0, this.bitrateTest = !0), this.level = F.nextLoadLevel = G, this.loadedmetadata = !1;
              }
              0 < M && O === -1 && (T.logger.log("override startPosition with lastCurrentTime @" + M.toFixed(3)), O = M), this.state = P.State.IDLE, this.nextLoadPosition = this.startPosition = this.lastCurrentTime = O, this.tick();
            } else
              this.forceStartLoad = !0, this.state = P.State.STOPPED;
          }, $.prototype.stopLoad = function() {
            this.forceStartLoad = !1, f.prototype.stopLoad.call(this);
          }, $.prototype.doTick = function() {
            switch (this.state) {
              case P.State.BUFFER_FLUSHING:
                this.fragLoadError = 0;
                break;
              case P.State.IDLE:
                this._doTickIdle();
                break;
              case P.State.WAITING_LEVEL:
                var O = this.levels[this.level];
                O && O.details && (this.state = P.State.IDLE);
                break;
              case P.State.FRAG_LOADING_WAITING_RETRY:
                var M = window.performance.now(), F = this.retryDate;
                (!F || F <= M || this.media && this.media.seeking) && (T.logger.log("mediaController: retryDate reached, switch back to IDLE state"), this.state = P.State.IDLE);
                break;
              case P.State.ERROR:
              case P.State.STOPPED:
              case P.State.FRAG_LOADING:
              case P.State.PARSING:
              case P.State.PARSED:
              case P.State.ENDED:
            }
            this._checkBuffer(), this._checkFragmentChanged();
          }, $.prototype._doTickIdle = function() {
            var O = this.hls, M = O.config, F = this.media;
            if (this.levelLastLoaded !== void 0 && (F || !this.startFragRequested && M.startFragPrefetch)) {
              var G;
              G = this.loadedmetadata ? F.currentTime : this.nextLoadPosition;
              var K = O.nextLoadLevel, J = this.levels[K];
              if (J) {
                var ue, ce = J.bitrate;
                ue = ce ? Math.max(8 * M.maxBufferSize / ce, M.maxBufferLength) : M.maxBufferLength, ue = Math.min(ue, M.maxMaxBufferLength);
                var ee = p.BufferHelper.bufferInfo(this.mediaBuffer ? this.mediaBuffer : F, G, M.maxBufferHole), me = ee.len;
                if (!(ue <= me)) {
                  T.logger.trace("buffer length of " + me.toFixed(3) + " is below max of " + ue.toFixed(3) + ". checking for more payload ..."), this.level = O.nextLoadLevel = K;
                  var Ce = J.details;
                  if (!Ce || Ce.live && this.levelLastLoaded !== K)
                    this.state = P.State.WAITING_LEVEL;
                  else {
                    if (this._streamEnded(ee, Ce)) {
                      var Ne = {};
                      return this.altAudio && (Ne.type = "video"), this.hls.trigger(y.default.BUFFER_EOS, Ne), void (this.state = P.State.ENDED);
                    }
                    this._fetchPayloadOrEos(G, ee, Ce);
                  }
                }
              }
            }
          }, $.prototype._fetchPayloadOrEos = function(O, M, F) {
            var G = this.fragPrevious, K = this.level, J = F.fragments, ue = J.length;
            if (ue !== 0) {
              var ce, ee = J[0].start, me = J[ue - 1].start + J[ue - 1].duration, Ce = M.end;
              if (F.initSegment && !F.initSegment.data)
                ce = F.initSegment;
              else if (F.live) {
                var Ne = this.config.initialLiveManifestSize;
                if (ue < Ne)
                  return void T.logger.warn("Can not start playback of a level, reason: not enough fragments " + ue + " < " + Ne);
                if ((ce = this._ensureFragmentAtLivePoint(F, Ce, ee, me, G, J, ue)) === null)
                  return;
              } else
                Ce < ee && (ce = J[0]);
              (ce = ce || this._findFragment(ee, G, ue, J, Ce, me, F)) && (ce.encrypted ? (T.logger.log("Loading key for " + ce.sn + " of [" + F.startSN + " ," + F.endSN + "],level " + K), this._loadKey(ce)) : (T.logger.log("Loading " + ce.sn + " of [" + F.startSN + " ," + F.endSN + "],level " + K + ", currentTime:" + O.toFixed(3) + ",bufferEnd:" + Ce.toFixed(3)), this._loadFragment(ce)));
            }
          }, $.prototype._ensureFragmentAtLivePoint = function(O, M, F, G, K, J, ue) {
            var ce, ee = this.hls.config, me = this.media, Ce = ee.liveMaxLatencyDuration !== void 0 ? ee.liveMaxLatencyDuration : ee.liveMaxLatencyDurationCount * O.targetduration;
            if (M < Math.max(F - ee.maxFragLookUpTolerance, G - Ce)) {
              var Ne = this.liveSyncPosition = this.computeLivePosition(F, O);
              T.logger.log("buffer end: " + M.toFixed(3) + " is located too far from the end of live sliding playlist, reset currentTime to : " + Ne.toFixed(3)), M = Ne, me && me.readyState && me.duration > Ne && (me.currentTime = Ne), this.nextLoadPosition = Ne;
            }
            if (O.PTSKnown && G < M && me && me.readyState)
              return null;
            if (this.startFragRequested && !O.PTSKnown) {
              if (K)
                if (O.hasProgramDateTime)
                  T.logger.log("live playlist, switching playlist, load frag with same PDT: " + K.programDateTime), ce = D.findFragmentByPDT(J, K.endProgramDateTime, ee.maxFragLookUpTolerance);
                else {
                  var ot = K.sn + 1;
                  if (ot >= O.startSN && ot <= O.endSN) {
                    var ze = J[ot - O.startSN];
                    K.cc === ze.cc && (ce = ze, T.logger.log("live playlist, switching playlist, load frag with next SN: " + ce.sn));
                  }
                  ce || (ce = m.default.search(J, function($e) {
                    return K.cc - $e.cc;
                  })) && T.logger.log("live playlist, switching playlist, load frag with same CC: " + ce.sn);
                }
              ce || (ce = J[Math.min(ue - 1, Math.round(ue / 2))], T.logger.log("live playlist, switching playlist, unknown, load middle frag : " + ce.sn));
            }
            return ce;
          }, $.prototype._findFragment = function(O, M, F, G, K, J, ue) {
            var ce, ee = this.hls.config;
            if (K < J) {
              var me = K > J - ee.maxFragLookUpTolerance ? 0 : ee.maxFragLookUpTolerance;
              ce = D.findFragmentByPTS(M, G, K, me);
            } else
              ce = G[F - 1];
            if (ce) {
              var Ce = ce.sn - ue.startSN, Ne = M && ce.level === M.level, ot = G[Ce - 1], ze = G[1 + Ce];
              if (M && ce.sn === M.sn)
                if (Ne && !ce.backtracked)
                  if (ce.sn < ue.endSN) {
                    var $e = M.deltaPTS;
                    $e && $e > ee.maxBufferHole && M.dropped && Ce ? (ce = ot, T.logger.warn("SN just loaded, with large PTS gap between audio and video, maybe frag is not starting with a keyframe ? load previous one to try to overcome this")) : (ce = ze, T.logger.log("SN just loaded, load next one: " + ce.sn, ce));
                  } else
                    ce = null;
                else
                  ce.backtracked && (ze && ze.backtracked ? (T.logger.warn("Already backtracked from fragment " + ze.sn + ", will not backtrack to fragment " + ce.sn + ". Loading fragment " + ze.sn), ce = ze) : (T.logger.warn("Loaded fragment with dropped frames, backtracking 1 segment to find a keyframe"), ce.dropped = 0, ot ? (ce = ot).backtracked = !0 : Ce && (ce = null)));
            }
            return ce;
          }, $.prototype._loadKey = function(O) {
            this.state = P.State.KEY_LOADING, this.hls.trigger(y.default.KEY_LOADING, { frag: O });
          }, $.prototype._loadFragment = function(O) {
            var M = this.fragmentTracker.getState(O);
            this.fragCurrent = O, this.startFragRequested = !0, h.isFinite(O.sn) && !O.bitrateTest && (this.nextLoadPosition = O.start + O.duration), O.backtracked || M === v.FragmentState.NOT_LOADED || M === v.FragmentState.PARTIAL ? (O.autoLevel = this.hls.autoLevelEnabled, O.bitrateTest = this.bitrateTest, this.hls.trigger(y.default.FRAG_LOADING, { frag: O }), this.demuxer || (this.demuxer = new b.default(this.hls, "main")), this.state = P.State.FRAG_LOADING) : M === v.FragmentState.APPENDING && this._reduceMaxBufferLength(O.duration) && this.fragmentTracker.removeFragment(O);
          }, Object.defineProperty($.prototype, "state", { get: function() {
            return this._state;
          }, set: function(O) {
            if (this.state !== O) {
              var M = this.state;
              this._state = O, T.logger.log("main stream:" + M + "->" + O), this.hls.trigger(y.default.STREAM_STATE_TRANSITION, { previousState: M, nextState: O });
            }
          }, enumerable: !0, configurable: !0 }), $.prototype.getBufferedFrag = function(O) {
            return this.fragmentTracker.getBufferedFrag(O, E.default.LevelType.MAIN);
          }, Object.defineProperty($.prototype, "currentLevel", { get: function() {
            var O = this.media;
            if (O) {
              var M = this.getBufferedFrag(O.currentTime);
              if (M)
                return M.level;
            }
            return -1;
          }, enumerable: !0, configurable: !0 }), Object.defineProperty($.prototype, "nextBufferedFrag", { get: function() {
            var O = this.media;
            return O ? this.followingBufferedFrag(this.getBufferedFrag(O.currentTime)) : null;
          }, enumerable: !0, configurable: !0 }), $.prototype.followingBufferedFrag = function(O) {
            return O ? this.getBufferedFrag(O.endPTS + 0.5) : null;
          }, Object.defineProperty($.prototype, "nextLevel", { get: function() {
            var O = this.nextBufferedFrag;
            return O ? O.level : -1;
          }, enumerable: !0, configurable: !0 }), $.prototype._checkFragmentChanged = function() {
            var O, M, F = this.media;
            if (F && F.readyState && F.seeking === !1 && ((M = F.currentTime) > this.lastCurrentTime && (this.lastCurrentTime = M), p.BufferHelper.isBuffered(F, M) ? O = this.getBufferedFrag(M) : p.BufferHelper.isBuffered(F, M + 0.1) && (O = this.getBufferedFrag(M + 0.1)), O)) {
              var G = O;
              if (G !== this.fragPlaying) {
                this.hls.trigger(y.default.FRAG_CHANGED, { frag: G });
                var K = G.level;
                this.fragPlaying && this.fragPlaying.level === K || this.hls.trigger(y.default.LEVEL_SWITCHED, { level: K }), this.fragPlaying = G;
              }
            }
          }, $.prototype.immediateLevelSwitch = function() {
            if (T.logger.log("immediateLevelSwitch"), !this.immediateSwitch) {
              this.immediateSwitch = !0;
              var O = this.media, M = void 0;
              O ? (M = O.paused, O.pause()) : M = !0, this.previouslyPaused = M;
            }
            var F = this.fragCurrent;
            F && F.loader && F.loader.abort(), this.fragCurrent = null, this.flushMainBuffer(0, h.POSITIVE_INFINITY);
          }, $.prototype.immediateLevelSwitchEnd = function() {
            var O = this.media;
            O && O.buffered.length && (this.immediateSwitch = !1, p.BufferHelper.isBuffered(O, O.currentTime) && (O.currentTime -= 1e-4), this.previouslyPaused || O.play());
          }, $.prototype.nextLevelSwitch = function() {
            var O = this.media;
            if (O && O.readyState) {
              var M, F = void 0, G = void 0;
              if ((M = this.getBufferedFrag(O.currentTime)) && 1 < M.startPTS && this.flushMainBuffer(0, M.startPTS - 1), O.paused)
                F = 0;
              else {
                var K = this.hls.nextLoadLevel, J = this.levels[K], ue = this.fragLastKbps;
                F = ue && this.fragCurrent ? this.fragCurrent.duration * J.bitrate / (1e3 * ue) + 1 : 0;
              }
              if (G = (G = this.getBufferedFrag(O.currentTime + F)) && this.followingBufferedFrag(G)) {
                var ce = this.fragCurrent;
                ce && ce.loader && ce.loader.abort(), this.fragCurrent = null, this.flushMainBuffer(G.maxStartPTS, h.POSITIVE_INFINITY);
              }
            }
          }, $.prototype.flushMainBuffer = function(O, M) {
            this.state = P.State.BUFFER_FLUSHING;
            var F = { startOffset: O, endOffset: M };
            this.altAudio && (F.type = "video"), this.hls.trigger(y.default.BUFFER_FLUSHING, F);
          }, $.prototype.onMediaAttached = function(O) {
            var M = this.media = this.mediaBuffer = O.media;
            this.onvseeking = this.onMediaSeeking.bind(this), this.onvseeked = this.onMediaSeeked.bind(this), this.onvended = this.onMediaEnded.bind(this), M.addEventListener("seeking", this.onvseeking), M.addEventListener("seeked", this.onvseeked), M.addEventListener("ended", this.onvended);
            var F = this.config;
            this.levels && F.autoStartLoad && this.hls.startLoad(F.startPosition), this.gapController = new R.default(F, M, this.fragmentTracker, this.hls);
          }, $.prototype.onMediaDetaching = function() {
            var O = this.media;
            O && O.ended && (T.logger.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0);
            var M = this.levels;
            M && M.forEach(function(F) {
              F.details && F.details.fragments.forEach(function(G) {
                G.backtracked = void 0;
              });
            }), O && (O.removeEventListener("seeking", this.onvseeking), O.removeEventListener("seeked", this.onvseeked), O.removeEventListener("ended", this.onvended), this.onvseeking = this.onvseeked = this.onvended = null), this.media = this.mediaBuffer = null, this.loadedmetadata = !1, this.stopLoad();
          }, $.prototype.onMediaSeeked = function() {
            var O = this.media, M = O ? O.currentTime : void 0;
            h.isFinite(M) && T.logger.log("media seeked to " + M.toFixed(3)), this.tick();
          }, $.prototype.onManifestLoading = function() {
            T.logger.log("trigger BUFFER_RESET"), this.hls.trigger(y.default.BUFFER_RESET), this.fragmentTracker.removeAllFragments(), this.stalled = !1, this.startPosition = this.lastCurrentTime = 0;
          }, $.prototype.onManifestParsed = function(O) {
            var M, F = !1, G = !1;
            O.levels.forEach(function(J) {
              (M = J.audioCodec) && (M.indexOf("mp4a.40.2") !== -1 && (F = !0), M.indexOf("mp4a.40.5") !== -1 && (G = !0));
            }), this.audioCodecSwitch = F && G, this.audioCodecSwitch && T.logger.log("both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"), this.levels = O.levels, this.startFragRequested = !1;
            var K = this.config;
            (K.autoStartLoad || this.forceStartLoad) && this.hls.startLoad(K.startPosition);
          }, $.prototype.onLevelLoaded = function(O) {
            var M = O.details, F = O.level, G = this.levels[this.levelLastLoaded], K = this.levels[F], J = M.totalduration, ue = 0;
            if (T.logger.log("level " + F + " loaded [" + M.startSN + "," + M.endSN + "],duration:" + J), M.live) {
              var ce = K.details;
              ce && 0 < M.fragments.length ? (x.mergeDetails(ce, M), ue = M.fragments[0].start, this.liveSyncPosition = this.computeLivePosition(ue, ce), M.PTSKnown && h.isFinite(ue) ? T.logger.log("live playlist sliding:" + ue.toFixed(3)) : (T.logger.log("live playlist - outdated PTS, unknown sliding"), C.alignStream(this.fragPrevious, G, M))) : (T.logger.log("live playlist - first load, unknown sliding"), M.PTSKnown = !1, C.alignStream(this.fragPrevious, G, M));
            } else
              M.PTSKnown = !1;
            if (K.details = M, this.levelLastLoaded = F, this.hls.trigger(y.default.LEVEL_UPDATED, { details: M, level: F }), this.startFragRequested === !1) {
              if (this.startPosition === -1 || this.lastCurrentTime === -1) {
                var ee = M.startTimeOffset;
                h.isFinite(ee) ? (ee < 0 && (T.logger.log("negative start time offset " + ee + ", count from end of last fragment"), ee = ue + J + ee), T.logger.log("start time offset found in playlist, adjust startPosition to " + ee), this.startPosition = ee) : M.live ? (this.startPosition = this.computeLivePosition(ue, M), T.logger.log("configure startPosition to " + this.startPosition)) : this.startPosition = 0, this.lastCurrentTime = this.startPosition;
              }
              this.nextLoadPosition = this.startPosition;
            }
            this.state === P.State.WAITING_LEVEL && (this.state = P.State.IDLE), this.tick();
          }, $.prototype.onKeyLoaded = function() {
            this.state === P.State.KEY_LOADING && (this.state = P.State.IDLE, this.tick());
          }, $.prototype.onFragLoaded = function(O) {
            var M = this.fragCurrent, F = this.hls, G = this.levels, K = this.media, J = O.frag;
            if (this.state === P.State.FRAG_LOADING && M && J.type === "main" && J.level === M.level && J.sn === M.sn) {
              var ue = O.stats, ce = G[M.level], ee = ce.details;
              if (this.bitrateTest = !1, this.stats = ue, T.logger.log("Loaded " + M.sn + " of [" + ee.startSN + " ," + ee.endSN + "],level " + M.level), J.bitrateTest && F.nextLoadLevel)
                this.state = P.State.IDLE, this.startFragRequested = !1, ue.tparsed = ue.tbuffered = window.performance.now(), F.trigger(y.default.FRAG_BUFFERED, { stats: ue, frag: M, id: "main" }), this.tick();
              else if (J.sn === "initSegment")
                this.state = P.State.IDLE, ue.tparsed = ue.tbuffered = window.performance.now(), ee.initSegment.data = O.payload, F.trigger(y.default.FRAG_BUFFERED, { stats: ue, frag: M, id: "main" }), this.tick();
              else {
                T.logger.log("Parsing " + M.sn + " of [" + ee.startSN + " ," + ee.endSN + "],level " + M.level + ", cc " + M.cc), this.state = P.State.PARSING, this.pendingBuffering = !0, this.appended = !1, J.bitrateTest && (J.bitrateTest = !1, this.fragmentTracker.onFragLoaded({ frag: J }));
                var me = !(K && K.seeking) && (ee.PTSKnown || !ee.live), Ce = ee.initSegment ? ee.initSegment.data : [], Ne = this._getAudioCodec(ce);
                (this.demuxer = this.demuxer || new b.default(this.hls, "main")).push(O.payload, Ce, Ne, ce.videoCodec, M, ee.totalduration, me);
              }
            }
            this.fragLoadError = 0;
          }, $.prototype.onFragParsingInitSegment = function(O) {
            var M = this.fragCurrent, F = O.frag;
            if (M && O.id === "main" && F.sn === M.sn && F.level === M.level && this.state === P.State.PARSING) {
              var G = O.tracks, K = void 0, J = void 0;
              if (G.audio && this.altAudio && delete G.audio, J = G.audio) {
                var ue = this.levels[this.level].audioCodec, ce = navigator.userAgent.toLowerCase();
                ue && this.audioCodecSwap && (T.logger.log("swapping playlist audio codec"), ue = ue.indexOf("mp4a.40.5") !== -1 ? "mp4a.40.2" : "mp4a.40.5"), this.audioCodecSwitch && J.metadata.channelCount !== 1 && ce.indexOf("firefox") === -1 && (ue = "mp4a.40.5"), ce.indexOf("android") !== -1 && J.container !== "audio/mpeg" && (ue = "mp4a.40.2", T.logger.log("Android: force audio codec to " + ue)), J.levelCodec = ue, J.id = O.id;
              }
              for (K in (J = G.video) && (J.levelCodec = this.levels[this.level].videoCodec, J.id = O.id), this.hls.trigger(y.default.BUFFER_CODECS, G), G) {
                J = G[K], T.logger.log("main track:" + K + ",container:" + J.container + ",codecs[level/parsed]=[" + J.levelCodec + "/" + J.codec + "]");
                var ee = J.initSegment;
                ee && (this.appended = !0, this.pendingBuffering = !0, this.hls.trigger(y.default.BUFFER_APPENDING, { type: K, data: ee, parent: "main", content: "initSegment" }));
              }
              this.tick();
            }
          }, $.prototype.onFragParsingData = function(O) {
            var M = this, F = this.fragCurrent, G = O.frag;
            if (F && O.id === "main" && G.sn === F.sn && G.level === F.level && (O.type !== "audio" || !this.altAudio) && this.state === P.State.PARSING) {
              var K = this.levels[this.level], J = F;
              if (h.isFinite(O.endPTS) || (O.endPTS = O.startPTS + F.duration, O.endDTS = O.startDTS + F.duration), O.hasAudio === !0 && J.addElementaryStream(g.default.ElementaryStreamTypes.AUDIO), O.hasVideo === !0 && J.addElementaryStream(g.default.ElementaryStreamTypes.VIDEO), T.logger.log("Parsed " + O.type + ",PTS:[" + O.startPTS.toFixed(3) + "," + O.endPTS.toFixed(3) + "],DTS:[" + O.startDTS.toFixed(3) + "/" + O.endDTS.toFixed(3) + "],nb:" + O.nb + ",dropped:" + (O.dropped || 0)), O.type === "video")
                if (J.dropped = O.dropped, J.dropped)
                  if (J.backtracked)
                    T.logger.warn("Already backtracked on this fragment, appending with the gap", J.sn);
                  else {
                    var ue = K.details;
                    if (!ue || J.sn !== ue.startSN)
                      return T.logger.warn("missing video frame(s), backtracking fragment", J.sn), this.fragmentTracker.removeFragment(J), J.backtracked = !0, this.nextLoadPosition = O.startPTS, this.state = P.State.IDLE, this.fragPrevious = J, void this.tick();
                    T.logger.warn("missing video frame(s) on first frag, appending with gap", J.sn);
                  }
                else
                  J.backtracked = !1;
              var ce = x.updateFragPTSDTS(K.details, J, O.startPTS, O.endPTS, O.startDTS, O.endDTS), ee = this.hls;
              ee.trigger(y.default.LEVEL_PTS_UPDATED, { details: K.details, level: this.level, drift: ce, type: O.type, start: O.startPTS, end: O.endPTS }), [O.data1, O.data2].forEach(function(me) {
                me && me.length && M.state === P.State.PARSING && (M.appended = !0, M.pendingBuffering = !0, ee.trigger(y.default.BUFFER_APPENDING, { type: O.type, data: me, parent: "main", content: "data" }));
              }), this.tick();
            }
          }, $.prototype.onFragParsed = function(O) {
            var M = this.fragCurrent, F = O.frag;
            M && O.id === "main" && F.sn === M.sn && F.level === M.level && this.state === P.State.PARSING && (this.stats.tparsed = window.performance.now(), this.state = P.State.PARSED, this._checkAppendedParsed());
          }, $.prototype.onAudioTrackSwitching = function(O) {
            var M = !!O.url, F = O.id;
            if (!M) {
              if (this.mediaBuffer !== this.media) {
                T.logger.log("switching on main audio, use media.buffered to schedule main fragment loading"), this.mediaBuffer = this.media;
                var G = this.fragCurrent;
                G.loader && (T.logger.log("switching to main audio track, cancel main fragment load"), G.loader.abort()), this.fragCurrent = null, this.fragPrevious = null, this.demuxer && (this.demuxer.destroy(), this.demuxer = null), this.state = P.State.IDLE;
              }
              var K = this.hls;
              K.trigger(y.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: h.POSITIVE_INFINITY, type: "audio" }), K.trigger(y.default.AUDIO_TRACK_SWITCHED, { id: F }), this.altAudio = !1;
            }
          }, $.prototype.onAudioTrackSwitched = function(O) {
            var M = O.id, F = !!this.hls.audioTracks[M].url;
            if (F) {
              var G = this.videoBuffer;
              G && this.mediaBuffer !== G && (T.logger.log("switching on alternate audio, use video.buffered to schedule main fragment loading"), this.mediaBuffer = G);
            }
            this.altAudio = F, this.tick();
          }, $.prototype.onBufferCreated = function(O) {
            var M, F, G = O.tracks, K = !1;
            for (var J in G) {
              var ue = G[J];
              ue.id === "main" ? (M = ue, (F = J) === "video" && (this.videoBuffer = G[J].buffer)) : K = !0;
            }
            K && M ? (T.logger.log("alternate track found, use " + F + ".buffered to schedule main fragment loading"), this.mediaBuffer = M.buffer) : this.mediaBuffer = this.media;
          }, $.prototype.onBufferAppended = function(O) {
            if (O.parent === "main") {
              var M = this.state;
              M !== P.State.PARSING && M !== P.State.PARSED || (this.pendingBuffering = 0 < O.pending, this._checkAppendedParsed());
            }
          }, $.prototype._checkAppendedParsed = function() {
            if (!(this.state !== P.State.PARSED || this.appended && this.pendingBuffering)) {
              var O = this.fragCurrent;
              if (O) {
                var M = this.mediaBuffer ? this.mediaBuffer : this.media;
                T.logger.log("main buffered : " + w.default.toString(M.buffered)), this.fragPrevious = O;
                var F = this.stats;
                F.tbuffered = window.performance.now(), this.fragLastKbps = Math.round(8 * F.total / (F.tbuffered - F.tfirst)), this.hls.trigger(y.default.FRAG_BUFFERED, { stats: F, frag: O, id: "main" }), this.state = P.State.IDLE;
              }
              this.tick();
            }
          }, $.prototype.onError = function(O) {
            var M = O.frag || this.fragCurrent;
            if (!M || M.type === "main") {
              var F = !!this.media && p.BufferHelper.isBuffered(this.media, this.media.currentTime) && p.BufferHelper.isBuffered(this.media, this.media.currentTime + 0.5);
              switch (O.details) {
                case S.ErrorDetails.FRAG_LOAD_ERROR:
                case S.ErrorDetails.FRAG_LOAD_TIMEOUT:
                case S.ErrorDetails.KEY_LOAD_ERROR:
                case S.ErrorDetails.KEY_LOAD_TIMEOUT:
                  if (!O.fatal)
                    if (this.fragLoadError + 1 <= this.config.fragLoadingMaxRetry) {
                      var G = Math.min(Math.pow(2, this.fragLoadError) * this.config.fragLoadingRetryDelay, this.config.fragLoadingMaxRetryTimeout);
                      T.logger.warn("mediaController: frag loading failed, retry in " + G + " ms"), this.retryDate = window.performance.now() + G, this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition), this.fragLoadError++, this.state = P.State.FRAG_LOADING_WAITING_RETRY;
                    } else
                      T.logger.error("mediaController: " + O.details + " reaches max retry, redispatch as fatal ..."), O.fatal = !0, this.state = P.State.ERROR;
                  break;
                case S.ErrorDetails.LEVEL_LOAD_ERROR:
                case S.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                  this.state !== P.State.ERROR && (O.fatal ? (this.state = P.State.ERROR, T.logger.warn("streamController: " + O.details + ",switch to " + this.state + " state ...")) : O.levelRetry || this.state !== P.State.WAITING_LEVEL || (this.state = P.State.IDLE));
                  break;
                case S.ErrorDetails.BUFFER_FULL_ERROR:
                  O.parent !== "main" || this.state !== P.State.PARSING && this.state !== P.State.PARSED || (F ? (this._reduceMaxBufferLength(this.config.maxBufferLength), this.state = P.State.IDLE) : (T.logger.warn("buffer full error also media.currentTime is not buffered, flush everything"), this.fragCurrent = null, this.flushMainBuffer(0, h.POSITIVE_INFINITY)));
              }
            }
          }, $.prototype._reduceMaxBufferLength = function(O) {
            var M = this.config;
            return M.maxMaxBufferLength >= O && (M.maxMaxBufferLength /= 2, T.logger.warn("main:reduce max buffer length to " + M.maxMaxBufferLength + "s"), !0);
          }, $.prototype._checkBuffer = function() {
            var O = this.media;
            if (O && O.readyState !== 0) {
              var M = (this.mediaBuffer ? this.mediaBuffer : O).buffered;
              !this.loadedmetadata && M.length ? (this.loadedmetadata = !0, this._seekToStartPos()) : this.immediateSwitch ? this.immediateLevelSwitchEnd() : this.gapController.poll(this.lastCurrentTime, M);
            }
          }, $.prototype.onFragLoadEmergencyAborted = function() {
            this.state = P.State.IDLE, this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition), this.tick();
          }, $.prototype.onBufferFlushed = function() {
            var O = this.mediaBuffer ? this.mediaBuffer : this.media;
            O && this.fragmentTracker.detectEvictedFragments(g.default.ElementaryStreamTypes.VIDEO, O.buffered), this.state = P.State.IDLE, this.fragPrevious = null;
          }, $.prototype.swapAudioCodec = function() {
            this.audioCodecSwap = !this.audioCodecSwap;
          }, $.prototype.computeLivePosition = function(O, M) {
            var F = this.config.liveSyncDuration !== void 0 ? this.config.liveSyncDuration : this.config.liveSyncDurationCount * M.targetduration;
            return O + Math.max(0, M.totalduration - F);
          }, $.prototype._seekToStartPos = function() {
            var O = this.media, M = O.currentTime, F = O.seeking ? M : this.startPosition;
            M !== F && (T.logger.log("target start position not buffered, seek to buffered.start(0) " + F + " from current time " + M + " "), O.currentTime = F);
          }, $.prototype._getAudioCodec = function(O) {
            var M = this.config.defaultAudioCodec || O.audioCodec;
            return this.audioCodecSwap && (T.logger.log("swapping playlist audio codec"), M = M && (M.indexOf("mp4a.40.5") !== -1 ? "mp4a.40.2" : "mp4a.40.5")), M;
          }, Object.defineProperty($.prototype, "liveSyncPosition", { get: function() {
            return this._liveSyncPosition;
          }, set: function(O) {
            this._liveSyncPosition = O;
          }, enumerable: !0, configurable: !0 }), $);
          function $(O, M) {
            var F = f.call(this, O, y.default.MEDIA_ATTACHED, y.default.MEDIA_DETACHING, y.default.MANIFEST_LOADING, y.default.MANIFEST_PARSED, y.default.LEVEL_LOADED, y.default.KEY_LOADED, y.default.FRAG_LOADED, y.default.FRAG_LOAD_EMERGENCY_ABORTED, y.default.FRAG_PARSING_INIT_SEGMENT, y.default.FRAG_PARSING_DATA, y.default.FRAG_PARSED, y.default.ERROR, y.default.AUDIO_TRACK_SWITCHING, y.default.AUDIO_TRACK_SWITCHED, y.default.BUFFER_CREATED, y.default.BUFFER_APPENDED, y.default.BUFFER_FLUSHED) || this;
            return F.fragmentTracker = M, F.config = O.config, F.audioCodecSwap = !1, F._state = P.State.STOPPED, F.stallReported = !1, F.gapController = null, F;
          }
          l.default = N;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/controller/subtitle-stream-controller.js": function(o, l, u) {
        var h, c = this && this.__extends || (h = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(T, C) {
          T.__proto__ = C;
        } || function(T, C) {
          for (var D in C)
            C.hasOwnProperty(D) && (T[D] = C[D]);
        }, function(T, C) {
          function D() {
            this.constructor = T;
          }
          h(T, C), T.prototype = C === null ? Object.create(C) : (D.prototype = C.prototype, new D());
        });
        Object.defineProperty(l, "__esModule", { value: !0 });
        var d, f = u("./src/events.js"), m = u("./src/utils/logger.js"), p = u("./src/crypt/decrypter.js"), b = u("./src/utils/buffer-helper.js"), y = u("./src/controller/fragment-finders.js"), v = u("./src/controller/fragment-tracker.js"), g = u("./src/controller/base-stream-controller.js"), E = u("./src/controller/level-helper.js"), x = window.performance, w = (d = g.default, c(S, d), S.prototype.onSubtitleFragProcessed = function(T) {
          var C = T.frag, D = T.success;
          if (this.fragPrevious = C, this.state = g.State.IDLE, D) {
            var R = this.tracksBuffered[this.currentTrackId];
            if (R) {
              for (var P, N = C.start, $ = 0; $ < R.length; $++)
                if (N >= R[$].start && N <= R[$].end) {
                  P = R[$];
                  break;
                }
              var O = C.start + C.duration;
              P ? P.end = O : (P = { start: N, end: O }, R.push(P));
            }
          }
        }, S.prototype.onMediaAttached = function(T) {
          var C = T.media;
          (this.media = C).addEventListener("seeking", this._onMediaSeeking), this.state = g.State.IDLE;
        }, S.prototype.onMediaDetaching = function() {
          this.media.removeEventListener("seeking", this._onMediaSeeking), this.media = null, this.state = g.State.STOPPED;
        }, S.prototype.onError = function(T) {
          var C = T.frag;
          C && C.type === "subtitle" && (this.state = g.State.IDLE);
        }, S.prototype.onSubtitleTracksUpdated = function(T) {
          var C = this;
          m.logger.log("subtitle tracks updated"), this.tracksBuffered = [], this.tracks = T.subtitleTracks, this.tracks.forEach(function(D) {
            C.tracksBuffered[D.id] = [];
          });
        }, S.prototype.onSubtitleTrackSwitch = function(T) {
          if (this.currentTrackId = T.id, this.tracks && this.currentTrackId !== -1) {
            var C = this.tracks[this.currentTrackId];
            C && C.details && this.setInterval(500);
          } else
            this.clearInterval();
        }, S.prototype.onSubtitleTrackLoaded = function(T) {
          var C = T.id, D = T.details, R = this.currentTrackId, P = this.tracks, N = P[R];
          C >= P.length || C !== R || !N || (D.live && E.mergeSubtitlePlaylists(N.details, D, this.lastAVStart), N.details = D, this.setInterval(500));
        }, S.prototype.onKeyLoaded = function() {
          this.state === g.State.KEY_LOADING && (this.state = g.State.IDLE);
        }, S.prototype.onFragLoaded = function(T) {
          var C = this.fragCurrent, D = T.frag.decryptdata, R = T.frag, P = this.hls;
          if (this.state === g.State.FRAG_LOADING && C && T.frag.type === "subtitle" && C.sn === T.frag.sn && 0 < T.payload.byteLength && D && D.key && D.method === "AES-128") {
            var N = x.now();
            this.decrypter.decrypt(T.payload, D.key.buffer, D.iv.buffer, function($) {
              var O = x.now();
              P.trigger(f.default.FRAG_DECRYPTED, { frag: R, payload: $, stats: { tstart: N, tdecrypt: O } });
            });
          }
        }, S.prototype.onLevelUpdated = function(T) {
          var C = T.details.fragments;
          this.lastAVStart = C.length ? C[0].start : 0;
        }, S.prototype.doTick = function() {
          if (this.media)
            switch (this.state) {
              case g.State.IDLE:
                var T = this, C = T.config, D = T.currentTrackId, R = T.fragmentTracker, P = T.media, N = T.tracks;
                if (!N || !N[D] || !N[D].details)
                  break;
                var $ = C.maxBufferHole, O = C.maxFragLookUpTolerance, M = Math.min(C.maxBufferLength, C.maxMaxBufferLength), F = b.BufferHelper.bufferedInfo(this._getBuffered(), P.currentTime, $), G = F.end, K = F.len, J = N[D].details, ue = J.fragments, ce = ue.length, ee = ue[ce - 1].start + ue[ce - 1].duration;
                if (M < K)
                  return;
                var me = void 0, Ce = this.fragPrevious;
                (me = G < ee ? (Ce && J.hasProgramDateTime && (me = y.findFragmentByPDT(ue, Ce.endProgramDateTime, O)), me || y.findFragmentByPTS(Ce, ue, G, O)) : ue[ce - 1]) && me.encrypted ? (m.logger.log("Loading key for " + me.sn), this.state = g.State.KEY_LOADING, this.hls.trigger(f.default.KEY_LOADING, { frag: me })) : me && R.getState(me) === v.FragmentState.NOT_LOADED && (this.fragCurrent = me, this.state = g.State.FRAG_LOADING, this.hls.trigger(f.default.FRAG_LOADING, { frag: me }));
            }
          else
            this.state = g.State.IDLE;
        }, S.prototype.stopLoad = function() {
          this.lastAVStart = 0, d.prototype.stopLoad.call(this);
        }, S.prototype._getBuffered = function() {
          return this.tracksBuffered[this.currentTrackId] || [];
        }, S.prototype.onMediaSeeking = function() {
          this.fragPrevious = null;
        }, S);
        function S(T, C) {
          var D = d.call(this, T, f.default.MEDIA_ATTACHED, f.default.MEDIA_DETACHING, f.default.ERROR, f.default.KEY_LOADED, f.default.FRAG_LOADED, f.default.SUBTITLE_TRACKS_UPDATED, f.default.SUBTITLE_TRACK_SWITCH, f.default.SUBTITLE_TRACK_LOADED, f.default.SUBTITLE_FRAG_PROCESSED, f.default.LEVEL_UPDATED) || this;
          return D.fragmentTracker = C, D.config = T.config, D.state = g.State.STOPPED, D.tracks = [], D.tracksBuffered = [], D.currentTrackId = -1, D.decrypter = new p.default(T, T.config), D.lastAVStart = 0, D._onMediaSeeking = D.onMediaSeeking.bind(D), D;
        }
        l.SubtitleStreamController = w;
      }, "./src/controller/subtitle-track-controller.js": function(o, l, u) {
        (function(h) {
          var c, d = this && this.__extends || (c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(x, w) {
            x.__proto__ = w;
          } || function(x, w) {
            for (var S in w)
              w.hasOwnProperty(S) && (x[S] = w[S]);
          }, function(x, w) {
            function S() {
              this.constructor = x;
            }
            c(x, w), x.prototype = w === null ? Object.create(w) : (S.prototype = w.prototype, new S());
          });
          Object.defineProperty(l, "__esModule", { value: !0 });
          var f, m = u("./src/events.js"), p = u("./src/event-handler.js"), b = u("./src/utils/logger.js"), y = u("./src/controller/level-helper.js"), v = (f = p.default, d(g, f), g.prototype.destroy = function() {
            p.default.prototype.destroy.call(this);
          }, g.prototype.onMediaAttached = function(x) {
            var w = this;
            this.media = x.media, this.media && (this.queuedDefaultTrack && (this.subtitleTrack = this.queuedDefaultTrack, delete this.queuedDefaultTrack), this.trackChangeListener = this._onTextTracksChanged.bind(this), this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks), this.useTextTrackPolling ? this.subtitlePollingInterval = setInterval(function() {
              w.trackChangeListener();
            }, 500) : this.media.textTracks.addEventListener("change", this.trackChangeListener));
          }, g.prototype.onMediaDetaching = function() {
            this.media && (this.useTextTrackPolling ? clearInterval(this.subtitlePollingInterval) : this.media.textTracks.removeEventListener("change", this.trackChangeListener), this.media = null);
          }, g.prototype.onManifestLoaded = function(x) {
            var w = this, S = x.subtitles || [];
            this.tracks = S, this.hls.trigger(m.default.SUBTITLE_TRACKS_UPDATED, { subtitleTracks: S }), S.forEach(function(T) {
              T.default && (w.media ? w.subtitleTrack = T.id : w.queuedDefaultTrack = T.id);
            });
          }, g.prototype.onSubtitleTrackLoaded = function(x) {
            var w = this, S = x.id, T = x.details, C = this.trackId, D = this.tracks, R = D[C];
            if (S >= D.length || S !== C || !R || this.stopped)
              this._clearReloadTimer();
            else if (b.logger.log("subtitle track " + S + " loaded"), T.live) {
              var P = y.computeReloadInterval(R.details, T, x.stats.trequest);
              b.logger.log("Reloading live subtitle playlist in " + P + "ms"), this.timer = setTimeout(function() {
                w._loadCurrentTrack();
              }, P);
            } else
              this._clearReloadTimer();
          }, g.prototype.startLoad = function() {
            this.stopped = !1, this._loadCurrentTrack();
          }, g.prototype.stopLoad = function() {
            this.stopped = !0, this._clearReloadTimer();
          }, Object.defineProperty(g.prototype, "subtitleTracks", { get: function() {
            return this.tracks;
          }, enumerable: !0, configurable: !0 }), Object.defineProperty(g.prototype, "subtitleTrack", { get: function() {
            return this.trackId;
          }, set: function(x) {
            this.trackId !== x && (this._toggleTrackModes(x), this._setSubtitleTrackInternal(x));
          }, enumerable: !0, configurable: !0 }), g.prototype._clearReloadTimer = function() {
            this.timer && (clearTimeout(this.timer), this.timer = null);
          }, g.prototype._loadCurrentTrack = function() {
            var x = this.trackId, w = this.tracks, S = this.hls, T = w[x];
            x < 0 || !T || T.details && !T.details.live || (b.logger.log("Loading subtitle track " + x), S.trigger(m.default.SUBTITLE_TRACK_LOADING, { url: T.url, id: x }));
          }, g.prototype._toggleTrackModes = function(x) {
            var w = this.media, S = this.subtitleDisplay, T = this.trackId;
            if (w) {
              var C = E(w.textTracks);
              if (x === -1)
                [].slice.call(C).forEach(function(P) {
                  P.mode = "disabled";
                });
              else {
                var D = C[T];
                D && (D.mode = "disabled");
              }
              var R = C[x];
              R && (R.mode = S ? "showing" : "hidden");
            }
          }, g.prototype._setSubtitleTrackInternal = function(x) {
            var w = this.hls, S = this.tracks;
            !h.isFinite(x) || x < -1 || x >= S.length || (this.trackId = x, b.logger.log("Switching to subtitle track " + x), w.trigger(m.default.SUBTITLE_TRACK_SWITCH, { id: x }), this._loadCurrentTrack());
          }, g.prototype._onTextTracksChanged = function() {
            if (this.media) {
              for (var x = -1, w = E(this.media.textTracks), S = 0; S < w.length; S++)
                if (w[S].mode === "hidden")
                  x = S;
                else if (w[S].mode === "showing") {
                  x = S;
                  break;
                }
              this.subtitleTrack = x;
            }
          }, g);
          function g(x) {
            var w = f.call(this, x, m.default.MEDIA_ATTACHED, m.default.MEDIA_DETACHING, m.default.MANIFEST_LOADED, m.default.SUBTITLE_TRACK_LOADED) || this;
            return w.tracks = [], w.trackId = -1, w.media = null, w.stopped = !0, w.subtitleDisplay = !0, w;
          }
          function E(x) {
            for (var w = [], S = 0; S < x.length; S++) {
              var T = x[S];
              T.kind === "subtitles" && T.label && w.push(x[S]);
            }
            return w;
          }
          l.default = v;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/controller/timeline-controller.js": function(o, l, u) {
        (function(h) {
          var c, d = this && this.__extends || (c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(S, T) {
            S.__proto__ = T;
          } || function(S, T) {
            for (var C in T)
              T.hasOwnProperty(C) && (S[C] = T[C]);
          }, function(S, T) {
            function C() {
              this.constructor = S;
            }
            c(S, T), S.prototype = T === null ? Object.create(T) : (C.prototype = T.prototype, new C());
          });
          Object.defineProperty(l, "__esModule", { value: !0 });
          var f = u("./src/events.js"), m = u("./src/event-handler.js"), p = u("./src/utils/cea-608-parser.js"), b = u("./src/utils/output-filter.js"), y = u("./src/utils/webvtt-parser.js"), v = u("./src/utils/logger.js"), g = u("./src/utils/texttrack-utils.js"), E, x = (E = m.default, d(w, E), w.prototype.addCues = function(S, T, C, D) {
            for (var R, P, N, $, O = this.cueRanges, M = !1, F = O.length; F--; ) {
              var G = O[F], K = (R = G[0], P = G[1], N = T, $ = C, Math.min(P, $) - Math.max(R, N));
              if (0 <= K && (G[0] = Math.min(G[0], T), G[1] = Math.max(G[1], C), M = !0, 0.5 < K / (C - T)))
                return;
            }
            M || O.push([T, C]), this.Cues.newCue(this.captionsTracks[S], T, C, D);
          }, w.prototype.onInitPtsFound = function(S) {
            var T = this;
            if (S.id === "main" && (this.initPTS[S.frag.cc] = S.initPTS), this.unparsedVttFrags.length) {
              var C = this.unparsedVttFrags;
              this.unparsedVttFrags = [], C.forEach(function(D) {
                T.onFragLoaded(D);
              });
            }
          }, w.prototype.getExistingTrack = function(S) {
            var T = this.media;
            if (T)
              for (var C = 0; C < T.textTracks.length; C++) {
                var D = T.textTracks[C];
                if (D[S])
                  return D;
              }
            return null;
          }, w.prototype.createCaptionsTrack = function(S) {
            var T = this.captionsProperties[S], C = T.label, D = T.languageCode, R = this.captionsTracks;
            if (!R[S]) {
              var P = this.getExistingTrack(S);
              if (P)
                R[S] = P, g.clearCurrentCues(R[S]), g.sendAddTrackEvent(R[S], this.media);
              else {
                var N = this.createTextTrack("captions", C, D);
                N && (N[S] = !0, R[S] = N);
              }
            }
          }, w.prototype.createTextTrack = function(S, T, C) {
            var D = this.media;
            if (D)
              return D.addTextTrack(S, T, C);
          }, w.prototype.destroy = function() {
            m.default.prototype.destroy.call(this);
          }, w.prototype.onMediaAttaching = function(S) {
            this.media = S.media, this._cleanTracks();
          }, w.prototype.onMediaDetaching = function() {
            var S = this.captionsTracks;
            Object.keys(S).forEach(function(T) {
              g.clearCurrentCues(S[T]), delete S[T];
            });
          }, w.prototype.onManifestLoading = function() {
            this.lastSn = -1, this.prevCC = -1, this.vttCCs = { ccOffset: 0, presentationOffset: 0, 0: { start: 0, prevCC: -1, new: !1 } }, this._cleanTracks();
          }, w.prototype._cleanTracks = function() {
            var S = this.media;
            if (S) {
              var T = S.textTracks;
              if (T)
                for (var C = 0; C < T.length; C++)
                  g.clearCurrentCues(T[C]);
            }
          }, w.prototype.onManifestLoaded = function(S) {
            var T = this;
            if (this.textTracks = [], this.unparsedVttFrags = this.unparsedVttFrags || [], this.initPTS = [], this.cueRanges = [], this.config.enableWebVTT) {
              this.tracks = S.subtitles || [];
              var C = this.media ? this.media.textTracks : [];
              this.tracks.forEach(function(D, R) {
                var P, N, $;
                if (R < C.length) {
                  for (var O = null, M = 0; M < C.length; M++)
                    if (N = C[M], $ = D, N && N.label === $.name && !N.textTrack1 && !N.textTrack2) {
                      O = C[M];
                      break;
                    }
                  O && (P = O);
                }
                P = P || T.createTextTrack("subtitles", D.name, D.lang), D.default ? P.mode = T.hls.subtitleDisplay ? "showing" : "hidden" : P.mode = "disabled", T.textTracks.push(P);
              });
            }
          }, w.prototype.onLevelSwitching = function() {
            this.enabled = this.hls.currentLevel.closedCaptions !== "NONE";
          }, w.prototype.onFragLoaded = function(S) {
            var T = S.frag, C = S.payload;
            if (T.type === "main") {
              var D = T.sn;
              if (D !== this.lastSn + 1) {
                var R = this.cea608Parser;
                R && R.reset();
              }
              this.lastSn = D;
            } else if (T.type === "subtitle")
              if (C.byteLength) {
                if (!h.isFinite(this.initPTS[T.cc]))
                  return this.unparsedVttFrags.push(S), void (this.initPTS.length && this.hls.trigger(f.default.SUBTITLE_FRAG_PROCESSED, { success: !1, frag: T }));
                var P = T.decryptdata;
                P != null && P.key != null && P.method === "AES-128" || this._parseVTTs(T, C);
              } else
                this.hls.trigger(f.default.SUBTITLE_FRAG_PROCESSED, { success: !1, frag: T });
          }, w.prototype._parseVTTs = function(S, T) {
            var C = this.vttCCs;
            C[S.cc] || (C[S.cc] = { start: S.start, prevCC: this.prevCC, new: !0 }, this.prevCC = S.cc);
            var D = this.textTracks, R = this.hls;
            y.default.parse(T, this.initPTS[S.cc], C, S.cc, function(P) {
              var N = D[S.level];
              N.mode !== "disabled" ? (P.forEach(function($) {
                if (!N.cues.getCueById($.id))
                  try {
                    N.addCue($);
                  } catch {
                    var O = new window.TextTrackCue($.startTime, $.endTime, $.text);
                    O.id = $.id, N.addCue(O);
                  }
              }), R.trigger(f.default.SUBTITLE_FRAG_PROCESSED, { success: !0, frag: S })) : R.trigger(f.default.SUBTITLE_FRAG_PROCESSED, { success: !1, frag: S });
            }, function(P) {
              v.logger.log("Failed to parse VTT cue: " + P), R.trigger(f.default.SUBTITLE_FRAG_PROCESSED, { success: !1, frag: S });
            });
          }, w.prototype.onFragDecrypted = function(S) {
            var T = S.payload, C = S.frag;
            if (C.type === "subtitle") {
              if (!h.isFinite(this.initPTS[C.cc]))
                return void this.unparsedVttFrags.push(S);
              this._parseVTTs(C, T);
            }
          }, w.prototype.onFragParsingUserdata = function(S) {
            if (this.enabled && this.config.enableCEA708Captions)
              for (var T = 0; T < S.samples.length; T++) {
                var C = this.extractCea608Data(S.samples[T].bytes);
                this.cea608Parser.addData(S.samples[T].pts, C);
              }
          }, w.prototype.extractCea608Data = function(S) {
            for (var T, C, D, R = 31 & S[0], P = 2, N = [], $ = 0; $ < R; $++)
              T = S[P++], C = 127 & S[P++], D = 127 & S[P++], C == 0 && D == 0 || (4 & T) != 0 && (3 & T) == 0 && (N.push(C), N.push(D));
            return N;
          }, w);
          function w(S) {
            var T = E.call(this, S, f.default.MEDIA_ATTACHING, f.default.MEDIA_DETACHING, f.default.FRAG_PARSING_USERDATA, f.default.FRAG_DECRYPTED, f.default.MANIFEST_LOADING, f.default.MANIFEST_LOADED, f.default.FRAG_LOADED, f.default.LEVEL_SWITCHING, f.default.INIT_PTS_FOUND) || this;
            if (T.hls = S, T.config = S.config, T.enabled = !0, T.Cues = S.config.cueHandler, T.textTracks = [], T.tracks = [], T.unparsedVttFrags = [], T.initPTS = [], T.cueRanges = [], T.captionsTracks = {}, T.captionsProperties = { textTrack1: { label: T.config.captionsTextTrack1Label, languageCode: T.config.captionsTextTrack1LanguageCode }, textTrack2: { label: T.config.captionsTextTrack2Label, languageCode: T.config.captionsTextTrack2LanguageCode } }, T.config.enableCEA708Captions) {
              var C = new b.default(T, "textTrack1"), D = new b.default(T, "textTrack2");
              T.cea608Parser = new p.default(0, C, D);
            }
            return T;
          }
          l.default = x;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/crypt/aes-crypto.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = (c.prototype.decrypt = function(d, f) {
          return this.subtle.decrypt({ name: "AES-CBC", iv: this.aesIV }, f, d);
        }, c);
        function c(d, f) {
          this.subtle = d, this.aesIV = f;
        }
        l.default = h;
      }, "./src/crypt/aes-decryptor.js": function(o, l, u) {
        function h(f) {
          var m = f.byteLength, p = m && new DataView(f).getUint8(m - 1);
          return p ? f.slice(0, m - p) : f;
        }
        Object.defineProperty(l, "__esModule", { value: !0 }), l.removePadding = h;
        var c = (d.prototype.uint8ArrayToUint32Array_ = function(f) {
          for (var m = new DataView(f), p = new Uint32Array(4), b = 0; b < 4; b++)
            p[b] = m.getUint32(4 * b);
          return p;
        }, d.prototype.initTable = function() {
          var f = this.sBox, m = this.invSBox, p = this.subMix, b = p[0], y = p[1], v = p[2], g = p[3], E = this.invSubMix, x = E[0], w = E[1], S = E[2], T = E[3], C = new Uint32Array(256), D = 0, R = 0, P = 0;
          for (P = 0; P < 256; P++)
            C[P] = P < 128 ? P << 1 : P << 1 ^ 283;
          for (P = 0; P < 256; P++) {
            var N = R ^ R << 1 ^ R << 2 ^ R << 3 ^ R << 4;
            N = N >>> 8 ^ 255 & N ^ 99;
            var $ = C[m[f[D] = N] = D], O = C[$], M = C[O], F = 257 * C[N] ^ 16843008 * N;
            b[D] = F << 24 | F >>> 8, y[D] = F << 16 | F >>> 16, v[D] = F << 8 | F >>> 24, g[D] = F, F = 16843009 * M ^ 65537 * O ^ 257 * $ ^ 16843008 * D, x[N] = F << 24 | F >>> 8, w[N] = F << 16 | F >>> 16, S[N] = F << 8 | F >>> 24, T[N] = F, D ? (D = $ ^ C[C[C[M ^ $]]], R ^= C[C[R]]) : D = R = 1;
          }
        }, d.prototype.expandKey = function(f) {
          for (var m = this.uint8ArrayToUint32Array_(f), p = !0, b = 0; b < m.length && p; )
            p = m[b] === this.key[b], b++;
          if (!p) {
            this.key = m;
            var y = this.keySize = m.length;
            if (y !== 4 && y !== 6 && y !== 8)
              throw new Error("Invalid aes key size=" + y);
            var v, g, E, x, w = this.ksRows = 4 * (y + 6 + 1), S = this.keySchedule = new Uint32Array(w), T = this.invKeySchedule = new Uint32Array(w), C = this.sBox, D = this.rcon, R = this.invSubMix, P = R[0], N = R[1], $ = R[2], O = R[3];
            for (v = 0; v < w; v++)
              v < y ? E = S[v] = m[v] : (x = E, v % y == 0 ? (x = C[(x = x << 8 | x >>> 24) >>> 24] << 24 | C[x >>> 16 & 255] << 16 | C[x >>> 8 & 255] << 8 | C[255 & x], x ^= D[v / y | 0] << 24) : 6 < y && v % y == 4 && (x = C[x >>> 24] << 24 | C[x >>> 16 & 255] << 16 | C[x >>> 8 & 255] << 8 | C[255 & x]), S[v] = E = (S[v - y] ^ x) >>> 0);
            for (g = 0; g < w; g++)
              v = w - g, x = 3 & g ? S[v] : S[v - 4], T[g] = g < 4 || v <= 4 ? x : P[C[x >>> 24]] ^ N[C[x >>> 16 & 255]] ^ $[C[x >>> 8 & 255]] ^ O[C[255 & x]], T[g] = T[g] >>> 0;
          }
        }, d.prototype.networkToHostOrderSwap = function(f) {
          return f << 24 | (65280 & f) << 8 | (16711680 & f) >> 8 | f >>> 24;
        }, d.prototype.decrypt = function(f, m, p, b) {
          for (var y, v, g, E, x, w, S, T, C, D, R, P, N, $, O = this.keySize + 6, M = this.invKeySchedule, F = this.invSBox, G = this.invSubMix, K = G[0], J = G[1], ue = G[2], ce = G[3], ee = this.uint8ArrayToUint32Array_(p), me = ee[0], Ce = ee[1], Ne = ee[2], ot = ee[3], ze = new Int32Array(f), $e = new Int32Array(ze.length), Ze = this.networkToHostOrderSwap; m < ze.length; ) {
            for (C = Ze(ze[m]), D = Ze(ze[m + 1]), R = Ze(ze[m + 2]), P = Ze(ze[m + 3]), x = C ^ M[0], w = P ^ M[1], S = R ^ M[2], T = D ^ M[3], N = 4, $ = 1; $ < O; $++)
              y = K[x >>> 24] ^ J[w >> 16 & 255] ^ ue[S >> 8 & 255] ^ ce[255 & T] ^ M[N], v = K[w >>> 24] ^ J[S >> 16 & 255] ^ ue[T >> 8 & 255] ^ ce[255 & x] ^ M[N + 1], g = K[S >>> 24] ^ J[T >> 16 & 255] ^ ue[x >> 8 & 255] ^ ce[255 & w] ^ M[N + 2], E = K[T >>> 24] ^ J[x >> 16 & 255] ^ ue[w >> 8 & 255] ^ ce[255 & S] ^ M[N + 3], x = y, w = v, S = g, T = E, N += 4;
            y = F[x >>> 24] << 24 ^ F[w >> 16 & 255] << 16 ^ F[S >> 8 & 255] << 8 ^ F[255 & T] ^ M[N], v = F[w >>> 24] << 24 ^ F[S >> 16 & 255] << 16 ^ F[T >> 8 & 255] << 8 ^ F[255 & x] ^ M[N + 1], g = F[S >>> 24] << 24 ^ F[T >> 16 & 255] << 16 ^ F[x >> 8 & 255] << 8 ^ F[255 & w] ^ M[N + 2], E = F[T >>> 24] << 24 ^ F[x >> 16 & 255] << 16 ^ F[w >> 8 & 255] << 8 ^ F[255 & S] ^ M[N + 3], N += 3, $e[m] = Ze(y ^ me), $e[m + 1] = Ze(E ^ Ce), $e[m + 2] = Ze(g ^ Ne), $e[m + 3] = Ze(v ^ ot), me = C, Ce = D, Ne = R, ot = P, m += 4;
          }
          return b ? h($e.buffer) : $e.buffer;
        }, d.prototype.destroy = function() {
          this.key = void 0, this.keySize = void 0, this.ksRows = void 0, this.sBox = void 0, this.invSBox = void 0, this.subMix = void 0, this.invSubMix = void 0, this.keySchedule = void 0, this.invKeySchedule = void 0, this.rcon = void 0;
        }, d);
        function d() {
          this.rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.sBox = new Uint32Array(256), this.invSBox = new Uint32Array(256), this.key = new Uint32Array(0), this.initTable();
        }
        l.default = c;
      }, "./src/crypt/decrypter.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./src/crypt/aes-crypto.js"), c = u("./src/crypt/fast-aes-key.js"), d = u("./src/crypt/aes-decryptor.js"), f = u("./src/errors.js"), m = u("./src/utils/logger.js"), p = u("./src/events.js"), b = u("./src/utils/get-self-scope.js").getSelfScope(), y = (v.prototype.isSync = function() {
          return this.disableWebCrypto && this.config.enableSoftwareAES;
        }, v.prototype.decrypt = function(g, E, x, w) {
          var S = this;
          if (this.disableWebCrypto && this.config.enableSoftwareAES) {
            this.logEnabled && (m.logger.log("JS AES decrypt"), this.logEnabled = !1);
            var T = this.decryptor;
            T || (this.decryptor = T = new d.default()), T.expandKey(E), w(T.decrypt(g, 0, x, this.removePKCS7Padding));
          } else {
            this.logEnabled && (m.logger.log("WebCrypto AES decrypt"), this.logEnabled = !1);
            var C = this.subtle;
            this.key !== E && (this.key = E, this.fastAesKey = new c.default(C, E)), this.fastAesKey.expandKey().then(function(D) {
              new h.default(C, x).decrypt(g, D).catch(function(R) {
                S.onWebCryptoError(R, g, E, x, w);
              }).then(function(R) {
                w(R);
              });
            }).catch(function(D) {
              S.onWebCryptoError(D, g, E, x, w);
            });
          }
        }, v.prototype.onWebCryptoError = function(g, E, x, w, S) {
          this.config.enableSoftwareAES ? (m.logger.log("WebCrypto Error, disable WebCrypto API"), this.disableWebCrypto = !0, this.logEnabled = !0, this.decrypt(E, x, w, S)) : (m.logger.error("decrypting error : " + g.message), this.observer.trigger(p.default.ERROR, { type: f.ErrorTypes.MEDIA_ERROR, details: f.ErrorDetails.FRAG_DECRYPT_ERROR, fatal: !0, reason: g.message }));
        }, v.prototype.destroy = function() {
          var g = this.decryptor;
          g && (g.destroy(), this.decryptor = void 0);
        }, v);
        function v(g, E, x) {
          var w = (x === void 0 ? {} : x).removePKCS7Padding, S = w === void 0 || w;
          if (this.logEnabled = !0, this.observer = g, this.config = E, this.removePKCS7Padding = S)
            try {
              var T = b.crypto;
              T && (this.subtle = T.subtle || T.webkitSubtle);
            } catch {
            }
          this.disableWebCrypto = !this.subtle;
        }
        l.default = y;
      }, "./src/crypt/fast-aes-key.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = (c.prototype.expandKey = function() {
          return this.subtle.importKey("raw", this.key, { name: "AES-CBC" }, !1, ["encrypt", "decrypt"]);
        }, c);
        function c(d, f) {
          this.subtle = d, this.key = f;
        }
        l.default = h;
      }, "./src/demux/aacdemuxer.js": function(o, l, u) {
        (function(h) {
          Object.defineProperty(l, "__esModule", { value: !0 });
          var c = u("./src/demux/adts.js"), d = u("./src/utils/logger.js"), f = u("./src/demux/id3.js"), m = (p.prototype.resetInitSegment = function(b, y, v, g) {
            this._audioTrack = { container: "audio/adts", type: "audio", id: 0, sequenceNumber: 0, isAAC: !0, samples: [], len: 0, manifestCodec: y, duration: g, inputTimeScale: 9e4 };
          }, p.prototype.resetTimeStamp = function() {
          }, p.probe = function(b) {
            if (!b)
              return !1;
            for (var y = (f.default.getID3Data(b, 0) || []).length, v = b.length; y < v; y++)
              if (c.probe(b, y))
                return d.logger.log("ADTS sync word found !"), !0;
            return !1;
          }, p.prototype.append = function(b, y, v, g) {
            for (var E = this._audioTrack, x = f.default.getID3Data(b, 0) || [], w = f.default.getTimeStamp(x), S = h.isFinite(w) ? 90 * w : 9e4 * y, T = 0, C = S, D = b.length, R = x.length, P = [{ pts: C, dts: C, data: x }]; R < D - 1; )
              if (c.isHeader(b, R) && R + 5 < D) {
                c.initTrackConfig(E, this.observer, b, R, E.manifestCodec);
                var N = c.appendFrame(E, b, R, S, T);
                if (!N) {
                  d.logger.log("Unable to parse AAC frame");
                  break;
                }
                R += N.length, C = N.sample.pts, T++;
              } else
                f.default.isHeader(b, R) ? (x = f.default.getID3Data(b, R), P.push({ pts: C, dts: C, data: x }), R += x.length) : R++;
            this.remuxer.remux(E, { samples: [] }, { samples: P, inputTimeScale: 9e4 }, { samples: [] }, y, v, g);
          }, p.prototype.destroy = function() {
          }, p);
          function p(b, y, v) {
            this.observer = b, this.config = v, this.remuxer = y;
          }
          l.default = m;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/demux/adts.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./src/utils/logger.js"), c = u("./src/errors.js"), d = u("./src/events.js");
        function f(g, E, x, w) {
          var S, T, C, D, R, P = navigator.userAgent.toLowerCase(), N = w, $ = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
          if (S = 1 + ((192 & E[x + 2]) >>> 6), T = (60 & E[x + 2]) >>> 2, !($.length - 1 < T))
            return D = (1 & E[x + 2]) << 2, D |= (192 & E[x + 3]) >>> 6, h.logger.log("manifest codec:" + w + ",ADTS data:type:" + S + ",sampleingIndex:" + T + "[" + $[T] + "Hz],channelConfig:" + D), C = /firefox/i.test(P) ? 6 <= T ? (S = 5, R = new Array(4), T - 3) : (S = 2, R = new Array(2), T) : P.indexOf("android") !== -1 ? (S = 2, R = new Array(2), T) : (S = 5, R = new Array(4), w && (w.indexOf("mp4a.40.29") !== -1 || w.indexOf("mp4a.40.5") !== -1) || !w && 6 <= T ? T - 3 : ((w && w.indexOf("mp4a.40.2") !== -1 && (6 <= T && D == 1 || /vivaldi/i.test(P)) || !w && D == 1) && (S = 2, R = new Array(2)), T)), R[0] = S << 3, R[0] |= (14 & T) >> 1, R[1] |= (1 & T) << 7, R[1] |= D << 3, S === 5 && (R[1] |= (14 & C) >> 1, R[2] = (1 & C) << 7, R[2] |= 8, R[3] = 0), { config: R, samplerate: $[T], channelCount: D, codec: "mp4a.40." + S, manifestCodec: N };
          g.trigger(d.default.ERROR, { type: c.ErrorTypes.MEDIA_ERROR, details: c.ErrorDetails.FRAG_PARSING_ERROR, fatal: !0, reason: "invalid ADTS sampling index:" + T });
        }
        function m(g, E) {
          return g[E] === 255 && (246 & g[E + 1]) == 240;
        }
        function p(g, E) {
          return 1 & g[E + 1] ? 7 : 9;
        }
        function b(g, E) {
          return (3 & g[E + 3]) << 11 | g[E + 4] << 3 | (224 & g[E + 5]) >>> 5;
        }
        function y(g) {
          return 9216e4 / g;
        }
        function v(g, E, x, w, S) {
          var T, C, D = g.length;
          if (T = p(g, E), C = b(g, E), 0 < (C -= T) && E + T + C <= D)
            return { headerLength: T, frameLength: C, stamp: x + w * S };
        }
        l.getAudioConfig = f, l.isHeaderPattern = m, l.getHeaderLength = p, l.getFullFrameLength = b, l.isHeader = function(g, E) {
          return !!(E + 1 < g.length && m(g, E));
        }, l.probe = function(g, E) {
          if (E + 1 < g.length && m(g, E)) {
            var x = p(g, E);
            E + 5 < g.length && (x = b(g, E));
            var w = E + x;
            if (w === g.length || w + 1 < g.length && m(g, w))
              return !0;
          }
          return !1;
        }, l.initTrackConfig = function(g, E, x, w, S) {
          if (!g.samplerate) {
            var T = f(E, x, w, S);
            g.config = T.config, g.samplerate = T.samplerate, g.channelCount = T.channelCount, g.codec = T.codec, g.manifestCodec = T.manifestCodec, h.logger.log("parsed codec:" + g.codec + ",rate:" + T.samplerate + ",nb channel:" + T.channelCount);
          }
        }, l.getFrameDuration = y, l.parseFrameHeader = v, l.appendFrame = function(g, E, x, w, S) {
          var T = v(E, x, w, S, y(g.samplerate));
          if (T) {
            var C = T.stamp, D = T.headerLength, R = T.frameLength, P = { unit: E.subarray(x + D, x + D + R), pts: C, dts: C };
            return g.samples.push(P), g.len += R, { sample: P, length: R + D };
          }
        };
      }, "./src/demux/demuxer-inline.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h, c = u("./src/events.js"), d = u("./src/errors.js"), f = u("./src/crypt/decrypter.js"), m = u("./src/demux/aacdemuxer.js"), p = u("./src/demux/mp4demuxer.js"), b = u("./src/demux/tsdemuxer.js"), y = u("./src/demux/mp3demuxer.js"), v = u("./src/remux/mp4-remuxer.js"), g = u("./src/remux/passthrough-remuxer.js"), E = u("./src/utils/get-self-scope.js"), x = u("./src/utils/logger.js"), w = E.getSelfScope();
        try {
          h = w.performance.now.bind(w.performance);
        } catch {
          x.logger.debug("Unable to use Performance API on this environment"), h = w.Date.now;
        }
        var S = (T.prototype.destroy = function() {
          var C = this.demuxer;
          C && C.destroy();
        }, T.prototype.push = function(C, D, R, P, N, $, O, M, F, G, K, J) {
          var ue = this;
          if (0 < C.byteLength && D != null && D.key != null && D.method === "AES-128") {
            var ce = this.decrypter;
            ce == null && (ce = this.decrypter = new f.default(this.observer, this.config));
            var ee = h();
            ce.decrypt(C, D.key.buffer, D.iv.buffer, function(me) {
              var Ce = h();
              ue.observer.trigger(c.default.FRAG_DECRYPTED, { stats: { tstart: ee, tdecrypt: Ce } }), ue.pushDecrypted(new Uint8Array(me), D, new Uint8Array(R), P, N, $, O, M, F, G, K, J);
            });
          } else
            this.pushDecrypted(new Uint8Array(C), D, new Uint8Array(R), P, N, $, O, M, F, G, K, J);
        }, T.prototype.pushDecrypted = function(C, D, R, P, N, $, O, M, F, G, K, J) {
          var ue = this.demuxer;
          if (!ue || (O || M) && !this.probe(C)) {
            for (var ce = this.observer, ee = this.typeSupported, me = this.config, Ce = [{ demux: b.default, remux: v.default }, { demux: p.default, remux: g.default }, { demux: m.default, remux: v.default }, { demux: y.default, remux: v.default }], Ne = 0, ot = Ce.length; Ne < ot; Ne++) {
              var ze = Ce[Ne], $e = ze.demux.probe;
              if ($e(C)) {
                var Ze = this.remuxer = new ze.remux(ce, me, ee, this.vendor);
                ue = new ze.demux(ce, Ze, me, ee), this.probe = $e;
                break;
              }
            }
            if (!ue)
              return void ce.trigger(c.default.ERROR, { type: d.ErrorTypes.MEDIA_ERROR, details: d.ErrorDetails.FRAG_PARSING_ERROR, fatal: !0, reason: "no demux matching with content found" });
            this.demuxer = ue;
          }
          var Ut = this.remuxer;
          (O || M) && (ue.resetInitSegment(R, P, N, G), Ut.resetInitSegment()), O && (ue.resetTimeStamp(J), Ut.resetTimeStamp(J)), typeof ue.setDecryptData == "function" && ue.setDecryptData(D), ue.append(C, $, F, K);
        }, T);
        function T(C, D, R, P) {
          this.observer = C, this.typeSupported = D, this.config = R, this.vendor = P;
        }
        l.default = S;
      }, "./src/demux/demuxer-worker.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./src/demux/demuxer-inline.js"), c = u("./src/events.js"), d = u("./src/utils/logger.js"), f = u("./node_modules/node-libs-browser/node_modules/events/events.js");
        l.default = function(m) {
          var p = new f.EventEmitter();
          p.trigger = function(y) {
            for (var v = [], g = 1; g < arguments.length; g++)
              v[g - 1] = arguments[g];
            p.emit.apply(p, [y, y].concat(v));
          }, p.off = function(y) {
            for (var v = [], g = 1; g < arguments.length; g++)
              v[g - 1] = arguments[g];
            p.removeListener.apply(p, [y].concat(v));
          };
          function b(y, v) {
            m.postMessage({ event: y, data: v });
          }
          m.addEventListener("message", function(y) {
            var v = y.data;
            switch (v.cmd) {
              case "init":
                var g = JSON.parse(v.config);
                m.demuxer = new h.default(p, v.typeSupported, g, v.vendor), d.enableLogs(g.debug), b("init", null);
                break;
              case "demux":
                m.demuxer.push(v.data, v.decryptdata, v.initSegment, v.audioCodec, v.videoCodec, v.timeOffset, v.discontinuity, v.trackSwitch, v.contiguous, v.duration, v.accurateTimeOffset, v.defaultInitPTS);
            }
          }), p.on(c.default.FRAG_DECRYPTED, b), p.on(c.default.FRAG_PARSING_INIT_SEGMENT, b), p.on(c.default.FRAG_PARSED, b), p.on(c.default.ERROR, b), p.on(c.default.FRAG_PARSING_METADATA, b), p.on(c.default.FRAG_PARSING_USERDATA, b), p.on(c.default.INIT_PTS_FOUND, b), p.on(c.default.FRAG_PARSING_DATA, function(y, v) {
            var g = [], E = { event: y, data: v };
            v.data1 && (E.data1 = v.data1.buffer, g.push(v.data1.buffer), delete v.data1), v.data2 && (E.data2 = v.data2.buffer, g.push(v.data2.buffer), delete v.data2), m.postMessage(E, g);
          });
        };
      }, "./src/demux/demuxer.js": function(o, l, u) {
        (function(h) {
          Object.defineProperty(l, "__esModule", { value: !0 });
          var c = u("./node_modules/webworkify-webpack/index.js"), d = u("./src/events.js"), f = u("./src/demux/demuxer-inline.js"), m = u("./src/utils/logger.js"), p = u("./src/errors.js"), b = u("./src/utils/mediasource-helper.js"), y = u("./src/utils/get-self-scope.js"), v = u("./src/observer.js"), g = y.getSelfScope(), E = b.getMediaSource(), x = (w.prototype.destroy = function() {
            var S = this.w;
            if (S)
              S.removeEventListener("message", this.onwmsg), S.terminate(), this.w = null;
            else {
              var T = this.demuxer;
              T && (T.destroy(), this.demuxer = null);
            }
            var C = this.observer;
            C && (C.removeAllListeners(), this.observer = null);
          }, w.prototype.push = function(S, T, C, D, R, P, N, $) {
            var O = this.w, M = h.isFinite(R.startPTS) ? R.startPTS : R.start, F = R.decryptdata, G = this.frag, K = !(G && R.cc === G.cc), J = !(G && R.level === G.level), ue = G && R.sn === G.sn + 1, ce = !J && ue;
            if (K && m.logger.log(this.id + ":discontinuity detected"), J && m.logger.log(this.id + ":switch detected"), this.frag = R, O)
              O.postMessage({ cmd: "demux", data: S, decryptdata: F, initSegment: T, audioCodec: C, videoCodec: D, timeOffset: M, discontinuity: K, trackSwitch: J, contiguous: ce, duration: P, accurateTimeOffset: N, defaultInitPTS: $ }, S instanceof ArrayBuffer ? [S] : []);
            else {
              var ee = this.demuxer;
              ee && ee.push(S, F, T, C, D, M, K, J, ce, P, N, $);
            }
          }, w.prototype.onWorkerMessage = function(S) {
            var T = S.data, C = this.hls;
            switch (T.event) {
              case "init":
                g.URL.revokeObjectURL(this.w.objectURL);
                break;
              case d.default.FRAG_PARSING_DATA:
                T.data.data1 = new Uint8Array(T.data1), T.data2 && (T.data.data2 = new Uint8Array(T.data2));
              default:
                T.data = T.data || {}, T.data.frag = this.frag, T.data.id = this.id, C.trigger(T.event, T.data);
            }
          }, w);
          function w(S, T) {
            var C = this;
            this.hls = S, this.id = T;
            function D(M, F) {
              (F = F || {}).frag = C.frag, F.id = C.id, S.trigger(M, F);
            }
            var R = this.observer = new v.Observer(), P = S.config;
            R.on(d.default.FRAG_DECRYPTED, D), R.on(d.default.FRAG_PARSING_INIT_SEGMENT, D), R.on(d.default.FRAG_PARSING_DATA, D), R.on(d.default.FRAG_PARSED, D), R.on(d.default.ERROR, D), R.on(d.default.FRAG_PARSING_METADATA, D), R.on(d.default.FRAG_PARSING_USERDATA, D), R.on(d.default.INIT_PTS_FOUND, D);
            var N = { mp4: E.isTypeSupported("video/mp4"), mpeg: E.isTypeSupported("audio/mpeg"), mp3: E.isTypeSupported('audio/mp4; codecs="mp3"') }, $ = navigator.vendor;
            if (P.enableWorker && typeof Worker < "u") {
              m.logger.log("demuxing in webworker");
              var O = void 0;
              try {
                O = this.w = c("./src/demux/demuxer-worker.js"), this.onwmsg = this.onWorkerMessage.bind(this), O.addEventListener("message", this.onwmsg), O.onerror = function(M) {
                  S.trigger(d.default.ERROR, { type: p.ErrorTypes.OTHER_ERROR, details: p.ErrorDetails.INTERNAL_EXCEPTION, fatal: !0, event: "demuxerWorker", err: { message: M.message + " (" + M.filename + ":" + M.lineno + ")" } });
                }, O.postMessage({ cmd: "init", typeSupported: N, vendor: $, id: T, config: JSON.stringify(P) });
              } catch (M) {
                m.logger.warn("Error in worker:", M), m.logger.error("Error while initializing DemuxerWorker, fallback on DemuxerInline"), O && g.URL.revokeObjectURL(O.objectURL), this.demuxer = new f.default(R, N, P, $), this.w = void 0;
              }
            } else
              this.demuxer = new f.default(R, N, P, $);
          }
          l.default = x;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/demux/exp-golomb.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./src/utils/logger.js"), c = (d.prototype.loadWord = function() {
          var f = this.data, m = this.bytesAvailable, p = f.byteLength - m, b = new Uint8Array(4), y = Math.min(4, m);
          if (y === 0)
            throw new Error("no bytes available");
          b.set(f.subarray(p, p + y)), this.word = new DataView(b.buffer).getUint32(0), this.bitsAvailable = 8 * y, this.bytesAvailable -= y;
        }, d.prototype.skipBits = function(f) {
          var m;
          this.bitsAvailable > f || (f -= this.bitsAvailable, f -= (m = f >> 3) >> 3, this.bytesAvailable -= m, this.loadWord()), this.word <<= f, this.bitsAvailable -= f;
        }, d.prototype.readBits = function(f) {
          var m = Math.min(this.bitsAvailable, f), p = this.word >>> 32 - m;
          return 32 < f && h.logger.error("Cannot read more than 32 bits at a time"), this.bitsAvailable -= m, 0 < this.bitsAvailable ? this.word <<= m : 0 < this.bytesAvailable && this.loadWord(), 0 < (m = f - m) && this.bitsAvailable ? p << m | this.readBits(m) : p;
        }, d.prototype.skipLZ = function() {
          var f;
          for (f = 0; f < this.bitsAvailable; ++f)
            if ((this.word & 2147483648 >>> f) != 0)
              return this.word <<= f, this.bitsAvailable -= f, f;
          return this.loadWord(), f + this.skipLZ();
        }, d.prototype.skipUEG = function() {
          this.skipBits(1 + this.skipLZ());
        }, d.prototype.skipEG = function() {
          this.skipBits(1 + this.skipLZ());
        }, d.prototype.readUEG = function() {
          var f = this.skipLZ();
          return this.readBits(f + 1) - 1;
        }, d.prototype.readEG = function() {
          var f = this.readUEG();
          return 1 & f ? 1 + f >>> 1 : -1 * (f >>> 1);
        }, d.prototype.readBoolean = function() {
          return this.readBits(1) === 1;
        }, d.prototype.readUByte = function() {
          return this.readBits(8);
        }, d.prototype.readUShort = function() {
          return this.readBits(16);
        }, d.prototype.readUInt = function() {
          return this.readBits(32);
        }, d.prototype.skipScalingList = function(f) {
          var m, p = 8, b = 8;
          for (m = 0; m < f; m++)
            b !== 0 && (b = (p + this.readEG() + 256) % 256), p = b === 0 ? p : b;
        }, d.prototype.readSPS = function() {
          var f, m, p, b, y, v, g, E = 0, x = 0, w = 0, S = 0, T = this.readUByte.bind(this), C = this.readBits.bind(this), D = this.readUEG.bind(this), R = this.readBoolean.bind(this), P = this.skipBits.bind(this), N = this.skipEG.bind(this), $ = this.skipUEG.bind(this), O = this.skipScalingList.bind(this);
          if (T(), f = T(), C(5), P(3), T(), $(), f === 100 || f === 110 || f === 122 || f === 244 || f === 44 || f === 83 || f === 86 || f === 118 || f === 128) {
            var M = D();
            if (M === 3 && P(1), $(), $(), P(1), R())
              for (v = M !== 3 ? 8 : 12, g = 0; g < v; g++)
                R() && O(g < 6 ? 16 : 64);
          }
          $();
          var F = D();
          if (F === 0)
            D();
          else if (F === 1)
            for (P(1), N(), N(), m = D(), g = 0; g < m; g++)
              N();
          $(), P(1), p = D(), b = D(), (y = C(1)) === 0 && P(1), P(1), R() && (E = D(), x = D(), w = D(), S = D());
          var G = [1, 1];
          if (R() && R())
            switch (T()) {
              case 1:
                G = [1, 1];
                break;
              case 2:
                G = [12, 11];
                break;
              case 3:
                G = [10, 11];
                break;
              case 4:
                G = [16, 11];
                break;
              case 5:
                G = [40, 33];
                break;
              case 6:
                G = [24, 11];
                break;
              case 7:
                G = [20, 11];
                break;
              case 8:
                G = [32, 11];
                break;
              case 9:
                G = [80, 33];
                break;
              case 10:
                G = [18, 11];
                break;
              case 11:
                G = [15, 11];
                break;
              case 12:
                G = [64, 33];
                break;
              case 13:
                G = [160, 99];
                break;
              case 14:
                G = [4, 3];
                break;
              case 15:
                G = [3, 2];
                break;
              case 16:
                G = [2, 1];
                break;
              case 255:
                G = [T() << 8 | T(), T() << 8 | T()];
            }
          return { width: Math.ceil(16 * (p + 1) - 2 * E - 2 * x), height: (2 - y) * (b + 1) * 16 - (y ? 2 : 4) * (w + S), pixelRatio: G };
        }, d.prototype.readSliceType = function() {
          return this.readUByte(), this.readUEG(), this.readUEG();
        }, d);
        function d(f) {
          this.data = f, this.bytesAvailable = f.byteLength, this.word = 0, this.bitsAvailable = 0;
        }
        l.default = c;
      }, "./src/demux/id3.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = (c.isHeader = function(f, m) {
          return m + 10 <= f.length && f[m] === 73 && f[m + 1] === 68 && f[m + 2] === 51 && f[m + 3] < 255 && f[m + 4] < 255 && f[m + 6] < 128 && f[m + 7] < 128 && f[m + 8] < 128 && f[m + 9] < 128;
        }, c.isFooter = function(f, m) {
          return m + 10 <= f.length && f[m] === 51 && f[m + 1] === 68 && f[m + 2] === 73 && f[m + 3] < 255 && f[m + 4] < 255 && f[m + 6] < 128 && f[m + 7] < 128 && f[m + 8] < 128 && f[m + 9] < 128;
        }, c.getID3Data = function(f, m) {
          for (var p = m, b = 0; c.isHeader(f, m); )
            b += 10, b += c._readSize(f, m + 6), c.isFooter(f, m + 10) && (b += 10), m += b;
          if (0 < b)
            return f.subarray(p, p + b);
        }, c._readSize = function(f, m) {
          var p = 0;
          return p = (127 & f[m]) << 21, p |= (127 & f[m + 1]) << 14, p |= (127 & f[m + 2]) << 7, p |= 127 & f[m + 3];
        }, c.getTimeStamp = function(f) {
          for (var m = c.getID3Frames(f), p = 0; p < m.length; p++) {
            var b = m[p];
            if (c.isTimeStampFrame(b))
              return c._readTimeStamp(b);
          }
        }, c.isTimeStampFrame = function(f) {
          return f && f.key === "PRIV" && f.info === "com.apple.streaming.transportStreamTimestamp";
        }, c._getFrameData = function(f) {
          var m = String.fromCharCode(f[0], f[1], f[2], f[3]), p = c._readSize(f, 4);
          return { type: m, size: p, data: f.subarray(10, 10 + p) };
        }, c.getID3Frames = function(f) {
          for (var m = 0, p = []; c.isHeader(f, m); ) {
            for (var b = c._readSize(f, m + 6), y = (m += 10) + b; m + 8 < y; ) {
              var v = c._getFrameData(f.subarray(m)), g = c._decodeFrame(v);
              g && p.push(g), m += v.size + 10;
            }
            c.isFooter(f, m) && (m += 10);
          }
          return p;
        }, c._decodeFrame = function(f) {
          return f.type === "PRIV" ? c._decodePrivFrame(f) : f.type[0] === "T" ? c._decodeTextFrame(f) : f.type[0] === "W" ? c._decodeURLFrame(f) : void 0;
        }, c._readTimeStamp = function(f) {
          if (f.data.byteLength === 8) {
            var m = new Uint8Array(f.data), p = 1 & m[3], b = (m[4] << 23) + (m[5] << 15) + (m[6] << 7) + m[7];
            return b /= 45, p && (b += 4772185884e-2), Math.round(b);
          }
        }, c._decodePrivFrame = function(f) {
          if (!(f.size < 2)) {
            var m = c._utf8ArrayToStr(f.data, !0), p = new Uint8Array(f.data.subarray(m.length + 1));
            return { key: f.type, info: m, data: p.buffer };
          }
        }, c._decodeTextFrame = function(f) {
          if (!(f.size < 2)) {
            if (f.type === "TXXX") {
              var m = 1, p = c._utf8ArrayToStr(f.data.subarray(m));
              m += p.length + 1;
              var b = c._utf8ArrayToStr(f.data.subarray(m));
              return { key: f.type, info: p, data: b };
            }
            var y = c._utf8ArrayToStr(f.data.subarray(1));
            return { key: f.type, data: y };
          }
        }, c._decodeURLFrame = function(f) {
          if (f.type === "WXXX") {
            if (f.size < 2)
              return;
            var m = 1, p = c._utf8ArrayToStr(f.data.subarray(m));
            m += p.length + 1;
            var b = c._utf8ArrayToStr(f.data.subarray(m));
            return { key: f.type, info: p, data: b };
          }
          var y = c._utf8ArrayToStr(f.data);
          return { key: f.type, data: y };
        }, c._utf8ArrayToStr = function(f, m) {
          m === void 0 && (m = !1);
          for (var p, b, y, v = f.length, g = "", E = 0; E < v; ) {
            if ((p = f[E++]) === 0 && m)
              return g;
            if (p !== 0 && p !== 3)
              switch (p >> 4) {
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                  g += String.fromCharCode(p);
                  break;
                case 12:
                case 13:
                  b = f[E++], g += String.fromCharCode((31 & p) << 6 | 63 & b);
                  break;
                case 14:
                  b = f[E++], y = f[E++], g += String.fromCharCode((15 & p) << 12 | (63 & b) << 6 | (63 & y) << 0);
              }
          }
          return g;
        }, c);
        function c() {
        }
        var d = h._utf8ArrayToStr;
        l.utf8ArrayToStr = d, l.default = h;
      }, "./src/demux/mp3demuxer.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./src/demux/id3.js"), c = u("./src/utils/logger.js"), d = u("./src/demux/mpegaudio.js"), f = (m.prototype.resetInitSegment = function(p, b, y, v) {
          this._audioTrack = { container: "audio/mpeg", type: "audio", id: -1, sequenceNumber: 0, isAAC: !1, samples: [], len: 0, manifestCodec: b, duration: v, inputTimeScale: 9e4 };
        }, m.prototype.resetTimeStamp = function() {
        }, m.probe = function(p) {
          var b, y, v = h.default.getID3Data(p, 0);
          if (v && h.default.getTimeStamp(v) !== void 0) {
            for (b = v.length, y = Math.min(p.length - 1, b + 100); b < y; b++)
              if (d.default.probe(p, b))
                return c.logger.log("MPEG Audio sync word found !"), !0;
          }
          return !1;
        }, m.prototype.append = function(p, b, y, v) {
          for (var g = h.default.getID3Data(p, 0), E = h.default.getTimeStamp(g), x = E ? 90 * E : 9e4 * b, w = g.length, S = p.length, T = 0, C = 0, D = this._audioTrack, R = [{ pts: x, dts: x, data: g }]; w < S; )
            if (d.default.isHeader(p, w)) {
              var P = d.default.appendFrame(D, p, w, x, T);
              if (!P)
                break;
              w += P.length, C = P.sample.pts, T++;
            } else
              h.default.isHeader(p, w) ? (g = h.default.getID3Data(p, w), R.push({ pts: C, dts: C, data: g }), w += g.length) : w++;
          this.remuxer.remux(D, { samples: [] }, { samples: R, inputTimeScale: 9e4 }, { samples: [] }, b, y, v);
        }, m.prototype.destroy = function() {
        }, m);
        function m(p, b, y) {
          this.observer = p, this.config = y, this.remuxer = b;
        }
        l.default = f;
      }, "./src/demux/mp4demuxer.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./src/utils/logger.js"), c = u("./src/events.js"), d = Math.pow(2, 32) - 1, f = (m.prototype.resetTimeStamp = function(p) {
          this.initPTS = p;
        }, m.prototype.resetInitSegment = function(p, b, y, v) {
          if (p && p.byteLength) {
            var g = this.initData = m.parseInitSegment(p);
            b == null && (b = "mp4a.40.5"), y == null && (y = "avc1.42e01e");
            var E = {};
            g.audio && g.video ? E.audiovideo = { container: "video/mp4", codec: b + "," + y, initSegment: v ? p : null } : (g.audio && (E.audio = { container: "audio/mp4", codec: b, initSegment: v ? p : null }), g.video && (E.video = { container: "video/mp4", codec: y, initSegment: v ? p : null })), this.observer.trigger(c.default.FRAG_PARSING_INIT_SEGMENT, { tracks: E });
          } else
            b && (this.audioCodec = b), y && (this.videoCodec = y);
        }, m.probe = function(p) {
          return 0 < m.findBox({ data: p, start: 0, end: Math.min(p.length, 16384) }, ["moof"]).length;
        }, m.bin2str = function(p) {
          return String.fromCharCode.apply(null, p);
        }, m.readUint16 = function(p, b) {
          p.data && (b += p.start, p = p.data);
          var y = p[b] << 8 | p[b + 1];
          return y < 0 ? 65536 + y : y;
        }, m.readUint32 = function(p, b) {
          p.data && (b += p.start, p = p.data);
          var y = p[b] << 24 | p[b + 1] << 16 | p[b + 2] << 8 | p[b + 3];
          return y < 0 ? 4294967296 + y : y;
        }, m.writeUint32 = function(p, b, y) {
          p.data && (b += p.start, p = p.data), p[b] = y >> 24, p[b + 1] = y >> 16 & 255, p[b + 2] = y >> 8 & 255, p[b + 3] = 255 & y;
        }, m.findBox = function(p, b) {
          var y, v, g, E, x, w, S = [];
          if (p.data ? (x = p.start, g = p.end, p = p.data) : (x = 0, g = p.byteLength), !b.length)
            return null;
          for (y = x; y < g; )
            w = 1 < (v = m.readUint32(p, y)) ? y + v : g, m.bin2str(p.subarray(y + 4, y + 8)) === b[0] && (b.length === 1 ? S.push({ data: p, start: y + 8, end: w }) : (E = m.findBox({ data: p, start: y + 8, end: w }, b.slice(1))).length && (S = S.concat(E))), y = w;
          return S;
        }, m.parseSegmentIndex = function(p) {
          var b, y = m.findBox(p, ["moov"])[0], v = y ? y.end : null, g = 0, E = m.findBox(p, ["sidx"]);
          if (!E || !E[0])
            return null;
          b = [];
          var x = (E = E[0]).data[0], w = m.readUint32(E, g = x === 0 ? 8 : 16);
          g += 4, g += x === 0 ? 8 : 16, g += 2;
          var S = E.end + 0, T = m.readUint16(E, g);
          g += 2;
          for (var C = 0; C < T; C++) {
            var D = g, R = m.readUint32(E, D), P = 2147483647 & R;
            if ((2147483648 & R) >>> 31 == 1)
              return;
            var N = m.readUint32(E, D += 4);
            D += 4, b.push({ referenceSize: P, subsegmentDuration: N, info: { duration: N / w, start: S, end: S + P - 1 } }), S += P, g = D += 4;
          }
          return { earliestPresentationTime: 0, timescale: w, version: x, referencesCount: T, references: b, moovEndOffset: v };
        }, m.parseInitSegment = function(p) {
          var b = [];
          return m.findBox(p, ["moov", "trak"]).forEach(function(y) {
            var v = m.findBox(y, ["tkhd"])[0];
            if (v) {
              var g = v.data[v.start], E = g === 0 ? 12 : 20, x = m.readUint32(v, E), w = m.findBox(y, ["mdia", "mdhd"])[0];
              if (w) {
                g = w.data[w.start];
                var S = m.readUint32(w, E = g === 0 ? 12 : 20), T = m.findBox(y, ["mdia", "hdlr"])[0];
                if (T) {
                  var C = { soun: "audio", vide: "video" }[m.bin2str(T.data.subarray(T.start + 8, T.start + 12))];
                  if (C) {
                    var D = m.findBox(y, ["mdia", "minf", "stbl", "stsd"]);
                    if (D.length) {
                      D = D[0];
                      var R = m.bin2str(D.data.subarray(D.start + 12, D.start + 16));
                      h.logger.log("MP4Demuxer:" + C + ":" + R + " found");
                    }
                    b[x] = { timescale: S, type: C }, b[C] = { timescale: S, id: x };
                  }
                }
              }
            }
          }), b;
        }, m.getStartDTS = function(p, b) {
          var y, v, g;
          return y = m.findBox(b, ["moof", "traf"]), v = [].concat.apply([], y.map(function(E) {
            return m.findBox(E, ["tfhd"]).map(function(x) {
              var w, S;
              return w = m.readUint32(x, 4), S = p[w].timescale || 9e4, m.findBox(E, ["tfdt"]).map(function(T) {
                var C, D;
                return C = T.data[T.start], D = m.readUint32(T, 4), C === 1 && (D *= Math.pow(2, 32), D += m.readUint32(T, 8)), D;
              })[0] / S;
            });
          })), g = Math.min.apply(null, v), isFinite(g) ? g : 0;
        }, m.offsetStartDTS = function(p, b, y) {
          m.findBox(b, ["moof", "traf"]).map(function(v) {
            return m.findBox(v, ["tfhd"]).map(function(g) {
              var E = m.readUint32(g, 4), x = p[E].timescale || 9e4;
              m.findBox(v, ["tfdt"]).map(function(w) {
                var S = w.data[w.start], T = m.readUint32(w, 4);
                if (S === 0)
                  m.writeUint32(w, 4, T - y * x);
                else {
                  T *= Math.pow(2, 32), T += m.readUint32(w, 8), T -= y * x, T = Math.max(T, 0);
                  var C = Math.floor(T / (1 + d)), D = Math.floor(T % (1 + d));
                  m.writeUint32(w, 4, C), m.writeUint32(w, 8, D);
                }
              });
            });
          });
        }, m.prototype.append = function(p, b, y, v) {
          var g = this.initData;
          g || (this.resetInitSegment(p, this.audioCodec, this.videoCodec, !1), g = this.initData);
          var E, x = this.initPTS;
          if (x === void 0) {
            var w = m.getStartDTS(g, p);
            this.initPTS = x = w - b, this.observer.trigger(c.default.INIT_PTS_FOUND, { initPTS: x });
          }
          m.offsetStartDTS(g, p, x), E = m.getStartDTS(g, p), this.remuxer.remux(g.audio, g.video, null, null, E, y, v, p);
        }, m.prototype.destroy = function() {
        }, m);
        function m(p, b) {
          this.observer = p, this.remuxer = b;
        }
        l.default = f;
      }, "./src/demux/mpegaudio.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = { BitratesMap: [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160], SamplingRateMap: [44100, 48e3, 32e3, 22050, 24e3, 16e3, 11025, 12e3, 8e3], SamplesCoefficients: [[0, 72, 144, 12], [0, 0, 0, 0], [0, 72, 144, 12], [0, 144, 144, 12]], BytesInSlot: [0, 1, 1, 4], appendFrame: function(c, d, f, m, p) {
          if (!(f + 24 > d.length)) {
            var b = this.parseHeader(d, f);
            if (b && f + b.frameLength <= d.length) {
              var y = m + p * (9e4 * b.samplesPerFrame / b.sampleRate), v = { unit: d.subarray(f, f + b.frameLength), pts: y, dts: y };
              return c.config = [], c.channelCount = b.channelCount, c.samplerate = b.sampleRate, c.samples.push(v), c.len += b.frameLength, { sample: v, length: b.frameLength };
            }
          }
        }, parseHeader: function(c, d) {
          var f = c[d + 1] >> 3 & 3, m = c[d + 1] >> 1 & 3, p = c[d + 2] >> 4 & 15, b = c[d + 2] >> 2 & 3, y = c[d + 2] >> 1 & 1;
          if (f != 1 && p != 0 && p != 15 && b != 3) {
            var v = f == 3 ? 3 - m : m == 3 ? 3 : 4, g = 1e3 * h.BitratesMap[14 * v + p - 1], E = f == 3 ? 0 : f == 2 ? 1 : 2, x = h.SamplingRateMap[3 * E + b], w = c[d + 3] >> 6 == 3 ? 1 : 2, S = h.SamplesCoefficients[f][m], T = h.BytesInSlot[m], C = 8 * S * T;
            return { sampleRate: x, channelCount: w, frameLength: parseInt(S * g / x + y, 10) * T, samplesPerFrame: C };
          }
        }, isHeaderPattern: function(c, d) {
          return c[d] === 255 && (224 & c[d + 1]) == 224 && (6 & c[d + 1]) != 0;
        }, isHeader: function(c, d) {
          return !!(d + 1 < c.length && this.isHeaderPattern(c, d));
        }, probe: function(c, d) {
          if (d + 1 < c.length && this.isHeaderPattern(c, d)) {
            var f = this.parseHeader(c, d), m = 4;
            f && f.frameLength && (m = f.frameLength);
            var p = d + m;
            if (p === c.length || p + 1 < c.length && this.isHeaderPattern(c, p))
              return !0;
          }
          return !1;
        } };
        l.default = h;
      }, "./src/demux/sample-aes.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./src/crypt/decrypter.js"), c = (d.prototype.decryptBuffer = function(f, m) {
          this.decrypter.decrypt(f, this.decryptdata.key.buffer, this.decryptdata.iv.buffer, m);
        }, d.prototype.decryptAacSample = function(f, m, p, b) {
          var y = f[m].unit, v = y.subarray(16, y.length - y.length % 16), g = v.buffer.slice(v.byteOffset, v.byteOffset + v.length), E = this;
          this.decryptBuffer(g, function(x) {
            x = new Uint8Array(x), y.set(x, 16), b || E.decryptAacSamples(f, m + 1, p);
          });
        }, d.prototype.decryptAacSamples = function(f, m, p) {
          for (; ; m++) {
            if (m >= f.length)
              return void p();
            if (!(f[m].unit.length < 32)) {
              var b = this.decrypter.isSync();
              if (this.decryptAacSample(f, m, p, b), !b)
                return;
            }
          }
        }, d.prototype.getAvcEncryptedData = function(f) {
          for (var m = 16 * Math.floor((f.length - 48) / 160) + 16, p = new Int8Array(m), b = 0, y = 32; y <= f.length - 16; y += 160, b += 16)
            p.set(f.subarray(y, y + 16), b);
          return p;
        }, d.prototype.getAvcDecryptedUnit = function(f, m) {
          m = new Uint8Array(m);
          for (var p = 0, b = 32; b <= f.length - 16; b += 160, p += 16)
            f.set(m.subarray(p, p + 16), b);
          return f;
        }, d.prototype.decryptAvcSample = function(f, m, p, b, y, v) {
          var g = this.discardEPB(y.data), E = this.getAvcEncryptedData(g), x = this;
          this.decryptBuffer(E.buffer, function(w) {
            y.data = x.getAvcDecryptedUnit(g, w), v || x.decryptAvcSamples(f, m, p + 1, b);
          });
        }, d.prototype.decryptAvcSamples = function(f, m, p, b) {
          for (; ; m++, p = 0) {
            if (m >= f.length)
              return void b();
            for (var y = f[m].units; !(p >= y.length); p++) {
              var v = y[p];
              if (!(v.length <= 48 || v.type !== 1 && v.type !== 5)) {
                var g = this.decrypter.isSync();
                if (this.decryptAvcSample(f, m, p, b, v, g), !g)
                  return;
              }
            }
          }
        }, d);
        function d(f, m, p, b) {
          this.decryptdata = p, this.discardEPB = b, this.decrypter = new h.default(f, m, { removePKCS7Padding: !1 });
        }
        l.default = c;
      }, "./src/demux/tsdemuxer.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./src/demux/adts.js"), c = u("./src/demux/mpegaudio.js"), d = u("./src/events.js"), f = u("./src/demux/exp-golomb.js"), m = u("./src/demux/sample-aes.js"), p = u("./src/utils/logger.js"), b = u("./src/errors.js"), y = { video: 1, audio: 2, id3: 3, text: 4 }, v = (g.prototype.setDecryptData = function(E) {
          E != null && E.key != null && E.method === "SAMPLE-AES" ? this.sampleAes = new m.default(this.observer, this.config, E, this.discardEPB) : this.sampleAes = null;
        }, g.probe = function(E) {
          var x = g._syncOffset(E);
          return !(x < 0 || (x && p.logger.warn("MPEG2-TS detected but first sync word found @ offset " + x + ", junk ahead ?"), 0));
        }, g._syncOffset = function(E) {
          for (var x = Math.min(1e3, E.length - 564), w = 0; w < x; ) {
            if (E[w] === 71 && E[w + 188] === 71 && E[w + 376] === 71)
              return w;
            w++;
          }
          return -1;
        }, g.createTrack = function(E, x) {
          return { container: E === "video" || E === "audio" ? "video/mp2t" : void 0, type: E, id: y[E], pid: -1, inputTimeScale: 9e4, sequenceNumber: 0, samples: [], len: 0, dropped: E === "video" ? 0 : void 0, isAAC: E === "audio" || void 0, duration: E === "audio" ? x : void 0 };
        }, g.prototype.resetInitSegment = function(E, x, w, S) {
          this.pmtParsed = !1, this._pmtId = -1, this._avcTrack = g.createTrack("video", S), this._audioTrack = g.createTrack("audio", S), this._id3Track = g.createTrack("id3", S), this._txtTrack = g.createTrack("text", S), this.aacOverFlow = null, this.aacLastPTS = null, this.avcSample = null, this.audioCodec = x, this.videoCodec = w, this._duration = S;
        }, g.prototype.resetTimeStamp = function() {
        }, g.prototype.append = function(E, x, w, S) {
          var T, C, D, R, P, N = E.length, $ = !1;
          this.contiguous = w;
          var O = this.pmtParsed, M = this._avcTrack, F = this._audioTrack, G = this._id3Track, K = M.pid, J = F.pid, ue = G.pid, ce = this._pmtId, ee = M.pesData, me = F.pesData, Ce = G.pesData, Ne = this._parsePAT, ot = this._parsePMT, ze = this._parsePES, $e = this._parseAVCPES.bind(this), Ze = this._parseAACPES.bind(this), Ut = this._parseMPEGPES.bind(this), qt = this._parseID3PES.bind(this), ir = g._syncOffset(E);
          for (N -= (N + ir) % 188, T = ir; T < N; T += 188)
            if (E[T] === 71) {
              if (C = !!(64 & E[T + 1]), D = ((31 & E[T + 1]) << 8) + E[T + 2], 1 < (48 & E[T + 3]) >> 4) {
                if ((R = T + 5 + E[T + 4]) === T + 188)
                  continue;
              } else
                R = T + 4;
              switch (D) {
                case K:
                  C && (ee && (P = ze(ee)) && P.pts !== void 0 && $e(P, !1), ee = { data: [], size: 0 }), ee && (ee.data.push(E.subarray(R, T + 188)), ee.size += T + 188 - R);
                  break;
                case J:
                  C && (me && (P = ze(me)) && P.pts !== void 0 && (F.isAAC ? Ze(P) : Ut(P)), me = { data: [], size: 0 }), me && (me.data.push(E.subarray(R, T + 188)), me.size += T + 188 - R);
                  break;
                case ue:
                  C && (Ce && (P = ze(Ce)) && P.pts !== void 0 && qt(P), Ce = { data: [], size: 0 }), Ce && (Ce.data.push(E.subarray(R, T + 188)), Ce.size += T + 188 - R);
                  break;
                case 0:
                  C && (R += E[R] + 1), ce = this._pmtId = Ne(E, R);
                  break;
                case ce:
                  C && (R += E[R] + 1);
                  var We = ot(E, R, this.typeSupported.mpeg === !0 || this.typeSupported.mp3 === !0, this.sampleAes != null);
                  0 < (K = We.avc) && (M.pid = K), 0 < (J = We.audio) && (F.pid = J, F.isAAC = We.isAAC), 0 < (ue = We.id3) && (G.pid = ue), $ && !O && (p.logger.log("reparse from beginning"), $ = !1, T = ir - 188), O = this.pmtParsed = !0;
                  break;
                case 17:
                case 8191:
                  break;
                default:
                  $ = !0;
              }
            } else
              this.observer.trigger(d.default.ERROR, { type: b.ErrorTypes.MEDIA_ERROR, details: b.ErrorDetails.FRAG_PARSING_ERROR, fatal: !1, reason: "TS packet did not start with 0x47" });
          ee && (P = ze(ee)) && P.pts !== void 0 ? ($e(P, !0), M.pesData = null) : M.pesData = ee, me && (P = ze(me)) && P.pts !== void 0 ? (F.isAAC ? Ze(P) : Ut(P), F.pesData = null) : (me && me.size && p.logger.log("last AAC PES packet truncated,might overlap between fragments"), F.pesData = me), Ce && (P = ze(Ce)) && P.pts !== void 0 ? (qt(P), G.pesData = null) : G.pesData = Ce, this.sampleAes == null ? this.remuxer.remux(F, M, G, this._txtTrack, x, w, S) : this.decryptAndRemux(F, M, G, this._txtTrack, x, w, S);
        }, g.prototype.decryptAndRemux = function(E, x, w, S, T, C, D) {
          if (E.samples && E.isAAC) {
            var R = this;
            this.sampleAes.decryptAacSamples(E.samples, 0, function() {
              R.decryptAndRemuxAvc(E, x, w, S, T, C, D);
            });
          } else
            this.decryptAndRemuxAvc(E, x, w, S, T, C, D);
        }, g.prototype.decryptAndRemuxAvc = function(E, x, w, S, T, C, D) {
          if (x.samples) {
            var R = this;
            this.sampleAes.decryptAvcSamples(x.samples, 0, 0, function() {
              R.remuxer.remux(E, x, w, S, T, C, D);
            });
          } else
            this.remuxer.remux(E, x, w, S, T, C, D);
        }, g.prototype.destroy = function() {
          this._initPTS = this._initDTS = void 0, this._duration = 0;
        }, g.prototype._parsePAT = function(E, x) {
          return (31 & E[x + 10]) << 8 | E[x + 11];
        }, g.prototype._parsePMT = function(E, x, w, S) {
          var T, C, D = { audio: -1, avc: -1, id3: -1, isAAC: !0 };
          for (T = x + 3 + ((15 & E[x + 1]) << 8 | E[x + 2]) - 4, x += 12 + ((15 & E[x + 10]) << 8 | E[x + 11]); x < T; ) {
            switch (C = (31 & E[x + 1]) << 8 | E[x + 2], E[x]) {
              case 207:
                if (!S) {
                  p.logger.log("unkown stream type:" + E[x]);
                  break;
                }
              case 15:
                D.audio === -1 && (D.audio = C);
                break;
              case 21:
                D.id3 === -1 && (D.id3 = C);
                break;
              case 219:
                if (!S) {
                  p.logger.log("unkown stream type:" + E[x]);
                  break;
                }
              case 27:
                D.avc === -1 && (D.avc = C);
                break;
              case 3:
              case 4:
                w ? D.audio === -1 && (D.audio = C, D.isAAC = !1) : p.logger.log("MPEG audio found, not supported in this browser for now");
                break;
              case 36:
                p.logger.warn("HEVC stream type found, not supported for now");
                break;
              default:
                p.logger.log("unkown stream type:" + E[x]);
            }
            x += 5 + ((15 & E[x + 3]) << 8 | E[x + 4]);
          }
          return D;
        }, g.prototype._parsePES = function(E) {
          var x, w, S, T, C, D, R, P, N = 0, $ = E.data;
          if (!E || E.size === 0)
            return null;
          for (; $[0].length < 19 && 1 < $.length; ) {
            var O = new Uint8Array($[0].length + $[1].length);
            O.set($[0]), O.set($[1], $[0].length), $[0] = O, $.splice(1, 1);
          }
          if (((x = $[0])[0] << 16) + (x[1] << 8) + x[2] !== 1 || (S = (x[4] << 8) + x[5]) && S > E.size - 6)
            return null;
          192 & (w = x[7]) && (4294967295 < (D = 536870912 * (14 & x[9]) + 4194304 * (255 & x[10]) + 16384 * (254 & x[11]) + 128 * (255 & x[12]) + (254 & x[13]) / 2) && (D -= 8589934592), 64 & w ? (4294967295 < (R = 536870912 * (14 & x[14]) + 4194304 * (255 & x[15]) + 16384 * (254 & x[16]) + 128 * (255 & x[17]) + (254 & x[18]) / 2) && (R -= 8589934592), 54e5 < D - R && (p.logger.warn(Math.round((D - R) / 9e4) + "s delta between PTS and DTS, align them"), D = R)) : R = D), P = (T = x[8]) + 9, E.size -= P, C = new Uint8Array(E.size);
          for (var M = 0, F = $.length; M < F; M++) {
            var G = (x = $[M]).byteLength;
            if (P) {
              if (G < P) {
                P -= G;
                continue;
              }
              x = x.subarray(P), G -= P, P = 0;
            }
            C.set(x, N), N += G;
          }
          return S && (S -= T + 3), { data: C, pts: D, dts: R, len: S };
        }, g.prototype.pushAccesUnit = function(E, x) {
          if (E.units.length && E.frame) {
            var w = x.samples, S = w.length;
            !this.config.forceKeyFrameOnDiscontinuity || E.key === !0 || x.sps && (S || this.contiguous) ? (E.id = S, w.push(E)) : x.dropped++;
          }
          E.debug.length && p.logger.log(E.pts + "/" + E.dts + ":" + E.debug);
        }, g.prototype._parseAVCPES = function(E, x) {
          function w(M, F, G, K) {
            return { key: M, pts: F, dts: G, units: [], debug: K };
          }
          var S, T, C, D = this, R = this._avcTrack, P = this._parseAVCNALu(E.data), N = this.avcSample, $ = !1, O = this.pushAccesUnit.bind(this);
          E.data = null, N && P.length && !R.audFound && (O(N, R), N = this.avcSample = w(!1, E.pts, E.dts, "")), P.forEach(function(M) {
            switch (M.type) {
              case 1:
                T = !0, (N = N || (D.avcSample = w(!0, E.pts, E.dts, ""))).frame = !0;
                var F = M.data;
                if ($ && 4 < F.length) {
                  var G = new f.default(F).readSliceType();
                  G !== 2 && G !== 4 && G !== 7 && G !== 9 || (N.key = !0);
                }
                break;
              case 5:
                T = !0, (N = N || (D.avcSample = w(!0, E.pts, E.dts, ""))).key = !0, N.frame = !0;
                break;
              case 6:
                T = !0, (S = new f.default(D.discardEPB(M.data))).readUByte();
                for (var K = 0, J = 0, ue = !1, ce = 0; !ue && 1 < S.bytesAvailable; ) {
                  for (K = 0; K += ce = S.readUByte(), ce === 255; )
                    ;
                  for (J = 0; J += ce = S.readUByte(), ce === 255; )
                    ;
                  if (K === 4 && S.bytesAvailable !== 0) {
                    if (ue = !0, S.readUByte() === 181 && S.readUShort() === 49 && S.readUInt() === 1195456820 && S.readUByte() === 3) {
                      var ee = S.readUByte(), me = 31 & ee, Ce = [ee, S.readUByte()];
                      for (C = 0; C < me; C++)
                        Ce.push(S.readUByte()), Ce.push(S.readUByte()), Ce.push(S.readUByte());
                      D._insertSampleInOrder(D._txtTrack.samples, { type: 3, pts: E.pts, bytes: Ce });
                    }
                  } else if (J < S.bytesAvailable)
                    for (C = 0; C < J; C++)
                      S.readUByte();
                }
                break;
              case 7:
                if ($ = T = !0, !R.sps) {
                  var Ne = (S = new f.default(M.data)).readSPS();
                  R.width = Ne.width, R.height = Ne.height, R.pixelRatio = Ne.pixelRatio, R.sps = [M.data], R.duration = D._duration;
                  var ot = M.data.subarray(1, 4), ze = "avc1.";
                  for (C = 0; C < 3; C++) {
                    var $e = ot[C].toString(16);
                    $e.length < 2 && ($e = "0" + $e), ze += $e;
                  }
                  R.codec = ze;
                }
                break;
              case 8:
                T = !0, R.pps || (R.pps = [M.data]);
                break;
              case 9:
                T = !1, R.audFound = !0, N && O(N, R), N = D.avcSample = w(!1, E.pts, E.dts, "");
                break;
              case 12:
                T = !1;
                break;
              default:
                T = !1, N && (N.debug += "unknown NAL " + M.type + " ");
            }
            N && T && N.units.push(M);
          }), x && N && (O(N, R), this.avcSample = null);
        }, g.prototype._insertSampleInOrder = function(E, x) {
          var w = E.length;
          if (0 < w) {
            if (x.pts >= E[w - 1].pts)
              E.push(x);
            else
              for (var S = w - 1; 0 <= S; S--)
                if (x.pts < E[S].pts) {
                  E.splice(S, 0, x);
                  break;
                }
          } else
            E.push(x);
        }, g.prototype._getLastNalUnit = function() {
          var E, x = this.avcSample;
          if (!x || x.units.length === 0) {
            var w = this._avcTrack.samples;
            x = w[w.length - 1];
          }
          if (x) {
            var S = x.units;
            E = S[S.length - 1];
          }
          return E;
        }, g.prototype._parseAVCNALu = function(E) {
          var x, w, S, T, C = 0, D = E.byteLength, R = this._avcTrack, P = R.naluState || 0, N = P, $ = [], O = -1;
          for (P === -1 && (T = 31 & E[O = 0], P = 0, C = 1); C < D; )
            if (x = E[C++], P)
              if (P !== 1)
                if (x)
                  if (x === 1) {
                    var M, F;
                    0 <= O ? (S = { data: E.subarray(O, C - P - 1), type: T }, $.push(S)) : (M = this._getLastNalUnit()) && (N && C <= 4 - N && M.state && (M.data = M.data.subarray(0, M.data.byteLength - N)), 0 < (w = C - P - 1) && ((F = new Uint8Array(M.data.byteLength + w)).set(M.data, 0), F.set(E.subarray(0, w), M.data.byteLength), M.data = F)), P = C < D ? (T = 31 & E[O = C], 0) : -1;
                  } else
                    P = 0;
                else
                  P = 3;
              else
                P = x ? 0 : 2;
            else
              P = x ? 0 : 1;
          return 0 <= O && 0 <= P && (S = { data: E.subarray(O, D), type: T, state: P }, $.push(S)), $.length !== 0 || (M = this._getLastNalUnit()) && ((F = new Uint8Array(M.data.byteLength + E.byteLength)).set(M.data, 0), F.set(E, M.data.byteLength), M.data = F), R.naluState = P, $;
        }, g.prototype.discardEPB = function(E) {
          for (var x, w, S = E.byteLength, T = [], C = 1; C < S - 2; )
            E[C] === 0 && E[C + 1] === 0 && E[C + 2] === 3 ? (T.push(C + 2), C += 2) : C++;
          if (T.length === 0)
            return E;
          x = S - T.length, w = new Uint8Array(x);
          var D = 0;
          for (C = 0; C < x; D++, C++)
            D === T[0] && (D++, T.shift()), w[C] = E[D];
          return w;
        }, g.prototype._parseAACPES = function(E) {
          var x, w, S, T, C, D = this._audioTrack, R = E.data, P = E.pts, N = this.aacOverFlow, $ = this.aacLastPTS;
          if (N) {
            var O = new Uint8Array(N.byteLength + R.byteLength);
            O.set(N, 0), O.set(R, N.byteLength), R = O;
          }
          for (S = 0, C = R.length; S < C - 1 && !h.isHeader(R, S); S++)
            ;
          if (S) {
            var M = void 0, F = void 0;
            if (F = S < C - 1 ? (M = "AAC PES did not start with ADTS header,offset:" + S, !1) : (M = "no ADTS header found in AAC PES", !0), p.logger.warn("parsing error:" + M), this.observer.trigger(d.default.ERROR, { type: b.ErrorTypes.MEDIA_ERROR, details: b.ErrorDetails.FRAG_PARSING_ERROR, fatal: F, reason: M }), F)
              return;
          }
          if (h.initTrackConfig(D, this.observer, R, S, this.audioCodec), w = 0, x = h.getFrameDuration(D.samplerate), N && $) {
            var G = $ + x;
            1 < Math.abs(G - P) && (p.logger.log("AAC: align PTS for overlapping frames by " + Math.round((G - P) / 90)), P = G);
          }
          for (; S < C; )
            if (h.isHeader(R, S) && S + 5 < C) {
              var K = h.appendFrame(D, R, S, P, w);
              if (!K)
                break;
              S += K.length, T = K.sample.pts, w++;
            } else
              S++;
          N = S < C ? R.subarray(S, C) : null, this.aacOverFlow = N, this.aacLastPTS = T;
        }, g.prototype._parseMPEGPES = function(E) {
          for (var x = E.data, w = x.length, S = 0, T = 0, C = E.pts; T < w; )
            if (c.default.isHeader(x, T)) {
              var D = c.default.appendFrame(this._audioTrack, x, T, C, S);
              if (!D)
                break;
              T += D.length, S++;
            } else
              T++;
        }, g.prototype._parseID3PES = function(E) {
          this._id3Track.samples.push(E);
        }, g);
        function g(E, x, w, S) {
          this.observer = E, this.config = w, this.typeSupported = S, this.remuxer = x, this.sampleAes = null;
        }
        l.default = v;
      }, "./src/errors.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 }), l.ErrorTypes = { NETWORK_ERROR: "networkError", MEDIA_ERROR: "mediaError", KEY_SYSTEM_ERROR: "keySystemError", MUX_ERROR: "muxError", OTHER_ERROR: "otherError" }, l.ErrorDetails = { KEY_SYSTEM_NO_KEYS: "keySystemNoKeys", KEY_SYSTEM_NO_ACCESS: "keySystemNoAccess", KEY_SYSTEM_NO_SESSION: "keySystemNoSession", KEY_SYSTEM_LICENSE_REQUEST_FAILED: "keySystemLicenseRequestFailed", MANIFEST_LOAD_ERROR: "manifestLoadError", MANIFEST_LOAD_TIMEOUT: "manifestLoadTimeOut", MANIFEST_PARSING_ERROR: "manifestParsingError", MANIFEST_INCOMPATIBLE_CODECS_ERROR: "manifestIncompatibleCodecsError", LEVEL_LOAD_ERROR: "levelLoadError", LEVEL_LOAD_TIMEOUT: "levelLoadTimeOut", LEVEL_SWITCH_ERROR: "levelSwitchError", AUDIO_TRACK_LOAD_ERROR: "audioTrackLoadError", AUDIO_TRACK_LOAD_TIMEOUT: "audioTrackLoadTimeOut", FRAG_LOAD_ERROR: "fragLoadError", FRAG_LOAD_TIMEOUT: "fragLoadTimeOut", FRAG_DECRYPT_ERROR: "fragDecryptError", FRAG_PARSING_ERROR: "fragParsingError", REMUX_ALLOC_ERROR: "remuxAllocError", KEY_LOAD_ERROR: "keyLoadError", KEY_LOAD_TIMEOUT: "keyLoadTimeOut", BUFFER_ADD_CODEC_ERROR: "bufferAddCodecError", BUFFER_APPEND_ERROR: "bufferAppendError", BUFFER_APPENDING_ERROR: "bufferAppendingError", BUFFER_STALLED_ERROR: "bufferStalledError", BUFFER_FULL_ERROR: "bufferFullError", BUFFER_SEEK_OVER_HOLE: "bufferSeekOverHole", BUFFER_NUDGE_ON_STALL: "bufferNudgeOnStall", INTERNAL_EXCEPTION: "internalException" };
      }, "./src/event-handler.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./src/utils/logger.js"), c = u("./src/errors.js"), d = u("./src/events.js"), f = { hlsEventGeneric: !0, hlsHandlerDestroying: !0, hlsHandlerDestroyed: !0 }, m = (p.prototype.destroy = function() {
          this.onHandlerDestroying(), this.unregisterListeners(), this.onHandlerDestroyed();
        }, p.prototype.onHandlerDestroying = function() {
        }, p.prototype.onHandlerDestroyed = function() {
        }, p.prototype.isEventHandler = function() {
          return typeof this.handledEvents == "object" && this.handledEvents.length && typeof this.onEvent == "function";
        }, p.prototype.registerListeners = function() {
          this.isEventHandler() && this.handledEvents.forEach(function(b) {
            if (f[b])
              throw new Error("Forbidden event-name: " + b);
            this.hls.on(b, this.onEvent);
          }, this);
        }, p.prototype.unregisterListeners = function() {
          this.isEventHandler() && this.handledEvents.forEach(function(b) {
            this.hls.off(b, this.onEvent);
          }, this);
        }, p.prototype.onEvent = function(b, y) {
          this.onEventGeneric(b, y);
        }, p.prototype.onEventGeneric = function(b, y) {
          try {
            (function(v, g) {
              var E = "on" + v.replace("hls", "");
              if (typeof this[E] != "function")
                throw new Error("Event " + v + " has no generic handler in this " + this.constructor.name + " class (tried " + E + ")");
              return this[E].bind(this, g);
            }).call(this, b, y).call();
          } catch (v) {
            h.logger.error("An internal error happened while handling event " + b + '. Error message: "' + v.message + '". Here is a stacktrace:', v), this.hls.trigger(d.default.ERROR, { type: c.ErrorTypes.OTHER_ERROR, details: c.ErrorDetails.INTERNAL_EXCEPTION, fatal: !1, event: b, err: v });
          }
        }, p);
        function p(b) {
          for (var y = [], v = 1; v < arguments.length; v++)
            y[v - 1] = arguments[v];
          this.hls = b, this.onEvent = this.onEvent.bind(this), this.handledEvents = y, this.useGenericHandler = !0, this.registerListeners();
        }
        l.default = m;
      }, "./src/events.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 }), l.default = { MEDIA_ATTACHING: "hlsMediaAttaching", MEDIA_ATTACHED: "hlsMediaAttached", MEDIA_DETACHING: "hlsMediaDetaching", MEDIA_DETACHED: "hlsMediaDetached", BUFFER_RESET: "hlsBufferReset", BUFFER_CODECS: "hlsBufferCodecs", BUFFER_CREATED: "hlsBufferCreated", BUFFER_APPENDING: "hlsBufferAppending", BUFFER_APPENDED: "hlsBufferAppended", BUFFER_EOS: "hlsBufferEos", BUFFER_FLUSHING: "hlsBufferFlushing", BUFFER_FLUSHED: "hlsBufferFlushed", MANIFEST_LOADING: "hlsManifestLoading", MANIFEST_LOADED: "hlsManifestLoaded", MANIFEST_PARSED: "hlsManifestParsed", LEVEL_SWITCHING: "hlsLevelSwitching", LEVEL_SWITCHED: "hlsLevelSwitched", LEVEL_LOADING: "hlsLevelLoading", LEVEL_LOADED: "hlsLevelLoaded", LEVEL_UPDATED: "hlsLevelUpdated", LEVEL_PTS_UPDATED: "hlsLevelPtsUpdated", AUDIO_TRACKS_UPDATED: "hlsAudioTracksUpdated", AUDIO_TRACK_SWITCHING: "hlsAudioTrackSwitching", AUDIO_TRACK_SWITCHED: "hlsAudioTrackSwitched", AUDIO_TRACK_LOADING: "hlsAudioTrackLoading", AUDIO_TRACK_LOADED: "hlsAudioTrackLoaded", SUBTITLE_TRACKS_UPDATED: "hlsSubtitleTracksUpdated", SUBTITLE_TRACK_SWITCH: "hlsSubtitleTrackSwitch", SUBTITLE_TRACK_LOADING: "hlsSubtitleTrackLoading", SUBTITLE_TRACK_LOADED: "hlsSubtitleTrackLoaded", SUBTITLE_FRAG_PROCESSED: "hlsSubtitleFragProcessed", INIT_PTS_FOUND: "hlsInitPtsFound", FRAG_LOADING: "hlsFragLoading", FRAG_LOAD_PROGRESS: "hlsFragLoadProgress", FRAG_LOAD_EMERGENCY_ABORTED: "hlsFragLoadEmergencyAborted", FRAG_LOADED: "hlsFragLoaded", FRAG_DECRYPTED: "hlsFragDecrypted", FRAG_PARSING_INIT_SEGMENT: "hlsFragParsingInitSegment", FRAG_PARSING_USERDATA: "hlsFragParsingUserdata", FRAG_PARSING_METADATA: "hlsFragParsingMetadata", FRAG_PARSING_DATA: "hlsFragParsingData", FRAG_PARSED: "hlsFragParsed", FRAG_BUFFERED: "hlsFragBuffered", FRAG_CHANGED: "hlsFragChanged", FPS_DROP: "hlsFpsDrop", FPS_DROP_LEVEL_CAPPING: "hlsFpsDropLevelCapping", ERROR: "hlsError", DESTROYING: "hlsDestroying", KEY_LOADING: "hlsKeyLoading", KEY_LOADED: "hlsKeyLoaded", STREAM_STATE_TRANSITION: "hlsStreamStateTransition" };
      }, "./src/hls.js": function(o, l, u) {
        var h, c = this && this.__extends || (h = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(N, $) {
          N.__proto__ = $;
        } || function(N, $) {
          for (var O in $)
            $.hasOwnProperty(O) && (N[O] = $[O]);
        }, function(N, $) {
          function O() {
            this.constructor = N;
          }
          h(N, $), N.prototype = $ === null ? Object.create($) : (O.prototype = $.prototype, new O());
        });
        Object.defineProperty(l, "__esModule", { value: !0 });
        var d, f = u("./node_modules/url-toolkit/src/url-toolkit.js"), m = u("./src/errors.js"), p = u("./src/loader/playlist-loader.js"), b = u("./src/loader/fragment-loader.js"), y = u("./src/loader/key-loader.js"), v = u("./src/controller/fragment-tracker.js"), g = u("./src/controller/stream-controller.js"), E = u("./src/controller/level-controller.js"), x = u("./src/controller/id3-track-controller.js"), w = u("./src/is-supported.js"), S = u("./src/utils/logger.js"), T = u("./src/config.js"), C = u("./src/events.js"), D = u("./src/observer.js"), R = (d = D.Observer, c(P, d), Object.defineProperty(P, "version", { get: function() {
          return "0.12.4";
        }, enumerable: !0, configurable: !0 }), P.isSupported = function() {
          return w.isSupported();
        }, Object.defineProperty(P, "Events", { get: function() {
          return C.default;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P, "ErrorTypes", { get: function() {
          return m.ErrorTypes;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P, "ErrorDetails", { get: function() {
          return m.ErrorDetails;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P, "DefaultConfig", { get: function() {
          return P.defaultConfig ? P.defaultConfig : T.hlsDefaultConfig;
        }, set: function(N) {
          P.defaultConfig = N;
        }, enumerable: !0, configurable: !0 }), P.prototype.destroy = function() {
          S.logger.log("destroy"), this.trigger(C.default.DESTROYING), this.detachMedia(), this.coreComponents.concat(this.networkControllers).forEach(function(N) {
            N.destroy();
          }), this.url = null, this.removeAllListeners(), this._autoLevelCapping = -1;
        }, P.prototype.attachMedia = function(N) {
          S.logger.log("attachMedia"), this.media = N, this.trigger(C.default.MEDIA_ATTACHING, { media: N });
        }, P.prototype.detachMedia = function() {
          S.logger.log("detachMedia"), this.trigger(C.default.MEDIA_DETACHING), this.media = null;
        }, P.prototype.loadSource = function(N) {
          N = f.buildAbsoluteURL(window.location.href, N, { alwaysNormalize: !0 }), S.logger.log("loadSource:" + N), this.url = N, this.trigger(C.default.MANIFEST_LOADING, { url: N });
        }, P.prototype.startLoad = function(N) {
          N === void 0 && (N = -1), S.logger.log("startLoad(" + N + ")"), this.networkControllers.forEach(function($) {
            $.startLoad(N);
          });
        }, P.prototype.stopLoad = function() {
          S.logger.log("stopLoad"), this.networkControllers.forEach(function(N) {
            N.stopLoad();
          });
        }, P.prototype.swapAudioCodec = function() {
          S.logger.log("swapAudioCodec"), this.streamController.swapAudioCodec();
        }, P.prototype.recoverMediaError = function() {
          S.logger.log("recoverMediaError");
          var N = this.media;
          this.detachMedia(), this.attachMedia(N);
        }, Object.defineProperty(P.prototype, "levels", { get: function() {
          return this.levelController.levels;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P.prototype, "currentLevel", { get: function() {
          return this.streamController.currentLevel;
        }, set: function(N) {
          S.logger.log("set currentLevel:" + N), this.loadLevel = N, this.streamController.immediateLevelSwitch();
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P.prototype, "nextLevel", { get: function() {
          return this.streamController.nextLevel;
        }, set: function(N) {
          S.logger.log("set nextLevel:" + N), this.levelController.manualLevel = N, this.streamController.nextLevelSwitch();
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P.prototype, "loadLevel", { get: function() {
          return this.levelController.level;
        }, set: function(N) {
          S.logger.log("set loadLevel:" + N), this.levelController.manualLevel = N;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P.prototype, "nextLoadLevel", { get: function() {
          return this.levelController.nextLoadLevel;
        }, set: function(N) {
          this.levelController.nextLoadLevel = N;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P.prototype, "firstLevel", { get: function() {
          return Math.max(this.levelController.firstLevel, this.minAutoLevel);
        }, set: function(N) {
          S.logger.log("set firstLevel:" + N), this.levelController.firstLevel = N;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P.prototype, "startLevel", { get: function() {
          return this.levelController.startLevel;
        }, set: function(N) {
          S.logger.log("set startLevel:" + N), N !== -1 && (N = Math.max(N, this.minAutoLevel)), this.levelController.startLevel = N;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P.prototype, "autoLevelCapping", { get: function() {
          return this._autoLevelCapping;
        }, set: function(N) {
          S.logger.log("set autoLevelCapping:" + N), this._autoLevelCapping = N;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P.prototype, "autoLevelEnabled", { get: function() {
          return this.levelController.manualLevel === -1;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P.prototype, "manualLevel", { get: function() {
          return this.levelController.manualLevel;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P.prototype, "minAutoLevel", { get: function() {
          for (var N = this.levels, $ = this.config.minAutoBitrate, O = N ? N.length : 0, M = 0; M < O; M++)
            if ($ < (N[M].realBitrate ? Math.max(N[M].realBitrate, N[M].bitrate) : N[M].bitrate))
              return M;
          return 0;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P.prototype, "maxAutoLevel", { get: function() {
          var N = this.levels, $ = this.autoLevelCapping;
          return $ === -1 && N && N.length ? N.length - 1 : $;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P.prototype, "nextAutoLevel", { get: function() {
          return Math.min(Math.max(this.abrController.nextAutoLevel, this.minAutoLevel), this.maxAutoLevel);
        }, set: function(N) {
          this.abrController.nextAutoLevel = Math.max(this.minAutoLevel, N);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P.prototype, "audioTracks", { get: function() {
          var N = this.audioTrackController;
          return N ? N.audioTracks : [];
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P.prototype, "audioTrack", { get: function() {
          var N = this.audioTrackController;
          return N ? N.audioTrack : -1;
        }, set: function(N) {
          var $ = this.audioTrackController;
          $ && ($.audioTrack = N);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P.prototype, "liveSyncPosition", { get: function() {
          return this.streamController.liveSyncPosition;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P.prototype, "subtitleTracks", { get: function() {
          var N = this.subtitleTrackController;
          return N ? N.subtitleTracks : [];
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P.prototype, "subtitleTrack", { get: function() {
          var N = this.subtitleTrackController;
          return N ? N.subtitleTrack : -1;
        }, set: function(N) {
          var $ = this.subtitleTrackController;
          $ && ($.subtitleTrack = N);
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(P.prototype, "subtitleDisplay", { get: function() {
          var N = this.subtitleTrackController;
          return !!N && N.subtitleDisplay;
        }, set: function(N) {
          var $ = this.subtitleTrackController;
          $ && ($.subtitleDisplay = N);
        }, enumerable: !0, configurable: !0 }), P);
        function P(N) {
          N === void 0 && (N = {});
          var $ = d.call(this) || this, O = P.DefaultConfig;
          if ((N.liveSyncDurationCount || N.liveMaxLatencyDurationCount) && (N.liveSyncDuration || N.liveMaxLatencyDuration))
            throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
          for (var M in O)
            M in N || (N[M] = O[M]);
          if (N.liveMaxLatencyDurationCount !== void 0 && N.liveMaxLatencyDurationCount <= N.liveSyncDurationCount)
            throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be gt "liveSyncDurationCount"');
          if (N.liveMaxLatencyDuration !== void 0 && (N.liveMaxLatencyDuration <= N.liveSyncDuration || N.liveSyncDuration === void 0))
            throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be gt "liveSyncDuration"');
          S.enableLogs(N.debug), $.config = N, $._autoLevelCapping = -1;
          var F = $.abrController = new N.abrController($), G = new N.bufferController($), K = new N.capLevelController($), J = new N.fpsController($), ue = new p.default($), ce = new b.default($), ee = new y.default($), me = new x.default($), Ce = $.levelController = new E.default($), Ne = new v.FragmentTracker($), ot = [Ce, $.streamController = new g.default($, Ne)], ze = N.audioStreamController;
          ze && ot.push(new ze($, Ne)), $.networkControllers = ot;
          var $e = [ue, ce, ee, F, G, K, J, me, Ne];
          if (ze = N.audioTrackController) {
            var Ze = new ze($);
            $.audioTrackController = Ze, $e.push(Ze);
          }
          if (ze = N.subtitleTrackController) {
            var Ut = new ze($);
            $.subtitleTrackController = Ut, ot.push(Ut);
          }
          if (ze = N.emeController) {
            var qt = new ze($);
            $.emeController = qt, $e.push(qt);
          }
          return (ze = N.subtitleStreamController) && ot.push(new ze($, Ne)), (ze = N.timelineController) && $e.push(new ze($)), $.coreComponents = $e, $;
        }
        l.default = R;
      }, "./src/is-supported.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./src/utils/mediasource-helper.js");
        l.isSupported = function() {
          var c = h.getMediaSource(), d = window.SourceBuffer || window.WebKitSourceBuffer, f = c && typeof c.isTypeSupported == "function" && c.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), m = !d || d.prototype && typeof d.prototype.appendBuffer == "function" && typeof d.prototype.remove == "function";
          return !!f && !!m;
        };
      }, "./src/loader/fragment-loader.js": function(o, l, u) {
        (function(h) {
          var c, d = this && this.__extends || (c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(E, x) {
            E.__proto__ = x;
          } || function(E, x) {
            for (var w in x)
              x.hasOwnProperty(w) && (E[w] = x[w]);
          }, function(E, x) {
            function w() {
              this.constructor = E;
            }
            c(E, x), E.prototype = x === null ? Object.create(x) : (w.prototype = x.prototype, new w());
          });
          Object.defineProperty(l, "__esModule", { value: !0 });
          var f, m = u("./src/events.js"), p = u("./src/event-handler.js"), b = u("./src/errors.js"), y = u("./src/utils/logger.js"), v = (f = p.default, d(g, f), g.prototype.destroy = function() {
            var E = this.loaders;
            for (var x in E) {
              var w = E[x];
              w && w.destroy();
            }
            this.loaders = {}, f.prototype.destroy.call(this);
          }, g.prototype.onFragLoading = function(E) {
            var x = E.frag, w = x.type, S = this.loaders, T = this.hls.config, C = T.fLoader, D = T.loader;
            x.loaded = 0;
            var R, P, N, $ = S[w];
            $ && (y.logger.warn("abort previous fragment loader for type: " + w), $.abort()), $ = S[w] = x.loader = T.fLoader ? new C(T) : new D(T), R = { url: x.url, frag: x, responseType: "arraybuffer", progressData: !1 };
            var O = x.byteRangeStartOffset, M = x.byteRangeEndOffset;
            h.isFinite(O) && h.isFinite(M) && (R.rangeStart = O, R.rangeEnd = M), P = { timeout: T.fragLoadingTimeOut, maxRetry: 0, retryDelay: 0, maxRetryDelay: T.fragLoadingMaxRetryTimeout }, N = { onSuccess: this.loadsuccess.bind(this), onError: this.loaderror.bind(this), onTimeout: this.loadtimeout.bind(this), onProgress: this.loadprogress.bind(this) }, $.load(R, P, N);
          }, g.prototype.loadsuccess = function(E, x, w, S) {
            S === void 0 && (S = null);
            var T = E.data, C = w.frag;
            C.loader = void 0, this.loaders[C.type] = void 0, this.hls.trigger(m.default.FRAG_LOADED, { payload: T, frag: C, stats: x, networkDetails: S });
          }, g.prototype.loaderror = function(E, x, w) {
            w === void 0 && (w = null);
            var S = x.frag, T = S.loader;
            T && T.abort(), this.loaders[S.type] = void 0, this.hls.trigger(m.default.ERROR, { type: b.ErrorTypes.NETWORK_ERROR, details: b.ErrorDetails.FRAG_LOAD_ERROR, fatal: !1, frag: x.frag, response: E, networkDetails: w });
          }, g.prototype.loadtimeout = function(E, x, w) {
            w === void 0 && (w = null);
            var S = x.frag, T = S.loader;
            T && T.abort(), this.loaders[S.type] = void 0, this.hls.trigger(m.default.ERROR, { type: b.ErrorTypes.NETWORK_ERROR, details: b.ErrorDetails.FRAG_LOAD_TIMEOUT, fatal: !1, frag: x.frag, networkDetails: w });
          }, g.prototype.loadprogress = function(E, x, w, S) {
            S === void 0 && (S = null);
            var T = x.frag;
            T.loaded = E.loaded, this.hls.trigger(m.default.FRAG_LOAD_PROGRESS, { frag: T, stats: E, networkDetails: S });
          }, g);
          function g(E) {
            var x = f.call(this, E, m.default.FRAG_LOADING) || this;
            return x.loaders = {}, x;
          }
          l.default = v;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/loader/fragment.js": function(o, l, u) {
        (function(h) {
          Object.defineProperty(l, "__esModule", { value: !0 });
          var c = u("./node_modules/url-toolkit/src/url-toolkit.js"), d = u("./src/loader/level-key.js"), f = (Object.defineProperty(m, "ElementaryStreamTypes", { get: function() {
            return { AUDIO: "audio", VIDEO: "video" };
          }, enumerable: !0, configurable: !0 }), Object.defineProperty(m.prototype, "url", { get: function() {
            return !this._url && this.relurl && (this._url = c.buildAbsoluteURL(this.baseurl, this.relurl, { alwaysNormalize: !0 })), this._url;
          }, set: function(p) {
            this._url = p;
          }, enumerable: !0, configurable: !0 }), Object.defineProperty(m.prototype, "byteRange", { get: function() {
            if (!this._byteRange && !this.rawByteRange)
              return [];
            if (this._byteRange)
              return this._byteRange;
            var p = [];
            if (this.rawByteRange) {
              var b = this.rawByteRange.split("@", 2);
              if (b.length === 1) {
                var y = this.lastByteRangeEndOffset;
                p[0] = y || 0;
              } else
                p[0] = parseInt(b[1]);
              p[1] = parseInt(b[0]) + p[0], this._byteRange = p;
            }
            return p;
          }, enumerable: !0, configurable: !0 }), Object.defineProperty(m.prototype, "byteRangeStartOffset", { get: function() {
            return this.byteRange[0];
          }, enumerable: !0, configurable: !0 }), Object.defineProperty(m.prototype, "byteRangeEndOffset", { get: function() {
            return this.byteRange[1];
          }, enumerable: !0, configurable: !0 }), Object.defineProperty(m.prototype, "decryptdata", { get: function() {
            return this._decryptdata || (this._decryptdata = this.fragmentDecryptdataFromLevelkey(this.levelkey, this.sn)), this._decryptdata;
          }, enumerable: !0, configurable: !0 }), Object.defineProperty(m.prototype, "endProgramDateTime", { get: function() {
            if (!h.isFinite(this.programDateTime))
              return null;
            var p = h.isFinite(this.duration) ? this.duration : 0;
            return this.programDateTime + 1e3 * p;
          }, enumerable: !0, configurable: !0 }), Object.defineProperty(m.prototype, "encrypted", { get: function() {
            return !(!this.decryptdata || this.decryptdata.uri === null || this.decryptdata.key !== null);
          }, enumerable: !0, configurable: !0 }), m.prototype.addElementaryStream = function(p) {
            this._elementaryStreams[p] = !0;
          }, m.prototype.hasElementaryStream = function(p) {
            return this._elementaryStreams[p] === !0;
          }, m.prototype.createInitializationVector = function(p) {
            for (var b = new Uint8Array(16), y = 12; y < 16; y++)
              b[y] = p >> 8 * (15 - y) & 255;
            return b;
          }, m.prototype.fragmentDecryptdataFromLevelkey = function(p, b) {
            var y = p;
            return p && p.method && p.uri && !p.iv && ((y = new d.default()).method = p.method, y.baseuri = p.baseuri, y.reluri = p.reluri, y.iv = this.createInitializationVector(b)), y;
          }, m);
          function m() {
            var p;
            this._url = null, this._byteRange = null, this._decryptdata = null, this.tagList = [], this.programDateTime = null, this.rawProgramDateTime = null, this._elementaryStreams = ((p = {})[m.ElementaryStreamTypes.AUDIO] = !1, p[m.ElementaryStreamTypes.VIDEO] = !1, p);
          }
          l.default = f;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/loader/key-loader.js": function(o, l, u) {
        var h, c = this && this.__extends || (h = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(g, E) {
          g.__proto__ = E;
        } || function(g, E) {
          for (var x in E)
            E.hasOwnProperty(x) && (g[x] = E[x]);
        }, function(g, E) {
          function x() {
            this.constructor = g;
          }
          h(g, E), g.prototype = E === null ? Object.create(E) : (x.prototype = E.prototype, new x());
        });
        Object.defineProperty(l, "__esModule", { value: !0 });
        var d, f = u("./src/events.js"), m = u("./src/event-handler.js"), p = u("./src/errors.js"), b = u("./src/utils/logger.js"), y = (d = m.default, c(v, d), v.prototype.destroy = function() {
          for (var g in this.loaders) {
            var E = this.loaders[g];
            E && E.destroy();
          }
          this.loaders = {}, m.default.prototype.destroy.call(this);
        }, v.prototype.onKeyLoading = function(g) {
          var E = g.frag, x = E.type, w = this.loaders[x], S = E.decryptdata, T = S.uri;
          if (T !== this.decrypturl || this.decryptkey === null) {
            var C, D, R, P = this.hls.config;
            w && (b.logger.warn("abort previous key loader for type:" + x), w.abort()), E.loader = this.loaders[x] = new P.loader(P), this.decrypturl = T, this.decryptkey = null, C = { url: T, frag: E, responseType: "arraybuffer" }, D = { timeout: P.fragLoadingTimeOut, maxRetry: 0, retryDelay: P.fragLoadingRetryDelay, maxRetryDelay: P.fragLoadingMaxRetryTimeout }, R = { onSuccess: this.loadsuccess.bind(this), onError: this.loaderror.bind(this), onTimeout: this.loadtimeout.bind(this) }, E.loader.load(C, D, R);
          } else
            this.decryptkey && (S.key = this.decryptkey, this.hls.trigger(f.default.KEY_LOADED, { frag: E }));
        }, v.prototype.loadsuccess = function(g, E, x) {
          var w = x.frag;
          this.decryptkey = w.decryptdata.key = new Uint8Array(g.data), w.loader = void 0, this.loaders[w.type] = void 0, this.hls.trigger(f.default.KEY_LOADED, { frag: w });
        }, v.prototype.loaderror = function(g, E) {
          var x = E.frag, w = x.loader;
          w && w.abort(), this.loaders[E.type] = void 0, this.hls.trigger(f.default.ERROR, { type: p.ErrorTypes.NETWORK_ERROR, details: p.ErrorDetails.KEY_LOAD_ERROR, fatal: !1, frag: x, response: g });
        }, v.prototype.loadtimeout = function(g, E) {
          var x = E.frag, w = x.loader;
          w && w.abort(), this.loaders[E.type] = void 0, this.hls.trigger(f.default.ERROR, { type: p.ErrorTypes.NETWORK_ERROR, details: p.ErrorDetails.KEY_LOAD_TIMEOUT, fatal: !1, frag: x });
        }, v);
        function v(g) {
          var E = d.call(this, g, f.default.KEY_LOADING) || this;
          return E.loaders = {}, E.decryptkey = null, E.decrypturl = null, E;
        }
        l.default = y;
      }, "./src/loader/level-key.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./node_modules/url-toolkit/src/url-toolkit.js"), c = (Object.defineProperty(d.prototype, "uri", { get: function() {
          return !this._uri && this.reluri && (this._uri = h.buildAbsoluteURL(this.baseuri, this.reluri, { alwaysNormalize: !0 })), this._uri;
        }, enumerable: !0, configurable: !0 }), d);
        function d() {
          this.method = null, this.key = null, this.iv = null, this._uri = null;
        }
        l.default = c;
      }, "./src/loader/level.js": function(o, l, u) {
        (function(h) {
          Object.defineProperty(l, "__esModule", { value: !0 });
          var c = (Object.defineProperty(d.prototype, "hasProgramDateTime", { get: function() {
            return !(!this.fragments[0] || !h.isFinite(this.fragments[0].programDateTime));
          }, enumerable: !0, configurable: !0 }), d);
          function d(f) {
            this.endCC = 0, this.endSN = 0, this.fragments = [], this.initSegment = null, this.live = !0, this.needSidxRanges = !1, this.startCC = 0, this.startSN = 0, this.startTimeOffset = null, this.targetduration = 0, this.totalduration = 0, this.type = null, this.url = f, this.version = null;
          }
          l.default = c;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/loader/m3u8-parser.js": function(o, l, u) {
        (function(h) {
          Object.defineProperty(l, "__esModule", { value: !0 });
          var c = u("./node_modules/url-toolkit/src/url-toolkit.js"), d = u("./src/loader/fragment.js"), f = u("./src/loader/level.js"), m = u("./src/loader/level-key.js"), p = u("./src/utils/attr-list.js"), b = u("./src/utils/logger.js"), y = u("./src/utils/codecs.js"), v = /#EXT-X-STREAM-INF:([^\n\r]*)[\r\n]+([^\r\n]+)/g, g = /#EXT-X-MEDIA:(.*)/g, E = new RegExp([/#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source, /|(?!#)([\S+ ?]+)/.source, /|#EXT-X-BYTERANGE:*(.+)/.source, /|#EXT-X-PROGRAM-DATE-TIME:(.+)/.source, /|#.*/.source].join(""), "g"), x = /(?:(?:#(EXTM3U))|(?:#EXT-X-(PLAYLIST-TYPE):(.+))|(?:#EXT-X-(MEDIA-SEQUENCE): *(\d+))|(?:#EXT-X-(TARGETDURATION): *(\d+))|(?:#EXT-X-(KEY):(.+))|(?:#EXT-X-(START):(.+))|(?:#EXT-X-(ENDLIST))|(?:#EXT-X-(DISCONTINUITY-SEQ)UENCE:(\d+))|(?:#EXT-X-(DIS)CONTINUITY))|(?:#EXT-X-(VERSION):(\d+))|(?:#EXT-X-(MAP):(.+))|(?:(#)([^:]*):(.*))|(?:(#)(.*))(?:.*)\r?\n?/, w = /\.(mp4|m4s|m4v|m4a)$/i, S = (T.findGroup = function(D, R) {
            if (!D)
              return null;
            for (var P = null, N = 0; N < D.length; N++) {
              var $ = D[N];
              $.id === R && (P = $);
            }
            return P;
          }, T.convertAVC1ToAVCOTI = function(D) {
            var R, P = D.split(".");
            return 2 < P.length ? (R = P.shift() + ".", R += parseInt(P.shift()).toString(16), R += ("000" + parseInt(P.shift()).toString(16)).substr(-4)) : R = D, R;
          }, T.resolve = function(D, R) {
            return c.buildAbsoluteURL(R, D, { alwaysNormalize: !0 });
          }, T.parseMasterPlaylist = function(D, R) {
            var P, N = [];
            function $(G, K) {
              ["video", "audio"].forEach(function(J) {
                var ue = G.filter(function(ee) {
                  return y.isCodecType(ee, J);
                });
                if (ue.length) {
                  var ce = ue.filter(function(ee) {
                    return ee.lastIndexOf("avc1", 0) === 0 || ee.lastIndexOf("mp4a", 0) === 0;
                  });
                  K[J + "Codec"] = 0 < ce.length ? ce[0] : ue[0], G = G.filter(function(ee) {
                    return ue.indexOf(ee) === -1;
                  });
                }
              }), K.unknownCodecs = G;
            }
            for (v.lastIndex = 0; (P = v.exec(D)) != null; ) {
              var O = {}, M = O.attrs = new p.default(P[1]);
              O.url = T.resolve(P[2], R);
              var F = M.decimalResolution("RESOLUTION");
              F && (O.width = F.width, O.height = F.height), O.bitrate = M.decimalInteger("AVERAGE-BANDWIDTH") || M.decimalInteger("BANDWIDTH"), O.name = M.NAME, $([].concat((M.CODECS || "").split(/[ ,]+/)), O), O.videoCodec && O.videoCodec.indexOf("avc1") !== -1 && (O.videoCodec = T.convertAVC1ToAVCOTI(O.videoCodec)), N.push(O);
            }
            return N;
          }, T.parseMasterPlaylistMedia = function(D, R, P, N) {
            var $;
            N === void 0 && (N = []);
            var O = [], M = 0;
            for (g.lastIndex = 0; ($ = g.exec(D)) !== null; ) {
              var F = {}, G = new p.default($[1]);
              if (G.TYPE === P) {
                if (F.groupId = G["GROUP-ID"], F.name = G.NAME, F.type = P, F.default = G.DEFAULT === "YES", F.autoselect = G.AUTOSELECT === "YES", F.forced = G.FORCED === "YES", G.URI && (F.url = T.resolve(G.URI, R)), F.lang = G.LANGUAGE, F.name || (F.name = F.lang), N.length) {
                  var K = T.findGroup(N, F.groupId);
                  F.audioCodec = K ? K.codec : N[0].codec;
                }
                F.id = M++, O.push(F);
              }
            }
            return O;
          }, T.parseLevelPlaylist = function(D, R, P, N, $) {
            var O, M, F = 0, G = 0, K = new f.default(R), J = new m.default(), ue = 0, ce = null, ee = new d.default(), me = null;
            for (E.lastIndex = 0; (O = E.exec(D)) !== null; ) {
              var Ce = O[1];
              if (Ce) {
                ee.duration = parseFloat(Ce);
                var Ne = (" " + O[2]).slice(1);
                ee.title = Ne || null, ee.tagList.push(Ne ? ["INF", Ce, Ne] : ["INF", Ce]);
              } else if (O[3]) {
                if (h.isFinite(ee.duration)) {
                  var ot = F++;
                  ee.type = N, ee.start = G, ee.levelkey = J, ee.sn = ot, ee.level = P, ee.cc = ue, ee.urlId = $, ee.baseurl = R, ee.relurl = (" " + O[3]).slice(1), C(ee, ce), K.fragments.push(ee), G += (ce = ee).duration, ee = new d.default();
                }
              } else if (O[4]) {
                if (ee.rawByteRange = (" " + O[4]).slice(1), ce) {
                  var ze = ce.byteRangeEndOffset;
                  ze && (ee.lastByteRangeEndOffset = ze);
                }
              } else if (O[5])
                ee.rawProgramDateTime = (" " + O[5]).slice(1), ee.tagList.push(["PROGRAM-DATE-TIME", ee.rawProgramDateTime]), me === null && (me = K.fragments.length);
              else {
                for (O = O[0].match(x), M = 1; M < O.length && O[M] === void 0; M++)
                  ;
                var $e = (" " + O[M + 1]).slice(1), Ze = (" " + O[M + 2]).slice(1);
                switch (O[M]) {
                  case "#":
                    ee.tagList.push(Ze ? [$e, Ze] : [$e]);
                    break;
                  case "PLAYLIST-TYPE":
                    K.type = $e.toUpperCase();
                    break;
                  case "MEDIA-SEQUENCE":
                    F = K.startSN = parseInt($e);
                    break;
                  case "TARGETDURATION":
                    K.targetduration = parseFloat($e);
                    break;
                  case "VERSION":
                    K.version = parseInt($e);
                    break;
                  case "EXTM3U":
                    break;
                  case "ENDLIST":
                    K.live = !1;
                    break;
                  case "DIS":
                    ue++, ee.tagList.push(["DIS"]);
                    break;
                  case "DISCONTINUITY-SEQ":
                    ue = parseInt($e);
                    break;
                  case "KEY":
                    var Ut = $e, qt = new p.default(Ut), ir = qt.enumeratedString("METHOD"), We = qt.URI, vt = qt.hexadecimalInteger("IV");
                    ir && (J = new m.default(), We && 0 <= ["AES-128", "SAMPLE-AES", "SAMPLE-AES-CENC"].indexOf(ir) && (J.method = ir, J.baseuri = R, J.reluri = We, J.key = null, J.iv = vt));
                    break;
                  case "START":
                    var Tt = $e, xt = new p.default(Tt).decimalFloatingPoint("TIME-OFFSET");
                    h.isFinite(xt) && (K.startTimeOffset = xt);
                    break;
                  case "MAP":
                    var Pt = new p.default($e);
                    ee.relurl = Pt.URI, ee.rawByteRange = Pt.BYTERANGE, ee.baseurl = R, ee.level = P, ee.type = N, ee.sn = "initSegment", K.initSegment = ee, (ee = new d.default()).rawProgramDateTime = K.initSegment.rawProgramDateTime;
                    break;
                  default:
                    b.logger.warn("line parsed but not handled: " + O);
                }
              }
            }
            return (ee = ce) && !ee.relurl && (K.fragments.pop(), G -= ee.duration), K.totalduration = G, K.averagetargetduration = G / K.fragments.length, K.endSN = F - 1, K.startCC = K.fragments[0] ? K.fragments[0].cc : 0, K.endCC = ue, !K.initSegment && K.fragments.length && K.fragments.every(function(at) {
              return w.test(at.relurl);
            }) && (b.logger.warn("MP4 fragments found but no init segment (probably no MAP, incomplete M3U8), trying to fetch SIDX"), (ee = new d.default()).relurl = K.fragments[0].relurl, ee.baseurl = R, ee.level = P, ee.type = N, ee.sn = "initSegment", K.initSegment = ee, K.needSidxRanges = !0), me && function(at, Ot) {
              for (var It = at[Ot], sr = Ot - 1; 0 <= sr; sr--) {
                var lt = at[sr];
                lt.programDateTime = It.programDateTime - 1e3 * lt.duration, It = lt;
              }
            }(K.fragments, me), K;
          }, T);
          function T() {
          }
          function C(D, R) {
            D.rawProgramDateTime ? D.programDateTime = Date.parse(D.rawProgramDateTime) : R && R.programDateTime && (D.programDateTime = R.endProgramDateTime), h.isFinite(D.programDateTime) || (D.programDateTime = null, D.rawProgramDateTime = null);
          }
          l.default = S;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/loader/playlist-loader.js": function(o, l, u) {
        (function(h) {
          var c, d = this && this.__extends || (c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(C, D) {
            C.__proto__ = D;
          } || function(C, D) {
            for (var R in D)
              D.hasOwnProperty(R) && (C[R] = D[R]);
          }, function(C, D) {
            function R() {
              this.constructor = C;
            }
            c(C, D), C.prototype = D === null ? Object.create(D) : (R.prototype = D.prototype, new R());
          });
          Object.defineProperty(l, "__esModule", { value: !0 });
          var f, m = u("./src/events.js"), p = u("./src/event-handler.js"), b = u("./src/errors.js"), y = u("./src/utils/logger.js"), v = u("./src/demux/mp4demuxer.js"), g = u("./src/loader/m3u8-parser.js"), E = window.performance, x = { MANIFEST: "manifest", LEVEL: "level", AUDIO_TRACK: "audioTrack", SUBTITLE_TRACK: "subtitleTrack" }, w = { MAIN: "main", AUDIO: "audio", SUBTITLE: "subtitle" }, S = (f = p.default, d(T, f), Object.defineProperty(T, "ContextType", { get: function() {
            return x;
          }, enumerable: !0, configurable: !0 }), Object.defineProperty(T, "LevelType", { get: function() {
            return w;
          }, enumerable: !0, configurable: !0 }), T.canHaveQualityLevels = function(C) {
            return C !== x.AUDIO_TRACK && C !== x.SUBTITLE_TRACK;
          }, T.mapContextToLevelType = function(C) {
            switch (C.type) {
              case x.AUDIO_TRACK:
                return w.AUDIO;
              case x.SUBTITLE_TRACK:
                return w.SUBTITLE;
              default:
                return w.MAIN;
            }
          }, T.getResponseUrl = function(C, D) {
            var R = C.url;
            return R !== void 0 && R.indexOf("data:") !== 0 || (R = D.url), R;
          }, T.prototype.createInternalLoader = function(C) {
            var D = this.hls.config, R = D.pLoader, P = D.loader, N = new (R || P)(D);
            return C.loader = N, this.loaders[C.type] = N;
          }, T.prototype.getInternalLoader = function(C) {
            return this.loaders[C.type];
          }, T.prototype.resetInternalLoader = function(C) {
            this.loaders[C] && delete this.loaders[C];
          }, T.prototype.destroyInternalLoaders = function() {
            for (var C in this.loaders) {
              var D = this.loaders[C];
              D && D.destroy(), this.resetInternalLoader(C);
            }
          }, T.prototype.destroy = function() {
            this.destroyInternalLoaders(), f.prototype.destroy.call(this);
          }, T.prototype.onManifestLoading = function(C) {
            this.load(C.url, { type: x.MANIFEST, level: 0, id: null });
          }, T.prototype.onLevelLoading = function(C) {
            this.load(C.url, { type: x.LEVEL, level: C.level, id: C.id });
          }, T.prototype.onAudioTrackLoading = function(C) {
            this.load(C.url, { type: x.AUDIO_TRACK, level: null, id: C.id });
          }, T.prototype.onSubtitleTrackLoading = function(C) {
            this.load(C.url, { type: x.SUBTITLE_TRACK, level: null, id: C.id });
          }, T.prototype.load = function(C, D) {
            var R = this.hls.config;
            y.logger.debug("Loading playlist of type " + D.type + ", level: " + D.level + ", id: " + D.id);
            var P, N, $, O, M = this.getInternalLoader(D);
            if (M) {
              var F = M.context;
              if (F && F.url === C)
                return y.logger.trace("playlist request ongoing"), !1;
              y.logger.warn("aborting previous loader for type: " + D.type), M.abort();
            }
            switch (D.type) {
              case x.MANIFEST:
                P = R.manifestLoadingMaxRetry, N = R.manifestLoadingTimeOut, $ = R.manifestLoadingRetryDelay, O = R.manifestLoadingMaxRetryTimeout;
                break;
              case x.LEVEL:
                P = 0, N = R.levelLoadingTimeOut;
                break;
              default:
                P = R.levelLoadingMaxRetry, N = R.levelLoadingTimeOut, $ = R.levelLoadingRetryDelay, O = R.levelLoadingMaxRetryTimeout;
            }
            M = this.createInternalLoader(D), D.url = C, D.responseType = D.responseType || "";
            var G = { timeout: N, maxRetry: P, retryDelay: $, maxRetryDelay: O }, K = { onSuccess: this.loadsuccess.bind(this), onError: this.loaderror.bind(this), onTimeout: this.loadtimeout.bind(this) };
            return y.logger.debug("Calling internal loader delegate for URL: " + C), M.load(D, G, K), !0;
          }, T.prototype.loadsuccess = function(C, D, R, P) {
            if (P === void 0 && (P = null), R.isSidxRequest)
              return this._handleSidxRequest(C, R), void this._handlePlaylistLoaded(C, D, R, P);
            this.resetInternalLoader(R.type);
            var N = C.data;
            D.tload = E.now(), N.indexOf("#EXTM3U") === 0 ? 0 < N.indexOf("#EXTINF:") || 0 < N.indexOf("#EXT-X-TARGETDURATION:") ? this._handleTrackOrLevelPlaylist(C, D, R, P) : this._handleMasterPlaylist(C, D, R, P) : this._handleManifestParsingError(C, R, "no EXTM3U delimiter", P);
          }, T.prototype.loaderror = function(C, D, R) {
            R === void 0 && (R = null), this._handleNetworkError(D, R, !1, C);
          }, T.prototype.loadtimeout = function(C, D, R) {
            R === void 0 && (R = null), this._handleNetworkError(D, R, !0);
          }, T.prototype._handleMasterPlaylist = function(C, D, R, P) {
            var N = this.hls, $ = C.data, O = T.getResponseUrl(C, R), M = g.default.parseMasterPlaylist($, O);
            if (M.length) {
              var F = M.map(function(ue) {
                return { id: ue.attrs.AUDIO, codec: ue.audioCodec };
              }), G = g.default.parseMasterPlaylistMedia($, O, "AUDIO", F), K = g.default.parseMasterPlaylistMedia($, O, "SUBTITLES");
              if (G.length) {
                var J = !1;
                G.forEach(function(ue) {
                  ue.url || (J = !0);
                }), J === !1 && M[0].audioCodec && !M[0].attrs.AUDIO && (y.logger.log("audio codec signaled in quality level, but no embedded audio track signaled, create one"), G.unshift({ type: "main", name: "main" }));
              }
              N.trigger(m.default.MANIFEST_LOADED, { levels: M, audioTracks: G, subtitles: K, url: O, stats: D, networkDetails: P });
            } else
              this._handleManifestParsingError(C, R, "no level found in manifest", P);
          }, T.prototype._handleTrackOrLevelPlaylist = function(C, D, R, P) {
            var N = this.hls, $ = R.id, O = R.level, M = R.type, F = T.getResponseUrl(C, R), G = h.isFinite($) ? $ : 0, K = h.isFinite(O) ? O : G, J = T.mapContextToLevelType(R), ue = g.default.parseLevelPlaylist(C.data, F, K, J, G);
            if (ue.tload = D.tload, M === x.MANIFEST) {
              var ce = { url: F, details: ue };
              N.trigger(m.default.MANIFEST_LOADED, { levels: [ce], audioTracks: [], url: F, stats: D, networkDetails: P });
            }
            if (D.tparsed = E.now(), ue.needSidxRanges) {
              var ee = ue.initSegment.url;
              this.load(ee, { isSidxRequest: !0, type: M, level: O, levelDetails: ue, id: $, rangeStart: 0, rangeEnd: 2048, responseType: "arraybuffer" });
            } else
              R.levelDetails = ue, this._handlePlaylistLoaded(C, D, R, P);
          }, T.prototype._handleSidxRequest = function(C, D) {
            var R = v.default.parseSegmentIndex(new Uint8Array(C.data));
            if (R) {
              var P = R.references, N = D.levelDetails;
              P.forEach(function($, O) {
                var M = $.info, F = N.fragments[O];
                F.byteRange.length === 0 && (F.rawByteRange = String(1 + M.end - M.start) + "@" + String(M.start));
              }), N.initSegment.rawByteRange = String(R.moovEndOffset) + "@0";
            }
          }, T.prototype._handleManifestParsingError = function(C, D, R, P) {
            this.hls.trigger(m.default.ERROR, { type: b.ErrorTypes.NETWORK_ERROR, details: b.ErrorDetails.MANIFEST_PARSING_ERROR, fatal: !0, url: C.url, reason: R, networkDetails: P });
          }, T.prototype._handleNetworkError = function(C, D, R, P) {
            var N, $;
            R === void 0 && (R = !1), P === void 0 && (P = null), y.logger.info("A network error occured while loading a " + C.type + "-type playlist");
            var O = this.getInternalLoader(C);
            switch (C.type) {
              case x.MANIFEST:
                N = R ? b.ErrorDetails.MANIFEST_LOAD_TIMEOUT : b.ErrorDetails.MANIFEST_LOAD_ERROR, $ = !0;
                break;
              case x.LEVEL:
                N = R ? b.ErrorDetails.LEVEL_LOAD_TIMEOUT : b.ErrorDetails.LEVEL_LOAD_ERROR, $ = !1;
                break;
              case x.AUDIO_TRACK:
                N = R ? b.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT : b.ErrorDetails.AUDIO_TRACK_LOAD_ERROR, $ = !1;
                break;
              default:
                $ = !1;
            }
            O && (O.abort(), this.resetInternalLoader(C.type));
            var M = { type: b.ErrorTypes.NETWORK_ERROR, details: N, fatal: $, url: O.url, loader: O, context: C, networkDetails: D };
            P && (M.response = P), this.hls.trigger(m.default.ERROR, M);
          }, T.prototype._handlePlaylistLoaded = function(C, D, R, P) {
            var N = R.type, $ = R.level, O = R.id, M = R.levelDetails;
            if (M.targetduration)
              if (T.canHaveQualityLevels(R.type))
                this.hls.trigger(m.default.LEVEL_LOADED, { details: M, level: $ || 0, id: O || 0, stats: D, networkDetails: P });
              else
                switch (N) {
                  case x.AUDIO_TRACK:
                    this.hls.trigger(m.default.AUDIO_TRACK_LOADED, { details: M, id: O, stats: D, networkDetails: P });
                    break;
                  case x.SUBTITLE_TRACK:
                    this.hls.trigger(m.default.SUBTITLE_TRACK_LOADED, { details: M, id: O, stats: D, networkDetails: P });
                }
            else
              this._handleManifestParsingError(C, R, "invalid target duration", P);
          }, T);
          function T(C) {
            var D = f.call(this, C, m.default.MANIFEST_LOADING, m.default.LEVEL_LOADING, m.default.AUDIO_TRACK_LOADING, m.default.SUBTITLE_TRACK_LOADING) || this;
            return D.loaders = {}, D;
          }
          l.default = S;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/observer.js": function(o, l, u) {
        var h, c = this && this.__extends || (h = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(b, y) {
          b.__proto__ = y;
        } || function(b, y) {
          for (var v in y)
            y.hasOwnProperty(v) && (b[v] = y[v]);
        }, function(b, y) {
          function v() {
            this.constructor = b;
          }
          h(b, y), b.prototype = y === null ? Object.create(y) : (v.prototype = y.prototype, new v());
        });
        Object.defineProperty(l, "__esModule", { value: !0 });
        var d, f = u("./node_modules/eventemitter3/index.js"), m = (d = f.EventEmitter, c(p, d), p.prototype.trigger = function(b) {
          for (var y = [], v = 1; v < arguments.length; v++)
            y[v - 1] = arguments[v];
          this.emit.apply(this, [b, b].concat(y));
        }, p);
        function p() {
          return d !== null && d.apply(this, arguments) || this;
        }
        l.Observer = m;
      }, "./src/polyfills/number.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./src/utils/get-self-scope.js").getSelfScope().Number;
        (l.Number = h).isFinite = h.isFinite || function(c) {
          return typeof c == "number" && isFinite(c);
        };
      }, "./src/remux/aac-helper.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = (c.getSilentFrame = function(d, f) {
          switch (d) {
            case "mp4a.40.2":
              if (f === 1)
                return new Uint8Array([0, 200, 0, 128, 35, 128]);
              if (f === 2)
                return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
              if (f === 3)
                return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
              if (f === 4)
                return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
              if (f === 5)
                return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56]);
              if (f === 6)
                return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0, 32, 8, 224]);
              break;
            default:
              if (f === 1)
                return new Uint8Array([1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
              if (f === 2)
                return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
              if (f === 3)
                return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
          }
          return null;
        }, c);
        function c() {
        }
        l.default = h;
      }, "./src/remux/mp4-generator.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = Math.pow(2, 32) - 1, c = (d.init = function() {
          var f;
          for (f in d.types = { avc1: [], avcC: [], btrt: [], dinf: [], dref: [], esds: [], ftyp: [], hdlr: [], mdat: [], mdhd: [], mdia: [], mfhd: [], minf: [], moof: [], moov: [], mp4a: [], ".mp3": [], mvex: [], mvhd: [], pasp: [], sdtp: [], stbl: [], stco: [], stsc: [], stsd: [], stsz: [], stts: [], tfdt: [], tfhd: [], traf: [], trak: [], trun: [], trex: [], tkhd: [], vmhd: [], smhd: [] })
            d.types.hasOwnProperty(f) && (d.types[f] = [f.charCodeAt(0), f.charCodeAt(1), f.charCodeAt(2), f.charCodeAt(3)]);
          var m = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 118, 105, 100, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 86, 105, 100, 101, 111, 72, 97, 110, 100, 108, 101, 114, 0]), p = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 115, 111, 117, 110, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 83, 111, 117, 110, 100, 72, 97, 110, 100, 108, 101, 114, 0]);
          d.HDLR_TYPES = { video: m, audio: p };
          var b = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 12, 117, 114, 108, 32, 0, 0, 0, 1]), y = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]);
          d.STTS = d.STSC = d.STCO = y, d.STSZ = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), d.VMHD = new Uint8Array([0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0]), d.SMHD = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]), d.STSD = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1]);
          var v = new Uint8Array([105, 115, 111, 109]), g = new Uint8Array([97, 118, 99, 49]), E = new Uint8Array([0, 0, 0, 1]);
          d.FTYP = d.box(d.types.ftyp, v, E, v, g), d.DINF = d.box(d.types.dinf, d.box(d.types.dref, b));
        }, d.box = function(f) {
          for (var m, p = Array.prototype.slice.call(arguments, 1), b = 8, y = p.length, v = y; y--; )
            b += p[y].byteLength;
          for ((m = new Uint8Array(b))[0] = b >> 24 & 255, m[1] = b >> 16 & 255, m[2] = b >> 8 & 255, m[3] = 255 & b, m.set(f, 4), y = 0, b = 8; y < v; y++)
            m.set(p[y], b), b += p[y].byteLength;
          return m;
        }, d.hdlr = function(f) {
          return d.box(d.types.hdlr, d.HDLR_TYPES[f]);
        }, d.mdat = function(f) {
          return d.box(d.types.mdat, f);
        }, d.mdhd = function(f, m) {
          m *= f;
          var p = Math.floor(m / (1 + h)), b = Math.floor(m % (1 + h));
          return d.box(d.types.mdhd, new Uint8Array([1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, f >> 24 & 255, f >> 16 & 255, f >> 8 & 255, 255 & f, p >> 24, p >> 16 & 255, p >> 8 & 255, 255 & p, b >> 24, b >> 16 & 255, b >> 8 & 255, 255 & b, 85, 196, 0, 0]));
        }, d.mdia = function(f) {
          return d.box(d.types.mdia, d.mdhd(f.timescale, f.duration), d.hdlr(f.type), d.minf(f));
        }, d.mfhd = function(f) {
          return d.box(d.types.mfhd, new Uint8Array([0, 0, 0, 0, f >> 24, f >> 16 & 255, f >> 8 & 255, 255 & f]));
        }, d.minf = function(f) {
          return f.type === "audio" ? d.box(d.types.minf, d.box(d.types.smhd, d.SMHD), d.DINF, d.stbl(f)) : d.box(d.types.minf, d.box(d.types.vmhd, d.VMHD), d.DINF, d.stbl(f));
        }, d.moof = function(f, m, p) {
          return d.box(d.types.moof, d.mfhd(f), d.traf(p, m));
        }, d.moov = function(f) {
          for (var m = f.length, p = []; m--; )
            p[m] = d.trak(f[m]);
          return d.box.apply(null, [d.types.moov, d.mvhd(f[0].timescale, f[0].duration)].concat(p).concat(d.mvex(f)));
        }, d.mvex = function(f) {
          for (var m = f.length, p = []; m--; )
            p[m] = d.trex(f[m]);
          return d.box.apply(null, [d.types.mvex].concat(p));
        }, d.mvhd = function(f, m) {
          m *= f;
          var p = Math.floor(m / (1 + h)), b = Math.floor(m % (1 + h)), y = new Uint8Array([1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, f >> 24 & 255, f >> 16 & 255, f >> 8 & 255, 255 & f, p >> 24, p >> 16 & 255, p >> 8 & 255, 255 & p, b >> 24, b >> 16 & 255, b >> 8 & 255, 255 & b, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 64, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 255, 255, 255, 255]);
          return d.box(d.types.mvhd, y);
        }, d.sdtp = function(f) {
          var m, p, b = f.samples || [], y = new Uint8Array(4 + b.length);
          for (p = 0; p < b.length; p++)
            m = b[p].flags, y[p + 4] = m.dependsOn << 4 | m.isDependedOn << 2 | m.hasRedundancy;
          return d.box(d.types.sdtp, y);
        }, d.stbl = function(f) {
          return d.box(d.types.stbl, d.stsd(f), d.box(d.types.stts, d.STTS), d.box(d.types.stsc, d.STSC), d.box(d.types.stsz, d.STSZ), d.box(d.types.stco, d.STCO));
        }, d.avc1 = function(f) {
          var m, p, b, y = [], v = [];
          for (m = 0; m < f.sps.length; m++)
            b = (p = f.sps[m]).byteLength, y.push(b >>> 8 & 255), y.push(255 & b), y = y.concat(Array.prototype.slice.call(p));
          for (m = 0; m < f.pps.length; m++)
            b = (p = f.pps[m]).byteLength, v.push(b >>> 8 & 255), v.push(255 & b), v = v.concat(Array.prototype.slice.call(p));
          var g = d.box(d.types.avcC, new Uint8Array([1, y[3], y[4], y[5], 255, 224 | f.sps.length].concat(y).concat([f.pps.length]).concat(v))), E = f.width, x = f.height, w = f.pixelRatio[0], S = f.pixelRatio[1];
          return d.box(d.types.avc1, new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, E >> 8 & 255, 255 & E, x >> 8 & 255, 255 & x, 0, 72, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 1, 18, 100, 97, 105, 108, 121, 109, 111, 116, 105, 111, 110, 47, 104, 108, 115, 46, 106, 115, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 17, 17]), g, d.box(d.types.btrt, new Uint8Array([0, 28, 156, 128, 0, 45, 198, 192, 0, 45, 198, 192])), d.box(d.types.pasp, new Uint8Array([w >> 24, w >> 16 & 255, w >> 8 & 255, 255 & w, S >> 24, S >> 16 & 255, S >> 8 & 255, 255 & S])));
        }, d.esds = function(f) {
          var m = f.config.length;
          return new Uint8Array([0, 0, 0, 0, 3, 23 + m, 0, 1, 0, 4, 15 + m, 64, 21, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5].concat([m]).concat(f.config).concat([6, 1, 2]));
        }, d.mp4a = function(f) {
          var m = f.samplerate;
          return d.box(d.types.mp4a, new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, f.channelCount, 0, 16, 0, 0, 0, 0, m >> 8 & 255, 255 & m, 0, 0]), d.box(d.types.esds, d.esds(f)));
        }, d.mp3 = function(f) {
          var m = f.samplerate;
          return d.box(d.types[".mp3"], new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, f.channelCount, 0, 16, 0, 0, 0, 0, m >> 8 & 255, 255 & m, 0, 0]));
        }, d.stsd = function(f) {
          return f.type === "audio" ? f.isAAC || f.codec !== "mp3" ? d.box(d.types.stsd, d.STSD, d.mp4a(f)) : d.box(d.types.stsd, d.STSD, d.mp3(f)) : d.box(d.types.stsd, d.STSD, d.avc1(f));
        }, d.tkhd = function(f) {
          var m = f.id, p = f.duration * f.timescale, b = f.width, y = f.height, v = Math.floor(p / (1 + h)), g = Math.floor(p % (1 + h));
          return d.box(d.types.tkhd, new Uint8Array([1, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, m >> 24 & 255, m >> 16 & 255, m >> 8 & 255, 255 & m, 0, 0, 0, 0, v >> 24, v >> 16 & 255, v >> 8 & 255, 255 & v, g >> 24, g >> 16 & 255, g >> 8 & 255, 255 & g, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 64, 0, 0, 0, b >> 8 & 255, 255 & b, 0, 0, y >> 8 & 255, 255 & y, 0, 0]));
        }, d.traf = function(f, m) {
          var p = d.sdtp(f), b = f.id, y = Math.floor(m / (1 + h)), v = Math.floor(m % (1 + h));
          return d.box(d.types.traf, d.box(d.types.tfhd, new Uint8Array([0, 0, 0, 0, b >> 24, b >> 16 & 255, b >> 8 & 255, 255 & b])), d.box(d.types.tfdt, new Uint8Array([1, 0, 0, 0, y >> 24, y >> 16 & 255, y >> 8 & 255, 255 & y, v >> 24, v >> 16 & 255, v >> 8 & 255, 255 & v])), d.trun(f, p.length + 16 + 20 + 8 + 16 + 8 + 8), p);
        }, d.trak = function(f) {
          return f.duration = f.duration || 4294967295, d.box(d.types.trak, d.tkhd(f), d.mdia(f));
        }, d.trex = function(f) {
          var m = f.id;
          return d.box(d.types.trex, new Uint8Array([0, 0, 0, 0, m >> 24, m >> 16 & 255, m >> 8 & 255, 255 & m, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1]));
        }, d.trun = function(f, m) {
          var p, b, y, v, g, E, x = f.samples || [], w = x.length, S = 12 + 16 * w, T = new Uint8Array(S);
          for (m += 8 + S, T.set([0, 0, 15, 1, w >>> 24 & 255, w >>> 16 & 255, w >>> 8 & 255, 255 & w, m >>> 24 & 255, m >>> 16 & 255, m >>> 8 & 255, 255 & m], 0), p = 0; p < w; p++)
            y = (b = x[p]).duration, v = b.size, g = b.flags, E = b.cts, T.set([y >>> 24 & 255, y >>> 16 & 255, y >>> 8 & 255, 255 & y, v >>> 24 & 255, v >>> 16 & 255, v >>> 8 & 255, 255 & v, g.isLeading << 2 | g.dependsOn, g.isDependedOn << 6 | g.hasRedundancy << 4 | g.paddingValue << 1 | g.isNonSync, 61440 & g.degradPrio, 15 & g.degradPrio, E >>> 24 & 255, E >>> 16 & 255, E >>> 8 & 255, 255 & E], 12 + 16 * p);
          return d.box(d.types.trun, T);
        }, d.initSegment = function(f) {
          d.types || d.init();
          var m, p = d.moov(f);
          return (m = new Uint8Array(d.FTYP.byteLength + p.byteLength)).set(d.FTYP), m.set(p, d.FTYP.byteLength), m;
        }, d);
        function d() {
        }
        l.default = c;
      }, "./src/remux/mp4-remuxer.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./src/remux/aac-helper.js"), c = u("./src/remux/mp4-generator.js"), d = u("./src/events.js"), f = u("./src/errors.js"), m = u("./src/utils/logger.js"), p = (b.prototype.destroy = function() {
        }, b.prototype.resetTimeStamp = function(y) {
          this._initPTS = this._initDTS = y;
        }, b.prototype.resetInitSegment = function() {
          this.ISGenerated = !1;
        }, b.prototype.remux = function(y, v, g, E, x, w, S) {
          if (this.ISGenerated || this.generateIS(y, v, x), this.ISGenerated) {
            var T = y.samples.length, C = v.samples.length, D = x, R = x;
            if (T && C) {
              var P = (y.samples[0].pts - v.samples[0].pts) / v.inputTimeScale;
              D += Math.max(0, P), R += Math.max(0, -P);
            }
            if (T) {
              y.timescale || (m.logger.warn("regenerate InitSegment as audio detected"), this.generateIS(y, v, x));
              var N = this.remuxAudio(y, D, w, S);
              if (C) {
                var $ = void 0;
                N && ($ = N.endPTS - N.startPTS), v.timescale || (m.logger.warn("regenerate InitSegment as video detected"), this.generateIS(y, v, x)), this.remuxVideo(v, R, w, $, S);
              }
            } else if (C) {
              var O = this.remuxVideo(v, R, w, 0, S);
              O && y.codec && this.remuxEmptyAudio(y, D, w, O);
            }
          }
          g.samples.length && this.remuxID3(g, x), E.samples.length && this.remuxText(E, x), this.observer.trigger(d.default.FRAG_PARSED);
        }, b.prototype.generateIS = function(y, v, g) {
          var E, x, w = this.observer, S = y.samples, T = v.samples, C = this.typeSupported, D = "audio/mp4", R = {}, P = { tracks: R }, N = this._initPTS === void 0;
          if (N && (E = x = 1 / 0), y.config && S.length && (y.timescale = y.samplerate, m.logger.log("audio sampling rate : " + y.samplerate), y.isAAC || (C.mpeg ? (D = "audio/mpeg", y.codec = "") : C.mp3 && (y.codec = "mp3")), R.audio = { container: D, codec: y.codec, initSegment: !y.isAAC && C.mpeg ? new Uint8Array() : c.default.initSegment([y]), metadata: { channelCount: y.channelCount } }, N && (E = x = S[0].pts - y.inputTimeScale * g)), v.sps && v.pps && T.length) {
            var $ = v.inputTimeScale;
            v.timescale = $, R.video = { container: "video/mp4", codec: v.codec, initSegment: c.default.initSegment([v]), metadata: { width: v.width, height: v.height } }, N && (E = Math.min(E, T[0].pts - $ * g), x = Math.min(x, T[0].dts - $ * g), this.observer.trigger(d.default.INIT_PTS_FOUND, { initPTS: E }));
          }
          Object.keys(R).length ? (w.trigger(d.default.FRAG_PARSING_INIT_SEGMENT, P), this.ISGenerated = !0, N && (this._initPTS = E, this._initDTS = x)) : w.trigger(d.default.ERROR, { type: f.ErrorTypes.MEDIA_ERROR, details: f.ErrorDetails.FRAG_PARSING_ERROR, fatal: !1, reason: "no audio/video samples found" });
        }, b.prototype.remuxVideo = function(y, v, g, E, x) {
          var w, S, T, C, D, R, P, N = 8, $ = y.timescale, O = y.samples, M = [], F = O.length, G = this._PTSNormalize, K = this._initPTS, J = this.nextAvcDts, ue = this.isSafari;
          if (F !== 0) {
            ue && (g |= O.length && J && (x && Math.abs(v - J / $) < 0.1 || Math.abs(O[0].pts - J - K) < $ / 5)), g || (J = v * $), O.forEach(function(ci) {
              ci.pts = G(ci.pts - K, J), ci.dts = G(ci.dts - K, J);
            }), O.sort(function(ci, oi) {
              var Kr = ci.dts - oi.dts, mn = ci.pts - oi.pts;
              return Kr || mn || ci.id - oi.id;
            });
            var ce = O.reduce(function(ci, oi) {
              return Math.max(Math.min(ci, oi.pts - oi.dts), -18e3);
            }, 0);
            if (ce < 0) {
              m.logger.warn("PTS < DTS detected in video samples, shifting DTS by " + Math.round(ce / 90) + " ms to overcome this issue");
              for (var ee = 0; ee < O.length; ee++)
                O[ee].dts += ce;
            }
            var me = O[0];
            D = Math.max(me.dts, 0), C = Math.max(me.pts, 0);
            var Ce = Math.round((D - J) / 90);
            g && Ce && (1 < Ce ? m.logger.log("AVC:" + Ce + " ms hole between fragments detected,filling it") : Ce < -1 && m.logger.log("AVC:" + -Ce + " ms overlapping between fragments detected"), D = J, O[0].dts = D, C = Math.max(C - Ce, J), O[0].pts = C, m.logger.log("Video/PTS/DTS adjusted: " + Math.round(C / 90) + "/" + Math.round(D / 90) + ",delta:" + Ce + " ms")), me = O[O.length - 1], P = Math.max(me.dts, 0), R = Math.max(me.pts, 0, P), ue && (w = Math.round((P - D) / (O.length - 1)));
            var Ne = 0, ot = 0;
            for (ee = 0; ee < F; ee++) {
              for (var ze = O[ee], $e = ze.units, Ze = $e.length, Ut = 0, qt = 0; qt < Ze; qt++)
                Ut += $e[qt].data.length;
              ot += Ut, Ne += Ze, ze.length = Ut, ze.dts = ue ? D + ee * w : Math.max(ze.dts, D), ze.pts = Math.max(ze.pts, ze.dts);
            }
            var ir = ot + 4 * Ne + 8;
            try {
              S = new Uint8Array(ir);
            } catch {
              return void this.observer.trigger(d.default.ERROR, { type: f.ErrorTypes.MUX_ERROR, details: f.ErrorDetails.REMUX_ALLOC_ERROR, fatal: !1, bytes: ir, reason: "fail allocating video mdat " + ir });
            }
            var We = new DataView(S.buffer);
            for (We.setUint32(0, ir), S.set(c.default.types.mdat, 4), ee = 0; ee < F; ee++) {
              var vt = O[ee], Tt = vt.units, xt = 0, Pt = void 0;
              for (qt = 0, Ze = Tt.length; qt < Ze; qt++) {
                var at = Tt[qt], Ot = at.data, It = at.data.byteLength;
                We.setUint32(N, It), N += 4, S.set(Ot, N), N += It, xt += 4 + It;
              }
              if (ue)
                Pt = Math.max(0, w * Math.round((vt.pts - vt.dts) / w));
              else {
                if (ee < F - 1)
                  w = O[ee + 1].dts - vt.dts;
                else {
                  var sr = this.config, lt = vt.dts - O[0 < ee ? ee - 1 : ee].dts;
                  if (sr.stretchShortVideoTrack) {
                    var ri = sr.maxBufferHole, Qr = Math.floor(ri * $), xr = (E ? C + E * $ : this.nextAudioPts) - vt.pts;
                    Qr < xr ? ((w = xr - lt) < 0 && (w = lt), m.logger.log("It is approximately " + xr / 90 + " ms to the next segment; using duration " + w / 90 + " ms for the last video frame.")) : w = lt;
                  } else
                    w = lt;
                }
                Pt = Math.round(vt.pts - vt.dts);
              }
              M.push({ size: xt, duration: w, cts: Pt, flags: { isLeading: 0, isDependedOn: 0, hasRedundancy: 0, degradPrio: 0, dependsOn: vt.key ? 2 : 1, isNonSync: vt.key ? 0 : 1 } });
            }
            this.nextAvcDts = P + w;
            var _i = y.dropped;
            if (y.len = 0, y.nbNalu = 0, y.dropped = 0, M.length && -1 < navigator.userAgent.toLowerCase().indexOf("chrome")) {
              var Gr = M[0].flags;
              Gr.dependsOn = 2, Gr.isNonSync = 0;
            }
            y.samples = M, T = c.default.moof(y.sequenceNumber++, D, y), y.samples = [];
            var li = { data1: T, data2: S, startPTS: C / $, endPTS: (R + w) / $, startDTS: D / $, endDTS: this.nextAvcDts / $, type: "video", hasAudio: !1, hasVideo: !0, nb: M.length, dropped: _i };
            return this.observer.trigger(d.default.FRAG_PARSING_DATA, li), li;
          }
        }, b.prototype.remuxAudio = function(y, v, g, E) {
          var x, w, S, T, C, D, R, P = y.inputTimeScale, N = y.timescale, $ = P / N, O = (y.isAAC ? 1024 : 1152) * $, M = this._PTSNormalize, F = this._initPTS, G = !y.isAAC && this.typeSupported.mpeg, K = y.samples, J = [], ue = this.nextAudioPts;
          if (g |= K.length && ue && (E && Math.abs(v - ue / P) < 0.1 || Math.abs(K[0].pts - ue - F) < 20 * O), K.forEach(function(ri) {
            ri.pts = ri.dts = M(ri.pts - F, v * P);
          }), (K = K.filter(function(ri) {
            return 0 <= ri.pts;
          })).length !== 0) {
            if (g || (ue = E ? v * P : K[0].pts), y.isAAC)
              for (var ce = this.config.maxAudioFramesDrift, ee = 0, me = ue; ee < K.length; ) {
                var Ce, Ne = K[ee];
                Ce = (We = Ne.pts) - me;
                var ot = Math.abs(1e3 * Ce / P);
                if (Ce <= -ce * O)
                  m.logger.warn("Dropping 1 audio frame @ " + (me / P).toFixed(3) + "s due to " + Math.round(ot) + " ms overlap."), K.splice(ee, 1), y.len -= Ne.unit.length;
                else if (ce * O <= Ce && ot < 1e4 && me) {
                  var ze = Math.round(Ce / O);
                  m.logger.warn("Injecting " + ze + " audio frame @ " + (me / P).toFixed(3) + "s due to " + Math.round(1e3 * Ce / P) + " ms gap.");
                  for (var $e = 0; $e < ze; $e++) {
                    var Ze = Math.max(me, 0);
                    (S = h.default.getSilentFrame(y.manifestCodec || y.codec, y.channelCount)) || (m.logger.log("Unable to get silent frame for given audio codec; duplicating last frame instead."), S = Ne.unit.subarray()), K.splice(ee, 0, { unit: S, pts: Ze, dts: Ze }), y.len += S.length, me += O, ee++;
                  }
                  Ne.pts = Ne.dts = me, me += O, ee++;
                } else
                  Ne.pts = Ne.dts = me, me += O, ee++;
              }
            $e = 0;
            for (var Ut = K.length; $e < Ut; $e++) {
              var qt = K[$e], ir = qt.unit, We = qt.pts;
              if (R !== void 0)
                w.duration = Math.round((We - R) / $);
              else {
                var vt = Math.round(1e3 * (We - ue) / P), Tt = 0;
                if (g && y.isAAC && vt) {
                  if (0 < vt && vt < 1e4)
                    Tt = Math.round((We - ue) / O), m.logger.log(vt + " ms hole between AAC samples detected,filling it"), 0 < Tt && (S = (S = h.default.getSilentFrame(y.manifestCodec || y.codec, y.channelCount)) || ir.subarray(), y.len += Tt * S.length);
                  else if (vt < -12) {
                    m.logger.log("drop overlapping AAC sample, expected/parsed/delta:" + (ue / P).toFixed(3) + "s/" + (We / P).toFixed(3) + "s/" + -vt + "ms"), y.len -= ir.byteLength;
                    continue;
                  }
                  We = ue;
                }
                if (D = We, !(0 < y.len))
                  return;
                var xt = G ? y.len : y.len + 8;
                x = G ? 0 : 8;
                try {
                  T = new Uint8Array(xt);
                } catch {
                  return void this.observer.trigger(d.default.ERROR, { type: f.ErrorTypes.MUX_ERROR, details: f.ErrorDetails.REMUX_ALLOC_ERROR, fatal: !1, bytes: xt, reason: "fail allocating audio mdat " + xt });
                }
                for (G || (new DataView(T.buffer).setUint32(0, xt), T.set(c.default.types.mdat, 4)), ee = 0; ee < Tt; ee++)
                  (S = h.default.getSilentFrame(y.manifestCodec || y.codec, y.channelCount)) || (m.logger.log("Unable to get silent frame for given audio codec; duplicating this frame instead."), S = ir.subarray()), T.set(S, x), x += S.byteLength, w = { size: S.byteLength, cts: 0, duration: 1024, flags: { isLeading: 0, isDependedOn: 0, hasRedundancy: 0, degradPrio: 0, dependsOn: 1 } }, J.push(w);
              }
              T.set(ir, x);
              var Pt = ir.byteLength;
              x += Pt, w = { size: Pt, cts: 0, duration: 0, flags: { isLeading: 0, isDependedOn: 0, hasRedundancy: 0, degradPrio: 0, dependsOn: 1 } }, J.push(w), R = We;
            }
            var at = 0, Ot = J.length;
            if (2 <= Ot && (at = J[Ot - 2].duration, w.duration = at), Ot) {
              this.nextAudioPts = ue = R + $ * at, y.len = 0, y.samples = J, C = G ? new Uint8Array() : c.default.moof(y.sequenceNumber++, D / $, y), y.samples = [];
              var It = D / P, sr = ue / P, lt = { data1: C, data2: T, startPTS: It, endPTS: sr, startDTS: It, endDTS: sr, type: "audio", hasAudio: !0, hasVideo: !1, nb: Ot };
              return this.observer.trigger(d.default.FRAG_PARSING_DATA, lt), lt;
            }
            return null;
          }
        }, b.prototype.remuxEmptyAudio = function(y, v, g, E) {
          var x = y.inputTimeScale, w = x / (y.samplerate ? y.samplerate : x), S = this.nextAudioPts, T = (S !== void 0 ? S : E.startDTS * x) + this._initDTS, C = E.endDTS * x + this._initDTS, D = 1024 * w, R = Math.ceil((C - T) / D), P = h.default.getSilentFrame(y.manifestCodec || y.codec, y.channelCount);
          if (m.logger.warn("remux empty Audio"), P) {
            for (var N = [], $ = 0; $ < R; $++) {
              var O = T + $ * D;
              N.push({ unit: P, pts: O, dts: O }), y.len += P.length;
            }
            y.samples = N, this.remuxAudio(y, v, g);
          } else
            m.logger.trace("Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec!");
        }, b.prototype.remuxID3 = function(y) {
          var v, g = y.samples.length, E = y.inputTimeScale, x = this._initPTS, w = this._initDTS;
          if (g) {
            for (var S = 0; S < g; S++)
              (v = y.samples[S]).pts = (v.pts - x) / E, v.dts = (v.dts - w) / E;
            this.observer.trigger(d.default.FRAG_PARSING_METADATA, { samples: y.samples });
          }
          y.samples = [];
        }, b.prototype.remuxText = function(y) {
          y.samples.sort(function(S, T) {
            return S.pts - T.pts;
          });
          var v, g = y.samples.length, E = y.inputTimeScale, x = this._initPTS;
          if (g) {
            for (var w = 0; w < g; w++)
              (v = y.samples[w]).pts = (v.pts - x) / E;
            this.observer.trigger(d.default.FRAG_PARSING_USERDATA, { samples: y.samples });
          }
          y.samples = [];
        }, b.prototype._PTSNormalize = function(y, v) {
          var g;
          if (v === void 0)
            return y;
          for (g = v < y ? -8589934592 : 8589934592; 4294967296 < Math.abs(y - v); )
            y += g;
          return y;
        }, b);
        function b(y, v, g, E) {
          this.observer = y, this.config = v, this.typeSupported = g;
          var x = navigator.userAgent;
          this.isSafari = E && -1 < E.indexOf("Apple") && x && !x.match("CriOS"), this.ISGenerated = !1;
        }
        l.default = p;
      }, "./src/remux/passthrough-remuxer.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./src/events.js"), c = (d.prototype.destroy = function() {
        }, d.prototype.resetTimeStamp = function() {
        }, d.prototype.resetInitSegment = function() {
        }, d.prototype.remux = function(f, m, p, b, y, v, g, E) {
          var x = this.observer, w = "";
          f && (w += "audio"), m && (w += "video"), x.trigger(h.default.FRAG_PARSING_DATA, { data1: E, startPTS: y, startDTS: y, type: w, hasAudio: !!f, hasVideo: !!m, nb: 1, dropped: 0 }), x.trigger(h.default.FRAG_PARSED);
        }, d);
        function d(f) {
          this.observer = f;
        }
        l.default = c;
      }, "./src/task-loop.js": function(o, l, u) {
        var h, c = this && this.__extends || (h = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(b, y) {
          b.__proto__ = y;
        } || function(b, y) {
          for (var v in y)
            y.hasOwnProperty(v) && (b[v] = y[v]);
        }, function(b, y) {
          function v() {
            this.constructor = b;
          }
          h(b, y), b.prototype = y === null ? Object.create(y) : (v.prototype = y.prototype, new v());
        });
        Object.defineProperty(l, "__esModule", { value: !0 });
        var d, f = u("./src/event-handler.js"), m = (d = f.default, c(p, d), p.prototype.onHandlerDestroying = function() {
          this.clearNextTick(), this.clearInterval();
        }, p.prototype.hasInterval = function() {
          return !!this._tickInterval;
        }, p.prototype.hasNextTick = function() {
          return !!this._tickTimer;
        }, p.prototype.setInterval = function(b) {
          return !this._tickInterval && (this._tickInterval = setInterval(this._boundTick, b), !0);
        }, p.prototype.clearInterval = function() {
          return !(!this._tickInterval || (clearInterval(this._tickInterval), this._tickInterval = null));
        }, p.prototype.clearNextTick = function() {
          return !(!this._tickTimer || (clearTimeout(this._tickTimer), this._tickTimer = null));
        }, p.prototype.tick = function() {
          this._tickCallCount++, this._tickCallCount === 1 && (this.doTick(), 1 < this._tickCallCount && (this.clearNextTick(), this._tickTimer = setTimeout(this._boundTick, 0)), this._tickCallCount = 0);
        }, p.prototype.doTick = function() {
        }, p);
        function p(b) {
          for (var y = [], v = 1; v < arguments.length; v++)
            y[v - 1] = arguments[v];
          var g = d.apply(this, [b].concat(y)) || this;
          return g._tickInterval = null, g._tickTimer = null, g._tickCallCount = 0, g._boundTick = g.tick.bind(g), g;
        }
        l.default = m;
      }, "./src/utils/attr-list.js": function(o, l, u) {
        (function(h) {
          Object.defineProperty(l, "__esModule", { value: !0 });
          var c = /^(\d+)x(\d+)$/, d = /\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g, f = (m.prototype.decimalInteger = function(p) {
            var b = parseInt(this[p], 10);
            return b > h.MAX_SAFE_INTEGER ? 1 / 0 : b;
          }, m.prototype.hexadecimalInteger = function(p) {
            if (this[p]) {
              var b = (this[p] || "0x").slice(2);
              b = (1 & b.length ? "0" : "") + b;
              for (var y = new Uint8Array(b.length / 2), v = 0; v < b.length / 2; v++)
                y[v] = parseInt(b.slice(2 * v, 2 * v + 2), 16);
              return y;
            }
            return null;
          }, m.prototype.hexadecimalIntegerAsNumber = function(p) {
            var b = parseInt(this[p], 16);
            return b > h.MAX_SAFE_INTEGER ? 1 / 0 : b;
          }, m.prototype.decimalFloatingPoint = function(p) {
            return parseFloat(this[p]);
          }, m.prototype.enumeratedString = function(p) {
            return this[p];
          }, m.prototype.decimalResolution = function(p) {
            var b = c.exec(this[p]);
            if (b !== null)
              return { width: parseInt(b[1], 10), height: parseInt(b[2], 10) };
          }, m.parseAttrList = function(p) {
            var b, y = {};
            for (d.lastIndex = 0; (b = d.exec(p)) !== null; ) {
              var v = b[2];
              v.indexOf('"') === 0 && v.lastIndexOf('"') === v.length - 1 && (v = v.slice(1, -1)), y[b[1]] = v;
            }
            return y;
          }, m);
          function m(p) {
            for (var b in typeof p == "string" && (p = m.parseAttrList(p)), p)
              p.hasOwnProperty(b) && (this[b] = p[b]);
          }
          l.default = f;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/utils/binary-search.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 }), l.default = { search: function(h, c) {
          for (var d = 0, f = h.length - 1, m = null, p = null; d <= f; ) {
            var b = c(p = h[m = (d + f) / 2 | 0]);
            if (0 < b)
              d = m + 1;
            else {
              if (!(b < 0))
                return p;
              f = m - 1;
            }
          }
          return null;
        } };
      }, "./src/utils/buffer-helper.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = (c.isBuffered = function(d, f) {
          try {
            if (d) {
              for (var m = d.buffered, p = 0; p < m.length; p++)
                if (f >= m.start(p) && f <= m.end(p))
                  return !0;
            }
          } catch {
          }
          return !1;
        }, c.bufferInfo = function(d, f, m) {
          try {
            if (d) {
              var p = d.buffered, b = [], y = void 0;
              for (y = 0; y < p.length; y++)
                b.push({ start: p.start(y), end: p.end(y) });
              return this.bufferedInfo(b, f, m);
            }
          } catch {
          }
          return { len: 0, start: f, end: f, nextStart: void 0 };
        }, c.bufferedInfo = function(d, f, m) {
          var p, b, y, v, g, E = [];
          for (d.sort(function(C, D) {
            var R = C.start - D.start;
            return R || D.end - C.end;
          }), g = 0; g < d.length; g++) {
            var x = E.length;
            if (x) {
              var w = E[x - 1].end;
              d[g].start - w < m ? d[g].end > w && (E[x - 1].end = d[g].end) : E.push(d[g]);
            } else
              E.push(d[g]);
          }
          for (p = g = 0, b = y = f; g < E.length; g++) {
            var S = E[g].start, T = E[g].end;
            if (S <= f + m && f < T)
              b = S, p = (y = T) - f;
            else if (f + m < S) {
              v = S;
              break;
            }
          }
          return { len: p, start: b, end: y, nextStart: v };
        }, c);
        function c() {
        }
        l.BufferHelper = h;
      }, "./src/utils/cea-608-parser.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        function h(O) {
          var M = O;
          return d.hasOwnProperty(O) && (M = d[O]), String.fromCharCode(M);
        }
        function c(O) {
          for (var M = [], F = 0; F < O.length; F++)
            M.push(O[F].toString(16));
          return M;
        }
        var d = { 42: 225, 92: 233, 94: 237, 95: 243, 96: 250, 123: 231, 124: 247, 125: 209, 126: 241, 127: 9608, 128: 174, 129: 176, 130: 189, 131: 191, 132: 8482, 133: 162, 134: 163, 135: 9834, 136: 224, 137: 32, 138: 232, 139: 226, 140: 234, 141: 238, 142: 244, 143: 251, 144: 193, 145: 201, 146: 211, 147: 218, 148: 220, 149: 252, 150: 8216, 151: 161, 152: 42, 153: 8217, 154: 9473, 155: 169, 156: 8480, 157: 8226, 158: 8220, 159: 8221, 160: 192, 161: 194, 162: 199, 163: 200, 164: 202, 165: 203, 166: 235, 167: 206, 168: 207, 169: 239, 170: 212, 171: 217, 172: 249, 173: 219, 174: 171, 175: 187, 176: 195, 177: 227, 178: 205, 179: 204, 180: 236, 181: 210, 182: 242, 183: 213, 184: 245, 185: 123, 186: 125, 187: 92, 188: 94, 189: 95, 190: 124, 191: 8764, 192: 196, 193: 228, 194: 214, 195: 246, 196: 223, 197: 165, 198: 164, 199: 9475, 200: 197, 201: 229, 202: 216, 203: 248, 204: 9487, 205: 9491, 206: 9495, 207: 9499 }, f = { 17: 1, 18: 3, 21: 5, 22: 7, 23: 9, 16: 11, 19: 12, 20: 14 }, m = { 17: 2, 18: 4, 21: 6, 22: 8, 23: 10, 19: 13, 20: 15 }, p = { 25: 1, 26: 3, 29: 5, 30: 7, 31: 9, 24: 11, 27: 12, 28: 14 }, b = { 25: 2, 26: 4, 29: 6, 30: 8, 31: 10, 27: 13, 28: 15 }, y = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"], v = { verboseFilter: { DATA: 3, DEBUG: 3, INFO: 2, WARNING: 2, TEXT: 1, ERROR: 0 }, time: null, verboseLevel: 0, setTime: function(O) {
          this.time = O;
        }, log: function(O, M) {
          this.verboseFilter[O], this.verboseLevel;
        } }, g = (E.prototype.reset = function() {
          this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
        }, E.prototype.setStyles = function(O) {
          for (var M = ["foreground", "underline", "italics", "background", "flash"], F = 0; F < M.length; F++) {
            var G = M[F];
            O.hasOwnProperty(G) && (this[G] = O[G]);
          }
        }, E.prototype.isDefault = function() {
          return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
        }, E.prototype.equals = function(O) {
          return this.foreground === O.foreground && this.underline === O.underline && this.italics === O.italics && this.background === O.background && this.flash === O.flash;
        }, E.prototype.copy = function(O) {
          this.foreground = O.foreground, this.underline = O.underline, this.italics = O.italics, this.background = O.background, this.flash = O.flash;
        }, E.prototype.toString = function() {
          return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
        }, E);
        function E(O, M, F, G, K) {
          this.foreground = O || "white", this.underline = M || !1, this.italics = F || !1, this.background = G || "black", this.flash = K || !1;
        }
        var x = (w.prototype.reset = function() {
          this.uchar = " ", this.penState.reset();
        }, w.prototype.setChar = function(O, M) {
          this.uchar = O, this.penState.copy(M);
        }, w.prototype.setPenState = function(O) {
          this.penState.copy(O);
        }, w.prototype.equals = function(O) {
          return this.uchar === O.uchar && this.penState.equals(O.penState);
        }, w.prototype.copy = function(O) {
          this.uchar = O.uchar, this.penState.copy(O.penState);
        }, w.prototype.isEmpty = function() {
          return this.uchar === " " && this.penState.isDefault();
        }, w);
        function w(O, M, F, G, K, J) {
          this.uchar = O || " ", this.penState = new g(M, F, G, K, J);
        }
        var S = (T.prototype.equals = function(O) {
          for (var M = !0, F = 0; F < 100; F++)
            if (!this.chars[F].equals(O.chars[F])) {
              M = !1;
              break;
            }
          return M;
        }, T.prototype.copy = function(O) {
          for (var M = 0; M < 100; M++)
            this.chars[M].copy(O.chars[M]);
        }, T.prototype.isEmpty = function() {
          for (var O = !0, M = 0; M < 100; M++)
            if (!this.chars[M].isEmpty()) {
              O = !1;
              break;
            }
          return O;
        }, T.prototype.setCursor = function(O) {
          this.pos !== O && (this.pos = O), this.pos < 0 ? (v.log("ERROR", "Negative cursor position " + this.pos), this.pos = 0) : 100 < this.pos && (v.log("ERROR", "Too large cursor position " + this.pos), this.pos = 100);
        }, T.prototype.moveCursor = function(O) {
          var M = this.pos + O;
          if (1 < O)
            for (var F = this.pos + 1; F < M + 1; F++)
              this.chars[F].setPenState(this.currPenState);
          this.setCursor(M);
        }, T.prototype.backSpace = function() {
          this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
        }, T.prototype.insertChar = function(O) {
          144 <= O && this.backSpace();
          var M = h(O);
          100 <= this.pos ? v.log("ERROR", "Cannot insert " + O.toString(16) + " (" + M + ") at position " + this.pos + ". Skipping it!") : (this.chars[this.pos].setChar(M, this.currPenState), this.moveCursor(1));
        }, T.prototype.clearFromPos = function(O) {
          var M;
          for (M = O; M < 100; M++)
            this.chars[M].reset();
        }, T.prototype.clear = function() {
          this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
        }, T.prototype.clearToEndOfRow = function() {
          this.clearFromPos(this.pos);
        }, T.prototype.getTextString = function() {
          for (var O = [], M = !0, F = 0; F < 100; F++) {
            var G = this.chars[F].uchar;
            G !== " " && (M = !1), O.push(G);
          }
          return M ? "" : O.join("");
        }, T.prototype.setPenStyles = function(O) {
          this.currPenState.setStyles(O), this.chars[this.pos].setPenState(this.currPenState);
        }, T);
        function T() {
          this.chars = [];
          for (var O = 0; O < 100; O++)
            this.chars.push(new x());
          this.pos = 0, this.currPenState = new g();
        }
        var C = (D.prototype.reset = function() {
          for (var O = 0; O < 15; O++)
            this.rows[O].clear();
          this.currRow = 14;
        }, D.prototype.equals = function(O) {
          for (var M = !0, F = 0; F < 15; F++)
            if (!this.rows[F].equals(O.rows[F])) {
              M = !1;
              break;
            }
          return M;
        }, D.prototype.copy = function(O) {
          for (var M = 0; M < 15; M++)
            this.rows[M].copy(O.rows[M]);
        }, D.prototype.isEmpty = function() {
          for (var O = !0, M = 0; M < 15; M++)
            if (!this.rows[M].isEmpty()) {
              O = !1;
              break;
            }
          return O;
        }, D.prototype.backSpace = function() {
          this.rows[this.currRow].backSpace();
        }, D.prototype.clearToEndOfRow = function() {
          this.rows[this.currRow].clearToEndOfRow();
        }, D.prototype.insertChar = function(O) {
          this.rows[this.currRow].insertChar(O);
        }, D.prototype.setPen = function(O) {
          this.rows[this.currRow].setPenStyles(O);
        }, D.prototype.moveCursor = function(O) {
          this.rows[this.currRow].moveCursor(O);
        }, D.prototype.setCursor = function(O) {
          v.log("INFO", "setCursor: " + O), this.rows[this.currRow].setCursor(O);
        }, D.prototype.setPAC = function(O) {
          v.log("INFO", "pacData = " + JSON.stringify(O));
          var M = O.row - 1;
          if (this.nrRollUpRows && M < this.nrRollUpRows - 1 && (M = this.nrRollUpRows - 1), this.nrRollUpRows && this.currRow !== M) {
            for (var F = 0; F < 15; F++)
              this.rows[F].clear();
            var G = this.currRow + 1 - this.nrRollUpRows, K = this.lastOutputScreen;
            if (K) {
              var J = K.rows[G].cueStartTime;
              if (J && J < v.time)
                for (F = 0; F < this.nrRollUpRows; F++)
                  this.rows[M - this.nrRollUpRows + F + 1].copy(K.rows[G + F]);
            }
          }
          this.currRow = M;
          var ue = this.rows[this.currRow];
          if (O.indent !== null) {
            var ce = O.indent, ee = Math.max(ce - 1, 0);
            ue.setCursor(O.indent), O.color = ue.chars[ee].penState.foreground;
          }
          var me = { foreground: O.color, underline: O.underline, italics: O.italics, background: "black", flash: !1 };
          this.setPen(me);
        }, D.prototype.setBkgData = function(O) {
          v.log("INFO", "bkgData = " + JSON.stringify(O)), this.backSpace(), this.setPen(O), this.insertChar(32);
        }, D.prototype.setRollUpRows = function(O) {
          this.nrRollUpRows = O;
        }, D.prototype.rollUp = function() {
          if (this.nrRollUpRows !== null) {
            v.log("TEXT", this.getDisplayText());
            var O = this.currRow + 1 - this.nrRollUpRows, M = this.rows.splice(O, 1)[0];
            M.clear(), this.rows.splice(this.currRow, 0, M), v.log("INFO", "Rolling up");
          } else
            v.log("DEBUG", "roll_up but nrRollUpRows not set yet");
        }, D.prototype.getDisplayText = function(O) {
          O = O || !1;
          for (var M = [], F = "", G = -1, K = 0; K < 15; K++) {
            var J = this.rows[K].getTextString();
            J && (G = K + 1, O ? M.push("Row " + G + ": '" + J + "'") : M.push(J.trim()));
          }
          return 0 < M.length && (F = O ? "[" + M.join(" | ") + "]" : M.join(`
`)), F;
        }, D.prototype.getTextAndFormat = function() {
          return this.rows;
        }, D);
        function D() {
          this.rows = [];
          for (var O = 0; O < 15; O++)
            this.rows.push(new S());
          this.currRow = 14, this.nrRollUpRows = null, this.reset();
        }
        var R = (P.prototype.reset = function() {
          this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.currRollUpRow = this.displayedMemory.rows[14], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.lastCueEndTime = null;
        }, P.prototype.getHandler = function() {
          return this.outputFilter;
        }, P.prototype.setHandler = function(O) {
          this.outputFilter = O;
        }, P.prototype.setPAC = function(O) {
          this.writeScreen.setPAC(O);
        }, P.prototype.setBkgData = function(O) {
          this.writeScreen.setBkgData(O);
        }, P.prototype.setMode = function(O) {
          O !== this.mode && (this.mode = O, v.log("INFO", "MODE=" + O), this.mode === "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = O);
        }, P.prototype.insertChars = function(O) {
          for (var M = 0; M < O.length; M++)
            this.writeScreen.insertChar(O[M]);
          var F = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
          v.log("INFO", F + ": " + this.writeScreen.getDisplayText(!0)), this.mode !== "MODE_PAINT-ON" && this.mode !== "MODE_ROLL-UP" || (v.log("TEXT", "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
        }, P.prototype.ccRCL = function() {
          v.log("INFO", "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
        }, P.prototype.ccBS = function() {
          v.log("INFO", "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
        }, P.prototype.ccAOF = function() {
        }, P.prototype.ccAON = function() {
        }, P.prototype.ccDER = function() {
          v.log("INFO", "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
        }, P.prototype.ccRU = function(O) {
          v.log("INFO", "RU(" + O + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(O);
        }, P.prototype.ccFON = function() {
          v.log("INFO", "FON - Flash On"), this.writeScreen.setPen({ flash: !0 });
        }, P.prototype.ccRDC = function() {
          v.log("INFO", "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
        }, P.prototype.ccTR = function() {
          v.log("INFO", "TR"), this.setMode("MODE_TEXT");
        }, P.prototype.ccRTD = function() {
          v.log("INFO", "RTD"), this.setMode("MODE_TEXT");
        }, P.prototype.ccEDM = function() {
          v.log("INFO", "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate(!0);
        }, P.prototype.ccCR = function() {
          v.log("CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate(!0);
        }, P.prototype.ccENM = function() {
          v.log("INFO", "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
        }, P.prototype.ccEOC = function() {
          if (v.log("INFO", "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
            var O = this.displayedMemory;
            this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = O, this.writeScreen = this.nonDisplayedMemory, v.log("TEXT", "DISP: " + this.displayedMemory.getDisplayText());
          }
          this.outputDataUpdate(!0);
        }, P.prototype.ccTO = function(O) {
          v.log("INFO", "TO(" + O + ") - Tab Offset"), this.writeScreen.moveCursor(O);
        }, P.prototype.ccMIDROW = function(O) {
          var M = { flash: !1 };
          if (M.underline = O % 2 == 1, M.italics = 46 <= O, M.italics)
            M.foreground = "white";
          else {
            var F = Math.floor(O / 2) - 16;
            M.foreground = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"][F];
          }
          v.log("INFO", "MIDROW: " + JSON.stringify(M)), this.writeScreen.setPen(M);
        }, P.prototype.outputDataUpdate = function(O) {
          O === void 0 && (O = !1);
          var M = v.time;
          M !== null && this.outputFilter && (this.cueStartTime !== null || this.displayedMemory.isEmpty() ? this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue && (this.outputFilter.newCue(this.cueStartTime, M, this.lastOutputScreen), O === !0 && this.outputFilter.dispatchCue && this.outputFilter.dispatchCue()), this.cueStartTime = this.displayedMemory.isEmpty() ? null : M) : this.cueStartTime = M, this.lastOutputScreen.copy(this.displayedMemory));
        }, P.prototype.cueSplitAtTime = function(O) {
          this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, O, this.displayedMemory), this.cueStartTime = O));
        }, P);
        function P(O, M) {
          this.chNr = O, this.outputFilter = M, this.mode = null, this.verbose = 0, this.displayedMemory = new C(), this.nonDisplayedMemory = new C(), this.lastOutputScreen = new C(), this.currRollUpRow = this.displayedMemory.rows[14], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
        }
        var N = ($.prototype.getHandler = function(O) {
          return this.channels[O].getHandler();
        }, $.prototype.setHandler = function(O, M) {
          this.channels[O].setHandler(M);
        }, $.prototype.addData = function(O, M) {
          var F, G, K, J = !1;
          this.lastTime = O, v.setTime(O);
          for (var ue = 0; ue < M.length; ue += 2)
            G = 127 & M[ue], K = 127 & M[ue + 1], G != 0 || K != 0 ? (v.log("DATA", "[" + c([M[ue], M[ue + 1]]) + "] -> (" + c([G, K]) + ")"), (F = (F = (F = (F = this.parseCmd(G, K)) || this.parseMidrow(G, K)) || this.parsePAC(G, K)) || this.parseBackgroundAttributes(G, K)) || (J = this.parseChars(G, K)) && (this.currChNr && 0 <= this.currChNr ? this.channels[this.currChNr - 1].insertChars(J) : v.log("WARNING", "No channel found yet. TEXT-MODE?")), F ? this.dataCounters.cmd += 2 : J ? this.dataCounters.char += 2 : (this.dataCounters.other += 2, v.log("WARNING", "Couldn't parse cleaned data " + c([G, K]) + " orig: " + c([M[ue], M[ue + 1]])))) : this.dataCounters.padding += 2;
        }, $.prototype.parseCmd = function(O, M) {
          var F = null;
          if (!((O === 20 || O === 28) && 32 <= M && M <= 47 || (O === 23 || O === 31) && 33 <= M && M <= 35))
            return !1;
          if (O === this.lastCmdA && M === this.lastCmdB)
            return this.lastCmdA = null, this.lastCmdB = null, v.log("DEBUG", "Repeated command (" + c([O, M]) + ") is dropped"), !0;
          F = O === 20 || O === 23 ? 1 : 2;
          var G = this.channels[F - 1];
          return O === 20 || O === 28 ? M === 32 ? G.ccRCL() : M === 33 ? G.ccBS() : M === 34 ? G.ccAOF() : M === 35 ? G.ccAON() : M === 36 ? G.ccDER() : M === 37 ? G.ccRU(2) : M === 38 ? G.ccRU(3) : M === 39 ? G.ccRU(4) : M === 40 ? G.ccFON() : M === 41 ? G.ccRDC() : M === 42 ? G.ccTR() : M === 43 ? G.ccRTD() : M === 44 ? G.ccEDM() : M === 45 ? G.ccCR() : M === 46 ? G.ccENM() : M === 47 && G.ccEOC() : G.ccTO(M - 32), this.lastCmdA = O, this.lastCmdB = M, this.currChNr = F, !0;
        }, $.prototype.parseMidrow = function(O, M) {
          var F = null;
          return (O === 17 || O === 25) && 32 <= M && M <= 47 && ((F = O === 17 ? 1 : 2) !== this.currChNr ? (v.log("ERROR", "Mismatch channel in midrow parsing"), !1) : (this.channels[F - 1].ccMIDROW(M), v.log("DEBUG", "MIDROW (" + c([O, M]) + ")"), !0));
        }, $.prototype.parsePAC = function(O, M) {
          var F, G = null;
          if (!((17 <= O && O <= 23 || 25 <= O && O <= 31) && 64 <= M && M <= 127 || (O === 16 || O === 24) && 64 <= M && M <= 95))
            return !1;
          if (O === this.lastCmdA && M === this.lastCmdB)
            return this.lastCmdA = null, !(this.lastCmdB = null);
          F = O <= 23 ? 1 : 2, G = 64 <= M && M <= 95 ? F == 1 ? f[O] : p[O] : F == 1 ? m[O] : b[O];
          var K = this.interpretPAC(G, M);
          return this.channels[F - 1].setPAC(K), this.lastCmdA = O, this.lastCmdB = M, this.currChNr = F, !0;
        }, $.prototype.interpretPAC = function(O, M) {
          var F = M, G = { color: null, italics: !1, indent: null, underline: !1, row: O };
          return F = 95 < M ? M - 96 : M - 64, G.underline = (1 & F) == 1, F <= 13 ? G.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(F / 2)] : F <= 15 ? (G.italics = !0, G.color = "white") : G.indent = 4 * Math.floor((F - 16) / 2), G;
        }, $.prototype.parseChars = function(O, M) {
          var F = null, G = null, K = null;
          if (17 <= (K = 25 <= O ? (F = 2, O - 8) : (F = 1, O)) && K <= 19) {
            var J = M;
            J = K === 17 ? M + 80 : K === 18 ? M + 112 : M + 144, v.log("INFO", "Special char '" + h(J) + "' in channel " + F), G = [J];
          } else
            32 <= O && O <= 127 && (G = M === 0 ? [O] : [O, M]);
          if (G) {
            var ue = c(G);
            v.log("DEBUG", "Char codes =  " + ue.join(",")), this.lastCmdA = null, this.lastCmdB = null;
          }
          return G;
        }, $.prototype.parseBackgroundAttributes = function(O, M) {
          var F, G, K;
          return ((O === 16 || O === 24) && 32 <= M && M <= 47 || (O === 23 || O === 31) && 45 <= M && M <= 47) && (F = {}, O === 16 || O === 24 ? (G = Math.floor((M - 32) / 2), F.background = y[G], M % 2 == 1 && (F.background = F.background + "_semi")) : M === 45 ? F.background = "transparent" : (F.foreground = "black", M === 47 && (F.underline = !0)), K = O < 24 ? 1 : 2, this.channels[K - 1].setBkgData(F), this.lastCmdA = null, !(this.lastCmdB = null));
        }, $.prototype.reset = function() {
          for (var O = 0; O < this.channels.length; O++)
            this.channels[O] && this.channels[O].reset();
          this.lastCmdA = null, this.lastCmdB = null;
        }, $.prototype.cueSplitAtTime = function(O) {
          for (var M = 0; M < this.channels.length; M++)
            this.channels[M] && this.channels[M].cueSplitAtTime(O);
        }, $);
        function $(O, M, F) {
          this.field = O || 1, this.outputs = [M, F], this.channels = [new R(1, M), new R(2, F)], this.currChNr = -1, this.lastCmdA = null, this.lastCmdB = null, this.bufferedData = [], this.startTime = null, this.lastTime = null, this.dataCounters = { padding: 0, char: 0, cmd: 0, other: 0 };
        }
        l.default = N;
      }, "./src/utils/codecs.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = { audio: { a3ds: !0, "ac-3": !0, "ac-4": !0, alac: !0, alaw: !0, dra1: !0, "dts+": !0, "dts-": !0, dtsc: !0, dtse: !0, dtsh: !0, "ec-3": !0, enca: !0, g719: !0, g726: !0, m4ae: !0, mha1: !0, mha2: !0, mhm1: !0, mhm2: !0, mlpa: !0, mp4a: !0, "raw ": !0, Opus: !0, samr: !0, sawb: !0, sawp: !0, sevc: !0, sqcp: !0, ssmv: !0, twos: !0, ulaw: !0 }, video: { avc1: !0, avc2: !0, avc3: !0, avc4: !0, avcp: !0, drac: !0, dvav: !0, dvhe: !0, encv: !0, hev1: !0, hvc1: !0, mjp2: !0, mp4v: !0, mvc1: !0, mvc2: !0, mvc3: !0, mvc4: !0, resv: !0, rv60: !0, s263: !0, svc1: !0, svc2: !0, "vc-1": !0, vp08: !0, vp09: !0 } };
        l.isCodecType = function(c, d) {
          var f = h[d];
          return !!f && f[c.slice(0, 4)] === !0;
        }, l.isCodecSupportedInMp4 = function(c, d) {
          return window.MediaSource.isTypeSupported((d || "video") + '/mp4;codecs="' + c + '"');
        };
      }, "./src/utils/cues.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./src/utils/vttparser.js");
        l.newCue = function(c, d, f, m) {
          for (var p, b, y, v, g, E = window.VTTCue || window.TextTrackCue, x = 0; x < m.rows.length; x++)
            if (y = !0, v = 0, g = "", !(p = m.rows[x]).isEmpty()) {
              for (var w = 0; w < p.chars.length; w++)
                p.chars[w].uchar.match(/\s/) && y ? v++ : (g += p.chars[w].uchar, y = !1);
              (p.cueStartTime = d) === f && (f += 1e-4), b = new E(d, f, h.fixLineBreaks(g.trim())), 16 <= v ? v-- : v++, navigator.userAgent.match(/Firefox\//) ? b.line = x + 1 : b.line = 7 < x ? x - 2 : x + 1, b.align = "left", b.position = Math.max(0, Math.min(100, v / 32 * 100 + (navigator.userAgent.match(/Firefox\//) ? 50 : 0))), c.addCue(b);
            }
        };
      }, "./src/utils/discontinuities.js": function(o, l, u) {
        (function(h) {
          Object.defineProperty(l, "__esModule", { value: !0 });
          var c = u("./src/utils/binary-search.js"), d = u("./src/utils/logger.js");
          function f(g, E) {
            for (var x = null, w = 0; w < g.length; w += 1) {
              var S = g[w];
              if (S && S.cc === E) {
                x = S;
                break;
              }
            }
            return x;
          }
          function m(g, E, x) {
            var w = !1;
            return E && E.details && x && (x.endCC > x.startCC || g && g.cc < x.startCC) && (w = !0), w;
          }
          function p(g, E) {
            var x = g.fragments, w = E.fragments;
            if (w.length && x.length) {
              var S = f(x, w[0].cc);
              if (S && (!S || S.startPTS))
                return S;
              d.logger.log("No frag in previous level to align on");
            } else
              d.logger.log("No fragments to align");
          }
          function b(g, E) {
            E.fragments.forEach(function(x) {
              if (x) {
                var w = x.start + g;
                x.start = x.startPTS = w, x.endPTS = w + x.duration;
              }
            }), E.PTSKnown = !0;
          }
          function y(g, E, x) {
            if (m(g, x, E)) {
              var w = p(x.details, E);
              w && (d.logger.log("Adjusting PTS using last level due to CC increase within current level"), b(w.start, E));
            }
          }
          function v(g, E) {
            if (E && E.fragments.length) {
              if (!g.hasProgramDateTime || !E.hasProgramDateTime)
                return;
              var x = E.fragments[0].programDateTime, w = (g.fragments[0].programDateTime - x) / 1e3 + E.fragments[0].start;
              h.isFinite(w) && (d.logger.log("adjusting PTS using programDateTime delta, sliding:" + w.toFixed(3)), b(w, g));
            }
          }
          l.findFirstFragWithCC = f, l.findFragWithCC = function(g, E) {
            return c.default.search(g, function(x) {
              return x.cc < E ? 1 : x.cc > E ? -1 : 0;
            });
          }, l.shouldAlignOnDiscontinuities = m, l.findDiscontinuousReferenceFrag = p, l.adjustPts = b, l.alignStream = function(g, E, x) {
            y(g, x, E), !x.PTSKnown && E && v(x, E.details);
          }, l.alignDiscontinuities = y, l.alignPDT = v;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/utils/ewma-bandwidth-estimator.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./src/utils/ewma.js"), c = (d.prototype.sample = function(f, m) {
          var p = 8e3 * m / (f = Math.max(f, this.minDelayMs_)), b = f / 1e3;
          this.fast_.sample(b, p), this.slow_.sample(b, p);
        }, d.prototype.canEstimate = function() {
          var f = this.fast_;
          return f && f.getTotalWeight() >= this.minWeight_;
        }, d.prototype.getEstimate = function() {
          return this.canEstimate() ? Math.min(this.fast_.getEstimate(), this.slow_.getEstimate()) : this.defaultEstimate_;
        }, d.prototype.destroy = function() {
        }, d);
        function d(f, m, p, b) {
          this.hls = f, this.defaultEstimate_ = b, this.minWeight_ = 1e-3, this.minDelayMs_ = 50, this.slow_ = new h.default(m), this.fast_ = new h.default(p);
        }
        l.default = c;
      }, "./src/utils/ewma.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = (c.prototype.sample = function(d, f) {
          var m = Math.pow(this.alpha_, d);
          this.estimate_ = f * (1 - m) + m * this.estimate_, this.totalWeight_ += d;
        }, c.prototype.getTotalWeight = function() {
          return this.totalWeight_;
        }, c.prototype.getEstimate = function() {
          if (this.alpha_) {
            var d = 1 - Math.pow(this.alpha_, this.totalWeight_);
            return this.estimate_ / d;
          }
          return this.estimate_;
        }, c);
        function c(d) {
          this.alpha_ = d ? Math.exp(Math.log(0.5) / d) : 0, this.estimate_ = 0, this.totalWeight_ = 0;
        }
        l.default = h;
      }, "./src/utils/get-self-scope.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 }), l.getSelfScope = function() {
          return typeof window > "u" ? self : window;
        };
      }, "./src/utils/logger.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./src/utils/get-self-scope.js");
        function c() {
        }
        var d = { trace: c, debug: c, log: c, warn: c, info: c, error: c }, f = d, m = h.getSelfScope();
        function p(b) {
          for (var y = [], v = 1; v < arguments.length; v++)
            y[v - 1] = arguments[v];
          y.forEach(function(g) {
            f[g] = b[g] ? b[g].bind(b) : function(E) {
              var x = m.console[E];
              return x ? function() {
                for (var w = [], S = 0; S < arguments.length; S++)
                  w[S] = arguments[S];
                w[0] && (w[0] = function(T, C) {
                  return C = "[" + T + "] > " + C;
                }(E, w[0])), x.apply(m.console, w);
              } : c;
            }(g);
          });
        }
        l.enableLogs = function(b) {
          if (b === !0 || typeof b == "object") {
            p(b, "debug", "log", "info", "warn", "error");
            try {
              f.log();
            } catch {
              f = d;
            }
          } else
            f = d;
        }, l.logger = f;
      }, "./src/utils/mediakeys-helper.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = typeof window < "u" && window.navigator && window.navigator.requestMediaKeySystemAccess ? window.navigator.requestMediaKeySystemAccess.bind(window.navigator) : null;
        l.requestMediaKeySystemAccess = h;
      }, "./src/utils/mediasource-helper.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 }), l.getMediaSource = function() {
          if (typeof window < "u")
            return window.MediaSource || window.WebKitMediaSource;
        };
      }, "./src/utils/output-filter.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = (c.prototype.dispatchCue = function() {
          this.startTime !== null && (this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen), this.startTime = null);
        }, c.prototype.newCue = function(d, f, m) {
          (this.startTime === null || this.startTime > d) && (this.startTime = d), this.endTime = f, this.screen = m, this.timelineController.createCaptionsTrack(this.trackName);
        }, c);
        function c(d, f) {
          this.timelineController = d, this.trackName = f, this.startTime = null, this.endTime = null, this.screen = null;
        }
        l.default = h;
      }, "./src/utils/texttrack-utils.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 }), l.sendAddTrackEvent = function(h, c) {
          var d = null;
          try {
            d = new window.Event("addtrack");
          } catch {
            (d = document.createEvent("Event")).initEvent("addtrack", !1, !1);
          }
          d.track = h, c.dispatchEvent(d);
        }, l.clearCurrentCues = function(h) {
          if (h && h.cues)
            for (; 0 < h.cues.length; )
              h.removeCue(h.cues[0]);
        };
      }, "./src/utils/time-ranges.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 }), l.default = { toString: function(h) {
          for (var c = "", d = h.length, f = 0; f < d; f++)
            c += "[" + h.start(f).toFixed(3) + "," + h.end(f).toFixed(3) + "]";
          return c;
        } };
      }, "./src/utils/vttcue.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 }), l.default = function() {
          if (typeof window < "u" && window.VTTCue)
            return window.VTTCue;
          var h = { "": !0, lr: !0, rl: !0 }, c = { start: !0, middle: !0, end: !0, left: !0, right: !0 };
          function d(p) {
            return typeof p == "string" && !!c[p.toLowerCase()] && p.toLowerCase();
          }
          function f(p) {
            for (var b = 1; b < arguments.length; b++) {
              var y = arguments[b];
              for (var v in y)
                p[v] = y[v];
            }
            return p;
          }
          function m(p, b, y) {
            var v = this, g = function() {
              if (typeof navigator < "u")
                return /MSIE\s8\.0/.test(navigator.userAgent);
            }(), E = {};
            g ? v = document.createElement("custom") : E.enumerable = !0, v.hasBeenReset = !1;
            var x = "", w = !1, S = p, T = b, C = y, D = null, R = "", P = !0, N = "auto", $ = "start", O = 50, M = "middle", F = 50, G = "middle";
            if (Object.defineProperty(v, "id", f({}, E, { get: function() {
              return x;
            }, set: function(K) {
              x = "" + K;
            } })), Object.defineProperty(v, "pauseOnExit", f({}, E, { get: function() {
              return w;
            }, set: function(K) {
              w = !!K;
            } })), Object.defineProperty(v, "startTime", f({}, E, { get: function() {
              return S;
            }, set: function(K) {
              if (typeof K != "number")
                throw new TypeError("Start time must be set to a number.");
              S = K, this.hasBeenReset = !0;
            } })), Object.defineProperty(v, "endTime", f({}, E, { get: function() {
              return T;
            }, set: function(K) {
              if (typeof K != "number")
                throw new TypeError("End time must be set to a number.");
              T = K, this.hasBeenReset = !0;
            } })), Object.defineProperty(v, "text", f({}, E, { get: function() {
              return C;
            }, set: function(K) {
              C = "" + K, this.hasBeenReset = !0;
            } })), Object.defineProperty(v, "region", f({}, E, { get: function() {
              return D;
            }, set: function(K) {
              D = K, this.hasBeenReset = !0;
            } })), Object.defineProperty(v, "vertical", f({}, E, { get: function() {
              return R;
            }, set: function(K) {
              var J = function(ue) {
                return typeof ue == "string" && !!h[ue.toLowerCase()] && ue.toLowerCase();
              }(K);
              if (J === !1)
                throw new SyntaxError("An invalid or illegal string was specified.");
              R = J, this.hasBeenReset = !0;
            } })), Object.defineProperty(v, "snapToLines", f({}, E, { get: function() {
              return P;
            }, set: function(K) {
              P = !!K, this.hasBeenReset = !0;
            } })), Object.defineProperty(v, "line", f({}, E, { get: function() {
              return N;
            }, set: function(K) {
              if (typeof K != "number" && K !== "auto")
                throw new SyntaxError("An invalid number or illegal string was specified.");
              N = K, this.hasBeenReset = !0;
            } })), Object.defineProperty(v, "lineAlign", f({}, E, { get: function() {
              return $;
            }, set: function(K) {
              var J = d(K);
              if (!J)
                throw new SyntaxError("An invalid or illegal string was specified.");
              $ = J, this.hasBeenReset = !0;
            } })), Object.defineProperty(v, "position", f({}, E, { get: function() {
              return O;
            }, set: function(K) {
              if (K < 0 || 100 < K)
                throw new Error("Position must be between 0 and 100.");
              O = K, this.hasBeenReset = !0;
            } })), Object.defineProperty(v, "positionAlign", f({}, E, { get: function() {
              return M;
            }, set: function(K) {
              var J = d(K);
              if (!J)
                throw new SyntaxError("An invalid or illegal string was specified.");
              M = J, this.hasBeenReset = !0;
            } })), Object.defineProperty(v, "size", f({}, E, { get: function() {
              return F;
            }, set: function(K) {
              if (K < 0 || 100 < K)
                throw new Error("Size must be between 0 and 100.");
              F = K, this.hasBeenReset = !0;
            } })), Object.defineProperty(v, "align", f({}, E, { get: function() {
              return G;
            }, set: function(K) {
              var J = d(K);
              if (!J)
                throw new SyntaxError("An invalid or illegal string was specified.");
              G = J, this.hasBeenReset = !0;
            } })), v.displayState = void 0, g)
              return v;
          }
          return m.prototype.getCueAsHTML = function() {
            return window.WebVTT.convertCueToDOMTree(window, this.text);
          }, m;
        }();
      }, "./src/utils/vttparser.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        function h() {
          return { decode: function(g) {
            if (!g)
              return "";
            if (typeof g != "string")
              throw new Error("Error - expected string data.");
            return decodeURIComponent(encodeURIComponent(g));
          } };
        }
        var c = u("./src/utils/vttcue.js");
        function d() {
          this.window = window, this.state = "INITIAL", this.buffer = "", this.decoder = new h(), this.regionList = [];
        }
        function f() {
          this.values = /* @__PURE__ */ Object.create(null);
        }
        function m(g, E, x, w) {
          var S = w ? g.split(w) : [g];
          for (var T in S)
            if (typeof S[T] == "string") {
              var C = S[T].split(x);
              C.length === 2 && E(C[0], C[1]);
            }
        }
        f.prototype = { set: function(g, E) {
          this.get(g) || E === "" || (this.values[g] = E);
        }, get: function(g, E, x) {
          return x ? this.has(g) ? this.values[g] : E[x] : this.has(g) ? this.values[g] : E;
        }, has: function(g) {
          return g in this.values;
        }, alt: function(g, E, x) {
          for (var w = 0; w < x.length; ++w)
            if (E === x[w]) {
              this.set(g, E);
              break;
            }
        }, integer: function(g, E) {
          /^-?\d+$/.test(E) && this.set(g, parseInt(E, 10));
        }, percent: function(g, E) {
          return !!(E.match(/^([\d]{1,3})(\.[\d]*)?%$/) && 0 <= (E = parseFloat(E)) && E <= 100) && (this.set(g, E), !0);
        } };
        var p = new c.default(0, 0, 0), b = p.align === "middle" ? "middle" : "center";
        function y(g, E, x) {
          var w = g;
          function S() {
            var C = function(D) {
              function R(N, $, O, M) {
                return 3600 * (0 | N) + 60 * (0 | $) + (0 | O) + (0 | M) / 1e3;
              }
              var P = D.match(/^(\d+):(\d{2})(:\d{2})?\.(\d{3})/);
              return P ? P[3] ? R(P[1], P[2], P[3].replace(":", ""), P[4]) : 59 < P[1] ? R(P[1], P[2], 0, P[4]) : R(0, P[1], P[2], P[4]) : null;
            }(g);
            if (C === null)
              throw new Error("Malformed timestamp: " + w);
            return g = g.replace(/^[^\sa-zA-Z-]+/, ""), C;
          }
          function T() {
            g = g.replace(/^\s+/, "");
          }
          if (T(), E.startTime = S(), T(), g.substr(0, 3) !== "-->")
            throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + w);
          g = g.substr(3), T(), E.endTime = S(), T(), function(C, D) {
            var R = new f();
            m(C, function($, O) {
              switch ($) {
                case "region":
                  for (var M = x.length - 1; 0 <= M; M--)
                    if (x[M].id === O) {
                      R.set($, x[M].region);
                      break;
                    }
                  break;
                case "vertical":
                  R.alt($, O, ["rl", "lr"]);
                  break;
                case "line":
                  var F = O.split(","), G = F[0];
                  R.integer($, G), R.percent($, G) && R.set("snapToLines", !1), R.alt($, G, ["auto"]), F.length === 2 && R.alt("lineAlign", F[1], ["start", b, "end"]);
                  break;
                case "position":
                  F = O.split(","), R.percent($, F[0]), F.length === 2 && R.alt("positionAlign", F[1], ["start", b, "end", "line-left", "line-right", "auto"]);
                  break;
                case "size":
                  R.percent($, O);
                  break;
                case "align":
                  R.alt($, O, ["start", b, "end", "left", "right"]);
              }
            }, /:/, /\s/), D.region = R.get("region", null), D.vertical = R.get("vertical", "");
            var P = R.get("line", "auto");
            P === "auto" && p.line === -1 && (P = -1), D.line = P, D.lineAlign = R.get("lineAlign", "start"), D.snapToLines = R.get("snapToLines", !0), D.size = R.get("size", 100), D.align = R.get("align", b);
            var N = R.get("position", "auto");
            N === "auto" && p.position === 50 && (N = D.align === "start" || D.align === "left" ? 0 : D.align === "end" || D.align === "right" ? 100 : 50), D.position = N;
          }(g, E);
        }
        function v(g) {
          return g.replace(/<br(?: \/)?>/gi, `
`);
        }
        l.fixLineBreaks = v, d.prototype = { parse: function(g) {
          var E = this;
          function x() {
            var D = E.buffer, R = 0;
            for (D = v(D); R < D.length && D[R] !== "\r" && D[R] !== `
`; )
              ++R;
            var P = D.substr(0, R);
            return D[R] === "\r" && ++R, D[R] === `
` && ++R, E.buffer = D.substr(R), P;
          }
          g && (E.buffer += E.decoder.decode(g, { stream: !0 }));
          try {
            var w = void 0;
            if (E.state === "INITIAL") {
              if (!/\r\n|\n/.test(E.buffer))
                return this;
              var S = (w = x()).match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
              if (!S || !S[0])
                throw new Error("Malformed WebVTT signature.");
              E.state = "HEADER";
            }
            for (var T = !1; E.buffer; ) {
              if (!/\r\n|\n/.test(E.buffer))
                return this;
              switch (T ? T = !1 : w = x(), E.state) {
                case "HEADER":
                  /:/.test(w) ? m(w, function(D, R) {
                  }, /:/) : w || (E.state = "ID");
                  continue;
                case "NOTE":
                  w || (E.state = "ID");
                  continue;
                case "ID":
                  if (/^NOTE($|[ \t])/.test(w)) {
                    E.state = "NOTE";
                    break;
                  }
                  if (!w)
                    continue;
                  if (E.cue = new c.default(0, 0, ""), E.state = "CUE", w.indexOf("-->") === -1) {
                    E.cue.id = w;
                    continue;
                  }
                case "CUE":
                  try {
                    y(w, E.cue, E.regionList);
                  } catch {
                    E.cue = null, E.state = "BADCUE";
                    continue;
                  }
                  E.state = "CUETEXT";
                  continue;
                case "CUETEXT":
                  var C = w.indexOf("-->") !== -1;
                  if (!w || C && (T = !0)) {
                    E.oncue && E.oncue(E.cue), E.cue = null, E.state = "ID";
                    continue;
                  }
                  E.cue.text && (E.cue.text += `
`), E.cue.text += w;
                  continue;
                case "BADCUE":
                  w || (E.state = "ID");
                  continue;
              }
            }
          } catch {
            E.state === "CUETEXT" && E.cue && E.oncue && E.oncue(E.cue), E.cue = null, E.state = E.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
          }
          return this;
        }, flush: function() {
          try {
            if (this.buffer += this.decoder.decode(), !this.cue && this.state !== "HEADER" || (this.buffer += `

`, this.parse()), this.state === "INITIAL")
              throw new Error("Malformed WebVTT signature.");
          } catch (g) {
            throw g;
          }
          return this.onflush && this.onflush(), this;
        } }, l.default = d;
      }, "./src/utils/webvtt-parser.js": function(o, l, u) {
        (function(h) {
          Object.defineProperty(l, "__esModule", { value: !0 });
          function c(b, y, v) {
            return b.substr(v || 0, y.length) === y;
          }
          function d(b) {
            for (var y = 5381, v = b.length; v; )
              y = 33 * y ^ b.charCodeAt(--v);
            return (y >>> 0).toString();
          }
          var f = u("./src/utils/vttparser.js"), m = u("./src/demux/id3.js"), p = { parse: function(b, y, v, g, E, x) {
            var w, S = m.utf8ArrayToStr(new Uint8Array(b)).trim().replace(/\r\n|\n\r|\n|\r/g, `
`).split(`
`), T = "00:00.000", C = 0, D = 0, R = 0, P = [], N = !0, $ = new f.default();
            $.oncue = function(O) {
              var M = v[g], F = v.ccOffset;
              M && M.new && (D !== void 0 ? F = v.ccOffset = M.start : function(G, K, J) {
                var ue = G[K], ce = G[ue.prevCC];
                if (!ce || !ce.new && ue.new)
                  return G.ccOffset = G.presentationOffset = ue.start, ue.new = !1;
                for (; ce && ce.new; )
                  G.ccOffset += ue.start - ce.start, ue.new = !1, ce = G[(ue = ce).prevCC];
                G.presentationOffset = J;
              }(v, g, R)), R && (F = R - v.presentationOffset), O.startTime += F - D, O.endTime += F - D, O.id = d(O.startTime.toString()) + d(O.endTime.toString()) + d(O.text), O.text = decodeURIComponent(encodeURIComponent(O.text)), 0 < O.endTime && P.push(O);
            }, $.onparsingerror = function(O) {
              w = O;
            }, $.onflush = function() {
              w && x ? x(w) : E(P);
            }, S.forEach(function(O) {
              if (N) {
                if (c(O, "X-TIMESTAMP-MAP=")) {
                  N = !1, O.substr(16).split(",").forEach(function(M) {
                    c(M, "LOCAL:") ? T = M.substr(6) : c(M, "MPEGTS:") && (C = parseInt(M.substr(7)));
                  });
                  try {
                    y + (9e4 * v[g].start || 0) < 0 && (y += 8589934592), C -= y, D = function(M) {
                      var F = parseInt(M.substr(-3)), G = parseInt(M.substr(-6, 2)), K = parseInt(M.substr(-9, 2)), J = 9 < M.length ? parseInt(M.substr(0, M.indexOf(":"))) : 0;
                      return h.isFinite(F) && h.isFinite(G) && h.isFinite(K) && h.isFinite(J) ? (F += 1e3 * G, F += 6e4 * K, F += 36e5 * J) : -1;
                    }(T) / 1e3, R = C / 9e4, D === -1 && (w = new Error("Malformed X-TIMESTAMP-MAP: " + O));
                  } catch {
                    w = new Error("Malformed X-TIMESTAMP-MAP: " + O);
                  }
                  return;
                }
                O === "" && (N = !1);
              }
              $.parse(O + `
`);
            }), $.flush();
          } };
          l.default = p;
        }).call(this, u("./src/polyfills/number.js").Number);
      }, "./src/utils/xhr-loader.js": function(o, l, u) {
        Object.defineProperty(l, "__esModule", { value: !0 });
        var h = u("./src/utils/logger.js"), c = window.performance, d = window.XMLHttpRequest, f = (m.prototype.destroy = function() {
          this.abort(), this.loader = null;
        }, m.prototype.abort = function() {
          var p = this.loader;
          p && p.readyState !== 4 && (this.stats.aborted = !0, p.abort()), window.clearTimeout(this.requestTimeout), this.requestTimeout = null, window.clearTimeout(this.retryTimeout), this.retryTimeout = null;
        }, m.prototype.load = function(p, b, y) {
          this.context = p, this.config = b, this.callbacks = y, this.stats = { trequest: c.now(), retry: 0 }, this.retryDelay = b.retryDelay, this.loadInternal();
        }, m.prototype.loadInternal = function() {
          var p, b = this.context;
          p = this.loader = new d();
          var y = this.stats;
          y.tfirst = 0, y.loaded = 0;
          var v = this.xhrSetup;
          try {
            if (v)
              try {
                v(p, b.url);
              } catch {
                p.open("GET", b.url, !0), v(p, b.url);
              }
            p.readyState || p.open("GET", b.url, !0);
          } catch (g) {
            return void this.callbacks.onError({ code: p.status, text: g.message }, b, p);
          }
          b.rangeEnd && p.setRequestHeader("Range", "bytes=" + b.rangeStart + "-" + (b.rangeEnd - 1)), p.onreadystatechange = this.readystatechange.bind(this), p.onprogress = this.loadprogress.bind(this), p.responseType = b.responseType, this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), this.config.timeout), p.send();
        }, m.prototype.readystatechange = function(p) {
          var b = p.currentTarget, y = b.readyState, v = this.stats, g = this.context, E = this.config;
          if (!v.aborted && 2 <= y)
            if (window.clearTimeout(this.requestTimeout), v.tfirst === 0 && (v.tfirst = Math.max(c.now(), v.trequest)), y === 4) {
              var x = b.status;
              if (200 <= x && x < 300) {
                v.tload = Math.max(v.tfirst, c.now());
                var w = void 0, S = void 0;
                S = g.responseType === "arraybuffer" ? (w = b.response).byteLength : (w = b.responseText).length, v.loaded = v.total = S;
                var T = { url: b.responseURL, data: w };
                this.callbacks.onSuccess(T, v, g, b);
              } else
                v.retry >= E.maxRetry || 400 <= x && x < 499 ? (h.logger.error(x + " while loading " + g.url), this.callbacks.onError({ code: x, text: b.statusText }, g, b)) : (h.logger.warn(x + " while loading " + g.url + ", retrying in " + this.retryDelay + "..."), this.destroy(), this.retryTimeout = window.setTimeout(this.loadInternal.bind(this), this.retryDelay), this.retryDelay = Math.min(2 * this.retryDelay, E.maxRetryDelay), v.retry++);
            } else
              this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), E.timeout);
        }, m.prototype.loadtimeout = function() {
          h.logger.warn("timeout while loading " + this.context.url), this.callbacks.onTimeout(this.stats, this.context, null);
        }, m.prototype.loadprogress = function(p) {
          var b = p.currentTarget, y = this.stats;
          y.loaded = p.loaded, p.lengthComputable && (y.total = p.total);
          var v = this.callbacks.onProgress;
          v && v(y, this.context, null, b);
        }, m);
        function m(p) {
          p && p.xhrSetup && (this.xhrSetup = p.xhrSetup);
        }
        l.default = f;
      } }, n.c = s, n.d = function(o, l, u) {
        n.o(o, l) || Object.defineProperty(o, l, { enumerable: !0, get: u });
      }, n.r = function(o) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(o, "__esModule", { value: !0 });
      }, n.t = function(o, l) {
        if (1 & l && (o = n(o)), 8 & l || 4 & l && typeof o == "object" && o && o.__esModule)
          return o;
        var u = /* @__PURE__ */ Object.create(null);
        if (n.r(u), Object.defineProperty(u, "default", { enumerable: !0, value: o }), 2 & l && typeof o != "string")
          for (var h in o)
            n.d(u, h, function(c) {
              return o[c];
            }.bind(null, h));
        return u;
      }, n.n = function(o) {
        var l = o && o.__esModule ? function() {
          return o.default;
        } : function() {
          return o;
        };
        return n.d(l, "a", l), l;
      }, n.o = function(o, l) {
        return Object.prototype.hasOwnProperty.call(o, l);
      }, n.p = "/dist/", n(n.s = "./src/hls.js")).default;
      function n(o) {
        if (s[o])
          return s[o].exports;
        var l = s[o] = { i: o, l: !1, exports: {} };
        return a[o].call(l.exports, l, l.exports, n), l.l = !0, l.exports;
      }
      var a, s;
    }, e.exports = t());
  }]);
});
fr.service("VJSHlsJsPlugin", ["VJSStreamrootHlsjsPlugin", function(e) {
  const r = re.getPlugin("plugin"), i = (n, a, s) => {
    if (console.log("Hls Error:", a), a.fatal) {
      const o = { code: 0, fatal: !0 };
      a.details === "manifestIncompatibleCodecsError" && (o.message = o.description = "Codec Unsupported."), a.details === "internalException" && (o.message = a.err.message), s.error(o);
    }
  };
  re.Html5Hlsjs && re.Html5Hlsjs.addHook("beforeinitialize", (n, a) => {
    a.on($a.Events.FRAG_CHANGED, function(s, o) {
    }), a.on($a.Events.FRAG_LOADED, function(s, o) {
    }), a.on($a.Events.LEVEL_LOADED, function(s, o) {
      n.vfhls.isLive = o.details.live, n.vfhls.isLive && (n.info.wasLive = !0);
    }), a.on($a.Events.LEVEL_SWITCHED, function(s, o) {
      try {
        let l = a.levels[o.level];
        n.vfhls.currentLevel = {
          width: l.width,
          height: l.height,
          bitrate: l.bitrate,
          audioCodec: l.audioCodec,
          videoCodec: l.videoCodec,
          level: o.level,
          totalLevels: a.levels.length,
          availableResolutions: a.levels.map((u) => u.attrs.RESOLUTION)
        };
      } catch {
      }
    }), a.on($a.Events.AUDIO_TRACK_LOADED, (s, o) => {
      try {
        n.audioTracks()[o.id].enabled = !0;
      } catch {
      }
    }), a.on($a.Events.MANIFEST_PARSED, (s, o) => {
    }), a.on($a.Events.MANIFEST_LOADED, (s, o) => {
      try {
        let l = o.levels.reduce((u, h) => (h.videoCodec.startsWith("hev1") && (Array.isArray(h.url) ? u = u.concat(h.url) : u.push(h.url)), u), []);
        o.levels.forEach((u) => {
          Array.isArray(u.url) && u.url.length > 1 && (u.url = u.url.filter((h) => !l.includes(h)));
        });
      } catch {
      }
    }), a.on($a.Events.ERROR, (s, o) => {
      i(s, o, n);
    }), a.on($a.Events.MEDIA_ATTACHED, function(s, o) {
    });
  });
  const t = re.extend(r, {
    constructor: function(n, a) {
      r.call(this, n, a);
    }
  });
  return t.pluginName = "hlsjswrapper", t;
}]);
fr.service("HlsService", function() {
  return this.isHLS = function(e) {
    return e && (e.indexOf(".m3u8") > 0 || e.indexOf("=m3u8") > 0);
  }, this;
});
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var GE;
function Vt() {
  return GE.apply(null, arguments);
}
function AL(e) {
  GE = e;
}
function fs(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function Ku(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function ei(e, r) {
  return Object.prototype.hasOwnProperty.call(e, r);
}
function km(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var r;
  for (r in e)
    if (ei(e, r))
      return !1;
  return !0;
}
function sa(e) {
  return e === void 0;
}
function yo(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function Ld(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function HE(e, r) {
  var i = [], t, n = e.length;
  for (t = 0; t < n; ++t)
    i.push(r(e[t], t));
  return i;
}
function Yo(e, r) {
  for (var i in r)
    ei(r, i) && (e[i] = r[i]);
  return ei(r, "toString") && (e.toString = r.toString), ei(r, "valueOf") && (e.valueOf = r.valueOf), e;
}
function Hs(e, r, i, t) {
  return fx(e, r, i, t, !0).utc();
}
function wL() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function wr(e) {
  return e._pf == null && (e._pf = wL()), e._pf;
}
var Zg;
Array.prototype.some ? Zg = Array.prototype.some : Zg = function(e) {
  var r = Object(this), i = r.length >>> 0, t;
  for (t = 0; t < i; t++)
    if (t in r && e.call(this, r[t], t, r))
      return !0;
  return !1;
};
function Rm(e) {
  var r = null, i = !1, t = e._d && !isNaN(e._d.getTime());
  if (t && (r = wr(e), i = Zg.call(r.parsedDateParts, function(n) {
    return n != null;
  }), t = r.overflow < 0 && !r.empty && !r.invalidEra && !r.invalidMonth && !r.invalidWeekday && !r.weekdayMismatch && !r.nullInput && !r.invalidFormat && !r.userInvalidated && (!r.meridiem || r.meridiem && i), e._strict && (t = t && r.charsLeftOver === 0 && r.unusedTokens.length === 0 && r.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(e))
    e._isValid = t;
  else
    return t;
  return e._isValid;
}
function Vh(e) {
  var r = Hs(NaN);
  return e != null ? Yo(wr(r), e) : wr(r).userInvalidated = !0, r;
}
var nb = Vt.momentProperties = [], Zp = !1;
function Pm(e, r) {
  var i, t, n, a = nb.length;
  if (sa(r._isAMomentObject) || (e._isAMomentObject = r._isAMomentObject), sa(r._i) || (e._i = r._i), sa(r._f) || (e._f = r._f), sa(r._l) || (e._l = r._l), sa(r._strict) || (e._strict = r._strict), sa(r._tzm) || (e._tzm = r._tzm), sa(r._isUTC) || (e._isUTC = r._isUTC), sa(r._offset) || (e._offset = r._offset), sa(r._pf) || (e._pf = wr(r)), sa(r._locale) || (e._locale = r._locale), a > 0)
    for (i = 0; i < a; i++)
      t = nb[i], n = r[t], sa(n) || (e[t] = n);
  return e;
}
function Id(e) {
  Pm(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), Zp === !1 && (Zp = !0, Vt.updateOffset(this), Zp = !1);
}
function hs(e) {
  return e instanceof Id || e != null && e._isAMomentObject != null;
}
function VE(e) {
  Vt.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function Ya(e, r) {
  var i = !0;
  return Yo(function() {
    if (Vt.deprecationHandler != null && Vt.deprecationHandler(null, e), i) {
      var t = [], n, a, s, o = arguments.length;
      for (a = 0; a < o; a++) {
        if (n = "", typeof arguments[a] == "object") {
          n += `
[` + a + "] ";
          for (s in arguments[0])
            ei(arguments[0], s) && (n += s + ": " + arguments[0][s] + ", ");
          n = n.slice(0, -2);
        } else
          n = arguments[a];
        t.push(n);
      }
      VE(
        e + `
Arguments: ` + Array.prototype.slice.call(t).join("") + `
` + new Error().stack
      ), i = !1;
    }
    return r.apply(this, arguments);
  }, r);
}
var ab = {};
function qE(e, r) {
  Vt.deprecationHandler != null && Vt.deprecationHandler(e, r), ab[e] || (VE(r), ab[e] = !0);
}
Vt.suppressDeprecationWarnings = !1;
Vt.deprecationHandler = null;
function Vs(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function CL(e) {
  var r, i;
  for (i in e)
    ei(e, i) && (r = e[i], Vs(r) ? this[i] = r : this["_" + i] = r);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function ev(e, r) {
  var i = Yo({}, e), t;
  for (t in r)
    ei(r, t) && (Ku(e[t]) && Ku(r[t]) ? (i[t] = {}, Yo(i[t], e[t]), Yo(i[t], r[t])) : r[t] != null ? i[t] = r[t] : delete i[t]);
  for (t in e)
    ei(e, t) && !ei(r, t) && Ku(e[t]) && (i[t] = Yo({}, i[t]));
  return i;
}
function Om(e) {
  e != null && this.set(e);
}
var tv;
Object.keys ? tv = Object.keys : tv = function(e) {
  var r, i = [];
  for (r in e)
    ei(e, r) && i.push(r);
  return i;
};
var DL = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function kL(e, r, i) {
  var t = this._calendar[e] || this._calendar.sameElse;
  return Vs(t) ? t.call(r, i) : t;
}
function $s(e, r, i) {
  var t = "" + Math.abs(e), n = r - t.length, a = e >= 0;
  return (a ? i ? "+" : "" : "-") + Math.pow(10, Math.max(0, n)).toString().substr(1) + t;
}
var Lm = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, gf = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, eg = {}, $l = {};
function lr(e, r, i, t) {
  var n = t;
  typeof t == "string" && (n = function() {
    return this[t]();
  }), e && ($l[e] = n), r && ($l[r[0]] = function() {
    return $s(n.apply(this, arguments), r[1], r[2]);
  }), i && ($l[i] = function() {
    return this.localeData().ordinal(
      n.apply(this, arguments),
      e
    );
  });
}
function RL(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function PL(e) {
  var r = e.match(Lm), i, t;
  for (i = 0, t = r.length; i < t; i++)
    $l[r[i]] ? r[i] = $l[r[i]] : r[i] = RL(r[i]);
  return function(n) {
    var a = "", s;
    for (s = 0; s < t; s++)
      a += Vs(r[s]) ? r[s].call(n, e) : r[s];
    return a;
  };
}
function kf(e, r) {
  return e.isValid() ? (r = WE(r, e.localeData()), eg[r] = eg[r] || PL(r), eg[r](e)) : e.localeData().invalidDate();
}
function WE(e, r) {
  var i = 5;
  function t(n) {
    return r.longDateFormat(n) || n;
  }
  for (gf.lastIndex = 0; i >= 0 && gf.test(e); )
    e = e.replace(
      gf,
      t
    ), gf.lastIndex = 0, i -= 1;
  return e;
}
var OL = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function LL(e) {
  var r = this._longDateFormat[e], i = this._longDateFormat[e.toUpperCase()];
  return r || !i ? r : (this._longDateFormat[e] = i.match(Lm).map(function(t) {
    return t === "MMMM" || t === "MM" || t === "DD" || t === "dddd" ? t.slice(1) : t;
  }).join(""), this._longDateFormat[e]);
}
var IL = "Invalid date";
function ML() {
  return this._invalidDate;
}
var NL = "%d", FL = /\d{1,2}/;
function UL(e) {
  return this._ordinal.replace("%d", e);
}
var BL = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function jL(e, r, i, t) {
  var n = this._relativeTime[i];
  return Vs(n) ? n(e, r, i, t) : n.replace(/%d/i, e);
}
function $L(e, r) {
  var i = this._relativeTime[e > 0 ? "future" : "past"];
  return Vs(i) ? i(r) : i.replace(/%s/i, r);
}
var sb = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function Ka(e) {
  return typeof e == "string" ? sb[e] || sb[e.toLowerCase()] : void 0;
}
function Im(e) {
  var r = {}, i, t;
  for (t in e)
    ei(e, t) && (i = Ka(t), i && (r[i] = e[t]));
  return r;
}
var GL = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function HL(e) {
  var r = [], i;
  for (i in e)
    ei(e, i) && r.push({ unit: i, priority: GL[i] });
  return r.sort(function(t, n) {
    return t.priority - n.priority;
  }), r;
}
var YE = /\d/, Aa = /\d\d/, KE = /\d{3}/, Mm = /\d{4}/, qh = /[+-]?\d{6}/, Pi = /\d\d?/, zE = /\d\d\d\d?/, XE = /\d\d\d\d\d\d?/, Wh = /\d{1,3}/, Nm = /\d{1,4}/, Yh = /[+-]?\d{1,6}/, hc = /\d+/, Kh = /[+-]?\d+/, VL = /Z|[+-]\d\d:?\d\d/gi, zh = /Z|[+-]\d\d(?::?\d\d)?/gi, qL = /[+-]?\d+(\.\d{1,3})?/, Md = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, pc = /^[1-9]\d?/, Fm = /^([1-9]\d|\d)/, nh;
nh = {};
function er(e, r, i) {
  nh[e] = Vs(r) ? r : function(t, n) {
    return t && i ? i : r;
  };
}
function WL(e, r) {
  return ei(nh, e) ? nh[e](r._strict, r._locale) : new RegExp(YL(e));
}
function YL(e) {
  return co(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(r, i, t, n, a) {
        return i || t || n || a;
      }
    )
  );
}
function co(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function Ha(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function $r(e) {
  var r = +e, i = 0;
  return r !== 0 && isFinite(r) && (i = Ha(r)), i;
}
var rv = {};
function yi(e, r) {
  var i, t = r, n;
  for (typeof e == "string" && (e = [e]), yo(r) && (t = function(a, s) {
    s[r] = $r(a);
  }), n = e.length, i = 0; i < n; i++)
    rv[e[i]] = t;
}
function Nd(e, r) {
  yi(e, function(i, t, n, a) {
    n._w = n._w || {}, r(i, n._w, n, a);
  });
}
function KL(e, r, i) {
  r != null && ei(rv, e) && rv[e](r, i._a, i, e);
}
function Xh(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
var Fn = 0, so = 1, Ls = 2, an = 3, us = 4, oo = 5, ju = 6, zL = 7, XL = 8;
lr("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? $s(e, 4) : "+" + e;
});
lr(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
lr(0, ["YYYY", 4], 0, "year");
lr(0, ["YYYYY", 5], 0, "year");
lr(0, ["YYYYYY", 6, !0], 0, "year");
er("Y", Kh);
er("YY", Pi, Aa);
er("YYYY", Nm, Mm);
er("YYYYY", Yh, qh);
er("YYYYYY", Yh, qh);
yi(["YYYYY", "YYYYYY"], Fn);
yi("YYYY", function(e, r) {
  r[Fn] = e.length === 2 ? Vt.parseTwoDigitYear(e) : $r(e);
});
yi("YY", function(e, r) {
  r[Fn] = Vt.parseTwoDigitYear(e);
});
yi("Y", function(e, r) {
  r[Fn] = parseInt(e, 10);
});
function Qc(e) {
  return Xh(e) ? 366 : 365;
}
Vt.parseTwoDigitYear = function(e) {
  return $r(e) + ($r(e) > 68 ? 1900 : 2e3);
};
var JE = gc("FullYear", !0);
function JL() {
  return Xh(this.year());
}
function gc(e, r) {
  return function(i) {
    return i != null ? (QE(this, e, i), Vt.updateOffset(this, r), this) : hd(this, e);
  };
}
function hd(e, r) {
  if (!e.isValid())
    return NaN;
  var i = e._d, t = e._isUTC;
  switch (r) {
    case "Milliseconds":
      return t ? i.getUTCMilliseconds() : i.getMilliseconds();
    case "Seconds":
      return t ? i.getUTCSeconds() : i.getSeconds();
    case "Minutes":
      return t ? i.getUTCMinutes() : i.getMinutes();
    case "Hours":
      return t ? i.getUTCHours() : i.getHours();
    case "Date":
      return t ? i.getUTCDate() : i.getDate();
    case "Day":
      return t ? i.getUTCDay() : i.getDay();
    case "Month":
      return t ? i.getUTCMonth() : i.getMonth();
    case "FullYear":
      return t ? i.getUTCFullYear() : i.getFullYear();
    default:
      return NaN;
  }
}
function QE(e, r, i) {
  var t, n, a, s, o;
  if (!(!e.isValid() || isNaN(i))) {
    switch (t = e._d, n = e._isUTC, r) {
      case "Milliseconds":
        return void (n ? t.setUTCMilliseconds(i) : t.setMilliseconds(i));
      case "Seconds":
        return void (n ? t.setUTCSeconds(i) : t.setSeconds(i));
      case "Minutes":
        return void (n ? t.setUTCMinutes(i) : t.setMinutes(i));
      case "Hours":
        return void (n ? t.setUTCHours(i) : t.setHours(i));
      case "Date":
        return void (n ? t.setUTCDate(i) : t.setDate(i));
      case "FullYear":
        break;
      default:
        return;
    }
    a = i, s = e.month(), o = e.date(), o = o === 29 && s === 1 && !Xh(a) ? 28 : o, n ? t.setUTCFullYear(a, s, o) : t.setFullYear(a, s, o);
  }
}
function QL(e) {
  return e = Ka(e), Vs(this[e]) ? this[e]() : this;
}
function ZL(e, r) {
  if (typeof e == "object") {
    e = Im(e);
    var i = HL(e), t, n = i.length;
    for (t = 0; t < n; t++)
      this[i[t].unit](e[i[t].unit]);
  } else if (e = Ka(e), Vs(this[e]))
    return this[e](r);
  return this;
}
function eI(e, r) {
  return (e % r + r) % r;
}
var Hi;
Array.prototype.indexOf ? Hi = Array.prototype.indexOf : Hi = function(e) {
  var r;
  for (r = 0; r < this.length; ++r)
    if (this[r] === e)
      return r;
  return -1;
};
function Um(e, r) {
  if (isNaN(e) || isNaN(r))
    return NaN;
  var i = eI(r, 12);
  return e += (r - i) / 12, i === 1 ? Xh(e) ? 29 : 28 : 31 - i % 7 % 2;
}
lr("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
lr("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
lr("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
er("M", Pi, pc);
er("MM", Pi, Aa);
er("MMM", function(e, r) {
  return r.monthsShortRegex(e);
});
er("MMMM", function(e, r) {
  return r.monthsRegex(e);
});
yi(["M", "MM"], function(e, r) {
  r[so] = $r(e) - 1;
});
yi(["MMM", "MMMM"], function(e, r, i, t) {
  var n = i._locale.monthsParse(e, t, i._strict);
  n != null ? r[so] = n : wr(i).invalidMonth = e;
});
var tI = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), ZE = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), ex = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, rI = Md, iI = Md;
function nI(e, r) {
  return e ? fs(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || ex).test(r) ? "format" : "standalone"][e.month()] : fs(this._months) ? this._months : this._months.standalone;
}
function aI(e, r) {
  return e ? fs(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[ex.test(r) ? "format" : "standalone"][e.month()] : fs(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function sI(e, r, i) {
  var t, n, a, s = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], t = 0; t < 12; ++t)
      a = Hs([2e3, t]), this._shortMonthsParse[t] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[t] = this.months(a, "").toLocaleLowerCase();
  return i ? r === "MMM" ? (n = Hi.call(this._shortMonthsParse, s), n !== -1 ? n : null) : (n = Hi.call(this._longMonthsParse, s), n !== -1 ? n : null) : r === "MMM" ? (n = Hi.call(this._shortMonthsParse, s), n !== -1 ? n : (n = Hi.call(this._longMonthsParse, s), n !== -1 ? n : null)) : (n = Hi.call(this._longMonthsParse, s), n !== -1 ? n : (n = Hi.call(this._shortMonthsParse, s), n !== -1 ? n : null));
}
function oI(e, r, i) {
  var t, n, a;
  if (this._monthsParseExact)
    return sI.call(this, e, r, i);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), t = 0; t < 12; t++) {
    if (n = Hs([2e3, t]), i && !this._longMonthsParse[t] && (this._longMonthsParse[t] = new RegExp(
      "^" + this.months(n, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[t] = new RegExp(
      "^" + this.monthsShort(n, "").replace(".", "") + "$",
      "i"
    )), !i && !this._monthsParse[t] && (a = "^" + this.months(n, "") + "|^" + this.monthsShort(n, ""), this._monthsParse[t] = new RegExp(a.replace(".", ""), "i")), i && r === "MMMM" && this._longMonthsParse[t].test(e))
      return t;
    if (i && r === "MMM" && this._shortMonthsParse[t].test(e))
      return t;
    if (!i && this._monthsParse[t].test(e))
      return t;
  }
}
function tx(e, r) {
  if (!e.isValid())
    return e;
  if (typeof r == "string") {
    if (/^\d+$/.test(r))
      r = $r(r);
    else if (r = e.localeData().monthsParse(r), !yo(r))
      return e;
  }
  var i = r, t = e.date();
  return t = t < 29 ? t : Math.min(t, Um(e.year(), i)), e._isUTC ? e._d.setUTCMonth(i, t) : e._d.setMonth(i, t), e;
}
function rx(e) {
  return e != null ? (tx(this, e), Vt.updateOffset(this, !0), this) : hd(this, "Month");
}
function uI() {
  return Um(this.year(), this.month());
}
function lI(e) {
  return this._monthsParseExact ? (ei(this, "_monthsRegex") || ix.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (ei(this, "_monthsShortRegex") || (this._monthsShortRegex = rI), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function cI(e) {
  return this._monthsParseExact ? (ei(this, "_monthsRegex") || ix.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (ei(this, "_monthsRegex") || (this._monthsRegex = iI), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function ix() {
  function e(l, u) {
    return u.length - l.length;
  }
  var r = [], i = [], t = [], n, a, s, o;
  for (n = 0; n < 12; n++)
    a = Hs([2e3, n]), s = co(this.monthsShort(a, "")), o = co(this.months(a, "")), r.push(s), i.push(o), t.push(o), t.push(s);
  r.sort(e), i.sort(e), t.sort(e), this._monthsRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
function dI(e, r, i, t, n, a, s) {
  var o;
  return e < 100 && e >= 0 ? (o = new Date(e + 400, r, i, t, n, a, s), isFinite(o.getFullYear()) && o.setFullYear(e)) : o = new Date(e, r, i, t, n, a, s), o;
}
function pd(e) {
  var r, i;
  return e < 100 && e >= 0 ? (i = Array.prototype.slice.call(arguments), i[0] = e + 400, r = new Date(Date.UTC.apply(null, i)), isFinite(r.getUTCFullYear()) && r.setUTCFullYear(e)) : r = new Date(Date.UTC.apply(null, arguments)), r;
}
function ah(e, r, i) {
  var t = 7 + r - i, n = (7 + pd(e, 0, t).getUTCDay() - r) % 7;
  return -n + t - 1;
}
function nx(e, r, i, t, n) {
  var a = (7 + i - t) % 7, s = ah(e, t, n), o = 1 + 7 * (r - 1) + a + s, l, u;
  return o <= 0 ? (l = e - 1, u = Qc(l) + o) : o > Qc(e) ? (l = e + 1, u = o - Qc(e)) : (l = e, u = o), {
    year: l,
    dayOfYear: u
  };
}
function gd(e, r, i) {
  var t = ah(e.year(), r, i), n = Math.floor((e.dayOfYear() - t - 1) / 7) + 1, a, s;
  return n < 1 ? (s = e.year() - 1, a = n + fo(s, r, i)) : n > fo(e.year(), r, i) ? (a = n - fo(e.year(), r, i), s = e.year() + 1) : (s = e.year(), a = n), {
    week: a,
    year: s
  };
}
function fo(e, r, i) {
  var t = ah(e, r, i), n = ah(e + 1, r, i);
  return (Qc(e) - t + n) / 7;
}
lr("w", ["ww", 2], "wo", "week");
lr("W", ["WW", 2], "Wo", "isoWeek");
er("w", Pi, pc);
er("ww", Pi, Aa);
er("W", Pi, pc);
er("WW", Pi, Aa);
Nd(
  ["w", "ww", "W", "WW"],
  function(e, r, i, t) {
    r[t.substr(0, 1)] = $r(e);
  }
);
function fI(e) {
  return gd(e, this._week.dow, this._week.doy).week;
}
var hI = {
  dow: 0,
  doy: 6
};
function pI() {
  return this._week.dow;
}
function gI() {
  return this._week.doy;
}
function vI(e) {
  var r = this.localeData().week(this);
  return e == null ? r : this.add((e - r) * 7, "d");
}
function mI(e) {
  var r = gd(this, 1, 4).week;
  return e == null ? r : this.add((e - r) * 7, "d");
}
lr("d", 0, "do", "day");
lr("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
lr("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
lr("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
lr("e", 0, 0, "weekday");
lr("E", 0, 0, "isoWeekday");
er("d", Pi);
er("e", Pi);
er("E", Pi);
er("dd", function(e, r) {
  return r.weekdaysMinRegex(e);
});
er("ddd", function(e, r) {
  return r.weekdaysShortRegex(e);
});
er("dddd", function(e, r) {
  return r.weekdaysRegex(e);
});
Nd(["dd", "ddd", "dddd"], function(e, r, i, t) {
  var n = i._locale.weekdaysParse(e, t, i._strict);
  n != null ? r.d = n : wr(i).invalidWeekday = e;
});
Nd(["d", "e", "E"], function(e, r, i, t) {
  r[t] = $r(e);
});
function yI(e, r) {
  return typeof e != "string" ? e : isNaN(e) ? (e = r.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function _I(e, r) {
  return typeof e == "string" ? r.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function Bm(e, r) {
  return e.slice(r, 7).concat(e.slice(0, r));
}
var bI = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), ax = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), TI = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), SI = Md, EI = Md, xI = Md;
function AI(e, r) {
  var i = fs(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(r) ? "format" : "standalone"];
  return e === !0 ? Bm(i, this._week.dow) : e ? i[e.day()] : i;
}
function wI(e) {
  return e === !0 ? Bm(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function CI(e) {
  return e === !0 ? Bm(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function DI(e, r, i) {
  var t, n, a, s = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], t = 0; t < 7; ++t)
      a = Hs([2e3, 1]).day(t), this._minWeekdaysParse[t] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[t] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[t] = this.weekdays(a, "").toLocaleLowerCase();
  return i ? r === "dddd" ? (n = Hi.call(this._weekdaysParse, s), n !== -1 ? n : null) : r === "ddd" ? (n = Hi.call(this._shortWeekdaysParse, s), n !== -1 ? n : null) : (n = Hi.call(this._minWeekdaysParse, s), n !== -1 ? n : null) : r === "dddd" ? (n = Hi.call(this._weekdaysParse, s), n !== -1 || (n = Hi.call(this._shortWeekdaysParse, s), n !== -1) ? n : (n = Hi.call(this._minWeekdaysParse, s), n !== -1 ? n : null)) : r === "ddd" ? (n = Hi.call(this._shortWeekdaysParse, s), n !== -1 || (n = Hi.call(this._weekdaysParse, s), n !== -1) ? n : (n = Hi.call(this._minWeekdaysParse, s), n !== -1 ? n : null)) : (n = Hi.call(this._minWeekdaysParse, s), n !== -1 || (n = Hi.call(this._weekdaysParse, s), n !== -1) ? n : (n = Hi.call(this._shortWeekdaysParse, s), n !== -1 ? n : null));
}
function kI(e, r, i) {
  var t, n, a;
  if (this._weekdaysParseExact)
    return DI.call(this, e, r, i);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), t = 0; t < 7; t++) {
    if (n = Hs([2e3, 1]).day(t), i && !this._fullWeekdaysParse[t] && (this._fullWeekdaysParse[t] = new RegExp(
      "^" + this.weekdays(n, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[t] = new RegExp(
      "^" + this.weekdaysShort(n, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[t] = new RegExp(
      "^" + this.weekdaysMin(n, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[t] || (a = "^" + this.weekdays(n, "") + "|^" + this.weekdaysShort(n, "") + "|^" + this.weekdaysMin(n, ""), this._weekdaysParse[t] = new RegExp(a.replace(".", ""), "i")), i && r === "dddd" && this._fullWeekdaysParse[t].test(e))
      return t;
    if (i && r === "ddd" && this._shortWeekdaysParse[t].test(e))
      return t;
    if (i && r === "dd" && this._minWeekdaysParse[t].test(e))
      return t;
    if (!i && this._weekdaysParse[t].test(e))
      return t;
  }
}
function RI(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var r = hd(this, "Day");
  return e != null ? (e = yI(e, this.localeData()), this.add(e - r, "d")) : r;
}
function PI(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var r = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? r : this.add(e - r, "d");
}
function OI(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var r = _I(e, this.localeData());
    return this.day(this.day() % 7 ? r : r - 7);
  } else
    return this.day() || 7;
}
function LI(e) {
  return this._weekdaysParseExact ? (ei(this, "_weekdaysRegex") || jm.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (ei(this, "_weekdaysRegex") || (this._weekdaysRegex = SI), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function II(e) {
  return this._weekdaysParseExact ? (ei(this, "_weekdaysRegex") || jm.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (ei(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = EI), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function MI(e) {
  return this._weekdaysParseExact ? (ei(this, "_weekdaysRegex") || jm.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (ei(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = xI), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function jm() {
  function e(h, c) {
    return c.length - h.length;
  }
  var r = [], i = [], t = [], n = [], a, s, o, l, u;
  for (a = 0; a < 7; a++)
    s = Hs([2e3, 1]).day(a), o = co(this.weekdaysMin(s, "")), l = co(this.weekdaysShort(s, "")), u = co(this.weekdays(s, "")), r.push(o), i.push(l), t.push(u), n.push(o), n.push(l), n.push(u);
  r.sort(e), i.sort(e), t.sort(e), n.sort(e), this._weekdaysRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
function $m() {
  return this.hours() % 12 || 12;
}
function NI() {
  return this.hours() || 24;
}
lr("H", ["HH", 2], 0, "hour");
lr("h", ["hh", 2], 0, $m);
lr("k", ["kk", 2], 0, NI);
lr("hmm", 0, 0, function() {
  return "" + $m.apply(this) + $s(this.minutes(), 2);
});
lr("hmmss", 0, 0, function() {
  return "" + $m.apply(this) + $s(this.minutes(), 2) + $s(this.seconds(), 2);
});
lr("Hmm", 0, 0, function() {
  return "" + this.hours() + $s(this.minutes(), 2);
});
lr("Hmmss", 0, 0, function() {
  return "" + this.hours() + $s(this.minutes(), 2) + $s(this.seconds(), 2);
});
function sx(e, r) {
  lr(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      r
    );
  });
}
sx("a", !0);
sx("A", !1);
function ox(e, r) {
  return r._meridiemParse;
}
er("a", ox);
er("A", ox);
er("H", Pi, Fm);
er("h", Pi, pc);
er("k", Pi, pc);
er("HH", Pi, Aa);
er("hh", Pi, Aa);
er("kk", Pi, Aa);
er("hmm", zE);
er("hmmss", XE);
er("Hmm", zE);
er("Hmmss", XE);
yi(["H", "HH"], an);
yi(["k", "kk"], function(e, r, i) {
  var t = $r(e);
  r[an] = t === 24 ? 0 : t;
});
yi(["a", "A"], function(e, r, i) {
  i._isPm = i._locale.isPM(e), i._meridiem = e;
});
yi(["h", "hh"], function(e, r, i) {
  r[an] = $r(e), wr(i).bigHour = !0;
});
yi("hmm", function(e, r, i) {
  var t = e.length - 2;
  r[an] = $r(e.substr(0, t)), r[us] = $r(e.substr(t)), wr(i).bigHour = !0;
});
yi("hmmss", function(e, r, i) {
  var t = e.length - 4, n = e.length - 2;
  r[an] = $r(e.substr(0, t)), r[us] = $r(e.substr(t, 2)), r[oo] = $r(e.substr(n)), wr(i).bigHour = !0;
});
yi("Hmm", function(e, r, i) {
  var t = e.length - 2;
  r[an] = $r(e.substr(0, t)), r[us] = $r(e.substr(t));
});
yi("Hmmss", function(e, r, i) {
  var t = e.length - 4, n = e.length - 2;
  r[an] = $r(e.substr(0, t)), r[us] = $r(e.substr(t, 2)), r[oo] = $r(e.substr(n));
});
function FI(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var UI = /[ap]\.?m?\.?/i, BI = gc("Hours", !0);
function jI(e, r, i) {
  return e > 11 ? i ? "pm" : "PM" : i ? "am" : "AM";
}
var ux = {
  calendar: DL,
  longDateFormat: OL,
  invalidDate: IL,
  ordinal: NL,
  dayOfMonthOrdinalParse: FL,
  relativeTime: BL,
  months: tI,
  monthsShort: ZE,
  week: hI,
  weekdays: bI,
  weekdaysMin: TI,
  weekdaysShort: ax,
  meridiemParse: UI
}, Fi = {}, Uc = {}, vd;
function $I(e, r) {
  var i, t = Math.min(e.length, r.length);
  for (i = 0; i < t; i += 1)
    if (e[i] !== r[i])
      return i;
  return t;
}
function ob(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function GI(e) {
  for (var r = 0, i, t, n, a; r < e.length; ) {
    for (a = ob(e[r]).split("-"), i = a.length, t = ob(e[r + 1]), t = t ? t.split("-") : null; i > 0; ) {
      if (n = Jh(a.slice(0, i).join("-")), n)
        return n;
      if (t && t.length >= i && $I(a, t) >= i - 1)
        break;
      i--;
    }
    r++;
  }
  return vd;
}
function HI(e) {
  return !!(e && e.match("^[^/\\\\]*$"));
}
function Jh(e) {
  var r = null, i;
  if (Fi[e] === void 0 && typeof module < "u" && module && module.exports && HI(e))
    try {
      r = vd._abbr, i = require, i("./locale/" + e), Zo(r);
    } catch {
      Fi[e] = null;
    }
  return Fi[e];
}
function Zo(e, r) {
  var i;
  return e && (sa(r) ? i = Ao(e) : i = Gm(e, r), i ? vd = i : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), vd._abbr;
}
function Gm(e, r) {
  if (r !== null) {
    var i, t = ux;
    if (r.abbr = e, Fi[e] != null)
      qE(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), t = Fi[e]._config;
    else if (r.parentLocale != null)
      if (Fi[r.parentLocale] != null)
        t = Fi[r.parentLocale]._config;
      else if (i = Jh(r.parentLocale), i != null)
        t = i._config;
      else
        return Uc[r.parentLocale] || (Uc[r.parentLocale] = []), Uc[r.parentLocale].push({
          name: e,
          config: r
        }), null;
    return Fi[e] = new Om(ev(t, r)), Uc[e] && Uc[e].forEach(function(n) {
      Gm(n.name, n.config);
    }), Zo(e), Fi[e];
  } else
    return delete Fi[e], null;
}
function VI(e, r) {
  if (r != null) {
    var i, t, n = ux;
    Fi[e] != null && Fi[e].parentLocale != null ? Fi[e].set(ev(Fi[e]._config, r)) : (t = Jh(e), t != null && (n = t._config), r = ev(n, r), t == null && (r.abbr = e), i = new Om(r), i.parentLocale = Fi[e], Fi[e] = i), Zo(e);
  } else
    Fi[e] != null && (Fi[e].parentLocale != null ? (Fi[e] = Fi[e].parentLocale, e === Zo() && Zo(e)) : Fi[e] != null && delete Fi[e]);
  return Fi[e];
}
function Ao(e) {
  var r;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return vd;
  if (!fs(e)) {
    if (r = Jh(e), r)
      return r;
    e = [e];
  }
  return GI(e);
}
function qI() {
  return tv(Fi);
}
function Hm(e) {
  var r, i = e._a;
  return i && wr(e).overflow === -2 && (r = i[so] < 0 || i[so] > 11 ? so : i[Ls] < 1 || i[Ls] > Um(i[Fn], i[so]) ? Ls : i[an] < 0 || i[an] > 24 || i[an] === 24 && (i[us] !== 0 || i[oo] !== 0 || i[ju] !== 0) ? an : i[us] < 0 || i[us] > 59 ? us : i[oo] < 0 || i[oo] > 59 ? oo : i[ju] < 0 || i[ju] > 999 ? ju : -1, wr(e)._overflowDayOfYear && (r < Fn || r > Ls) && (r = Ls), wr(e)._overflowWeeks && r === -1 && (r = zL), wr(e)._overflowWeekday && r === -1 && (r = XL), wr(e).overflow = r), e;
}
var WI = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, YI = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, KI = /Z|[+-]\d\d(?::?\d\d)?/, vf = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], tg = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], zI = /^\/?Date\((-?\d+)/i, XI = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, JI = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function lx(e) {
  var r, i, t = e._i, n = WI.exec(t) || YI.exec(t), a, s, o, l, u = vf.length, h = tg.length;
  if (n) {
    for (wr(e).iso = !0, r = 0, i = u; r < i; r++)
      if (vf[r][1].exec(n[1])) {
        s = vf[r][0], a = vf[r][2] !== !1;
        break;
      }
    if (s == null) {
      e._isValid = !1;
      return;
    }
    if (n[3]) {
      for (r = 0, i = h; r < i; r++)
        if (tg[r][1].exec(n[3])) {
          o = (n[2] || " ") + tg[r][0];
          break;
        }
      if (o == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && o != null) {
      e._isValid = !1;
      return;
    }
    if (n[4])
      if (KI.exec(n[4]))
        l = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = s + (o || "") + (l || ""), qm(e);
  } else
    e._isValid = !1;
}
function QI(e, r, i, t, n, a) {
  var s = [
    ZI(e),
    ZE.indexOf(r),
    parseInt(i, 10),
    parseInt(t, 10),
    parseInt(n, 10)
  ];
  return a && s.push(parseInt(a, 10)), s;
}
function ZI(e) {
  var r = parseInt(e, 10);
  return r <= 49 ? 2e3 + r : r <= 999 ? 1900 + r : r;
}
function eM(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function tM(e, r, i) {
  if (e) {
    var t = ax.indexOf(e), n = new Date(
      r[0],
      r[1],
      r[2]
    ).getDay();
    if (t !== n)
      return wr(i).weekdayMismatch = !0, i._isValid = !1, !1;
  }
  return !0;
}
function rM(e, r, i) {
  if (e)
    return JI[e];
  if (r)
    return 0;
  var t = parseInt(i, 10), n = t % 100, a = (t - n) / 100;
  return a * 60 + n;
}
function cx(e) {
  var r = XI.exec(eM(e._i)), i;
  if (r) {
    if (i = QI(
      r[4],
      r[3],
      r[2],
      r[5],
      r[6],
      r[7]
    ), !tM(r[1], i, e))
      return;
    e._a = i, e._tzm = rM(r[8], r[9], r[10]), e._d = pd.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), wr(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function iM(e) {
  var r = zI.exec(e._i);
  if (r !== null) {
    e._d = new Date(+r[1]);
    return;
  }
  if (lx(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (cx(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : Vt.createFromInputFallback(e);
}
Vt.createFromInputFallback = Ya(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function Dl(e, r, i) {
  return e != null ? e : r != null ? r : i;
}
function nM(e) {
  var r = new Date(Vt.now());
  return e._useUTC ? [
    r.getUTCFullYear(),
    r.getUTCMonth(),
    r.getUTCDate()
  ] : [r.getFullYear(), r.getMonth(), r.getDate()];
}
function Vm(e) {
  var r, i, t = [], n, a, s;
  if (!e._d) {
    for (n = nM(e), e._w && e._a[Ls] == null && e._a[so] == null && aM(e), e._dayOfYear != null && (s = Dl(e._a[Fn], n[Fn]), (e._dayOfYear > Qc(s) || e._dayOfYear === 0) && (wr(e)._overflowDayOfYear = !0), i = pd(s, 0, e._dayOfYear), e._a[so] = i.getUTCMonth(), e._a[Ls] = i.getUTCDate()), r = 0; r < 3 && e._a[r] == null; ++r)
      e._a[r] = t[r] = n[r];
    for (; r < 7; r++)
      e._a[r] = t[r] = e._a[r] == null ? r === 2 ? 1 : 0 : e._a[r];
    e._a[an] === 24 && e._a[us] === 0 && e._a[oo] === 0 && e._a[ju] === 0 && (e._nextDay = !0, e._a[an] = 0), e._d = (e._useUTC ? pd : dI).apply(
      null,
      t
    ), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[an] = 24), e._w && typeof e._w.d < "u" && e._w.d !== a && (wr(e).weekdayMismatch = !0);
  }
}
function aM(e) {
  var r, i, t, n, a, s, o, l, u;
  r = e._w, r.GG != null || r.W != null || r.E != null ? (a = 1, s = 4, i = Dl(
    r.GG,
    e._a[Fn],
    gd(ki(), 1, 4).year
  ), t = Dl(r.W, 1), n = Dl(r.E, 1), (n < 1 || n > 7) && (l = !0)) : (a = e._locale._week.dow, s = e._locale._week.doy, u = gd(ki(), a, s), i = Dl(r.gg, e._a[Fn], u.year), t = Dl(r.w, u.week), r.d != null ? (n = r.d, (n < 0 || n > 6) && (l = !0)) : r.e != null ? (n = r.e + a, (r.e < 0 || r.e > 6) && (l = !0)) : n = a), t < 1 || t > fo(i, a, s) ? wr(e)._overflowWeeks = !0 : l != null ? wr(e)._overflowWeekday = !0 : (o = nx(i, t, n, a, s), e._a[Fn] = o.year, e._dayOfYear = o.dayOfYear);
}
Vt.ISO_8601 = function() {
};
Vt.RFC_2822 = function() {
};
function qm(e) {
  if (e._f === Vt.ISO_8601) {
    lx(e);
    return;
  }
  if (e._f === Vt.RFC_2822) {
    cx(e);
    return;
  }
  e._a = [], wr(e).empty = !0;
  var r = "" + e._i, i, t, n, a, s, o = r.length, l = 0, u, h;
  for (n = WE(e._f, e._locale).match(Lm) || [], h = n.length, i = 0; i < h; i++)
    a = n[i], t = (r.match(WL(a, e)) || [])[0], t && (s = r.substr(0, r.indexOf(t)), s.length > 0 && wr(e).unusedInput.push(s), r = r.slice(
      r.indexOf(t) + t.length
    ), l += t.length), $l[a] ? (t ? wr(e).empty = !1 : wr(e).unusedTokens.push(a), KL(a, t, e)) : e._strict && !t && wr(e).unusedTokens.push(a);
  wr(e).charsLeftOver = o - l, r.length > 0 && wr(e).unusedInput.push(r), e._a[an] <= 12 && wr(e).bigHour === !0 && e._a[an] > 0 && (wr(e).bigHour = void 0), wr(e).parsedDateParts = e._a.slice(0), wr(e).meridiem = e._meridiem, e._a[an] = sM(
    e._locale,
    e._a[an],
    e._meridiem
  ), u = wr(e).era, u !== null && (e._a[Fn] = e._locale.erasConvertYear(u, e._a[Fn])), Vm(e), Hm(e);
}
function sM(e, r, i) {
  var t;
  return i == null ? r : e.meridiemHour != null ? e.meridiemHour(r, i) : (e.isPM != null && (t = e.isPM(i), t && r < 12 && (r += 12), !t && r === 12 && (r = 0)), r);
}
function oM(e) {
  var r, i, t, n, a, s, o = !1, l = e._f.length;
  if (l === 0) {
    wr(e).invalidFormat = !0, e._d = new Date(NaN);
    return;
  }
  for (n = 0; n < l; n++)
    a = 0, s = !1, r = Pm({}, e), e._useUTC != null && (r._useUTC = e._useUTC), r._f = e._f[n], qm(r), Rm(r) && (s = !0), a += wr(r).charsLeftOver, a += wr(r).unusedTokens.length * 10, wr(r).score = a, o ? a < t && (t = a, i = r) : (t == null || a < t || s) && (t = a, i = r, s && (o = !0));
  Yo(e, i || r);
}
function uM(e) {
  if (!e._d) {
    var r = Im(e._i), i = r.day === void 0 ? r.date : r.day;
    e._a = HE(
      [r.year, r.month, i, r.hour, r.minute, r.second, r.millisecond],
      function(t) {
        return t && parseInt(t, 10);
      }
    ), Vm(e);
  }
}
function lM(e) {
  var r = new Id(Hm(dx(e)));
  return r._nextDay && (r.add(1, "d"), r._nextDay = void 0), r;
}
function dx(e) {
  var r = e._i, i = e._f;
  return e._locale = e._locale || Ao(e._l), r === null || i === void 0 && r === "" ? Vh({ nullInput: !0 }) : (typeof r == "string" && (e._i = r = e._locale.preparse(r)), hs(r) ? new Id(Hm(r)) : (Ld(r) ? e._d = r : fs(i) ? oM(e) : i ? qm(e) : cM(e), Rm(e) || (e._d = null), e));
}
function cM(e) {
  var r = e._i;
  sa(r) ? e._d = new Date(Vt.now()) : Ld(r) ? e._d = new Date(r.valueOf()) : typeof r == "string" ? iM(e) : fs(r) ? (e._a = HE(r.slice(0), function(i) {
    return parseInt(i, 10);
  }), Vm(e)) : Ku(r) ? uM(e) : yo(r) ? e._d = new Date(r) : Vt.createFromInputFallback(e);
}
function fx(e, r, i, t, n) {
  var a = {};
  return (r === !0 || r === !1) && (t = r, r = void 0), (i === !0 || i === !1) && (t = i, i = void 0), (Ku(e) && km(e) || fs(e) && e.length === 0) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = n, a._l = i, a._i = e, a._f = r, a._strict = t, lM(a);
}
function ki(e, r, i, t) {
  return fx(e, r, i, t, !1);
}
var dM = Ya(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = ki.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : Vh();
  }
), fM = Ya(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = ki.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : Vh();
  }
);
function hx(e, r) {
  var i, t;
  if (r.length === 1 && fs(r[0]) && (r = r[0]), !r.length)
    return ki();
  for (i = r[0], t = 1; t < r.length; ++t)
    (!r[t].isValid() || r[t][e](i)) && (i = r[t]);
  return i;
}
function hM() {
  var e = [].slice.call(arguments, 0);
  return hx("isBefore", e);
}
function pM() {
  var e = [].slice.call(arguments, 0);
  return hx("isAfter", e);
}
var gM = function() {
  return Date.now ? Date.now() : +new Date();
}, Bc = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function vM(e) {
  var r, i = !1, t, n = Bc.length;
  for (r in e)
    if (ei(e, r) && !(Hi.call(Bc, r) !== -1 && (e[r] == null || !isNaN(e[r]))))
      return !1;
  for (t = 0; t < n; ++t)
    if (e[Bc[t]]) {
      if (i)
        return !1;
      parseFloat(e[Bc[t]]) !== $r(e[Bc[t]]) && (i = !0);
    }
  return !0;
}
function mM() {
  return this._isValid;
}
function yM() {
  return vs(NaN);
}
function Qh(e) {
  var r = Im(e), i = r.year || 0, t = r.quarter || 0, n = r.month || 0, a = r.week || r.isoWeek || 0, s = r.day || 0, o = r.hour || 0, l = r.minute || 0, u = r.second || 0, h = r.millisecond || 0;
  this._isValid = vM(r), this._milliseconds = +h + u * 1e3 + l * 6e4 + o * 1e3 * 60 * 60, this._days = +s + a * 7, this._months = +n + t * 3 + i * 12, this._data = {}, this._locale = Ao(), this._bubble();
}
function Rf(e) {
  return e instanceof Qh;
}
function iv(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function _M(e, r, i) {
  var t = Math.min(e.length, r.length), n = Math.abs(e.length - r.length), a = 0, s;
  for (s = 0; s < t; s++)
    (i && e[s] !== r[s] || !i && $r(e[s]) !== $r(r[s])) && a++;
  return a + n;
}
function px(e, r) {
  lr(e, 0, 0, function() {
    var i = this.utcOffset(), t = "+";
    return i < 0 && (i = -i, t = "-"), t + $s(~~(i / 60), 2) + r + $s(~~i % 60, 2);
  });
}
px("Z", ":");
px("ZZ", "");
er("Z", zh);
er("ZZ", zh);
yi(["Z", "ZZ"], function(e, r, i) {
  i._useUTC = !0, i._tzm = Wm(zh, e);
});
var bM = /([\+\-]|\d\d)/gi;
function Wm(e, r) {
  var i = (r || "").match(e), t, n, a;
  return i === null ? null : (t = i[i.length - 1] || [], n = (t + "").match(bM) || ["-", 0, 0], a = +(n[1] * 60) + $r(n[2]), a === 0 ? 0 : n[0] === "+" ? a : -a);
}
function Ym(e, r) {
  var i, t;
  return r._isUTC ? (i = r.clone(), t = (hs(e) || Ld(e) ? e.valueOf() : ki(e).valueOf()) - i.valueOf(), i._d.setTime(i._d.valueOf() + t), Vt.updateOffset(i, !1), i) : ki(e).local();
}
function nv(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
Vt.updateOffset = function() {
};
function TM(e, r, i) {
  var t = this._offset || 0, n;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = Wm(zh, e), e === null)
        return this;
    } else
      Math.abs(e) < 16 && !i && (e = e * 60);
    return !this._isUTC && r && (n = nv(this)), this._offset = e, this._isUTC = !0, n != null && this.add(n, "m"), t !== e && (!r || this._changeInProgress ? mx(
      this,
      vs(e - t, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, Vt.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? t : nv(this);
}
function SM(e, r) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, r), this) : -this.utcOffset();
}
function EM(e) {
  return this.utcOffset(0, e);
}
function xM(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(nv(this), "m")), this;
}
function AM() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = Wm(VL, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function wM(e) {
  return this.isValid() ? (e = e ? ki(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function CM() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function DM() {
  if (!sa(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, r;
  return Pm(e, this), e = dx(e), e._a ? (r = e._isUTC ? Hs(e._a) : ki(e._a), this._isDSTShifted = this.isValid() && _M(e._a, r.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function kM() {
  return this.isValid() ? !this._isUTC : !1;
}
function RM() {
  return this.isValid() ? this._isUTC : !1;
}
function gx() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var PM = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, OM = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function vs(e, r) {
  var i = e, t = null, n, a, s;
  return Rf(e) ? i = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : yo(e) || !isNaN(+e) ? (i = {}, r ? i[r] = +e : i.milliseconds = +e) : (t = PM.exec(e)) ? (n = t[1] === "-" ? -1 : 1, i = {
    y: 0,
    d: $r(t[Ls]) * n,
    h: $r(t[an]) * n,
    m: $r(t[us]) * n,
    s: $r(t[oo]) * n,
    ms: $r(iv(t[ju] * 1e3)) * n
  }) : (t = OM.exec(e)) ? (n = t[1] === "-" ? -1 : 1, i = {
    y: Ru(t[2], n),
    M: Ru(t[3], n),
    w: Ru(t[4], n),
    d: Ru(t[5], n),
    h: Ru(t[6], n),
    m: Ru(t[7], n),
    s: Ru(t[8], n)
  }) : i == null ? i = {} : typeof i == "object" && ("from" in i || "to" in i) && (s = LM(
    ki(i.from),
    ki(i.to)
  ), i = {}, i.ms = s.milliseconds, i.M = s.months), a = new Qh(i), Rf(e) && ei(e, "_locale") && (a._locale = e._locale), Rf(e) && ei(e, "_isValid") && (a._isValid = e._isValid), a;
}
vs.fn = Qh.prototype;
vs.invalid = yM;
function Ru(e, r) {
  var i = e && parseFloat(e.replace(",", "."));
  return (isNaN(i) ? 0 : i) * r;
}
function ub(e, r) {
  var i = {};
  return i.months = r.month() - e.month() + (r.year() - e.year()) * 12, e.clone().add(i.months, "M").isAfter(r) && --i.months, i.milliseconds = +r - +e.clone().add(i.months, "M"), i;
}
function LM(e, r) {
  var i;
  return e.isValid() && r.isValid() ? (r = Ym(r, e), e.isBefore(r) ? i = ub(e, r) : (i = ub(r, e), i.milliseconds = -i.milliseconds, i.months = -i.months), i) : { milliseconds: 0, months: 0 };
}
function vx(e, r) {
  return function(i, t) {
    var n, a;
    return t !== null && !isNaN(+t) && (qE(
      r,
      "moment()." + r + "(period, number) is deprecated. Please use moment()." + r + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = i, i = t, t = a), n = vs(i, t), mx(this, n, e), this;
  };
}
function mx(e, r, i, t) {
  var n = r._milliseconds, a = iv(r._days), s = iv(r._months);
  !e.isValid() || (t = t == null ? !0 : t, s && tx(e, hd(e, "Month") + s * i), a && QE(e, "Date", hd(e, "Date") + a * i), n && e._d.setTime(e._d.valueOf() + n * i), t && Vt.updateOffset(e, a || s));
}
var IM = vx(1, "add"), MM = vx(-1, "subtract");
function yx(e) {
  return typeof e == "string" || e instanceof String;
}
function NM(e) {
  return hs(e) || Ld(e) || yx(e) || yo(e) || UM(e) || FM(e) || e === null || e === void 0;
}
function FM(e) {
  var r = Ku(e) && !km(e), i = !1, t = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], n, a, s = t.length;
  for (n = 0; n < s; n += 1)
    a = t[n], i = i || ei(e, a);
  return r && i;
}
function UM(e) {
  var r = fs(e), i = !1;
  return r && (i = e.filter(function(t) {
    return !yo(t) && yx(e);
  }).length === 0), r && i;
}
function BM(e) {
  var r = Ku(e) && !km(e), i = !1, t = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], n, a;
  for (n = 0; n < t.length; n += 1)
    a = t[n], i = i || ei(e, a);
  return r && i;
}
function jM(e, r) {
  var i = e.diff(r, "days", !0);
  return i < -6 ? "sameElse" : i < -1 ? "lastWeek" : i < 0 ? "lastDay" : i < 1 ? "sameDay" : i < 2 ? "nextDay" : i < 7 ? "nextWeek" : "sameElse";
}
function $M(e, r) {
  arguments.length === 1 && (arguments[0] ? NM(arguments[0]) ? (e = arguments[0], r = void 0) : BM(arguments[0]) && (r = arguments[0], e = void 0) : (e = void 0, r = void 0));
  var i = e || ki(), t = Ym(i, this).startOf("day"), n = Vt.calendarFormat(this, t) || "sameElse", a = r && (Vs(r[n]) ? r[n].call(this, i) : r[n]);
  return this.format(
    a || this.localeData().calendar(n, this, ki(i))
  );
}
function GM() {
  return new Id(this);
}
function HM(e, r) {
  var i = hs(e) ? e : ki(e);
  return this.isValid() && i.isValid() ? (r = Ka(r) || "millisecond", r === "millisecond" ? this.valueOf() > i.valueOf() : i.valueOf() < this.clone().startOf(r).valueOf()) : !1;
}
function VM(e, r) {
  var i = hs(e) ? e : ki(e);
  return this.isValid() && i.isValid() ? (r = Ka(r) || "millisecond", r === "millisecond" ? this.valueOf() < i.valueOf() : this.clone().endOf(r).valueOf() < i.valueOf()) : !1;
}
function qM(e, r, i, t) {
  var n = hs(e) ? e : ki(e), a = hs(r) ? r : ki(r);
  return this.isValid() && n.isValid() && a.isValid() ? (t = t || "()", (t[0] === "(" ? this.isAfter(n, i) : !this.isBefore(n, i)) && (t[1] === ")" ? this.isBefore(a, i) : !this.isAfter(a, i))) : !1;
}
function WM(e, r) {
  var i = hs(e) ? e : ki(e), t;
  return this.isValid() && i.isValid() ? (r = Ka(r) || "millisecond", r === "millisecond" ? this.valueOf() === i.valueOf() : (t = i.valueOf(), this.clone().startOf(r).valueOf() <= t && t <= this.clone().endOf(r).valueOf())) : !1;
}
function YM(e, r) {
  return this.isSame(e, r) || this.isAfter(e, r);
}
function KM(e, r) {
  return this.isSame(e, r) || this.isBefore(e, r);
}
function zM(e, r, i) {
  var t, n, a;
  if (!this.isValid())
    return NaN;
  if (t = Ym(e, this), !t.isValid())
    return NaN;
  switch (n = (t.utcOffset() - this.utcOffset()) * 6e4, r = Ka(r), r) {
    case "year":
      a = Pf(this, t) / 12;
      break;
    case "month":
      a = Pf(this, t);
      break;
    case "quarter":
      a = Pf(this, t) / 3;
      break;
    case "second":
      a = (this - t) / 1e3;
      break;
    case "minute":
      a = (this - t) / 6e4;
      break;
    case "hour":
      a = (this - t) / 36e5;
      break;
    case "day":
      a = (this - t - n) / 864e5;
      break;
    case "week":
      a = (this - t - n) / 6048e5;
      break;
    default:
      a = this - t;
  }
  return i ? a : Ha(a);
}
function Pf(e, r) {
  if (e.date() < r.date())
    return -Pf(r, e);
  var i = (r.year() - e.year()) * 12 + (r.month() - e.month()), t = e.clone().add(i, "months"), n, a;
  return r - t < 0 ? (n = e.clone().add(i - 1, "months"), a = (r - t) / (t - n)) : (n = e.clone().add(i + 1, "months"), a = (r - t) / (n - t)), -(i + a) || 0;
}
Vt.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
Vt.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function XM() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function JM(e) {
  if (!this.isValid())
    return null;
  var r = e !== !0, i = r ? this.clone().utc() : this;
  return i.year() < 0 || i.year() > 9999 ? kf(
    i,
    r ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : Vs(Date.prototype.toISOString) ? r ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", kf(i, "Z")) : kf(
    i,
    r ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function QM() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", r = "", i, t, n, a;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", r = "Z"), i = "[" + e + '("]', t = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", n = "-MM-DD[T]HH:mm:ss.SSS", a = r + '[")]', this.format(i + t + n + a);
}
function ZM(e) {
  e || (e = this.isUtc() ? Vt.defaultFormatUtc : Vt.defaultFormat);
  var r = kf(this, e);
  return this.localeData().postformat(r);
}
function eN(e, r) {
  return this.isValid() && (hs(e) && e.isValid() || ki(e).isValid()) ? vs({ to: this, from: e }).locale(this.locale()).humanize(!r) : this.localeData().invalidDate();
}
function tN(e) {
  return this.from(ki(), e);
}
function rN(e, r) {
  return this.isValid() && (hs(e) && e.isValid() || ki(e).isValid()) ? vs({ from: this, to: e }).locale(this.locale()).humanize(!r) : this.localeData().invalidDate();
}
function iN(e) {
  return this.to(ki(), e);
}
function _x(e) {
  var r;
  return e === void 0 ? this._locale._abbr : (r = Ao(e), r != null && (this._locale = r), this);
}
var bx = Ya(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function Tx() {
  return this._locale;
}
var sh = 1e3, Gl = 60 * sh, oh = 60 * Gl, Sx = (365 * 400 + 97) * 24 * oh;
function Hl(e, r) {
  return (e % r + r) % r;
}
function Ex(e, r, i) {
  return e < 100 && e >= 0 ? new Date(e + 400, r, i) - Sx : new Date(e, r, i).valueOf();
}
function xx(e, r, i) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, r, i) - Sx : Date.UTC(e, r, i);
}
function nN(e) {
  var r, i;
  if (e = Ka(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (i = this._isUTC ? xx : Ex, e) {
    case "year":
      r = i(this.year(), 0, 1);
      break;
    case "quarter":
      r = i(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      r = i(this.year(), this.month(), 1);
      break;
    case "week":
      r = i(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      r = i(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      r = i(this.year(), this.month(), this.date());
      break;
    case "hour":
      r = this._d.valueOf(), r -= Hl(
        r + (this._isUTC ? 0 : this.utcOffset() * Gl),
        oh
      );
      break;
    case "minute":
      r = this._d.valueOf(), r -= Hl(r, Gl);
      break;
    case "second":
      r = this._d.valueOf(), r -= Hl(r, sh);
      break;
  }
  return this._d.setTime(r), Vt.updateOffset(this, !0), this;
}
function aN(e) {
  var r, i;
  if (e = Ka(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (i = this._isUTC ? xx : Ex, e) {
    case "year":
      r = i(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      r = i(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      r = i(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      r = i(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      r = i(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      r = i(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      r = this._d.valueOf(), r += oh - Hl(
        r + (this._isUTC ? 0 : this.utcOffset() * Gl),
        oh
      ) - 1;
      break;
    case "minute":
      r = this._d.valueOf(), r += Gl - Hl(r, Gl) - 1;
      break;
    case "second":
      r = this._d.valueOf(), r += sh - Hl(r, sh) - 1;
      break;
  }
  return this._d.setTime(r), Vt.updateOffset(this, !0), this;
}
function sN() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function oN() {
  return Math.floor(this.valueOf() / 1e3);
}
function uN() {
  return new Date(this.valueOf());
}
function lN() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function cN() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function dN() {
  return this.isValid() ? this.toISOString() : null;
}
function fN() {
  return Rm(this);
}
function hN() {
  return Yo({}, wr(this));
}
function pN() {
  return wr(this).overflow;
}
function gN() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
lr("N", 0, 0, "eraAbbr");
lr("NN", 0, 0, "eraAbbr");
lr("NNN", 0, 0, "eraAbbr");
lr("NNNN", 0, 0, "eraName");
lr("NNNNN", 0, 0, "eraNarrow");
lr("y", ["y", 1], "yo", "eraYear");
lr("y", ["yy", 2], 0, "eraYear");
lr("y", ["yyy", 3], 0, "eraYear");
lr("y", ["yyyy", 4], 0, "eraYear");
er("N", Km);
er("NN", Km);
er("NNN", Km);
er("NNNN", wN);
er("NNNNN", CN);
yi(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, r, i, t) {
    var n = i._locale.erasParse(e, t, i._strict);
    n ? wr(i).era = n : wr(i).invalidEra = e;
  }
);
er("y", hc);
er("yy", hc);
er("yyy", hc);
er("yyyy", hc);
er("yo", DN);
yi(["y", "yy", "yyy", "yyyy"], Fn);
yi(["yo"], function(e, r, i, t) {
  var n;
  i._locale._eraYearOrdinalRegex && (n = e.match(i._locale._eraYearOrdinalRegex)), i._locale.eraYearOrdinalParse ? r[Fn] = i._locale.eraYearOrdinalParse(e, n) : r[Fn] = parseInt(e, 10);
});
function vN(e, r) {
  var i, t, n, a = this._eras || Ao("en")._eras;
  for (i = 0, t = a.length; i < t; ++i) {
    switch (typeof a[i].since) {
      case "string":
        n = Vt(a[i].since).startOf("day"), a[i].since = n.valueOf();
        break;
    }
    switch (typeof a[i].until) {
      case "undefined":
        a[i].until = 1 / 0;
        break;
      case "string":
        n = Vt(a[i].until).startOf("day").valueOf(), a[i].until = n.valueOf();
        break;
    }
  }
  return a;
}
function mN(e, r, i) {
  var t, n, a = this.eras(), s, o, l;
  for (e = e.toUpperCase(), t = 0, n = a.length; t < n; ++t)
    if (s = a[t].name.toUpperCase(), o = a[t].abbr.toUpperCase(), l = a[t].narrow.toUpperCase(), i)
      switch (r) {
        case "N":
        case "NN":
        case "NNN":
          if (o === e)
            return a[t];
          break;
        case "NNNN":
          if (s === e)
            return a[t];
          break;
        case "NNNNN":
          if (l === e)
            return a[t];
          break;
      }
    else if ([s, o, l].indexOf(e) >= 0)
      return a[t];
}
function yN(e, r) {
  var i = e.since <= e.until ? 1 : -1;
  return r === void 0 ? Vt(e.since).year() : Vt(e.since).year() + (r - e.offset) * i;
}
function _N() {
  var e, r, i, t = this.localeData().eras();
  for (e = 0, r = t.length; e < r; ++e)
    if (i = this.clone().startOf("day").valueOf(), t[e].since <= i && i <= t[e].until || t[e].until <= i && i <= t[e].since)
      return t[e].name;
  return "";
}
function bN() {
  var e, r, i, t = this.localeData().eras();
  for (e = 0, r = t.length; e < r; ++e)
    if (i = this.clone().startOf("day").valueOf(), t[e].since <= i && i <= t[e].until || t[e].until <= i && i <= t[e].since)
      return t[e].narrow;
  return "";
}
function TN() {
  var e, r, i, t = this.localeData().eras();
  for (e = 0, r = t.length; e < r; ++e)
    if (i = this.clone().startOf("day").valueOf(), t[e].since <= i && i <= t[e].until || t[e].until <= i && i <= t[e].since)
      return t[e].abbr;
  return "";
}
function SN() {
  var e, r, i, t, n = this.localeData().eras();
  for (e = 0, r = n.length; e < r; ++e)
    if (i = n[e].since <= n[e].until ? 1 : -1, t = this.clone().startOf("day").valueOf(), n[e].since <= t && t <= n[e].until || n[e].until <= t && t <= n[e].since)
      return (this.year() - Vt(n[e].since).year()) * i + n[e].offset;
  return this.year();
}
function EN(e) {
  return ei(this, "_erasNameRegex") || zm.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function xN(e) {
  return ei(this, "_erasAbbrRegex") || zm.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function AN(e) {
  return ei(this, "_erasNarrowRegex") || zm.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function Km(e, r) {
  return r.erasAbbrRegex(e);
}
function wN(e, r) {
  return r.erasNameRegex(e);
}
function CN(e, r) {
  return r.erasNarrowRegex(e);
}
function DN(e, r) {
  return r._eraYearOrdinalRegex || hc;
}
function zm() {
  var e = [], r = [], i = [], t = [], n, a, s, o, l, u = this.eras();
  for (n = 0, a = u.length; n < a; ++n)
    s = co(u[n].name), o = co(u[n].abbr), l = co(u[n].narrow), r.push(s), e.push(o), i.push(l), t.push(s), t.push(o), t.push(l);
  this._erasRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  );
}
lr(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
lr(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function Zh(e, r) {
  lr(0, [e, e.length], 0, r);
}
Zh("gggg", "weekYear");
Zh("ggggg", "weekYear");
Zh("GGGG", "isoWeekYear");
Zh("GGGGG", "isoWeekYear");
er("G", Kh);
er("g", Kh);
er("GG", Pi, Aa);
er("gg", Pi, Aa);
er("GGGG", Nm, Mm);
er("gggg", Nm, Mm);
er("GGGGG", Yh, qh);
er("ggggg", Yh, qh);
Nd(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, r, i, t) {
    r[t.substr(0, 2)] = $r(e);
  }
);
Nd(["gg", "GG"], function(e, r, i, t) {
  r[t] = Vt.parseTwoDigitYear(e);
});
function kN(e) {
  return Ax.call(
    this,
    e,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function RN(e) {
  return Ax.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function PN() {
  return fo(this.year(), 1, 4);
}
function ON() {
  return fo(this.isoWeekYear(), 1, 4);
}
function LN() {
  var e = this.localeData()._week;
  return fo(this.year(), e.dow, e.doy);
}
function IN() {
  var e = this.localeData()._week;
  return fo(this.weekYear(), e.dow, e.doy);
}
function Ax(e, r, i, t, n) {
  var a;
  return e == null ? gd(this, t, n).year : (a = fo(e, t, n), r > a && (r = a), MN.call(this, e, r, i, t, n));
}
function MN(e, r, i, t, n) {
  var a = nx(e, r, i, t, n), s = pd(a.year, 0, a.dayOfYear);
  return this.year(s.getUTCFullYear()), this.month(s.getUTCMonth()), this.date(s.getUTCDate()), this;
}
lr("Q", 0, "Qo", "quarter");
er("Q", YE);
yi("Q", function(e, r) {
  r[so] = ($r(e) - 1) * 3;
});
function NN(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
lr("D", ["DD", 2], "Do", "date");
er("D", Pi, pc);
er("DD", Pi, Aa);
er("Do", function(e, r) {
  return e ? r._dayOfMonthOrdinalParse || r._ordinalParse : r._dayOfMonthOrdinalParseLenient;
});
yi(["D", "DD"], Ls);
yi("Do", function(e, r) {
  r[Ls] = $r(e.match(Pi)[0]);
});
var wx = gc("Date", !0);
lr("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
er("DDD", Wh);
er("DDDD", KE);
yi(["DDD", "DDDD"], function(e, r, i) {
  i._dayOfYear = $r(e);
});
function FN(e) {
  var r = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? r : this.add(e - r, "d");
}
lr("m", ["mm", 2], 0, "minute");
er("m", Pi, Fm);
er("mm", Pi, Aa);
yi(["m", "mm"], us);
var UN = gc("Minutes", !1);
lr("s", ["ss", 2], 0, "second");
er("s", Pi, Fm);
er("ss", Pi, Aa);
yi(["s", "ss"], oo);
var BN = gc("Seconds", !1);
lr("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
lr(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
lr(0, ["SSS", 3], 0, "millisecond");
lr(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
lr(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
lr(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
lr(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
lr(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
lr(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
er("S", Wh, YE);
er("SS", Wh, Aa);
er("SSS", Wh, KE);
var Ko, Cx;
for (Ko = "SSSS"; Ko.length <= 9; Ko += "S")
  er(Ko, hc);
function jN(e, r) {
  r[ju] = $r(("0." + e) * 1e3);
}
for (Ko = "S"; Ko.length <= 9; Ko += "S")
  yi(Ko, jN);
Cx = gc("Milliseconds", !1);
lr("z", 0, 0, "zoneAbbr");
lr("zz", 0, 0, "zoneName");
function $N() {
  return this._isUTC ? "UTC" : "";
}
function GN() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var Dt = Id.prototype;
Dt.add = IM;
Dt.calendar = $M;
Dt.clone = GM;
Dt.diff = zM;
Dt.endOf = aN;
Dt.format = ZM;
Dt.from = eN;
Dt.fromNow = tN;
Dt.to = rN;
Dt.toNow = iN;
Dt.get = QL;
Dt.invalidAt = pN;
Dt.isAfter = HM;
Dt.isBefore = VM;
Dt.isBetween = qM;
Dt.isSame = WM;
Dt.isSameOrAfter = YM;
Dt.isSameOrBefore = KM;
Dt.isValid = fN;
Dt.lang = bx;
Dt.locale = _x;
Dt.localeData = Tx;
Dt.max = fM;
Dt.min = dM;
Dt.parsingFlags = hN;
Dt.set = ZL;
Dt.startOf = nN;
Dt.subtract = MM;
Dt.toArray = lN;
Dt.toObject = cN;
Dt.toDate = uN;
Dt.toISOString = JM;
Dt.inspect = QM;
typeof Symbol < "u" && Symbol.for != null && (Dt[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
Dt.toJSON = dN;
Dt.toString = XM;
Dt.unix = oN;
Dt.valueOf = sN;
Dt.creationData = gN;
Dt.eraName = _N;
Dt.eraNarrow = bN;
Dt.eraAbbr = TN;
Dt.eraYear = SN;
Dt.year = JE;
Dt.isLeapYear = JL;
Dt.weekYear = kN;
Dt.isoWeekYear = RN;
Dt.quarter = Dt.quarters = NN;
Dt.month = rx;
Dt.daysInMonth = uI;
Dt.week = Dt.weeks = vI;
Dt.isoWeek = Dt.isoWeeks = mI;
Dt.weeksInYear = LN;
Dt.weeksInWeekYear = IN;
Dt.isoWeeksInYear = PN;
Dt.isoWeeksInISOWeekYear = ON;
Dt.date = wx;
Dt.day = Dt.days = RI;
Dt.weekday = PI;
Dt.isoWeekday = OI;
Dt.dayOfYear = FN;
Dt.hour = Dt.hours = BI;
Dt.minute = Dt.minutes = UN;
Dt.second = Dt.seconds = BN;
Dt.millisecond = Dt.milliseconds = Cx;
Dt.utcOffset = TM;
Dt.utc = EM;
Dt.local = xM;
Dt.parseZone = AM;
Dt.hasAlignedHourOffset = wM;
Dt.isDST = CM;
Dt.isLocal = kM;
Dt.isUtcOffset = RM;
Dt.isUtc = gx;
Dt.isUTC = gx;
Dt.zoneAbbr = $N;
Dt.zoneName = GN;
Dt.dates = Ya(
  "dates accessor is deprecated. Use date instead.",
  wx
);
Dt.months = Ya(
  "months accessor is deprecated. Use month instead",
  rx
);
Dt.years = Ya(
  "years accessor is deprecated. Use year instead",
  JE
);
Dt.zone = Ya(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  SM
);
Dt.isDSTShifted = Ya(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  DM
);
function HN(e) {
  return ki(e * 1e3);
}
function VN() {
  return ki.apply(null, arguments).parseZone();
}
function Dx(e) {
  return e;
}
var ti = Om.prototype;
ti.calendar = kL;
ti.longDateFormat = LL;
ti.invalidDate = ML;
ti.ordinal = UL;
ti.preparse = Dx;
ti.postformat = Dx;
ti.relativeTime = jL;
ti.pastFuture = $L;
ti.set = CL;
ti.eras = vN;
ti.erasParse = mN;
ti.erasConvertYear = yN;
ti.erasAbbrRegex = xN;
ti.erasNameRegex = EN;
ti.erasNarrowRegex = AN;
ti.months = nI;
ti.monthsShort = aI;
ti.monthsParse = oI;
ti.monthsRegex = cI;
ti.monthsShortRegex = lI;
ti.week = fI;
ti.firstDayOfYear = gI;
ti.firstDayOfWeek = pI;
ti.weekdays = AI;
ti.weekdaysMin = CI;
ti.weekdaysShort = wI;
ti.weekdaysParse = kI;
ti.weekdaysRegex = LI;
ti.weekdaysShortRegex = II;
ti.weekdaysMinRegex = MI;
ti.isPM = FI;
ti.meridiem = jI;
function uh(e, r, i, t) {
  var n = Ao(), a = Hs().set(t, r);
  return n[i](a, e);
}
function kx(e, r, i) {
  if (yo(e) && (r = e, e = void 0), e = e || "", r != null)
    return uh(e, r, i, "month");
  var t, n = [];
  for (t = 0; t < 12; t++)
    n[t] = uh(e, t, i, "month");
  return n;
}
function Xm(e, r, i, t) {
  typeof e == "boolean" ? (yo(r) && (i = r, r = void 0), r = r || "") : (r = e, i = r, e = !1, yo(r) && (i = r, r = void 0), r = r || "");
  var n = Ao(), a = e ? n._week.dow : 0, s, o = [];
  if (i != null)
    return uh(r, (i + a) % 7, t, "day");
  for (s = 0; s < 7; s++)
    o[s] = uh(r, (s + a) % 7, t, "day");
  return o;
}
function qN(e, r) {
  return kx(e, r, "months");
}
function WN(e, r) {
  return kx(e, r, "monthsShort");
}
function YN(e, r, i) {
  return Xm(e, r, i, "weekdays");
}
function KN(e, r, i) {
  return Xm(e, r, i, "weekdaysShort");
}
function zN(e, r, i) {
  return Xm(e, r, i, "weekdaysMin");
}
Zo("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var r = e % 10, i = $r(e % 100 / 10) === 1 ? "th" : r === 1 ? "st" : r === 2 ? "nd" : r === 3 ? "rd" : "th";
    return e + i;
  }
});
Vt.lang = Ya(
  "moment.lang is deprecated. Use moment.locale instead.",
  Zo
);
Vt.langData = Ya(
  "moment.langData is deprecated. Use moment.localeData instead.",
  Ao
);
var ro = Math.abs;
function XN() {
  var e = this._data;
  return this._milliseconds = ro(this._milliseconds), this._days = ro(this._days), this._months = ro(this._months), e.milliseconds = ro(e.milliseconds), e.seconds = ro(e.seconds), e.minutes = ro(e.minutes), e.hours = ro(e.hours), e.months = ro(e.months), e.years = ro(e.years), this;
}
function Rx(e, r, i, t) {
  var n = vs(r, i);
  return e._milliseconds += t * n._milliseconds, e._days += t * n._days, e._months += t * n._months, e._bubble();
}
function JN(e, r) {
  return Rx(this, e, r, 1);
}
function QN(e, r) {
  return Rx(this, e, r, -1);
}
function lb(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function ZN() {
  var e = this._milliseconds, r = this._days, i = this._months, t = this._data, n, a, s, o, l;
  return e >= 0 && r >= 0 && i >= 0 || e <= 0 && r <= 0 && i <= 0 || (e += lb(av(i) + r) * 864e5, r = 0, i = 0), t.milliseconds = e % 1e3, n = Ha(e / 1e3), t.seconds = n % 60, a = Ha(n / 60), t.minutes = a % 60, s = Ha(a / 60), t.hours = s % 24, r += Ha(s / 24), l = Ha(Px(r)), i += l, r -= lb(av(l)), o = Ha(i / 12), i %= 12, t.days = r, t.months = i, t.years = o, this;
}
function Px(e) {
  return e * 4800 / 146097;
}
function av(e) {
  return e * 146097 / 4800;
}
function eF(e) {
  if (!this.isValid())
    return NaN;
  var r, i, t = this._milliseconds;
  if (e = Ka(e), e === "month" || e === "quarter" || e === "year")
    switch (r = this._days + t / 864e5, i = this._months + Px(r), e) {
      case "month":
        return i;
      case "quarter":
        return i / 3;
      case "year":
        return i / 12;
    }
  else
    switch (r = this._days + Math.round(av(this._months)), e) {
      case "week":
        return r / 7 + t / 6048e5;
      case "day":
        return r + t / 864e5;
      case "hour":
        return r * 24 + t / 36e5;
      case "minute":
        return r * 1440 + t / 6e4;
      case "second":
        return r * 86400 + t / 1e3;
      case "millisecond":
        return Math.floor(r * 864e5) + t;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function wo(e) {
  return function() {
    return this.as(e);
  };
}
var Ox = wo("ms"), tF = wo("s"), rF = wo("m"), iF = wo("h"), nF = wo("d"), aF = wo("w"), sF = wo("M"), oF = wo("Q"), uF = wo("y"), lF = Ox;
function cF() {
  return vs(this);
}
function dF(e) {
  return e = Ka(e), this.isValid() ? this[e + "s"]() : NaN;
}
function nl(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var fF = nl("milliseconds"), hF = nl("seconds"), pF = nl("minutes"), gF = nl("hours"), vF = nl("days"), mF = nl("months"), yF = nl("years");
function _F() {
  return Ha(this.days() / 7);
}
var no = Math.round, Ll = {
  ss: 44,
  s: 45,
  m: 45,
  h: 22,
  d: 26,
  w: null,
  M: 11
};
function bF(e, r, i, t, n) {
  return n.relativeTime(r || 1, !!i, e, t);
}
function TF(e, r, i, t) {
  var n = vs(e).abs(), a = no(n.as("s")), s = no(n.as("m")), o = no(n.as("h")), l = no(n.as("d")), u = no(n.as("M")), h = no(n.as("w")), c = no(n.as("y")), d = a <= i.ss && ["s", a] || a < i.s && ["ss", a] || s <= 1 && ["m"] || s < i.m && ["mm", s] || o <= 1 && ["h"] || o < i.h && ["hh", o] || l <= 1 && ["d"] || l < i.d && ["dd", l];
  return i.w != null && (d = d || h <= 1 && ["w"] || h < i.w && ["ww", h]), d = d || u <= 1 && ["M"] || u < i.M && ["MM", u] || c <= 1 && ["y"] || ["yy", c], d[2] = r, d[3] = +e > 0, d[4] = t, bF.apply(null, d);
}
function SF(e) {
  return e === void 0 ? no : typeof e == "function" ? (no = e, !0) : !1;
}
function EF(e, r) {
  return Ll[e] === void 0 ? !1 : r === void 0 ? Ll[e] : (Ll[e] = r, e === "s" && (Ll.ss = r - 1), !0);
}
function xF(e, r) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var i = !1, t = Ll, n, a;
  return typeof e == "object" && (r = e, e = !1), typeof e == "boolean" && (i = e), typeof r == "object" && (t = Object.assign({}, Ll, r), r.s != null && r.ss == null && (t.ss = r.s - 1)), n = this.localeData(), a = TF(this, !i, t, n), i && (a = n.pastFuture(+this, a)), n.postformat(a);
}
var rg = Math.abs;
function Cl(e) {
  return (e > 0) - (e < 0) || +e;
}
function ep() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = rg(this._milliseconds) / 1e3, r = rg(this._days), i = rg(this._months), t, n, a, s, o = this.asSeconds(), l, u, h, c;
  return o ? (t = Ha(e / 60), n = Ha(t / 60), e %= 60, t %= 60, a = Ha(i / 12), i %= 12, s = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", l = o < 0 ? "-" : "", u = Cl(this._months) !== Cl(o) ? "-" : "", h = Cl(this._days) !== Cl(o) ? "-" : "", c = Cl(this._milliseconds) !== Cl(o) ? "-" : "", l + "P" + (a ? u + a + "Y" : "") + (i ? u + i + "M" : "") + (r ? h + r + "D" : "") + (n || t || e ? "T" : "") + (n ? c + n + "H" : "") + (t ? c + t + "M" : "") + (e ? c + s + "S" : "")) : "P0D";
}
var Yr = Qh.prototype;
Yr.isValid = mM;
Yr.abs = XN;
Yr.add = JN;
Yr.subtract = QN;
Yr.as = eF;
Yr.asMilliseconds = Ox;
Yr.asSeconds = tF;
Yr.asMinutes = rF;
Yr.asHours = iF;
Yr.asDays = nF;
Yr.asWeeks = aF;
Yr.asMonths = sF;
Yr.asQuarters = oF;
Yr.asYears = uF;
Yr.valueOf = lF;
Yr._bubble = ZN;
Yr.clone = cF;
Yr.get = dF;
Yr.milliseconds = fF;
Yr.seconds = hF;
Yr.minutes = pF;
Yr.hours = gF;
Yr.days = vF;
Yr.weeks = _F;
Yr.months = mF;
Yr.years = yF;
Yr.humanize = xF;
Yr.toISOString = ep;
Yr.toString = ep;
Yr.toJSON = ep;
Yr.locale = _x;
Yr.localeData = Tx;
Yr.toIsoString = Ya(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  ep
);
Yr.lang = bx;
lr("X", 0, 0, "unix");
lr("x", 0, 0, "valueOf");
er("x", Kh);
er("X", qL);
yi("X", function(e, r, i) {
  i._d = new Date(parseFloat(e) * 1e3);
});
yi("x", function(e, r, i) {
  i._d = new Date($r(e));
});
//! moment.js
Vt.version = "2.30.1";
AL(ki);
Vt.fn = Dt;
Vt.min = hM;
Vt.max = pM;
Vt.now = gM;
Vt.utc = Hs;
Vt.unix = HN;
Vt.months = qN;
Vt.isDate = Ld;
Vt.locale = Zo;
Vt.invalid = Vh;
Vt.duration = vs;
Vt.isMoment = hs;
Vt.weekdays = YN;
Vt.parseZone = VN;
Vt.localeData = Ao;
Vt.isDuration = Rf;
Vt.monthsShort = WN;
Vt.weekdaysMin = zN;
Vt.defineLocale = Gm;
Vt.updateLocale = VI;
Vt.locales = qI;
Vt.weekdaysShort = KN;
Vt.normalizeUnits = Ka;
Vt.relativeTimeRounding = SF;
Vt.relativeTimeThreshold = EF;
Vt.calendarFormat = jM;
Vt.prototype = Dt;
Vt.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  DATE: "YYYY-MM-DD",
  TIME: "HH:mm",
  TIME_SECONDS: "HH:mm:ss",
  TIME_MS: "HH:mm:ss.SSS",
  WEEK: "GGGG-[W]WW",
  MONTH: "YYYY-MM"
};
fr.factory("HlsManifest", ["$rootScope", "$http", "$q", "PlayerEvents", "HlsService", function(e, r, i, t, n) {
  let o = function(d) {
    this.parseManifest(d), this.chunkCount = 0, this.streamHealth = 0, this.isFirstHealthCount = !0, this.onTimecodeCB = () => {
    };
  };
  function l(c, d) {
    for (let f = 0; f < c.length; f++)
      if (d.startsWith(c.substr(f)))
        return c.substr(0, f) + d;
    return c + d;
  }
  function u(c) {
    let d = i.defer();
    return r.get(c).then(function(f) {
      let m = new xg();
      m.push(f.data), m.end(), d.resolve(m.manifest);
    }), d.promise;
  }
  const h = (c, d) => c.attributes.BANDWIDTH > d.attributes.BANDWIDTH ? 1 : d.attributes.BANDWIDTH > c.attributes.BANDWIDTH ? -1 : 0;
  return o.prototype = {
    parseManifest: function(c) {
      let d = this;
      n.isHLS(c) && (this.src = c, this.baseUrl = c.substr(0, c.lastIndexOf("/") + 1), u(c).then(function(f) {
        if (d.manifest = f, d.playlists = f.playlists.sort(h), d.playlists && d.playlists.length)
          d.subManifestUrl = l(d.baseUrl, d.playlists[0].uri), u(d.subManifestUrl).then(function(m) {
            d._live = !m.endList, d._segmentDuration = m.segments.length ? Math.round(m.segments[0].duration) : m.targetDuration, e.$broadcast(t.MANIFEST_PARSED, c);
          });
        else {
          try {
            d._live = !f.endList, d._segmentDuration = Math.round(f.segments[0].duration);
          } catch {
          }
          e.$broadcast(t.MANIFEST_PARSED, c);
        }
      }));
    },
    startManualParseInterval: function() {
      let c = this;
      this.manualParseInterval || (this.manualParseInterval = setInterval(function() {
        c._getCurrentTime();
      }, 3e3));
    },
    stopManualParseInterval: function() {
      this.manualParseInterval && (clearInterval(this.manualParseInterval), delete self.manualParseInterval);
    },
    getLevel: function(c) {
      if (c = this.playlists && Math.min(this.playlists.length - 1, c) || 0, this.playlists && this.playlists.length && this.playlists[c])
        return this.baseUrl + this.playlists[c].uri;
    },
    getLowestLevel: function() {
      if (this.playlists && this.playlists.length)
        return this.baseUrl + this.playlists[0].uri;
    },
    getMediumLevel: function() {
      if (this.playlists && this.playlists.length)
        return this.baseUrl + this.playlists[Math.ceil(this.playlists.length / 2) - 1].uri;
    },
    getHighestLevel: function() {
      if (this.playlists && this.playlists.length)
        return this.baseUrl + this.playlists[this.playlists.length - 1].uri;
    },
    isLive: function() {
      return this._live;
    },
    destroy: function() {
      this.stopManualParseInterval();
    },
    calculateStreamHealth: function(c, d) {
      this.isFirstHealthCount && (this.chunkCount = parseInt(sessionStorage.getItem(c + "-sample-size")) || 0, this.streamHealth = parseFloat(sessionStorage.getItem(c + "-stream-health")) || 0, this.isFirstHealthCount = !1), this.chunkCount++, this.streamHealth = (this.streamHealth * (this.chunkCount - 1) + d) / this.chunkCount, window.health_trend = d, window.sample_size = this.chunkCount, window.stream_health = this.streamHealth, sessionStorage.setItem(c + "-sample-size", this.chunkCount), sessionStorage.setItem(c + "-stream-health", this.streamHealth);
    },
    streamHealthSuccess: function(c) {
      this.calculateStreamHealth(c, 1);
    },
    streamHealthFail: function(c) {
      this.calculateStreamHealth(c, 0);
    },
    _getCurrentTime: function() {
      let c = i.defer(), d = this;
      if (this.subManifestUrl)
        u(d.subManifestUrl).then((f) => {
          let m = f.segments[f.segments.length - Math.min(3, f.segments.length)], p = Vt.utc(m.dateTimeString).valueOf();
          p !== d.lastCurrentTimecode && this.isLive() && (d.onTimecodeCB({ pdt: p, duration: d._segmentDuration }), d.lastCurrentTimecode = p), c.resolve(d.currentTimecode);
        });
      else if (this.manifest && this.manifest.segments && this.manifest.segments.length) {
        let f = this.manifest.segments[this.manifest.segments.length - Math.min(3, this.manifest.segments.length)], m = Vt.utc(f.dateTimeString).valueOf();
        m !== d.lastCurrentTimecode && this.isLive() && (d.onTimecodeCB({ pdt: m, duration: d._segmentDuration }), d.lastCurrentTimecode = m), c.resolve(d.currentTimecode);
      }
      return c.promise;
    },
    onTimecode: function(c) {
      this.onTimecodeCB = c;
    }
  }, o;
}]);
fr.service("VJSManualHlsPlugin", ["HlsManifest", function(e) {
  const r = re.getPlugin("plugin");
  function i(n) {
    return n && (n.indexOf(".m3u8") > 0 || n.indexOf("=m3u8") > 0);
  }
  const t = re.extend(r, {
    constructor: function(n, a) {
      r.call(this, n, a);
    },
    init: function(n) {
      if (this.stop(), !i(n)) {
        delete this.player.vfhls.manifest;
        return;
      }
      let a = this.player.getChild("vfClock");
      const s = new e(n);
      this.player.vfhls.manifest = s, $a.isSupported() || (s.onTimecode((o) => {
        if (o.pdt) {
          this.player.vfhls._hasPDT = !0;
          let l = Vt.utc(o.pdt).year(Vt().year()).valueOf();
          a.set(l);
        }
      }), this.start());
    },
    start: function() {
      this.player.vfhls.manifest && this.player.vfhls.manifest.startManualParseInterval();
    },
    stop: function() {
      this.player.vfhls.manifest && this.player.vfhls.manifest.stopManualParseInterval();
    }
  });
  return t.pluginName = "manualHls", t;
}]);
function ig(e, r, i) {
  if (!e || !r.length || !i.length)
    return null;
  let t = [e];
  return r.forEach((n) => {
    t.push(document.querySelector(n));
  }), t[0].parentNode.prepend(i[0]), i[i.length - 1].append(...t), i.forEach((n, a) => {
    i.length > a + 1 && n.append(i[a + 1]);
  }), i[0];
}
function nn(e, r, i) {
  Array.isArray(e) || (e = [e]), isNaN(+i) || (i += "px"), e.forEach((t) => {
    t.css ? t.css(r, i) : t[0] && t[0].style && (t[0].style[r] = i);
  });
}
fr.service("VJSContentFitPlugin", function() {
  const e = re.getPlugin("plugin"), r = {
    fill: "video-fill",
    fit: "video-fit",
    fitTop: "video-fit-top",
    fitBottom: "video-fit-bottom"
  };
  function i(u, h, c) {
    let d = angular.element(h.tech_.el_);
    c.width / c.ratio < c.height ? (nn(u, "width", "100%"), nn(d, "width", "auto"), nn(d, "height", ""), nn(u, "height", "100%")) : (nn(u, "width", "100%"), nn(u, "height", "100%"), nn(d, "height", "auto"), nn(d, "width", ""));
  }
  function t(u) {
    nn(u, "top", 0), nn(u, "transform", "translate(-50%,0)");
  }
  function n(u) {
    nn(u, "top", "initial"), nn(u, "bottom", 0), nn(u, "transform", "translate(-50%,0)");
  }
  function a(u, h, c) {
    h.width / h.ratio < h.height ? (nn(u, "width", h.width), nn(u, "height", h.width / h.ratio)) : (nn(u, "height", h.height), nn(u, "width", h.height * h.ratio)), nn(u, "top", ""), nn(u, "transform", ""), c === "fitTop" ? t(u) : c === "fitBottom" && n(u);
  }
  function s(u) {
    return "fit";
  }
  function o(u, h) {
    let c = s();
    Object.values(r).forEach((f) => {
      u.removeClass(f);
    }), u.addClass(r[c]);
    let d = [
      angular.element(u.videoWrapper),
      angular.element(u.controlWrapper),
      angular.element(u.adsWrapper),
      angular.element(document.querySelector(".gfx-overlay"))
    ];
    !c || c.indexOf("fit") === 0 ? a(d, h, c) : c === "fill" && i(d, u, h);
  }
  const l = re.extend(e, {
    constructor: function(u, h) {
      e.call(this, u, h), u.fillFit = (c) => {
        o(u, c);
      }, u.fill = () => {
        u.forceFill_ = !0, u.forceFit_ = !1, u.trigger("playerresize");
      }, u.fit = () => {
        u.forceFit_ = !0, u.forceFill_ = !1, u.trigger("playerresize");
      }, u.fitTop = () => {
        u.forceFitTop_ = !0, u.forceFit_ = !1, u.forceFill_ = !1, u.trigger("playerresize");
      }, u.unsetSizing = () => {
        delete u.forceFill_, delete u.forceFit_, u.trigger("playerresize");
      };
    }
  });
  return l.pluginName = "contentFit", l;
});
fr.service("VJSCropperPlugin", function() {
  const e = re.getPlugin("plugin"), r = {
    fit: {
      none: { width: "", height: "", top: "", left: "" },
      "top-left": { width: "200%", height: "200%", top: "100%", left: "100%" },
      "top-right": { width: "200%", height: "200%", top: "100%", left: "0" },
      "bottom-left": { width: "200%", height: "200%", top: "0", left: "100%" },
      "bottom-right": { width: "200%", height: "200%", top: "0", left: "0" }
    },
    fill: {
      none: { width: "", height: "", top: "", left: "" },
      "top-left": { width: "auto", height: "200%", top: "100%", left: "150%" },
      "top-right": { width: "auto", height: "200%", top: "100%", left: "-50%" },
      "bottom-left": { width: "auto", height: "200%", top: "0", left: "150%" },
      "bottom-right": { width: "auto", height: "200%", top: "0", left: "-50%" }
    }
  }, i = re.extend(e, {
    constructor: function(t, n) {
      e.call(this, t, n);
    },
    crop: function(t, n) {
      this.player.tech(!0).el_.style[r[t][n]];
    }
  });
  return i.pluginName = "cropper", i;
});
fr.service("VJSElementWrapperPlugin", function() {
  const e = re.getPlugin("plugin"), r = re.extend(e, {
    constructor: function(i, t) {
      e.call(this, i, t);
    },
    wrapVideo: function(i) {
      if (this.techName !== this.player.techName_) {
        this.techName = this.player.techName_, this.techName === "Youtube" && this.player.tech(!0).el_.querySelector(".vjs-tech").removeAttribute("style");
        try {
          document.querySelector(`.${i}`).remove();
        } catch {
        }
        let t = document.createElement("div");
        t.className = i, this.player.videoWrapper = ig(this.player.tech(!0).el_, [
          ".video-js .vjs-mask",
          ".video-js .vjs-loading-spinner",
          ".video-js .vjs-text-track-display"
        ], [t]);
      }
    },
    wrapControls: function(i) {
      const t = document.createElement("div");
      t.className = i;
      const n = document.createElement("div");
      n.className = "vjs-controls-wrapper-inner", this.player.controlWrapper = ig(this.player.controlBar.el_, [
        ".video-js .vjs-hover-overlay",
        ".video-js .vjs-logo",
        ".video-js .vjs-fs-play-pause"
      ], [t, n]);
    },
    wrapAds: function(i) {
      const t = document.createElement("div");
      t.className = i, this.player.adsWrapper = ig(document.querySelector(".video-js .ima-ad-container"), [], [t]);
    }
  });
  return r.pluginName = "elementWrapper", r;
});
fr.service("VJSAutoplaySupportPlugin", function() {
  const e = re.getPlugin("plugin"), r = re.extend(e, {
    constructor: function(i, t) {
      e.call(this, i, t), i.canAutoplay = this.canAutoplay;
    },
    canAutoplay: function(i) {
      i = i || {};
      let t = i.timeout || 250, n = !!i.nomute;
      return new Promise((a, s) => {
        canAutoplay.video({ timeout: t, muted: !1 }).then((o) => {
          o.result === !1 ? n ? s(o.error) : canAutoplay.video({ timeout: t, muted: !0 }).then((l) => {
            l.result === !1 ? s(l.error) : a({ muted: !0 });
          }) : a({ muted: !1 });
        });
      });
    }
  });
  return r.pluginName = "autoplaySupport", r;
});
fr.service("VJSResponsiveScrubbing", function() {
  const e = re.getPlugin("plugin"), r = re.extend(e, {
    constructor: function(i, t) {
      e.call(this, i, t), this.triggerEvent = !0, this.fn = () => {
        i.scrubbing() && i.trigger("timeupdate"), this.triggerEvent && window.requestAnimationFrame(this.fn);
      }, this.fn(), i.controlBar.progressControl.seekBar.handleMouseMove = function(n) {
        if (!re.dom.isSingleLeftClick(n))
          return;
        this.player_.tech_.scrubbing = !0;
        let a;
        const s = this.calculateDistance(n), o = this.player_.liveTracker;
        if (!o || !o.isLive())
          a = s * this.player_.duration(), a === this.player_.duration() && (a = a - 0.1);
        else {
          const l = o.seekableStart(), u = o.liveCurrentTime();
          if (a = l + s * o.liveWindow(), a >= u && (a = u), a <= l && (a = l + 0.1), a === 1 / 0)
            return;
        }
        this.player_.seekedTime = a;
      }, i.controlBar.progressControl.seekBar.getCurrentTime_ = function() {
        return this.player_.scrubbing() ? this.player_.seekedTime : this.player_.currentTime();
      }, i.controlBar.progressControl.seekBar._handleMouseUp = i.controlBar.progressControl.seekBar.handleMouseUp, i.controlBar.progressControl.seekBar.handleMouseUp = function(n) {
        this.player_.tech_.scrubbing = !1, this._handleMouseUp.call(this, n), this.player_.currentTime(this.player_.seekedTime);
      };
    },
    dispose: function() {
      this.triggerEvent = !1;
    }
  });
  return r.pluginName = "responsiveScrubbing", r;
});
fr.service("VJSPostMessagesPlugin", function() {
  const e = re.getPlugin("plugin"), r = re.extend(e, {
    constructor: function(t, n) {
      e.call(this, t, n), n.manualReady || t.ready(() => {
        setTimeout(() => {
          setTimeout(() => {
            window.postMessage(JSON.stringify({ ready: !0 }), "*");
          }, t.techName_ === "Youtube" ? 1500 : 500);
        }, 200);
      });
    }
  });
  return r.pluginName = "postMessages", r;
});
fr.service("VJSTransform", function() {
  const e = re.getPlugin("plugin");
  function r(a, s, o, l, u, h, c, d, f, m) {
    const p = (l - s) / (u - o), b = (d - h) / (f - c), y = d - h, v = f - c;
    if (p > b && m.scalingMode !== "fill" || p < b && m.scalingMode === "fill") {
      const g = y / p;
      f = c + g;
    } else {
      const g = v * p;
      d = h + g;
    }
    i(a, s, o, l, u, h, c, d, f);
  }
  function i(a, s, o, l, u, h, c, d, f) {
    let m = a.tech_.el_;
    a.techName_ === "AmazonIVS" && (m = m.querySelector("video")), a.mask && a.mask(h, c, d, f);
    let p = Math.abs(d - h) / Math.abs(l - s), b = Math.abs(f - c) / Math.abs(u - o), y = h - s * p, v = c - o * b, g = `translate(${y * 100}%, ${v * 100}%) scale(${p},${b})`;
    m.classList.add("transformed"), m.style.transform = g;
    try {
      let E = a.controlWrapper.querySelector(".vjs-controls-wrapper-inner");
      E.style.top = c * 100 + "%", E.style.left = h * 100 + "%", E.style.width = (d - h) * 100 + "%", E.style.height = (f - c) * 100 + "%";
    } catch {
    }
    a.ads && a.ads.snapshot && (a.ads.snapshot.style = m.getAttribute("style"));
    try {
      let E = a.ima.controller.getAdContainerDiv();
      E.classList.add("transformed"), E.style.transform = g;
    } catch {
    }
    try {
      let E = a.textTrackDisplay.el();
      E.classList.add("transformed"), E.style.top = c * 100 + "%", E.style.left = h * 100 + "%", E.style.width = (d - h) * 100 + "%", E.style.height = (f - c) * 100 + "%";
    } catch {
    }
  }
  function t(a) {
    if (a[a.length - 1].constructor.name !== "Object") {
      let s = { scalingMode: "fit" };
      a.push(s);
    } else
      a[a.length - 1].scalingMode = a[a.length - 1].scalingMode || "fit";
    return a.length === 5 && (a = [...a.slice(0, 4), 0, 0, 1, 1, a[a.length - 1]]), a;
  }
  const n = re.extend(e, {
    constructor: function(a, s) {
      e.call(this, a, s), a.transform = (...o) => {
        if (o = o.filter((l) => l != null), o.length)
          o = t(o), r(a, ...o);
        else {
          let l = a.tech_.el_;
          l.classList.remove("transformed"), l.style.transform = "translate(-50%,-50%)", a.hideMask();
        }
      };
    }
  });
  return n.pluginName = "transformContent", n;
});
fr.service("VJSSeekButtons", function() {
  const e = re.getPlugin("plugin"), r = re.extend(e, {
    constructor: function(t, n) {
      e.call(this, t, n), t.on("durationchange", () => {
        try {
          (t.liveTracker.isLive() || t.isLive()) && t.controlBar.skipForward.hide();
        } catch {
        }
      }), t.ready(() => {
        t.addClass("vjs-skip-buttons"), n.forward && n.forward > 0 && (t.controlBar.skipForward = t.controlBar.addChild("skipButton", {
          direction: "forward",
          seconds: n.forward
        }), t.controlBar.el().insertBefore(
          t.controlBar.skipForward.el(),
          t.controlBar.el().firstChild.nextSibling
        )), n.back && n.back > 0 && (t.controlBar.skipBack = t.controlBar.addChild("skipButton", {
          direction: "back",
          seconds: n.back
        }), t.controlBar.el().insertBefore(
          t.controlBar.skipBack.el(),
          t.controlBar.el().firstChild.nextSibling
        ));
      });
    }
  });
  return r.pluginName = "skipButtons", r;
});
fr.service("VJSSourceSelector", function() {
  const e = re.getPlugin("plugin"), r = re.extend(e, {
    constructor: function(t, n) {
      e.call(this, t, n), t.ready(() => {
        t.info.sources && t.info.sources.length > 1 && (t.controlBar.sourceSelector = t.controlBar.addChild("vfSourceSelectorButton", {}), t.controlBar.el().insertBefore(
          t.controlBar.sourceSelector.el(),
          t.controlBar.el().firstChild.nextSibling
        ));
      });
    }
  });
  return r.pluginName = "sourceSelector", r;
});
var AF = { exports: {} };
const Lx = /* @__PURE__ */ Mb(ZO);
/*!
 * videojs-mux
 * @version 4.19.0
 * @copyright 2024 Mux, Inc.
 */
(function(e, r) {
  (function() {
    (function(i, t) {
      e.exports = t(Lx);
    })(this, function(i) {
      return function() {
        var t = { 48: function(o, l, u) {
          var h;
          h = typeof window < "u" ? window : u.g !== void 0 ? u.g : typeof self < "u" ? self : {}, o.exports = h;
        }, 855: function(o) {
          o.exports = i;
        } }, n = {};
        function a(o) {
          var l = n[o];
          if (l !== void 0)
            return l.exports;
          var u = n[o] = { exports: {} };
          return t[o](u, u.exports, a), u.exports;
        }
        a.n = function(o) {
          var l = o && o.__esModule ? function() {
            return o.default;
          } : function() {
            return o;
          };
          return a.d(l, { a: l }), l;
        }, a.d = function(o, l) {
          for (var u in l)
            a.o(l, u) && !a.o(o, u) && Object.defineProperty(o, u, { enumerable: !0, get: l[u] });
        }, a.g = function() {
          if (typeof globalThis == "object")
            return globalThis;
          try {
            return this || new Function("return this")();
          } catch {
            if (typeof window == "object")
              return window;
          }
        }(), a.o = function(o, l) {
          return Object.prototype.hasOwnProperty.call(o, l);
        }, a.r = function(o) {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(o, "__esModule", { value: !0 });
        };
        var s = {};
        return function() {
          a.r(s), a.d(s, { register: function() {
            return xc;
          } });
          var o = a(48), l = a.n(o), u = a(855), h = a.n(u), c = Object.create, d = Object.defineProperty, f = Object.getOwnPropertyDescriptor, m = Object.getOwnPropertyNames, p = Object.getPrototypeOf, b = Object.prototype.hasOwnProperty, y = function(Q, V) {
            return function() {
              return Q && (V = Q(Q = 0)), V;
            };
          }, v = function(Q, V) {
            return function() {
              return V || Q((V = { exports: {} }).exports, V), V.exports;
            };
          }, g = function(Q, V, Y) {
            return Y = Q != null ? c(p(Q)) : {}, function(se, le, oe, te) {
              if (le && typeof le == "object" || typeof le == "function")
                for (var we, Fe = m(le), He = 0, ct = Fe.length; He < ct; He++)
                  we = Fe[He], !b.call(se, we) && we !== oe && d(se, we, { get: function(ut) {
                    return le[ut];
                  }.bind(null, we), enumerable: !(te = f(le, we)) || te.enumerable });
              return se;
            }(!V && Q && Q.__esModule ? Y : d(Y, "default", { value: Q, enumerable: !0 }), Q);
          }, E = v(function(Q, V) {
            var Y;
            Y = typeof window < "u" ? window : typeof fn < "u" ? fn : typeof self < "u" ? self : {}, V.exports = Y;
          });
          function x(Q) {
            return Q && typeof Symbol < "u" && Q.constructor === Symbol ? "symbol" : typeof Q;
          }
          var w = y(function() {
          }), S = v(function(Q, V) {
            var Y, se;
            w(), Y = Q, se = function() {
              var le = function() {
              }, oe = "undefined", te = (typeof window > "u" ? "undefined" : x(window)) !== oe && x(window.navigator) !== oe && /Trident\/|MSIE /.test(window.navigator.userAgent), we = ["trace", "debug", "info", "warn", "error"];
              function Fe(tr, Dr) {
                var hr = tr[Dr];
                if (typeof hr.bind == "function")
                  return hr.bind(tr);
                try {
                  return Function.prototype.bind.call(hr, tr);
                } catch {
                  return function() {
                    return Function.prototype.apply.apply(hr, [tr, arguments]);
                  };
                }
              }
              function He() {
                console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
              }
              function ct(tr) {
                return tr === "debug" && (tr = "log"), (typeof console > "u" ? "undefined" : x(console)) !== oe && (tr === "trace" && te ? He : console[tr] !== void 0 ? Fe(console, tr) : console.log !== void 0 ? Fe(console, "log") : le);
              }
              function ut(tr, Dr) {
                for (var hr = 0; hr < we.length; hr++) {
                  var $t = we[hr];
                  this[$t] = hr < tr ? le : this.methodFactory($t, tr, Dr);
                }
                this.log = this.debug;
              }
              function ft(tr, Dr, hr) {
                return function() {
                  (typeof console > "u" ? "undefined" : x(console)) !== oe && (ut.call(this, Dr, hr), this[tr].apply(this, arguments));
                };
              }
              function Ue(tr, Dr, hr) {
                return ct(tr) || ft.apply(this, arguments);
              }
              function _t(tr, Dr, hr) {
                var $t, ht = this;
                Dr = Dr == null ? "WARN" : Dr;
                var pt = "loglevel";
                function Gt() {
                  var Ht;
                  if ((typeof window > "u" ? "undefined" : x(window)) !== oe && pt) {
                    try {
                      Ht = window.localStorage[pt];
                    } catch {
                    }
                    if ((Ht === void 0 ? "undefined" : x(Ht)) === oe)
                      try {
                        var vr = window.document.cookie, Zr = vr.indexOf(encodeURIComponent(pt) + "=");
                        Zr !== -1 && (Ht = /^([^;]+)/.exec(vr.slice(Zr))[1]);
                      } catch {
                      }
                    return ht.levels[Ht] === void 0 && (Ht = void 0), Ht;
                  }
                }
                typeof tr == "string" ? pt += ":" + tr : (tr === void 0 ? "undefined" : x(tr)) === "symbol" && (pt = void 0), ht.name = tr, ht.levels = { TRACE: 0, DEBUG: 1, INFO: 2, WARN: 3, ERROR: 4, SILENT: 5 }, ht.methodFactory = hr || Ue, ht.getLevel = function() {
                  return $t;
                }, ht.setLevel = function(Ht, vr) {
                  if (typeof Ht == "string" && ht.levels[Ht.toUpperCase()] !== void 0 && (Ht = ht.levels[Ht.toUpperCase()]), !(typeof Ht == "number" && Ht >= 0 && Ht <= ht.levels.SILENT))
                    throw "log.setLevel() called with invalid level: " + Ht;
                  if ($t = Ht, vr !== !1 && function(Zr) {
                    var zr = (we[Zr] || "silent").toUpperCase();
                    if ((typeof window > "u" ? "undefined" : x(window)) !== oe && pt) {
                      try {
                        return void (window.localStorage[pt] = zr);
                      } catch {
                      }
                      try {
                        window.document.cookie = encodeURIComponent(pt) + "=" + zr + ";";
                      } catch {
                      }
                    }
                  }(Ht), ut.call(ht, Ht, tr), (typeof console > "u" ? "undefined" : x(console)) === oe && Ht < ht.levels.SILENT)
                    return "No console available for logging";
                }, ht.setDefaultLevel = function(Ht) {
                  Dr = Ht, Gt() || ht.setLevel(Ht, !1);
                }, ht.resetLevel = function() {
                  ht.setLevel(Dr, !1), function() {
                    if ((typeof window > "u" ? "undefined" : x(window)) !== oe && pt) {
                      try {
                        return void window.localStorage.removeItem(pt);
                      } catch {
                      }
                      try {
                        window.document.cookie = encodeURIComponent(pt) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
                      } catch {
                      }
                    }
                  }();
                }, ht.enableAll = function(Ht) {
                  ht.setLevel(ht.levels.TRACE, Ht);
                }, ht.disableAll = function(Ht) {
                  ht.setLevel(ht.levels.SILENT, Ht);
                };
                var Yt = Gt();
                Yt == null && (Yt = Dr), ht.setLevel(Yt, !1);
              }
              var Lt = new _t(), ar = {};
              Lt.getLogger = function(tr) {
                if ((tr === void 0 ? "undefined" : x(tr)) !== "symbol" && typeof tr != "string" || tr === "")
                  throw new TypeError("You must supply a name when creating a logger.");
                var Dr = ar[tr];
                return Dr || (Dr = ar[tr] = new _t(tr, Lt.getLevel(), Lt.methodFactory)), Dr;
              };
              var or = (typeof window > "u" ? "undefined" : x(window)) !== oe ? window.log : void 0;
              return Lt.noConflict = function() {
                return (typeof window > "u" ? "undefined" : x(window)) !== oe && window.log === Lt && (window.log = or), Lt;
              }, Lt.getLoggers = function() {
                return ar;
              }, Lt.default = Lt, Lt;
            }, typeof V == "object" && V.exports ? V.exports = se() : Y.log = se();
          });
          function T(Q, V) {
            return V != null && typeof Symbol < "u" && V[Symbol.hasInstance] ? !!V[Symbol.hasInstance](Q) : T(Q, V);
          }
          var C = y(function() {
            C();
          }), D = v(function(Q) {
            var V = Object.prototype.hasOwnProperty;
            function Y(le) {
              try {
                return decodeURIComponent(le.replace(/\+/g, " "));
              } catch {
                return null;
              }
            }
            function se(le) {
              try {
                return encodeURIComponent(le);
              } catch {
                return null;
              }
            }
            Q.stringify = function(le, oe) {
              oe = oe || "";
              var te, we, Fe = [];
              for (we in typeof oe != "string" && (oe = "?"), le)
                if (V.call(le, we)) {
                  if (!(te = le[we]) && (te == null || isNaN(te)) && (te = ""), we = se(we), te = se(te), we === null || te === null)
                    continue;
                  Fe.push(we + "=" + te);
                }
              return Fe.length ? oe + Fe.join("&") : "";
            }, Q.parse = function(le) {
              for (var oe, te = /([^=?#&]+)=?([^&]*)/g, we = {}; oe = te.exec(le); ) {
                var Fe = Y(oe[1]), He = Y(oe[2]);
                Fe === null || He === null || Fe in we || (we[Fe] = He);
              }
              return we;
            };
          }), R = v(function(Q, V) {
            (function(Y) {
              var se = !1;
              if (typeof Q == "object" && (V.exports = Y(), se = !0), !se) {
                var le = window.Cookies, oe = window.Cookies = Y();
                oe.noConflict = function() {
                  return window.Cookies = le, oe;
                };
              }
            })(function() {
              var Y = function() {
                for (var se = 0, le = {}; se < arguments.length; se++) {
                  var oe = arguments[se];
                  for (var te in oe)
                    le[te] = oe[te];
                }
                return le;
              };
              return function se(le) {
                function oe(te, we, Fe) {
                  var He;
                  if (typeof document < "u") {
                    if (arguments.length > 1) {
                      if (typeof (Fe = Y({ path: "/" }, oe.defaults, Fe)).expires == "number") {
                        var ct = new Date();
                        ct.setMilliseconds(ct.getMilliseconds() + 864e5 * Fe.expires), Fe.expires = ct;
                      }
                      try {
                        He = JSON.stringify(we), /^[\{\[]/.test(He) && (we = He);
                      } catch {
                      }
                      return we = le.write ? le.write(we, te) : encodeURIComponent(String(we)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), te = (te = (te = encodeURIComponent(String(te))).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)).replace(/[\(\)]/g, escape), document.cookie = [te, "=", we, Fe.expires ? "; expires=" + Fe.expires.toUTCString() : "", Fe.path ? "; path=" + Fe.path : "", Fe.domain ? "; domain=" + Fe.domain : "", Fe.secure ? "; secure" : ""].join("");
                    }
                    te || (He = {});
                    for (var ut = document.cookie ? document.cookie.split("; ") : [], ft = /(%[0-9A-Z]{2})+/g, Ue = 0; Ue < ut.length; Ue++) {
                      var _t = ut[Ue].split("="), Lt = _t.slice(1).join("=");
                      Lt.charAt(0) === '"' && (Lt = Lt.slice(1, -1));
                      try {
                        var ar = _t[0].replace(ft, decodeURIComponent);
                        if (Lt = le.read ? le.read(Lt, ar) : le(Lt, ar) || Lt.replace(ft, decodeURIComponent), this.json)
                          try {
                            Lt = JSON.parse(Lt);
                          } catch {
                          }
                        if (te === ar) {
                          He = Lt;
                          break;
                        }
                        te || (He[ar] = Lt);
                      } catch {
                      }
                    }
                    return He;
                  }
                }
                return oe.set = oe, oe.get = function(te) {
                  return oe.call(oe, te);
                }, oe.getJSON = function() {
                  return oe.apply({ json: !0 }, [].slice.call(arguments));
                }, oe.defaults = {}, oe.remove = function(te, we) {
                  oe(te, "", Y(we, { expires: -1 }));
                }, oe.withConverter = se, oe;
              }(function() {
              });
            });
          }), P = v(function(Q, V) {
            var Y = Array.prototype.slice;
            V.exports = function(se, le) {
              for (("length" in se) || (se = [se]), se = Y.call(se); se.length; ) {
                var oe = se.shift(), te = le(oe);
                if (te)
                  return te;
                oe.childNodes && oe.childNodes.length && (se = Y.call(oe.childNodes).concat(se));
              }
            };
          }), N = v(function(Q, V) {
            function Y(se, le) {
              if (!T(this, Y))
                return new Y(se, le);
              this.data = se, this.nodeValue = se, this.length = se.length, this.ownerDocument = le || null;
            }
            C(), V.exports = Y, Y.prototype.nodeType = 8, Y.prototype.nodeName = "#comment", Y.prototype.toString = function() {
              return "[object Comment]";
            };
          }), $ = v(function(Q, V) {
            function Y(se, le) {
              if (!T(this, Y))
                return new Y(se);
              this.data = se || "", this.length = this.data.length, this.ownerDocument = le || null;
            }
            C(), V.exports = Y, Y.prototype.type = "DOMTextNode", Y.prototype.nodeType = 3, Y.prototype.nodeName = "#text", Y.prototype.toString = function() {
              return this.data;
            }, Y.prototype.replaceData = function(se, le, oe) {
              var te = this.data, we = te.substring(0, se), Fe = te.substring(se + le, te.length);
              this.data = we + oe + Fe, this.length = this.data.length;
            };
          }), O = v(function(Q, V) {
            V.exports = function(Y) {
              var se = this, le = Y.type;
              Y.target || (Y.target = se), se.listeners || (se.listeners = {});
              var oe = se.listeners[le];
              if (oe)
                return oe.forEach(function(te) {
                  Y.currentTarget = se, typeof te == "function" ? te(Y) : te.handleEvent(Y);
                });
              se.parentNode && se.parentNode.dispatchEvent(Y);
            };
          }), M = v(function(Q, V) {
            V.exports = function(Y, se) {
              var le = this;
              le.listeners || (le.listeners = {}), le.listeners[Y] || (le.listeners[Y] = []), le.listeners[Y].indexOf(se) === -1 && le.listeners[Y].push(se);
            };
          }), F = v(function(Q, V) {
            V.exports = function(Y, se) {
              var le = this;
              if (le.listeners && le.listeners[Y]) {
                var oe = le.listeners[Y], te = oe.indexOf(se);
                te !== -1 && oe.splice(te, 1);
              }
            };
          }), G = v(function(Q, V) {
            w(), V.exports = se;
            var Y = ["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "menuitem", "meta", "param", "source", "track", "wbr"];
            function se(we) {
              switch (we.nodeType) {
                case 3:
                  return te(we.data);
                case 8:
                  return "<!--" + we.data + "-->";
                default:
                  return function(Fe) {
                    var He = [], ct = Fe.tagName;
                    return Fe.namespaceURI === "http://www.w3.org/1999/xhtml" && (ct = ct.toLowerCase()), He.push("<" + ct + function(ut) {
                      var ft = [];
                      for (var Ue in ut)
                        le(ut, Ue) && ft.push({ name: Ue, value: ut[Ue] });
                      for (var _t in ut._attributes)
                        for (var Lt in ut._attributes[_t]) {
                          var ar = ut._attributes[_t][Lt], or = (ar.prefix ? ar.prefix + ":" : "") + Lt;
                          ft.push({ name: or, value: ar.value });
                        }
                      return ut.className && ft.push({ name: "class", value: ut.className }), ft.length ? oe(ft) : "";
                    }(Fe) + function(ut) {
                      var ft = ut.dataset, Ue = [];
                      for (var _t in ft)
                        Ue.push({ name: "data-" + _t, value: ft[_t] });
                      return Ue.length ? oe(Ue) : "";
                    }(Fe)), Y.indexOf(ct) > -1 ? He.push(" />") : (He.push(">"), Fe.childNodes.length ? He.push.apply(He, Fe.childNodes.map(se)) : Fe.textContent || Fe.innerText ? He.push(te(Fe.textContent || Fe.innerText)) : Fe.innerHTML && He.push(Fe.innerHTML), He.push("</" + ct + ">")), He.join("");
                  }(we);
              }
            }
            function le(we, Fe) {
              var He = x(we[Fe]);
              return Fe === "style" && Object.keys(we.style).length > 0 || we.hasOwnProperty(Fe) && (He === "string" || He === "boolean" || He === "number") && Fe !== "nodeName" && Fe !== "className" && Fe !== "tagName" && Fe !== "textContent" && Fe !== "innerText" && Fe !== "namespaceURI" && Fe !== "innerHTML";
            }
            function oe(we) {
              var Fe = [];
              return we.forEach(function(He) {
                var ct = He.name, ut = He.value;
                ct === "style" && (ut = function(ft) {
                  if (typeof ft == "string")
                    return ft;
                  var Ue = "";
                  return Object.keys(ft).forEach(function(_t) {
                    var Lt = ft[_t];
                    _t = _t.replace(/[A-Z]/g, function(ar) {
                      return "-" + ar.toLowerCase();
                    }), Ue += _t + ":" + Lt + ";";
                  }), Ue;
                }(ut)), Fe.push(ct + '="' + function(ft) {
                  return te(ft).replace(/"/g, "&quot;");
                }(ut) + '"');
              }), Fe.length ? " " + Fe.join(" ") : "";
            }
            function te(we) {
              var Fe = "";
              return typeof we == "string" ? Fe = we : we && (Fe = we.toString()), Fe.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
            }
          }), K = v(function(Q, V) {
            C();
            var Y = P(), se = O(), le = M(), oe = F(), te = G(), we = "http://www.w3.org/1999/xhtml";
            function Fe(He, ct, ut) {
              if (!T(this, Fe))
                return new Fe(He);
              var ft = ut === void 0 ? we : ut || null;
              this.tagName = ft === we ? String(He).toUpperCase() : He, this.nodeName = this.tagName, this.className = "", this.dataset = {}, this.childNodes = [], this.parentNode = null, this.style = {}, this.ownerDocument = ct || null, this.namespaceURI = ft, this._attributes = {}, this.tagName === "INPUT" && (this.type = "text");
            }
            V.exports = Fe, Fe.prototype.type = "DOMElement", Fe.prototype.nodeType = 1, Fe.prototype.appendChild = function(He) {
              return He.parentNode && He.parentNode.removeChild(He), this.childNodes.push(He), He.parentNode = this, He;
            }, Fe.prototype.replaceChild = function(He, ct) {
              He.parentNode && He.parentNode.removeChild(He);
              var ut = this.childNodes.indexOf(ct);
              return ct.parentNode = null, this.childNodes[ut] = He, He.parentNode = this, ct;
            }, Fe.prototype.removeChild = function(He) {
              var ct = this.childNodes.indexOf(He);
              return this.childNodes.splice(ct, 1), He.parentNode = null, He;
            }, Fe.prototype.insertBefore = function(He, ct) {
              He.parentNode && He.parentNode.removeChild(He);
              var ut = ct == null ? -1 : this.childNodes.indexOf(ct);
              return ut > -1 ? this.childNodes.splice(ut, 0, He) : this.childNodes.push(He), He.parentNode = this, He;
            }, Fe.prototype.setAttributeNS = function(He, ct, ut) {
              var ft = null, Ue = ct, _t = ct.indexOf(":");
              _t > -1 && (ft = ct.substr(0, _t), Ue = ct.substr(_t + 1)), this.tagName === "INPUT" && ct === "type" ? this.type = ut : (this._attributes[He] || (this._attributes[He] = {}))[Ue] = { value: ut, prefix: ft };
            }, Fe.prototype.getAttributeNS = function(He, ct) {
              var ut = this._attributes[He], ft = ut && ut[ct] && ut[ct].value;
              return this.tagName === "INPUT" && ct === "type" ? this.type : typeof ft != "string" ? null : ft;
            }, Fe.prototype.removeAttributeNS = function(He, ct) {
              var ut = this._attributes[He];
              ut && delete ut[ct];
            }, Fe.prototype.hasAttributeNS = function(He, ct) {
              var ut = this._attributes[He];
              return !!ut && ct in ut;
            }, Fe.prototype.setAttribute = function(He, ct) {
              return this.setAttributeNS(null, He, ct);
            }, Fe.prototype.getAttribute = function(He) {
              return this.getAttributeNS(null, He);
            }, Fe.prototype.removeAttribute = function(He) {
              return this.removeAttributeNS(null, He);
            }, Fe.prototype.hasAttribute = function(He) {
              return this.hasAttributeNS(null, He);
            }, Fe.prototype.removeEventListener = oe, Fe.prototype.addEventListener = le, Fe.prototype.dispatchEvent = se, Fe.prototype.focus = function() {
            }, Fe.prototype.toString = function() {
              return te(this);
            }, Fe.prototype.getElementsByClassName = function(He) {
              var ct = He.split(" "), ut = [];
              return Y(this, function(ft) {
                if (ft.nodeType === 1) {
                  var Ue = (ft.className || "").split(" ");
                  ct.every(function(_t) {
                    return Ue.indexOf(_t) !== -1;
                  }) && ut.push(ft);
                }
              }), ut;
            }, Fe.prototype.getElementsByTagName = function(He) {
              He = He.toLowerCase();
              var ct = [];
              return Y(this.childNodes, function(ut) {
                ut.nodeType === 1 && (He === "*" || ut.tagName.toLowerCase() === He) && ct.push(ut);
              }), ct;
            }, Fe.prototype.contains = function(He) {
              return Y(this, function(ct) {
                return He === ct;
              }) || !1;
            };
          }), J = v(function(Q, V) {
            C();
            var Y = K();
            function se(le) {
              if (!T(this, se))
                return new se();
              this.childNodes = [], this.parentNode = null, this.ownerDocument = le || null;
            }
            V.exports = se, se.prototype.type = "DocumentFragment", se.prototype.nodeType = 11, se.prototype.nodeName = "#document-fragment", se.prototype.appendChild = Y.prototype.appendChild, se.prototype.replaceChild = Y.prototype.replaceChild, se.prototype.removeChild = Y.prototype.removeChild, se.prototype.toString = function() {
              return this.childNodes.map(function(le) {
                return String(le);
              }).join("");
            };
          }), ue = v(function(Q, V) {
            function Y(se) {
            }
            V.exports = Y, Y.prototype.initEvent = function(se, le, oe) {
              this.type = se, this.bubbles = le, this.cancelable = oe;
            }, Y.prototype.preventDefault = function() {
            };
          }), ce = v(function(Q, V) {
            C();
            var Y = P(), se = N(), le = $(), oe = K(), te = J(), we = ue(), Fe = O(), He = M(), ct = F();
            function ut() {
              if (!T(this, ut))
                return new ut();
              this.head = this.createElement("head"), this.body = this.createElement("body"), this.documentElement = this.createElement("html"), this.documentElement.appendChild(this.head), this.documentElement.appendChild(this.body), this.childNodes = [this.documentElement], this.nodeType = 9;
            }
            V.exports = ut;
            var ft = ut.prototype;
            ft.createTextNode = function(Ue) {
              return new le(Ue, this);
            }, ft.createElementNS = function(Ue, _t) {
              var Lt = Ue === null ? null : String(Ue);
              return new oe(_t, this, Lt);
            }, ft.createElement = function(Ue) {
              return new oe(Ue, this);
            }, ft.createDocumentFragment = function() {
              return new te(this);
            }, ft.createEvent = function(Ue) {
              return new we(Ue);
            }, ft.createComment = function(Ue) {
              return new se(Ue, this);
            }, ft.getElementById = function(Ue) {
              return Ue = String(Ue), Y(this.childNodes, function(_t) {
                if (String(_t.id) === Ue)
                  return _t;
              }) || null;
            }, ft.getElementsByClassName = oe.prototype.getElementsByClassName, ft.getElementsByTagName = oe.prototype.getElementsByTagName, ft.contains = oe.prototype.contains, ft.removeEventListener = ct, ft.addEventListener = He, ft.dispatchEvent = Fe;
          }), ee = v(function(Q, V) {
            var Y = ce();
            V.exports = new Y();
          }), me = v(function(Q, V) {
            var Y, se = typeof fn < "u" ? fn : typeof window < "u" ? window : {}, le = ee();
            typeof document < "u" ? Y = document : (Y = se["__GLOBAL_DOCUMENT_CACHE@4"]) || (Y = se["__GLOBAL_DOCUMENT_CACHE@4"] = le), V.exports = Y;
          });
          function Ce(Q, V) {
            (V == null || V > Q.length) && (V = Q.length);
            for (var Y = 0, se = new Array(V); Y < V; Y++)
              se[Y] = Q[Y];
            return se;
          }
          function Ne(Q, V) {
            return function(Y) {
              if (Array.isArray(Y))
                return Y;
            }(Q) || function(Y, se) {
              var le = Y == null ? null : typeof Symbol < "u" && Y[Symbol.iterator] || Y["@@iterator"];
              if (le != null) {
                var oe, te, we = [], Fe = !0, He = !1;
                try {
                  for (le = le.call(Y); !(Fe = (oe = le.next()).done) && (we.push(oe.value), !se || we.length !== se); Fe = !0)
                    ;
                } catch (ct) {
                  He = !0, te = ct;
                } finally {
                  try {
                    !Fe && le.return != null && le.return();
                  } finally {
                    if (He)
                      throw te;
                  }
                }
                return we;
              }
            }(Q, V) || function(Y, se) {
              if (Y) {
                if (typeof Y == "string")
                  return Ce(Y, se);
                var le = Object.prototype.toString.call(Y).slice(8, -1);
                if (le === "Object" && Y.constructor && (le = Y.constructor.name), le === "Map" || le === "Set")
                  return Array.from(le);
                if (le === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(le))
                  return Ce(Y, se);
              }
            }(Q, V) || function() {
              throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }();
          }
          var ot = g(E()), ze = function() {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(Q) {
              var V = 16 * Math.random() | 0;
              return (Q === "x" ? V : 3 & V | 8).toString(16);
            });
          }, $e = function() {
            return ("000000" + (Math.random() * Math.pow(36, 6) << 0).toString(36)).slice(-6);
          }, Ze = function(Q) {
            if (Q && Q.nodeName !== void 0)
              return Q.muxId || (Q.muxId = $e()), Q.muxId;
            var V;
            try {
              V = document.querySelector(Q);
            } catch {
            }
            return V && !V.muxId && (V.muxId = Q), (V == null ? void 0 : V.muxId) || Q;
          }, Ut = function(Q) {
            var V;
            Q && Q.nodeName !== void 0 ? Q = Ze(V = Q) : V = document.querySelector(Q);
            var Y = V && V.nodeName ? V.nodeName.toLowerCase() : "";
            return [V, Q, Y];
          }, qt = g(S()), ir = qt.default.methodFactory;
          qt.default.methodFactory = function(Q, V, Y) {
            var se = ir(Q, V, Y);
            return function() {
              for (var le = ["[mux]"], oe = 0; oe < arguments.length; oe++)
                le.push(arguments[oe]);
              se.apply(void 0, le);
            };
          }, qt.default.setLevel(qt.default.getLevel());
          var We = qt.default, vt = g(E());
          function Tt() {
            return (vt.default.doNotTrack || vt.default.navigator && vt.default.navigator.doNotTrack) === "1";
          }
          var xt = g(E()), Pt = { now: function() {
            var Q = xt.default.performance, V = Q && Q.timing, Y = V && V.navigationStart, se = typeof Y == "number" && typeof Q.now == "function" ? Y + Q.now() : Date.now();
            return Math.round(se);
          } };
          function at(Q) {
            if (Q === void 0)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return Q;
          }
          function Ot(Q, V) {
            if (!T(Q, V))
              throw new TypeError("Cannot call a class as a function");
          }
          function It(Q, V) {
            for (var Y = 0; Y < V.length; Y++) {
              var se = V[Y];
              se.enumerable = se.enumerable || !1, se.configurable = !0, "value" in se && (se.writable = !0), Object.defineProperty(Q, se.key, se);
            }
          }
          function sr(Q, V, Y) {
            return V && It(Q.prototype, V), Y && It(Q, Y), Q;
          }
          function lt(Q, V, Y) {
            return V in Q ? Object.defineProperty(Q, V, { value: Y, enumerable: !0, configurable: !0, writable: !0 }) : Q[V] = Y, Q;
          }
          function ri(Q, V) {
            return (ri = Object.setPrototypeOf || function(Y, se) {
              return Y.__proto__ = se, Y;
            })(Q, V);
          }
          function Qr(Q) {
            return (Qr = Object.setPrototypeOf ? Object.getPrototypeOf : function(V) {
              return V.__proto__ || Object.getPrototypeOf(V);
            })(Q);
          }
          function xr(Q, V) {
            return !V || x(V) !== "object" && typeof V != "function" ? at(Q) : V;
          }
          function _i(Q) {
            var V = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }();
            return function() {
              var Y, se = Qr(Q);
              if (V) {
                var le = Qr(this).constructor;
                Y = Reflect.construct(se, arguments, le);
              } else
                Y = se.apply(this, arguments);
              return xr(this, Y);
            };
          }
          C(), w();
          var Gr = function(Q) {
            return li(Q)[0];
          }, li = function(Q) {
            if (typeof Q != "string" || Q === "")
              return ["localhost"];
            var V, Y = (Q.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/) || [])[4];
            return Y && (V = (Y.match(/[^\.]+\.[^\.]+$/) || [])[0]), [Y, V];
          }, ci = g(E()), oi = { exists: function() {
            var Q = ci.default.performance;
            return (Q && Q.timing) !== void 0;
          }, domContentLoadedEventEnd: function() {
            var Q = ci.default.performance, V = Q && Q.timing;
            return V && V.domContentLoadedEventEnd;
          }, navigationStart: function() {
            var Q = ci.default.performance, V = Q && Q.timing;
            return V && V.navigationStart;
          } };
          function Kr(Q, V, Y) {
            Y = Y === void 0 ? 1 : Y, Q[V] = Q[V] || 0, Q[V] += Y;
          }
          function mn(Q) {
            for (var V = 1; V < arguments.length; V++) {
              var Y = arguments[V] != null ? arguments[V] : {}, se = Object.keys(Y);
              typeof Object.getOwnPropertySymbols == "function" && (se = se.concat(Object.getOwnPropertySymbols(Y).filter(function(le) {
                return Object.getOwnPropertyDescriptor(Y, le).enumerable;
              }))), se.forEach(function(le) {
                lt(Q, le, Y[le]);
              });
            }
            return Q;
          }
          function wa(Q, V) {
            return V = V != null ? V : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(Q, Object.getOwnPropertyDescriptors(V)) : function(Y, se) {
              var le = Object.keys(Y);
              if (Object.getOwnPropertySymbols) {
                var oe = Object.getOwnPropertySymbols(Y);
                se && (oe = oe.filter(function(te) {
                  return Object.getOwnPropertyDescriptor(Y, te).enumerable;
                })), le.push.apply(le, oe);
              }
              return le;
            }(Object(V)).forEach(function(Y) {
              Object.defineProperty(Q, Y, Object.getOwnPropertyDescriptor(V, Y));
            }), Q;
          }
          var Ys = ["x-request-id", "cf-ray", "x-amz-cf-id", "x-akamai-request-id"], za = ["x-cdn", "content-type"].concat(Ys);
          function jn(Q) {
            var V = {};
            return (Q = Q || "").trim().split(/[\r\n]+/).forEach(function(Y) {
              if (Y) {
                var se = Y.split(": "), le = se.shift();
                le && (za.indexOf(le.toLowerCase()) >= 0 || le.toLowerCase().indexOf("x-litix-") === 0) && (V[le] = se.join(": "));
              }
            }), V;
          }
          function Xa(Q) {
            if (Q) {
              var V = Ys.find(function(Y) {
                return Q[Y] !== void 0;
              });
              return V ? Q[V] : void 0;
            }
          }
          var Ks = function(Q) {
            var V = {};
            for (var Y in Q) {
              var se = Q[Y];
              se["DATA-ID"].search("io.litix.data.") !== -1 && (V[se["DATA-ID"].replace("io.litix.data.", "")] = se.VALUE);
            }
            return V;
          }, yn = function(Q) {
            if (!Q)
              return {};
            var V = oi.navigationStart(), Y = Q.loading, se = Y ? Y.start : Q.trequest, le = Y ? Y.first : Q.tfirst, oe = Y ? Y.end : Q.tload;
            return { bytesLoaded: Q.total, requestStart: Math.round(V + se), responseStart: Math.round(V + le), responseEnd: Math.round(V + oe) };
          }, ha = function(Q) {
            if (Q && typeof Q.getAllResponseHeaders == "function")
              return jn(Q.getAllResponseHeaders());
          }, Ei = function(Q, V) {
            if (!Q || !Q.requestEndDate)
              return {};
            var Y, se = Gr(Q.url), le = Q.url, oe = Q.bytesLoaded, te = new Date(Q.requestStartDate).getTime(), we = new Date(Q.firstByteDate).getTime(), Fe = new Date(Q.requestEndDate).getTime(), He = isNaN(Q.duration) ? 0 : Q.duration, ct = typeof V.getMetricsFor == "function" ? V.getMetricsFor(Q.mediaType).HttpList : V.getDashMetrics().getHttpRequests(Q.mediaType);
            return ct.length > 0 && (Y = jn(ct[ct.length - 1]._responseHeaders || "")), { requestStart: te, requestResponseStart: we, requestResponseEnd: Fe, requestBytesLoaded: oe, requestResponseHeaders: Y, requestMediaDuration: He, requestHostname: se, requestUrl: le, requestId: Y ? Xa(Y) : void 0 };
          }, ys = function(Q, V) {
            var Y = V.getQualityFor(Q), se = V.getCurrentTrackFor(Q).bitrateList;
            return se ? { currentLevel: Y, renditionWidth: se[Y].width || null, renditionHeight: se[Y].height || null, renditionBitrate: se[Y].bandwidth } : {};
          }, Ro = function(Q) {
            var V;
            return (V = Q.match(/.*codecs\*?="(.*)"/)) === null || V === void 0 ? void 0 : V[1];
          }, zs = function(Q) {
            try {
              var V, Y;
              return (Y = Q.getVersion) === null || Y === void 0 || (V = Y.call(Q)) === null || V === void 0 ? void 0 : V.split(".").map(function(se) {
                return parseInt(se);
              })[0];
            } catch {
              return !1;
            }
          }, Ja = 0, _n = function() {
            function Q() {
              Ot(this, Q), lt(this, "_listeners", void 0);
            }
            return sr(Q, [{ key: "on", value: function(V, Y, se) {
              return Y._eventEmitterGuid = Y._eventEmitterGuid || ++Ja, this._listeners = this._listeners || {}, this._listeners[V] = this._listeners[V] || [], se && (Y = Y.bind(se)), this._listeners[V].push(Y), Y;
            } }, { key: "off", value: function(V, Y) {
              var se = this._listeners && this._listeners[V];
              se && se.forEach(function(le, oe) {
                le._eventEmitterGuid === Y._eventEmitterGuid && se.splice(oe, 1);
              });
            } }, { key: "one", value: function(V, Y, se) {
              var le = this;
              Y._eventEmitterGuid = Y._eventEmitterGuid || ++Ja;
              var oe = function() {
                le.off(V, oe), Y.apply(se || this, arguments);
              };
              oe._eventEmitterGuid = Y._eventEmitterGuid, this.on(V, oe);
            } }, { key: "emit", value: function(V, Y) {
              var se = this;
              if (this._listeners) {
                Y = Y || {};
                var le = this._listeners["before*"] || [], oe = this._listeners[V] || [], te = this._listeners["after" + V] || [], we = function(Fe, He) {
                  (Fe = Fe.slice()).forEach(function(ct) {
                    ct.call(se, { type: V }, He);
                  });
                };
                we(le, Y), we(oe, Y), we(te, Y);
              }
            } }]), Q;
          }(), Ca = _n, Da = g(E()), on = function() {
            function Q(V) {
              var Y = this;
              Ot(this, Q), lt(this, "_playbackHeartbeatInterval", void 0), lt(this, "_playheadShouldBeProgressing", void 0), lt(this, "pm", void 0), this.pm = V, this._playbackHeartbeatInterval = null, this._playheadShouldBeProgressing = !1, V.on("playing", function() {
                Y._playheadShouldBeProgressing = !0;
              }), V.on("play", this._startPlaybackHeartbeatInterval.bind(this)), V.on("playing", this._startPlaybackHeartbeatInterval.bind(this)), V.on("adbreakstart", this._startPlaybackHeartbeatInterval.bind(this)), V.on("adplay", this._startPlaybackHeartbeatInterval.bind(this)), V.on("adplaying", this._startPlaybackHeartbeatInterval.bind(this)), V.on("devicewake", this._startPlaybackHeartbeatInterval.bind(this)), V.on("viewstart", this._startPlaybackHeartbeatInterval.bind(this)), V.on("rebufferstart", this._startPlaybackHeartbeatInterval.bind(this)), V.on("pause", this._stopPlaybackHeartbeatInterval.bind(this)), V.on("ended", this._stopPlaybackHeartbeatInterval.bind(this)), V.on("viewend", this._stopPlaybackHeartbeatInterval.bind(this)), V.on("error", this._stopPlaybackHeartbeatInterval.bind(this)), V.on("aderror", this._stopPlaybackHeartbeatInterval.bind(this)), V.on("adpause", this._stopPlaybackHeartbeatInterval.bind(this)), V.on("adended", this._stopPlaybackHeartbeatInterval.bind(this)), V.on("adbreakend", this._stopPlaybackHeartbeatInterval.bind(this)), V.on("seeked", function() {
                V.data.player_is_paused ? Y._stopPlaybackHeartbeatInterval() : Y._startPlaybackHeartbeatInterval();
              }), V.on("timeupdate", function() {
                Y._playbackHeartbeatInterval !== null && V.emit("playbackheartbeat");
              }), V.on("devicesleep", function(se, le) {
                Y._playbackHeartbeatInterval !== null && (Da.default.clearInterval(Y._playbackHeartbeatInterval), V.emit("playbackheartbeatend", { viewer_time: le.viewer_time }), Y._playbackHeartbeatInterval = null);
              });
            }
            return sr(Q, [{ key: "_startPlaybackHeartbeatInterval", value: function() {
              var V = this;
              this._playbackHeartbeatInterval === null && (this.pm.emit("playbackheartbeat"), this._playbackHeartbeatInterval = Da.default.setInterval(function() {
                V.pm.emit("playbackheartbeat");
              }, this.pm.playbackHeartbeatTime));
            } }, { key: "_stopPlaybackHeartbeatInterval", value: function() {
              this._playheadShouldBeProgressing = !1, this._playbackHeartbeatInterval !== null && (Da.default.clearInterval(this._playbackHeartbeatInterval), this.pm.emit("playbackheartbeatend"), this._playbackHeartbeatInterval = null);
            } }]), Q;
          }(), Po = function Q(V) {
            var Y = this;
            Ot(this, Q), lt(this, "viewErrored", void 0), V.on("viewinit", function() {
              Y.viewErrored = !1;
            }), V.on("error", function(se, le) {
              try {
                var oe = V.errorTranslator({ player_error_code: le.player_error_code, player_error_message: le.player_error_message, player_error_context: le.player_error_context, player_error_severity: le.player_error_severity, player_error_business_exception: le.player_error_business_exception });
                oe && (V.data.player_error_code = oe.player_error_code || le.player_error_code, V.data.player_error_message = oe.player_error_message || le.player_error_message, V.data.player_error_context = oe.player_error_context || le.player_error_context, V.data.player_error_severity = oe.player_error_severity || le.player_error_severity, V.data.player_error_business_exception = oe.player_error_business_exception || le.player_error_business_exception, Y.viewErrored = !0);
              } catch (te) {
                V.mux.log.warn("Exception in error translator callback.", te), Y.viewErrored = !0;
              }
            }), V.on("aftererror", function() {
              var se, le, oe, te, we;
              (se = V.data) === null || se === void 0 || delete se.player_error_code, (le = V.data) === null || le === void 0 || delete le.player_error_message, (oe = V.data) === null || oe === void 0 || delete oe.player_error_context, (te = V.data) === null || te === void 0 || delete te.player_error_severity, (we = V.data) === null || we === void 0 || delete we.player_error_business_exception;
            });
          }, _s = function() {
            function Q(V) {
              Ot(this, Q), lt(this, "_watchTimeTrackerLastCheckedTime", void 0), lt(this, "pm", void 0), this.pm = V, this._watchTimeTrackerLastCheckedTime = null, V.on("playbackheartbeat", this._updateWatchTime.bind(this)), V.on("playbackheartbeatend", this._clearWatchTimeState.bind(this));
            }
            return sr(Q, [{ key: "_updateWatchTime", value: function(V, Y) {
              var se = Y.viewer_time;
              this._watchTimeTrackerLastCheckedTime === null && (this._watchTimeTrackerLastCheckedTime = se), Kr(this.pm.data, "view_watch_time", se - this._watchTimeTrackerLastCheckedTime), this._watchTimeTrackerLastCheckedTime = se;
            } }, { key: "_clearWatchTimeState", value: function(V, Y) {
              this._updateWatchTime(V, Y), this._watchTimeTrackerLastCheckedTime = null;
            } }]), Q;
          }(), bs = function() {
            function Q(V) {
              var Y = this;
              Ot(this, Q), lt(this, "_playbackTimeTrackerLastPlayheadPosition", void 0), lt(this, "_lastTime", void 0), lt(this, "_isAdPlaying", void 0), lt(this, "_callbackUpdatePlaybackTime", void 0), lt(this, "pm", void 0), this.pm = V, this._playbackTimeTrackerLastPlayheadPosition = -1, this._lastTime = Pt.now(), this._isAdPlaying = !1, this._callbackUpdatePlaybackTime = null;
              var se = this._startPlaybackTimeTracking.bind(this);
              V.on("playing", se), V.on("adplaying", se), V.on("seeked", se);
              var le = this._stopPlaybackTimeTracking.bind(this);
              V.on("playbackheartbeatend", le), V.on("seeking", le), V.on("adplaying", function() {
                Y._isAdPlaying = !0;
              }), V.on("adended", function() {
                Y._isAdPlaying = !1;
              }), V.on("adpause", function() {
                Y._isAdPlaying = !1;
              }), V.on("adbreakstart", function() {
                Y._isAdPlaying = !1;
              }), V.on("adbreakend", function() {
                Y._isAdPlaying = !1;
              }), V.on("adplay", function() {
                Y._isAdPlaying = !1;
              }), V.on("viewinit", function() {
                Y._playbackTimeTrackerLastPlayheadPosition = -1, Y._lastTime = Pt.now(), Y._isAdPlaying = !1, Y._callbackUpdatePlaybackTime = null;
              });
            }
            return sr(Q, [{ key: "_startPlaybackTimeTracking", value: function() {
              this._callbackUpdatePlaybackTime === null && (this._callbackUpdatePlaybackTime = this._updatePlaybackTime.bind(this), this._playbackTimeTrackerLastPlayheadPosition = this.pm.data.player_playhead_time, this.pm.on("playbackheartbeat", this._callbackUpdatePlaybackTime));
            } }, { key: "_stopPlaybackTimeTracking", value: function() {
              this._callbackUpdatePlaybackTime && (this._updatePlaybackTime(), this.pm.off("playbackheartbeat", this._callbackUpdatePlaybackTime), this._callbackUpdatePlaybackTime = null, this._playbackTimeTrackerLastPlayheadPosition = -1);
            } }, { key: "_updatePlaybackTime", value: function() {
              var V = this.pm.data.player_playhead_time, Y = Pt.now(), se = -1;
              this._playbackTimeTrackerLastPlayheadPosition >= 0 && V > this._playbackTimeTrackerLastPlayheadPosition ? se = V - this._playbackTimeTrackerLastPlayheadPosition : this._isAdPlaying && (se = Y - this._lastTime), se > 0 && se <= 1e3 && Kr(this.pm.data, "view_content_playback_time", se), this._playbackTimeTrackerLastPlayheadPosition = V, this._lastTime = Y;
            } }]), Q;
          }(), Oo = function() {
            function Q(V) {
              Ot(this, Q), lt(this, "pm", void 0), this.pm = V;
              var Y = this._updatePlayheadTime.bind(this);
              V.on("playbackheartbeat", Y), V.on("playbackheartbeatend", Y), V.on("timeupdate", Y), V.on("destroy", function() {
                V.off("timeupdate", Y);
              });
            }
            return sr(Q, [{ key: "_updateMaxPlayheadPosition", value: function() {
              this.pm.data.view_max_playhead_position = this.pm.data.view_max_playhead_position === void 0 ? this.pm.data.player_playhead_time : Math.max(this.pm.data.view_max_playhead_position, this.pm.data.player_playhead_time);
            } }, { key: "_updatePlayheadTime", value: function(V, Y) {
              var se = this, le = function() {
                se.pm.currentFragmentPDT && se.pm.currentFragmentStart && (se.pm.data.player_program_time = se.pm.currentFragmentPDT + se.pm.data.player_playhead_time - se.pm.currentFragmentStart);
              };
              if (Y && Y.player_playhead_time)
                this.pm.data.player_playhead_time = Y.player_playhead_time, le(), this._updateMaxPlayheadPosition();
              else if (this.pm.getPlayheadTime) {
                var oe = this.pm.getPlayheadTime();
                oe !== void 0 && (this.pm.data.player_playhead_time = oe, le(), this._updateMaxPlayheadPosition());
              }
            } }]), Q;
          }(), $n = 3e5, ui = function Q(V) {
            if (Ot(this, Q), !V.disableRebufferTracking) {
              var Y, se = function(oe, te) {
                le(te), Y = void 0;
              }, le = function(oe) {
                if (Y) {
                  var te = oe.viewer_time - Y;
                  Kr(V.data, "view_rebuffer_duration", te), Y = oe.viewer_time, V.data.view_rebuffer_duration > $n && (V.emit("viewend"), V.send("viewend"), V.mux.log.warn("Ending view after rebuffering for longer than ".concat($n, "ms, future events will be ignored unless a programchange or videochange occurs.")));
                }
                V.data.view_watch_time >= 0 && V.data.view_rebuffer_count > 0 && (V.data.view_rebuffer_frequency = V.data.view_rebuffer_count / V.data.view_watch_time, V.data.view_rebuffer_percentage = V.data.view_rebuffer_duration / V.data.view_watch_time);
              };
              V.on("playbackheartbeat", function(oe, te) {
                return le(te);
              }), V.on("rebufferstart", function(oe, te) {
                Y || (Kr(V.data, "view_rebuffer_count", 1), Y = te.viewer_time, V.one("rebufferend", se));
              }), V.on("viewinit", function() {
                Y = void 0, V.off("rebufferend", se);
              });
            }
          }, Ts = function() {
            function Q(V) {
              var Y = this;
              Ot(this, Q), lt(this, "_lastCheckedTime", void 0), lt(this, "_lastPlayheadTime", void 0), lt(this, "_lastPlayheadTimeUpdatedTime", void 0), lt(this, "_rebuffering", void 0), lt(this, "pm", void 0), this.pm = V, !V.disableRebufferTracking && !V.disablePlayheadRebufferTracking && (this._lastCheckedTime = null, this._lastPlayheadTime = null, this._lastPlayheadTimeUpdatedTime = null, V.on("playbackheartbeat", this._checkIfRebuffering.bind(this)), V.on("playbackheartbeatend", this._cleanupRebufferTracker.bind(this)), V.on("seeking", function() {
                Y._cleanupRebufferTracker(null, { viewer_time: Pt.now() });
              }));
            }
            return sr(Q, [{ key: "_checkIfRebuffering", value: function(V, Y) {
              if (this.pm.seekingTracker.isSeeking || this.pm.adTracker.isAdBreak || !this.pm.playbackHeartbeat._playheadShouldBeProgressing)
                this._cleanupRebufferTracker(V, Y);
              else if (this._lastCheckedTime !== null)
                if (this._lastPlayheadTime === this.pm.data.player_playhead_time) {
                  var se = Y.viewer_time - this._lastPlayheadTimeUpdatedTime;
                  typeof this.pm.sustainedRebufferThreshold == "number" && se >= this.pm.sustainedRebufferThreshold && (this._rebuffering || (this._rebuffering = !0, this.pm.emit("rebufferstart", { viewer_time: this._lastPlayheadTimeUpdatedTime }))), this._lastCheckedTime = Y.viewer_time;
                } else
                  this._cleanupRebufferTracker(V, Y, !0);
              else
                this._prepareRebufferTrackerState(Y.viewer_time);
            } }, { key: "_clearRebufferTrackerState", value: function() {
              this._lastCheckedTime = null, this._lastPlayheadTime = null, this._lastPlayheadTimeUpdatedTime = null;
            } }, { key: "_prepareRebufferTrackerState", value: function(V) {
              this._lastCheckedTime = V, this._lastPlayheadTime = this.pm.data.player_playhead_time, this._lastPlayheadTimeUpdatedTime = V;
            } }, { key: "_cleanupRebufferTracker", value: function(V, Y) {
              var se = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
              if (this._rebuffering)
                this._rebuffering = !1, this.pm.emit("rebufferend", { viewer_time: Y.viewer_time });
              else {
                if (this._lastCheckedTime === null)
                  return;
                var le = this.pm.data.player_playhead_time - this._lastPlayheadTime, oe = Y.viewer_time - this._lastPlayheadTimeUpdatedTime;
                typeof this.pm.minimumRebufferDuration == "number" && le > 0 && oe - le > this.pm.minimumRebufferDuration && (this._lastCheckedTime = null, this.pm.emit("rebufferstart", { viewer_time: this._lastPlayheadTimeUpdatedTime }), this.pm.emit("rebufferend", { viewer_time: this._lastPlayheadTimeUpdatedTime + oe - le }));
              }
              se ? this._prepareRebufferTrackerState(Y.viewer_time) : this._clearRebufferTrackerState();
            } }]), Q;
          }(), Qi = Ts, Ss = function() {
            function Q(V) {
              var Y = this;
              Ot(this, Q), lt(this, "NAVIGATION_START", void 0), lt(this, "pm", void 0), this.pm = V, V.on("viewinit", function() {
                var se = V.data, le = se.view_id;
                if (!se.view_program_changed) {
                  var oe = function(te, we) {
                    var Fe = we.viewer_time;
                    (te.type === "playing" && V.data.view_time_to_first_frame === void 0 || te.type === "adplaying" && (V.data.view_time_to_first_frame === void 0 || Y._inPrerollPosition())) && Y.calculateTimeToFirstFrame(Fe || Pt.now(), le);
                  };
                  V.one("playing", oe), V.one("adplaying", oe), V.one("viewend", function() {
                    V.off("playing", oe), V.off("adplaying", oe);
                  });
                }
              });
            }
            return sr(Q, [{ key: "_inPrerollPosition", value: function() {
              return this.pm.data.view_content_playback_time === void 0 || this.pm.data.view_content_playback_time <= 1e3;
            } }, { key: "calculateTimeToFirstFrame", value: function(V, Y) {
              Y === this.pm.data.view_id && (this.pm.watchTimeTracker._updateWatchTime(null, { viewer_time: V }), this.pm.data.view_time_to_first_frame = this.pm.data.view_watch_time, (this.pm.data.player_autoplay_on || this.pm.data.video_is_autoplay) && this.NAVIGATION_START && (this.pm.data.view_aggregate_startup_time = this.pm.data.view_start + this.pm.data.view_watch_time - this.NAVIGATION_START));
            } }]), Q;
          }(), ka = function Q(V) {
            var Y = this;
            Ot(this, Q), lt(this, "_lastPlayerHeight", void 0), lt(this, "_lastPlayerWidth", void 0), lt(this, "_lastPlayheadPosition", void 0), lt(this, "_lastSourceHeight", void 0), lt(this, "_lastSourceWidth", void 0), V.on("viewinit", function() {
              Y._lastPlayheadPosition = -1;
            }), ["pause", "rebufferstart", "seeking", "error", "adbreakstart", "hb"].forEach(function(se) {
              V.on(se, function() {
                if (Y._lastPlayheadPosition >= 0 && V.data.player_playhead_time >= 0 && Y._lastPlayerWidth >= 0 && Y._lastSourceWidth > 0 && Y._lastPlayerHeight >= 0 && Y._lastSourceHeight > 0) {
                  var le = V.data.player_playhead_time - Y._lastPlayheadPosition;
                  if (le < 0)
                    return void (Y._lastPlayheadPosition = -1);
                  var oe = Math.min(Y._lastPlayerWidth / Y._lastSourceWidth, Y._lastPlayerHeight / Y._lastSourceHeight), te = Math.max(0, oe - 1), we = Math.max(0, 1 - oe);
                  V.data.view_max_upscale_percentage = Math.max(V.data.view_max_upscale_percentage || 0, te), V.data.view_max_downscale_percentage = Math.max(V.data.view_max_downscale_percentage || 0, we), Kr(V.data, "view_total_content_playback_time", le), Kr(V.data, "view_total_upscaling", te * le), Kr(V.data, "view_total_downscaling", we * le);
                }
                Y._lastPlayheadPosition = -1;
              });
            }), ["playing", "hb"].forEach(function(se) {
              V.on(se, function() {
                Y._lastPlayheadPosition = V.data.player_playhead_time, Y._lastPlayerWidth = V.data.player_width, Y._lastPlayerHeight = V.data.player_height, Y._lastSourceWidth = V.data.video_source_width, Y._lastSourceHeight = V.data.video_source_height;
              });
            });
          }, pa = function Q(V) {
            var Y = this;
            Ot(this, Q), lt(this, "isSeeking", void 0), this.isSeeking = !1;
            var se = -1, le = function() {
              var oe = Pt.now(), te = (V.data.viewer_time || oe) - (se || oe);
              Kr(V.data, "view_seek_duration", te), V.data.view_max_seek_time = Math.max(V.data.view_max_seek_time || 0, te), Y.isSeeking = !1, se = -1;
            };
            V.on("seeking", function(oe, te) {
              Object.assign(V.data, te), Y.isSeeking && te.viewer_time - se <= 2e3 ? se = te.viewer_time : (Y.isSeeking && le(), Y.isSeeking = !0, se = te.viewer_time, Kr(V.data, "view_seek_count", 1), V.send("seeking"));
            }), V.on("seeked", function() {
              le();
            }), V.on("viewend", function() {
              Y.isSeeking && (le(), V.send("seeked")), Y.isSeeking = !1, se = -1;
            });
          }, Qa = function(Q, V) {
            Q.push(V), Q.sort(function(Y, se) {
              return Y.viewer_time - se.viewer_time;
            });
          }, Za = ["adbreakstart", "adrequest", "adresponse", "adplay", "adplaying", "adpause", "adended", "adbreakend", "aderror", "adclicked", "adskipped"], xi = function() {
            function Q(V) {
              var Y = this;
              Ot(this, Q), lt(this, "_adHasPlayed", void 0), lt(this, "_adRequests", void 0), lt(this, "_adResponses", void 0), lt(this, "_currentAdRequestNumber", void 0), lt(this, "_currentAdResponseNumber", void 0), lt(this, "_prerollPlayTime", void 0), lt(this, "_wouldBeNewAdPlay", void 0), lt(this, "isAdBreak", void 0), lt(this, "pm", void 0), this.pm = V, V.on("viewinit", function() {
                Y.isAdBreak = !1, Y._currentAdRequestNumber = 0, Y._currentAdResponseNumber = 0, Y._adRequests = [], Y._adResponses = [], Y._adHasPlayed = !1, Y._wouldBeNewAdPlay = !0, Y._prerollPlayTime = void 0;
              }), Za.forEach(function(le) {
                return V.on(le, Y._updateAdData.bind(Y));
              });
              var se = function() {
                Y.isAdBreak = !1;
              };
              V.on("adbreakstart", function() {
                Y.isAdBreak = !0;
              }), V.on("play", se), V.on("playing", se), V.on("viewend", se), V.on("adrequest", function(le, oe) {
                oe = Object.assign({ ad_request_id: "generatedAdRequestId" + Y._currentAdRequestNumber++ }, oe), Qa(Y._adRequests, oe), Kr(V.data, "view_ad_request_count"), Y.inPrerollPosition() && (V.data.view_preroll_requested = !0, Y._adHasPlayed || Kr(V.data, "view_preroll_request_count"));
              }), V.on("adresponse", function(le, oe) {
                oe = Object.assign({ ad_request_id: "generatedAdRequestId" + Y._currentAdResponseNumber++ }, oe), Qa(Y._adResponses, oe);
                var te = Y.findAdRequest(oe.ad_request_id);
                te && Kr(V.data, "view_ad_request_time", Math.max(0, oe.viewer_time - te.viewer_time));
              }), V.on("adplay", function(le, oe) {
                Y._adHasPlayed = !0, Y._wouldBeNewAdPlay && (Y._wouldBeNewAdPlay = !1, Kr(V.data, "view_ad_played_count")), Y.inPrerollPosition() && !V.data.view_preroll_played && (V.data.view_preroll_played = !0, Y._adRequests.length > 0 && (V.data.view_preroll_request_time = Math.max(0, oe.viewer_time - Y._adRequests[0].viewer_time)), V.data.view_start && (V.data.view_startup_preroll_request_time = Math.max(0, oe.viewer_time - V.data.view_start)), Y._prerollPlayTime = oe.viewer_time);
              }), V.on("adplaying", function(le, oe) {
                Y.inPrerollPosition() && V.data.view_preroll_load_time === void 0 && Y._prerollPlayTime !== void 0 && (V.data.view_preroll_load_time = oe.viewer_time - Y._prerollPlayTime, V.data.view_startup_preroll_load_time = oe.viewer_time - Y._prerollPlayTime);
              }), V.on("adclicked", function(le, oe) {
                Y._wouldBeNewAdPlay || Kr(V.data, "view_ad_clicked_count");
              }), V.on("adskipped", function(le, oe) {
                Y._wouldBeNewAdPlay || Kr(V.data, "view_ad_skipped_count");
              }), V.on("adended", function() {
                Y._wouldBeNewAdPlay = !0;
              }), V.on("aderror", function() {
                Y._wouldBeNewAdPlay = !0;
              });
            }
            return sr(Q, [{ key: "inPrerollPosition", value: function() {
              return this.pm.data.view_content_playback_time === void 0 || this.pm.data.view_content_playback_time <= 1e3;
            } }, { key: "findAdRequest", value: function(V) {
              for (var Y = 0; Y < this._adRequests.length; Y++)
                if (this._adRequests[Y].ad_request_id === V)
                  return this._adRequests[Y];
            } }, { key: "_updateAdData", value: function(V, Y) {
              if (this.inPrerollPosition()) {
                if (!this.pm.data.view_preroll_ad_tag_hostname && Y.ad_tag_url) {
                  var se = Ne(li(Y.ad_tag_url), 2), le = se[0], oe = se[1];
                  this.pm.data.view_preroll_ad_tag_domain = oe, this.pm.data.view_preroll_ad_tag_hostname = le;
                }
                if (!this.pm.data.view_preroll_ad_asset_hostname && Y.ad_asset_url) {
                  var te = Ne(li(Y.ad_asset_url), 2), we = te[0], Fe = te[1];
                  this.pm.data.view_preroll_ad_asset_domain = Fe, this.pm.data.view_preroll_ad_asset_hostname = we;
                }
              }
              this.pm.data.ad_asset_url = Y == null ? void 0 : Y.ad_asset_url, this.pm.data.ad_tag_url = Y == null ? void 0 : Y.ad_tag_url, this.pm.data.ad_creative_id = Y == null ? void 0 : Y.ad_creative_id, this.pm.data.ad_id = Y == null ? void 0 : Y.ad_id, this.pm.data.ad_universal_id = Y == null ? void 0 : Y.ad_universal_id;
            } }]), Q;
          }(), bn = g(E()), Es = function Q(V) {
            Ot(this, Q);
            var Y, se, le = function() {
              V.disableRebufferTracking || Y && (Kr(V.data, "view_waiting_rebuffer_duration", Pt.now() - Y), Y = !1, bn.default.clearInterval(se));
            }, oe = !1, te = function() {
              oe = !1, le();
            };
            V.on("waiting", function() {
              oe && (V.disableRebufferTracking || (Kr(V.data, "view_waiting_rebuffer_count", 1), Y = Pt.now(), se = bn.default.setInterval(function() {
                if (Y) {
                  var we = Pt.now();
                  Kr(V.data, "view_waiting_rebuffer_duration", we - Y), Y = we;
                }
              }, 250)));
            }), V.on("playing", function() {
              le(), oe = !0;
            }), V.on("pause", te), V.on("seeking", te);
          }, Ra = function Q(V) {
            var Y = this;
            Ot(this, Q), lt(this, "lastWallClockTime", void 0);
            var se = function() {
              Y.lastWallClockTime = Pt.now(), V.on("before*", le);
            }, le = function(oe) {
              var te = Pt.now(), we = Y.lastWallClockTime;
              Y.lastWallClockTime = te, te - we > 3e4 && (V.emit("devicesleep", { viewer_time: we }), Object.assign(V.data, { viewer_time: we }), V.send("devicesleep"), V.emit("devicewake", { viewer_time: te }), Object.assign(V.data, { viewer_time: te }), V.send("devicewake"));
            };
            V.one("playbackheartbeat", se), V.on("playbackheartbeatend", function() {
              V.off("before*", le), V.one("playbackheartbeat", se);
            });
          }, Dn = g(E()), xs = g(D()), ta = g(R()), Pa = "muxData", Xs = function() {
            var Q;
            try {
              Q = xs.default.parse(ta.default.get(Pa) || "");
            } catch {
              Q = {};
            }
            return Q;
          }, Tn = function(Q) {
            try {
              ta.default.set(Pa, xs.default.stringify(Q), { expires: 365 });
            } catch {
            }
          }, es = function() {
            var Q = Xs();
            return Q.mux_viewer_id = Q.mux_viewer_id || ze(), Q.msn = Q.msn || Math.random(), Tn(Q), { mux_viewer_id: Q.mux_viewer_id, mux_sample_number: Q.msn };
          };
          function ga(Q, V) {
            var Y = V.beaconCollectionDomain, se = V.beaconDomain;
            if (Y)
              return "https://" + Y;
            var le = se || "litix.io";
            return (Q = Q || "inferred").match(/^[a-z0-9]+$/) ? "https://" + Q + "." + le : "https://img.litix.io/a.gif";
          }
          var un = g(E()), As = function() {
            var Q;
            switch (Oa()) {
              case "cellular":
                Q = "cellular";
                break;
              case "ethernet":
                Q = "wired";
                break;
              case "wifi":
                Q = "wifi";
                break;
              case void 0:
                break;
              default:
                Q = "other";
            }
            return Q;
          }, Oa = function() {
            var Q = un.default.navigator, V = Q && (Q.connection || Q.mozConnection || Q.webkitConnection);
            return V && V.type;
          };
          As.getConnectionFromAPI = Oa;
          var Gn = As, Hn = de({ a: "env", b: "beacon", c: "custom", d: "ad", e: "event", f: "experiment", i: "internal", m: "mux", n: "response", p: "player", q: "request", r: "retry", s: "session", t: "timestamp", u: "viewer", v: "video", w: "page", x: "view", y: "sub" }), Lo = de({ ad: "ad", ag: "aggregate", ap: "api", al: "application", ar: "architecture", as: "asset", au: "autoplay", av: "average", bi: "bitrate", br: "break", bw: "browser", by: "bytes", bz: "business", ca: "cached", cb: "cancel", cc: "codec", cd: "code", cg: "category", ch: "changed", ck: "clicked", cl: "canceled", cn: "config", co: "count", ce: "counter", cp: "complete", cr: "creative", ct: "content", cu: "current", cx: "connection", cz: "context", dg: "downscaling", dm: "domain", dn: "cdn", do: "downscale", dr: "drm", dp: "dropped", du: "duration", dv: "device", ec: "encoding", ed: "edge", en: "end", eg: "engine", em: "embed", er: "error", ep: "experiments", es: "errorcode", et: "errortext", ee: "event", ev: "events", ex: "expires", ez: "exception", fa: "failed", fi: "first", fm: "family", ft: "format", fp: "fps", fq: "frequency", fr: "frame", fs: "fullscreen", ha: "has", hb: "holdback", he: "headers", ho: "host", hn: "hostname", ht: "height", id: "id", ii: "init", in: "instance", ip: "ip", is: "is", ke: "key", la: "language", lb: "labeled", le: "level", li: "live", ld: "loaded", lo: "load", ls: "lists", lt: "latency", ma: "max", md: "media", me: "message", mf: "manifest", mi: "mime", ml: "midroll", mm: "min", mn: "manufacturer", mo: "model", mx: "mux", ne: "newest", nm: "name", no: "number", on: "on", os: "os", pa: "paused", pb: "playback", pd: "producer", pe: "percentage", pf: "played", pg: "program", ph: "playhead", pi: "plugin", pl: "preroll", pn: "playing", po: "poster", pr: "preload", ps: "position", pt: "part", py: "property", ra: "rate", rd: "requested", re: "rebuffer", rf: "rendition", rm: "remote", ro: "ratio", rp: "response", rq: "request", rs: "requests", sa: "sample", sd: "skipped", se: "session", sk: "seek", sm: "stream", so: "source", sq: "sequence", sr: "series", st: "start", su: "startup", sv: "server", sw: "software", sy: "severity", ta: "tag", tc: "tech", te: "text", tg: "target", th: "throughput", ti: "time", tl: "total", to: "to", tt: "title", ty: "type", ug: "upscaling", un: "universal", up: "upscale", ur: "url", us: "user", va: "variant", vd: "viewed", vi: "video", ve: "version", vw: "view", vr: "viewer", wd: "width", wa: "watch", wt: "waiting" });
          function de(Q) {
            var V = {};
            for (var Y in Q)
              Q.hasOwnProperty(Y) && (V[Q[Y]] = Y);
            return V;
          }
          function Ee(Q) {
            var V = {}, Y = {};
            return Object.keys(Q).forEach(function(se) {
              var le = !1;
              if (Q.hasOwnProperty(se) && Q[se] !== void 0) {
                var oe = se.split("_"), te = oe[0], we = Hn[te];
                we || (We.info("Data key word `" + oe[0] + "` not expected in " + se), we = te + "_"), oe.splice(1).forEach(function(Fe) {
                  Fe === "url" && (le = !0), Lo[Fe] ? we += Lo[Fe] : Number(Fe) && Math.floor(Number(Fe)) === Number(Fe) ? we += Fe : (We.info("Data key word `" + Fe + "` not expected in " + se), we += "_" + Fe + "_");
                }), le ? Y[we] = Q[se] : V[we] = Q[se];
              }
            }), Object.assign(V, Y);
          }
          var ge = g(E()), Me = { maxBeaconSize: 300, maxQueueLength: 3600, baseTimeBetweenBeacons: 1e4, maxPayloadKBSize: 500 }, Ge = ["hb", "requestcompleted", "requestfailed", "requestcanceled"], Le = "https://img.litix.io", et = function(Q) {
            var V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            this._beaconUrl = Q || Le, this._eventQueue = [], this._postInFlight = !1, this._failureCount = 0, this._sendTimeout = !1, this._options = Object.assign({}, Me, V);
          };
          et.prototype.queueEvent = function(Q, V) {
            var Y = Object.assign({}, V);
            return (this._eventQueue.length <= this._options.maxQueueLength || Q === "eventrateexceeded") && (this._eventQueue.push(Y), this._sendTimeout || this._startBeaconSending(), this._eventQueue.length <= this._options.maxQueueLength);
          }, et.prototype.flushEvents = function() {
            var Q = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
            Q && this._eventQueue.length === 1 ? this._eventQueue.pop() : (this._eventQueue.length && this._sendBeaconQueue(), this._startBeaconSending());
          }, et.prototype.destroy = function() {
            var Q = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
            this.destroyed = !0, Q ? this._clearBeaconQueue() : this.flushEvents(), ge.default.clearTimeout(this._sendTimeout);
          }, et.prototype._clearBeaconQueue = function() {
            var Q = this._eventQueue.length > this._options.maxBeaconSize ? this._eventQueue.length - this._options.maxBeaconSize : 0, V = this._eventQueue.slice(Q);
            Q > 0 && Object.assign(V[V.length - 1], Ee({ mux_view_message: "event queue truncated" }));
            var Y = this._createPayload(V);
            gt(this._beaconUrl, Y, !0, function() {
            });
          }, et.prototype._sendBeaconQueue = function() {
            var Q = this;
            if (!this._postInFlight) {
              var V = this._eventQueue.slice(0, this._options.maxBeaconSize);
              this._eventQueue = this._eventQueue.slice(this._options.maxBeaconSize), this._postInFlight = !0;
              var Y = this._createPayload(V), se = Pt.now();
              gt(this._beaconUrl, Y, !1, function(le, oe) {
                oe ? (Q._eventQueue = V.concat(Q._eventQueue), Q._failureCount += 1, We.info("Error sending beacon: " + oe)) : Q._failureCount = 0, Q._roundTripTime = Pt.now() - se, Q._postInFlight = !1;
              });
            }
          }, et.prototype._getNextBeaconTime = function() {
            if (!this._failureCount)
              return this._options.baseTimeBetweenBeacons;
            var Q = Math.pow(2, this._failureCount - 1);
            return (1 + (Q *= Math.random())) * this._options.baseTimeBetweenBeacons;
          }, et.prototype._startBeaconSending = function() {
            var Q = this;
            ge.default.clearTimeout(this._sendTimeout), !this.destroyed && (this._sendTimeout = ge.default.setTimeout(function() {
              Q._eventQueue.length && Q._sendBeaconQueue(), Q._startBeaconSending();
            }, this._getNextBeaconTime()));
          }, et.prototype._createPayload = function(Q) {
            var V = this, Y = { transmission_timestamp: Math.round(Pt.now()) };
            this._roundTripTime && (Y.rtt_ms = Math.round(this._roundTripTime));
            var se, le, oe, te = function() {
              se = JSON.stringify({ metadata: Y, events: le || Q }), oe = se.length / 1024;
            }, we = function() {
              return oe <= V._options.maxPayloadKBSize;
            };
            return te(), we() || (We.info("Payload size is too big (" + oe + " kb). Removing unnecessary events."), le = Q.filter(function(Fe) {
              return Ge.indexOf(Fe.e) === -1;
            }), te()), we() || (We.info("Payload size still too big (" + oe + " kb). Cropping fields.."), le.forEach(function(Fe) {
              for (var He in Fe) {
                var ct = Fe[He];
                typeof ct == "string" && ct.length > 51200 && (Fe[He] = ct.substring(0, 51200));
              }
            }), te()), se;
          };
          var yt = function(Q) {
            return Q.length <= 57344;
          }, gt = function(Q, V, Y, se) {
            if (Y && navigator && navigator.sendBeacon && navigator.sendBeacon(Q, V))
              se();
            else if (ge.default.fetch)
              ge.default.fetch(Q, { method: "POST", body: V, headers: { "Content-Type": "text/plain" }, keepalive: yt(V) }).then(function(oe) {
                return se(null, oe.ok ? null : "Error");
              }).catch(function(oe) {
                return se(null, oe);
              });
            else {
              if (ge.default.XMLHttpRequest) {
                var le = new ge.default.XMLHttpRequest();
                return le.onreadystatechange = function() {
                  if (le.readyState === 4)
                    return se(null, le.status !== 200 ? "error" : void 0);
                }, le.open("POST", Q), le.setRequestHeader("Content-Type", "text/plain"), void le.send(V);
              }
              se();
            }
          }, St = et, kt = ["env_key", "view_id", "view_sequence_number", "player_sequence_number", "beacon_domain", "player_playhead_time", "viewer_time", "mux_api_version", "event", "video_id", "player_instance_id", "player_error_code", "player_error_message", "player_error_context", "player_error_severity", "player_error_business_exception"], Qt = ["adplay", "adplaying", "adpause", "adfirstquartile", "admidpoint", "adthirdquartile", "adended", "adresponse", "adrequest"], _r = ["ad_id", "ad_creative_id", "ad_universal_id"], Br = ["viewstart", "error", "ended", "viewend"], jr = function() {
            function Q(V, Y) {
              var se, le, oe, te, we, Fe, He, ct, ut, ft, Ue, _t, Lt, ar, or, tr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
              Ot(this, Q), lt(this, "mux", void 0), lt(this, "envKey", void 0), lt(this, "options", void 0), lt(this, "eventQueue", void 0), lt(this, "sampleRate", void 0), lt(this, "disableCookies", void 0), lt(this, "respectDoNotTrack", void 0), lt(this, "previousBeaconData", void 0), lt(this, "lastEventTime", void 0), lt(this, "rateLimited", void 0), lt(this, "pageLevelData", void 0), lt(this, "viewerData", void 0), this.mux = V, this.envKey = Y, this.options = tr, this.previousBeaconData = null, this.lastEventTime = 0, this.rateLimited = !1, this.eventQueue = new St(ga(this.envKey, this.options)), this.sampleRate = (Lt = this.options.sampleRate) !== null && Lt !== void 0 ? Lt : 1, this.disableCookies = (ar = this.options.disableCookies) !== null && ar !== void 0 && ar, this.respectDoNotTrack = (or = this.options.respectDoNotTrack) !== null && or !== void 0 && or, this.previousBeaconData = null, this.lastEventTime = 0, this.rateLimited = !1, this.pageLevelData = { mux_api_version: this.mux.API_VERSION, mux_embed: this.mux.NAME, mux_embed_version: this.mux.VERSION, viewer_application_name: (se = this.options.platform) === null || se === void 0 ? void 0 : se.name, viewer_application_version: (le = this.options.platform) === null || le === void 0 ? void 0 : le.version, viewer_application_engine: (oe = this.options.platform) === null || oe === void 0 ? void 0 : oe.layout, viewer_device_name: (te = this.options.platform) === null || te === void 0 ? void 0 : te.product, viewer_device_category: "", viewer_device_manufacturer: (we = this.options.platform) === null || we === void 0 ? void 0 : we.manufacturer, viewer_os_family: (He = this.options.platform) === null || He === void 0 || (Fe = He.os) === null || Fe === void 0 ? void 0 : Fe.family, viewer_os_architecture: (ut = this.options.platform) === null || ut === void 0 || (ct = ut.os) === null || ct === void 0 ? void 0 : ct.architecture, viewer_os_version: (Ue = this.options.platform) === null || Ue === void 0 || (ft = Ue.os) === null || ft === void 0 ? void 0 : ft.version, viewer_connection_type: Gn(), page_url: Dn.default === null || Dn.default === void 0 || (_t = Dn.default.location) === null || _t === void 0 ? void 0 : _t.href }, this.viewerData = this.disableCookies ? {} : es();
            }
            return sr(Q, [{ key: "send", value: function(V, Y) {
              if (V && Y != null && Y.view_id) {
                if (this.respectDoNotTrack && Tt())
                  return We.info("Not sending `" + V + "` because Do Not Track is enabled");
                if (!Y || typeof Y != "object")
                  return We.error("A data object was expected in send() but was not provided");
                var se = this.disableCookies ? {} : function() {
                  var Fe = Xs(), He = Pt.now();
                  return Fe.session_start && (Fe.sst = Fe.session_start, delete Fe.session_start), Fe.session_id && (Fe.sid = Fe.session_id, delete Fe.session_id), Fe.session_expires && (Fe.sex = Fe.session_expires, delete Fe.session_expires), (!Fe.sex || Fe.sex < He) && (Fe.sid = ze(), Fe.sst = He), Fe.sex = He + 15e5, Tn(Fe), { session_id: Fe.sid, session_start: Fe.sst, session_expires: Fe.sex };
                }(), le = wa(mn({}, this.pageLevelData, Y, se, this.viewerData), { event: V, env_key: this.envKey });
                le.user_id && (le.viewer_user_id = le.user_id, delete le.user_id);
                var oe, te = ((oe = le.mux_sample_number) !== null && oe !== void 0 ? oe : 0) >= this.sampleRate, we = Ee(this._deduplicateBeaconData(V, le));
                if (this.lastEventTime = this.mux.utils.now(), te)
                  return We.info("Not sending event due to sample rate restriction", V, le, we);
                if (this.envKey || We.info("Missing environment key (envKey) - beacons will be dropped if the video source is not a valid mux video URL", V, le, we), !this.rateLimited) {
                  if (We.info("Sending event", V, le, we), this.rateLimited = !this.eventQueue.queueEvent(V, we), this.mux.WINDOW_UNLOADING && V === "viewend")
                    this.eventQueue.destroy(!0);
                  else if (this.mux.WINDOW_HIDDEN && V === "hb" ? this.eventQueue.flushEvents(!0) : Br.indexOf(V) >= 0 && this.eventQueue.flushEvents(), this.rateLimited)
                    return le.event = "eventrateexceeded", we = Ee(le), this.eventQueue.queueEvent(le.event, we), We.error("Beaconing disabled due to rate limit.");
                }
              }
            } }, { key: "destroy", value: function() {
              this.eventQueue.destroy(!1);
            } }, { key: "_deduplicateBeaconData", value: function(V, Y) {
              var se = this, le = {}, oe = Y.view_id;
              if (oe === "-1" || V === "viewstart" || V === "viewend" || !this.previousBeaconData || this.mux.utils.now() - this.lastEventTime >= 6e5)
                le = mn({}, Y), oe && (this.previousBeaconData = le), oe && V === "viewend" && (this.previousBeaconData = null);
              else {
                var te = V.indexOf("request") === 0;
                Object.entries(Y).forEach(function(we) {
                  var Fe = Ne(we, 2), He = Fe[0], ct = Fe[1];
                  se.previousBeaconData && (ct !== se.previousBeaconData[He] || kt.indexOf(He) > -1 || se.objectHasChanged(te, He, ct, se.previousBeaconData[He]) || se.eventRequiresKey(V, He)) && (le[He] = ct, se.previousBeaconData[He] = ct);
                });
              }
              return le;
            } }, { key: "objectHasChanged", value: function(V, Y, se, le) {
              return !(!V || Y.indexOf("request_") !== 0) && (Y === "request_response_headers" || typeof se != "object" || typeof le != "object" || Object.keys(se || {}).length !== Object.keys(le || {}).length);
            } }, { key: "eventRequiresKey", value: function(V, Y) {
              return !!(V === "renditionchange" && Y.indexOf("video_source_") === 0 || _r.includes(Y) && Qt.includes(V));
            } }]), Q;
          }(), Ai = function Q(V) {
            Ot(this, Q);
            var Y = 0, se = 0, le = 0, oe = 0, te = 0, we = 0, Fe = 0;
            V.on("requestcompleted", function(He, ct) {
              var ut, ft, Ue = ct.request_start, _t = ct.request_response_start, Lt = ct.request_response_end, ar = ct.request_bytes_loaded;
              if (oe++, _t ? (ut = _t - (Ue != null ? Ue : 0), ft = (Lt != null ? Lt : 0) - _t) : ft = (Lt != null ? Lt : 0) - (Ue != null ? Ue : 0), ft > 0 && ar && ar > 0) {
                var or = ar / ft * 8e3;
                te++, se += ar, le += ft, V.data.view_min_request_throughput = Math.min(V.data.view_min_request_throughput || 1 / 0, or), V.data.view_average_request_throughput = se / le * 8e3, V.data.view_request_count = oe, ut > 0 && (Y += ut, V.data.view_max_request_latency = Math.max(V.data.view_max_request_latency || 0, ut), V.data.view_average_request_latency = Y / te);
              }
            }), V.on("requestfailed", function(He, ct) {
              oe++, we++, V.data.view_request_count = oe, V.data.view_request_failed_count = we;
            }), V.on("requestcanceled", function(He, ct) {
              oe++, Fe++, V.data.view_request_count = oe, V.data.view_request_canceled_count = Fe;
            });
          }, mr = function Q(V) {
            var Y = this;
            Ot(this, Q), lt(this, "_lastEventTime", void 0), V.on("before*", function(se, le) {
              var oe = le.viewer_time, te = Pt.now(), we = Y._lastEventTime;
              if (Y._lastEventTime = te, we && te - we > 36e5) {
                var Fe = Object.keys(V.data).reduce(function(He, ct) {
                  return ct.indexOf("video_") === 0 ? Object.assign(He, lt({}, ct, V.data[ct])) : He;
                }, {});
                V.mux.log.info("Received event after at least an hour inactivity, creating a new view"), V.emit("viewinit", Object.assign({ viewer_time: oe }, Fe)), V.playbackHeartbeat._playheadShouldBeProgressing && se.type !== "play" && se.type !== "adbreakstart" && (V.emit("play", { viewer_time: oe }), se.type !== "playing" && V.emit("playing", { viewer_time: oe }));
              }
            });
          }, Ki = ["viewstart", "ended", "loadstart", "pause", "play", "playing", "ratechange", "waiting", "adplay", "adpause", "adended", "aderror", "adplaying", "adrequest", "adresponse", "adbreakstart", "adbreakend", "adfirstquartile", "admidpoint", "adthirdquartile", "rebufferstart", "rebufferend", "seeked", "error", "hb", "requestcompleted", "requestfailed", "requestcanceled", "renditionchange"], ra = function(Q) {
            (function(se, le) {
              if (typeof le != "function" && le !== null)
                throw new TypeError("Super expression must either be null or a function");
              se.prototype = Object.create(le && le.prototype, { constructor: { value: se, writable: !0, configurable: !0 } }), le && ri(se, le);
            })(Y, Q);
            var V = _i(Y);
            function Y(se, le, oe) {
              var te;
              Ot(this, Y), lt(at(te = V.call(this)), "DOM_CONTENT_LOADED_EVENT_END", void 0), lt(at(te), "NAVIGATION_START", void 0), lt(at(te), "_destroyed", void 0), lt(at(te), "_heartBeatTimeout", void 0), lt(at(te), "adTracker", void 0), lt(at(te), "dashjs", void 0), lt(at(te), "data", void 0), lt(at(te), "disablePlayheadRebufferTracking", void 0), lt(at(te), "disableRebufferTracking", void 0), lt(at(te), "errorTracker", void 0), lt(at(te), "errorTranslator", void 0), lt(at(te), "getAdData", void 0), lt(at(te), "getPlayheadTime", void 0), lt(at(te), "getStateData", void 0), lt(at(te), "hlsjs", void 0), lt(at(te), "id", void 0), lt(at(te), "longResumeTracker", void 0), lt(at(te), "minimumRebufferDuration", void 0), lt(at(te), "mux", void 0), lt(at(te), "oldEmit", void 0), lt(at(te), "playbackEventDispatcher", void 0), lt(at(te), "playbackHeartbeat", void 0), lt(at(te), "playbackHeartbeatTime", void 0), lt(at(te), "playheadTime", void 0), lt(at(te), "seekingTracker", void 0), lt(at(te), "sustainedRebufferThreshold", void 0), lt(at(te), "watchTimeTracker", void 0), lt(at(te), "currentFragmentPDT", void 0), lt(at(te), "currentFragmentStart", void 0), te.DOM_CONTENT_LOADED_EVENT_END = oi.domContentLoadedEventEnd(), te.NAVIGATION_START = oi.navigationStart(), te.mux = se, te.id = le, oe != null && oe.beaconDomain && te.mux.log.warn("The `beaconDomain` setting has been deprecated in favor of `beaconCollectionDomain`. Please change your integration to use `beaconCollectionDomain` instead of `beaconDomain`."), (oe = Object.assign({ debug: !1, minimumRebufferDuration: 250, sustainedRebufferThreshold: 1e3, playbackHeartbeatTime: 25, beaconDomain: "litix.io", sampleRate: 1, disableCookies: !1, respectDoNotTrack: !1, disableRebufferTracking: !1, disablePlayheadRebufferTracking: !1, errorTranslator: function(ut) {
                return ut;
              } }, oe)).data = oe.data || {}, oe.data.property_key && (oe.data.env_key = oe.data.property_key, delete oe.data.property_key), We.setLevel(oe.debug ? "debug" : "warn"), te.getPlayheadTime = oe.getPlayheadTime, te.getStateData = oe.getStateData || function() {
                return {};
              }, te.getAdData = oe.getAdData || function() {
              }, te.minimumRebufferDuration = oe.minimumRebufferDuration, te.sustainedRebufferThreshold = oe.sustainedRebufferThreshold, te.playbackHeartbeatTime = oe.playbackHeartbeatTime, te.disableRebufferTracking = oe.disableRebufferTracking, te.disableRebufferTracking && te.mux.log.warn("Disabling rebuffer tracking. This should only be used in specific circumstances as a last resort when your player is known to unreliably track rebuffering."), te.disablePlayheadRebufferTracking = oe.disablePlayheadRebufferTracking, te.errorTranslator = oe.errorTranslator, te.playbackEventDispatcher = new jr(se, oe.data.env_key, oe), te.data = { player_instance_id: ze(), mux_sample_rate: oe.sampleRate, beacon_domain: oe.beaconCollectionDomain || oe.beaconDomain }, te.data.view_sequence_number = 1, te.data.player_sequence_number = 1, te.oldEmit = te.emit, te.emit = function(ut, ft) {
                ft = Object.assign({ viewer_time: this.mux.utils.now() }, ft), this.oldEmit(ut, ft);
              };
              var we = function() {
                this.data.view_start === void 0 && (this.data.view_start = this.mux.utils.now(), this.emit("viewstart"));
              }.bind(at(te));
              te.on("viewinit", function(ut, ft) {
                this._resetVideoData(), this._resetViewData(), this._resetErrorData(), this._updateStateData(), Object.assign(this.data, ft), this._initializeViewData(), this.one("play", we), this.one("adbreakstart", we);
              });
              var Fe = function(ut) {
                this.emit("viewend"), this.send("viewend"), this.emit("viewinit", ut);
              }.bind(at(te));
              if (te.on("videochange", function(ut, ft) {
                Fe(ft);
              }), te.on("programchange", function(ut, ft) {
                this.data.player_is_paused && this.mux.log.warn("The `programchange` event is intended to be used when the content changes mid playback without the video source changing, however the video is not currently playing. If the video source is changing please use the videochange event otherwise you will lose startup time information."), Fe(Object.assign(ft, { view_program_changed: !0 })), we(), this.emit("play"), this.emit("playing");
              }), te.on("fragmentchange", function(ut, ft) {
                this.currentFragmentPDT = ft.currentFragmentPDT, this.currentFragmentStart = ft.currentFragmentStart;
              }), te.on("destroy", te.destroy), typeof window < "u" && typeof window.addEventListener == "function" && typeof window.removeEventListener == "function") {
                var He = function() {
                  var ut = te.data.view_start !== void 0;
                  te.mux.WINDOW_HIDDEN = document.visibilityState === "hidden", ut && te.mux.WINDOW_HIDDEN && (te.data.player_is_paused || te.emit("hb"));
                };
                window.addEventListener("visibilitychange", He, !1);
                var ct = function(ut) {
                  ut.persisted || te.destroy();
                };
                window.addEventListener("pagehide", ct, !1), te.on("destroy", function() {
                  window.removeEventListener("visibilitychange", He), window.removeEventListener("pagehide", ct);
                });
              }
              return te.on("playerready", function(ut, ft) {
                Object.assign(this.data, ft);
              }), Ki.forEach(function(ut) {
                te.on(ut, function(ft, Ue) {
                  ut.indexOf("ad") !== 0 && this._updateStateData(), Object.assign(this.data, Ue), this._sanitizeData();
                }), te.on("after" + ut, function() {
                  (ut !== "error" || this.errorTracker.viewErrored) && this.send(ut);
                });
              }), te.on("viewend", function(ut, ft) {
                Object.assign(te.data, ft);
              }), te.one("playerready", function(ut) {
                var ft = this.mux.utils.now();
                this.data.player_init_time && (this.data.player_startup_time = ft - this.data.player_init_time), !this.mux.PLAYER_TRACKED && this.NAVIGATION_START && (this.mux.PLAYER_TRACKED = !0, (this.data.player_init_time || this.DOM_CONTENT_LOADED_EVENT_END) && (this.data.page_load_time = Math.min(this.data.player_init_time || 1 / 0, this.DOM_CONTENT_LOADED_EVENT_END || 1 / 0) - this.NAVIGATION_START)), this.send("playerready"), delete this.data.player_startup_time, delete this.data.page_load_time;
              }), te.longResumeTracker = new mr(at(te)), te.errorTracker = new Po(at(te)), new Ra(at(te)), te.seekingTracker = new pa(at(te)), te.playheadTime = new Oo(at(te)), te.playbackHeartbeat = new on(at(te)), new ka(at(te)), te.watchTimeTracker = new _s(at(te)), new bs(at(te)), te.adTracker = new xi(at(te)), new Qi(at(te)), new ui(at(te)), new Ss(at(te)), new Es(at(te)), new Ai(at(te)), oe.hlsjs && te.addHLSJS(oe), oe.dashjs && te.addDashJS(oe), te.emit("viewinit", oe.data), te;
            }
            return sr(Y, [{ key: "destroy", value: function() {
              this._destroyed || (this._destroyed = !0, this.data.view_start !== void 0 && (this.emit("viewend"), this.send("viewend")), this.playbackEventDispatcher.destroy(), this.removeHLSJS(), this.removeDashJS(), window.clearTimeout(this._heartBeatTimeout));
            } }, { key: "send", value: function(se) {
              if (this.data.view_id) {
                var le = Object.assign({}, this.data);
                if (le.video_source_is_live === void 0 && (le.player_source_duration === 1 / 0 || le.video_source_duration === 1 / 0 ? le.video_source_is_live = !0 : (le.player_source_duration > 0 || le.video_source_duration > 0) && (le.video_source_is_live = !1)), le.video_source_is_live || ["player_program_time", "player_manifest_newest_program_time", "player_live_edge_program_time", "player_program_time", "video_holdback", "video_part_holdback", "video_target_duration", "video_part_target_duration"].forEach(function(Fe) {
                  le[Fe] = void 0;
                }), le.video_source_url = le.video_source_url || le.player_source_url, le.video_source_url) {
                  var oe = Ne(li(le.video_source_url), 2), te = oe[0], we = oe[1];
                  le.video_source_domain = we, le.video_source_hostname = te;
                }
                delete le.ad_request_id, this.playbackEventDispatcher.send(se, le), this.data.view_sequence_number++, this.data.player_sequence_number++, this._restartHeartBeat(), se === "viewend" && delete this.data.view_id;
              }
            } }, { key: "_updateStateData", value: function() {
              Object.assign(this.data, this.getStateData()), this.playheadTime._updatePlayheadTime(), this._sanitizeData();
            } }, { key: "_sanitizeData", value: function() {
              var se = this;
              ["player_width", "player_height", "video_source_width", "video_source_height", "player_playhead_time", "video_source_bitrate"].forEach(function(le) {
                var oe = parseInt(se.data[le], 10);
                se.data[le] = isNaN(oe) ? void 0 : oe;
              }), ["player_source_url", "video_source_url"].forEach(function(le) {
                if (se.data[le]) {
                  var oe = se.data[le].toLowerCase();
                  (oe.indexOf("data:") === 0 || oe.indexOf("blob:") === 0) && (se.data[le] = "MSE style URL");
                }
              });
            } }, { key: "_resetVideoData", value: function() {
              var se = this;
              Object.keys(this.data).forEach(function(le) {
                le.indexOf("video_") === 0 && delete se.data[le];
              });
            } }, { key: "_resetViewData", value: function() {
              var se = this;
              Object.keys(this.data).forEach(function(le) {
                le.indexOf("view_") === 0 && delete se.data[le];
              }), this.data.view_sequence_number = 1;
            } }, { key: "_resetErrorData", value: function() {
              delete this.data.player_error_code, delete this.data.player_error_message, delete this.data.player_error_context, delete this.data.player_error_severity, delete this.data.player_error_business_exception;
            } }, { key: "_initializeViewData", value: function() {
              var se = this, le = this.data.view_id = ze(), oe = function() {
                le === se.data.view_id && Kr(se.data, "player_view_count", 1);
              };
              this.data.player_is_paused ? this.one("play", oe) : oe();
            } }, { key: "_restartHeartBeat", value: function() {
              var se = this;
              window.clearTimeout(this._heartBeatTimeout), this._heartBeatTimeout = window.setTimeout(function() {
                se.data.player_is_paused || se.emit("hb");
              }, 1e4);
            } }, { key: "addHLSJS", value: function(se) {
              se.hlsjs ? this.hlsjs ? this.mux.log.warn("An instance of HLS.js is already being monitored for this player.") : (this.hlsjs = se.hlsjs, function(le, oe, te) {
                var we = arguments.length > 4 ? arguments[4] : void 0, Fe = le.log, He = le.utils.secondsToMs, ct = function(hr) {
                  var $t, ht = parseInt(we.version);
                  return ht === 1 && hr.programDateTime !== null && ($t = hr.programDateTime), ht === 0 && hr.pdt !== null && ($t = hr.pdt), $t;
                };
                if (oi.exists()) {
                  var ut = function(hr, $t) {
                    return le.emit(oe, hr, $t);
                  }, ft = function(hr, $t) {
                    var ht = $t.levels, pt = $t.audioTracks, Gt = $t.url, Yt = $t.stats, Ht = $t.networkDetails, vr = $t.sessionData, Zr = {}, zr = {};
                    ht.forEach(function(aa, Ma) {
                      Zr[Ma] = { width: aa.width, height: aa.height, bitrate: aa.bitrate, attrs: aa.attrs };
                    }), pt.forEach(function(aa, Ma) {
                      zr[Ma] = { name: aa.name, language: aa.lang, bitrate: aa.bitrate };
                    });
                    var kr = yn(Yt), Xr = kr.bytesLoaded, ks = kr.requestStart, yu = kr.responseStart, _u = kr.responseEnd;
                    ut("requestcompleted", wa(mn({}, Ks(vr)), { request_event_type: hr, request_bytes_loaded: Xr, request_start: ks, request_response_start: yu, request_response_end: _u, request_type: "manifest", request_hostname: Gr(Gt), request_response_headers: ha(Ht), request_rendition_lists: { media: Zr, audio: zr, video: {} } }));
                  };
                  te.on(we.Events.MANIFEST_LOADED, ft);
                  var Ue = function(hr, $t) {
                    var ht = $t.details, pt = $t.level, Gt = $t.networkDetails, Yt = $t.stats, Ht = yn(Yt), vr = Ht.bytesLoaded, Zr = Ht.requestStart, zr = Ht.responseStart, kr = Ht.responseEnd, Xr = ht.fragments[ht.fragments.length - 1], ks = ct(Xr) + He(Xr.duration);
                    ut("requestcompleted", { request_event_type: hr, request_bytes_loaded: vr, request_start: Zr, request_response_start: zr, request_response_end: kr, request_current_level: pt, request_type: "manifest", request_hostname: Gr(ht.url), request_response_headers: ha(Gt), video_holdback: ht.holdBack && He(ht.holdBack), video_part_holdback: ht.partHoldBack && He(ht.partHoldBack), video_part_target_duration: ht.partTarget && He(ht.partTarget), video_target_duration: ht.targetduration && He(ht.targetduration), video_source_is_live: ht.live, player_manifest_newest_program_time: isNaN(ks) ? void 0 : ks });
                  };
                  te.on(we.Events.LEVEL_LOADED, Ue);
                  var _t = function(hr, $t) {
                    var ht = $t.details, pt = $t.networkDetails, Gt = $t.stats, Yt = yn(Gt), Ht = Yt.bytesLoaded, vr = Yt.requestStart, Zr = Yt.responseStart, zr = Yt.responseEnd;
                    ut("requestcompleted", { request_event_type: hr, request_bytes_loaded: Ht, request_start: vr, request_response_start: Zr, request_response_end: zr, request_type: "manifest", request_hostname: Gr(ht.url), request_response_headers: ha(pt) });
                  };
                  te.on(we.Events.AUDIO_TRACK_LOADED, _t);
                  var Lt = function(hr, $t) {
                    var ht = $t.stats, pt = $t.networkDetails, Gt = $t.frag;
                    ht = ht || Gt.stats;
                    var Yt = yn(ht), Ht = Yt.bytesLoaded, vr = Yt.requestStart, Zr = Yt.responseStart, zr = Yt.responseEnd, kr = pt ? ha(pt) : void 0, Xr = { request_event_type: hr, request_bytes_loaded: Ht, request_start: vr, request_response_start: Zr, request_response_end: zr, request_hostname: pt ? Gr(pt.responseURL) : void 0, request_id: kr ? Xa(kr) : void 0, request_response_headers: kr, request_media_duration: Gt.duration, request_url: pt == null ? void 0 : pt.responseURL };
                    Gt.type === "main" ? (Xr.request_type = "media", Xr.request_current_level = Gt.level, Xr.request_video_width = (te.levels[Gt.level] || {}).width, Xr.request_video_height = (te.levels[Gt.level] || {}).height, Xr.request_labeled_bitrate = (te.levels[Gt.level] || {}).bitrate) : Xr.request_type = Gt.type, ut("requestcompleted", Xr);
                  };
                  te.on(we.Events.FRAG_LOADED, Lt);
                  var ar = function(hr, $t) {
                    var ht = $t.frag, pt = ht.start, Gt = { currentFragmentPDT: ct(ht), currentFragmentStart: He(pt) };
                    ut("fragmentchange", Gt);
                  };
                  te.on(we.Events.FRAG_CHANGED, ar);
                  var or = function(hr, $t) {
                    var ht = $t.type, pt = $t.details, Gt = $t.response, Yt = $t.fatal, Ht = $t.frag, vr = $t.networkDetails, Zr = (Ht == null ? void 0 : Ht.url) || $t.url || "", zr = vr ? ha(vr) : void 0;
                    if ((pt === we.ErrorDetails.MANIFEST_LOAD_ERROR || pt === we.ErrorDetails.MANIFEST_LOAD_TIMEOUT || pt === we.ErrorDetails.FRAG_LOAD_ERROR || pt === we.ErrorDetails.FRAG_LOAD_TIMEOUT || pt === we.ErrorDetails.LEVEL_LOAD_ERROR || pt === we.ErrorDetails.LEVEL_LOAD_TIMEOUT || pt === we.ErrorDetails.AUDIO_TRACK_LOAD_ERROR || pt === we.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT || pt === we.ErrorDetails.SUBTITLE_LOAD_ERROR || pt === we.ErrorDetails.SUBTITLE_LOAD_TIMEOUT || pt === we.ErrorDetails.KEY_LOAD_ERROR || pt === we.ErrorDetails.KEY_LOAD_TIMEOUT) && ut("requestfailed", { request_error: pt, request_url: Zr, request_hostname: Gr(Zr), request_id: zr ? Xa(zr) : void 0, request_type: pt === we.ErrorDetails.FRAG_LOAD_ERROR || pt === we.ErrorDetails.FRAG_LOAD_TIMEOUT ? "media" : pt === we.ErrorDetails.AUDIO_TRACK_LOAD_ERROR || pt === we.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT ? "audio" : pt === we.ErrorDetails.SUBTITLE_LOAD_ERROR || pt === we.ErrorDetails.SUBTITLE_LOAD_TIMEOUT ? "subtitle" : pt === we.ErrorDetails.KEY_LOAD_ERROR || pt === we.ErrorDetails.KEY_LOAD_TIMEOUT ? "encryption" : "manifest", request_error_code: Gt == null ? void 0 : Gt.code, request_error_text: Gt == null ? void 0 : Gt.text }), Yt) {
                      var kr, Xr = "".concat(Zr ? "url: ".concat(Zr, `
`) : "") + "".concat(Gt && (Gt.code || Gt.text) ? "response: ".concat(Gt.code, ", ").concat(Gt.text, `
`) : "") + "".concat($t.reason ? "failure reason: ".concat($t.reason, `
`) : "") + "".concat($t.level ? "level: ".concat($t.level, `
`) : "") + "".concat($t.parent ? "parent stream controller: ".concat($t.parent, `
`) : "") + "".concat($t.buffer ? "buffer length: ".concat($t.buffer, `
`) : "") + "".concat($t.error ? "error: ".concat($t.error, `
`) : "") + "".concat($t.event ? "event: ".concat($t.event, `
`) : "") + "".concat($t.err ? "error message: ".concat((kr = $t.err) === null || kr === void 0 ? void 0 : kr.message, `
`) : "");
                      ut("error", { player_error_code: ht, player_error_message: pt, player_error_context: Xr });
                    }
                  };
                  te.on(we.Events.ERROR, or);
                  var tr = function(hr, $t) {
                    var ht = $t.frag, pt = ht && ht._url || "";
                    ut("requestcanceled", { request_event_type: hr, request_url: pt, request_type: "media", request_hostname: Gr(pt) });
                  };
                  te.on(we.Events.FRAG_LOAD_EMERGENCY_ABORTED, tr);
                  var Dr = function(hr, $t) {
                    var ht = $t.level, pt = te.levels[ht];
                    if (pt && pt.attrs && pt.attrs.BANDWIDTH) {
                      var Gt, Yt = pt.attrs.BANDWIDTH, Ht = parseFloat(pt.attrs["FRAME-RATE"]);
                      isNaN(Ht) || (Gt = Ht), Yt ? ut("renditionchange", { video_source_fps: Gt, video_source_bitrate: Yt, video_source_width: pt.width, video_source_height: pt.height, video_source_rendition_name: pt.name, video_source_codec: pt == null ? void 0 : pt.videoCodec }) : Fe.warn("missing BANDWIDTH from HLS manifest parsed by HLS.js");
                    }
                  };
                  te.on(we.Events.LEVEL_SWITCHED, Dr), te._stopMuxMonitor = function() {
                    te.off(we.Events.MANIFEST_LOADED, ft), te.off(we.Events.LEVEL_LOADED, Ue), te.off(we.Events.AUDIO_TRACK_LOADED, _t), te.off(we.Events.FRAG_LOADED, Lt), te.off(we.Events.FRAG_CHANGED, ar), te.off(we.Events.ERROR, or), te.off(we.Events.FRAG_LOAD_EMERGENCY_ABORTED, tr), te.off(we.Events.LEVEL_SWITCHED, Dr), te.off(we.Events.DESTROYING, te._stopMuxMonitor), delete te._stopMuxMonitor;
                  }, te.on(we.Events.DESTROYING, te._stopMuxMonitor);
                } else
                  Fe.warn("performance timing not supported. Not tracking HLS.js.");
              }(this.mux, this.id, se.hlsjs, {}, se.Hls || window.Hls)) : this.mux.log.warn("You must pass a valid hlsjs instance in order to track it.");
            } }, { key: "removeHLSJS", value: function() {
              this.hlsjs && (function(se) {
                se && typeof se._stopMuxMonitor == "function" && se._stopMuxMonitor();
              }(this.hlsjs), this.hlsjs = void 0);
            } }, { key: "addDashJS", value: function(se) {
              se.dashjs ? this.dashjs ? this.mux.log.warn("An instance of Dash.js is already being monitored for this player.") : (this.dashjs = se.dashjs, function(le, oe, te) {
                var we = le.log;
                if (te && te.on) {
                  var Fe = zs(te), He = function(ht, pt) {
                    return le.emit(oe, ht, pt);
                  }, ct = function(ht) {
                    var pt = ht.type, Gt = (ht.data || {}).url;
                    He("requestcompleted", { request_event_type: pt, request_start: 0, request_response_start: 0, request_response_end: 0, request_bytes_loaded: -1, request_type: "manifest", request_hostname: Gr(Gt), request_url: Gt });
                  };
                  te.on("manifestLoaded", ct);
                  var ut = {}, ft = function(ht) {
                    if (typeof ht.getRequests != "function")
                      return null;
                    var pt = ht.getRequests({ state: "executed" });
                    return pt.length === 0 ? null : pt[pt.length - 1];
                  }, Ue = function(ht) {
                    var pt = ht.type, Gt = ht.fragmentModel, Yt = ht.chunk, Ht = ft(Gt);
                    _t({ type: pt, request: Ht, chunk: Yt });
                  }, _t = function(ht) {
                    var pt = ht.type, Gt = ht.chunk, Yt = ht.request, Ht = (Gt || {}).mediaInfo || {}, vr = Ht.type, Zr = Ht.bitrateList, zr = {};
                    (Zr = Zr || []).forEach(function(Uo, $i) {
                      zr[$i] = {}, zr[$i].width = Uo.width, zr[$i].height = Uo.height, zr[$i].bitrate = Uo.bandwidth, zr[$i].attrs = {};
                    }), vr === "video" ? ut.video = zr : vr === "audio" ? ut.audio = zr : ut.media = zr;
                    var kr = Ei(Yt, te), Xr = kr.requestStart, ks = kr.requestResponseStart, yu = kr.requestResponseEnd, _u = kr.requestResponseHeaders, aa = kr.requestMediaDuration, Ma = kr.requestHostname, bu = kr.requestUrl, gl = kr.requestId;
                    He("requestcompleted", { request_event_type: pt, request_start: Xr, request_response_start: ks, request_response_end: yu, request_bytes_loaded: -1, request_type: vr + "_init", request_response_headers: _u, request_hostname: Ma, request_id: gl, request_url: bu, request_media_duration: aa, request_rendition_lists: ut });
                  };
                  Fe >= 4 ? te.on("initFragmentLoaded", _t) : te.on("initFragmentLoaded", Ue);
                  var Lt = function(ht) {
                    var pt = ht.type, Gt = ht.fragmentModel, Yt = ht.chunk, Ht = ft(Gt);
                    ar({ type: pt, request: Ht, chunk: Yt });
                  }, ar = function(ht) {
                    var pt = ht.type, Gt = ht.chunk, Yt = ht.request, Ht = Gt || {}, vr = Ht.mediaInfo, Zr = Ht.start, zr = (vr || {}).type, kr = Ei(Yt, te), Xr = kr.requestStart, ks = kr.requestResponseStart, yu = kr.requestResponseEnd, _u = kr.requestBytesLoaded, aa = kr.requestResponseHeaders, Ma = kr.requestMediaDuration, bu = kr.requestHostname, gl = kr.requestUrl, Uo = kr.requestId, $i = ys(zr, te), Zs = $i.currentLevel, Tu = $i.renditionWidth, op = $i.renditionHeight, up = $i.renditionBitrate;
                    He("requestcompleted", { request_event_type: pt, request_start: Xr, request_response_start: ks, request_response_end: yu, request_bytes_loaded: _u, request_type: zr, request_response_headers: aa, request_hostname: bu, request_id: Uo, request_url: gl, request_media_start_time: Zr, request_media_duration: Ma, request_current_level: Zs, request_labeled_bitrate: up, request_video_width: Tu, request_video_height: op });
                  };
                  Fe >= 4 ? te.on("mediaFragmentLoaded", ar) : te.on("mediaFragmentLoaded", Lt);
                  var or = { video: void 0, audio: void 0, totalBitrate: void 0 }, tr = function() {
                    if (or.video && typeof or.video.bitrate == "number") {
                      if (!or.video.width || !or.video.height)
                        return void we.warn("have bitrate info for video but missing width/height");
                      var ht = or.video.bitrate;
                      if (or.audio && typeof or.audio.bitrate == "number" && (ht += or.audio.bitrate), ht !== or.totalBitrate)
                        return or.totalBitrate = ht, { video_source_bitrate: ht, video_source_height: or.video.height, video_source_width: or.video.width, video_source_codec: Ro(or.video.codec) };
                    }
                  }, Dr = function(ht, pt, Gt) {
                    if (typeof ht.newQuality == "number") {
                      var Yt = ht.mediaType;
                      if (Yt === "audio" || Yt === "video") {
                        var Ht = te.getBitrateInfoListFor(Yt).find(function(Zr) {
                          return Zr.qualityIndex === ht.newQuality;
                        });
                        if (!Ht || typeof Ht.bitrate != "number")
                          return void we.warn("missing bitrate info for ".concat(Yt));
                        or[Yt] = wa(mn({}, Ht), { codec: te.getCurrentTrackFor(Yt).codec });
                        var vr = tr();
                        vr && He("renditionchange", vr);
                      }
                    } else
                      we.warn("missing evt.newQuality in qualityChangeRendered event", ht);
                  };
                  te.on("qualityChangeRendered", Dr);
                  var hr = function(ht) {
                    var pt = ht.request, Gt = ht.mediaType;
                    He("requestcanceled", { request_event_type: (pt = pt || {}).type + "_" + pt.action, request_url: pt.url, request_type: Gt, request_hostname: Gr(pt.url) });
                  };
                  te.on("fragmentLoadingAbandoned", hr);
                  var $t = function(ht) {
                    var pt, Gt, Yt = ht.error, Ht = (Yt == null || (pt = Yt.data) === null || pt === void 0 ? void 0 : pt.request) || {}, vr = (Yt == null || (Gt = Yt.data) === null || Gt === void 0 ? void 0 : Gt.response) || {};
                    (Yt == null ? void 0 : Yt.code) === 27 && He("requestfailed", { request_error: Ht.type + "_" + Ht.action, request_url: Ht.url, request_hostname: Gr(Ht.url), request_type: Ht.mediaType, request_error_code: vr.status, request_error_text: vr.statusText });
                    var Zr = "".concat(Ht != null && Ht.url ? "url: ".concat(Ht.url, `
`) : "") + "".concat(vr != null && vr.status || vr != null && vr.statusText ? "response: ".concat(vr == null ? void 0 : vr.status, ", ").concat(vr == null ? void 0 : vr.statusText, `
`) : "");
                    He("error", { player_error_code: Yt == null ? void 0 : Yt.code, player_error_message: Yt == null ? void 0 : Yt.message, player_error_context: Zr });
                  };
                  te.on("error", $t), te._stopMuxMonitor = function() {
                    te.off("manifestLoaded", ct), te.off("initFragmentLoaded", _t), te.off("mediaFragmentLoaded", ar), te.off("qualityChangeRendered", Dr), te.off("error", $t), te.off("fragmentLoadingAbandoned", hr), delete te._stopMuxMonitor;
                  };
                } else
                  we.warn("Invalid dash.js player reference. Monitoring blocked.");
              }(this.mux, this.id, se.dashjs)) : this.mux.log.warn("You must pass a valid dashjs instance in order to track it.");
            } }, { key: "removeDashJS", value: function() {
              this.dashjs && (function(se) {
                se && typeof se._stopMuxMonitor == "function" && se._stopMuxMonitor();
              }(this.dashjs), this.dashjs = void 0);
            } }]), Y;
          }(Ca), La = ra;
          w();
          var Sn = g(me()), Ia = ["loadstart", "pause", "play", "playing", "seeking", "seeked", "timeupdate", "ratechange", "stalled", "waiting", "error", "ended"], Io = { 1: "MEDIA_ERR_ABORTED", 2: "MEDIA_ERR_NETWORK", 3: "MEDIA_ERR_DECODE", 4: "MEDIA_ERR_SRC_NOT_SUPPORTED" }, Vn, ia = g(E());
          ia.default && ia.default.WeakMap && (Vn = /* @__PURE__ */ new WeakMap());
          var va = "#EXT-X-TARGETDURATION", Js = "#EXT-X-PART-INF", ws = "#EXT-X-SERVER-CONTROL", ma = "#EXTINF", Qs = "#EXT-X-PROGRAM-DATE-TIME", ya = "#EXT-X-VERSION", fl = "#EXT-X-SESSION-DATA", na = function(Q) {
            return this.buffer = "", this.manifest = { segments: [], serverControl: {}, sessionData: {} }, this.currentUri = {}, this.process(Q), this.manifest;
          };
          na.prototype.process = function(Q) {
            var V;
            for (this.buffer += Q, V = this.buffer.indexOf(`
`); V > -1; V = this.buffer.indexOf(`
`))
              this.processLine(this.buffer.substring(0, V)), this.buffer = this.buffer.substring(V + 1);
          }, na.prototype.processLine = function(Q) {
            var V = Q.indexOf(":"), Y = Ec(Q, V), se = Y[0], le = Y.length === 2 ? Mo(Y[1]) : void 0;
            if (se[0] !== "#")
              this.currentUri.uri = se, this.manifest.segments.push(this.currentUri), this.manifest.targetDuration && !("duration" in this.currentUri) && (this.currentUri.duration = this.manifest.targetDuration), this.currentUri = {};
            else
              switch (se) {
                case va:
                  if (!isFinite(le) || le < 0)
                    return;
                  this.manifest.targetDuration = le, this.setHoldBack();
                  break;
                case Js:
                  Cs(this.manifest, Y), this.manifest.partInf.partTarget && (this.manifest.partTargetDuration = this.manifest.partInf.partTarget), this.setHoldBack();
                  break;
                case ws:
                  Cs(this.manifest, Y), this.setHoldBack();
                  break;
                case ma:
                  le === 0 ? this.currentUri.duration = 0.01 : le > 0 && (this.currentUri.duration = le);
                  break;
                case Qs:
                  var oe = le, te = new Date(oe);
                  this.manifest.dateTimeString || (this.manifest.dateTimeString = oe, this.manifest.dateTimeObject = te), this.currentUri.dateTimeString = oe, this.currentUri.dateTimeObject = te;
                  break;
                case ya:
                  Cs(this.manifest, Y);
                  break;
                case fl:
                  var we = xe(Y[1]), Fe = Ks(we);
                  Object.assign(this.manifest.sessionData, Fe);
              }
          }, na.prototype.setHoldBack = function() {
            var Q = this.manifest, V = Q.serverControl, Y = Q.targetDuration, se = Q.partTargetDuration;
            if (V) {
              var le = "holdBack", oe = "partHoldBack", te = Y && 3 * Y, we = se && 2 * se;
              Y && !V.hasOwnProperty(le) && (V[le] = te), te && V[le] < te && (V[le] = te), se && !V.hasOwnProperty(oe) && (V[oe] = 3 * se), se && V[oe] < we && (V[oe] = we);
            }
          };
          var Cs = function(Q, V) {
            var Y, se = pu(V[0].replace("#EXT-X-", ""));
            Sc(V[1]) ? (Y = {}, Y = Object.assign(pl(V[1]), Y)) : Y = Mo(V[1]), Q[se] = Y;
          }, pu = function(Q) {
            return Q.toLowerCase().replace(/-(\w)/g, function(V) {
              return V[1].toUpperCase();
            });
          }, Mo = function(Q) {
            if (Q.toLowerCase() === "yes" || Q.toLowerCase() === "no")
              return Q.toLowerCase() === "yes";
            var V = Q.indexOf(":") !== -1 ? Q : parseFloat(Q);
            return isNaN(V) ? Q : V;
          }, hl = function(Q) {
            var V = {}, Y = Q.split("=");
            return Y.length > 1 && (V[pu(Y[0])] = Mo(Y[1])), V;
          }, pl = function(Q) {
            for (var V = Q.split(","), Y = {}, se = 0; V.length > se; se++) {
              var le = V[se], oe = hl(le);
              Y = Object.assign(oe, Y);
            }
            return Y;
          }, Sc = function(Q) {
            return Q.indexOf("=") > -1;
          }, Ec = function(Q, V) {
            return V === -1 ? [Q] : [Q.substring(0, V), Q.substring(V + 1)];
          }, xe = function(Q) {
            var V = {};
            if (Q) {
              var Y = Q.search(",");
              return [Q.slice(0, Y), Q.slice(Y + 1)].forEach(function(se, le) {
                for (var oe = se.replace(/['"]+/g, "").split("="), te = 0; te < oe.length; te++)
                  oe[te] === "DATA-ID" && (V["DATA-ID"] = oe[1 - te]), oe[te] === "VALUE" && (V.VALUE = oe[1 - te]);
              }), { data: V };
            }
          }, q = na, z = { safeCall: function(Q, V, Y, se) {
            var le = se;
            if (Q && typeof Q[V] == "function")
              try {
                le = Q[V].apply(Q, Y);
              } catch (oe) {
                We.info("safeCall error", oe);
              }
            return le;
          }, safeIncrement: Kr, getComputedStyle: function(Q, V) {
            return Q && V && ia.default && typeof ia.default.getComputedStyle == "function" ? (Vn && Vn.has(Q) && (Y = Vn.get(Q)), Y || (Y = ia.default.getComputedStyle(Q, null), Vn && Vn.set(Q, Y)), Y.getPropertyValue(V)) : "";
            var Y;
          }, secondsToMs: function(Q) {
            return Math.floor(1e3 * Q);
          }, assign: Object.assign, headersStringToObject: jn, cdnHeadersToRequestId: Xa, extractHostnameAndDomain: li, extractHostname: Gr, manifestParser: q, generateShortID: $e, generateUUID: ze, now: Pt.now }, ie = { PLAYER_READY: "playerready", VIEW_INIT: "viewinit", VIDEO_CHANGE: "videochange", PLAY: "play", PAUSE: "pause", PLAYING: "playing", TIME_UPDATE: "timeupdate", SEEKING: "seeking", SEEKED: "seeked", REBUFFER_START: "rebufferstart", REBUFFER_END: "rebufferend", ERROR: "error", ENDED: "ended", RENDITION_CHANGE: "renditionchange", ORIENTATION_CHANGE: "orientationchange", AD_REQUEST: "adrequest", AD_RESPONSE: "adresponse", AD_BREAK_START: "adbreakstart", AD_PLAY: "adplay", AD_PLAYING: "adplaying", AD_PAUSE: "adpause", AD_FIRST_QUARTILE: "adfirstquartile", AD_MID_POINT: "admidpoint", AD_THIRD_QUARTILE: "adthirdquartile", AD_ENDED: "adended", AD_BREAK_END: "adbreakend", AD_ERROR: "aderror", REQUEST_COMPLETED: "requestcompleted", REQUEST_FAILED: "requestfailed", REQUEST_CANCELLED: "requestcanceled" }, ne = {}, pe = function(Q) {
            var V = arguments;
            typeof Q == "string" ? pe.hasOwnProperty(Q) ? ot.default.setTimeout(function() {
              V = Array.prototype.splice.call(V, 1), pe[Q].apply(null, V);
            }, 0) : We.warn("`" + Q + "` is an unknown task") : typeof Q == "function" ? ot.default.setTimeout(function() {
              Q(pe);
            }, 0) : We.warn("`" + Q + "` is invalid.");
          }, ve = { loaded: Pt.now(), NAME: "mux-embed", VERSION: "5.2.1", API_VERSION: "2.1", PLAYER_TRACKED: !1, monitor: function(Q, V) {
            return function(Y, se, le) {
              var oe = Ne(Ut(se), 3), te = oe[0], we = oe[1], Fe = oe[2], He = Y.log, ct = Y.utils.getComputedStyle, ut = Y.utils.secondsToMs;
              if (!te)
                return He.error("No element was found with the `" + we + "` query selector.");
              if (Fe !== "video" && Fe !== "audio")
                return He.error("The element of `" + we + "` was not a media element.");
              te.mux && (te.mux.destroy(), delete te.mux, He.warn("Already monitoring this video element, replacing existing event listeners")), (le = Object.assign({ automaticErrorTracking: !0 }, le)).data = Object.assign({ player_software: "HTML5 Video Element", player_mux_plugin_name: "VideoElementMonitor", player_mux_plugin_version: Y.VERSION }, le.data), le.getPlayheadTime = function() {
                return ut(te.currentTime);
              }, le.getStateData = function() {
                var Ue, _t = this.hlsjs && this.hlsjs.url, Lt = this.dashjs && x(this.dashjs.getSource === "function") && this.dashjs.getSource(), ar = { player_is_paused: te.paused, player_playhead_time: ut(te.currentTime), player_width: parseInt(ct(te, "width")), player_height: parseInt(ct(te, "height")), player_autoplay_on: te.autoplay, player_preload_on: te.preload, player_language_code: te.lang, player_is_fullscreen: Sn.default && !!(Sn.default.fullscreenElement || Sn.default.webkitFullscreenElement || Sn.default.mozFullScreenElement || Sn.default.msFullscreenElement), video_poster_url: te.poster, video_source_url: _t || Lt || te.currentSrc, video_source_duration: ut(te.duration), video_source_height: te.videoHeight, video_source_width: te.videoWidth, view_dropped_frame_count: te == null || (Ue = te.getVideoPlaybackQuality) === null || Ue === void 0 ? void 0 : Ue.call(te).droppedVideoFrames }, or = le.getPlayheadTime();
                if (te.getStartDate && or > 0) {
                  var tr = te.getStartDate();
                  if (tr && typeof tr.getTime == "function" && tr.getTime()) {
                    var Dr = tr.getTime();
                    if (ar.player_program_time = Dr + or, te.seekable.length > 0) {
                      var hr = Dr + te.seekable.end(te.seekable.length - 1);
                      ar.player_live_edge_program_time = hr;
                    }
                  }
                }
                return ar;
              }, te.mux = te.mux || {}, te.mux.deleted = !1, te.mux.emit = function(Ue, _t) {
                Y.emit(we, Ue, _t);
              };
              var ft = function() {
                He.error("The monitor for this video element has already been destroyed.");
              };
              te.mux.destroy = function() {
                Object.keys(te.mux.listeners).forEach(function(Ue) {
                  te.removeEventListener(Ue, te.mux.listeners[Ue], !1);
                }), delete te.mux.listeners, te.mux.destroy = ft, te.mux.swapElement = ft, te.mux.emit = ft, te.mux.addHLSJS = ft, te.mux.addDashJS = ft, te.mux.removeHLSJS = ft, te.mux.removeDashJS = ft, te.mux.deleted = !0, Y.emit(we, "destroy");
              }, te.mux.swapElement = function(Ue) {
                var _t = Ne(Ut(Ue), 3), Lt = _t[0], ar = _t[1], or = _t[2];
                return Lt ? or !== "video" && or !== "audio" ? Y.log.error("The element of `" + ar + "` was not a media element.") : (Lt.muxId = te.muxId, delete te.muxId, Lt.mux = Lt.mux || {}, Lt.mux.listeners = Object.assign({}, te.mux.listeners), delete te.mux.listeners, Object.keys(Lt.mux.listeners).forEach(function(tr) {
                  te.removeEventListener(tr, Lt.mux.listeners[tr], !1), Lt.addEventListener(tr, Lt.mux.listeners[tr], !1);
                }), Lt.mux.swapElement = te.mux.swapElement, Lt.mux.destroy = te.mux.destroy, delete te.mux, void (te = Lt)) : Y.log.error("No element was found with the `" + ar + "` query selector.");
              }, te.mux.addHLSJS = function(Ue) {
                Y.addHLSJS(we, Ue);
              }, te.mux.addDashJS = function(Ue) {
                Y.addDashJS(we, Ue);
              }, te.mux.removeHLSJS = function() {
                Y.removeHLSJS(we);
              }, te.mux.removeDashJS = function() {
                Y.removeDashJS(we);
              }, Y.init(we, le), Y.emit(we, "playerready"), te.paused || (Y.emit(we, "play"), te.readyState > 2 && Y.emit(we, "playing")), te.mux.listeners = {}, Ia.forEach(function(Ue) {
                Ue === "error" && !le.automaticErrorTracking || (te.mux.listeners[Ue] = function() {
                  var _t = {};
                  if (Ue === "error") {
                    if (!te.error || te.error.code === 1)
                      return;
                    _t.player_error_code = te.error.code, _t.player_error_message = Io[te.error.code] || te.error.message;
                  }
                  Y.emit(we, Ue, _t);
                }, te.addEventListener(Ue, te.mux.listeners[Ue], !1));
              });
            }(pe, Q, V);
          }, destroyMonitor: function(Q) {
            var V = Ne(Ut(Q), 1)[0];
            V && V.mux && typeof V.mux.destroy == "function" ? V.mux.destroy() : We.error("A video element monitor for `" + Q + "` has not been initialized via `mux.monitor`.");
          }, addHLSJS: function(Q, V) {
            var Y = Ze(Q);
            ne[Y] ? ne[Y].addHLSJS(V) : We.error("A monitor for `" + Y + "` has not been initialized.");
          }, addDashJS: function(Q, V) {
            var Y = Ze(Q);
            ne[Y] ? ne[Y].addDashJS(V) : We.error("A monitor for `" + Y + "` has not been initialized.");
          }, removeHLSJS: function(Q) {
            var V = Ze(Q);
            ne[V] ? ne[V].removeHLSJS() : We.error("A monitor for `" + V + "` has not been initialized.");
          }, removeDashJS: function(Q) {
            var V = Ze(Q);
            ne[V] ? ne[V].removeDashJS() : We.error("A monitor for `" + V + "` has not been initialized.");
          }, init: function(Q, V) {
            Tt() && V && V.respectDoNotTrack && We.info("The browser's Do Not Track flag is enabled - Mux beaconing is disabled.");
            var Y = Ze(Q);
            ne[Y] = new La(pe, Y, V);
          }, emit: function(Q, V, Y) {
            var se = Ze(Q);
            ne[se] ? (ne[se].emit(V, Y), V === "destroy" && delete ne[se]) : We.error("A monitor for `" + se + "` has not been initialized.");
          }, checkDoNotTrack: Tt, log: We, utils: z, events: ie, WINDOW_HIDDEN: !1, WINDOW_UNLOADING: !1 };
          Object.assign(pe, ve), ot.default !== void 0 && typeof ot.default.addEventListener == "function" && ot.default.addEventListener("pagehide", function(Q) {
            Q.persisted || (pe.WINDOW_UNLOADING = !0);
          }, !1);
          var Ae = pe;
          /*!
          * JavaScript Cookie v2.1.3
          * https://github.com/js-cookie/js-cookie
          *
          * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
          * Released under the MIT license
          */
          var ke = Ae.utils.secondsToMs;
          function Ve(Q, V) {
            var Y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], se = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], le = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {
              return {};
            }, oe = !1;
            Q.on("adstart", function() {
              oe = !0;
            }), Q.on("adend", function() {
              oe = !1;
            }), Q.on("adserror", function() {
              oe = !1;
            });
            var te = function() {
              var we = ke(V.currentTime()), Fe = function ct() {
                var ut = Ae.utils.now(), ft = ke(V.currentTime());
                if (oe) {
                  if (ft > we) {
                    var Ue = le();
                    Ue.viewer_time = ut - Math.max(0, ft - we), V.off("timeupdate", ct), Q.mux.emit("adplaying", Ue);
                  }
                } else
                  V.off("timeupdate", ct);
              };
              V.on("timeupdate", Fe);
              var He = function ct() {
                V.off("timeupdate", Fe), Y.forEach(function(ut) {
                  V.off(ut, ct);
                });
              };
              Y.forEach(function(ct) {
                V.on(ct, He);
              });
            };
            se.forEach(function(we) {
              V.on(we, te);
            });
          }
          function st(Q) {
            if (typeof Q != "string")
              return !1;
            var V = Q.split(".").map(function(le) {
              return parseInt(le);
            }), Y = V[0], se = V[1];
            return Y > 2 || Y === 2 && se >= 3;
          }
          var Ft = Ae.utils.manifestParser;
          function Zt(Q, V) {
            return function(Y) {
              if (Array.isArray(Y))
                return Y;
            }(Q) || function(Y, se) {
              var le = Y == null ? null : typeof Symbol < "u" && Y[Symbol.iterator] || Y["@@iterator"];
              if (le != null) {
                var oe, te, we = [], Fe = !0, He = !1;
                try {
                  for (le = le.call(Y); !(Fe = (oe = le.next()).done) && (we.push(oe.value), !se || we.length !== se); Fe = !0)
                    ;
                } catch (ct) {
                  He = !0, te = ct;
                } finally {
                  try {
                    Fe || le.return == null || le.return();
                  } finally {
                    if (He)
                      throw te;
                  }
                }
                return we;
              }
            }(Q, V) || function(Y, se) {
              if (!!Y) {
                if (typeof Y == "string")
                  return nr(Y, se);
                var le = Object.prototype.toString.call(Y).slice(8, -1);
                if (le === "Object" && Y.constructor && (le = Y.constructor.name), le === "Map" || le === "Set")
                  return Array.from(Y);
                if (le === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(le))
                  return nr(Y, se);
              }
            }(Q, V) || function() {
              throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }();
          }
          function nr(Q, V) {
            (V == null || V > Q.length) && (V = Q.length);
            for (var Y = 0, se = new Array(V); Y < V; Y++)
              se[Y] = Q[Y];
            return se;
          }
          var br = Ae.utils, Cr = br.assign, Rt = br.secondsToMs;
          function Oi(Q, V, Y) {
            var se = 0;
            return function() {
              var le, oe = V.readyState;
              if (oe >= 2) {
                if (se = se || Ae.utils.now(), oe !== 4)
                  return;
                var te = Q(), we = te.mux.utils.extractHostnameAndDomain, Fe = te.mux.utils.headersStringToObject, He = Ae.utils.now(), ct = Zt(we(V.responseURL), 1)[0], ut = V.responseType === "arraybuffer" ? V.response.byteLength : V.responseText.length, ft = Fe(V.getAllResponseHeaders ? V.getAllResponseHeaders() : ""), Ue = function(Ht) {
                  var vr = Ht["content-type"];
                  return vr ? vr.match(/^audio\/mpegurl/i) ? "manifest" : vr.match(/^audio.*/i) ? "audio" : vr.match(/^video.*/) ? "video" : vr.match(/^application\/x-mpegurl/i) || vr.match(/^application\/vnd.apple.mpegurl/i) || vr.match(/^application\/dash+xml/i) ? "manifest" : "unknown" : "unknown";
                }(ft);
                if (V.status >= 200 && V.status < 300) {
                  var _t = { request_start: Y, request_response_start: se, request_response_end: He, request_bytes_loaded: ut, request_hostname: ct, request_url: V.responseURL, request_response_headers: ft, request_type: Ue };
                  if (Ue === "manifest") {
                    var Lt, ar, or, tr, Dr, hr, $t, ht = (le = V.responseText, new Ft(le));
                    if (ht) {
                      Lt = ht.partTargetDuration, ar = ht.targetDuration, or = ht.segments;
                      var pt = ht.serverControl;
                      tr = pt.partHoldBack, Dr = pt.holdBack, $t = ht.sessionData;
                      var Gt = or[or.length - 1];
                      Gt && Gt.dateTimeObject && (hr = Gt.dateTimeObject.getTime() + Rt(Gt.duration)), _t = Cr(_t, { video_holdback: Dr && Rt(Dr), video_part_holdback: tr && Rt(tr), video_part_target_duration: Lt && Rt(Lt), video_target_duration: ar && Rt(ar), player_manifest_newest_program_time: hr }), $t && (_t = Cr(_t, $t));
                    }
                  }
                  te.mux.emit("requestcompleted", _t);
                } else {
                  var Yt = { request_hostname: Zt(we(V.responseURL), 1)[0], request_url: V.responseURL, request_type: Ue };
                  te.mux.emit("requestfailed", Yt);
                }
              }
            };
          }
          function qn(Q, V) {
            var Y, se = function(le) {
              return function(oe) {
                var te = Ae.utils.now();
                try {
                  le(oe);
                } catch {
                }
                try {
                  oe.onreadystatechange = function(we, Fe, He) {
                    var ct = Oi(Q, we, Fe);
                    return function() {
                      try {
                        ct();
                      } catch {
                      }
                      try {
                        He();
                      } catch {
                      }
                    };
                  }(oe, te, oe.onreadystatechange || function() {
                  });
                } catch {
                }
              };
            };
            typeof (V == null ? void 0 : V.onRequest) == "function" ? V.onRequest(function(le) {
              return le.beforeSend = se(le.beforeSend || function() {
              }), le;
            }) : V.beforeRequest = (Y = V.beforeRequest || function(le) {
              return le;
            }, function(le) {
              var oe = Y(le);
              return oe ? (oe.beforeSend = se(oe.beforeSend || function() {
              }), oe) : le;
            });
          }
          var Ds = function(Q) {
            var V, Y = function(se) {
              for (var le, oe = se.textTracks(), te = 0; te < oe.length; te++)
                oe[te].label === "segment-metadata" && (le = oe[te]);
              return le;
            }(Q);
            Y && Y.on && Y.on("cuechange", function() {
              try {
                var se = Q.tech({ IWillNotUseThisInPlugins: !0 }), le = (se.vhs || se.hls).playlists.media().attributes.BANDWIDTH;
                V !== le && Q.mux.emit("renditionchange", { video_source_bitrate: le }), V = le;
              } catch (oe) {
                Q.mux && Q.mux.log && Q.mux.log.warn && Q.mux.log.warn("Cannot retrieve BANDWIDTH information from player: ".concat(oe));
              }
            });
          };
          function _a(Q, V) {
            return function(Y) {
              if (Array.isArray(Y))
                return Y;
            }(Q) || function(Y, se) {
              var le = Y == null ? null : typeof Symbol < "u" && Y[Symbol.iterator] || Y["@@iterator"];
              if (le != null) {
                var oe, te, we = [], Fe = !0, He = !1;
                try {
                  for (le = le.call(Y); !(Fe = (oe = le.next()).done) && (we.push(oe.value), !se || we.length !== se); Fe = !0)
                    ;
                } catch (ct) {
                  He = !0, te = ct;
                } finally {
                  try {
                    Fe || le.return == null || le.return();
                  } finally {
                    if (He)
                      throw te;
                  }
                }
                return we;
              }
            }(Q, V) || function(Y, se) {
              if (!!Y) {
                if (typeof Y == "string")
                  return No(Y, se);
                var le = Object.prototype.toString.call(Y).slice(8, -1);
                if (le === "Object" && Y.constructor && (le = Y.constructor.name), le === "Map" || le === "Set")
                  return Array.from(Y);
                if (le === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(le))
                  return No(Y, se);
              }
            }(Q, V) || function() {
              throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }();
          }
          function No(Q, V) {
            (V == null || V > Q.length) && (V = Q.length);
            for (var Y = 0, se = new Array(V); Y < V; Y++)
              se[Y] = Q[Y];
            return se;
          }
          var gu = /* @__PURE__ */ new Map(), ts, vu = Ae.log, Fo = Ae.utils.assign, Zi = Ae.utils.safeCall, wi = Ae.utils.getComputedStyle, mu = Ae.utils.secondsToMs, rs = ["loadstart", "pause", "play", "playing", "seeking", "seeked", "timeupdate", "ratechange", "stalled", "waiting", "error", "ended"];
          function sp(Q) {
            var V = Q;
            return function(Y) {
              var se, le;
              if (V.IS_IE8)
                return !1;
              var oe = this, te = oe.id(), we = ((se = oe.tech) === null || se === void 0 || (le = se.call(oe, !0)) === null || le === void 0 ? void 0 : le.el()) || oe.tag, Fe = ts && (ts.get(we) || ts.get(oe.el()));
              (Y = Fo({ automaticErrorTracking: !0 }, Y)).data = Fo({ player_software_name: "Video.js", player_software_version: V.VERSION || "< 4.11", player_mux_plugin_name: "videojs-mux", player_mux_plugin_version: "4.19.0", player_init_time: Fe }, Y.data), Y.getPlayheadTime = function() {
                return mu(oe.currentTime());
              }, Y.getStateData = function() {
                var Ue = Zi(oe, "videoHeight"), _t = Zi(oe, "videoWidth");
                if (_t === void 0 || Ue === void 0) {
                  var Lt = oe.el().firstChild;
                  Lt && Lt.nodeName.toUpperCase() === "VIDEO" && (Ue = Lt.videoHeight, _t = Lt.videoWidth);
                }
                return { player_is_paused: Zi(oe, "paused"), player_is_fullscreen: Zi(oe, "isFullscreen"), player_autoplay_on: !!Zi(oe, "autoplay"), player_preload_on: Zi(oe, "preload"), player_width: parseInt(wi(oe.el(), "width"), 10), player_height: parseInt(wi(oe.el(), "height"), 10), player_language_code: Zi(oe, "language"), video_poster_url: Zi(oe, "poster"), video_source_url: Zi(oe, "currentSrc"), video_source_mime_type: Zi(oe, "currentType") && Zi(oe, "currentType").toLowerCase(), video_source_duration: mu(Zi(oe, "duration") || 0), video_source_is_live: oe.duration() === 1 / 0, video_source_height: Ue, video_source_width: _t };
              }, oe.mux = function() {
                vu.error("[videojs-mux] The plugin was initialized more than once.");
              }, oe.mux.emit = function(Ue, _t) {
                Ae.emit(te, Ue, _t);
              }, oe.mux.addHLSJS = function(Ue) {
                Ae.addHLSJS(te, Ue);
              }, oe.mux.log = vu, oe.mux.utils = Ae.utils, Ae.init(te, Y);
              var He = !1, ct = function() {
                He || oe.mux.emit("playerready"), He = !0;
              };
              oe.ready(function() {
                oe.addClass("vjs-mux"), l().setTimeout(ct, 0);
              });
              var ut = !1;
              oe.one("play", ct), rs.forEach(function(Ue) {
                (Ue !== "error" || Y.automaticErrorTracking) && oe.on(Ue, function() {
                  if (!ut) {
                    var _t = {};
                    if (Ue === "error") {
                      var Lt = Zi(oe, "error");
                      if (Lt) {
                        if (Lt.code === 1)
                          return;
                        _t = { player_error_code: Lt.code, player_error_message: Lt.message, player_error_context: Lt.status };
                      }
                    }
                    oe.mux.emit(Ue, _t);
                  }
                });
              });
              var ft = !1;
              oe.on("play", function() {
                ft = !0;
              }), oe.on("pause", function() {
                ft = !1;
              }), oe.on("adstart", function() {
                ut = !0, ft && oe.mux.emit("pause"), oe.mux.emit("adbreakstart");
              }), oe.on("adend", function() {
                oe.mux.emit("adbreakend"), ut = !1, Zi(oe, "paused") || (oe.mux.emit("play"), ft = !0, oe.onceux && oe.mux.emit("playing"));
              }), oe.ima && function(Ue) {
                var _t, Lt, ar, or, tr, Dr, hr = function(pt) {
                  var Gt = typeof (pt = pt || {}).getAdData == "function" ? pt.getAdData() : {}, Yt = typeof pt.getAd == "function" ? pt.getAd() : {}, Ht = typeof Yt.getMediaUrl == "function" ? Yt.getMediaUrl() : Gt.mediaUrl, vr = Gt == null ? void 0 : Gt.adId, Zr = Gt == null ? void 0 : Gt.creativeId, zr = Gt == null ? void 0 : Gt.universalAdIdValue, kr = Ue.ima.settings || {}, Xr = {};
                  return Ht && (Xr.ad_asset_url = Ht), kr.adTagUrl && (Xr.ad_tag_url = kr.adTagUrl), vr && (Xr.ad_id = vr), Zr && (Xr.ad_creative_id = Zr), zr && (Xr.ad_universal_id = zr), Xr;
                };
                try {
                  var $t = window.google.ima.AdEvent.Type;
                  _t = $t.LOADED, Lt = $t.STARTED, ar = $t.COMPLETE, or = $t.PAUSED, tr = $t.RESUMED, Dr = $t.SKIPPED;
                } catch {
                  _t = "loaded", Lt = "start", ar = "complete", or = "pause", tr = "resume", Dr = "skip";
                }
                var ht = 0;
                Ue.mux.triggerAdRequest = function() {
                  ht++, Ue.mux.emit("adrequest", hr());
                }, Ue.on("adsready", function() {
                  var pt = Ue.ima.addEventListener || function() {
                  };
                  pt(_t, function(Gt) {
                    var Yt = hr(Gt);
                    ht > 0 && (ht--, Ue.mux.emit("adresponse", Yt)), Ue.mux.emit("adplay", Yt);
                  }), pt(Lt, function(Gt) {
                    var Yt = hr(Gt);
                    Ue.mux.emit("adplaying", Yt);
                  }), pt(tr, function(Gt) {
                    var Yt = hr(Gt);
                    Ue.mux.emit("adplay", Yt), Ue.mux.emit("adplaying", Yt);
                  }), pt(or, function(Gt) {
                    var Yt = hr(Gt);
                    Ue.mux.emit("adpause", Yt);
                  }), pt(ar, function(Gt) {
                    var Yt = hr(Gt);
                    Ue.mux.emit("adended", Yt);
                  }), pt(Dr, function(Gt) {
                    var Yt = hr(Gt);
                    Ue.mux.emit("adended", Yt);
                  }), Ue.on("adserror", function() {
                    ht > 0 && (ht--, Ue.mux.emit("adresponse")), Ue.mux.emit("aderror");
                  });
                });
              }(oe), oe.onceux && function(Ue) {
                Ve(Ue, Ue, ["onceux-linearad-pause", "onceux-linearad-skipped", "onceux-linearad-complete", "adserror"], ["adstart", "onceux-linearad-resume"]), Ue.on("adstart", function() {
                  Ue.mux.emit("adplay");
                }), Ue.on("onceux-linearad-start", function(_t) {
                  _t.linearAd && _t.linearAd.index > 0 && (Ue.mux.emit("adplay"), Ue.mux.emit("adplaying"));
                }), Ue.on("onceux-linearad-resume", function() {
                  Ue.mux.emit("adplay");
                }), Ue.on("onceux-linearad-pause", function() {
                  Ue.mux.emit("adpause");
                }), Ue.on("onceux-linearad-complete", function() {
                  Ue.mux.emit("adended");
                }), Ue.on("onceux-linearad-skipped", function() {
                  Ue.mux.emit("adended");
                });
              }(oe), oe.ima3 && typeof oe.ima3.ready == "function" && function(Ue) {
                var _t = function() {
                  var or = Ue.ima3.currentAd, tr = Ue.ima3.settings, Dr = {};
                  return or && (Dr.ad_asset_url = or.mediaUrl), tr && (Dr.ad_tag_url = tr.serverUrl), Dr;
                };
                if (st(Ue.ima3.version)) {
                  var Lt = 0, ar = function() {
                    Lt > 0 && (Lt--, Ue.mux.emit("adresponse", _t()));
                  };
                  Ue.on("ads-request", function() {
                    Lt++, Ue.mux.emit("adrequest", _t());
                  }), Ue.on("ads-load", function() {
                    ar(), Ue.mux.emit("adplay", _t());
                  }), Ue.on("adserror", function() {
                    ar(), Ue.mux.emit("aderror");
                  }), Ue.on("ads-play", function() {
                    Ue.mux.emit("adplay", _t());
                  }), Ue.on("ads-pause", function() {
                    Ue.mux.emit("adpause", _t());
                  }), Ue.on("ads-ad-ended", function() {
                    Ue.mux.emit("adended", _t());
                  });
                }
                Ue.ima3.ready(function() {
                  Ue.ima3.adPlayer ? (st(Ue.ima3.version) || (Ue.ima3.adPlayer.on("play", function() {
                    Ue.mux.emit("adplay");
                  }), Ue.ima3.adPlayer.on("pause", function() {
                    Ue.mux.emit("adpause");
                  }), Ue.ima3.adPlayer.on("ended", function() {
                    Ue.mux.emit("adended");
                  })), Ve(Ue, Ue.ima3.adPlayer, ["pause", "ended", "adserror"], ["play"], _t)) : (Ue.mux.log("Legacy IMA3 plugin found, ad events may not track correctly."), Ue.on("ads-ad-started", function() {
                    Ue.mux.emit("adplaying", _t());
                  }), Ue.on("ads-play", function() {
                    Ue.mux.emit("adplaying", _t());
                  }));
                });
              }(oe), oe.FreeWheelPlugin && oe.FreeWheelPlugin.VERSION && function(Ue) {
                var _t = function(Lt) {
                  var ar = Ue.FreeWheelPlugin, or = {};
                  switch (Lt) {
                    case "adplay":
                    case "adplaying":
                    case "adpause":
                      or.ad_asset_url = Ue.currentSrc();
                  }
                  return ar && (or.ad_tag_url = ar.tech.toLowerCase() === "html5" ? ar.settings.Html5.serverUrl : ar.settings.Flash.serverUrl), or;
                };
                Ue.on("ads-request", function() {
                  Ue.mux.emit("adrequest", _t("adrequest"));
                }), Ue.on("ads-load", function() {
                  Ue.mux.emit("adresponse", _t("adresponse"));
                }), Ue.on("adserror", function() {
                  Ue.mux.emit("aderror");
                }), Ue.on("ads-ad-started", function() {
                  Ue.mux.emit("adplay", _t("adplay")), Ue.mux.emit("adplaying", _t("adplaying"));
                }), Ue.on("ads-play", function() {
                  Ue.mux.emit("adplay", _t("adplay")), Ue.mux.emit("adplaying", _t("adplaying"));
                }), Ue.on("ads-pause", function() {
                  Ue.mux.emit("adpause", _t("adpause"));
                }), Ue.on("ads-ad-ended", function() {
                  Ue.mux.emit("adended", _t("adended"));
                }), Ue.on("adend", function() {
                  Ue.mux.emit("play");
                });
              }(oe), oe.on("dispose", function() {
                oe.mux.emit("destroy"), ts.delete(oe);
              });
            };
          }
          function xc(Q) {
            (Q.registerPlugin || Q.plugin || function() {
              Ae.log.error("No valid method to register videojs plugin available.");
            })("mux", sp(Q)), function(V) {
              if (!gu.get(V) && (gu.set(V, "video.js ".concat(V.VERSION, " initialized")), typeof V.getTech == "function"))
                for (var Y = (V.getTech("Html5") || {}).sourceHandlers, se = V.Vhs || V.Hls, le = function(te) {
                  var we = Y[te], Fe = we.handleSource;
                  we.handleSource = function(He, ct) {
                    var ut = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                    se && se.xhr && qn(function() {
                      return V(ct.el());
                    }, se.xhr);
                    var ft = Fe(He, ct, ut);
                    if (ft && typeof ft.xhr == "function")
                      try {
                        var Ue = _a(V.VERSION.split("."), 2), _t = Ue[0], Lt = Ue[1];
                        _t = parseInt(_t), Lt = parseInt(Lt);
                        var ar = _t >= 7 && Lt >= 4 ? ft.player().id() : ft.player_.el_.parentNode.id;
                        Ds(V(ar));
                      } catch {
                      }
                    return ft;
                  };
                }, oe = 0; oe < Y.length; oe++)
                  le(oe);
            }(Q);
          }
          ts = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : /* @__PURE__ */ new Map(), h().hook && h().hook("beforesetup", function(Q, V) {
            return ts.set(Q, Ae.utils.now()), V;
          }), xc(h());
        }(), s;
      }();
    });
  })();
})(AF);
var ho = {
  DEBUG: !1,
  LIB_VERSION: "2.52.0"
}, Or;
if (typeof window > "u") {
  var cb = {
    hostname: ""
  };
  Or = {
    navigator: { userAgent: "" },
    document: {
      location: cb,
      referrer: ""
    },
    screen: { width: 0, height: 0 },
    location: cb
  };
} else
  Or = window;
var wF = 24 * 60 * 60 * 1e3, tp = Array.prototype, CF = Function.prototype, Ix = Object.prototype, zo = tp.slice, Fd = Ix.toString, rp = Ix.hasOwnProperty, zi = Or.console, Xo = Or.navigator, vi = Or.document, mf = Or.opera, lh = Or.screen, Os = Xo.userAgent, ng = CF.bind, db = tp.forEach, fb = tp.indexOf, hb = tp.map, DF = Array.isArray, sv = {}, ae = {
  trim: function(e) {
    return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
  }
}, si = {
  log: function() {
    if (ho.DEBUG && !ae.isUndefined(zi) && zi)
      try {
        zi.log.apply(zi, arguments);
      } catch {
        ae.each(arguments, function(r) {
          zi.log(r);
        });
      }
  },
  warn: function() {
    if (ho.DEBUG && !ae.isUndefined(zi) && zi) {
      var e = ["Mixpanel warning:"].concat(ae.toArray(arguments));
      try {
        zi.warn.apply(zi, e);
      } catch {
        ae.each(e, function(i) {
          zi.warn(i);
        });
      }
    }
  },
  error: function() {
    if (ho.DEBUG && !ae.isUndefined(zi) && zi) {
      var e = ["Mixpanel error:"].concat(ae.toArray(arguments));
      try {
        zi.error.apply(zi, e);
      } catch {
        ae.each(e, function(i) {
          zi.error(i);
        });
      }
    }
  },
  critical: function() {
    if (!ae.isUndefined(zi) && zi) {
      var e = ["Mixpanel error:"].concat(ae.toArray(arguments));
      try {
        zi.error.apply(zi, e);
      } catch {
        ae.each(e, function(i) {
          zi.error(i);
        });
      }
    }
  }
}, ag = function(e, r) {
  return function() {
    return arguments[0] = "[" + r + "] " + arguments[0], e.apply(si, arguments);
  };
}, Jm = function(e) {
  return {
    log: ag(si.log, e),
    error: ag(si.error, e),
    critical: ag(si.critical, e)
  };
};
ae.bind = function(e, r) {
  var i, t;
  if (ng && e.bind === ng)
    return ng.apply(e, zo.call(arguments, 1));
  if (!ae.isFunction(e))
    throw new TypeError();
  return i = zo.call(arguments, 2), t = function() {
    if (!(this instanceof t))
      return e.apply(r, i.concat(zo.call(arguments)));
    var n = {};
    n.prototype = e.prototype;
    var a = new n();
    n.prototype = null;
    var s = e.apply(a, i.concat(zo.call(arguments)));
    return Object(s) === s ? s : a;
  }, t;
};
ae.each = function(e, r, i) {
  if (e != null) {
    if (db && e.forEach === db)
      e.forEach(r, i);
    else if (e.length === +e.length) {
      for (var t = 0, n = e.length; t < n; t++)
        if (t in e && r.call(i, e[t], t, e) === sv)
          return;
    } else
      for (var a in e)
        if (rp.call(e, a) && r.call(i, e[a], a, e) === sv)
          return;
  }
};
ae.extend = function(e) {
  return ae.each(zo.call(arguments, 1), function(r) {
    for (var i in r)
      r[i] !== void 0 && (e[i] = r[i]);
  }), e;
};
ae.isArray = DF || function(e) {
  return Fd.call(e) === "[object Array]";
};
ae.isFunction = function(e) {
  try {
    return /^\s*\bfunction\b/.test(e);
  } catch {
    return !1;
  }
};
ae.isArguments = function(e) {
  return !!(e && rp.call(e, "callee"));
};
ae.toArray = function(e) {
  return e ? e.toArray ? e.toArray() : ae.isArray(e) || ae.isArguments(e) ? zo.call(e) : ae.values(e) : [];
};
ae.map = function(e, r, i) {
  if (hb && e.map === hb)
    return e.map(r, i);
  var t = [];
  return ae.each(e, function(n) {
    t.push(r.call(i, n));
  }), t;
};
ae.keys = function(e) {
  var r = [];
  return e === null || ae.each(e, function(i, t) {
    r[r.length] = t;
  }), r;
};
ae.values = function(e) {
  var r = [];
  return e === null || ae.each(e, function(i) {
    r[r.length] = i;
  }), r;
};
ae.include = function(e, r) {
  var i = !1;
  return e === null ? i : fb && e.indexOf === fb ? e.indexOf(r) != -1 : (ae.each(e, function(t) {
    if (i || (i = t === r))
      return sv;
  }), i);
};
ae.includes = function(e, r) {
  return e.indexOf(r) !== -1;
};
ae.inherit = function(e, r) {
  return e.prototype = new r(), e.prototype.constructor = e, e.superclass = r.prototype, e;
};
ae.isObject = function(e) {
  return e === Object(e) && !ae.isArray(e);
};
ae.isEmptyObject = function(e) {
  if (ae.isObject(e)) {
    for (var r in e)
      if (rp.call(e, r))
        return !1;
    return !0;
  }
  return !1;
};
ae.isUndefined = function(e) {
  return e === void 0;
};
ae.isString = function(e) {
  return Fd.call(e) == "[object String]";
};
ae.isDate = function(e) {
  return Fd.call(e) == "[object Date]";
};
ae.isNumber = function(e) {
  return Fd.call(e) == "[object Number]";
};
ae.isElement = function(e) {
  return !!(e && e.nodeType === 1);
};
ae.encodeDates = function(e) {
  return ae.each(e, function(r, i) {
    ae.isDate(r) ? e[i] = ae.formatDate(r) : ae.isObject(r) && (e[i] = ae.encodeDates(r));
  }), e;
};
ae.timestamp = function() {
  return Date.now = Date.now || function() {
    return +new Date();
  }, Date.now();
};
ae.formatDate = function(e) {
  function r(i) {
    return i < 10 ? "0" + i : i;
  }
  return e.getUTCFullYear() + "-" + r(e.getUTCMonth() + 1) + "-" + r(e.getUTCDate()) + "T" + r(e.getUTCHours()) + ":" + r(e.getUTCMinutes()) + ":" + r(e.getUTCSeconds());
};
ae.strip_empty_properties = function(e) {
  var r = {};
  return ae.each(e, function(i, t) {
    ae.isString(i) && i.length > 0 && (r[t] = i);
  }), r;
};
ae.truncate = function(e, r) {
  var i;
  return typeof e == "string" ? i = e.slice(0, r) : ae.isArray(e) ? (i = [], ae.each(e, function(t) {
    i.push(ae.truncate(t, r));
  })) : ae.isObject(e) ? (i = {}, ae.each(e, function(t, n) {
    i[n] = ae.truncate(t, r);
  })) : i = e, i;
};
ae.JSONEncode = function() {
  return function(e) {
    var r = e, i = function(n) {
      var a = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, s = {
        "\b": "\\b",
        "	": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
      };
      return a.lastIndex = 0, a.test(n) ? '"' + n.replace(a, function(o) {
        var l = s[o];
        return typeof l == "string" ? l : "\\u" + ("0000" + o.charCodeAt(0).toString(16)).slice(-4);
      }) + '"' : '"' + n + '"';
    }, t = function(n, a) {
      var s = "", o = "    ", l = 0, u = "", h = "", c = 0, d = s, f = [], m = a[n];
      switch (m && typeof m == "object" && typeof m.toJSON == "function" && (m = m.toJSON(n)), typeof m) {
        case "string":
          return i(m);
        case "number":
          return isFinite(m) ? String(m) : "null";
        case "boolean":
        case "null":
          return String(m);
        case "object":
          if (!m)
            return "null";
          if (s += o, f = [], Fd.apply(m) === "[object Array]") {
            for (c = m.length, l = 0; l < c; l += 1)
              f[l] = t(l, m) || "null";
            return h = f.length === 0 ? "[]" : s ? `[
` + s + f.join(`,
` + s) + `
` + d + "]" : "[" + f.join(",") + "]", s = d, h;
          }
          for (u in m)
            rp.call(m, u) && (h = t(u, m), h && f.push(i(u) + (s ? ": " : ":") + h));
          return h = f.length === 0 ? "{}" : s ? "{" + f.join(",") + d + "}" : "{" + f.join(",") + "}", s = d, h;
      }
    };
    return t("", {
      "": r
    });
  };
}();
ae.JSONDecode = function() {
  var e, r, i = {
    '"': '"',
    "\\": "\\",
    "/": "/",
    b: "\b",
    f: "\f",
    n: `
`,
    r: "\r",
    t: "	"
  }, t, n = function(f) {
    var m = new SyntaxError(f);
    throw m.at = e, m.text = t, m;
  }, a = function(f) {
    return f && f !== r && n("Expected '" + f + "' instead of '" + r + "'"), r = t.charAt(e), e += 1, r;
  }, s = function() {
    var f, m = "";
    for (r === "-" && (m = "-", a("-")); r >= "0" && r <= "9"; )
      m += r, a();
    if (r === ".")
      for (m += "."; a() && r >= "0" && r <= "9"; )
        m += r;
    if (r === "e" || r === "E")
      for (m += r, a(), (r === "-" || r === "+") && (m += r, a()); r >= "0" && r <= "9"; )
        m += r, a();
    if (f = +m, !isFinite(f))
      n("Bad number");
    else
      return f;
  }, o = function() {
    var f, m, p = "", b;
    if (r === '"')
      for (; a(); ) {
        if (r === '"')
          return a(), p;
        if (r === "\\")
          if (a(), r === "u") {
            for (b = 0, m = 0; m < 4 && (f = parseInt(a(), 16), !!isFinite(f)); m += 1)
              b = b * 16 + f;
            p += String.fromCharCode(b);
          } else if (typeof i[r] == "string")
            p += i[r];
          else
            break;
        else
          p += r;
      }
    n("Bad string");
  }, l = function() {
    for (; r && r <= " "; )
      a();
  }, u = function() {
    switch (r) {
      case "t":
        return a("t"), a("r"), a("u"), a("e"), !0;
      case "f":
        return a("f"), a("a"), a("l"), a("s"), a("e"), !1;
      case "n":
        return a("n"), a("u"), a("l"), a("l"), null;
    }
    n('Unexpected "' + r + '"');
  }, h, c = function() {
    var f = [];
    if (r === "[") {
      if (a("["), l(), r === "]")
        return a("]"), f;
      for (; r; ) {
        if (f.push(h()), l(), r === "]")
          return a("]"), f;
        a(","), l();
      }
    }
    n("Bad array");
  }, d = function() {
    var f, m = {};
    if (r === "{") {
      if (a("{"), l(), r === "}")
        return a("}"), m;
      for (; r; ) {
        if (f = o(), l(), a(":"), Object.hasOwnProperty.call(m, f) && n('Duplicate key "' + f + '"'), m[f] = h(), l(), r === "}")
          return a("}"), m;
        a(","), l();
      }
    }
    n("Bad object");
  };
  return h = function() {
    switch (l(), r) {
      case "{":
        return d();
      case "[":
        return c();
      case '"':
        return o();
      case "-":
        return s();
      default:
        return r >= "0" && r <= "9" ? s() : u();
    }
  }, function(f) {
    var m;
    return t = f, e = 0, r = " ", m = h(), l(), r && n("Syntax error"), m;
  };
}();
ae.base64Encode = function(e) {
  var r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", i, t, n, a, s, o, l, u, h = 0, c = 0, d = "", f = [];
  if (!e)
    return e;
  e = ae.utf8Encode(e);
  do
    i = e.charCodeAt(h++), t = e.charCodeAt(h++), n = e.charCodeAt(h++), u = i << 16 | t << 8 | n, a = u >> 18 & 63, s = u >> 12 & 63, o = u >> 6 & 63, l = u & 63, f[c++] = r.charAt(a) + r.charAt(s) + r.charAt(o) + r.charAt(l);
  while (h < e.length);
  switch (d = f.join(""), e.length % 3) {
    case 1:
      d = d.slice(0, -2) + "==";
      break;
    case 2:
      d = d.slice(0, -1) + "=";
      break;
  }
  return d;
};
ae.utf8Encode = function(e) {
  e = (e + "").replace(/\r\n/g, `
`).replace(/\r/g, `
`);
  var r = "", i, t, n = 0, a;
  for (i = t = 0, n = e.length, a = 0; a < n; a++) {
    var s = e.charCodeAt(a), o = null;
    s < 128 ? t++ : s > 127 && s < 2048 ? o = String.fromCharCode(s >> 6 | 192, s & 63 | 128) : o = String.fromCharCode(s >> 12 | 224, s >> 6 & 63 | 128, s & 63 | 128), o !== null && (t > i && (r += e.substring(i, t)), r += o, i = t = a + 1);
  }
  return t > i && (r += e.substring(i, e.length)), r;
};
ae.UUID = function() {
  var e = function() {
    var t = 1 * new Date(), n;
    if (Or.performance && Or.performance.now)
      n = Or.performance.now();
    else
      for (n = 0; t == 1 * new Date(); )
        n++;
    return t.toString(16) + Math.floor(n).toString(16);
  }, r = function() {
    return Math.random().toString(16).replace(".", "");
  }, i = function() {
    var t = Os, n, a, s = [], o = 0;
    function l(u, h) {
      var c, d = 0;
      for (c = 0; c < h.length; c++)
        d |= s[c] << c * 8;
      return u ^ d;
    }
    for (n = 0; n < t.length; n++)
      a = t.charCodeAt(n), s.unshift(a & 255), s.length >= 4 && (o = l(o, s), s = []);
    return s.length > 0 && (o = l(o, s)), o.toString(16);
  };
  return function() {
    var t = (lh.height * lh.width).toString(16);
    return e() + "-" + r() + "-" + i() + "-" + t + "-" + e();
  };
}();
var pb = [
  "ahrefsbot",
  "ahrefssiteaudit",
  "baiduspider",
  "bingbot",
  "bingpreview",
  "chrome-lighthouse",
  "facebookexternal",
  "petalbot",
  "pinterest",
  "screaming frog",
  "yahoo! slurp",
  "yandexbot",
  "adsbot-google",
  "apis-google",
  "duplexweb-google",
  "feedfetcher-google",
  "google favicon",
  "google web preview",
  "google-read-aloud",
  "googlebot",
  "googleweblight",
  "mediapartners-google",
  "storebot-google"
];
ae.isBlockedUA = function(e) {
  var r;
  for (e = e.toLowerCase(), r = 0; r < pb.length; r++)
    if (e.indexOf(pb[r]) !== -1)
      return !0;
  return !1;
};
ae.HTTPBuildQuery = function(e, r) {
  var i, t, n = [];
  return ae.isUndefined(r) && (r = "&"), ae.each(e, function(a, s) {
    i = encodeURIComponent(a.toString()), t = encodeURIComponent(s), n[n.length] = t + "=" + i;
  }), n.join(r);
};
ae.getQueryParam = function(e, r) {
  r = r.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  var i = "[\\?&]" + r + "=([^&#]*)", t = new RegExp(i), n = t.exec(e);
  if (n === null || n && typeof n[1] != "string" && n[1].length)
    return "";
  var a = n[1];
  try {
    a = decodeURIComponent(a);
  } catch {
    si.error("Skipping decoding for malformed query param: " + a);
  }
  return a.replace(/\+/g, " ");
};
ae.cookie = {
  get: function(e) {
    for (var r = e + "=", i = vi.cookie.split(";"), t = 0; t < i.length; t++) {
      for (var n = i[t]; n.charAt(0) == " "; )
        n = n.substring(1, n.length);
      if (n.indexOf(r) === 0)
        return decodeURIComponent(n.substring(r.length, n.length));
    }
    return null;
  },
  parse: function(e) {
    var r;
    try {
      r = ae.JSONDecode(ae.cookie.get(e)) || {};
    } catch {
    }
    return r;
  },
  set_seconds: function(e, r, i, t, n, a, s) {
    var o = "", l = "", u = "";
    if (s)
      o = "; domain=" + s;
    else if (t) {
      var h = gb(vi.location.hostname);
      o = h ? "; domain=." + h : "";
    }
    if (i) {
      var c = new Date();
      c.setTime(c.getTime() + i * 1e3), l = "; expires=" + c.toGMTString();
    }
    a && (n = !0, u = "; SameSite=None"), n && (u += "; secure"), vi.cookie = e + "=" + encodeURIComponent(r) + l + "; path=/" + o + u;
  },
  set: function(e, r, i, t, n, a, s) {
    var o = "", l = "", u = "";
    if (s)
      o = "; domain=" + s;
    else if (t) {
      var h = gb(vi.location.hostname);
      o = h ? "; domain=." + h : "";
    }
    if (i) {
      var c = new Date();
      c.setTime(c.getTime() + i * 24 * 60 * 60 * 1e3), l = "; expires=" + c.toGMTString();
    }
    a && (n = !0, u = "; SameSite=None"), n && (u += "; secure");
    var d = e + "=" + encodeURIComponent(r) + l + "; path=/" + o + u;
    return vi.cookie = d, d;
  },
  remove: function(e, r, i) {
    ae.cookie.set(e, "", -1, r, !1, !1, i);
  }
};
var sg = null, ch = function(e, r) {
  if (sg !== null && !r)
    return sg;
  var i = !0;
  try {
    e = e || window.localStorage;
    var t = "__mplss_" + Qm(8), n = "xyz";
    e.setItem(t, n), e.getItem(t) !== n && (i = !1), e.removeItem(t);
  } catch {
    i = !1;
  }
  return sg = i, i;
};
ae.localStorage = {
  is_supported: function(e) {
    var r = ch(null, e);
    return r || si.error("localStorage unsupported; falling back to cookie store"), r;
  },
  error: function(e) {
    si.error("localStorage error: " + e);
  },
  get: function(e) {
    try {
      return window.localStorage.getItem(e);
    } catch (r) {
      ae.localStorage.error(r);
    }
    return null;
  },
  parse: function(e) {
    try {
      return ae.JSONDecode(ae.localStorage.get(e)) || {};
    } catch {
    }
    return null;
  },
  set: function(e, r) {
    try {
      window.localStorage.setItem(e, r);
    } catch (i) {
      ae.localStorage.error(i);
    }
  },
  remove: function(e) {
    try {
      window.localStorage.removeItem(e);
    } catch (r) {
      ae.localStorage.error(r);
    }
  }
};
ae.register_event = function() {
  var e = function(t, n, a, s, o) {
    if (!t) {
      si.error("No valid element provided to register_event");
      return;
    }
    if (t.addEventListener && !s)
      t.addEventListener(n, a, !!o);
    else {
      var l = "on" + n, u = t[l];
      t[l] = r(t, a, u);
    }
  };
  function r(t, n, a) {
    var s = function(o) {
      if (o = o || i(window.event), !!o) {
        var l = !0, u, h;
        return ae.isFunction(a) && (u = a(o)), h = n.call(t, o), (u === !1 || h === !1) && (l = !1), l;
      }
    };
    return s;
  }
  function i(t) {
    return t && (t.preventDefault = i.preventDefault, t.stopPropagation = i.stopPropagation), t;
  }
  return i.preventDefault = function() {
    this.returnValue = !1;
  }, i.stopPropagation = function() {
    this.cancelBubble = !0;
  }, e;
}();
var kF = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
ae.dom_query = function() {
  function e(n) {
    return n.all ? n.all : n.getElementsByTagName("*");
  }
  var r = /[\t\r\n]/g;
  function i(n, a) {
    var s = " " + a + " ";
    return (" " + n.className + " ").replace(r, " ").indexOf(s) >= 0;
  }
  function t(n) {
    if (!vi.getElementsByTagName)
      return [];
    var a = n.split(" "), s, o, l, u, h, c, d, f, m, p, b = [vi];
    for (c = 0; c < a.length; c++) {
      if (s = a[c].replace(/^\s+/, "").replace(/\s+$/, ""), s.indexOf("#") > -1) {
        o = s.split("#"), l = o[0];
        var y = o[1], v = vi.getElementById(y);
        if (!v || l && v.nodeName.toLowerCase() != l)
          return [];
        b = [v];
        continue;
      }
      if (s.indexOf(".") > -1) {
        o = s.split("."), l = o[0];
        var g = o[1];
        for (l || (l = "*"), u = [], h = 0, d = 0; d < b.length; d++)
          for (l == "*" ? m = e(b[d]) : m = b[d].getElementsByTagName(l), f = 0; f < m.length; f++)
            u[h++] = m[f];
        for (b = [], p = 0, d = 0; d < u.length; d++)
          u[d].className && ae.isString(u[d].className) && i(u[d], g) && (b[p++] = u[d]);
        continue;
      }
      var E = s.match(kF);
      if (E) {
        l = E[1];
        var x = E[2], w = E[3], S = E[4];
        for (l || (l = "*"), u = [], h = 0, d = 0; d < b.length; d++)
          for (l == "*" ? m = e(b[d]) : m = b[d].getElementsByTagName(l), f = 0; f < m.length; f++)
            u[h++] = m[f];
        b = [], p = 0;
        var T;
        switch (w) {
          case "=":
            T = function(C) {
              return C.getAttribute(x) == S;
            };
            break;
          case "~":
            T = function(C) {
              return C.getAttribute(x).match(new RegExp("\\b" + S + "\\b"));
            };
            break;
          case "|":
            T = function(C) {
              return C.getAttribute(x).match(new RegExp("^" + S + "-?"));
            };
            break;
          case "^":
            T = function(C) {
              return C.getAttribute(x).indexOf(S) === 0;
            };
            break;
          case "$":
            T = function(C) {
              return C.getAttribute(x).lastIndexOf(S) == C.getAttribute(x).length - S.length;
            };
            break;
          case "*":
            T = function(C) {
              return C.getAttribute(x).indexOf(S) > -1;
            };
            break;
          default:
            T = function(C) {
              return C.getAttribute(x);
            };
        }
        for (b = [], p = 0, d = 0; d < u.length; d++)
          T(u[d]) && (b[p++] = u[d]);
        continue;
      }
      for (l = s, u = [], h = 0, d = 0; d < b.length; d++)
        for (m = b[d].getElementsByTagName(l), f = 0; f < m.length; f++)
          u[h++] = m[f];
      b = u;
    }
    return b;
  }
  return function(n) {
    return ae.isElement(n) ? [n] : ae.isObject(n) && !ae.isUndefined(n.length) ? n : t.call(this, n);
  };
}();
var RF = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"], PF = ["dclid", "fbclid", "gclid", "ko_click_id", "li_fat_id", "msclkid", "ttclid", "twclid", "wbraid"];
ae.info = {
  campaignParams: function(e) {
    var r = "", i = {};
    return ae.each(RF, function(t) {
      r = ae.getQueryParam(vi.URL, t), r.length ? i[t] = r : e !== void 0 && (i[t] = e);
    }), i;
  },
  clickParams: function() {
    var e = "", r = {};
    return ae.each(PF, function(i) {
      e = ae.getQueryParam(vi.URL, i), e.length && (r[i] = e);
    }), r;
  },
  marketingParams: function() {
    return ae.extend(ae.info.campaignParams(), ae.info.clickParams());
  },
  searchEngine: function(e) {
    return e.search("https?://(.*)google.([^/?]*)") === 0 ? "google" : e.search("https?://(.*)bing.com") === 0 ? "bing" : e.search("https?://(.*)yahoo.com") === 0 ? "yahoo" : e.search("https?://(.*)duckduckgo.com") === 0 ? "duckduckgo" : null;
  },
  searchInfo: function(e) {
    var r = ae.info.searchEngine(e), i = r != "yahoo" ? "q" : "p", t = {};
    if (r !== null) {
      t.$search_engine = r;
      var n = ae.getQueryParam(e, i);
      n.length && (t.mp_keyword = n);
    }
    return t;
  },
  browser: function(e, r, i) {
    return r = r || "", i || ae.includes(e, " OPR/") ? ae.includes(e, "Mini") ? "Opera Mini" : "Opera" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : ae.includes(e, "IEMobile") || ae.includes(e, "WPDesktop") ? "Internet Explorer Mobile" : ae.includes(e, "SamsungBrowser/") ? "Samsung Internet" : ae.includes(e, "Edge") || ae.includes(e, "Edg/") ? "Microsoft Edge" : ae.includes(e, "FBIOS") ? "Facebook Mobile" : ae.includes(e, "Chrome") ? "Chrome" : ae.includes(e, "CriOS") ? "Chrome iOS" : ae.includes(e, "UCWEB") || ae.includes(e, "UCBrowser") ? "UC Browser" : ae.includes(e, "FxiOS") ? "Firefox iOS" : ae.includes(r, "Apple") ? ae.includes(e, "Mobile") ? "Mobile Safari" : "Safari" : ae.includes(e, "Android") ? "Android Mobile" : ae.includes(e, "Konqueror") ? "Konqueror" : ae.includes(e, "Firefox") ? "Firefox" : ae.includes(e, "MSIE") || ae.includes(e, "Trident/") ? "Internet Explorer" : ae.includes(e, "Gecko") ? "Mozilla" : "";
  },
  browserVersion: function(e, r, i) {
    var t = ae.info.browser(e, r, i), n = {
      "Internet Explorer Mobile": /rv:(\d+(\.\d+)?)/,
      "Microsoft Edge": /Edge?\/(\d+(\.\d+)?)/,
      Chrome: /Chrome\/(\d+(\.\d+)?)/,
      "Chrome iOS": /CriOS\/(\d+(\.\d+)?)/,
      "UC Browser": /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
      Safari: /Version\/(\d+(\.\d+)?)/,
      "Mobile Safari": /Version\/(\d+(\.\d+)?)/,
      Opera: /(Opera|OPR)\/(\d+(\.\d+)?)/,
      Firefox: /Firefox\/(\d+(\.\d+)?)/,
      "Firefox iOS": /FxiOS\/(\d+(\.\d+)?)/,
      Konqueror: /Konqueror:(\d+(\.\d+)?)/,
      BlackBerry: /BlackBerry (\d+(\.\d+)?)/,
      "Android Mobile": /android\s(\d+(\.\d+)?)/,
      "Samsung Internet": /SamsungBrowser\/(\d+(\.\d+)?)/,
      "Internet Explorer": /(rv:|MSIE )(\d+(\.\d+)?)/,
      Mozilla: /rv:(\d+(\.\d+)?)/
    }, a = n[t];
    if (a === void 0)
      return null;
    var s = e.match(a);
    return s ? parseFloat(s[s.length - 2]) : null;
  },
  os: function() {
    var e = Os;
    return /Windows/i.test(e) ? /Phone/.test(e) || /WPDesktop/.test(e) ? "Windows Phone" : "Windows" : /(iPhone|iPad|iPod)/.test(e) ? "iOS" : /Android/.test(e) ? "Android" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : /Mac/i.test(e) ? "Mac OS X" : /Linux/.test(e) ? "Linux" : /CrOS/.test(e) ? "Chrome OS" : "";
  },
  device: function(e) {
    return /Windows Phone/i.test(e) || /WPDesktop/.test(e) ? "Windows Phone" : /iPad/.test(e) ? "iPad" : /iPod/.test(e) ? "iPod Touch" : /iPhone/.test(e) ? "iPhone" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : /Android/.test(e) ? "Android" : "";
  },
  referringDomain: function(e) {
    var r = e.split("/");
    return r.length >= 3 ? r[2] : "";
  },
  currentUrl: function() {
    return Or.location.href;
  },
  properties: function(e) {
    return typeof e != "object" && (e = {}), ae.extend(ae.strip_empty_properties({
      $os: ae.info.os(),
      $browser: ae.info.browser(Os, Xo.vendor, mf),
      $referrer: vi.referrer,
      $referring_domain: ae.info.referringDomain(vi.referrer),
      $device: ae.info.device(Os)
    }), {
      $current_url: ae.info.currentUrl(),
      $browser_version: ae.info.browserVersion(Os, Xo.vendor, mf),
      $screen_height: lh.height,
      $screen_width: lh.width,
      mp_lib: "web",
      $lib_version: ho.LIB_VERSION,
      $insert_id: Qm(),
      time: ae.timestamp() / 1e3
    }, ae.strip_empty_properties(e));
  },
  people_properties: function() {
    return ae.extend(ae.strip_empty_properties({
      $os: ae.info.os(),
      $browser: ae.info.browser(Os, Xo.vendor, mf)
    }), {
      $browser_version: ae.info.browserVersion(Os, Xo.vendor, mf)
    });
  },
  mpPageViewProperties: function() {
    return ae.strip_empty_properties({
      current_page_title: vi.title,
      current_domain: Or.location.hostname,
      current_url_path: Or.location.pathname,
      current_url_protocol: Or.location.protocol,
      current_url_search: Or.location.search
    });
  }
};
var Qm = function(e) {
  var r = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
  return e ? r.substring(0, e) : r;
}, OF = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i, LF = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i, gb = function(e) {
  var r = LF, i = e.split("."), t = i[i.length - 1];
  (t.length > 4 || t === "com" || t === "org") && (r = OF);
  var n = e.match(r);
  return n ? n[0] : "";
}, dh = null, fh = null;
typeof JSON < "u" && (dh = JSON.stringify, fh = JSON.parse);
dh = dh || ae.JSONEncode;
fh = fh || ae.JSONDecode;
ae.toArray = ae.toArray;
ae.isObject = ae.isObject;
ae.JSONEncode = ae.JSONEncode;
ae.JSONDecode = ae.JSONDecode;
ae.isBlockedUA = ae.isBlockedUA;
ae.isEmptyObject = ae.isEmptyObject;
ae.info = ae.info;
ae.info.device = ae.info.device;
ae.info.browser = ae.info.browser;
ae.info.browserVersion = ae.info.browserVersion;
ae.info.properties = ae.info.properties;
var Co = function() {
};
Co.prototype.create_properties = function() {
};
Co.prototype.event_handler = function() {
};
Co.prototype.after_track_handler = function() {
};
Co.prototype.init = function(e) {
  return this.mp = e, this;
};
Co.prototype.track = function(e, r, i, t) {
  var n = this, a = ae.dom_query(e);
  if (a.length === 0) {
    si.error("The DOM query (" + e + ") returned 0 elements");
    return;
  }
  return ae.each(a, function(s) {
    ae.register_event(s, this.override_event, function(o) {
      var l = {}, u = n.create_properties(i, this), h = n.mp.get_config("track_links_timeout");
      n.event_handler(o, this, l), window.setTimeout(n.track_callback(t, u, l, !0), h), n.mp.track(r, u, n.track_callback(t, u, l));
    });
  }, this), !0;
};
Co.prototype.track_callback = function(e, r, i, t) {
  t = t || !1;
  var n = this;
  return function() {
    i.callback_fired || (i.callback_fired = !0, !(e && e(t, r) === !1) && n.after_track_handler(r, i, t));
  };
};
Co.prototype.create_properties = function(e, r) {
  var i;
  return typeof e == "function" ? i = e(r) : i = ae.extend({}, e), i;
};
var Zl = function() {
  this.override_event = "click";
};
ae.inherit(Zl, Co);
Zl.prototype.create_properties = function(e, r) {
  var i = Zl.superclass.create_properties.apply(this, arguments);
  return r.href && (i.url = r.href), i;
};
Zl.prototype.event_handler = function(e, r, i) {
  i.new_tab = e.which === 2 || e.metaKey || e.ctrlKey || r.target === "_blank", i.href = r.href, i.new_tab || e.preventDefault();
};
Zl.prototype.after_track_handler = function(e, r) {
  r.new_tab || setTimeout(function() {
    window.location = r.href;
  }, 0);
};
var ip = function() {
  this.override_event = "submit";
};
ae.inherit(ip, Co);
ip.prototype.event_handler = function(e, r, i) {
  i.element = r, e.preventDefault();
};
ip.prototype.after_track_handler = function(e, r) {
  setTimeout(function() {
    r.element.submit();
  }, 0);
};
var IF = Jm("lock"), Mx = function(e, r) {
  r = r || {}, this.storageKey = e, this.storage = r.storage || window.localStorage, this.pollIntervalMS = r.pollIntervalMS || 100, this.timeoutMS = r.timeoutMS || 2e3;
};
Mx.prototype.withLock = function(e, r, i) {
  !i && typeof r != "function" && (i = r, r = null);
  var t = i || new Date().getTime() + "|" + Math.random(), n = new Date().getTime(), a = this.storageKey, s = this.pollIntervalMS, o = this.timeoutMS, l = this.storage, u = a + ":X", h = a + ":Y", c = a + ":Z", d = function(v) {
    r && r(v);
  }, f = function(v) {
    if (new Date().getTime() - n > o) {
      IF.error("Timeout waiting for mutex on " + a + "; clearing lock. [" + t + "]"), l.removeItem(c), l.removeItem(h), b();
      return;
    }
    setTimeout(function() {
      try {
        v();
      } catch (g) {
        d(g);
      }
    }, s * (Math.random() + 0.1));
  }, m = function(v, g) {
    v() ? g() : f(function() {
      m(v, g);
    });
  }, p = function() {
    var v = l.getItem(h);
    if (v && v !== t)
      return !1;
    if (l.setItem(h, t), l.getItem(h) === t)
      return !0;
    if (!ch(l, !0))
      throw new Error("localStorage support dropped while acquiring lock");
    return !1;
  }, b = function() {
    l.setItem(u, t), m(p, function() {
      if (l.getItem(u) === t) {
        y();
        return;
      }
      f(function() {
        if (l.getItem(h) !== t) {
          b();
          return;
        }
        m(function() {
          return !l.getItem(c);
        }, y);
      });
    });
  }, y = function() {
    l.setItem(c, "1");
    try {
      e();
    } finally {
      l.removeItem(c), l.getItem(h) === t && l.removeItem(h), l.getItem(u) === t && l.removeItem(u);
    }
  };
  try {
    if (ch(l, !0))
      b();
    else
      throw new Error("localStorage support check failed");
  } catch (v) {
    d(v);
  }
};
var vb = Jm("batch"), cu = function(e, r) {
  r = r || {}, this.storageKey = e, this.storage = r.storage || window.localStorage, this.reportError = r.errorReporter || ae.bind(vb.error, vb), this.lock = new Mx(e, { storage: this.storage }), this.pid = r.pid || null, this.memQueue = [];
};
cu.prototype.enqueue = function(e, r, i) {
  var t = {
    id: Qm(),
    flushAfter: new Date().getTime() + r * 2,
    payload: e
  };
  this.lock.withLock(ae.bind(function() {
    var a;
    try {
      var s = this.readFromStorage();
      s.push(t), a = this.saveToStorage(s), a && this.memQueue.push(t);
    } catch {
      this.reportError("Error enqueueing item", e), a = !1;
    }
    i && i(a);
  }, this), ae.bind(function(a) {
    this.reportError("Error acquiring storage lock", a), i && i(!1);
  }, this), this.pid);
};
cu.prototype.fillBatch = function(e) {
  var r = this.memQueue.slice(0, e);
  if (r.length < e) {
    var i = this.readFromStorage();
    if (i.length) {
      var t = {};
      ae.each(r, function(s) {
        t[s.id] = !0;
      });
      for (var n = 0; n < i.length; n++) {
        var a = i[n];
        if (new Date().getTime() > a.flushAfter && !t[a.id] && (a.orphaned = !0, r.push(a), r.length >= e))
          break;
      }
    }
  }
  return r;
};
var mb = function(e, r) {
  var i = [];
  return ae.each(e, function(t) {
    t.id && !r[t.id] && i.push(t);
  }), i;
};
cu.prototype.removeItemsByID = function(e, r) {
  var i = {};
  ae.each(e, function(n) {
    i[n] = !0;
  }), this.memQueue = mb(this.memQueue, i);
  var t = ae.bind(function() {
    var n;
    try {
      var a = this.readFromStorage();
      if (a = mb(a, i), n = this.saveToStorage(a), n) {
        a = this.readFromStorage();
        for (var s = 0; s < a.length; s++) {
          var o = a[s];
          if (o.id && !!i[o.id])
            return this.reportError("Item not removed from storage"), !1;
        }
      }
    } catch {
      this.reportError("Error removing items", e), n = !1;
    }
    return n;
  }, this);
  this.lock.withLock(function() {
    var a = t();
    r && r(a);
  }, ae.bind(function(a) {
    var s = !1;
    if (this.reportError("Error acquiring storage lock", a), !ch(this.storage, !0) && (s = t(), !s))
      try {
        this.storage.removeItem(this.storageKey);
      } catch (o) {
        this.reportError("Error clearing queue", o);
      }
    r && r(s);
  }, this), this.pid);
};
var yb = function(e, r) {
  var i = [];
  return ae.each(e, function(t) {
    var n = t.id;
    if (n in r) {
      var a = r[n];
      a !== null && (t.payload = a, i.push(t));
    } else
      i.push(t);
  }), i;
};
cu.prototype.updatePayloads = function(e, r) {
  this.memQueue = yb(this.memQueue, e), this.lock.withLock(ae.bind(function() {
    var t;
    try {
      var n = this.readFromStorage();
      n = yb(n, e), t = this.saveToStorage(n);
    } catch {
      this.reportError("Error updating items", e), t = !1;
    }
    r && r(t);
  }, this), ae.bind(function(t) {
    this.reportError("Error acquiring storage lock", t), r && r(!1);
  }, this), this.pid);
};
cu.prototype.readFromStorage = function() {
  var e;
  try {
    e = this.storage.getItem(this.storageKey), e && (e = fh(e), ae.isArray(e) || (this.reportError("Invalid storage entry:", e), e = null));
  } catch (r) {
    this.reportError("Error retrieving queue", r), e = null;
  }
  return e || [];
};
cu.prototype.saveToStorage = function(e) {
  try {
    return this.storage.setItem(this.storageKey, dh(e)), !0;
  } catch (r) {
    return this.reportError("Error saving queue", r), !1;
  }
};
cu.prototype.clear = function() {
  this.memQueue = [], this.storage.removeItem(this.storageKey);
};
var MF = 10 * 60 * 1e3, Zc = Jm("batch"), qs = function(e, r) {
  this.errorReporter = r.errorReporter, this.queue = new cu(e, {
    errorReporter: ae.bind(this.reportError, this),
    storage: r.storage
  }), this.libConfig = r.libConfig, this.sendRequest = r.sendRequestFunc, this.beforeSendHook = r.beforeSendHook, this.stopAllBatching = r.stopAllBatchingFunc, this.batchSize = this.libConfig.batch_size, this.flushInterval = this.libConfig.batch_flush_interval_ms, this.stopped = !this.libConfig.batch_autostart, this.consecutiveRemovalFailures = 0, this.itemIdsSentSuccessfully = {};
};
qs.prototype.enqueue = function(e, r) {
  this.queue.enqueue(e, this.flushInterval, r);
};
qs.prototype.start = function() {
  this.stopped = !1, this.consecutiveRemovalFailures = 0, this.flush();
};
qs.prototype.stop = function() {
  this.stopped = !0, this.timeoutID && (clearTimeout(this.timeoutID), this.timeoutID = null);
};
qs.prototype.clear = function() {
  this.queue.clear();
};
qs.prototype.resetBatchSize = function() {
  this.batchSize = this.libConfig.batch_size;
};
qs.prototype.resetFlush = function() {
  this.scheduleFlush(this.libConfig.batch_flush_interval_ms);
};
qs.prototype.scheduleFlush = function(e) {
  this.flushInterval = e, this.stopped || (this.timeoutID = setTimeout(ae.bind(this.flush, this), this.flushInterval));
};
qs.prototype.flush = function(e) {
  try {
    if (this.requestInProgress) {
      Zc.log("Flush: Request already in progress");
      return;
    }
    e = e || {};
    var r = this.libConfig.batch_request_timeout_ms, i = new Date().getTime(), t = this.batchSize, n = this.queue.fillBatch(t), a = [], s = {};
    if (ae.each(n, function(u) {
      var h = u.payload;
      if (this.beforeSendHook && !u.orphaned && (h = this.beforeSendHook(h)), h) {
        h.event && h.properties && (h.properties = ae.extend(
          {},
          h.properties,
          { mp_sent_by_lib_version: ho.LIB_VERSION }
        ));
        var c = !0, d = u.id;
        d ? (this.itemIdsSentSuccessfully[d] || 0) > 5 && (this.reportError("[dupe] item ID sent too many times, not sending", {
          item: u,
          batchSize: n.length,
          timesSent: this.itemIdsSentSuccessfully[d]
        }), c = !1) : this.reportError("[dupe] found item with no ID", { item: u }), c && a.push(h);
      }
      s[u.id] = h;
    }, this), a.length < 1) {
      this.resetFlush();
      return;
    }
    this.requestInProgress = !0;
    var o = ae.bind(function(u) {
      this.requestInProgress = !1;
      try {
        var h = !1;
        if (e.unloading)
          this.queue.updatePayloads(s);
        else if (ae.isObject(u) && u.error === "timeout" && new Date().getTime() - i >= r)
          this.reportError("Network timeout; retrying"), this.flush();
        else if (ae.isObject(u) && u.xhr_req && (u.xhr_req.status >= 500 || u.xhr_req.status === 429 || u.error === "timeout")) {
          var c = this.flushInterval * 2, d = u.xhr_req.responseHeaders;
          if (d) {
            var f = d["Retry-After"];
            f && (c = parseInt(f, 10) * 1e3 || c);
          }
          c = Math.min(MF, c), this.reportError("Error; retry in " + c + " ms"), this.scheduleFlush(c);
        } else if (ae.isObject(u) && u.xhr_req && u.xhr_req.status === 413)
          if (n.length > 1) {
            var m = Math.max(1, Math.floor(t / 2));
            this.batchSize = Math.min(this.batchSize, m, n.length - 1), this.reportError("413 response; reducing batch size to " + this.batchSize), this.resetFlush();
          } else
            this.reportError("Single-event request too large; dropping", n), this.resetBatchSize(), h = !0;
        else
          h = !0;
        h && (this.queue.removeItemsByID(
          ae.map(n, function(p) {
            return p.id;
          }),
          ae.bind(function(p) {
            p ? (this.consecutiveRemovalFailures = 0, this.flush()) : (this.reportError("Failed to remove items from queue"), ++this.consecutiveRemovalFailures > 5 ? (this.reportError("Too many queue failures; disabling batching system."), this.stopAllBatching()) : this.resetFlush());
          }, this)
        ), ae.each(n, ae.bind(function(p) {
          var b = p.id;
          b ? (this.itemIdsSentSuccessfully[b] = this.itemIdsSentSuccessfully[b] || 0, this.itemIdsSentSuccessfully[b]++, this.itemIdsSentSuccessfully[b] > 5 && this.reportError("[dupe] item ID sent too many times", {
            item: p,
            batchSize: n.length,
            timesSent: this.itemIdsSentSuccessfully[b]
          })) : this.reportError("[dupe] found item with no ID while removing", { item: p });
        }, this)));
      } catch (p) {
        this.reportError("Error handling API response", p), this.resetFlush();
      }
    }, this), l = {
      method: "POST",
      verbose: !0,
      ignore_json_errors: !0,
      timeout_ms: r
    };
    e.unloading && (l.transport = "sendBeacon"), Zc.log("MIXPANEL REQUEST:", a), this.sendRequest(a, l, o);
  } catch (u) {
    this.reportError("Error flushing request queue", u), this.resetFlush();
  }
};
qs.prototype.reportError = function(e, r) {
  if (Zc.error.apply(Zc.error, arguments), this.errorReporter)
    try {
      r instanceof Error || (r = new Error(e)), this.errorReporter(e, r);
    } catch (i) {
      Zc.error(i);
    }
};
var NF = "__mp_opt_in_out_";
function FF(e, r) {
  Ux(!0, e, r);
}
function UF(e, r) {
  Ux(!1, e, r);
}
function BF(e, r) {
  return Fx(e, r) === "1";
}
function Nx(e, r) {
  if ($F(r))
    return si.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"'), !0;
  var i = Fx(e, r) === "0";
  return i && si.warn("You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data."), i;
}
function al(e) {
  return t0(e, function(r) {
    return this.get_config(r);
  });
}
function du(e) {
  return t0(e, function(r) {
    return this._get_config(r);
  });
}
function vc(e) {
  return t0(e, function(r) {
    return this._get_config(r);
  });
}
function jF(e, r) {
  r = r || {}, Zm(r).remove(
    e0(e, r),
    !!r.crossSubdomainCookie,
    r.cookieDomain
  );
}
function Zm(e) {
  return e = e || {}, e.persistenceType === "localStorage" ? ae.localStorage : ae.cookie;
}
function e0(e, r) {
  return r = r || {}, (r.persistencePrefix || NF) + e;
}
function Fx(e, r) {
  return Zm(r).get(e0(e, r));
}
function $F(e) {
  if (e && e.ignoreDnt)
    return !1;
  var r = e && e.window || Or, i = r.navigator || {}, t = !1;
  return ae.each([
    i.doNotTrack,
    i.msDoNotTrack,
    r.doNotTrack
  ], function(n) {
    ae.includes([!0, 1, "1", "yes"], n) && (t = !0);
  }), t;
}
function Ux(e, r, i) {
  if (!ae.isString(r) || !r.length) {
    si.error("gdpr." + (e ? "optIn" : "optOut") + " called with an invalid token");
    return;
  }
  i = i || {}, Zm(i).set(
    e0(r, i),
    e ? 1 : 0,
    ae.isNumber(i.cookieExpiration) ? i.cookieExpiration : null,
    !!i.crossSubdomainCookie,
    !!i.secureCookie,
    !!i.crossSiteCookie,
    i.cookieDomain
  ), i.track && e && i.track(i.trackEventName || "$opt_in", i.trackProperties, {
    send_immediately: !0
  });
}
function t0(e, r) {
  return function() {
    var i = !1;
    try {
      var t = r.call(this, "token"), n = r.call(this, "ignore_dnt"), a = r.call(this, "opt_out_tracking_persistence_type"), s = r.call(this, "opt_out_tracking_cookie_prefix"), o = r.call(this, "window");
      t && (i = Nx(t, {
        ignoreDnt: n,
        persistenceType: a,
        persistencePrefix: s,
        window: o
      }));
    } catch (u) {
      si.error("Unexpected error when checking tracking opt-out status: " + u);
    }
    if (!i)
      return e.apply(this, arguments);
    var l = arguments[arguments.length - 1];
    typeof l == "function" && l(0);
  };
}
var nu = "$set", ec = "$set_once", os = "$unset", el = "$add", Us = "$append", tl = "$union", po = "$remove", GF = "$delete", Bx = {
  set_action: function(e, r) {
    var i = {}, t = {};
    return ae.isObject(e) ? ae.each(e, function(n, a) {
      this._is_reserved_property(a) || (t[a] = n);
    }, this) : t[e] = r, i[nu] = t, i;
  },
  unset_action: function(e) {
    var r = {}, i = [];
    return ae.isArray(e) || (e = [e]), ae.each(e, function(t) {
      this._is_reserved_property(t) || i.push(t);
    }, this), r[os] = i, r;
  },
  set_once_action: function(e, r) {
    var i = {}, t = {};
    return ae.isObject(e) ? ae.each(e, function(n, a) {
      this._is_reserved_property(a) || (t[a] = n);
    }, this) : t[e] = r, i[ec] = t, i;
  },
  union_action: function(e, r) {
    var i = {}, t = {};
    return ae.isObject(e) ? ae.each(e, function(n, a) {
      this._is_reserved_property(a) || (t[a] = ae.isArray(n) ? n : [n]);
    }, this) : t[e] = ae.isArray(r) ? r : [r], i[tl] = t, i;
  },
  append_action: function(e, r) {
    var i = {}, t = {};
    return ae.isObject(e) ? ae.each(e, function(n, a) {
      this._is_reserved_property(a) || (t[a] = n);
    }, this) : t[e] = r, i[Us] = t, i;
  },
  remove_action: function(e, r) {
    var i = {}, t = {};
    return ae.isObject(e) ? ae.each(e, function(n, a) {
      this._is_reserved_property(a) || (t[a] = n);
    }, this) : t[e] = r, i[po] = t, i;
  },
  delete_action: function() {
    var e = {};
    return e[GF] = "", e;
  }
}, Ri = function() {
};
ae.extend(Ri.prototype, Bx);
Ri.prototype._init = function(e, r, i) {
  this._mixpanel = e, this._group_key = r, this._group_id = i;
};
Ri.prototype.set = vc(function(e, r, i) {
  var t = this.set_action(e, r);
  return ae.isObject(e) && (i = r), this._send_request(t, i);
});
Ri.prototype.set_once = vc(function(e, r, i) {
  var t = this.set_once_action(e, r);
  return ae.isObject(e) && (i = r), this._send_request(t, i);
});
Ri.prototype.unset = vc(function(e, r) {
  var i = this.unset_action(e);
  return this._send_request(i, r);
});
Ri.prototype.union = vc(function(e, r, i) {
  ae.isObject(e) && (i = r);
  var t = this.union_action(e, r);
  return this._send_request(t, i);
});
Ri.prototype.delete = vc(function(e) {
  var r = this.delete_action();
  return this._send_request(r, e);
});
Ri.prototype.remove = vc(function(e, r, i) {
  var t = this.remove_action(e, r);
  return this._send_request(t, i);
});
Ri.prototype._send_request = function(e, r) {
  e.$group_key = this._group_key, e.$group_id = this._group_id, e.$token = this._get_config("token");
  var i = ae.encodeDates(e);
  return this._mixpanel._track_or_batch({
    type: "groups",
    data: i,
    endpoint: this._get_config("api_host") + "/" + this._get_config("api_routes").groups,
    batcher: this._mixpanel.request_batchers.groups
  }, r);
};
Ri.prototype._is_reserved_property = function(e) {
  return e === "$group_key" || e === "$group_id";
};
Ri.prototype._get_config = function(e) {
  return this._mixpanel.get_config(e);
};
Ri.prototype.toString = function() {
  return this._mixpanel.toString() + ".group." + this._group_key + "." + this._group_id;
};
Ri.prototype.remove = Ri.prototype.remove;
Ri.prototype.set = Ri.prototype.set;
Ri.prototype.set_once = Ri.prototype.set_once;
Ri.prototype.union = Ri.prototype.union;
Ri.prototype.unset = Ri.prototype.unset;
Ri.prototype.toString = Ri.prototype.toString;
var Er = function() {
};
ae.extend(Er.prototype, Bx);
Er.prototype._init = function(e) {
  this._mixpanel = e;
};
Er.prototype.set = du(function(e, r, i) {
  var t = this.set_action(e, r);
  return ae.isObject(e) && (i = r), this._get_config("save_referrer") && this._mixpanel.persistence.update_referrer_info(document.referrer), t[nu] = ae.extend(
    {},
    ae.info.people_properties(),
    t[nu]
  ), this._send_request(t, i);
});
Er.prototype.set_once = du(function(e, r, i) {
  var t = this.set_once_action(e, r);
  return ae.isObject(e) && (i = r), this._send_request(t, i);
});
Er.prototype.unset = du(function(e, r) {
  var i = this.unset_action(e);
  return this._send_request(i, r);
});
Er.prototype.increment = du(function(e, r, i) {
  var t = {}, n = {};
  return ae.isObject(e) ? (ae.each(e, function(a, s) {
    if (!this._is_reserved_property(s))
      if (isNaN(parseFloat(a))) {
        si.error("Invalid increment value passed to mixpanel.people.increment - must be a number");
        return;
      } else
        n[s] = a;
  }, this), i = r) : (ae.isUndefined(r) && (r = 1), n[e] = r), t[el] = n, this._send_request(t, i);
});
Er.prototype.append = du(function(e, r, i) {
  ae.isObject(e) && (i = r);
  var t = this.append_action(e, r);
  return this._send_request(t, i);
});
Er.prototype.remove = du(function(e, r, i) {
  ae.isObject(e) && (i = r);
  var t = this.remove_action(e, r);
  return this._send_request(t, i);
});
Er.prototype.union = du(function(e, r, i) {
  ae.isObject(e) && (i = r);
  var t = this.union_action(e, r);
  return this._send_request(t, i);
});
Er.prototype.track_charge = du(function(e, r, i) {
  if (!ae.isNumber(e) && (e = parseFloat(e), isNaN(e))) {
    si.error("Invalid value passed to mixpanel.people.track_charge - must be a number");
    return;
  }
  return this.append("$transactions", ae.extend({
    $amount: e
  }, r), i);
});
Er.prototype.clear_charges = function(e) {
  return this.set("$transactions", [], e);
};
Er.prototype.delete_user = function() {
  if (!this._identify_called()) {
    si.error("mixpanel.people.delete_user() requires you to call identify() first");
    return;
  }
  var e = { $delete: this._mixpanel.get_distinct_id() };
  return this._send_request(e);
};
Er.prototype.toString = function() {
  return this._mixpanel.toString() + ".people";
};
Er.prototype._send_request = function(e, r) {
  e.$token = this._get_config("token"), e.$distinct_id = this._mixpanel.get_distinct_id();
  var i = this._mixpanel.get_property("$device_id"), t = this._mixpanel.get_property("$user_id"), n = this._mixpanel.get_property("$had_persisted_distinct_id");
  i && (e.$device_id = i), t && (e.$user_id = t), n && (e.$had_persisted_distinct_id = n);
  var a = ae.encodeDates(e);
  return this._identify_called() ? this._mixpanel._track_or_batch({
    type: "people",
    data: a,
    endpoint: this._get_config("api_host") + "/" + this._get_config("api_routes").engage,
    batcher: this._mixpanel.request_batchers.people
  }, r) : (this._enqueue(e), ae.isUndefined(r) || (this._get_config("verbose") ? r({ status: -1, error: null }) : r(-1)), ae.truncate(a, 255));
};
Er.prototype._get_config = function(e) {
  return this._mixpanel.get_config(e);
};
Er.prototype._identify_called = function() {
  return this._mixpanel._flags.identify_called === !0;
};
Er.prototype._enqueue = function(e) {
  nu in e ? this._mixpanel.persistence._add_to_people_queue(nu, e) : ec in e ? this._mixpanel.persistence._add_to_people_queue(ec, e) : os in e ? this._mixpanel.persistence._add_to_people_queue(os, e) : el in e ? this._mixpanel.persistence._add_to_people_queue(el, e) : Us in e ? this._mixpanel.persistence._add_to_people_queue(Us, e) : po in e ? this._mixpanel.persistence._add_to_people_queue(po, e) : tl in e ? this._mixpanel.persistence._add_to_people_queue(tl, e) : si.error("Invalid call to _enqueue():", e);
};
Er.prototype._flush_one_queue = function(e, r, i, t) {
  var n = this, a = ae.extend({}, this._mixpanel.persistence.load_queue(e)), s = a;
  !ae.isUndefined(a) && ae.isObject(a) && !ae.isEmptyObject(a) && (n._mixpanel.persistence._pop_from_people_queue(e, a), n._mixpanel.persistence.save(), t && (s = t(a)), r.call(n, s, function(o, l) {
    o === 0 && n._mixpanel.persistence._add_to_people_queue(e, a), ae.isUndefined(i) || i(o, l);
  }));
};
Er.prototype._flush = function(e, r, i, t, n, a, s) {
  var o = this;
  this._flush_one_queue(nu, this.set, e), this._flush_one_queue(ec, this.set_once, t), this._flush_one_queue(os, this.unset, a, function(b) {
    return ae.keys(b);
  }), this._flush_one_queue(el, this.increment, r), this._flush_one_queue(tl, this.union, n);
  var l = this._mixpanel.persistence.load_queue(Us);
  if (!ae.isUndefined(l) && ae.isArray(l) && l.length)
    for (var u, h = function(b, y) {
      b === 0 && o._mixpanel.persistence._add_to_people_queue(Us, u), ae.isUndefined(i) || i(b, y);
    }, c = l.length - 1; c >= 0; c--)
      l = this._mixpanel.persistence.load_queue(Us), u = l.pop(), o._mixpanel.persistence.save(), ae.isEmptyObject(u) || o.append(u, h);
  var d = this._mixpanel.persistence.load_queue(po);
  if (!ae.isUndefined(d) && ae.isArray(d) && d.length)
    for (var f, m = function(b, y) {
      b === 0 && o._mixpanel.persistence._add_to_people_queue(po, f), ae.isUndefined(s) || s(b, y);
    }, p = d.length - 1; p >= 0; p--)
      d = this._mixpanel.persistence.load_queue(po), f = d.pop(), o._mixpanel.persistence.save(), ae.isEmptyObject(f) || o.remove(f, m);
};
Er.prototype._is_reserved_property = function(e) {
  return e === "$distinct_id" || e === "$token" || e === "$device_id" || e === "$user_id" || e === "$had_persisted_distinct_id";
};
Er.prototype.set = Er.prototype.set;
Er.prototype.set_once = Er.prototype.set_once;
Er.prototype.unset = Er.prototype.unset;
Er.prototype.increment = Er.prototype.increment;
Er.prototype.append = Er.prototype.append;
Er.prototype.remove = Er.prototype.remove;
Er.prototype.union = Er.prototype.union;
Er.prototype.track_charge = Er.prototype.track_charge;
Er.prototype.clear_charges = Er.prototype.clear_charges;
Er.prototype.delete_user = Er.prototype.delete_user;
Er.prototype.toString = Er.prototype.toString;
var r0 = "__mps", i0 = "__mpso", n0 = "__mpus", a0 = "__mpa", s0 = "__mpap", o0 = "__mpr", u0 = "__mpu", jx = "$people_distinct_id", hh = "__alias", md = "__timers", HF = [
  r0,
  i0,
  n0,
  a0,
  s0,
  o0,
  u0,
  jx,
  hh,
  md
], Nr = function(e) {
  this.props = {}, this.campaign_params_saved = !1, e.persistence_name ? this.name = "mp_" + e.persistence_name : this.name = "mp_" + e.token + "_mixpanel";
  var r = e.persistence;
  r !== "cookie" && r !== "localStorage" && (si.critical("Unknown persistence type " + r + "; falling back to cookie"), r = e.persistence = "cookie"), r === "localStorage" && ae.localStorage.is_supported() ? this.storage = ae.localStorage : this.storage = ae.cookie, this.load(), this.update_config(e), this.upgrade(), this.save();
};
Nr.prototype.properties = function() {
  var e = {};
  return this.load(), ae.each(this.props, function(r, i) {
    ae.include(HF, i) || (e[i] = r);
  }), e;
};
Nr.prototype.load = function() {
  if (!this.disabled) {
    var e = this.storage.parse(this.name);
    e && (this.props = ae.extend({}, e));
  }
};
Nr.prototype.upgrade = function() {
  var e, r;
  this.storage === ae.localStorage ? (e = ae.cookie.parse(this.name), ae.cookie.remove(this.name), ae.cookie.remove(this.name, !0), e && this.register_once(e)) : this.storage === ae.cookie && (r = ae.localStorage.parse(this.name), ae.localStorage.remove(this.name), r && this.register_once(r));
};
Nr.prototype.save = function() {
  this.disabled || this.storage.set(
    this.name,
    ae.JSONEncode(this.props),
    this.expire_days,
    this.cross_subdomain,
    this.secure,
    this.cross_site,
    this.cookie_domain
  );
};
Nr.prototype.load_prop = function(e) {
  return this.load(), this.props[e];
};
Nr.prototype.remove = function() {
  this.storage.remove(this.name, !1, this.cookie_domain), this.storage.remove(this.name, !0, this.cookie_domain);
};
Nr.prototype.clear = function() {
  this.remove(), this.props = {};
};
Nr.prototype.register_once = function(e, r, i) {
  return ae.isObject(e) ? (typeof r > "u" && (r = "None"), this.expire_days = typeof i > "u" ? this.default_expiry : i, this.load(), ae.each(e, function(t, n) {
    (!this.props.hasOwnProperty(n) || this.props[n] === r) && (this.props[n] = t);
  }, this), this.save(), !0) : !1;
};
Nr.prototype.register = function(e, r) {
  return ae.isObject(e) ? (this.expire_days = typeof r > "u" ? this.default_expiry : r, this.load(), ae.extend(this.props, e), this.save(), !0) : !1;
};
Nr.prototype.unregister = function(e) {
  this.load(), e in this.props && (delete this.props[e], this.save());
};
Nr.prototype.update_search_keyword = function(e) {
  this.register(ae.info.searchInfo(e));
};
Nr.prototype.update_referrer_info = function(e) {
  this.register_once({
    $initial_referrer: e || "$direct",
    $initial_referring_domain: ae.info.referringDomain(e) || "$direct"
  }, "");
};
Nr.prototype.get_referrer_info = function() {
  return ae.strip_empty_properties({
    $initial_referrer: this.props.$initial_referrer,
    $initial_referring_domain: this.props.$initial_referring_domain
  });
};
Nr.prototype.update_config = function(e) {
  this.default_expiry = this.expire_days = e.cookie_expiration, this.set_disabled(e.disable_persistence), this.set_cookie_domain(e.cookie_domain), this.set_cross_site(e.cross_site_cookie), this.set_cross_subdomain(e.cross_subdomain_cookie), this.set_secure(e.secure_cookie);
};
Nr.prototype.set_disabled = function(e) {
  this.disabled = e, this.disabled ? this.remove() : this.save();
};
Nr.prototype.set_cookie_domain = function(e) {
  e !== this.cookie_domain && (this.remove(), this.cookie_domain = e, this.save());
};
Nr.prototype.set_cross_site = function(e) {
  e !== this.cross_site && (this.cross_site = e, this.remove(), this.save());
};
Nr.prototype.set_cross_subdomain = function(e) {
  e !== this.cross_subdomain && (this.cross_subdomain = e, this.remove(), this.save());
};
Nr.prototype.get_cross_subdomain = function() {
  return this.cross_subdomain;
};
Nr.prototype.set_secure = function(e) {
  e !== this.secure && (this.secure = !!e, this.remove(), this.save());
};
Nr.prototype._add_to_people_queue = function(e, r) {
  var i = this._get_queue_key(e), t = r[e], n = this._get_or_create_queue(nu), a = this._get_or_create_queue(ec), s = this._get_or_create_queue(os), o = this._get_or_create_queue(el), l = this._get_or_create_queue(tl), u = this._get_or_create_queue(po, []), h = this._get_or_create_queue(Us, []);
  i === r0 ? (ae.extend(n, t), this._pop_from_people_queue(el, t), this._pop_from_people_queue(tl, t), this._pop_from_people_queue(os, t)) : i === i0 ? (ae.each(t, function(c, d) {
    d in a || (a[d] = c);
  }), this._pop_from_people_queue(os, t)) : i === n0 ? ae.each(t, function(c) {
    ae.each([n, a, o, l], function(d) {
      c in d && delete d[c];
    }), ae.each(h, function(d) {
      c in d && delete d[c];
    }), s[c] = !0;
  }) : i === a0 ? (ae.each(t, function(c, d) {
    d in n ? n[d] += c : (d in o || (o[d] = 0), o[d] += c);
  }, this), this._pop_from_people_queue(os, t)) : i === u0 ? (ae.each(t, function(c, d) {
    ae.isArray(c) && (d in l || (l[d] = []), l[d] = l[d].concat(c));
  }), this._pop_from_people_queue(os, t)) : i === o0 ? (u.push(t), this._pop_from_people_queue(Us, t)) : i === s0 && (h.push(t), this._pop_from_people_queue(os, t)), si.log("MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):"), si.log(r), this.save();
};
Nr.prototype._pop_from_people_queue = function(e, r) {
  var i = this.props[this._get_queue_key(e)];
  ae.isUndefined(i) || ae.each(r, function(t, n) {
    e === Us || e === po ? ae.each(i, function(a) {
      a[n] === t && delete a[n];
    }) : delete i[n];
  }, this);
};
Nr.prototype.load_queue = function(e) {
  return this.load_prop(this._get_queue_key(e));
};
Nr.prototype._get_queue_key = function(e) {
  if (e === nu)
    return r0;
  if (e === ec)
    return i0;
  if (e === os)
    return n0;
  if (e === el)
    return a0;
  if (e === Us)
    return s0;
  if (e === po)
    return o0;
  if (e === tl)
    return u0;
  si.error("Invalid queue:", e);
};
Nr.prototype._get_or_create_queue = function(e, r) {
  var i = this._get_queue_key(e);
  return r = ae.isUndefined(r) ? {} : r, this.props[i] || (this.props[i] = r);
};
Nr.prototype.set_event_timer = function(e, r) {
  var i = this.load_prop(md) || {};
  i[e] = r, this.props[md] = i, this.save();
};
Nr.prototype.remove_event_timer = function(e) {
  var r = this.load_prop(md) || {}, i = r[e];
  return ae.isUndefined(i) || (delete this.props[md][e], this.save()), i;
};
var l0, Nn, $x = 0, VF = 1, qF = function(e) {
  return e;
}, yd = function() {
}, Va = "mixpanel", Gx = "base64", WF = "json", c0 = "$device:", Vl = Or.XMLHttpRequest && "withCredentials" in new XMLHttpRequest(), Hx = !Vl && Os.indexOf("MSIE") === -1 && Os.indexOf("Mozilla") === -1, ph = null;
Xo.sendBeacon && (ph = function() {
  return Xo.sendBeacon.apply(Xo, arguments);
});
var Vx = {
  track: "track/",
  engage: "engage/",
  groups: "groups/",
  record: "record/"
}, _b = {
  api_host: "https://api-js.mixpanel.com",
  api_routes: Vx,
  api_method: "POST",
  api_transport: "XHR",
  api_payload_format: Gx,
  app_host: "https://mixpanel.com",
  cdn: "https://cdn.mxpnl.com",
  cross_site_cookie: !1,
  cross_subdomain_cookie: !0,
  error_reporter: yd,
  persistence: "cookie",
  persistence_name: "",
  cookie_domain: "",
  cookie_name: "",
  loaded: yd,
  mp_loader: null,
  track_marketing: !0,
  track_pageview: !1,
  skip_first_touch_marketing: !1,
  store_google: !0,
  stop_utm_persistence: !1,
  save_referrer: !0,
  test: !1,
  verbose: !1,
  img: !1,
  debug: !1,
  track_links_timeout: 300,
  cookie_expiration: 365,
  upgrade: !1,
  disable_persistence: !1,
  disable_cookie: !1,
  secure_cookie: !1,
  ip: !0,
  opt_out_tracking_by_default: !1,
  opt_out_persistence_by_default: !1,
  opt_out_tracking_persistence_type: "localStorage",
  opt_out_tracking_cookie_prefix: null,
  property_blacklist: [],
  xhr_headers: {},
  ignore_dnt: !1,
  batch_requests: !0,
  batch_size: 50,
  batch_flush_interval_ms: 5e3,
  batch_request_timeout_ms: 9e4,
  batch_autostart: !0,
  hooks: {},
  record_block_class: new RegExp("^(mp-block|fs-exclude|amp-block|rr-block|ph-no-capture)$"),
  record_block_selector: "img, video",
  record_idle_timeout_ms: 30 * 60 * 1e3,
  record_mask_text_class: new RegExp("^(mp-mask|fs-mask|amp-mask|rr-mask|ph-mask)$"),
  record_mask_text_selector: "*",
  record_max_ms: wF,
  record_sessions_percent: 0,
  recorder_src: "https://cdn.mxpnl.com/libs/mixpanel-recorder.min.js"
}, qx = !1, nt = function() {
}, ov = function(e, r, i) {
  var t, n = i === Va ? Nn : Nn[i];
  if (n && l0 === $x)
    t = n;
  else {
    if (n && !ae.isArray(n)) {
      si.error("You have already initialized " + i);
      return;
    }
    t = new nt();
  }
  if (t._cached_groups = {}, t._init(e, r, i), t.people = new Er(), t.people._init(t), !t.get_config("skip_first_touch_marketing")) {
    var a = ae.info.campaignParams(null), s = {}, o = !1;
    ae.each(a, function(l, u) {
      s["initial_" + u] = l, l && (o = !0);
    }), o && t.people.set_once(s);
  }
  return ho.DEBUG = ho.DEBUG || t.get_config("debug"), !ae.isUndefined(n) && ae.isArray(n) && (t._execute_array.call(t.people, n.people), t._execute_array(n)), t;
};
nt.prototype.init = function(e, r, i) {
  if (ae.isUndefined(i)) {
    this.report_error("You must name your new library: init(token, config, name)");
    return;
  }
  if (i === Va) {
    this.report_error("You must initialize the main mixpanel object right after you include the Mixpanel js snippet");
    return;
  }
  var t = ov(e, r, i);
  return Nn[i] = t, t._loaded(), t;
};
nt.prototype._init = function(e, r, i) {
  r = r || {}, this.__loaded = !0, this.config = {};
  var t = {};
  if (!("api_payload_format" in r)) {
    var n = r.api_host || _b.api_host;
    n.match(/\.mixpanel\.com/) && (t.api_payload_format = WF);
  }
  if (this.set_config(ae.extend({}, _b, t, r, {
    name: i,
    token: e,
    callback_fn: (i === Va ? i : Va + "." + i) + "._jsc"
  })), this._jsc = yd, this.__dom_loaded_queue = [], this.__request_queue = [], this.__disabled_events = [], this._flags = {
    disable_all_events: !1,
    identify_called: !1
  }, this.request_batchers = {}, this._batch_requests = this.get_config("batch_requests"), this._batch_requests) {
    if (!ae.localStorage.is_supported(!0) || !Vl)
      this._batch_requests = !1, si.log("Turning off Mixpanel request-queueing; needs XHR and localStorage support"), ae.each(this.get_batcher_configs(), function(l) {
        si.log("Clearing batch queue " + l.queue_key), ae.localStorage.remove(l.queue_key);
      });
    else if (this.init_batchers(), ph && Or.addEventListener) {
      var a = ae.bind(function() {
        this.request_batchers.events.stopped || this.request_batchers.events.flush({ unloading: !0 });
      }, this);
      Or.addEventListener("pagehide", function(l) {
        l.persisted && a();
      }), Or.addEventListener("visibilitychange", function() {
        vi.visibilityState === "hidden" && a();
      });
    }
  }
  this.persistence = this.cookie = new Nr(this.config), this.unpersisted_superprops = {}, this._gdpr_init();
  var s = ae.UUID();
  this.get_distinct_id() || this.register_once({
    distinct_id: c0 + s,
    $device_id: s
  }, "");
  var o = this.get_config("track_pageview");
  o && this._init_url_change_tracking(o), this.get_config("record_sessions_percent") > 0 && Math.random() * 100 <= this.get_config("record_sessions_percent") && this.start_session_recording();
};
nt.prototype.start_session_recording = al(function() {
  if (!Or.MutationObserver) {
    si.critical("Browser does not support MutationObserver; skipping session recording");
    return;
  }
  var e = ae.bind(function() {
    this._recorder = this._recorder || new Or.__mp_recorder(this), this._recorder.startRecording();
  }, this);
  if (ae.isUndefined(Or.__mp_recorder)) {
    var r = vi.createElement("script");
    r.type = "text/javascript", r.async = !0, r.onload = e, r.src = this.get_config("recorder_src"), vi.head.appendChild(r);
  } else
    e();
});
nt.prototype.stop_session_recording = function() {
  this._recorder ? this._recorder.stopRecording() : si.critical("Session recorder module not loaded");
};
nt.prototype.get_session_recording_properties = function() {
  var e = {};
  if (this._recorder) {
    var r = this._recorder.replayId;
    r && (e.$mp_replay_id = r);
  }
  return e;
};
nt.prototype._loaded = function() {
  if (this.get_config("loaded")(this), this._set_default_superprops(), this.people.set_once(this.persistence.get_referrer_info()), this.get_config("store_google") && this.get_config("stop_utm_persistence")) {
    var e = ae.info.campaignParams(null);
    ae.each(e, function(r, i) {
      this.unregister(i);
    }.bind(this));
  }
};
nt.prototype._set_default_superprops = function() {
  this.persistence.update_search_keyword(vi.referrer), this.get_config("store_google") && !this.get_config("stop_utm_persistence") && this.register(ae.info.campaignParams()), this.get_config("save_referrer") && this.persistence.update_referrer_info(vi.referrer);
};
nt.prototype._dom_loaded = function() {
  ae.each(this.__dom_loaded_queue, function(e) {
    this._track_dom.apply(this, e);
  }, this), this.has_opted_out_tracking() || ae.each(this.__request_queue, function(e) {
    this._send_request.apply(this, e);
  }, this), delete this.__dom_loaded_queue, delete this.__request_queue;
};
nt.prototype._track_dom = function(e, r) {
  if (this.get_config("img"))
    return this.report_error("You can't use DOM tracking functions with img = true."), !1;
  if (!qx)
    return this.__dom_loaded_queue.push([e, r]), !1;
  var i = new e().init(this);
  return i.track.apply(i, r);
};
nt.prototype._init_url_change_tracking = function(e) {
  var r = "", i = this.track_pageview();
  if (i && (r = ae.info.currentUrl()), ae.include(["full-url", "url-with-path-and-query-string", "url-with-path"], e)) {
    Or.addEventListener("popstate", function() {
      Or.dispatchEvent(new Event("mp_locationchange"));
    }), Or.addEventListener("hashchange", function() {
      Or.dispatchEvent(new Event("mp_locationchange"));
    });
    var t = Or.history.pushState;
    typeof t == "function" && (Or.history.pushState = function(a, s, o) {
      t.call(Or.history, a, s, o), Or.dispatchEvent(new Event("mp_locationchange"));
    });
    var n = Or.history.replaceState;
    typeof n == "function" && (Or.history.replaceState = function(a, s, o) {
      n.call(Or.history, a, s, o), Or.dispatchEvent(new Event("mp_locationchange"));
    }), Or.addEventListener("mp_locationchange", function() {
      var a = ae.info.currentUrl(), s = !1;
      if (e === "full-url" ? s = a !== r : e === "url-with-path-and-query-string" ? s = a.split("#")[0] !== r.split("#")[0] : e === "url-with-path" && (s = a.split("#")[0].split("?")[0] !== r.split("#")[0].split("?")[0]), s) {
        var o = this.track_pageview();
        o && (r = a);
      }
    }.bind(this));
  }
};
nt.prototype._prepare_callback = function(e, r) {
  if (ae.isUndefined(e))
    return null;
  if (Vl) {
    var i = function(s) {
      e(s, r);
    };
    return i;
  } else {
    var t = this._jsc, n = "" + Math.floor(Math.random() * 1e8), a = this.get_config("callback_fn") + "[" + n + "]";
    return t[n] = function(s) {
      delete t[n], e(s, r);
    }, a;
  }
};
nt.prototype._send_request = function(e, r, i, t) {
  var n = !0;
  if (Hx)
    return this.__request_queue.push(arguments), n;
  var a = {
    method: this.get_config("api_method"),
    transport: this.get_config("api_transport"),
    verbose: this.get_config("verbose")
  }, s = null;
  !t && (ae.isFunction(i) || typeof i == "string") && (t = i, i = null), i = ae.extend(a, i || {}), Vl || (i.method = "GET");
  var o = i.method === "POST", l = ph && o && i.transport.toLowerCase() === "sendbeacon", u = i.verbose;
  r.verbose && (u = !0), this.get_config("test") && (r.test = 1), u && (r.verbose = 1), this.get_config("img") && (r.img = 1), Vl || (t ? r.callback = t : (u || this.get_config("test")) && (r.callback = "(function(){})")), r.ip = this.get_config("ip") ? 1 : 0, r._ = new Date().getTime().toString(), o && (s = "data=" + encodeURIComponent(r.data), delete r.data), e += "?" + ae.HTTPBuildQuery(r);
  var h = this;
  if ("img" in r) {
    var c = vi.createElement("img");
    c.src = e, vi.body.appendChild(c);
  } else if (l) {
    try {
      n = ph(e, s);
    } catch (y) {
      h.report_error(y), n = !1;
    }
    try {
      t && t(n ? 1 : 0);
    } catch (y) {
      h.report_error(y);
    }
  } else if (Vl)
    try {
      var d = new XMLHttpRequest();
      d.open(i.method, e, !0);
      var f = this.get_config("xhr_headers");
      if (o && (f["Content-Type"] = "application/x-www-form-urlencoded"), ae.each(f, function(y, v) {
        d.setRequestHeader(v, y);
      }), i.timeout_ms && typeof d.timeout < "u") {
        d.timeout = i.timeout_ms;
        var m = new Date().getTime();
      }
      d.withCredentials = !0, d.onreadystatechange = function() {
        if (d.readyState === 4)
          if (d.status === 200) {
            if (t)
              if (u) {
                var y;
                try {
                  y = ae.JSONDecode(d.responseText);
                } catch (g) {
                  if (h.report_error(g), i.ignore_json_errors)
                    y = d.responseText;
                  else
                    return;
                }
                t(y);
              } else
                t(Number(d.responseText));
          } else {
            var v;
            d.timeout && !d.status && new Date().getTime() - m >= d.timeout ? v = "timeout" : v = "Bad HTTP status: " + d.status + " " + d.statusText, h.report_error(v), t && t(u ? { status: 0, error: v, xhr_req: d } : 0);
          }
      }, d.send(s);
    } catch (y) {
      h.report_error(y), n = !1;
    }
  else {
    var p = vi.createElement("script");
    p.type = "text/javascript", p.async = !0, p.defer = !0, p.src = e;
    var b = vi.getElementsByTagName("script")[0];
    b.parentNode.insertBefore(p, b);
  }
  return n;
};
nt.prototype._execute_array = function(e) {
  var r, i = [], t = [], n = [];
  ae.each(e, function(s) {
    s && (r = s[0], ae.isArray(r) ? n.push(s) : typeof s == "function" ? s.call(this) : ae.isArray(s) && r === "alias" ? i.push(s) : ae.isArray(s) && r.indexOf("track") !== -1 && typeof this[r] == "function" ? n.push(s) : t.push(s));
  }, this);
  var a = function(s, o) {
    ae.each(s, function(l) {
      if (ae.isArray(l[0])) {
        var u = o;
        ae.each(l, function(h) {
          u = u[h[0]].apply(u, h.slice(1));
        });
      } else
        this[l[0]].apply(this, l.slice(1));
    }, o);
  };
  a(i, this), a(t, this), a(n, this);
};
nt.prototype.are_batchers_initialized = function() {
  return !!this.request_batchers.events;
};
nt.prototype.get_batcher_configs = function() {
  var e = "__mpq_" + this.get_config("token"), r = this.get_config("api_routes");
  return this._batcher_configs = this._batcher_configs || {
    events: { type: "events", endpoint: "/" + r.track, queue_key: e + "_ev" },
    people: { type: "people", endpoint: "/" + r.engage, queue_key: e + "_pp" },
    groups: { type: "groups", endpoint: "/" + r.groups, queue_key: e + "_gr" }
  }, this._batcher_configs;
};
nt.prototype.init_batchers = function() {
  if (!this.are_batchers_initialized()) {
    var e = ae.bind(function(i) {
      return new qs(
        i.queue_key,
        {
          libConfig: this.config,
          sendRequestFunc: ae.bind(function(t, n, a) {
            this._send_request(
              this.get_config("api_host") + i.endpoint,
              this._encode_data_for_request(t),
              n,
              this._prepare_callback(a, t)
            );
          }, this),
          beforeSendHook: ae.bind(function(t) {
            return this._run_hook("before_send_" + i.type, t);
          }, this),
          errorReporter: this.get_config("error_reporter"),
          stopAllBatchingFunc: ae.bind(this.stop_batch_senders, this)
        }
      );
    }, this), r = this.get_batcher_configs();
    this.request_batchers = {
      events: e(r.events),
      people: e(r.people),
      groups: e(r.groups)
    };
  }
  this.get_config("batch_autostart") && this.start_batch_senders();
};
nt.prototype.start_batch_senders = function() {
  this._batchers_were_started = !0, this.are_batchers_initialized() && (this._batch_requests = !0, ae.each(this.request_batchers, function(e) {
    e.start();
  }));
};
nt.prototype.stop_batch_senders = function() {
  this._batch_requests = !1, ae.each(this.request_batchers, function(e) {
    e.stop(), e.clear();
  });
};
nt.prototype.push = function(e) {
  this._execute_array([e]);
};
nt.prototype.disable = function(e) {
  typeof e > "u" ? this._flags.disable_all_events = !0 : this.__disabled_events = this.__disabled_events.concat(e);
};
nt.prototype._encode_data_for_request = function(e) {
  var r = ae.JSONEncode(e);
  return this.get_config("api_payload_format") === Gx && (r = ae.base64Encode(r)), { data: r };
};
nt.prototype._track_or_batch = function(e, r) {
  var i = ae.truncate(e.data, 255), t = e.endpoint, n = e.batcher, a = e.should_send_immediately, s = e.send_request_options || {};
  r = r || yd;
  var o = !0, l = ae.bind(function() {
    return s.skip_hooks || (i = this._run_hook("before_send_" + e.type, i)), i ? (si.log("MIXPANEL REQUEST:"), si.log(i), this._send_request(
      t,
      this._encode_data_for_request(i),
      s,
      this._prepare_callback(r, i)
    )) : null;
  }, this);
  return this._batch_requests && !a ? n.enqueue(i, function(u) {
    u ? r(1, i) : l();
  }) : o = l(), o && i;
};
nt.prototype.track = al(function(e, r, i, t) {
  !t && typeof i == "function" && (t = i, i = null), i = i || {};
  var n = i.transport;
  n && (i.transport = n);
  var a = i.send_immediately;
  if (typeof t != "function" && (t = yd), ae.isUndefined(e)) {
    this.report_error("No event name provided to mixpanel.track");
    return;
  }
  if (this._event_is_disabled(e)) {
    t(0);
    return;
  }
  r = ae.extend({}, r), r.token = this.get_config("token");
  var s = this.persistence.remove_event_timer(e);
  if (!ae.isUndefined(s)) {
    var o = new Date().getTime() - s;
    r.$duration = parseFloat((o / 1e3).toFixed(3));
  }
  this._set_default_superprops();
  var l = this.get_config("track_marketing") ? ae.info.marketingParams() : {};
  r = ae.extend(
    {},
    ae.info.properties({ mp_loader: this.get_config("mp_loader") }),
    l,
    this.persistence.properties(),
    this.unpersisted_superprops,
    this.get_session_recording_properties(),
    r
  );
  var u = this.get_config("property_blacklist");
  ae.isArray(u) ? ae.each(u, function(d) {
    delete r[d];
  }) : this.report_error("Invalid value for property_blacklist config: " + u);
  var h = {
    event: e,
    properties: r
  }, c = this._track_or_batch({
    type: "events",
    data: h,
    endpoint: this.get_config("api_host") + "/" + this.get_config("api_routes").track,
    batcher: this.request_batchers.events,
    should_send_immediately: a,
    send_request_options: i
  }, t);
  return c;
});
nt.prototype.set_group = al(function(e, r, i) {
  ae.isArray(r) || (r = [r]);
  var t = {};
  return t[e] = r, this.register(t), this.people.set(e, r, i);
});
nt.prototype.add_group = al(function(e, r, i) {
  var t = this.get_property(e), n = {};
  return t === void 0 ? (n[e] = [r], this.register(n)) : t.indexOf(r) === -1 && (t.push(r), n[e] = t, this.register(n)), this.people.union(e, r, i);
});
nt.prototype.remove_group = al(function(e, r, i) {
  var t = this.get_property(e);
  if (t !== void 0) {
    var n = t.indexOf(r);
    n > -1 && (t.splice(n, 1), this.register({ group_key: t })), t.length === 0 && this.unregister(e);
  }
  return this.people.remove(e, r, i);
});
nt.prototype.track_with_groups = al(function(e, r, i, t) {
  var n = ae.extend({}, r || {});
  return ae.each(i, function(a, s) {
    a != null && (n[s] = a);
  }), this.track(e, n, t);
});
nt.prototype._create_map_key = function(e, r) {
  return e + "_" + JSON.stringify(r);
};
nt.prototype._remove_group_from_cache = function(e, r) {
  delete this._cached_groups[this._create_map_key(e, r)];
};
nt.prototype.get_group = function(e, r) {
  var i = this._create_map_key(e, r), t = this._cached_groups[i];
  return (t === void 0 || t._group_key !== e || t._group_id !== r) && (t = new Ri(), t._init(this, e, r), this._cached_groups[i] = t), t;
};
nt.prototype.track_pageview = al(function(e, r) {
  typeof e != "object" && (e = {}), r = r || {};
  var i = r.event_name || "$mp_web_page_view", t = ae.extend(
    ae.info.mpPageViewProperties(),
    ae.info.campaignParams(),
    ae.info.clickParams()
  ), n = ae.extend(
    {},
    t,
    e
  );
  return this.track(i, n);
});
nt.prototype.track_links = function() {
  return this._track_dom.call(this, Zl, arguments);
};
nt.prototype.track_forms = function() {
  return this._track_dom.call(this, ip, arguments);
};
nt.prototype.time_event = function(e) {
  if (ae.isUndefined(e)) {
    this.report_error("No event name provided to mixpanel.time_event");
    return;
  }
  this._event_is_disabled(e) || this.persistence.set_event_timer(e, new Date().getTime());
};
var YF = {
  persistent: !0
}, d0 = function(e) {
  var r;
  return ae.isObject(e) ? r = e : ae.isUndefined(e) ? r = {} : r = { days: e }, ae.extend({}, YF, r);
};
nt.prototype.register = function(e, r) {
  var i = d0(r);
  i.persistent ? this.persistence.register(e, i.days) : ae.extend(this.unpersisted_superprops, e);
};
nt.prototype.register_once = function(e, r, i) {
  var t = d0(i);
  t.persistent ? this.persistence.register_once(e, r, t.days) : (typeof r > "u" && (r = "None"), ae.each(e, function(n, a) {
    (!this.unpersisted_superprops.hasOwnProperty(a) || this.unpersisted_superprops[a] === r) && (this.unpersisted_superprops[a] = n);
  }, this));
};
nt.prototype.unregister = function(e, r) {
  r = d0(r), r.persistent ? this.persistence.unregister(e) : delete this.unpersisted_superprops[e];
};
nt.prototype._register_single = function(e, r) {
  var i = {};
  i[e] = r, this.register(i);
};
nt.prototype.identify = function(e, r, i, t, n, a, s, o) {
  var l = this.get_distinct_id();
  if (e && l !== e) {
    if (typeof e == "string" && e.indexOf(c0) === 0)
      return this.report_error("distinct_id cannot have $device: prefix"), -1;
    this.register({ $user_id: e });
  }
  if (!this.get_property("$device_id")) {
    var u = l;
    this.register_once({
      $had_persisted_distinct_id: !0,
      $device_id: u
    }, "");
  }
  e !== l && e !== this.get_property(hh) && (this.unregister(hh), this.register({ distinct_id: e })), this._flags.identify_called = !0, this.people._flush(r, i, t, n, a, s, o), e !== l && this.track("$identify", {
    distinct_id: e,
    $anon_distinct_id: l
  }, { skip_hooks: !0 });
};
nt.prototype.reset = function() {
  this.persistence.clear(), this._flags.identify_called = !1;
  var e = ae.UUID();
  this.register_once({
    distinct_id: c0 + e,
    $device_id: e
  }, "");
};
nt.prototype.get_distinct_id = function() {
  return this.get_property("distinct_id");
};
nt.prototype.alias = function(e, r) {
  if (e === this.get_property(jx))
    return this.report_error("Attempting to create alias for existing People user - aborting."), -2;
  var i = this;
  return ae.isUndefined(r) && (r = this.get_distinct_id()), e !== r ? (this._register_single(hh, e), this.track("$create_alias", {
    alias: e,
    distinct_id: r
  }, {
    skip_hooks: !0
  }, function() {
    i.identify(e);
  })) : (this.report_error("alias matches current distinct_id - skipping api call."), this.identify(e), -1);
};
nt.prototype.name_tag = function(e) {
  this._register_single("mp_name_tag", e);
};
nt.prototype.set_config = function(e) {
  if (ae.isObject(e)) {
    ae.extend(this.config, e);
    var r = e.batch_size;
    r && ae.each(this.request_batchers, function(i) {
      i.resetBatchSize();
    }), this.get_config("persistence_name") || (this.config.persistence_name = this.config.cookie_name), this.get_config("disable_persistence") || (this.config.disable_persistence = this.config.disable_cookie), this.persistence && this.persistence.update_config(this.config), ho.DEBUG = ho.DEBUG || this.get_config("debug");
  }
};
nt.prototype.get_config = function(e) {
  return this.config[e];
};
nt.prototype._run_hook = function(e) {
  var r = (this.config.hooks[e] || qF).apply(this, zo.call(arguments, 1));
  return typeof r > "u" && (this.report_error(e + " hook did not return a value"), r = null), r;
};
nt.prototype.get_property = function(e) {
  return this.persistence.load_prop([e]);
};
nt.prototype.toString = function() {
  var e = this.get_config("name");
  return e !== Va && (e = Va + "." + e), e;
};
nt.prototype._event_is_disabled = function(e) {
  return ae.isBlockedUA(Os) || this._flags.disable_all_events || ae.include(this.__disabled_events, e);
};
nt.prototype._gdpr_init = function() {
  var e = this.get_config("opt_out_tracking_persistence_type") === "localStorage";
  e && ae.localStorage.is_supported() && (!this.has_opted_in_tracking() && this.has_opted_in_tracking({ persistence_type: "cookie" }) && this.opt_in_tracking({ enable_persistence: !1 }), !this.has_opted_out_tracking() && this.has_opted_out_tracking({ persistence_type: "cookie" }) && this.opt_out_tracking({ clear_persistence: !1 }), this.clear_opt_in_out_tracking({
    persistence_type: "cookie",
    enable_persistence: !1
  })), this.has_opted_out_tracking() ? this._gdpr_update_persistence({ clear_persistence: !0 }) : !this.has_opted_in_tracking() && (this.get_config("opt_out_tracking_by_default") || ae.cookie.get("mp_optout")) && (ae.cookie.remove("mp_optout"), this.opt_out_tracking({
    clear_persistence: this.get_config("opt_out_persistence_by_default")
  }));
};
nt.prototype._gdpr_update_persistence = function(e) {
  var r;
  if (e && e.clear_persistence)
    r = !0;
  else if (e && e.enable_persistence)
    r = !1;
  else
    return;
  !this.get_config("disable_persistence") && this.persistence.disabled !== r && this.persistence.set_disabled(r), r ? this.stop_batch_senders() : this._batchers_were_started && this.start_batch_senders();
};
nt.prototype._gdpr_call_func = function(e, r) {
  return r = ae.extend({
    track: ae.bind(this.track, this),
    persistence_type: this.get_config("opt_out_tracking_persistence_type"),
    cookie_prefix: this.get_config("opt_out_tracking_cookie_prefix"),
    cookie_expiration: this.get_config("cookie_expiration"),
    cross_site_cookie: this.get_config("cross_site_cookie"),
    cross_subdomain_cookie: this.get_config("cross_subdomain_cookie"),
    cookie_domain: this.get_config("cookie_domain"),
    secure_cookie: this.get_config("secure_cookie"),
    ignore_dnt: this.get_config("ignore_dnt")
  }, r), ae.localStorage.is_supported() || (r.persistence_type = "cookie"), e(this.get_config("token"), {
    track: r.track,
    trackEventName: r.track_event_name,
    trackProperties: r.track_properties,
    persistenceType: r.persistence_type,
    persistencePrefix: r.cookie_prefix,
    cookieDomain: r.cookie_domain,
    cookieExpiration: r.cookie_expiration,
    crossSiteCookie: r.cross_site_cookie,
    crossSubdomainCookie: r.cross_subdomain_cookie,
    secureCookie: r.secure_cookie,
    ignoreDnt: r.ignore_dnt
  });
};
nt.prototype.opt_in_tracking = function(e) {
  e = ae.extend({
    enable_persistence: !0
  }, e), this._gdpr_call_func(FF, e), this._gdpr_update_persistence(e);
};
nt.prototype.opt_out_tracking = function(e) {
  e = ae.extend({
    clear_persistence: !0,
    delete_user: !0
  }, e), e.delete_user && this.people && this.people._identify_called() && (this.people.delete_user(), this.people.clear_charges()), this._gdpr_call_func(UF, e), this._gdpr_update_persistence(e);
};
nt.prototype.has_opted_in_tracking = function(e) {
  return this._gdpr_call_func(BF, e);
};
nt.prototype.has_opted_out_tracking = function(e) {
  return this._gdpr_call_func(Nx, e);
};
nt.prototype.clear_opt_in_out_tracking = function(e) {
  e = ae.extend({
    enable_persistence: !0
  }, e), this._gdpr_call_func(jF, e), this._gdpr_update_persistence(e);
};
nt.prototype.report_error = function(e, r) {
  si.error.apply(si.error, arguments);
  try {
    !r && !(e instanceof Error) && (e = new Error(e)), this.get_config("error_reporter")(e, r);
  } catch (i) {
    si.error(i);
  }
};
nt.prototype.init = nt.prototype.init;
nt.prototype.reset = nt.prototype.reset;
nt.prototype.disable = nt.prototype.disable;
nt.prototype.time_event = nt.prototype.time_event;
nt.prototype.track = nt.prototype.track;
nt.prototype.track_links = nt.prototype.track_links;
nt.prototype.track_forms = nt.prototype.track_forms;
nt.prototype.track_pageview = nt.prototype.track_pageview;
nt.prototype.register = nt.prototype.register;
nt.prototype.register_once = nt.prototype.register_once;
nt.prototype.unregister = nt.prototype.unregister;
nt.prototype.identify = nt.prototype.identify;
nt.prototype.alias = nt.prototype.alias;
nt.prototype.name_tag = nt.prototype.name_tag;
nt.prototype.set_config = nt.prototype.set_config;
nt.prototype.get_config = nt.prototype.get_config;
nt.prototype.get_property = nt.prototype.get_property;
nt.prototype.get_distinct_id = nt.prototype.get_distinct_id;
nt.prototype.toString = nt.prototype.toString;
nt.prototype.opt_out_tracking = nt.prototype.opt_out_tracking;
nt.prototype.opt_in_tracking = nt.prototype.opt_in_tracking;
nt.prototype.has_opted_out_tracking = nt.prototype.has_opted_out_tracking;
nt.prototype.has_opted_in_tracking = nt.prototype.has_opted_in_tracking;
nt.prototype.clear_opt_in_out_tracking = nt.prototype.clear_opt_in_out_tracking;
nt.prototype.get_group = nt.prototype.get_group;
nt.prototype.set_group = nt.prototype.set_group;
nt.prototype.add_group = nt.prototype.add_group;
nt.prototype.remove_group = nt.prototype.remove_group;
nt.prototype.track_with_groups = nt.prototype.track_with_groups;
nt.prototype.start_batch_senders = nt.prototype.start_batch_senders;
nt.prototype.stop_batch_senders = nt.prototype.stop_batch_senders;
nt.prototype.start_session_recording = nt.prototype.start_session_recording;
nt.prototype.stop_session_recording = nt.prototype.stop_session_recording;
nt.prototype.get_session_recording_properties = nt.prototype.get_session_recording_properties;
nt.prototype.DEFAULT_API_ROUTES = Vx;
Nr.prototype.properties = Nr.prototype.properties;
Nr.prototype.update_search_keyword = Nr.prototype.update_search_keyword;
Nr.prototype.update_referrer_info = Nr.prototype.update_referrer_info;
Nr.prototype.get_cross_subdomain = Nr.prototype.get_cross_subdomain;
Nr.prototype.clear = Nr.prototype.clear;
var Il = {}, KF = function() {
  ae.each(Il, function(e, r) {
    r !== Va && (Nn[r] = e);
  }), Nn._ = ae;
}, zF = function() {
  Nn.init = function(e, r, i) {
    if (i)
      return Nn[i] || (Nn[i] = Il[i] = ov(e, r, i), Nn[i]._loaded()), Nn[i];
    var t = Nn;
    Il[Va] ? t = Il[Va] : e && (t = ov(e, r, Va), t._loaded(), Il[Va] = t), Nn = t, l0 === VF && (Or[Va] = Nn), KF();
  };
}, XF = function() {
  function e() {
    e.done || (e.done = !0, qx = !0, Hx = !1, ae.each(Il, function(t) {
      t._dom_loaded();
    }));
  }
  function r() {
    try {
      vi.documentElement.doScroll("left");
    } catch {
      setTimeout(r, 1);
      return;
    }
    e();
  }
  if (vi.addEventListener)
    vi.readyState === "complete" ? e() : vi.addEventListener("DOMContentLoaded", e, !1);
  else if (vi.attachEvent) {
    vi.attachEvent("onreadystatechange", e);
    var i = !1;
    try {
      i = Or.frameElement === null;
    } catch {
    }
    vi.documentElement.doScroll && i && r();
  }
  ae.register_event(Or, "load", e, !0);
};
function JF() {
  return l0 = $x, Nn = new nt(), zF(), Nn.init(), XF(), Nn;
}
var QF = JF(), og = QF;
fr.factory("MixpanelService", [function() {
  const e = {}, r = "https://d3ige8rf4hrn8x.cloudfront.net";
  og.init("some_token");
  const i = {};
  function t(s, ...o) {
    Object.values(i).forEach((l) => {
      l[s] ? l[s](...o) : console.warn(`Method "${s}" not found on instance.`);
    });
  }
  e.init = (s, o) => {
    i[s] ? console.warn(`Analytics instance: '${s}' is already initialized`) : (og.init("", { api_host: o || r }, s), i[s] = og[s]);
  }, e.getProperty = (s) => {
    t("get_property", s);
  }, e.registerOnce = (s) => {
    t("register_once", s);
  }, e.register = (s) => {
    t("register", s);
  };
  const n = (s) => {
    t("identify", s);
  }, a = (s, o) => {
    t("track", s, o);
  };
  return e.sendProxyEvent = (s, o, l) => {
    try {
      s = s.toLowerCase(), o = o || {}, o.user_id && n(o.user_id), a(s, o);
    } catch {
      console.log("Failed to send MX event");
    }
  }, e;
}]);
fr.service("PlayerTrackerService", ["MixpanelService", function(e) {
  this.init = function(r, i) {
    e.init(r, i);
  }, this.track = function(r, i, t) {
    i.__table = "video_events", e.sendProxyEvent(r, i, t);
  }, this.register = function(r) {
    e.register(r);
  }, this.registerOnce = function(r) {
    e.registerOnce(r);
  }, this.getProperty = function(r) {
    e.getProperty(r);
  };
  try {
    const r = new BroadcastChannel("chunk_loaded"), i = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function() {
      this.addEventListener("load", function() {
        let t;
        try {
          t = new URL(this.responseURL), this.status === 200 && t && ["stream.videoflow.io", "dflsjqznkm1lx.cloudfront.net", "a6f45de6e044.us-west-2.playback.live-video.net", "live.videoflow.io"].includes(t.hostname) && t.pathname.match(/.(ts|cmfv|cmfa)$/) && r.postMessage(JSON.stringify({ size: parseInt(this.getResponseHeader("content-length")) }));
        } catch {
        }
      }), i.apply(this, arguments);
    };
  } catch {
  }
  return this;
}]).factory("PlayerTracker", ["PlayerTrackerService", function(e) {
  const r = "video_watched_time", i = {
    impression: !0,
    play: !1,
    pause: !1,
    ended: !1,
    "section watched": !0,
    "ad started": !0,
    "ad impression": !1,
    "ad skipped": !0,
    "ad completed": !0,
    chunk: !1
  }, t = function(a, s) {
    this.player = a, this.metadata = s, e.init("custom", s.endpoint), this.player.one("play", () => {
      try {
        const c = this._getProps();
        c.event = "impression", i[c.event] && (window.analytics && typeof window.analytics.track == "function" && typeof window.analytics.identify == "function" && analytics.track("Video Playback Started", {
          video_player: "stream engine player",
          title: c.input_name,
          asset_id: c.input_token,
          channel: c.channel_name,
          keywords: c.input_tags,
          total_length: c.video_duration
        }), e.track("video", c), a.logger.log("Video impression", c)), this.sendSectionWatchedEvent();
      } catch {
      }
    }), this.on("play"), this.on("pause"), this.on("ended");
    const o = {};
    o[r] = 0, e.registerOnce(o), this.lastTimeUpdate = 0, this.watchTime = 0;
    let l = 0;
    const u = 30;
    let h = this;
    this.chunkListener = function(c) {
      try {
        let d = JSON.parse(c.data);
        const f = h._getProps();
        f.event = "chunk", Object.assign(f, h._getHLSProps()), f.stream_bitrate = d.size, i[f.event] && e.track("video", f);
      } catch {
      }
    }, this.sendSectionWatchedEvent = function() {
      const c = this._getProps();
      c.event = "section watched", c.section_duration = u, c.measure = u, Object.assign(c, this._getHLSProps()), i[c.event] && e.track("video", c);
    };
    try {
      this.broadcastChannel = new BroadcastChannel("chunk_loaded"), this.broadcastChannel.addEventListener("message", this.chunkListener);
    } catch {
    }
    this.player.on("frag_loaded", (c, d) => {
      try {
        const f = this._getProps();
        f.event = "chunk", f.stream_bitrate = d.frag.loaded, Object.assign(f, this._getHLSProps()), f.stream_segment_duration = d.frag.duration, i[f.event] && e.track("video", f);
      } catch {
      }
    }), this.player.on("timeupdate", (c) => {
      if (this.lastTimeUpdate && Math.abs(this.player.currentTime() - this.lastTimeUpdate) < 1 && (this._increment(r, this.player.currentTime() - this.lastTimeUpdate), this.watchTime += this.player.currentTime() - this.lastTimeUpdate), this.lastTimeUpdate = this.player.currentTime(), this.watchTime - l > u)
        try {
          this.sendSectionWatchedEvent(), l = this.watchTime;
        } catch {
        }
    });
  };
  return t.prototype = {
    _getInputType: function(n) {
      return n.type === "live" ? n.live_type : n.type === "normal" ? "custom" : n.type;
    },
    _getProps: function() {
      return {
        input_src: this.player.src(),
        input_name: this.metadata.videoTitle,
        input_token: this.metadata.videoId,
        input_tags: this.metadata.videoTags,
        input_parent_id: this.metadata.videoParentId,
        input_parent_token: this.metadata.videoParentId,
        organization_owner: this.metadata.workspaceOwner,
        organization_name: this.metadata.workspaceName,
        organization_token: this.metadata.workspaceToken,
        organization_id: this.metadata.workspaceId,
        channel_name: this.metadata.channelTitle,
        channel_token: this.metadata.channelId,
        video_current_watch_time: parseFloat(this.watchTime.toFixed(2)),
        video_duration: parseFloat(this.player.duration().toFixed(2)),
        video_current_time: parseFloat(this.player.currentTime().toFixed(2)),
        is_recording: !!this.metadata.isRecording,
        is_external: !!this.metadata.isExternal,
        input_stream_state: this.metadata.videoState,
        input_type: this.metadata.videoType,
        user_id: this.metadata.viewerId
      };
    },
    _aproxEq: function(n, a, s) {
      return n >= a - s && n <= a + s;
    },
    _getHLSProps: function() {
      try {
        if (this.player.vfhls.currentLevel)
          return {
            stream_width: this.player.vfhls.currentLevel.width,
            stream_height: this.player.vfhls.currentLevel.height,
            stream_bitrate: this.player.vfhls.currentLevel.bitrate,
            stream_video_codec: this.player.vfhls.currentLevel.videoCodec,
            stream_audio_codec: this.player.vfhls.currentLevel.audioCodec,
            stream_level: `${this.player.vfhls.currentLevel.level + 1}/${this.player.vfhls.currentLevel.totalLevels}`,
            stream_level_index: this.player.vfhls.currentLevel.level,
            stream_total_levels: this.player.vfhls.currentLevel.totalLevels,
            stream_resolutions: this.player.vfhls.currentLevel.availableResolutions,
            stream_is_live: !!this.player.vfhls.isLive,
            stream_segment_duration: this.player.vfhls.manifest ? this.player.vfhls.manifest._segmentDuration : void 0
          };
        if (this.player.vfhls.manifest && this.player.vfhls.manifest.playlists) {
          const n = this.player.videoWidth(), a = this.player.videoHeight();
          let s = this.player.vfhls.manifest.playlists;
          const o = s.findIndex((h) => h.attributes && h.attributes.RESOLUTION && this._aproxEq(h.attributes.RESOLUTION.width, n, 10) && this._aproxEq(h.attributes.RESOLUTION.height, a, 10));
          if (o < 0)
            return {};
          const l = s[o];
          if (!l || !l.attributes)
            return {};
          const u = l.attributes.CODECS ? l.attributes.CODECS.split(",") : [];
          return {
            stream_total_levels: s.length,
            stream_level: `${o + 1}/${s.length}`,
            stream_level_index: o,
            stream_is_live: this.player.vfhls.manifest._live,
            stream_segment_duration: this.player.vfhls.manifest._segmentDuration,
            stream_bitrate: l.attributes.BANDWIDTH,
            stream_width: l.attributes.RESOLUTION ? l.attributes.RESOLUTION.width : void 0,
            stream_height: l.attributes.RESOLUTION ? l.attributes.RESOLUTION.height : void 0,
            stream_video_codec: u.length > 1 ? u[0].trim() : "unknown",
            stream_audio_codec: u.length > 2 ? u[1].trim() : "unknown"
          };
        } else
          return {};
      } catch {
        return {};
      }
    },
    one: function(n, a) {
      this.player.one(n, () => {
        const s = this._getProps();
        s.event = n, e.track(a, s);
      });
    },
    on: function(n, a) {
      this.player.on(n, () => {
        try {
          const s = this._getProps();
          s.event = a || n, i[s.event] && e.track("video", s);
        } catch {
        }
      });
    },
    onAd: function(n, a) {
      try {
        this.player.ima.addEventListener(n, (s) => {
          try {
            const o = this._getProps();
            o.event = a || n, i[o.event] && e.track("video", o);
          } catch {
          }
        });
      } catch {
      }
    },
    debug: function(n) {
      this.player.on(n, () => {
        console.log(n);
      });
    },
    off: function(n) {
      this.player.off(n);
    },
    trackAds: function() {
      this.onAd("start", "ad started"), this.onAd("impression", "ad impression"), this.onAd("skip", "ad skipped"), this.onAd("allAdsCompleted", "ad completed");
    },
    destroy: function(n) {
      this.off("play"), this.off("pause"), this.off("ended"), this.off("timeupdate");
      try {
        this.broadcastChannel.removeEventListener("message", this.chunkListener);
      } catch {
      }
    },
    _increment: function(n, a) {
      const s = {};
      s[n] = parseFloat((e.getProperty(n) + a).toFixed(2)), e.register(s);
    }
  }, t;
}]);
function ZF(e, r) {
  var t;
  const i = {
    debug: !1,
    data: {
      env_key: r.muxKey,
      player_name: r.playerName || "Stream Engine Player",
      viewer_user_id: r.viewerId || "",
      player_version: "1.0.0",
      video_id: r.videoId,
      video_title: r.videoTitle,
      video_series: "",
      video_duration: (parseFloat(e.duration().toFixed(2)) || 0) * 1e3,
      video_stream_type: (t = r.videoState) == null ? void 0 : t.toUpperCase(),
      video_cdn: "CloudFront",
      custom_1: r.channelTitle,
      custom_2: window.location.host
    }
  };
  e.mux(i);
}
fr.service("VJSAnalyticsPlugin", ["PlayerTracker", function(e) {
  const r = re.getPlugin("plugin"), i = re.extend(r, {
    constructor: function(t, n) {
      r.call(this, t, n), n.muxKey && t.mux && ZF(t, n), this.tracker = new e(t, n);
    },
    trackAds: function() {
      this.tracker.trackAds();
    }
  });
  return i.pluginName = "analytics", i;
}]);
var Vi = {
  log: "log",
  debug: "debug",
  info: "info",
  warn: "warn",
  error: "error"
}, Is = console, Mu = {};
Object.keys(Vi).forEach(function(e) {
  Mu[e] = Is[e];
});
var jc = "Datadog Browser SDK:", sn = {
  debug: Mu.debug.bind(Is, jc),
  log: Mu.log.bind(Is, jc),
  info: Mu.info.bind(Is, jc),
  warn: Mu.warn.bind(Is, jc),
  error: Mu.error.bind(Is, jc)
}, f0 = "https://docs.datadoghq.com", Wx = "".concat(f0, "/real_user_monitoring/browser/troubleshooting"), np = "More details:";
function Yx(e, r) {
  return function() {
    for (var i = [], t = 0; t < arguments.length; t++)
      i[t] = arguments[t];
    try {
      return e.apply(void 0, i);
    } catch (n) {
      sn.error(r, n);
    }
  };
}
function Of(e) {
  return e !== 0 && Math.random() * 100 <= e;
}
function eU(e) {
  return tU(e) && e >= 0 && e <= 100;
}
function tU(e) {
  return typeof e == "number";
}
var Ud = 1e3, sl = 60 * Ud, rU = 60 * sl;
function _d() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function fu() {
  return _d();
}
function gh() {
  return performance.now();
}
function mc() {
  return { relative: gh(), timeStamp: fu() };
}
function iU() {
  return { relative: 0, timeStamp: Kx() };
}
function nU(e, r) {
  return r - e;
}
function aU(e, r) {
  return e + r;
}
function sU(e) {
  return e - Kx();
}
var ug;
function Kx() {
  return ug === void 0 && (ug = performance.timing.navigationStart), ug;
}
var _o = 1024, zx = 1024 * _o, oU = /[^\u0000-\u007F]/;
function h0(e) {
  return oU.test(e) ? window.TextEncoder !== void 0 ? new TextEncoder().encode(e).length : new Blob([e]).size : e.length;
}
function yc(e, r) {
  return e.indexOf(r) !== -1;
}
function p0(e) {
  if (Array.from)
    return Array.from(e);
  var r = [];
  if (e instanceof Set)
    e.forEach(function(t) {
      return r.push(t);
    });
  else
    for (var i = 0; i < e.length; i++)
      r.push(e[i]);
  return r;
}
function uU(e, r) {
  for (var i = 0; i < e.length; i += 1) {
    var t = e[i];
    if (r(t, i))
      return t;
  }
}
function tc(e) {
  return Object.keys(e).map(function(r) {
    return e[r];
  });
}
function lU(e) {
  return Object.keys(e).map(function(r) {
    return [r, e[r]];
  });
}
function g0(e, r) {
  return e.slice(0, r.length) === r;
}
function cU(e, r) {
  return e.slice(-r.length) === r;
}
function Un(e) {
  for (var r = [], i = 1; i < arguments.length; i++)
    r[i - 1] = arguments[i];
  return r.forEach(function(t) {
    for (var n in t)
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  }), e;
}
function dU(e) {
  return Un({}, e);
}
function Xx(e, r) {
  return Object.keys(e).some(function(i) {
    return e[i] === r;
  });
}
function v0(e) {
  return Object.keys(e).length === 0;
}
function hu() {
  if (typeof globalThis == "object")
    return globalThis;
  Object.defineProperty(Object.prototype, "_dd_temp_", {
    get: function() {
      return this;
    },
    configurable: !0
  });
  var e = _dd_temp_;
  return delete Object.prototype._dd_temp_, typeof e != "object" && (typeof self == "object" ? e = self : typeof window == "object" ? e = window : e = {}), e;
}
function rc(e, r) {
  var i = hu(), t;
  return i.Zone && typeof i.Zone.__symbol__ == "function" && (t = e[i.Zone.__symbol__(r)]), t || (t = e[r]), t;
}
var fU = function(e, r, i) {
  if (i || arguments.length === 2)
    for (var t = 0, n = r.length, a; t < n; t++)
      (a || !(t in r)) && (a || (a = Array.prototype.slice.call(r, 0, t)), a[t] = r[t]);
  return e.concat(a || Array.prototype.slice.call(r));
}, vh, Jx = !1;
function hU(e) {
  vh = e;
}
function pU(e) {
  Jx = e;
}
function gU(e, r, i) {
  var t = i.value;
  i.value = function() {
    for (var n = [], a = 0; a < arguments.length; a++)
      n[a] = arguments[a];
    var s = vh ? pi(t) : t;
    return s.apply(this, n);
  };
}
function pi(e) {
  return function() {
    return bd(e, this, arguments);
  };
}
function bd(e, r, i) {
  try {
    return e.apply(r, i);
  } catch (t) {
    if (uv(t), vh)
      try {
        vh(t);
      } catch (n) {
        uv(n);
      }
  }
}
function uv() {
  for (var e = [], r = 0; r < arguments.length; r++)
    e[r] = arguments[r];
  Jx && sn.error.apply(sn, fU(["[MONITOR]"], e, !1));
}
function Bd(e, r) {
  return rc(hu(), "setTimeout")(pi(e), r);
}
function Qx(e) {
  rc(hu(), "clearTimeout")(e);
}
function m0(e, r) {
  return rc(hu(), "setInterval")(pi(e), r);
}
function Zx(e) {
  rc(hu(), "clearInterval")(e);
}
var pn = function() {
  function e(r) {
    this.onFirstSubscribe = r, this.observers = [];
  }
  return e.prototype.subscribe = function(r) {
    var i = this;
    return this.observers.push(r), this.observers.length === 1 && this.onFirstSubscribe && (this.onLastUnsubscribe = this.onFirstSubscribe(this) || void 0), {
      unsubscribe: function() {
        i.observers = i.observers.filter(function(t) {
          return r !== t;
        }), !i.observers.length && i.onLastUnsubscribe && i.onLastUnsubscribe();
      }
    };
  }, e.prototype.notify = function(r) {
    this.observers.forEach(function(i) {
      return i(r);
    });
  }, e;
}();
function eA() {
  for (var e = [], r = 0; r < arguments.length; r++)
    e[r] = arguments[r];
  return new pn(function(i) {
    var t = e.map(function(n) {
      return n.subscribe(function(a) {
        return i.notify(a);
      });
    });
    return function() {
      return t.forEach(function(n) {
        return n.unsubscribe();
      });
    };
  });
}
function tA(e, r, i) {
  var t = i && i.leading !== void 0 ? i.leading : !0, n = i && i.trailing !== void 0 ? i.trailing : !0, a = !1, s, o;
  return {
    throttled: function() {
      for (var l = [], u = 0; u < arguments.length; u++)
        l[u] = arguments[u];
      if (a) {
        s = l;
        return;
      }
      t ? e.apply(void 0, l) : s = l, a = !0, o = Bd(function() {
        n && s && e.apply(void 0, s), a = !1, s = void 0;
      }, r);
    },
    cancel: function() {
      Qx(o), a = !1, s = void 0;
    }
  };
}
function au() {
}
function ol(e) {
  return e ? (parseInt(e, 10) ^ Math.random() * 16 >> parseInt(e, 10) / 4).toString(16) : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, ol);
}
var mh = /([\w-]+)\s*=\s*([^;]+)/g;
function vU(e, r) {
  for (mh.lastIndex = 0; ; ) {
    var i = mh.exec(e);
    if (i) {
      if (i[1] === r)
        return i[2];
    } else
      break;
  }
}
function mU(e) {
  var r = /* @__PURE__ */ new Map();
  for (mh.lastIndex = 0; ; ) {
    var i = mh.exec(e);
    if (i)
      r.set(i[1], i[2]);
    else
      break;
  }
  return r;
}
function yU(e, r, i) {
  i === void 0 && (i = "");
  var t = e.charCodeAt(r - 1), n = t >= 55296 && t <= 56319, a = n ? r + 1 : r;
  return e.length <= a ? e : "".concat(e.slice(0, a)).concat(i);
}
function _U() {
  return bU() === 1;
}
var yf;
function bU() {
  return yf != null ? yf : yf = TU();
}
function TU(e) {
  var r;
  e === void 0 && (e = window);
  var i = e.navigator.userAgent;
  return e.chrome || /HeadlessChrome/.test(i) ? 1 : ((r = e.navigator.vendor) === null || r === void 0 ? void 0 : r.indexOf("Apple")) === 0 || /safari/i.test(i) && !/chrome|android/i.test(i) ? 2 : e.document.documentMode ? 0 : 3;
}
function jd(e, r, i, t) {
  var n = /* @__PURE__ */ new Date();
  n.setTime(n.getTime() + i);
  var a = "expires=".concat(n.toUTCString()), s = t && t.crossSite ? "none" : "strict", o = t && t.domain ? ";domain=".concat(t.domain) : "", l = t && t.secure ? ";secure" : "", u = t && t.partitioned ? ";partitioned" : "";
  document.cookie = "".concat(e, "=").concat(r, ";").concat(a, ";path=/;samesite=").concat(s).concat(o).concat(l).concat(u);
}
function y0(e) {
  return vU(document.cookie, e);
}
var lg;
function $u(e) {
  return lg || (lg = mU(document.cookie)), lg.get(e);
}
function rA(e, r) {
  jd(e, "", 0, r);
}
function SU(e) {
  if (document.cookie === void 0 || document.cookie === null)
    return !1;
  try {
    var r = "dd_cookie_test_".concat(ol()), i = "test";
    jd(r, i, sl, e);
    var t = y0(r) === i;
    return rA(r, e), t;
  } catch (n) {
    return sn.error(n), !1;
  }
}
var cg;
function EU() {
  if (cg === void 0) {
    for (var e = "dd_site_test_".concat(ol()), r = "test", i = window.location.hostname.split("."), t = i.pop(); i.length && !y0(e); )
      t = "".concat(i.pop(), ".").concat(t), jd(e, r, Ud, { domain: t });
    rA(e, { domain: t }), cg = t;
  }
  return cg;
}
var _c = "_dd_s", _0 = 4 * rU, iA = 15 * sl, nA = /^([a-zA-Z]+)=([a-z0-9-]+)$/, b0 = "&", xU = "1";
function Nu() {
  return {
    isExpired: xU
  };
}
function Lf(e) {
  return v0(e);
}
function aA(e) {
  return !Lf(e);
}
function yh(e) {
  return e.isExpired !== void 0 || !AU(e);
}
function AU(e) {
  return (e.created === void 0 || _d() - Number(e.created) < _0) && (e.expire === void 0 || _d() < Number(e.expire));
}
function sA(e) {
  e.expire = String(_d() + iA);
}
function T0(e) {
  return lU(e).map(function(r) {
    var i = r[0], t = r[1];
    return "".concat(i, "=").concat(t);
  }).join(b0);
}
function oA(e) {
  var r = {};
  return wU(e) && e.split(b0).forEach(function(i) {
    var t = nA.exec(i);
    if (t !== null) {
      var n = t[1], a = t[2];
      r[n] = a;
    }
  }), r;
}
function wU(e) {
  return !!e && (e.indexOf(b0) !== -1 || nA.test(e));
}
var CU = "_dd", DU = "_dd_r", kU = "_dd_l", RU = "rum", PU = "logs";
function OU(e) {
  var r = $u(_c);
  if (!r) {
    var i = $u(CU), t = $u(DU), n = $u(kU), a = {};
    i && (a.id = i), n && /^[01]$/.test(n) && (a[PU] = n), t && /^[012]$/.test(t) && (a[RU] = t), aA(a) && (sA(a), e.persistSession(a));
  }
}
function LU(e) {
  var r = UU(e);
  return SU(r) ? { type: "Cookie", cookieOptions: r } : void 0;
}
function IU(e) {
  var r = {
    isLockEnabled: _U(),
    persistSession: MU(e),
    retrieveSession: FU,
    expireSession: function() {
      return NU(e);
    }
  };
  return OU(r), r;
}
function MU(e) {
  return function(r) {
    jd(_c, T0(r), iA, e);
  };
}
function NU(e) {
  jd(_c, T0(Nu()), _0, e);
}
function FU() {
  var e = y0(_c);
  return oA(e);
}
function UU(e) {
  var r = {};
  return r.secure = !!e.useSecureSessionCookie || !!e.usePartitionedCrossSiteSessionCookie || !!e.useCrossSiteSessionCookie, r.crossSite = !!e.usePartitionedCrossSiteSessionCookie || !!e.useCrossSiteSessionCookie, r.partitioned = !!e.usePartitionedCrossSiteSessionCookie, e.trackSessionAcrossSubdomains && (r.domain = EU()), r;
}
var BU = "_dd_test_";
function jU() {
  try {
    var e = ol(), r = "".concat(BU).concat(e);
    localStorage.setItem(r, e);
    var i = localStorage.getItem(r);
    return localStorage.removeItem(r), e === i ? { type: "LocalStorage" } : void 0;
  } catch {
    return;
  }
}
function $U() {
  return {
    isLockEnabled: !1,
    persistSession: uA,
    retrieveSession: GU,
    expireSession: HU
  };
}
function uA(e) {
  localStorage.setItem(_c, T0(e));
}
function GU() {
  var e = localStorage.getItem(_c);
  return oA(e);
}
function HU() {
  uA(Nu());
}
var VU = 10, qU = 100, lA = [], If;
function Fu(e, r, i) {
  var t;
  i === void 0 && (i = 0);
  var n = r.isLockEnabled, a = r.persistSession, s = r.expireSession, o = function(d) {
    return a(Un({}, d, { lock: u }));
  }, l = function() {
    var d = r.retrieveSession(), f = d.lock;
    return d.lock && delete d.lock, {
      session: d,
      lock: f
    };
  };
  if (If || (If = e), e !== If) {
    lA.push(e);
    return;
  }
  if (n && i >= qU) {
    bb(r);
    return;
  }
  var u, h = l();
  if (n) {
    if (h.lock) {
      _f(e, r, i);
      return;
    }
    if (u = ol(), o(h.session), h = l(), h.lock !== u) {
      _f(e, r, i);
      return;
    }
  }
  var c = e.process(h.session);
  if (n && (h = l(), h.lock !== u)) {
    _f(e, r, i);
    return;
  }
  if (c && (yh(c) ? s() : (sA(c), n ? o(c) : a(c))), n && !(c && yh(c))) {
    if (h = l(), h.lock !== u) {
      _f(e, r, i);
      return;
    }
    a(h.session), c = h.session;
  }
  (t = e.after) === null || t === void 0 || t.call(e, c || h.session), bb(r);
}
function _f(e, r, i) {
  Bd(function() {
    Fu(e, r, i + 1);
  }, VU);
}
function bb(e) {
  If = void 0;
  var r = lA.shift();
  r && Fu(r, e);
}
var Tb = Ud;
function WU(e) {
  var r = LU(e);
  return !r && e.allowFallbackToLocalStorage && (r = jU()), r;
}
function YU(e, r, i) {
  var t = new pn(), n = new pn(), a = new pn(), s = e.type === "Cookie" ? IU(e.cookieOptions) : $U(), o = s.expireSession, l = m0(m, Tb), u;
  b();
  var h = tA(function() {
    Fu({
      process: function(S) {
        if (!Lf(S)) {
          var T = p(S);
          return y(T), T;
        }
      },
      after: function(S) {
        aA(S) && !v() && x(S), u = S;
      }
    }, s);
  }, Tb), c = h.throttled, d = h.cancel;
  function f() {
    Fu({
      process: function(S) {
        return v() ? p(S) : void 0;
      }
    }, s);
  }
  function m() {
    Fu({
      process: function(S) {
        return yh(S) ? Nu() : void 0;
      },
      after: p
    }, s);
  }
  function p(S) {
    return yh(S) && (S = Nu()), v() && (g(S) ? E() : (a.notify({ previousState: u, newState: S }), u = S)), S;
  }
  function b() {
    Fu({
      process: function(S) {
        if (Lf(S))
          return Nu();
      },
      after: function(S) {
        u = S;
      }
    }, s);
  }
  function y(S) {
    if (Lf(S))
      return !1;
    var T = i(S[r]), C = T.trackingType, D = T.isTracked;
    S[r] = C, delete S.isExpired, D && !S.id && (S.id = ol(), S.created = String(_d()));
  }
  function v() {
    return u[r] !== void 0;
  }
  function g(S) {
    return u.id !== S.id || u[r] !== S[r];
  }
  function E() {
    u = Nu(), n.notify();
  }
  function x(S) {
    u = S, t.notify();
  }
  function w(S) {
    Fu({
      process: function(T) {
        return Un({}, T, S);
      },
      after: p
    }, s);
  }
  return {
    expandOrRenewSession: c,
    expandSession: f,
    getSession: function() {
      return u;
    },
    renewObservable: t,
    expireObservable: n,
    sessionStateUpdateObservable: a,
    restartSession: b,
    expire: function() {
      d(), o(), p(Nu());
    },
    stop: function() {
      Zx(l);
    },
    updateSessionState: w
  };
}
var lv = {
  GRANTED: "granted",
  NOT_GRANTED: "not-granted"
};
function KU(e) {
  var r = new pn();
  return {
    tryToInit: function(i) {
      e || (e = i);
    },
    update: function(i) {
      e = i, r.notify();
    },
    isGranted: function() {
      return e === lv.GRANTED;
    },
    observable: r
  };
}
function ul(e, r, i) {
  if (typeof e != "object" || e === null)
    return JSON.stringify(e);
  var t = Ml(Object.prototype), n = Ml(Array.prototype), a = Ml(Object.getPrototypeOf(e)), s = Ml(e);
  try {
    return JSON.stringify(e, r, i);
  } catch {
    return "<error: unable to serialize object>";
  } finally {
    t(), n(), a(), s();
  }
}
function Ml(e) {
  var r = e, i = r.toJSON;
  return i ? (delete r.toJSON, function() {
    r.toJSON = i;
  }) : au;
}
function S0(e) {
  return zU(e, location.href).href;
}
function zU(e, r) {
  var i = XU();
  if (i)
    try {
      return r !== void 0 ? new i(e, r) : new i(e);
    } catch (s) {
      throw new Error("Failed to construct URL: ".concat(String(s), " ").concat(ul({ url: e, base: r })));
    }
  if (r === void 0 && !/:/.test(e))
    throw new Error("Invalid URL: '".concat(e, "'"));
  var t = document, n = t.createElement("a");
  if (r !== void 0) {
    t = document.implementation.createHTMLDocument("");
    var a = t.createElement("base");
    a.href = r, t.head.appendChild(a), t.body.appendChild(n);
  }
  return n.href = e, n;
}
var Sb = URL, bf;
function XU() {
  if (bf === void 0)
    try {
      var e = new Sb("http://test/path");
      bf = e.href === "http://test/path";
    } catch {
      bf = !1;
    }
  return bf ? Sb : void 0;
}
var JU = "datad0g.com", QU = "dd0g-gov.com", Gu = "datadoghq.com", ZU = "ddog-gov.com", cA = "pci.browser-intake-datadoghq.com";
function ed(e, r, i) {
  var t = eB(e, r);
  return {
    build: function(n, a) {
      var s = rB(e, r, i, n, a);
      return t(s);
    },
    urlPrefix: t(""),
    trackType: r
  };
}
function eB(e, r) {
  var i = "/api/v2/".concat(r), t = e.proxy;
  if (typeof t == "string") {
    var n = S0(t);
    return function(s) {
      return "".concat(n, "?ddforward=").concat(encodeURIComponent("".concat(i, "?").concat(s)));
    };
  }
  if (typeof t == "function")
    return function(s) {
      return t({ path: i, parameters: s });
    };
  var a = tB(r, e);
  return function(s) {
    return "https://".concat(a).concat(i, "?").concat(s);
  };
}
function tB(e, r) {
  var i = r.site, t = i === void 0 ? Gu : i, n = r.internalAnalyticsSubdomain;
  if (e === "logs" && r.usePciIntake && t === Gu)
    return cA;
  if (n && t === Gu)
    return "".concat(n, ".").concat(Gu);
  if (t === QU)
    return "http-intake.logs.".concat(t);
  var a = t.split("."), s = a.pop();
  return "browser-intake-".concat(a.join("-"), ".").concat(s);
}
function rB(e, r, i, t, n) {
  var a = e.clientToken, s = e.internalAnalyticsSubdomain, o = n.retry, l = n.encoding, u = ["sdk_version:".concat("5.23.3"), "api:".concat(t)].concat(i);
  o && u.push("retry_count:".concat(o.count), "retry_after:".concat(o.lastFailureStatus));
  var h = [
    "ddsource=browser",
    "ddtags=".concat(encodeURIComponent(u.join(","))),
    "dd-api-key=".concat(a),
    "dd-evp-origin-version=".concat(encodeURIComponent("5.23.3")),
    "dd-evp-origin=browser",
    "dd-request-id=".concat(ol())
  ];
  return l && h.push("dd-evp-encoding=".concat(l)), r === "rum" && h.push("batch_time=".concat(fu())), s && h.reverse(), h.join("&");
}
var iB = 200;
function nB(e) {
  var r = e.env, i = e.service, t = e.version, n = e.datacenter, a = [];
  return r && a.push(Tf("env", r)), i && a.push(Tf("service", i)), t && a.push(Tf("version", t)), n && a.push(Tf("datacenter", n)), a;
}
var aB = /[^a-z0-9_:./-]/;
function Tf(e, r) {
  var i = iB - e.length - 1;
  (r.length > i || aB.test(r)) && sn.warn("".concat(e, " value doesn't meet tag requirements and will be sanitized. ").concat(np, " ").concat(f0, "/getting_started/tagging/#defining-tags"));
  var t = r.replace(/,/g, "_");
  return "".concat(e, ":").concat(t);
}
function sB(e) {
  var r = e.site || Gu, i = nB(e), t = oB(e, i), n = lB(t, r), a = uB(e, n, i);
  return Un({
    isIntakeUrl: function(s) {
      return n.some(function(o) {
        return s.indexOf(o) === 0;
      });
    },
    replica: a,
    site: r
  }, t);
}
function oB(e, r) {
  return {
    logsEndpointBuilder: ed(e, "logs", r),
    rumEndpointBuilder: ed(e, "rum", r),
    sessionReplayEndpointBuilder: ed(e, "replay", r)
  };
}
function uB(e, r, i) {
  if (!!e.replica) {
    var t = Un({}, e, {
      site: Gu,
      clientToken: e.replica.clientToken
    }), n = {
      logsEndpointBuilder: ed(t, "logs", i),
      rumEndpointBuilder: ed(t, "rum", i)
    };
    return r.push.apply(r, tc(n).map(function(a) {
      return a.urlPrefix;
    })), Un({ applicationId: e.replica.applicationId }, n);
  }
}
function lB(e, r) {
  var i = tc(e).map(function(t) {
    return t.urlPrefix;
  });
  return r === Gu && i.push("https://".concat(cA, "/")), i;
}
function dg(e, r) {
  return e != null && typeof e != "string" ? (sn.error("".concat(r, " must be defined as a string")), !1) : !0;
}
function cB(e) {
  return e && typeof e == "string" && !/(datadog|ddog|datad0g|dd0g)/.test(e) ? (sn.error("Site should be a valid Datadog site. ".concat(np, " ").concat(f0, "/getting_started/site/.")), !1) : !0;
}
function Sf(e, r) {
  return e !== void 0 && !eU(e) ? (sn.error("".concat(r, " Sample Rate should be a number between 0 and 100")), !1) : !0;
}
function dB(e) {
  var r, i, t, n, a;
  if (!e || !e.clientToken) {
    sn.error("Client Token is not configured, we will not send any data.");
    return;
  }
  if (!(!cB(e.site) || !Sf(e.sessionSampleRate, "Session") || !Sf(e.telemetrySampleRate, "Telemetry") || !Sf(e.telemetryConfigurationSampleRate, "Telemetry Configuration") || !Sf(e.telemetryUsageSampleRate, "Telemetry Usage") || !dg(e.version, "Version") || !dg(e.env, "Env") || !dg(e.service, "Service"))) {
    if (e.trackingConsent !== void 0 && !Xx(lv, e.trackingConsent)) {
      sn.error('Tracking Consent should be either "granted" or "not-granted"');
      return;
    }
    return Un({
      beforeSend: e.beforeSend && Yx(e.beforeSend, "beforeSend threw an error:"),
      sessionStoreStrategyType: WU(e),
      sessionSampleRate: (r = e.sessionSampleRate) !== null && r !== void 0 ? r : 100,
      telemetrySampleRate: (i = e.telemetrySampleRate) !== null && i !== void 0 ? i : 20,
      telemetryConfigurationSampleRate: (t = e.telemetryConfigurationSampleRate) !== null && t !== void 0 ? t : 5,
      telemetryUsageSampleRate: (n = e.telemetryUsageSampleRate) !== null && n !== void 0 ? n : 5,
      service: e.service || void 0,
      silentMultipleInit: !!e.silentMultipleInit,
      allowUntrustedEvents: !!e.allowUntrustedEvents,
      trackingConsent: (a = e.trackingConsent) !== null && a !== void 0 ? a : lv.GRANTED,
      storeContextsAcrossPages: !!e.storeContextsAcrossPages,
      batchBytesLimit: 16 * _o,
      eventRateLimiterThreshold: 3e3,
      maxTelemetryEventsPerPage: 15,
      flushTimeout: 30 * Ud,
      batchMessagesLimit: 50,
      messageBytesLimit: 256 * _o
    }, sB(e));
  }
}
function fB(e) {
  return {
    session_sample_rate: e.sessionSampleRate,
    telemetry_sample_rate: e.telemetrySampleRate,
    telemetry_configuration_sample_rate: e.telemetryConfigurationSampleRate,
    telemetry_usage_sample_rate: e.telemetryUsageSampleRate,
    use_before_send: !!e.beforeSend,
    use_cross_site_session_cookie: e.useCrossSiteSessionCookie,
    use_partitioned_cross_site_session_cookie: e.usePartitionedCrossSiteSessionCookie,
    use_secure_session_cookie: e.useSecureSessionCookie,
    use_proxy: !!e.proxy,
    silent_multiple_init: e.silentMultipleInit,
    track_session_across_subdomains: e.trackSessionAcrossSubdomains,
    allow_fallback_to_local_storage: !!e.allowFallbackToLocalStorage,
    store_contexts_across_pages: !!e.storeContextsAcrossPages,
    allow_untrusted_events: !!e.allowUntrustedEvents,
    tracking_consent: e.trackingConsent
  };
}
var cv;
(function(e) {
  e.WRITABLE_RESOURCE_GRAPHQL = "writable_resource_graphql", e.CUSTOM_VITALS = "custom_vitals", e.TOLERANT_RESOURCE_TIMINGS = "tolerant_resource_timings", e.REMOTE_CONFIGURATION = "remote_configuration", e.UPDATE_VIEW_NAME = "update_view_name";
})(cv || (cv = {}));
var dA = /* @__PURE__ */ new Set();
function hB(e) {
  Array.isArray(e) && pB(e.filter(function(r) {
    return Xx(cv, r);
  }));
}
function pB(e) {
  e.forEach(function(r) {
    dA.add(r);
  });
}
function gB() {
  return dA;
}
var $d = "?";
function Do(e) {
  var r = [], i = fg(e, "stack"), t = String(e);
  return i && g0(i, t) && (i = i.slice(t.length)), i && i.split(`
`).forEach(function(n) {
    var a = yB(n) || bB(n) || SB(n) || AB(n);
    a && (!a.func && a.line && (a.func = $d), r.push(a));
  }), {
    message: fg(e, "message"),
    name: fg(e, "name"),
    stack: r
  };
}
var fA = "((?:file|https?|blob|chrome-extension|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)", ic = "(?::(\\d+))", vB = new RegExp("^\\s*at (.*?) ?\\(".concat(fA).concat(ic, "?").concat(ic, "?\\)?\\s*$"), "i"), mB = new RegExp("\\((\\S*)".concat(ic).concat(ic, "\\)"));
function yB(e) {
  var r = vB.exec(e);
  if (!!r) {
    var i = r[2] && r[2].indexOf("native") === 0, t = r[2] && r[2].indexOf("eval") === 0, n = mB.exec(r[2]);
    return t && n && (r[2] = n[1], r[3] = n[2], r[4] = n[3]), {
      args: i ? [r[2]] : [],
      column: r[4] ? +r[4] : void 0,
      func: r[1] || $d,
      line: r[3] ? +r[3] : void 0,
      url: i ? void 0 : r[2]
    };
  }
}
var _B = new RegExp("^\\s*at ?".concat(fA).concat(ic, "?").concat(ic, "??\\s*$"), "i");
function bB(e) {
  var r = _B.exec(e);
  if (!!r)
    return {
      args: [],
      column: r[3] ? +r[3] : void 0,
      func: $d,
      line: r[2] ? +r[2] : void 0,
      url: r[1]
    };
}
var TB = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function SB(e) {
  var r = TB.exec(e);
  if (!!r)
    return {
      args: [],
      column: r[4] ? +r[4] : void 0,
      func: r[1] || $d,
      line: +r[3],
      url: r[2]
    };
}
var EB = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i, xB = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function AB(e) {
  var r = EB.exec(e);
  if (!!r) {
    var i = r[3] && r[3].indexOf(" > eval") > -1, t = xB.exec(r[3]);
    return i && t && (r[3] = t[1], r[4] = t[2], r[5] = void 0), {
      args: r[2] ? r[2].split(",") : [],
      column: r[5] ? +r[5] : void 0,
      func: r[1] || $d,
      line: r[4] ? +r[4] : void 0,
      url: r[3]
    };
  }
}
function fg(e, r) {
  if (!(typeof e != "object" || !e || !(r in e))) {
    var i = e[r];
    return typeof i == "string" ? i : void 0;
  }
}
function wB(e, r, i, t) {
  var n = [{ url: r, column: t, line: i }], a = DB(e), s = a.name, o = a.message;
  return {
    name: s,
    message: o,
    stack: n
  };
}
var CB = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function DB(e) {
  var r, i, t;
  return {}.toString.call(e) === "[object String]" && (r = CB.exec(e), i = r[1], t = r[2]), { name: i, message: t };
}
function ap() {
  var e = 2, r = new Error(), i;
  if (!r.stack)
    try {
      throw r;
    } catch {
    }
  return bd(function() {
    var t = Do(r);
    t.stack = t.stack.slice(e), i = ll(t);
  }), i;
}
function ll(e) {
  var r = hA(e);
  return e.stack.forEach(function(i) {
    var t = i.func === "?" ? "<anonymous>" : i.func, n = i.args && i.args.length > 0 ? "(".concat(i.args.join(", "), ")") : "", a = i.line ? ":".concat(i.line) : "", s = i.line && i.column ? ":".concat(i.column) : "";
    r += `
  at `.concat(t).concat(n, " @ ").concat(i.url).concat(a).concat(s);
  }), r;
}
function hA(e) {
  return "".concat(e.name || "Error", ": ").concat(e.message);
}
function zu(e, r, i, t) {
  var n = t === void 0 ? {} : t, a = n.computeHandlingStack, s = e[r];
  if (typeof s != "function")
    if (g0(r, "on"))
      s = au;
    else
      return { stop: au };
  var o = !1, l = function() {
    if (o)
      return s.apply(this, arguments);
    var u = p0(arguments), h;
    bd(i, null, [
      {
        target: this,
        parameters: u,
        onPostCall: function(d) {
          h = d;
        },
        handlingStack: a ? ap() : void 0
      }
    ]);
    var c = s.apply(this, u);
    return h && bd(h, null, [c]), c;
  };
  return e[r] = l, {
    stop: function() {
      o = !0, e[r] === l && (e[r] = s);
    }
  };
}
var kB = 220 * _o, RB = "$", PB = 3;
function bo(e, r) {
  r === void 0 && (r = kB);
  var i = Ml(Object.prototype), t = Ml(Array.prototype), n = [], a = /* @__PURE__ */ new WeakMap(), s = hg(e, RB, void 0, n, a), o = JSON.stringify(s), l = o ? o.length : 0;
  if (l > r) {
    pg(r, "discarded", e);
    return;
  }
  for (; n.length > 0 && l < r; ) {
    var u = n.shift(), h = 0;
    if (Array.isArray(u.source))
      for (var c = 0; c < u.source.length; c++) {
        var d = hg(u.source[c], u.path, c, n, a);
        if (d !== void 0 ? l += JSON.stringify(d).length : l += 4, l += h, h = 1, l > r) {
          pg(r, "truncated", e);
          break;
        }
        u.target[c] = d;
      }
    else
      for (var c in u.source)
        if (Object.prototype.hasOwnProperty.call(u.source, c)) {
          var d = hg(u.source[c], u.path, c, n, a);
          if (d !== void 0 && (l += JSON.stringify(d).length + h + c.length + PB, h = 1), l > r) {
            pg(r, "truncated", e);
            break;
          }
          u.target[c] = d;
        }
  }
  return i(), t(), s;
}
function hg(e, r, i, t, n) {
  var a = IB(e);
  if (!a || typeof a != "object")
    return OB(a);
  var s = LB(a);
  if (s !== "[Object]" && s !== "[Array]" && s !== "[Error]")
    return s;
  var o = e;
  if (n.has(o))
    return "[Reference seen at ".concat(n.get(o), "]");
  var l = i !== void 0 ? "".concat(r, ".").concat(i) : r, u = Array.isArray(a) ? [] : {};
  return n.set(o, l), t.push({ source: a, target: u, path: l }), u;
}
function OB(e) {
  return typeof e == "bigint" ? "[BigInt] ".concat(e.toString()) : typeof e == "function" ? "[Function] ".concat(e.name || "unknown") : typeof e == "symbol" ? "[Symbol] ".concat(e.description || e.toString()) : e;
}
function LB(e) {
  try {
    if (e instanceof Event)
      return {
        isTrusted: e.isTrusted
      };
    var r = Object.prototype.toString.call(e), i = r.match(/\[object (.*)\]/);
    if (i && i[1])
      return "[".concat(i[1], "]");
  } catch {
  }
  return "[Unserializable]";
}
function IB(e) {
  var r = e;
  if (r && typeof r.toJSON == "function")
    try {
      return r.toJSON();
    } catch {
    }
  return e;
}
function pg(e, r, i) {
  sn.warn("The data provided has been ".concat(r, " as it is over the limit of ").concat(e, " characters:"), i);
}
var pA = "No stack, consider using an instance of Error";
function gA(e) {
  var r = e.stackTrace, i = e.originalError, t = e.handlingStack, n = e.startClocks, a = e.nonErrorPrefix, s = e.source, o = e.handling, l = i instanceof Error, u = MB(r, l, a, i), h = NB(l, r) ? ll(r) : pA, c = l ? mA(i, s) : void 0, d = r ? r.name : void 0, f = vA(i);
  return {
    startClocks: n,
    source: s,
    handling: o,
    handlingStack: t,
    originalError: i,
    type: d,
    message: u,
    stack: h,
    causes: c,
    fingerprint: f
  };
}
function MB(e, r, i, t) {
  return (e == null ? void 0 : e.message) && (e == null ? void 0 : e.name) ? e.message : r ? "Empty message" : "".concat(i, " ").concat(ul(bo(t)));
}
function NB(e, r) {
  return r === void 0 ? !1 : e ? !0 : r.stack.length > 0 && (r.stack.length > 1 || r.stack[0].url !== void 0);
}
function vA(e) {
  return e instanceof Error && "dd_fingerprint" in e ? String(e.dd_fingerprint) : void 0;
}
function FB(e) {
  var r;
  return (r = /@ (.+)/.exec(e)) === null || r === void 0 ? void 0 : r[1];
}
function mA(e, r) {
  for (var i = e, t = []; (i == null ? void 0 : i.cause) instanceof Error && t.length < 10; ) {
    var n = Do(i.cause);
    t.push({
      message: i.cause.message,
      source: r,
      type: n == null ? void 0 : n.name,
      stack: n && ll(n)
    }), i = i.cause;
  }
  return t.length ? t : void 0;
}
var ms = {
  AGENT: "agent",
  CONSOLE: "console",
  CUSTOM: "custom",
  LOGGER: "logger",
  NETWORK: "network",
  SOURCE: "source",
  REPORT: "report"
};
function UB(e) {
  var r = function(n, a) {
    var s = gA({
      stackTrace: n,
      originalError: a,
      startClocks: mc(),
      nonErrorPrefix: "Uncaught",
      source: ms.SOURCE,
      handling: "unhandled"
    });
    e.notify(s);
  }, i = BB(r).stop, t = jB(r).stop;
  return {
    stop: function() {
      i(), t();
    }
  };
}
function BB(e) {
  return zu(window, "onerror", function(r) {
    var i = r.parameters, t = i[0], n = i[1], a = i[2], s = i[3], o = i[4], l;
    o instanceof Error ? l = Do(o) : l = wB(t, n, a, s), e(l, o != null ? o : t);
  });
}
function jB(e) {
  return zu(window, "onunhandledrejection", function(r) {
    var i = r.parameters[0], t = i.reason || "Empty reason", n = Do(t);
    e(n, t);
  });
}
function $B(e) {
  var r = Un({
    version: "5.23.3",
    onReady: function(i) {
      i();
    }
  }, e);
  return Object.defineProperty(r, "_setDebug", {
    get: function() {
      return pU;
    },
    enumerable: !1
  }), r;
}
function GB(e, r, i) {
  var t = e[r];
  t && !t.q && t.version && sn.warn("SDK is loaded more than once. This is unsupported and might have unexpected behavior."), e[r] = i, t && t.q && t.q.forEach(function(n) {
    return Yx(n, "onReady callback threw an error:")();
  });
}
function yA(e, r) {
  r.silentMultipleInit || sn.error("".concat(e, " is already initialized."));
}
function cl(e, r, i, t, n) {
  return E0(e, r, [i], t, n);
}
function E0(e, r, i, t, n) {
  var a = n === void 0 ? {} : n, s = a.once, o = a.capture, l = a.passive, u = pi(function(f) {
    !f.isTrusted && !f.__ddIsTrusted && !e.allowUntrustedEvents || (s && d(), t(f));
  }), h = l ? { capture: o, passive: l } : o, c = rc(r, "addEventListener");
  i.forEach(function(f) {
    return c.call(r, f, u, h);
  });
  function d() {
    var f = rc(r, "removeEventListener");
    i.forEach(function(m) {
      return f.call(r, m, u, h);
    });
  }
  return {
    stop: d
  };
}
var eu = {
  intervention: "intervention",
  deprecation: "deprecation",
  cspViolation: "csp_violation"
};
function HB(e, r) {
  var i = [];
  yc(r, eu.cspViolation) && i.push(qB(e));
  var t = r.filter(function(n) {
    return n !== eu.cspViolation;
  });
  return t.length && i.push(VB(t)), eA.apply(void 0, i);
}
function VB(e) {
  return new pn(function(r) {
    if (!!window.ReportingObserver) {
      var i = pi(function(n, a) {
        return n.forEach(function(s) {
          r.notify(WB(s));
        });
      }), t = new window.ReportingObserver(i, {
        types: e,
        buffered: !0
      });
      return t.observe(), function() {
        t.disconnect();
      };
    }
  });
}
function qB(e) {
  return new pn(function(r) {
    var i = cl(e, document, "securitypolicyviolation", function(t) {
      r.notify(YB(t));
    }).stop;
    return i;
  });
}
function WB(e) {
  var r = e.type, i = e.body;
  return {
    type: r,
    subtype: i.id,
    message: "".concat(r, ": ").concat(i.message),
    originalReport: e,
    stack: _A(i.id, i.message, i.sourceFile, i.lineNumber, i.columnNumber)
  };
}
function YB(e) {
  var r = eu.cspViolation, i = "'".concat(e.blockedURI, "' blocked by '").concat(e.effectiveDirective, "' directive");
  return {
    type: eu.cspViolation,
    subtype: e.effectiveDirective,
    message: "".concat(r, ": ").concat(i),
    stack: _A(e.effectiveDirective, e.originalPolicy ? "".concat(i, ' of the policy "').concat(yU(e.originalPolicy, 100, "..."), '"') : "no policy", e.sourceFile, e.lineNumber, e.columnNumber),
    originalReport: e
  };
}
function _A(e, r, i, t, n) {
  return i ? ll({
    name: e,
    message: r,
    stack: [
      {
        func: "?",
        url: i,
        line: t != null ? t : void 0,
        column: n != null ? n : void 0
      }
    ]
  }) : void 0;
}
function bA(e, r) {
  var i = window.__ddBrowserSdkExtensionCallback;
  i && i({ type: e, payload: r });
}
function x0(e) {
  return e === null ? "null" : Array.isArray(e) ? "array" : typeof e;
}
function _h(e, r, i) {
  if (i === void 0 && (i = KB()), r === void 0)
    return e;
  if (typeof r != "object" || r === null)
    return r;
  if (r instanceof Date)
    return new Date(r.getTime());
  if (r instanceof RegExp) {
    var t = r.flags || [
      r.global ? "g" : "",
      r.ignoreCase ? "i" : "",
      r.multiline ? "m" : "",
      r.sticky ? "y" : "",
      r.unicode ? "u" : ""
    ].join("");
    return new RegExp(r.source, t);
  }
  if (!i.hasAlreadyBeenSeen(r)) {
    if (Array.isArray(r)) {
      for (var n = Array.isArray(e) ? e : [], a = 0; a < r.length; ++a)
        n[a] = _h(n[a], r[a], i);
      return n;
    }
    var s = x0(e) === "object" ? e : {};
    for (var o in r)
      Object.prototype.hasOwnProperty.call(r, o) && (s[o] = _h(s[o], r[o], i));
    return s;
  }
}
function TA(e) {
  return _h(void 0, e);
}
function nc() {
  for (var e = [], r = 0; r < arguments.length; r++)
    e[r] = arguments[r];
  for (var i, t = 0, n = e; t < n.length; t++) {
    var a = n[t];
    a != null && (i = _h(i, a));
  }
  return i;
}
function KB() {
  if (typeof WeakSet < "u") {
    var e = /* @__PURE__ */ new WeakSet();
    return {
      hasAlreadyBeenSeen: function(i) {
        var t = e.has(i);
        return t || e.add(i), t;
      }
    };
  }
  var r = [];
  return {
    hasAlreadyBeenSeen: function(i) {
      var t = r.indexOf(i) >= 0;
      return t || r.push(i), t;
    }
  };
}
function zB() {
  var e, r = window.navigator;
  return {
    status: r.onLine ? "connected" : "not_connected",
    interfaces: r.connection && r.connection.type ? [r.connection.type] : void 0,
    effective_type: (e = r.connection) === null || e === void 0 ? void 0 : e.effectiveType
  };
}
function XB(e) {
  var r = /* @__PURE__ */ new Set();
  return e.forEach(function(i) {
    return r.add(i);
  }), p0(r);
}
function SA(e, r) {
  var i = e.indexOf(r);
  i >= 0 && e.splice(i, 1);
}
var JB = 500;
function EA() {
  var e = [], r = function(n) {
    var a = e.push(n);
    a > JB && e.splice(0, 1);
  }, i = function(n) {
    SA(e, n);
  }, t = function(n) {
    e.forEach(function(a) {
      return a(n);
    }), e.length = 0;
  };
  return {
    add: r,
    remove: i,
    drain: t
  };
}
var Xu = {
  log: "log",
  configuration: "configuration",
  usage: "usage"
}, QB = [
  "https://www.datadoghq-browser-agent.com",
  "https://www.datad0g-browser-agent.com",
  "https://d3uc069fcn7uxw.cloudfront.net",
  "https://d20xtzwzcl0ceb.cloudfront.net",
  "http://localhost",
  "<anonymous>"
], ZB = [ZU], xA = EA(), bc = function(e) {
  xA.add(function() {
    return bc(e);
  });
};
function e3(e, r) {
  var i, t, n = new pn(), a = /* @__PURE__ */ new Set(), s = !yc(ZB, r.site) && Of(r.telemetrySampleRate), o = (i = {}, i[Xu.log] = s, i[Xu.configuration] = s && Of(r.telemetryConfigurationSampleRate), i[Xu.usage] = s && Of(r.telemetryUsageSampleRate), i), l = t3();
  bc = function(h) {
    var c = ul(h);
    if (o[h.type] && a.size < r.maxTelemetryEventsPerPage && !a.has(c)) {
      var d = u(e, h, l);
      n.notify(d), bA("telemetry", d), a.add(c);
    }
  }, hU(wA);
  function u(h, c, d) {
    return nc({
      type: "telemetry",
      date: fu(),
      service: h,
      version: "5.23.3",
      source: "browser",
      _dd: {
        format_version: 2
      },
      telemetry: nc(c, {
        runtime_env: d,
        connectivity: zB()
      }),
      experimental_features: p0(gB())
    }, t !== void 0 ? t() : {});
  }
  return {
    setContextProvider: function(h) {
      t = h;
    },
    observable: n,
    enabled: s
  };
}
function t3() {
  return {
    is_local_file: window.location.protocol === "file:",
    is_worker: "WorkerGlobalScope" in self
  };
}
function r3() {
  xA.drain();
}
function i3(e) {
  return e.site === JU;
}
function AA(e, r) {
  uv(Vi.debug, e, r), bc(Un({
    type: Xu.log,
    message: e,
    status: "debug"
  }, r));
}
function wA(e, r) {
  bc(Un({
    type: Xu.log,
    status: "error"
  }, s3(e), r));
}
function n3(e) {
  bc({
    type: Xu.configuration,
    configuration: e
  });
}
function a3(e) {
  bc({
    type: Xu.usage,
    usage: e
  });
}
function s3(e) {
  if (e instanceof Error) {
    var r = Do(e);
    return {
      error: {
        kind: r.name,
        stack: ll(o3(r))
      },
      message: r.message
    };
  }
  return {
    error: {
      stack: pA
    },
    message: "".concat("Uncaught", " ").concat(ul(e))
  };
}
function o3(e) {
  return e.stack = e.stack.filter(function(r) {
    return !r.url || QB.some(function(i) {
      return g0(r.url, i);
    });
  }), e;
}
var Ef = 1 / 0, u3 = sl;
function l3(e) {
  var r = e.expireDelay, i = e.maxEntries, t = [], n = m0(function() {
    return a();
  }, u3);
  function a() {
    for (var d = gh() - r; t.length > 0 && t[t.length - 1].endTime < d; )
      t.pop();
  }
  function s(d, f) {
    var m = {
      value: d,
      startTime: f,
      endTime: Ef,
      remove: function() {
        SA(t, m);
      },
      close: function(p) {
        m.endTime = p;
      }
    };
    return i && t.length >= i && t.pop(), t.unshift(m), m;
  }
  function o(d, f) {
    d === void 0 && (d = Ef), f === void 0 && (f = { returnInactive: !1 });
    for (var m = 0, p = t; m < p.length; m++) {
      var b = p[m];
      if (b.startTime <= d) {
        if (f.returnInactive || d <= b.endTime)
          return b.value;
        break;
      }
    }
  }
  function l(d) {
    var f = t[0];
    f && f.endTime === Ef && f.close(d);
  }
  function u(d, f) {
    d === void 0 && (d = Ef), f === void 0 && (f = 0);
    var m = aU(d, f);
    return t.filter(function(p) {
      return p.startTime <= m && d <= p.endTime;
    }).map(function(p) {
      return p.value;
    });
  }
  function h() {
    t = [];
  }
  function c() {
    Zx(n);
  }
  return { add: s, find: o, closeActive: l, findAll: u, reset: h, stop: c };
}
var c3 = sl, d3 = _0;
function f3(e, r, i, t) {
  var n = new pn(), a = new pn(), s = YU(e.sessionStoreStrategyType, r, i), o = l3({
    expireDelay: d3
  });
  s.renewObservable.subscribe(function() {
    o.add(l(), gh()), n.notify();
  }), s.expireObservable.subscribe(function() {
    a.notify(), o.closeActive(gh());
  }), s.expandOrRenewSession(), o.add(l(), iU().relative), t.observable.subscribe(function() {
    t.isGranted() ? s.expandOrRenewSession() : s.expire();
  }), h3(e, function() {
    t.isGranted() && s.expandOrRenewSession();
  }), p3(e, function() {
    return s.expandSession();
  }), g3(e, function() {
    return s.restartSession();
  });
  function l() {
    return {
      id: s.getSession().id,
      trackingType: s.getSession()[r],
      isReplayForced: !!s.getSession().forcedReplay
    };
  }
  return {
    findSession: function(u, h) {
      return o.find(u, h);
    },
    renewObservable: n,
    expireObservable: a,
    sessionStateUpdateObservable: s.sessionStateUpdateObservable,
    expire: s.expire,
    updateSessionState: s.updateSessionState
  };
}
function h3(e, r) {
  E0(e, window, [
    "click",
    "touchstart",
    "keydown",
    "scroll"
  ], r, { capture: !0, passive: !0 }).stop;
}
function p3(e, r) {
  var i = function() {
    document.visibilityState === "visible" && r();
  };
  cl(e, document, "visibilitychange", i).stop, m0(i, c3);
}
function g3(e, r) {
  cl(e, window, "resume", r, { capture: !0 }).stop;
}
function CA(e) {
  return e >= 500;
}
function v3(e) {
  try {
    return e.clone();
  } catch {
    return;
  }
}
var m3 = 80 * _o, y3 = 32, DA = 3 * zx, _3 = sl, kA = Ud;
function RA(e, r, i, t, n) {
  r.transportStatus === 0 && r.queuedPayloads.size() === 0 && r.bandwidthMonitor.canHandle(e) ? OA(e, r, i, {
    onSuccess: function() {
      return LA(0, r, i, t, n);
    },
    onFailure: function() {
      r.queuedPayloads.enqueue(e), PA(r, i, t, n);
    }
  }) : r.queuedPayloads.enqueue(e);
}
function PA(e, r, i, t) {
  e.transportStatus === 2 && Bd(function() {
    var n = e.queuedPayloads.first();
    OA(n, e, r, {
      onSuccess: function() {
        e.queuedPayloads.dequeue(), e.currentBackoffTime = kA, LA(1, e, r, i, t);
      },
      onFailure: function() {
        e.currentBackoffTime = Math.min(_3, e.currentBackoffTime * 2), PA(e, r, i, t);
      }
    });
  }, e.currentBackoffTime);
}
function OA(e, r, i, t) {
  var n = t.onSuccess, a = t.onFailure;
  r.bandwidthMonitor.add(e), i(e, function(s) {
    r.bandwidthMonitor.remove(e), b3(s) ? (r.transportStatus = r.bandwidthMonitor.ongoingRequestCount > 0 ? 1 : 2, e.retry = {
      count: e.retry ? e.retry.count + 1 : 1,
      lastFailureStatus: s.status
    }, a()) : (r.transportStatus = 0, n());
  });
}
function LA(e, r, i, t, n) {
  e === 0 && r.queuedPayloads.isFull() && !r.queueFullReported && (n({
    message: "Reached max ".concat(t, " events size queued for upload: ").concat(DA / zx, "MiB"),
    source: ms.AGENT,
    startClocks: mc()
  }), r.queueFullReported = !0);
  var a = r.queuedPayloads;
  for (r.queuedPayloads = IA(); a.size() > 0; )
    RA(a.dequeue(), r, i, t, n);
}
function b3(e) {
  return e.type !== "opaque" && (e.status === 0 && !navigator.onLine || e.status === 408 || e.status === 429 || CA(e.status));
}
function T3() {
  return {
    transportStatus: 0,
    currentBackoffTime: kA,
    bandwidthMonitor: S3(),
    queuedPayloads: IA(),
    queueFullReported: !1
  };
}
function IA() {
  var e = [];
  return {
    bytesCount: 0,
    enqueue: function(r) {
      this.isFull() || (e.push(r), this.bytesCount += r.bytesCount);
    },
    first: function() {
      return e[0];
    },
    dequeue: function() {
      var r = e.shift();
      return r && (this.bytesCount -= r.bytesCount), r;
    },
    size: function() {
      return e.length;
    },
    isFull: function() {
      return this.bytesCount >= DA;
    }
  };
}
function S3() {
  return {
    ongoingRequestCount: 0,
    ongoingByteCount: 0,
    canHandle: function(e) {
      return this.ongoingRequestCount === 0 || this.ongoingByteCount + e.bytesCount <= m3 && this.ongoingRequestCount < y3;
    },
    add: function(e) {
      this.ongoingRequestCount += 1, this.ongoingByteCount += e.bytesCount;
    },
    remove: function(e) {
      this.ongoingRequestCount -= 1, this.ongoingByteCount -= e.bytesCount;
    }
  };
}
function E3(e, r, i, t) {
  var n = T3(), a = function(s, o) {
    return w3(e, r, i, s, o);
  };
  return {
    send: function(s) {
      RA(s, n, a, r.trackType, t);
    },
    sendOnExit: function(s) {
      x3(e, r, i, s);
    }
  };
}
function x3(e, r, i, t) {
  var n = !!navigator.sendBeacon && t.bytesCount < i;
  if (n)
    try {
      var a = r.build("beacon", t), s = navigator.sendBeacon(a, t.data);
      if (s)
        return;
    } catch (l) {
      A3(l);
    }
  var o = r.build("xhr", t);
  dv(e, o, t.data);
}
var Eb = !1;
function A3(e) {
  Eb || (Eb = !0, wA(e));
}
function w3(e, r, i, t, n) {
  var a = C3() && t.bytesCount < i;
  if (a) {
    var s = r.build("fetch", t);
    fetch(s, { method: "POST", body: t.data, keepalive: !0, mode: "cors" }).then(pi(function(l) {
      return n == null ? void 0 : n({ status: l.status, type: l.type });
    }), pi(function() {
      var l = r.build("xhr", t);
      dv(e, l, t.data, n);
    }));
  } else {
    var o = r.build("xhr", t);
    dv(e, o, t.data, n);
  }
}
function C3() {
  try {
    return window.Request && "keepalive" in new Request("http://a");
  } catch {
    return !1;
  }
}
function dv(e, r, i, t) {
  var n = new XMLHttpRequest();
  n.open("POST", r, !0), i instanceof Blob && n.setRequestHeader("Content-Type", i.type), cl(e, n, "loadend", function() {
    t == null || t({ status: n.status });
  }, {
    once: !0
  }), n.send(i);
}
function A0() {
  var e = D3();
  if (!!e)
    return {
      getCapabilities: function() {
        var r;
        return JSON.parse(((r = e.getCapabilities) === null || r === void 0 ? void 0 : r.call(e)) || "[]");
      },
      getPrivacyLevel: function() {
        var r;
        return (r = e.getPrivacyLevel) === null || r === void 0 ? void 0 : r.call(e);
      },
      getAllowedWebViewHosts: function() {
        return JSON.parse(e.getAllowedWebViewHosts());
      },
      send: function(r, i, t) {
        var n = t ? { id: t } : void 0;
        e.send(JSON.stringify({ eventType: r, event: i, view: n }));
      }
    };
}
function bh(e) {
  var r;
  e === void 0 && (e = (r = hu().location) === null || r === void 0 ? void 0 : r.hostname);
  var i = A0();
  return !!i && i.getAllowedWebViewHosts().some(function(t) {
    return e === t || cU(e, ".".concat(t));
  });
}
function D3() {
  return hu().DatadogEventBridge;
}
var Mf = {
  HIDDEN: "visibility_hidden",
  UNLOADING: "before_unload",
  PAGEHIDE: "page_hide",
  FROZEN: "page_frozen"
};
function k3(e) {
  return new pn(function(r) {
    var i = E0(e, window, [
      "visibilitychange",
      "freeze"
    ], function(n) {
      n.type === "visibilitychange" && document.visibilityState === "hidden" ? r.notify({ reason: Mf.HIDDEN }) : n.type === "freeze" && r.notify({ reason: Mf.FROZEN });
    }, { capture: !0 }).stop, t = cl(e, window, "beforeunload", function() {
      r.notify({ reason: Mf.UNLOADING });
    }).stop;
    return function() {
      i(), t();
    };
  });
}
function R3(e) {
  return yc(tc(Mf), e);
}
function P3(e) {
  var r = e.encoder, i = e.request, t = e.flushController, n = e.messageBytesLimit, a = {}, s = t.flushObservable.subscribe(function(d) {
    return c(d);
  });
  function o(d, f, m) {
    t.notifyBeforeAddMessage(f), m !== void 0 ? (a[m] = d, t.notifyAfterAddMessage()) : r.write(r.isEmpty ? d : `
`.concat(d), function(p) {
      t.notifyAfterAddMessage(p - f);
    });
  }
  function l(d) {
    return d !== void 0 && a[d] !== void 0;
  }
  function u(d) {
    var f = a[d];
    delete a[d];
    var m = r.estimateEncodedBytesCount(f);
    t.notifyAfterRemoveMessage(m);
  }
  function h(d, f) {
    var m = ul(d), p = r.estimateEncodedBytesCount(m);
    if (p >= n) {
      sn.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(n, "KB. ").concat(np, " ").concat(Wx, "/#technical-limitations"));
      return;
    }
    l(f) && u(f), o(m, p, f);
  }
  function c(d) {
    var f = tc(a).join(`
`);
    a = {};
    var m = R3(d.reason), p = m ? i.sendOnExit : i.send;
    if (m && r.isAsync) {
      var b = r.finishSync();
      b.outputBytesCount && p(xb(b));
      var y = [b.pendingData, f].filter(Boolean).join(`
`);
      y && p({
        data: y,
        bytesCount: h0(y)
      });
    } else
      f && r.write(r.isEmpty ? f : `
`.concat(f)), r.finish(function(v) {
        p(xb(v));
      });
  }
  return {
    flushController: t,
    add: h,
    upsert: h,
    stop: s.unsubscribe
  };
}
function xb(e) {
  var r;
  return typeof e.output == "string" ? r = e.output : r = new Blob([e.output], {
    type: "text/plain"
  }), {
    data: r,
    bytesCount: e.outputBytesCount,
    encoding: e.encoding
  };
}
function O3(e) {
  var r = e.messagesLimit, i = e.bytesLimit, t = e.durationLimit, n = e.pageExitObservable, a = e.sessionExpireObservable, s = n.subscribe(function(p) {
    return c(p.reason);
  }), o = a.subscribe(function() {
    return c("session_expire");
  }), l = new pn(function() {
    return function() {
      s.unsubscribe(), o.unsubscribe();
    };
  }), u = 0, h = 0;
  function c(p) {
    if (h !== 0) {
      var b = h, y = u;
      h = 0, u = 0, m(), l.notify({
        reason: p,
        messagesCount: b,
        bytesCount: y
      });
    }
  }
  var d;
  function f() {
    d === void 0 && (d = Bd(function() {
      c("duration_limit");
    }, t));
  }
  function m() {
    Qx(d), d = void 0;
  }
  return {
    flushObservable: l,
    get messagesCount() {
      return h;
    },
    notifyBeforeAddMessage: function(p) {
      u + p >= i && c("bytes_limit"), h += 1, u += p, f();
    },
    notifyAfterAddMessage: function(p) {
      p === void 0 && (p = 0), u += p, h >= r ? c("messages_limit") : u >= i && c("bytes_limit");
    },
    notifyAfterRemoveMessage: function(p) {
      u -= p, h -= 1, h === 0 && m();
    }
  };
}
function MA(e, r, i, t, n, a, s) {
  s === void 0 && (s = P3);
  var o = u(e, r), l = i && u(e, i);
  function u(h, c) {
    var d = c.endpoint, f = c.encoder;
    return s({
      encoder: f,
      request: E3(h, d, h.batchBytesLimit, t),
      flushController: O3({
        messagesLimit: h.batchMessagesLimit,
        bytesLimit: h.batchBytesLimit,
        durationLimit: h.flushTimeout,
        pageExitObservable: n,
        sessionExpireObservable: a
      }),
      messageBytesLimit: h.messageBytesLimit
    });
  }
  return {
    flushObservable: o.flushController.flushObservable,
    add: function(h, c) {
      c === void 0 && (c = !0), o.add(h), l && c && l.add(i.transformMessage ? i.transformMessage(h) : h);
    },
    upsert: function(h, c) {
      o.upsert(h, c), l && l.upsert(i.transformMessage ? i.transformMessage(h) : h, c);
    },
    stop: function() {
      o.stop(), l && l.stop();
    }
  };
}
function Th() {
  var e = "", r = 0;
  return {
    isAsync: !1,
    get isEmpty() {
      return !e;
    },
    write: function(i, t) {
      var n = h0(i);
      r += n, e += i, t && t(n);
    },
    finish: function(i) {
      i(this.finishSync());
    },
    finishSync: function() {
      var i = {
        output: e,
        outputBytesCount: r,
        rawBytesCount: r,
        pendingData: ""
      };
      return e = "", r = 0, i;
    },
    estimateEncodedBytesCount: function(i) {
      return i.length;
    }
  };
}
var L3 = function() {
  function e() {
    this.callbacks = {};
  }
  return e.prototype.notify = function(r, i) {
    var t = this.callbacks[r];
    t && t.forEach(function(n) {
      return n(i);
    });
  }, e.prototype.subscribe = function(r, i) {
    var t = this;
    return this.callbacks[r] || (this.callbacks[r] = []), this.callbacks[r].push(i), {
      unsubscribe: function() {
        t.callbacks[r] = t.callbacks[r].filter(function(n) {
          return i !== n;
        });
      }
    };
  }, e;
}();
function I3(e, r, i) {
  var t = 0, n = !1;
  return {
    isLimitReached: function() {
      if (t === 0 && Bd(function() {
        t = 0;
      }, sl), t += 1, t <= r || n)
        return n = !1, !1;
      if (t === r + 1) {
        n = !0;
        try {
          i({
            message: "Reached max number of ".concat(e, "s by minute: ").concat(r),
            source: ms.AGENT,
            startClocks: mc()
          });
        } finally {
          n = !1;
        }
      }
      return !0;
    }
  };
}
var gg, w0 = /* @__PURE__ */ new WeakMap();
function M3(e) {
  return gg || (gg = N3(e)), gg;
}
function N3(e) {
  return new pn(function(r) {
    var i = zu(XMLHttpRequest.prototype, "open", F3).stop, t = zu(XMLHttpRequest.prototype, "send", function(a) {
      U3(a, e, r);
    }, { computeHandlingStack: !0 }).stop, n = zu(XMLHttpRequest.prototype, "abort", B3).stop;
    return function() {
      i(), t(), n();
    };
  });
}
function F3(e) {
  var r = e.target, i = e.parameters, t = i[0], n = i[1];
  w0.set(r, {
    state: "open",
    method: String(t).toUpperCase(),
    url: S0(String(n))
  });
}
function U3(e, r, i) {
  var t = e.target, n = e.handlingStack, a = w0.get(t);
  if (!!a) {
    var s = a;
    s.state = "start", s.startClocks = mc(), s.isAborted = !1, s.xhr = t, s.handlingStack = n;
    var o = !1, l = zu(t, "onreadystatechange", function() {
      t.readyState === XMLHttpRequest.DONE && u();
    }).stop, u = function() {
      if (h(), l(), !o) {
        o = !0;
        var c = a;
        c.state = "complete", c.duration = nU(s.startClocks.timeStamp, fu()), c.status = t.status, i.notify(dU(c));
      }
    }, h = cl(r, t, "loadend", u).stop;
    i.notify(s);
  }
}
function B3(e) {
  var r = e.target, i = w0.get(r);
  i && (i.isAborted = !0);
}
var vg;
function NA() {
  return vg || (vg = j3()), vg;
}
function j3() {
  return new pn(function(e) {
    if (!!window.fetch) {
      var r = zu(window, "fetch", function(i) {
        return $3(i, e);
      }, {
        computeHandlingStack: !0
      }).stop;
      return r;
    }
  });
}
function $3(e, r) {
  var i = e.parameters, t = e.onPostCall, n = e.handlingStack, a = i[0], s = i[1], o = s && s.method;
  o === void 0 && a instanceof Request && (o = a.method);
  var l = o !== void 0 ? String(o).toUpperCase() : "GET", u = a instanceof Request ? a.url : S0(String(a)), h = mc(), c = {
    state: "start",
    init: s,
    input: a,
    method: l,
    startClocks: h,
    url: u,
    handlingStack: n
  };
  r.notify(c), i[0] = c.input, i[1] = c.init, t(function(d) {
    return G3(r, d, c);
  });
}
function G3(e, r, i) {
  var t = i;
  function n(a) {
    t.state = "resolve", Un(t, a), e.notify(t);
  }
  r.then(pi(function(a) {
    n({
      response: a,
      responseType: a.type,
      status: a.status,
      isAborted: !1
    });
  }), pi(function(a) {
    var s, o;
    n({
      status: 0,
      isAborted: ((o = (s = t.init) === null || s === void 0 ? void 0 : s.signal) === null || o === void 0 ? void 0 : o.aborted) || a instanceof DOMException && a.code === DOMException.ABORT_ERR,
      error: a
    });
  }));
}
var mg = {};
function H3(e) {
  var r = e.map(function(i) {
    return mg[i] || (mg[i] = V3(i)), mg[i];
  });
  return eA.apply(void 0, r);
}
function V3(e) {
  return new pn(function(r) {
    var i = Is[e];
    return Is[e] = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      i.apply(console, t);
      var a = ap();
      bd(function() {
        r.notify(q3(t, e, a));
      });
    }, function() {
      Is[e] = i;
    };
  });
}
function q3(e, r, i) {
  var t = e.map(function(l) {
    return W3(l);
  }).join(" "), n, a, s;
  if (r === Vi.error) {
    var o = uU(e, function(l) {
      return l instanceof Error;
    });
    n = o ? ll(Do(o)) : void 0, a = vA(o), s = o ? mA(o, "console") : void 0;
  }
  return {
    api: r,
    message: t,
    stack: n,
    handlingStack: i,
    fingerprint: a,
    causes: s
  };
}
function W3(e) {
  return typeof e == "string" ? bo(e) : e instanceof Error ? hA(Do(e)) : ul(bo(e), void 0, 2);
}
function fv(e) {
  var r = {}, i = new pn(), t = {
    getContext: function() {
      return TA(r);
    },
    setContext: function(n) {
      x0(n) === "object" ? (r = bo(n), e.updateCustomerData(r)) : t.clearContext(), i.notify();
    },
    setContextProperty: function(n, a) {
      r[n] = bo(a), e.updateCustomerData(r), i.notify();
    },
    removeContextProperty: function(n) {
      delete r[n], e.updateCustomerData(r), i.notify();
    },
    clearContext: function() {
      r = {}, e.resetCustomerData(), i.notify();
    },
    changeObservable: i
  };
  return t;
}
var Y3 = "_dd_c", K3 = [];
function Ab(e, r, i, t) {
  var n = z3(i, t);
  K3.push(cl(e, window, "storage", function(l) {
    var u = l.key;
    n === u && a();
  })), r.changeObservable.subscribe(s), r.setContext(nc(o(), r.getContext()));
  function a() {
    r.setContext(o());
  }
  function s() {
    localStorage.setItem(n, JSON.stringify(r.getContext()));
  }
  function o() {
    var l = localStorage.getItem(n);
    return l !== null ? JSON.parse(l) : {};
  }
}
function z3(e, r) {
  return "".concat(Y3, "_").concat(e, "_").concat(r);
}
var X3 = 3 * _o, J3 = 16 * _o, Q3 = 200;
function Z3(e) {
  e === void 0 && (e = 2);
  var r = /* @__PURE__ */ new Map(), i = !1;
  function t(n) {
    if (n === void 0 && (n = 0), !(i || e === 0)) {
      var a = e === 2 ? X3 : J3, s = n;
      r.forEach(function(o) {
        s += o.getBytesCount();
      }), s > a && (ej(a), i = !0);
    }
  }
  return {
    createDetachedTracker: function() {
      var n = wb(function() {
        return t(n.getBytesCount());
      });
      return n;
    },
    getOrCreateTracker: function(n) {
      return r.has(n) || r.set(n, wb(t)), r.get(n);
    },
    setCompressionStatus: function(n) {
      e === 0 && (e = n, t());
    },
    getCompressionStatus: function() {
      return e;
    },
    stop: function() {
      r.forEach(function(n) {
        return n.stop();
      }), r.clear();
    }
  };
}
function wb(e) {
  var r = 0, i = tA(function(s) {
    r = h0(ul(s)), e();
  }, Q3), t = i.throttled, n = i.cancel, a = function() {
    n(), r = 0;
  };
  return {
    updateCustomerData: function(s) {
      v0(s) ? a() : t(s);
    },
    resetCustomerData: a,
    getBytesCount: function() {
      return r;
    },
    stop: function() {
      n();
    }
  };
}
function ej(e) {
  sn.warn("Customer data exceeds the recommended ".concat(e / _o, "KiB threshold. ").concat(np, " ").concat(Wx, "/#customer-data-exceeds-the-recommended-threshold-warning"));
}
function tj(e, r, i) {
  var t = e.getReader(), n = [], a = 0;
  s();
  function s() {
    t.read().then(pi(function(l) {
      if (l.done) {
        o();
        return;
      }
      i.collectStreamBody && n.push(l.value), a += l.value.length, a > i.bytesLimit ? o() : s();
    }), pi(function(l) {
      return r(l);
    }));
  }
  function o() {
    t.cancel().catch(
      au
    );
    var l, u;
    if (i.collectStreamBody) {
      var h;
      if (n.length === 1)
        h = n[0];
      else {
        h = new Uint8Array(a);
        var c = 0;
        n.forEach(function(d) {
          h.set(d, c), c += d.length;
        });
      }
      l = h.slice(0, i.bytesLimit), u = h.length > i.bytesLimit;
    }
    r(void 0, l, u);
  }
}
var rj = "datadog-synthetics-public-id", ij = "datadog-synthetics-result-id", nj = "datadog-synthetics-injects-rum";
function FA() {
  return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || $u(nj));
}
function aj() {
  var e = window._DATADOG_SYNTHETICS_PUBLIC_ID || $u(rj);
  return typeof e == "string" ? e : void 0;
}
function sj() {
  var e = window._DATADOG_SYNTHETICS_RESULT_ID || $u(ij);
  return typeof e == "string" ? e : void 0;
}
function Cb(e) {
  var r = Un({}, e), i = ["id", "name", "email"];
  return i.forEach(function(t) {
    t in r && (r[t] = String(r[t]));
  }), r;
}
function oj(e) {
  var r = x0(e) === "object";
  return r || sn.error("Unsupported user:", e), r;
}
var as;
function Sh(e, r, i) {
  var t = i.getHandler(), n = Array.isArray(t) ? t : [t];
  return Db[e] >= Db[i.getLevel()] && yc(n, r);
}
var Sr = {
  ok: "ok",
  debug: "debug",
  info: "info",
  notice: "notice",
  warn: "warn",
  error: "error",
  critical: "critical",
  alert: "alert",
  emerg: "emerg"
}, Db = (as = {}, as[Sr.ok] = 0, as[Sr.debug] = 1, as[Sr.info] = 2, as[Sr.notice] = 4, as[Sr.warn] = 5, as[Sr.error] = 6, as[Sr.critical] = 7, as[Sr.alert] = 8, as[Sr.emerg] = 9, as), uj = function(e, r, i, t) {
  var n = arguments.length, a = n < 3 ? r : t === null ? t = Object.getOwnPropertyDescriptor(r, i) : t, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(e, r, i, t);
  else
    for (var o = e.length - 1; o >= 0; o--)
      (s = e[o]) && (a = (n < 3 ? s(a) : n > 3 ? s(r, i, a) : s(r, i)) || a);
  return n > 3 && a && Object.defineProperty(r, i, a), a;
}, Td = {
  console: "console",
  http: "http",
  silent: "silent"
}, lj = Object.keys(Sr), ps = function() {
  function e(r, i, t, n, a, s) {
    n === void 0 && (n = Td.http), a === void 0 && (a = Sr.debug), s === void 0 && (s = {}), this.handleLogStrategy = r, this.handlerType = n, this.level = a, this.contextManager = fv(i), this.contextManager.setContext(s), t && this.contextManager.setContextProperty("logger", { name: t });
  }
  return e.prototype.logImplementation = function(r, i, t, n, a) {
    t === void 0 && (t = Sr.info);
    var s;
    if (n != null) {
      var o = n instanceof Error ? Do(n) : void 0, l = gA({
        stackTrace: o,
        originalError: n,
        nonErrorPrefix: "Provided",
        source: ms.LOGGER,
        handling: "handled",
        startClocks: mc()
      });
      s = {
        stack: l.stack,
        kind: l.type,
        message: l.message,
        causes: l.causes
      };
    }
    var u = bo(i), h = s ? nc({ error: s }, u) : u;
    this.handleLogStrategy({
      message: bo(r),
      context: h,
      status: t
    }, this, a);
  }, e.prototype.log = function(r, i, t, n) {
    t === void 0 && (t = Sr.info);
    var a;
    Sh(t, Td.http, this) && (a = ap()), this.logImplementation(r, i, t, n, a);
  }, e.prototype.setContext = function(r) {
    this.contextManager.setContext(r);
  }, e.prototype.getContext = function() {
    return this.contextManager.getContext();
  }, e.prototype.setContextProperty = function(r, i) {
    this.contextManager.setContextProperty(r, i);
  }, e.prototype.removeContextProperty = function(r) {
    this.contextManager.removeContextProperty(r);
  }, e.prototype.clearContext = function() {
    this.contextManager.clearContext();
  }, e.prototype.setHandler = function(r) {
    this.handlerType = r;
  }, e.prototype.getHandler = function() {
    return this.handlerType;
  }, e.prototype.setLevel = function(r) {
    this.level = r;
  }, e.prototype.getLevel = function() {
    return this.level;
  }, uj([
    gU
  ], e.prototype, "logImplementation", null), e;
}();
ps.prototype.ok = ko(Sr.ok);
ps.prototype.debug = ko(Sr.debug);
ps.prototype.info = ko(Sr.info);
ps.prototype.notice = ko(Sr.notice);
ps.prototype.warn = ko(Sr.warn);
ps.prototype.error = ko(Sr.error);
ps.prototype.critical = ko(Sr.critical);
ps.prototype.alert = ko(Sr.alert);
ps.prototype.emerg = ko(Sr.emerg);
function ko(e) {
  return function(r, i, t) {
    var n;
    Sh(e, Td.http, this) && (n = ap()), this.logImplementation(r, i, e, t, n);
  };
}
function cj(e, r) {
  return {
    view: {
      referrer: document.referrer,
      url: window.location.href
    },
    context: e.getContext(),
    user: r.getContext()
  };
}
var dj = 32 * _o;
function fj(e) {
  e.usePciIntake === !0 && e.site && e.site !== "datadoghq.com" && sn.warn("PCI compliance for Logs is only available for Datadog organizations in the US1 site. Default intake will be used.");
  var r = dB(e), i = kb(e.forwardConsoleLogs, tc(Vi), "Forward Console Logs"), t = kb(e.forwardReports, tc(eu), "Forward Reports");
  if (!(!r || !i || !t))
    return e.forwardErrorsToLogs && !yc(i, Vi.error) && i.push(Vi.error), Un({
      forwardErrorsToLogs: e.forwardErrorsToLogs !== !1,
      forwardConsoleLogs: i,
      forwardReports: t,
      requestErrorResponseLengthLimit: dj,
      sendLogsAfterSessionExpiration: !!e.sendLogsAfterSessionExpiration
    }, r);
}
function kb(e, r, i) {
  if (e === void 0)
    return [];
  if (!(e === "all" || Array.isArray(e) && e.every(function(t) {
    return yc(r, t);
  }))) {
    sn.error("".concat(i, ' should be "all" or an array with allowed values "').concat(r.join('", "'), '"'));
    return;
  }
  return e === "all" ? r : XB(e);
}
function hj(e) {
  var r = fB(e);
  return Un({
    forward_errors_to_logs: e.forwardErrorsToLogs,
    forward_console_logs: e.forwardConsoleLogs,
    forward_reports: e.forwardReports,
    use_pci_intake: e.usePciIntake,
    send_logs_after_session_expiration: e.sendLogsAfterSessionExpiration
  }, r);
}
function pj(e, r, i) {
  var t = EA(), n, a, s = r.observable.subscribe(o);
  function o() {
    if (!(!a || !n || !r.isGranted())) {
      s.unsubscribe();
      var l = i(n, a);
      t.drain(l);
    }
  }
  return {
    init: function(l) {
      if (!l) {
        sn.error("Missing configuration");
        return;
      }
      if (hB(l.enableExperimentalFeatures), bh() && (l = gj(l)), n = l, a) {
        yA("DD_LOGS", l);
        return;
      }
      var u = fj(l);
      !u || (a = u, NA().subscribe(au), r.tryToInit(u.trackingConsent), o());
    },
    get initConfiguration() {
      return n;
    },
    getInternalContext: au,
    handleLog: function(l, u, h, c, d) {
      c === void 0 && (c = e()), d === void 0 && (d = fu()), t.add(function(f) {
        return f.handleLog(l, u, h, c, d);
      });
    }
  };
}
function gj(e) {
  return Un({}, e, { clientToken: "empty" });
}
var Rb = "logs";
function vj(e) {
  var r = Z3(), i = fv(r.getOrCreateTracker(
    2
  )), t = fv(r.getOrCreateTracker(
    1
  )), n = KU();
  function a() {
    return cj(i, t);
  }
  var s = pj(a, n, function(u, h) {
    u.storeContextsAcrossPages && (Ab(
      h,
      i,
      Rb,
      2
    ), Ab(
      h,
      t,
      Rb,
      1
    ));
    var c = e(u, h, a, n);
    return s = mj(u, c), c;
  }), o = {}, l = new ps(function() {
    for (var u = [], h = 0; h < arguments.length; h++)
      u[h] = arguments[h];
    return s.handleLog.apply(s, u);
  }, r.createDetachedTracker());
  return $B({
    logger: l,
    init: pi(function(u) {
      return s.init(u);
    }),
    setTrackingConsent: pi(function(u) {
      n.update(u), a3({ feature: "set-tracking-consent", tracking_consent: u });
    }),
    getGlobalContext: pi(function() {
      return i.getContext();
    }),
    setGlobalContext: pi(function(u) {
      return i.setContext(u);
    }),
    setGlobalContextProperty: pi(function(u, h) {
      return i.setContextProperty(u, h);
    }),
    removeGlobalContextProperty: pi(function(u) {
      return i.removeContextProperty(u);
    }),
    clearGlobalContext: pi(function() {
      return i.clearContext();
    }),
    createLogger: pi(function(u, h) {
      return h === void 0 && (h = {}), o[u] = new ps(function() {
        for (var c = [], d = 0; d < arguments.length; d++)
          c[d] = arguments[d];
        return s.handleLog.apply(s, c);
      }, r.createDetachedTracker(), bo(u), h.handler, h.level, bo(h.context)), o[u];
    }),
    getLogger: pi(function(u) {
      return o[u];
    }),
    getInitConfiguration: pi(function() {
      return TA(s.initConfiguration);
    }),
    getInternalContext: pi(function(u) {
      return s.getInternalContext(u);
    }),
    setUser: pi(function(u) {
      oj(u) && t.setContext(Cb(u));
    }),
    getUser: pi(function() {
      return t.getContext();
    }),
    setUserProperty: pi(function(u, h) {
      var c, d = Cb((c = {}, c[u] = h, c))[u];
      t.setContextProperty(u, d);
    }),
    removeUserProperty: pi(function(u) {
      return t.removeContextProperty(u);
    }),
    clearUser: pi(function() {
      return t.clearContext();
    })
  });
}
function mj(e, r) {
  return Un({
    init: function(i) {
      yA("DD_LOGS", i);
    },
    initConfiguration: e
  }, r);
}
var yj = "logs";
function _j(e, r) {
  var i = f3(e, yj, function(t) {
    return Tj(e, t);
  }, r);
  return {
    findTrackedSession: function(t, n) {
      n === void 0 && (n = { returnInactive: !1 });
      var a = i.findSession(t, n);
      return a && a.trackingType === "1" ? {
        id: a.id
      } : void 0;
    },
    expireObservable: i.expireObservable
  };
}
function bj(e) {
  var r = UA(e) === "1", i = r ? {} : void 0;
  return {
    findTrackedSession: function() {
      return i;
    },
    expireObservable: new pn()
  };
}
function UA(e) {
  return Of(e.sessionSampleRate) ? "1" : "0";
}
function Tj(e, r) {
  var i = Sj(r) ? r : UA(e);
  return {
    trackingType: i,
    isTracked: i === "1"
  };
}
function Sj(e) {
  return e === "0" || e === "1";
}
var Pb = !1;
function Nf(e) {
  var r = window;
  if (FA()) {
    var i = t(r.DD_RUM_SYNTHETICS);
    return !i && !Pb && (Pb = !0, AA("Logs sent before RUM is injected by the synthetics worker", {
      testId: aj(),
      resultId: sj()
    })), i;
  }
  return t(r.DD_RUM);
  function t(n) {
    if (n && n.getInternalContext)
      return n.getInternalContext(e);
  }
}
function Ej(e, r, i, t, n) {
  var a = lj.concat(["custom"]), s = {};
  a.forEach(function(o) {
    s[o] = I3(o, r.eventRateLimiterThreshold, n);
  }), i.subscribe(0, function(o) {
    var l, u, h = o.rawLogsEvent, c = o.messageContext, d = c === void 0 ? void 0 : c, f = o.savedCommonContext, m = f === void 0 ? void 0 : f, p = o.domainContext, b = sU(h.date), y = e.findTrackedSession(b);
    if (!(!y && (!r.sendLogsAfterSessionExpiration || !e.findTrackedSession(b, { returnInactive: !0 })))) {
      var v = m || t(), g = nc({
        service: r.service,
        session_id: y ? y.id : void 0,
        usr: v0(v.user) ? void 0 : v.user,
        view: v.view
      }, v.context, Nf(b), h, d);
      ((l = r.beforeSend) === null || l === void 0 ? void 0 : l.call(r, g, p)) === !1 || g.origin !== ms.AGENT && ((u = s[g.status]) !== null && u !== void 0 ? u : s.custom).isLimitReached() || i.notify(1, g);
    }
  });
}
var Pu, xj = (Pu = {}, Pu[Vi.log] = Sr.info, Pu[Vi.debug] = Sr.debug, Pu[Vi.info] = Sr.info, Pu[Vi.warn] = Sr.warn, Pu[Vi.error] = Sr.error, Pu);
function Aj(e, r) {
  var i = H3(e.forwardConsoleLogs).subscribe(function(t) {
    var n = {
      rawLogsEvent: {
        date: fu(),
        message: t.message,
        origin: ms.CONSOLE,
        error: t.api === Vi.error ? {
          stack: t.stack,
          fingerprint: t.fingerprint,
          causes: t.causes
        } : void 0,
        status: xj[t.api]
      },
      domainContext: {
        handlingStack: t.handlingStack
      }
    };
    r.notify(0, n);
  });
  return {
    stop: function() {
      i.unsubscribe();
    }
  };
}
var $c, wj = ($c = {}, $c[eu.cspViolation] = Sr.error, $c[eu.intervention] = Sr.error, $c[eu.deprecation] = Sr.warn, $c);
function Cj(e, r) {
  var i = HB(e, e.forwardReports).subscribe(function(t) {
    var n = t.message, a = wj[t.type], s;
    a === Sr.error ? s = {
      kind: t.subtype,
      stack: t.stack
    } : t.stack && (n += " Found in ".concat(FB(t.stack))), r.notify(0, {
      rawLogsEvent: {
        date: fu(),
        message: n,
        origin: ms.REPORT,
        error: s,
        status: a
      }
    });
  });
  return {
    stop: function() {
      i.unsubscribe();
    }
  };
}
function Dj(e, r) {
  if (!e.forwardErrorsToLogs)
    return { stop: au };
  var i = M3(e).subscribe(function(a) {
    a.state === "complete" && n("xhr", a);
  }), t = NA().subscribe(function(a) {
    a.state === "resolve" && n("fetch", a);
  });
  function n(a, s) {
    !e.isIntakeUrl(s.url) && (Oj(s) || CA(s.status)) && ("xhr" in s ? kj(s.xhr, e, o) : s.response ? Pj(s.response, e, o) : s.error && Rj(s.error, e, o));
    function o(l) {
      var u = {
        isAborted: s.isAborted,
        handlingStack: s.handlingStack
      };
      r.notify(0, {
        rawLogsEvent: {
          message: "".concat(Lj(a), " error ").concat(s.method, " ").concat(s.url),
          date: s.startClocks.timeStamp,
          error: {
            stack: l || "Failed to load"
          },
          http: {
            method: s.method,
            status_code: s.status,
            url: s.url
          },
          status: Sr.error,
          origin: ms.NETWORK
        },
        domainContext: u
      });
    }
  }
  return {
    stop: function() {
      i.unsubscribe(), t.unsubscribe();
    }
  };
}
function kj(e, r, i) {
  typeof e.response == "string" ? i(C0(e.response, r)) : i(e.response);
}
function Rj(e, r, i) {
  i(C0(ll(Do(e)), r));
}
function Pj(e, r, i) {
  var t = v3(e);
  !t || !t.body ? i() : window.TextDecoder ? Ij(t.body, r.requestErrorResponseLengthLimit, function(n, a) {
    i(n ? "Unable to retrieve response: ".concat(n) : a);
  }) : t.text().then(pi(function(n) {
    return i(C0(n, r));
  }), pi(function(n) {
    return i("Unable to retrieve response: ".concat(n));
  }));
}
function Oj(e) {
  return e.status === 0 && e.responseType !== "opaque";
}
function C0(e, r) {
  return e.length > r.requestErrorResponseLengthLimit ? "".concat(e.substring(0, r.requestErrorResponseLengthLimit), "...") : e;
}
function Lj(e) {
  return e === "xhr" ? "XHR" : "Fetch";
}
function Ij(e, r, i) {
  tj(e, function(t, n, a) {
    if (t)
      i(t);
    else {
      var s = new TextDecoder().decode(n);
      a && (s += "..."), i(void 0, s);
    }
  }, {
    bytesLimit: r,
    collectStreamBody: !0
  });
}
function Mj(e, r) {
  if (!e.forwardErrorsToLogs)
    return { stop: au };
  var i = new pn(), t = UB(i).stop, n = i.subscribe(function(a) {
    r.notify(0, {
      rawLogsEvent: {
        message: a.message,
        date: a.startClocks.timeStamp,
        error: {
          kind: a.type,
          stack: a.stack,
          causes: a.causes
        },
        origin: ms.SOURCE,
        status: Sr.error
      }
    });
  });
  return {
    stop: function() {
      t(), n.unsubscribe();
    }
  };
}
var Nj = L3, ss;
function Fj(e) {
  function r(i, t, n, a, s) {
    var o = nc(t.getContext(), i.context);
    if (Sh(i.status, Td.console, t) && Bj(i, o), Sh(i.status, Td.http, t)) {
      var l = {
        rawLogsEvent: {
          date: s || fu(),
          message: i.message,
          status: i.status,
          origin: ms.LOGGER
        },
        messageContext: o,
        savedCommonContext: a
      };
      n && (l.domainContext = { handlingStack: n }), e.notify(0, l);
    }
  }
  return {
    handleLog: r
  };
}
var Uj = (ss = {}, ss[Sr.ok] = Vi.debug, ss[Sr.debug] = Vi.debug, ss[Sr.info] = Vi.info, ss[Sr.notice] = Vi.info, ss[Sr.warn] = Vi.warn, ss[Sr.error] = Vi.error, ss[Sr.critical] = Vi.error, ss[Sr.alert] = Vi.error, ss[Sr.emerg] = Vi.error, ss);
function Bj(e, r) {
  var i = e.status, t = e.message;
  Mu[Uj[i]].call(Is, t, r);
}
function jj(e, r, i, t, n) {
  var a = MA(e, {
    endpoint: e.logsEndpointBuilder,
    encoder: Th()
  }, e.replica && {
    endpoint: e.replica.logsEndpointBuilder,
    encoder: Th()
  }, i, t, n.expireObservable);
  return r.subscribe(1, function(s) {
    a.add(s);
  }), a;
}
function $j(e) {
  var r = A0();
  e.subscribe(1, function(i) {
    r.send("log", i);
  });
}
function Gj(e) {
  return {
    get: function(r) {
      var i = e.findTrackedSession(r);
      if (i)
        return {
          session_id: i.id
        };
    }
  };
}
function Hj(e) {
  return function(r) {
    e.notify(0, {
      rawLogsEvent: {
        message: r.message,
        date: r.startClocks.timeStamp,
        origin: ms.AGENT,
        status: Sr.error
      }
    }), AA("Error reported to customer", { "error.message": r.message });
  };
}
function Vj(e, r, i, t, n) {
  var a = e3("browser-logs-sdk", r);
  a.setContextProvider(function() {
    var c, d, f, m, p, b;
    return {
      application: {
        id: (c = Nf()) === null || c === void 0 ? void 0 : c.application_id
      },
      session: {
        id: (d = n.findTrackedSession()) === null || d === void 0 ? void 0 : d.id
      },
      view: {
        id: (m = (f = Nf()) === null || f === void 0 ? void 0 : f.view) === null || m === void 0 ? void 0 : m.id
      },
      action: {
        id: (b = (p = Nf()) === null || p === void 0 ? void 0 : p.user_action) === null || b === void 0 ? void 0 : b.id
      }
    };
  });
  var s = [];
  if (bh()) {
    var o = A0(), l = a.observable.subscribe(function(c) {
      return o.send("internal_telemetry", c);
    });
    s.push(function() {
      return l.unsubscribe();
    });
  } else {
    var u = MA(r, {
      endpoint: r.rumEndpointBuilder,
      encoder: Th()
    }, r.replica && {
      endpoint: r.replica.rumEndpointBuilder,
      encoder: Th()
    }, i, t, n.expireObservable);
    s.push(function() {
      return u.stop();
    });
    var h = a.observable.subscribe(function(c) {
      return u.add(c, i3(r));
    });
    s.push(function() {
      return h.unsubscribe();
    });
  }
  return r3(), n3(hj(e)), {
    telemetry: a,
    stop: function() {
      s.forEach(function(c) {
        return c();
      });
    }
  };
}
function qj(e, r, i, t) {
  var n = new Nj(), a = [];
  n.subscribe(1, function(f) {
    return bA("logs", f);
  });
  var s = Hj(n), o = k3(r), l = r.sessionStoreStrategyType && !bh() && !FA() ? _j(r, t) : bj(r), u = Vj(e, r, s, o, l).stop;
  a.push(function() {
    return u();
  }), Dj(r, n), Mj(r, n), Aj(r, n), Cj(r, n);
  var h = Fj(n).handleLog;
  if (Ej(l, r, n, i, s), bh())
    $j(n);
  else {
    var c = jj(r, n, s, o, l).stop;
    a.push(function() {
      return c();
    });
  }
  var d = Gj(l);
  return {
    handleLog: h,
    getInternalContext: d.get,
    stop: function() {
      a.forEach(function(f) {
        return f();
      });
    }
  };
}
var hv = vj(qj);
GB(hu(), "DD_LOGS", hv);
function yg(e) {
  let r = "", i = {}, t, n = 1;
  return Array.from(arguments).forEach((a) => {
    typeof a == "string" ? r += ` ${a}` : a instanceof Error ? t = a : Array.isArray(a) ? i[`array${n++}`] = a : typeof a == "object" && Object.assign(i, a);
  }), {
    message: r.trim(),
    properties: i,
    error: t
  };
}
const Wj = {
  silentMultipleInit: !0,
  service: "BROWSER_LOG",
  site: "datadoghq.com",
  forwardErrorsToLogs: !1,
  sessionSampleRate: 100
};
class Yj {
  constructor(r = {}) {
    if (!r.clientToken)
      throw new Error('Please provide "clientToken" for your Datadog account');
    let { exclude: i = [], ...t } = r;
    hv.init({
      ...Wj,
      ...t,
      beforeSend: (n) => {
        try {
          if (i.some((a) => n && n.message && n.message.toLowerCase().includes(a.toLowerCase())))
            return !1;
        } catch {
        }
      }
    }), this.options = r, this.logger = hv.logger, this.ctx = {};
  }
  log() {
    let r = yg(...arguments);
    this.logger.log(r.message, Object.assign(r.properties, this.ctx));
  }
  info() {
    let r = yg(...arguments);
    this.logger.info(r.message, Object.assign(r.properties, this.ctx));
  }
  error() {
    let r = yg(...arguments);
    this.logger.error(r.message, Object.assign(r.properties, this.ctx), r.error);
  }
  context(r, i) {
    return typeof r == "string" ? this.ctx[r] = i : typeof r == "object" && Object.assign(this.ctx, r), this;
  }
}
fr.service("VJSLoggerPlugin", [function() {
  const e = re.getPlugin("plugin"), r = { log: () => {
  }, error: () => {
  } }, i = re.extend(e, {
    constructor: function(t, n) {
      var a;
      e.call(this, t, n), t.logger = r, (a = n == null ? void 0 : n.datadog) != null && a.clientToken && (t.logger = new Yj(n.datadog));
    }
  });
  return i.pluginName = "loggerPlugin", i;
}]);
fr.service("VJSCustomEventsPlugin", ["PlayerEvents", function(e) {
  const r = re.getPlugin("plugin"), i = re.extend(r, {
    constructor: function(t, n) {
      r.call(this, t, n);
      let a = n.currentTimeEventInterval || 60, s = n.videoEndPercent || 1;
      const o = n.sectionDuration || 30;
      let l = 0, u = 0, h = !1;
      this.lastTimeUpdate = 0, this.watchTime = 0, t.one("play", () => {
        t.trigger(e.IMPRESSION, { streamInfo: t.streamInfo() });
      }), t.on("timeupdate", () => {
        let c = t.currentTime() / t.duration();
        if (!h && c >= s && (t.trigger(e.VIDEO_END, { streamInfo: t.streamInfo() }), h = !0), c < s && (h = !1), this.lastTimeUpdate && Math.abs(t.currentTime() - this.lastTimeUpdate) < 1 && (this.watchTime += t.currentTime() - this.lastTimeUpdate), this.lastTimeUpdate = t.currentTime(), a && c < s && this.watchTime - u > a)
          try {
            t.trigger(e.CURRENT_TIME, {
              currentTime: parseFloat(t.currentTime().toFixed(2)),
              streamInfo: t.streamInfo()
            }), u = this.watchTime;
          } catch {
          }
        if (this.watchTime - l > o)
          try {
            t.trigger(e.SECTION_WATCHED, {
              watchTime: parseFloat(this.watchTime.toFixed(2)),
              streamInfo: t.streamInfo()
            }), l = this.watchTime;
          } catch {
          }
      }), t.on("seeked", () => {
        t.currentTime() / t.duration() < s && t.trigger(e.CURRENT_TIME, {
          currentTime: parseFloat(t.currentTime().toFixed(2)),
          streamInfo: t.streamInfo()
        });
      }), t.on("pause", () => {
        t.currentTime() / t.duration() < s && t.trigger(e.CURRENT_TIME, {
          currentTime: parseFloat(t.currentTime().toFixed(2)),
          streamInfo: t.streamInfo()
        });
      }), window.addEventListener("beforeunload", (c) => {
        t.currentTime() / t.duration() < s && t.trigger(e.CURRENT_TIME, {
          currentTime: parseFloat(t.currentTime().toFixed(2)),
          streamInfo: t.streamInfo()
        });
      });
    }
  });
  return i.pluginName = "customEvents", i;
}]);
fr.service("VJSCustomAdEventsPlugin", ["PlayerEvents", function(e) {
  const r = re.getPlugin("plugin"), i = re.extend(r, {
    constructor: function(t, n) {
      r.call(this, t, n);
      try {
        t.ima.addEventListener("start", () => t.trigger(e.AD_START)), t.ima.addEventListener("impression", () => t.trigger(e.AD_IMPRESSION)), t.ima.addEventListener("skip", () => t.trigger(e.AD_SKIP)), t.ima.addEventListener("allAdsCompleted", () => t.trigger(e.AD_COMPLETED));
      } catch (a) {
        console.log(a);
      }
    }
  });
  return i.pluginName = "customAdEvents", i;
}]);
fr.run([
  "VJSPlaylistPlugin",
  "VJSHlsJsPlugin",
  "VJSManualHlsPlugin",
  "VJSContentFitPlugin",
  "VJSCropperPlugin",
  "VJSElementWrapperPlugin",
  "VJSAutoplaySupportPlugin",
  "VJSResponsiveScrubbing",
  "VJSPostMessagesPlugin",
  "VJSTransform",
  "VJSSeekButtons",
  "VJSSourceSelector",
  "VJSAnalyticsPlugin",
  "VJSLoggerPlugin",
  "VJSCustomEventsPlugin",
  "VJSCustomAdEventsPlugin",
  function(e, r, i, t, n, a, s, o, l, u, h, c, d, f, m, p) {
    re.registerPlugin(e.pluginName, e), re.registerPlugin(r.pluginName, r), re.registerPlugin(i.pluginName, i), re.registerPlugin(t.pluginName, t), re.registerPlugin(n.pluginName, n), re.registerPlugin(a.pluginName, a), re.registerPlugin(s.pluginName, s), re.registerPlugin(o.pluginName, o), re.registerPlugin(l.pluginName, l), re.registerPlugin(u.pluginName, u), re.registerPlugin(h.pluginName, h), re.registerPlugin(c.pluginName, c), re.registerPlugin(d.pluginName, d), re.registerPlugin(f.pluginName, f), re.registerPlugin(m.pluginName, m), re.registerPlugin(p.pluginName, p);
  }
]);
fr.factory("VJSFullscreenToggle", function() {
  let e = re.getComponent("FullscreenToggle");
  function r() {
    const t = document.exitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen || document.msExitFullscreen;
    !screenfull.isFullscreen && screenfull.enabled ? (screenfull.request(), setPlayerFullScreenMode()) : t.call(document);
  }
  return re.extend(e, {
    constructor: function(t, n) {
      e.apply(this, arguments);
    },
    handleClick: function(t) {
      r();
    }
  });
});
fr.factory("VJSOrientationPoster", ["$rootScope", "$compile", function(e, r) {
  let i = re.getComponent("Component");
  return re.extend(i, {
    constructor: function() {
      i.apply(this, arguments);
    },
    createEl: function() {
      return re.dom.createEl("div", { className: "vjs-orientation-poster" });
    }
  });
}]);
fr.factory("Clock", [function() {
  function e() {
    var i = new Worker("interval-worker.js");
    return i;
  }
  var r = function(t) {
    var n = this;
    this._running = !1, this._options = t || {}, this._initial = this._options.initial !== void 0 ? this._options.initial : Date.now(), this._time = this._initial, this._worker = e(), this._worker.onmessage = function(a) {
      n._time += a.data;
    };
  };
  return r.prototype = {
    get: function() {
      return this._time;
    },
    set: function(i) {
      var t = this._running;
      this.pause(), this._time = i, t && this.resume();
    },
    stop: function() {
      this._worker.postMessage({ cmd: "stop" }), this._time = this._initial, this._running = !1;
    },
    pause: function() {
      this._worker.postMessage({ cmd: "stop" }), this._running = !1;
    },
    resume: function() {
      this.start();
    },
    start: function() {
      this._worker.postMessage({ cmd: "start", interval: this._options.interval }), this._running = !0;
    },
    restart: function() {
      this.stop(), this.start();
    },
    isRunning: function() {
      return this._running;
    }
  }, r;
}]);
fr.factory("VJSClock", ["Clock", function(e) {
  let r = re.getComponent("TimeDisplay");
  function i(n) {
    let a = Math.floor(n / 3600), s = Math.floor((n - a * 3600) / 60), o = Math.floor(n - a * 3600 - s * 60), l = Math.floor(n % 1 * 10);
    return a < 10 && (a = "0" + a), s < 10 && (s = "0" + s), o < 10 && (o = "0" + o), a + ":" + s + ":" + o + ":" + l;
  }
  return re.extend(r, {
    constructor: function(a, s) {
      r.apply(this, arguments), a.on("pause", this.pause), a.on("waiting", this.pause), a.on("playing", this.resume), s.show || this.hide();
    },
    buildCSSClass() {
      return "vjs-clock";
    },
    updateContent(n) {
      let a = this.get();
      this.updateFormattedTime_(a);
    },
    formatTime_(n) {
      if (this.clock_) {
        const a = new Date(n), s = a.getHours().toString().padStart(2, "0"), o = a.getMinutes().toString().padStart(2, "0"), l = a.getSeconds().toString().padStart(2, "0"), u = a.getMilliseconds().toString().padStart(1, "0");
        return `${s}:${o}:${l}:${u}`;
      } else
        return i(n);
    },
    pause: function() {
      this.clock_ && this.clock_.pause();
    },
    resume: function() {
      this.clock_ && this.clock_.resume();
    },
    set: function(n) {
      this.clock_ ? this.clock_.set(n) : (this.clock_ = new e({ initial: n }), this.clock_.start());
    },
    get: function() {
      return this.clock_ ? this.clock_.get() : this.player_.currentTime();
    }
  });
}]);
fr.factory("VJSCheckers", function() {
  let e = re.getComponent("Component");
  return re.extend(e, {
    constructor: function() {
      e.apply(this, arguments), this.hide();
    },
    createEl: function() {
      return re.dom.createEl("div", { className: "vjs-checkers" });
    }
  });
});
fr.factory("VJSLogo", function() {
  let e = re.getComponent("Component");
  const r = ["hidden", "top-left", "top-right", "bottom-left", "bottom-right"];
  return re.extend(e, {
    constructor: function(n, a) {
      e.apply(this, arguments), a.src || this.hide();
    },
    createEl: function() {
      let t = r.includes(this.options_.align) ? this.options_.align : "top-right", n = re.dom.createEl("img", { className: "vjs-logo" });
      return this.options_.link && (n.onclick = () => {
        window.open(this.options_.link);
      }, n.classList.add("clickable")), n.classList.add(t), this.options_.src && (n.src = this.options_.src), n;
    }
  });
});
fr.factory("VJSSeekBar", function() {
  let e = re.getComponent("SeekBar");
  return re.extend(e, {
    constructor: function() {
      e.apply(this, arguments);
    },
    handleMouseMove(i) {
      if (!re.dom.isSingleLeftClick(i))
        return;
      let t;
      const n = this.calculateDistance(i), a = this.player_.liveTracker;
      if (!a || !a.isLive())
        t = n * this.player_.duration(), t === this.player_.duration() && (t = t - 0.1);
      else {
        const s = a.seekableStart(), o = a.liveCurrentTime();
        if (t = s + n * a.liveWindow(), t >= o && (t = o), t <= s && (t = s + 0.1), t === 1 / 0)
          return;
      }
      this.player_.seekedTime = t;
    },
    getCurrentTime_() {
      return this.player_.scrubbing() ? this.player_.seekedTime : this.player_.currentTime();
    },
    handleMouseUp(i) {
      console.log("Seeking"), e.prototype.handleMouseUp.call(this, i), this.player_.currentTime(this.player_.seekedTime);
    }
  });
});
fr.factory("VJSMask", function() {
  let e = re.getComponent("Component");
  const r = "0 0 , 0 100%, 100% 100%, 100% 0, 0 0";
  function i(a) {
    let s = a[0][0], o = a[0][1], l = a[1][0], u = a[1][1];
    return [[s, o], [l, o], [l, u], [s, u]];
  }
  const t = (a, ...s) => {
    s = s.reduce(function(l, u, h, c) {
      return h % 2 === 0 && l.push(c.slice(h, h + 2)), l;
    }, []), s.length === 2 && (s = i(s));
    let o = "";
    s.forEach((l) => {
      o += `${l[0] * 100}% ${l[1] * 100}%, `;
    }), o += `${s[0][0] * 100}% ${s[0][1] * 100}%`, a.style.clipPath = `polygon(${r}, ${o})`, a.style.webkitClipPath = `polygon(${r}, ${o})`;
  };
  return re.extend(e, {
    constructor: function(s, o) {
      e.apply(this, arguments), this.hide(), s.mask = (...l) => {
        this.show(), t(this.el(), ...l);
      }, s.hideMask = () => {
        this.hide();
      };
    },
    createEl: function() {
      return re.dom.createEl("div", { className: "vjs-mask" });
    }
  });
});
fr.factory("VJSHoverOverlay", function() {
  let e = re.getComponent("Component");
  return re.extend(e, {
    constructor: function(t, n) {
      e.apply(this, arguments), t.setTitle = (a) => {
        this._title.innerText = a;
      }, t.setDescription = (a) => {
        this._desc.innerText = a;
      }, t.on("userinactive", () => {
        this.hide();
      });
    },
    show() {
      this._el.classList.add("active");
    },
    hide() {
      this._el.classList.remove("active");
    },
    remove() {
      this._el.classList.add("vjs-hidden");
    },
    createEl: function() {
      let i = this.options(), t = this._el = re.dom.createEl("div", { className: "vjs-hover-overlay" });
      return this._back = re.dom.createEl("div", { className: "vjs-hover-overlay-back-btn" }), this._data = re.dom.createEl("div", { className: "vjs-hover-overlay-data" }), this._title = re.dom.createEl("div", { className: "vjs-hover-overlay-title" }), this._desc = re.dom.createEl("div", { className: "vjs-hover-overlay-description" }), this._hoverArea = re.dom.createEl("div", { className: "vjs-hover-area" }), t.appendChild(this._hoverArea), i.back && t.appendChild(this._back), this._data.appendChild(this._title), this._data.appendChild(this._desc), t.appendChild(this._data), this._title.innerText = i.title || "", this._desc.innerText = i.description || "", this._back.addEventListener("click", function() {
        window.top.history.back();
      }), this._hoverArea.addEventListener("mouseover", () => {
        this.show();
      }), this._hoverArea.addEventListener("touchstart", () => {
        this.show();
      }), t;
    }
  });
});
fr.factory("VJSFSPlayPause", function() {
  let e = re.getComponent("Component");
  return re.extend(e, {
    constructor: function(t, n) {
      e.apply(this, arguments);
    },
    show() {
      this._el.classList.add("active");
    },
    hide() {
      this._el.classList.remove("active");
    },
    remove() {
      this._el.classList.add("vjs-hidden");
    },
    createEl: function() {
      this.options();
      let i = this._el = re.dom.createEl("div", { className: "vjs-fs-play-pause" }), t = re.dom.createEl("i", { className: "vjs-fs-play fa fa-play fa-4x" }), n = re.dom.createEl("i", { className: "vjs-fs-pause fa fa-pause fa-4x" });
      i.appendChild(t), i.appendChild(n);
      let a = this.player();
      return i.addEventListener("click", function(s) {
        if (a.hasClass("vjs-ad-playing"))
          try {
            a.adPaused ? a.ima.resumeAd() : (a.ima.getAdsManager().clicked(), a.ima.pauseAd());
          } catch {
          }
        else
          a.paused() ? (a.play(), t.classList.add("playPauseAnimation"), setTimeout(function() {
            t.classList.remove("playPauseAnimation");
          }, 500), console.log("play")) : (a.pause(), n.classList.add("playPauseAnimation"), setTimeout(function() {
            n.classList.remove("playPauseAnimation");
          }, 500), console.log("pause"));
      }), i;
    }
  });
});
fr.factory("VJSSkipButton", function() {
  const e = re.getComponent("Button");
  return re.extend(e, {
    constructor: function(i, t) {
      e.apply(this, arguments), this.options_.direction === "forward" ? this.controlText(this.localize("Skip forward {{seconds}} seconds").replace("{{seconds}}", this.options_.seconds)) : this.options_.direction === "back" && this.controlText(this.localize("Skip back {{seconds}} seconds").replace("{{seconds}}", this.options_.seconds));
    },
    buildCSSClass() {
      return `vjs-control vjs-button vjs-skip-button skip-${this.options_.direction} skip-${this.options_.seconds}`;
    },
    handleClick: function(i) {
      const t = this.player_.currentTime();
      this.options_.direction === "forward" ? this.player_.currentTime(t + this.options_.seconds) : this.options_.direction === "back" && this.player_.currentTime(t - this.options_.seconds);
    }
  });
});
fr.factory("VJSOpenInVideoflow", function() {
  const e = re.getComponent("Button");
  return re.extend(e, {
    constructor: function(i, t) {
      e.apply(this, arguments), this.controlText(this.localize("Open in Videoflow"));
    },
    buildCSSClass() {
      return "vjs-control vjs-button vjs-open-in-videoflow-button";
    },
    handleClick: function(i) {
      window.open(`${window.location.origin}/output/${xL()._outputtkn}`, "_blank");
    }
  });
});
fr.factory("VJSSourceSelectorMenuItem", function() {
  let e = re.getComponent("MenuItem");
  return re.extend(e, {
    constructor: function(i, t) {
      this._label = t.label, this._url = t.url, e.apply(this, arguments);
    },
    createEl: function(i, t, n) {
      let a = re.dom.createEl("div", { className: "vjs-menu-item vjs-source-item" });
      this.player_.src() === this._url && a.classList.add("selected"), a.innerText = this._label;
      let s = (o) => {
        this.player_.src() === this._url ? a.classList.add("selected") : a.classList.remove("selected");
      };
      return this.player_.on("loadstart", s), this.player_.on(a, "loadedmetadata", s), a;
    },
    handleClick: function(i) {
      if (this.player_.src() !== this._url) {
        this.player_.src({ src: this._url }), this.player_.load(), this.player_.play();
        try {
          this.player_.getChild("error-modal").close();
        } catch {
        }
      }
    }
  });
});
fr.factory("VJSSourceSelectorButton", ["VJSSourceSelectorMenuItem", function(e) {
  const r = re.getComponent("MenuButton");
  return re.extend(r, {
    constructor: function(t, n) {
      n.sources = [], r.apply(this, arguments), this.controlText("Sources");
    },
    buildCSSClass() {
      return "fa fa-video-camera vjs-menu-button vjs-control vjs-button";
    },
    createItems: function(t) {
      return t = t || [], this.player_.info.sources && this.player_.info.sources.forEach((n) => {
        t.push(new e(this.player_, { label: n.name, url: n.url }));
      }), this.player_.sources = t, t;
    }
  });
}]);
fr.factory("VJSVideoTitle", function() {
  let e = re.getComponent("Component");
  return re.extend(e, {
    constructor: function(t, n) {
      e.apply(this, arguments);
    },
    createEl: function() {
      let i = re.dom.createEl("div", { className: "vjs-control vjs-video-title" });
      return this.player_.ready(() => {
        i.innerHTML = `<span class="vjs-video-title-text">${this.player_.info.name}</span>`;
      }), i;
    }
  });
});
const Kj = 2, zj = 100;
function Xj() {
  function e() {
    return Math.floor((1 + Math.random()) * 65536).toString(16).substring(1);
  }
  return e() + e() + e() + e() + e() + e() + e() + e();
}
const Jj = function(e, r) {
  return function(i) {
    try {
      _.isString(i.data) && (i = JSON.parse(i.data), i.type === "taco-ack" && i.cid === e && r());
    } catch {
    }
  };
};
function BA(e, r, i, t, n) {
  if (n = n || 1, !e || !e.postMessage)
    return;
  let a = {
    type: r,
    payload: i
  };
  if (t) {
    a.cid = Xj();
    let s;
    const o = Jj(a.cid, function() {
      window.removeEventListener("message", o, !1), clearTimeout(s);
    });
    window.addEventListener("message", o, !1), s = setTimeout(function() {
      BA(e, r, i, n < Kj, n + 1);
    }, zj);
  }
  e.postMessage(JSON.stringify(a), "*");
}
const _g = {
  PAUSE: "vff-pause",
  SEEK: "vff-video-go",
  READY: "taco-ready"
}, Qj = {
  [_g.PAUSE]: (e) => {
    e.player.paused() ? e.player.play() : e.player.pause();
  },
  [_g.SEEK]: (e, r) => {
    e.player.currentTime(r.time);
  },
  [_g.READY]: (e, r) => {
    BA(e.iframeElement.contentWindow, "vff-vf-data", { input: e.options.data }, !0);
  }
};
fr.directive("vjsGfxOverlay", [function() {
  return {
    restrict: "E",
    template: `
            <div class="gfx-overlay" ng-show="hasGfxOverlay()" ng-class="getPlayerTypeClass()">
<!--               <div fake-size width="width" height="height" max-height="10000" promise="ready.promise" enable="isGfxScaled()" class="fake-size-wrap">-->
                   <iframe id="gfx-overlay-iframe" style="width: 100%; height: 100%; border:none;" allow="geolocation; fullscreen"/>
<!--               </div>-->
            </div>`,
    replace: !0,
    scope: {
      options: "=",
      player: "="
    },
    controller: ["$scope", "$q", function(e, r) {
    }],
    link: function(e, r) {
      e.hasGfxOverlay = () => !0, e.iframeElement = r.find("iframe")[0];
      let i = function(t) {
        let n;
        try {
          n = JSON.parse(t.data);
        } catch {
          n = {};
        }
        let a = n.type, s = Qj[a];
        s && s(e, n.payload);
      };
      window.addEventListener("message", i), e.$on("$destroy", () => {
        window.removeEventListener("message", i);
      });
    }
  };
}]);
fr.factory("VJSGFXOverlay", ["$compile", "$rootScope", "$sce", function(e, r, i) {
  let t = re.getComponent("Component");
  return re.extend(t, {
    constructor: function(a, s) {
      t.apply(this, arguments);
    },
    show() {
      this.el().classList.add("active");
    },
    hide() {
      this.el().classList.remove("active");
    },
    remove() {
      this.el().classList.add("vjs-hidden");
    },
    createEl: function() {
      return this.scope = r.$new(), this.scope.options = this.options(), this.scope.player = this.player_, e('<vjs-gfx-overlay options="options" player="player" ></vjs-gfx-overlay>')(this.scope)[0];
    },
    src: function(n) {
      const a = this.el().querySelector("iframe");
      a.src !== n && (!n || !a.src.endsWith(n)) && (this.player().vfApi.getCurrentTemplate(), a.src = i.trustAsResourceUrl(n)), n ? (this.show(), this.addClass()) : (this.hide(), this.removeClass());
    },
    dispose: function() {
      this.scope.$destroy();
    },
    addClass: function() {
      this.player_.el_.classList.add("has-gfx-overlay");
    },
    removeClass: function() {
      this.player_.el_.classList.remove("has-gfx-overlay");
    }
  });
}]);
fr.run([
  "VJSFullscreenToggle",
  "VJSOrientationPoster",
  "VJSClock",
  "VJSCheckers",
  "VJSLogo",
  "VJSSeekBar",
  "VJSMask",
  "VJSHoverOverlay",
  "VJSFSPlayPause",
  "VJSSkipButton",
  "VJSOpenInVideoflow",
  "VJSSourceSelectorButton",
  "VJSSourceSelectorMenuItem",
  "VJSVideoTitle",
  "VJSGFXOverlay",
  function(e, r, i, t, n, a, s, o, l, u, h, c, d, f, m) {
    re.registerComponent("VFFullscreenToggle", e), re.registerComponent("vfGfxOverlay", m), re.registerComponent("vfOrientationPoster", r), re.registerComponent("vfClock", i), re.registerComponent("vfCheckers", t), re.registerComponent("vfLogo", n), re.registerComponent("vfMask", s), re.registerComponent("vfHoverOverlay", o), re.registerComponent("vfFSPlayPause", l), re.registerComponent("skipButton", u), re.registerComponent("openInVideoflowButton", h), re.registerComponent("vfSourceSelectorButton", c), re.registerComponent("vfSSourceSelectorMenuItem", d), re.registerComponent("vfVideoTitle", f);
  }
]);
fr.factory("VJSAntTech", [function() {
  let e = re.getTech("Tech"), r = re.extend(e, {
    constructor: function(t, n) {
      e.call(this, t, n), this.triggerReady();
      const a = {
        iceServers: [{
          urls: "stun:stun1.l.google.com:19302"
        }]
      }, s = {
        mandatory: {
          OfferToReceiveAudio: !0,
          OfferToReceiveVideo: !0
        }
      }, o = {
        video: !1,
        audio: !1
      };
      this._connected = !1, this._config = {
        pc_config: a,
        sdpConstraints: s,
        mediaConstraints: o
      };
    },
    createEl: function() {
      return this._videoEl = re.dom.createEl("video", { className: "vjs-tech vjs-webrtc", id: this.options_.techId }), this._videoEl;
    },
    src(i) {
      if (i === void 0)
        return this.el_.src;
      this.setSrc(i);
    },
    bindEvents: function(i) {
      [
        "abort",
        "canplay",
        "canplaythrough",
        "durationchange",
        "emptied",
        "ended",
        "error",
        "loadeddata",
        "loadedmetadata",
        "loadstart",
        "pause",
        "play",
        "playing",
        "progress",
        "ratechange",
        "seeked",
        "seeking",
        "stalled",
        "suspend",
        "timeupdate",
        "volumechange",
        "waiting"
      ].forEach((n) => {
        i.addEventListener(n, (a) => {
          this.trigger(n, a);
        }, !1);
      });
    },
    setConnected(i) {
      this._connected = i, this._connected || this.retryConnect();
    },
    retryConnect() {
      this._shuttingDown || (clearTimeout(this._retryTimeout), this._connected || (this._retryTimeout = setTimeout(() => {
        this.connect();
      }, 1e3)));
    },
    buildWebsocketURL() {
      const i = this._host || "stun.videoflow.io", t = 5443, n = "LiveApp/", a = i + ":" + t + "/" + n + "websocket";
      let s = "wss://" + a;
      return location.protocol.startsWith("https") && (s = "wss://" + a), s;
    },
    connect: function() {
      clearTimeout(this._retryTimeout);
      const i = this._webRTCAdaptor = new WebRTCAdaptor({
        websocket_url: this.buildWebsocketURL(),
        mediaConstraints: this._config.mediaConstraints,
        peerconnection_config: this._config.pc_config,
        sdp_constraints: this._config.sdpConstraints,
        remoteVideoId: this.options_.techId,
        isPlayMode: !0,
        debug: !1,
        callback: (t, n) => {
          switch (t) {
            case "initialized":
              console.log("initialized"), i.getStreamInfo(this._target);
              break;
            case "streamInformation":
              console.log(t), this.setConnected(!0), this._webRTCAdaptor.play(this._target, void 0, "", [], void 0, void 0), this.play();
              break;
            case "data_channel_opened":
              this.play();
              break;
            case "data_channel_closed":
              this.setConnected(!1), console.log(t);
              break;
            case "pong":
            case "bitrateMeasurement":
              break;
            case "play_started":
              break;
            case "play_finished":
            case "ice_connection_state_changed":
            default:
              console.log(t);
              break;
          }
        },
        callbackError: (t, n) => {
          switch (console.log("error callback: " + t), t) {
            case "already_playing":
              break;
            default:
              this.setConnected(!1);
          }
        }
      });
      clearTimeout(this._retryTimeout);
    },
    shutdown: function() {
      this._shuttingDown || (this._shuttingDown = !0, this._webRTCAdaptor.stop(this._target, void 0, "", [], void 0, void 0));
    },
    setSrc: function(i) {
      i = i.src;
      const t = i.split("/");
      t.length < 4 || (this._app = t[3], this._target = t[4], this._host = t[2].split(":")[0], this._port = t[2].split(":")[1], this._secure = !!t[0].match(/https/i), this.connect());
    },
    setLoop: function(i) {
      this._videoEl && (this._videoEl.loop = i);
    },
    setPlaybackRate: function(i) {
      this._videoEl && (this._videoEl.playbackRate = i);
    },
    setVolume: function(i) {
      this._videoEl && (this._videoEl.volume = i);
    },
    playbackRate: function() {
      return this._videoEl ? this._videoEl.playbackRate : 1;
    },
    setSource: function(i) {
      this.src(i);
    },
    setPoster: function() {
      return !0;
    },
    setPreload: function() {
      return !0;
    },
    setDefaultPlaybackRate: function() {
      this._videoEl && (this._videoEl.playbackRate = 1);
    },
    loop: function() {
      return this._videoEl ? this._videoEl.loop : !1;
    },
    load: function() {
    },
    play: function() {
      return this._videoEl ? this._videoEl.play() : !0;
    },
    pause: function() {
      return this._videoEl ? this._videoEl.pause() : !0;
    },
    paused: function() {
      return this._videoEl ? this._videoEl.paused : !0;
    },
    currentTime: function() {
      return this._videoEl ? this._videoEl.currentTime : 0;
    },
    volume: function() {
      return this._videoEl ? this._videoEl.volume : 0;
    },
    duration: function() {
      return this._videoEl ? this._videoEl.duration : 0;
    },
    seekable: function() {
      return this._videoEl ? this._videoEl.seekable : 0;
    },
    buffered: function() {
      return this._videoEl ? this._videoEl.buffered : 0;
    },
    supportsFullScreen: function() {
      return !0;
    },
    controls: function() {
      return this._videoEl ? this._videoEl.controls : !1;
    },
    muted: function() {
      return this._videoEl ? this._videoEl.muted : !0;
    },
    setMuted: function(i) {
      this._videoEl && (this._videoEl.muted = i);
    },
    dispose: function() {
      try {
        this.shutdown();
      } catch {
      }
      this.el_ && this.el_.parentNode.removeChild(this.el_);
    }
  });
  return r.isSupported = function() {
    return !0;
  }, r.nativeSourceHandler = {}, r.nativeSourceHandler.canPlayType = function(i) {
    try {
      if (~i.indexOf("stun.videoflow.io") || ~i.indexOf("ull.ap-northeast-1.videoflow.io") || ~i.indexOf("ulltokyo.videoflow.io") || ~i.indexOf("ullus.videoflow.io") || ~i.indexOf("ullireland.videoflow.io") || ~i.indexOf("ulloragon.videoflow.io"))
        return "maybe";
    } catch {
    }
    return "";
  }, r.nativeSourceHandler.canHandleSource = function(i) {
    return i.type ? r.nativeSourceHandler.canPlayType(i.type) : i.src ? r.nativeSourceHandler.canPlayType(i.src) : r.nativeSourceHandler.canPlayType(i);
  }, e.withSourceHandlers(r), r.nativeSourceHandler.handleSource = function(i, t, n) {
    t.setSrc(i);
  }, r.nativeSourceHandler.dispose = function() {
    console.log("disposing of webRTC tech");
  }, r.registerSourceHandler(r.nativeSourceHandler), e.registerTech("ant", r), r;
}]);
fr.factory("VJSImageTech", function() {
  let e = re.getTech("Tech"), r = re.extend(e, {
    constructor: function(t, n) {
      e.call(this, t, n);
      const a = t.source;
      a && this.src(a), this.triggerReady();
    },
    createEl: function() {
      let i = re.dom.createEl("img", { className: "vjs-tech vjs-image", id: this.options_.techId });
      return i.onload = () => {
        try {
          this.trigger("play"), this.trigger("playing");
        } catch {
        }
      }, i.onerror = (t) => {
        try {
          this.trigger("error", t);
        } catch {
        }
      }, i;
    },
    src(i) {
      if (i === void 0)
        return this.el_.src;
      this.setSrc(i);
    },
    setSrc: function(i) {
      let t = i.src || i;
      this.el_.src !== t && (this.trigger("loadstart"), this.el_.src = t, i.duration && this.one("load", () => {
        setTimeout(() => {
          this.trigger("ended");
        }, i.duration);
      }));
    },
    setLoop: function() {
      return !0;
    },
    setPlaybackRate: function() {
      return !0;
    },
    setVolume: function() {
      return !0;
    },
    playbackRate: function() {
      return 1;
    },
    setSource: function(i) {
      this.src(i);
    },
    setPoster: function() {
      return !0;
    },
    setPreload: function() {
      return !0;
    },
    setDefaultPlaybackRate: function() {
      return !0;
    },
    play: function() {
      return !0;
    },
    pause: function() {
      return !0;
    },
    paused: function() {
      return !0;
    },
    currentTime: function() {
      return 0;
    },
    volume: function() {
      return 0;
    },
    duration: function() {
      return 0;
    },
    buffered: function() {
      return 0;
    },
    supportsFullScreen: function() {
      return !0;
    },
    controls: function() {
      return !1;
    },
    muted: function() {
      return !0;
    }
  });
  return r.isSupported = function() {
    return !0;
  }, r.nativeSourceHandler = {}, r.nativeSourceHandler.canPlayType = function(i) {
    return i.match("^image/.*") || i.match(/(?:([^:\?#]+):)?(?:\/([^\/?#]*))?([^?#]*\.(?:jpg|jpeg|gif|png))(?:\?([^#]*))?(?:#(.*))?/) || i.match(/data:image\/([a-zA-Z]*);base64,([^\"]*)/) !== null || i.indexOf("placeholder.com") > -1 ? "maybe" : "";
  }, r.nativeSourceHandler.canHandleSource = function(i) {
    return i.type ? r.nativeSourceHandler.canPlayType(i.type) : i.src ? r.nativeSourceHandler.canPlayType(i.src) : r.nativeSourceHandler.canPlayType(i);
  }, e.withSourceHandlers(r), r.nativeSourceHandler.handleSource = function(i, t, n) {
    t.setSrc(i);
  }, r.registerSourceHandler(r.nativeSourceHandler), e.registerTech("Image", r), r;
});
fr.service("VJSIVSTech", function() {
  try {
    registerIVSTech(re), registerIVSQualityPlugin(re);
    const e = re.getTech("AmazonIVS");
    e.prototype.setLoop = () => !0, e.canPlaySource = (r) => r.src && (r.src.indexOf("playback.live-video.net/api/video/v1/") > -1 || r.src.indexOf("dflsjqznkm1lx.cloudfront.net/") > -1 || r.src.indexOf("na3rqtc5l9.videoflow.io") > -1 || r.src.indexOf("live.videoflow.io") > -1) && r.src.indexOf(".m3u8") > -1 ? "maybe" : "";
  } catch {
  }
  return this;
});
fr.factory("VJSRed5Tech", function() {
  function e(t) {
    return !!~t.indexOf("tyrellcct") || !!~t.indexOf("paddypower");
  }
  let r = re.getTech("Tech"), i = re.extend(r, {
    constructor: function(n, a) {
      r.call(this, n, a), this.triggerReady(), this._connected = !1, this._subscribeOrder = ["rtc"], this._rtcConfig = {
        rtcConfiguration: {
          iceServers: [{ urls: "stun:stun2.l.google.com:19302" }],
          iceCandidatePoolSize: 2,
          bundlePolicy: "max-bundle",
          iceTransportPolicy: "all",
          rtcpMuxPolicy: "require"
        },
        mediaElementId: this.options_.techId,
        rtcpMuxPolicy: "negotiate"
      };
    },
    createEl: function() {
      return this._videoEl = re.dom.createEl("video", { className: "vjs-tech vjs-webrtc", id: this.options_.techId }), this._videoEl;
    },
    src(t) {
      if (t === void 0)
        return this.el_.src;
      this.setSrc(t);
    },
    bindEvents: function(t) {
      [
        "abort",
        "canplay",
        "canplaythrough",
        "durationchange",
        "emptied",
        "ended",
        "error",
        "loadeddata",
        "loadedmetadata",
        "loadstart",
        "pause",
        "play",
        "playing",
        "progress",
        "ratechange",
        "seeked",
        "seeking",
        "stalled",
        "suspend",
        "timeupdate",
        "volumechange",
        "waiting"
      ].forEach((a) => {
        t.addEventListener(a, (s) => {
          this.trigger(a, s);
        }, !1);
      });
    },
    setConnected(t) {
      this._connected = t, this._connected || this.retryConnect();
    },
    retryConnect() {
      this._shuttingDown || (clearTimeout(this._retryTimeout), this._connected || (this._retryTimeout = setTimeout(() => {
        this.connect();
      }, 1e3)));
    },
    getEdgeAddress: async function(t) {
      let n = await fetch(t);
      if (n.headers.get("content-type") && n.headers.get("content-type").toLowerCase().indexOf("application/json") >= 0)
        return n = await n.json(), n.serverAddress;
    },
    getSMConfig: function() {
      return {
        host: this._host,
        port: this._port || (this._secure ? 443 : 80),
        app: "streammanager",
        protocol: this._secure ? "wss" : "ws",
        connectionParams: {
          host: this._edgeAddress,
          app: this._app
        },
        streamName: this._target
      };
    },
    getConfig: function() {
      return {
        protocol: this._secure ? "wss" : "ws",
        port: this._port || (this._secure ? 443 : 80),
        host: this._host,
        streamName: this._target,
        app: this._app
      };
    },
    connect: function() {
      clearTimeout(this._retryTimeout);
      let t = new red5prosdk.Red5ProSubscriber();
      t.on(red5prosdk.SubscriberEventTypes.CONNECT_FAILURE, function(a) {
        console.log(a), setConnected(!1);
      });
      let n = e(this._host) ? this.getSMConfig() : this.getConfig();
      console.log("Connection config"), console.log(n), t.setPlaybackOrder(this._subscribeOrder).init({
        rtc: Object.assign({}, this._rtcConfig, n)
      }).then((a) => (this._subscriber = a, a.on("*", (s) => {
        (s.type === red5prosdk.SubscriberEventTypes.CONNECTION_CLOSED || s.type === red5prosdk.SubscriberEventTypes.CONNECT_FAILURE) && (console.log(s), this.setConnected(!1));
      }), a.subscribe())).then((a) => {
        this._videoEl = a.getPlayer(), this.bindEvents(this._videoEl), this._videoEl.setAttribute("loop", ""), this._videoEl.setAttribute("autoplay", "true"), this._videoEl.setAttribute("width", "100%"), this._videoEl.setAttribute("height", "100%"), this._videoEl.setAttribute("playsinline", "true"), a.play(), this.setConnected(!0);
      }).catch((a) => {
        console.error(a), this.setConnected(!1);
      });
    },
    unsubscribe: function() {
      let t = this._subscriber;
      return t ? new Promise(function(n, a) {
        t.unsubscribe().then(function() {
          t.off("*", this.onSubscriberEvent), this._subscriber = void 0, n();
        }).catch(function(s) {
          a(s);
        });
      }) : Promise.resolve();
    },
    shutdown: function() {
      if (this._shuttingDown)
        return;
      this._shuttingDown = !0;
      const t = () => {
        this._subscriber && this._subscriber.off("*", onSubscriberEvent), this._subscriber = void 0;
      };
      return this.unsubscribe().then(t).catch(t);
    },
    setSMSrc: async function(t) {
      t = t.src;
      const n = t.split("/");
      if (!(n.length < 4))
        try {
          let a = await this.getEdgeAddress(t);
          this._edgeAddress = a, this._app = n[7], this._target = n[8].split("?")[0], this._host = n[2].split(":")[0], this._port = n[2].split(":")[1], this._secure = !!n[0].match(/https/i), this.connect();
        } catch (a) {
          console.error(a);
        }
    },
    setSrc: function(t) {
      t = t.src;
      const n = t.split("/");
      n.length < 4 || (this._app = n[3], this._target = n[4], this._host = n[2].split(":")[0], this._port = n[2].split(":")[1], this._secure = !!n[0].match(/https/i), this.connect());
    },
    setLoop: function(t) {
      this._videoEl && (this._videoEl.loop = t);
    },
    setPlaybackRate: function(t) {
      this._videoEl && (this._videoEl.playbackRate = t);
    },
    setVolume: function(t) {
      this._videoEl && (this._videoEl.volume = t);
    },
    playbackRate: function() {
      return this._videoEl ? this._videoEl.playbackRate : 1;
    },
    setSource: function(t) {
      this.src(t);
    },
    setPoster: function() {
      return !0;
    },
    setPreload: function() {
      return !0;
    },
    setDefaultPlaybackRate: function() {
      this._videoEl && (this._videoEl.playbackRate = 1);
    },
    loop: function() {
      return this._videoEl ? this._videoEl.loop : !1;
    },
    play: function() {
      return this._videoEl ? this._videoEl.play() : !0;
    },
    pause: function() {
      return this._videoEl ? this._videoEl.pause() : !0;
    },
    paused: function() {
      return this._videoEl ? this._videoEl.paused : !0;
    },
    currentTime: function() {
      return this._videoEl ? this._videoEl.currentTime : 0;
    },
    volume: function() {
      return this._videoEl ? this._videoEl.volume : 0;
    },
    duration: function() {
      return this._videoEl ? this._videoEl.duration : 0;
    },
    seekable: function() {
      return this._videoEl ? this._videoEl.seekable : 0;
    },
    buffered: function() {
      return this._videoEl ? this._videoEl.buffered : 0;
    },
    supportsFullScreen: function() {
      return !0;
    },
    controls: function() {
      return this._videoEl ? this._videoEl.controls : !1;
    },
    muted: function() {
      return this._videoEl ? this._videoEl.muted : !0;
    },
    setMuted: function(t) {
      this._videoEl && (this._videoEl.muted = t);
    },
    dispose: function() {
      this.shutdown(), this.el_ && this.el_.parentNode.removeChild(this.el_);
    }
  });
  return i.isSupported = function() {
    return !0;
  }, i.nativeSourceHandler = {}, i.nativeSourceHandler.canPlayType = function(t) {
    try {
      let n = new RegExp("https:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&\\/\\/=]*)", "gi"), a = t.split("/");
      if (e(t) || t.match(n) && a.length === 5 && !a[4].match(/\./))
        return "maybe";
    } catch {
    }
    return "";
  }, i.nativeSourceHandler.canHandleSource = function(t) {
    return t.type ? i.nativeSourceHandler.canPlayType(t.type) : t.src ? i.nativeSourceHandler.canPlayType(t.src) : i.nativeSourceHandler.canPlayType(t);
  }, r.withSourceHandlers(i), i.nativeSourceHandler.handleSource = function(t, n, a) {
    e(t.src) ? n.setSMSrc(t) : n.setSrc(t);
  }, i.nativeSourceHandler.dispose = function() {
    console.log("disposing of webRTC tech"), i.closeWebRTC();
  }, i.registerSourceHandler(i.nativeSourceHandler), r.registerTech("red5", i), i;
});
/**
 * videojs-vimeo
 * @version 3.0.0
 * @copyright 2016 Benoit Tremblay <trembl.ben@gmail.com>
 * @license MIT
 */
(function(e) {
  if (typeof exports == "object" && typeof module < "u")
    module.exports = e();
  else if (typeof define == "function" && define.amd)
    define([], e);
  else {
    var r;
    typeof window < "u" ? r = window : typeof global < "u" ? r = global : typeof self < "u" ? r = self : r = this, r.videojsVimeo = e();
  }
})(function() {
  var e;
  return function r(i, t, n) {
    function a(l, u) {
      if (!t[l]) {
        if (!i[l]) {
          var h = typeof require == "function" && require;
          if (!u && h)
            return h(l, !0);
          if (s)
            return s(l, !0);
          var c = new Error("Cannot find module '" + l + "'");
          throw c.code = "MODULE_NOT_FOUND", c;
        }
        var d = t[l] = { exports: {} };
        i[l][0].call(d.exports, function(f) {
          var m = i[l][1][f];
          return a(m || f);
        }, d, d.exports, r, i, t, n);
      }
      return t[l].exports;
    }
    for (var s = typeof require == "function" && require, o = 0; o < n.length; o++)
      a(n[o]);
    return a;
  }({ 1: [function(r, i, t) {
    (function(n) {
      /*! @vimeo/player v1.0.6 | (c) 2016 Vimeo | MIT License | https://github.com/vimeo/player.js */
      (function(a, s) {
        typeof t == "object" && typeof i < "u" ? i.exports = s() : (a.Vimeo = a.Vimeo || {}, a.Vimeo.Player = s());
      })(this, function() {
        function a(F, G) {
          return G = { exports: {} }, F(G, G.exports), G.exports;
        }
        function s(F, G, K) {
          var J = R.get(F.element) || {};
          G in J || (J[G] = []), J[G].push(K), R.set(F.element, J);
        }
        function o(F, G) {
          var K = R.get(F.element) || {};
          return K[G] || [];
        }
        function l(F, G, K) {
          var J = R.get(F.element) || {};
          if (!J[G])
            return !0;
          if (!K)
            return J[G] = [], R.set(F.element, J), !0;
          var ue = J[G].indexOf(K);
          return ue !== -1 && J[G].splice(ue, 1), R.set(F.element, J), J[G] && J[G].length === 0;
        }
        function u(F, G) {
          var K = R.get(F);
          R.set(G, K), R.delete(F);
        }
        function h(F, G) {
          return F.indexOf(G.toLowerCase()) === 0 ? F : "" + G.toLowerCase() + F.substr(0, 1).toUpperCase() + F.substr(1);
        }
        function c(F) {
          return F instanceof window.HTMLElement;
        }
        function d(F) {
          return !isNaN(parseFloat(F)) && isFinite(F) && Math.floor(F) == F;
        }
        function f(F) {
          return /^(https?:)?\/\/(player.)?vimeo.com(?=$|\/)/.test(F);
        }
        function m() {
          var F = arguments.length <= 0 || arguments[0] === void 0 ? {} : arguments[0], G = F.id, K = F.url, J = G || K;
          if (!J)
            throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
          if (d(J))
            return "https://vimeo.com/" + J;
          if (f(J))
            return J.replace("http:", "https:");
          throw G ? new TypeError("\u201C" + G + "\u201D is not a valid video id.") : new TypeError("\u201C" + J + "\u201D is not a vimeo.com url.");
        }
        function p(F) {
          for (var G = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1], ue = P, K = Array.isArray(ue), J = 0, ue = K ? ue : ue[Symbol.iterator](); ; ) {
            var ce;
            if (K) {
              if (J >= ue.length)
                break;
              ce = ue[J++];
            } else {
              if (J = ue.next(), J.done)
                break;
              ce = J.value;
            }
            var ee = ce, me = F.getAttribute("data-vimeo-" + ee);
            (me || me === "") && (G[ee] = me === "" ? 1 : me);
          }
          return G;
        }
        function b(F) {
          var G = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1];
          return new Promise(function(K, J) {
            if (!f(F))
              throw new TypeError("\u201C" + F + "\u201D is not a vimeo.com url.");
            var ue = "https://vimeo.com/api/oembed.json?url=" + encodeURIComponent(F);
            for (var ce in G)
              G.hasOwnProperty(ce) && (ue += "&" + ce + "=" + encodeURIComponent(G[ce]));
            var ee = "XDomainRequest" in window ? new XDomainRequest() : new XMLHttpRequest();
            ee.open("GET", ue, !0), ee.onload = function() {
              if (ee.status === 404)
                return void J(new Error("\u201C" + F + "\u201D was not found."));
              if (ee.status === 403)
                return void J(new Error("\u201C" + F + "\u201D is not embeddable."));
              try {
                var me = JSON.parse(ee.responseText);
                K(me);
              } catch (Ce) {
                J(Ce);
              }
            }, ee.onerror = function() {
              var me = ee.status ? " (" + ee.status + ")" : "";
              J(new Error("There was an error fetching the embed code from Vimeo" + me + "."));
            }, ee.send();
          });
        }
        function y(F, G) {
          var K = F.html;
          if (!G)
            throw new TypeError("An element must be provided");
          if (G.getAttribute("data-vimeo-initialized") !== null)
            return G.querySelector("iframe");
          var J = document.createElement("div");
          return J.innerHTML = K, G.appendChild(J.firstChild), G.setAttribute("data-vimeo-initialized", "true"), G.querySelector("iframe");
        }
        function v() {
          var F = arguments.length <= 0 || arguments[0] === void 0 ? document : arguments[0], G = [].slice.call(F.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")), K = function(Ne) {
            "console" in window && console.error && console.error("There was an error creating an embed: " + Ne);
          }, J = function() {
            if (ue) {
              if (ce >= ee.length)
                return "break";
              me = ee[ce++];
            } else {
              if (ce = ee.next(), ce.done)
                return "break";
              me = ce.value;
            }
            var Ne = me;
            try {
              if (Ne.getAttribute("data-vimeo-defer") !== null)
                return "continue";
              var ot = p(Ne), ze = m(ot);
              b(ze, ot).then(function($e) {
                return y($e, Ne);
              }).catch(K);
            } catch ($e) {
              K($e);
            }
          };
          e:
            for (var ee = G, ue = Array.isArray(ee), ce = 0, ee = ue ? ee : ee[Symbol.iterator](); ; ) {
              var me, Ce = J();
              switch (Ce) {
                case "break":
                  break e;
                case "continue":
                  continue;
              }
            }
        }
        function g(F) {
          return typeof F == "string" && (F = JSON.parse(F)), F;
        }
        function E(F, G, K) {
          if (F.element.contentWindow.postMessage) {
            var J = { method: G };
            K !== void 0 && (J.value = K);
            var ue = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
            ue >= 8 && ue < 10 && (J = JSON.stringify(J)), F.element.contentWindow.postMessage(J, F.origin);
          }
        }
        function x(F, G) {
          G = g(G);
          var K = [], J = void 0;
          if (G.event) {
            if (G.event === "error")
              for (var ue = o(F, G.data.method), me = ue, ce = Array.isArray(me), ee = 0, me = ce ? me : me[Symbol.iterator](); ; ) {
                var Ce;
                if (ce) {
                  if (ee >= me.length)
                    break;
                  Ce = me[ee++];
                } else {
                  if (ee = me.next(), ee.done)
                    break;
                  Ce = ee.value;
                }
                var Ne = Ce, ot = new Error(G.data.message);
                ot.name = G.data.name, Ne.reject(ot), l(F, G.data.method, Ne);
              }
            K = o(F, "event:" + G.event), J = G.data;
          } else
            G.method && (K = o(F, G.method), J = G.value, l(F, G.method));
          for (var Ze = K, ze = Array.isArray(Ze), $e = 0, Ze = ze ? Ze : Ze[Symbol.iterator](); ; ) {
            var Ut;
            if (ze) {
              if ($e >= Ze.length)
                break;
              Ut = Ze[$e++];
            } else {
              if ($e = Ze.next(), $e.done)
                break;
              Ut = $e.value;
            }
            var qt = Ut;
            try {
              if (typeof qt == "function") {
                qt.call(F, J);
                continue;
              }
              qt.resolve(J);
            } catch {
            }
          }
        }
        var w = typeof Array.prototype.indexOf < "u", S = typeof window.postMessage < "u";
        if (!w || !S)
          throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
        var T = typeof window < "u" ? window : typeof n < "u" ? n : typeof self < "u" ? self : {}, C = (a(function(F, G) {
          (function(K) {
            function J(Ot, It) {
              function sr(lt) {
                return this && this.constructor === sr ? (this._keys = [], this._values = [], this._itp = [], this.objectOnly = It, void (lt && ue.call(this, lt))) : new sr(lt);
              }
              return It || Pt(Ot, "size", { get: vt }), Ot.constructor = sr, sr.prototype = Ot, sr;
            }
            function ue(Ot) {
              this.add ? Ot.forEach(this.add, this) : Ot.forEach(function(It) {
                this.set(It[0], It[1]);
              }, this);
            }
            function ce(Ot) {
              return this.has(Ot) && (this._keys.splice(xt, 1), this._values.splice(xt, 1), this._itp.forEach(function(It) {
                xt < It[0] && It[0]--;
              })), -1 < xt;
            }
            function ee(Ot) {
              return this.has(Ot) ? this._values[xt] : void 0;
            }
            function me(Ot, It) {
              if (this.objectOnly && It !== Object(It))
                throw new TypeError("Invalid value used as weak collection key");
              if (It != It || It === 0)
                for (xt = Ot.length; xt-- && !at(Ot[xt], It); )
                  ;
              else
                xt = Ot.indexOf(It);
              return -1 < xt;
            }
            function Ce(Ot) {
              return me.call(this, this._values, Ot);
            }
            function Ne(Ot) {
              return me.call(this, this._keys, Ot);
            }
            function ot(Ot, It) {
              return this.has(Ot) ? this._values[xt] = It : this._values[this._keys.push(Ot) - 1] = It, this;
            }
            function ze(Ot) {
              return this.has(Ot) || this._values.push(Ot), this;
            }
            function $e() {
              (this._keys || 0).length = this._values.length = 0;
            }
            function Ze() {
              return We(this._itp, this._keys);
            }
            function Ut() {
              return We(this._itp, this._values);
            }
            function qt() {
              return We(this._itp, this._keys, this._values);
            }
            function ir() {
              return We(this._itp, this._values, this._values);
            }
            function We(Ot, It, sr) {
              var lt = [0], ri = !1;
              return Ot.push(lt), { next: function() {
                var Qr, xr = lt[0];
                return !ri && xr < It.length ? (Qr = sr ? [It[xr], sr[xr]] : It[xr], lt[0]++) : (ri = !0, Ot.splice(Ot.indexOf(lt), 1)), { done: ri, value: Qr };
              } };
            }
            function vt() {
              return this._values.length;
            }
            function Tt(Ot, It) {
              for (var sr = this.entries(); ; ) {
                var lt = sr.next();
                if (lt.done)
                  break;
                Ot.call(It, lt.value[1], lt.value[0], this);
              }
            }
            var xt, Pt = Object.defineProperty, at = function(Ot, It) {
              return Ot === It || Ot !== Ot && It !== It;
            };
            typeof WeakMap > "u" && (K.WeakMap = J({ delete: ce, clear: $e, get: ee, has: Ne, set: ot }, !0)), typeof Map < "u" && typeof (/* @__PURE__ */ new Map()).values == "function" && (/* @__PURE__ */ new Map()).values().next || (K.Map = J({ delete: ce, has: Ne, get: ee, set: ot, keys: Ze, values: Ut, entries: qt, forEach: Tt, clear: $e })), typeof Set < "u" && typeof (/* @__PURE__ */ new Set()).values == "function" && (/* @__PURE__ */ new Set()).values().next || (K.Set = J({ has: Ce, add: ze, delete: ce, clear: $e, keys: Ut, values: Ut, entries: ir, forEach: Tt })), typeof WeakSet > "u" && (K.WeakSet = J({ delete: ce, add: ze, clear: $e, has: Ce }, !0));
          })(typeof G < "u" && typeof T < "u" ? T : window);
        }), a(function(F) {
          (function(G, K, J) {
            K[G] = K[G] || J(), typeof F < "u" && F.exports && (F.exports = K[G]);
          })("Promise", T, function() {
            function G(We, vt) {
              Ze.add(We, vt), $e || ($e = qt(Ze.drain));
            }
            function K(We) {
              var vt, Tt = typeof We;
              return We == null || Tt != "object" && Tt != "function" || (vt = We.then), typeof vt == "function" && vt;
            }
            function J() {
              for (var We = 0; We < this.chain.length; We++)
                ue(this, this.state === 1 ? this.chain[We].success : this.chain[We].failure, this.chain[We]);
              this.chain.length = 0;
            }
            function ue(We, vt, Tt) {
              var xt, Pt;
              try {
                vt === !1 ? Tt.reject(We.msg) : (xt = vt === !0 ? We.msg : vt.call(void 0, We.msg), xt === Tt.promise ? Tt.reject(TypeError("Promise-chain cycle")) : (Pt = K(xt)) ? Pt.call(xt, Tt.resolve, Tt.reject) : Tt.resolve(xt));
              } catch (at) {
                Tt.reject(at);
              }
            }
            function ce(We) {
              var vt, Tt = this;
              if (!Tt.triggered) {
                Tt.triggered = !0, Tt.def && (Tt = Tt.def);
                try {
                  (vt = K(We)) ? G(function() {
                    var xt = new Ce(Tt);
                    try {
                      vt.call(We, function() {
                        ce.apply(xt, arguments);
                      }, function() {
                        ee.apply(xt, arguments);
                      });
                    } catch (Pt) {
                      ee.call(xt, Pt);
                    }
                  }) : (Tt.msg = We, Tt.state = 1, Tt.chain.length > 0 && G(J, Tt));
                } catch (xt) {
                  ee.call(new Ce(Tt), xt);
                }
              }
            }
            function ee(We) {
              var vt = this;
              vt.triggered || (vt.triggered = !0, vt.def && (vt = vt.def), vt.msg = We, vt.state = 2, vt.chain.length > 0 && G(J, vt));
            }
            function me(We, vt, Tt, xt) {
              for (var Pt = 0; Pt < vt.length; Pt++)
                (function(at) {
                  We.resolve(vt[at]).then(function(Ot) {
                    Tt(at, Ot);
                  }, xt);
                })(Pt);
            }
            function Ce(We) {
              this.def = We, this.triggered = !1;
            }
            function Ne(We) {
              this.promise = We, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
            }
            function ot(We) {
              if (typeof We != "function")
                throw TypeError("Not a function");
              if (this.__NPO__ !== 0)
                throw TypeError("Not a promise");
              this.__NPO__ = 1;
              var vt = new Ne(this);
              this.then = function(Tt, xt) {
                var Pt = { success: typeof Tt != "function" || Tt, failure: typeof xt == "function" && xt };
                return Pt.promise = new this.constructor(function(at, Ot) {
                  if (typeof at != "function" || typeof Ot != "function")
                    throw TypeError("Not a function");
                  Pt.resolve = at, Pt.reject = Ot;
                }), vt.chain.push(Pt), vt.state !== 0 && G(J, vt), Pt.promise;
              }, this.catch = function(Tt) {
                return this.then(void 0, Tt);
              };
              try {
                We.call(void 0, function(Tt) {
                  ce.call(vt, Tt);
                }, function(Tt) {
                  ee.call(vt, Tt);
                });
              } catch (Tt) {
                ee.call(vt, Tt);
              }
            }
            var ze, $e, Ze, Ut = Object.prototype.toString, qt = typeof setImmediate < "u" ? function(We) {
              return setImmediate(We);
            } : setTimeout;
            try {
              Object.defineProperty({}, "x", {}), ze = function(We, vt, Tt, xt) {
                return Object.defineProperty(We, vt, { value: Tt, writable: !0, configurable: xt !== !1 });
              };
            } catch {
              ze = function(vt, Tt, xt) {
                return vt[Tt] = xt, vt;
              };
            }
            Ze = function() {
              function We(Pt, at) {
                this.fn = Pt, this.self = at, this.next = void 0;
              }
              var vt, Tt, xt;
              return { add: function(Pt, at) {
                xt = new We(Pt, at), Tt ? Tt.next = xt : vt = xt, Tt = xt, xt = void 0;
              }, drain: function() {
                var Pt = vt;
                for (vt = Tt = $e = void 0; Pt; )
                  Pt.fn.call(Pt.self), Pt = Pt.next;
              } };
            }();
            var ir = ze({}, "constructor", ot, !1);
            return ot.prototype = ir, ze(ir, "__NPO__", 0, !1), ze(ot, "resolve", function(We) {
              var vt = this;
              return We && typeof We == "object" && We.__NPO__ === 1 ? We : new vt(function(Tt, xt) {
                if (typeof Tt != "function" || typeof xt != "function")
                  throw TypeError("Not a function");
                Tt(We);
              });
            }), ze(ot, "reject", function(We) {
              return new this(function(vt, Tt) {
                if (typeof vt != "function" || typeof Tt != "function")
                  throw TypeError("Not a function");
                Tt(We);
              });
            }), ze(ot, "all", function(We) {
              var vt = this;
              return Ut.call(We) != "[object Array]" ? vt.reject(TypeError("Not an array")) : We.length === 0 ? vt.resolve([]) : new vt(function(Tt, xt) {
                if (typeof Tt != "function" || typeof xt != "function")
                  throw TypeError("Not a function");
                var Pt = We.length, at = Array(Pt), Ot = 0;
                me(vt, We, function(It, sr) {
                  at[It] = sr, ++Ot === Pt && Tt(at);
                }, xt);
              });
            }), ze(ot, "race", function(We) {
              var vt = this;
              return Ut.call(We) != "[object Array]" ? vt.reject(TypeError("Not an array")) : new vt(function(Tt, xt) {
                if (typeof Tt != "function" || typeof xt != "function")
                  throw TypeError("Not a function");
                me(vt, We, function(Pt, at) {
                  Tt(at);
                }, xt);
              });
            }), ot;
          });
        })), D = C && typeof C == "object" && "default" in C ? C.default : C, R = /* @__PURE__ */ new WeakMap(), P = ["id", "url", "width", "maxwidth", "height", "maxheight", "portrait", "title", "byline", "color", "autoplay", "autopause", "loop", "responsive"], N = function(F, G) {
          if (!(F instanceof G))
            throw new TypeError("Cannot call a class as a function");
        }, $ = /* @__PURE__ */ new WeakMap(), O = /* @__PURE__ */ new WeakMap(), M = function() {
          function F(G) {
            var K = this, J = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1];
            if (N(this, F), window.jQuery && G instanceof jQuery && (G.length > 1 && window.console && console.warn && console.warn("A jQuery object with multiple elements was passed, using the first element."), G = G[0]), typeof G == "string" && (G = document.getElementById(G)), !c(G))
              throw new TypeError("You must pass either a valid element or a valid id.");
            if (G.nodeName !== "IFRAME") {
              var ue = G.querySelector("iframe");
              ue && (G = ue);
            }
            if (G.nodeName === "IFRAME" && !f(G.getAttribute("src") || ""))
              throw new Error("The player element passed isn\u2019t a Vimeo embed.");
            if ($.has(G))
              return $.get(G);
            this.element = G, this.origin = "*";
            var ce = new D(function(ee, me) {
              var Ce = function(ze) {
                if (f(ze.origin) && K.element.contentWindow === ze.source) {
                  K.origin === "*" && (K.origin = ze.origin);
                  var $e = g(ze.data), Ze = "event" in $e && $e.event === "ready", Ut = "method" in $e && $e.method === "ping";
                  return Ze || Ut ? (K.element.setAttribute("data-ready", "true"), void ee()) : void x(K, $e);
                }
              };
              if (window.addEventListener ? window.addEventListener("message", Ce, !1) : window.attachEvent && window.attachEvent("onmessage", Ce), K.element.nodeName !== "IFRAME") {
                var Ne = p(G, J), ot = m(Ne);
                b(ot, Ne).then(function(ze) {
                  var $e = y(ze, G);
                  return K.element = $e, u(G, $e), ze;
                }).catch(function(ze) {
                  return me(ze);
                });
              }
            });
            return O.set(this, ce), $.set(this.element, this), this.element.nodeName === "IFRAME" && E(this, "ping"), this;
          }
          return F.prototype.then = function(G) {
            var K = arguments.length <= 1 || arguments[1] === void 0 ? function() {
            } : arguments[1];
            return this.ready().then(G, K);
          }, F.prototype.callMethod = function(G) {
            var K = this, J = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1];
            return new D(function(ue, ce) {
              return K.ready().then(function() {
                s(K, G, { resolve: ue, reject: ce }), E(K, G, J);
              });
            });
          }, F.prototype.get = function(G) {
            var K = this;
            return new D(function(J, ue) {
              return G = h(G, "get"), K.ready().then(function() {
                s(K, G, { resolve: J, reject: ue }), E(K, G);
              });
            });
          }, F.prototype.set = function(G, K) {
            var J = this;
            return D.resolve(K).then(function(ue) {
              if (G = h(G, "set"), ue == null)
                throw new TypeError("There must be a value to set.");
              return J.ready().then(function() {
                return new D(function(ce, ee) {
                  s(J, G, { resolve: ce, reject: ee }), E(J, G, ue);
                });
              });
            });
          }, F.prototype.on = function(G, K) {
            if (!G)
              throw new TypeError("You must pass an event name.");
            if (!K)
              throw new TypeError("You must pass a callback function.");
            if (typeof K != "function")
              throw new TypeError("The callback must be a function.");
            var J = o(this, "event:" + G);
            J.length === 0 && this.callMethod("addEventListener", G).catch(function() {
            }), s(this, "event:" + G, K);
          }, F.prototype.off = function(G, K) {
            if (!G)
              throw new TypeError("You must pass an event name.");
            if (K && typeof K != "function")
              throw new TypeError("The callback must be a function.");
            var J = l(this, "event:" + G, K);
            J && this.callMethod("removeEventListener", G).catch(function(ue) {
            });
          }, F.prototype.loadVideo = function(G) {
            return this.callMethod("loadVideo", G);
          }, F.prototype.ready = function() {
            var G = O.get(this);
            return D.resolve(G);
          }, F.prototype.enableTextTrack = function(G, K) {
            if (!G)
              throw new TypeError("You must pass a language.");
            return this.callMethod("enableTextTrack", { language: G, kind: K });
          }, F.prototype.disableTextTrack = function() {
            return this.callMethod("disableTextTrack");
          }, F.prototype.pause = function() {
            return this.callMethod("pause");
          }, F.prototype.play = function() {
            return this.callMethod("play");
          }, F.prototype.unload = function() {
            return this.callMethod("unload");
          }, F.prototype.getAutopause = function() {
            return this.get("autopause");
          }, F.prototype.setAutopause = function(G) {
            return this.set("autopause", G);
          }, F.prototype.getColor = function() {
            return this.get("color");
          }, F.prototype.setColor = function(G) {
            return this.set("color", G);
          }, F.prototype.getCurrentTime = function() {
            return this.get("currentTime");
          }, F.prototype.setCurrentTime = function(G) {
            return this.set("currentTime", G);
          }, F.prototype.getDuration = function() {
            return this.get("duration");
          }, F.prototype.getEnded = function() {
            return this.get("ended");
          }, F.prototype.getLoop = function() {
            return this.get("loop");
          }, F.prototype.setLoop = function(G) {
            return this.set("loop", G);
          }, F.prototype.getPaused = function() {
            return this.get("paused");
          }, F.prototype.getTextTracks = function() {
            return this.get("textTracks");
          }, F.prototype.getVideoEmbedCode = function() {
            return this.get("videoEmbedCode");
          }, F.prototype.getVideoId = function() {
            return this.get("videoId");
          }, F.prototype.getVideoTitle = function() {
            return this.get("videoTitle");
          }, F.prototype.getVideoWidth = function() {
            return this.get("videoWidth");
          }, F.prototype.getVideoHeight = function() {
            return this.get("videoHeight");
          }, F.prototype.getVideoUrl = function() {
            return this.get("videoUrl");
          }, F.prototype.getVolume = function() {
            return this.get("volume");
          }, F.prototype.setVolume = function(G) {
            return this.set("volume", G);
          }, F;
        }();
        return v(), M;
      });
    }).call(this, typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {});
  }, {}], 2: [function(r, i, t) {
    (function(n) {
      t.__esModule = !0;
      var a = re, s = u(a), o = r("@vimeo/player"), l = u(o);
      function u(y) {
        return y && y.__esModule ? y : { default: y };
      }
      function h(y, v) {
        if (!(y instanceof v))
          throw new TypeError("Cannot call a class as a function");
      }
      function c(y, v) {
        if (!y)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return v && (typeof v == "object" || typeof v == "function") ? v : y;
      }
      function d(y, v) {
        if (typeof v != "function" && v !== null)
          throw new TypeError("Super expression must either be null or a function, not " + typeof v);
        y.prototype = Object.create(v && v.prototype, { constructor: { value: y, enumerable: !1, writable: !0, configurable: !0 } }), v && (Object.setPrototypeOf ? Object.setPrototypeOf(y, v) : y.__proto__ = v);
      }
      s.default.getComponent("Component");
      var f = s.default.getComponent("Tech"), m = !1, p = function(y) {
        d(v, y);
        function v(g, E) {
          h(this, v);
          var x = c(this, y.call(this, g, E));
          return b(), x.setPoster(g.poster), x.initVimeoPlayer(), x;
        }
        return v.prototype.initVimeoPlayer = function() {
          var E = this, x = {
            url: this.options_.source.src,
            byline: !1,
            portrait: !1,
            title: !1
          };
          this.options_.autoplay && (x.autoplay = !0), this.options_.height && (x.height = this.options_.height), this.options_.width && (x.width = this.options_.width), this.options_.maxheight && (x.maxheight = this.options_.maxheight), this.options_.maxwidth && (x.maxwidth = this.options_.maxwidth), this.options_.loop && (x.loop = this.options_.loop), this._player = new l.default(this.el(), x), this.initVimeoState(), ["play", "pause", "ended", "timeupdate", "progress", "seeked"].forEach(function(w) {
            E._player.on(w, function(S) {
              E._vimeoState.progress.duration != S.duration && E.trigger("durationchange"), E._vimeoState.progress = S, E.trigger(w);
            });
          }), this._player.on("pause", function() {
            return E._vimeoState.playing = !1;
          }), this._player.on("play", function() {
            E._vimeoState.playing = !0, E._vimeoState.ended = !1;
          }), this._player.on("ended", function() {
            E._vimeoState.playing = !1, E._vimeoState.ended = !0;
          }), this._player.on("volumechange", function(w) {
            return E._vimeoState.volume = w;
          }), this._player.on("error", function(w) {
            return E.trigger("error", w);
          }), this.triggerReady();
        }, v.prototype.initVimeoState = function() {
          var E = this._vimeoState = {
            ended: !1,
            playing: !1,
            volume: 0,
            progress: {
              seconds: 0,
              percent: 0,
              duration: 0
            }
          };
          this._player.getCurrentTime().then(function(x) {
            return E.progress.seconds = x;
          }), this._player.getDuration().then(function(x) {
            return E.progress.duration = x;
          }), this._player.getPaused().then(function(x) {
            return E.playing = !x;
          }), this._player.getVolume().then(function(x) {
            return E.volume = x;
          });
        }, v.prototype.createEl = function() {
          var E = s.default.createEl("div", {
            id: this.options_.techId
          });
          return E.style.cssText = "width:100%;height:100%;top:0;left:0;position:absolute", E.className = "vjs-vimeo", E;
        }, v.prototype.controls = function() {
          return !0;
        }, v.prototype.supportsFullScreen = function() {
          return !0;
        }, v.prototype.src = function() {
          return this.options_.source;
        }, v.prototype.currentSrc = function() {
          return this.options_.source.src;
        }, v.prototype.currentTime = function() {
          return this._vimeoState.progress.seconds;
        }, v.prototype.setCurrentTime = function(E) {
          this._player.setCurrentTime(E);
        }, v.prototype.volume = function() {
          return this._vimeoState.volume;
        }, v.prototype.setVolume = function(E) {
          return this._player.setVolume(E);
        }, v.prototype.duration = function() {
          return this._vimeoState.progress.duration;
        }, v.prototype.buffered = function() {
          var E = this._vimeoState.progress;
          return s.default.createTimeRange(0, E.percent * E.duration);
        }, v.prototype.paused = function() {
          return !this._vimeoState.playing;
        }, v.prototype.pause = function() {
          this._player.pause();
        }, v.prototype.play = function() {
          this._player.play();
        }, v.prototype.muted = function() {
          return this._vimeoState.volume === 0;
        }, v.prototype.ended = function() {
          return this._vimeoState.ended;
        }, v;
      }(f);
      p.prototype.featuresTimeupdateEvents = !0, p.isSupported = function() {
        return !0;
      }, f.withSourceHandlers(p), p.nativeSourceHandler = {}, p.nativeSourceHandler.canPlayType = function(y) {
        return y === "video/vimeo" ? "maybe" : "";
      }, p.nativeSourceHandler.canHandleSource = function(y) {
        return y.type ? p.nativeSourceHandler.canPlayType(y.type) : y.src ? p.nativeSourceHandler.canPlayType(y.src) : "";
      }, p.nativeSourceHandler.handleSource = function(y, v) {
        v.src(y.src);
      }, p.nativeSourceHandler.dispose = function() {
      }, p.registerSourceHandler(p.nativeSourceHandler);
      function b() {
        if (!m) {
          m = !0;
          var y = `
      .vjs-vimeo iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    `, v = document.head || document.getElementsByTagName("head")[0], g = document.createElement("style");
          g.type = "text/css", g.styleSheet ? g.styleSheet.cssText = y : g.appendChild(document.createTextNode(y)), v.appendChild(g);
        }
      }
      f.registerTech("Vimeo", p), p.VERSION = "0.0.1", t.default = p;
    }).call(this, typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {});
  }, { "@vimeo/player": 1 }] }, {}, [2])(2);
});
var Zj = { exports: {} };
(function(e, r) {
  (function(i, t) {
    {
      var n = Lx;
      e.exports = t(n.default || n);
    }
  })(fn, function(i) {
    var t = i.browser.IS_IOS || i.browser.IS_NATIVE_ANDROID, n = i.getTech("Tech"), a = i.extend(n, {
      constructor: function(u, h) {
        n.call(this, u, h), this.setPoster(u.poster), this.setSrc(this.options_.source, !0), this.setTimeout(function() {
          this.el_ && (this.el_.parentNode.className += " vjs-youtube", t && (this.el_.parentNode.className += " vjs-youtube-mobile"), a.isApiReady ? this.initYTPlayer() : a.apiReadyQueue.push(this));
        }.bind(this));
      },
      dispose: function() {
        if (this.ytPlayer)
          this.ytPlayer.stopVideo && this.ytPlayer.stopVideo(), this.ytPlayer.destroy && this.ytPlayer.destroy();
        else {
          var u = a.apiReadyQueue.indexOf(this);
          u !== -1 && a.apiReadyQueue.splice(u, 1);
        }
        this.ytPlayer = null, this.el_.parentNode.className = this.el_.parentNode.className.replace(" vjs-youtube", "").replace(" vjs-youtube-mobile", ""), this.el_.parentNode.removeChild(this.el_), n.prototype.dispose.call(this);
      },
      createEl: function() {
        var u = document.createElement("div");
        u.setAttribute("id", this.options_.techId), u.setAttribute("style", "width:100%;height:100%;top:0;left:0;position:absolute"), u.setAttribute("class", "vjs-tech");
        var h = document.createElement("div");
        if (h.appendChild(u), !t && !this.options_.ytControls) {
          var c = document.createElement("div");
          c.setAttribute("class", "vjs-iframe-blocker"), c.setAttribute("style", "position:absolute;top:0;left:0;width:100%;height:100%"), c.onclick = function() {
            this.pause();
          }.bind(this), h.appendChild(c);
        }
        return h;
      },
      initYTPlayer: function() {
        var u = {
          controls: 0,
          modestbranding: 1,
          rel: 0,
          showinfo: 0,
          loop: this.options_.loop ? 1 : 0
        };
        if (typeof this.options_.autohide < "u" && (u.autohide = this.options_.autohide), typeof this.options_.cc_load_policy < "u" && (u.cc_load_policy = this.options_.cc_load_policy), typeof this.options_.ytControls < "u" && (u.controls = this.options_.ytControls), typeof this.options_.disablekb < "u" && (u.disablekb = this.options_.disablekb), typeof this.options_.color < "u" && (u.color = this.options_.color), u.controls ? typeof this.options_.fs < "u" && (u.fs = this.options_.fs) : u.fs = 0, this.options_.source.src.indexOf("end=") !== -1) {
          var h = this.options_.source.src.match(/end=([0-9]*)/);
          this.options_.end = parseInt(h[1]);
        }
        if (typeof this.options_.end < "u" && (u.end = this.options_.end), typeof this.options_.hl < "u" ? u.hl = this.options_.hl : typeof this.options_.language < "u" && (u.hl = this.options_.language.substr(0, 2)), typeof this.options_.iv_load_policy < "u" && (u.iv_load_policy = this.options_.iv_load_policy), typeof this.options_.list < "u" ? u.list = this.options_.list : this.url && typeof this.url.listId < "u" && (u.list = this.url.listId), typeof this.options_.listType < "u" && (u.listType = this.options_.listType), typeof this.options_.modestbranding < "u" && (u.modestbranding = this.options_.modestbranding), typeof this.options_.playlist < "u" && (u.playlist = this.options_.playlist), typeof this.options_.playsinline < "u" && (u.playsinline = this.options_.playsinline), typeof this.options_.rel < "u" && (u.rel = this.options_.rel), typeof this.options_.showinfo < "u" && (u.showinfo = this.options_.showinfo), this.options_.source.src.indexOf("start=") !== -1) {
          var c = this.options_.source.src.match(/start=([0-9]*)/);
          this.options_.start = parseInt(c[1]);
        }
        if (typeof this.options_.start < "u" && (u.start = this.options_.start), typeof this.options_.theme < "u" && (u.theme = this.options_.theme), typeof this.options_.customVars < "u") {
          var d = this.options_.customVars;
          Object.keys(d).forEach(function(m) {
            u[m] = d[m];
          });
        }
        this.activeVideoId = this.url ? this.url.videoId : null, this.activeList = u.list;
        var f = {
          videoId: this.activeVideoId,
          playerVars: u,
          events: {
            onReady: this.onPlayerReady.bind(this),
            onPlaybackQualityChange: this.onPlayerPlaybackQualityChange.bind(this),
            onPlaybackRateChange: this.onPlayerPlaybackRateChange.bind(this),
            onStateChange: this.onPlayerStateChange.bind(this),
            onVolumeChange: this.onPlayerVolumeChange.bind(this),
            onError: this.onPlayerError.bind(this)
          }
        };
        typeof this.options_.enablePrivacyEnhancedMode < "u" && this.options_.enablePrivacyEnhancedMode && (f.host = "https://www.youtube-nocookie.com"), this.ytPlayer = new YT.Player(this.options_.techId, f);
      },
      onPlayerReady: function() {
        this.options_.muted && this.ytPlayer.mute();
        var u = this.ytPlayer.getAvailablePlaybackRates();
        u.length > 1 && (this.featuresPlaybackRate = !0), this.playerReady_ = !0, this.triggerReady(), this.playOnReady ? this.play() : this.cueOnReady && (this.cueVideoById_(this.url.videoId), this.activeVideoId = this.url.videoId);
      },
      onPlayerPlaybackQualityChange: function() {
      },
      onPlayerPlaybackRateChange: function() {
        this.trigger("ratechange");
      },
      onPlayerStateChange: function(u) {
        var h = u.data;
        if (!(h === this.lastState || this.errorNumber))
          switch (this.lastState = h, h) {
            case -1:
              this.trigger("loadstart"), this.trigger("loadedmetadata"), this.trigger("durationchange"), this.trigger("ratechange");
              break;
            case YT.PlayerState.ENDED:
              this.trigger("ended");
              break;
            case YT.PlayerState.PLAYING:
              this.trigger("timeupdate"), this.trigger("durationchange"), this.trigger("playing"), this.trigger("play"), this.isSeeking && this.onSeeked();
              break;
            case YT.PlayerState.PAUSED:
              this.trigger("canplay"), this.isSeeking ? this.onSeeked() : this.trigger("pause");
              break;
            case YT.PlayerState.BUFFERING:
              this.player_.trigger("timeupdate"), this.player_.trigger("waiting");
              break;
          }
      },
      onPlayerVolumeChange: function() {
        this.trigger("volumechange");
      },
      onPlayerError: function(u) {
        this.errorNumber = u.data, this.trigger("pause"), this.trigger("error");
      },
      error: function() {
        var u = 1e3 + this.errorNumber;
        switch (this.errorNumber) {
          case 5:
            return { code: u, message: "Error while trying to play the video" };
          case 2:
          case 100:
            return { code: u, message: "Unable to find the video" };
          case 101:
          case 150:
            return {
              code: u,
              message: "Playback on other Websites has been disabled by the video owner."
            };
        }
        return { code: u, message: "YouTube unknown error (" + this.errorNumber + ")" };
      },
      loadVideoById_: function(u) {
        var h = {
          videoId: u
        };
        this.options_.start && (h.startSeconds = this.options_.start), this.options_.end && (h.endSeconds = this.options_.end), this.ytPlayer.loadVideoById(h);
      },
      cueVideoById_: function(u) {
        var h = {
          videoId: u
        };
        this.options_.start && (h.startSeconds = this.options_.start), this.options_.end && (h.endSeconds = this.options_.end), this.ytPlayer.cueVideoById(h);
      },
      src: function(u) {
        return u && this.setSrc({ src: u }), this.source;
      },
      poster: function() {
        return t ? null : this.poster_;
      },
      setPoster: function(u) {
        this.poster_ = u;
      },
      setSrc: function(u) {
        !u || !u.src || (delete this.errorNumber, this.source = u, this.url = a.parseUrl(u.src), this.options_.poster || this.url.videoId && (this.poster_ = "https://img.youtube.com/vi/" + this.url.videoId + "/0.jpg", this.trigger("posterchange"), this.checkHighResPoster()), this.options_.autoplay && !t ? this.isReady_ ? this.play() : this.playOnReady = !0 : this.activeVideoId !== this.url.videoId && (this.isReady_ ? (this.cueVideoById_(this.url.videoId), this.activeVideoId = this.url.videoId) : this.cueOnReady = !0));
      },
      autoplay: function() {
        return this.options_.autoplay;
      },
      setAutoplay: function(u) {
        this.options_.autoplay = u;
      },
      loop: function() {
        return this.options_.loop;
      },
      setLoop: function(u) {
        this.options_.loop = u;
      },
      play: function() {
        !this.url || !this.url.videoId || (this.wasPausedBeforeSeek = !1, this.isReady_ ? (this.url.listId && (this.activeList === this.url.listId ? this.ytPlayer.playVideo() : (this.ytPlayer.loadPlaylist(this.url.listId), this.activeList = this.url.listId)), this.activeVideoId === this.url.videoId ? this.ytPlayer.playVideo() : (this.loadVideoById_(this.url.videoId), this.activeVideoId = this.url.videoId)) : (this.trigger("waiting"), this.playOnReady = !0));
      },
      pause: function() {
        this.ytPlayer && this.ytPlayer.pauseVideo();
      },
      paused: function() {
        return this.ytPlayer ? this.lastState !== YT.PlayerState.PLAYING && this.lastState !== YT.PlayerState.BUFFERING : !0;
      },
      currentTime: function() {
        return this.ytPlayer ? this.ytPlayer.getCurrentTime() : 0;
      },
      setCurrentTime: function(u) {
        this.lastState === YT.PlayerState.PAUSED && (this.timeBeforeSeek = this.currentTime()), this.isSeeking || (this.wasPausedBeforeSeek = this.paused()), this.ytPlayer.seekTo(u, !0), this.trigger("timeupdate"), this.trigger("seeking"), this.isSeeking = !0, this.lastState === YT.PlayerState.PAUSED && this.timeBeforeSeek !== u && (clearInterval(this.checkSeekedInPauseInterval), this.checkSeekedInPauseInterval = setInterval(function() {
          this.lastState !== YT.PlayerState.PAUSED || !this.isSeeking ? clearInterval(this.checkSeekedInPauseInterval) : this.currentTime() !== this.timeBeforeSeek && (this.trigger("timeupdate"), this.onSeeked());
        }.bind(this), 250));
      },
      seeking: function() {
        return this.isSeeking;
      },
      seekable: function() {
        return this.ytPlayer ? i.createTimeRange(0, this.ytPlayer.getDuration()) : i.createTimeRange();
      },
      onSeeked: function() {
        clearInterval(this.checkSeekedInPauseInterval), this.isSeeking = !1, this.wasPausedBeforeSeek && this.pause(), this.trigger("seeked");
      },
      playbackRate: function() {
        return this.ytPlayer ? this.ytPlayer.getPlaybackRate() : 1;
      },
      setPlaybackRate: function(u) {
        !this.ytPlayer || this.ytPlayer.setPlaybackRate(u);
      },
      duration: function() {
        return this.ytPlayer ? this.ytPlayer.getDuration() : 0;
      },
      currentSrc: function() {
        return this.source && this.source.src;
      },
      ended: function() {
        return this.ytPlayer ? this.lastState === YT.PlayerState.ENDED : !1;
      },
      volume: function() {
        return this.ytPlayer ? this.ytPlayer.getVolume() / 100 : 1;
      },
      setVolume: function(u) {
        !this.ytPlayer || this.ytPlayer.setVolume(u * 100);
      },
      muted: function() {
        return this.ytPlayer ? this.ytPlayer.isMuted() : !1;
      },
      setMuted: function(u) {
        if (this.ytPlayer)
          this.muted(!0);
        else
          return;
        u ? this.ytPlayer.mute() : this.ytPlayer.unMute(), this.setTimeout(function() {
          this.trigger("volumechange");
        }, 50);
      },
      buffered: function() {
        if (!this.ytPlayer || !this.ytPlayer.getVideoLoadedFraction)
          return i.createTimeRange();
        var u = this.ytPlayer.getVideoLoadedFraction() * this.ytPlayer.getDuration();
        return i.createTimeRange(0, u);
      },
      preload: function() {
      },
      load: function() {
      },
      reset: function() {
      },
      networkState: function() {
        if (!this.ytPlayer)
          return 0;
        switch (this.ytPlayer.getPlayerState()) {
          case -1:
            return 0;
          case 3:
            return 2;
          default:
            return 1;
        }
      },
      readyState: function() {
        if (!this.ytPlayer)
          return 0;
        switch (this.ytPlayer.getPlayerState()) {
          case -1:
            return 0;
          case 5:
            return 1;
          case 3:
            return 2;
          default:
            return 4;
        }
      },
      supportsFullScreen: function() {
        return document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled;
      },
      checkHighResPoster: function() {
        var u = "https://img.youtube.com/vi/" + this.url.videoId + "/maxresdefault.jpg";
        try {
          var h = new Image();
          h.onload = function() {
            if ("naturalHeight" in h) {
              if (h.naturalHeight <= 90 || h.naturalWidth <= 120)
                return;
            } else if (h.height <= 90 || h.width <= 120)
              return;
            this.poster_ = u, this.trigger("posterchange");
          }.bind(this), h.onerror = function() {
          }, h.src = u;
        } catch {
        }
      }
    });
    a.isSupported = function() {
      return !0;
    }, a.canPlaySource = function(u) {
      return a.canPlayType(u.type);
    }, a.canPlayType = function(u) {
      return u === "video/youtube";
    }, a.parseUrl = function(u) {
      var h = {
        videoId: null
      }, c = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/, d = u.match(c);
      d && d[2].length === 11 && (h.videoId = d[2]);
      var f = /[?&]list=([^#\&\?]+)/;
      return d = u.match(f), d && d[1] && (h.listId = d[1]), h;
    };
    function s() {
      YT.ready(function() {
        a.isApiReady = !0;
        for (var u = 0; u < a.apiReadyQueue.length; ++u)
          a.apiReadyQueue[u].initYTPlayer();
      });
    }
    function o(u, h) {
      var c = !1, d = document.createElement("script"), f = document.getElementsByTagName("script")[0];
      !f || (f.parentNode.insertBefore(d, f), d.onload = function() {
        c || (c = !0, h());
      }, d.onreadystatechange = function() {
        !c && (this.readyState === "complete" || this.readyState === "loaded") && (c = !0, h());
      }, d.src = u);
    }
    function l() {
      var u = ".vjs-youtube .vjs-iframe-blocker { display: none; }.vjs-youtube.vjs-user-inactive .vjs-iframe-blocker { display: block; }.vjs-youtube .vjs-poster { background-size: cover; }.vjs-youtube-mobile .vjs-big-play-button { display: none; }", h = document.head || document.getElementsByTagName("head")[0], c = document.createElement("style");
      c.type = "text/css", c.styleSheet ? c.styleSheet.cssText = u : c.appendChild(document.createTextNode(u)), h.appendChild(c);
    }
    a.apiReadyQueue = [], typeof document < "u" && (o("https://www.youtube.com/iframe_api", s), l()), typeof i.registerTech < "u" ? i.registerTech("Youtube", a) : i.registerComponent("Youtube", a);
  });
})(Zj);
fr.service("VJSYoutubeTech", function() {
  const e = re.getTech("Youtube");
  return e.prototype.onPlayerReady = function() {
    console.log("YT Player Ready"), this.options_.muted && this.ytPlayer.mute();
    var r = this.ytPlayer.getAvailablePlaybackRates();
    r.length > 1 && (this.featuresPlaybackRate = !0), this.playerReady_ = !0, this.triggerReady(), this.playOnReady ? this.play() : this.cueOnReady && (this.cueVideoById_(this.url.videoId), this.activeVideoId = this.url.videoId);
  }, e.prototype.onPlayerError = function(r) {
    console.log("YT Player Error", r), this.errorNumber = r.data, this.trigger("pause"), this.trigger("error");
  }, e.prototype.initYTPlayer = function() {
    console.log("YT Player init"), console.log(window.location.origin);
    var r = {
      controls: 0,
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      loop: this.options_.loop ? 1 : 0
    };
    if (typeof this.options_.autohide < "u" && (r.autohide = this.options_.autohide), typeof this.options_.cc_load_policy < "u" && (r.cc_load_policy = this.options_.cc_load_policy), typeof this.options_.ytControls < "u" && (r.controls = this.options_.ytControls), typeof this.options_.disablekb < "u" && (r.disablekb = this.options_.disablekb), typeof this.options_.color < "u" && (r.color = this.options_.color), r.controls ? typeof this.options_.fs < "u" && (r.fs = this.options_.fs) : r.fs = 0, this.options_.source.src.indexOf("end=") !== -1) {
      var i = this.options_.source.src.match(/end=([0-9]*)/);
      this.options_.end = parseInt(i[1]);
    }
    if (typeof this.options_.end < "u" && (r.end = this.options_.end), typeof this.options_.hl < "u" ? r.hl = this.options_.hl : typeof this.options_.language < "u" && (r.hl = this.options_.language.substr(0, 2)), typeof this.options_.iv_load_policy < "u" && (r.iv_load_policy = this.options_.iv_load_policy), typeof this.options_.list < "u" ? r.list = this.options_.list : this.url && typeof this.url.listId < "u" && (r.list = this.url.listId), typeof this.options_.listType < "u" && (r.listType = this.options_.listType), typeof this.options_.modestbranding < "u" && (r.modestbranding = this.options_.modestbranding), typeof this.options_.playlist < "u" && (r.playlist = this.options_.playlist), typeof this.options_.playsinline < "u" && (r.playsinline = this.options_.playsinline), typeof this.options_.rel < "u" && (r.rel = this.options_.rel), typeof this.options_.showinfo < "u" && (r.showinfo = this.options_.showinfo), this.options_.source.src.indexOf("start=") !== -1) {
      var t = this.options_.source.src.match(/start=([0-9]*)/);
      this.options_.start = parseInt(t[1]);
    }
    if (typeof this.options_.start < "u" && (r.start = this.options_.start), typeof this.options_.theme < "u" && (r.theme = this.options_.theme), typeof this.options_.customVars < "u") {
      var n = this.options_.customVars;
      Object.keys(n).forEach(function(s) {
        r[s] = n[s];
      });
    }
    this.activeVideoId = this.url ? this.url.videoId : null, this.activeList = r.list;
    var a = {
      videoId: this.activeVideoId,
      playerVars: r,
      events: {
        onReady: this.onPlayerReady.bind(this),
        onPlaybackQualityChange: this.onPlayerPlaybackQualityChange.bind(this),
        onPlaybackRateChange: this.onPlayerPlaybackRateChange.bind(this),
        onStateChange: this.onPlayerStateChange.bind(this),
        onVolumeChange: this.onPlayerVolumeChange.bind(this),
        onError: this.onPlayerError.bind(this)
      }
    };
    typeof this.options_.enablePrivacyEnhancedMode < "u" && this.options_.enablePrivacyEnhancedMode && (a.host = "https://www.youtube-nocookie.com"), this.ytPlayer = new YT.Player(this.options_.techId, a);
  }, e.prototype.onPlayerStateChange = function(r) {
    var i = r.data;
    if (!(i === this.lastState || this.errorNumber))
      switch ((!this.scrubbing || this.scrubbing && i === YT.PlayerState.PAUSED) && (this.lastState = i), i) {
        case -1:
          this.trigger("loadstart"), this.trigger("loadedmetadata"), this.trigger("durationchange"), this.trigger("ratechange");
          break;
        case YT.PlayerState.ENDED:
          this.trigger("ended");
          break;
        case YT.PlayerState.PLAYING:
          this.trigger("timeupdate"), this.trigger("durationchange"), this.trigger("playing"), this.trigger("play"), this.isSeeking && this.onSeeked();
          break;
        case YT.PlayerState.PAUSED:
          this.trigger("canplay"), this.isSeeking ? this.onSeeked() : this.trigger("pause");
          break;
        case YT.PlayerState.BUFFERING:
          this.player_.trigger("timeupdate"), this.player_.trigger("waiting");
          break;
      }
  }, this;
});
fr.run([
  "VJSImageTech",
  "VJSYoutubeTech",
  "VJSRed5Tech",
  "VJSIVSTech",
  "VJSAntTech",
  function(e, r, i, t, n) {
  }
]);
var Ob = typeof fn < "u" ? fn : typeof window < "u" ? window : {}, e$ = Ub, Yc;
typeof document < "u" ? Yc = document : (Yc = Ob["__GLOBAL_DOCUMENT_CACHE@4"], Yc || (Yc = Ob["__GLOBAL_DOCUMENT_CACHE@4"] = e$));
var t$ = Yc;
/*! @name videojs-contrib-ads @version 6.6.5 @license Apache-2.0 */
var jA = "6.6.5";
function r$(e) {
  return {
    disableNextSnapshotRestore: !1,
    _contentEnding: !1,
    _contentHasEnded: !1,
    _hasThereBeenALoadStartDuringPlayerLife: !1,
    _hasThereBeenALoadedData: !1,
    _hasThereBeenALoadedMetaData: !1,
    _inLinearAdMode: !1,
    _shouldBlockPlay: !1,
    _playBlocked: !1,
    _playRequested: !1,
    adType: null,
    VERSION: jA,
    reset: function() {
      e.ads.disableNextSnapshotRestore = !1, e.ads._contentEnding = !1, e.ads._contentHasEnded = !1, e.ads.snapshot = null, e.ads.adType = null, e.ads._hasThereBeenALoadedData = !1, e.ads._hasThereBeenALoadedMetaData = !1, e.ads._cancelledPlay = !1, e.ads._shouldBlockPlay = !1, e.ads._playBlocked = !1, e.ads.nopreroll_ = !1, e.ads.nopostroll_ = !1, e.ads._playRequested = !1;
    },
    startLinearAdMode: function() {
      e.ads._state.startLinearAdMode();
    },
    endLinearAdMode: function() {
      e.ads._state.endLinearAdMode();
    },
    skipLinearAdMode: function() {
      e.ads._state.skipLinearAdMode();
    },
    stitchedAds: function(i) {
      return i !== void 0 && (re.log.warn("Using player.ads.stitchedAds() as a setter is deprecated, it should be set as an option upon initialization of contrib-ads."), this.settings.stitchedAds = !!i), this.settings.stitchedAds;
    },
    videoElementRecycled: function() {
      if (e.ads.shouldPlayContentBehindAd(e))
        return !1;
      if (!this.snapshot)
        throw new Error("You cannot use videoElementRecycled while there is no snapshot.");
      var i = e.tech_.src() !== this.snapshot.src, t = e.currentSrc() !== this.snapshot.currentSrc;
      return i || t;
    },
    isLive: function(i) {
      return i === void 0 && (i = e), typeof i.ads.settings.contentIsLive == "boolean" ? i.ads.settings.contentIsLive : i.duration() === 1 / 0 ? !0 : re.browser.IOS_VERSION === "8" && i.duration() === 0;
    },
    shouldPlayContentBehindAd: function(i) {
      if (i === void 0 && (i = e), i)
        return i.ads.settings.liveCuePoints ? !re.browser.IS_IOS && !re.browser.IS_ANDROID && i.duration() === 1 / 0 : !1;
      throw new Error("shouldPlayContentBehindAd requires a player as a param");
    },
    shouldTakeSnapshots: function(i) {
      return i === void 0 && (i = e), !this.shouldPlayContentBehindAd(i) && !this.stitchedAds();
    },
    isInAdMode: function() {
      return this._state.isAdState();
    },
    isWaitingForAdBreak: function() {
      return this._state.isWaitingForAdBreak();
    },
    isContentResuming: function() {
      return this._state.isContentResuming();
    },
    isAdPlaying: function() {
      return this._state.inAdBreak();
    },
    inAdBreak: function() {
      return this._state.inAdBreak();
    },
    removeNativePoster: function() {
      var i = e.$(".vjs-tech");
      i && i.removeAttribute("poster");
    },
    debug: function() {
      if (this.settings.debug) {
        for (var i = arguments.length, t = new Array(i), n = 0; n < i; n++)
          t[n] = arguments[n];
        t.length === 1 && typeof t[0] == "string" ? re.log("ADS: " + t[0]) : re.log.apply(re, ["ADS:"].concat(t));
      }
    }
  };
}
var $A = function(r, i) {
  i.isImmediatePropagationStopped = function() {
    return !0;
  }, i.cancelBubble = !0, i.isPropagationStopped = function() {
    return !0;
  };
}, Gs = function(r, i, t) {
  $A(r, t), r.trigger({
    type: i + t.type,
    originalEvent: t
  });
}, i$ = function(r, i) {
  r.ads.isInAdMode() && (r.ads.isContentResuming() ? r.ads._contentEnding && Gs(r, "content", i) : Gs(r, "ad", i));
}, n$ = function(r, i) {
  r.ads.isInAdMode() ? r.ads.isContentResuming() ? ($A(r, i), r.trigger("resumeended")) : Gs(r, "ad", i) : !r.ads._contentHasEnded && !r.ads.stitchedAds() && (Gs(r, "content", i), r.trigger("readyforpostroll"));
}, a$ = function(r, i) {
  if (!(i.type === "loadstart" && !r.ads._hasThereBeenALoadStartDuringPlayerLife || i.type === "loadeddata" && !r.ads._hasThereBeenALoadedData || i.type === "loadedmetadata" && !r.ads._hasThereBeenALoadedMetaData))
    if (r.ads.inAdBreak())
      Gs(r, "ad", i);
    else {
      if (r.currentSrc() !== r.ads.contentSrc)
        return;
      Gs(r, "content", i);
    }
}, s$ = function(r, i) {
  r.ads.inAdBreak() ? Gs(r, "ad", i) : r.ads.isContentResuming() && Gs(r, "content", i);
};
function o$(e) {
  e.type === "playing" ? i$(this, e) : e.type === "ended" ? n$(this, e) : e.type === "loadstart" || e.type === "loadeddata" || e.type === "loadedmetadata" ? a$(this, e) : e.type === "play" ? s$(this, e) : this.ads.isInAdMode() && (this.ads.isContentResuming() ? Gs(this, "content", e) : Gs(this, "ad", e));
}
function u$(e) {
  e.ads.contentSrc = e.currentSrc(), e.ads._seenInitialLoadstart = !1;
  var r = function() {
    if (!e.ads.inAdBreak()) {
      var t = e.currentSrc();
      t !== e.ads.contentSrc && (e.ads._seenInitialLoadstart && e.trigger({
        type: "contentchanged"
      }), e.trigger({
        type: "contentupdate",
        oldValue: e.ads.contentSrc,
        newValue: t
      }), e.ads.contentSrc = t), e.ads._seenInitialLoadstart = !0;
    }
  };
  e.on("loadstart", r);
}
var Lb = function(r, i) {
  return i ? encodeURIComponent(r) : r;
}, Ib = function(r, i, t) {
  if (r && r[t])
    for (var n = r[t], a = Object.keys(n), s = 0; s < a.length; s++) {
      var o = "{mediainfo." + t + "." + a[s] + "}";
      i[o] = n[a[s]];
    }
};
function l$(e, r, i) {
  var t = this, n = {};
  e = e.replace(/{([^}=]+)=([^}]+)}/g, function(l, u, h) {
    return n["{" + u + "}"] = h, "{" + u + "}";
  }), r === void 0 && (r = !1);
  var a = {};
  i !== void 0 && (a = i), a["{player.id}"] = this.options_["data-player"], a["{mediainfo.id}"] = this.mediainfo ? this.mediainfo.id : "", a["{mediainfo.name}"] = this.mediainfo ? this.mediainfo.name : "", a["{mediainfo.duration}"] = this.mediainfo ? this.mediainfo.duration : "", a["{player.duration}"] = this.duration(), a["{timestamp}"] = new Date().getTime(), a["{document.referrer}"] = t$.referrer, a["{window.location.href}"] = ai.location.href, a["{random}"] = Math.floor(Math.random() * 1e12), ["description", "tags", "reference_id", "ad_keys"].forEach(function(l) {
    t.mediainfo && t.mediainfo[l] ? a["{mediainfo." + l + "}"] = t.mediainfo[l] : n["{mediainfo." + l + "}"] ? a["{mediainfo." + l + "}"] = n["{mediainfo." + l + "}"] : a["{mediainfo." + l + "}"] = "";
  }), Ib(this.mediainfo, a, "custom_fields"), Ib(this.mediainfo, a, "customFields");
  for (var s in a)
    e = e.split(s).join(Lb(a[s], r));
  e = e.replace(/{pageVariable\.([^}]+)}/g, function(l, u) {
    for (var h, c = ai, d = u.split("."), f = 0; f < d.length; f++)
      f === d.length - 1 ? h = c[d[f]] : c = c[d[f]];
    var m = typeof h;
    return h === null ? "null" : h === void 0 ? n["{pageVariable." + u + "}"] ? n["{pageVariable." + u + "}"] : (re.log.warn('Page variable "' + u + '" not found'), "") : m !== "string" && m !== "number" && m !== "boolean" ? (re.log.warn('Page variable "' + u + '" is not a supported type'), "") : Lb(String(h), r);
  });
  for (var o in n)
    e = e.replace(o, n[o]);
  return e;
}
var dl = {};
dl.processMetadataTracks = function(e, r) {
  for (var i = e.textTracks(), t = function(s) {
    s.kind === "metadata" && (e.ads.cueTextTracks.setMetadataTrackMode(s), r(e, s));
  }, n = 0; n < i.length; n++)
    t(i[n]);
  i.addEventListener("addtrack", function(a) {
    t(a.track);
  });
};
dl.setMetadataTrackMode = function(e) {
};
dl.getSupportedAdCue = function(e, r) {
  return r;
};
dl.isSupportedAdCue = function(e, r) {
  return !0;
};
dl.getCueId = function(e, r) {
  return r.id;
};
var c$ = function(r, i) {
  return i !== void 0 && r.ads.includedCues[i];
}, d$ = function(r, i) {
  i !== void 0 && i !== "" && (r.ads.includedCues[i] = !0);
};
dl.processAdTrack = function(e, r, i, t) {
  e.ads.includedCues = {};
  for (var n = 0; n < r.length; n++) {
    var a = r[n], s = this.getSupportedAdCue(e, a);
    if (!this.isSupportedAdCue(e, a)) {
      re.log.warn("Skipping as this is not a supported ad cue.", a);
      return;
    }
    var o = this.getCueId(e, a), l = a.startTime;
    if (c$(e, o)) {
      re.log("Skipping ad already seen with ID " + o);
      return;
    }
    t && t(e, s, o, l), i(e, s, o, l), d$(e, o);
  }
};
function f$(e, r) {
  r && re.log("Using cancelContentPlay to block content playback"), e.on("play", h$);
}
function h$() {
  this.ads._shouldBlockPlay !== !1 && (this.paused() || (this.ads.debug("Playback was canceled by cancelContentPlay"), this.pause()), this.ads._cancelledPlay = !0);
}
var Tc = {}, Uu = re;
Tc.isMiddlewareMediatorSupported = function() {
  return Uu.browser.IS_IOS || Uu.browser.IS_ANDROID ? !1 : !!(Uu.use && Uu.middleware && Uu.middleware.TERMINATOR);
};
Tc.playMiddleware = function(e) {
  return {
    setSource: function(i, t) {
      t(null, i);
    },
    callPlay: function() {
      if (e.ads && e.ads._shouldBlockPlay === !0)
        return e.ads.debug("Using playMiddleware to block content playback"), e.ads._playBlocked = !0, Uu.middleware.TERMINATOR;
    },
    play: function(i, t) {
      e.ads && e.ads._playBlocked && i ? (e.ads.debug("Play call to Tech was terminated."), e.trigger("play"), e.addClass("vjs-has-started"), e.ads._playBlocked = !1) : t && t.catch && t.catch(function(n) {
        n.name === "NotAllowedError" && !re.browser.IS_SAFARI && e.trigger("pause");
      });
    }
  };
};
Tc.testHook = function(e) {
  Uu = e;
};
var p$ = Tc.playMiddleware, g$ = Tc.isMiddlewareMediatorSupported, v$ = function() {
  if (re.getPlugin)
    return Boolean(re.getPlugin("ads"));
  var r = re.getComponent("Player");
  return Boolean(r && r.prototype.ads);
};
function m$(e) {
  if (v$())
    return !1;
  var r = re.registerPlugin || re.plugin;
  return r("ads", e), g$() && !re.usingContribAdsMiddleware_ && (re.use("*", p$), re.usingContribAdsMiddleware_ = !0, re.log.debug("Play middleware has been registered with videojs")), !0;
}
var Wr = /* @__PURE__ */ function() {
  function e() {
  }
  return e.getState = function(i) {
    if (!!i && e.states_ && e.states_[i])
      return e.states_[i];
  }, e.registerState = function(i, t) {
    if (typeof i != "string" || !i)
      throw new Error('Illegal state name, "' + i + '"; must be a non-empty string.');
    return e.states_ || (e.states_ = {}), e.states_[i] = t, t;
  }, e;
}(), D0 = /* @__PURE__ */ function() {
  e._getName = function() {
    return "Anonymous State";
  };
  function e(i) {
    this.player = i;
  }
  var r = e.prototype;
  return r.transitionTo = function(t) {
    var n = this.player;
    this.cleanup(n);
    var a = new t(n);
    n.ads._state = a, n.ads.debug(this.constructor._getName() + " -> " + a.constructor._getName());
    for (var s = arguments.length, o = new Array(s > 1 ? s - 1 : 0), l = 1; l < s; l++)
      o[l - 1] = arguments[l];
    a.init.apply(a, [n].concat(o));
  }, r.init = function() {
  }, r.cleanup = function() {
  }, r.onPlay = function() {
  }, r.onPlaying = function() {
  }, r.onEnded = function() {
  }, r.onAdEnded = function() {
  }, r.onAdsReady = function() {
    re.log.warn("Unexpected adsready event");
  }, r.onAdsError = function() {
  }, r.onAdsCanceled = function() {
  }, r.onAdTimeout = function() {
  }, r.onAdStarted = function() {
  }, r.onContentChanged = function() {
  }, r.onContentResumed = function() {
  }, r.onReadyForPostroll = function() {
    re.log.warn("Unexpected readyforpostroll event");
  }, r.onNoPreroll = function() {
  }, r.onNoPostroll = function() {
  }, r.startLinearAdMode = function() {
    re.log.warn("Unexpected startLinearAdMode invocation (State via " + this.constructor._getName() + ")");
  }, r.endLinearAdMode = function() {
    re.log.warn("Unexpected endLinearAdMode invocation (State via " + this.constructor._getName() + ")");
  }, r.skipLinearAdMode = function() {
    re.log.warn("Unexpected skipLinearAdMode invocation (State via " + this.constructor._getName() + ")");
  }, r.isAdState = function() {
    throw new Error("isAdState unimplemented for " + this.constructor._getName());
  }, r.isWaitingForAdBreak = function() {
    return !1;
  }, r.isContentResuming = function() {
    return !1;
  }, r.inAdBreak = function() {
    return !1;
  }, r.handleEvent = function(t) {
    var n = this.player;
    t === "play" ? this.onPlay(n) : t === "adsready" ? this.onAdsReady(n) : t === "adserror" ? this.onAdsError(n) : t === "adscanceled" ? this.onAdsCanceled(n) : t === "adtimeout" ? this.onAdTimeout(n) : t === "ads-ad-started" ? this.onAdStarted(n) : t === "contentchanged" ? this.onContentChanged(n) : t === "contentresumed" ? this.onContentResumed(n) : t === "readyforpostroll" ? this.onReadyForPostroll(n) : t === "playing" ? this.onPlaying(n) : t === "ended" ? this.onEnded(n) : t === "nopreroll" ? this.onNoPreroll(n) : t === "nopostroll" ? this.onNoPostroll(n) : t === "adended" && this.onAdEnded(n);
  }, e;
}();
Wr.registerState("State", D0);
function Ws(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, e.__proto__ = r;
}
var y$ = /* @__PURE__ */ function(e) {
  Ws(r, e);
  function r(t) {
    var n;
    return n = e.call(this, t) || this, n.contentResuming = !1, n.waitingForAdBreak = !1, n;
  }
  var i = r.prototype;
  return i.isAdState = function() {
    return !0;
  }, i.onPlaying = function() {
    var n = Wr.getState("ContentPlayback");
    this.contentResuming && this.transitionTo(n);
  }, i.onContentResumed = function() {
    var n = Wr.getState("ContentPlayback");
    this.contentResuming && this.transitionTo(n);
  }, i.isWaitingForAdBreak = function() {
    return this.waitingForAdBreak;
  }, i.isContentResuming = function() {
    return this.contentResuming;
  }, i.inAdBreak = function() {
    return this.player.ads._inLinearAdMode === !0;
  }, r;
}(D0);
Wr.registerState("AdState", y$);
var _$ = /* @__PURE__ */ function(e) {
  Ws(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  var i = r.prototype;
  return i.isAdState = function() {
    return !1;
  }, i.onContentChanged = function(n) {
    var a = Wr.getState("BeforePreroll"), s = Wr.getState("Preroll");
    n.ads.debug("Received contentchanged event (ContentState)"), n.paused() ? this.transitionTo(a) : (this.transitionTo(s, !1), n.pause(), n.ads._pausedOnContentupdate = !0);
  }, r;
}(D0);
Wr.registerState("ContentState", _$);
var b$ = Wr.getState("ContentState"), T$ = /* @__PURE__ */ function(e) {
  Ws(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  r._getName = function() {
    return "AdsDone";
  };
  var i = r.prototype;
  return i.init = function(n) {
    n.ads._contentHasEnded = !0, n.trigger("ended");
  }, i.startLinearAdMode = function() {
    re.log.warn("Unexpected startLinearAdMode invocation (AdsDone)");
  }, r;
}(b$);
Wr.registerState("AdsDone", T$);
var bg;
function S$(e) {
  var r;
  re.browser.IS_IOS && e.ads.isLive(e) && e.seekable().length > 0 ? r = e.currentTime() - e.seekable().end(0) : r = e.currentTime();
  var i = e.$(".vjs-tech"), t = e.textTracks ? e.textTracks() : [], n = [], a = {
    ended: e.ended(),
    currentSrc: e.currentSrc(),
    sources: e.currentSources(),
    src: e.tech_.src(),
    currentTime: r,
    type: e.currentType()
  };
  i && (a.style = i.getAttribute("style"));
  for (var s = 0; s < t.length; s++) {
    var o = t[s];
    n.push({
      track: o,
      mode: o.mode
    }), o.mode = "disabled";
  }
  return a.suppressedTracks = n, a;
}
function E$(e, r) {
  var i = e.ads.snapshot;
  if (r === void 0 && (r = function() {
  }), e.ads.disableNextSnapshotRestore === !0) {
    e.ads.disableNextSnapshotRestore = !1, delete e.ads.snapshot, r();
    return;
  }
  var t = e.$(".vjs-tech"), n = 20, a = i.suppressedTracks, s, o = function() {
    for (var d = 0; d < a.length; d++)
      s = a[d], s.track.mode = s.mode;
  }, l = function() {
    var d;
    if (re.browser.IS_IOS && e.ads.isLive(e)) {
      if (i.currentTime < 0 && (e.seekable().length > 0 ? d = e.seekable().end(0) + i.currentTime : d = e.currentTime(), e.currentTime(d)), e.paused()) {
        var f = e.play();
        f && f.catch && f.catch(function(p) {
          re.log.warn("Play promise rejected in IOS snapshot resume", p);
        });
      }
    } else if (i.ended)
      e.currentTime(e.duration());
    else {
      e.currentTime(i.currentTime);
      var m = e.play();
      m && m.catch && m.catch(function(p) {
        re.log.warn("Play promise rejected in snapshot resume", p);
      });
    }
    e.ads.shouldRemoveAutoplay_ && (e.autoplay(!1), e.ads.shouldRemoveAutoplay_ = !1);
  }, u = function c() {
    if (e.off("contentcanplay", c), bg && e.clearTimeout(bg), t = e.el().querySelector(".vjs-tech"), t.readyState > 1 || t.seekable === void 0 || t.seekable.length > 0)
      return l();
    if (n--)
      e.setTimeout(c, 50);
    else
      try {
        l();
      } catch (d) {
        re.log.warn("Failed to resume the content after an advertisement", d);
      }
  };
  if ("style" in i && t.setAttribute("style", i.style || ""), e.ads.videoElementRecycled())
    e.one("resumeended", function() {
      delete e.ads.snapshot, r();
    }), e.one("contentloadedmetadata", o), re.browser.IS_IOS && !e.autoplay() && (e.autoplay(!0), e.ads.shouldRemoveAutoplay_ = !0), e.src(i.sources), e.one("contentcanplay", u), bg = e.setTimeout(u, 2e3);
  else {
    if (o(), !e.ended()) {
      var h = e.play();
      h && h.catch && h.catch(function(c) {
        re.log.warn("Play promise rejected in snapshot restore", c);
      });
    }
    delete e.ads.snapshot, r();
  }
}
function x$(e) {
  e.ads.debug("Starting ad break"), e.ads._inLinearAdMode = !0, e.trigger("adstart"), e.ads.shouldTakeSnapshots() && (e.ads.snapshot = S$(e)), e.ads.shouldPlayContentBehindAd(e) && (e.ads.preAdVolume_ = e.volume(), e.volume(0)), e.addClass("vjs-ad-playing"), e.hasClass("vjs-live") && e.removeClass("vjs-live"), e.ads.removeNativePoster();
}
function A$(e, r) {
  e.ads.debug("Ending ad break"), r === void 0 && (r = function() {
  }), e.ads.adType = null, e.ads._inLinearAdMode = !1, e.trigger("adend"), e.removeClass("vjs-ad-playing"), e.ads.isLive(e) && e.addClass("vjs-live"), e.ads.shouldTakeSnapshots() ? E$(e, r) : (e.volume(e.ads.preAdVolume_), r());
}
var su = {
  start: x$,
  end: A$
}, w$ = Wr.getState("AdState"), C$ = /* @__PURE__ */ function(e) {
  Ws(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  r._getName = function() {
    return "Preroll";
  };
  var i = r.prototype;
  return i.init = function(n, a, s) {
    if (this.waitingForAdBreak = !0, n.addClass("vjs-ad-loading"), s || n.ads.nopreroll_)
      return this.resumeAfterNoPreroll(n);
    var o = n.ads.settings.timeout;
    typeof n.ads.settings.prerollTimeout == "number" && (o = n.ads.settings.prerollTimeout), this._timeout = n.setTimeout(function() {
      n.trigger("adtimeout");
    }, o), a ? this.handleAdsReady() : this.adsReady = !1;
  }, i.onAdsReady = function(n) {
    n.ads.inAdBreak() ? re.log.warn("Unexpected adsready event (Preroll)") : (n.ads.debug("Received adsready event (Preroll)"), this.handleAdsReady());
  }, i.handleAdsReady = function() {
    this.adsReady = !0, this.readyForPreroll();
  }, i.afterLoadStart = function(n) {
    var a = this.player;
    a.ads._hasThereBeenALoadStartDuringPlayerLife ? n() : (a.ads.debug("Waiting for loadstart..."), a.one("loadstart", function() {
      a.ads.debug("Received loadstart event"), n();
    }));
  }, i.noPreroll = function() {
    var n = this;
    this.afterLoadStart(function() {
      n.player.ads.debug("Skipping prerolls due to nopreroll event (Preroll)"), n.resumeAfterNoPreroll(n.player);
    });
  }, i.readyForPreroll = function() {
    var n = this.player;
    this.afterLoadStart(function() {
      n.ads.debug("Triggered readyforpreroll event (Preroll)"), n.trigger("readyforpreroll");
    });
  }, i.onAdsCanceled = function(n) {
    var a = this;
    n.ads.debug("adscanceled (Preroll)"), this.afterLoadStart(function() {
      a.resumeAfterNoPreroll(n);
    });
  }, i.onAdsError = function(n) {
    var a = this;
    re.log("adserror (Preroll)"), this.inAdBreak() ? n.ads.endLinearAdMode() : this.afterLoadStart(function() {
      a.resumeAfterNoPreroll(n);
    });
  }, i.startLinearAdMode = function() {
    var n = this.player;
    this.adsReady && !n.ads.inAdBreak() && !this.isContentResuming() ? (this.clearTimeout(n), n.ads.adType = "preroll", this.waitingForAdBreak = !1, su.start(n), n.ads._shouldBlockPlay = !1) : re.log.warn("Unexpected startLinearAdMode invocation (Preroll)");
  }, i.onAdStarted = function(n) {
    n.removeClass("vjs-ad-loading");
  }, i.endLinearAdMode = function() {
    var n = this.player;
    this.inAdBreak() && (n.removeClass("vjs-ad-loading"), n.addClass("vjs-ad-content-resuming"), this.contentResuming = !0, su.end(n));
  }, i.skipLinearAdMode = function() {
    var n = this, a = this.player;
    a.ads.inAdBreak() || this.isContentResuming() ? re.log.warn("Unexpected skipLinearAdMode invocation") : this.afterLoadStart(function() {
      a.trigger("adskip"), a.ads.debug("skipLinearAdMode (Preroll)"), n.resumeAfterNoPreroll(a);
    });
  }, i.onAdTimeout = function(n) {
    var a = this;
    this.afterLoadStart(function() {
      n.ads.debug("adtimeout (Preroll)"), a.resumeAfterNoPreroll(n);
    });
  }, i.onNoPreroll = function(n) {
    n.ads.inAdBreak() || this.isContentResuming() ? re.log.warn("Unexpected nopreroll event (Preroll)") : this.noPreroll();
  }, i.resumeAfterNoPreroll = function(n) {
    if (this.contentResuming = !0, n.ads._shouldBlockPlay = !1, this.cleanupPartial(n), n.paused() && (n.ads._playRequested || n.ads._pausedOnContentupdate)) {
      var a = n.play();
      a && a.then && a.then(null, function(s) {
      });
    }
  }, i.cleanup = function(n) {
    n.ads._hasThereBeenALoadStartDuringPlayerLife || re.log.warn("Leaving Preroll state before loadstart event can cause issues."), this.cleanupPartial(n);
  }, i.cleanupPartial = function(n) {
    n.removeClass("vjs-ad-loading"), n.removeClass("vjs-ad-content-resuming"), this.clearTimeout(n);
  }, i.clearTimeout = function(n) {
    n.clearTimeout(this._timeout), this._timeout = null;
  }, r;
}(w$);
Wr.registerState("Preroll", C$);
var D$ = Wr.getState("ContentState"), k$ = /* @__PURE__ */ function(e) {
  Ws(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  r._getName = function() {
    return "BeforePreroll";
  };
  var i = r.prototype;
  return i.init = function(n) {
    this.adsReady = !1, this.shouldResumeToContent = !1, n.ads._shouldBlockPlay = !0;
  }, i.onAdsReady = function(n) {
    n.ads.debug("Received adsready event (BeforePreroll)"), this.adsReady = !0;
  }, i.onPlay = function(n) {
    var a = Wr.getState("Preroll");
    n.ads.debug("Received play event (BeforePreroll)"), this.transitionTo(a, this.adsReady, this.shouldResumeToContent);
  }, i.onAdsCanceled = function(n) {
    n.ads.debug("adscanceled (BeforePreroll)"), this.shouldResumeToContent = !0;
  }, i.onAdsError = function() {
    this.player.ads.debug("adserror (BeforePreroll)"), this.shouldResumeToContent = !0;
  }, i.onNoPreroll = function() {
    this.player.ads.debug("Skipping prerolls due to nopreroll event (BeforePreroll)"), this.shouldResumeToContent = !0;
  }, i.skipLinearAdMode = function() {
    var n = this.player;
    n.trigger("adskip"), n.ads.debug("skipLinearAdMode (BeforePreroll)"), this.shouldResumeToContent = !0;
  }, i.onContentChanged = function() {
    this.init(this.player);
  }, r;
}(D$);
Wr.registerState("BeforePreroll", k$);
var R$ = Wr.getState("AdState"), P$ = /* @__PURE__ */ function(e) {
  Ws(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  r._getName = function() {
    return "Midroll";
  };
  var i = r.prototype;
  return i.init = function(n) {
    n.ads.adType = "midroll", su.start(n), n.addClass("vjs-ad-loading");
  }, i.onAdStarted = function(n) {
    n.removeClass("vjs-ad-loading");
  }, i.endLinearAdMode = function() {
    var n = this.player;
    this.inAdBreak() && (this.contentResuming = !0, n.addClass("vjs-ad-content-resuming"), n.removeClass("vjs-ad-loading"), su.end(n));
  }, i.onAdsError = function(n) {
    this.inAdBreak() && n.ads.endLinearAdMode();
  }, i.cleanup = function(n) {
    n.removeClass("vjs-ad-loading"), n.removeClass("vjs-ad-content-resuming");
  }, r;
}(R$);
Wr.registerState("Midroll", P$);
var O$ = Wr.getState("AdState"), L$ = /* @__PURE__ */ function(e) {
  Ws(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  r._getName = function() {
    return "Postroll";
  };
  var i = r.prototype;
  return i.init = function(n) {
    if (this.waitingForAdBreak = !0, n.ads._contentEnding = !0, n.ads.nopostroll_) {
      this.resumeContent(n);
      var s = Wr.getState("AdsDone");
      this.transitionTo(s);
    } else {
      n.addClass("vjs-ad-loading");
      var a = n.ads.settings.timeout;
      typeof n.ads.settings.postrollTimeout == "number" && (a = n.ads.settings.postrollTimeout), this._postrollTimeout = n.setTimeout(function() {
        n.trigger("adtimeout");
      }, a);
    }
  }, i.startLinearAdMode = function() {
    var n = this.player;
    !n.ads.inAdBreak() && !this.isContentResuming() ? (n.ads.adType = "postroll", n.clearTimeout(this._postrollTimeout), this.waitingForAdBreak = !1, su.start(n)) : re.log.warn("Unexpected startLinearAdMode invocation (Postroll)");
  }, i.onAdStarted = function(n) {
    n.removeClass("vjs-ad-loading");
  }, i.endLinearAdMode = function() {
    var n = this, a = this.player, s = Wr.getState("AdsDone");
    this.inAdBreak() && (a.removeClass("vjs-ad-loading"), this.resumeContent(a), su.end(a, function() {
      n.transitionTo(s);
    }));
  }, i.skipLinearAdMode = function() {
    var n = this.player;
    n.ads.inAdBreak() || this.isContentResuming() ? re.log.warn("Unexpected skipLinearAdMode invocation") : (n.ads.debug("Postroll abort (skipLinearAdMode)"), n.trigger("adskip"), this.abort(n));
  }, i.onAdTimeout = function(n) {
    n.ads.debug("Postroll abort (adtimeout)"), this.abort(n);
  }, i.onAdsError = function(n) {
    n.ads.debug("Postroll abort (adserror)"), n.ads.inAdBreak() ? n.ads.endLinearAdMode() : this.abort(n);
  }, i.onContentChanged = function(n) {
    if (this.isContentResuming()) {
      var a = Wr.getState("BeforePreroll");
      this.transitionTo(a);
    } else if (!this.inAdBreak()) {
      var s = Wr.getState("Preroll");
      this.transitionTo(s);
    }
  }, i.onNoPostroll = function(n) {
    !this.isContentResuming() && !this.inAdBreak() ? this.abort(n) : re.log.warn("Unexpected nopostroll event (Postroll)");
  }, i.resumeContent = function(n) {
    this.contentResuming = !0, n.addClass("vjs-ad-content-resuming");
  }, i.abort = function(n) {
    var a = Wr.getState("AdsDone");
    this.resumeContent(n), n.removeClass("vjs-ad-loading"), this.transitionTo(a);
  }, i.cleanup = function(n) {
    n.removeClass("vjs-ad-content-resuming"), n.clearTimeout(this._postrollTimeout), n.ads._contentEnding = !1;
  }, r;
}(O$);
Wr.registerState("Postroll", L$);
var I$ = Wr.getState("ContentState"), M$ = /* @__PURE__ */ function(e) {
  Ws(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  r._getName = function() {
    return "ContentPlayback";
  };
  var i = r.prototype;
  return i.init = function(n) {
    n.ads._shouldBlockPlay = !1;
  }, i.onAdsReady = function(n) {
    n.ads.debug("Received adsready event (ContentPlayback)"), n.ads.nopreroll_ || (n.ads.debug("Triggered readyforpreroll event (ContentPlayback)"), n.trigger("readyforpreroll"));
  }, i.onReadyForPostroll = function(n) {
    var a = Wr.getState("Postroll");
    n.ads.debug("Received readyforpostroll event"), this.transitionTo(a);
  }, i.startLinearAdMode = function() {
    var n = Wr.getState("Midroll");
    this.transitionTo(n);
  }, r;
}(I$);
Wr.registerState("ContentPlayback", M$);
var N$ = Wr.getState("ContentState"), F$ = /* @__PURE__ */ function(e) {
  Ws(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  r._getName = function() {
    return "StitchedContentPlayback";
  };
  var i = r.prototype;
  return i.init = function() {
    this.player.ads._shouldBlockPlay = !1;
  }, i.onContentChanged = function() {
    this.player.ads.debug("Received contentchanged event (" + this.constructor._getName() + ")");
  }, i.startLinearAdMode = function() {
    var n = Wr.getState("StitchedAdRoll");
    this.transitionTo(n);
  }, r;
}(N$);
Wr.registerState("StitchedContentPlayback", F$);
var U$ = Wr.getState("AdState"), B$ = /* @__PURE__ */ function(e) {
  Ws(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  r._getName = function() {
    return "StitchedAdRoll";
  };
  var i = r.prototype;
  return i.init = function() {
    this.waitingForAdBreak = !1, this.contentResuming = !1, this.player.ads.adType = "stitched", su.start(this.player);
  }, i.onPlaying = function() {
  }, i.onContentResumed = function() {
  }, i.onAdEnded = function() {
    this.endLinearAdMode(), this.player.trigger("ended");
  }, i.endLinearAdMode = function() {
    var n = Wr.getState("StitchedContentPlayback");
    su.end(this.player), this.transitionTo(n);
  }, r;
}(U$);
Wr.registerState("StitchedAdRoll", B$);
var j$ = Tc.isMiddlewareMediatorSupported, $$ = re.getTech("Html5").Events, G$ = {
  timeout: 5e3,
  prerollTimeout: void 0,
  postrollTimeout: void 0,
  debug: !1,
  stitchedAds: !1,
  contentIsLive: void 0,
  liveCuePoints: !0
}, GA = function(r) {
  var i = this, t = re.mergeOptions(G$, r), n = [];
  $$.concat(["firstplay", "loadedalldata"]).forEach(function(o) {
    n.indexOf(o) === -1 && n.push(o);
  }), i.on(n, o$), j$() || f$(i, t.debug), i.setTimeout(function() {
    !i.ads._hasThereBeenALoadStartDuringPlayerLife && i.src() !== "" && re.log.error("videojs-contrib-ads has not seen a loadstart event 5 seconds after being initialized, but a source is present. This indicates that videojs-contrib-ads was initialized too late. It must be initialized immediately after video.js in the same tick. As a result, some ads will not play and some media events will be incorrect. For more information, see http://videojs.github.io/videojs-contrib-ads/integrator/getting-started.html");
  }, 5e3), i.on("ended", function() {
    i.hasClass("vjs-has-started") || i.addClass("vjs-has-started");
  }), i.on("contenttimeupdate", function() {
    i.removeClass("vjs-waiting");
  }), i.on(["addurationchange", "adcanplay"], function() {
    if (!i.ads.settings.stitchedAds && !i.hasStarted() && !(i.ads.snapshot && i.currentSrc() === i.ads.snapshot.currentSrc) && !!i.ads.inAdBreak()) {
      var o = i.play();
      o && o.catch && o.catch(function(l) {
        re.log.warn("Play promise rejected when playing ad", l);
      });
    }
  }), i.on("nopreroll", function() {
    i.ads.debug("Received nopreroll event"), i.ads.nopreroll_ = !0;
  }), i.on("nopostroll", function() {
    i.ads.debug("Received nopostroll event"), i.ads.nopostroll_ = !0;
  }), i.on("playing", function() {
    i.ads._cancelledPlay = !1, i.ads._pausedOnContentupdate = !1;
  }), i.on("play", function() {
    i.ads._playRequested = !0;
  }), i.one("loadstart", function() {
    i.ads._hasThereBeenALoadStartDuringPlayerLife = !0;
  }), i.on("loadeddata", function() {
    i.ads._hasThereBeenALoadedData = !0;
  }), i.on("loadedmetadata", function() {
    i.ads._hasThereBeenALoadedMetaData = !0;
  }), i.ads = r$(i), i.ads.settings = t, t.stitchedAds = !!t.stitchedAds, t.stitchedAds ? i.ads._state = new (Wr.getState("StitchedContentPlayback"))(i) : i.ads._state = new (Wr.getState("BeforePreroll"))(i), i.ads._state.init(i), i.ads.cueTextTracks = dl, i.ads.adMacroReplacement = l$.bind(i), u$(i), i.on("contentchanged", i.ads.reset);
  var a = function() {
    return !i.ads.shouldPlayContentBehindAd(i) && i.ads.inAdBreak() && i.tech_.featuresNativeTextTracks && re.browser.IS_IOS && !Array.isArray(i.textTracks());
  }, s = function() {
    var l = i.textTracks();
    if (a())
      for (var u = 0; u < l.length; u++) {
        var h = l[u];
        h.mode === "showing" && (h.mode = "disabled");
      }
  };
  i.ready(function() {
    i.textTracks().addEventListener("change", s);
  }), i.on(["play", "playing", "ended", "adsready", "adscanceled", "adskip", "adserror", "adtimeout", "adended", "ads-ad-started", "contentchanged", "dispose", "contentresumed", "readyforpostroll", "nopreroll", "nopostroll"], function(o) {
    i.ads._state.handleEvent(o.type);
  }), i.on("dispose", function() {
    i.ads.reset(), i.textTracks().removeEventListener("change", s);
  });
};
GA.VERSION = jA;
m$(GA);
var Fr = function(r, i, t) {
  this.vjsPlayer = r, this.controller = t, this.contentTrackingTimer = null, this.contentComplete = !1, this.updateTimeIntervalHandle = null, this.updateTimeInterval = 1e3, this.seekCheckIntervalHandle = null, this.seekCheckInterval = 1e3, this.resizeCheckIntervalHandle = null, this.resizeCheckInterval = 250, this.seekThreshold = 100, this.contentEndedListeners = [], this.contentSource = "", this.contentSourceType = "", this.contentPlayheadTracker = {
    currentTime: 0,
    previousTime: 0,
    seeking: !1,
    duration: 0
  }, this.vjsPlayerDimensions = {
    width: this.getPlayerWidth(),
    height: this.getPlayerHeight()
  }, this.vjsControls = this.vjsPlayer.getChild("controlBar"), this.h5Player = null, this.vjsPlayer.one("play", this.setUpPlayerIntervals.bind(this)), this.boundContentEndedListener = this.localContentEndedListener.bind(this), this.vjsPlayer.on("contentended", this.boundContentEndedListener), this.vjsPlayer.on("dispose", this.playerDisposedListener.bind(this)), this.vjsPlayer.on("readyforpreroll", this.onReadyForPreroll.bind(this)), this.vjsPlayer.on("adtimeout", this.onAdTimeout.bind(this)), this.vjsPlayer.ready(this.onPlayerReady.bind(this)), this.controller.getSettings().requestMode === "onPlay" && this.vjsPlayer.one("play", this.controller.requestAds.bind(this.controller)), this.vjsPlayer.ads(i);
};
Fr.prototype.setUpPlayerIntervals = function() {
  this.updateTimeIntervalHandle = setInterval(this.updateCurrentTime.bind(this), this.updateTimeInterval), this.seekCheckIntervalHandle = setInterval(this.checkForSeeking.bind(this), this.seekCheckInterval), this.resizeCheckIntervalHandle = setInterval(this.checkForResize.bind(this), this.resizeCheckInterval);
};
Fr.prototype.updateCurrentTime = function() {
  this.contentPlayheadTracker.seeking || (this.contentPlayheadTracker.currentTime = this.vjsPlayer.currentTime());
};
Fr.prototype.checkForSeeking = function() {
  var e = this.vjsPlayer.currentTime(), r = (e - this.contentPlayheadTracker.previousTime) * 1e3;
  Math.abs(r) > this.seekCheckInterval + this.seekThreshold ? this.contentPlayheadTracker.seeking = !0 : this.contentPlayheadTracker.seeking = !1, this.contentPlayheadTracker.previousTime = this.vjsPlayer.currentTime();
};
Fr.prototype.checkForResize = function() {
  var e = this.getPlayerWidth(), r = this.getPlayerHeight();
  (e != this.vjsPlayerDimensions.width || r != this.vjsPlayerDimensions.height) && (this.vjsPlayerDimensions.width = e, this.vjsPlayerDimensions.height = r, this.controller.onPlayerResize(e, r));
};
Fr.prototype.localContentEndedListener = function() {
  this.contentComplete || (this.contentComplete = !0, this.controller.onContentComplete());
  for (var e in this.contentEndedListeners)
    typeof this.contentEndedListeners[e] == "function" && this.contentEndedListeners[e]();
  clearInterval(this.updateTimeIntervalHandle), clearInterval(this.seekCheckIntervalHandle), clearInterval(this.resizeCheckIntervalHandle), this.vjsPlayer.el() && this.vjsPlayer.one("play", this.setUpPlayerIntervals.bind(this));
};
Fr.prototype.onNoPostroll = function() {
  this.vjsPlayer.trigger("nopostroll");
};
Fr.prototype.playerDisposedListener = function() {
  this.contentEndedListeners = [], this.controller.onPlayerDisposed(), this.contentComplete = !0, this.vjsPlayer.off("contentended", this.boundContentEndedListener), this.vjsPlayer.ads.adTimeoutTimeout && clearTimeout(this.vjsPlayer.ads.adTimeoutTimeout);
  var e = [this.updateTimeIntervalHandle, this.seekCheckIntervalHandle, this.resizeCheckIntervalHandle];
  for (var r in e)
    e[r] && clearInterval(e[r]);
};
Fr.prototype.onReadyForPreroll = function() {
  this.controller.onPlayerReadyForPreroll();
};
Fr.prototype.onAdTimeout = function() {
  this.controller.onAdTimeout();
};
Fr.prototype.onPlayerReady = function() {
  this.h5Player = document.getElementById(this.getPlayerId()).getElementsByClassName("vjs-tech")[0], this.h5Player.hasAttribute("autoplay") && this.controller.setSetting("adWillAutoPlay", !0), this.onVolumeChange(), this.vjsPlayer.on("fullscreenchange", this.onFullscreenChange.bind(this)), this.vjsPlayer.on("volumechange", this.onVolumeChange.bind(this)), this.controller.onPlayerReady();
};
Fr.prototype.onFullscreenChange = function() {
  this.vjsPlayer.isFullscreen() ? this.controller.onPlayerEnterFullscreen() : this.controller.onPlayerExitFullscreen();
};
Fr.prototype.onVolumeChange = function() {
  var e = this.vjsPlayer.muted() ? 0 : this.vjsPlayer.volume();
  this.controller.onPlayerVolumeChanged(e);
};
Fr.prototype.injectAdContainerDiv = function(e) {
  this.vjsControls.el().parentNode.appendChild(e);
};
Fr.prototype.getContentPlayer = function() {
  return this.h5Player;
};
Fr.prototype.getVolume = function() {
  return this.vjsPlayer.muted() ? 0 : this.vjsPlayer.volume();
};
Fr.prototype.setVolume = function(e) {
  this.vjsPlayer.volume(e), e == 0 ? this.vjsPlayer.muted(!0) : this.vjsPlayer.muted(!1);
};
Fr.prototype.unmute = function() {
  this.vjsPlayer.muted(!1);
};
Fr.prototype.mute = function() {
  this.vjsPlayer.muted(!0);
};
Fr.prototype.play = function() {
  this.vjsPlayer.play();
};
Fr.prototype.getPlayerWidth = function() {
  var e = (getComputedStyle(this.vjsPlayer.el()) || {}).width;
  return (!e || parseFloat(e) === 0) && (e = (this.vjsPlayer.el().getBoundingClientRect() || {}).width), parseFloat(e) || this.vjsPlayer.width();
};
Fr.prototype.getPlayerHeight = function() {
  var e = (getComputedStyle(this.vjsPlayer.el()) || {}).height;
  return (!e || parseFloat(e) === 0) && (e = (this.vjsPlayer.el().getBoundingClientRect() || {}).height), parseFloat(e) || this.vjsPlayer.height();
};
Fr.prototype.getPlayerOptions = function() {
  return this.vjsPlayer.options_;
};
Fr.prototype.getPlayerId = function() {
  return this.vjsPlayer.id();
};
Fr.prototype.toggleFullscreen = function() {
  this.vjsPlayer.isFullscreen() ? this.vjsPlayer.exitFullscreen() : this.vjsPlayer.requestFullscreen();
};
Fr.prototype.getContentPlayheadTracker = function() {
  return this.contentPlayheadTracker;
};
Fr.prototype.onAdError = function(e) {
  this.vjsControls.show();
  var r = e.getError !== void 0 ? e.getError() : e.stack;
  this.vjsPlayer.trigger({ type: "adserror", data: {
    AdError: r,
    AdErrorEvent: e
  } });
};
Fr.prototype.onAdLog = function(e) {
  var r = e.getAdData(), i = r.adError !== void 0 ? r.adError.getMessage() : void 0;
  this.vjsPlayer.trigger({ type: "adslog", data: {
    AdError: i,
    AdEvent: e
  } });
};
Fr.prototype.onAdBreakStart = function() {
  this.contentSource = this.vjsPlayer.currentSrc(), this.contentSourceType = this.vjsPlayer.currentType(), this.vjsPlayer.off("contentended", this.boundContentEndedListener), this.vjsPlayer.ads.startLinearAdMode(), this.vjsControls.hide(), this.vjsPlayer.pause();
};
Fr.prototype.onAdBreakEnd = function() {
  this.vjsPlayer.on("contentended", this.boundContentEndedListener), this.vjsPlayer.ads.inAdBreak() && this.vjsPlayer.ads.endLinearAdMode(), this.vjsControls.show();
};
Fr.prototype.onAdStart = function() {
  this.vjsPlayer.trigger("ads-ad-started");
};
Fr.prototype.onAllAdsCompleted = function() {
  this.contentComplete == !0 && (this.contentSource && this.vjsPlayer.currentSrc() != this.contentSource && this.vjsPlayer.src({
    src: this.contentSource,
    type: this.contentSourceType
  }), this.controller.onContentAndAdsCompleted());
};
Fr.prototype.onAdsReady = function() {
  this.vjsPlayer.trigger("adsready");
};
Fr.prototype.changeSource = function(e) {
  this.vjsPlayer.currentSrc() && (this.vjsPlayer.currentTime(0), this.vjsPlayer.pause()), e && this.vjsPlayer.src(e), this.vjsPlayer.one("loadedmetadata", this.seekContentToZero.bind(this));
};
Fr.prototype.seekContentToZero = function() {
  this.vjsPlayer.currentTime(0);
};
Fr.prototype.triggerPlayerEvent = function(e, r) {
  this.vjsPlayer.trigger(e, r);
};
Fr.prototype.addContentEndedListener = function(e) {
  this.contentEndedListeners.push(e);
};
Fr.prototype.reset = function() {
  this.vjsPlayer.off("contentended", this.boundContentEndedListener), this.vjsPlayer.on("contentended", this.boundContentEndedListener), this.vjsControls.show(), this.vjsPlayer.ads.inAdBreak() && this.vjsPlayer.ads.endLinearAdMode(), this.contentPlayheadTracker.currentTime = 0, this.contentComplete = !1;
};
var Ur = function(r) {
  this.controller = r, this.adContainerDiv = document.createElement("div"), this.controlsDiv = document.createElement("div"), this.countdownDiv = document.createElement("div"), this.seekBarDiv = document.createElement("div"), this.progressDiv = document.createElement("div"), this.playPauseDiv = document.createElement("div"), this.muteDiv = document.createElement("div"), this.sliderDiv = document.createElement("div"), this.sliderLevelDiv = document.createElement("div"), this.fullscreenDiv = document.createElement("div"), this.boundOnMouseUp = this.onMouseUp.bind(this), this.boundOnMouseMove = this.onMouseMove.bind(this), this.adPlayheadTracker = {
    currentTime: 0,
    duration: 0,
    isPod: !1,
    adPosition: 0,
    totalAds: 0
  }, this.controlPrefix = this.controller.getPlayerId() + "_", this.showCountdown = !0, this.controller.getSettings().showCountdown === !1 && (this.showCountdown = !1), this.createAdContainer();
};
Ur.prototype.createAdContainer = function() {
  this.assignControlAttributes(this.adContainerDiv, "ima-ad-container"), this.adContainerDiv.style.position = "absolute", this.adContainerDiv.style.zIndex = 1111, this.adContainerDiv.addEventListener("mouseenter", this.showAdControls.bind(this), !1), this.adContainerDiv.addEventListener("mouseleave", this.hideAdControls.bind(this), !1), this.createControls(), this.controller.injectAdContainerDiv(this.adContainerDiv);
};
Ur.prototype.createControls = function() {
  this.assignControlAttributes(this.controlsDiv, "ima-controls-div"), this.controlsDiv.style.width = "100%", this.controller.getIsMobile() ? this.countdownDiv.style.display = "none" : (this.assignControlAttributes(this.countdownDiv, "ima-countdown-div"), this.countdownDiv.innerHTML = this.controller.getSettings().adLabel, this.countdownDiv.style.display = this.showCountdown ? "block" : "none"), this.assignControlAttributes(this.seekBarDiv, "ima-seek-bar-div"), this.seekBarDiv.style.width = "100%", this.assignControlAttributes(this.progressDiv, "ima-progress-div"), this.assignControlAttributes(this.playPauseDiv, "ima-play-pause-div"), this.addClass(this.playPauseDiv, "ima-playing"), this.playPauseDiv.addEventListener("click", this.onAdPlayPauseClick.bind(this), !1), this.assignControlAttributes(this.muteDiv, "ima-mute-div"), this.addClass(this.muteDiv, "ima-non-muted"), this.muteDiv.addEventListener("click", this.onAdMuteClick.bind(this), !1), this.assignControlAttributes(this.sliderDiv, "ima-slider-div"), this.sliderDiv.addEventListener("mousedown", this.onAdVolumeSliderMouseDown.bind(this), !1), this.controller.getIsIos() && (this.sliderDiv.style.display = "none"), this.assignControlAttributes(this.sliderLevelDiv, "ima-slider-level-div"), this.assignControlAttributes(this.fullscreenDiv, "ima-fullscreen-div"), this.addClass(this.fullscreenDiv, "ima-non-fullscreen"), this.fullscreenDiv.addEventListener("click", this.onAdFullscreenClick.bind(this), !1), this.adContainerDiv.appendChild(this.controlsDiv), this.controlsDiv.appendChild(this.countdownDiv), this.controlsDiv.appendChild(this.seekBarDiv), this.controlsDiv.appendChild(this.playPauseDiv), this.controlsDiv.appendChild(this.muteDiv), this.controlsDiv.appendChild(this.sliderDiv), this.controlsDiv.appendChild(this.fullscreenDiv), this.seekBarDiv.appendChild(this.progressDiv), this.sliderDiv.appendChild(this.sliderLevelDiv);
};
Ur.prototype.onAdPlayPauseClick = function() {
  this.controller.onAdPlayPauseClick();
};
Ur.prototype.onAdMuteClick = function() {
  this.controller.onAdMuteClick();
};
Ur.prototype.onAdFullscreenClick = function() {
  this.controller.toggleFullscreen();
};
Ur.prototype.onAdsPaused = function() {
  this.controller.sdkImpl.adPlaying = !1, this.addClass(this.playPauseDiv, "ima-paused"), this.removeClass(this.playPauseDiv, "ima-playing"), this.showAdControls();
};
Ur.prototype.onAdsResumed = function() {
  this.onAdsPlaying(), this.showAdControls();
};
Ur.prototype.onAdsPlaying = function() {
  this.controller.sdkImpl.adPlaying = !0, this.addClass(this.playPauseDiv, "ima-playing"), this.removeClass(this.playPauseDiv, "ima-paused");
};
Ur.prototype.updateAdUi = function(e, r, i, t, n) {
  var a = Math.floor(r / 60), s = Math.floor(r % 60);
  s.toString().length < 2 && (s = "0" + s);
  var o = ": ";
  n > 1 && (o = " (" + t + " " + this.controller.getSettings().adLabelNofN + " " + n + "): "), this.countdownDiv.innerHTML = this.controller.getSettings().adLabel + o + a + ":" + s;
  var l = e / i, u = l * 100;
  this.progressDiv.style.width = u + "%";
};
Ur.prototype.unmute = function() {
  this.addClass(this.muteDiv, "ima-non-muted"), this.removeClass(this.muteDiv, "ima-muted"), this.sliderLevelDiv.style.width = this.controller.getPlayerVolume() * 100 + "%";
};
Ur.prototype.mute = function() {
  this.addClass(this.muteDiv, "ima-muted"), this.removeClass(this.muteDiv, "ima-non-muted"), this.sliderLevelDiv.style.width = "0%";
};
Ur.prototype.onAdVolumeSliderMouseDown = function() {
  document.addEventListener("mouseup", this.boundOnMouseUp, !1), document.addEventListener("mousemove", this.boundOnMouseMove, !1);
};
Ur.prototype.onMouseMove = function(e) {
  this.changeVolume(e);
};
Ur.prototype.onMouseUp = function(e) {
  this.changeVolume(e), document.removeEventListener("mouseup", this.boundOnMouseUp), document.removeEventListener("mousemove", this.boundOnMouseMove);
};
Ur.prototype.changeVolume = function(e) {
  var r = (e.clientX - this.sliderDiv.getBoundingClientRect().left) / this.sliderDiv.offsetWidth;
  r *= 100, r = Math.min(Math.max(r, 0), 100), this.sliderLevelDiv.style.width = r + "%", this.percent == 0 ? (this.addClass(this.muteDiv, "ima-muted"), this.removeClass(this.muteDiv, "ima-non-muted")) : (this.addClass(this.muteDiv, "ima-non-muted"), this.removeClass(this.muteDiv, "ima-muted")), this.controller.setVolume(r / 100);
};
Ur.prototype.showAdContainer = function() {
  this.adContainerDiv.style.display = "block";
};
Ur.prototype.hideAdContainer = function() {
  this.adContainerDiv.style.display = "none";
};
Ur.prototype.reset = function() {
  this.hideAdContainer();
};
Ur.prototype.onAdError = function() {
  this.hideAdContainer();
};
Ur.prototype.onAdBreakStart = function(e) {
  this.showAdContainer();
  var r = e.getAd().getContentType();
  r === "application/javascript" && !this.controller.getSettings().showControlsForJSAds ? this.controlsDiv.style.display = "none" : this.controlsDiv.style.display = "block", this.onAdsPlaying(), this.hideAdControls();
};
Ur.prototype.onAdBreakEnd = function() {
  var e = this.controller.getCurrentAd();
  (e == null || e.isLinear()) && this.hideAdContainer(), this.controlsDiv.style.display = "none", this.countdownDiv.innerHTML = "";
};
Ur.prototype.onAllAdsCompleted = function() {
  this.hideAdContainer();
};
Ur.prototype.onLinearAdStart = function() {
  this.removeClass(this.adContainerDiv, "bumpable-ima-ad-container");
};
Ur.prototype.onNonLinearAdLoad = function() {
  this.adContainerDiv.style.display = "block", this.addClass(this.adContainerDiv, "bumpable-ima-ad-container");
};
Ur.prototype.onPlayerEnterFullscreen = function() {
  this.addClass(this.fullscreenDiv, "ima-fullscreen"), this.removeClass(this.fullscreenDiv, "ima-non-fullscreen");
};
Ur.prototype.onPlayerExitFullscreen = function() {
  this.addClass(this.fullscreenDiv, "ima-non-fullscreen"), this.removeClass(this.fullscreenDiv, "ima-fullscreen");
};
Ur.prototype.onPlayerVolumeChanged = function(e) {
  e == 0 ? (this.addClass(this.muteDiv, "ima-muted"), this.removeClass(this.muteDiv, "ima-non-muted"), this.sliderLevelDiv.style.width = "0%") : (this.addClass(this.muteDiv, "ima-non-muted"), this.removeClass(this.muteDiv, "ima-muted"), this.sliderLevelDiv.style.width = e * 100 + "%");
};
Ur.prototype.showAdControls = function() {
  this.addClass(this.controlsDiv, "ima-controls-div-showing");
};
Ur.prototype.hideAdControls = function() {
  this.removeClass(this.controlsDiv, "ima-controls-div-showing");
};
Ur.prototype.assignControlAttributes = function(e, r) {
  e.id = this.controlPrefix + r, e.className = this.controlPrefix + r + " " + r;
};
Ur.prototype.getClassRegexp = function(e) {
  return new RegExp("(^|[^A-Za-z-])" + e + "((?![A-Za-z-])|$)", "gi");
};
Ur.prototype.elementHasClass = function(e, r) {
  var i = this.getClassRegexp(r);
  return i.test(e.className);
};
Ur.prototype.addClass = function(e, r) {
  e.className = e.className.trim() + " " + r;
};
Ur.prototype.removeClass = function(e, r) {
  var i = this.getClassRegexp(r);
  e.className = e.className.trim().replace(i, "");
};
Ur.prototype.getAdContainerDiv = function() {
  return this.adContainerDiv;
};
Ur.prototype.setShowCountdown = function(e) {
  this.showCountdown = e, this.countdownDiv.style.display = this.showCountdown ? "block" : "none";
};
var H$ = "videojs-ima", V$ = "1.7.5", q$ = "Apache-2.0", W$ = "./dist/videojs.ima.js", Y$ = "./dist/videojs.ima.es.js", K$ = { name: "Google Inc." }, z$ = { node: ">=0.8.0" }, X$ = { contBuild: "watch 'npm run rollup:max' src", predevServer: 'echo "Starting up server on localhost:8000."', devServer: "npm-run-all -p testServer contBuild", lint: 'eslint "src/*.js"', rollup: "npm-run-all rollup:*", "rollup:max": "rollup -c configs/rollup.config.js", "rollup:es": "rollup -c configs/rollup.config.es.js", "rollup:min": "rollup -c configs/rollup.config.min.js", pretest: "npm run rollup", start: "npm run devServer", test: "npm-run-all test:*", "test:vjs5": "npm install video.js@5.19.2 --no-save && npm-run-all -p -r testServer webdriver", "test:vjs6": "npm install video.js@6 --no-save && npm-run-all -p -r testServer webdriver", "test:vjs7": "npm install video.js@7 --no-save && npm-run-all -p -r testServer webdriver", testServer: "http-server --cors -p 8000 --silent", preversion: "node scripts/preversion.js && npm run lint && npm test", version: "node scripts/version.js", postversion: "node scripts/postversion.js", webdriver: "mocha test/webdriver/*.js --no-timeouts" }, J$ = { type: "git", url: "https://github.com/googleads/videojs-ima" }, Q$ = ["CHANGELOG.md", "LICENSE", "README.md", "dist/", "src/"], Z$ = { "can-autoplay": "^3.0.0", cryptiles: "^4.1.2", extend: ">=3.0.2", lodash: ">=4.17.13", "lodash.template": ">=4.5.0", "video.js": "^5.19.2 || ^6 || ^7", "videojs-contrib-ads": "^6" }, e4 = { "babel-core": "^6.26.3", "babel-preset-env": "^1.7.0", child_process: "^1.0.2", chromedriver: "^2.35.0", "conventional-changelog-cli": "^2.0.21", "conventional-changelog-videojs": "^3.0.0", eslint: "^4.11.0", "eslint-config-google": "^0.9.1", "eslint-plugin-jsdoc": "^3.2.0", geckodriver: "^1.16.2", "http-server": "^0.10.0", mocha: "^5.0.3", "npm-run-all": "^4.1.2", path: "^0.12.7", rimraf: "^2.6.2", rollup: "^0.51.8", "rollup-plugin-babel": "^3.0.3", "rollup-plugin-copy": "^0.2.3", "rollup-plugin-json": "^2.3.0", "rollup-plugin-uglify": "^2.0.1", "selenium-webdriver": "^3.6.0", "uglify-es": "^3.1.10", watch: "^1.0.2" }, t4 = ["videojs", "videojs-plugin"], r4 = {
  name: H$,
  version: V$,
  license: q$,
  main: W$,
  module: Y$,
  author: K$,
  engines: z$,
  scripts: X$,
  repository: J$,
  files: Q$,
  dependencies: Z$,
  devDependencies: e4,
  keywords: t4
}, i4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
  return typeof e;
} : function(e) {
  return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
}, Ar = function(r) {
  this.controller = r, this.adDisplayContainer = null, this.adDisplayContainerInitialized = !1, this.adsLoader = null, this.adsManager = null, this.adsRenderingSettings = null, this.adsResponse = null, this.currentAd = null, this.adTrackingTimer = null, this.allAdsCompleted = !1, this.adsActive = !1, this.adPlaying = !1, this.adMuted = !1, this.adBreakReadyListener = void 0, this.contentCompleteCalled = !1, this.isAdTimedOut = !1, this.adsManagerDimensions = {
    width: 0,
    height: 0
  }, this.autoPlayAdBreaks = !0, this.controller.getSettings().autoPlayAdBreaks === !1 && (this.autoPlayAdBreaks = !1), this.controller.getSettings().locale && google.ima.settings.setLocale(this.controller.getSettings().locale), this.controller.getSettings().disableFlashAds && google.ima.settings.setDisableFlashAds(this.controller.getSettings().disableFlashAds), this.controller.getSettings().disableCustomPlaybackForIOS10Plus && google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.controller.getSettings().disableCustomPlaybackForIOS10Plus);
};
Ar.prototype.initAdObjects = function() {
  this.adDisplayContainer = new google.ima.AdDisplayContainer(this.controller.getAdContainerDiv(), this.controller.getContentPlayer()), this.adsLoader = new google.ima.AdsLoader(this.adDisplayContainer), this.adsLoader.getSettings().setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED), this.controller.getSettings().vpaidAllowed == !1 && this.adsLoader.getSettings().setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.DISABLED), this.controller.getSettings().vpaidMode && this.adsLoader.getSettings().setVpaidMode(this.controller.getSettings().vpaidMode), this.controller.getSettings().locale && this.adsLoader.getSettings().setLocale(this.controller.getSettings().locale), this.controller.getSettings().numRedirects && this.adsLoader.getSettings().setNumRedirects(this.controller.getSettings().numRedirects), this.adsLoader.getSettings().setPlayerType("videojs-ima"), this.adsLoader.getSettings().setPlayerVersion(r4.version), this.adsLoader.getSettings().setAutoPlayAdBreaks(this.autoPlayAdBreaks), this.adsLoader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, this.onAdsManagerLoaded.bind(this), !1), this.adsLoader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdsLoaderError.bind(this), !1), this.controller.playerWrapper.vjsPlayer.trigger({
    type: "ads-loader",
    adsLoader: this.adsLoader
  });
};
Ar.prototype.requestAds = function() {
  var e = new google.ima.AdsRequest();
  this.controller.getSettings().adTagUrl ? e.adTagUrl = this.controller.getSettings().adTagUrl : e.adsResponse = this.controller.getSettings().adsResponse, this.controller.getSettings().forceNonLinearFullSlot && (e.forceNonLinearFullSlot = !0), this.controller.getSettings().vastLoadTimeout && (e.vastLoadTimeout = this.controller.getSettings().vastLoadTimeout), e.linearAdSlotWidth = this.controller.getPlayerWidth(), e.linearAdSlotHeight = this.controller.getPlayerHeight(), e.nonLinearAdSlotWidth = this.controller.getSettings().nonLinearWidth || this.controller.getPlayerWidth(), e.nonLinearAdSlotHeight = this.controller.getSettings().nonLinearHeight || this.controller.getPlayerHeight(), e.setAdWillAutoPlay(this.controller.adsWillAutoplay()), e.setAdWillPlayMuted(this.controller.adsWillPlayMuted());
  var r = this.controller.getSettings().adsRequest;
  r && (typeof r > "u" ? "undefined" : i4(r)) === "object" && Object.keys(r).forEach(function(i) {
    e[i] = r[i];
  }), this.adsLoader.requestAds(e), this.controller.playerWrapper.vjsPlayer.trigger({
    type: "ads-request",
    AdsRequest: e
  });
};
Ar.prototype.onAdsManagerLoaded = function(e) {
  this.createAdsRenderingSettings(), this.adsManager = e.getAdsManager(this.controller.getContentPlayheadTracker(), this.adsRenderingSettings), this.adsManager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.AD_BREAK_READY, this.onAdBreakReady.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, this.onContentPauseRequested.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, this.onContentResumeRequested.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.ALL_ADS_COMPLETED, this.onAllAdsCompleted.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.LOADED, this.onAdLoaded.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.STARTED, this.onAdStarted.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.COMPLETE, this.onAdComplete.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.SKIPPED, this.onAdComplete.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.LOG, this.onAdLog.bind(this)), this.controller.getIsMobile() && (this.adsManager.addEventListener(google.ima.AdEvent.Type.PAUSED, this.onAdPaused.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.RESUMED, this.onAdResumed.bind(this))), this.controller.playerWrapper.vjsPlayer.trigger({
    type: "ads-manager",
    adsManager: this.adsManager
  }), this.autoPlayAdBreaks || this.initAdsManager();
  var r = this.controller.getSettings(), i = r.preventLateAdStart;
  i ? i && !this.isAdTimedOut && this.controller.onAdsReady() : this.controller.onAdsReady(), this.controller.getSettings().adsManagerLoadedCallback && this.controller.getSettings().adsManagerLoadedCallback();
};
Ar.prototype.onAdsLoaderError = function(e) {
  window.console.warn("AdsLoader error: " + e.getError()), this.controller.onErrorLoadingAds(e), this.adsManager && this.adsManager.destroy();
};
Ar.prototype.initAdsManager = function() {
  try {
    var e = this.controller.getPlayerWidth(), r = this.controller.getPlayerHeight();
    this.adsManagerDimensions.width = e, this.adsManagerDimensions.height = r, this.adsManager.init(e, r, google.ima.ViewMode.NORMAL), this.adsManager.setVolume(this.controller.getPlayerVolume()), this.initializeAdDisplayContainer();
  } catch (i) {
    this.onAdError(i);
  }
};
Ar.prototype.createAdsRenderingSettings = function() {
  if (this.adsRenderingSettings = new google.ima.AdsRenderingSettings(), this.adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = !0, this.controller.getSettings().adsRenderingSettings)
    for (var e in this.controller.getSettings().adsRenderingSettings)
      e !== "" && (this.adsRenderingSettings[e] = this.controller.getSettings().adsRenderingSettings[e]);
};
Ar.prototype.onAdError = function(e) {
  var r = e.getError !== void 0 ? e.getError() : e.stack;
  window.console.warn("Ad error: " + r), this.adsManager.destroy(), this.controller.onAdError(e), this.adsActive = !1, this.adPlaying = !1;
};
Ar.prototype.onAdBreakReady = function(e) {
  this.adBreakReadyListener(e);
};
Ar.prototype.onContentPauseRequested = function(e) {
  this.adsActive = !0, this.adPlaying = !0, this.controller.onAdBreakStart(e);
};
Ar.prototype.onContentResumeRequested = function(e) {
  this.adsActive = !1, this.adPlaying = !1, this.controller.onAdBreakEnd();
};
Ar.prototype.onAllAdsCompleted = function(e) {
  this.allAdsCompleted = !0, this.controller.onAllAdsCompleted();
};
Ar.prototype.onAdLoaded = function(e) {
  e.getAd().isLinear() || (this.controller.onNonLinearAdLoad(), this.controller.playContent());
};
Ar.prototype.onAdStarted = function(e) {
  this.currentAd = e.getAd(), this.currentAd.isLinear() ? (this.adTrackingTimer = setInterval(this.onAdPlayheadTrackerInterval.bind(this), 250), this.controller.onLinearAdStart()) : this.controller.onNonLinearAdStart();
};
Ar.prototype.onAdPaused = function() {
  this.controller.onAdsPaused();
};
Ar.prototype.onAdResumed = function(e) {
  this.controller.onAdsResumed();
};
Ar.prototype.onAdComplete = function() {
  this.currentAd.isLinear() && clearInterval(this.adTrackingTimer);
};
Ar.prototype.onAdLog = function(e) {
  this.controller.onAdLog(e);
};
Ar.prototype.onAdPlayheadTrackerInterval = function() {
  if (this.adsManager !== null) {
    var e = this.adsManager.getRemainingTime(), r = this.currentAd.getDuration(), i = r - e;
    i = i > 0 ? i : 0;
    var t = 0, n = void 0;
    this.currentAd.getAdPodInfo() && (n = this.currentAd.getAdPodInfo().getAdPosition(), t = this.currentAd.getAdPodInfo().getTotalAds()), this.controller.onAdPlayheadUpdated(i, e, r, n, t);
  }
};
Ar.prototype.onContentComplete = function() {
  this.adsLoader && (this.adsLoader.contentComplete(), this.contentCompleteCalled = !0), this.adsManager && this.adsManager.getCuePoints() && !this.adsManager.getCuePoints().includes(-1) && this.controller.onNoPostroll(), this.allAdsCompleted && this.controller.onContentAndAdsCompleted();
};
Ar.prototype.onPlayerDisposed = function() {
  this.adTrackingTimer && clearInterval(this.adTrackingTimer), this.adsManager && (this.adsManager.destroy(), this.adsManager = null);
};
Ar.prototype.onPlayerReadyForPreroll = function() {
  if (this.autoPlayAdBreaks) {
    this.initAdsManager();
    try {
      this.controller.showAdContainer(), this.adsManager.setVolume(this.controller.getPlayerVolume()), this.adsManager.start();
    } catch (e) {
      this.onAdError(e);
    }
  }
};
Ar.prototype.onAdTimeout = function() {
  this.isAdTimedOut = !0;
};
Ar.prototype.onPlayerReady = function() {
  this.initAdObjects(), (this.controller.getSettings().adTagUrl || this.controller.getSettings().adsResponse) && this.controller.getSettings().requestMode === "onLoad" && this.requestAds();
};
Ar.prototype.onPlayerEnterFullscreen = function() {
  this.adsManager && this.adsManager.resize(window.screen.width, window.screen.height, google.ima.ViewMode.FULLSCREEN);
};
Ar.prototype.onPlayerExitFullscreen = function() {
  this.adsManager && this.adsManager.resize(this.controller.getPlayerWidth(), this.controller.getPlayerHeight(), google.ima.ViewMode.NORMAL);
};
Ar.prototype.onPlayerVolumeChanged = function(e) {
  this.adsManager && this.adsManager.setVolume(e), e == 0 ? this.adMuted = !0 : this.adMuted = !1;
};
Ar.prototype.onPlayerResize = function(e, r) {
  this.adsManager && (this.adsManagerDimensions.width = e, this.adsManagerDimensions.height = r, this.adsManager.resize(e, r, google.ima.ViewMode.NORMAL));
};
Ar.prototype.getCurrentAd = function() {
  return this.currentAd;
};
Ar.prototype.setAdBreakReadyListener = function(e) {
  this.adBreakReadyListener = e;
};
Ar.prototype.isAdPlaying = function() {
  return this.adPlaying;
};
Ar.prototype.isAdMuted = function() {
  return this.adMuted;
};
Ar.prototype.pauseAds = function() {
  this.adsManager.pause(), this.adPlaying = !1;
};
Ar.prototype.resumeAds = function() {
  this.adsManager.resume(), this.adPlaying = !0;
};
Ar.prototype.unmute = function() {
  this.adsManager.setVolume(1), this.adMuted = !1;
};
Ar.prototype.mute = function() {
  this.adsManager.setVolume(0), this.adMuted = !0;
};
Ar.prototype.setVolume = function(e) {
  this.adsManager.setVolume(e), e == 0 ? this.adMuted = !0 : this.adMuted = !1;
};
Ar.prototype.initializeAdDisplayContainer = function() {
  this.adDisplayContainer && (this.adDisplayContainerInitialized || (this.adDisplayContainer.initialize(), this.adDisplayContainerInitialized = !0));
};
Ar.prototype.playAdBreak = function() {
  this.autoPlayAdBreaks || (this.controller.showAdContainer(), this.adsManager.setVolume(this.controller.getPlayerVolume()), this.adsManager.start());
};
Ar.prototype.addEventListener = function(e, r) {
  this.adsManager && this.adsManager.addEventListener(e, r);
};
Ar.prototype.getAdsManager = function() {
  return this.adsManager;
};
Ar.prototype.reset = function() {
  this.adsActive = !1, this.adPlaying = !1, this.adTrackingTimer && clearInterval(this.adTrackingTimer), this.adsManager && (this.adsManager.destroy(), this.adsManager = null), this.adsLoader && !this.contentCompleteCalled && this.adsLoader.contentComplete(), this.contentCompleteCalled = !1, this.allAdsCompleted = !1;
};
var Jt = function(r, i) {
  this.settings = {}, this.contentAndAdsEndedListeners = [], this.isMobile = navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/Android/i), this.isIos = navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i), this.initWithSettings(i);
  var t = {
    debug: this.settings.debug,
    timeout: this.settings.timeout,
    prerollTimeout: this.settings.prerollTimeout
  }, n = this.extend({}, t, i.contribAdsSettings || {});
  this.playerWrapper = new Fr(r, n, this), this.adUi = new Ur(this), this.sdkImpl = new Ar(this);
};
Jt.IMA_DEFAULTS = {
  debug: !1,
  timeout: 5e3,
  prerollTimeout: 1e3,
  adLabel: "Advertisement",
  adLabelNofN: "of",
  showControlsForJSAds: !0,
  requestMode: "onLoad",
  preventLateAdStart: !1
};
Jt.prototype.initWithSettings = function(e) {
  this.settings = this.extend({}, Jt.IMA_DEFAULTS, e || {}), this.warnAboutDeprecatedSettings(), this.showCountdown = !0, this.settings.showCountdown === !1 && (this.showCountdown = !1);
};
Jt.prototype.warnAboutDeprecatedSettings = function() {
  var e = this, r = ["adWillAutoplay", "adsWillAutoplay", "adWillPlayMuted", "adsWillPlayMuted"];
  r.forEach(function(i) {
    e.settings[i] !== void 0 && console.warn("WARNING: videojs.ima setting " + i + " is deprecated");
  });
};
Jt.prototype.getSettings = function() {
  return this.settings;
};
Jt.prototype.getIsMobile = function() {
  return this.isMobile;
};
Jt.prototype.getIsIos = function() {
  return this.isIos;
};
Jt.prototype.injectAdContainerDiv = function(e) {
  this.playerWrapper.injectAdContainerDiv(e);
};
Jt.prototype.getAdContainerDiv = function() {
  return this.adUi.getAdContainerDiv();
};
Jt.prototype.getContentPlayer = function() {
  return this.playerWrapper.getContentPlayer();
};
Jt.prototype.getContentPlayheadTracker = function() {
  return this.playerWrapper.getContentPlayheadTracker();
};
Jt.prototype.requestAds = function() {
  this.sdkImpl.requestAds();
};
Jt.prototype.setSetting = function(e, r) {
  this.settings[e] = r;
};
Jt.prototype.onErrorLoadingAds = function(e) {
  this.adUi.onAdError(), this.playerWrapper.onAdError(e);
};
Jt.prototype.onAdPlayPauseClick = function() {
  this.sdkImpl.isAdPlaying() ? (this.adUi.onAdsPaused(), this.sdkImpl.pauseAds()) : (this.adUi.onAdsPlaying(), this.sdkImpl.resumeAds());
};
Jt.prototype.onAdMuteClick = function() {
  this.sdkImpl.isAdMuted() ? (this.playerWrapper.unmute(), this.adUi.unmute(), this.sdkImpl.unmute()) : (this.playerWrapper.mute(), this.adUi.mute(), this.sdkImpl.mute());
};
Jt.prototype.setVolume = function(e) {
  this.playerWrapper.setVolume(e), this.sdkImpl.setVolume(e);
};
Jt.prototype.getPlayerVolume = function() {
  return this.playerWrapper.getVolume();
};
Jt.prototype.toggleFullscreen = function() {
  this.playerWrapper.toggleFullscreen();
};
Jt.prototype.onAdError = function(e) {
  this.adUi.onAdError(), this.playerWrapper.onAdError(e);
};
Jt.prototype.onAdBreakStart = function(e) {
  this.playerWrapper.onAdBreakStart(), this.adUi.onAdBreakStart(e);
};
Jt.prototype.showAdContainer = function() {
  this.adUi.showAdContainer();
};
Jt.prototype.onAdBreakEnd = function() {
  this.playerWrapper.onAdBreakEnd(), this.adUi.onAdBreakEnd();
};
Jt.prototype.onAllAdsCompleted = function() {
  this.adUi.onAllAdsCompleted(), this.playerWrapper.onAllAdsCompleted();
};
Jt.prototype.onAdsPaused = function() {
  this.adUi.onAdsPaused();
};
Jt.prototype.onAdsResumed = function() {
  this.adUi.onAdsResumed();
};
Jt.prototype.onAdPlayheadUpdated = function(e, r, i, t, n) {
  this.adUi.updateAdUi(e, r, i, t, n);
};
Jt.prototype.onAdLog = function(e) {
  this.playerWrapper.onAdLog(e);
};
Jt.prototype.getCurrentAd = function() {
  return this.sdkImpl.getCurrentAd();
};
Jt.prototype.playContent = function() {
  this.playerWrapper.play();
};
Jt.prototype.onLinearAdStart = function() {
  this.adUi.onLinearAdStart(), this.playerWrapper.onAdStart();
};
Jt.prototype.onNonLinearAdLoad = function() {
  this.adUi.onNonLinearAdLoad();
};
Jt.prototype.onNonLinearAdStart = function() {
  this.adUi.onNonLinearAdLoad(), this.playerWrapper.onAdStart();
};
Jt.prototype.getPlayerWidth = function() {
  return this.playerWrapper.getPlayerWidth();
};
Jt.prototype.getPlayerHeight = function() {
  return this.playerWrapper.getPlayerHeight();
};
Jt.prototype.onAdsReady = function() {
  this.playerWrapper.onAdsReady();
};
Jt.prototype.onPlayerResize = function(e, r) {
  this.sdkImpl.onPlayerResize(e, r);
};
Jt.prototype.onContentComplete = function() {
  this.sdkImpl.onContentComplete();
};
Jt.prototype.onNoPostroll = function() {
  this.playerWrapper.onNoPostroll();
};
Jt.prototype.onContentAndAdsCompleted = function() {
  for (var e in this.contentAndAdsEndedListeners)
    typeof this.contentAndAdsEndedListeners[e] == "function" && this.contentAndAdsEndedListeners[e]();
};
Jt.prototype.onPlayerDisposed = function() {
  this.contentAndAdsEndedListeners = [], this.sdkImpl.onPlayerDisposed();
};
Jt.prototype.onPlayerReadyForPreroll = function() {
  this.sdkImpl.onPlayerReadyForPreroll();
};
Jt.prototype.onAdTimeout = function() {
  this.sdkImpl.onAdTimeout();
};
Jt.prototype.onPlayerReady = function() {
  this.sdkImpl.onPlayerReady();
};
Jt.prototype.onPlayerEnterFullscreen = function() {
  this.adUi.onPlayerEnterFullscreen(), this.sdkImpl.onPlayerEnterFullscreen();
};
Jt.prototype.onPlayerExitFullscreen = function() {
  this.adUi.onPlayerExitFullscreen(), this.sdkImpl.onPlayerExitFullscreen();
};
Jt.prototype.onPlayerVolumeChanged = function(e) {
  this.adUi.onPlayerVolumeChanged(e), this.sdkImpl.onPlayerVolumeChanged(e);
};
Jt.prototype.setContentWithAdTag = function(e, r) {
  this.reset(), this.settings.adTagUrl = r || this.settings.adTagUrl, this.playerWrapper.changeSource(e);
};
Jt.prototype.setContentWithAdsResponse = function(e, r) {
  this.reset(), this.settings.adsResponse = r || this.settings.adsResponse, this.playerWrapper.changeSource(e);
};
Jt.prototype.setContentWithAdsRequest = function(e, r) {
  this.reset(), this.settings.adsRequest = r || this.settings.adsRequest, this.playerWrapper.changeSource(e);
};
Jt.prototype.reset = function() {
  this.sdkImpl.reset(), this.playerWrapper.reset(), this.adUi.reset();
};
Jt.prototype.addContentEndedListener = function(e) {
  this.playerWrapper.addContentEndedListener(e);
};
Jt.prototype.addContentAndAdsEndedListener = function(e) {
  this.contentAndAdsEndedListeners.push(e);
};
Jt.prototype.setAdBreakReadyListener = function(e) {
  this.sdkImpl.setAdBreakReadyListener(e);
};
Jt.prototype.setShowCountdown = function(e) {
  this.adUi.setShowCountdown(e), this.showCountdown = e, this.adUi.countdownDiv.style.display = this.showCountdown ? "block" : "none";
};
Jt.prototype.initializeAdDisplayContainer = function() {
  this.sdkImpl.initializeAdDisplayContainer();
};
Jt.prototype.playAdBreak = function() {
  this.sdkImpl.playAdBreak();
};
Jt.prototype.addEventListener = function(e, r) {
  this.sdkImpl.addEventListener(e, r);
};
Jt.prototype.getAdsManager = function() {
  return this.sdkImpl.getAdsManager();
};
Jt.prototype.getPlayerId = function() {
  return this.playerWrapper.getPlayerId();
};
Jt.prototype.changeAdTag = function(e) {
  this.reset(), this.settings.adTagUrl = e;
};
Jt.prototype.pauseAd = function() {
  this.adUi.onAdsPaused(), this.sdkImpl.pauseAds();
};
Jt.prototype.resumeAd = function() {
  this.adUi.onAdsPlaying(), this.sdkImpl.resumeAds();
};
Jt.prototype.adsWillAutoplay = function() {
  return this.settings.adsWillAutoplay !== void 0 ? this.settings.adsWillAutoplay : this.settings.adWillAutoplay !== void 0 ? this.settings.adWillAutoplay : !!this.playerWrapper.getPlayerOptions().autoplay;
};
Jt.prototype.adsWillPlayMuted = function() {
  return this.settings.adsWillPlayMuted !== void 0 ? this.settings.adsWillPlayMuted : this.settings.adWillPlayMuted !== void 0 ? this.settings.adWillPlayMuted : this.playerWrapper.getPlayerOptions().muted !== void 0 ? this.playerWrapper.getPlayerOptions().muted : this.playerWrapper.getVolume() == 0;
};
Jt.prototype.triggerPlayerEvent = function(e, r) {
  this.playerWrapper.triggerPlayerEvent(e, r);
};
Jt.prototype.extend = function(e) {
  for (var r = void 0, i = void 0, t = void 0, n = arguments.length, a = Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
    a[s - 1] = arguments[s];
  for (i = 0; i < a.length; i++) {
    r = a[i];
    for (t in r)
      r.hasOwnProperty(t) && (e[t] = r[t]);
  }
  return e;
};
var n4 = function(r, i) {
  this.controller = new Jt(r, i), this.addContentAndAdsEndedListener = function(t) {
    this.controller.addContentAndAdsEndedListener(t);
  }.bind(this), this.addContentEndedListener = function(t) {
    this.controller.addContentEndedListener(t);
  }.bind(this), this.addEventListener = function(t, n) {
    this.controller.addEventListener(t, n);
  }.bind(this), this.changeAdTag = function(t) {
    this.controller.changeAdTag(t);
  }.bind(this), this.getAdsManager = function() {
    return this.controller.getAdsManager();
  }.bind(this), this.initializeAdDisplayContainer = function() {
    this.controller.initializeAdDisplayContainer();
  }.bind(this), this.pauseAd = function() {
    this.controller.pauseAd();
  }.bind(this), this.playAdBreak = function() {
    this.controller.playAdBreak();
  }.bind(this), this.requestAds = function() {
    this.controller.requestAds();
  }.bind(this), this.resumeAd = function() {
    this.controller.resumeAd();
  }.bind(this), this.setAdBreakReadyListener = function(t) {
    this.controller.setAdBreakReadyListener(t);
  }.bind(this), this.setContentWithAdTag = function(t, n) {
    this.controller.setContentWithAdTag(t, n);
  }.bind(this), this.setContentWithAdsResponse = function(t, n) {
    this.controller.setContentWithAdsResponse(t, n);
  }.bind(this), this.setContentWithAdsRequest = function(t, n) {
    this.controller.setContentWithAdsRequest(t, n);
  }.bind(this), this.setShowCountdown = function(t) {
    this.controller.setShowCountdown(t);
  }.bind(this);
}, a4 = function(r) {
  this.ima = new n4(this, r);
}, s4 = re.registerPlugin || re.plugin;
s4("ima", a4);
function o4(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
/*! @name videojs-sprite-thumbnails @version 1.2.1 @license MIT */
var u4 = function(r, i, t) {
  var n = ai.navigator, a = re.dom || re, s = i.log || re.log, o = re.mergeOptions, l = r.controlBar, u = l && l.progressControl, h = u && u.seekBar, c = h && h.mouseTimeDisplay && h.mouseTimeDisplay.timeTooltip, d = c && c.el(), f = d && d.style, m = function(E) {
    var x = t.urlArray;
    return x.length ? x[E] : t.url.replace("{index}", t.idxTag(E));
  }, p = function(E) {
    var x = h.el(), w = r.currentWidth(), S = r.duration(), T = t.interval, C = t.columns, D = t.responsive, R = T * C, P = R * (t.rows || Math.ceil(S / R)), N = a.getPointerPosition(x, E).x * S, $ = Math.floor(N / P);
    N = (N - P * $) / T;
    var O = D && w < D ? w / D : 1, M = t.width * O, F = t.height * O, G = Math.floor(N % C) * -M, K = Math.floor(N / C) * -F, J = a.findPosition(l.el()).top, ue = a.findPosition(x).top, ce = -F - Math.max(0, ue - J), ee = {
      backgroundImage: 'url("' + m($) + '")',
      backgroundRepeat: "no-repeat",
      backgroundPosition: G + "px " + K + "px",
      backgroundSize: M * C + "px auto",
      top: ce + "px",
      color: "#fff",
      textShadow: "1px 1px #000",
      border: "1px solid #000",
      width: M + 2 + "px",
      height: F + 2 + "px"
    };
    Object.keys(ee).forEach(function(me) {
      d.style[me] = ee[me];
    });
  }, b = function(E) {
    var x = t[E], w = E !== "rows" ? 1 : 0;
    return parseInt(x, 10) !== x || x < w ? (s(E + " must be an integer greater than " + (w - 1)), !1) : !0;
  }, y = function() {
    var E = n.connection || n.mozConnection || n.webkitConnection, x = t.downlink;
    return E && E.downlink < x ? (s.warn("connection.downlink < " + x), !1) : !0;
  };
  i.on("statechanged", function() {
    var g = i.state, E = ["mousemove", "touchmove"], x = s.debug || s;
    g.ready ? (x("ready to show thumbnails"), u.on(E, p)) : (!t.url && !t.urlArray.length && s("no urls given"), x("resetting"), u.off(E, p), d.style = f), r.toggleClass("vjs-thumbnails-ready", g.ready);
  });
  var v = function() {
    var E = i.name, x = r.currentSources().filter(function(T) {
      return T.hasOwnProperty(E);
    })[0], w = x && x[E];
    if (w) {
      var S = w.urlArray;
      Object.keys(w).length ? S && S.length ? w.url = "" : w.url && (w.urlArray = []) : (w = {
        url: "",
        urlArray: []
      }, s("disabling plugin")), i.options = t = o(t, w);
    }
    i.setState({
      ready: !!(c && (t.urlArray.length || t.url) && b("width") && b("height") && b("columns") && b("rows") && y())
    });
  };
  r.on("loadstart", v), v(), r.addClass("vjs-sprite-thumbnails");
}, l4 = "1.2.1", c4 = re.getPlugin("plugin"), d4 = {
  url: "",
  idxTag: function(r) {
    return r;
  },
  urlArray: [],
  width: 0,
  height: 0,
  columns: 0,
  rows: 0,
  interval: 1,
  responsive: 600,
  downlink: 1.5
}, k0 = /* @__PURE__ */ function(e) {
  WT(r, e);
  function r(i, t) {
    var n;
    return n = e.call(this, i, t) || this, n.options = re.mergeOptions(d4, t), n.player.ready(function() {
      u4(n.player, o4(n), n.options);
    }), n;
  }
  return r;
}(c4);
k0.defaultState = {
  ready: !1
};
k0.VERSION = l4;
re.registerPlugin("spriteThumbnails", k0);
fr.directive(
  "videojsWrapper",
  ["PlayerEvents", "$http", function(e, r) {
    return {
      restrict: "E",
      template: `<div class="player-videojs vjs-skin-videoflow vjs-waiting" ng-class="{ios:isIOS()}">
                    <video
                        id="videoflow-player"
                        class="video-js video footage"
                        controls
                        preload="auto"   
                        
                        >
                  
                      <p class="vjs-no-js">
                        To view this video please enable JavaScript, and consider upgrading to a
                        web browser that
                        <a href="https://videojs.com/html5-video-support/" target="_blank">
                          supports HTML5 video
                        </a>
                      </p>
                    </video>
                </div>`,
      replace: !0,
      scope: {
        api: "=",
        options: "=?"
      },
      controller: ["$scope", function(i) {
      }],
      link: function(i, t, n, a) {
        var E, x;
        i.isIOS = function() {
          return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        }, Object.keys(i.options.style).forEach((w) => {
          t[0].style.setProperty(
            `--${w.replaceAll("_", "-")}`,
            i.options.style[w]
          );
        });
        const s = {
          playlist: [],
          transparent: !1,
          adTagUrl: "",
          autoplay: "muted",
          showClock: !1,
          manualHlsParsing: !1,
          isMobile: !1,
          mute: !1,
          allowFullscreen: !0,
          sendStats: !0,
          hoverOverlay: !1,
          techOrder: [
            "red5",
            "image",
            "html5",
            "youtube"
          ]
        };
        i.options = Object.assign({}, s, i.options), i.options.isIVS && i.options.techOrder.unshift("AmazonIVS");
        try {
          (~i.options.playlist[0].src.indexOf(
            "stun.videoflow.io"
          ) || ~i.options.playlist[0].src.indexOf(
            "ull.ap-northeast-1.videoflow.io"
          ) || ~i.options.playlist[0].src.indexOf(
            "ulltokyo.videoflow.io"
          ) || ~i.options.playlist[0].src.indexOf(
            "ullireland.videoflow.io"
          ) || ~i.options.playlist[0].src.indexOf(
            "ullus.videoflow.io"
          ) || ~i.options.playlist[0].src.indexOf(
            "ulloragon.videoflow.io"
          )) && i.options.techOrder.unshift("ant");
        } catch {
        }
        const o = function() {
          let w, S = this.context;
          w = this.loader = new XMLHttpRequest();
          let T = this.stats;
          T.tfirst = 0, T.loaded = 0;
          const C = this.xhrSetup;
          if (~S.url.indexOf("cpix.ezdrm.com"))
            try {
              let R = i.options.encryptionQP;
              S.url += `&${R}`, console.log("Key request", S.url);
            } catch {
            }
          w.onreadystatechange = this.readystatechange.bind(this), w.onprogress = this.loadprogress.bind(this), w.responseType = S.responseType, clearTimeout(this.requestTimeout), this.requestTimeout = window.setTimeout(
            this.loadtimeout.bind(this),
            this.config.timeout
          );
          function D() {
            S.rangeEnd && w.setRequestHeader(
              "Range",
              "bytes=" + S.rangeStart + "-" + (S.rangeEnd - 1)
            ), w.send();
          }
          try {
            if (C)
              try {
                S.type === "manifest" ? u(
                  S.url,
                  i.options.metadata.inputToken
                ).then((R) => {
                  S.url = S.url + (~S.url.indexOf("?") ? "&" : "?") + R, C(w, S.url), D();
                }) : (C(w, S.url), D());
              } catch {
                w.open("GET", S.url, !0), C(w, S.url), D();
              }
            w.readyState || (S.type === "manifest" ? u(
              S.url,
              i.options.metadata.inputToken
            ).then((R) => {
              S.url = S.url + (~S.url.indexOf("?") ? "&" : "?") + R, w.open("GET", S.url, !0), D();
            }) : (w.open("GET", S.url, !0), D()));
          } catch (R) {
            this.callbacks.onError(
              { code: w.status, text: R.message },
              S,
              w
            );
            return;
          }
        }, l = function() {
        };
        l.prototype = new $a.DefaultConfig.loader({}), l.prototype.loadInternal = o;
        function u(w, S) {
          return new Promise((T, C) => {
            r.get(
              `/input/${S}/token?url=${w}`
            ).then((D) => {
              T(D.data);
            }, C);
          });
        }
        i.options.adTagUrl && (i.options.autoplay = !1);
        const h = {
          playsinline: !0,
          errorDisplay: !1,
          textTrackSettings: !1,
          techOrder: i.options.techOrder,
          playbackRates: [0.5, 1, 1.5, 2],
          liveui: !0,
          controlBar: {
            pictureInPictureToggle: !1,
            volumePanel: !i.options.isMobile,
            muteToggle: !!i.options.isMobile,
            vfVideoTitle: i.options.videoTitle,
            fullscreenToggle: i.options.allowFullscreen,
            openInVideoflowButton: !1
          },
          youtube: {
            playsinline: 1
          },
          muted: i.options.mute,
          html5: {
            hls: {
              debug: !0
            },
            hlsjsConfig: {
              maxBufferHole: 0.5,
              stretchShortVideoTrack: !0,
              debug: ((E = i.options.logger) == null ? void 0 : E.hls) || !1
            }
          }
        };
        (i.options.tokenization || i.options.encryption) && (h.html5.hlsjsConfig.loader = l);
        let c = i.player = re(
          "videoflow-player",
          h,
          () => {
          }
        );
        c.info = {}, c.vfhls = {}, c.transparent = !!i.options.transparent;
        let d = c.analytics(i.options.analytics);
        c.customEvents({
          videoEndPercent: i.options.videoEndEventPercent,
          sectionDuration: i.options.sectionDuration,
          currentTimeEventInterval: i.options.currentTimeEventInterval
        });
        let f = {
          adTagUrl: i.options.adTagUrl,
          adsManagerLoadedCallback: g
        };
        c.bigPlayButton.hide(), c.autoplaySupport(), c.contentFit(), c.loggerPlugin(i.options.logger), c.transformContent(), c.responsiveScrubbing(), c.postMessages({
          manualReady: i.options.manualReady
        }), c.skipButtons({
          forward: i.options.skipForward,
          back: i.options.skipBack
        }), c.sourceSelector(), i.api.player = c, i.api.element = angular.element(c.el()), c.isMobile = i.options.isMobile, c.vfProject = i.api.project, c.vfApi = i.api, c.addChild("vfMask", {}), i.options.hoverOverlay && c.addChild("vfHoverOverlay", {
          back: i.options.hoverOverlay.back
        }), (x = i.options.overlay) != null && x.src && c.addChild("vfGfxOverlay", i.options.overlay), c.addChild("vfOrientationPoster", {}), c.addChild("vfClock", {
          show: i.options.showClock
        }), c.addChild("vfCheckers", {}), c.addChild("vfFSPlayPause", {}), c.addChild("vfLogo", {
          src: i.options.logoSrc,
          align: i.options.logoPosition,
          link: i.options.logoLink
        }), c.on("play", function() {
          t.removeClass("vjs-waiting"), c.removeClass("vjs-youtube-loading");
        }), c.one("play", function() {
          setTimeout(function() {
            try {
              c.info.startTime ? c.isLive() && c.currentTime(c.info.startTime) : c.liveTracker.seekToLiveEdge();
            } catch {
            }
          }, 1500);
        }), c.one("loadeddata", () => {
          (c.info.startTime || i.options.startBoundry) && c.currentTime(Math.max(c.info.startTime, i.options.startBoundry));
        }), c.one("canplay", function() {
          try {
            c.info.startTime || c.liveTracker.seekToLiveEdge();
          } catch {
          }
        }), c.on("canplay", function() {
          t.removeClass("vjs-waiting");
        }), c.on("playing", () => {
          c.vfApi.broadcast(e.PLAYING);
        });
        try {
          c.ima.initializeAdDisplayContainer();
        } catch {
        }
        function m() {
          c.bigPlayButton.hide();
          try {
            c.ima.initializeAdDisplayContainer();
          } catch {
          }
        }
        c.bigPlayButton.on("click", m), c.bigPlayButton.on("touchstart", m), c.on("error", function() {
          let w = c.error();
          if (w.code === 4 || w.code === 2 || w.code === 0 && w.fatal) {
            if (c.info.wasLive && !(w.code === 0 && w.fatal)) {
              c.playlist().reloadItem();
              return;
            }
            let S = document.createElement("div");
            if (S.className = "absolute-center vjs-overlay-error-poster", S.innerHTML = `
                            <div class="overlay-error-poster-content">
                                <h1 class="overlay-error-poster-title">${w.description ? w.description : "Content is not available."}</h1>
                            </div>  
                        `, c.info.sources && c.info.sources.length > 1) {
              let D = re.getComponent(
                "vfSourceSelectorButton"
              ), R = new D(c, {});
              S.appendChild(R.el());
            }
            let T = re.getComponent("ModalDialog"), C = new T(c, {
              content: S,
              uncloseable: !0
            });
            C.name_ = "error-modal", C.addClass("vjs-modal-error"), c.addChild(C), C.open();
          }
        });
        function p() {
          let w = {
            width: c.currentWidth(),
            height: c.currentHeight(),
            ratio: c.vfApi.getCurrentTemplate().width / c.vfApi.getCurrentTemplate().height
          };
          c.vfApi.broadcast(e.RESIZE, w), c.fillFit(w);
        }
        c.on("playerresize", p), c.ready(function() {
          f.adTagUrl = c.info.adTagUrl || f.adTagUrl, f.adTagUrl && c.ima(f), c.elementWrapper().wrapControls("vjs-control-wrapper");
          let w = new Event("ready", { bubbles: !0 });
          c.el().parentElement.dispatchEvent(w);
        }), c.on("seeked", (w, S) => {
          i.options.startBoundry && c.currentTime() < i.options.startBoundry && c.currentTime(i.options.startBoundry);
        });
        function b() {
          try {
            return c.currentTime();
          } catch {
            return 0;
          }
        }
        c.getTimecode = () => {
          try {
            return c.ads.isInAdMode() && c.ads.snapshot ? c.ads.snapshot.currentTime : c.info.ignorePDT ? b() : c.getChild("vfClock").get();
          } catch {
            return b();
          }
        }, c.isLive = () => c.vfhls ? !!c.vfhls.isLive : !1;
        function y(w, S, T) {
          try {
            return w[S]();
          } catch {
            return T;
          }
        }
        c.status = () => Object.assign(c.info, {
          timecode: y(c, "getTimecode", 0),
          duration: y(c, "duration", 0),
          paused: y(c, "paused", !0),
          muted: y(c, "muted", !1),
          isLive: y(c, "isLive", !1),
          hasPDT: c.vfhls._hasPDT,
          isStream: [
            "application/x-mpegURL",
            "video/youtube"
          ].includes(c.currentType())
        }), c.gfxOnly = () => {
          c.reset(), c.posterImage.hide(), c.loadingSpinner.hide(), c.bigPlayButton && c.bigPlayButton.hide(), c.controlBar.hide();
          let w = c.getChild("vfHoverOverlay");
          w && w.remove(), c.controlWrapper.classList.add("vjs-hidden");
        }, c.overlay = (w) => {
          let S = c.getChild("vfGfxOverlay");
          if (w = w || "", S)
            return S.src(w);
        }, c.manifest = (w) => {
          c.manualHls().init(w);
        }, i.api.getCurrentTemplate = function() {
          return c.status();
        }, c.isIVS = function() {
          return c.techName_ === "AmazonIVS";
        };
        function v(w, S, T) {
          return w >= S - T && w <= S + T;
        }
        c.streamInfo = function() {
          try {
            if (c.vfhls.currentLevel)
              return {
                stream_width: c.vfhls.currentLevel.width,
                stream_height: c.vfhls.currentLevel.height,
                stream_bitrate: c.vfhls.currentLevel.bitrate,
                stream_video_codec: c.vfhls.currentLevel.videoCodec,
                stream_audio_codec: c.vfhls.currentLevel.audioCodec,
                stream_level: `${c.vfhls.currentLevel.level + 1}/${c.vfhls.currentLevel.totalLevels}`,
                stream_level_index: c.vfhls.currentLevel.level,
                stream_total_levels: c.vfhls.currentLevel.totalLevels,
                stream_resolutions: c.vfhls.currentLevel.availableResolutions,
                stream_is_live: !!c.vfhls.isLive,
                stream_segment_duration: c.vfhls.manifest ? c.vfhls.manifest._segmentDuration : void 0
              };
            if (c.vfhls.manifest && c.vfhls.manifest.playlists) {
              const w = c.videoWidth(), S = c.videoHeight();
              let T = c.vfhls.manifest.playlists;
              const C = T.findIndex((P) => P.attributes && P.attributes.RESOLUTION && v(P.attributes.RESOLUTION.width, w, 10) && v(P.attributes.RESOLUTION.height, S, 10));
              if (C < 0)
                return {};
              const D = T[C];
              if (!D || !D.attributes)
                return {};
              const R = D.attributes.CODECS ? D.attributes.CODECS.split(",") : [];
              return {
                stream_total_levels: T.length,
                stream_level: `${C + 1}/${T.length}`,
                stream_level_index: C,
                stream_is_live: c.vfhls.manifest._live,
                stream_segment_duration: c.vfhls.manifest._segmentDuration,
                stream_bitrate: D.attributes.BANDWIDTH,
                stream_width: D.attributes.RESOLUTION ? D.attributes.RESOLUTION.width : void 0,
                stream_height: D.attributes.RESOLUTION ? D.attributes.RESOLUTION.height : void 0,
                stream_video_codec: R.length > 1 ? R[0].trim() : "unknown",
                stream_audio_codec: R.length > 2 ? R[1].trim() : "unknown"
              };
            } else
              return {};
          } catch {
            return {};
          }
        }, c.init = () => {
          if (c.isIVS()) {
            c.enableIVSQualityPlugin(), i.options.autoplay = !1;
            const w = c.getIVSEvents().PlayerEventType, S = c.getIVSEvents().PlayerState;
            let T = c.getIVSPlayer();
            T.addEventListener(
              w.ERROR,
              (C) => {
                console.log("IVS ERROR:", C), C.code === 404 && c.playlist().reloadItem();
              }
            ), T.addEventListener(S.PLAYING, () => {
              console.log("Player State - PLAYING"), setTimeout(() => {
                console.log(
                  `This stream is ${T.isLiveLowLatency() ? "" : "not "}playing in ultra low latency mode`
                ), console.log(
                  `Stream Latency: ${T.getLiveLatency()}s`
                );
              }, 5e3);
            }), T.addEventListener(
              w.TEXT_METADATA_CUE,
              (C) => {
                let D = c.getChild("vfGfxOverlay");
                D && D.sendData(C), console.log("IVS P:layer Event:", C);
              }
            );
          }
          if (i.options.autoplay) {
            i.options.autoplay === "muted" && c.muted(!0);
            let w = c.play();
            w !== void 0 && w.then(function() {
            }).catch(function(S) {
              console.log("Autoplay was prevented.");
              try {
                c.bigPlayButton.show();
              } catch {
              }
            });
          } else
            c.bigPlayButton.show();
          c.transparent && c.gfxOnly(), i.options.noContent && (c.gfxOnly(), c.getChild("vfCheckers").show()), c.playbackRate(c.playbackRate()), c.elementWrapper().wrapVideo("vjs-video-wrapper"), c.elementWrapper().wrapAds("vjs-ads-wrapper"), c.techName_ === "Youtube" ? (c.addClass("vjs-youtube-tech"), i.options.isMobile && c.addClass("vjs-youtube-tech-mobile"), !c.tech_.supportsFullScreen() && c.controlBar.fullscreenToggle && c.controlBar.fullscreenToggle.hide(), c.addClass("vjs-youtube-loading")) : c.techName_ === "WebRTC" ? c.controlBar.progressControl.hide() : (c.controlBar.fullscreenToggle && c.controlBar.fullscreenToggle.show(), c.removeClass("vjs-youtube-tech"), c.removeClass("vjs-youtube-tech-mobile")), p(), c.resetOverlayReadyPromise_(5e3), c.whenOverlayReady().then((w) => {
            w && c.removeClass("vjs-interactive");
          }), i.options.isDVR && c.addClass("vjs-live-dvr"), i.options.captions && c.addRemoteTextTrack(
            {
              kind: "captions",
              src: i.options.captions,
              srclang: "en",
              default: !1
            },
            !0
          );
        }, c.setItem = (w) => {
          var T, C, D, R;
          let S = c.info;
          if (c.info = w, c.vfhls = {}, i.options.hoverOverlay)
            c.setTitle(i.options.title), i.options.description && c.setDescription(
              i.options.description
            );
          else if (!i.options.hoverOverlay || !i.options.hoverOverlay.back) {
            let P = c.getChild("vfHoverOverlay");
            P && P.remove();
          }
          if ((C = (T = i.options) == null ? void 0 : T.preview) != null && C.url) {
            let N = function(J) {
              const ue = J.seekable();
              return ue.length > 0 ? ue.end(0) - ue.start(0) : 0;
            }, P = i.options.preview;
            const $ = re.dom || re, O = i.player.controlBar, M = O && O.progressControl, G = (M && M.seekBar).el();
            let K = (J) => {
              if (J === 1 / 0 && window.event)
                try {
                  const ce = N(i.player), ee = P.interval, me = P.columns, Ne = ee * me * P.rows;
                  let ot = $.getPointerPosition(G, window.event).x * ce;
                  J = Math.floor(ot / Ne);
                } catch {
                }
              return (J + Math.floor(P.offset / P.interval)).toString().padStart(P.padding || 0, "0");
            };
            c.spriteThumbnails({
              url: P.url,
              idxTag: K,
              columns: P.columns || 1,
              rows: P.rows || 1,
              width: P.width || 160,
              height: P.height || 90,
              downlink: P.downlink || 1,
              interval: P.interval || 1
            });
          }
          c.src({
            src: w.src,
            type: w.type,
            duration: w.duration
          }), c.vfApi.broadcast(e.PAGE_LOADED), c.overlay((R = (D = i.options) == null ? void 0 : D.overlay) == null ? void 0 : R.src), setTimeout(() => {
            c.trigger(e.ITEM_CHANGE, {
              newItem: w,
              oldItem: S
            });
          }, 0), c.manifest(w.src), w.isLoop ? c.loop(!0) : c.loop(!1), c.poster(w.poster), c.ready(() => {
            (w.startTime || i.options.startBoundry) && c.currentTime(Math.max(w.startTime, i.options.startBoundry)), w.hasControls && c.techName_ !== "Image" ? (c.controlBar.show(), c.controlBar.el().classList.remove("vjs-hide"), c.controlWrapper.classList.remove(
              "vjs-hide-controls"
            )) : (c.controlBar.hide(), c.controlBar.el().classList.add("vjs-hide"), c.controlWrapper.classList.add(
              "vjs-hide-controls"
            )), setTimeout(c.init, 100);
          });
        }, c.resetOverlayReadyPromise_ = (w) => {
          c.overlayReady_ = {}, c.overlayReady_.promise = new Promise(
            (S, T) => {
              c.overlayReady_.resolve = S, c.overlayReady_.reject = T;
            }
          ), setTimeout(() => {
            c.overlayReady_.resolve(!1);
          }, w);
        }, c.overlayReady = () => {
          c.overlayReady_.resolve(!0);
        }, c.whenOverlayReady = () => c.overlayReady_.promise, c.customReady = () => {
          window.postMessage(
            JSON.stringify({ ready: !0 }),
            "*"
          );
        }, i.api.ready(), i.options.playlist && c.playlist({
          list: i.options.playlist,
          loop: i.options.loop
        }), window.vfPlayerStatus = c.status;
        function g() {
          c.ima.addEventListener(
            google.ima.AdEvent.Type.CLICK,
            (S) => {
              c.ima.resumeAd();
            }
          ), c.ima.addEventListener(
            google.ima.AdEvent.Type.PAUSED,
            (S) => {
              c.adPaused = !0, c.addClass("vjs-ad-paused");
            }
          ), c.ima.addEventListener(
            google.ima.AdEvent.Type.RESUMED,
            (S) => {
              c.adPaused = !1, c.removeClass("vjs-ad-paused");
            }
          ), d.trackAds(), c.customAdEvents();
          let w = !1;
          c.on("adstart", () => {
            try {
              w = c.loop(), c.loop(!1);
            } catch {
            }
          }), c.on("adend", () => {
            try {
              c.loop(w), c.play(), setTimeout(function() {
                c.liveTracker.seekToLiveEdge();
              }, 500);
            } catch {
            }
          });
        }
        i.$on("$destroy", () => {
          try {
            c.trigger("dispose"), tracker.destroy(), c.dispose();
          } catch {
          }
        });
      }
    };
  }]
);
fr.directive("streamEnginePlayer", [
  "Player",
  "PlayerEvents",
  (e, r) => ({
    restrict: "EC",
    template: `
                    <div>
                        <videojs-wrapper api="api" options="options"></videojs-wrapper>
                    </div>    
                `,
    replace: !0,
    scope: {
      src: "@",
      options: "=?",
      sources: "=",
      startTime: "=",
      controls: "=",
      style: "=",
      transparent: "=",
      mobile: "=",
      autoplay: "=",
      adTagUrl: "@",
      noContent: "=",
      allowFullscreen: "=",
      mute: "=",
      logoSrc: "@",
      logoPosition: "@",
      logoLink: "@",
      sendStats: "=",
      skipBack: "=",
      skipForward: "=",
      loop: "=",
      logger: "=",
      title: "@",
      dvr: "=",
      captions: "=",
      analytics: "=",
      logging: "=",
      overlay: "=",
      preview: "=",
      currentTimeEventInterval: "=",
      videoEndEventPercent: "=",
      sectionDuration: "=",
      startBoundry: "="
    },
    controller: ["$scope", (i) => {
      i.api = new e(), i.options = i.options || {};
      let t = !1;
      try {
        t = window.frameElement.hasAttribute("controller");
      } catch {
      }
      const n = [
        {
          id: "",
          name: "",
          src: i.src,
          width: 1920,
          height: 1080,
          hasControls: !!i.controls,
          startTime: i.startTime || 0,
          metadata: {
            input: "",
            title: "",
            description: ""
          },
          type: _L(i.src) === "youtube" ? "video/youtube" : EL(i.src) ? "application/x-mpegURL" : void 0
        }
      ];
      try {
        new URL(i.adTagUrl);
      } catch {
        i.adTagUrl = "";
      }
      i.options = {
        controls: !!i.controls,
        transparent: !!i.transparent,
        playlist: n,
        isMobile: i.mobile,
        allowFullscreen: i.allowFullscreen,
        adTagUrl: i.adTagUrl,
        autoplay: i.autoplay && !i.adTagUrl,
        noContent: i.noContent,
        mute: i.mute,
        logoSrc: i.logoSrc,
        logoPosition: i.logoPosition,
        logoLink: i.logoLink,
        sendStats: i.sendStats,
        manualReady: !1,
        hoverOverlay: { back: !1 },
        skipBack: i.skipBack,
        skipForward: i.skipForward,
        loop: i.loop,
        logger: i.logger,
        videoTitle: i.title,
        isDVR: i.dvr,
        isIVS: !1,
        style: i.style || {},
        metadata: {},
        captions: i.captions,
        analytics: i.analytics,
        logging: i.logging,
        title: "",
        description: "",
        overlay: i.overlay,
        preview: i.preview,
        currentTimeEventInterval: i.currentTimeEventInterval,
        videoEndEventPercent: i.videoEndEventPercent,
        sectionDuration: i.sectionDuration,
        startBoundry: i.startBoundry
      }, i.api.whenReady().then(() => {
        i.api.player.on("useractive", () => {
          window.top.postMessage(
            JSON.stringify({ useractive: !0 }),
            "*"
          );
        }), i.api.player.on("userinactive", () => {
          window.top.postMessage(
            JSON.stringify({ useractive: !1 }),
            "*"
          );
        }), i.$on(r.OUTPUT, (a, s) => {
          s && s.command && s.command === "reload" && window.postMessage(
            JSON.stringify({ reload: !0 }),
            "*"
          );
        });
      }), i.$on(r.CROP, (a, s) => {
        i.api.player.cropper().crop(
          i.project.settings.getContentSizing(
            i.api.getCurrentTemplate()
          ) === "fill" ? "fill" : "fit",
          s.crop
        );
      }), i.$on("vff-cmd-play", () => {
        i.api.player.play();
      }), i.$on("vff-cmd-pause", () => {
        i.api.player.pause();
      }), i.$on(r.TRANSFORM, (a, s) => {
        i.project.settings.getContentSizing(
          i.api.getCurrentTemplate()
        ) === "fill" && (s.options.scalingMode = "fill"), s.options && s.options.playerScalingMode === "fit" && i.api.player.fit(), s.options && s.options.playerScalingMode === "fill" && i.api.player.fill(), i.api.player.transform(
          s.fromTopLeftX,
          s.fromTopLeftY,
          s.fromBottomRightX,
          s.fromBottomRightY,
          s.toTopLeftX,
          s.toTopLeftY,
          s.toBottomRightX,
          s.toBottomRightY,
          s.options
        );
      });
    }],
    link: (i, t) => {
    }
  })
]);
window.Hls = $a;
window.videojs = re;
let f4 = (e) => e.replace(/[A-Z]/g, (r) => "-" + r.toLowerCase());
function h4(e, r) {
  if (window.google)
    return e();
  const i = document.createElement("script");
  i.src = "//imasdk.googleapis.com/js/sdkloader/ima3.js", i.async = !0, i.onload = e, i.onerror = r, document.head.appendChild(i);
}
let Tg = (e, r = {}) => {
  let i = document.getElementById(e);
  if (i) {
    const t = document.createElement("div");
    for (const [n, a] of Object.entries(r))
      t.setAttribute(f4(n), typeof a == "object" ? JSON.stringify(a) : a);
    t.classList.add("stream-engine-player"), i.appendChild(t), Nb.bootstrap(t, ["stream-engine-player"], {
      strictDi: !0
    });
  }
};
function p4(e, r = {}) {
  const i = new hL(), t = document.getElementById(e);
  return t ? (t.addEventListener("ready", () => {
    var a;
    const n = (a = t.querySelector("#videoflow-player")) == null ? void 0 : a.player;
    n && i.setPlayer(n);
  }), r.adTagUrl ? h4(
    () => {
      Tg(e, r);
    },
    () => {
      delete r.adTagUrl, Tg(e, r);
    }
  ) : Tg(e, r), i) : (console.error(`Element with id "${e}" not found`), i);
}
window.streamEnginePlayer = p4;
console.log(`Stream Engine Player version: ${fL.version}`);
export {
  p4 as default
};
//# sourceMappingURL=stream-engine-player-bundle.mjs.map
